
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5oaC6", function(module, exports) {
//# 1 ".tensor_playground_web.eobjs/jsoo/tensor_playground_web.bc.runtime.js"
// Generated by js_of_ocaml
//# buildInfo:effects=false, kind=unknown, use-js-string=true, version=5.8.2
//# 3 ".tensor_playground_web.eobjs/jsoo/tensor_playground_web.bc.runtime.js"
//# 7 ".tensor_playground_web.eobjs/jsoo/tensor_playground_web.bc.runtime.js"
(function(Object1) {
    typeof globalThis !== "object" && (this ? get() : (Object1.defineProperty(Object1.prototype, "_T_", {
        configurable: true,
        get: get
    }), _T_));
    function get() {
        var global = this || self;
        global.globalThis = global;
        delete Object1.prototype._T_;
    }
})(Object);






(function(globalThis1) {
    "use strict";
    function Base_am_testing(x) {
        return 0;
    }
    function Base_caml_exn_is_most_recent_exn(x) {
        return 1;
    }
    function Base_clear_caml_backtrace_pos(x) {
        return 0;
    }
    function caml_is_continuation_tag(t) {
        return t == 245 ? 1 : 0;
    }
    function caml_mul(a, b) {
        return Math.imul(a, b);
    }
    function caml_hash_mix_int(h, d) {
        d = caml_mul(d, -862048943);
        d = d << 15 | d >>> 17;
        d = caml_mul(d, 0x1b873593);
        h ^= d;
        h = h << 13 | h >>> 19;
        return (h + (h << 2) | 0) + -430675100 | 0;
    }
    function caml_hash_mix_jsbytes(h, s) {
        var len = s.length, i, w;
        for(i = 0; i + 4 <= len; i += 4){
            w = s.charCodeAt(i) | s.charCodeAt(i + 1) << 8 | s.charCodeAt(i + 2) << 16 | s.charCodeAt(i + 3) << 24;
            h = caml_hash_mix_int(h, w);
        }
        w = 0;
        switch(len & 3){
            case 3:
                w = s.charCodeAt(i + 2) << 16;
            case 2:
                w |= s.charCodeAt(i + 1) << 8;
            case 1:
                w |= s.charCodeAt(i);
                h = caml_hash_mix_int(h, w);
        }
        h ^= len;
        return h;
    }
    var log2_ok = Math.log2 && Math.log2(1.1235582092889474E+307) == 1020;
    function jsoo_floor_log2(x) {
        if (log2_ok) return Math.floor(Math.log2(x));
        var i = 0;
        if (x == 0) return -Infinity;
        if (x >= 1) while(x >= 2){
            x /= 2;
            i++;
        }
        else while(x < 1){
            x *= 2;
            i--;
        }
        return i;
    }
    var caml_int64_offset = Math.pow(2, -24);
    function caml_raise_constant(tag) {
        throw tag;
    }
    var caml_global_data = [
        0
    ];
    function caml_raise_zero_divide() {
        caml_raise_constant(caml_global_data.Division_by_zero);
    }
    function MlInt64(lo, mi, hi) {
        this.lo = lo & 0xffffff;
        this.mi = mi & 0xffffff;
        this.hi = hi & 0xffff;
    }
    MlInt64.prototype.caml_custom = "_j";
    MlInt64.prototype.copy = function() {
        return new MlInt64(this.lo, this.mi, this.hi);
    };
    MlInt64.prototype.ucompare = function(x) {
        if (this.hi > x.hi) return 1;
        if (this.hi < x.hi) return -1;
        if (this.mi > x.mi) return 1;
        if (this.mi < x.mi) return -1;
        if (this.lo > x.lo) return 1;
        if (this.lo < x.lo) return -1;
        return 0;
    };
    MlInt64.prototype.compare = function(x) {
        var hi = this.hi << 16, xhi = x.hi << 16;
        if (hi > xhi) return 1;
        if (hi < xhi) return -1;
        if (this.mi > x.mi) return 1;
        if (this.mi < x.mi) return -1;
        if (this.lo > x.lo) return 1;
        if (this.lo < x.lo) return -1;
        return 0;
    };
    MlInt64.prototype.neg = function() {
        var lo = -this.lo, mi = -this.mi + (lo >> 24), hi = -this.hi + (mi >> 24);
        return new MlInt64(lo, mi, hi);
    };
    MlInt64.prototype.add = function(x) {
        var lo = this.lo + x.lo, mi = this.mi + x.mi + (lo >> 24), hi = this.hi + x.hi + (mi >> 24);
        return new MlInt64(lo, mi, hi);
    };
    MlInt64.prototype.sub = function(x) {
        var lo = this.lo - x.lo, mi = this.mi - x.mi + (lo >> 24), hi = this.hi - x.hi + (mi >> 24);
        return new MlInt64(lo, mi, hi);
    };
    MlInt64.prototype.mul = function(x) {
        var lo = this.lo * x.lo, mi = (lo * caml_int64_offset | 0) + this.mi * x.lo + this.lo * x.mi, hi = (mi * caml_int64_offset | 0) + this.hi * x.lo + this.mi * x.mi + this.lo * x.hi;
        return new MlInt64(lo, mi, hi);
    };
    MlInt64.prototype.isZero = function() {
        return (this.lo | this.mi | this.hi) == 0;
    };
    MlInt64.prototype.isNeg = function() {
        return this.hi << 16 < 0;
    };
    MlInt64.prototype.and = function(x) {
        return new MlInt64(this.lo & x.lo, this.mi & x.mi, this.hi & x.hi);
    };
    MlInt64.prototype.or = function(x) {
        return new MlInt64(this.lo | x.lo, this.mi | x.mi, this.hi | x.hi);
    };
    MlInt64.prototype.xor = function(x) {
        return new MlInt64(this.lo ^ x.lo, this.mi ^ x.mi, this.hi ^ x.hi);
    };
    MlInt64.prototype.shift_left = function(s) {
        s = s & 63;
        if (s == 0) return this;
        if (s < 24) return new MlInt64(this.lo << s, this.mi << s | this.lo >> 24 - s, this.hi << s | this.mi >> 24 - s);
        if (s < 48) return new MlInt64(0, this.lo << s - 24, this.mi << s - 24 | this.lo >> 48 - s);
        return new MlInt64(0, 0, this.lo << s - 48);
    };
    MlInt64.prototype.shift_right_unsigned = function(s) {
        s = s & 63;
        if (s == 0) return this;
        if (s < 24) return new MlInt64(this.lo >> s | this.mi << 24 - s, this.mi >> s | this.hi << 24 - s, this.hi >> s);
        if (s < 48) return new MlInt64(this.mi >> s - 24 | this.hi << 48 - s, this.hi >> s - 24, 0);
        return new MlInt64(this.hi >> s - 48, 0, 0);
    };
    MlInt64.prototype.shift_right = function(s) {
        s = s & 63;
        if (s == 0) return this;
        var h = this.hi << 16 >> 16;
        if (s < 24) return new MlInt64(this.lo >> s | this.mi << 24 - s, this.mi >> s | h << 24 - s, this.hi << 16 >> s >>> 16);
        var sign = this.hi << 16 >> 31;
        if (s < 48) return new MlInt64(this.mi >> s - 24 | this.hi << 48 - s, this.hi << 16 >> s - 24 >> 16, sign & 0xffff);
        return new MlInt64(this.hi << 16 >> s - 32, sign, sign);
    };
    MlInt64.prototype.lsl1 = function() {
        this.hi = this.hi << 1 | this.mi >> 23;
        this.mi = (this.mi << 1 | this.lo >> 23) & 0xffffff;
        this.lo = this.lo << 1 & 0xffffff;
    };
    MlInt64.prototype.lsr1 = function() {
        this.lo = (this.lo >>> 1 | this.mi << 23) & 0xffffff;
        this.mi = (this.mi >>> 1 | this.hi << 23) & 0xffffff;
        this.hi = this.hi >>> 1;
    };
    MlInt64.prototype.udivmod = function(x) {
        var offset = 0, modulus = this.copy(), divisor = x.copy(), quotient = new MlInt64(0, 0, 0);
        while(modulus.ucompare(divisor) > 0){
            offset++;
            divisor.lsl1();
        }
        while(offset >= 0){
            offset--;
            quotient.lsl1();
            if (modulus.ucompare(divisor) >= 0) {
                quotient.lo++;
                modulus = modulus.sub(divisor);
            }
            divisor.lsr1();
        }
        return {
            quotient: quotient,
            modulus: modulus
        };
    };
    MlInt64.prototype.div = function(y) {
        var x = this;
        if (y.isZero()) caml_raise_zero_divide();
        var sign = x.hi ^ y.hi;
        if (x.hi & 0x8000) x = x.neg();
        if (y.hi & 0x8000) y = y.neg();
        var q = x.udivmod(y).quotient;
        if (sign & 0x8000) q = q.neg();
        return q;
    };
    MlInt64.prototype.mod = function(y) {
        var x = this;
        if (y.isZero()) caml_raise_zero_divide();
        var sign = x.hi;
        if (x.hi & 0x8000) x = x.neg();
        if (y.hi & 0x8000) y = y.neg();
        var r = x.udivmod(y).modulus;
        if (sign & 0x8000) r = r.neg();
        return r;
    };
    MlInt64.prototype.toInt = function() {
        return this.lo | this.mi << 24;
    };
    MlInt64.prototype.toFloat = function() {
        return (this.hi << 16) * Math.pow(2, 32) + this.mi * Math.pow(2, 24) + this.lo;
    };
    MlInt64.prototype.toArray = function() {
        return [
            this.hi >> 8,
            this.hi & 0xff,
            this.mi >> 16,
            this.mi >> 8 & 0xff,
            this.mi & 0xff,
            this.lo >> 16,
            this.lo >> 8 & 0xff,
            this.lo & 0xff
        ];
    };
    MlInt64.prototype.lo32 = function() {
        return this.lo | (this.mi & 0xff) << 24;
    };
    MlInt64.prototype.hi32 = function() {
        return this.mi >>> 8 & 0xffff | this.hi << 16;
    };
    function caml_int64_create_lo_mi_hi(lo, mi, hi) {
        return new MlInt64(lo, mi, hi);
    }
    function caml_int64_bits_of_float(x) {
        if (!isFinite(x)) {
            if (isNaN(x)) return caml_int64_create_lo_mi_hi(1, 0, 0x7ff0);
            return x > 0 ? caml_int64_create_lo_mi_hi(0, 0, 0x7ff0) : caml_int64_create_lo_mi_hi(0, 0, 0xfff0);
        }
        var sign = x == 0 && 1 / x == -Infinity ? 0x8000 : x >= 0 ? 0 : 0x8000;
        if (sign) x = -x;
        var exp = jsoo_floor_log2(x) + 1023;
        if (exp <= 0) {
            exp = 0;
            x /= Math.pow(2, -1026);
        } else {
            x /= Math.pow(2, exp - 1027);
            if (x < 16) {
                x *= 2;
                exp -= 1;
            }
            if (exp == 0) x /= 2;
        }
        var k = Math.pow(2, 24), r3 = x | 0;
        x = (x - r3) * k;
        var r2 = x | 0;
        x = (x - r2) * k;
        var r1 = x | 0;
        r3 = r3 & 0xf | sign | exp << 4;
        return caml_int64_create_lo_mi_hi(r1, r2, r3);
    }
    function caml_int64_lo32(v) {
        return v.lo32();
    }
    function caml_int64_hi32(v) {
        return v.hi32();
    }
    function caml_hash_mix_int64(h, v) {
        h = caml_hash_mix_int(h, caml_int64_lo32(v));
        h = caml_hash_mix_int(h, caml_int64_hi32(v));
        return h;
    }
    function caml_hash_mix_float(h, v0) {
        return caml_hash_mix_int64(h, caml_int64_bits_of_float(v0));
    }
    function caml_jsbytes_of_string(x) {
        return x;
    }
    function caml_hash_mix_string(h, v) {
        return caml_hash_mix_jsbytes(h, caml_jsbytes_of_string(v));
    }
    function caml_hash_mix_bytes_arr(h, s) {
        var len = s.length, i, w;
        for(i = 0; i + 4 <= len; i += 4){
            w = s[i] | s[i + 1] << 8 | s[i + 2] << 16 | s[i + 3] << 24;
            h = caml_hash_mix_int(h, w);
        }
        w = 0;
        switch(len & 3){
            case 3:
                w = s[i + 2] << 16;
            case 2:
                w |= s[i + 1] << 8;
            case 1:
                w |= s[i];
                h = caml_hash_mix_int(h, w);
        }
        h ^= len;
        return h;
    }
    function caml_str_repeat(n, s) {
        if (n == 0) return "";
        if (s.repeat) return s.repeat(n);
        var r = "", l = 0;
        for(;;){
            if (n & 1) r += s;
            n >>= 1;
            if (n == 0) return r;
            s += s;
            l++;
            if (l == 9) s.slice(0, 1);
        }
    }
    function caml_subarray_to_jsbytes(a, i, len) {
        var f = String.fromCharCode;
        if (i == 0 && len <= 4096 && len == a.length) return f.apply(null, a);
        var s = "";
        for(; 0 < len; i += 1024, len -= 1024)s += f.apply(null, a.slice(i, i + Math.min(len, 1024)));
        return s;
    }
    function caml_convert_string_to_bytes(s) {
        if (s.t == 2) s.c += caml_str_repeat(s.l - s.c.length, "\0");
        else s.c = caml_subarray_to_jsbytes(s.c, 0, s.c.length);
        s.t = 0;
    }
    function jsoo_is_ascii(s) {
        if (s.length < 24) {
            for(var i = 0; i < s.length; i++)if (s.charCodeAt(i) > 127) return false;
            return true;
        } else return !/[^\x00-\x7f]/.test(s);
    }
    function caml_utf16_of_utf8(s) {
        for(var b = "", t = "", c, c1, c2, v, i = 0, l = s.length; i < l; i++){
            c1 = s.charCodeAt(i);
            if (c1 < 0x80) {
                for(var j = i + 1; j < l && (c1 = s.charCodeAt(j)) < 0x80; j++);
                if (j - i > 512) {
                    t.substr(0, 1);
                    b += t;
                    t = "";
                    b += s.slice(i, j);
                } else t += s.slice(i, j);
                if (j == l) break;
                i = j;
            }
            v = 1;
            if (++i < l && ((c2 = s.charCodeAt(i)) & -64) == 128) {
                c = c2 + (c1 << 6);
                if (c1 < 0xe0) {
                    v = c - 0x3080;
                    if (v < 0x80) v = 1;
                } else {
                    v = 2;
                    if (++i < l && ((c2 = s.charCodeAt(i)) & -64) == 128) {
                        c = c2 + (c << 6);
                        if (c1 < 0xf0) {
                            v = c - 0xe2080;
                            if (v < 0x800 || v >= 0xd7ff && v < 0xe000) v = 2;
                        } else {
                            v = 3;
                            if (++i < l && ((c2 = s.charCodeAt(i)) & -64) == 128 && c1 < 0xf5) {
                                v = c2 - 0x3c82080 + (c << 6);
                                if (v < 0x10000 || v > 0x10ffff) v = 3;
                            }
                        }
                    }
                }
            }
            if (v < 4) {
                i -= v;
                t += "\ufffd";
            } else if (v > 0xffff) t += String.fromCharCode(0xd7c0 + (v >> 10), 0xdc00 + (v & 0x3FF));
            else t += String.fromCharCode(v);
            if (t.length > 1024) {
                t.substr(0, 1);
                b += t;
                t = "";
            }
        }
        return b + t;
    }
    function MlBytes(tag, contents, length) {
        this.t = tag;
        this.c = contents;
        this.l = length;
    }
    MlBytes.prototype.toString = function() {
        switch(this.t){
            case 9:
                return this.c;
            default:
                caml_convert_string_to_bytes(this);
            case 0:
                if (jsoo_is_ascii(this.c)) {
                    this.t = 9;
                    return this.c;
                }
                this.t = 8;
            case 8:
                return this.c;
        }
    };
    MlBytes.prototype.toUtf16 = function() {
        var r = this.toString();
        if (this.t == 9) return r;
        return caml_utf16_of_utf8(r);
    };
    MlBytes.prototype.slice = function() {
        var content = this.t == 4 ? this.c.slice() : this.c;
        return new MlBytes(this.t, content, this.l);
    };
    function caml_ml_bytes_content(s) {
        switch(s.t & 6){
            default:
                caml_convert_string_to_bytes(s);
            case 0:
                return s.c;
            case 4:
                return s.c;
        }
    }
    function caml_hash_mix_bytes(h, v) {
        var content = caml_ml_bytes_content(v);
        return typeof content === "string" ? caml_hash_mix_jsbytes(h, content) : caml_hash_mix_bytes_arr(h, content);
    }
    function caml_int32_bits_of_float(x) {
        var float32a = new Float32Array(1);
        float32a[0] = x;
        var int32a = new Int32Array(float32a.buffer);
        return int32a[0] | 0;
    }
    function caml_int64_to_bytes(x) {
        return x.toArray();
    }
    function caml_ba_serialize(writer, ba, sz) {
        writer.write(32, ba.dims.length);
        writer.write(32, ba.kind | ba.layout << 8);
        if (ba.caml_custom == "_bigarr02") for(var i = 0; i < ba.dims.length; i++)if (ba.dims[i] < 0xffff) writer.write(16, ba.dims[i]);
        else {
            writer.write(16, 0xffff);
            writer.write(32, 0);
            writer.write(32, ba.dims[i]);
        }
        else for(var i = 0; i < ba.dims.length; i++)writer.write(32, ba.dims[i]);
        switch(ba.kind){
            case 2:
            case 3:
            case 12:
                for(var i = 0; i < ba.data.length; i++)writer.write(8, ba.data[i]);
                break;
            case 4:
            case 5:
                for(var i = 0; i < ba.data.length; i++)writer.write(16, ba.data[i]);
                break;
            case 6:
                for(var i = 0; i < ba.data.length; i++)writer.write(32, ba.data[i]);
                break;
            case 8:
            case 9:
                writer.write(8, 0);
                for(var i = 0; i < ba.data.length; i++)writer.write(32, ba.data[i]);
                break;
            case 7:
                for(var i = 0; i < ba.data.length / 2; i++){
                    var b = caml_int64_to_bytes(ba.get(i));
                    for(var j = 0; j < 8; j++)writer.write(8, b[j]);
                }
                break;
            case 1:
                for(var i = 0; i < ba.data.length; i++){
                    var b = caml_int64_to_bytes(caml_int64_bits_of_float(ba.get(i)));
                    for(var j = 0; j < 8; j++)writer.write(8, b[j]);
                }
                break;
            case 0:
                for(var i = 0; i < ba.data.length; i++){
                    var b = caml_int32_bits_of_float(ba.get(i));
                    writer.write(32, b);
                }
                break;
            case 10:
                for(var i = 0; i < ba.data.length / 2; i++){
                    var j = ba.get(i);
                    writer.write(32, caml_int32_bits_of_float(j[1]));
                    writer.write(32, caml_int32_bits_of_float(j[2]));
                }
                break;
            case 11:
                for(var i = 0; i < ba.data.length / 2; i++){
                    var complex = ba.get(i), b = caml_int64_to_bytes(caml_int64_bits_of_float(complex[1]));
                    for(var j = 0; j < 8; j++)writer.write(8, b[j]);
                    var b = caml_int64_to_bytes(caml_int64_bits_of_float(complex[2]));
                    for(var j = 0; j < 8; j++)writer.write(8, b[j]);
                }
                break;
        }
        sz[0] = (4 + ba.dims.length) * 4;
        sz[1] = (4 + ba.dims.length) * 8;
    }
    function jsoo_sys_getenv(n) {
        var process = globalThis1.process;
        if (process && process.env && process.env[n] != undefined) return process.env[n];
        if (globalThis1.jsoo_static_env && globalThis1.jsoo_static_env[n]) return globalThis1.jsoo_static_env[n];
    }
    var caml_record_backtrace_flag = 0;
    (function() {
        var r = jsoo_sys_getenv("OCAMLRUNPARAM");
        if (r !== undefined) {
            var l = r.split(",");
            for(var i = 0; i < l.length; i++)if (l[i] == "b") {
                caml_record_backtrace_flag = 1;
                break;
            } else if (l[i].startsWith("b=")) caml_record_backtrace_flag = +l[i].slice(2);
            else continue;
        }
    })();
    function caml_exn_with_js_backtrace(exn, force) {
        if (!exn.js_error || force || exn[0] == 248) exn.js_error = new globalThis1.Error("Js exception containing backtrace");
        return exn;
    }
    function caml_maybe_attach_backtrace(exn, force) {
        return caml_record_backtrace_flag ? caml_exn_with_js_backtrace(exn, force) : exn;
    }
    function caml_raise_with_arg(tag, arg) {
        throw caml_maybe_attach_backtrace([
            0,
            tag,
            arg
        ]);
    }
    function caml_string_of_jsbytes(x) {
        return x;
    }
    function caml_raise_with_string(tag, msg) {
        caml_raise_with_arg(tag, caml_string_of_jsbytes(msg));
    }
    function caml_invalid_argument(msg) {
        caml_raise_with_string(caml_global_data.Invalid_argument, msg);
    }
    function caml_ba_get_size_per_element(kind) {
        switch(kind){
            case 7:
            case 10:
            case 11:
                return 2;
            default:
                return 1;
        }
    }
    function caml_ba_create_buffer(kind, size) {
        var view;
        switch(kind){
            case 0:
                view = Float32Array;
                break;
            case 1:
                view = Float64Array;
                break;
            case 2:
                view = Int8Array;
                break;
            case 3:
                view = Uint8Array;
                break;
            case 4:
                view = Int16Array;
                break;
            case 5:
                view = Uint16Array;
                break;
            case 6:
                view = Int32Array;
                break;
            case 7:
                view = Int32Array;
                break;
            case 8:
                view = Int32Array;
                break;
            case 9:
                view = Int32Array;
                break;
            case 10:
                view = Float32Array;
                break;
            case 11:
                view = Float64Array;
                break;
            case 12:
                view = Uint8Array;
                break;
        }
        if (!view) caml_invalid_argument("Bigarray.create: unsupported kind");
        var data = new view(size * caml_ba_get_size_per_element(kind));
        return data;
    }
    function caml_int32_float_of_bits(x) {
        var int32a = new Int32Array(1);
        int32a[0] = x;
        var float32a = new Float32Array(int32a.buffer);
        return float32a[0];
    }
    function caml_int64_of_bytes(a) {
        return new MlInt64(a[7] << 0 | a[6] << 8 | a[5] << 16, a[4] << 0 | a[3] << 8 | a[2] << 16, a[1] << 0 | a[0] << 8);
    }
    function caml_int64_float_of_bits(x) {
        var lo = x.lo, mi = x.mi, hi = x.hi, exp = (hi & 0x7fff) >> 4;
        if (exp == 2047) return (lo | mi | hi & 0xf) == 0 ? hi & 0x8000 ? -Infinity : Infinity : NaN;
        var k = Math.pow(2, -24), res = (lo * k + mi) * k + (hi & 0xf);
        if (exp > 0) {
            res += 16;
            res *= Math.pow(2, exp - 1027);
        } else res *= Math.pow(2, -1026);
        if (hi & 0x8000) res = -res;
        return res;
    }
    function caml_ba_get_size(dims) {
        var n_dims = dims.length, size = 1;
        for(var i = 0; i < n_dims; i++){
            if (dims[i] < 0) caml_invalid_argument("Bigarray.create: negative dimension");
            size = size * dims[i];
        }
        return size;
    }
    function caml_int64_create_lo_hi(lo, hi) {
        return new MlInt64(lo & 0xffffff, lo >>> 24 & 0xff | (hi & 0xffff) << 8, hi >>> 16 & 0xffff);
    }
    function caml_array_bound_error() {
        caml_invalid_argument("index out of bounds");
    }
    var caml_ba_custom_name = "_bigarr02";
    function Ml_Bigarray(kind, layout, dims, buffer) {
        this.kind = kind;
        this.layout = layout;
        this.dims = dims;
        this.data = buffer;
    }
    Ml_Bigarray.prototype.caml_custom = caml_ba_custom_name;
    Ml_Bigarray.prototype.offset = function(arg) {
        var ofs = 0;
        if (typeof arg === "number") arg = [
            arg
        ];
        if (!(arg instanceof Array)) caml_invalid_argument("bigarray.js: invalid offset");
        if (this.dims.length != arg.length) caml_invalid_argument("Bigarray.get/set: bad number of dimensions");
        if (this.layout == 0) for(var i = 0; i < this.dims.length; i++){
            if (arg[i] < 0 || arg[i] >= this.dims[i]) caml_array_bound_error();
            ofs = ofs * this.dims[i] + arg[i];
        }
        else for(var i = this.dims.length - 1; i >= 0; i--){
            if (arg[i] < 1 || arg[i] > this.dims[i]) caml_array_bound_error();
            ofs = ofs * this.dims[i] + (arg[i] - 1);
        }
        return ofs;
    };
    Ml_Bigarray.prototype.get = function(ofs) {
        switch(this.kind){
            case 7:
                var l = this.data[ofs * 2 + 0], h = this.data[ofs * 2 + 1];
                return caml_int64_create_lo_hi(l, h);
            case 10:
            case 11:
                var r = this.data[ofs * 2 + 0], i = this.data[ofs * 2 + 1];
                return [
                    254,
                    r,
                    i
                ];
            default:
                return this.data[ofs];
        }
    };
    Ml_Bigarray.prototype.set = function(ofs, v) {
        switch(this.kind){
            case 7:
                this.data[ofs * 2 + 0] = caml_int64_lo32(v);
                this.data[ofs * 2 + 1] = caml_int64_hi32(v);
                break;
            case 10:
            case 11:
                this.data[ofs * 2 + 0] = v[1];
                this.data[ofs * 2 + 1] = v[2];
                break;
            default:
                this.data[ofs] = v;
                break;
        }
        return 0;
    };
    Ml_Bigarray.prototype.fill = function(v) {
        switch(this.kind){
            case 7:
                var a = caml_int64_lo32(v), b = caml_int64_hi32(v);
                if (a == b) this.data.fill(a);
                else for(var i = 0; i < this.data.length; i++)this.data[i] = i % 2 == 0 ? a : b;
                break;
            case 10:
            case 11:
                var im = v[1], re = v[2];
                if (im == re) this.data.fill(im);
                else for(var i = 0; i < this.data.length; i++)this.data[i] = i % 2 == 0 ? im : re;
                break;
            default:
                this.data.fill(v);
                break;
        }
    };
    Ml_Bigarray.prototype.compare = function(b, total) {
        if (this.layout != b.layout || this.kind != b.kind) {
            var k1 = this.kind | this.layout << 8, k2 = b.kind | b.layout << 8;
            return k2 - k1;
        }
        if (this.dims.length != b.dims.length) return b.dims.length - this.dims.length;
        for(var i = 0; i < this.dims.length; i++)if (this.dims[i] != b.dims[i]) return this.dims[i] < b.dims[i] ? -1 : 1;
        switch(this.kind){
            case 0:
            case 1:
            case 10:
            case 11:
                var x, y;
                for(var i = 0; i < this.data.length; i++){
                    x = this.data[i];
                    y = b.data[i];
                    if (x < y) return -1;
                    if (x > y) return 1;
                    if (x != y) {
                        if (!total) return NaN;
                        if (x == x) return 1;
                        if (y == y) return -1;
                    }
                }
                break;
            case 7:
                for(var i = 0; i < this.data.length; i += 2){
                    if (this.data[i + 1] < b.data[i + 1]) return -1;
                    if (this.data[i + 1] > b.data[i + 1]) return 1;
                    if (this.data[i] >>> 0 < b.data[i] >>> 0) return -1;
                    if (this.data[i] >>> 0 > b.data[i] >>> 0) return 1;
                }
                break;
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 8:
            case 9:
            case 12:
                for(var i = 0; i < this.data.length; i++){
                    if (this.data[i] < b.data[i]) return -1;
                    if (this.data[i] > b.data[i]) return 1;
                }
                break;
        }
        return 0;
    };
    function Ml_Bigarray_c_1_1(kind, layout, dims, buffer) {
        this.kind = kind;
        this.layout = layout;
        this.dims = dims;
        this.data = buffer;
    }
    Ml_Bigarray_c_1_1.prototype = new Ml_Bigarray();
    Ml_Bigarray_c_1_1.prototype.offset = function(arg) {
        if (typeof arg !== "number") {
            if (arg instanceof Array && arg.length == 1) arg = arg[0];
            else caml_invalid_argument("Ml_Bigarray_c_1_1.offset");
        }
        if (arg < 0 || arg >= this.dims[0]) caml_array_bound_error();
        return arg;
    };
    Ml_Bigarray_c_1_1.prototype.get = function(ofs) {
        return this.data[ofs];
    };
    Ml_Bigarray_c_1_1.prototype.set = function(ofs, v) {
        this.data[ofs] = v;
        return 0;
    };
    Ml_Bigarray_c_1_1.prototype.fill = function(v) {
        this.data.fill(v);
        return 0;
    };
    function caml_ba_create_unsafe(kind, layout, dims, data) {
        var size_per_element = caml_ba_get_size_per_element(kind);
        if (caml_ba_get_size(dims) * size_per_element != data.length) caml_invalid_argument("length doesn't match dims");
        if (layout == 0 && dims.length == 1 && size_per_element == 1) return new Ml_Bigarray_c_1_1(kind, layout, dims, data);
        return new Ml_Bigarray(kind, layout, dims, data);
    }
    function caml_failwith(msg) {
        if (!caml_global_data.Failure) caml_global_data.Failure = [
            248,
            caml_string_of_jsbytes("Failure"),
            -3
        ];
        caml_raise_with_string(caml_global_data.Failure, msg);
    }
    function caml_ba_deserialize(reader, sz, name) {
        var num_dims = reader.read32s();
        if (num_dims < 0 || num_dims > 16) caml_failwith("input_value: wrong number of bigarray dimensions");
        var tag = reader.read32s(), kind = tag & 0xff, layout = tag >> 8 & 1, dims = [];
        if (name == "_bigarr02") for(var i = 0; i < num_dims; i++){
            var size_dim = reader.read16u();
            if (size_dim == 0xffff) {
                var size_dim_hi = reader.read32u(), size_dim_lo = reader.read32u();
                if (size_dim_hi != 0) caml_failwith("input_value: bigarray dimension overflow in 32bit");
                size_dim = size_dim_lo;
            }
            dims.push(size_dim);
        }
        else for(var i = 0; i < num_dims; i++)dims.push(reader.read32u());
        var size = caml_ba_get_size(dims), data = caml_ba_create_buffer(kind, size), ba = caml_ba_create_unsafe(kind, layout, dims, data);
        switch(kind){
            case 2:
                for(var i = 0; i < size; i++)data[i] = reader.read8s();
                break;
            case 3:
            case 12:
                for(var i = 0; i < size; i++)data[i] = reader.read8u();
                break;
            case 4:
                for(var i = 0; i < size; i++)data[i] = reader.read16s();
                break;
            case 5:
                for(var i = 0; i < size; i++)data[i] = reader.read16u();
                break;
            case 6:
                for(var i = 0; i < size; i++)data[i] = reader.read32s();
                break;
            case 8:
            case 9:
                var sixty = reader.read8u();
                if (sixty) caml_failwith("input_value: cannot read bigarray with 64-bit OCaml ints");
                for(var i = 0; i < size; i++)data[i] = reader.read32s();
                break;
            case 7:
                var t = new Array(8);
                for(var i = 0; i < size; i++){
                    for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                    var int64 = caml_int64_of_bytes(t);
                    ba.set(i, int64);
                }
                break;
            case 1:
                var t = new Array(8);
                for(var i = 0; i < size; i++){
                    for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                    var f = caml_int64_float_of_bits(caml_int64_of_bytes(t));
                    ba.set(i, f);
                }
                break;
            case 0:
                for(var i = 0; i < size; i++){
                    var f = caml_int32_float_of_bits(reader.read32s());
                    ba.set(i, f);
                }
                break;
            case 10:
                for(var i = 0; i < size; i++){
                    var re = caml_int32_float_of_bits(reader.read32s()), im = caml_int32_float_of_bits(reader.read32s());
                    ba.set(i, [
                        254,
                        re,
                        im
                    ]);
                }
                break;
            case 11:
                var t = new Array(8);
                for(var i = 0; i < size; i++){
                    for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                    var re = caml_int64_float_of_bits(caml_int64_of_bytes(t));
                    for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                    var im = caml_int64_float_of_bits(caml_int64_of_bytes(t));
                    ba.set(i, [
                        254,
                        re,
                        im
                    ]);
                }
                break;
        }
        sz[0] = (4 + num_dims) * 4;
        return caml_ba_create_unsafe(kind, layout, dims, data);
    }
    function caml_ba_compare(a, b, total) {
        return a.compare(b, total);
    }
    function caml_ba_hash(ba) {
        var num_elts = caml_ba_get_size(ba.dims), h = 0;
        switch(ba.kind){
            case 2:
            case 3:
            case 12:
                if (num_elts > 256) num_elts = 256;
                var w = 0, i = 0;
                for(i = 0; i + 4 <= ba.data.length; i += 4){
                    w = ba.data[i + 0] | ba.data[i + 1] << 8 | ba.data[i + 2] << 16 | ba.data[i + 3] << 24;
                    h = caml_hash_mix_int(h, w);
                }
                w = 0;
                switch(num_elts & 3){
                    case 3:
                        w = ba.data[i + 2] << 16;
                    case 2:
                        w |= ba.data[i + 1] << 8;
                    case 1:
                        w |= ba.data[i + 0];
                        h = caml_hash_mix_int(h, w);
                }
                break;
            case 4:
            case 5:
                if (num_elts > 128) num_elts = 128;
                var w = 0, i = 0;
                for(i = 0; i + 2 <= ba.data.length; i += 2){
                    w = ba.data[i + 0] | ba.data[i + 1] << 16;
                    h = caml_hash_mix_int(h, w);
                }
                if ((num_elts & 1) != 0) h = caml_hash_mix_int(h, ba.data[i]);
                break;
            case 6:
                if (num_elts > 64) num_elts = 64;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_int(h, ba.data[i]);
                break;
            case 8:
            case 9:
                if (num_elts > 64) num_elts = 64;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_int(h, ba.data[i]);
                break;
            case 7:
                if (num_elts > 32) num_elts = 32;
                num_elts *= 2;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_int(h, ba.data[i]);
                break;
            case 10:
                num_elts *= 2;
            case 0:
                if (num_elts > 64) num_elts = 64;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_float(h, ba.data[i]);
                break;
            case 11:
                num_elts *= 2;
            case 1:
                if (num_elts > 32) num_elts = 32;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_float(h, ba.data[i]);
                break;
        }
        return h;
    }
    function caml_int32_unmarshal(reader, size) {
        size[0] = 4;
        return reader.read32s();
    }
    function caml_nativeint_unmarshal(reader, size) {
        switch(reader.read8u()){
            case 1:
                size[0] = 4;
                return reader.read32s();
            case 2:
                caml_failwith("input_value: native integer value too large");
            default:
                caml_failwith("input_value: ill-formed native integer");
        }
    }
    function caml_int64_unmarshal(reader, size) {
        var t = new Array(8);
        for(var j = 0; j < 8; j++)t[j] = reader.read8u();
        size[0] = 8;
        return caml_int64_of_bytes(t);
    }
    function caml_int64_marshal(writer, v, sizes) {
        var b = caml_int64_to_bytes(v);
        for(var i = 0; i < 8; i++)writer.write(8, b[i]);
        sizes[0] = 8;
        sizes[1] = 8;
    }
    function caml_int64_compare(x, y, total) {
        return x.compare(y);
    }
    function caml_int64_hash(v) {
        return v.lo32() ^ v.hi32();
    }
    var caml_custom_ops = {
        "_j": {
            deserialize: caml_int64_unmarshal,
            serialize: caml_int64_marshal,
            fixed_length: 8,
            compare: caml_int64_compare,
            hash: caml_int64_hash
        },
        "_i": {
            deserialize: caml_int32_unmarshal,
            fixed_length: 4
        },
        "_n": {
            deserialize: caml_nativeint_unmarshal,
            fixed_length: 4
        },
        "_bigarray": {
            deserialize: function(reader, sz) {
                return caml_ba_deserialize(reader, sz, "_bigarray");
            },
            serialize: caml_ba_serialize,
            compare: caml_ba_compare,
            hash: caml_ba_hash
        },
        "_bigarr02": {
            deserialize: function(reader, sz) {
                return caml_ba_deserialize(reader, sz, "_bigarr02");
            },
            serialize: caml_ba_serialize,
            compare: caml_ba_compare,
            hash: caml_ba_hash
        }
    };
    function caml_hash_mix_final(h) {
        h ^= h >>> 16;
        h = caml_mul(h, -2048144789);
        h ^= h >>> 13;
        h = caml_mul(h, -1028477387);
        h ^= h >>> 16;
        return h;
    }
    function caml_is_ml_string(s) {
        return typeof s === "string" && !/[^\x00-\xff]/.test(s);
    }
    function caml_is_ml_bytes(s) {
        return s instanceof MlBytes;
    }
    function caml_hash(count, limit, seed, obj) {
        var queue, rd, wr, sz, num, h, v, i, len;
        sz = limit;
        if (sz < 0 || sz > 256) sz = 256;
        num = count;
        h = seed;
        queue = [
            obj
        ];
        rd = 0;
        wr = 1;
        while(rd < wr && num > 0){
            v = queue[rd++];
            if (v && v.caml_custom) {
                if (caml_custom_ops[v.caml_custom] && caml_custom_ops[v.caml_custom].hash) {
                    var hh = caml_custom_ops[v.caml_custom].hash(v);
                    h = caml_hash_mix_int(h, hh);
                    num--;
                }
            } else if (v instanceof Array && v[0] === (v[0] | 0)) switch(v[0]){
                case 248:
                    h = caml_hash_mix_int(h, v[2]);
                    num--;
                    break;
                case 250:
                    queue[--rd] = v[1];
                    break;
                default:
                    if (caml_is_continuation_tag(v[0])) break;
                    var tag = v.length - 1 << 10 | v[0];
                    h = caml_hash_mix_int(h, tag);
                    for(i = 1, len = v.length; i < len; i++){
                        if (wr >= sz) break;
                        queue[wr++] = v[i];
                    }
                    break;
            }
            else if (caml_is_ml_bytes(v)) {
                h = caml_hash_mix_bytes(h, v);
                num--;
            } else if (caml_is_ml_string(v)) {
                h = caml_hash_mix_string(h, v);
                num--;
            } else if (typeof v === "string") {
                h = caml_hash_mix_jsbytes(h, v);
                num--;
            } else if (v === (v | 0)) {
                h = caml_hash_mix_int(h, v + v + 1);
                num--;
            } else if (typeof v === "number") {
                h = caml_hash_mix_float(h, v);
                num--;
            }
        }
        h = caml_hash_mix_final(h);
        return h & 0x3FFFFFFF;
    }
    function Base_hash_double(d) {
        return caml_hash(1, 1, 0, d);
    }
    function Base_hash_string(s) {
        return caml_hash(1, 1, 0, s);
    }
    function Base_int_math_int32_clz(x) {
        var n = 32, y;
        y = x >> 16;
        if (y != 0) {
            n = n - 16;
            x = y;
        }
        y = x >> 8;
        if (y != 0) {
            n = n - 8;
            x = y;
        }
        y = x >> 4;
        if (y != 0) {
            n = n - 4;
            x = y;
        }
        y = x >> 2;
        if (y != 0) {
            n = n - 2;
            x = y;
        }
        y = x >> 1;
        if (y != 0) return n - 2;
        return n - x;
    }
    function Base_int_math_int32_ctz(x) {
        if (x === 0) return 32;
        var n = 1;
        if ((x & 0x0000FFFF) === 0) {
            n = n + 16;
            x = x >> 16;
        }
        if ((x & 0x000000FF) === 0) {
            n = n + 8;
            x = x >> 8;
        }
        if ((x & 0x0000000F) === 0) {
            n = n + 4;
            x = x >> 4;
        }
        if ((x & 0x00000003) === 0) {
            n = n + 2;
            x = x >> 2;
        }
        return n - (x & 1);
    }
    function caml_int64_shift_right_unsigned(x, s) {
        return x.shift_right_unsigned(s);
    }
    function caml_int64_is_zero(x) {
        return +x.isZero();
    }
    function caml_int64_to_int32(x) {
        return x.toInt();
    }
    function Base_int_math_int64_clz(x) {
        var n = 64, y;
        y = caml_int64_shift_right_unsigned(x, 32);
        if (!caml_int64_is_zero(y)) {
            n = n - 32;
            x = y;
        }
        y = caml_int64_shift_right_unsigned(x, 16);
        if (!caml_int64_is_zero(y)) {
            n = n - 16;
            x = y;
        }
        y = caml_int64_shift_right_unsigned(x, 8);
        if (!caml_int64_is_zero(y)) {
            n = n - 8;
            x = y;
        }
        y = caml_int64_shift_right_unsigned(x, 4);
        if (!caml_int64_is_zero(y)) {
            n = n - 4;
            x = y;
        }
        y = caml_int64_shift_right_unsigned(x, 2);
        if (!caml_int64_is_zero(y)) {
            n = n - 2;
            x = y;
        }
        y = caml_int64_shift_right_unsigned(x, 1);
        if (!caml_int64_is_zero(y)) return n - 2;
        return n - caml_int64_to_int32(x);
    }
    function caml_int64_and(x, y) {
        return x.and(y);
    }
    function caml_int64_of_int32(x) {
        return new MlInt64(x & 0xffffff, x >> 24 & 0xffffff, x >> 31 & 0xffff);
    }
    function Base_int_math_int64_ctz(x) {
        if (caml_int64_is_zero(x)) return 64;
        var n = 1;
        function is_zero(x) {
            return caml_int64_is_zero(x);
        }
        function land(x, y) {
            return caml_int64_and(x, y);
        }
        function small_int64(x) {
            return caml_int64_create_lo_mi_hi(x, 0, 0);
        }
        if (is_zero(land(x, caml_int64_create_lo_mi_hi(0xFFFFFF, 0x0000FF, 0x0000)))) {
            n = n + 32;
            x = caml_int64_shift_right_unsigned(x, 32);
        }
        if (is_zero(land(x, small_int64(0x00FFFF)))) {
            n = n + 16;
            x = caml_int64_shift_right_unsigned(x, 16);
        }
        if (is_zero(land(x, small_int64(0x0000FF)))) {
            n = n + 8;
            x = caml_int64_shift_right_unsigned(x, 8);
        }
        if (is_zero(land(x, small_int64(0x00000F)))) {
            n = n + 4;
            x = caml_int64_shift_right_unsigned(x, 4);
        }
        if (is_zero(land(x, small_int64(0x000003)))) {
            n = n + 2;
            x = caml_int64_shift_right_unsigned(x, 2);
        }
        return n - caml_int64_to_int32(caml_int64_and(x, small_int64(0x000001)));
    }
    function caml_int64_mul(x, y) {
        return x.mul(y);
    }
    function Base_int_math_int64_pow_stub(base, exponent) {
        var one = caml_int64_create_lo_hi(1, 0), mul = [
            one,
            base,
            one,
            one
        ], res = one;
        while(!caml_int64_is_zero(exponent)){
            mul[1] = caml_int64_mul(mul[1], mul[3]);
            mul[2] = caml_int64_mul(mul[1], mul[1]);
            mul[3] = caml_int64_mul(mul[2], mul[1]);
            res = caml_int64_mul(res, mul[caml_int64_lo32(exponent) & 3]);
            exponent = caml_int64_shift_right_unsigned(exponent, 2);
        }
        return res;
    }
    function Base_int_math_int_clz(x) {
        return Base_int_math_int32_clz(x);
    }
    function Base_int_math_int_ctz(x) {
        return Base_int_math_int32_ctz(x);
    }
    function Base_int_math_int_popcount(v) {
        v = v - (v >>> 1 & 0x55555555);
        v = (v & 0x33333333) + (v >>> 2 & 0x33333333);
        return (v + (v >>> 4) & 0xF0F0F0F) * 0x1010101 >>> 24;
    }
    function Base_int_math_int_pow_stub(base, exponent) {
        var one = 1, mul = [
            one,
            base,
            one,
            one
        ], res = one;
        while(!exponent == 0){
            mul[1] = mul[1] * mul[3] | 0;
            mul[2] = mul[1] * mul[1] | 0;
            mul[3] = mul[2] * mul[1] | 0;
            res = res * mul[exponent & 3] | 0;
            exponent = exponent >> 2;
        }
        return res;
    }
    function Base_int_math_nativeint_clz(x) {
        return Base_int_math_int32_clz(x);
    }
    function Base_int_math_nativeint_ctz(x) {
        return Base_int_math_int32_ctz(x);
    }
    var Base_internalhash_fold_float = caml_hash_mix_float, Base_internalhash_fold_int = caml_hash_mix_int, Base_internalhash_fold_int64 = caml_hash_mix_int64, Base_internalhash_fold_string = caml_hash_mix_string;
    function Base_internalhash_get_hash_value(seed) {
        var h = caml_hash_mix_final(seed);
        return h & 0x3FFFFFFF;
    }
    function caml_create_bytes(len) {
        if (len < 0) caml_invalid_argument("Bytes.create");
        return new MlBytes(len ? 2 : 9, "", len);
    }
    function Base_unsafe_create_local_bytes(v_len) {
        return caml_create_bytes(v_len);
    }
    function caml_string_of_array(a) {
        return caml_string_of_jsbytes(caml_subarray_to_jsbytes(a, 0, a.length));
    }
    function caml_ba_get_1(ba, i0) {
        return ba.get(ba.offset(i0));
    }
    function BigStringReader(bs, i) {
        this.s = bs;
        this.i = i;
    }
    BigStringReader.prototype = {
        read8u: function() {
            return caml_ba_get_1(this.s, this.i++);
        },
        read8s: function() {
            return caml_ba_get_1(this.s, this.i++) << 24 >> 24;
        },
        read16u: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return caml_ba_get_1(s, i) << 8 | caml_ba_get_1(s, i + 1);
        },
        read16s: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return caml_ba_get_1(s, i) << 24 >> 16 | caml_ba_get_1(s, i + 1);
        },
        read32u: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return (caml_ba_get_1(s, i) << 24 | caml_ba_get_1(s, i + 1) << 16 | caml_ba_get_1(s, i + 2) << 8 | caml_ba_get_1(s, i + 3)) >>> 0;
        },
        read32s: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return caml_ba_get_1(s, i) << 24 | caml_ba_get_1(s, i + 1) << 16 | caml_ba_get_1(s, i + 2) << 8 | caml_ba_get_1(s, i + 3);
        },
        readstr: function(len) {
            var i = this.i, arr = new Array(len);
            for(var j = 0; j < len; j++)arr[j] = caml_ba_get_1(this.s, i + j);
            this.i = i + len;
            return caml_string_of_array(arr);
        },
        readuint8array: function(len) {
            var i = this.i, offset = this.offset(i);
            this.i = i + len;
            return this.s.data.subarray(offset, offset + len);
        }
    };
    function caml_utf8_of_utf16(s) {
        for(var b = "", t = b, c, d, i = 0, l = s.length; i < l; i++){
            c = s.charCodeAt(i);
            if (c < 0x80) {
                for(var j = i + 1; j < l && (c = s.charCodeAt(j)) < 0x80; j++);
                if (j - i > 512) {
                    t.substr(0, 1);
                    b += t;
                    t = "";
                    b += s.slice(i, j);
                } else t += s.slice(i, j);
                if (j == l) break;
                i = j;
            }
            if (c < 0x800) {
                t += String.fromCharCode(0xc0 | c >> 6);
                t += String.fromCharCode(0x80 | c & 0x3f);
            } else if (c < 0xd800 || c >= 0xdfff) t += String.fromCharCode(0xe0 | c >> 12, 0x80 | c >> 6 & 0x3f, 0x80 | c & 0x3f);
            else if (c >= 0xdbff || i + 1 == l || (d = s.charCodeAt(i + 1)) < 0xdc00 || d > 0xdfff) t += "\xef\xbf\xbd";
            else {
                i++;
                c = (c << 10) + d - 0x35fdc00;
                t += String.fromCharCode(0xf0 | c >> 18, 0x80 | c >> 12 & 0x3f, 0x80 | c >> 6 & 0x3f, 0x80 | c & 0x3f);
            }
            if (t.length > 1024) {
                t.substr(0, 1);
                b += t;
                t = "";
            }
        }
        return b + t;
    }
    function caml_string_of_jsstring(s) {
        return jsoo_is_ascii(s) ? caml_string_of_jsbytes(s) : caml_string_of_jsbytes(caml_utf8_of_utf16(s));
    }
    var unix_error = [
        "E2BIG",
        "EACCES",
        "EAGAIN",
        "EBADF",
        "EBUSY",
        "ECHILD",
        "EDEADLK",
        "EDOM",
        "EEXIST",
        "EFAULT",
        "EFBIG",
        "EINTR",
        "EINVAL",
        "EIO",
        "EISDIR",
        "EMFILE",
        "EMLINK",
        "ENAMETOOLONG",
        "ENFILE",
        "ENODEV",
        "ENOENT",
        "ENOEXEC",
        "ENOLCK",
        "ENOMEM",
        "ENOSPC",
        "ENOSYS",
        "ENOTDIR",
        "ENOTEMPTY",
        "ENOTTY",
        "ENXIO",
        "EPERM",
        "EPIPE",
        "ERANGE",
        "EROFS",
        "ESPIPE",
        "ESRCH",
        "EXDEV",
        "EWOULDBLOCK",
        "EINPROGRESS",
        "EALREADY",
        "ENOTSOCK",
        "EDESTADDRREQ",
        "EMSGSIZE",
        "EPROTOTYPE",
        "ENOPROTOOPT",
        "EPROTONOSUPPORT",
        "ESOCKTNOSUPPORT",
        "EOPNOTSUPP",
        "EPFNOSUPPORT",
        "EAFNOSUPPORT",
        "EADDRINUSE",
        "EADDRNOTAVAIL",
        "ENETDOWN",
        "ENETUNREACH",
        "ENETRESET",
        "ECONNABORTED",
        "ECONNRESET",
        "ENOBUFS",
        "EISCONN",
        "ENOTCONN",
        "ESHUTDOWN",
        "ETOOMANYREFS",
        "ETIMEDOUT",
        "ECONNREFUSED",
        "EHOSTDOWN",
        "EHOSTUNREACH",
        "ELOOP",
        "EOVERFLOW"
    ];
    function make_unix_err_args(code, syscall, path, errno) {
        var variant = unix_error.indexOf(code);
        if (variant < 0) {
            if (errno == null) errno = -9999;
            variant = [
                0,
                errno
            ];
        }
        var args = [
            variant,
            caml_string_of_jsstring(syscall || ""),
            caml_string_of_jsstring(path || "")
        ];
        return args;
    }
    var caml_named_values = {};
    function caml_named_value(nm) {
        return caml_named_values[nm];
    }
    function caml_raise_with_args(tag, args) {
        throw caml_maybe_attach_backtrace([
            0,
            tag
        ].concat(args));
    }
    function caml_bytes_of_array(a) {
        if (!(a instanceof Uint8Array)) a = new Uint8Array(a);
        return new MlBytes(4, a, a.length);
    }
    function caml_bytes_of_jsbytes(s) {
        return new MlBytes(0, s, s.length);
    }
    function caml_bytes_of_string(s) {
        return caml_bytes_of_jsbytes(caml_jsbytes_of_string(s));
    }
    function caml_raise_sys_error(msg) {
        caml_raise_with_string(caml_global_data.Sys_error, msg);
    }
    function caml_raise_no_such_file(name) {
        caml_raise_sys_error(name + ": No such file or directory");
    }
    function caml_convert_bytes_to_array(s) {
        var a = new Uint8Array(s.l), b = s.c, l = b.length, i = 0;
        for(; i < l; i++)a[i] = b.charCodeAt(i);
        for(l = s.l; i < l; i++)a[i] = 0;
        s.c = a;
        s.t = 4;
        return a;
    }
    function caml_uint8_array_of_bytes(s) {
        if (s.t != 4) caml_convert_bytes_to_array(s);
        return s.c;
    }
    function caml_ml_bytes_length(s) {
        return s.l;
    }
    function caml_blit_bytes(s1, i1, s2, i2, len) {
        if (len == 0) return 0;
        if (i2 == 0 && (len >= s2.l || s2.t == 2 && len >= s2.c.length)) {
            s2.c = s1.t == 4 ? caml_subarray_to_jsbytes(s1.c, i1, len) : i1 == 0 && s1.c.length == len ? s1.c : s1.c.substr(i1, len);
            s2.t = s2.c.length == s2.l ? 0 : 2;
        } else if (s2.t == 2 && i2 == s2.c.length) {
            s2.c += s1.t == 4 ? caml_subarray_to_jsbytes(s1.c, i1, len) : i1 == 0 && s1.c.length == len ? s1.c : s1.c.substr(i1, len);
            s2.t = s2.c.length == s2.l ? 0 : 2;
        } else {
            if (s2.t != 4) caml_convert_bytes_to_array(s2);
            var c1 = s1.c, c2 = s2.c;
            if (s1.t == 4) {
                if (i2 <= i1) for(var i = 0; i < len; i++)c2[i2 + i] = c1[i1 + i];
                else for(var i = len - 1; i >= 0; i--)c2[i2 + i] = c1[i1 + i];
            } else {
                var l = Math.min(len, c1.length - i1);
                for(var i = 0; i < l; i++)c2[i2 + i] = c1.charCodeAt(i1 + i);
                for(; i < len; i++)c2[i2 + i] = 0;
            }
        }
        return 0;
    }
    function MlFile() {}
    function MlFakeFile(content) {
        this.data = content;
    }
    MlFakeFile.prototype = new MlFile();
    MlFakeFile.prototype.constructor = MlFakeFile;
    MlFakeFile.prototype.truncate = function(len) {
        var old = this.data;
        this.data = caml_create_bytes(len | 0);
        caml_blit_bytes(old, 0, this.data, 0, len);
    };
    MlFakeFile.prototype.length = function() {
        return caml_ml_bytes_length(this.data);
    };
    MlFakeFile.prototype.write = function(offset, buf, pos, len) {
        var clen = this.length();
        if (offset + len >= clen) {
            var new_str = caml_create_bytes(offset + len), old_data = this.data;
            this.data = new_str;
            caml_blit_bytes(old_data, 0, this.data, 0, clen);
        }
        caml_blit_bytes(caml_bytes_of_array(buf), pos, this.data, offset, len);
        return 0;
    };
    MlFakeFile.prototype.read = function(offset, buf, pos, len) {
        var clen = this.length();
        if (offset + len >= clen) len = clen - offset;
        if (len) {
            var data = caml_create_bytes(len | 0);
            caml_blit_bytes(this.data, offset, data, 0, len);
            buf.set(caml_uint8_array_of_bytes(data), pos);
        }
        return len;
    };
    function MlFakeFd(name, file, flags) {
        this.file = file;
        this.name = name;
        this.flags = flags;
    }
    MlFakeFd.prototype.err_closed = function() {
        caml_raise_sys_error(this.name + ": file descriptor already closed");
    };
    MlFakeFd.prototype.length = function() {
        if (this.file) return this.file.length();
        this.err_closed();
    };
    MlFakeFd.prototype.write = function(offset, buf, pos, len) {
        if (this.file) return this.file.write(offset, buf, pos, len);
        this.err_closed();
    };
    MlFakeFd.prototype.read = function(offset, buf, pos, len) {
        if (this.file) return this.file.read(offset, buf, pos, len);
        this.err_closed();
    };
    MlFakeFd.prototype.close = function() {
        this.file = undefined;
    };
    function MlFakeDevice(root, f) {
        this.content = {};
        this.root = root;
        this.lookupFun = f;
    }
    MlFakeDevice.prototype.nm = function(name) {
        return this.root + name;
    };
    MlFakeDevice.prototype.create_dir_if_needed = function(name) {
        var comp = name.split("/"), res = "";
        for(var i = 0; i < comp.length - 1; i++){
            res += comp[i] + "/";
            if (this.content[res]) continue;
            this.content[res] = Symbol("directory");
        }
    };
    MlFakeDevice.prototype.slash = function(name) {
        return /\/$/.test(name) ? name : name + "/";
    };
    MlFakeDevice.prototype.lookup = function(name) {
        if (!this.content[name] && this.lookupFun) {
            var res = this.lookupFun(caml_string_of_jsbytes(this.root), caml_string_of_jsbytes(name));
            if (res !== 0) {
                this.create_dir_if_needed(name);
                this.content[name] = new MlFakeFile(caml_bytes_of_string(res[1]));
            }
        }
    };
    MlFakeDevice.prototype.exists = function(name) {
        if (name == "") return 1;
        var name_slash = this.slash(name);
        if (this.content[name_slash]) return 1;
        this.lookup(name);
        return this.content[name] ? 1 : 0;
    };
    MlFakeDevice.prototype.isFile = function(name) {
        return this.exists(name) && !this.is_dir(name) ? 1 : 0;
    };
    MlFakeDevice.prototype.mkdir = function(name, mode, raise_unix) {
        var unix_error = raise_unix && caml_named_value("Unix.Unix_error");
        if (this.exists(name)) {
            if (unix_error) caml_raise_with_args(unix_error, make_unix_err_args("EEXIST", "mkdir", this.nm(name)));
            else caml_raise_sys_error(name + ": File exists");
        }
        var parent = /^(.*)\/[^/]+/.exec(name);
        parent = parent && parent[1] || "";
        if (!this.exists(parent)) {
            if (unix_error) caml_raise_with_args(unix_error, make_unix_err_args("ENOENT", "mkdir", this.nm(parent)));
            else caml_raise_sys_error(parent + ": No such file or directory");
        }
        if (!this.is_dir(parent)) {
            if (unix_error) caml_raise_with_args(unix_error, make_unix_err_args("ENOTDIR", "mkdir", this.nm(parent)));
            else caml_raise_sys_error(parent + ": Not a directory");
        }
        this.create_dir_if_needed(this.slash(name));
    };
    MlFakeDevice.prototype.rmdir = function(name, raise_unix) {
        var unix_error = raise_unix && caml_named_value("Unix.Unix_error"), name_slash = name == "" ? "" : this.slash(name), r = new RegExp("^" + name_slash + "([^/]+)");
        if (!this.exists(name)) {
            if (unix_error) caml_raise_with_args(unix_error, make_unix_err_args("ENOENT", "rmdir", this.nm(name)));
            else caml_raise_sys_error(name + ": No such file or directory");
        }
        if (!this.is_dir(name)) {
            if (unix_error) caml_raise_with_args(unix_error, make_unix_err_args("ENOTDIR", "rmdir", this.nm(name)));
            else caml_raise_sys_error(name + ": Not a directory");
        }
        for(var n in this.content)if (n.match(r)) {
            if (unix_error) caml_raise_with_args(unix_error, make_unix_err_args("ENOTEMPTY", "rmdir", this.nm(name)));
            else caml_raise_sys_error(this.nm(name) + ": Directory not empty");
        }
        delete this.content[name_slash];
    };
    MlFakeDevice.prototype.readdir = function(name) {
        var name_slash = name == "" ? "" : this.slash(name);
        if (!this.exists(name)) caml_raise_sys_error(name + ": No such file or directory");
        if (!this.is_dir(name)) caml_raise_sys_error(name + ": Not a directory");
        var r = new RegExp("^" + name_slash + "([^/]+)"), seen = {}, a = [];
        for(var n in this.content){
            var m = n.match(r);
            if (m && !seen[m[1]]) {
                seen[m[1]] = true;
                a.push(m[1]);
            }
        }
        return a;
    };
    MlFakeDevice.prototype.opendir = function(name, raise_unix) {
        var unix_error = raise_unix && caml_named_value("Unix.Unix_error"), a = this.readdir(name), c = false, i = 0;
        return {
            readSync: function() {
                if (c) {
                    if (unix_error) caml_raise_with_args(unix_error, make_unix_err_args("EBADF", "closedir", this.nm(name)));
                    else caml_raise_sys_error(name + ": closedir failed");
                }
                if (i == a.length) return null;
                var entry = a[i];
                i++;
                return {
                    name: entry
                };
            },
            closeSync: function() {
                if (c) {
                    if (unix_error) caml_raise_with_args(unix_error, make_unix_err_args("EBADF", "closedir", this.nm(name)));
                    else caml_raise_sys_error(name + ": closedir failed");
                }
                c = true;
                a = [];
            }
        };
    };
    MlFakeDevice.prototype.is_dir = function(name) {
        if (name == "") return true;
        var name_slash = this.slash(name);
        return this.content[name_slash] ? 1 : 0;
    };
    MlFakeDevice.prototype.unlink = function(name) {
        var ok = this.content[name] ? true : false;
        delete this.content[name];
        return ok;
    };
    MlFakeDevice.prototype.open = function(name, f) {
        var file;
        if (f.rdonly && f.wronly) caml_raise_sys_error(this.nm(name) + " : flags Open_rdonly and Open_wronly are not compatible");
        if (f.text && f.binary) caml_raise_sys_error(this.nm(name) + " : flags Open_text and Open_binary are not compatible");
        this.lookup(name);
        if (this.content[name]) {
            if (this.is_dir(name)) caml_raise_sys_error(this.nm(name) + " : is a directory");
            if (f.create && f.excl) caml_raise_sys_error(this.nm(name) + " : file already exists");
            file = this.content[name];
            if (f.truncate) file.truncate();
        } else if (f.create) {
            this.create_dir_if_needed(name);
            this.content[name] = new MlFakeFile(caml_create_bytes(0));
            file = this.content[name];
        } else caml_raise_no_such_file(this.nm(name));
        return new MlFakeFd(this.nm(name), file, f);
    };
    MlFakeDevice.prototype.open = function(name, f) {
        var file;
        if (f.rdonly && f.wronly) caml_raise_sys_error(this.nm(name) + " : flags Open_rdonly and Open_wronly are not compatible");
        if (f.text && f.binary) caml_raise_sys_error(this.nm(name) + " : flags Open_text and Open_binary are not compatible");
        this.lookup(name);
        if (this.content[name]) {
            if (this.is_dir(name)) caml_raise_sys_error(this.nm(name) + " : is a directory");
            if (f.create && f.excl) caml_raise_sys_error(this.nm(name) + " : file already exists");
            file = this.content[name];
            if (f.truncate) file.truncate();
        } else if (f.create) {
            this.create_dir_if_needed(name);
            this.content[name] = new MlFakeFile(caml_create_bytes(0));
            file = this.content[name];
        } else caml_raise_no_such_file(this.nm(name));
        return new MlFakeFd(this.nm(name), file, f);
    };
    MlFakeDevice.prototype.register = function(name, content) {
        var file;
        if (this.content[name]) caml_raise_sys_error(this.nm(name) + " : file already exists");
        if (caml_is_ml_bytes(content)) file = new MlFakeFile(content);
        if (caml_is_ml_string(content)) file = new MlFakeFile(caml_bytes_of_string(content));
        else if (content instanceof Array) file = new MlFakeFile(caml_bytes_of_array(content));
        else if (typeof content === "string") file = new MlFakeFile(caml_bytes_of_jsbytes(content));
        else if (content.toString) {
            var bytes = caml_bytes_of_string(caml_string_of_jsstring(content.toString()));
            file = new MlFakeFile(bytes);
        }
        if (file) {
            this.create_dir_if_needed(name);
            this.content[name] = file;
        } else caml_raise_sys_error(this.nm(name) + " : registering file with invalid content type");
    };
    MlFakeDevice.prototype.constructor = MlFakeDevice;
    function MlFakeFd_out(fd, flags) {
        MlFakeFile.call(this, caml_create_bytes(0));
        this.log = function(s) {
            return 0;
        };
        if (fd == 1 && typeof console.log == "function") this.log = console.log;
        else if (fd == 2 && typeof console.error == "function") this.log = console.error;
        else if (typeof console.log == "function") this.log = console.log;
        this.flags = flags;
    }
    MlFakeFd_out.prototype.length = function() {
        return 0;
    };
    MlFakeFd_out.prototype.write = function(offset, buf, pos, len) {
        if (this.log) {
            if (len > 0 && pos >= 0 && pos + len <= buf.length && buf[pos + len - 1] == 10) len--;
            var src = caml_create_bytes(len);
            caml_blit_bytes(caml_bytes_of_array(buf), pos, src, 0, len);
            this.log(src.toUtf16());
            return 0;
        }
        caml_raise_sys_error(this.fd + ": file descriptor already closed");
    };
    MlFakeFd_out.prototype.read = function(offset, buf, pos, len) {
        caml_raise_sys_error(this.fd + ": file descriptor is write only");
    };
    MlFakeFd_out.prototype.close = function() {
        this.log = undefined;
    };
    function MlMutex() {
        this.locked = false;
    }
    function MlNat(x) {
        this.data = new Int32Array(x);
        this.length = this.data.length + 2;
    }
    MlNat.prototype.caml_custom = "_nat";
    function caml_ml_string_length(s) {
        return s.length;
    }
    function caml_string_unsafe_get(s, i) {
        return s.charCodeAt(i);
    }
    function caml_uint8_array_of_string(s) {
        var l = caml_ml_string_length(s), a = new Uint8Array(l), i = 0;
        for(; i < l; i++)a[i] = caml_string_unsafe_get(s, i);
        return a;
    }
    function caml_bytes_bound_error() {
        caml_invalid_argument("index out of bounds");
    }
    function caml_bytes_unsafe_set(s, i, c) {
        c &= 0xff;
        if (s.t != 4) {
            if (i == s.c.length) {
                s.c += String.fromCharCode(c);
                if (i + 1 == s.l) s.t = 0;
                return 0;
            }
            caml_convert_bytes_to_array(s);
        }
        s.c[i] = c;
        return 0;
    }
    function caml_bytes_set(s, i, c) {
        if (i >>> 0 >= s.l) caml_bytes_bound_error();
        return caml_bytes_unsafe_set(s, i, c);
    }
    function MlNodeFd(fd, flags) {
        this.fs = (parcelRequire("48K42"));
        this.fd = fd;
        this.flags = flags;
    }
    MlNodeFd.prototype = new MlFile();
    MlNodeFd.prototype.constructor = MlNodeFd;
    MlNodeFd.prototype.truncate = function(len) {
        try {
            this.fs.ftruncateSync(this.fd, len | 0);
        } catch (err) {
            caml_raise_sys_error(err.toString());
        }
    };
    MlNodeFd.prototype.length = function() {
        try {
            return this.fs.fstatSync(this.fd).size;
        } catch (err) {
            caml_raise_sys_error(err.toString());
        }
    };
    MlNodeFd.prototype.write = function(offset, buf, buf_offset, len) {
        try {
            if (this.flags.isCharacterDevice) this.fs.writeSync(this.fd, buf, buf_offset, len);
            else this.fs.writeSync(this.fd, buf, buf_offset, len, offset);
        } catch (err) {
            caml_raise_sys_error(err.toString());
        }
        return 0;
    };
    MlNodeFd.prototype.read = function(offset, a, buf_offset, len) {
        try {
            if (this.flags.isCharacterDevice) var read = this.fs.readSync(this.fd, a, buf_offset, len);
            else var read = this.fs.readSync(this.fd, a, buf_offset, len, offset);
            return read;
        } catch (err) {
            caml_raise_sys_error(err.toString());
        }
    };
    MlNodeFd.prototype.close = function() {
        try {
            this.fs.closeSync(this.fd);
            return 0;
        } catch (err) {
            caml_raise_sys_error(err.toString());
        }
    };
    function MlNodeDevice(root) {
        this.fs = (parcelRequire("48K42"));
        this.root = root;
    }
    MlNodeDevice.prototype.nm = function(name) {
        return this.root + name;
    };
    MlNodeDevice.prototype.exists = function(name) {
        try {
            return this.fs.existsSync(this.nm(name)) ? 1 : 0;
        } catch (err) {
            return 0;
        }
    };
    MlNodeDevice.prototype.isFile = function(name) {
        try {
            return this.fs.statSync(this.nm(name)).isFile() ? 1 : 0;
        } catch (err) {
            caml_raise_sys_error(err.toString());
        }
    };
    MlNodeDevice.prototype.mkdir = function(name, mode, raise_unix) {
        try {
            this.fs.mkdirSync(this.nm(name), {
                mode: mode
            });
            return 0;
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.rmdir = function(name, raise_unix) {
        try {
            this.fs.rmdirSync(this.nm(name));
            return 0;
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.readdir = function(name, raise_unix) {
        try {
            return this.fs.readdirSync(this.nm(name));
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.is_dir = function(name) {
        try {
            return this.fs.statSync(this.nm(name)).isDirectory() ? 1 : 0;
        } catch (err) {
            caml_raise_sys_error(err.toString());
        }
    };
    MlNodeDevice.prototype.unlink = function(name, raise_unix) {
        try {
            var b = this.fs.existsSync(this.nm(name)) ? 1 : 0;
            this.fs.unlinkSync(this.nm(name));
            return b;
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.open = function(name, f, raise_unix) {
        var consts = (parcelRequire("77U2W")), res = 0;
        for(var key in f)switch(key){
            case "rdonly":
                res |= consts.O_RDONLY;
                break;
            case "wronly":
                res |= consts.O_WRONLY;
                break;
            case "append":
                res |= consts.O_WRONLY | consts.O_APPEND;
                break;
            case "create":
                res |= consts.O_CREAT;
                break;
            case "truncate":
                res |= consts.O_TRUNC;
                break;
            case "excl":
                res |= consts.O_EXCL;
                break;
            case "binary":
                res |= consts.O_BINARY;
                break;
            case "text":
                res |= consts.O_TEXT;
                break;
            case "nonblock":
                res |= consts.O_NONBLOCK;
                break;
        }
        try {
            var fd = this.fs.openSync(this.nm(name), res), isCharacterDevice = this.fs.lstatSync(this.nm(name)).isCharacterDevice();
            f.isCharacterDevice = isCharacterDevice;
            return new MlNodeFd(fd, f);
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.rename = function(o, n, raise_unix) {
        try {
            this.fs.renameSync(this.nm(o), this.nm(n));
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.stat = function(name, raise_unix) {
        try {
            var js_stats = this.fs.statSync(this.nm(name));
            return this.stats_from_js(js_stats);
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.lstat = function(name, raise_unix) {
        try {
            var js_stats = this.fs.lstatSync(this.nm(name));
            return this.stats_from_js(js_stats);
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.symlink = function(to_dir, target, path, raise_unix) {
        try {
            this.fs.symlinkSync(this.nm(target), this.nm(path), to_dir ? "dir" : "file");
            return 0;
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.readlink = function(name, raise_unix) {
        try {
            var link = this.fs.readlinkSync(this.nm(name), "utf8");
            return caml_string_of_jsstring(link);
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.opendir = function(name, raise_unix) {
        try {
            return this.fs.opendirSync(this.nm(name));
        } catch (err) {
            this.raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.raise_nodejs_error = function(err, raise_unix) {
        var unix_error = caml_named_value("Unix.Unix_error");
        if (raise_unix && unix_error) {
            var args = make_unix_err_args(err.code, err.syscall, err.path, err.errno);
            caml_raise_with_args(unix_error, args);
        } else caml_raise_sys_error(err.toString());
    };
    MlNodeDevice.prototype.stats_from_js = function(js_stats) {
        var file_kind;
        if (js_stats.isFile()) file_kind = 0;
        else if (js_stats.isDirectory()) file_kind = 1;
        else if (js_stats.isCharacterDevice()) file_kind = 2;
        else if (js_stats.isBlockDevice()) file_kind = 3;
        else if (js_stats.isSymbolicLink()) file_kind = 4;
        else if (js_stats.isFIFO()) file_kind = 5;
        else if (js_stats.isSocket()) file_kind = 6;
        return [
            0,
            js_stats.dev,
            js_stats.ino,
            file_kind,
            js_stats.mode,
            js_stats.nlink,
            js_stats.uid,
            js_stats.gid,
            js_stats.rdev,
            js_stats.size,
            js_stats.atimeMs,
            js_stats.mtimeMs,
            js_stats.ctimeMs
        ];
    };
    MlNodeDevice.prototype.constructor = MlNodeDevice;
    var MlObjectTable;
    if (typeof globalThis1.Map === "undefined") MlObjectTable = function() {
        function NaiveLookup(objs) {
            this.objs = objs;
        }
        NaiveLookup.prototype.get = function(v) {
            for(var i = 0; i < this.objs.length; i++)if (this.objs[i] === v) return i;
        };
        NaiveLookup.prototype.set = function() {};
        return function() {
            this.objs = [];
            this.lookup = new NaiveLookup(this.objs);
        };
    }();
    else MlObjectTable = function() {
        this.objs = [];
        this.lookup = new globalThis1.Map();
    };
    MlObjectTable.prototype.store = function(v) {
        this.lookup.set(v, this.objs.length);
        this.objs.push(v);
    };
    MlObjectTable.prototype.recall = function(v) {
        var i = this.lookup.get(v);
        return i === undefined ? undefined : this.objs.length - i;
    };
    function MlStringReader(s, i) {
        this.s = caml_jsbytes_of_string(s);
        this.i = i;
    }
    MlStringReader.prototype = {
        read8u: function() {
            return this.s.charCodeAt(this.i++);
        },
        read8s: function() {
            return this.s.charCodeAt(this.i++) << 24 >> 24;
        },
        read16u: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return s.charCodeAt(i) << 8 | s.charCodeAt(i + 1);
        },
        read16s: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return s.charCodeAt(i) << 24 >> 16 | s.charCodeAt(i + 1);
        },
        read32u: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return (s.charCodeAt(i) << 24 | s.charCodeAt(i + 1) << 16 | s.charCodeAt(i + 2) << 8 | s.charCodeAt(i + 3)) >>> 0;
        },
        read32s: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return s.charCodeAt(i) << 24 | s.charCodeAt(i + 1) << 16 | s.charCodeAt(i + 2) << 8 | s.charCodeAt(i + 3);
        },
        readstr: function(len) {
            var i = this.i;
            this.i = i + len;
            return caml_string_of_jsbytes(this.s.substring(i, i + len));
        },
        readuint8array: function(len) {
            var b = new Uint8Array(len), s = this.s, i = this.i;
            for(var j = 0; j < len; j++)b[j] = s.charCodeAt(i + j);
            this.i = i + len;
            return b;
        }
    };
    function UInt8ArrayReader(s, i) {
        this.s = s;
        this.i = i;
    }
    UInt8ArrayReader.prototype = {
        read8u: function() {
            return this.s[this.i++];
        },
        read8s: function() {
            return this.s[this.i++] << 24 >> 24;
        },
        read16u: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return s[i] << 8 | s[i + 1];
        },
        read16s: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return s[i] << 24 >> 16 | s[i + 1];
        },
        read32u: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return (s[i] << 24 | s[i + 1] << 16 | s[i + 2] << 8 | s[i + 3]) >>> 0;
        },
        read32s: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return s[i] << 24 | s[i + 1] << 16 | s[i + 2] << 8 | s[i + 3];
        },
        readstr: function(len) {
            var i = this.i;
            this.i = i + len;
            return caml_string_of_array(this.s.subarray(i, i + len));
        },
        readuint8array: function(len) {
            var i = this.i;
            this.i = i + len;
            return this.s.subarray(i, i + len);
        }
    };
    function incr_nat(nat, ofs, len, carry_in) {
        var carry = carry_in;
        for(var i = 0; i < len; i++){
            var x = (nat.data[ofs + i] >>> 0) + carry;
            nat.data[ofs + i] = x | 0;
            if (x == x >>> 0) {
                carry = 0;
                break;
            } else carry = 1;
        }
        return carry;
    }
    function add_nat(nat1, ofs1, len1, nat2, ofs2, len2, carry_in) {
        var carry = carry_in;
        for(var i = 0; i < len2; i++){
            var x = (nat1.data[ofs1 + i] >>> 0) + (nat2.data[ofs2 + i] >>> 0) + carry;
            nat1.data[ofs1 + i] = x;
            if (x == x >>> 0) carry = 0;
            else carry = 1;
        }
        return incr_nat(nat1, ofs1 + len2, len1 - len2, carry);
    }
    function bigstring_of_array_buffer(ab) {
        var ta = new Uint8Array(ab);
        return caml_ba_create_unsafe(12, 0, [
            ta.length
        ], ta);
    }
    function bigstring_of_typed_array(ba) {
        var ta = new Uint8Array(ba.buffer, ba.byteOffset, ba.length * ba.BYTES_PER_ELEMENT);
        return caml_ba_create_unsafe(12, 0, [
            ta.length
        ], ta);
    }
    function bigstring_to_array_buffer(bs) {
        return bs.data.buffer;
    }
    function bigstring_to_typed_array(bs) {
        return bs.data;
    }
    var blake2b = function() {
        function ADD64AA(v, a, b) {
            const o0 = v[a] + v[b];
            let o1 = v[a + 1] + v[b + 1];
            if (o0 >= 0x100000000) o1++;
            v[a] = o0;
            v[a + 1] = o1;
        }
        function ADD64AC(v, a, b0, b1) {
            let o0 = v[a] + b0;
            if (b0 < 0) o0 += 0x100000000;
            let o1 = v[a + 1] + b1;
            if (o0 >= 0x100000000) o1++;
            v[a] = o0;
            v[a + 1] = o1;
        }
        function B2B_GET32(arr, i) {
            return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
        }
        function B2B_G(a, b, c, d, ix, iy) {
            const x0 = m[ix], x1 = m[ix + 1], y0 = m[iy], y1 = m[iy + 1];
            ADD64AA(v, a, b);
            ADD64AC(v, a, x0, x1);
            let xor0 = v[d] ^ v[a], xor1 = v[d + 1] ^ v[a + 1];
            v[d] = xor1;
            v[d + 1] = xor0;
            ADD64AA(v, c, d);
            xor0 = v[b] ^ v[c];
            xor1 = v[b + 1] ^ v[c + 1];
            v[b] = xor0 >>> 24 ^ xor1 << 8;
            v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
            ADD64AA(v, a, b);
            ADD64AC(v, a, y0, y1);
            xor0 = v[d] ^ v[a];
            xor1 = v[d + 1] ^ v[a + 1];
            v[d] = xor0 >>> 16 ^ xor1 << 16;
            v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
            ADD64AA(v, c, d);
            xor0 = v[b] ^ v[c];
            xor1 = v[b + 1] ^ v[c + 1];
            v[b] = xor1 >>> 31 ^ xor0 << 1;
            v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
        }
        const BLAKE2B_IV32 = new Uint32Array([
            0xf3bcc908,
            0x6a09e667,
            0x84caa73b,
            0xbb67ae85,
            0xfe94f82b,
            0x3c6ef372,
            0x5f1d36f1,
            0xa54ff53a,
            0xade682d1,
            0x510e527f,
            0x2b3e6c1f,
            0x9b05688c,
            0xfb41bd6b,
            0x1f83d9ab,
            0x137e2179,
            0x5be0cd19
        ]), SIGMA8 = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            14,
            10,
            4,
            8,
            9,
            15,
            13,
            6,
            1,
            12,
            0,
            2,
            11,
            7,
            5,
            3,
            11,
            8,
            12,
            0,
            5,
            2,
            15,
            13,
            10,
            14,
            3,
            6,
            7,
            1,
            9,
            4,
            7,
            9,
            3,
            1,
            13,
            12,
            11,
            14,
            2,
            6,
            5,
            10,
            4,
            0,
            15,
            8,
            9,
            0,
            5,
            7,
            2,
            4,
            10,
            15,
            14,
            1,
            11,
            12,
            6,
            8,
            3,
            13,
            2,
            12,
            6,
            10,
            0,
            11,
            8,
            3,
            4,
            13,
            7,
            5,
            15,
            14,
            1,
            9,
            12,
            5,
            1,
            15,
            14,
            13,
            4,
            10,
            0,
            7,
            6,
            3,
            9,
            2,
            8,
            11,
            13,
            11,
            7,
            14,
            12,
            1,
            3,
            9,
            5,
            0,
            15,
            4,
            8,
            6,
            2,
            10,
            6,
            15,
            14,
            9,
            11,
            3,
            0,
            8,
            12,
            2,
            13,
            7,
            1,
            4,
            10,
            5,
            10,
            2,
            8,
            4,
            7,
            6,
            1,
            5,
            15,
            11,
            9,
            14,
            3,
            12,
            13,
            0,
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            14,
            10,
            4,
            8,
            9,
            15,
            13,
            6,
            1,
            12,
            0,
            2,
            11,
            7,
            5,
            3
        ], SIGMA82 = new Uint8Array(SIGMA8.map(function(x) {
            return x * 2;
        })), v = new Uint32Array(32), m = new Uint32Array(32);
        function blake2bCompress(ctx, last) {
            let i = 0;
            for(i = 0; i < 16; i++){
                v[i] = ctx.h[i];
                v[i + 16] = BLAKE2B_IV32[i];
            }
            v[24] = v[24] ^ ctx.t;
            v[25] = v[25] ^ ctx.t / 0x100000000;
            if (last) {
                v[28] = ~v[28];
                v[29] = ~v[29];
            }
            for(i = 0; i < 32; i++)m[i] = B2B_GET32(ctx.b, 4 * i);
            for(i = 0; i < 12; i++){
                B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
                B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
                B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
                B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
                B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
                B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
                B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
                B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
            }
            for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
        }
        const parameterBlock = new Uint8Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        function blake2bInit(outlen, key) {
            if (outlen === 0 || outlen > 64) throw new Error("Illegal output length, expected 0 < length <= 64");
            if (key.length > 64) throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
            const ctx = {
                b: new Uint8Array(128),
                h: new Uint32Array(16),
                t: 0,
                c: 0,
                outlen: outlen
            };
            parameterBlock.fill(0);
            parameterBlock[0] = outlen;
            parameterBlock[1] = key.length;
            parameterBlock[2] = 1;
            parameterBlock[3] = 1;
            for(let i = 0; i < 16; i++)ctx.h[i] = BLAKE2B_IV32[i] ^ B2B_GET32(parameterBlock, i * 4);
            if (key.length > 0) {
                blake2bUpdate(ctx, key);
                ctx.c = 128;
            }
            return ctx;
        }
        function blake2bUpdate(ctx, input) {
            for(let i = 0; i < input.length; i++){
                if (ctx.c === 128) {
                    ctx.t += ctx.c;
                    blake2bCompress(ctx, false);
                    ctx.c = 0;
                }
                ctx.b[ctx.c++] = input[i];
            }
        }
        function blake2bFinal(ctx) {
            ctx.t += ctx.c;
            while(ctx.c < 128)ctx.b[ctx.c++] = 0;
            blake2bCompress(ctx, true);
            const out = new Uint8Array(ctx.outlen);
            for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
            return out;
        }
        return {
            Init: blake2bInit,
            Update: blake2bUpdate,
            Final: blake2bFinal
        };
    }();
    function blit_nat(nat1, ofs1, nat2, ofs2, len) {
        for(var i = 0; i < len; i++)nat1.data[ofs1 + i] = nat2.data[ofs2 + i];
        return 0;
    }
    var caml_MD5Transform = function() {
        function add(x, y) {
            return x + y | 0;
        }
        function xx(q, a, b, x, s, t) {
            a = add(add(a, q), add(x, t));
            return add(a << s | a >>> 32 - s, b);
        }
        function ff(a, b, c, d, x, s, t) {
            return xx(b & c | ~b & d, a, b, x, s, t);
        }
        function gg(a, b, c, d, x, s, t) {
            return xx(b & d | c & ~d, a, b, x, s, t);
        }
        function hh(a, b, c, d, x, s, t) {
            return xx(b ^ c ^ d, a, b, x, s, t);
        }
        function ii(a, b, c, d, x, s, t) {
            return xx(c ^ (b | ~d), a, b, x, s, t);
        }
        return function(w, buffer) {
            var a = w[0], b = w[1], c = w[2], d = w[3];
            a = ff(a, b, c, d, buffer[0], 7, 0xD76AA478);
            d = ff(d, a, b, c, buffer[1], 12, 0xE8C7B756);
            c = ff(c, d, a, b, buffer[2], 17, 0x242070DB);
            b = ff(b, c, d, a, buffer[3], 22, 0xC1BDCEEE);
            a = ff(a, b, c, d, buffer[4], 7, 0xF57C0FAF);
            d = ff(d, a, b, c, buffer[5], 12, 0x4787C62A);
            c = ff(c, d, a, b, buffer[6], 17, 0xA8304613);
            b = ff(b, c, d, a, buffer[7], 22, 0xFD469501);
            a = ff(a, b, c, d, buffer[8], 7, 0x698098D8);
            d = ff(d, a, b, c, buffer[9], 12, 0x8B44F7AF);
            c = ff(c, d, a, b, buffer[10], 17, 0xFFFF5BB1);
            b = ff(b, c, d, a, buffer[11], 22, 0x895CD7BE);
            a = ff(a, b, c, d, buffer[12], 7, 0x6B901122);
            d = ff(d, a, b, c, buffer[13], 12, 0xFD987193);
            c = ff(c, d, a, b, buffer[14], 17, 0xA679438E);
            b = ff(b, c, d, a, buffer[15], 22, 0x49B40821);
            a = gg(a, b, c, d, buffer[1], 5, 0xF61E2562);
            d = gg(d, a, b, c, buffer[6], 9, 0xC040B340);
            c = gg(c, d, a, b, buffer[11], 14, 0x265E5A51);
            b = gg(b, c, d, a, buffer[0], 20, 0xE9B6C7AA);
            a = gg(a, b, c, d, buffer[5], 5, 0xD62F105D);
            d = gg(d, a, b, c, buffer[10], 9, 0x02441453);
            c = gg(c, d, a, b, buffer[15], 14, 0xD8A1E681);
            b = gg(b, c, d, a, buffer[4], 20, 0xE7D3FBC8);
            a = gg(a, b, c, d, buffer[9], 5, 0x21E1CDE6);
            d = gg(d, a, b, c, buffer[14], 9, 0xC33707D6);
            c = gg(c, d, a, b, buffer[3], 14, 0xF4D50D87);
            b = gg(b, c, d, a, buffer[8], 20, 0x455A14ED);
            a = gg(a, b, c, d, buffer[13], 5, 0xA9E3E905);
            d = gg(d, a, b, c, buffer[2], 9, 0xFCEFA3F8);
            c = gg(c, d, a, b, buffer[7], 14, 0x676F02D9);
            b = gg(b, c, d, a, buffer[12], 20, 0x8D2A4C8A);
            a = hh(a, b, c, d, buffer[5], 4, 0xFFFA3942);
            d = hh(d, a, b, c, buffer[8], 11, 0x8771F681);
            c = hh(c, d, a, b, buffer[11], 16, 0x6D9D6122);
            b = hh(b, c, d, a, buffer[14], 23, 0xFDE5380C);
            a = hh(a, b, c, d, buffer[1], 4, 0xA4BEEA44);
            d = hh(d, a, b, c, buffer[4], 11, 0x4BDECFA9);
            c = hh(c, d, a, b, buffer[7], 16, 0xF6BB4B60);
            b = hh(b, c, d, a, buffer[10], 23, 0xBEBFBC70);
            a = hh(a, b, c, d, buffer[13], 4, 0x289B7EC6);
            d = hh(d, a, b, c, buffer[0], 11, 0xEAA127FA);
            c = hh(c, d, a, b, buffer[3], 16, 0xD4EF3085);
            b = hh(b, c, d, a, buffer[6], 23, 0x04881D05);
            a = hh(a, b, c, d, buffer[9], 4, 0xD9D4D039);
            d = hh(d, a, b, c, buffer[12], 11, 0xE6DB99E5);
            c = hh(c, d, a, b, buffer[15], 16, 0x1FA27CF8);
            b = hh(b, c, d, a, buffer[2], 23, 0xC4AC5665);
            a = ii(a, b, c, d, buffer[0], 6, 0xF4292244);
            d = ii(d, a, b, c, buffer[7], 10, 0x432AFF97);
            c = ii(c, d, a, b, buffer[14], 15, 0xAB9423A7);
            b = ii(b, c, d, a, buffer[5], 21, 0xFC93A039);
            a = ii(a, b, c, d, buffer[12], 6, 0x655B59C3);
            d = ii(d, a, b, c, buffer[3], 10, 0x8F0CCC92);
            c = ii(c, d, a, b, buffer[10], 15, 0xFFEFF47D);
            b = ii(b, c, d, a, buffer[1], 21, 0x85845DD1);
            a = ii(a, b, c, d, buffer[8], 6, 0x6FA87E4F);
            d = ii(d, a, b, c, buffer[15], 10, 0xFE2CE6E0);
            c = ii(c, d, a, b, buffer[6], 15, 0xA3014314);
            b = ii(b, c, d, a, buffer[13], 21, 0x4E0811A1);
            a = ii(a, b, c, d, buffer[4], 6, 0xF7537E82);
            d = ii(d, a, b, c, buffer[11], 10, 0xBD3AF235);
            c = ii(c, d, a, b, buffer[2], 15, 0x2AD7D2BB);
            b = ii(b, c, d, a, buffer[9], 21, 0xEB86D391);
            w[0] = add(a, w[0]);
            w[1] = add(b, w[1]);
            w[2] = add(c, w[2]);
            w[3] = add(d, w[3]);
        };
    }();
    function caml_MD5Final(ctx) {
        var in_buf = ctx.len & 0x3f;
        ctx.b8[in_buf] = 0x80;
        in_buf++;
        if (in_buf > 56) {
            for(var j = in_buf; j < 64; j++)ctx.b8[j] = 0;
            caml_MD5Transform(ctx.w, ctx.b32);
            for(var j = 0; j < 56; j++)ctx.b8[j] = 0;
        } else for(var j = in_buf; j < 56; j++)ctx.b8[j] = 0;
        ctx.b32[14] = ctx.len << 3;
        ctx.b32[15] = ctx.len >> 29 & 0x1FFFFFFF;
        caml_MD5Transform(ctx.w, ctx.b32);
        var t = new Uint8Array(16);
        for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++)t[i * 4 + j] = ctx.w[i] >> 8 * j & 0xFF;
        return t;
    }
    function caml_MD5Init() {
        var buffer = new ArrayBuffer(64), b32 = new Uint32Array(buffer), b8 = new Uint8Array(buffer);
        return {
            len: 0,
            w: new Uint32Array([
                0x67452301,
                0xEFCDAB89,
                0x98BADCFE,
                0x10325476
            ]),
            b32: b32,
            b8: b8
        };
    }
    function caml_MD5Update(ctx, input, input_len) {
        var in_buf = ctx.len & 0x3f, input_pos = 0;
        ctx.len += input_len;
        if (in_buf) {
            var missing = 64 - in_buf;
            if (input_len < missing) {
                ctx.b8.set(input.subarray(0, input_len), in_buf);
                return;
            }
            ctx.b8.set(input.subarray(0, missing), in_buf);
            caml_MD5Transform(ctx.w, ctx.b32);
            input_len -= missing;
            input_pos += missing;
        }
        while(input_len >= 64){
            ctx.b8.set(input.subarray(input_pos, input_pos + 64), 0);
            caml_MD5Transform(ctx.w, ctx.b32);
            input_len -= 64;
            input_pos += 64;
        }
        if (input_len) ctx.b8.set(input.subarray(input_pos, input_pos + input_len), 0);
    }
    function caml_acosh_float(x) {
        return Math.acosh(x);
    }
    function caml_call_gen(f, args) {
        var n = f.l >= 0 ? f.l : f.l = f.length, argsLen = args.length, d = n - argsLen;
        if (d == 0) return f.apply(null, args);
        else if (d < 0) {
            var g = f.apply(null, args.slice(0, n));
            if (typeof g !== "function") return g;
            return caml_call_gen(g, args.slice(n));
        } else {
            switch(d){
                case 1:
                    var g = function(x) {
                        var nargs = new Array(argsLen + 1);
                        for(var i = 0; i < argsLen; i++)nargs[i] = args[i];
                        nargs[argsLen] = x;
                        return f.apply(null, nargs);
                    };
                    break;
                case 2:
                    var g = function(x, y) {
                        var nargs = new Array(argsLen + 2);
                        for(var i = 0; i < argsLen; i++)nargs[i] = args[i];
                        nargs[argsLen] = x;
                        nargs[argsLen + 1] = y;
                        return f.apply(null, nargs);
                    };
                    break;
                default:
                    var g = function() {
                        var extra_args = arguments.length == 0 ? 1 : arguments.length, nargs = new Array(args.length + extra_args);
                        for(var i = 0; i < args.length; i++)nargs[i] = args[i];
                        for(var i = 0; i < arguments.length; i++)nargs[args.length + i] = arguments[i];
                        return caml_call_gen(f, nargs);
                    };
            }
            g.l = d;
            return g;
        }
    }
    function caml_alloc_dummy_infix() {
        return function f(x) {
            return caml_call_gen(f.fun, [
                x
            ]);
        };
    }
    function caml_alloc_stack(hv, hx, hf) {
        return 0;
    }
    var caml_argv = function() {
        var process = globalThis1.process, main = "a.out", args = [];
        if (process && process.argv && process.argv.length > 1) {
            var argv = process.argv;
            main = argv[1];
            args = argv.slice(2);
        }
        var p = caml_string_of_jsstring(main), args2 = [
            0,
            p
        ];
        for(var i = 0; i < args.length; i++)args2.push(caml_string_of_jsstring(args[i]));
        return args2;
    }();
    function caml_array_append(a1, a2) {
        var l1 = a1.length, l2 = a2.length, l = l1 + l2 - 1, a = new Array(l);
        a[0] = 0;
        var i = 1, j = 1;
        for(; i < l1; i++)a[i] = a1[i];
        for(; i < l; i++, j++)a[i] = a2[j];
        return a;
    }
    function caml_array_blit(a1, i1, a2, i2, len) {
        if (i2 <= i1) for(var j = 1; j <= len; j++)a2[i2 + j] = a1[i1 + j];
        else for(var j = len; j >= 1; j--)a2[i2 + j] = a1[i1 + j];
        return 0;
    }
    function caml_array_concat(l) {
        var a = [
            0
        ];
        while(l !== 0){
            var b = l[1];
            for(var i = 1; i < b.length; i++)a.push(b[i]);
            l = l[2];
        }
        return a;
    }
    function caml_array_fill(array, ofs, len, v) {
        for(var i = 0; i < len; i++)array[ofs + i + 1] = v;
        return 0;
    }
    function caml_array_get(array, index) {
        if (index < 0 || index >= array.length - 1) caml_array_bound_error();
        return array[index + 1];
    }
    function caml_array_of_bytes(x) {
        return caml_uint8_array_of_bytes(x);
    }
    function caml_array_of_string(x) {
        return caml_uint8_array_of_string(x);
    }
    function caml_array_set(array, index, newval) {
        if (index < 0 || index >= array.length - 1) caml_array_bound_error();
        array[index + 1] = newval;
        return 0;
    }
    function caml_array_sub(a, i, len) {
        var a2 = new Array(len + 1);
        a2[0] = 0;
        for(var i2 = 1, i1 = i + 1; i2 <= len; i2++, i1++)a2[i2] = a[i1];
        return a2;
    }
    function caml_asinh_float(x) {
        return Math.asinh(x);
    }
    function caml_atanh_float(x) {
        return Math.atanh(x);
    }
    function caml_atomic_cas(ref, o, n) {
        if (ref[1] === o) {
            ref[1] = n;
            return 1;
        }
        return 0;
    }
    function caml_atomic_exchange(ref, v) {
        var r = ref[1];
        ref[1] = v;
        return r;
    }
    function caml_atomic_fetch_add(ref, i) {
        var old = ref[1];
        ref[1] += i;
        return old;
    }
    function caml_atomic_load(ref) {
        return ref[1];
    }
    function caml_atomic_make_contended(a) {
        return [
            0,
            a
        ];
    }
    function caml_ba_blit(src, dst) {
        if (dst.dims.length != src.dims.length) caml_invalid_argument("Bigarray.blit: dimension mismatch");
        for(var i = 0; i < dst.dims.length; i++)if (dst.dims[i] != src.dims[i]) caml_invalid_argument("Bigarray.blit: dimension mismatch");
        dst.data.set(src.data);
        return 0;
    }
    function caml_ba_change_layout(ba, layout) {
        if (ba.layout == layout) return ba;
        var new_dims = [];
        for(var i = 0; i < ba.dims.length; i++)new_dims[i] = ba.dims[ba.dims.length - i - 1];
        return caml_ba_create_unsafe(ba.kind, layout, new_dims, ba.data);
    }
    function caml_js_from_array(a) {
        return a.slice(1);
    }
    function caml_ba_create(kind, layout, dims_ml) {
        var dims = caml_js_from_array(dims_ml), data = caml_ba_create_buffer(kind, caml_ba_get_size(dims));
        return caml_ba_create_unsafe(kind, layout, dims, data);
    }
    function caml_ba_create_from(data1, data2, jstyp, kind, layout, dims) {
        if (data2 || caml_ba_get_size_per_element(kind) == 2) caml_invalid_argument("caml_ba_create_from: use return caml_ba_create_unsafe");
        return caml_ba_create_unsafe(kind, layout, dims, data1);
    }
    function caml_ba_dim(ba, i) {
        if (i < 0 || i >= ba.dims.length) caml_invalid_argument("Bigarray.dim");
        return ba.dims[i];
    }
    function caml_ba_dim_1(ba) {
        return caml_ba_dim(ba, 0);
    }
    function caml_ba_dim_2(ba) {
        return caml_ba_dim(ba, 1);
    }
    function caml_ba_dim_3(ba) {
        return caml_ba_dim(ba, 2);
    }
    function caml_ba_fill(ba, v) {
        ba.fill(v);
        return 0;
    }
    function caml_ba_kind_of_typed_array(ta) {
        var kind;
        if (ta instanceof Float32Array) kind = 0;
        else if (ta instanceof Float64Array) kind = 1;
        else if (ta instanceof Int8Array) kind = 2;
        else if (ta instanceof Uint8Array) kind = 3;
        else if (ta instanceof Uint8ClampedArray) kind = 3;
        else if (ta instanceof Int16Array) kind = 4;
        else if (ta instanceof Uint16Array) kind = 5;
        else if (ta instanceof Int32Array) kind = 6;
        else if (ta instanceof Uint32Array) kind = 6;
        else caml_invalid_argument("caml_ba_kind_of_typed_array: unsupported kind");
        return kind;
    }
    function caml_ba_from_typed_array(ta) {
        var kind = caml_ba_kind_of_typed_array(ta), ta = ta instanceof Uint32Array ? new Int32Array(ta.buffer, ta.byteOffset, ta.length) : ta;
        return caml_ba_create_unsafe(kind, 0, [
            ta.length
        ], ta);
    }
    function caml_ba_get_2(ba, i0, i1) {
        return ba.get(ba.offset([
            i0,
            i1
        ]));
    }
    function caml_ba_get_3(ba, i0, i1, i2) {
        return ba.get(ba.offset([
            i0,
            i1,
            i2
        ]));
    }
    function caml_ba_get_generic(ba, i) {
        var ofs = ba.offset(caml_js_from_array(i));
        return ba.get(ofs);
    }
    function caml_ba_init() {
        return 0;
    }
    function caml_ba_kind(ba) {
        return ba.kind;
    }
    function caml_ba_layout(ba) {
        return ba.layout;
    }
    function caml_ba_map_file(vfd, kind, layout, shared, dims, pos) {
        caml_failwith("caml_ba_map_file not implemented");
    }
    function caml_ba_map_file_bytecode(argv, argn) {
        return caml_ba_map_file(argv[0], argv[1], argv[2], argv[3], argv[4], argv[5]);
    }
    function caml_ba_num_dims(ba) {
        return ba.dims.length;
    }
    function caml_ba_reshape(ba, vind) {
        vind = caml_js_from_array(vind);
        var new_dim = [], num_dims = vind.length;
        if (num_dims < 0 || num_dims > 16) caml_invalid_argument("Bigarray.reshape: bad number of dimensions");
        var num_elts = 1;
        for(var i = 0; i < num_dims; i++){
            new_dim[i] = vind[i];
            if (new_dim[i] < 0) caml_invalid_argument("Bigarray.reshape: negative dimension");
            num_elts = num_elts * new_dim[i];
        }
        var size = caml_ba_get_size(ba.dims);
        if (num_elts != size) caml_invalid_argument("Bigarray.reshape: size mismatch");
        return caml_ba_create_unsafe(ba.kind, ba.layout, new_dim, ba.data);
    }
    function caml_ba_set_1(ba, i0, v) {
        ba.set(ba.offset(i0), v);
        return 0;
    }
    function caml_ba_set_2(ba, i0, i1, v) {
        ba.set(ba.offset([
            i0,
            i1
        ]), v);
        return 0;
    }
    function caml_ba_set_3(ba, i0, i1, i2, v) {
        ba.set(ba.offset([
            i0,
            i1,
            i2
        ]), v);
        return 0;
    }
    function caml_ba_set_generic(ba, i, v) {
        ba.set(ba.offset(caml_js_from_array(i)), v);
        return 0;
    }
    function caml_ba_slice(ba, vind) {
        vind = caml_js_from_array(vind);
        var num_inds = vind.length, index = [], sub_dims = [], ofs;
        if (num_inds > ba.dims.length) caml_invalid_argument("Bigarray.slice: too many indices");
        if (ba.layout == 0) {
            for(var i = 0; i < num_inds; i++)index[i] = vind[i];
            for(; i < ba.dims.length; i++)index[i] = 0;
            sub_dims = ba.dims.slice(num_inds);
        } else {
            for(var i = 0; i < num_inds; i++)index[ba.dims.length - num_inds + i] = vind[i];
            for(var i = 0; i < ba.dims.length - num_inds; i++)index[i] = 1;
            sub_dims = ba.dims.slice(0, ba.dims.length - num_inds);
        }
        ofs = ba.offset(index);
        var size = caml_ba_get_size(sub_dims), size_per_element = caml_ba_get_size_per_element(ba.kind), new_data = ba.data.subarray(ofs * size_per_element, (ofs + size) * size_per_element);
        return caml_ba_create_unsafe(ba.kind, ba.layout, sub_dims, new_data);
    }
    function caml_ba_sub(ba, ofs, len) {
        var changed_dim, mul = 1;
        if (ba.layout == 0) {
            for(var i = 1; i < ba.dims.length; i++)mul = mul * ba.dims[i];
            changed_dim = 0;
        } else {
            for(var i = 0; i < ba.dims.length - 1; i++)mul = mul * ba.dims[i];
            changed_dim = ba.dims.length - 1;
            ofs = ofs - 1;
        }
        if (ofs < 0 || len < 0 || ofs + len > ba.dims[changed_dim]) caml_invalid_argument("Bigarray.sub: bad sub-array");
        var new_dims = [];
        for(var i = 0; i < ba.dims.length; i++)new_dims[i] = ba.dims[i];
        new_dims[changed_dim] = len;
        mul *= caml_ba_get_size_per_element(ba.kind);
        var new_data = ba.data.subarray(ofs * mul, (ofs + len) * mul);
        return caml_ba_create_unsafe(ba.kind, ba.layout, new_dims, new_data);
    }
    function caml_ba_to_typed_array(ba) {
        return ba.data;
    }
    function caml_ba_uint8_get16(ba, i0) {
        var ofs = ba.offset(i0);
        if (ofs + 1 >= ba.data.length) caml_array_bound_error();
        var b1 = ba.get(ofs), b2 = ba.get(ofs + 1);
        return b1 | b2 << 8;
    }
    function caml_ba_uint8_get32(ba, i0) {
        var ofs = ba.offset(i0);
        if (ofs + 3 >= ba.data.length) caml_array_bound_error();
        var b1 = ba.get(ofs + 0), b2 = ba.get(ofs + 1), b3 = ba.get(ofs + 2), b4 = ba.get(ofs + 3);
        return b1 << 0 | b2 << 8 | b3 << 16 | b4 << 24;
    }
    function caml_ba_uint8_get64(ba, i0) {
        var ofs = ba.offset(i0);
        if (ofs + 7 >= ba.data.length) caml_array_bound_error();
        var b1 = ba.get(ofs + 0), b2 = ba.get(ofs + 1), b3 = ba.get(ofs + 2), b4 = ba.get(ofs + 3), b5 = ba.get(ofs + 4), b6 = ba.get(ofs + 5), b7 = ba.get(ofs + 6), b8 = ba.get(ofs + 7);
        return caml_int64_of_bytes([
            b8,
            b7,
            b6,
            b5,
            b4,
            b3,
            b2,
            b1
        ]);
    }
    function caml_ba_uint8_set16(ba, i0, v) {
        var ofs = ba.offset(i0);
        if (ofs + 1 >= ba.data.length) caml_array_bound_error();
        ba.set(ofs + 0, v & 0xff);
        ba.set(ofs + 1, v >>> 8 & 0xff);
        return 0;
    }
    function caml_ba_uint8_set32(ba, i0, v) {
        var ofs = ba.offset(i0);
        if (ofs + 3 >= ba.data.length) caml_array_bound_error();
        ba.set(ofs + 0, v & 0xff);
        ba.set(ofs + 1, v >>> 8 & 0xff);
        ba.set(ofs + 2, v >>> 16 & 0xff);
        ba.set(ofs + 3, v >>> 24 & 0xff);
        return 0;
    }
    function caml_ba_uint8_set64(ba, i0, v) {
        var ofs = ba.offset(i0);
        if (ofs + 7 >= ba.data.length) caml_array_bound_error();
        var v = caml_int64_to_bytes(v);
        for(var i = 0; i < 8; i++)ba.set(ofs + i, v[7 - i]);
        return 0;
    }
    function caml_backtrace_status(_unit) {
        return caml_record_backtrace_flag ? 1 : 0;
    }
    function caml_bigstring_blit_ba_to_ba(ba1, pos1, ba2, pos2, len) {
        if (12 != ba1.kind) caml_invalid_argument("caml_bigstring_blit_ba_to_ba: kind mismatch");
        if (12 != ba2.kind) caml_invalid_argument("caml_bigstring_blit_ba_to_ba: kind mismatch");
        if (len == 0) return 0;
        var ofs1 = ba1.offset(pos1), ofs2 = ba2.offset(pos2);
        if (ofs1 + len > ba1.data.length) caml_array_bound_error();
        if (ofs2 + len > ba2.data.length) caml_array_bound_error();
        var slice = ba1.data.subarray(ofs1, ofs1 + len);
        ba2.data.set(slice, pos2);
        return 0;
    }
    function caml_bigstring_blit_ba_to_bytes(ba1, pos1, bytes2, pos2, len) {
        if (12 != ba1.kind) caml_invalid_argument("caml_bigstring_blit_string_to_ba: kind mismatch");
        if (len == 0) return 0;
        var ofs1 = ba1.offset(pos1);
        if (ofs1 + len > ba1.data.length) caml_array_bound_error();
        if (pos2 + len > caml_ml_bytes_length(bytes2)) caml_array_bound_error();
        var slice = ba1.data.slice(ofs1, ofs1 + len);
        caml_blit_bytes(caml_bytes_of_array(slice), 0, bytes2, pos2, len);
        return 0;
    }
    function caml_bigstring_blit_bytes_to_ba(str1, pos1, ba2, pos2, len) {
        if (12 != ba2.kind) caml_invalid_argument("caml_bigstring_blit_string_to_ba: kind mismatch");
        if (len == 0) return 0;
        var ofs2 = ba2.offset(pos2);
        if (pos1 + len > caml_ml_bytes_length(str1)) caml_array_bound_error();
        if (ofs2 + len > ba2.data.length) caml_array_bound_error();
        var slice = caml_uint8_array_of_bytes(str1).slice(pos1, pos1 + len);
        ba2.data.set(slice, ofs2);
        return 0;
    }
    function caml_bigstring_blit_string_to_ba(str1, pos1, ba2, pos2, len) {
        if (12 != ba2.kind) caml_invalid_argument("caml_bigstring_blit_string_to_ba: kind mismatch");
        if (len == 0) return 0;
        var ofs2 = ba2.offset(pos2);
        if (pos1 + len > caml_ml_string_length(str1)) caml_array_bound_error();
        if (ofs2 + len > ba2.data.length) caml_array_bound_error();
        var slice = caml_uint8_array_of_string(str1).slice(pos1, pos1 + len);
        ba2.data.set(slice, ofs2);
        return 0;
    }
    function caml_bigstring_memcmp(s1, pos1, s2, pos2, len) {
        for(var i = 0; i < len; i++){
            var a = caml_ba_get_1(s1, pos1 + i), b = caml_ba_get_1(s2, pos2 + i);
            if (a < b) return -1;
            if (a > b) return 1;
        }
        return 0;
    }
    function caml_blake2_create(hashlen, key) {
        key = caml_uint8_array_of_string(key);
        if (key.length > 64) key.subarray(0, 64);
        return blake2b.Init(hashlen, key);
    }
    function caml_blake2_final(ctx, hashlen) {
        var r = blake2b.Final(ctx);
        return caml_string_of_array(r);
    }
    function caml_blake2_update(ctx, buf, ofs, len) {
        var input = caml_uint8_array_of_string(buf);
        input = input.subarray(ofs, ofs + len);
        blake2b.Update(ctx, input);
        return 0;
    }
    function caml_blake2_string(hashlen, key, buf, ofs, len) {
        var ctx = caml_blake2_create(hashlen, key);
        caml_blake2_update(ctx, buf, ofs, len);
        return caml_blake2_final(ctx, hashlen);
    }
    function caml_blit_string(a, b, c, d, e) {
        caml_blit_bytes(caml_bytes_of_string(a), b, c, d, e);
        return 0;
    }
    function caml_bswap16(x) {
        return (x & 0x00FF) << 8 | (x & 0xFF00) >> 8;
    }
    function caml_jsstring_of_string(s) {
        if (jsoo_is_ascii(s)) return s;
        return caml_utf16_of_utf8(s);
    }
    function caml_build_symbols(symb) {
        var r = {};
        if (symb) for(var i = 1; i < symb.length; i++)r[caml_jsstring_of_string(symb[i][1])] = symb[i][2];
        return r;
    }
    function caml_bytes_compare(s1, s2) {
        s1.t & 6 && caml_convert_string_to_bytes(s1);
        s2.t & 6 && caml_convert_string_to_bytes(s2);
        return s1.c < s2.c ? -1 : s1.c > s2.c ? 1 : 0;
    }
    function caml_bytes_equal(s1, s2) {
        if (s1 === s2) return 1;
        s1.t & 6 && caml_convert_string_to_bytes(s1);
        s2.t & 6 && caml_convert_string_to_bytes(s2);
        return s1.c == s2.c ? 1 : 0;
    }
    function caml_bytes_unsafe_get(s, i) {
        switch(s.t & 6){
            default:
                if (i >= s.c.length) return 0;
            case 0:
                return s.c.charCodeAt(i);
            case 4:
                return s.c[i];
        }
    }
    function caml_bytes_get(s, i) {
        if (i >>> 0 >= s.l) caml_bytes_bound_error();
        return caml_bytes_unsafe_get(s, i);
    }
    function caml_bytes_get16(s, i) {
        if (i >>> 0 >= s.l - 1) caml_bytes_bound_error();
        var b1 = caml_bytes_unsafe_get(s, i), b2 = caml_bytes_unsafe_get(s, i + 1);
        return b2 << 8 | b1;
    }
    function caml_bytes_get32(s, i) {
        if (i >>> 0 >= s.l - 3) caml_bytes_bound_error();
        var b1 = caml_bytes_unsafe_get(s, i), b2 = caml_bytes_unsafe_get(s, i + 1), b3 = caml_bytes_unsafe_get(s, i + 2), b4 = caml_bytes_unsafe_get(s, i + 3);
        return b4 << 24 | b3 << 16 | b2 << 8 | b1;
    }
    function caml_bytes_get64(s, i) {
        if (i >>> 0 >= s.l - 7) caml_bytes_bound_error();
        var a = new Array(8);
        for(var j = 0; j < 8; j++)a[7 - j] = caml_bytes_unsafe_get(s, i + j);
        return caml_int64_of_bytes(a);
    }
    function caml_bytes_lessequal(s1, s2) {
        s1.t & 6 && caml_convert_string_to_bytes(s1);
        s2.t & 6 && caml_convert_string_to_bytes(s2);
        return s1.c <= s2.c ? 1 : 0;
    }
    function caml_bytes_greaterequal(s1, s2) {
        return caml_bytes_lessequal(s2, s1);
    }
    function caml_bytes_lessthan(s1, s2) {
        s1.t & 6 && caml_convert_string_to_bytes(s1);
        s2.t & 6 && caml_convert_string_to_bytes(s2);
        return s1.c < s2.c ? 1 : 0;
    }
    function caml_bytes_greaterthan(s1, s2) {
        return caml_bytes_lessthan(s2, s1);
    }
    function caml_bytes_notequal(s1, s2) {
        return 1 - caml_bytes_equal(s1, s2);
    }
    function caml_bytes_of_utf16_jsstring(s) {
        var tag = 9;
        if (!jsoo_is_ascii(s)) tag = 8, s = caml_utf8_of_utf16(s);
        return new MlBytes(tag, s, s.length);
    }
    function caml_bytes_set16(s, i, i16) {
        if (i >>> 0 >= s.l - 1) caml_bytes_bound_error();
        var b2 = 0xFF & i16 >> 8, b1 = 0xFF & i16;
        caml_bytes_unsafe_set(s, i + 0, b1);
        caml_bytes_unsafe_set(s, i + 1, b2);
        return 0;
    }
    function caml_bytes_set32(s, i, i32) {
        if (i >>> 0 >= s.l - 3) caml_bytes_bound_error();
        var b4 = 0xFF & i32 >> 24, b3 = 0xFF & i32 >> 16, b2 = 0xFF & i32 >> 8, b1 = 0xFF & i32;
        caml_bytes_unsafe_set(s, i + 0, b1);
        caml_bytes_unsafe_set(s, i + 1, b2);
        caml_bytes_unsafe_set(s, i + 2, b3);
        caml_bytes_unsafe_set(s, i + 3, b4);
        return 0;
    }
    function caml_bytes_set64(s, i, i64) {
        if (i >>> 0 >= s.l - 7) caml_bytes_bound_error();
        var a = caml_int64_to_bytes(i64);
        for(var j = 0; j < 8; j++)caml_bytes_unsafe_set(s, i + 7 - j, a[j]);
        return 0;
    }
    var caml_callback = caml_call_gen;
    function caml_cbrt_float(x) {
        return Math.cbrt(x);
    }
    var caml_ml_channels = new Array();
    function caml_ml_channel_get(id) {
        return caml_ml_channels[id];
    }
    function caml_channel_descriptor(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return chan.fd;
    }
    function caml_check_bound(array, index) {
        if (index >>> 0 >= array.length - 1) caml_array_bound_error();
        return array;
    }
    function caml_classify_float(x) {
        if (isFinite(x)) {
            if (Math.abs(x) >= 2.2250738585072014e-308) return 0;
            if (x != 0) return 1;
            return 2;
        }
        return isNaN(x) ? 4 : 3;
    }
    function caml_compare_val_get_custom(a) {
        return caml_custom_ops[a.caml_custom] && caml_custom_ops[a.caml_custom].compare;
    }
    function caml_compare_val_number_custom(num, custom, swap, total) {
        var comp = caml_compare_val_get_custom(custom);
        if (comp) {
            var x = swap > 0 ? comp(custom, num, total) : comp(num, custom, total);
            if (total && x != x) return swap;
            if (+x != +x) return +x;
            if ((x | 0) != 0) return x | 0;
        }
        return swap;
    }
    function caml_compare_val_tag(a) {
        if (typeof a === "number") return 1000;
        else if (caml_is_ml_bytes(a)) return 252;
        else if (caml_is_ml_string(a)) return 1252;
        else if (a instanceof Array && a[0] === a[0] >>> 0 && a[0] <= 255) {
            var tag = a[0] | 0;
            return tag == 254 ? 0 : tag;
        } else if (a instanceof String) return 12520;
        else if (typeof a == "string") return 12520;
        else if (a instanceof Number) return 1000;
        else if (a && a.caml_custom) return 1255;
        else if (a && a.compare) return 1256;
        else if (typeof a == "function") return 1247;
        else if (typeof a == "symbol") return 1251;
        return 1001;
    }
    function caml_int_compare(a, b) {
        if (a < b) return -1;
        if (a == b) return 0;
        return 1;
    }
    function caml_string_compare(s1, s2) {
        return s1 < s2 ? -1 : s1 > s2 ? 1 : 0;
    }
    function caml_compare_val(a, b, total) {
        var stack = [];
        for(;;){
            if (!(total && a === b)) {
                var tag_a = caml_compare_val_tag(a);
                if (tag_a == 250) {
                    a = a[1];
                    continue;
                }
                var tag_b = caml_compare_val_tag(b);
                if (tag_b == 250) {
                    b = b[1];
                    continue;
                }
                if (tag_a !== tag_b) {
                    if (tag_a == 1000) {
                        if (tag_b == 1255) return caml_compare_val_number_custom(a, b, -1, total);
                        return -1;
                    }
                    if (tag_b == 1000) {
                        if (tag_a == 1255) return caml_compare_val_number_custom(b, a, 1, total);
                        return 1;
                    }
                    return tag_a < tag_b ? -1 : 1;
                }
                switch(tag_a){
                    case 247:
                        caml_invalid_argument("compare: functional value");
                        break;
                    case 248:
                        var x = caml_int_compare(a[2], b[2]);
                        if (x != 0) return x | 0;
                        break;
                    case 249:
                        caml_invalid_argument("compare: functional value");
                        break;
                    case 250:
                        caml_invalid_argument("equal: got Forward_tag, should not happen");
                        break;
                    case 251:
                        caml_invalid_argument("equal: abstract value");
                        break;
                    case 252:
                        if (a !== b) {
                            var x = caml_bytes_compare(a, b);
                            if (x != 0) return x | 0;
                        }
                        break;
                    case 253:
                        caml_invalid_argument("equal: got Double_tag, should not happen");
                        break;
                    case 254:
                        caml_invalid_argument("equal: got Double_array_tag, should not happen");
                        break;
                    case 255:
                        caml_invalid_argument("equal: got Custom_tag, should not happen");
                        break;
                    case 1247:
                        caml_invalid_argument("compare: functional value");
                        break;
                    case 1255:
                        var comp = caml_compare_val_get_custom(a);
                        if (comp != caml_compare_val_get_custom(b)) return a.caml_custom < b.caml_custom ? -1 : 1;
                        if (!comp) caml_invalid_argument("compare: abstract value");
                        var x = comp(a, b, total);
                        if (x != x) return total ? -1 : x;
                        if (x !== (x | 0)) return -1;
                        if (x != 0) return x | 0;
                        break;
                    case 1256:
                        var x = a.compare(b, total);
                        if (x != x) return total ? -1 : x;
                        if (x !== (x | 0)) return -1;
                        if (x != 0) return x | 0;
                        break;
                    case 1000:
                        a = +a;
                        b = +b;
                        if (a < b) return -1;
                        if (a > b) return 1;
                        if (a != b) {
                            if (!total) return NaN;
                            if (a == a) return 1;
                            if (b == b) return -1;
                        }
                        break;
                    case 1001:
                        if (a < b) return -1;
                        if (a > b) return 1;
                        if (a != b) {
                            if (!total) return NaN;
                            if (a == a) return 1;
                            if (b == b) return -1;
                        }
                        break;
                    case 1251:
                        if (a !== b) {
                            if (!total) return NaN;
                            return 1;
                        }
                        break;
                    case 1252:
                        var a = caml_jsbytes_of_string(a), b = caml_jsbytes_of_string(b);
                        if (a !== b) {
                            if (a < b) return -1;
                            if (a > b) return 1;
                        }
                        break;
                    case 12520:
                        var a = a.toString(), b = b.toString();
                        if (a !== b) {
                            if (a < b) return -1;
                            if (a > b) return 1;
                        }
                        break;
                    case 246:
                    case 254:
                    default:
                        if (caml_is_continuation_tag(tag_a)) {
                            caml_invalid_argument("compare: continuation value");
                            break;
                        }
                        if (a.length != b.length) return a.length < b.length ? -1 : 1;
                        if (a.length > 1) stack.push(a, b, 1);
                        break;
                }
            }
            if (stack.length == 0) return 0;
            var i = stack.pop();
            b = stack.pop();
            a = stack.pop();
            if (i + 1 < a.length) stack.push(a, b, i + 1);
            a = a[i];
            b = b[i];
        }
    }
    function caml_compare(a, b) {
        return caml_compare_val(a, b, true);
    }
    function caml_continuation_use_noexc(cont) {
        var stack = cont[1];
        cont[1] = 0;
        return stack;
    }
    function caml_continuation_use_and_update_handler_noexc(cont, hval, hexn, heff) {
        var stack = caml_continuation_use_noexc(cont);
        stack[3] = [
            0,
            hval,
            hexn,
            heff
        ];
        return stack;
    }
    function caml_convert_raw_backtrace() {
        return [
            0
        ];
    }
    function caml_convert_raw_backtrace_slot() {
        caml_failwith("caml_convert_raw_backtrace_slot");
    }
    function caml_copysign_float(x, y) {
        if (y == 0) y = 1 / y;
        x = Math.abs(x);
        return y < 0 ? -x : x;
    }
    function caml_cosh_float(x) {
        return Math.cosh(x);
    }
    function fs_node_supported() {
        return typeof globalThis1.process !== "undefined" && typeof globalThis1.process.versions !== "undefined" && typeof globalThis1.process.versions.node !== "undefined";
    }
    function make_path_is_absolute() {
        function posix(path) {
            if (path.charAt(0) === "/") return [
                "",
                path.substring(1)
            ];
            return;
        }
        function win32(path) {
            var splitDeviceRe = /^([a-zA-Z]:|[\\/]{2}[^\\/]+[\\/]+[^\\/]+)?([\\/])?([\s\S]*?)$/, result = splitDeviceRe.exec(path), device = result[1] || "", isUnc = Boolean(device && device.charAt(1) !== ":");
            if (Boolean(result[2] || isUnc)) {
                var root = result[1] || "", sep = result[2] || "";
                return [
                    root,
                    path.substring(root.length + sep.length)
                ];
            }
            return;
        }
        return fs_node_supported() && globalThis1.process && globalThis1.process.platform ? globalThis1.process.platform === "win32" ? win32 : posix : posix;
    }
    var path_is_absolute = make_path_is_absolute();
    function caml_trailing_slash(name) {
        return name.slice(-1) !== "/" ? name + "/" : name;
    }
    if (fs_node_supported() && globalThis1.process && globalThis1.process.cwd) var caml_current_dir = globalThis1.process.cwd().replace(/\\/g, "/");
    else var caml_current_dir = "/static";
    caml_current_dir = caml_trailing_slash(caml_current_dir);
    function caml_make_path(name) {
        name = caml_jsstring_of_string(name);
        if (!path_is_absolute(name)) name = caml_current_dir + name;
        var comp0 = path_is_absolute(name), comp = comp0[1].split("/"), ncomp = [];
        for(var i = 0; i < comp.length; i++)switch(comp[i]){
            case "..":
                if (ncomp.length > 1) ncomp.pop();
                break;
            case ".":
                break;
            case "":
                break;
            default:
                ncomp.push(comp[i]);
                break;
        }
        ncomp.unshift(comp0[0]);
        ncomp.orig = name;
        return ncomp;
    }
    function caml_get_root(path) {
        var x = path_is_absolute(path);
        if (!x) return;
        return x[0] + "/";
    }
    var caml_root = caml_get_root(caml_current_dir) || caml_failwith("unable to compute caml_root"), jsoo_mount_point = [];
    if (fs_node_supported()) jsoo_mount_point.push({
        path: caml_root,
        device: new MlNodeDevice(caml_root)
    });
    else jsoo_mount_point.push({
        path: caml_root,
        device: new MlFakeDevice(caml_root)
    });
    jsoo_mount_point.push({
        path: "/static/",
        device: new MlFakeDevice("/static/")
    });
    function resolve_fs_device(name) {
        var path = caml_make_path(name), name = path.join("/"), name_slash = caml_trailing_slash(name), res;
        for(var i = 0; i < jsoo_mount_point.length; i++){
            var m = jsoo_mount_point[i];
            if (name_slash.search(m.path) == 0 && (!res || res.path.length < m.path.length)) res = {
                path: m.path,
                device: m.device,
                rest: name.substring(m.path.length, name.length)
            };
        }
        if (!res && fs_node_supported()) {
            var root = caml_get_root(name);
            if (root && root.match(/^[a-zA-Z]:\/$/)) {
                var m = {
                    path: root,
                    device: new MlNodeDevice(root)
                };
                jsoo_mount_point.push(m);
                res = {
                    path: m.path,
                    device: m.device,
                    rest: name.substring(m.path.length, name.length)
                };
            }
        }
        if (res) return res;
        caml_raise_sys_error("no device found for " + name_slash);
    }
    function caml_create_file(name, content) {
        var root = resolve_fs_device(name);
        if (!root.device.register) caml_failwith("cannot register file");
        root.device.register(root.rest, content);
        return 0;
    }
    function caml_create_string(len) {
        caml_invalid_argument("String.create");
    }
    function caml_csel_value(v_cond, v_true, v_false) {
        return v_cond ? v_true : v_false;
    }
    var caml_custom_event_index = 0, zstd_decompress = function() {
        "use strict";
        var ab = ArrayBuffer, u8 = Uint8Array, u16 = Uint16Array, i16 = Int16Array, u32 = Uint32Array, i32 = Int32Array;
        function slc(v, s, e) {
            if (u8.prototype.slice) return u8.prototype.slice.call(v, s, e);
            if (s == null || s < 0) s = 0;
            if (e == null || e > v.length) e = v.length;
            var n = new u8(e - s);
            n.set(v.subarray(s, e));
            return n;
        }
        function fill(v, n, s, e) {
            if (u8.prototype.fill) return u8.prototype.fill.call(v, n, s, e);
            if (s == null || s < 0) s = 0;
            if (e == null || e > v.length) e = v.length;
            for(; s < e; ++s)v[s] = n;
            return v;
        }
        function cpw(v, t, s, e) {
            if (u8.prototype.copyWithin) return u8.prototype.copyWithin.call(v, t, s, e);
            if (s == null || s < 0) s = 0;
            if (e == null || e > v.length) e = v.length;
            while(s < e)v[t++] = v[s++];
        }
        var ec = [
            "invalid zstd data",
            "window size too large (>2046MB)",
            "invalid block type",
            "FSE accuracy too high",
            "match distance too far back",
            "unexpected EOF"
        ];
        function err(ind, msg, nt) {
            var e = new Error(msg || ec[ind]);
            e.code = ind;
            if (!nt) throw e;
            return e;
        }
        function rb(d, b, n) {
            var i = 0, o = 0;
            for(; i < n; ++i)o |= d[b++] << (i << 3);
            return o;
        }
        function b4(d, b) {
            return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
        }
        function rzfh(dat, w) {
            var n3 = dat[0] | dat[1] << 8 | dat[2] << 16;
            if (n3 == 0x2FB528 && dat[3] == 253) {
                var flg = dat[4], ss = flg >> 5 & 1, cc = flg >> 2 & 1, df = flg & 3, fcf = flg >> 6;
                if (flg & 8) err(0);
                var bt = 6 - ss, db = df == 3 ? 4 : df, di = rb(dat, bt, db);
                bt += db;
                var fsb = fcf ? 1 << fcf : ss, fss = rb(dat, bt, fsb) + (fcf == 1 && 256), ws = fss;
                if (!ss) {
                    var wb = 1 << 10 + (dat[5] >> 3);
                    ws = wb + (wb >> 3) * (dat[5] & 7);
                }
                if (ws > 2145386496) err(1);
                var buf = new u8((w == 1 ? fss || ws : w ? 0 : ws) + 12);
                buf[0] = 1, buf[4] = 4, buf[8] = 8;
                return {
                    b: bt + fsb,
                    y: 0,
                    l: 0,
                    d: di,
                    w: w && w != 1 ? w : buf.subarray(12),
                    e: ws,
                    o: new i32(buf.buffer, 0, 3),
                    u: fss,
                    c: cc,
                    m: Math.min(131072, ws)
                };
            } else if ((n3 >> 4 | dat[3] << 20) == 0x184D2A5) return b4(dat, 4) + 8;
            err(0);
        }
        function msb(val) {
            var bits = 0;
            for(; 1 << bits <= val; ++bits);
            return bits - 1;
        }
        function rfse(dat, bt, mal) {
            var tpos = (bt << 3) + 4, al = (dat[bt] & 15) + 5;
            if (al > mal) err(3);
            var sz = 1 << al, probs = sz, sym = -1, re = -1, i = -1, ht = sz, buf = new ab(512 + (sz << 2)), freq = new i16(buf, 0, 256), dstate = new u16(buf, 0, 256), nstate = new u16(buf, 512, sz), bb1 = 512 + (sz << 1), syms = new u8(buf, bb1, sz), nbits = new u8(buf, bb1 + sz);
            while(sym < 255 && probs > 0){
                var bits = msb(probs + 1), cbt = tpos >> 3, msk = (1 << bits + 1) - 1, val = (dat[cbt] | dat[cbt + 1] << 8 | dat[cbt + 2] << 16) >> (tpos & 7) & msk, msk1fb = (1 << bits) - 1, msv = msk - probs - 1, sval = val & msk1fb;
                if (sval < msv) tpos += bits, val = sval;
                else {
                    tpos += bits + 1;
                    if (val > msk1fb) val -= msv;
                }
                freq[++sym] = --val;
                if (val == -1) {
                    probs += val;
                    syms[--ht] = sym;
                } else probs -= val;
                if (!val) do {
                    var rbt = tpos >> 3;
                    re = (dat[rbt] | dat[rbt + 1] << 8) >> (tpos & 7) & 3;
                    tpos += 2;
                    sym += re;
                }while (re == 3);
            }
            if (sym > 255 || probs) err(0);
            var sympos = 0, sstep = (sz >> 1) + (sz >> 3) + 3, smask = sz - 1;
            for(var s = 0; s <= sym; ++s){
                var sf = freq[s];
                if (sf < 1) {
                    dstate[s] = -sf;
                    continue;
                }
                for(i = 0; i < sf; ++i){
                    syms[sympos] = s;
                    do sympos = sympos + sstep & smask;
                    while (sympos >= ht);
                }
            }
            if (sympos) err(0);
            for(i = 0; i < sz; ++i){
                var ns = dstate[syms[i]]++, nb = nbits[i] = al - msb(ns);
                nstate[i] = (ns << nb) - sz;
            }
            return [
                tpos + 7 >> 3,
                {
                    b: al,
                    s: syms,
                    n: nbits,
                    t: nstate
                }
            ];
        }
        function rhu(dat, bt) {
            var i = 0, wc = -1, buf = new u8(292), hb = dat[bt], hw = buf.subarray(0, 256), rc = buf.subarray(256, 268), ri = new u16(buf.buffer, 268);
            if (hb < 128) {
                var _a = rfse(dat, bt + 1, 6), ebt = _a[0], fdt = _a[1];
                bt += hb;
                var epos = ebt << 3, lb = dat[bt];
                if (!lb) err(0);
                var st1 = 0, st2 = 0, btr1 = fdt.b, btr2 = btr1, fpos = (++bt << 3) - 8 + msb(lb);
                for(;;){
                    fpos -= btr1;
                    if (fpos < epos) break;
                    var cbt = fpos >> 3;
                    st1 += (dat[cbt] | dat[cbt + 1] << 8) >> (fpos & 7) & (1 << btr1) - 1;
                    hw[++wc] = fdt.s[st1];
                    fpos -= btr2;
                    if (fpos < epos) break;
                    cbt = fpos >> 3;
                    st2 += (dat[cbt] | dat[cbt + 1] << 8) >> (fpos & 7) & (1 << btr2) - 1;
                    hw[++wc] = fdt.s[st2];
                    btr1 = fdt.n[st1];
                    st1 = fdt.t[st1];
                    btr2 = fdt.n[st2];
                    st2 = fdt.t[st2];
                }
                if (++wc > 255) err(0);
            } else {
                wc = hb - 127;
                for(; i < wc; i += 2){
                    var byte = dat[++bt];
                    hw[i] = byte >> 4;
                    hw[i + 1] = byte & 15;
                }
                ++bt;
            }
            var wes = 0;
            for(i = 0; i < wc; ++i){
                var wt = hw[i];
                if (wt > 11) err(0);
                wes += wt && 1 << wt - 1;
            }
            var mb = msb(wes) + 1, ts = 1 << mb, rem = ts - wes;
            if (rem & rem - 1) err(0);
            hw[wc++] = msb(rem) + 1;
            for(i = 0; i < wc; ++i){
                var wt = hw[i];
                ++rc[hw[i] = wt && mb + 1 - wt];
            }
            var hbuf = new u8(ts << 1), syms = hbuf.subarray(0, ts), nb = hbuf.subarray(ts);
            ri[mb] = 0;
            for(i = mb; i > 0; --i){
                var pv = ri[i];
                fill(nb, i, pv, ri[i - 1] = pv + rc[i] * (1 << mb - i));
            }
            if (ri[0] != ts) err(0);
            for(i = 0; i < wc; ++i){
                var bits = hw[i];
                if (bits) {
                    var code = ri[bits];
                    fill(syms, i, code, ri[bits] = code + (1 << mb - bits));
                }
            }
            return [
                bt,
                {
                    n: nb,
                    b: mb,
                    s: syms
                }
            ];
        }
        var dllt = rfse(new u8([
            81,
            16,
            99,
            140,
            49,
            198,
            24,
            99,
            12,
            33,
            196,
            24,
            99,
            102,
            102,
            134,
            70,
            146,
            4
        ]), 0, 6)[1], dmlt = rfse(new u8([
            33,
            20,
            196,
            24,
            99,
            140,
            33,
            132,
            16,
            66,
            8,
            33,
            132,
            16,
            66,
            8,
            33,
            68,
            68,
            68,
            68,
            68,
            68,
            68,
            68,
            36,
            9
        ]), 0, 6)[1], doct = rfse(new u8([
            32,
            132,
            16,
            66,
            102,
            70,
            68,
            68,
            68,
            68,
            36,
            73,
            2
        ]), 0, 5)[1];
        function b2bl(b, s) {
            var len = b.length, bl = new i32(len);
            for(var i = 0; i < len; ++i){
                bl[i] = s;
                s += 1 << b[i];
            }
            return bl;
        }
        var llb = new u8(new i32([
            0,
            0,
            0,
            0,
            16843009,
            50528770,
            134678020,
            202050057,
            269422093
        ]).buffer, 0, 36), llbl = b2bl(llb, 0), mlb = new u8(new i32([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            16843009,
            50528770,
            117769220,
            185207048,
            252579084,
            16
        ]).buffer, 0, 53), mlbl = b2bl(mlb, 3);
        function dhu(dat, out, hu) {
            var len = dat.length, ss = out.length, lb = dat[len - 1], msk = (1 << hu.b) - 1, eb = -hu.b;
            if (!lb) err(0);
            var st = 0, btr = hu.b, pos = (len << 3) - 8 + msb(lb) - btr, i = -1;
            for(; pos > eb && i < ss;){
                var cbt = pos >> 3, val = (dat[cbt] | dat[cbt + 1] << 8 | dat[cbt + 2] << 16) >> (pos & 7);
                st = (st << btr | val) & msk;
                out[++i] = hu.s[st];
                pos -= btr = hu.n[st];
            }
            if (pos != eb || i + 1 != ss) err(0);
        }
        function dhu4(dat, out, hu) {
            var bt = 6, ss = out.length, sz1 = ss + 3 >> 2, sz2 = sz1 << 1, sz3 = sz1 + sz2;
            dhu(dat.subarray(bt, bt += dat[0] | dat[1] << 8), out.subarray(0, sz1), hu);
            dhu(dat.subarray(bt, bt += dat[2] | dat[3] << 8), out.subarray(sz1, sz2), hu);
            dhu(dat.subarray(bt, bt += dat[4] | dat[5] << 8), out.subarray(sz2, sz3), hu);
            dhu(dat.subarray(bt), out.subarray(sz3), hu);
        }
        function rzb(dat, st, out) {
            var _a, bt = st.b, b0 = dat[bt], btype = b0 >> 1 & 3;
            st.l = b0 & 1;
            var sz = b0 >> 3 | dat[bt + 1] << 5 | dat[bt + 2] << 13, ebt = (bt += 3) + sz;
            if (btype == 1) {
                if (bt >= dat.length) return;
                st.b = bt + 1;
                if (out) {
                    fill(out, dat[bt], st.y, st.y += sz);
                    return out;
                }
                return fill(new u8(sz), dat[bt]);
            }
            if (ebt > dat.length) return;
            if (btype == 0) {
                st.b = ebt;
                if (out) {
                    out.set(dat.subarray(bt, ebt), st.y);
                    st.y += sz;
                    return out;
                }
                return slc(dat, bt, ebt);
            }
            if (btype == 2) {
                var b3 = dat[bt], lbt = b3 & 3, sf = b3 >> 2 & 3, lss = b3 >> 4, lcs = 0, s4 = 0;
                if (lbt < 2) {
                    if (sf & 1) lss |= dat[++bt] << 4 | (sf & 2 && dat[++bt] << 12);
                    else lss = b3 >> 3;
                } else {
                    s4 = sf;
                    if (sf < 2) lss |= (dat[++bt] & 63) << 4, lcs = dat[bt] >> 6 | dat[++bt] << 2;
                    else if (sf == 2) lss |= dat[++bt] << 4 | (dat[++bt] & 3) << 12, lcs = dat[bt] >> 2 | dat[++bt] << 6;
                    else lss |= dat[++bt] << 4 | (dat[++bt] & 63) << 12, lcs = dat[bt] >> 6 | dat[++bt] << 2 | dat[++bt] << 10;
                }
                ++bt;
                var buf = out ? out.subarray(st.y, st.y + st.m) : new u8(st.m), spl = buf.length - lss;
                if (lbt == 0) buf.set(dat.subarray(bt, bt += lss), spl);
                else if (lbt == 1) fill(buf, dat[bt++], spl);
                else {
                    var hu = st.h;
                    if (lbt == 2) {
                        var hud = rhu(dat, bt);
                        lcs += bt - (bt = hud[0]);
                        st.h = hu = hud[1];
                    } else if (!hu) err(0);
                    (s4 ? dhu4 : dhu)(dat.subarray(bt, bt += lcs), buf.subarray(spl), hu);
                }
                var ns = dat[bt++];
                if (ns) {
                    if (ns == 255) ns = (dat[bt++] | dat[bt++] << 8) + 0x7F00;
                    else if (ns > 127) ns = ns - 128 << 8 | dat[bt++];
                    var scm = dat[bt++];
                    if (scm & 3) err(0);
                    var dts = [
                        dmlt,
                        doct,
                        dllt
                    ];
                    for(var i = 2; i > -1; --i){
                        var md = scm >> (i << 1) + 2 & 3;
                        if (md == 1) {
                            var rbuf = new u8([
                                0,
                                0,
                                dat[bt++]
                            ]);
                            dts[i] = {
                                s: rbuf.subarray(2, 3),
                                n: rbuf.subarray(0, 1),
                                t: new u16(rbuf.buffer, 0, 1),
                                b: 0
                            };
                        } else if (md == 2) _a = rfse(dat, bt, 9 - (i & 1)), bt = _a[0], dts[i] = _a[1];
                        else if (md == 3) {
                            if (!st.t) err(0);
                            dts[i] = st.t[i];
                        }
                    }
                    var _b = st.t = dts, mlt = _b[0], oct = _b[1], llt = _b[2], lb = dat[ebt - 1];
                    if (!lb) err(0);
                    var spos = (ebt << 3) - 8 + msb(lb) - llt.b, cbt = spos >> 3, oubt = 0, lst = (dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << llt.b) - 1;
                    cbt = (spos -= oct.b) >> 3;
                    var ost = (dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << oct.b) - 1;
                    cbt = (spos -= mlt.b) >> 3;
                    var mst = (dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << mlt.b) - 1;
                    for(++ns; --ns;){
                        var llc = llt.s[lst], lbtr = llt.n[lst], mlc = mlt.s[mst], mbtr = mlt.n[mst], ofc = oct.s[ost], obtr = oct.n[ost];
                        cbt = (spos -= ofc) >> 3;
                        var ofp = 1 << ofc, off = ofp + ((dat[cbt] | dat[cbt + 1] << 8 | dat[cbt + 2] << 16 | dat[cbt + 3] << 24) >>> (spos & 7) & ofp - 1);
                        cbt = (spos -= mlb[mlc]) >> 3;
                        var ml = mlbl[mlc] + ((dat[cbt] | dat[cbt + 1] << 8 | dat[cbt + 2] << 16) >> (spos & 7) & (1 << mlb[mlc]) - 1);
                        cbt = (spos -= llb[llc]) >> 3;
                        var ll = llbl[llc] + ((dat[cbt] | dat[cbt + 1] << 8 | dat[cbt + 2] << 16) >> (spos & 7) & (1 << llb[llc]) - 1);
                        cbt = (spos -= lbtr) >> 3;
                        lst = llt.t[lst] + ((dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << lbtr) - 1);
                        cbt = (spos -= mbtr) >> 3;
                        mst = mlt.t[mst] + ((dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << mbtr) - 1);
                        cbt = (spos -= obtr) >> 3;
                        ost = oct.t[ost] + ((dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << obtr) - 1);
                        if (off > 3) {
                            st.o[2] = st.o[1];
                            st.o[1] = st.o[0];
                            st.o[0] = off -= 3;
                        } else {
                            var idx = off - (ll != 0);
                            if (idx) {
                                off = idx == 3 ? st.o[0] - 1 : st.o[idx];
                                if (idx > 1) st.o[2] = st.o[1];
                                st.o[1] = st.o[0];
                                st.o[0] = off;
                            } else off = st.o[0];
                        }
                        for(var i = 0; i < ll; ++i)buf[oubt + i] = buf[spl + i];
                        oubt += ll, spl += ll;
                        var stin = oubt - off;
                        if (stin < 0) {
                            var len = -stin, bs = st.e + stin;
                            if (len > ml) len = ml;
                            for(var i = 0; i < len; ++i)buf[oubt + i] = st.w[bs + i];
                            oubt += len, ml -= len, stin = 0;
                        }
                        for(var i = 0; i < ml; ++i)buf[oubt + i] = buf[stin + i];
                        oubt += ml;
                    }
                    if (oubt != spl) while(spl < buf.length)buf[oubt++] = buf[spl++];
                    else oubt = buf.length;
                    if (out) st.y += oubt;
                    else buf = slc(buf, 0, oubt);
                } else if (out) {
                    st.y += lss;
                    if (spl) for(var i = 0; i < lss; ++i)buf[i] = buf[spl + i];
                } else if (spl) buf = slc(buf, spl);
                st.b = ebt;
                return buf;
            }
            err(2);
        }
        function cct(bufs, ol) {
            if (bufs.length == 1) return bufs[0];
            var buf = new u8(ol);
            for(var i = 0, b = 0; i < bufs.length; ++i){
                var chk = bufs[i];
                buf.set(chk, b);
                b += chk.length;
            }
            return buf;
        }
        return function(dat, buf) {
            var bt = 0, bufs = [], nb = +!buf, ol = 0;
            for(; dat.length;){
                var st = rzfh(dat, nb || buf);
                if (typeof st == "object") {
                    if (nb) {
                        buf = null;
                        if (st.w.length == st.u) {
                            bufs.push(buf = st.w);
                            ol += st.u;
                        }
                    } else {
                        bufs.push(buf);
                        st.e = 0;
                    }
                    for(; !st.l;){
                        var blk = rzb(dat, st, buf);
                        if (!blk) err(5);
                        if (buf) st.e = st.y;
                        else {
                            bufs.push(blk);
                            ol += blk.length;
                            cpw(st.w, 0, blk.length);
                            st.w.set(blk, st.w.length - blk.length);
                        }
                    }
                    bt = st.b + st.c * 4;
                } else bt = st;
                dat = dat.subarray(bt);
            }
            return cct(bufs, ol);
        };
    }(), caml_decompress_input = zstd_decompress;
    function caml_div(x, y) {
        if (y == 0) caml_raise_zero_divide();
        return x / y | 0;
    }
    var caml_domain_dls = [
        0
    ];
    function caml_domain_dls_compare_and_set(old, n) {
        if (caml_domain_dls !== old) return 0;
        caml_domain_dls = n;
        return 1;
    }
    function caml_domain_dls_get(unit) {
        return caml_domain_dls;
    }
    function caml_domain_dls_set(a) {
        caml_domain_dls = a;
    }
    var caml_domain_id = 0;
    function caml_ml_mutex_unlock(t) {
        t.locked = false;
        return 0;
    }
    var caml_domain_latest_idx = 1;
    function caml_domain_spawn(f, term_sync) {
        var id = caml_domain_latest_idx++, old = caml_domain_id;
        caml_domain_id = id;
        var res = caml_callback(f, [
            0
        ]);
        caml_domain_id = old;
        caml_ml_mutex_unlock(term_sync[2]);
        term_sync[1] = [
            0,
            [
                0,
                res
            ]
        ];
        return id;
    }
    function caml_dummy_obj_is_stack(x) {
        throw new Error(`BUG: this function should be unreachable; please report to compiler or base devs.`);
    }
    var caml_ephe_data_offset = 2, caml_ephe_key_offset = 3;
    function caml_ephe_unset_data(x) {
        if (globalThis1.FinalizationRegistry && globalThis1.WeakRef) {
            if (x[1] instanceof globalThis1.FinalizationRegistry) for(var j = caml_ephe_key_offset; j < x.length; j++){
                var key = x[j];
                if (key instanceof globalThis1.WeakRef) {
                    key = key.deref();
                    if (key) x[1].unregister(key);
                }
            }
        }
        x[caml_ephe_data_offset] = undefined;
        return 0;
    }
    function caml_ephe_set_data(x, data) {
        if (globalThis1.FinalizationRegistry && globalThis1.WeakRef) {
            if (!(x[1] instanceof globalThis1.FinalizationRegistry)) {
                x[1] = new globalThis1.FinalizationRegistry(function() {
                    caml_ephe_unset_data(x);
                });
                for(var j = caml_ephe_key_offset; j < x.length; j++){
                    var key = x[j];
                    if (key instanceof globalThis1.WeakRef) {
                        key = key.deref();
                        if (key) x[1].register(key, undefined, key);
                    }
                }
            }
        }
        x[caml_ephe_data_offset] = data;
        return 0;
    }
    function caml_ephe_blit_data(src, dst) {
        var n = src[caml_ephe_data_offset];
        if (n === undefined) caml_ephe_unset_data(dst);
        else caml_ephe_set_data(dst, n);
        return 0;
    }
    function caml_ephe_blit_key(a1, i1, a2, i2, len) {
        caml_array_blit(a1, caml_ephe_key_offset + i1 - 1, a2, caml_ephe_key_offset + i2 - 1, len);
        return 0;
    }
    function caml_ephe_check_data(x) {
        return x[caml_ephe_data_offset] === undefined ? 0 : 1;
    }
    function caml_ephe_check_key(x, i) {
        var weak = x[caml_ephe_key_offset + i];
        if (globalThis1.WeakRef && weak instanceof globalThis1.WeakRef) weak = weak.deref();
        return weak === undefined ? 0 : 1;
    }
    function caml_weak_create(n) {
        if (n < 0) caml_invalid_argument("Weak.create");
        var x = [
            251,
            "caml_ephe_list_head"
        ];
        x.length = caml_ephe_key_offset + n;
        return x;
    }
    function caml_ephe_create(n) {
        var x = caml_weak_create(n);
        return x;
    }
    function caml_ephe_get_data(x) {
        return x[caml_ephe_data_offset] === undefined ? 0 : [
            0,
            x[caml_ephe_data_offset]
        ];
    }
    function caml_obj_dup(x) {
        var l = x.length, a = new Array(l);
        for(var i = 0; i < l; i++)a[i] = x[i];
        return a;
    }
    function caml_ephe_get_data_copy(x) {
        return x[caml_ephe_data_offset] === undefined ? 0 : [
            0,
            caml_obj_dup(x[caml_ephe_data_offset])
        ];
    }
    function caml_ephe_get_key(x, i) {
        if (i < 0 || caml_ephe_key_offset + i >= x.length) caml_invalid_argument("Weak.get_key");
        var weak = x[caml_ephe_key_offset + i];
        if (globalThis1.WeakRef && weak instanceof globalThis1.WeakRef) weak = weak.deref();
        return weak === undefined ? 0 : [
            0,
            weak
        ];
    }
    function caml_ephe_get_key_copy(x, i) {
        if (i < 0 || caml_ephe_key_offset + i >= x.length) caml_invalid_argument("Weak.get_copy");
        var y = caml_ephe_get_key(x, i);
        if (y === 0) return y;
        var z = y[1];
        if (z instanceof Array) return [
            0,
            caml_obj_dup(z)
        ];
        return y;
    }
    function caml_ephe_set_key(x, i, v) {
        if (i < 0 || caml_ephe_key_offset + i >= x.length) caml_invalid_argument("Weak.set");
        if (v instanceof Object && globalThis1.WeakRef) {
            if (x[1].register) x[1].register(v, undefined, v);
            x[caml_ephe_key_offset + i] = new globalThis1.WeakRef(v);
        } else x[caml_ephe_key_offset + i] = v;
        return 0;
    }
    function caml_ephe_unset_key(x, i) {
        if (i < 0 || caml_ephe_key_offset + i >= x.length) caml_invalid_argument("Weak.set");
        if (globalThis1.WeakRef && x[caml_ephe_key_offset + i] instanceof globalThis1.WeakRef && x[1].unregister) {
            var old = x[caml_ephe_key_offset + i].deref();
            if (old !== undefined) {
                var count = 0;
                for(var j = caml_ephe_key_offset; j < x.length; j++){
                    var key = x[j];
                    if (key instanceof globalThis1.WeakRef) {
                        key = key.deref();
                        if (key === old) count++;
                    }
                }
                if (count == 1) x[1].unregister(old);
            }
        }
        x[caml_ephe_key_offset + i] = undefined;
        return 0;
    }
    function caml_equal(x, y) {
        return +(caml_compare_val(x, y, false) == 0);
    }
    function caml_erf_float(x) {
        var a1 = 0.254829592, a2 = -0.284496736, a3 = 1.421413741, a4 = -1.453152027, a5 = 1.061405429, p = 0.3275911, sign = 1;
        if (x < 0) sign = -1;
        x = Math.abs(x);
        var t = 1.0 / (1.0 + p * x), y = 1.0 - ((((a5 * t + a4) * t + a3) * t + a2) * t + a1) * t * Math.exp(-(x * x));
        return sign * y;
    }
    function caml_erfc_float(x) {
        return 1 - caml_erf_float(x);
    }
    function caml_eventlog_pause(unit) {
        return 0;
    }
    function caml_eventlog_resume(unit) {
        return 0;
    }
    var caml_executable_name = caml_argv[1];
    function caml_exp2_float(x) {
        return Math.pow(2, x);
    }
    function caml_expm1_float(x) {
        return Math.expm1(x);
    }
    function caml_is_special_exception(exn) {
        switch(exn[2]){
            case -8:
            case -11:
            case -12:
                return 1;
            default:
                return 0;
        }
    }
    function caml_format_exception(exn) {
        var r = "";
        if (exn[0] == 0) {
            r += exn[1][1];
            if (exn.length == 3 && exn[2][0] == 0 && caml_is_special_exception(exn[1])) var bucket = exn[2], start = 1;
            else var start = 2, bucket = exn;
            r += "(";
            for(var i = start; i < bucket.length; i++){
                if (i > start) r += ", ";
                var v = bucket[i];
                if (typeof v == "number") r += v.toString();
                else if (v instanceof MlBytes) r += '"' + v.toString() + '"';
                else if (typeof v == "string") r += '"' + v.toString() + '"';
                else r += "_";
            }
            r += ")";
        } else if (exn[0] == 248) r += exn[1];
        return r;
    }
    function caml_fatal_uncaught_exception(err) {
        if (err instanceof Array && (err[0] == 0 || err[0] == 248)) {
            var handler = caml_named_value("Printexc.handle_uncaught_exception");
            if (handler) caml_callback(handler, [
                err,
                false
            ]);
            else {
                var msg = caml_format_exception(err), at_exit = caml_named_value("Pervasives.do_at_exit");
                if (at_exit) caml_callback(at_exit, [
                    0
                ]);
                console.error("Fatal error: exception " + msg);
                if (err.js_error) throw err.js_error;
            }
        } else throw err;
    }
    function caml_fill_bytes(s, i, l, c) {
        if (l > 0) {
            if (i == 0 && (l >= s.l || s.t == 2 && l >= s.c.length)) {
                if (c == 0) {
                    s.c = "";
                    s.t = 2;
                } else {
                    s.c = caml_str_repeat(l, String.fromCharCode(c));
                    s.t = l == s.l ? 0 : 2;
                }
            } else {
                if (s.t != 4) caml_convert_bytes_to_array(s);
                for(l += i; i < l; i++)s.c[i] = c;
            }
        }
        return 0;
    }
    function caml_final_register() {
        return 0;
    }
    var all_finalizers = new globalThis1.Set();
    function caml_final_register_called_without_value(cb, a) {
        if (globalThis1.FinalizationRegistry && a instanceof Object) {
            var x = new globalThis1.FinalizationRegistry(function(x) {
                all_finalizers.delete(x);
                cb(0);
                return;
            });
            x.register(a, x);
            all_finalizers.add(x);
        }
        return 0;
    }
    function caml_final_release() {
        return 0;
    }
    function caml_finish_formatting(f, rawbuffer) {
        if (f.uppercase) rawbuffer = rawbuffer.toUpperCase();
        var len = rawbuffer.length;
        if (f.signedconv && (f.sign < 0 || f.signstyle != "-")) len++;
        if (f.alternate) {
            if (f.base == 8) len += 1;
            if (f.base == 16) len += 2;
        }
        var buffer = "";
        if (f.justify == "+" && f.filler == " ") for(var i = len; i < f.width; i++)buffer += " ";
        if (f.signedconv) {
            if (f.sign < 0) buffer += "-";
            else if (f.signstyle != "-") buffer += f.signstyle;
        }
        if (f.alternate && f.base == 8) buffer += "0";
        if (f.alternate && f.base == 16) buffer += f.uppercase ? "0X" : "0x";
        if (f.justify == "+" && f.filler == "0") for(var i = len; i < f.width; i++)buffer += "0";
        buffer += rawbuffer;
        if (f.justify == "-") for(var i = len; i < f.width; i++)buffer += " ";
        return caml_string_of_jsbytes(buffer);
    }
    function caml_float_compare(x, y) {
        if (x === y) return 0;
        if (x < y) return -1;
        if (x > y) return 1;
        if (x === x) return 1;
        if (y === y) return -1;
        return 0;
    }
    function caml_float_of_bytes(a) {
        return caml_int64_float_of_bits(caml_int64_of_bytes(a));
    }
    function caml_float_of_string(s) {
        var res;
        s = caml_jsbytes_of_string(s);
        res = +s;
        if (s.length > 0 && res === res) return res;
        s = s.replace(/_/g, "");
        res = +s;
        if (s.length > 0 && res === res || /^[+-]?nan$/i.test(s)) return res;
        var m = /^ *([+-]?)0x([0-9a-f]+)\.?([0-9a-f]*)(p([+-]?[0-9]+))?/i.exec(s);
        if (m) {
            var m3 = m[3].replace(/0+$/, ""), mantissa = parseInt(m[1] + m[2] + m3, 16), exponent = (m[5] | 0) - 4 * m3.length;
            res = mantissa * Math.pow(2, exponent);
            return res;
        }
        if (/^\+?inf(inity)?$/i.test(s)) return Infinity;
        if (/^-inf(inity)?$/i.test(s)) return -Infinity;
        caml_failwith("float_of_string");
    }
    function caml_floatarray_blit(a1, i1, a2, i2, len) {
        if (i2 <= i1) for(var j = 1; j <= len; j++)a2[i2 + j] = a1[i1 + j];
        else for(var j = len; j >= 1; j--)a2[i2 + j] = a1[i1 + j];
        return 0;
    }
    function caml_floatarray_create(len) {
        if (len < 0) caml_array_bound_error();
        var len = len + 1 | 0, b = new Array(len);
        b[0] = 254;
        for(var i = 1; i < len; i++)b[i] = 0;
        return b;
    }
    function caml_fma_float(x, y, z) {
        var SPLIT = Math.pow(2, 27) + 1, MIN_VALUE = Math.pow(2, -1022), EPSILON = Math.pow(2, -52), C = 416, A = Math.pow(2, +C), B = Math.pow(2, -C);
        function multiply(a, b) {
            var at = SPLIT * a, ahi = at - (at - a), alo = a - ahi, bt = SPLIT * b, bhi = bt - (bt - b), blo = b - bhi, p = a * b, e = ahi * bhi - p + ahi * blo + alo * bhi + alo * blo;
            return {
                p: p,
                e: e
            };
        }
        function add(a, b) {
            var s = a + b, v = s - a, e = a - (s - v) + (b - v);
            return {
                s: s,
                e: e
            };
        }
        function adjust(x, y) {
            return x !== 0 && y !== 0 && SPLIT * x - (SPLIT * x - x) === x ? x * (1 + (x < 0 ? -1 : 1) * (y < 0 ? -1 : 1) * EPSILON) : x;
        }
        if (x === 0 || x !== x || x === +(1 / 0) || x === -1 / 0 || y === 0 || y !== y || y === +(1 / 0) || y === -1 / 0) return x * y + z;
        if (z === 0) return x * y;
        if (z !== z || z === +(1 / 0) || z === -1 / 0) return z;
        var scale = 1;
        while(Math.abs(x) > A){
            scale *= A;
            x *= B;
        }
        while(Math.abs(y) > A){
            scale *= A;
            y *= B;
        }
        if (scale === 1 / 0) return x * y * scale;
        while(Math.abs(x) < B){
            scale *= B;
            x *= A;
        }
        while(Math.abs(y) < B){
            scale *= B;
            y *= A;
        }
        if (scale === 0) return z;
        var xs = x, ys = y, zs = z / scale;
        if (Math.abs(zs) > Math.abs(xs * ys) * 4 / EPSILON) return z;
        if (Math.abs(zs) < Math.abs(xs * ys) * EPSILON / 4 * EPSILON / 4) zs = (z < 0 ? -1 : 1) * MIN_VALUE;
        var xy = multiply(xs, ys), s = add(xy.p, zs), u = add(xy.e, s.e), i = add(s.s, u.s), f = i.s + adjust(i.e, u.e);
        if (f === 0) return f;
        var fs = f * scale;
        if (Math.abs(fs) > MIN_VALUE) return fs;
        return fs + adjust(f - fs / scale, i.e) * scale;
    }
    function caml_parse_format(fmt) {
        fmt = caml_jsbytes_of_string(fmt);
        var len = fmt.length;
        if (len > 31) caml_invalid_argument("format_int: format too long");
        var f = {
            justify: "+",
            signstyle: "-",
            filler: " ",
            alternate: false,
            base: 0,
            signedconv: false,
            width: 0,
            uppercase: false,
            sign: 1,
            prec: -1,
            conv: "f"
        };
        for(var i = 0; i < len; i++){
            var c = fmt.charAt(i);
            switch(c){
                case "-":
                    f.justify = "-";
                    break;
                case "+":
                case " ":
                    f.signstyle = c;
                    break;
                case "0":
                    f.filler = "0";
                    break;
                case "#":
                    f.alternate = true;
                    break;
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                case "8":
                case "9":
                    f.width = 0;
                    while(c = fmt.charCodeAt(i) - 48, c >= 0 && c <= 9){
                        f.width = f.width * 10 + c;
                        i++;
                    }
                    i--;
                    break;
                case ".":
                    f.prec = 0;
                    i++;
                    while(c = fmt.charCodeAt(i) - 48, c >= 0 && c <= 9){
                        f.prec = f.prec * 10 + c;
                        i++;
                    }
                    i--;
                case "d":
                case "i":
                    f.signedconv = true;
                case "u":
                    f.base = 10;
                    break;
                case "x":
                    f.base = 16;
                    break;
                case "X":
                    f.base = 16;
                    f.uppercase = true;
                    break;
                case "o":
                    f.base = 8;
                    break;
                case "e":
                case "f":
                case "g":
                    f.signedconv = true;
                    f.conv = c;
                    break;
                case "E":
                case "F":
                case "G":
                    f.signedconv = true;
                    f.uppercase = true;
                    f.conv = c.toLowerCase();
                    break;
            }
        }
        return f;
    }
    function caml_format_float(fmt, x) {
        function toFixed(x, dp) {
            if (Math.abs(x) < 1.0) return x.toFixed(dp);
            else {
                var e = parseInt(x.toString().split("+")[1]);
                if (e > 20) {
                    e -= 20;
                    x /= Math.pow(10, e);
                    x += new Array(e + 1).join("0");
                    if (dp > 0) x = x + "." + new Array(dp + 1).join("0");
                    return x;
                } else return x.toFixed(dp);
            }
        }
        var s, f = caml_parse_format(fmt), prec = f.prec < 0 ? 6 : f.prec;
        if (x < 0 || x == 0 && 1 / x == -Infinity) {
            f.sign = -1;
            x = -x;
        }
        if (isNaN(x)) {
            s = "nan";
            f.filler = " ";
        } else if (!isFinite(x)) {
            s = "inf";
            f.filler = " ";
        } else switch(f.conv){
            case "e":
                var s = x.toExponential(prec), i = s.length;
                if (s.charAt(i - 3) == "e") s = s.slice(0, i - 1) + "0" + s.slice(i - 1);
                break;
            case "f":
                s = toFixed(x, prec);
                break;
            case "g":
                prec = prec ? prec : 1;
                s = x.toExponential(prec - 1);
                var j = s.indexOf("e"), exp = +s.slice(j + 1);
                if (exp < -4 || x >= 1e21 || x.toFixed(0).length > prec) {
                    var i = j - 1;
                    while(s.charAt(i) == "0")i--;
                    if (s.charAt(i) == ".") i--;
                    s = s.slice(0, i + 1) + s.slice(j);
                    i = s.length;
                    if (s.charAt(i - 3) == "e") s = s.slice(0, i - 1) + "0" + s.slice(i - 1);
                    break;
                } else {
                    var p = prec;
                    if (exp < 0) {
                        p -= exp + 1;
                        s = x.toFixed(p);
                    } else while(s = x.toFixed(p), s.length > prec + 1)p--;
                    if (p) {
                        var i = s.length - 1;
                        while(s.charAt(i) == "0")i--;
                        if (s.charAt(i) == ".") i--;
                        s = s.slice(0, i + 1);
                    }
                }
                break;
        }
        return caml_finish_formatting(f, s);
    }
    function caml_format_int(fmt, i) {
        if (caml_jsbytes_of_string(fmt) == "%d") return caml_string_of_jsbytes("" + i);
        var f = caml_parse_format(fmt);
        if (i < 0) {
            if (f.signedconv) {
                f.sign = -1;
                i = -i;
            } else i >>>= 0;
        }
        var s = i.toString(f.base);
        if (f.prec >= 0) {
            f.filler = " ";
            var n = f.prec - s.length;
            if (n > 0) s = caml_str_repeat(n, "0") + s;
        }
        return caml_finish_formatting(f, s);
    }
    var caml_oo_last_id = 0;
    function caml_fresh_oo_id() {
        return caml_oo_last_id++;
    }
    function caml_frexp_float(x) {
        if (x == 0 || !isFinite(x)) return [
            0,
            x,
            0
        ];
        var neg = x < 0;
        if (neg) x = -x;
        var exp = Math.max(-1023, jsoo_floor_log2(x) + 1);
        x *= Math.pow(2, -exp);
        while(x < 0.5){
            x *= 2;
            exp--;
        }
        while(x >= 1){
            x *= 0.5;
            exp++;
        }
        if (neg) x = -x;
        return [
            0,
            x,
            exp
        ];
    }
    function jsoo_create_file(name, content) {
        var name = caml_string_of_jsbytes(name), content = caml_string_of_jsbytes(content);
        return caml_create_file(name, content);
    }
    function caml_fs_init() {
        var tmp = globalThis1.caml_fs_tmp;
        if (tmp) for(var i = 0; i < tmp.length; i++)jsoo_create_file(tmp[i].name, tmp[i].content);
        globalThis1.jsoo_create_file = jsoo_create_file;
        globalThis1.caml_fs_tmp = [];
        return 0;
    }
    function caml_gc_compaction() {
        return 0;
    }
    function caml_gc_counters() {
        return [
            254,
            0,
            0,
            0
        ];
    }
    function caml_gc_full_major(unit) {
        if (typeof globalThis1.gc == "function") globalThis1.gc();
        return 0;
    }
    function caml_gc_get() {
        return [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
    }
    function caml_gc_huge_fallback_count(unit) {
        return 0;
    }
    function caml_gc_major(unit) {
        if (typeof globalThis1.gc == "function") globalThis1.gc();
        return 0;
    }
    function caml_gc_major_slice(work) {
        return 0;
    }
    function caml_gc_minor(unit) {
        if (typeof globalThis1.gc == "function") globalThis1.gc(true);
        return 0;
    }
    function caml_gc_minor_words(unit) {
        return 0;
    }
    function caml_gc_quick_stat() {
        return [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
    }
    function caml_gc_set(_control) {
        return 0;
    }
    function caml_gc_stat() {
        return caml_gc_quick_stat();
    }
    function caml_get_continuation_callstack() {
        return [
            0
        ];
    }
    function caml_get_current_callstack() {
        return [
            0
        ];
    }
    function caml_get_exception_backtrace() {
        return 0;
    }
    function caml_get_exception_raw_backtrace() {
        return [
            0
        ];
    }
    function caml_get_global_data() {
        return caml_global_data;
    }
    function caml_get_major_bucket(n) {
        return 0;
    }
    function caml_get_major_credit(n) {
        return 0;
    }
    function caml_get_minor_free(unit) {
        return 0;
    }
    var caml_method_cache = [];
    function caml_get_public_method(obj, tag, cacheid) {
        var meths = obj[1], ofs = caml_method_cache[cacheid];
        if (ofs === undefined) for(var i = caml_method_cache.length; i < cacheid; i++)caml_method_cache[i] = 0;
        else if (meths[ofs] === tag) return meths[ofs - 1];
        var li = 3, hi = meths[1] * 2 + 1, mi;
        while(li < hi){
            mi = li + hi >> 1 | 1;
            if (tag < meths[mi + 1]) hi = mi - 2;
            else li = mi;
        }
        caml_method_cache[cacheid] = li + 1;
        return tag == meths[li + 1] ? meths[li] : 0;
    }
    function caml_gr_arc_aux(ctx, cx, cy, ry, rx, a1, a2) {
        while(a1 > a2)a2 += 360;
        a1 /= 180;
        a2 /= 180;
        var rot = 0, xPos, yPos, xPos_prev, yPos_prev, space = 2, num = (a2 - a1) * Math.PI * ((rx + ry) / 2) / space | 0, delta = (a2 - a1) * Math.PI / num, i = a1 * Math.PI;
        for(var j = 0; j <= num; j++){
            xPos = cx - rx * Math.sin(i) * Math.sin(rot * Math.PI) + ry * Math.cos(i) * Math.cos(rot * Math.PI);
            xPos = xPos.toFixed(2);
            yPos = cy + ry * Math.cos(i) * Math.sin(rot * Math.PI) + rx * Math.sin(i) * Math.cos(rot * Math.PI);
            yPos = yPos.toFixed(2);
            if (j == 0) ctx.moveTo(xPos, yPos);
            else if (xPos_prev != xPos || yPos_prev != yPos) ctx.lineTo(xPos, yPos);
            xPos_prev = xPos;
            yPos_prev = yPos;
            i -= delta;
        }
        return 0;
    }
    var caml_gr_state;
    function caml_gr_state_get() {
        if (caml_gr_state) return caml_gr_state;
        throw caml_maybe_attach_backtrace([
            0,
            caml_named_value("Graphics.Graphic_failure"),
            caml_string_of_jsbytes("Not initialized")
        ]);
    }
    function caml_gr_blit_image(im, x, y) {
        var s = caml_gr_state_get(), im2 = s.context.getImageData(x, s.height - im.height - y, im.width, im.height);
        for(var i = 0; i < im2.data.length; i += 4){
            im.data[i] = im2.data[i];
            im.data[i + 1] = im2.data[i + 1];
            im.data[i + 2] = im2.data[i + 2];
            im.data[i + 3] = im2.data[i + 3];
        }
        return 0;
    }
    function caml_gr_clear_graph() {
        var s = caml_gr_state_get();
        s.canvas.width = s.width;
        s.canvas.height = s.height;
        return 0;
    }
    function caml_gr_close_graph() {
        var s = caml_gr_state_get();
        s.canvas.width = 0;
        s.canvas.height = 0;
        return 0;
    }
    function caml_gr_close_subwindow(a) {
        caml_failwith("caml_gr_close_subwindow not Implemented");
    }
    function caml_gr_create_image(x, y) {
        var s = caml_gr_state_get();
        return s.context.createImageData(x, y);
    }
    function caml_gr_current_x() {
        var s = caml_gr_state_get();
        return s.x;
    }
    function caml_gr_current_y() {
        var s = caml_gr_state_get();
        return s.y;
    }
    function caml_gr_display_mode() {
        caml_failwith("caml_gr_display_mode not Implemented");
    }
    function caml_gr_doc_of_state(state) {
        if (state.canvas.ownerDocument) return state.canvas.ownerDocument;
    }
    function caml_gr_draw_arc(x, y, rx, ry, a1, a2) {
        var s = caml_gr_state_get();
        s.context.beginPath();
        caml_gr_arc_aux(s.context, x, s.height - y, rx, ry, a1, a2);
        s.context.stroke();
        return 0;
    }
    function caml_gr_draw_str(str) {
        var s = caml_gr_state_get(), m = s.context.measureText(str), dx = m.width;
        s.context.fillText(str, s.x, s.height - s.y);
        s.x += dx | 0;
        return 0;
    }
    function caml_gr_draw_char(c) {
        caml_gr_draw_str(String.fromCharCode(c));
        return 0;
    }
    function caml_gr_draw_image(im, x, y) {
        var s = caml_gr_state_get();
        if (!im.image) {
            var canvas = document.createElement("canvas");
            canvas.width = s.width;
            canvas.height = s.height;
            canvas.getContext("2d").putImageData(im, 0, 0);
            var image = new globalThis1.Image();
            image.onload = function() {
                s.context.drawImage(image, x, s.height - im.height - y);
                im.image = image;
            };
            image.src = canvas.toDataURL("image/png");
        } else s.context.drawImage(im.image, x, s.height - im.height - y);
        return 0;
    }
    function caml_gr_draw_rect(x, y, w, h) {
        var s = caml_gr_state_get();
        s.context.strokeRect(x, s.height - y, w, -h);
        return 0;
    }
    function caml_gr_draw_string(str) {
        caml_gr_draw_str(caml_jsstring_of_string(str));
        return 0;
    }
    function caml_gr_dump_image(im) {
        var data = [
            0
        ];
        for(var i = 0; i < im.height; i++){
            data[i + 1] = [
                0
            ];
            for(var j = 0; j < im.width; j++){
                var o = i * (im.width * 4) + j * 4, r = im.data[o + 0], g = im.data[o + 1], b = im.data[o + 2];
                data[i + 1][j + 1] = (r << 16) + (g << 8) + b;
            }
        }
        return data;
    }
    function caml_gr_fill_arc(x, y, rx, ry, a1, a2) {
        var s = caml_gr_state_get();
        s.context.beginPath();
        caml_gr_arc_aux(s.context, x, s.height - y, rx, ry, a1, a2);
        s.context.fill();
        return 0;
    }
    function caml_gr_fill_poly(ar) {
        var s = caml_gr_state_get();
        s.context.beginPath();
        s.context.moveTo(ar[1][1], s.height - ar[1][2]);
        for(var i = 2; i < ar.length; i++)s.context.lineTo(ar[i][1], s.height - ar[i][2]);
        s.context.lineTo(ar[1][1], s.height - ar[1][2]);
        s.context.fill();
        return 0;
    }
    function caml_gr_fill_rect(x, y, w, h) {
        var s = caml_gr_state_get();
        s.context.fillRect(x, s.height - y, w, -h);
        return 0;
    }
    function caml_gr_lineto(x, y) {
        var s = caml_gr_state_get();
        s.context.beginPath();
        s.context.moveTo(s.x, s.height - s.y);
        s.context.lineTo(x, s.height - y);
        s.context.stroke();
        s.x = x;
        s.y = y;
        return 0;
    }
    function caml_gr_make_image(arr) {
        var s = caml_gr_state_get(), h = arr.length - 1, w = arr[1].length - 1, im = s.context.createImageData(w, h);
        for(var i = 0; i < h; i++)for(var j = 0; j < w; j++){
            var c = arr[i + 1][j + 1], o = i * (w * 4) + j * 4;
            if (c == -1) {
                im.data[o + 0] = 0;
                im.data[o + 1] = 0;
                im.data[o + 2] = 0;
                im.data[o + 3] = 0;
            } else {
                im.data[o + 0] = c >> 16 & 0xff;
                im.data[o + 1] = c >> 8 & 0xff;
                im.data[o + 2] = c >> 0 & 0Xff;
                im.data[o + 3] = 0xff;
            }
        }
        return im;
    }
    function caml_gr_moveto(x, y) {
        var s = caml_gr_state_get();
        s.x = x;
        s.y = y;
        return 0;
    }
    function caml_gr_set_window_title(name) {
        var s = caml_gr_state_get();
        s.title = name;
        var jsname = caml_jsstring_of_string(name);
        if (s.set_title) s.set_title(jsname);
        return 0;
    }
    function caml_gr_set_line_width(w) {
        var s = caml_gr_state_get();
        s.line_width = w;
        s.context.lineWidth = w;
        return 0;
    }
    function caml_gr_set_text_size(size) {
        var s = caml_gr_state_get();
        s.text_size = size;
        s.context.font = s.text_size + "px " + caml_jsstring_of_string(s.font);
        return 0;
    }
    function caml_gr_set_font(f) {
        var s = caml_gr_state_get();
        s.font = f;
        s.context.font = s.text_size + "px " + caml_jsstring_of_string(s.font);
        return 0;
    }
    function caml_gr_set_color(color) {
        var s = caml_gr_state_get();
        function convert(number) {
            var str = "" + number.toString(16);
            while(str.length < 2)str = "0" + str;
            return str;
        }
        var r = color >> 16 & 0xff, g = color >> 8 & 0xff, b = color >> 0 & 0xff;
        s.color = color;
        var c_str = "#" + convert(r) + convert(g) + convert(b);
        s.context.fillStyle = c_str;
        s.context.strokeStyle = c_str;
        return 0;
    }
    function caml_gr_resize_window(w, h) {
        var s = caml_gr_state_get();
        s.width = w;
        s.height = h;
        s.canvas.width = w;
        s.canvas.height = h;
        return 0;
    }
    function caml_gr_state_init() {
        caml_gr_moveto(caml_gr_state.x, caml_gr_state.y);
        caml_gr_resize_window(caml_gr_state.width, caml_gr_state.height);
        caml_gr_set_line_width(caml_gr_state.line_width);
        caml_gr_set_text_size(caml_gr_state.text_size);
        caml_gr_set_font(caml_gr_state.font);
        caml_gr_set_color(caml_gr_state.color);
        caml_gr_set_window_title(caml_gr_state.title);
        caml_gr_state.context.textBaseline = "bottom";
    }
    function caml_gr_state_set(ctx) {
        caml_gr_state = ctx;
        caml_gr_state_init();
        return 0;
    }
    function caml_gr_state_create(canvas, w, h) {
        var context = canvas.getContext("2d");
        return {
            context: context,
            canvas: canvas,
            x: 0,
            y: 0,
            width: w,
            height: h,
            line_width: 1,
            font: caml_string_of_jsbytes("fixed"),
            text_size: 26,
            color: 0x000000,
            title: caml_string_of_jsbytes("")
        };
    }
    function caml_gr_open_graph(info) {
        var info = caml_jsstring_of_string(info);
        function get(name) {
            var res = info.match("(^|,) *" + name + " *= *([a-zA-Z0-9_]+) *(,|$)");
            if (res) return res[2];
        }
        var specs = [];
        if (!(info == "")) specs.push(info);
        var target = get("target");
        if (!target) target = "";
        var status = get("status");
        if (!status) specs.push("status=1");
        var w = get("width");
        w = w ? parseInt(w) : 200;
        specs.push("width=" + w);
        var h = get("height");
        h = h ? parseInt(h) : 200;
        specs.push("height=" + h);
        var win = globalThis1.open("about:blank", target, specs.join(","));
        if (!win) caml_failwith("Graphics.open_graph: cannot open the window");
        var doc = win.document, canvas = doc.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        var ctx = caml_gr_state_create(canvas, w, h);
        ctx.set_title = function(title) {
            doc.title = title;
        };
        caml_gr_state_set(ctx);
        var body = doc.body;
        body.style.margin = "0px";
        body.appendChild(canvas);
        return 0;
    }
    function caml_gr_open_subwindow(a, b, c, d) {
        caml_failwith("caml_gr_open_subwindow not Implemented");
    }
    function caml_gr_plot(x, y) {
        var s = caml_gr_state_get(), im = s.context.createImageData(1, 1), d = im.data, color = s.color;
        d[0] = color >> 16 & 0xff;
        d[1] = color >> 8 & 0xff, d[2] = color >> 0 & 0xff;
        d[3] = 0xFF;
        s.x = x;
        s.y = y;
        s.context.putImageData(im, x, s.height - y);
        return 0;
    }
    function caml_gr_point_color(x, y) {
        var s = caml_gr_state_get(), im = s.context.getImageData(x, s.height - y, 1, 1), d = im.data;
        return (d[0] << 16) + (d[1] << 8) + d[2];
    }
    function caml_gr_remember_mode() {
        caml_failwith("caml_gr_remember_mode not Implemented");
    }
    function caml_gr_sigio_handler() {
        return 0;
    }
    function caml_gr_sigio_signal() {
        return 0;
    }
    function caml_gr_size_x() {
        var s = caml_gr_state_get();
        return s.width;
    }
    function caml_gr_size_y() {
        var s = caml_gr_state_get();
        return s.height;
    }
    function caml_gr_synchronize() {
        caml_failwith("caml_gr_synchronize not Implemented");
    }
    function caml_gr_text_size(txt) {
        var s = caml_gr_state_get(), w = s.context.measureText(caml_jsstring_of_string(txt)).width;
        return [
            0,
            w,
            s.text_size
        ];
    }
    function caml_gr_wait_event(_evl) {
        caml_failwith("caml_gr_wait_event not Implemented: use Graphics_js instead");
    }
    function caml_gr_window_id(a) {
        caml_failwith("caml_gr_window_id not Implemented");
    }
    function caml_greaterequal(x, y) {
        return +(caml_compare_val(x, y, false) >= 0);
    }
    function caml_greaterthan(x, y) {
        return +(caml_compare_val(x, y, false) > 0);
    }
    function caml_hash_mix_bigstring(h, bs) {
        return caml_hash_mix_bytes_arr(h, bs.data);
    }
    function num_digits_nat(nat, ofs, len) {
        for(var i = len - 1; i >= 0; i--)if (nat.data[ofs + i] != 0) return i + 1;
        return 1;
    }
    function caml_hash_nat(x) {
        var len = num_digits_nat(x, 0, x.data.length), h = 0;
        for(var i = 0; i < len; i++)h = caml_hash_mix_int(h, x.data[i]);
        return h;
    }
    function caml_hexstring_of_float(x, prec, style) {
        if (!isFinite(x)) {
            if (isNaN(x)) return caml_string_of_jsstring("nan");
            return caml_string_of_jsstring(x > 0 ? "infinity" : "-infinity");
        }
        var sign = x == 0 && 1 / x == -Infinity ? 1 : x >= 0 ? 0 : 1;
        if (sign) x = -x;
        var exp = 0;
        if (x == 0) ;
        else if (x < 1) while(x < 1 && exp > -1022){
            x *= 2;
            exp--;
        }
        else while(x >= 2){
            x /= 2;
            exp++;
        }
        var exp_sign = exp < 0 ? "" : "+", sign_str = "";
        if (sign) sign_str = "-";
        else switch(style){
            case 43:
                sign_str = "+";
                break;
            case 32:
                sign_str = " ";
                break;
            default:
                break;
        }
        if (prec >= 0 && prec < 13) {
            var cst = Math.pow(2, prec * 4);
            x = Math.round(x * cst) / cst;
        }
        var x_str = x.toString(16);
        if (prec >= 0) {
            var idx = x_str.indexOf(".");
            if (idx < 0) x_str += "." + caml_str_repeat(prec, "0");
            else {
                var size = idx + 1 + prec;
                if (x_str.length < size) x_str += caml_str_repeat(size - x_str.length, "0");
                else x_str = x_str.substr(0, size);
            }
        }
        return caml_string_of_jsstring(sign_str + "0x" + x_str + "p" + exp_sign + exp.toString(10));
    }
    function caml_hypot_float(x, y) {
        return Math.hypot(x, y);
    }
    var caml_marshal_header_size = 16;
    function caml_refill(chan) {
        if (chan.refill != null) {
            var str = chan.refill(), str_a = caml_uint8_array_of_string(str);
            if (str_a.length == 0) chan.refill = null;
            else {
                if (chan.buffer.length < chan.buffer_max + str_a.length) {
                    var b = new Uint8Array(chan.buffer_max + str_a.length);
                    b.set(chan.buffer);
                    chan.buffer = b;
                }
                chan.buffer.set(str_a, chan.buffer_max);
                chan.offset += str_a.length;
                chan.buffer_max += str_a.length;
            }
        } else {
            var nread = chan.file.read(chan.offset, chan.buffer, chan.buffer_max, chan.buffer.length - chan.buffer_max);
            chan.offset += nread;
            chan.buffer_max += nread;
        }
    }
    function caml_raise_end_of_file() {
        caml_raise_constant(caml_global_data.End_of_file);
    }
    function caml_marshal_data_size(s, ofs) {
        var r = new UInt8ArrayReader(caml_uint8_array_of_bytes(s), ofs);
        function readvlq(overflow) {
            var c = r.read8u(), n = c & 0x7F;
            while((c & 0x80) != 0){
                c = r.read8u();
                var n7 = n << 7;
                if (n != n7 >> 7) overflow[0] = true;
                n = n7 | c & 0x7F;
            }
            return n;
        }
        switch(r.read32u()){
            case 0x8495A6BE:
                var header_len = 20, data_len = r.read32u();
                break;
            case 0x8495A6BD:
                var header_len = r.read8u() & 0x3F, overflow = [
                    false
                ], data_len = readvlq(overflow);
                if (overflow[0]) caml_failwith("Marshal.data_size: object too large to be read back on this platform");
                break;
            case 0x8495A6BF:
            default:
                caml_failwith("Marshal.data_size: bad object");
                break;
        }
        return header_len - caml_marshal_header_size + data_len;
    }
    function caml_input_value_from_reader(reader, ofs) {
        function readvlq(overflow) {
            var c = reader.read8u(), n = c & 0x7F;
            while((c & 0x80) != 0){
                c = reader.read8u();
                var n7 = n << 7;
                if (n != n7 >> 7) overflow[0] = true;
                n = n7 | c & 0x7F;
            }
            return n;
        }
        var magic = reader.read32u();
        switch(magic){
            case 0x8495A6BE:
                var header_len = 20, compressed = 0, data_len = reader.read32u(), uncompressed_data_len = data_len, num_objects = reader.read32u(), _size_32 = reader.read32u(), _size_64 = reader.read32u();
                break;
            case 0x8495A6BD:
                var header_len = reader.read8u() & 0x3F, compressed = 1, overflow = [
                    false
                ], data_len = readvlq(overflow), uncompressed_data_len = readvlq(overflow), num_objects = readvlq(overflow), _size_32 = readvlq(overflow), _size_64 = readvlq(overflow);
                if (overflow[0]) caml_failwith("caml_input_value_from_reader: object too large to be read back on this platform");
                break;
            case 0x8495A6BF:
                caml_failwith("caml_input_value_from_reader: object too large to be read back on a 32-bit platform");
                break;
            default:
                caml_failwith("caml_input_value_from_reader: bad object");
                break;
        }
        var stack = [], intern_obj_table = num_objects > 0 ? [] : null, obj_counter = 0;
        function intern_rec(reader) {
            var code = reader.read8u();
            if (code >= 0x40) {
                if (code >= 0x80) {
                    var tag = code & 0xF, size = code >> 4 & 0x7, v = [
                        tag
                    ];
                    if (size == 0) return v;
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    stack.push(v, size);
                    return v;
                } else return code & 0x3F;
            } else if (code >= 0x20) {
                var len = code & 0x1F, v = reader.readstr(len);
                if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                return v;
            } else switch(code){
                case 0x00:
                    return reader.read8s();
                case 0x01:
                    return reader.read16s();
                case 0x02:
                    return reader.read32s();
                case 0x03:
                    caml_failwith("input_value: integer too large");
                    break;
                case 0x04:
                    var offset = reader.read8u();
                    if (compressed == 0) offset = obj_counter - offset;
                    return intern_obj_table[offset];
                case 0x05:
                    var offset = reader.read16u();
                    if (compressed == 0) offset = obj_counter - offset;
                    return intern_obj_table[offset];
                case 0x06:
                    var offset = reader.read32u();
                    if (compressed == 0) offset = obj_counter - offset;
                    return intern_obj_table[offset];
                case 0x08:
                    var header = reader.read32u(), tag = header & 0xFF, size = header >> 10, v = [
                        tag
                    ];
                    if (size == 0) return v;
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    stack.push(v, size);
                    return v;
                case 0x13:
                    caml_failwith("input_value: data block too large");
                    break;
                case 0x09:
                    var len = reader.read8u(), v = reader.readstr(len);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    return v;
                case 0x0A:
                    var len = reader.read32u(), v = reader.readstr(len);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    return v;
                case 0x0C:
                    var t = new Array(8);
                    for(var i = 0; i < 8; i++)t[7 - i] = reader.read8u();
                    var v = caml_float_of_bytes(t);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    return v;
                case 0x0B:
                    var t = new Array(8);
                    for(var i = 0; i < 8; i++)t[i] = reader.read8u();
                    var v = caml_float_of_bytes(t);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    return v;
                case 0x0E:
                    var len = reader.read8u(), v = new Array(len + 1);
                    v[0] = 254;
                    var t = new Array(8);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    for(var i = 1; i <= len; i++){
                        for(var j = 0; j < 8; j++)t[7 - j] = reader.read8u();
                        v[i] = caml_float_of_bytes(t);
                    }
                    return v;
                case 0x0D:
                    var len = reader.read8u(), v = new Array(len + 1);
                    v[0] = 254;
                    var t = new Array(8);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    for(var i = 1; i <= len; i++){
                        for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                        v[i] = caml_float_of_bytes(t);
                    }
                    return v;
                case 0x07:
                    var len = reader.read32u(), v = new Array(len + 1);
                    v[0] = 254;
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    var t = new Array(8);
                    for(var i = 1; i <= len; i++){
                        for(var j = 0; j < 8; j++)t[7 - j] = reader.read8u();
                        v[i] = caml_float_of_bytes(t);
                    }
                    return v;
                case 0x0F:
                    var len = reader.read32u(), v = new Array(len + 1);
                    v[0] = 254;
                    var t = new Array(8);
                    for(var i = 1; i <= len; i++){
                        for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                        v[i] = caml_float_of_bytes(t);
                    }
                    return v;
                case 0x10:
                case 0x11:
                    caml_failwith("input_value: code pointer");
                    break;
                case 0x12:
                case 0x18:
                case 0x19:
                    var c, s = "";
                    while((c = reader.read8u()) != 0)s += String.fromCharCode(c);
                    var ops = caml_custom_ops[s], expected_size;
                    if (!ops) caml_failwith("input_value: unknown custom block identifier");
                    switch(code){
                        case 0x12:
                            break;
                        case 0x19:
                            if (!ops.fixed_length) caml_failwith("input_value: expected a fixed-size custom block");
                            expected_size = ops.fixed_length;
                            break;
                        case 0x18:
                            expected_size = reader.read32u();
                            reader.read32s();
                            reader.read32s();
                            break;
                    }
                    var old_pos = reader.i, size = [
                        0
                    ], v = ops.deserialize(reader, size);
                    if (expected_size != undefined) {
                        if (expected_size != size[0]) caml_failwith("input_value: incorrect length of serialized custom block");
                    }
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    return v;
                default:
                    caml_failwith("input_value: ill-formed message");
            }
        }
        if (compressed) {
            if (caml_decompress_input) var data = reader.readuint8array(data_len), res = new Uint8Array(uncompressed_data_len), res = caml_decompress_input(data, res), reader = new UInt8ArrayReader(res, 0);
            else caml_failwith("input_value: compressed object, cannot decompress");
        }
        var res = intern_rec(reader);
        while(stack.length > 0){
            var size = stack.pop(), v = stack.pop(), d = v.length;
            if (d < size) stack.push(v, size);
            v[d] = intern_rec(reader);
        }
        if (typeof ofs != "number") ofs[0] = reader.i;
        return res;
    }
    function caml_string_of_bytes(s) {
        s.t & 6 && caml_convert_string_to_bytes(s);
        return caml_string_of_jsbytes(s.c);
    }
    function caml_input_value_from_bytes(s, ofs) {
        var reader = new MlStringReader(caml_string_of_bytes(s), typeof ofs == "number" ? ofs : ofs[0]);
        return caml_input_value_from_reader(reader, ofs);
    }
    function caml_input_value(chanid) {
        var chan = caml_ml_channel_get(chanid), header = new Uint8Array(caml_marshal_header_size);
        function block(buffer, offset, n) {
            var r = 0;
            while(r < n){
                if (chan.buffer_curr >= chan.buffer_max) {
                    chan.buffer_curr = 0;
                    chan.buffer_max = 0;
                    caml_refill(chan);
                }
                if (chan.buffer_curr >= chan.buffer_max) break;
                buffer[offset + r] = chan.buffer[chan.buffer_curr];
                chan.buffer_curr++;
                r++;
            }
            return r;
        }
        var r = block(header, 0, caml_marshal_header_size);
        if (r == 0) caml_raise_end_of_file();
        else if (r < caml_marshal_header_size) caml_failwith("input_value: truncated object");
        var len = caml_marshal_data_size(caml_bytes_of_array(header), 0), buf = new Uint8Array(len + caml_marshal_header_size);
        buf.set(header, 0);
        var r = block(buf, caml_marshal_header_size, len);
        if (r < len) caml_failwith("input_value: truncated object " + r + "  " + len);
        var offset = [
            0
        ], res = caml_input_value_from_bytes(caml_bytes_of_array(buf), offset);
        chan.offset = chan.offset + offset[0];
        return res;
    }
    function caml_input_value_from_string(s, ofs) {
        var reader = new MlStringReader(s, typeof ofs == "number" ? ofs : ofs[0]);
        return caml_input_value_from_reader(reader, ofs);
    }
    function caml_input_value_to_outside_heap(c) {
        return caml_input_value(c);
    }
    function caml_install_signal_handler() {
        return 0;
    }
    function caml_int32_bswap(x) {
        return (x & 0x000000FF) << 24 | (x & 0x0000FF00) << 8 | (x & 0x00FF0000) >>> 8 | (x & 0xFF000000) >>> 24;
    }
    function caml_int64_add(x, y) {
        return x.add(y);
    }
    function caml_int64_bswap(x) {
        var y = caml_int64_to_bytes(x);
        return caml_int64_of_bytes([
            y[7],
            y[6],
            y[5],
            y[4],
            y[3],
            y[2],
            y[1],
            y[0]
        ]);
    }
    function caml_int64_div(x, y) {
        return x.div(y);
    }
    function caml_int64_is_negative(x) {
        return +x.isNeg();
    }
    function caml_int64_neg(x) {
        return x.neg();
    }
    function caml_int64_format(fmt, x) {
        var f = caml_parse_format(fmt);
        if (f.signedconv && caml_int64_is_negative(x)) {
            f.sign = -1;
            x = caml_int64_neg(x);
        }
        var buffer = "", wbase = caml_int64_of_int32(f.base), cvtbl = "0123456789abcdef";
        do {
            var p = x.udivmod(wbase);
            x = p.quotient;
            buffer = cvtbl.charAt(caml_int64_to_int32(p.modulus)) + buffer;
        }while (!caml_int64_is_zero(x));
        if (f.prec >= 0) {
            f.filler = " ";
            var n = f.prec - buffer.length;
            if (n > 0) buffer = caml_str_repeat(n, "0") + buffer;
        }
        return caml_finish_formatting(f, buffer);
    }
    function caml_int64_mod(x, y) {
        return x.mod(y);
    }
    function caml_int64_of_float(x) {
        if (x < 0) x = Math.ceil(x);
        return new MlInt64(x & 0xffffff, Math.floor(x * caml_int64_offset) & 0xffffff, Math.floor(x * caml_int64_offset * caml_int64_offset) & 0xffff);
    }
    function caml_int64_ult(x, y) {
        return x.ucompare(y) < 0;
    }
    function caml_parse_sign_and_base(s) {
        var i = 0, len = caml_ml_string_length(s), base = 10, sign = 1;
        if (len > 0) switch(caml_string_unsafe_get(s, i)){
            case 45:
                i++;
                sign = -1;
                break;
            case 43:
                i++;
                sign = 1;
                break;
        }
        if (i + 1 < len && caml_string_unsafe_get(s, i) == 48) switch(caml_string_unsafe_get(s, i + 1)){
            case 120:
            case 88:
                base = 16;
                i += 2;
                break;
            case 111:
            case 79:
                base = 8;
                i += 2;
                break;
            case 98:
            case 66:
                base = 2;
                i += 2;
                break;
            case 117:
            case 85:
                i += 2;
                break;
        }
        return [
            i,
            sign,
            base
        ];
    }
    function caml_parse_digit(c) {
        if (c >= 48 && c <= 57) return c - 48;
        if (c >= 65 && c <= 90) return c - 55;
        if (c >= 97 && c <= 122) return c - 87;
        return -1;
    }
    function caml_int64_of_string(s) {
        var r = caml_parse_sign_and_base(s), i = r[0], sign = r[1], base = r[2], base64 = caml_int64_of_int32(base), threshold = new MlInt64(0xffffff, 0xfffffff, 0xffff).udivmod(base64).quotient, c = caml_string_unsafe_get(s, i), d = caml_parse_digit(c);
        if (d < 0 || d >= base) caml_failwith("int_of_string");
        var res = caml_int64_of_int32(d);
        for(;;){
            i++;
            c = caml_string_unsafe_get(s, i);
            if (c == 95) continue;
            d = caml_parse_digit(c);
            if (d < 0 || d >= base) break;
            if (caml_int64_ult(threshold, res)) caml_failwith("int_of_string");
            d = caml_int64_of_int32(d);
            res = caml_int64_add(caml_int64_mul(base64, res), d);
            if (caml_int64_ult(res, d)) caml_failwith("int_of_string");
        }
        if (i != caml_ml_string_length(s)) caml_failwith("int_of_string");
        if (base == 10 && caml_int64_ult(new MlInt64(0, 0, 0x8000), res)) caml_failwith("int_of_string");
        if (sign < 0) res = caml_int64_neg(res);
        return res;
    }
    function caml_int64_or(x, y) {
        return x.or(y);
    }
    function caml_int64_shift_left(x, s) {
        return x.shift_left(s);
    }
    function caml_int64_shift_right(x, s) {
        return x.shift_right(s);
    }
    function caml_int64_sub(x, y) {
        return x.sub(y);
    }
    function caml_int64_to_float(x) {
        return x.toFloat();
    }
    function caml_int64_xor(x, y) {
        return x.xor(y);
    }
    function caml_int_of_string(s) {
        var r = caml_parse_sign_and_base(s), i = r[0], sign = r[1], base = r[2], len = caml_ml_string_length(s), threshold = 4294967295, c = i < len ? caml_string_unsafe_get(s, i) : 0, d = caml_parse_digit(c);
        if (d < 0 || d >= base) caml_failwith("int_of_string");
        var res = d;
        for(i++; i < len; i++){
            c = caml_string_unsafe_get(s, i);
            if (c == 95) continue;
            d = caml_parse_digit(c);
            if (d < 0 || d >= base) break;
            res = base * res + d;
            if (res > threshold) caml_failwith("int_of_string");
        }
        if (i != len) caml_failwith("int_of_string");
        res = sign * res;
        if (base == 10 && (res | 0) != res) caml_failwith("int_of_string");
        return res | 0;
    }
    function caml_is_js() {
        return 1;
    }
    function caml_is_printable(c) {
        return +(c > 31 && c < 127);
    }
    function caml_js_call(f, o, args) {
        return f.apply(o, caml_js_from_array(args));
    }
    function caml_js_delete(o, f) {
        delete o[f];
        return 0;
    }
    function caml_js_equals(x, y) {
        return +(x == y);
    }
    function caml_js_error_of_exception(exn) {
        if (exn.js_error) return exn.js_error;
        return null;
    }
    function caml_js_error_option_of_exception(exn) {
        if (exn.js_error) return [
            0,
            exn.js_error
        ];
        return 0;
    }
    function caml_js_eval_string(s) {
        return eval(caml_jsstring_of_string(s));
    }
    function caml_js_expr(s) {
        console.error("caml_js_expr: fallback to runtime evaluation\n");
        return eval(caml_jsstring_of_string(s));
    }
    function caml_js_from_bool(x) {
        return !!x;
    }
    function caml_js_from_float(x) {
        return x;
    }
    function caml_js_from_string(s) {
        return caml_jsstring_of_string(s);
    }
    function caml_js_fun_call(f, a) {
        switch(a.length){
            case 1:
                return f();
            case 2:
                return f(a[1]);
            case 3:
                return f(a[1], a[2]);
            case 4:
                return f(a[1], a[2], a[3]);
            case 5:
                return f(a[1], a[2], a[3], a[4]);
            case 6:
                return f(a[1], a[2], a[3], a[4], a[5]);
            case 7:
                return f(a[1], a[2], a[3], a[4], a[5], a[6]);
            case 8:
                return f(a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
        }
        return f.apply(null, caml_js_from_array(a));
    }
    function caml_js_function_arity(f) {
        return f.l >= 0 ? f.l : f.l = f.length;
    }
    function caml_js_get(o, f) {
        return o[f];
    }
    function caml_js_get_console() {
        var c = console, m = [
            "log",
            "debug",
            "info",
            "warn",
            "error",
            "assert",
            "dir",
            "dirxml",
            "trace",
            "group",
            "groupCollapsed",
            "groupEnd",
            "time",
            "timeEnd"
        ];
        function f() {}
        for(var i = 0; i < m.length; i++)if (!c[m[i]]) c[m[i]] = f;
        return c;
    }
    function caml_js_html_entities(s) {
        var entity = /^&#?[0-9a-zA-Z]+;$/;
        if (s.match(entity)) {
            var str, temp = document.createElement("p");
            temp.innerHTML = s;
            str = temp.textContent || temp.innerText;
            temp = null;
            return str;
        } else caml_failwith("Invalid entity " + s);
    }
    var caml_js_regexps = {
        amp: /&/g,
        lt: /</g,
        quot: /\"/g,
        all: /[&<\"]/
    };
    function caml_js_html_escape(s) {
        if (!caml_js_regexps.all.test(s)) return s;
        return s.replace(caml_js_regexps.amp, "&amp;").replace(caml_js_regexps.lt, "&lt;").replace(caml_js_regexps.quot, "&quot;");
    }
    function caml_js_instanceof(o, c) {
        return o instanceof c ? 1 : 0;
    }
    function caml_js_meth_call(o, f, args) {
        return o[caml_jsstring_of_string(f)].apply(o, caml_js_from_array(args));
    }
    function caml_js_new(c, a) {
        switch(a.length){
            case 1:
                return new c;
            case 2:
                return new c(a[1]);
            case 3:
                return new c(a[1], a[2]);
            case 4:
                return new c(a[1], a[2], a[3]);
            case 5:
                return new c(a[1], a[2], a[3], a[4]);
            case 6:
                return new c(a[1], a[2], a[3], a[4], a[5]);
            case 7:
                return new c(a[1], a[2], a[3], a[4], a[5], a[6]);
            case 8:
                return new c(a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
        }
        function F() {
            return c.apply(this, caml_js_from_array(a));
        }
        F.prototype = c.prototype;
        return new F;
    }
    function caml_js_object(a) {
        var o = {};
        for(var i = 1; i < a.length; i++){
            var p = a[i];
            o[caml_jsstring_of_string(p[1])] = p[2];
        }
        return o;
    }
    function caml_js_on_ie() {
        var ua = globalThis1.navigator && globalThis1.navigator.userAgent ? globalThis1.navigator.userAgent : "";
        return ua.indexOf("MSIE") != -1 && ua.indexOf("Opera") != 0;
    }
    function caml_js_pure_expr(f) {
        return caml_callback(f, [
            0
        ]);
    }
    function caml_js_set(o, f, v) {
        o[f] = v;
        return 0;
    }
    function caml_js_strict_equals(x, y) {
        return +(x === y);
    }
    function caml_js_to_array(a) {
        var len = a.length, b = new Array(len + 1);
        b[0] = 0;
        for(var i = 0; i < len; i++)b[i + 1] = a[i];
        return b;
    }
    function caml_js_to_bool(x) {
        return +x;
    }
    function caml_js_to_byte_string(s) {
        return caml_string_of_jsbytes(s);
    }
    function caml_js_to_float(x) {
        return x;
    }
    function caml_js_to_int32(x) {
        return x | 0;
    }
    function caml_js_to_string(s) {
        return caml_string_of_jsstring(s);
    }
    function caml_js_typeof(o) {
        return typeof o;
    }
    function caml_js_var(x) {
        var x = caml_jsstring_of_string(x);
        if (!x.match(/^[a-zA-Z_$][a-zA-Z_$0-9]*(\.[a-zA-Z_$][a-zA-Z_$0-9]*)*$/)) console.error('caml_js_var: "' + x + '" is not a valid JavaScript variable. continuing ..');
        return eval(x);
    }
    function caml_js_wrap_callback(f) {
        return function() {
            var len = arguments.length;
            if (len > 0) {
                var args = new Array(len);
                for(var i = 0; i < len; i++)args[i] = arguments[i];
            } else args = [
                undefined
            ];
            var res = caml_callback(f, args);
            return res instanceof Function ? caml_js_wrap_callback(res) : res;
        };
    }
    function caml_js_wrap_callback_arguments(f) {
        return function() {
            var len = arguments.length, args = new Array(len);
            for(var i = 0; i < len; i++)args[i] = arguments[i];
            return caml_callback(f, [
                args
            ]);
        };
    }
    function caml_js_wrap_callback_strict(arity, f) {
        return function() {
            var n = arguments.length, args = new Array(arity), len = Math.min(arguments.length, arity);
            for(var i = 0; i < len; i++)args[i] = arguments[i];
            return caml_callback(f, args);
        };
    }
    function caml_js_wrap_callback_unsafe(f) {
        return function() {
            var len = caml_js_function_arity(f), args = new Array(len);
            for(var i = 0; i < len; i++)args[i] = arguments[i];
            return caml_callback(f, args);
        };
    }
    function caml_js_wrap_meth_callback(f) {
        return function() {
            var len = arguments.length, args = new Array(len + 1);
            args[0] = this;
            for(var i = 0; i < len; i++)args[i + 1] = arguments[i];
            var res = caml_callback(f, args);
            return res instanceof Function ? caml_js_wrap_callback(res) : res;
        };
    }
    function caml_js_wrap_meth_callback_arguments(f) {
        return function() {
            var len = arguments.length, args = new Array(len);
            for(var i = 0; i < len; i++)args[i] = arguments[i];
            return caml_callback(f, [
                this,
                args
            ]);
        };
    }
    function caml_js_wrap_meth_callback_strict(arity, f) {
        return function() {
            var args = new Array(arity + 1), len = Math.min(arguments.length, arity);
            args[0] = this;
            for(var i = 0; i < len; i++)args[i + 1] = arguments[i];
            return caml_callback(f, args);
        };
    }
    function caml_js_wrap_meth_callback_unsafe(f) {
        return function() {
            var len = caml_js_function_arity(f) - 1, args = new Array(len + 1);
            args[0] = this;
            for(var i = 0; i < len; i++)args[i + 1] = arguments[i];
            return caml_callback(f, args);
        };
    }
    function caml_jsoo_flags_effects(unit) {
        return 0;
    }
    function caml_jsoo_flags_use_js_string(unit) {
        return 1;
    }
    function caml_lazy_make_forward(v) {
        return [
            250,
            v
        ];
    }
    function caml_obj_tag(x) {
        if (x instanceof Array && x[0] == x[0] >>> 0) return x[0];
        else if (caml_is_ml_bytes(x)) return 252;
        else if (caml_is_ml_string(x)) return 252;
        else if (x instanceof Function || typeof x == "function") return 247;
        else if (x && x.caml_custom) return 255;
        else return 1000;
    }
    function caml_lazy_read_result(o) {
        return caml_obj_tag(o) == 250 ? o[1] : o;
    }
    function caml_obj_update_tag(b, o, n) {
        if (b[0] == o) {
            b[0] = n;
            return 1;
        }
        return 0;
    }
    function caml_lazy_reset_to_lazy(o) {
        caml_obj_update_tag(o, 244, 246);
        return 0;
    }
    function caml_lazy_update_to_forcing(o) {
        return o instanceof Array && o[0] == o[0] >>> 0 && caml_obj_update_tag(o, 246, 244) ? 0 : 1;
    }
    function caml_lazy_update_to_forward(o) {
        caml_obj_update_tag(o, 244, 250);
        return 0;
    }
    function caml_ldexp_float(x, exp) {
        exp |= 0;
        if (exp > 1023) {
            exp -= 1023;
            x *= Math.pow(2, 1023);
            if (exp > 1023) {
                exp -= 1023;
                x *= Math.pow(2, 1023);
            }
        }
        if (exp < -1023) {
            exp += 1023;
            x *= Math.pow(2, -1023);
        }
        x *= Math.pow(2, exp);
        return x;
    }
    function caml_lessequal(x, y) {
        return +(caml_compare_val(x, y, false) <= 0);
    }
    function caml_lessthan(x, y) {
        return +(caml_compare_val(x, y, false) < 0);
    }
    function caml_lex_array(s) {
        s = caml_jsbytes_of_string(s);
        var l = s.length / 2, a = new Array(l);
        for(var i = 0; i < l; i++)a[i] = (s.charCodeAt(2 * i) | s.charCodeAt(2 * i + 1) << 8) << 16 >> 16;
        return a;
    }
    function caml_lex_engine(tbl, start_state, lexbuf) {
        var lex_buffer = 2, lex_buffer_len = 3, lex_start_pos = 5, lex_curr_pos = 6, lex_last_pos = 7, lex_last_action = 8, lex_eof_reached = 9, lex_base = 1, lex_backtrk = 2, lex_default = 3, lex_trans = 4, lex_check = 5;
        if (!tbl.lex_default) {
            tbl.lex_base = caml_lex_array(tbl[lex_base]);
            tbl.lex_backtrk = caml_lex_array(tbl[lex_backtrk]);
            tbl.lex_check = caml_lex_array(tbl[lex_check]);
            tbl.lex_trans = caml_lex_array(tbl[lex_trans]);
            tbl.lex_default = caml_lex_array(tbl[lex_default]);
        }
        var c, state = start_state, buffer = caml_uint8_array_of_bytes(lexbuf[lex_buffer]);
        if (state >= 0) {
            lexbuf[lex_last_pos] = lexbuf[lex_start_pos] = lexbuf[lex_curr_pos];
            lexbuf[lex_last_action] = -1;
        } else state = -state - 1;
        for(;;){
            var base = tbl.lex_base[state];
            if (base < 0) return -base - 1;
            var backtrk = tbl.lex_backtrk[state];
            if (backtrk >= 0) {
                lexbuf[lex_last_pos] = lexbuf[lex_curr_pos];
                lexbuf[lex_last_action] = backtrk;
            }
            if (lexbuf[lex_curr_pos] >= lexbuf[lex_buffer_len]) {
                if (lexbuf[lex_eof_reached] == 0) return -state - 1;
                else c = 256;
            } else {
                c = buffer[lexbuf[lex_curr_pos]];
                lexbuf[lex_curr_pos]++;
            }
            if (tbl.lex_check[base + c] == state) state = tbl.lex_trans[base + c];
            else state = tbl.lex_default[state];
            if (state < 0) {
                lexbuf[lex_curr_pos] = lexbuf[lex_last_pos];
                if (lexbuf[lex_last_action] == -1) caml_failwith("lexing: empty token");
                else return lexbuf[lex_last_action];
            } else if (c == 256) lexbuf[lex_eof_reached] = 0;
        }
    }
    function caml_list_mount_point() {
        var prev = 0;
        for(var i = 0; i < jsoo_mount_point.length; i++){
            var old = prev;
            prev = [
                0,
                caml_string_of_jsbytes(jsoo_mount_point[i].path),
                old
            ];
        }
        return prev;
    }
    function caml_list_of_js_array(a) {
        var l = 0;
        for(var i = a.length - 1; i >= 0; i--){
            var e = a[i];
            l = [
                0,
                e,
                l
            ];
        }
        return l;
    }
    function caml_list_to_js_array(l) {
        var a = [];
        for(; l !== 0; l = l[2])a.push(l[1]);
        return a;
    }
    function caml_log10_float(x) {
        return Math.log10(x);
    }
    function caml_log1p_float(x) {
        return Math.log1p(x);
    }
    function caml_log2_float(x) {
        return Math.log2(x);
    }
    function caml_new_string(s) {
        return caml_string_of_jsbytes(s);
    }
    function caml_lxm_next(v) {
        function shift_l(x, k) {
            return caml_int64_shift_left(x, k);
        }
        function shift_r(x, k) {
            return caml_int64_shift_right_unsigned(x, k);
        }
        function or(a, b) {
            return caml_int64_or(a, b);
        }
        function xor(a, b) {
            return caml_int64_xor(a, b);
        }
        function add(a, b) {
            return caml_int64_add(a, b);
        }
        function mul(a, b) {
            return caml_int64_mul(a, b);
        }
        function rotl(x, k) {
            return or(shift_l(x, k), shift_r(x, 64 - k));
        }
        function get(a, i) {
            return caml_ba_get_1(a, i);
        }
        function set(a, i, x) {
            return caml_ba_set_1(a, i, x);
        }
        var M = caml_int64_of_string(caml_new_string("0xd1342543de82ef95")), daba = caml_int64_of_string(caml_new_string("0xdaba0b6eb09322e3")), z, q0, q1, st = v, a = get(st, 0), s = get(st, 1), x0 = get(st, 2), x1 = get(st, 3);
        z = add(s, x0);
        z = mul(xor(z, shift_r(z, 32)), daba);
        z = mul(xor(z, shift_r(z, 32)), daba);
        z = xor(z, shift_r(z, 32));
        set(st, 1, add(mul(s, M), a));
        var q0 = x0, q1 = x1;
        q1 = xor(q1, q0);
        q0 = rotl(q0, 24);
        q0 = xor(xor(q0, q1), shift_l(q1, 16));
        q1 = rotl(q1, 37);
        set(st, 2, q0);
        set(st, 3, q1);
        return z;
    }
    function caml_make_float_vect(len) {
        if (len < 0) caml_array_bound_error();
        var len = len + 1 | 0, b = new Array(len);
        b[0] = 254;
        for(var i = 1; i < len; i++)b[i] = 0;
        return b;
    }
    function caml_make_vect(len, init) {
        if (len < 0) caml_array_bound_error();
        var len = len + 1 | 0, b = new Array(len);
        b[0] = 0;
        for(var i = 1; i < len; i++)b[i] = init;
        return b;
    }
    function caml_make_local_vect(v_len, v_elt) {
        return caml_make_vect(v_len, v_elt);
    }
    var caml_marshal_constants = {
        PREFIX_SMALL_BLOCK: 0x80,
        PREFIX_SMALL_INT: 0x40,
        PREFIX_SMALL_STRING: 0x20,
        CODE_INT8: 0x00,
        CODE_INT16: 0x01,
        CODE_INT32: 0x02,
        CODE_INT64: 0x03,
        CODE_SHARED8: 0x04,
        CODE_SHARED16: 0x05,
        CODE_SHARED32: 0x06,
        CODE_BLOCK32: 0x08,
        CODE_BLOCK64: 0x13,
        CODE_STRING8: 0x09,
        CODE_STRING32: 0x0A,
        CODE_DOUBLE_BIG: 0x0B,
        CODE_DOUBLE_LITTLE: 0x0C,
        CODE_DOUBLE_ARRAY8_BIG: 0x0D,
        CODE_DOUBLE_ARRAY8_LITTLE: 0x0E,
        CODE_DOUBLE_ARRAY32_BIG: 0x0F,
        CODE_DOUBLE_ARRAY32_LITTLE: 0x07,
        CODE_CODEPOINTER: 0x10,
        CODE_INFIXPOINTER: 0x11,
        CODE_CUSTOM: 0x12,
        CODE_CUSTOM_LEN: 0x18,
        CODE_CUSTOM_FIXED: 0x19
    };
    function caml_maybe_print_stats(unit) {
        return 0;
    }
    function caml_md5_bytes(s, ofs, len) {
        var ctx = caml_MD5Init(), a = caml_uint8_array_of_bytes(s);
        caml_MD5Update(ctx, a.subarray(ofs, ofs + len), len);
        return caml_string_of_array(caml_MD5Final(ctx));
    }
    function caml_ml_input_block(chanid, ba, i, l) {
        var chan = caml_ml_channel_get(chanid), n = l, avail = chan.buffer_max - chan.buffer_curr;
        if (l <= avail) {
            ba.set(chan.buffer.subarray(chan.buffer_curr, chan.buffer_curr + l), i);
            chan.buffer_curr += l;
        } else if (avail > 0) {
            ba.set(chan.buffer.subarray(chan.buffer_curr, chan.buffer_curr + avail), i);
            chan.buffer_curr += avail;
            n = avail;
        } else {
            chan.buffer_curr = 0;
            chan.buffer_max = 0;
            caml_refill(chan);
            var avail = chan.buffer_max - chan.buffer_curr;
            if (n > avail) n = avail;
            ba.set(chan.buffer.subarray(chan.buffer_curr, chan.buffer_curr + n), i);
            chan.buffer_curr += n;
        }
        return n | 0;
    }
    function caml_md5_chan(chanid, toread) {
        var ctx = caml_MD5Init(), buffer = new Uint8Array(4096);
        if (toread < 0) while(true){
            var read = caml_ml_input_block(chanid, buffer, 0, buffer.length);
            if (read == 0) break;
            caml_MD5Update(ctx, buffer.subarray(0, read), read);
        }
        else while(toread > 0){
            var read = caml_ml_input_block(chanid, buffer, 0, toread > buffer.length ? buffer.length : toread);
            if (read == 0) caml_raise_end_of_file();
            caml_MD5Update(ctx, buffer.subarray(0, read), read);
            toread -= read;
        }
        return caml_string_of_array(caml_MD5Final(ctx));
    }
    function caml_md5_string(s, ofs, len) {
        return caml_md5_bytes(caml_bytes_of_string(s), ofs, len);
    }
    function caml_memprof_discard(t) {
        return 0;
    }
    function caml_memprof_set(_control) {
        return 0;
    }
    function caml_memprof_start(rate, stack_size, tracker) {
        return 0;
    }
    function caml_memprof_stop(unit) {
        return 0;
    }
    function caml_ml_channel_redirect(captured, into) {
        var to_restore = caml_ml_channel_get(captured), new_ = caml_ml_channel_get(into);
        caml_ml_channels[captured] = new_;
        return to_restore;
    }
    function caml_ml_channel_restore(captured, to_restore) {
        caml_ml_channels[captured] = to_restore;
        return 0;
    }
    function caml_ml_channel_size(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return chan.file.length();
    }
    function caml_ml_channel_size_64(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return caml_int64_of_float(chan.file.length());
    }
    var caml_sys_fds = new Array(3);
    function caml_sys_close(fd) {
        var file = caml_sys_fds[fd];
        if (file) file.close();
        delete caml_sys_fds[fd];
        return 0;
    }
    function caml_ml_flush(chanid) {
        var chan = caml_ml_channel_get(chanid);
        if (!chan.opened) caml_raise_sys_error("Cannot flush a closed channel");
        if (!chan.buffer || chan.buffer_curr == 0) return 0;
        if (chan.output) chan.output(caml_subarray_to_jsbytes(chan.buffer, 0, chan.buffer_curr));
        else chan.file.write(chan.offset, chan.buffer, 0, chan.buffer_curr);
        chan.offset += chan.buffer_curr;
        chan.buffer_curr = 0;
        return 0;
    }
    function caml_ml_close_channel(chanid) {
        var chan = caml_ml_channel_get(chanid);
        if (chan.opened) {
            chan.opened = false;
            caml_sys_close(chan.fd);
            chan.fd = -1;
            chan.buffer = new Uint8Array(0);
            chan.buffer_curr = 0;
            chan.buffer_max = 0;
        }
        return 0;
    }
    function caml_ml_condition_broadcast(t) {
        return 0;
    }
    function caml_ml_condition_new(unit) {
        return {
            condition: 1
        };
    }
    function caml_ml_condition_signal(t) {
        return 0;
    }
    function caml_ml_condition_wait(t, mutext) {
        return 0;
    }
    function caml_ml_debug_info_status() {
        return 0;
    }
    function caml_ml_domain_cpu_relax(unit) {
        return 0;
    }
    function caml_ml_domain_id(unit) {
        return caml_domain_id;
    }
    function caml_ml_domain_set_name(_name) {
        return 0;
    }
    var caml_runtime_warnings = 0;
    function caml_ml_enable_runtime_warnings(bool) {
        caml_runtime_warnings = bool;
        return 0;
    }
    function caml_ml_input(chanid, b, i, l) {
        var ba = caml_uint8_array_of_bytes(b);
        return caml_ml_input_block(chanid, ba, i, l);
    }
    function caml_ml_input_bigarray(chanid, b, i, l) {
        var ba = caml_ba_to_typed_array(b);
        return caml_ml_input_block(chanid, ba, i, l);
    }
    function caml_ml_input_char(chanid) {
        var chan = caml_ml_channel_get(chanid);
        if (chan.buffer_curr >= chan.buffer_max) {
            chan.buffer_curr = 0;
            chan.buffer_max = 0;
            caml_refill(chan);
        }
        if (chan.buffer_curr >= chan.buffer_max) caml_raise_end_of_file();
        var res = chan.buffer[chan.buffer_curr];
        chan.buffer_curr++;
        return res;
    }
    function caml_ml_input_int(chanid) {
        var chan = caml_ml_channel_get(chanid), res = 0;
        for(var i = 0; i < 4; i++)res = (res << 8) + caml_ml_input_char(chanid) | 0;
        return res | 0;
    }
    function caml_ml_input_scan_line(chanid) {
        var chan = caml_ml_channel_get(chanid), p = chan.buffer_curr;
        do if (p >= chan.buffer_max) {
            if (chan.buffer_curr > 0) {
                chan.buffer.set(chan.buffer.subarray(chan.buffer_curr), 0);
                p -= chan.buffer_curr;
                chan.buffer_max -= chan.buffer_curr;
                chan.buffer_curr = 0;
            }
            if (chan.buffer_max >= chan.buffer.length) return -chan.buffer_max | 0;
            var prev_max = chan.buffer_max;
            caml_refill(chan);
            if (prev_max == chan.buffer_max) return -chan.buffer_max | 0;
        }
        while (chan.buffer[p++] != 10);
        return p - chan.buffer_curr | 0;
    }
    function caml_ml_is_binary_mode(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return chan.file.flags.binary;
    }
    function caml_ml_is_buffered(chanid) {
        return caml_ml_channel_get(chanid).buffered ? 1 : 0;
    }
    function caml_ml_mutex_lock(t) {
        if (t.locked) caml_failwith("Mutex.lock: mutex already locked. Cannot wait.");
        else t.locked = true;
        return 0;
    }
    function caml_ml_mutex_new(unit) {
        return new MlMutex();
    }
    function caml_ml_mutex_try_lock(t) {
        if (!t.locked) {
            t.locked = true;
            return 1;
        }
        return 0;
    }
    function caml_sys_open_for_node(fd, flags) {
        if (flags.name) try {
            var fs = (parcelRequire("48K42")), fd2 = fs.openSync(flags.name, "rs");
            return new MlNodeFd(fd2, flags);
        } catch (e) {}
        return new MlNodeFd(fd, flags);
    }
    function caml_sys_open_internal(file, idx) {
        if (idx == undefined) idx = caml_sys_fds.length;
        caml_sys_fds[idx] = file;
        return idx | 0;
    }
    function caml_sys_open(name, flags, _perms) {
        var f = {};
        while(flags){
            switch(flags[1]){
                case 0:
                    f.rdonly = 1;
                    break;
                case 1:
                    f.wronly = 1;
                    break;
                case 2:
                    f.append = 1;
                    break;
                case 3:
                    f.create = 1;
                    break;
                case 4:
                    f.truncate = 1;
                    break;
                case 5:
                    f.excl = 1;
                    break;
                case 6:
                    f.binary = 1;
                    break;
                case 7:
                    f.text = 1;
                    break;
                case 8:
                    f.nonblock = 1;
                    break;
            }
            flags = flags[2];
        }
        if (f.rdonly && f.wronly) caml_raise_sys_error(caml_jsbytes_of_string(name) + " : flags Open_rdonly and Open_wronly are not compatible");
        if (f.text && f.binary) caml_raise_sys_error(caml_jsbytes_of_string(name) + " : flags Open_text and Open_binary are not compatible");
        var root = resolve_fs_device(name), file = root.device.open(root.rest, f);
        return caml_sys_open_internal(file, undefined);
    }
    (function() {
        function file(fd, flags) {
            return fs_node_supported() ? caml_sys_open_for_node(fd, flags) : new MlFakeFd_out(fd, flags);
        }
        caml_sys_open_internal(file(0, {
            rdonly: 1,
            altname: "/dev/stdin",
            isCharacterDevice: true
        }), 0);
        caml_sys_open_internal(file(1, {
            buffered: 2,
            wronly: 1,
            isCharacterDevice: true
        }), 1);
        caml_sys_open_internal(file(2, {
            buffered: 2,
            wronly: 1,
            isCharacterDevice: true
        }), 2);
    })();
    function caml_ml_open_descriptor_in(fd) {
        var file = caml_sys_fds[fd];
        if (file.flags.wronly) caml_raise_sys_error("fd " + fd + " is writeonly");
        var refill = null, channel = {
            file: file,
            offset: file.flags.append ? file.length() : 0,
            fd: fd,
            opened: true,
            out: false,
            buffer_curr: 0,
            buffer_max: 0,
            buffer: new Uint8Array(65536),
            refill: refill
        };
        caml_ml_channels[channel.fd] = channel;
        return channel.fd;
    }
    function caml_ml_open_descriptor_in_with_flags(fd, flags) {
        return caml_ml_open_descriptor_in(fd);
    }
    function caml_ml_open_descriptor_out(fd) {
        var file = caml_sys_fds[fd];
        if (file.flags.rdonly) caml_raise_sys_error("fd " + fd + " is readonly");
        var buffered = file.flags.buffered !== undefined ? file.flags.buffered : 1, channel = {
            file: file,
            offset: file.flags.append ? file.length() : 0,
            fd: fd,
            opened: true,
            out: true,
            buffer_curr: 0,
            buffer: new Uint8Array(65536),
            buffered: buffered
        };
        caml_ml_channels[channel.fd] = channel;
        return channel.fd;
    }
    function caml_ml_open_descriptor_out_with_flags(fd, flags) {
        return caml_ml_open_descriptor_out(fd);
    }
    function caml_ml_out_channels_list() {
        var l = 0;
        for(var c = 0; c < caml_ml_channels.length; c++)if (caml_ml_channels[c] && caml_ml_channels[c].opened && caml_ml_channels[c].out) l = [
            0,
            caml_ml_channels[c].fd,
            l
        ];
        return l;
    }
    function caml_ml_output_ta(chanid, buffer, offset, len) {
        var chan = caml_ml_channel_get(chanid);
        if (!chan.opened) caml_raise_sys_error("Cannot output to a closed channel");
        buffer = buffer.subarray(offset, offset + len);
        if (chan.buffer_curr + buffer.length > chan.buffer.length) {
            var b = new Uint8Array(chan.buffer_curr + buffer.length);
            b.set(chan.buffer);
            chan.buffer = b;
        }
        switch(chan.buffered){
            case 0:
                chan.buffer.set(buffer, chan.buffer_curr);
                chan.buffer_curr += buffer.length;
                caml_ml_flush(chanid);
                break;
            case 1:
                chan.buffer.set(buffer, chan.buffer_curr);
                chan.buffer_curr += buffer.length;
                if (chan.buffer_curr >= chan.buffer.length) caml_ml_flush(chanid);
                break;
            case 2:
                var id = buffer.lastIndexOf(10);
                if (id < 0) {
                    chan.buffer.set(buffer, chan.buffer_curr);
                    chan.buffer_curr += buffer.length;
                    if (chan.buffer_curr >= chan.buffer.length) caml_ml_flush(chanid);
                } else {
                    chan.buffer.set(buffer.subarray(0, id + 1), chan.buffer_curr);
                    chan.buffer_curr += id + 1;
                    caml_ml_flush(chanid);
                    chan.buffer.set(buffer.subarray(id + 1), chan.buffer_curr);
                    chan.buffer_curr += buffer.length - id - 1;
                }
                break;
        }
        return 0;
    }
    function caml_ml_output_bytes(chanid, buffer, offset, len) {
        var buffer = caml_uint8_array_of_bytes(buffer);
        return caml_ml_output_ta(chanid, buffer, offset, len);
    }
    function caml_ml_output(chanid, buffer, offset, len) {
        return caml_ml_output_bytes(chanid, caml_bytes_of_string(buffer), offset, len);
    }
    function caml_ml_output_bigarray(chanid, buffer, offset, len) {
        var buffer = caml_ba_to_typed_array(buffer);
        return caml_ml_output_ta(chanid, buffer, offset, len);
    }
    function caml_ml_output_char(chanid, c) {
        var s = caml_string_of_jsbytes(String.fromCharCode(c));
        caml_ml_output(chanid, s, 0, 1);
        return 0;
    }
    function caml_ml_output_int(chanid, i) {
        var arr = [
            i >> 24 & 0xFF,
            i >> 16 & 0xFF,
            i >> 8 & 0xFF,
            i & 0xFF
        ], s = caml_string_of_array(arr);
        caml_ml_output(chanid, s, 0, 4);
        return 0;
    }
    function caml_pos_in(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return chan.offset - (chan.buffer_max - chan.buffer_curr) | 0;
    }
    function caml_ml_pos_in(chanid) {
        return caml_pos_in(chanid);
    }
    function caml_ml_pos_in_64(chanid) {
        return caml_int64_of_float(caml_pos_in(chanid));
    }
    function caml_pos_out(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return chan.offset + chan.buffer_curr;
    }
    function caml_ml_pos_out(chanid) {
        return caml_pos_out(chanid);
    }
    function caml_ml_pos_out_64(chanid) {
        return caml_int64_of_float(caml_pos_out(chanid));
    }
    function caml_ml_runtime_events_are_active() {
        return 0;
    }
    function caml_ml_runtime_events_pause() {
        return 0;
    }
    function caml_ml_runtime_events_resume() {
        return 0;
    }
    function caml_ml_runtime_events_start() {
        return 0;
    }
    function caml_ml_runtime_warnings_enabled(_unit) {
        return caml_runtime_warnings;
    }
    function caml_seek_in(chanid, pos) {
        var chan = caml_ml_channel_get(chanid);
        if (chan.refill != null) caml_raise_sys_error("Illegal seek");
        if (pos >= chan.offset - chan.buffer_max && pos <= chan.offset && chan.file.flags.binary) chan.buffer_curr = chan.buffer_max - (chan.offset - pos);
        else {
            chan.offset = pos;
            chan.buffer_curr = 0;
            chan.buffer_max = 0;
        }
        return 0;
    }
    function caml_ml_seek_in(chanid, pos) {
        return caml_seek_in(chanid, pos);
    }
    function caml_ml_seek_in_64(chanid, pos) {
        var pos = caml_int64_to_float(pos);
        return caml_seek_in(chanid, pos);
    }
    function caml_seek_out(chanid, pos) {
        caml_ml_flush(chanid);
        var chan = caml_ml_channel_get(chanid);
        chan.offset = pos;
        return 0;
    }
    function caml_ml_seek_out(chanid, pos) {
        return caml_seek_out(chanid, pos);
    }
    function caml_ml_seek_out_64(chanid, pos) {
        var pos = caml_int64_to_float(pos);
        return caml_seek_out(chanid, pos);
    }
    function caml_ml_set_binary_mode(chanid, mode) {
        var chan = caml_ml_channel_get(chanid);
        chan.file.flags.text = !mode;
        chan.file.flags.binary = mode;
        return 0;
    }
    function caml_ml_set_buffered(chanid, v) {
        caml_ml_channel_get(chanid).buffered = v;
        if (!v) caml_ml_flush(chanid);
        return 0;
    }
    function caml_ml_set_channel_name(chanid, name) {
        var chan = caml_ml_channel_get(chanid);
        chan.name = name;
        return 0;
    }
    function caml_ml_set_channel_output(chanid, f) {
        var chan = caml_ml_channel_get(chanid);
        chan.output = function(s) {
            f(s);
        };
        return 0;
    }
    function caml_ml_set_channel_refill(chanid, f) {
        caml_ml_channel_get(chanid).refill = f;
        return 0;
    }
    function caml_mod(x, y) {
        if (y == 0) caml_raise_zero_divide();
        return x % y;
    }
    function caml_modf_float(x) {
        if (isFinite(x)) {
            var neg = 1 / x < 0;
            x = Math.abs(x);
            var i = Math.floor(x), f = x - i;
            if (neg) {
                i = -i;
                f = -f;
            }
            return [
                0,
                f,
                i
            ];
        }
        if (isNaN(x)) return [
            0,
            NaN,
            NaN
        ];
        return [
            0,
            1 / x,
            x
        ];
    }
    function caml_mount_autoload(name, f) {
        var path = caml_make_path(name), name = caml_trailing_slash(path.join("/"));
        jsoo_mount_point.push({
            path: name,
            device: new MlFakeDevice(name, f)
        });
        return 0;
    }
    function caml_lex_run_mem(s, i, mem, curr_pos) {
        for(;;){
            var dst = s.charCodeAt(i);
            i++;
            if (dst == 0xff) return;
            var src = s.charCodeAt(i);
            i++;
            if (src == 0xff) mem[dst + 1] = curr_pos;
            else mem[dst + 1] = mem[src + 1];
        }
    }
    function caml_lex_run_tag(s, i, mem) {
        for(;;){
            var dst = s.charCodeAt(i);
            i++;
            if (dst == 0xff) return;
            var src = s.charCodeAt(i);
            i++;
            if (src == 0xff) mem[dst + 1] = -1;
            else mem[dst + 1] = mem[src + 1];
        }
    }
    function caml_new_lex_engine(tbl, start_state, lexbuf) {
        var lex_buffer = 2, lex_buffer_len = 3, lex_start_pos = 5, lex_curr_pos = 6, lex_last_pos = 7, lex_last_action = 8, lex_eof_reached = 9, lex_mem = 10, lex_base = 1, lex_backtrk = 2, lex_default = 3, lex_trans = 4, lex_check = 5, lex_base_code = 6, lex_backtrk_code = 7, lex_default_code = 8, lex_trans_code = 9, lex_check_code = 10, lex_code = 11;
        if (!tbl.lex_default) {
            tbl.lex_base = caml_lex_array(tbl[lex_base]);
            tbl.lex_backtrk = caml_lex_array(tbl[lex_backtrk]);
            tbl.lex_check = caml_lex_array(tbl[lex_check]);
            tbl.lex_trans = caml_lex_array(tbl[lex_trans]);
            tbl.lex_default = caml_lex_array(tbl[lex_default]);
        }
        if (!tbl.lex_default_code) {
            tbl.lex_base_code = caml_lex_array(tbl[lex_base_code]);
            tbl.lex_backtrk_code = caml_lex_array(tbl[lex_backtrk_code]);
            tbl.lex_check_code = caml_lex_array(tbl[lex_check_code]);
            tbl.lex_trans_code = caml_lex_array(tbl[lex_trans_code]);
            tbl.lex_default_code = caml_lex_array(tbl[lex_default_code]);
        }
        if (tbl.lex_code == null) tbl.lex_code = caml_jsbytes_of_string(tbl[lex_code]);
        var c, state = start_state, buffer = caml_uint8_array_of_bytes(lexbuf[lex_buffer]);
        if (state >= 0) {
            lexbuf[lex_last_pos] = lexbuf[lex_start_pos] = lexbuf[lex_curr_pos];
            lexbuf[lex_last_action] = -1;
        } else state = -state - 1;
        for(;;){
            var base = tbl.lex_base[state];
            if (base < 0) {
                var pc_off = tbl.lex_base_code[state];
                caml_lex_run_tag(tbl.lex_code, pc_off, lexbuf[lex_mem]);
                return -base - 1;
            }
            var backtrk = tbl.lex_backtrk[state];
            if (backtrk >= 0) {
                var pc_off = tbl.lex_backtrk_code[state];
                caml_lex_run_tag(tbl.lex_code, pc_off, lexbuf[lex_mem]);
                lexbuf[lex_last_pos] = lexbuf[lex_curr_pos];
                lexbuf[lex_last_action] = backtrk;
            }
            if (lexbuf[lex_curr_pos] >= lexbuf[lex_buffer_len]) {
                if (lexbuf[lex_eof_reached] == 0) return -state - 1;
                else c = 256;
            } else {
                c = buffer[lexbuf[lex_curr_pos]];
                lexbuf[lex_curr_pos]++;
            }
            var pstate = state;
            if (tbl.lex_check[base + c] == state) state = tbl.lex_trans[base + c];
            else state = tbl.lex_default[state];
            if (state < 0) {
                lexbuf[lex_curr_pos] = lexbuf[lex_last_pos];
                if (lexbuf[lex_last_action] == -1) caml_failwith("lexing: empty token");
                else return lexbuf[lex_last_action];
            } else {
                var base_code = tbl.lex_base_code[pstate], pc_off;
                if (tbl.lex_check_code[base_code + c] == pstate) pc_off = tbl.lex_trans_code[base_code + c];
                else pc_off = tbl.lex_default_code[pstate];
                if (pc_off > 0) caml_lex_run_mem(tbl.lex_code, pc_off, lexbuf[lex_mem], lexbuf[lex_curr_pos]);
                if (c == 256) lexbuf[lex_eof_reached] = 0;
            }
        }
    }
    function caml_nextafter_float(x, y) {
        if (isNaN(x) || isNaN(y)) return NaN;
        if (x == y) return y;
        if (x == 0) return y < 0 ? -Math.pow(2, -1074) : Math.pow(2, -1074);
        var bits = caml_int64_bits_of_float(x), one = caml_int64_of_int32(1);
        if (x < y == x > 0) bits = caml_int64_add(bits, one);
        else bits = caml_int64_sub(bits, one);
        return caml_int64_float_of_bits(bits);
    }
    function caml_notequal(x, y) {
        return +(caml_compare_val(x, y, false) != 0);
    }
    function caml_obj_add_offset(v, offset) {
        caml_failwith("Obj.add_offset is not supported");
    }
    function caml_obj_block(tag, size) {
        var o = new Array(size + 1);
        o[0] = tag;
        for(var i = 1; i <= size; i++)o[i] = 0;
        return o;
    }
    function caml_obj_compare_and_swap(x, i, old, n) {
        if (x[i + 1] == old) {
            x[i + 1] = n;
            return 1;
        }
        return 0;
    }
    function caml_obj_is_block(x) {
        return +(x instanceof Array);
    }
    function caml_obj_is_shared(x) {
        return 1;
    }
    function caml_obj_make_forward(b, v) {
        b[0] = 250;
        b[1] = v;
        return 0;
    }
    function caml_obj_raw_field(o, i) {
        return o[i + 1];
    }
    function caml_obj_reachable_words(o) {
        return 0;
    }
    function caml_obj_set_raw_field(o, i, v) {
        return o[i + 1] = v;
    }
    function caml_obj_set_tag(x, tag) {
        x[0] = tag;
        return 0;
    }
    function caml_obj_truncate(x, s) {
        if (s <= 0 || s + 1 > x.length) caml_invalid_argument("Obj.truncate");
        if (x.length != s + 1) x.length = s + 1;
        return 0;
    }
    function caml_obj_with_tag(tag, x) {
        var l = x.length, a = new Array(l);
        a[0] = tag;
        for(var i = 1; i < l; i++)a[i] = x[i];
        return a;
    }
    function caml_ojs_new_arr(c, a) {
        switch(a.length){
            case 0:
                return new c;
            case 1:
                return new c(a[0]);
            case 2:
                return new c(a[0], a[1]);
            case 3:
                return new c(a[0], a[1], a[2]);
            case 4:
                return new c(a[0], a[1], a[2], a[3]);
            case 5:
                return new c(a[0], a[1], a[2], a[3], a[4]);
            case 6:
                return new c(a[0], a[1], a[2], a[3], a[4], a[5]);
            case 7:
                return new c(a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
        }
        function F() {
            return c.apply(this, a);
        }
        F.prototype = c.prototype;
        return new F;
    }
    var caml_output_val = function() {
        function Writer() {
            this.chunk = [];
        }
        Writer.prototype = {
            chunk_idx: 20,
            block_len: 0,
            obj_counter: 0,
            size_32: 0,
            size_64: 0,
            write: function(size, value) {
                for(var i = size - 8; i >= 0; i -= 8)this.chunk[this.chunk_idx++] = value >> i & 0xFF;
            },
            write_at: function(pos, size, value) {
                var pos = pos;
                for(var i = size - 8; i >= 0; i -= 8)this.chunk[pos++] = value >> i & 0xFF;
            },
            write_code: function(size, code, value) {
                this.chunk[this.chunk_idx++] = code;
                for(var i = size - 8; i >= 0; i -= 8)this.chunk[this.chunk_idx++] = value >> i & 0xFF;
            },
            write_shared: function(offset) {
                if (offset < 256) this.write_code(8, 0x04, offset);
                else if (offset < 65536) this.write_code(16, 0x05, offset);
                else this.write_code(32, 0x06, offset);
            },
            pos: function() {
                return this.chunk_idx;
            },
            finalize: function() {
                this.block_len = this.chunk_idx - 20;
                this.chunk_idx = 0;
                this.write(32, 0x8495A6BE);
                this.write(32, this.block_len);
                this.write(32, this.obj_counter);
                this.write(32, this.size_32);
                this.write(32, this.size_64);
                return this.chunk;
            }
        };
        return function(v, flags) {
            flags = caml_list_to_js_array(flags);
            var no_sharing = flags.indexOf(0) !== -1, closures = flags.indexOf(1) !== -1;
            if (closures) console.warn("in caml_output_val: flag Marshal.Closures is not supported.");
            var writer = new Writer(), stack = [], intern_obj_table = no_sharing ? null : new MlObjectTable();
            function memo(v) {
                if (no_sharing) return false;
                var existing_offset = intern_obj_table.recall(v);
                if (existing_offset) {
                    writer.write_shared(existing_offset);
                    return true;
                } else {
                    intern_obj_table.store(v);
                    return false;
                }
            }
            function extern_rec(v) {
                if (v.caml_custom) {
                    if (memo(v)) return;
                    var name = v.caml_custom, ops = caml_custom_ops[name], sz_32_64 = [
                        0,
                        0
                    ];
                    if (!ops.serialize) caml_invalid_argument("output_value: abstract value (Custom)");
                    if (ops.fixed_length == undefined) {
                        writer.write(8, 0x18);
                        for(var i = 0; i < name.length; i++)writer.write(8, name.charCodeAt(i));
                        writer.write(8, 0);
                        var header_pos = writer.pos();
                        for(var i = 0; i < 12; i++)writer.write(8, 0);
                        ops.serialize(writer, v, sz_32_64);
                        writer.write_at(header_pos, 32, sz_32_64[0]);
                        writer.write_at(header_pos + 4, 32, 0);
                        writer.write_at(header_pos + 8, 32, sz_32_64[1]);
                    } else {
                        writer.write(8, 0x19);
                        for(var i = 0; i < name.length; i++)writer.write(8, name.charCodeAt(i));
                        writer.write(8, 0);
                        var old_pos = writer.pos();
                        ops.serialize(writer, v, sz_32_64);
                        if (ops.fixed_length != writer.pos() - old_pos) caml_failwith("output_value: incorrect fixed sizes specified by " + name);
                    }
                    writer.size_32 += 2 + (sz_32_64[0] + 3 >> 2);
                    writer.size_64 += 2 + (sz_32_64[1] + 7 >> 3);
                } else if (v instanceof Array && v[0] === (v[0] | 0)) {
                    if (v[0] == 251) caml_failwith("output_value: abstract value (Abstract)");
                    if (caml_is_continuation_tag(v[0])) caml_invalid_argument("output_value: continuation value");
                    if (v.length > 1 && memo(v)) return;
                    if (v[0] < 16 && v.length - 1 < 8) writer.write(8, 0x80 + v[0] + (v.length - 1 << 4));
                    else writer.write_code(32, 0x08, v.length - 1 << 10 | v[0]);
                    writer.size_32 += v.length;
                    writer.size_64 += v.length;
                    if (v.length > 1) stack.push(v, 1);
                } else if (caml_is_ml_bytes(v)) {
                    if (!caml_is_ml_bytes(caml_string_of_jsbytes(""))) caml_failwith("output_value: [Bytes.t] cannot safely be marshaled with [--enable use-js-string]");
                    if (memo(v)) return;
                    var len = caml_ml_bytes_length(v);
                    if (len < 0x20) writer.write(8, 0x20 + len);
                    else if (len < 0x100) writer.write_code(8, 0x09, len);
                    else writer.write_code(32, 0x0A, len);
                    for(var i = 0; i < len; i++)writer.write(8, caml_bytes_unsafe_get(v, i));
                    writer.size_32 += 1 + ((len + 4) / 4 | 0);
                    writer.size_64 += 1 + ((len + 8) / 8 | 0);
                } else if (caml_is_ml_string(v)) {
                    if (memo(v)) return;
                    var len = caml_ml_string_length(v);
                    if (len < 0x20) writer.write(8, 0x20 + len);
                    else if (len < 0x100) writer.write_code(8, 0x09, len);
                    else writer.write_code(32, 0x0A, len);
                    for(var i = 0; i < len; i++)writer.write(8, caml_string_unsafe_get(v, i));
                    writer.size_32 += 1 + ((len + 4) / 4 | 0);
                    writer.size_64 += 1 + ((len + 8) / 8 | 0);
                } else if (v != (v | 0)) {
                    var type_of_v = typeof v;
                    if (type_of_v != "number") caml_failwith("output_value: abstract value (" + type_of_v + ")");
                    if (memo(v)) return;
                    var t = caml_int64_to_bytes(caml_int64_bits_of_float(v));
                    writer.write(8, 0x0C);
                    for(var i = 0; i < 8; i++)writer.write(8, t[7 - i]);
                    writer.size_32 += 3;
                    writer.size_64 += 2;
                } else if (v >= 0 && v < 0x40) writer.write(8, 0X40 + v);
                else if (v >= -128 && v < 128) writer.write_code(8, 0x00, v);
                else if (v >= -32768 && v < 32768) writer.write_code(16, 0x01, v);
                else writer.write_code(32, 0x02, v);
            }
            extern_rec(v);
            while(stack.length > 0){
                var i = stack.pop(), v = stack.pop();
                if (i + 1 < v.length) stack.push(v, i + 1);
                extern_rec(v[i]);
            }
            if (intern_obj_table) writer.obj_counter = intern_obj_table.objs.length;
            writer.finalize();
            return writer.chunk;
        };
    }();
    function caml_output_value_to_string(v, flags) {
        return caml_string_of_array(caml_output_val(v, flags));
    }
    function caml_output_value(chanid, v, flags) {
        var s = caml_output_value_to_string(v, flags);
        caml_ml_output(chanid, s, 0, caml_ml_string_length(s));
        return 0;
    }
    function caml_output_value_to_buffer(s, ofs, len, v, flags) {
        var t = caml_output_val(v, flags);
        if (t.length > len) caml_failwith("Marshal.to_buffer: buffer overflow");
        caml_blit_bytes(t, 0, s, ofs, t.length);
        return 0;
    }
    function caml_output_value_to_bytes(v, flags) {
        return caml_bytes_of_array(caml_output_val(v, flags));
    }
    var caml_parser_trace = 0;
    function caml_parse_engine(tables, env, cmd, arg) {
        var ERRCODE = 256, loop = 6, testshift = 7, shift = 8, shift_recover = 9, reduce = 10, READ_TOKEN = 0, RAISE_PARSE_ERROR = 1, GROW_STACKS_1 = 2, GROW_STACKS_2 = 3, COMPUTE_SEMANTIC_ACTION = 4, CALL_ERROR_FUNCTION = 5, env_s_stack = 1, env_v_stack = 2, env_symb_start_stack = 3, env_symb_end_stack = 4, env_stacksize = 5, env_stackbase = 6, env_curr_char = 7, env_lval = 8, env_symb_start = 9, env_symb_end = 10, env_asp = 11, env_rule_len = 12, env_rule_number = 13, env_sp = 14, env_state = 15, env_errflag = 16, tbl_transl_const = 2, tbl_transl_block = 3, tbl_lhs = 4, tbl_len = 5, tbl_defred = 6, tbl_dgoto = 7, tbl_sindex = 8, tbl_rindex = 9, tbl_gindex = 10, tbl_tablesize = 11, tbl_table = 12, tbl_check = 13, tbl_names_const = 15, tbl_names_block = 16;
        function log(x) {
            var s = caml_string_of_jsbytes(x + "\n");
            caml_ml_output(2, s, 0, caml_ml_string_length(s));
        }
        function token_name(names, number) {
            var str = caml_jsstring_of_string(names);
            if (str[0] == "\x00") return "<unknown token>";
            return str.split("\x00")[number];
        }
        function print_token(state, tok) {
            var token, kind;
            if (tok instanceof Array) {
                token = token_name(tables[tbl_names_block], tok[0]);
                if (typeof tok[1] == "number") kind = "" + tok[1];
                else if (typeof tok[1] == "string") kind = tok[1];
                else if (tok[1] instanceof MlBytes) kind = caml_jsbytes_of_string(tok[1]);
                else kind = "_";
                log("State " + state + ": read token " + token + "(" + kind + ")");
            } else {
                token = token_name(tables[tbl_names_const], tok);
                log("State " + state + ": read token " + token);
            }
        }
        if (!tables.dgoto) {
            tables.defred = caml_lex_array(tables[tbl_defred]);
            tables.sindex = caml_lex_array(tables[tbl_sindex]);
            tables.check = caml_lex_array(tables[tbl_check]);
            tables.rindex = caml_lex_array(tables[tbl_rindex]);
            tables.table = caml_lex_array(tables[tbl_table]);
            tables.len = caml_lex_array(tables[tbl_len]);
            tables.lhs = caml_lex_array(tables[tbl_lhs]);
            tables.gindex = caml_lex_array(tables[tbl_gindex]);
            tables.dgoto = caml_lex_array(tables[tbl_dgoto]);
        }
        var res = 0, n, n1, n2, state1, sp = env[env_sp], state = env[env_state], errflag = env[env_errflag];
        exit: for(;;)next: switch(cmd){
            case 0:
                state = 0;
                errflag = 0;
            case 6:
                n = tables.defred[state];
                if (n != 0) {
                    cmd = reduce;
                    break;
                }
                if (env[env_curr_char] >= 0) {
                    cmd = testshift;
                    break;
                }
                res = READ_TOKEN;
                break exit;
            case 1:
                if (arg instanceof Array) {
                    env[env_curr_char] = tables[tbl_transl_block][arg[0] + 1];
                    env[env_lval] = arg[1];
                } else {
                    env[env_curr_char] = tables[tbl_transl_const][arg + 1];
                    env[env_lval] = 0;
                }
                if (caml_parser_trace) print_token(state, arg);
            case 7:
                n1 = tables.sindex[state];
                n2 = n1 + env[env_curr_char];
                if (n1 != 0 && n2 >= 0 && n2 <= tables[tbl_tablesize] && tables.check[n2] == env[env_curr_char]) {
                    cmd = shift;
                    break;
                }
                n1 = tables.rindex[state];
                n2 = n1 + env[env_curr_char];
                if (n1 != 0 && n2 >= 0 && n2 <= tables[tbl_tablesize] && tables.check[n2] == env[env_curr_char]) {
                    n = tables.table[n2];
                    cmd = reduce;
                    break;
                }
                if (errflag <= 0) {
                    res = CALL_ERROR_FUNCTION;
                    break exit;
                }
            case 5:
                if (errflag < 3) {
                    errflag = 3;
                    for(;;){
                        state1 = env[env_s_stack][sp + 1];
                        n1 = tables.sindex[state1];
                        n2 = n1 + ERRCODE;
                        if (n1 != 0 && n2 >= 0 && n2 <= tables[tbl_tablesize] && tables.check[n2] == ERRCODE) {
                            if (caml_parser_trace) log("Recovering in state " + state1);
                            cmd = shift_recover;
                            break next;
                        } else {
                            if (caml_parser_trace) log("Discarding state " + state1);
                            if (sp <= env[env_stackbase]) {
                                if (caml_parser_trace) log("No more states to discard");
                                return RAISE_PARSE_ERROR;
                            }
                            sp--;
                        }
                    }
                } else {
                    if (env[env_curr_char] == 0) return RAISE_PARSE_ERROR;
                    if (caml_parser_trace) log("Discarding last token read");
                    env[env_curr_char] = -1;
                    cmd = loop;
                    break;
                }
            case 8:
                env[env_curr_char] = -1;
                if (errflag > 0) errflag--;
            case 9:
                if (caml_parser_trace) log("State " + state + ": shift to state " + tables.table[n2]);
                state = tables.table[n2];
                sp++;
                if (sp >= env[env_stacksize]) {
                    res = GROW_STACKS_1;
                    break exit;
                }
            case 2:
                env[env_s_stack][sp + 1] = state;
                env[env_v_stack][sp + 1] = env[env_lval];
                env[env_symb_start_stack][sp + 1] = env[env_symb_start];
                env[env_symb_end_stack][sp + 1] = env[env_symb_end];
                cmd = loop;
                break;
            case 10:
                if (caml_parser_trace) log("State " + state + ": reduce by rule " + n);
                var m = tables.len[n];
                env[env_asp] = sp;
                env[env_rule_number] = n;
                env[env_rule_len] = m;
                sp = sp - m + 1;
                m = tables.lhs[n];
                state1 = env[env_s_stack][sp];
                n1 = tables.gindex[m];
                n2 = n1 + state1;
                if (n1 != 0 && n2 >= 0 && n2 <= tables[tbl_tablesize] && tables.check[n2] == state1) state = tables.table[n2];
                else state = tables.dgoto[m];
                if (sp >= env[env_stacksize]) {
                    res = GROW_STACKS_2;
                    break exit;
                }
            case 3:
                res = COMPUTE_SEMANTIC_ACTION;
                break exit;
            case 4:
                env[env_s_stack][sp + 1] = state;
                env[env_v_stack][sp + 1] = arg;
                var asp = env[env_asp];
                env[env_symb_end_stack][sp + 1] = env[env_symb_end_stack][asp + 1];
                if (sp > asp) env[env_symb_start_stack][sp + 1] = env[env_symb_end_stack][asp + 1];
                cmd = loop;
                break;
            default:
                return RAISE_PARSE_ERROR;
        }
        env[env_sp] = sp;
        env[env_state] = state;
        env[env_errflag] = errflag;
        return res;
    }
    function caml_pure_js_expr(s) {
        console.error("caml_pure_js_expr: fallback to runtime evaluation\n");
        return eval(caml_jsstring_of_string(s));
    }
    function caml_raise_not_a_dir(name) {
        caml_raise_sys_error(name + ": Not a directory");
    }
    function caml_raise_not_found() {
        caml_raise_constant(caml_global_data.Not_found);
    }
    function caml_raw_backtrace_length() {
        return 0;
    }
    function caml_raw_backtrace_next_slot() {
        return 0;
    }
    function caml_raw_backtrace_slot() {
        caml_invalid_argument("Printexc.get_raw_backtrace_slot: index out of bounds");
    }
    function caml_read_file_content(name) {
        var name = typeof name == "string" ? caml_string_of_jsbytes(name) : name, root = resolve_fs_device(name);
        if (root.device.exists(root.rest)) {
            var file = root.device.open(root.rest, {
                rdonly: 1
            }), len = file.length(), buf = new Uint8Array(len);
            file.read(0, buf, 0, len);
            return caml_string_of_array(buf);
        }
        caml_raise_no_such_file(caml_jsbytes_of_string(name));
    }
    function caml_recommended_domain_count(unit) {
        return 1;
    }
    function caml_record_backtrace(b) {
        caml_record_backtrace_flag = b;
        return 0;
    }
    function caml_register_channel_for_spacetime(_channel) {
        return 0;
    }
    function caml_register_global(n, v, name_opt) {
        if (name_opt) {
            var name = name_opt;
            if (globalThis1.toplevelReloc) n = caml_callback(globalThis1.toplevelReloc, [
                name
            ]);
            else if (caml_global_data.symbols) {
                if (!caml_global_data.symidx) caml_global_data.symidx = caml_build_symbols(caml_global_data.symbols);
                var nid = caml_global_data.symidx[name];
                if (nid >= 0) n = nid;
                else caml_failwith("caml_register_global: cannot locate " + name);
            }
        }
        caml_global_data[n + 1] = v;
        if (name_opt) caml_global_data[name_opt] = v;
    }
    function caml_register_named_value(nm, v) {
        caml_named_values[caml_jsbytes_of_string(nm)] = v;
        return 0;
    }
    function caml_restore_raw_backtrace(exn, bt) {
        return 0;
    }
    function caml_round_float(x) {
        if (x >= 0) {
            var y = Math.floor(x);
            return x - y >= 0.5 ? y + 1 : y;
        } else {
            var y = Math.ceil(x);
            return y - x >= 0.5 ? y - 1 : y;
        }
    }
    function caml_runtime_events_create_cursor(target) {
        return {};
    }
    function caml_runtime_events_free_cursor(cursor) {
        return 0;
    }
    function caml_runtime_events_read_poll(cursor, callbacks, num) {
        return 0;
    }
    function caml_runtime_events_user_register(event_name, event_tag, event_type) {
        caml_custom_event_index += 1;
        return [
            0,
            caml_custom_event_index,
            event_name,
            event_type,
            event_tag
        ];
    }
    function caml_runtime_events_user_resolve() {
        return 0;
    }
    function caml_runtime_events_user_write(event, event_content) {
        return 0;
    }
    function caml_runtime_parameters(_unit) {
        return caml_string_of_jsbytes("");
    }
    function caml_runtime_variant(_unit) {
        return caml_string_of_jsbytes("");
    }
    function caml_set_oo_id(b) {
        b[2] = caml_oo_last_id++;
        return b;
    }
    function caml_set_parser_trace(bool) {
        var oldflag = caml_parser_trace;
        caml_parser_trace = bool;
        return oldflag;
    }
    function caml_set_static_env(k, v) {
        if (!globalThis1.jsoo_static_env) globalThis1.jsoo_static_env = {};
        globalThis1.jsoo_static_env[k] = v;
        return 0;
    }
    function caml_signbit_float(x) {
        if (x == 0) x = 1 / x;
        return x < 0 ? 1 : 0;
    }
    function caml_sinh_float(x) {
        return Math.sinh(x);
    }
    function caml_spacetime_enabled(_unit) {
        return 0;
    }
    function caml_spacetime_only_works_for_native_code() {
        caml_failwith("Spacetime profiling only works for native code");
    }
    function caml_sse2_float64_max_bytecode(x, y) {
        return x > y ? x : y;
    }
    function caml_sse2_float64_min_bytecode(x, y) {
        return x < y ? x : y;
    }
    function caml_str_initialize(unit) {
        return 0;
    }
    function caml_string_bound_error() {
        caml_invalid_argument("index out of bounds");
    }
    function caml_string_concat(a, b) {
        return a + b;
    }
    function caml_string_equal(s1, s2) {
        if (s1 === s2) return 1;
        return 0;
    }
    function caml_string_get(s, i) {
        if (i >>> 0 >= caml_ml_string_length(s)) caml_string_bound_error();
        return caml_string_unsafe_get(s, i);
    }
    function caml_string_get16(s, i) {
        if (i >>> 0 >= caml_ml_string_length(s) - 1) caml_string_bound_error();
        var b1 = caml_string_unsafe_get(s, i), b2 = caml_string_unsafe_get(s, i + 1);
        return b2 << 8 | b1;
    }
    function caml_string_get32(s, i) {
        if (i >>> 0 >= caml_ml_string_length(s) - 3) caml_string_bound_error();
        var b1 = caml_string_unsafe_get(s, i), b2 = caml_string_unsafe_get(s, i + 1), b3 = caml_string_unsafe_get(s, i + 2), b4 = caml_string_unsafe_get(s, i + 3);
        return b4 << 24 | b3 << 16 | b2 << 8 | b1;
    }
    function caml_string_get64(s, i) {
        if (i >>> 0 >= caml_ml_string_length(s) - 7) caml_string_bound_error();
        var a = new Array(8);
        for(var j = 0; j < 8; j++)a[7 - j] = caml_string_unsafe_get(s, i + j);
        return caml_int64_of_bytes(a);
    }
    function caml_string_lessequal(s1, s2) {
        return s1 <= s2 ? 1 : 0;
    }
    function caml_string_greaterequal(s1, s2) {
        return caml_string_lessequal(s2, s1);
    }
    function caml_string_lessthan(s1, s2) {
        return s1 < s2 ? 1 : 0;
    }
    function caml_string_greaterthan(s1, s2) {
        return caml_string_lessthan(s2, s1);
    }
    function caml_string_hash(h, v) {
        var h = caml_hash_mix_string(h, v), h = caml_hash_mix_final(h);
        return h & 0x3FFFFFFF;
    }
    function caml_string_notequal(s1, s2) {
        return 1 - caml_string_equal(s1, s2);
    }
    function caml_string_set(s, i, c) {
        caml_failwith("caml_string_set");
    }
    function caml_string_set16(s, i, i16) {
        caml_failwith("caml_string_set16");
    }
    function caml_string_set32(s, i, i32) {
        caml_failwith("caml_string_set32");
    }
    function caml_string_set64(s, i, i64) {
        caml_failwith("caml_string_set64");
    }
    function caml_string_unsafe_set(s, i, c) {
        caml_failwith("caml_string_unsafe_set");
    }
    function caml_sys_argv(a) {
        return caml_argv;
    }
    function caml_sys_chdir(dir) {
        var root = resolve_fs_device(dir);
        if (root.device.exists(root.rest)) {
            if (root.rest) caml_current_dir = caml_trailing_slash(root.path + root.rest);
            else caml_current_dir = root.path;
            return 0;
        } else caml_raise_no_such_file(caml_jsbytes_of_string(dir));
    }
    function caml_sys_const_backend_type() {
        return [
            0,
            caml_string_of_jsbytes("js_of_ocaml")
        ];
    }
    function caml_sys_const_big_endian() {
        return 0;
    }
    function caml_sys_const_int_size() {
        return 32;
    }
    function caml_sys_const_max_wosize() {
        return 536870911;
    }
    function caml_sys_const_naked_pointers_checked(_unit) {
        return 0;
    }
    var os_type = globalThis1.process && globalThis1.process.platform && globalThis1.process.platform == "win32" ? "Cygwin" : "Unix";
    function caml_sys_const_ostype_cygwin() {
        return os_type == "Cygwin" ? 1 : 0;
    }
    function caml_sys_const_ostype_unix() {
        return os_type == "Unix" ? 1 : 0;
    }
    function caml_sys_const_ostype_win32() {
        return os_type == "Win32" ? 1 : 0;
    }
    function caml_sys_const_word_size() {
        return 32;
    }
    function caml_sys_executable_name(a) {
        return caml_executable_name;
    }
    function caml_sys_exit(code) {
        if (globalThis1.quit) globalThis1.quit(code);
        if (globalThis1.process && globalThis1.process.exit) globalThis1.process.exit(code);
        caml_invalid_argument("Function 'exit' not implemented");
    }
    function caml_sys_file_exists(name) {
        var root = resolve_fs_device(name);
        return root.device.exists(root.rest);
    }
    function caml_sys_get_argv(a) {
        return [
            0,
            caml_argv[1],
            caml_argv
        ];
    }
    function caml_sys_get_config() {
        return [
            0,
            caml_string_of_jsbytes(os_type),
            32,
            0
        ];
    }
    function caml_sys_getcwd() {
        return caml_string_of_jsbytes(caml_current_dir);
    }
    function caml_sys_getenv(name) {
        var r = jsoo_sys_getenv(caml_jsstring_of_string(name));
        if (r === undefined) caml_raise_not_found();
        return caml_string_of_jsstring(r);
    }
    function caml_sys_is_directory(name) {
        var root = resolve_fs_device(name), a = root.device.is_dir(root.rest);
        return a ? 1 : 0;
    }
    function caml_sys_is_regular_file(name) {
        var root = resolve_fs_device(name);
        return root.device.isFile(root.rest);
    }
    function caml_sys_isatty(_chan) {
        return 0;
    }
    function caml_sys_mkdir(name, perm) {
        var root = resolve_fs_device(name);
        root.device.mkdir(root.rest, perm);
        return 0;
    }
    function caml_sys_modify_argv(arg) {
        caml_argv = arg;
        return 0;
    }
    function caml_sys_random_seed() {
        if (globalThis1.crypto) {
            if (globalThis1.crypto.getRandomValues) {
                var a = globalThis1.crypto.getRandomValues(new Int32Array(4));
                return [
                    0,
                    a[0],
                    a[1],
                    a[2],
                    a[3]
                ];
            } else if (globalThis1.crypto.randomBytes) {
                var a = new Int32Array(globalThis1.crypto.randomBytes(16).buffer);
                return [
                    0,
                    a[0],
                    a[1],
                    a[2],
                    a[3]
                ];
            }
        }
        var now = new Date().getTime(), x = now ^ 0xffffffff * Math.random();
        return [
            0,
            x
        ];
    }
    function caml_sys_read_directory(name) {
        var root = resolve_fs_device(name), a = root.device.readdir(root.rest), l = new Array(a.length + 1);
        l[0] = 0;
        for(var i = 0; i < a.length; i++)l[i + 1] = caml_string_of_jsbytes(a[i]);
        return l;
    }
    function caml_sys_remove(name) {
        var root = resolve_fs_device(name), ok = root.device.unlink(root.rest);
        if (ok == 0) caml_raise_no_such_file(caml_jsbytes_of_string(name));
        return 0;
    }
    function caml_sys_rename(o, n) {
        var o_root = resolve_fs_device(o), n_root = resolve_fs_device(n);
        if (o_root.device != n_root.device) caml_failwith("caml_sys_rename: cannot move file between two filesystem");
        if (!o_root.device.rename) caml_failwith("caml_sys_rename: no implemented");
        o_root.device.rename(o_root.rest, n_root.rest);
    }
    function caml_sys_rmdir(name) {
        var root = resolve_fs_device(name);
        root.device.rmdir(root.rest);
        return 0;
    }
    function caml_sys_system_command(cmd) {
        var cmd = caml_jsstring_of_string(cmd);
        var child_process = (parcelRequire("48K42"));
        if (child_process && child_process.execSync) try {
            child_process.execSync(cmd, {
                stdio: "inherit"
            });
            return 0;
        } catch (e) {
            return 1;
        }
    }
    var caml_initial_time = new Date().getTime() * 0.001;
    function caml_sys_time() {
        var now = new Date().getTime();
        return now * 0.001 - caml_initial_time;
    }
    function caml_sys_time_include_children(b) {
        return caml_sys_time();
    }
    function caml_sys_unsafe_getenv(name) {
        return caml_sys_getenv(name);
    }
    function caml_tanh_float(x) {
        return Math.tanh(x);
    }
    function caml_to_js_string(s) {
        return caml_jsstring_of_string(s);
    }
    function caml_trampoline(res) {
        var c = 1;
        while(res && res.joo_tramp){
            res = res.joo_tramp.apply(null, res.joo_args);
            c++;
        }
        return res;
    }
    function caml_trampoline_return(f, args) {
        return {
            joo_tramp: f,
            joo_args: args
        };
    }
    function caml_trunc_float(x) {
        return Math.trunc(x);
    }
    function caml_unix_cleanup() {}
    function caml_unix_closedir(dir_handle) {
        try {
            dir_handle.pointer.closeSync();
        } catch (e) {
            var unix_error = caml_named_value("Unix.Unix_error");
            caml_raise_with_args(unix_error, make_unix_err_args("EBADF", "closedir", dir_handle.path));
        }
    }
    function caml_unix_filedescr_of_fd(x) {
        return x;
    }
    function caml_unix_findclose(dir_handle) {
        return caml_unix_closedir(dir_handle);
    }
    function caml_unix_opendir(path) {
        var root = resolve_fs_device(path);
        if (!root.device.opendir) caml_failwith("caml_unix_opendir: not implemented");
        var dir_handle = root.device.opendir(root.rest, true);
        return {
            pointer: dir_handle,
            path: path
        };
    }
    function caml_unix_readdir(dir_handle) {
        var entry;
        try {
            entry = dir_handle.pointer.readSync();
        } catch (e) {
            var unix_error = caml_named_value("Unix.Unix_error");
            caml_raise_with_args(unix_error, make_unix_err_args("EBADF", "readdir", dir_handle.path));
        }
        if (entry === null) caml_raise_end_of_file();
        else return caml_string_of_jsstring(entry.name);
    }
    function caml_unix_findfirst(path) {
        var path_js = caml_jsstring_of_string(path);
        path_js = path_js.replace(/(^|[\\\/])\*\.\*$/, "");
        path = caml_string_of_jsstring(path_js);
        var dir_handle = caml_unix_opendir(path), first_entry = caml_unix_readdir(dir_handle);
        return [
            0,
            first_entry,
            dir_handle
        ];
    }
    function caml_unix_findnext(dir_handle) {
        return caml_unix_readdir(dir_handle);
    }
    function caml_unix_getpwuid(unit) {
        caml_raise_not_found();
    }
    function caml_unix_gettimeofday() {
        return new Date().getTime() / 1000;
    }
    function caml_unix_getuid(unit) {
        if (globalThis1.process && globalThis1.process.getuid) return globalThis1.process.getuid();
        caml_raise_not_found();
    }
    function caml_unix_gmtime(t) {
        var d = new Date(t * 1000), d_num = d.getTime(), januaryfirst = new Date(Date.UTC(d.getUTCFullYear(), 0, 1)).getTime(), doy = Math.floor((d_num - januaryfirst) / 86400000);
        return [
            0,
            d.getUTCSeconds(),
            d.getUTCMinutes(),
            d.getUTCHours(),
            d.getUTCDate(),
            d.getUTCMonth(),
            d.getUTCFullYear() - 1900,
            d.getUTCDay(),
            doy,
            0
        ];
    }
    function caml_unix_has_symlink(unit) {
        return fs_node_supported() ? 1 : 0;
    }
    function caml_unix_inet_addr_of_string() {
        return 0;
    }
    function caml_unix_isatty(fileDescriptor) {
        if (fs_node_supported()) {
            var tty = (parcelRequire("85dKZ"));
            return tty.isatty(fileDescriptor) ? 1 : 0;
        } else return 0;
    }
    function caml_unix_localtime(t) {
        var d = new Date(t * 1000), d_num = d.getTime(), januaryfirst = new Date(d.getFullYear(), 0, 1).getTime(), doy = Math.floor((d_num - januaryfirst) / 86400000), jan = new Date(d.getFullYear(), 0, 1), jul = new Date(d.getFullYear(), 6, 1), stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
        return [
            0,
            d.getSeconds(),
            d.getMinutes(),
            d.getHours(),
            d.getDate(),
            d.getMonth(),
            d.getFullYear() - 1900,
            d.getDay(),
            doy,
            d.getTimezoneOffset() < stdTimezoneOffset | 0
        ];
    }
    function caml_unix_lstat(name) {
        var root = resolve_fs_device(name);
        if (!root.device.lstat) caml_failwith("caml_unix_lstat: not implemented");
        return root.device.lstat(root.rest, true);
    }
    function caml_unix_lstat_64(name) {
        var r = caml_unix_lstat(name);
        r[9] = caml_int64_of_int32(r[9]);
        return r;
    }
    function caml_unix_mkdir(name, perm) {
        var root = resolve_fs_device(name);
        if (!root.device.mkdir) caml_failwith("caml_unix_mkdir: not implemented");
        return root.device.mkdir(root.rest, perm, true);
    }
    function caml_unix_mktime(tm) {
        var d = new Date(tm[6] + 1900, tm[5], tm[4], tm[3], tm[2], tm[1]).getTime(), t = Math.floor(d / 1000), tm2 = caml_unix_localtime(t);
        return [
            0,
            t,
            tm2
        ];
    }
    function caml_unix_readlink(name) {
        var root = resolve_fs_device(name);
        if (!root.device.readlink) caml_failwith("caml_unix_readlink: not implemented");
        return root.device.readlink(root.rest, true);
    }
    function caml_unix_rewinddir(dir_handle) {
        caml_unix_closedir(dir_handle);
        var new_dir_handle = caml_unix_opendir(dir_handle.path);
        dir_handle.pointer = new_dir_handle.pointer;
        return 0;
    }
    function caml_unix_rmdir(name) {
        var root = resolve_fs_device(name);
        if (!root.device.rmdir) caml_failwith("caml_unix_rmdir: not implemented");
        return root.device.rmdir(root.rest, true);
    }
    function caml_unix_startup() {}
    function caml_unix_stat(name) {
        var root = resolve_fs_device(name);
        if (!root.device.stat) caml_failwith("caml_unix_stat: not implemented");
        return root.device.stat(root.rest, true);
    }
    function caml_unix_stat_64(name) {
        var r = caml_unix_stat(name);
        r[9] = caml_int64_of_int32(r[9]);
        return r;
    }
    function caml_unix_symlink(to_dir, src, dst) {
        var src_root = resolve_fs_device(src), dst_root = resolve_fs_device(dst);
        if (src_root.device != dst_root.device) caml_failwith("caml_unix_symlink: cannot symlink between two filesystems");
        if (!src_root.device.symlink) caml_failwith("caml_unix_symlink: not implemented");
        return src_root.device.symlink(to_dir, src_root.rest, dst_root.rest, true);
    }
    function caml_unix_time() {
        return Math.floor(caml_unix_gettimeofday());
    }
    function caml_unix_unlink(name) {
        var root = resolve_fs_device(name);
        if (!root.device.unlink) caml_failwith("caml_unix_unlink: not implemented");
        return root.device.unlink(root.rest, true);
    }
    function caml_unmount(name) {
        var path = caml_make_path(name), name = caml_trailing_slash(path.join("/")), idx = -1;
        for(var i = 0; i < jsoo_mount_point.length; i++)if (jsoo_mount_point[i].path == name) idx = i;
        if (idx > -1) jsoo_mount_point.splice(idx, 1);
        return 0;
    }
    function caml_update_dummy(x, y) {
        if (y.fun) {
            x.fun = y.fun;
            return 0;
        }
        if (typeof y === "function") {
            x.fun = y;
            return 0;
        }
        var i = y.length;
        while(i--)x[i] = y[i];
        return 0;
    }
    function caml_weak_set(x, i, v) {
        if (v == 0) caml_ephe_unset_key(x, i);
        else caml_ephe_set_key(x, i, v[1]);
        return 0;
    }
    function caml_wrap_exception(e) {
        if (e instanceof Array) return e;
        var exn;
        if (globalThis1.RangeError && e instanceof globalThis1.RangeError && e.message && e.message.match(/maximum call stack/i)) exn = caml_global_data.Stack_overflow;
        else if (globalThis1.InternalError && e instanceof globalThis1.InternalError && e.message && e.message.match(/too much recursion/i)) exn = caml_global_data.Stack_overflow;
        else if (e instanceof globalThis1.Error && caml_named_value("jsError")) exn = [
            0,
            caml_named_value("jsError"),
            e
        ];
        else exn = [
            0,
            caml_global_data.Failure,
            caml_string_of_jsstring(String(e))
        ];
        if (e instanceof globalThis1.Error) exn.js_error = e;
        return exn;
    }
    function caml_xdg_defaults(_unit) {
        return 0;
    }
    function caml_xmlhttprequest_create(unit) {
        if (typeof globalThis1.XMLHttpRequest !== "undefined") try {
            return new globalThis1.XMLHttpRequest;
        } catch (e) {}
        if (typeof globalThis1.activeXObject !== "undefined") {
            try {
                return new globalThis1.activeXObject("Msxml2.XMLHTTP");
            } catch (e) {}
            try {
                return new globalThis1.activeXObject("Msxml3.XMLHTTP");
            } catch (e) {}
            try {
                return new globalThis1.activeXObject("Microsoft.XMLHTTP");
            } catch (e) {}
        }
        caml_failwith("Cannot create a XMLHttpRequest");
    }
    function caml_zstd_initialize(unit) {
        caml_decompress_input = zstd_decompress;
        return 1;
    }
    function compare_digits_nat(nat1, ofs1, nat2, ofs2) {
        if (nat1.data[ofs1] > nat2.data[ofs2]) return 1;
        if (nat1.data[ofs1] < nat2.data[ofs2]) return -1;
        return 0;
    }
    function compare_nat(nat1, ofs1, len1, nat2, ofs2, len2) {
        var a = num_digits_nat(nat1, ofs1, len1), b = num_digits_nat(nat2, ofs2, len2);
        if (a > b) return 1;
        if (a < b) return -1;
        for(var i = len1 - 1; i >= 0; i--){
            if (nat1.data[ofs1 + i] >>> 0 > nat2.data[ofs2 + i] >>> 0) return 1;
            if (nat1.data[ofs1 + i] >>> 0 < nat2.data[ofs2 + i] >>> 0) return -1;
        }
        return 0;
    }
    function compare_nat_real(nat1, nat2) {
        return compare_nat(nat1, 0, nat1.data.length, nat2, 0, nat2.data.length);
    }
    function complement_nat(nat, ofs, len) {
        for(var i = 0; i < len; i++)nat.data[ofs + i] = 4294967295 - (nat.data[ofs + i] >>> 0);
    }
    function create_nat(size) {
        var arr = new MlNat(size);
        for(var i = 0; i < size; i++)arr.data[i] = -1;
        return arr;
    }
    function decr_nat(nat, ofs, len, carry_in) {
        var borrow = carry_in == 1 ? 0 : 1;
        for(var i = 0; i < len; i++){
            var x = (nat.data[ofs + i] >>> 0) - borrow;
            nat.data[ofs + i] = x;
            if (x >= 0) {
                borrow = 0;
                break;
            } else borrow = 1;
        }
        return borrow == 1 ? 0 : 1;
    }
    function deserialize_nat(reader, sz) {
        var len = reader.read32s(), nat = new MlNat(len);
        for(var i = 0; i < len; i++)nat.data[i] = reader.read32s();
        sz[0] = len * 4;
        return nat;
    }
    function div_helper(a, b, c) {
        var x = a * 65536 + (b >>> 16), y = Math.floor(x / c) * 65536, z = x % c * 65536, w = z + (b & 0x0000FFFF);
        return [
            y + Math.floor(w / c),
            w % c
        ];
    }
    function div_digit_nat(natq, ofsq, natr, ofsr, nat1, ofs1, len, nat2, ofs2) {
        var rem = nat1.data[ofs1 + len - 1] >>> 0;
        for(var i = len - 2; i >= 0; i--){
            var x = div_helper(rem, nat1.data[ofs1 + i] >>> 0, nat2.data[ofs2] >>> 0);
            natq.data[ofsq + i] = x[0];
            rem = x[1];
        }
        natr.data[ofsr] = rem;
        return 0;
    }
    function num_leading_zero_bits_in_digit(nat, ofs) {
        var a = nat.data[ofs], b = 0;
        if (a & 0xFFFF0000) {
            b += 16;
            a >>>= 16;
        }
        if (a & 0xFF00) {
            b += 8;
            a >>>= 8;
        }
        if (a & 0xF0) {
            b += 4;
            a >>>= 4;
        }
        if (a & 12) {
            b += 2;
            a >>>= 2;
        }
        if (a & 2) {
            b += 1;
            a >>>= 1;
        }
        if (a & 1) b += 1;
        return 32 - b;
    }
    function shift_left_nat(nat1, ofs1, len1, nat2, ofs2, nbits) {
        if (nbits == 0) {
            nat2.data[ofs2] = 0;
            return 0;
        }
        var wrap = 0;
        for(var i = 0; i < len1; i++){
            var a = nat1.data[ofs1 + i] >>> 0;
            nat1.data[ofs1 + i] = a << nbits | wrap;
            wrap = a >>> 32 - nbits;
        }
        nat2.data[ofs2] = wrap;
        return 0;
    }
    function shift_right_nat(nat1, ofs1, len1, nat2, ofs2, nbits) {
        if (nbits == 0) {
            nat2.data[ofs2] = 0;
            return 0;
        }
        var wrap = 0;
        for(var i = len1 - 1; i >= 0; i--){
            var a = nat1.data[ofs1 + i] >>> 0;
            nat1.data[ofs1 + i] = a >>> nbits | wrap;
            wrap = a << 32 - nbits;
        }
        nat2.data[ofs2] = wrap;
        return 0;
    }
    function set_to_zero_nat(nat, ofs, len) {
        for(var i = 0; i < len; i++)nat.data[ofs + i] = 0;
        return 0;
    }
    function nat_of_array(l) {
        return new MlNat(l);
    }
    function mult_digit_nat(nat1, ofs1, len1, nat2, ofs2, len2, nat3, ofs3) {
        var carry = 0, a = nat3.data[ofs3] >>> 0;
        for(var i = 0; i < len2; i++){
            var x1 = (nat1.data[ofs1 + i] >>> 0) + (nat2.data[ofs2 + i] >>> 0) * (a & 0x0000FFFF) + carry, x2 = (nat2.data[ofs2 + i] >>> 0) * (a >>> 16);
            carry = Math.floor(x2 / 65536);
            var x3 = x1 + x2 % 65536 * 65536;
            nat1.data[ofs1 + i] = x3;
            carry += Math.floor(x3 / 4294967296);
        }
        return len2 < len1 && carry ? add_nat(nat1, ofs1 + len2, len1 - len2, nat_of_array([
            carry
        ]), 0, 1, 0) : carry;
    }
    function sub_nat(nat1, ofs1, len1, nat2, ofs2, len2, carry_in) {
        var borrow = carry_in == 1 ? 0 : 1;
        for(var i = 0; i < len2; i++){
            var x = (nat1.data[ofs1 + i] >>> 0) - (nat2.data[ofs2 + i] >>> 0) - borrow;
            nat1.data[ofs1 + i] = x;
            if (x >= 0) borrow = 0;
            else borrow = 1;
        }
        return decr_nat(nat1, ofs1 + len2, len1 - len2, borrow == 1 ? 0 : 1);
    }
    function div_nat(nat1, ofs1, len1, nat2, ofs2, len2) {
        if (len2 == 1) {
            div_digit_nat(nat1, ofs1 + 1, nat1, ofs1, nat1, ofs1, len1, nat2, ofs2);
            return 0;
        }
        var s = num_leading_zero_bits_in_digit(nat2, ofs2 + len2 - 1);
        shift_left_nat(nat2, ofs2, len2, nat_of_array([
            0
        ]), 0, s);
        shift_left_nat(nat1, ofs1, len1, nat_of_array([
            0
        ]), 0, s);
        var d = (nat2.data[ofs2 + len2 - 1] >>> 0) + 1, a = create_nat(len2 + 1);
        for(var i = len1 - 1; i >= len2; i--){
            var quo = d == 4294967296 ? nat1.data[ofs1 + i] >>> 0 : div_helper(nat1.data[ofs1 + i] >>> 0, nat1.data[ofs1 + i - 1] >>> 0, d)[0];
            set_to_zero_nat(a, 0, len2 + 1);
            mult_digit_nat(a, 0, len2 + 1, nat2, ofs2, len2, nat_of_array([
                quo
            ]), 0);
            sub_nat(nat1, ofs1 + i - len2, len2 + 1, a, 0, len2 + 1, 1);
            while(nat1.data[ofs1 + i] != 0 || compare_nat(nat1, ofs1 + i - len2, len2, nat2, ofs2, len2) >= 0){
                quo = quo + 1;
                sub_nat(nat1, ofs1 + i - len2, len2 + 1, nat2, ofs2, len2, 1);
            }
            nat1.data[ofs1 + i] = quo;
        }
        shift_right_nat(nat1, ofs1, len2, nat_of_array([
            0
        ]), 0, s);
        shift_right_nat(nat2, ofs2, len2, nat_of_array([
            0
        ]), 0, s);
        return 0;
    }
    function serialize_nat(writer, nat, sz) {
        var len = nat.data.length;
        writer.write(32, len);
        for(var i = 0; i < len; i++)writer.write(32, nat.data[i]);
        sz[0] = len * 4;
        sz[1] = len * 8;
    }
    function initialize_nat() {
        caml_custom_ops["_nat"] = {
            deserialize: deserialize_nat,
            serialize: serialize_nat,
            hash: caml_hash_nat
        };
    }
    function is_digit_int(nat, ofs) {
        if (nat.data[ofs] >= 0) return 1;
        return 0;
    }
    function is_digit_odd(nat, ofs) {
        if (nat.data[ofs] & 1) return 1;
        return 0;
    }
    function is_digit_zero(nat, ofs) {
        if (nat.data[ofs] == 0) return 1;
        return 0;
    }
    function jsoo_create_file_extern(name, content) {
        if (globalThis1.jsoo_create_file) globalThis1.jsoo_create_file(name, content);
        else {
            if (!globalThis1.caml_fs_tmp) globalThis1.caml_fs_tmp = [];
            globalThis1.caml_fs_tmp.push({
                name: name,
                content: content
            });
        }
        return 0;
    }
    function jsoo_effect_not_supported() {
        caml_failwith("Effect handlers are not supported");
    }
    function land_digit_nat(nat1, ofs1, nat2, ofs2) {
        nat1.data[ofs1] &= nat2.data[ofs2];
        return 0;
    }
    function length_nat(x) {
        return x.data.length;
    }
    function lor_digit_nat(nat1, ofs1, nat2, ofs2) {
        nat1.data[ofs1] |= nat2.data[ofs2];
        return 0;
    }
    function lxor_digit_nat(nat1, ofs1, nat2, ofs2) {
        nat1.data[ofs1] ^= nat2.data[ofs2];
        return 0;
    }
    function ms_float_to_ns_int64(ms) {
        return caml_int64_of_float(ms * 1000000);
    }
    function mult_nat(nat1, ofs1, len1, nat2, ofs2, len2, nat3, ofs3, len3) {
        var carry = 0;
        for(var i = 0; i < len3; i++)carry += mult_digit_nat(nat1, ofs1 + i, len1 - i, nat2, ofs2, len2, nat3, ofs3 + i);
        return carry;
    }
    function nth_digit_nat(nat, ofs) {
        return nat.data[ofs];
    }
    function nth_digit_nat_native(nat, ofs) {
        return nat.data[ofs];
    }
    var ppx_expect_runtime_saved_stderr, ppx_expect_runtime_saved_stdout;
    function ppx_expect_runtime_after_test(vstdout, vstderr) {
        caml_ml_channel_restore(vstdout, ppx_expect_runtime_saved_stdout);
        caml_ml_channel_restore(vstderr, ppx_expect_runtime_saved_stderr);
        return 0;
    }
    function ppx_expect_runtime_before_test(voutput, vstdout, vstderr) {
        ppx_expect_runtime_saved_stderr = caml_ml_channel_redirect(vstderr, voutput);
        ppx_expect_runtime_saved_stdout = caml_ml_channel_redirect(vstdout, voutput);
        return 0;
    }
    function ppx_expect_runtime_flush_stubs_streams(vunit) {
        return 0;
    }
    function ppx_expect_runtime_out_channel_position(chan) {
        var info = caml_ml_channel_get(chan);
        return info.offset;
    }
    var re_match = function() {
        var re_word_letters = [
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0xFF,
            0x03,
            0xFE,
            0xFF,
            0xFF,
            0x87,
            0xFE,
            0xFF,
            0xFF,
            0x07,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0xFF,
            0xFF,
            0x7F,
            0xFF,
            0xFF,
            0xFF,
            0x7F,
            0xFF
        ], opcodes = {
            CHAR: 0,
            CHARNORM: 1,
            STRING: 2,
            STRINGNORM: 3,
            CHARCLASS: 4,
            BOL: 5,
            EOL: 6,
            WORDBOUNDARY: 7,
            BEGGROUP: 8,
            ENDGROUP: 9,
            REFGROUP: 10,
            ACCEPT: 11,
            SIMPLEOPT: 12,
            SIMPLESTAR: 13,
            SIMPLEPLUS: 14,
            GOTO: 15,
            PUSHBACK: 16,
            SETMARK: 17,
            CHECKPROGRESS: 18
        };
        function is_word_letter(c) {
            return re_word_letters[c >> 3] >> (c & 7) & 1;
        }
        function in_bitset(s, i) {
            return caml_string_get(s, i >> 3) >> (i & 7) & 1;
        }
        function re_match_impl(re, s, pos, partial) {
            var prog = caml_js_from_array(re[1]), cpool = caml_js_from_array(re[2]), normtable = caml_jsbytes_of_string(re[3]), numgroups = re[4] | 0, numregisters = re[5] | 0, startchars = re[6] | 0, s = caml_uint8_array_of_string(s), pc = 0, quit = false, stack = [], groups = new Array(numgroups), re_register = new Array(numregisters);
            for(var i = 0; i < groups.length; i++)groups[i] = {
                start: -1,
                end: -1
            };
            groups[0].start = pos;
            function backtrack() {
                while(stack.length){
                    var item = stack.pop();
                    if (item.undo) item.undo.obj[item.undo.prop] = item.undo.value;
                    else if (item.pos) {
                        pc = item.pos.pc;
                        pos = item.pos.txt;
                        return;
                    }
                }
                quit = true;
            }
            function push(item) {
                stack.push(item);
            }
            function accept() {
                groups[0].end = pos;
                var result = new Array(1 + groups.length * 2);
                result[0] = 0;
                for(var i = 0; i < groups.length; i++){
                    var g = groups[i];
                    if (g.start < 0 || g.end < 0) g.start = g.end = -1;
                    result[2 * i + 1] = g.start;
                    result[2 * i + 1 + 1] = g.end;
                }
                return result;
            }
            function prefix_match() {
                if (partial) return accept();
                else backtrack();
            }
            while(!quit){
                var op = prog[pc] & 0xff, sarg = prog[pc] >> 8, uarg = sarg & 0xff, c = s[pos], group;
                pc++;
                switch(op){
                    case opcodes.CHAR:
                        if (pos === s.length) {
                            prefix_match();
                            break;
                        }
                        if (c === uarg) pos++;
                        else backtrack();
                        break;
                    case opcodes.CHARNORM:
                        if (pos === s.length) {
                            prefix_match();
                            break;
                        }
                        if (normtable.charCodeAt(c) === uarg) pos++;
                        else backtrack();
                        break;
                    case opcodes.STRING:
                        for(var arg = caml_jsbytes_of_string(cpool[uarg]), i = 0; i < arg.length; i++){
                            if (pos === s.length) {
                                prefix_match();
                                break;
                            }
                            if (c === arg.charCodeAt(i)) c = s[++pos];
                            else {
                                backtrack();
                                break;
                            }
                        }
                        break;
                    case opcodes.STRINGNORM:
                        for(var arg = caml_jsbytes_of_string(cpool[uarg]), i = 0; i < arg.length; i++){
                            if (pos === s.length) {
                                prefix_match();
                                break;
                            }
                            if (normtable.charCodeAt(c) === arg.charCodeAt(i)) c = s[++pos];
                            else {
                                backtrack();
                                break;
                            }
                        }
                        break;
                    case opcodes.CHARCLASS:
                        if (pos === s.length) {
                            prefix_match();
                            break;
                        }
                        if (in_bitset(cpool[uarg], c)) pos++;
                        else backtrack();
                        break;
                    case opcodes.BOL:
                        if (pos > 0 && s[pos - 1] != 10) backtrack();
                        break;
                    case opcodes.EOL:
                        if (pos < s.length && s[pos] != 10) backtrack();
                        break;
                    case opcodes.WORDBOUNDARY:
                        if (pos == 0) {
                            if (pos === s.length) {
                                prefix_match();
                                break;
                            }
                            if (is_word_letter(s[0])) break;
                            backtrack();
                        } else if (pos === s.length) {
                            if (is_word_letter(s[pos - 1])) break;
                            backtrack();
                        } else {
                            if (is_word_letter(s[pos - 1]) != is_word_letter(s[pos])) break;
                            backtrack();
                        }
                        break;
                    case opcodes.BEGGROUP:
                        group = groups[uarg];
                        push({
                            undo: {
                                obj: group,
                                prop: "start",
                                value: group.start
                            }
                        });
                        group.start = pos;
                        break;
                    case opcodes.ENDGROUP:
                        group = groups[uarg];
                        push({
                            undo: {
                                obj: group,
                                prop: "end",
                                value: group.end
                            }
                        });
                        group.end = pos;
                        break;
                    case opcodes.REFGROUP:
                        group = groups[uarg];
                        if (group.start < 0 || group.end < 0) {
                            backtrack();
                            break;
                        }
                        for(var i = group.start; i < group.end; i++){
                            if (pos === s.length) {
                                prefix_match();
                                break;
                            }
                            if (s[i] != s[pos]) {
                                backtrack();
                                break;
                            }
                            pos++;
                        }
                        break;
                    case opcodes.SIMPLEOPT:
                        if (in_bitset(cpool[uarg], c)) pos++;
                        break;
                    case opcodes.SIMPLESTAR:
                        while(in_bitset(cpool[uarg], c))c = s[++pos];
                        break;
                    case opcodes.SIMPLEPLUS:
                        if (pos === s.length) {
                            prefix_match();
                            break;
                        }
                        if (in_bitset(cpool[uarg], c)) do c = s[++pos];
                        while (in_bitset(cpool[uarg], c));
                        else backtrack();
                        break;
                    case opcodes.ACCEPT:
                        return accept();
                    case opcodes.GOTO:
                        pc = pc + sarg;
                        break;
                    case opcodes.PUSHBACK:
                        push({
                            pos: {
                                pc: pc + sarg,
                                txt: pos
                            }
                        });
                        break;
                    case opcodes.SETMARK:
                        push({
                            undo: {
                                obj: re_register,
                                prop: uarg,
                                value: re_register[uarg]
                            }
                        });
                        re_register[uarg] = pos;
                        break;
                    case opcodes.CHECKPROGRESS:
                        if (re_register[uarg] === pos) backtrack();
                        break;
                    default:
                        throw new Error("Invalid bytecode");
                }
            }
            return 0;
        }
        return re_match_impl;
    }();
    function re_partial_match(re, s, pos) {
        if (pos < 0 || pos > caml_ml_string_length(s)) caml_invalid_argument("Str.partial_match");
        var res = re_match(re, s, pos, 1);
        return res ? res : [
            0
        ];
    }
    function re_replacement_text(repl, groups, orig) {
        var repl = caml_jsbytes_of_string(repl), len = repl.length, orig = caml_jsbytes_of_string(orig), res = "", n = 0, cur, start, end, c;
        while(n < len){
            cur = repl.charAt(n++);
            if (cur != "\\") res += cur;
            else {
                if (n == len) caml_failwith("Str.replace: illegal backslash sequence");
                cur = repl.charAt(n++);
                switch(cur){
                    case "\\":
                        res += cur;
                        break;
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        c = +cur;
                        if (c * 2 >= groups.length - 1) caml_failwith("Str.replace: reference to unmatched group");
                        start = caml_array_get(groups, c * 2);
                        end = caml_array_get(groups, c * 2 + 1);
                        if (start == -1) caml_failwith("Str.replace: reference to unmatched group");
                        res += orig.slice(start, end);
                        break;
                    default:
                        res += "\\" + cur;
                }
            }
        }
        return caml_string_of_jsbytes(res);
    }
    function re_search_backward(re, s, pos) {
        if (pos < 0 || pos > caml_ml_string_length(s)) caml_invalid_argument("Str.search_backward");
        while(pos >= 0){
            var res = re_match(re, s, pos, 0);
            if (res) return res;
            pos--;
        }
        return [
            0
        ];
    }
    function re_search_forward(re, s, pos) {
        if (pos < 0 || pos > caml_ml_string_length(s)) caml_invalid_argument("Str.search_forward");
        while(pos <= caml_ml_string_length(s)){
            var res = re_match(re, s, pos, 0);
            if (res) return res;
            pos++;
        }
        return [
            0
        ];
    }
    function re_string_match(re, s, pos) {
        if (pos < 0 || pos > caml_ml_string_length(s)) caml_invalid_argument("Str.string_match");
        var res = re_match(re, s, pos, 0);
        return res ? res : [
            0
        ];
    }
    function set_digit_nat(nat, ofs, digit) {
        nat.data[ofs] = digit;
        return 0;
    }
    function set_digit_nat_native(nat, ofs, digit) {
        nat.data[ofs] = digit;
        return 0;
    }
    function square_nat(nat1, ofs1, len1, nat2, ofs2, len2) {
        var carry = 0;
        carry += add_nat(nat1, ofs1, len1, nat1, ofs1, len1, 0);
        carry += mult_nat(nat1, ofs1, len1, nat2, ofs2, len2, nat2, ofs2, len2);
        return carry;
    }
    function time_now_nanosecond_counter_for_timing() {
        var ms_since_program_started = performance.now(), ns_since_program_started = ms_float_to_ns_int64(ms_since_program_started);
        return caml_int64_shift_left(ns_since_program_started, 1);
    }
    var ms_to_nano = caml_int64_of_int32(1000000);
    function time_now_nanoseconds_since_unix_epoch_or_zero() {
        var ms = Date.now(), ms_i63 = caml_int64_of_float(ms * 2);
        return caml_int64_mul(ms_i63, ms_to_nano);
    }
    function caml_setup_uncaught_exception_handler() {
        var process = globalThis1.process;
        if (process && process.on) process.on("uncaughtException", function(err, origin) {
            caml_fatal_uncaught_exception(err);
            process.exit(2);
        });
        else if (globalThis1.addEventListener) globalThis1.addEventListener("error", function(event) {
            if (event.error) caml_fatal_uncaught_exception(event.error);
        });
    }
    caml_setup_uncaught_exception_handler();
    globalThis1.jsoo_runtime = {
        ppx_expect_runtime_flush_stubs_streams: ppx_expect_runtime_flush_stubs_streams,
        ppx_expect_runtime_out_channel_position: ppx_expect_runtime_out_channel_position,
        ppx_expect_runtime_after_test: ppx_expect_runtime_after_test,
        ppx_expect_runtime_before_test: ppx_expect_runtime_before_test,
        ppx_expect_runtime_saved_stderr: ppx_expect_runtime_saved_stderr,
        ppx_expect_runtime_saved_stdout: ppx_expect_runtime_saved_stdout,
        time_now_nanosecond_counter_for_timing: time_now_nanosecond_counter_for_timing,
        ms_float_to_ns_int64: ms_float_to_ns_int64,
        time_now_nanoseconds_since_unix_epoch_or_zero: time_now_nanoseconds_since_unix_epoch_or_zero,
        caml_dummy_obj_is_stack: caml_dummy_obj_is_stack,
        caml_make_local_vect: caml_make_local_vect,
        Base_unsafe_create_local_bytes: Base_unsafe_create_local_bytes,
        Base_am_testing: Base_am_testing,
        Base_hash_double: Base_hash_double,
        Base_hash_string: Base_hash_string,
        Base_int_math_int64_pow_stub: Base_int_math_int64_pow_stub,
        Base_int_math_int_pow_stub: Base_int_math_int_pow_stub,
        Base_int_math_int64_ctz: Base_int_math_int64_ctz,
        Base_int_math_nativeint_ctz: Base_int_math_nativeint_ctz,
        Base_int_math_int_ctz: Base_int_math_int_ctz,
        Base_int_math_int32_ctz: Base_int_math_int32_ctz,
        Base_int_math_int64_clz: Base_int_math_int64_clz,
        Base_int_math_nativeint_clz: Base_int_math_nativeint_clz,
        Base_int_math_int_clz: Base_int_math_int_clz,
        Base_int_math_int32_clz: Base_int_math_int32_clz,
        Base_caml_exn_is_most_recent_exn: Base_caml_exn_is_most_recent_exn,
        Base_clear_caml_backtrace_pos: Base_clear_caml_backtrace_pos,
        Base_int_math_int_popcount: Base_int_math_int_popcount,
        caml_sse2_float64_max_bytecode: caml_sse2_float64_max_bytecode,
        caml_sse2_float64_min_bytecode: caml_sse2_float64_min_bytecode,
        caml_csel_value: caml_csel_value,
        Base_internalhash_get_hash_value: Base_internalhash_get_hash_value,
        Base_internalhash_fold_string: Base_internalhash_fold_string,
        Base_internalhash_fold_float: Base_internalhash_fold_float,
        Base_internalhash_fold_int: Base_internalhash_fold_int,
        Base_internalhash_fold_int64: Base_internalhash_fold_int64,
        caml_blake2_string: caml_blake2_string,
        caml_blake2_update: caml_blake2_update,
        caml_blake2_final: caml_blake2_final,
        caml_blake2_create: caml_blake2_create,
        blake2b: blake2b,
        caml_runtime_events_read_poll: caml_runtime_events_read_poll,
        caml_runtime_events_free_cursor: caml_runtime_events_free_cursor,
        caml_runtime_events_create_cursor: caml_runtime_events_create_cursor,
        caml_ml_runtime_events_resume: caml_ml_runtime_events_resume,
        caml_ml_runtime_events_are_active: caml_ml_runtime_events_are_active,
        caml_ml_runtime_events_pause: caml_ml_runtime_events_pause,
        caml_ml_runtime_events_start: caml_ml_runtime_events_start,
        caml_runtime_events_user_resolve: caml_runtime_events_user_resolve,
        caml_runtime_events_user_write: caml_runtime_events_user_write,
        caml_runtime_events_user_register: caml_runtime_events_user_register,
        caml_custom_event_index: caml_custom_event_index,
        caml_zstd_initialize: caml_zstd_initialize,
        caml_decompress_input: caml_decompress_input,
        zstd_decompress: zstd_decompress,
        jsoo_effect_not_supported: jsoo_effect_not_supported,
        caml_ml_condition_signal: caml_ml_condition_signal,
        caml_ml_condition_broadcast: caml_ml_condition_broadcast,
        caml_ml_condition_wait: caml_ml_condition_wait,
        caml_ml_condition_new: caml_ml_condition_new,
        caml_get_continuation_callstack: caml_get_continuation_callstack,
        caml_continuation_use_and_update_handler_noexc: caml_continuation_use_and_update_handler_noexc,
        caml_continuation_use_noexc: caml_continuation_use_noexc,
        caml_alloc_stack: caml_alloc_stack,
        caml_ml_mutex_unlock: caml_ml_mutex_unlock,
        caml_ml_mutex_try_lock: caml_ml_mutex_try_lock,
        caml_ml_mutex_lock: caml_ml_mutex_lock,
        caml_ml_mutex_new: caml_ml_mutex_new,
        MlMutex: MlMutex,
        caml_lxm_next: caml_lxm_next,
        caml_ml_domain_cpu_relax: caml_ml_domain_cpu_relax,
        caml_ml_domain_id: caml_ml_domain_id,
        caml_domain_spawn: caml_domain_spawn,
        caml_domain_id: caml_domain_id,
        caml_recommended_domain_count: caml_recommended_domain_count,
        caml_ml_domain_set_name: caml_ml_domain_set_name,
        caml_atomic_make_contended: caml_atomic_make_contended,
        caml_atomic_exchange: caml_atomic_exchange,
        caml_atomic_fetch_add: caml_atomic_fetch_add,
        caml_atomic_cas: caml_atomic_cas,
        caml_atomic_load: caml_atomic_load,
        caml_domain_dls_get: caml_domain_dls_get,
        caml_domain_dls_compare_and_set: caml_domain_dls_compare_and_set,
        caml_domain_dls_set: caml_domain_dls_set,
        caml_domain_dls: caml_domain_dls,
        caml_ephe_check_data: caml_ephe_check_data,
        caml_ephe_unset_data: caml_ephe_unset_data,
        caml_ephe_set_data: caml_ephe_set_data,
        caml_ephe_get_data_copy: caml_ephe_get_data_copy,
        caml_ephe_get_data: caml_ephe_get_data,
        caml_ephe_blit_data: caml_ephe_blit_data,
        caml_ephe_blit_key: caml_ephe_blit_key,
        caml_ephe_check_key: caml_ephe_check_key,
        caml_ephe_get_key_copy: caml_ephe_get_key_copy,
        caml_ephe_get_key: caml_ephe_get_key,
        caml_weak_set: caml_weak_set,
        caml_weak_create: caml_weak_create,
        caml_ephe_create: caml_ephe_create,
        caml_ephe_unset_key: caml_ephe_unset_key,
        caml_ephe_set_key: caml_ephe_set_key,
        caml_ephe_data_offset: caml_ephe_data_offset,
        caml_ephe_key_offset: caml_ephe_key_offset,
        caml_unix_inet_addr_of_string: caml_unix_inet_addr_of_string,
        caml_unix_findclose: caml_unix_findclose,
        caml_unix_findnext: caml_unix_findnext,
        caml_unix_findfirst: caml_unix_findfirst,
        caml_unix_rewinddir: caml_unix_rewinddir,
        caml_unix_closedir: caml_unix_closedir,
        caml_unix_readdir: caml_unix_readdir,
        caml_unix_opendir: caml_unix_opendir,
        caml_unix_has_symlink: caml_unix_has_symlink,
        caml_unix_getpwuid: caml_unix_getpwuid,
        caml_unix_getuid: caml_unix_getuid,
        caml_unix_unlink: caml_unix_unlink,
        caml_unix_readlink: caml_unix_readlink,
        caml_unix_symlink: caml_unix_symlink,
        caml_unix_rmdir: caml_unix_rmdir,
        caml_unix_mkdir: caml_unix_mkdir,
        caml_unix_lstat_64: caml_unix_lstat_64,
        caml_unix_lstat: caml_unix_lstat,
        caml_unix_stat_64: caml_unix_stat_64,
        caml_unix_stat: caml_unix_stat,
        make_unix_err_args: make_unix_err_args,
        caml_unix_isatty: caml_unix_isatty,
        caml_unix_filedescr_of_fd: caml_unix_filedescr_of_fd,
        caml_unix_cleanup: caml_unix_cleanup,
        caml_unix_startup: caml_unix_startup,
        caml_unix_mktime: caml_unix_mktime,
        caml_unix_localtime: caml_unix_localtime,
        caml_unix_gmtime: caml_unix_gmtime,
        caml_unix_time: caml_unix_time,
        caml_unix_gettimeofday: caml_unix_gettimeofday,
        caml_str_initialize: caml_str_initialize,
        re_replacement_text: re_replacement_text,
        re_partial_match: re_partial_match,
        re_string_match: re_string_match,
        re_search_backward: re_search_backward,
        re_search_forward: re_search_forward,
        re_match: re_match,
        caml_sys_is_regular_file: caml_sys_is_regular_file,
        caml_xdg_defaults: caml_xdg_defaults,
        caml_spacetime_only_works_for_native_code: caml_spacetime_only_works_for_native_code,
        caml_register_channel_for_spacetime: caml_register_channel_for_spacetime,
        caml_sys_const_naked_pointers_checked: caml_sys_const_naked_pointers_checked,
        caml_spacetime_enabled: caml_spacetime_enabled,
        caml_ml_runtime_warnings_enabled: caml_ml_runtime_warnings_enabled,
        caml_ml_enable_runtime_warnings: caml_ml_enable_runtime_warnings,
        caml_runtime_warnings: caml_runtime_warnings,
        caml_install_signal_handler: caml_install_signal_handler,
        caml_runtime_parameters: caml_runtime_parameters,
        caml_runtime_variant: caml_runtime_variant,
        caml_sys_isatty: caml_sys_isatty,
        caml_sys_get_config: caml_sys_get_config,
        os_type: os_type,
        caml_sys_const_backend_type: caml_sys_const_backend_type,
        caml_sys_const_ostype_cygwin: caml_sys_const_ostype_cygwin,
        caml_sys_const_ostype_win32: caml_sys_const_ostype_win32,
        caml_sys_const_ostype_unix: caml_sys_const_ostype_unix,
        caml_sys_const_max_wosize: caml_sys_const_max_wosize,
        caml_sys_const_int_size: caml_sys_const_int_size,
        caml_sys_const_word_size: caml_sys_const_word_size,
        caml_sys_const_big_endian: caml_sys_const_big_endian,
        caml_sys_random_seed: caml_sys_random_seed,
        caml_sys_time_include_children: caml_sys_time_include_children,
        caml_sys_time: caml_sys_time,
        caml_sys_system_command: caml_sys_system_command,
        caml_sys_executable_name: caml_sys_executable_name,
        caml_sys_modify_argv: caml_sys_modify_argv,
        caml_sys_argv: caml_sys_argv,
        caml_sys_get_argv: caml_sys_get_argv,
        caml_executable_name: caml_executable_name,
        caml_argv: caml_argv,
        caml_sys_unsafe_getenv: caml_sys_unsafe_getenv,
        caml_sys_getenv: caml_sys_getenv,
        jsoo_sys_getenv: jsoo_sys_getenv,
        caml_set_static_env: caml_set_static_env,
        caml_fatal_uncaught_exception: caml_fatal_uncaught_exception,
        caml_format_exception: caml_format_exception,
        caml_is_special_exception: caml_is_special_exception,
        caml_sys_exit: caml_sys_exit,
        caml_raise_sys_error: caml_raise_sys_error,
        caml_maybe_print_stats: caml_maybe_print_stats,
        caml_is_printable: caml_is_printable,
        caml_get_global_data: caml_get_global_data,
        caml_register_global: caml_register_global,
        caml_build_symbols: caml_build_symbols,
        caml_global_data: caml_global_data,
        caml_named_value: caml_named_value,
        caml_register_named_value: caml_register_named_value,
        caml_named_values: caml_named_values,
        caml_call_gen: caml_call_gen,
        caml_set_parser_trace: caml_set_parser_trace,
        caml_parse_engine: caml_parse_engine,
        caml_parser_trace: caml_parser_trace,
        caml_is_continuation_tag: caml_is_continuation_tag,
        caml_lazy_read_result: caml_lazy_read_result,
        caml_lazy_reset_to_lazy: caml_lazy_reset_to_lazy,
        caml_lazy_update_to_forward: caml_lazy_update_to_forward,
        caml_lazy_update_to_forcing: caml_lazy_update_to_forcing,
        caml_obj_update_tag: caml_obj_update_tag,
        caml_obj_add_offset: caml_obj_add_offset,
        caml_obj_reachable_words: caml_obj_reachable_words,
        caml_obj_set_raw_field: caml_obj_set_raw_field,
        caml_obj_raw_field: caml_obj_raw_field,
        caml_fresh_oo_id: caml_fresh_oo_id,
        caml_set_oo_id: caml_set_oo_id,
        caml_oo_last_id: caml_oo_last_id,
        caml_get_public_method: caml_get_public_method,
        caml_lazy_make_forward: caml_lazy_make_forward,
        caml_obj_is_shared: caml_obj_is_shared,
        caml_obj_compare_and_swap: caml_obj_compare_and_swap,
        caml_obj_make_forward: caml_obj_make_forward,
        caml_obj_truncate: caml_obj_truncate,
        caml_obj_dup: caml_obj_dup,
        caml_obj_with_tag: caml_obj_with_tag,
        caml_obj_block: caml_obj_block,
        caml_obj_set_tag: caml_obj_set_tag,
        caml_obj_tag: caml_obj_tag,
        caml_obj_is_block: caml_obj_is_block,
        caml_alloc_dummy_infix: caml_alloc_dummy_infix,
        caml_update_dummy: caml_update_dummy,
        deserialize_nat: deserialize_nat,
        serialize_nat: serialize_nat,
        lxor_digit_nat: lxor_digit_nat,
        lor_digit_nat: lor_digit_nat,
        land_digit_nat: land_digit_nat,
        compare_nat_real: compare_nat_real,
        compare_nat: compare_nat,
        compare_digits_nat: compare_digits_nat,
        shift_right_nat: shift_right_nat,
        div_nat: div_nat,
        div_digit_nat: div_digit_nat,
        div_helper: div_helper,
        shift_left_nat: shift_left_nat,
        square_nat: square_nat,
        mult_nat: mult_nat,
        mult_digit_nat: mult_digit_nat,
        sub_nat: sub_nat,
        decr_nat: decr_nat,
        complement_nat: complement_nat,
        add_nat: add_nat,
        incr_nat: incr_nat,
        is_digit_odd: is_digit_odd,
        is_digit_zero: is_digit_zero,
        is_digit_int: is_digit_int,
        num_leading_zero_bits_in_digit: num_leading_zero_bits_in_digit,
        num_digits_nat: num_digits_nat,
        nth_digit_nat_native: nth_digit_nat_native,
        set_digit_nat_native: set_digit_nat_native,
        nth_digit_nat: nth_digit_nat,
        set_digit_nat: set_digit_nat,
        blit_nat: blit_nat,
        set_to_zero_nat: set_to_zero_nat,
        create_nat: create_nat,
        nat_of_array: nat_of_array,
        length_nat: length_nat,
        caml_hash_nat: caml_hash_nat,
        MlNat: MlNat,
        initialize_nat: initialize_nat,
        caml_array_of_bytes: caml_array_of_bytes,
        caml_array_of_string: caml_array_of_string,
        caml_js_to_string: caml_js_to_string,
        caml_to_js_string: caml_to_js_string,
        caml_js_from_string: caml_js_from_string,
        caml_new_string: caml_new_string,
        caml_js_to_byte_string: caml_js_to_byte_string,
        caml_is_ml_string: caml_is_ml_string,
        caml_ml_bytes_content: caml_ml_bytes_content,
        caml_is_ml_bytes: caml_is_ml_bytes,
        caml_bytes_of_jsbytes: caml_bytes_of_jsbytes,
        caml_string_of_jsstring: caml_string_of_jsstring,
        caml_jsstring_of_string: caml_jsstring_of_string,
        caml_jsbytes_of_string: caml_jsbytes_of_string,
        caml_string_of_jsbytes: caml_string_of_jsbytes,
        caml_bytes_of_string: caml_bytes_of_string,
        caml_string_of_bytes: caml_string_of_bytes,
        caml_string_lessthan: caml_string_lessthan,
        caml_string_lessequal: caml_string_lessequal,
        caml_string_equal: caml_string_equal,
        caml_string_compare: caml_string_compare,
        caml_ml_string_length: caml_ml_string_length,
        caml_string_unsafe_set: caml_string_unsafe_set,
        caml_string_unsafe_get: caml_string_unsafe_get,
        caml_string_concat: caml_string_concat,
        caml_ml_bytes_length: caml_ml_bytes_length,
        caml_blit_string: caml_blit_string,
        caml_blit_bytes: caml_blit_bytes,
        caml_fill_bytes: caml_fill_bytes,
        caml_bytes_greaterthan: caml_bytes_greaterthan,
        caml_string_greaterthan: caml_string_greaterthan,
        caml_bytes_greaterequal: caml_bytes_greaterequal,
        caml_string_greaterequal: caml_string_greaterequal,
        caml_bytes_lessthan: caml_bytes_lessthan,
        caml_bytes_lessequal: caml_bytes_lessequal,
        caml_bytes_notequal: caml_bytes_notequal,
        caml_string_notequal: caml_string_notequal,
        caml_bytes_equal: caml_bytes_equal,
        caml_bytes_compare: caml_bytes_compare,
        caml_bytes_of_array: caml_bytes_of_array,
        caml_string_of_array: caml_string_of_array,
        caml_create_bytes: caml_create_bytes,
        caml_create_string: caml_create_string,
        caml_uint8_array_of_string: caml_uint8_array_of_string,
        caml_uint8_array_of_bytes: caml_uint8_array_of_bytes,
        caml_convert_bytes_to_array: caml_convert_bytes_to_array,
        caml_convert_string_to_bytes: caml_convert_string_to_bytes,
        MlBytes: MlBytes,
        caml_bytes_of_utf16_jsstring: caml_bytes_of_utf16_jsstring,
        caml_bytes_set: caml_bytes_set,
        caml_string_set64: caml_string_set64,
        caml_bytes_set64: caml_bytes_set64,
        caml_string_set32: caml_string_set32,
        caml_bytes_set32: caml_bytes_set32,
        caml_string_set16: caml_string_set16,
        caml_bytes_set16: caml_bytes_set16,
        caml_string_set: caml_string_set,
        caml_bytes_get: caml_bytes_get,
        caml_bytes_get64: caml_bytes_get64,
        caml_string_get64: caml_string_get64,
        caml_bytes_get32: caml_bytes_get32,
        caml_string_get32: caml_string_get32,
        caml_bytes_get16: caml_bytes_get16,
        caml_string_get16: caml_string_get16,
        caml_string_get: caml_string_get,
        caml_bytes_bound_error: caml_bytes_bound_error,
        caml_string_bound_error: caml_string_bound_error,
        caml_bytes_unsafe_set: caml_bytes_unsafe_set,
        caml_bytes_unsafe_get: caml_bytes_unsafe_get,
        jsoo_is_ascii: jsoo_is_ascii,
        caml_utf16_of_utf8: caml_utf16_of_utf8,
        caml_utf8_of_utf16: caml_utf8_of_utf16,
        caml_subarray_to_jsbytes: caml_subarray_to_jsbytes,
        caml_str_repeat: caml_str_repeat,
        caml_md5_bytes: caml_md5_bytes,
        caml_MD5Final: caml_MD5Final,
        caml_MD5Update: caml_MD5Update,
        caml_MD5Init: caml_MD5Init,
        caml_MD5Transform: caml_MD5Transform,
        caml_md5_string: caml_md5_string,
        caml_md5_chan: caml_md5_chan,
        caml_output_value_to_buffer: caml_output_value_to_buffer,
        caml_output_value_to_bytes: caml_output_value_to_bytes,
        caml_output_value_to_string: caml_output_value_to_string,
        caml_output_val: caml_output_val,
        MlObjectTable: MlObjectTable,
        caml_marshal_data_size: caml_marshal_data_size,
        caml_marshal_header_size: caml_marshal_header_size,
        caml_input_value_from_reader: caml_input_value_from_reader,
        caml_custom_ops: caml_custom_ops,
        caml_nativeint_unmarshal: caml_nativeint_unmarshal,
        caml_int32_unmarshal: caml_int32_unmarshal,
        caml_int64_marshal: caml_int64_marshal,
        caml_int64_unmarshal: caml_int64_unmarshal,
        caml_input_value_from_bytes: caml_input_value_from_bytes,
        caml_input_value_from_string: caml_input_value_from_string,
        caml_float_of_bytes: caml_float_of_bytes,
        BigStringReader: BigStringReader,
        MlStringReader: MlStringReader,
        UInt8ArrayReader: UInt8ArrayReader,
        caml_marshal_constants: caml_marshal_constants,
        caml_new_lex_engine: caml_new_lex_engine,
        caml_lex_engine: caml_lex_engine,
        caml_lex_array: caml_lex_array,
        caml_js_error_of_exception: caml_js_error_of_exception,
        caml_xmlhttprequest_create: caml_xmlhttprequest_create,
        caml_js_get_console: caml_js_get_console,
        caml_js_html_entities: caml_js_html_entities,
        caml_js_html_escape: caml_js_html_escape,
        caml_js_on_ie: caml_js_on_ie,
        caml_js_object: caml_js_object,
        caml_pure_js_expr: caml_pure_js_expr,
        caml_js_expr: caml_js_expr,
        caml_js_eval_string: caml_js_eval_string,
        caml_js_strict_equals: caml_js_strict_equals,
        caml_js_equals: caml_js_equals,
        caml_js_function_arity: caml_js_function_arity,
        caml_js_wrap_meth_callback_unsafe: caml_js_wrap_meth_callback_unsafe,
        caml_js_wrap_meth_callback_strict: caml_js_wrap_meth_callback_strict,
        caml_js_wrap_meth_callback_arguments: caml_js_wrap_meth_callback_arguments,
        caml_js_wrap_meth_callback: caml_js_wrap_meth_callback,
        caml_js_wrap_callback_unsafe: caml_js_wrap_callback_unsafe,
        caml_js_wrap_callback_strict: caml_js_wrap_callback_strict,
        caml_js_wrap_callback_arguments: caml_js_wrap_callback_arguments,
        caml_js_wrap_callback: caml_js_wrap_callback,
        caml_ojs_new_arr: caml_ojs_new_arr,
        caml_js_new: caml_js_new,
        caml_js_meth_call: caml_js_meth_call,
        caml_js_fun_call: caml_js_fun_call,
        caml_js_call: caml_js_call,
        caml_js_var: caml_js_var,
        caml_list_to_js_array: caml_list_to_js_array,
        caml_list_of_js_array: caml_list_of_js_array,
        caml_js_to_array: caml_js_to_array,
        caml_js_from_array: caml_js_from_array,
        caml_js_to_int32: caml_js_to_int32,
        caml_js_to_float: caml_js_to_float,
        caml_js_from_float: caml_js_from_float,
        caml_js_to_bool: caml_js_to_bool,
        caml_js_from_bool: caml_js_from_bool,
        caml_js_error_option_of_exception: caml_js_error_option_of_exception,
        caml_exn_with_js_backtrace: caml_exn_with_js_backtrace,
        caml_maybe_attach_backtrace: caml_maybe_attach_backtrace,
        caml_wrap_exception: caml_wrap_exception,
        caml_jsoo_flags_effects: caml_jsoo_flags_effects,
        caml_jsoo_flags_use_js_string: caml_jsoo_flags_use_js_string,
        caml_is_js: caml_is_js,
        caml_callback: caml_callback,
        caml_trampoline_return: caml_trampoline_return,
        caml_trampoline: caml_trampoline,
        caml_js_typeof: caml_js_typeof,
        caml_js_instanceof: caml_js_instanceof,
        caml_js_delete: caml_js_delete,
        caml_js_get: caml_js_get,
        caml_js_set: caml_js_set,
        caml_js_pure_expr: caml_js_pure_expr,
        caml_ml_set_buffered: caml_ml_set_buffered,
        caml_ml_is_buffered: caml_ml_is_buffered,
        caml_ml_output_int: caml_ml_output_int,
        caml_ml_pos_out_64: caml_ml_pos_out_64,
        caml_ml_pos_out: caml_ml_pos_out,
        caml_pos_out: caml_pos_out,
        caml_ml_seek_out_64: caml_ml_seek_out_64,
        caml_ml_seek_out: caml_ml_seek_out,
        caml_seek_out: caml_seek_out,
        caml_output_value: caml_output_value,
        caml_ml_output_char: caml_ml_output_char,
        caml_ml_output: caml_ml_output,
        caml_ml_output_bigarray: caml_ml_output_bigarray,
        caml_ml_output_bytes: caml_ml_output_bytes,
        caml_ml_output_ta: caml_ml_output_ta,
        caml_ml_flush: caml_ml_flush,
        caml_ml_input_scan_line: caml_ml_input_scan_line,
        caml_ml_pos_in_64: caml_ml_pos_in_64,
        caml_ml_pos_in: caml_ml_pos_in,
        caml_pos_in: caml_pos_in,
        caml_ml_seek_in_64: caml_ml_seek_in_64,
        caml_ml_seek_in: caml_ml_seek_in,
        caml_seek_in: caml_seek_in,
        caml_ml_input_int: caml_ml_input_int,
        caml_ml_input_char: caml_ml_input_char,
        caml_input_value_to_outside_heap: caml_input_value_to_outside_heap,
        caml_input_value: caml_input_value,
        caml_ml_input_block: caml_ml_input_block,
        caml_ml_input_bigarray: caml_ml_input_bigarray,
        caml_ml_input: caml_ml_input,
        caml_refill: caml_refill,
        caml_ml_set_channel_refill: caml_ml_set_channel_refill,
        caml_ml_set_channel_output: caml_ml_set_channel_output,
        caml_ml_channel_size_64: caml_ml_channel_size_64,
        caml_ml_channel_size: caml_ml_channel_size,
        caml_ml_close_channel: caml_ml_close_channel,
        caml_ml_is_binary_mode: caml_ml_is_binary_mode,
        caml_ml_set_binary_mode: caml_ml_set_binary_mode,
        caml_channel_descriptor: caml_channel_descriptor,
        caml_ml_open_descriptor_out_with_flags: caml_ml_open_descriptor_out_with_flags,
        caml_ml_open_descriptor_in_with_flags: caml_ml_open_descriptor_in_with_flags,
        caml_ml_open_descriptor_in: caml_ml_open_descriptor_in,
        caml_ml_open_descriptor_out: caml_ml_open_descriptor_out,
        caml_ml_out_channels_list: caml_ml_out_channels_list,
        caml_ml_channel_get: caml_ml_channel_get,
        caml_ml_channel_restore: caml_ml_channel_restore,
        caml_ml_channel_redirect: caml_ml_channel_redirect,
        caml_ml_channels: caml_ml_channels,
        caml_ml_set_channel_name: caml_ml_set_channel_name,
        caml_sys_open: caml_sys_open,
        caml_sys_close: caml_sys_close,
        caml_sys_fds: caml_sys_fds,
        caml_int64_bswap: caml_int64_bswap,
        caml_int32_bswap: caml_int32_bswap,
        caml_bswap16: caml_bswap16,
        caml_mod: caml_mod,
        caml_div: caml_div,
        caml_mul: caml_mul,
        caml_int_of_string: caml_int_of_string,
        caml_parse_digit: caml_parse_digit,
        caml_parse_sign_and_base: caml_parse_sign_and_base,
        caml_format_int: caml_format_int,
        caml_int64_hash: caml_int64_hash,
        caml_int64_to_bytes: caml_int64_to_bytes,
        caml_int64_of_bytes: caml_int64_of_bytes,
        caml_int64_hi32: caml_int64_hi32,
        caml_int64_lo32: caml_int64_lo32,
        caml_int64_create_lo_hi: caml_int64_create_lo_hi,
        caml_int64_create_lo_mi_hi: caml_int64_create_lo_mi_hi,
        caml_int64_of_string: caml_int64_of_string,
        caml_int64_format: caml_int64_format,
        caml_int64_of_float: caml_int64_of_float,
        caml_int64_to_float: caml_int64_to_float,
        caml_int64_to_int32: caml_int64_to_int32,
        caml_int64_of_int32: caml_int64_of_int32,
        caml_int64_mod: caml_int64_mod,
        caml_int64_div: caml_int64_div,
        caml_int64_shift_right: caml_int64_shift_right,
        caml_int64_shift_right_unsigned: caml_int64_shift_right_unsigned,
        caml_int64_shift_left: caml_int64_shift_left,
        caml_int64_xor: caml_int64_xor,
        caml_int64_or: caml_int64_or,
        caml_int64_and: caml_int64_and,
        caml_int64_is_negative: caml_int64_is_negative,
        caml_int64_is_zero: caml_int64_is_zero,
        caml_int64_mul: caml_int64_mul,
        caml_int64_sub: caml_int64_sub,
        caml_int64_add: caml_int64_add,
        caml_int64_neg: caml_int64_neg,
        caml_int64_compare: caml_int64_compare,
        caml_int64_ult: caml_int64_ult,
        MlInt64: MlInt64,
        caml_int64_offset: caml_int64_offset,
        caml_float_of_string: caml_float_of_string,
        caml_format_float: caml_format_float,
        caml_fma_float: caml_fma_float,
        caml_erfc_float: caml_erfc_float,
        caml_erf_float: caml_erf_float,
        caml_cbrt_float: caml_cbrt_float,
        caml_round_float: caml_round_float,
        caml_atanh_float: caml_atanh_float,
        caml_tanh_float: caml_tanh_float,
        caml_asinh_float: caml_asinh_float,
        caml_sinh_float: caml_sinh_float,
        caml_acosh_float: caml_acosh_float,
        caml_cosh_float: caml_cosh_float,
        caml_log10_float: caml_log10_float,
        caml_hypot_float: caml_hypot_float,
        caml_log2_float: caml_log2_float,
        caml_log1p_float: caml_log1p_float,
        caml_exp2_float: caml_exp2_float,
        caml_expm1_float: caml_expm1_float,
        caml_signbit_float: caml_signbit_float,
        caml_copysign_float: caml_copysign_float,
        caml_float_compare: caml_float_compare,
        caml_frexp_float: caml_frexp_float,
        caml_ldexp_float: caml_ldexp_float,
        caml_modf_float: caml_modf_float,
        caml_classify_float: caml_classify_float,
        caml_int32_float_of_bits: caml_int32_float_of_bits,
        caml_trunc_float: caml_trunc_float,
        caml_nextafter_float: caml_nextafter_float,
        caml_int64_float_of_bits: caml_int64_float_of_bits,
        caml_hexstring_of_float: caml_hexstring_of_float,
        caml_int32_bits_of_float: caml_int32_bits_of_float,
        caml_int64_bits_of_float: caml_int64_bits_of_float,
        jsoo_floor_log2: jsoo_floor_log2,
        caml_string_hash: caml_string_hash,
        caml_hash: caml_hash,
        caml_hash_mix_string: caml_hash_mix_string,
        caml_hash_mix_bytes: caml_hash_mix_bytes,
        caml_hash_mix_bytes_arr: caml_hash_mix_bytes_arr,
        caml_hash_mix_jsbytes: caml_hash_mix_jsbytes,
        caml_hash_mix_int64: caml_hash_mix_int64,
        caml_hash_mix_float: caml_hash_mix_float,
        caml_hash_mix_final: caml_hash_mix_final,
        caml_hash_mix_int: caml_hash_mix_int,
        caml_gr_close_subwindow: caml_gr_close_subwindow,
        caml_gr_open_subwindow: caml_gr_open_subwindow,
        caml_gr_window_id: caml_gr_window_id,
        caml_gr_display_mode: caml_gr_display_mode,
        caml_gr_remember_mode: caml_gr_remember_mode,
        caml_gr_synchronize: caml_gr_synchronize,
        caml_gr_wait_event: caml_gr_wait_event,
        caml_gr_sigio_signal: caml_gr_sigio_signal,
        caml_gr_sigio_handler: caml_gr_sigio_handler,
        caml_gr_blit_image: caml_gr_blit_image,
        caml_gr_create_image: caml_gr_create_image,
        caml_gr_draw_image: caml_gr_draw_image,
        caml_gr_dump_image: caml_gr_dump_image,
        caml_gr_make_image: caml_gr_make_image,
        caml_gr_text_size: caml_gr_text_size,
        caml_gr_set_text_size: caml_gr_set_text_size,
        caml_gr_set_font: caml_gr_set_font,
        caml_gr_draw_string: caml_gr_draw_string,
        caml_gr_draw_char: caml_gr_draw_char,
        caml_gr_draw_str: caml_gr_draw_str,
        caml_gr_fill_arc: caml_gr_fill_arc,
        caml_gr_fill_poly: caml_gr_fill_poly,
        caml_gr_fill_rect: caml_gr_fill_rect,
        caml_gr_set_line_width: caml_gr_set_line_width,
        caml_gr_draw_arc: caml_gr_draw_arc,
        caml_gr_arc_aux: caml_gr_arc_aux,
        caml_gr_draw_rect: caml_gr_draw_rect,
        caml_gr_lineto: caml_gr_lineto,
        caml_gr_current_y: caml_gr_current_y,
        caml_gr_current_x: caml_gr_current_x,
        caml_gr_moveto: caml_gr_moveto,
        caml_gr_point_color: caml_gr_point_color,
        caml_gr_plot: caml_gr_plot,
        caml_gr_set_color: caml_gr_set_color,
        caml_gr_size_y: caml_gr_size_y,
        caml_gr_size_x: caml_gr_size_x,
        caml_gr_clear_graph: caml_gr_clear_graph,
        caml_gr_resize_window: caml_gr_resize_window,
        caml_gr_set_window_title: caml_gr_set_window_title,
        caml_gr_close_graph: caml_gr_close_graph,
        caml_gr_doc_of_state: caml_gr_doc_of_state,
        caml_gr_state_create: caml_gr_state_create,
        caml_gr_state_init: caml_gr_state_init,
        caml_gr_open_graph: caml_gr_open_graph,
        caml_gr_state_set: caml_gr_state_set,
        caml_gr_state_get: caml_gr_state_get,
        caml_gr_state: caml_gr_state,
        caml_get_major_credit: caml_get_major_credit,
        caml_get_major_bucket: caml_get_major_bucket,
        caml_get_minor_free: caml_get_minor_free,
        caml_gc_minor_words: caml_gc_minor_words,
        caml_gc_major_slice: caml_gc_major_slice,
        caml_gc_huge_fallback_count: caml_gc_huge_fallback_count,
        caml_eventlog_pause: caml_eventlog_pause,
        caml_eventlog_resume: caml_eventlog_resume,
        caml_memprof_discard: caml_memprof_discard,
        caml_memprof_stop: caml_memprof_stop,
        caml_memprof_start: caml_memprof_start,
        caml_final_release: caml_final_release,
        caml_final_register_called_without_value: caml_final_register_called_without_value,
        caml_final_register: caml_final_register,
        caml_memprof_set: caml_memprof_set,
        caml_gc_get: caml_gc_get,
        caml_gc_set: caml_gc_set,
        caml_gc_stat: caml_gc_stat,
        caml_gc_quick_stat: caml_gc_quick_stat,
        caml_gc_counters: caml_gc_counters,
        caml_gc_compaction: caml_gc_compaction,
        caml_gc_full_major: caml_gc_full_major,
        caml_gc_major: caml_gc_major,
        caml_gc_minor: caml_gc_minor,
        caml_sys_open_for_node: caml_sys_open_for_node,
        MlNodeFd: MlNodeFd,
        MlNodeDevice: MlNodeDevice,
        fs_node_supported: fs_node_supported,
        MlFakeFd: MlFakeFd,
        MlFakeFd_out: MlFakeFd_out,
        MlFakeFile: MlFakeFile,
        MlFakeDevice: MlFakeDevice,
        caml_read_file_content: caml_read_file_content,
        jsoo_create_file: jsoo_create_file,
        caml_create_file: caml_create_file,
        caml_fs_init: caml_fs_init,
        jsoo_create_file_extern: jsoo_create_file_extern,
        caml_ba_map_file_bytecode: caml_ba_map_file_bytecode,
        caml_ba_map_file: caml_ba_map_file,
        caml_sys_rmdir: caml_sys_rmdir,
        caml_sys_mkdir: caml_sys_mkdir,
        caml_sys_rename: caml_sys_rename,
        caml_sys_is_directory: caml_sys_is_directory,
        caml_sys_remove: caml_sys_remove,
        caml_sys_read_directory: caml_sys_read_directory,
        caml_sys_file_exists: caml_sys_file_exists,
        caml_raise_not_a_dir: caml_raise_not_a_dir,
        caml_raise_no_such_file: caml_raise_no_such_file,
        caml_sys_chdir: caml_sys_chdir,
        caml_sys_getcwd: caml_sys_getcwd,
        caml_unmount: caml_unmount,
        caml_mount_autoload: caml_mount_autoload,
        resolve_fs_device: resolve_fs_device,
        caml_list_mount_point: caml_list_mount_point,
        jsoo_mount_point: jsoo_mount_point,
        caml_make_path: caml_make_path,
        path_is_absolute: path_is_absolute,
        MlFile: MlFile,
        caml_root: caml_root,
        caml_get_root: caml_get_root,
        caml_current_dir: caml_current_dir,
        caml_trailing_slash: caml_trailing_slash,
        caml_finish_formatting: caml_finish_formatting,
        caml_parse_format: caml_parse_format,
        caml_array_bound_error: caml_array_bound_error,
        caml_raise_not_found: caml_raise_not_found,
        caml_raise_zero_divide: caml_raise_zero_divide,
        caml_raise_end_of_file: caml_raise_end_of_file,
        caml_invalid_argument: caml_invalid_argument,
        caml_failwith: caml_failwith,
        caml_raise_with_string: caml_raise_with_string,
        caml_raise_with_args: caml_raise_with_args,
        caml_raise_with_arg: caml_raise_with_arg,
        caml_raise_constant: caml_raise_constant,
        caml_lessthan: caml_lessthan,
        caml_lessequal: caml_lessequal,
        caml_greaterthan: caml_greaterthan,
        caml_greaterequal: caml_greaterequal,
        caml_notequal: caml_notequal,
        caml_equal: caml_equal,
        caml_int_compare: caml_int_compare,
        caml_compare: caml_compare,
        caml_compare_val: caml_compare_val,
        caml_compare_val_number_custom: caml_compare_val_number_custom,
        caml_compare_val_get_custom: caml_compare_val_get_custom,
        caml_compare_val_tag: caml_compare_val_tag,
        caml_bigstring_blit_ba_to_bytes: caml_bigstring_blit_ba_to_bytes,
        caml_bigstring_blit_bytes_to_ba: caml_bigstring_blit_bytes_to_ba,
        caml_bigstring_blit_string_to_ba: caml_bigstring_blit_string_to_ba,
        caml_bigstring_blit_ba_to_ba: caml_bigstring_blit_ba_to_ba,
        caml_bigstring_memcmp: caml_bigstring_memcmp,
        bigstring_of_typed_array: bigstring_of_typed_array,
        bigstring_of_array_buffer: bigstring_of_array_buffer,
        bigstring_to_typed_array: bigstring_to_typed_array,
        bigstring_to_array_buffer: bigstring_to_array_buffer,
        caml_hash_mix_bigstring: caml_hash_mix_bigstring,
        caml_ba_from_typed_array: caml_ba_from_typed_array,
        caml_ba_kind_of_typed_array: caml_ba_kind_of_typed_array,
        caml_ba_to_typed_array: caml_ba_to_typed_array,
        caml_ba_hash: caml_ba_hash,
        caml_ba_create_from: caml_ba_create_from,
        caml_ba_deserialize: caml_ba_deserialize,
        caml_ba_serialize: caml_ba_serialize,
        caml_ba_reshape: caml_ba_reshape,
        caml_ba_slice: caml_ba_slice,
        caml_ba_sub: caml_ba_sub,
        caml_ba_blit: caml_ba_blit,
        caml_ba_fill: caml_ba_fill,
        caml_ba_set_3: caml_ba_set_3,
        caml_ba_set_2: caml_ba_set_2,
        caml_ba_set_1: caml_ba_set_1,
        caml_ba_uint8_set64: caml_ba_uint8_set64,
        caml_ba_uint8_set32: caml_ba_uint8_set32,
        caml_ba_uint8_set16: caml_ba_uint8_set16,
        caml_ba_set_generic: caml_ba_set_generic,
        caml_ba_get_3: caml_ba_get_3,
        caml_ba_get_2: caml_ba_get_2,
        caml_ba_get_1: caml_ba_get_1,
        caml_ba_uint8_get64: caml_ba_uint8_get64,
        caml_ba_uint8_get32: caml_ba_uint8_get32,
        caml_ba_uint8_get16: caml_ba_uint8_get16,
        caml_ba_get_generic: caml_ba_get_generic,
        caml_ba_dim_3: caml_ba_dim_3,
        caml_ba_dim_2: caml_ba_dim_2,
        caml_ba_dim_1: caml_ba_dim_1,
        caml_ba_dim: caml_ba_dim,
        caml_ba_num_dims: caml_ba_num_dims,
        caml_ba_layout: caml_ba_layout,
        caml_ba_kind: caml_ba_kind,
        caml_ba_change_layout: caml_ba_change_layout,
        caml_ba_create: caml_ba_create,
        caml_ba_create_unsafe: caml_ba_create_unsafe,
        caml_ba_compare: caml_ba_compare,
        Ml_Bigarray_c_1_1: Ml_Bigarray_c_1_1,
        Ml_Bigarray: Ml_Bigarray,
        caml_ba_custom_name: caml_ba_custom_name,
        caml_ba_create_buffer: caml_ba_create_buffer,
        caml_ba_get_size_per_element: caml_ba_get_size_per_element,
        caml_ba_get_size: caml_ba_get_size,
        caml_ba_init: caml_ba_init,
        caml_convert_raw_backtrace_slot: caml_convert_raw_backtrace_slot,
        caml_get_current_callstack: caml_get_current_callstack,
        caml_restore_raw_backtrace: caml_restore_raw_backtrace,
        caml_raw_backtrace_slot: caml_raw_backtrace_slot,
        caml_raw_backtrace_next_slot: caml_raw_backtrace_next_slot,
        caml_raw_backtrace_length: caml_raw_backtrace_length,
        caml_convert_raw_backtrace: caml_convert_raw_backtrace,
        caml_record_backtrace: caml_record_backtrace,
        caml_get_exception_raw_backtrace: caml_get_exception_raw_backtrace,
        caml_get_exception_backtrace: caml_get_exception_backtrace,
        caml_backtrace_status: caml_backtrace_status,
        caml_ml_debug_info_status: caml_ml_debug_info_status,
        caml_record_backtrace_flag: caml_record_backtrace_flag,
        caml_floatarray_create: caml_floatarray_create,
        caml_make_float_vect: caml_make_float_vect,
        caml_make_vect: caml_make_vect,
        caml_check_bound: caml_check_bound,
        caml_array_fill: caml_array_fill,
        caml_array_get: caml_array_get,
        caml_array_set: caml_array_set,
        caml_floatarray_blit: caml_floatarray_blit,
        caml_array_blit: caml_array_blit,
        caml_array_concat: caml_array_concat,
        caml_array_append: caml_array_append,
        caml_array_sub: caml_array_sub
    };
    var cst_Assert_failure = "Assert_failure", cst_Division_by_zero = "Division_by_zero", cst_End_of_file = "End_of_file", cst_Failure = "Failure", cst_Invalid_argument = "Invalid_argument", cst_Match_failure = "Match_failure", cst_Not_found = "Not_found", cst_Out_of_memory = "Out_of_memory", cst_Stack_overflow = "Stack_overflow", cst_Sys_blocked_io = "Sys_blocked_io", cst_Sys_error = "Sys_error", cst_Undefined_recursive_module = "Undefined_recursive_module";
    caml_fs_init();
    caml_register_global(0, [
        248,
        cst_Out_of_memory,
        -1
    ], cst_Out_of_memory);
    caml_register_global(1, [
        248,
        cst_Sys_error,
        -2
    ], cst_Sys_error);
    caml_register_global(2, [
        248,
        cst_Failure,
        -3
    ], cst_Failure);
    caml_register_global(3, [
        248,
        cst_Invalid_argument,
        -4
    ], cst_Invalid_argument);
    caml_register_global(4, [
        248,
        cst_End_of_file,
        -5
    ], cst_End_of_file);
    caml_register_global(5, [
        248,
        cst_Division_by_zero,
        -6
    ], cst_Division_by_zero);
    caml_register_global(6, [
        248,
        cst_Not_found,
        -7
    ], cst_Not_found);
    caml_register_global(7, [
        248,
        cst_Match_failure,
        -8
    ], cst_Match_failure);
    caml_register_global(8, [
        248,
        cst_Stack_overflow,
        -9
    ], cst_Stack_overflow);
    caml_register_global(9, [
        248,
        cst_Sys_blocked_io,
        -10
    ], cst_Sys_blocked_io);
    caml_register_global(10, [
        248,
        cst_Assert_failure,
        -11
    ], cst_Assert_failure);
    caml_register_global(11, [
        248,
        cst_Undefined_recursive_module,
        -12
    ], cst_Undefined_recursive_module);
    return;
})(globalThis);
(function(a) {
    "use strict";
    var hx = 289, hw = 163, hv = "Base__Pretty_printer", hu = "Base__Source_code_position0", dx = "Base__Uchar0", ht = 232, dw = 240, hs = "Base__Fn", du = 308, dv = "Jv", dq = "Base__Binary_search", dr = "Base__Monad_intf", ds = "Ocaml_intrinsics_kernel__Common", dt = "Stdlib__In_channel", hq = 218, hr = "Stdlib__Bytes", dp = "Dune__exe__Tensor_playground_web", dn = 293, hp = "Stdlib__Condition", ho = "Jstr", dm = 148, hm = 216, hn = "Out_of_memory", hk = 185, hl = 283, hj = "Base__Array", hi = "Base__Field", hh = "Failure", hg = "Stdlib__Printf", dk = 279, dl = "Stdlib", hf = "Brr_canvas", he = "Base__Hash_set", dj = "Stdlib__Filename", di = "Base__Nativeint", hc = 170, hd = "Stdio__", ha = "Base__Dictionary_mutable_intf", hb = "Base__Type_equal", dh = 238, g$ = "Stdlib__Mutex", dg = 176, de = "Ppx_expect_runtime__Current_file", df = 296, g_ = "Stdlib__ListLabels", g9 = 299, g8 = "Sexplib0__Sexp_conv_grammar", dd = 132, dc = "Base__Unit", g7 = 304, db = "Base__Int_math", da = 260, c$ = "Base__Import0", g5 = "Base__Float0", g6 = "Base__Monad", c_ = "Sexplib0__Sexp_grammar", g3 = "Match_failure", g4 = "Stdlib__Semaphore", g1 = "Base__Binary_searchable", g2 = 280, g0 = 109, c8 = 226, c9 = "Stdlib__Int64", c7 = 221, c6 = "Tensor_playground__Counter", gZ = 310, c5 = 284, gY = 265, c4 = "Time_now", gX = "Ocaml_intrinsics_kernel__Float", c3 = 139, gW = "Stdlib__Digest", gV = "Base__Either0", gT = 208, gU = "Stdlib__Type", c1 = "Base__Formatter", c2 = 107, gS = "Base__Int63", gQ = 203, gR = "Stdlib__Nativeint", gP = "Stdlib__Stack", c0 = "Undefined_recursive_module", cZ = "CamlinternalFormatBasics", cX = "Base__Error", cY = "Stdlib__Queue", gN = "Base__Intable", gO = 224, cV = "Base__Import", cW = "Base__Int64", cU = "Base__Sign_or_nan", cT = "Stdio__In_channel", cQ = 204, cR = "Base__String_intf", cS = "CamlinternalMod", gM = 192, cP = 264, cN = "Make_corrected_file__", cO = 114, cM = "Base__Dictionary_mutable", cL = "Stdlib__Parsing", cJ = "Base__Comparator", cK = 113, cH = "Base__Lazy", cI = "Stdlib__Effect", cE = "Stdlib__Bigarray", cF = "Stdlib__List", cG = "Tensor_playground__Tensor_type", cC = 256, cD = "Ppxlib_print_diff", gL = "Base__Option", cB = 111, gK = 258, gJ = "Base__Sequence", gI = 182, gH = "Base__Sexp_with_comparable", gG = "Stdlib__Atomic", cA = 135, gF = "Ppx_expect_runtime__Test_block", gE = 247, cz = "Dune__exe__Einsum_explanation", gD = 231, cy = "Stdlib__Set", cx = 123, cw = "Base__Map_intf", gC = "Base__Bytes", cv = "Ppx_expect_runtime__Expectation_intf", gB = 222, gA = 228, cu = "Base__List1", gz = 239, ct = 127, cq = 190, cr = "Base__Hash", cs = "Base__String", gy = "Brr_webcrypto", cp = "Sys_blocked_io", co = "Stdlib__Uchar", gw = "Base__Info_intf", gx = "Base__Int_intf", cn = "Stdio__Out_channel", ck = 217, cl = 205, cm = "Dune__exe__Isometric", cj = 245, gv = "Brr_webworkers", ci = "Base__Hashable", gt = "Base__Bytes0", gu = "Base__Random_repr", gr = "Ocaml_intrinsics_kernel__Conditional", gs = "Stdlib__Random", gq = "Base__Floatable", go = 137, gp = "Stdlib__Array", cf = "Assert_failure", cg = "Ppx_compare_lib", ch = "Ppx_expect_runtime__Output", ce = "Base__Array_permute", gn = "Jsoo_runtime__", cd = "Base__Comparable", gm = "Stdlib__Dynarray", cb = 131, cc = "Stdlib__BytesLabels", b9 = 152, b_ = 134, b$ = "Stdlib__Marshal", ca = "Tensor_playground__Einops", b7 = 253, b8 = 227, gl = 122, gj = "Base__Bytes_intf", gk = "Base__Either_intf", b6 = "Base__String0", gi = "Jsoo_runtime__Runtime_version", gh = "Stdlib__String", gg = "Base__Container_intf", b5 = "Base__Staged", b4 = 173, gf = "Base__Int0", b3 = 124, b2 = 235, b1 = 141, b0 = 120, bZ = 236, bY = 246, bX = "Base__Bool0", ge = "Base__Ppx_enumerate_lib", gd = 166, gc = 202, ga = 213, gb = "Dune__exe__Tensor_diagram", bW = "Sexplib0__", f9 = 210, f_ = "Ppx_expect_runtime__Test_node", f$ = "Sexplib0__Sexp", bV = "Base__Container", bU = "Base__With_return", f8 = "Ppx_expect_runtime", bT = "Inline_test_config", f7 = "Stdlib__Complex", f6 = 309, bS = "Base__Blit_intf", bQ = 181, bR = 118, f5 = "Stdlib__Sys", bO = "Base__Hash_set_intf", bP = "Base__Identifiable", f4 = "Base__Source_code_position", bN = 249, f3 = 273, f2 = 305, bM = "Base__Printf", f1 = 282, bK = "Fut", bL = "Stdlib__Char", f0 = 144, bI = "Note_brr_kit", bJ = "Stdlib__Int32", fZ = "Base__Popcount", fY = 275, fV = "Ocaml_intrinsics_kernel", fW = "Stdlib__Unit", fX = 295, bH = 151, fU = "Expect_test_config", fT = 188, fS = "Base__Hashtbl", bG = "Stack_overflow", bF = "Stdlib__Arg", fR = 183, bC = "Base__Comparable_intf", bD = 153, bE = "Base__Hashtbl_intf", fQ = 211, bB = 269, fP = "Tensor_playground__Einsum_parser_test", bA = 189, bz = 145, fO = 193, fN = "Ppx_here_lib", fL = 164, fM = 300, fK = "Ppx_hash_lib", fH = 178, fI = "Base__Queue", fJ = 272, fG = "Base__Info", by = "Stdlib__Lexing", fF = 297, fE = 187, fD = 149, bx = 162, bw = 243, fC = "Base__Bytes_tr", bv = "Base__Exn", bu = "Base__Ppx_compare_lib", fB = "Base__Set", fz = "Base__Obj_local", fA = "Ppx_inline_test_lib", fy = "Base__", bt = "Note", bs = "Tensor_playground__Einsum_parser", br = 115, bp = 270, bq = "Stdlib__Float", bo = "Base__Option_array", fw = 215, fx = "Base__Equal", bn = 143, bm = "Base__Char", bl = 104, bk = "Ppx_expect_runtime__Expectation", bj = "Base__Nothing", fv = "Stdlib__Obj", fs = 180, ft = 197, fu = 303, bi = 291, fp = 129, fq = "Base__Dictionary_immutable_intf", fr = 169, bh = "Stdlib__Map", bg = "Base__Poly0", fo = "Stdlib__Domain", be = 146, bf = 242, bd = "Stdlib__Format", fn = "Base__T", bc = "Note_brr_legacy", ba = "Base__Hash_intf", bb = "End_of_file", fm = "Brr_webgpu", a$ = "Base__Char0", fl = "Sexplib0__Sexp_conv_error", fj = 267, fk = 285, a_ = "Make_corrected_file__Import", fi = 244, a9 = "Base__Binary_searchable_intf", fh = 136, a8 = 177, fg = "Stdlib__Callback", fe = "Base__Float", ff = "Stdlib__Hashtbl", fd = 147, a7 = "Stdlib__Option", a5 = "Base__Applicative_intf", a6 = "Base__Uniform_array", fb = 125, fc = "Stdlib__MoreLabels", a4 = 219, a3 = 186, fa = "Base__Sexp", e$ = "Base__Ordering", a2 = "Base__Hashable_intf", e_ = 156, aZ = "Base__Int32", a0 = "Dune__exe__Colors", a1 = 307, e9 = 301, e7 = 154, e8 = 175, aY = "Base__Array0", e6 = "Ppx_sexp_conv_lib", aX = "Base__Hasher", aW = "Brr_webmidi", aV = "Base__Buffer", e4 = "Ocaml_intrinsics_kernel__Int64", e5 = 290, aU = 233, aT = 161, aS = "Sys_error", aR = "Base_internalhash_types", aQ = "Base__Buffer_intf", aO = 196, aP = "CamlinternalFormat", e3 = "Base__Int_conversions", e2 = "Stdlib__Printexc", e1 = "Base__Either", aN = 281, e0 = "Base__Indexed_container", aM = "Jsoo_runtime", eZ = 257, eY = "Division_by_zero", eX = "Ppx_expect_runtime__Write_corrected_file", aJ = "Base__Ordered_collection_common0", aK = "Sexplib0__Sexp_conv_record", aL = 276, eW = "Base__Dictionary_immutable", eV = 158, eS = 119, eT = 287, eU = "Stdlib__Weak", aI = 110, eP = "Base__Comparisons", eQ = "Brr_webaudio", eR = 101, aG = 128, aH = "Stdlib__StdLabels", eO = "Fmt", aF = "Base__Variant", aE = 155, eN = 255, eM = 288, aD = "Base__Ref", eJ = 261, eK = 100, eL = "Tensor_playground__Numpy", aC = 306, eI = "Base__Invariant_intf", aB = 229, eH = "Base__Stack_intf", ay = 200, az = 234, aA = 102, eG = 171, eF = "Make_corrected_file", eD = "Base__Indexed_container_intf", eE = "Base__Random", ax = "Base__Linked_queue0", eC = "Ocaml_intrinsics_kernel__Nativeint", eB = "Ocaml_intrinsics_kernel__Int", aw = "Base__Sign0", eA = 150, at = 199, au = "Expect_test_config_types", av = "Sexplib0__Sexp_conv_labeled_tuple", as = 184, ez = "Brr", aq = 237, ar = "Stdlib__Seq", ap = "Base__Identifiable_intf", ey = "Base__Queue_intf", ex = 225, an = "CamlinternalOO", ao = "Shadow_stdlib", ew = "Base__Type_equal_intf", ev = 266, eu = 172, et = 209, am = 191, al = "Stdlib__Gc", es = "Base__Sexpable", er = 206, ak = 116, eq = "Stdlib__Either", aj = "Ocaml_intrinsics_kernel__Naive_ints", eo = 212, ep = "Base__Stack", en = "Ocaml_intrinsics_kernel__Int32", ag = 259, ah = 159, ai = "Stdlib__Lazy", em = 277, el = "Tensor_playground__Util", ek = 201, af = "Base__List", ej = "Base__Backtrace", ae = "Ppx_expect_runtime__Types", ei = 278, ad = 160, eh = "Base__Fieldslib", ac = "Base__Bool", ef = 223, eg = "Not_found", ee = 230, ab = 121, aa = "Ppx_enumerate_lib", $ = 168, _ = "Invalid_argument", ed = 254, Y = 263, Z = 262, ec = "Base__Int63_emul", eb = "Base__Sys0", X = "Base__Ordered_collection_common", W = "Std_exit", V = "Jane_street_headers", ea = "Base__Blit", U = "Stdlib__StringLabels", d$ = 133, T = "Base__List0", S = 157, R = 112, Q = 140, P = "Base__Sign", O = "Base__Variantslib", d9 = "Base__Maybe_bound", d_ = "Base__Ppx_hash_lib", N = 198, d8 = "CamlinternalLazy", d7 = 207, M = "Stdlib__Scanf", K = 248, L = 174, d6 = 167, d5 = "Base__Result", J = 214, d4 = "Base__Int", d3 = 220, I = "Base__Stringable", d2 = "Base__Map", d1 = 126, H = "Tensor_playground", d0 = "Stdlib__ArrayLabels", G = 108, dZ = "Brr_io", dY = "Base__Sys", F = "Base__Avltree", dX = 241, dW = "Sexplib0__Sexpable", D = "Base__Globalize", E = "Stdlib__Bool", dV = 165, dU = 302, C = "Base__Int_string_conversions", dT = "Sexplib0__Sexp_conv", dS = "Dune__exe", z = 194, A = "Base__Pow_overflow_bounds", B = "Ppx_expect_runtime__", dR = "Base__Linked_queue", y = "Stdlib__Int", w = 271, x = "Stdlib__Oo", dQ = "Stdlib__Ephemeron", u = 130, v = 138, t = 298, dP = "Base", r = "Base__Hex_lexer", s = 106, dN = 252, dO = "Stdio", dL = 292, dM = "Stdlib__Fun", p = 179, q = 117, dK = "Base__Invariant", o = "Base__Uchar", n = 251, dJ = "Stdlib__Result", m = "Base__Set_intf", dH = "Base__Or_error", dI = "Stdlib__Buffer", dF = "Dune__exe__Frontend_util", dG = "Sexplib0", dE = "Note_brr", l = 250, dD = "Base__Obj_array", dC = "Stdlib__Out_channel", k = 268, i = "Base__Uchar_intf", j = 286, dB = "Brr_svg", g = 274, h = 103, f = 294, dA = "Base__Applicative", e = 142, dz = 105, dy = 195, d = "Base__Word_size", c = a.jsoo_runtime, b = c.caml_get_global_data();
    b.prim_count = 764;
    b.symbols = [
        0,
        [
            0,
            c0,
            11
        ],
        [
            0,
            c4,
            fJ
        ],
        [
            0,
            el,
            df
        ],
        [
            0,
            cG,
            fF
        ],
        [
            0,
            eL,
            t
        ],
        [
            0,
            fP,
            dU
        ],
        [
            0,
            bs,
            e9
        ],
        [
            0,
            ca,
            fM
        ],
        [
            0,
            c6,
            g9
        ],
        [
            0,
            H,
            fX
        ],
        [
            0,
            aS,
            10
        ],
        [
            0,
            cp,
            9
        ],
        [
            0,
            eU,
            62
        ],
        [
            0,
            fW,
            31
        ],
        [
            0,
            co,
            26
        ],
        [
            0,
            gU,
            17
        ],
        [
            0,
            f5,
            15
        ],
        [
            0,
            U,
            75
        ],
        [
            0,
            gh,
            30
        ],
        [
            0,
            aH,
            77
        ],
        [
            0,
            gP,
            42
        ],
        [
            0,
            cy,
            40
        ],
        [
            0,
            ar,
            21
        ],
        [
            0,
            g4,
            47
        ],
        [
            0,
            M,
            64
        ],
        [
            0,
            dJ,
            23
        ],
        [
            0,
            gs,
            60
        ],
        [
            0,
            cY,
            43
        ],
        [
            0,
            hg,
            50
        ],
        [
            0,
            e2,
            53
        ],
        [
            0,
            cL,
            39
        ],
        [
            0,
            dC,
            57
        ],
        [
            0,
            a7,
            22
        ],
        [
            0,
            x,
            67
        ],
        [
            0,
            fv,
            16
        ],
        [
            0,
            gR,
            37
        ],
        [
            0,
            g$,
            45
        ],
        [
            0,
            fc,
            76
        ],
        [
            0,
            b$,
            32
        ],
        [
            0,
            bh,
            41
        ],
        [
            0,
            g_,
            73
        ],
        [
            0,
            cF,
            27
        ],
        [
            0,
            by,
            38
        ],
        [
            0,
            ai,
            20
        ],
        [
            0,
            c9,
            36
        ],
        [
            0,
            bJ,
            35
        ],
        [
            0,
            y,
            28
        ],
        [
            0,
            dt,
            56
        ],
        [
            0,
            ff,
            61
        ],
        [
            0,
            al,
            55
        ],
        [
            0,
            dM,
            54
        ],
        [
            0,
            bd,
            63
        ],
        [
            0,
            bq,
            34
        ],
        [
            0,
            dj,
            70
        ],
        [
            0,
            dQ,
            69
        ],
        [
            0,
            eq,
            14
        ],
        [
            0,
            cI,
            78
        ],
        [
            0,
            gm,
            51
        ],
        [
            0,
            fo,
            48
        ],
        [
            0,
            gW,
            58
        ],
        [
            0,
            hp,
            46
        ],
        [
            0,
            f7,
            71
        ],
        [
            0,
            bL,
            25
        ],
        [
            0,
            fg,
            65
        ],
        [
            0,
            cc,
            74
        ],
        [
            0,
            hr,
            29
        ],
        [
            0,
            dI,
            44
        ],
        [
            0,
            E,
            24
        ],
        [
            0,
            cE,
            59
        ],
        [
            0,
            gG,
            18
        ],
        [
            0,
            d0,
            72
        ],
        [
            0,
            gp,
            33
        ],
        [
            0,
            bF,
            52
        ],
        [
            0,
            dl,
            13
        ],
        [
            0,
            cn,
            em
        ],
        [
            0,
            cT,
            aL
        ],
        [
            0,
            hd,
            fY
        ],
        [
            0,
            dO,
            ei
        ],
        [
            0,
            W,
            gZ
        ],
        [
            0,
            bG,
            8
        ],
        [
            0,
            ao,
            cB
        ],
        [
            0,
            dW,
            g0
        ],
        [
            0,
            c_,
            h
        ],
        [
            0,
            aK,
            G
        ],
        [
            0,
            av,
            c2
        ],
        [
            0,
            g8,
            bl
        ],
        [
            0,
            fl,
            s
        ],
        [
            0,
            dT,
            dz
        ],
        [
            0,
            f$,
            aA
        ],
        [
            0,
            bW,
            eR
        ],
        [
            0,
            dG,
            aI
        ],
        [
            0,
            cD,
            dk
        ],
        [
            0,
            e6,
            k
        ],
        [
            0,
            fA,
            f3
        ],
        [
            0,
            fN,
            g
        ],
        [
            0,
            fK,
            w
        ],
        [
            0,
            eX,
            eT
        ],
        [
            0,
            ae,
            j
        ],
        [
            0,
            f_,
            bi
        ],
        [
            0,
            gF,
            dn
        ],
        [
            0,
            ch,
            eM
        ],
        [
            0,
            cv,
            hx
        ],
        [
            0,
            bk,
            e5
        ],
        [
            0,
            de,
            dL
        ],
        [
            0,
            B,
            fk
        ],
        [
            0,
            f8,
            f
        ],
        [
            0,
            aa,
            bp
        ],
        [
            0,
            cg,
            bB
        ],
        [
            0,
            hn,
            7
        ],
        [
            0,
            eC,
            br
        ],
        [
            0,
            aj,
            cO
        ],
        [
            0,
            e4,
            ak
        ],
        [
            0,
            en,
            q
        ],
        [
            0,
            eB,
            bR
        ],
        [
            0,
            gX,
            eS
        ],
        [
            0,
            gr,
            b0
        ],
        [
            0,
            ds,
            cK
        ],
        [
            0,
            fV,
            R
        ],
        [
            0,
            bc,
            98
        ],
        [
            0,
            bI,
            97
        ],
        [
            0,
            dE,
            96
        ],
        [
            0,
            bt,
            95
        ],
        [
            0,
            eg,
            6
        ],
        [
            0,
            g3,
            5
        ],
        [
            0,
            a_,
            aN
        ],
        [
            0,
            cN,
            g2
        ],
        [
            0,
            eF,
            f1
        ],
        [
            0,
            dv,
            83
        ],
        [
            0,
            ho,
            82
        ],
        [
            0,
            gi,
            80
        ],
        [
            0,
            gn,
            79
        ],
        [
            0,
            aM,
            81
        ],
        [
            0,
            V,
            fj
        ],
        [
            0,
            _,
            4
        ],
        [
            0,
            bT,
            99
        ],
        [
            0,
            bK,
            84
        ],
        [
            0,
            eO,
            94
        ],
        [
            0,
            hh,
            3
        ],
        [
            0,
            au,
            hl
        ],
        [
            0,
            fU,
            c5
        ],
        [
            0,
            bb,
            2
        ],
        [
            0,
            dp,
            f6
        ],
        [
            0,
            gb,
            a1
        ],
        [
            0,
            cm,
            aC
        ],
        [
            0,
            dF,
            f2
        ],
        [
            0,
            cz,
            du
        ],
        [
            0,
            a0,
            g7
        ],
        [
            0,
            dS,
            fu
        ],
        [
            0,
            eY,
            1
        ],
        [
            0,
            an,
            66
        ],
        [
            0,
            cS,
            68
        ],
        [
            0,
            d8,
            19
        ],
        [
            0,
            cZ,
            12
        ],
        [
            0,
            aP,
            49
        ],
        [
            0,
            gv,
            92
        ],
        [
            0,
            aW,
            91
        ],
        [
            0,
            fm,
            88
        ],
        [
            0,
            gy,
            90
        ],
        [
            0,
            eQ,
            89
        ],
        [
            0,
            dB,
            93
        ],
        [
            0,
            dZ,
            86
        ],
        [
            0,
            hf,
            87
        ],
        [
            0,
            ez,
            85
        ],
        [
            0,
            aR,
            eK
        ],
        [
            0,
            d,
            v
        ],
        [
            0,
            bU,
            e
        ],
        [
            0,
            O,
            f0
        ],
        [
            0,
            aF,
            bn
        ],
        [
            0,
            dc,
            fE
        ],
        [
            0,
            a6,
            gO
        ],
        [
            0,
            i,
            ex
        ],
        [
            0,
            dx,
            e_
        ],
        [
            0,
            o,
            c8
        ],
        [
            0,
            ew,
            b8
        ],
        [
            0,
            hb,
            gA
        ],
        [
            0,
            fn,
            dm
        ],
        [
            0,
            eb,
            aG
        ],
        [
            0,
            dY,
            c7
        ],
        [
            0,
            I,
            as
        ],
        [
            0,
            cR,
            ga
        ],
        [
            0,
            b6,
            S
        ],
        [
            0,
            cs,
            J
        ],
        [
            0,
            b5,
            et
        ],
        [
            0,
            eH,
            aB
        ],
        [
            0,
            ep,
            gD
        ],
        [
            0,
            hu,
            eV
        ],
        [
            0,
            f4,
            ht
        ],
        [
            0,
            cU,
            aU
        ],
        [
            0,
            aw,
            p
        ],
        [
            0,
            P,
            a4
        ],
        [
            0,
            es,
            ek
        ],
        [
            0,
            gH,
            az
        ],
        [
            0,
            fa,
            fh
        ],
        [
            0,
            m,
            dw
        ],
        [
            0,
            fB,
            dX
        ],
        [
            0,
            gJ,
            ay
        ],
        [
            0,
            d5,
            aT
        ],
        [
            0,
            aD,
            bf
        ],
        [
            0,
            gu,
            fr
        ],
        [
            0,
            eE,
            hc
        ],
        [
            0,
            ey,
            bw
        ],
        [
            0,
            fI,
            fi
        ],
        [
            0,
            bM,
            ct
        ],
        [
            0,
            hv,
            Q
        ],
        [
            0,
            d_,
            cA
        ],
        [
            0,
            ge,
            at
        ],
        [
            0,
            bu,
            b_
        ],
        [
            0,
            A,
            d7
        ],
        [
            0,
            fZ,
            hq
        ],
        [
            0,
            bg,
            b3
        ],
        [
            0,
            e$,
            b4
        ],
        [
            0,
            aJ,
            $
        ],
        [
            0,
            X,
            fT
        ],
        [
            0,
            dH,
            fH
        ],
        [
            0,
            bo,
            ee
        ],
        [
            0,
            gL,
            N
        ],
        [
            0,
            fz,
            gB
        ],
        [
            0,
            dD,
            ef
        ],
        [
            0,
            bj,
            cj
        ],
        [
            0,
            di,
            bY
        ],
        [
            0,
            dr,
            be
        ],
        [
            0,
            g6,
            fd
        ],
        [
            0,
            d9,
            dh
        ],
        [
            0,
            cw,
            gz
        ],
        [
            0,
            d2,
            gE
        ],
        [
            0,
            cu,
            ad
        ],
        [
            0,
            T,
            dd
        ],
        [
            0,
            af,
            L
        ],
        [
            0,
            ax,
            K
        ],
        [
            0,
            dR,
            bN
        ],
        [
            0,
            cH,
            gd
        ],
        [
            0,
            eI,
            ah
        ],
        [
            0,
            dK,
            a8
        ],
        [
            0,
            gN,
            cl
        ],
        [
            0,
            C,
            ck
        ],
        [
            0,
            db,
            gT
        ],
        [
            0,
            gx,
            er
        ],
        [
            0,
            e3,
            aE
        ],
        [
            0,
            cW,
            l
        ],
        [
            0,
            ec,
            n
        ],
        [
            0,
            gS,
            b7
        ],
        [
            0,
            aZ,
            dN
        ],
        [
            0,
            gf,
            d1
        ],
        [
            0,
            d4,
            d3
        ],
        [
            0,
            gw,
            d6
        ],
        [
            0,
            fG,
            e8
        ],
        [
            0,
            eD,
            fL
        ],
        [
            0,
            e0,
            dV
        ],
        [
            0,
            c$,
            fb
        ],
        [
            0,
            cV,
            go
        ],
        [
            0,
            ap,
            hk
        ],
        [
            0,
            bP,
            a3
        ],
        [
            0,
            r,
            hm
        ],
        [
            0,
            bE,
            cC
        ],
        [
            0,
            fS,
            gK
        ],
        [
            0,
            aX,
            aq
        ],
        [
            0,
            a2,
            gI
        ],
        [
            0,
            ci,
            fR
        ],
        [
            0,
            bO,
            ag
        ],
        [
            0,
            he,
            da
        ],
        [
            0,
            ba,
            cb
        ],
        [
            0,
            cr,
            d$
        ],
        [
            0,
            D,
            cx
        ],
        [
            0,
            c1,
            c3
        ],
        [
            0,
            hs,
            bz
        ],
        [
            0,
            gq,
            gQ
        ],
        [
            0,
            g5,
            cQ
        ],
        [
            0,
            fe,
            eJ
        ],
        [
            0,
            eh,
            Z
        ],
        [
            0,
            hi,
            e7
        ],
        [
            0,
            bv,
            b1
        ],
        [
            0,
            cX,
            dg
        ],
        [
            0,
            fx,
            eu
        ],
        [
            0,
            gk,
            aO
        ],
        [
            0,
            gV,
            bD
        ],
        [
            0,
            e1,
            ft
        ],
        [
            0,
            ha,
            ed
        ],
        [
            0,
            cM,
            eN
        ],
        [
            0,
            fq,
            b2
        ],
        [
            0,
            eW,
            bZ
        ],
        [
            0,
            gg,
            bx
        ],
        [
            0,
            bV,
            hw
        ],
        [
            0,
            eP,
            b9
        ],
        [
            0,
            cJ,
            bH
        ],
        [
            0,
            bC,
            fs
        ],
        [
            0,
            cd,
            bQ
        ],
        [
            0,
            a$,
            u
        ],
        [
            0,
            bm,
            fQ
        ],
        [
            0,
            fC,
            eo
        ],
        [
            0,
            gj,
            f9
        ],
        [
            0,
            gt,
            fO
        ],
        [
            0,
            gC,
            fw
        ],
        [
            0,
            aQ,
            Y
        ],
        [
            0,
            aV,
            cP
        ],
        [
            0,
            bX,
            gl
        ],
        [
            0,
            ac,
            dy
        ],
        [
            0,
            bS,
            gM
        ],
        [
            0,
            ea,
            z
        ],
        [
            0,
            a9,
            cq
        ],
        [
            0,
            g1,
            am
        ],
        [
            0,
            dq,
            bA
        ],
        [
            0,
            ej,
            gY
        ],
        [
            0,
            F,
            eZ
        ],
        [
            0,
            ce,
            eG
        ],
        [
            0,
            aY,
            fp
        ],
        [
            0,
            hj,
            gc
        ],
        [
            0,
            a5,
            fD
        ],
        [
            0,
            dA,
            eA
        ],
        [
            0,
            fy,
            ab
        ],
        [
            0,
            dP,
            ev
        ],
        [
            0,
            cf,
            0
        ]
    ];
    var hy = [
        0,
        ej
    ], hz = [
        0,
        ea
    ], hA = [
        0,
        ac
    ], hB = [
        0,
        0,
        [
            0,
            gt
        ],
        fO,
        0,
        1
    ], hC = [
        0,
        gC
    ], hD = [
        0,
        [
            0,
            0,
            [
                0,
                aV
            ],
            cP,
            0,
            1
        ],
        [
            0,
            aQ
        ],
        Y,
        0,
        2
    ], hE = [
        0,
        bm
    ], hF = [
        0,
        0,
        [
            0,
            fC
        ],
        eo,
        0,
        1
    ], hG = [
        0,
        bC
    ], hH = [
        0,
        0,
        [
            0,
            cd
        ],
        bQ,
        0,
        1
    ], hI = [
        0,
        0,
        [
            0,
            bV
        ],
        hw,
        0,
        1
    ], hJ = [
        0,
        eP
    ], hK = [
        0,
        0,
        [
            0,
            cM
        ],
        eN,
        0,
        1
    ], hL = [
        0,
        fq
    ], hM = [
        0,
        0,
        [
            0,
            eW
        ],
        bZ,
        0,
        1
    ], hN = [
        0,
        e1
    ], hO = [
        0,
        gk
    ], hP = [
        0,
        cX
    ], hQ = [
        0,
        eh
    ], hR = [
        0,
        bO
    ], hS = [
        0,
        0,
        [
            0,
            he
        ],
        da,
        0,
        1
    ], hT = [
        0,
        bE
    ], hU = [
        0,
        0,
        [
            0,
            fS
        ],
        gK,
        0,
        1
    ], hV = [
        0,
        bP
    ], hW = [
        0,
        cV
    ], hX = [
        0,
        ec
    ], hY = [
        0,
        0,
        [
            0,
            aZ
        ],
        dN,
        [
            0,
            0,
            [
                0,
                gS
            ],
            b7,
            0,
            1
        ],
        2
    ], hZ = [
        0,
        e3
    ], h0 = [
        0,
        0,
        [
            0,
            C
        ],
        ck,
        0,
        1
    ], h1 = [
        0,
        db
    ], h2 = [
        0,
        dK
    ], h3 = [
        0,
        dR
    ], h4 = [
        0,
        cw
    ], h5 = [
        0,
        0,
        [
            0,
            d2
        ],
        gE,
        0,
        1
    ], h6 = [
        0,
        0,
        [
            0,
            fz
        ],
        gB,
        0,
        1
    ], h7 = [
        0,
        dD
    ], h8 = [
        0,
        [
            0,
            0,
            [
                0,
                di
            ],
            bY,
            0,
            1
        ],
        [
            0,
            bj
        ],
        cj,
        0,
        2
    ], h9 = [
        0,
        bo
    ], h_ = [
        0,
        X
    ], h$ = [
        0,
        e$
    ], ia = [
        0,
        ey
    ], ib = [
        0,
        0,
        [
            0,
            fI
        ],
        fi,
        0,
        1
    ], ic = [
        0,
        fB
    ], id = [
        0,
        gH
    ], ie = [
        0,
        P
    ], ig = [
        0,
        cU
    ], ih = [
        0,
        ep
    ], ii = [
        0,
        hb
    ], ij = [
        0,
        i
    ], ik = [
        0,
        dB
    ], il = [
        0,
        gy
    ], im = [
        0,
        gv
    ], io = [
        0,
        cS
    ], ip = [
        0,
        cz
    ], iq = [
        0,
        0,
        [
            0,
            gb
        ],
        a1,
        [
            0,
            0,
            [
                0,
                dp
            ],
            f6,
            0,
            1
        ],
        2
    ], ir = [
        0,
        cm
    ], is = [
        0,
        fU
    ], it = [
        0,
        eO
    ], iu = [
        0,
        bT
    ], iv = [
        0,
        V
    ], iw = [
        0,
        0,
        [
            0,
            a_
        ],
        aN,
        0,
        1
    ], ix = [
        0,
        cN
    ], iy = [
        0,
        0,
        [
            0,
            eF
        ],
        f1,
        0,
        1
    ], iz = [
        0,
        eg
    ], iA = [
        0,
        bI
    ], iB = [
        0,
        fV
    ], iC = [
        0,
        gX
    ], iD = [
        0,
        0,
        [
            0,
            gr
        ],
        b0,
        0,
        1
    ], iE = [
        0,
        e4
    ], iF = [
        0,
        eC
    ], iG = [
        0,
        cg
    ], iH = [
        0,
        f8
    ], iI = [
        0,
        cv
    ], iJ = [
        0,
        [
            0,
            0,
            [
                0,
                de
            ],
            dL,
            0,
            1
        ],
        [
            0,
            bk
        ],
        e5,
        0,
        2
    ], iK = [
        0,
        f_
    ], iL = [
        0,
        0,
        [
            0,
            gF
        ],
        dn,
        0,
        1
    ], iM = [
        0,
        eX
    ], iN = [
        0,
        fA
    ], iO = [
        0,
        0,
        [
            0,
            fN
        ],
        g,
        0,
        1
    ], iP = [
        0,
        0,
        [
            0,
            bW
        ],
        eR,
        0,
        1
    ], iQ = [
        0,
        dG
    ], iR = [
        0,
        0,
        [
            0,
            cD
        ],
        dk,
        0,
        1
    ], iS = [
        0,
        0,
        [
            0,
            fl
        ],
        s,
        0,
        1
    ], iT = [
        0,
        dT
    ], iU = [
        0,
        ao
    ], iV = [
        0,
        dO
    ], iW = [
        0,
        0,
        [
            0,
            W
        ],
        gZ,
        0,
        1
    ], iX = [
        0,
        0,
        [
            0,
            cn
        ],
        em,
        0,
        1
    ], iY = [
        0,
        cT
    ], iZ = [
        0,
        cI
    ], i0 = [
        0,
        dj
    ], i1 = [
        0,
        ff
    ], i2 = [
        0,
        x
    ], i3 = [
        0,
        dC
    ], i4 = [
        0,
        e2
    ], i5 = [
        0,
        M
    ], i6 = [
        0,
        aH
    ], i7 = [
        0,
        aS
    ], i8 = [
        0,
        0,
        [
            0,
            fP
        ],
        dU,
        0,
        1
    ], i9 = [
        0,
        bs
    ], i_ = [
        0,
        c0
    ];
    b.sections = [
        0,
        [
            0,
            311,
            [
                0,
                [
                    0,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            cf
                                        ],
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dP
                                            ],
                                            ev,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    [
                                        0,
                                        fy
                                    ],
                                    ab,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dA
                                            ],
                                            eA,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            a5
                                        ],
                                        fD,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                hj
                                            ],
                                            gc,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    3
                                ],
                                [
                                    0,
                                    aY
                                ],
                                fp,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            ce
                                        ],
                                        eG,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                F
                                            ],
                                            eZ,
                                            [
                                                0,
                                                0,
                                                hy,
                                                gY,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        dq
                                    ],
                                    bA,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                g1
                                            ],
                                            am,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            a9
                                        ],
                                        cq,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                hz,
                                                z,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                bS
                                            ],
                                            gM,
                                            [
                                                0,
                                                0,
                                                hA,
                                                dy,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    4
                                ],
                                5
                            ],
                            [
                                0,
                                bX
                            ],
                            gl,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                hD,
                                                hC,
                                                fw,
                                                hB,
                                                3
                                            ],
                                            [
                                                0,
                                                gj
                                            ],
                                            f9,
                                            [
                                                0,
                                                hF,
                                                hE,
                                                fQ,
                                                0,
                                                2
                                            ],
                                            4
                                        ],
                                        [
                                            0,
                                            a$
                                        ],
                                        u,
                                        [
                                            0,
                                            [
                                                0,
                                                hH,
                                                hG,
                                                fs,
                                                0,
                                                2
                                            ],
                                            [
                                                0,
                                                cJ
                                            ],
                                            bH,
                                            [
                                                0,
                                                0,
                                                hJ,
                                                b9,
                                                hI,
                                                2
                                            ],
                                            3
                                        ],
                                        5
                                    ],
                                    [
                                        0,
                                        gg
                                    ],
                                    bx,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                hM,
                                                hL,
                                                b2,
                                                hK,
                                                2
                                            ],
                                            [
                                                0,
                                                ha
                                            ],
                                            ed,
                                            [
                                                0,
                                                0,
                                                hN,
                                                ft,
                                                0,
                                                1
                                            ],
                                            3
                                        ],
                                        [
                                            0,
                                            gV
                                        ],
                                        bD,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                hO,
                                                aO,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                fx
                                            ],
                                            eu,
                                            [
                                                0,
                                                0,
                                                hP,
                                                dg,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        4
                                    ],
                                    6
                                ],
                                [
                                    0,
                                    bv
                                ],
                                b1,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            hi
                                        ],
                                        e7,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                hQ,
                                                Z,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                fe
                                            ],
                                            eJ,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        g5
                                    ],
                                    cQ,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gq
                                            ],
                                            gQ,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            hs
                                        ],
                                        bz,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                c1
                                            ],
                                            c3,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    4
                                ],
                                7
                            ],
                            8
                        ],
                        [
                            0,
                            D
                        ],
                        cx,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cr
                                            ],
                                            d$,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            ba
                                        ],
                                        cb,
                                        [
                                            0,
                                            [
                                                0,
                                                hS,
                                                hR,
                                                ag,
                                                0,
                                                2
                                            ],
                                            [
                                                0,
                                                ci
                                            ],
                                            fR,
                                            0,
                                            3
                                        ],
                                        4
                                    ],
                                    [
                                        0,
                                        a2
                                    ],
                                    gI,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                aX
                                            ],
                                            aq,
                                            [
                                                0,
                                                hU,
                                                hT,
                                                cC,
                                                0,
                                                2
                                            ],
                                            3
                                        ],
                                        [
                                            0,
                                            r
                                        ],
                                        hm,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                hV,
                                                a3,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                ap
                                            ],
                                            hk,
                                            [
                                                0,
                                                0,
                                                hW,
                                                go,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        4
                                    ],
                                    5
                                ],
                                [
                                    0,
                                    c$
                                ],
                                fb,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            e0
                                        ],
                                        dV,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        eD
                                    ],
                                    fL,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                fG
                                            ],
                                            e8,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            gw
                                        ],
                                        d6,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                d4
                                            ],
                                            d3,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    3
                                ],
                                6
                            ],
                            [
                                0,
                                gf
                            ],
                            d1,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                hY,
                                                hX,
                                                n,
                                                0,
                                                3
                                            ],
                                            [
                                                0,
                                                cW
                                            ],
                                            l,
                                            [
                                                0,
                                                0,
                                                hZ,
                                                aE,
                                                0,
                                                1
                                            ],
                                            4
                                        ],
                                        [
                                            0,
                                            gx
                                        ],
                                        er,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                h1,
                                                gT,
                                                h0,
                                                2
                                            ],
                                            [
                                                0,
                                                gN
                                            ],
                                            cl,
                                            [
                                                0,
                                                0,
                                                h2,
                                                a8,
                                                0,
                                                1
                                            ],
                                            3
                                        ],
                                        5
                                    ],
                                    [
                                        0,
                                        eI
                                    ],
                                    ah,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cH
                                            ],
                                            gd,
                                            [
                                                0,
                                                0,
                                                h3,
                                                bN,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            ax
                                        ],
                                        K,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                af
                                            ],
                                            L,
                                            0,
                                            1
                                        ],
                                        3
                                    ],
                                    6
                                ],
                                [
                                    0,
                                    T
                                ],
                                dd,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cu
                                            ],
                                            ad,
                                            [
                                                0,
                                                h5,
                                                h4,
                                                gz,
                                                0,
                                                2
                                            ],
                                            3
                                        ],
                                        [
                                            0,
                                            d9
                                        ],
                                        dh,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                g6
                                            ],
                                            fd,
                                            0,
                                            1
                                        ],
                                        4
                                    ],
                                    [
                                        0,
                                        dr
                                    ],
                                    be,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                h8,
                                                h7,
                                                ef,
                                                h6,
                                                3
                                            ],
                                            [
                                                0,
                                                gL
                                            ],
                                            N,
                                            [
                                                0,
                                                0,
                                                h9,
                                                ee,
                                                0,
                                                1
                                            ],
                                            4
                                        ],
                                        [
                                            0,
                                            dH
                                        ],
                                        fH,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                h_,
                                                fT,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                aJ
                                            ],
                                            $,
                                            [
                                                0,
                                                0,
                                                h$,
                                                b4,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        5
                                    ],
                                    6
                                ],
                                7
                            ],
                            8
                        ],
                        9
                    ],
                    [
                        0,
                        bg
                    ],
                    b3,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                fZ
                                            ],
                                            hq,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            A
                                        ],
                                        d7,
                                        0,
                                        2
                                    ],
                                    [
                                        0,
                                        bu
                                    ],
                                    b_,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                ge
                                            ],
                                            at,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            d_
                                        ],
                                        cA,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                hv
                                            ],
                                            Q,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    3
                                ],
                                [
                                    0,
                                    bM
                                ],
                                ct,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                ib,
                                                ia,
                                                bw,
                                                0,
                                                2
                                            ],
                                            [
                                                0,
                                                eE
                                            ],
                                            hc,
                                            0,
                                            3
                                        ],
                                        [
                                            0,
                                            gu
                                        ],
                                        fr,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                aD
                                            ],
                                            bf,
                                            0,
                                            1
                                        ],
                                        4
                                    ],
                                    [
                                        0,
                                        d5
                                    ],
                                    aT,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            gJ
                                        ],
                                        ay,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ic,
                                                dX,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                m
                                            ],
                                            dw,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    5
                                ],
                                6
                            ],
                            [
                                0,
                                fa
                            ],
                            fh,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                id,
                                                az,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                es
                                            ],
                                            ek,
                                            [
                                                0,
                                                0,
                                                ie,
                                                a4,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            aw
                                        ],
                                        p,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ig,
                                                aU,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                f4
                                            ],
                                            ht,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        hu
                                    ],
                                    eV,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ih,
                                                gD,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                eH
                                            ],
                                            aB,
                                            0,
                                            2
                                        ],
                                        [
                                            0,
                                            b5
                                        ],
                                        et,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cs
                                            ],
                                            J,
                                            0,
                                            1
                                        ],
                                        3
                                    ],
                                    4
                                ],
                                [
                                    0,
                                    b6
                                ],
                                S,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            cR
                                        ],
                                        ga,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        I
                                    ],
                                    as,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            dY
                                        ],
                                        c7,
                                        0,
                                        1
                                    ],
                                    2
                                ],
                                5
                            ],
                            7
                        ],
                        [
                            0,
                            eb
                        ],
                        aG,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                fn
                                            ],
                                            dm,
                                            [
                                                0,
                                                0,
                                                ii,
                                                gA,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            ew
                                        ],
                                        b8,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                o
                                            ],
                                            c8,
                                            0,
                                            1
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        dx
                                    ],
                                    e_,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ij,
                                                ex,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                a6
                                            ],
                                            gO,
                                            0,
                                            2
                                        ],
                                        [
                                            0,
                                            dc
                                        ],
                                        fE,
                                        0,
                                        3
                                    ],
                                    4
                                ],
                                [
                                    0,
                                    aF
                                ],
                                bn,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                O
                                            ],
                                            f0,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            bU
                                        ],
                                        e,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                d
                                            ],
                                            v,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    [
                                        0,
                                        aR
                                    ],
                                    eK,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            ez
                                        ],
                                        85,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                hf
                                            ],
                                            87,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    3
                                ],
                                5
                            ],
                            [
                                0,
                                dZ
                            ],
                            86,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ik,
                                                93,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                eQ
                                            ],
                                            89,
                                            [
                                                0,
                                                0,
                                                il,
                                                90,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            fm
                                        ],
                                        88,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                aW
                                            ],
                                            91,
                                            [
                                                0,
                                                0,
                                                im,
                                                92,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        aP
                                    ],
                                    49,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            cZ
                                        ],
                                        12,
                                        0,
                                        1
                                    ],
                                    4
                                ],
                                [
                                    0,
                                    d8
                                ],
                                19,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                io,
                                                68,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                an
                                            ],
                                            66,
                                            0,
                                            2
                                        ],
                                        [
                                            0,
                                            eY
                                        ],
                                        1,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dS
                                            ],
                                            fu,
                                            0,
                                            1
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        a0
                                    ],
                                    g7,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ip,
                                                du,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                dF
                                            ],
                                            f2,
                                            [
                                                0,
                                                0,
                                                ir,
                                                aC,
                                                iq,
                                                3
                                            ],
                                            4
                                        ],
                                        [
                                            0,
                                            bb
                                        ],
                                        2,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                is,
                                                c5,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                au
                                            ],
                                            hl,
                                            0,
                                            2
                                        ],
                                        5
                                    ],
                                    6
                                ],
                                7
                            ],
                            8
                        ],
                        9
                    ],
                    10
                ],
                [
                    0,
                    hh
                ],
                3,
                [
                    0,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                it,
                                                94,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                bK
                                            ],
                                            84,
                                            [
                                                0,
                                                0,
                                                iu,
                                                99,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            _
                                        ],
                                        4,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iv,
                                                fj,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                aM
                                            ],
                                            81,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        gn
                                    ],
                                    79,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gi
                                            ],
                                            80,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            ho
                                        ],
                                        82,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dv
                                            ],
                                            83,
                                            [
                                                0,
                                                iy,
                                                ix,
                                                g2,
                                                iw,
                                                2
                                            ],
                                            3
                                        ],
                                        4
                                    ],
                                    5
                                ],
                                [
                                    0,
                                    g3
                                ],
                                5,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iz,
                                                6,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                bt
                                            ],
                                            95,
                                            0,
                                            2
                                        ],
                                        [
                                            0,
                                            dE
                                        ],
                                        96,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iA,
                                                97,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                bc
                                            ],
                                            98,
                                            [
                                                0,
                                                0,
                                                iB,
                                                R,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        ds
                                    ],
                                    cK,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                iD,
                                                iC,
                                                eS,
                                                0,
                                                2
                                            ],
                                            [
                                                0,
                                                eB
                                            ],
                                            bR,
                                            0,
                                            3
                                        ],
                                        [
                                            0,
                                            en
                                        ],
                                        q,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iE,
                                                ak,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                aj
                                            ],
                                            cO,
                                            [
                                                0,
                                                0,
                                                iF,
                                                br,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        4
                                    ],
                                    5
                                ],
                                6
                            ],
                            [
                                0,
                                hn
                            ],
                            7,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iG,
                                                bB,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                aa
                                            ],
                                            bp,
                                            [
                                                0,
                                                0,
                                                iH,
                                                f,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            B
                                        ],
                                        fk,
                                        [
                                            0,
                                            [
                                                0,
                                                iJ,
                                                iI,
                                                hx,
                                                0,
                                                3
                                            ],
                                            [
                                                0,
                                                ch
                                            ],
                                            eM,
                                            [
                                                0,
                                                iL,
                                                iK,
                                                bi,
                                                0,
                                                2
                                            ],
                                            4
                                        ],
                                        5
                                    ],
                                    [
                                        0,
                                        ae
                                    ],
                                    j,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iM,
                                                eT,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                fK
                                            ],
                                            w,
                                            [
                                                0,
                                                iO,
                                                iN,
                                                f3,
                                                0,
                                                2
                                            ],
                                            3
                                        ],
                                        [
                                            0,
                                            e6
                                        ],
                                        k,
                                        [
                                            0,
                                            [
                                                0,
                                                iR,
                                                iQ,
                                                aI,
                                                iP,
                                                2
                                            ],
                                            [
                                                0,
                                                f$
                                            ],
                                            aA,
                                            [
                                                0,
                                                0,
                                                iT,
                                                dz,
                                                iS,
                                                2
                                            ],
                                            3
                                        ],
                                        4
                                    ],
                                    6
                                ],
                                [
                                    0,
                                    g8
                                ],
                                bl,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            av
                                        ],
                                        c2,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                aK
                                            ],
                                            G,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    [
                                        0,
                                        c_
                                    ],
                                    h,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dW
                                            ],
                                            g0,
                                            [
                                                0,
                                                0,
                                                iU,
                                                cB,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            bG
                                        ],
                                        8,
                                        [
                                            0,
                                            [
                                                0,
                                                iW,
                                                iV,
                                                ei,
                                                0,
                                                2
                                            ],
                                            [
                                                0,
                                                hd
                                            ],
                                            fY,
                                            [
                                                0,
                                                0,
                                                iY,
                                                aL,
                                                iX,
                                                2
                                            ],
                                            3
                                        ],
                                        4
                                    ],
                                    5
                                ],
                                7
                            ],
                            8
                        ],
                        [
                            0,
                            dl
                        ],
                        13,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            bF
                                        ],
                                        52,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        gp
                                    ],
                                    33,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            d0
                                        ],
                                        72,
                                        0,
                                        1
                                    ],
                                    2
                                ],
                                [
                                    0,
                                    gG
                                ],
                                18,
                                [
                                    0,
                                    0,
                                    [
                                        0,
                                        cE
                                    ],
                                    59,
                                    0,
                                    1
                                ],
                                3
                            ],
                            [
                                0,
                                E
                            ],
                            24,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            dI
                                        ],
                                        44,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        hr
                                    ],
                                    29,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cc
                                            ],
                                            74,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            fg
                                        ],
                                        65,
                                        0,
                                        2
                                    ],
                                    3
                                ],
                                [
                                    0,
                                    bL
                                ],
                                25,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            f7
                                        ],
                                        71,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        hp
                                    ],
                                    46,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gW
                                            ],
                                            58,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            fo
                                        ],
                                        48,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gm
                                            ],
                                            51,
                                            [
                                                0,
                                                0,
                                                iZ,
                                                78,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    4
                                ],
                                5
                            ],
                            6
                        ],
                        9
                    ],
                    [
                        0,
                        eq
                    ],
                    14,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dQ
                                            ],
                                            69,
                                            [
                                                0,
                                                0,
                                                i0,
                                                70,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            bq
                                        ],
                                        34,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                bd
                                            ],
                                            63,
                                            0,
                                            1
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        dM
                                    ],
                                    54,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            al
                                        ],
                                        55,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                i1,
                                                61,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                dt
                                            ],
                                            56,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    4
                                ],
                                [
                                    0,
                                    y
                                ],
                                28,
                                [
                                    0,
                                    0,
                                    [
                                        0,
                                        bJ
                                    ],
                                    35,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            c9
                                        ],
                                        36,
                                        0,
                                        1
                                    ],
                                    2
                                ],
                                5
                            ],
                            [
                                0,
                                ai
                            ],
                            20,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            by
                                        ],
                                        38,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        cF
                                    ],
                                    27,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                g_
                                            ],
                                            73,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            bh
                                        ],
                                        41,
                                        0,
                                        2
                                    ],
                                    3
                                ],
                                [
                                    0,
                                    b$
                                ],
                                32,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                fc
                                            ],
                                            76,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            g$
                                        ],
                                        45,
                                        0,
                                        2
                                    ],
                                    [
                                        0,
                                        gR
                                    ],
                                    37,
                                    0,
                                    3
                                ],
                                4
                            ],
                            6
                        ],
                        [
                            0,
                            fv
                        ],
                        16,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                i2,
                                                67,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                a7
                                            ],
                                            22,
                                            [
                                                0,
                                                0,
                                                i3,
                                                57,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            cL
                                        ],
                                        39,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                i4,
                                                53,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                hg
                                            ],
                                            50,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        cY
                                    ],
                                    43,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gs
                                            ],
                                            60,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            dJ
                                        ],
                                        23,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                i5,
                                                64,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                g4
                                            ],
                                            47,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    4
                                ],
                                [
                                    0,
                                    ar
                                ],
                                21,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            cy
                                        ],
                                        40,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gP
                                            ],
                                            42,
                                            [
                                                0,
                                                0,
                                                i6,
                                                77,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        gh
                                    ],
                                    30,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            U
                                        ],
                                        75,
                                        0,
                                        1
                                    ],
                                    4
                                ],
                                5
                            ],
                            [
                                0,
                                f5
                            ],
                            15,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            gU
                                        ],
                                        17,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        co
                                    ],
                                    26,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            fW
                                        ],
                                        31,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                eU
                                            ],
                                            62,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    3
                                ],
                                [
                                    0,
                                    cp
                                ],
                                9,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                i7,
                                                10,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                H
                                            ],
                                            fX,
                                            0,
                                            2
                                        ],
                                        [
                                            0,
                                            c6
                                        ],
                                        g9,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                ca
                                            ],
                                            fM,
                                            [
                                                0,
                                                0,
                                                i9,
                                                e9,
                                                i8,
                                                2
                                            ],
                                            3
                                        ],
                                        4
                                    ],
                                    [
                                        0,
                                        eL
                                    ],
                                    t,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cG
                                            ],
                                            fF,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            el
                                        ],
                                        df,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                c4
                                            ],
                                            fJ,
                                            [
                                                0,
                                                0,
                                                i_,
                                                11,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    5
                                ],
                                6
                            ],
                            7
                        ],
                        8
                    ],
                    10
                ],
                11
            ]
        ],
        0,
        c.caml_list_of_js_array([
            "Base_am_testing",
            "Base_caml_exn_is_most_recent_exn",
            "Base_clear_caml_backtrace_pos",
            "Base_hash_double",
            "Base_hash_string",
            "Base_int_math_int32_clz",
            "Base_int_math_int32_ctz",
            "Base_int_math_int64_clz",
            "Base_int_math_int64_ctz",
            "Base_int_math_int64_pow_stub",
            "Base_int_math_int_clz",
            "Base_int_math_int_ctz",
            "Base_int_math_int_popcount",
            "Base_int_math_int_pow_stub",
            "Base_int_math_nativeint_clz",
            "Base_int_math_nativeint_ctz",
            "Base_internalhash_fold_float",
            "Base_internalhash_fold_int",
            "Base_internalhash_fold_int64",
            "Base_internalhash_fold_string",
            "Base_internalhash_get_hash_value",
            "Base_unsafe_create_local_bytes",
            "BigStringReader",
            "MlBytes",
            "MlFakeDevice",
            "MlFakeFd",
            "MlFakeFd_out",
            "MlFakeFile",
            "MlFile",
            "MlInt64",
            "MlMutex",
            "MlNat",
            "MlNodeDevice",
            "MlNodeFd",
            "MlObjectTable",
            "MlStringReader",
            "Ml_Bigarray",
            "Ml_Bigarray_c_1_1",
            "UInt8ArrayReader",
            "add_nat",
            "bigstring_of_array_buffer",
            "bigstring_of_typed_array",
            "bigstring_to_array_buffer",
            "bigstring_to_typed_array",
            "blake2b",
            "blit_nat",
            "caml_MD5Final",
            "caml_MD5Init",
            "caml_MD5Transform",
            "caml_MD5Update",
            "caml_acosh_float",
            "caml_alloc_dummy_infix",
            "caml_alloc_stack",
            "caml_argv",
            "caml_array_append",
            "caml_array_blit",
            "caml_array_bound_error",
            "caml_array_concat",
            "caml_array_fill",
            "caml_array_get",
            "caml_array_of_bytes",
            "caml_array_of_string",
            "caml_array_set",
            "caml_array_sub",
            "caml_asinh_float",
            "caml_atanh_float",
            "caml_atomic_cas",
            "caml_atomic_exchange",
            "caml_atomic_fetch_add",
            "caml_atomic_load",
            "caml_atomic_make_contended",
            "caml_ba_blit",
            "caml_ba_change_layout",
            "caml_ba_compare",
            "caml_ba_create",
            "caml_ba_create_buffer",
            "caml_ba_create_from",
            "caml_ba_create_unsafe",
            "caml_ba_custom_name",
            "caml_ba_deserialize",
            "caml_ba_dim",
            "caml_ba_dim_1",
            "caml_ba_dim_2",
            "caml_ba_dim_3",
            "caml_ba_fill",
            "caml_ba_from_typed_array",
            "caml_ba_get_1",
            "caml_ba_get_2",
            "caml_ba_get_3",
            "caml_ba_get_generic",
            "caml_ba_get_size",
            "caml_ba_get_size_per_element",
            "caml_ba_hash",
            "caml_ba_init",
            "caml_ba_kind",
            "caml_ba_kind_of_typed_array",
            "caml_ba_layout",
            "caml_ba_map_file",
            "caml_ba_map_file_bytecode",
            "caml_ba_num_dims",
            "caml_ba_reshape",
            "caml_ba_serialize",
            "caml_ba_set_1",
            "caml_ba_set_2",
            "caml_ba_set_3",
            "caml_ba_set_generic",
            "caml_ba_slice",
            "caml_ba_sub",
            "caml_ba_to_typed_array",
            "caml_ba_uint8_get16",
            "caml_ba_uint8_get32",
            "caml_ba_uint8_get64",
            "caml_ba_uint8_set16",
            "caml_ba_uint8_set32",
            "caml_ba_uint8_set64",
            "caml_backtrace_status",
            "caml_bigstring_blit_ba_to_ba",
            "caml_bigstring_blit_ba_to_bytes",
            "caml_bigstring_blit_bytes_to_ba",
            "caml_bigstring_blit_string_to_ba",
            "caml_bigstring_memcmp",
            "caml_blake2_create",
            "caml_blake2_final",
            "caml_blake2_string",
            "caml_blake2_update",
            "caml_blit_bytes",
            "caml_blit_string",
            "caml_bswap16",
            "caml_build_symbols",
            "caml_bytes_bound_error",
            "caml_bytes_compare",
            "caml_bytes_equal",
            "caml_bytes_get",
            "caml_bytes_get16",
            "caml_bytes_get32",
            "caml_bytes_get64",
            "caml_bytes_greaterequal",
            "caml_bytes_greaterthan",
            "caml_bytes_lessequal",
            "caml_bytes_lessthan",
            "caml_bytes_notequal",
            "caml_bytes_of_array",
            "caml_bytes_of_jsbytes",
            "caml_bytes_of_string",
            "caml_bytes_of_utf16_jsstring",
            "caml_bytes_set",
            "caml_bytes_set16",
            "caml_bytes_set32",
            "caml_bytes_set64",
            "caml_bytes_unsafe_get",
            "caml_bytes_unsafe_set",
            "caml_call_gen",
            "caml_callback",
            "caml_cbrt_float",
            "caml_channel_descriptor",
            "caml_check_bound",
            "caml_classify_float",
            "caml_compare",
            "caml_compare_val",
            "caml_compare_val_get_custom",
            "caml_compare_val_number_custom",
            "caml_compare_val_tag",
            "caml_continuation_use_and_update_handler_noexc",
            "caml_continuation_use_noexc",
            "caml_convert_bytes_to_array",
            "caml_convert_raw_backtrace",
            "caml_convert_raw_backtrace_slot",
            "caml_convert_string_to_bytes",
            "caml_copysign_float",
            "caml_cosh_float",
            "caml_create_bytes",
            "caml_create_file",
            "caml_create_string",
            "caml_csel_value",
            "caml_current_dir",
            "caml_custom_event_index",
            "caml_custom_ops",
            "caml_decompress_input",
            "caml_div",
            "caml_domain_dls",
            "caml_domain_dls_compare_and_set",
            "caml_domain_dls_get",
            "caml_domain_dls_set",
            "caml_domain_id",
            "caml_domain_spawn",
            "caml_dummy_obj_is_stack",
            "caml_ephe_blit_data",
            "caml_ephe_blit_key",
            "caml_ephe_check_data",
            "caml_ephe_check_key",
            "caml_ephe_create",
            "caml_ephe_data_offset",
            "caml_ephe_get_data",
            "caml_ephe_get_data_copy",
            "caml_ephe_get_key",
            "caml_ephe_get_key_copy",
            "caml_ephe_key_offset",
            "caml_ephe_set_data",
            "caml_ephe_set_key",
            "caml_ephe_unset_data",
            "caml_ephe_unset_key",
            "caml_equal",
            "caml_erf_float",
            "caml_erfc_float",
            "caml_eventlog_pause",
            "caml_eventlog_resume",
            "caml_executable_name",
            "caml_exn_with_js_backtrace",
            "caml_exp2_float",
            "caml_expm1_float",
            "caml_failwith",
            "caml_fatal_uncaught_exception",
            "caml_fill_bytes",
            "caml_final_register",
            "caml_final_register_called_without_value",
            "caml_final_release",
            "caml_finish_formatting",
            "caml_float_compare",
            "caml_float_of_bytes",
            "caml_float_of_string",
            "caml_floatarray_blit",
            "caml_floatarray_create",
            "caml_fma_float",
            "caml_format_exception",
            "caml_format_float",
            "caml_format_int",
            "caml_fresh_oo_id",
            "caml_frexp_float",
            "caml_fs_init",
            "caml_gc_compaction",
            "caml_gc_counters",
            "caml_gc_full_major",
            "caml_gc_get",
            "caml_gc_huge_fallback_count",
            "caml_gc_major",
            "caml_gc_major_slice",
            "caml_gc_minor",
            "caml_gc_minor_words",
            "caml_gc_quick_stat",
            "caml_gc_set",
            "caml_gc_stat",
            "caml_get_continuation_callstack",
            "caml_get_current_callstack",
            "caml_get_exception_backtrace",
            "caml_get_exception_raw_backtrace",
            "caml_get_global_data",
            "caml_get_major_bucket",
            "caml_get_major_credit",
            "caml_get_minor_free",
            "caml_get_public_method",
            "caml_get_root",
            "caml_global_data",
            "caml_gr_arc_aux",
            "caml_gr_blit_image",
            "caml_gr_clear_graph",
            "caml_gr_close_graph",
            "caml_gr_close_subwindow",
            "caml_gr_create_image",
            "caml_gr_current_x",
            "caml_gr_current_y",
            "caml_gr_display_mode",
            "caml_gr_doc_of_state",
            "caml_gr_draw_arc",
            "caml_gr_draw_char",
            "caml_gr_draw_image",
            "caml_gr_draw_rect",
            "caml_gr_draw_str",
            "caml_gr_draw_string",
            "caml_gr_dump_image",
            "caml_gr_fill_arc",
            "caml_gr_fill_poly",
            "caml_gr_fill_rect",
            "caml_gr_lineto",
            "caml_gr_make_image",
            "caml_gr_moveto",
            "caml_gr_open_graph",
            "caml_gr_open_subwindow",
            "caml_gr_plot",
            "caml_gr_point_color",
            "caml_gr_remember_mode",
            "caml_gr_resize_window",
            "caml_gr_set_color",
            "caml_gr_set_font",
            "caml_gr_set_line_width",
            "caml_gr_set_text_size",
            "caml_gr_set_window_title",
            "caml_gr_sigio_handler",
            "caml_gr_sigio_signal",
            "caml_gr_size_x",
            "caml_gr_size_y",
            "caml_gr_state",
            "caml_gr_state_create",
            "caml_gr_state_get",
            "caml_gr_state_init",
            "caml_gr_state_set",
            "caml_gr_synchronize",
            "caml_gr_text_size",
            "caml_gr_wait_event",
            "caml_gr_window_id",
            "caml_greaterequal",
            "caml_greaterthan",
            "caml_hash",
            "caml_hash_mix_bigstring",
            "caml_hash_mix_bytes",
            "caml_hash_mix_bytes_arr",
            "caml_hash_mix_final",
            "caml_hash_mix_float",
            "caml_hash_mix_int",
            "caml_hash_mix_int64",
            "caml_hash_mix_jsbytes",
            "caml_hash_mix_string",
            "caml_hash_nat",
            "caml_hexstring_of_float",
            "caml_hypot_float",
            "caml_input_value",
            "caml_input_value_from_bytes",
            "caml_input_value_from_reader",
            "caml_input_value_from_string",
            "caml_input_value_to_outside_heap",
            "caml_install_signal_handler",
            "caml_int32_bits_of_float",
            "caml_int32_bswap",
            "caml_int32_float_of_bits",
            "caml_int32_unmarshal",
            "caml_int64_add",
            "caml_int64_and",
            "caml_int64_bits_of_float",
            "caml_int64_bswap",
            "caml_int64_compare",
            "caml_int64_create_lo_hi",
            "caml_int64_create_lo_mi_hi",
            "caml_int64_div",
            "caml_int64_float_of_bits",
            "caml_int64_format",
            "caml_int64_hash",
            "caml_int64_hi32",
            "caml_int64_is_negative",
            "caml_int64_is_zero",
            "caml_int64_lo32",
            "caml_int64_marshal",
            "caml_int64_mod",
            "caml_int64_mul",
            "caml_int64_neg",
            "caml_int64_of_bytes",
            "caml_int64_of_float",
            "caml_int64_of_int32",
            "caml_int64_of_string",
            "caml_int64_offset",
            "caml_int64_or",
            "caml_int64_shift_left",
            "caml_int64_shift_right",
            "caml_int64_shift_right_unsigned",
            "caml_int64_sub",
            "caml_int64_to_bytes",
            "caml_int64_to_float",
            "caml_int64_to_int32",
            "caml_int64_ult",
            "caml_int64_unmarshal",
            "caml_int64_xor",
            "caml_int_compare",
            "caml_int_of_string",
            "caml_invalid_argument",
            "caml_is_continuation_tag",
            "caml_is_js",
            "caml_is_ml_bytes",
            "caml_is_ml_string",
            "caml_is_printable",
            "caml_is_special_exception",
            "caml_js_call",
            "caml_js_delete",
            "caml_js_equals",
            "caml_js_error_of_exception",
            "caml_js_error_option_of_exception",
            "caml_js_eval_string",
            "caml_js_expr",
            "caml_js_from_array",
            "caml_js_from_bool",
            "caml_js_from_float",
            "caml_js_from_string",
            "caml_js_fun_call",
            "caml_js_function_arity",
            "caml_js_get",
            "caml_js_get_console",
            "caml_js_html_entities",
            "caml_js_html_escape",
            "caml_js_instanceof",
            "caml_js_meth_call",
            "caml_js_new",
            "caml_js_object",
            "caml_js_on_ie",
            "caml_js_pure_expr",
            "caml_js_set",
            "caml_js_strict_equals",
            "caml_js_to_array",
            "caml_js_to_bool",
            "caml_js_to_byte_string",
            "caml_js_to_float",
            "caml_js_to_int32",
            "caml_js_to_string",
            "caml_js_typeof",
            "caml_js_var",
            "caml_js_wrap_callback",
            "caml_js_wrap_callback_arguments",
            "caml_js_wrap_callback_strict",
            "caml_js_wrap_callback_unsafe",
            "caml_js_wrap_meth_callback",
            "caml_js_wrap_meth_callback_arguments",
            "caml_js_wrap_meth_callback_strict",
            "caml_js_wrap_meth_callback_unsafe",
            "caml_jsbytes_of_string",
            "caml_jsoo_flags_effects",
            "caml_jsoo_flags_use_js_string",
            "caml_jsstring_of_string",
            "caml_lazy_make_forward",
            "caml_lazy_read_result",
            "caml_lazy_reset_to_lazy",
            "caml_lazy_update_to_forcing",
            "caml_lazy_update_to_forward",
            "caml_ldexp_float",
            "caml_lessequal",
            "caml_lessthan",
            "caml_lex_array",
            "caml_lex_engine",
            "caml_list_mount_point",
            "caml_list_of_js_array",
            "caml_list_to_js_array",
            "caml_log10_float",
            "caml_log1p_float",
            "caml_log2_float",
            "caml_lxm_next",
            "caml_make_float_vect",
            "caml_make_local_vect",
            "caml_make_path",
            "caml_make_vect",
            "caml_marshal_constants",
            "caml_marshal_data_size",
            "caml_marshal_header_size",
            "caml_maybe_attach_backtrace",
            "caml_maybe_print_stats",
            "caml_md5_bytes",
            "caml_md5_chan",
            "caml_md5_string",
            "caml_memprof_discard",
            "caml_memprof_set",
            "caml_memprof_start",
            "caml_memprof_stop",
            "caml_ml_bytes_content",
            "caml_ml_bytes_length",
            "caml_ml_channel_get",
            "caml_ml_channel_redirect",
            "caml_ml_channel_restore",
            "caml_ml_channel_size",
            "caml_ml_channel_size_64",
            "caml_ml_channels",
            "caml_ml_close_channel",
            "caml_ml_condition_broadcast",
            "caml_ml_condition_new",
            "caml_ml_condition_signal",
            "caml_ml_condition_wait",
            "caml_ml_debug_info_status",
            "caml_ml_domain_cpu_relax",
            "caml_ml_domain_id",
            "caml_ml_domain_set_name",
            "caml_ml_enable_runtime_warnings",
            "caml_ml_flush",
            "caml_ml_input",
            "caml_ml_input_bigarray",
            "caml_ml_input_block",
            "caml_ml_input_char",
            "caml_ml_input_int",
            "caml_ml_input_scan_line",
            "caml_ml_is_binary_mode",
            "caml_ml_is_buffered",
            "caml_ml_mutex_lock",
            "caml_ml_mutex_new",
            "caml_ml_mutex_try_lock",
            "caml_ml_mutex_unlock",
            "caml_ml_open_descriptor_in",
            "caml_ml_open_descriptor_in_with_flags",
            "caml_ml_open_descriptor_out",
            "caml_ml_open_descriptor_out_with_flags",
            "caml_ml_out_channels_list",
            "caml_ml_output",
            "caml_ml_output_bigarray",
            "caml_ml_output_bytes",
            "caml_ml_output_char",
            "caml_ml_output_int",
            "caml_ml_output_ta",
            "caml_ml_pos_in",
            "caml_ml_pos_in_64",
            "caml_ml_pos_out",
            "caml_ml_pos_out_64",
            "caml_ml_runtime_events_are_active",
            "caml_ml_runtime_events_pause",
            "caml_ml_runtime_events_resume",
            "caml_ml_runtime_events_start",
            "caml_ml_runtime_warnings_enabled",
            "caml_ml_seek_in",
            "caml_ml_seek_in_64",
            "caml_ml_seek_out",
            "caml_ml_seek_out_64",
            "caml_ml_set_binary_mode",
            "caml_ml_set_buffered",
            "caml_ml_set_channel_name",
            "caml_ml_set_channel_output",
            "caml_ml_set_channel_refill",
            "caml_ml_string_length",
            "caml_mod",
            "caml_modf_float",
            "caml_mount_autoload",
            "caml_mul",
            "caml_named_value",
            "caml_named_values",
            "caml_nativeint_unmarshal",
            "caml_new_lex_engine",
            "caml_new_string",
            "caml_nextafter_float",
            "caml_notequal",
            "caml_obj_add_offset",
            "caml_obj_block",
            "caml_obj_compare_and_swap",
            "caml_obj_dup",
            "caml_obj_is_block",
            "caml_obj_is_shared",
            "caml_obj_make_forward",
            "caml_obj_raw_field",
            "caml_obj_reachable_words",
            "caml_obj_set_raw_field",
            "caml_obj_set_tag",
            "caml_obj_tag",
            "caml_obj_truncate",
            "caml_obj_update_tag",
            "caml_obj_with_tag",
            "caml_ojs_new_arr",
            "caml_oo_last_id",
            "caml_output_val",
            "caml_output_value",
            "caml_output_value_to_buffer",
            "caml_output_value_to_bytes",
            "caml_output_value_to_string",
            "caml_parse_digit",
            "caml_parse_engine",
            "caml_parse_format",
            "caml_parse_sign_and_base",
            "caml_parser_trace",
            "caml_pos_in",
            "caml_pos_out",
            "caml_pure_js_expr",
            "caml_raise_constant",
            "caml_raise_end_of_file",
            "caml_raise_no_such_file",
            "caml_raise_not_a_dir",
            "caml_raise_not_found",
            "caml_raise_sys_error",
            "caml_raise_with_arg",
            "caml_raise_with_args",
            "caml_raise_with_string",
            "caml_raise_zero_divide",
            "caml_raw_backtrace_length",
            "caml_raw_backtrace_next_slot",
            "caml_raw_backtrace_slot",
            "caml_read_file_content",
            "caml_recommended_domain_count",
            "caml_record_backtrace",
            "caml_record_backtrace_flag",
            "caml_refill",
            "caml_register_channel_for_spacetime",
            "caml_register_global",
            "caml_register_named_value",
            "caml_restore_raw_backtrace",
            "caml_root",
            "caml_round_float",
            "caml_runtime_events_create_cursor",
            "caml_runtime_events_free_cursor",
            "caml_runtime_events_read_poll",
            "caml_runtime_events_user_register",
            "caml_runtime_events_user_resolve",
            "caml_runtime_events_user_write",
            "caml_runtime_parameters",
            "caml_runtime_variant",
            "caml_runtime_warnings",
            "caml_seek_in",
            "caml_seek_out",
            "caml_set_oo_id",
            "caml_set_parser_trace",
            "caml_set_static_env",
            "caml_signbit_float",
            "caml_sinh_float",
            "caml_spacetime_enabled",
            "caml_spacetime_only_works_for_native_code",
            "caml_sse2_float64_max_bytecode",
            "caml_sse2_float64_min_bytecode",
            "caml_str_initialize",
            "caml_str_repeat",
            "caml_string_bound_error",
            "caml_string_compare",
            "caml_string_concat",
            "caml_string_equal",
            "caml_string_get",
            "caml_string_get16",
            "caml_string_get32",
            "caml_string_get64",
            "caml_string_greaterequal",
            "caml_string_greaterthan",
            "caml_string_hash",
            "caml_string_lessequal",
            "caml_string_lessthan",
            "caml_string_notequal",
            "caml_string_of_array",
            "caml_string_of_bytes",
            "caml_string_of_jsbytes",
            "caml_string_of_jsstring",
            "caml_string_set",
            "caml_string_set16",
            "caml_string_set32",
            "caml_string_set64",
            "caml_string_unsafe_get",
            "caml_string_unsafe_set",
            "caml_subarray_to_jsbytes",
            "caml_sys_argv",
            "caml_sys_chdir",
            "caml_sys_close",
            "caml_sys_const_backend_type",
            "caml_sys_const_big_endian",
            "caml_sys_const_int_size",
            "caml_sys_const_max_wosize",
            "caml_sys_const_naked_pointers_checked",
            "caml_sys_const_ostype_cygwin",
            "caml_sys_const_ostype_unix",
            "caml_sys_const_ostype_win32",
            "caml_sys_const_word_size",
            "caml_sys_executable_name",
            "caml_sys_exit",
            "caml_sys_fds",
            "caml_sys_file_exists",
            "caml_sys_get_argv",
            "caml_sys_get_config",
            "caml_sys_getcwd",
            "caml_sys_getenv",
            "caml_sys_is_directory",
            "caml_sys_is_regular_file",
            "caml_sys_isatty",
            "caml_sys_mkdir",
            "caml_sys_modify_argv",
            "caml_sys_open",
            "caml_sys_open_for_node",
            "caml_sys_random_seed",
            "caml_sys_read_directory",
            "caml_sys_remove",
            "caml_sys_rename",
            "caml_sys_rmdir",
            "caml_sys_system_command",
            "caml_sys_time",
            "caml_sys_time_include_children",
            "caml_sys_unsafe_getenv",
            "caml_tanh_float",
            "caml_to_js_string",
            "caml_trailing_slash",
            "caml_trampoline",
            "caml_trampoline_return",
            "caml_trunc_float",
            "caml_uint8_array_of_bytes",
            "caml_uint8_array_of_string",
            "caml_unix_cleanup",
            "caml_unix_closedir",
            "caml_unix_filedescr_of_fd",
            "caml_unix_findclose",
            "caml_unix_findfirst",
            "caml_unix_findnext",
            "caml_unix_getpwuid",
            "caml_unix_gettimeofday",
            "caml_unix_getuid",
            "caml_unix_gmtime",
            "caml_unix_has_symlink",
            "caml_unix_inet_addr_of_string",
            "caml_unix_isatty",
            "caml_unix_localtime",
            "caml_unix_lstat",
            "caml_unix_lstat_64",
            "caml_unix_mkdir",
            "caml_unix_mktime",
            "caml_unix_opendir",
            "caml_unix_readdir",
            "caml_unix_readlink",
            "caml_unix_rewinddir",
            "caml_unix_rmdir",
            "caml_unix_startup",
            "caml_unix_stat",
            "caml_unix_stat_64",
            "caml_unix_symlink",
            "caml_unix_time",
            "caml_unix_unlink",
            "caml_unmount",
            "caml_update_dummy",
            "caml_utf16_of_utf8",
            "caml_utf8_of_utf16",
            "caml_weak_create",
            "caml_weak_set",
            "caml_wrap_exception",
            "caml_xdg_defaults",
            "caml_xmlhttprequest_create",
            "caml_zstd_initialize",
            "compare_digits_nat",
            "compare_nat",
            "compare_nat_real",
            "complement_nat",
            "create_nat",
            "decr_nat",
            "deserialize_nat",
            "div_digit_nat",
            "div_helper",
            "div_nat",
            "fs_node_supported",
            "incr_nat",
            "initialize_nat",
            "is_digit_int",
            "is_digit_odd",
            "is_digit_zero",
            "jsoo_create_file",
            "jsoo_create_file_extern",
            "jsoo_effect_not_supported",
            "jsoo_floor_log2",
            "jsoo_is_ascii",
            "jsoo_mount_point",
            "jsoo_sys_getenv",
            "land_digit_nat",
            "length_nat",
            "lor_digit_nat",
            "lxor_digit_nat",
            "make_unix_err_args",
            "ms_float_to_ns_int64",
            "mult_digit_nat",
            "mult_nat",
            "nat_of_array",
            "nth_digit_nat",
            "nth_digit_nat_native",
            "num_digits_nat",
            "num_leading_zero_bits_in_digit",
            "os_type",
            "path_is_absolute",
            "ppx_expect_runtime_after_test",
            "ppx_expect_runtime_before_test",
            "ppx_expect_runtime_flush_stubs_streams",
            "ppx_expect_runtime_out_channel_position",
            "ppx_expect_runtime_saved_stderr",
            "ppx_expect_runtime_saved_stdout",
            "re_match",
            "re_partial_match",
            "re_replacement_text",
            "re_search_backward",
            "re_search_forward",
            "re_string_match",
            "resolve_fs_device",
            "serialize_nat",
            "set_digit_nat",
            "set_digit_nat_native",
            "set_to_zero_nat",
            "shift_left_nat",
            "shift_right_nat",
            "square_nat",
            "sub_nat",
            "time_now_nanosecond_counter_for_timing",
            "time_now_nanoseconds_since_unix_epoch_or_zero",
            "zstd_decompress"
        ]),
        0
    ];
    return;
})(globalThis);
//# 1 "../.js/default/stdlib/stdlib.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/stdlib/stdlib.cma.js"
//# 5 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function erase_rel(param) {
        if (typeof param === "number") return 0;
        switch(param[0]){
            case 0:
                var rest = param[1];
                return [
                    0,
                    erase_rel(rest)
                ];
            case 1:
                var rest$0 = param[1];
                return [
                    1,
                    erase_rel(rest$0)
                ];
            case 2:
                var rest$1 = param[1];
                return [
                    2,
                    erase_rel(rest$1)
                ];
            case 3:
                var rest$2 = param[1];
                return [
                    3,
                    erase_rel(rest$2)
                ];
            case 4:
                var rest$3 = param[1];
                return [
                    4,
                    erase_rel(rest$3)
                ];
            case 5:
                var rest$4 = param[1];
                return [
                    5,
                    erase_rel(rest$4)
                ];
            case 6:
                var rest$5 = param[1];
                return [
                    6,
                    erase_rel(rest$5)
                ];
            case 7:
                var rest$6 = param[1];
                return [
                    7,
                    erase_rel(rest$6)
                ];
            case 8:
                var rest$7 = param[2], ty = param[1];
                return [
                    8,
                    ty,
                    erase_rel(rest$7)
                ];
            case 9:
                var rest$8 = param[3], ty1 = param[1];
                return [
                    9,
                    ty1,
                    ty1,
                    erase_rel(rest$8)
                ];
            case 10:
                var rest$9 = param[1];
                return [
                    10,
                    erase_rel(rest$9)
                ];
            case 11:
                var rest$10 = param[1];
                return [
                    11,
                    erase_rel(rest$10)
                ];
            case 12:
                var rest$11 = param[1];
                return [
                    12,
                    erase_rel(rest$11)
                ];
            case 13:
                var rest$12 = param[1];
                return [
                    13,
                    erase_rel(rest$12)
                ];
            default:
                var rest$13 = param[1];
                return [
                    14,
                    erase_rel(rest$13)
                ];
        }
    }
    function concat_fmtty(fmtty1, fmtty2) {
        if (typeof fmtty1 === "number") return fmtty2;
        switch(fmtty1[0]){
            case 0:
                var rest = fmtty1[1];
                return [
                    0,
                    concat_fmtty(rest, fmtty2)
                ];
            case 1:
                var rest$0 = fmtty1[1];
                return [
                    1,
                    concat_fmtty(rest$0, fmtty2)
                ];
            case 2:
                var rest$1 = fmtty1[1];
                return [
                    2,
                    concat_fmtty(rest$1, fmtty2)
                ];
            case 3:
                var rest$2 = fmtty1[1];
                return [
                    3,
                    concat_fmtty(rest$2, fmtty2)
                ];
            case 4:
                var rest$3 = fmtty1[1];
                return [
                    4,
                    concat_fmtty(rest$3, fmtty2)
                ];
            case 5:
                var rest$4 = fmtty1[1];
                return [
                    5,
                    concat_fmtty(rest$4, fmtty2)
                ];
            case 6:
                var rest$5 = fmtty1[1];
                return [
                    6,
                    concat_fmtty(rest$5, fmtty2)
                ];
            case 7:
                var rest$6 = fmtty1[1];
                return [
                    7,
                    concat_fmtty(rest$6, fmtty2)
                ];
            case 8:
                var rest$7 = fmtty1[2], ty = fmtty1[1];
                return [
                    8,
                    ty,
                    concat_fmtty(rest$7, fmtty2)
                ];
            case 9:
                var rest$8 = fmtty1[3], ty2 = fmtty1[2], ty1 = fmtty1[1];
                return [
                    9,
                    ty1,
                    ty2,
                    concat_fmtty(rest$8, fmtty2)
                ];
            case 10:
                var rest$9 = fmtty1[1];
                return [
                    10,
                    concat_fmtty(rest$9, fmtty2)
                ];
            case 11:
                var rest$10 = fmtty1[1];
                return [
                    11,
                    concat_fmtty(rest$10, fmtty2)
                ];
            case 12:
                var rest$11 = fmtty1[1];
                return [
                    12,
                    concat_fmtty(rest$11, fmtty2)
                ];
            case 13:
                var rest$12 = fmtty1[1];
                return [
                    13,
                    concat_fmtty(rest$12, fmtty2)
                ];
            default:
                var rest$13 = fmtty1[1];
                return [
                    14,
                    concat_fmtty(rest$13, fmtty2)
                ];
        }
    }
    function concat_fmt(fmt1, fmt2) {
        if (typeof fmt1 === "number") return fmt2;
        switch(fmt1[0]){
            case 0:
                var rest = fmt1[1];
                return [
                    0,
                    concat_fmt(rest, fmt2)
                ];
            case 1:
                var rest$0 = fmt1[1];
                return [
                    1,
                    concat_fmt(rest$0, fmt2)
                ];
            case 2:
                var rest$1 = fmt1[2], pad = fmt1[1];
                return [
                    2,
                    pad,
                    concat_fmt(rest$1, fmt2)
                ];
            case 3:
                var rest$2 = fmt1[2], pad$0 = fmt1[1];
                return [
                    3,
                    pad$0,
                    concat_fmt(rest$2, fmt2)
                ];
            case 4:
                var rest$3 = fmt1[4], prec = fmt1[3], pad$1 = fmt1[2], iconv = fmt1[1];
                return [
                    4,
                    iconv,
                    pad$1,
                    prec,
                    concat_fmt(rest$3, fmt2)
                ];
            case 5:
                var rest$4 = fmt1[4], prec$0 = fmt1[3], pad$2 = fmt1[2], iconv$0 = fmt1[1];
                return [
                    5,
                    iconv$0,
                    pad$2,
                    prec$0,
                    concat_fmt(rest$4, fmt2)
                ];
            case 6:
                var rest$5 = fmt1[4], prec$1 = fmt1[3], pad$3 = fmt1[2], iconv$1 = fmt1[1];
                return [
                    6,
                    iconv$1,
                    pad$3,
                    prec$1,
                    concat_fmt(rest$5, fmt2)
                ];
            case 7:
                var rest$6 = fmt1[4], prec$2 = fmt1[3], pad$4 = fmt1[2], iconv$2 = fmt1[1];
                return [
                    7,
                    iconv$2,
                    pad$4,
                    prec$2,
                    concat_fmt(rest$6, fmt2)
                ];
            case 8:
                var rest$7 = fmt1[4], prec$3 = fmt1[3], pad$5 = fmt1[2], fconv = fmt1[1];
                return [
                    8,
                    fconv,
                    pad$5,
                    prec$3,
                    concat_fmt(rest$7, fmt2)
                ];
            case 9:
                var rest$8 = fmt1[2], pad$6 = fmt1[1];
                return [
                    9,
                    pad$6,
                    concat_fmt(rest$8, fmt2)
                ];
            case 10:
                var rest$9 = fmt1[1];
                return [
                    10,
                    concat_fmt(rest$9, fmt2)
                ];
            case 11:
                var rest$10 = fmt1[2], str = fmt1[1];
                return [
                    11,
                    str,
                    concat_fmt(rest$10, fmt2)
                ];
            case 12:
                var rest$11 = fmt1[2], chr = fmt1[1];
                return [
                    12,
                    chr,
                    concat_fmt(rest$11, fmt2)
                ];
            case 13:
                var rest$12 = fmt1[3], fmtty = fmt1[2], pad$7 = fmt1[1];
                return [
                    13,
                    pad$7,
                    fmtty,
                    concat_fmt(rest$12, fmt2)
                ];
            case 14:
                var rest$13 = fmt1[3], fmtty$0 = fmt1[2], pad$8 = fmt1[1];
                return [
                    14,
                    pad$8,
                    fmtty$0,
                    concat_fmt(rest$13, fmt2)
                ];
            case 15:
                var rest$14 = fmt1[1];
                return [
                    15,
                    concat_fmt(rest$14, fmt2)
                ];
            case 16:
                var rest$15 = fmt1[1];
                return [
                    16,
                    concat_fmt(rest$15, fmt2)
                ];
            case 17:
                var rest$16 = fmt1[2], fmting_lit = fmt1[1];
                return [
                    17,
                    fmting_lit,
                    concat_fmt(rest$16, fmt2)
                ];
            case 18:
                var rest$17 = fmt1[2], fmting_gen = fmt1[1];
                return [
                    18,
                    fmting_gen,
                    concat_fmt(rest$17, fmt2)
                ];
            case 19:
                var rest$18 = fmt1[1];
                return [
                    19,
                    concat_fmt(rest$18, fmt2)
                ];
            case 20:
                var rest$19 = fmt1[3], char_set = fmt1[2], width_opt = fmt1[1];
                return [
                    20,
                    width_opt,
                    char_set,
                    concat_fmt(rest$19, fmt2)
                ];
            case 21:
                var rest$20 = fmt1[2], counter = fmt1[1];
                return [
                    21,
                    counter,
                    concat_fmt(rest$20, fmt2)
                ];
            case 22:
                var rest$21 = fmt1[1];
                return [
                    22,
                    concat_fmt(rest$21, fmt2)
                ];
            case 23:
                var rest$22 = fmt1[2], ign = fmt1[1];
                return [
                    23,
                    ign,
                    concat_fmt(rest$22, fmt2)
                ];
            default:
                var rest$23 = fmt1[3], f = fmt1[2], arity = fmt1[1];
                return [
                    24,
                    arity,
                    f,
                    concat_fmt(rest$23, fmt2)
                ];
        }
    }
    var CamlinternalFormatBasics = [
        0,
        concat_fmtty,
        erase_rel,
        concat_fmt
    ];
    runtime.caml_register_global(0, CamlinternalFormatBasics, "CamlinternalFormatBasics");
    return;
})(globalThis);
//# 180 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_false$0 = "false", cst_true$0 = "true", caml_atomic_cas = runtime.caml_atomic_cas, caml_atomic_load = runtime.caml_atomic_load, caml_create_bytes = runtime.caml_create_bytes, caml_float_of_string = runtime.caml_float_of_string, caml_int64_float_of_bits = runtime.caml_int64_float_of_bits, caml_int_of_string = runtime.caml_int_of_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_channel_size = runtime.caml_ml_channel_size, caml_ml_channel_size_64 = runtime.caml_ml_channel_size_64, caml_ml_close_channel = runtime.caml_ml_close_channel, caml_ml_flush = runtime.caml_ml_flush, caml_ml_input = runtime.caml_ml_input, caml_ml_input_char = runtime.caml_ml_input_char, caml_ml_open_descriptor_in = runtime.caml_ml_open_descriptor_in, caml_ml_open_descriptor_out = runtime.caml_ml_open_descriptor_out, caml_ml_output = runtime.caml_ml_output, caml_ml_output_bytes = runtime.caml_ml_output_bytes, caml_ml_output_char = runtime.caml_ml_output_char, caml_ml_set_binary_mode = runtime.caml_ml_set_binary_mode, caml_ml_set_channel_name = runtime.caml_ml_set_channel_name, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_concat = runtime.caml_string_concat, caml_string_of_bytes = runtime.caml_string_of_bytes, caml_sys_open = runtime.caml_sys_open, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), CamlinternalFormatBasics = global_data.CamlinternalFormatBasics, Invalid_argument = global_data.Invalid_argument, Failure = global_data.Failure, Match_failure = global_data.Match_failure, Assert_failure = global_data.Assert_failure, Not_found = global_data.Not_found, Out_of_memory = global_data.Out_of_memory, Stack_overflow = global_data.Stack_overflow, Sys_error = global_data.Sys_error, End_of_file = global_data.End_of_file, Division_by_zero = global_data.Division_by_zero, Sys_blocked_io = global_data.Sys_blocked_io, Undefined_recursive_module = global_data.Undefined_recursive_module;
    function failwith(s) {
        throw caml_maybe_attach_backtrace([
            0,
            Failure,
            s
        ], 1);
    }
    function invalid_arg(s) {
        throw caml_maybe_attach_backtrace([
            0,
            Invalid_argument,
            s
        ], 1);
    }
    var Exit = [
        248,
        "Stdlib.Exit",
        runtime.caml_fresh_oo_id(0)
    ];
    function min(x, y) {
        return runtime.caml_lessequal(x, y) ? x : y;
    }
    function max(x, y) {
        return runtime.caml_greaterequal(x, y) ? x : y;
    }
    function abs(x) {
        return 0 <= x ? x : -x | 0;
    }
    function lnot(x) {
        return x ^ -1;
    }
    var infinity = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(0, 0, 32752)), neg_infinity = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(0, 0, 65520)), nan = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(1, 0, 32760)), max_float = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 32751)), min_float = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(0, 0, 16)), epsilon_float = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(0, 0, 15536)), symbol_concat = caml_string_concat, cst_char_of_int = "char_of_int", cst_true = cst_true$0, cst_false = cst_false$0, cst_bool_of_string = "bool_of_string", _a_ = [
        0,
        1
    ], _b_ = [
        0,
        0
    ];
    function char_of_int(n) {
        if (0 <= n && 255 >= n) return n;
        return invalid_arg(cst_char_of_int);
    }
    function string_of_bool(b) {
        return b ? cst_true : cst_false;
    }
    function bool_of_string(param) {
        return param !== cst_false$0 ? param !== cst_true$0 ? invalid_arg(cst_bool_of_string) : 1 : 0;
    }
    function bool_of_string_opt(param) {
        return param !== cst_false$0 ? param !== cst_true$0 ? 0 : _a_ : _b_;
    }
    function string_of_int(n) {
        return "" + n;
    }
    function int_of_string_opt(s) {
        try {
            var _w_ = [
                0,
                caml_int_of_string(s)
            ];
            return _w_;
        } catch (_x_) {
            var _v_ = caml_wrap_exception(_x_);
            if (_v_[1] === Failure) return 0;
            throw caml_maybe_attach_backtrace(_v_, 0);
        }
    }
    function valid_float_lexem(s1) {
        var l = caml_ml_string_length(s1), i = 0;
        for(;;){
            if (l <= i) return s1 + ".";
            var match = runtime.caml_string_get(s1, i);
            a: {
                if (48 <= match) {
                    if (58 > match) break a;
                } else if (45 === match) break a;
                return s1;
            }
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function string_of_float(f) {
        return valid_float_lexem(runtime.caml_format_float("%.12g", f));
    }
    function float_of_string_opt(s) {
        try {
            var _t_ = [
                0,
                caml_float_of_string(s)
            ];
            return _t_;
        } catch (_u_) {
            var _s_ = caml_wrap_exception(_u_);
            if (_s_[1] === Failure) return 0;
            throw caml_maybe_attach_backtrace(_s_, 0);
        }
    }
    function symbol(l1, l2) {
        if (!l1) return l2;
        var _q_ = l1[2], h1 = l1[1];
        if (!_q_) return [
            0,
            h1,
            l2
        ];
        var match = _q_[2], h2 = _q_[1];
        if (!match) return [
            0,
            h1,
            [
                0,
                h2,
                l2
            ]
        ];
        var tl = match[2], h3 = match[1], block = [
            0,
            h3,
            24029
        ], dst = block, offset = 1, l1$0 = tl;
        for(;;){
            if (l1$0) {
                var _r_ = l1$0[2], h1$0 = l1$0[1];
                if (_r_) {
                    var match$0 = _r_[2], h2$0 = _r_[1];
                    if (match$0) {
                        var tl$0 = match$0[2], h3$0 = match$0[1], dst$0 = [
                            0,
                            h3$0,
                            24029
                        ];
                        dst[1 + offset] = [
                            0,
                            h1$0,
                            [
                                0,
                                h2$0,
                                dst$0
                            ]
                        ];
                        dst = dst$0;
                        offset = 1;
                        l1$0 = tl$0;
                        continue;
                    }
                    dst[1 + offset] = [
                        0,
                        h1$0,
                        [
                            0,
                            h2$0,
                            l2
                        ]
                    ];
                } else dst[1 + offset] = [
                    0,
                    h1$0,
                    l2
                ];
            } else dst[1 + offset] = l2;
            return [
                0,
                h1,
                [
                    0,
                    h2,
                    block
                ]
            ];
        }
    }
    var stdin = caml_ml_open_descriptor_in(0), stdout = caml_ml_open_descriptor_out(1), stderr = caml_ml_open_descriptor_out(2), _c_ = [
        0,
        1,
        [
            0,
            3,
            [
                0,
                4,
                [
                    0,
                    7,
                    0
                ]
            ]
        ]
    ], _d_ = [
        0,
        1,
        [
            0,
            3,
            [
                0,
                4,
                [
                    0,
                    6,
                    0
                ]
            ]
        ]
    ], cst_output = "output", cst_output_substring = "output_substring", _e_ = [
        0,
        0,
        [
            0,
            7,
            0
        ]
    ], _f_ = [
        0,
        0,
        [
            0,
            6,
            0
        ]
    ], cst_input = "input", cst_really_input = "really_input";
    function open_out_gen(mode, perm, name) {
        var c = caml_ml_open_descriptor_out(caml_sys_open(name, mode, perm));
        caml_ml_set_channel_name(c, name);
        return c;
    }
    function open_out(name) {
        return open_out_gen(_c_, 438, name);
    }
    function open_out_bin(name) {
        return open_out_gen(_d_, 438, name);
    }
    function flush_all(param) {
        var param$0 = runtime.caml_ml_out_channels_list(0);
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1];
            try {
                caml_ml_flush(a);
            } catch (_p_) {
                var _o_ = caml_wrap_exception(_p_);
                if (_o_[1] !== Sys_error) throw caml_maybe_attach_backtrace(_o_, 0);
            }
            param$0 = l;
        }
    }
    function output_bytes(oc, s) {
        return caml_ml_output_bytes(oc, s, 0, caml_ml_bytes_length(s));
    }
    function output_string(oc, s) {
        return caml_ml_output(oc, s, 0, caml_ml_string_length(s));
    }
    function output(oc, s, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs) return caml_ml_output_bytes(oc, s, ofs, len);
        return invalid_arg(cst_output);
    }
    function output_substring(oc, s, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_string_length(s) - len | 0) >= ofs) return caml_ml_output(oc, s, ofs, len);
        return invalid_arg(cst_output_substring);
    }
    function output_value(chan, v) {
        return runtime.caml_output_value(chan, v, 0);
    }
    function close_out(oc) {
        caml_ml_flush(oc);
        return caml_ml_close_channel(oc);
    }
    function close_out_noerr(oc) {
        try {
            caml_ml_flush(oc);
        } catch (_n_) {}
        try {
            var _l_ = caml_ml_close_channel(oc);
            return _l_;
        } catch (_m_) {
            return 0;
        }
    }
    function open_in_gen(mode, perm, name) {
        var c = caml_ml_open_descriptor_in(caml_sys_open(name, mode, perm));
        caml_ml_set_channel_name(c, name);
        return c;
    }
    function open_in(name) {
        return open_in_gen(_e_, 0, name);
    }
    function open_in_bin(name) {
        return open_in_gen(_f_, 0, name);
    }
    function input(ic, s, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs) return caml_ml_input(ic, s, ofs, len);
        return invalid_arg(cst_input);
    }
    function unsafe_really_input(ic, s, ofs, len) {
        var ofs$0 = ofs, len$0 = len;
        for(;;){
            if (0 >= len$0) return 0;
            var r = caml_ml_input(ic, s, ofs$0, len$0);
            if (0 === r) throw caml_maybe_attach_backtrace(End_of_file, 1);
            var len$1 = len$0 - r | 0, ofs$1 = ofs$0 + r | 0;
            ofs$0 = ofs$1;
            len$0 = len$1;
        }
    }
    function really_input(ic, s, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs) return unsafe_really_input(ic, s, ofs, len);
        return invalid_arg(cst_really_input);
    }
    function really_input_string(ic, len) {
        var s = caml_create_bytes(len);
        really_input(ic, s, 0, len);
        return caml_string_of_bytes(s);
    }
    function input_line(chan) {
        function build_result(buf, pos, param) {
            var pos$0 = pos, param$0 = param;
            for(;;){
                if (!param$0) return buf;
                var tl = param$0[2], hd = param$0[1], len = caml_ml_bytes_length(hd);
                runtime.caml_blit_bytes(hd, 0, buf, pos$0 - len | 0, len);
                var pos$1 = pos$0 - len | 0;
                pos$0 = pos$1;
                param$0 = tl;
            }
        }
        var accu = 0, len = 0;
        for(;;){
            var n = runtime.caml_ml_input_scan_line(chan);
            if (0 === n) {
                if (!accu) throw caml_maybe_attach_backtrace(End_of_file, 1);
                var _k_ = build_result(caml_create_bytes(len), len, accu);
            } else {
                if (0 >= n) {
                    var beg = caml_create_bytes(-n | 0);
                    caml_ml_input(chan, beg, 0, -n | 0);
                    var len$1 = len - n | 0, accu$0 = [
                        0,
                        beg,
                        accu
                    ];
                    accu = accu$0;
                    len = len$1;
                    continue;
                }
                var res = caml_create_bytes(n - 1 | 0);
                caml_ml_input(chan, res, 0, n - 1 | 0);
                caml_ml_input_char(chan);
                if (accu) var len$0 = (len + n | 0) - 1 | 0, _k_ = build_result(caml_create_bytes(len$0), len$0, [
                    0,
                    res,
                    accu
                ]);
                else var _k_ = res;
            }
            return caml_string_of_bytes(_k_);
        }
    }
    function close_in_noerr(ic) {
        try {
            var _i_ = caml_ml_close_channel(ic);
            return _i_;
        } catch (_j_) {
            return 0;
        }
    }
    function print_char(c) {
        return caml_ml_output_char(stdout, c);
    }
    function print_string(s) {
        return output_string(stdout, s);
    }
    function print_bytes(s) {
        return output_bytes(stdout, s);
    }
    function print_int(i) {
        return output_string(stdout, "" + i);
    }
    function print_float(f) {
        return output_string(stdout, string_of_float(f));
    }
    function print_endline(s) {
        output_string(stdout, s);
        caml_ml_output_char(stdout, 10);
        return caml_ml_flush(stdout);
    }
    function print_newline(param) {
        caml_ml_output_char(stdout, 10);
        return caml_ml_flush(stdout);
    }
    function prerr_char(c) {
        return caml_ml_output_char(stderr, c);
    }
    function prerr_string(s) {
        return output_string(stderr, s);
    }
    function prerr_bytes(s) {
        return output_bytes(stderr, s);
    }
    function prerr_int(i) {
        return output_string(stderr, "" + i);
    }
    function prerr_float(f) {
        return output_string(stderr, string_of_float(f));
    }
    function prerr_endline(s) {
        output_string(stderr, s);
        caml_ml_output_char(stderr, 10);
        return caml_ml_flush(stderr);
    }
    function prerr_newline(param) {
        caml_ml_output_char(stderr, 10);
        return caml_ml_flush(stderr);
    }
    function read_line(param) {
        caml_ml_flush(stdout);
        return input_line(stdin);
    }
    function read_int(param) {
        return caml_int_of_string(read_line(0));
    }
    function read_int_opt(param) {
        return int_of_string_opt(read_line(0));
    }
    function read_float(param) {
        return caml_float_of_string(read_line(0));
    }
    function read_float_opt(param) {
        return float_of_string_opt(read_line(0));
    }
    function string_of_format(param) {
        var str = param[2];
        return str;
    }
    function symbol$0(_h_, param) {
        var str2 = param[2], fmt2 = param[1], str1 = _h_[2], fmt1 = _h_[1], s2 = "%," + str2;
        return [
            0,
            caml_call2(CamlinternalFormatBasics[3], fmt1, fmt2),
            str1 + s2
        ];
    }
    var exit_function = [
        0,
        flush_all
    ];
    function at_exit(f) {
        for(;;){
            var f_yet_to_run = [
                0,
                1
            ], old_exit = caml_atomic_load(exit_function);
            let f_yet_to_run$0 = f_yet_to_run, old_exit$0 = old_exit;
            var new_exit = function(param) {
                if (caml_atomic_cas(f_yet_to_run$0, 1, 0)) caml_call1(f, 0);
                return caml_call1(old_exit$0, 0);
            }, success = caml_atomic_cas(exit_function, old_exit, new_exit), _g_ = 1 - success;
            if (!_g_) return _g_;
        }
    }
    var do_domain_local_at_exit = [
        0,
        function(param) {
            return 0;
        }
    ];
    function do_at_exit(param) {
        caml_call1(do_domain_local_at_exit[1], 0);
        return caml_call1(caml_atomic_load(exit_function), 0);
    }
    function exit(retcode) {
        do_at_exit(0);
        return runtime.caml_sys_exit(retcode);
    }
    runtime.caml_register_named_value("Pervasives.do_at_exit", do_at_exit);
    var Stdlib = [
        0,
        invalid_arg,
        failwith,
        Exit,
        Match_failure,
        Assert_failure,
        Invalid_argument,
        Failure,
        Not_found,
        Out_of_memory,
        Stack_overflow,
        Sys_error,
        End_of_file,
        Division_by_zero,
        Sys_blocked_io,
        Undefined_recursive_module,
        min,
        max,
        abs,
        2147483647,
        -2147483648,
        lnot,
        infinity,
        neg_infinity,
        nan,
        max_float,
        min_float,
        epsilon_float,
        symbol_concat,
        char_of_int,
        string_of_bool,
        bool_of_string_opt,
        bool_of_string,
        string_of_int,
        int_of_string_opt,
        string_of_float,
        float_of_string_opt,
        symbol,
        stdin,
        stdout,
        stderr,
        print_char,
        print_string,
        print_bytes,
        print_int,
        print_float,
        print_endline,
        print_newline,
        prerr_char,
        prerr_string,
        prerr_bytes,
        prerr_int,
        prerr_float,
        prerr_endline,
        prerr_newline,
        read_line,
        read_int_opt,
        read_int,
        read_float_opt,
        read_float,
        open_out,
        open_out_bin,
        open_out_gen,
        caml_ml_flush,
        flush_all,
        caml_ml_output_char,
        output_string,
        output_bytes,
        output,
        output_substring,
        caml_ml_output_char,
        runtime.caml_ml_output_int,
        output_value,
        runtime.caml_ml_seek_out,
        runtime.caml_ml_pos_out,
        caml_ml_channel_size,
        close_out,
        close_out_noerr,
        caml_ml_set_binary_mode,
        open_in,
        open_in_bin,
        open_in_gen,
        caml_ml_input_char,
        input_line,
        input,
        really_input,
        really_input_string,
        caml_ml_input_char,
        runtime.caml_ml_input_int,
        runtime.caml_input_value,
        runtime.caml_ml_seek_in,
        runtime.caml_ml_pos_in,
        caml_ml_channel_size,
        caml_ml_close_channel,
        close_in_noerr,
        caml_ml_set_binary_mode,
        [
            0,
            runtime.caml_ml_seek_out_64,
            runtime.caml_ml_pos_out_64,
            caml_ml_channel_size_64,
            runtime.caml_ml_seek_in_64,
            runtime.caml_ml_pos_in_64,
            caml_ml_channel_size_64
        ],
        string_of_format,
        symbol$0,
        exit,
        at_exit,
        valid_float_lexem,
        unsafe_really_input,
        do_at_exit,
        do_domain_local_at_exit
    ];
    runtime.caml_register_global(45, Stdlib, "Stdlib");
    return;
})(globalThis);
//# 775 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception, global_data = runtime.caml_get_global_data(), ocaml_version = "5.2.0", ocaml_release = [
        0,
        5,
        2,
        0,
        0
    ], Stdlib = global_data.Stdlib, executable_name = runtime.caml_sys_executable_name(0), os_type = runtime.caml_sys_get_config(0)[1], backend_type = [
        0,
        "js_of_ocaml"
    ], unix = runtime.caml_sys_const_ostype_unix(0), win32 = runtime.caml_sys_const_ostype_win32(0), cygwin = runtime.caml_sys_const_ostype_cygwin(0), max_array_length = runtime.caml_sys_const_max_wosize(0), max_floatarray_length = max_array_length / 2 | 0, max_string_length = (4 * max_array_length | 0) - 1 | 0;
    function getenv_opt(s) {
        try {
            var _d_ = [
                0,
                runtime.caml_sys_getenv(s)
            ];
            return _d_;
        } catch (_e_) {
            var _c_ = caml_wrap_exception(_e_);
            if (_c_ === Stdlib[8]) return 0;
            throw caml_maybe_attach_backtrace(_c_, 0);
        }
    }
    var interactive = [
        0,
        0
    ];
    function set_signal(sig_num, sig_beh) {
        return 0;
    }
    var Break = [
        248,
        "Stdlib.Sys.Break",
        runtime.caml_fresh_oo_id(0)
    ];
    function catch_break(on) {
        return on ? 0 : 0;
    }
    function Make(_b_, _a_) {
        return [
            0,
            1
        ];
    }
    var Immediate64 = [
        0,
        Make
    ], Stdlib_Sys = [
        0,
        executable_name,
        getenv_opt,
        interactive,
        os_type,
        backend_type,
        unix,
        win32,
        cygwin,
        32,
        32,
        0,
        max_string_length,
        max_array_length,
        max_floatarray_length,
        set_signal,
        -1,
        -2,
        -3,
        -4,
        -5,
        -6,
        -7,
        -8,
        -9,
        -10,
        -11,
        -12,
        -13,
        -14,
        -15,
        -16,
        -17,
        -18,
        -19,
        -20,
        -21,
        -22,
        -23,
        -24,
        -25,
        -26,
        -27,
        -28,
        Break,
        catch_break,
        ocaml_version,
        0,
        ocaml_release,
        runtime.caml_ml_enable_runtime_warnings,
        runtime.caml_ml_runtime_warnings_enabled,
        Immediate64
    ];
    runtime.caml_register_global(4, Stdlib_Sys, "Stdlib__Sys");
    return;
})(globalThis);
//# 870 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Obj_extension_constructor$1 = "Obj.extension_constructor", caml_obj_tag = runtime.caml_obj_tag;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Sys = global_data.Stdlib__Sys;
    function is_block(a) {
        return 1 - (typeof a === "number" ? 1 : 0);
    }
    var double_field = runtime.caml_array_get, set_double_field = runtime.caml_array_set, cst_Obj_extension_constructor = cst_Obj_extension_constructor$1, cst_Obj_extension_constructor$0 = cst_Obj_extension_constructor$1;
    function of_val(x) {
        a: {
            if (is_block(x) && caml_obj_tag(x) !== 248 && 1 <= x.length - 1) {
                var slot = x[1];
                break a;
            }
            var slot = x;
        }
        a: {
            if (is_block(slot) && caml_obj_tag(slot) === 248) {
                var name = slot[1];
                break a;
            }
            var name = caml_call1(Stdlib[1], cst_Obj_extension_constructor$0);
        }
        return caml_obj_tag(name) === 252 ? slot : caml_call1(Stdlib[1], cst_Obj_extension_constructor);
    }
    function name(slot) {
        return slot[1];
    }
    function id(slot) {
        return slot[2];
    }
    var Extension_constructor = [
        0,
        of_val,
        name,
        id
    ], max_ephe_length = Stdlib_Sys[13] - 2 | 0, cst_Obj_Ephemeron_create = "Obj.Ephemeron.create", cst_Obj_Ephemeron_get_key = "Obj.Ephemeron.get_key", cst_Obj_Ephemeron_get_key_copy = "Obj.Ephemeron.get_key_copy", cst_Obj_Ephemeron_set_key = "Obj.Ephemeron.set_key", cst_Obj_Ephemeron_unset_key = "Obj.Ephemeron.unset_key", cst_Obj_Ephemeron_check_key = "Obj.Ephemeron.check_key", cst_Obj_Ephemeron_blit_key = "Obj.Ephemeron.blit_key";
    function create(l) {
        var _f_ = 0 <= l ? 1 : 0, _g_ = _f_ ? l <= max_ephe_length ? 1 : 0 : _f_;
        if (1 - _g_) caml_call1(Stdlib[1], cst_Obj_Ephemeron_create);
        return runtime.caml_ephe_create(l);
    }
    function length(x) {
        return x.length - 3 | 0;
    }
    function raise_if_invalid_offset(e, o, msg) {
        var _c_ = 0 <= o ? 1 : 0, _d_ = _c_ ? o < length(e) ? 1 : 0 : _c_, _e_ = 1 - _d_;
        return _e_ ? caml_call1(Stdlib[1], msg) : _e_;
    }
    function get_key(e, o) {
        raise_if_invalid_offset(e, o, cst_Obj_Ephemeron_get_key);
        return runtime.caml_ephe_get_key(e, o);
    }
    function get_key_copy(e, o) {
        raise_if_invalid_offset(e, o, cst_Obj_Ephemeron_get_key_copy);
        return runtime.caml_ephe_get_key_copy(e, o);
    }
    function set_key(e, o, x) {
        raise_if_invalid_offset(e, o, cst_Obj_Ephemeron_set_key);
        return runtime.caml_ephe_set_key(e, o, x);
    }
    function unset_key(e, o) {
        raise_if_invalid_offset(e, o, cst_Obj_Ephemeron_unset_key);
        return runtime.caml_ephe_unset_key(e, o);
    }
    function check_key(e, o) {
        raise_if_invalid_offset(e, o, cst_Obj_Ephemeron_check_key);
        return runtime.caml_ephe_check_key(e, o);
    }
    function blit_key(e1, o1, e2, o2, l) {
        if (0 <= l && 0 <= o1 && (length(e1) - l | 0) >= o1 && 0 <= o2 && (length(e2) - l | 0) >= o2) {
            var _a_ = 0 !== l ? 1 : 0, _b_ = _a_ ? runtime.caml_ephe_blit_key(e1, o1, e2, o2, l) : _a_;
            return _b_;
        }
        return caml_call1(Stdlib[1], cst_Obj_Ephemeron_blit_key);
    }
    var Stdlib_Obj = [
        0,
        is_block,
        double_field,
        set_double_field,
        0,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        251,
        252,
        253,
        254,
        255,
        1000,
        1001,
        1002,
        Extension_constructor,
        [
            0,
            create,
            length,
            get_key,
            get_key_copy,
            set_key,
            unset_key,
            check_key,
            blit_key,
            runtime.caml_ephe_get_data,
            runtime.caml_ephe_get_data_copy,
            runtime.caml_ephe_set_data,
            runtime.caml_ephe_unset_data,
            runtime.caml_ephe_check_data,
            runtime.caml_ephe_blit_data,
            max_ephe_length
        ]
    ];
    runtime.caml_register_global(11, Stdlib_Obj, "Stdlib__Obj");
    return;
})(globalThis);
//# 1043 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_atomic_exchange = runtime.caml_atomic_exchange, caml_atomic_fetch_add = runtime.caml_atomic_fetch_add;
    function set(r, x) {
        caml_atomic_exchange(r, x);
        return 0;
    }
    function incr(r) {
        caml_atomic_fetch_add(r, 1);
        return 0;
    }
    function decr(r) {
        caml_atomic_fetch_add(r, -1);
        return 0;
    }
    var Stdlib_Atomic = [
        0,
        function(_a_) {
            return [
                0,
                _a_
            ];
        },
        runtime.caml_atomic_make_contended,
        runtime.caml_atomic_load,
        set,
        caml_atomic_exchange,
        runtime.caml_atomic_cas,
        caml_atomic_fetch_add,
        incr,
        decr
    ];
    runtime.caml_register_global(0, Stdlib_Atomic, "Stdlib__Atomic");
    return;
})(globalThis);
//# 1071 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_lazy_update_to_forward = runtime.caml_lazy_update_to_forward, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Obj = global_data.Stdlib__Obj, Undefined = [
        248,
        "CamlinternalLazy.Undefined",
        runtime.caml_fresh_oo_id(0)
    ];
    function force_gen_lazy_block(only_val, blk) {
        if (0 !== runtime.caml_lazy_update_to_forcing(blk)) throw caml_maybe_attach_backtrace(Undefined, 1);
        if (only_val) {
            var closure$0 = blk[1];
            blk[1] = 0;
            var result$0 = caml_call1(closure$0, 0);
            blk[1] = result$0;
            caml_lazy_update_to_forward(blk);
            return result$0;
        }
        var closure = blk[1];
        blk[1] = 0;
        try {
            var result = caml_call1(closure, 0);
            blk[1] = result;
            caml_lazy_update_to_forward(blk);
            return result;
        } catch (e$0) {
            var e = caml_wrap_exception(e$0);
            blk[1] = function(param) {
                throw caml_maybe_attach_backtrace(e, 0);
            };
            runtime.caml_lazy_reset_to_lazy(blk);
            throw caml_maybe_attach_backtrace(e, 0);
        }
    }
    function force_lazy_block(blk) {
        return force_gen_lazy_block(0, blk);
    }
    function force_gen(only_val, lzv) {
        var t = runtime.caml_obj_tag(lzv);
        if (t === Stdlib_Obj[12]) return lzv[1];
        if (t === Stdlib_Obj[6]) throw caml_maybe_attach_backtrace(Undefined, 1);
        return t !== Stdlib_Obj[8] ? lzv : force_gen_lazy_block(only_val, lzv);
    }
    var CamlinternalLazy = [
        0,
        Undefined,
        force_lazy_block,
        force_gen
    ];
    runtime.caml_register_global(2, CamlinternalLazy, "CamlinternalLazy");
    return;
})(globalThis);
//# 1130 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_obj_tag = runtime.caml_obj_tag;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), CamlinternalLazy = global_data.CamlinternalLazy, Stdlib_Obj = global_data.Stdlib__Obj, Undefined = CamlinternalLazy[1];
    function force_val(l) {
        return caml_call2(CamlinternalLazy[3], 1, l);
    }
    function from_fun(f) {
        var x = runtime.caml_obj_block(Stdlib_Obj[8], 1);
        x[1] = f;
        return x;
    }
    function from_val(v) {
        var t = caml_obj_tag(v);
        if (t !== Stdlib_Obj[12] && t !== Stdlib_Obj[8] && t !== Stdlib_Obj[6] && t !== Stdlib_Obj[16]) return v;
        return runtime.caml_lazy_make_forward(v);
    }
    function is_val(l) {
        var _i_ = Stdlib_Obj[8];
        return caml_obj_tag(l) !== _i_ ? 1 : 0;
    }
    function map(f, x) {
        return [
            246,
            function(_f_) {
                var _g_ = caml_obj_tag(x);
                a: if (250 === _g_) var _h_ = x[1];
                else {
                    if (246 !== _g_ && 244 !== _g_) {
                        var _h_ = x;
                        break a;
                    }
                    var _h_ = caml_call1(CamlinternalLazy[2], x);
                }
                return caml_call1(f, _h_);
            }
        ];
    }
    function map_val(f, x) {
        if (!is_val(x)) return [
            246,
            function(_c_) {
                var _d_ = caml_obj_tag(x);
                a: if (250 === _d_) var _e_ = x[1];
                else {
                    if (246 !== _d_ && 244 !== _d_) {
                        var _e_ = x;
                        break a;
                    }
                    var _e_ = caml_call1(CamlinternalLazy[2], x);
                }
                return caml_call1(f, _e_);
            }
        ];
        var _a_ = caml_obj_tag(x);
        a: if (250 === _a_) var _b_ = x[1];
        else {
            if (246 !== _a_ && 244 !== _a_) {
                var _b_ = x;
                break a;
            }
            var _b_ = caml_call1(CamlinternalLazy[2], x);
        }
        return from_val(caml_call1(f, _b_));
    }
    var Stdlib_Lazy = [
        0,
        Undefined,
        map,
        is_val,
        from_val,
        map_val,
        from_fun,
        force_val
    ];
    runtime.caml_register_global(2, Stdlib_Lazy, "Stdlib__Lazy");
    return;
})(globalThis);
//# 1215 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Assert_failure = global_data.Assert_failure, Stdlib_Atomic = global_data.Stdlib__Atomic, CamlinternalLazy = global_data.CamlinternalLazy, Stdlib = global_data.Stdlib, Stdlib_Lazy = global_data.Stdlib__Lazy, cst_Seq_init = "Seq.init", cst_Seq_take = "Seq.take", cst_Seq_drop = "Seq.drop";
    function empty(param) {
        return 0;
    }
    function return$0(x, param) {
        return [
            0,
            x,
            empty
        ];
    }
    function cons(x, next, param) {
        return [
            0,
            x,
            next
        ];
    }
    function append(seq1, seq2, param) {
        var match = caml_call1(seq1, 0);
        if (!match) return caml_call1(seq2, 0);
        var next = match[2], x = match[1];
        return [
            0,
            x,
            function(_au_) {
                return append(next, seq2, _au_);
            }
        ];
    }
    function map(f, seq, param) {
        var match = caml_call1(seq, 0);
        if (!match) return 0;
        var next = match[2], x = match[1];
        return [
            0,
            caml_call1(f, x),
            function(_at_) {
                return map(f, next, _at_);
            }
        ];
    }
    function filter_map(f, seq, param) {
        var seq$0 = seq;
        for(;;){
            var match = caml_call1(seq$0, 0);
            if (!match) return 0;
            var next = match[2], x = match[1], match$0 = caml_call1(f, x);
            if (match$0) {
                var y = match$0[1];
                return [
                    0,
                    y,
                    function(_as_) {
                        return filter_map(f, next, _as_);
                    }
                ];
            }
            seq$0 = next;
        }
    }
    function filter(f, seq, param) {
        var seq$0 = seq;
        for(;;){
            var match = caml_call1(seq$0, 0);
            if (!match) return 0;
            var next = match[2], x = match[1];
            if (caml_call1(f, x)) return [
                0,
                x,
                function(_ar_) {
                    return filter(f, next, _ar_);
                }
            ];
            seq$0 = next;
        }
    }
    function concat(seq, param) {
        var match = caml_call1(seq, 0);
        if (!match) return 0;
        var next = match[2], x = match[1];
        return append(x, function(_aq_) {
            return concat(next, _aq_);
        }, 0);
    }
    function flat_map(f, seq, param) {
        var match = caml_call1(seq, 0);
        if (!match) return 0;
        var next = match[2], x = match[1];
        return append(caml_call1(f, x), function(_ap_) {
            return flat_map(f, next, _ap_);
        }, 0);
    }
    function fold_left(f, acc, seq) {
        var acc$0 = acc, seq$0 = seq;
        for(;;){
            var match = caml_call1(seq$0, 0);
            if (!match) return acc$0;
            var next = match[2], x = match[1], acc$1 = caml_call2(f, acc$0, x);
            acc$0 = acc$1;
            seq$0 = next;
        }
    }
    function iter(f, seq) {
        var seq$0 = seq;
        for(;;){
            var match = caml_call1(seq$0, 0);
            if (!match) return 0;
            var next = match[2], x = match[1];
            caml_call1(f, x);
            seq$0 = next;
        }
    }
    function unfold(f, u, param) {
        var match = caml_call1(f, u);
        if (!match) return 0;
        var match$0 = match[1], u$0 = match$0[2], x = match$0[1];
        return [
            0,
            x,
            function(_ao_) {
                return unfold(f, u$0, _ao_);
            }
        ];
    }
    function is_empty(xs) {
        return caml_call1(xs, 0) ? 0 : 1;
    }
    function uncons(xs) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1];
        return [
            0,
            [
                0,
                x,
                xs$0
            ]
        ];
    }
    function length(xs$1) {
        var accu = 0, xs = xs$1;
        for(;;){
            var match = caml_call1(xs, 0);
            if (!match) return accu;
            var xs$0 = match[2], accu$0 = accu + 1 | 0;
            accu = accu$0;
            xs = xs$0;
        }
    }
    function iteri(f, xs$1) {
        var i = 0, xs = xs$1;
        for(;;){
            var match = caml_call1(xs, 0);
            if (!match) return 0;
            var xs$0 = match[2], x = match[1];
            caml_call2(f, i, x);
            var i$0 = i + 1 | 0;
            i = i$0;
            xs = xs$0;
        }
    }
    function fold_lefti(f, accu$1, xs$1) {
        var accu = accu$1, i = 0, xs = xs$1;
        for(;;){
            var match = caml_call1(xs, 0);
            if (!match) return accu;
            var xs$0 = match[2], x = match[1], accu$0 = caml_call3(f, accu, i, x), i$0 = i + 1 | 0;
            accu = accu$0;
            i = i$0;
            xs = xs$0;
        }
    }
    function for_all(p, xs) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 1;
            var xs$1 = match[2], x = match[1], _an_ = caml_call1(p, x);
            if (!_an_) return _an_;
            xs$0 = xs$1;
        }
    }
    function exists(p, xs) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], _am_ = caml_call1(p, x);
            if (_am_) return _am_;
            xs$0 = xs$1;
        }
    }
    function find(p, xs) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1];
            if (caml_call1(p, x)) return [
                0,
                x
            ];
            xs$0 = xs$1;
        }
    }
    function find_index(p, xs) {
        var i = 0, xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1];
            if (caml_call1(p, x)) return [
                0,
                i
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
            xs$0 = xs$1;
        }
    }
    function find_map(f, xs) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], result = caml_call1(f, x);
            if (result) return result;
            xs$0 = xs$1;
        }
    }
    function find_mapi(f, xs) {
        var i = 0, xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], result = caml_call2(f, i, x);
            if (result) return result;
            var i$0 = i + 1 | 0;
            i = i$0;
            xs$0 = xs$1;
        }
    }
    function iter2(f, xs, ys) {
        var xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(ys$0, 0);
            if (!match$0) return 0;
            var ys$1 = match$0[2], y = match$0[1];
            caml_call2(f, x, y);
            xs$0 = xs$1;
            ys$0 = ys$1;
        }
    }
    function fold_left2(f, accu, xs, ys) {
        var accu$0 = accu, xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return accu$0;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(ys$0, 0);
            if (!match$0) return accu$0;
            var ys$1 = match$0[2], y = match$0[1], accu$1 = caml_call3(f, accu$0, x, y);
            accu$0 = accu$1;
            xs$0 = xs$1;
            ys$0 = ys$1;
        }
    }
    function for_all2(f, xs, ys) {
        var xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 1;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(ys$0, 0);
            if (!match$0) return 1;
            var ys$1 = match$0[2], y = match$0[1], _al_ = caml_call2(f, x, y);
            if (!_al_) return _al_;
            xs$0 = xs$1;
            ys$0 = ys$1;
        }
    }
    function exists2(f, xs, ys) {
        var xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(ys$0, 0);
            if (!match$0) return 0;
            var ys$1 = match$0[2], y = match$0[1], _ak_ = caml_call2(f, x, y);
            if (_ak_) return _ak_;
            xs$0 = xs$1;
            ys$0 = ys$1;
        }
    }
    function equal(eq, xs, ys) {
        var xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0), match$0 = caml_call1(ys$0, 0);
            if (match) {
                if (match$0) {
                    var ys$1 = match$0[2], y = match$0[1], xs$1 = match[2], x = match[1], _aj_ = caml_call2(eq, x, y);
                    if (!_aj_) return _aj_;
                    xs$0 = xs$1;
                    ys$0 = ys$1;
                    continue;
                }
            } else if (!match$0) return 1;
            return 0;
        }
    }
    function compare(cmp, xs, ys) {
        var xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0), match$0 = caml_call1(ys$0, 0);
            if (!match) return match$0 ? -1 : 0;
            var xs$1 = match[2], x = match[1];
            if (!match$0) return 1;
            var ys$1 = match$0[2], y = match$0[1], c = caml_call2(cmp, x, y);
            if (0 !== c) return c;
            xs$0 = xs$1;
            ys$0 = ys$1;
        }
    }
    function init_aux(f, i, j, param) {
        if (i >= j) return 0;
        var _ah_ = i + 1 | 0;
        return [
            0,
            caml_call1(f, i),
            function(_ai_) {
                return init_aux(f, _ah_, j, _ai_);
            }
        ];
    }
    function init(n, f) {
        if (0 > n) return caml_call1(Stdlib[1], cst_Seq_init);
        var _af_ = 0;
        return function(_ag_) {
            return init_aux(f, _af_, n, _ag_);
        };
    }
    function repeat(x, param) {
        return [
            0,
            x,
            function(_ae_) {
                return repeat(x, _ae_);
            }
        ];
    }
    function forever(f, param) {
        return [
            0,
            caml_call1(f, 0),
            function(_ad_) {
                return forever(f, _ad_);
            }
        ];
    }
    function cycle_nonempty(xs, param) {
        return append(xs, function(_ac_) {
            return cycle_nonempty(xs, _ac_);
        }, 0);
    }
    function cycle(xs, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1];
        function _$_(_ab_) {
            return cycle_nonempty(xs, _ab_);
        }
        return [
            0,
            x,
            function(_aa_) {
                return append(xs$0, _$_, _aa_);
            }
        ];
    }
    function iterate1(f, x, param) {
        var y = caml_call1(f, x);
        return [
            0,
            y,
            function(___) {
                return iterate1(f, y, ___);
            }
        ];
    }
    function iterate(f, x) {
        function next(_Z_) {
            return iterate1(f, x, _Z_);
        }
        return function(_Y_) {
            return [
                0,
                x,
                next
            ];
        };
    }
    function mapi_aux(f, i, xs, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1], _W_ = i + 1 | 0;
        return [
            0,
            caml_call2(f, i, x),
            function(_X_) {
                return mapi_aux(f, _W_, xs$0, _X_);
            }
        ];
    }
    function mapi(f, xs) {
        var _U_ = 0;
        return function(_V_) {
            return mapi_aux(f, _U_, xs, _V_);
        };
    }
    function tail_scan(f, s, xs, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1], s$0 = caml_call2(f, s, x);
        return [
            0,
            s$0,
            function(_T_1) {
                return tail_scan(f, s$0, xs$0, _T_1);
            }
        ];
    }
    function scan(f, s, xs) {
        function next(_S_) {
            return tail_scan(f, s, xs, _S_);
        }
        return function(_R_) {
            return [
                0,
                s,
                next
            ];
        };
    }
    function take_aux(n, xs) {
        return 0 === n ? empty : function(param) {
            var match = caml_call1(xs, 0);
            if (!match) return 0;
            var xs$0 = match[2], x = match[1];
            return [
                0,
                x,
                take_aux(n - 1 | 0, xs$0)
            ];
        };
    }
    function take(n, xs) {
        if (n < 0) caml_call1(Stdlib[1], cst_Seq_take);
        return take_aux(n, xs);
    }
    function drop(n, xs) {
        return 0 <= n ? 0 === n ? xs : function(param) {
            var n$0 = n, xs$0 = xs;
            for(;;){
                var match = caml_call1(xs$0, 0);
                if (!match) return 0;
                var xs$1 = match[2], n$1 = n$0 - 1 | 0;
                if (0 === n$1) return caml_call1(xs$1, 0);
                n$0 = n$1;
                xs$0 = xs$1;
            }
        } : caml_call1(Stdlib[1], cst_Seq_drop);
    }
    function take_while(p, xs, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1];
        return caml_call1(p, x) ? [
            0,
            x,
            function(_Q_) {
                return take_while(p, xs$0, _Q_);
            }
        ] : 0;
    }
    function drop_while(p, xs, param) {
        var xs$0 = xs;
        for(;;){
            var node = caml_call1(xs$0, 0);
            if (!node) return 0;
            var xs$1 = node[2], x = node[1];
            if (!caml_call1(p, x)) return node;
            xs$0 = xs$1;
        }
    }
    function group(eq, xs, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1], _J_ = caml_call1(eq, x);
        function _K_(_P_) {
            return drop_while(_J_, xs$0, _P_);
        }
        var _L_ = caml_call1(eq, x);
        function next(_O_) {
            return take_while(_L_, xs$0, _O_);
        }
        return [
            0,
            function(_N_) {
                return [
                    0,
                    x,
                    next
                ];
            },
            function(_M_) {
                return group(eq, _K_, _M_);
            }
        ];
    }
    var Forced_twice = [
        248,
        "Stdlib.Seq.Forced_twice",
        runtime.caml_fresh_oo_id(0)
    ], to_lazy = Stdlib_Lazy[6], _a_ = [
        0,
        "seq.ml",
        616,
        4
    ];
    function failure(param) {
        throw caml_maybe_attach_backtrace(Forced_twice, 1);
    }
    function memoize(xs) {
        function s$0(param) {
            var match = caml_call1(xs, 0);
            if (!match) return 0;
            var xs$0 = match[2], x = match[1];
            return [
                0,
                x,
                memoize(xs$0)
            ];
        }
        var s = caml_call1(to_lazy, s$0);
        return function(param) {
            var _I_ = runtime.caml_obj_tag(s);
            if (250 === _I_) return s[1];
            if (246 !== _I_ && 244 !== _I_) return s;
            return caml_call1(CamlinternalLazy[2], s);
        };
    }
    function once(xs) {
        function f(param) {
            var match = caml_call1(xs, 0);
            if (!match) return 0;
            var xs$0 = match[2], x = match[1];
            return [
                0,
                x,
                once(xs$0)
            ];
        }
        var action = caml_call1(Stdlib_Atomic[1], f);
        return function(param) {
            var f = caml_call2(Stdlib_Atomic[5], action, failure);
            return caml_call1(f, 0);
        };
    }
    function zip(xs, ys, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1], match$0 = caml_call1(ys, 0);
        if (!match$0) return 0;
        var ys$0 = match$0[2], y = match$0[1];
        return [
            0,
            [
                0,
                x,
                y
            ],
            function(_H_) {
                return zip(xs$0, ys$0, _H_);
            }
        ];
    }
    function map2(f, xs, ys, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1], match$0 = caml_call1(ys, 0);
        if (!match$0) return 0;
        var ys$0 = match$0[2], y = match$0[1];
        return [
            0,
            caml_call2(f, x, y),
            function(_G_) {
                return map2(f, xs$0, ys$0, _G_);
            }
        ];
    }
    function interleave(xs, ys, param) {
        var match = caml_call1(xs, 0);
        if (!match) return caml_call1(ys, 0);
        var xs$0 = match[2], x = match[1];
        return [
            0,
            x,
            function(_F_) {
                return interleave(ys, xs$0, _F_);
            }
        ];
    }
    function sorted_merge1(cmp, x, xs, y, ys) {
        return 0 < caml_call2(cmp, x, y) ? [
            0,
            y,
            function(_D_) {
                var match = caml_call1(ys, 0);
                if (!match) return [
                    0,
                    x,
                    xs
                ];
                var ys$0 = match[2], y = match[1];
                return sorted_merge1(cmp, x, xs, y, ys$0);
            }
        ] : [
            0,
            x,
            function(_E_) {
                var match = caml_call1(xs, 0);
                if (!match) return [
                    0,
                    y,
                    ys
                ];
                var xs$0 = match[2], x = match[1];
                return sorted_merge1(cmp, x, xs$0, y, ys);
            }
        ];
    }
    function sorted_merge(cmp, xs, ys, param) {
        var match = caml_call1(xs, 0), match$0 = caml_call1(ys, 0);
        if (match) {
            if (match$0) {
                var ys$0 = match$0[2], y = match$0[1], xs$0 = match[2], x = match[1];
                return sorted_merge1(cmp, x, xs$0, y, ys$0);
            }
            var c = match;
        } else {
            if (!match$0) return 0;
            var c = match$0;
        }
        return c;
    }
    function map_fst(xys, param) {
        var match = caml_call1(xys, 0);
        if (!match) return 0;
        var xys$0 = match[2], x = match[1][1];
        return [
            0,
            x,
            function(_C_) {
                return map_fst(xys$0, _C_);
            }
        ];
    }
    function map_snd(xys, param) {
        var match = caml_call1(xys, 0);
        if (!match) return 0;
        var xys$0 = match[2], y = match[1][2];
        return [
            0,
            y,
            function(_B_) {
                return map_snd(xys$0, _B_);
            }
        ];
    }
    function unzip(xys) {
        return [
            0,
            function(_A_) {
                return map_fst(xys, _A_);
            },
            function(_z_) {
                return map_snd(xys, _z_);
            }
        ];
    }
    function filter_map_find_left_map(f, xs, param) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(f, x);
            if (0 === match$0[0]) {
                var y = match$0[1];
                return [
                    0,
                    y,
                    function(_y_) {
                        return filter_map_find_left_map(f, xs$1, _y_);
                    }
                ];
            }
            xs$0 = xs$1;
        }
    }
    function filter_map_find_right_map(f, xs, param) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(f, x);
            if (0 !== match$0[0]) {
                var z = match$0[1];
                return [
                    0,
                    z,
                    function(_x_) {
                        return filter_map_find_right_map(f, xs$1, _x_);
                    }
                ];
            }
            xs$0 = xs$1;
        }
    }
    function partition_map(f, xs) {
        return [
            0,
            function(_w_) {
                return filter_map_find_left_map(f, xs, _w_);
            },
            function(_v_) {
                return filter_map_find_right_map(f, xs, _v_);
            }
        ];
    }
    function partition(p, xs) {
        function _s_(x) {
            return 1 - caml_call1(p, x);
        }
        return [
            0,
            function(_u_) {
                return filter(p, xs, _u_);
            },
            function(_t_) {
                return filter(_s_, xs, _t_);
            }
        ];
    }
    function peel(xss) {
        return unzip(function(_r_) {
            return filter_map(uncons, xss, _r_);
        });
    }
    function transpose(xss, param) {
        var match = peel(xss), tails = match[2], heads = match[1];
        if (!is_empty(heads)) return [
            0,
            heads,
            function(_q_) {
                return transpose(tails, _q_);
            }
        ];
        if (is_empty(tails)) return 0;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
    }
    function _b_(remainders, xss, param) {
        var match = caml_call1(xss, 0);
        if (!match) return transpose(remainders, 0);
        var xss$0 = match[2], xs = match[1], match$0 = caml_call1(xs, 0);
        if (match$0) {
            var xs$0 = match$0[2], x = match$0[1], match$1 = peel(remainders), tails = match$1[2], heads = match$1[1], _l_ = function(_p_) {
                return [
                    0,
                    xs$0,
                    tails
                ];
            };
            return [
                0,
                function(_o_) {
                    return [
                        0,
                        x,
                        heads
                    ];
                },
                function(_n_) {
                    return _b_(_l_, xss$0, _n_);
                }
            ];
        }
        var match$2 = peel(remainders), tails$0 = match$2[2], heads$0 = match$2[1];
        return [
            0,
            heads$0,
            function(_m_) {
                return _b_(tails$0, xss$0, _m_);
            }
        ];
    }
    function map_product(f, xs, ys) {
        function _f_(x) {
            function _j_(y) {
                return caml_call2(f, x, y);
            }
            return function(_k_) {
                return map(_j_, ys, _k_);
            };
        }
        function xss(_i_) {
            return map(_f_, xs, _i_);
        }
        function _e_(_h_) {
            return _b_(empty, xss, _h_);
        }
        return function(_g_) {
            return concat(_e_, _g_);
        };
    }
    function product(xs, ys) {
        return map_product(function(x, y) {
            return [
                0,
                x,
                y
            ];
        }, xs, ys);
    }
    function of_dispenser(it) {
        function c(param) {
            var match = caml_call1(it, 0);
            if (!match) return 0;
            var x = match[1];
            return [
                0,
                x,
                c
            ];
        }
        return c;
    }
    function to_dispenser(xs) {
        var s = [
            0,
            xs
        ];
        return function(param) {
            var match = caml_call1(s[1], 0);
            if (!match) return 0;
            var xs = match[2], x = match[1];
            s[1] = xs;
            return [
                0,
                x
            ];
        };
    }
    function ints(i, param) {
        var _c_ = i + 1 | 0;
        return [
            0,
            i,
            function(_d_) {
                return ints(_c_, _d_);
            }
        ];
    }
    var Stdlib_Seq = [
        0,
        is_empty,
        uncons,
        length,
        iter,
        fold_left,
        iteri,
        fold_lefti,
        for_all,
        exists,
        find,
        find_index,
        find_map,
        find_mapi,
        iter2,
        fold_left2,
        for_all2,
        exists2,
        equal,
        compare,
        empty,
        return$0,
        cons,
        init,
        unfold,
        repeat,
        forever,
        cycle,
        iterate,
        map,
        mapi,
        filter,
        filter_map,
        scan,
        take,
        drop,
        take_while,
        drop_while,
        group,
        memoize,
        Forced_twice,
        once,
        transpose,
        append,
        concat,
        flat_map,
        flat_map,
        zip,
        map2,
        interleave,
        sorted_merge,
        product,
        map_product,
        unzip,
        unzip,
        partition_map,
        partition,
        of_dispenser,
        to_dispenser,
        ints
    ];
    runtime.caml_register_global(10, Stdlib_Seq, "Stdlib__Seq");
    return;
})(globalThis);
//# 1927 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Stdlib = global_data.Stdlib, cst_option_is_None = "option is None";
    function some(v) {
        return [
            0,
            v
        ];
    }
    function value(o, default$0) {
        if (!o) return default$0;
        var v = o[1];
        return v;
    }
    function get(param) {
        if (!param) return caml_call1(Stdlib[1], cst_option_is_None);
        var v = param[1];
        return v;
    }
    function bind(o, f) {
        if (!o) return 0;
        var v = o[1];
        return caml_call1(f, v);
    }
    function join(param) {
        if (!param) return 0;
        var o = param[1];
        return o;
    }
    function map(f, o) {
        if (!o) return 0;
        var v = o[1];
        return [
            0,
            caml_call1(f, v)
        ];
    }
    function fold(none, some, param) {
        if (!param) return none;
        var v = param[1];
        return caml_call1(some, v);
    }
    function iter(f, param) {
        if (!param) return 0;
        var v = param[1];
        return caml_call1(f, v);
    }
    function is_none(param) {
        return param ? 0 : 1;
    }
    function is_some(param) {
        return param ? 1 : 0;
    }
    function equal(eq, o0, o1) {
        if (o0) {
            if (o1) {
                var v1 = o1[1], v0 = o0[1];
                return caml_call2(eq, v0, v1);
            }
        } else if (!o1) return 1;
        return 0;
    }
    function compare(cmp, o0, o1) {
        if (!o0) return o1 ? -1 : 0;
        var v0 = o0[1];
        if (!o1) return 1;
        var v1 = o1[1];
        return caml_call2(cmp, v0, v1);
    }
    function to_result(none, param) {
        if (!param) return [
            1,
            none
        ];
        var v = param[1];
        return [
            0,
            v
        ];
    }
    function to_list(param) {
        if (!param) return 0;
        var v = param[1];
        return [
            0,
            v,
            0
        ];
    }
    function to_seq(param) {
        if (!param) return Stdlib_Seq[20];
        var v = param[1];
        return caml_call1(Stdlib_Seq[21], v);
    }
    var Stdlib_Option = [
        0,
        0,
        some,
        value,
        get,
        bind,
        join,
        map,
        fold,
        iter,
        is_none,
        is_some,
        equal,
        compare,
        to_result,
        to_list,
        to_seq
    ];
    runtime.caml_register_global(3, Stdlib_Option, "Stdlib__Option");
    return;
})(globalThis);
//# 2035 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Stdlib = global_data.Stdlib, cst_result_is_Error = "result is Error _", cst_result_is_Ok = "result is Ok _";
    function ok(v) {
        return [
            0,
            v
        ];
    }
    function error(e) {
        return [
            1,
            e
        ];
    }
    function value(r, default$0) {
        if (0 !== r[0]) return default$0;
        var v = r[1];
        return v;
    }
    function get_ok(param) {
        if (0 !== param[0]) return caml_call1(Stdlib[1], cst_result_is_Error);
        var v = param[1];
        return v;
    }
    function get_error(param) {
        if (0 === param[0]) return caml_call1(Stdlib[1], cst_result_is_Ok);
        var e = param[1];
        return e;
    }
    function bind(r, f) {
        if (0 !== r[0]) return r;
        var v = r[1];
        return caml_call1(f, v);
    }
    function join(e) {
        if (0 !== e[0]) return e;
        var r = e[1];
        return r;
    }
    function map(f, e) {
        if (0 !== e[0]) return e;
        var v = e[1];
        return [
            0,
            caml_call1(f, v)
        ];
    }
    function map_error(f, v) {
        if (0 === v[0]) return v;
        var e = v[1];
        return [
            1,
            caml_call1(f, e)
        ];
    }
    function fold(ok, error, param) {
        if (0 === param[0]) {
            var v = param[1];
            return caml_call1(ok, v);
        }
        var e = param[1];
        return caml_call1(error, e);
    }
    function iter(f, param) {
        if (0 !== param[0]) return 0;
        var v = param[1];
        return caml_call1(f, v);
    }
    function iter_error(f, param) {
        if (0 === param[0]) return 0;
        var e = param[1];
        return caml_call1(f, e);
    }
    function is_ok(param) {
        return 0 === param[0] ? 1 : 0;
    }
    function is_error(param) {
        return 0 === param[0] ? 0 : 1;
    }
    function equal(ok, error, r0, r1) {
        if (0 === r0[0]) {
            var v0 = r0[1];
            if (0 === r1[0]) {
                var v1 = r1[1];
                return caml_call2(ok, v0, v1);
            }
        } else {
            var e0 = r0[1];
            if (0 !== r1[0]) {
                var e1 = r1[1];
                return caml_call2(error, e0, e1);
            }
        }
        return 0;
    }
    function compare(ok, error, r0, r1) {
        if (0 === r0[0]) {
            var v0 = r0[1];
            if (0 !== r1[0]) return -1;
            var v1 = r1[1];
            return caml_call2(ok, v0, v1);
        }
        var e0 = r0[1];
        if (0 === r1[0]) return 1;
        var e1 = r1[1];
        return caml_call2(error, e0, e1);
    }
    function to_option(param) {
        if (0 !== param[0]) return 0;
        var v = param[1];
        return [
            0,
            v
        ];
    }
    function to_list(param) {
        if (0 !== param[0]) return 0;
        var v = param[1];
        return [
            0,
            v,
            0
        ];
    }
    function to_seq(param) {
        if (0 !== param[0]) return Stdlib_Seq[20];
        var v = param[1];
        return caml_call1(Stdlib_Seq[21], v);
    }
    var Stdlib_Result = [
        0,
        ok,
        error,
        value,
        get_ok,
        get_error,
        bind,
        join,
        map,
        map_error,
        fold,
        iter,
        iter_error,
        is_ok,
        is_error,
        equal,
        compare,
        to_option,
        to_list,
        to_seq
    ];
    runtime.caml_register_global(4, Stdlib_Result, "Stdlib__Result");
    return;
})(globalThis);
//# 2201 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_hash = runtime.caml_hash, caml_string_of_bytes = runtime.caml_string_of_bytes;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = "\\\\", cst$0 = "\\'", Stdlib = global_data.Stdlib, cst_Char_chr = "Char.chr", cst_b = "\\b", cst_t = "\\t", cst_n = "\\n", cst_r = "\\r";
    function chr(n) {
        if (0 <= n && 255 >= n) return n;
        return caml_call1(Stdlib[1], cst_Char_chr);
    }
    function escaped(c) {
        a: {
            if (40 <= c) {
                if (92 === c) return cst;
                if (127 > c) break a;
            } else {
                if (32 <= c) {
                    if (39 <= c) return cst$0;
                    break a;
                }
                if (14 > c) switch(c){
                    case 8:
                        return cst_b;
                    case 9:
                        return cst_t;
                    case 10:
                        return cst_n;
                    case 13:
                        return cst_r;
                }
            }
            var s = caml_create_bytes(4);
            caml_bytes_unsafe_set(s, 0, 92);
            caml_bytes_unsafe_set(s, 1, 48 + (c / 100 | 0) | 0);
            caml_bytes_unsafe_set(s, 2, 48 + ((c / 10 | 0) % 10 | 0) | 0);
            caml_bytes_unsafe_set(s, 3, 48 + (c % 10 | 0) | 0);
            return caml_string_of_bytes(s);
        }
        var s$0 = caml_create_bytes(1);
        caml_bytes_unsafe_set(s$0, 0, c);
        return caml_string_of_bytes(s$0);
    }
    function lowercase_ascii(c) {
        return 25 < c - 65 >>> 0 ? c : c + 32 | 0;
    }
    function uppercase_ascii(c) {
        return 25 < c - 97 >>> 0 ? c : c - 32 | 0;
    }
    function compare(c1, c2) {
        return c1 - c2 | 0;
    }
    function equal(c1, c2) {
        return 0 === (c1 - c2 | 0) ? 1 : 0;
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    var Stdlib_Char = [
        0,
        chr,
        escaped,
        lowercase_ascii,
        uppercase_ascii,
        compare,
        equal,
        seeded_hash,
        hash
    ];
    runtime.caml_register_global(8, Stdlib_Char, "Stdlib__Char");
    return;
})(globalThis);
//# 2285 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_uchar_ml = "uchar.ml", caml_format_int = runtime.caml_format_int, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), err_no_pred = "U+0000 has no predecessor", err_no_succ = "U+10FFFF has no successor", Assert_failure = global_data.Assert_failure, Stdlib = global_data.Stdlib, cst_is_not_an_Unicode_scalar_v = " is not an Unicode scalar value", cst_is_not_a_latin1_character = " is not a latin1 character", cst_U = "U+", lo_bound = 55295, hi_bound = 57344;
    function succ(u) {
        return u === 55295 ? hi_bound : u === 1114111 ? caml_call1(Stdlib[1], err_no_succ) : u + 1 | 0;
    }
    function pred(u) {
        return u === 57344 ? lo_bound : u === 0 ? caml_call1(Stdlib[1], err_no_pred) : u - 1 | 0;
    }
    function is_valid(i) {
        var _n_ = 0 <= i ? 1 : 0, _o_ = _n_ ? i <= 55295 ? 1 : 0 : _n_;
        if (_o_) var _p_ = _o_;
        else var _q_ = 57344 <= i ? 1 : 0, _p_ = _q_ ? i <= 1114111 ? 1 : 0 : _q_;
        return _p_;
    }
    function of_int(i) {
        if (is_valid(i)) return i;
        var _m_ = caml_call2(Stdlib[28], caml_format_int("%X", i), cst_is_not_an_Unicode_scalar_v);
        return caml_call1(Stdlib[1], _m_);
    }
    function is_char(u) {
        return u < 256 ? 1 : 0;
    }
    function of_char(c) {
        return c;
    }
    function to_char(u) {
        if (255 >= u) return u;
        var _k_ = caml_call2(Stdlib[28], caml_format_int("%04X", u), cst_is_not_a_latin1_character), _l_ = caml_call2(Stdlib[28], cst_U, _k_);
        return caml_call1(Stdlib[1], _l_);
    }
    function unsafe_to_char(_j_) {
        return _j_;
    }
    function equal(_i_, _h_) {
        return _i_ === _h_ ? 1 : 0;
    }
    var compare = runtime.caml_int_compare, _a_ = [
        0,
        cst_uchar_ml,
        85,
        7
    ], _b_ = [
        0,
        cst_uchar_ml,
        80,
        18
    ], _c_ = [
        0,
        cst_uchar_ml,
        91,
        7
    ], _d_ = [
        0,
        cst_uchar_ml,
        88,
        18
    ];
    function hash(_g_) {
        return _g_;
    }
    function utf_decode_is_valid(d) {
        return 1 === (d >>> 27 | 0) ? 1 : 0;
    }
    function utf_decode_length(d) {
        return (d >>> 24 | 0) & 7;
    }
    function utf_decode_uchar(d) {
        return d & 16777215;
    }
    function utf_decode(n, u) {
        return (8 | n) << 24 | u;
    }
    function utf_decode_invalid(n) {
        return n << 24 | 65533;
    }
    function utf_8_byte_length(u) {
        if (0 > u) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        if (127 >= u) return 1;
        if (2047 >= u) return 2;
        if (65535 >= u) return 3;
        if (1114111 < u) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
        return 4;
    }
    function utf_16_byte_length(u) {
        if (0 > u) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _d_
        ], 1);
        if (65535 >= u) return 2;
        if (1114111 < u) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _c_
        ], 1);
        return 4;
    }
    var Stdlib_Uchar = [
        0,
        0,
        1114111,
        65279,
        65533,
        succ,
        pred,
        is_valid,
        of_int,
        function(_f_) {
            return _f_;
        },
        function(_e_) {
            return _e_;
        },
        is_char,
        of_char,
        to_char,
        unsafe_to_char,
        equal,
        compare,
        hash,
        utf_decode_is_valid,
        utf_decode_uchar,
        utf_decode_length,
        utf_decode,
        utf_decode_invalid,
        utf_8_byte_length,
        utf_16_byte_length
    ];
    runtime.caml_register_global(13, Stdlib_Uchar, "Stdlib__Uchar");
    return;
})(globalThis);
//# 2417 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_List_map2$1 = "List.map2", cst_List_nth$1 = "List.nth", caml_compare = runtime.caml_compare, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, cst_hd = "hd", cst_tl = "tl", cst_nth = "nth", cst_List_nth = cst_List_nth$1, cst_List_nth$0 = cst_List_nth$1;
    function length(l$0) {
        var len = 0, param = l$0;
        for(;;){
            if (!param) return len;
            var l = param[2], len$0 = len + 1 | 0;
            len = len$0;
            param = l;
        }
    }
    function cons(a, l) {
        return [
            0,
            a,
            l
        ];
    }
    function hd(param) {
        if (!param) return caml_call1(Stdlib[2], cst_hd);
        var a = param[1];
        return a;
    }
    function tl(param) {
        if (!param) return caml_call1(Stdlib[2], cst_tl);
        var l = param[2];
        return l;
    }
    function nth(l, n) {
        if (0 > n) return caml_call1(Stdlib[1], cst_List_nth);
        var l$0 = l, n$0 = n;
        for(;;){
            if (!l$0) return caml_call1(Stdlib[2], cst_nth);
            var l$1 = l$0[2], a = l$0[1];
            if (0 === n$0) return a;
            var n$1 = n$0 - 1 | 0;
            l$0 = l$1;
            n$0 = n$1;
        }
    }
    function nth_opt(l, n) {
        if (0 > n) return caml_call1(Stdlib[1], cst_List_nth$0);
        var l$0 = l, n$0 = n;
        for(;;){
            if (!l$0) return 0;
            var l$1 = l$0[2], a = l$0[1];
            if (0 === n$0) return [
                0,
                a
            ];
            var n$1 = n$0 - 1 | 0;
            l$0 = l$1;
            n$0 = n$1;
        }
    }
    var append = Stdlib[37], cst_List_init = "List.init", cst_List_map2 = cst_List_map2$1, cst_List_map2$0 = cst_List_map2$1, cst_List_rev_map2 = "List.rev_map2", cst_List_iter2 = "List.iter2", cst_List_fold_left2 = "List.fold_left2", cst_List_fold_right2 = "List.fold_right2", cst_List_for_all2 = "List.for_all2", cst_List_exists2 = "List.exists2", _a_ = [
        0,
        0,
        0
    ], cst_List_combine = "List.combine";
    function rev_append(l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (!l1$0) return l2$0;
            var l1$1 = l1$0[2], a = l1$0[1], l2$1 = [
                0,
                a,
                l2$0
            ];
            l1$0 = l1$1;
            l2$0 = l2$1;
        }
    }
    function rev(l) {
        return rev_append(l, 0);
    }
    function init(len, f) {
        if (0 > len) return caml_call1(Stdlib[1], cst_List_init);
        var last = len - 1 | 0, i$1 = 0;
        if (last < 0) return 0;
        if (0 === last) return [
            0,
            caml_call1(f, i$1),
            0
        ];
        var r1 = caml_call1(f, i$1), r2 = caml_call1(f, 1), block = [
            0,
            r2,
            24029
        ], dst = block, offset = 1, i = 2;
        for(;;){
            if (last < i) dst[1 + offset] = 0;
            else {
                if (i !== last) {
                    var r1$0 = caml_call1(f, i), r2$0 = caml_call1(f, i + 1 | 0), dst$0 = [
                        0,
                        r2$0,
                        24029
                    ];
                    dst[1 + offset] = [
                        0,
                        r1$0,
                        dst$0
                    ];
                    var i$0 = i + 2 | 0;
                    dst = dst$0;
                    offset = 1;
                    i = i$0;
                    continue;
                }
                dst[1 + offset] = [
                    0,
                    caml_call1(f, i),
                    0
                ];
            }
            return [
                0,
                r1,
                block
            ];
        }
    }
    function flatten(param) {
        if (!param) return 0;
        var r = param[2], l = param[1], _I_ = flatten(r);
        return caml_call2(Stdlib[37], l, _I_);
    }
    function map(f, param) {
        if (!param) return 0;
        var match = param[2], a1 = param[1];
        if (!match) {
            var r1$0 = caml_call1(f, a1);
            return [
                0,
                r1$0,
                0
            ];
        }
        var l = match[2], a2 = match[1], r1 = caml_call1(f, a1), r2 = caml_call1(f, a2), block = [
            0,
            r2,
            24029
        ], dst = block, offset = 1, param$0 = l;
        for(;;){
            if (param$0) {
                var match$0 = param$0[2], a1$0 = param$0[1];
                if (match$0) {
                    var l$0 = match$0[2], a2$0 = match$0[1], r1$1 = caml_call1(f, a1$0), r2$0 = caml_call1(f, a2$0), dst$0 = [
                        0,
                        r2$0,
                        24029
                    ];
                    dst[1 + offset] = [
                        0,
                        r1$1,
                        dst$0
                    ];
                    dst = dst$0;
                    offset = 1;
                    param$0 = l$0;
                    continue;
                }
                var r1$2 = caml_call1(f, a1$0);
                dst[1 + offset] = [
                    0,
                    r1$2,
                    0
                ];
            } else dst[1 + offset] = 0;
            return [
                0,
                r1,
                block
            ];
        }
    }
    function mapi(f, l$1) {
        var i$1 = 0;
        if (!l$1) return 0;
        var match = l$1[2], a1 = l$1[1];
        if (!match) {
            var r1$0 = caml_call2(f, i$1, a1);
            return [
                0,
                r1$0,
                0
            ];
        }
        var l = match[2], a2 = match[1], r1 = caml_call2(f, i$1, a1), r2 = caml_call2(f, 1, a2), block = [
            0,
            r2,
            24029
        ], dst = block, offset = 1, i = 2, param = l;
        for(;;){
            if (param) {
                var match$0 = param[2], a1$0 = param[1];
                if (match$0) {
                    var l$0 = match$0[2], a2$0 = match$0[1], r1$1 = caml_call2(f, i, a1$0), r2$0 = caml_call2(f, i + 1 | 0, a2$0), dst$0 = [
                        0,
                        r2$0,
                        24029
                    ];
                    dst[1 + offset] = [
                        0,
                        r1$1,
                        dst$0
                    ];
                    var i$0 = i + 2 | 0;
                    dst = dst$0;
                    offset = 1;
                    i = i$0;
                    param = l$0;
                    continue;
                }
                var r1$2 = caml_call2(f, i, a1$0);
                dst[1 + offset] = [
                    0,
                    r1$2,
                    0
                ];
            } else dst[1 + offset] = 0;
            return [
                0,
                r1,
                block
            ];
        }
    }
    function rev_map(f, l) {
        var accu = 0, param = l;
        for(;;){
            if (!param) return accu;
            var l$0 = param[2], a = param[1], accu$0 = [
                0,
                caml_call1(f, a),
                accu
            ];
            accu = accu$0;
            param = l$0;
        }
    }
    function iter(f, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1];
            caml_call1(f, a);
            param$0 = l;
        }
    }
    function iteri(f, l$0) {
        var i = 0, param = l$0;
        for(;;){
            if (!param) return 0;
            var l = param[2], a = param[1];
            caml_call2(f, i, a);
            var i$0 = i + 1 | 0;
            i = i$0;
            param = l;
        }
    }
    function fold_left(f, accu, l) {
        var accu$0 = accu, l$0 = l;
        for(;;){
            if (!l$0) return accu$0;
            var l$1 = l$0[2], a = l$0[1], accu$1 = caml_call2(f, accu$0, a);
            accu$0 = accu$1;
            l$0 = l$1;
        }
    }
    function fold_right(f, l, accu) {
        if (!l) return accu;
        var l$0 = l[2], a = l[1];
        return caml_call2(f, a, fold_right(f, l$0, accu));
    }
    function map2(f, l1, l2) {
        if (l1) {
            var _G_ = l1[2], a1 = l1[1];
            if (_G_) {
                if (l2) {
                    var match = l2[2];
                    if (match) {
                        var l2$0 = match[2], b2 = match[1], b1 = l2[1], l1$0 = _G_[2], a2 = _G_[1], r1 = caml_call2(f, a1, b1), r2 = caml_call2(f, a2, b2), block = [
                            0,
                            r2,
                            24029
                        ], dst = block, offset = 1, l1$1 = l1$0, l2$1 = l2$0;
                        for(;;){
                            a: {
                                if (l1$1) {
                                    var _H_ = l1$1[2], a1$0 = l1$1[1];
                                    if (_H_) {
                                        if (l2$1) {
                                            var match$0 = l2$1[2];
                                            if (match$0) {
                                                var l2$2 = match$0[2], b2$0 = match$0[1], b1$1 = l2$1[1], l1$2 = _H_[2], a2$0 = _H_[1], r1$1 = caml_call2(f, a1$0, b1$1), r2$0 = caml_call2(f, a2$0, b2$0), dst$0 = [
                                                    0,
                                                    r2$0,
                                                    24029
                                                ];
                                                dst[1 + offset] = [
                                                    0,
                                                    r1$1,
                                                    dst$0
                                                ];
                                                dst = dst$0;
                                                offset = 1;
                                                l1$1 = l1$2;
                                                l2$1 = l2$2;
                                                continue;
                                            }
                                        }
                                    } else if (l2$1 && !l2$1[2]) {
                                        var b1$2 = l2$1[1], r1$2 = caml_call2(f, a1$0, b1$2);
                                        dst[1 + offset] = [
                                            0,
                                            r1$2,
                                            0
                                        ];
                                        break a;
                                    }
                                } else if (!l2$1) {
                                    dst[1 + offset] = 0;
                                    break a;
                                }
                                dst[1 + offset] = caml_call1(Stdlib[1], cst_List_map2$0);
                            }
                            return [
                                0,
                                r1,
                                block
                            ];
                        }
                    }
                }
            } else if (l2 && !l2[2]) {
                var b1$0 = l2[1], r1$0 = caml_call2(f, a1, b1$0);
                return [
                    0,
                    r1$0,
                    0
                ];
            }
        } else if (!l2) return 0;
        return caml_call1(Stdlib[1], cst_List_map2);
    }
    function rev_map2(f, l1, l2) {
        var accu = 0, l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], accu$0 = [
                        0,
                        caml_call2(f, a1, a2),
                        accu
                    ];
                    accu = accu$0;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return accu;
            return caml_call1(Stdlib[1], cst_List_rev_map2);
        }
    }
    function iter2(f, l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1];
                    caml_call2(f, a1, a2);
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 0;
            return caml_call1(Stdlib[1], cst_List_iter2);
        }
    }
    function fold_left2(f, accu, l1, l2) {
        var accu$0 = accu, l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], accu$1 = caml_call3(f, accu$0, a1, a2);
                    accu$0 = accu$1;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return accu$0;
            return caml_call1(Stdlib[1], cst_List_fold_left2);
        }
    }
    function fold_right2(f, l1, l2, accu) {
        if (l1) {
            if (l2) {
                var l2$0 = l2[2], a2 = l2[1], l1$0 = l1[2], a1 = l1[1];
                return caml_call3(f, a1, a2, fold_right2(f, l1$0, l2$0, accu));
            }
        } else if (!l2) return accu;
        return caml_call1(Stdlib[1], cst_List_fold_right2);
    }
    function for_all(p, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 1;
            var l = param$0[2], a = param$0[1], _F_ = caml_call1(p, a);
            if (!_F_) return _F_;
            param$0 = l;
        }
    }
    function exists(p, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1], _E_ = caml_call1(p, a);
            if (_E_) return _E_;
            param$0 = l;
        }
    }
    function for_all2(p, l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], _D_ = caml_call2(p, a1, a2);
                    if (!_D_) return _D_;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 1;
            return caml_call1(Stdlib[1], cst_List_for_all2);
        }
    }
    function exists2(p, l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], _C_ = caml_call2(p, a1, a2);
                    if (_C_) return _C_;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 0;
            return caml_call1(Stdlib[1], cst_List_exists2);
        }
    }
    function mem(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1], _B_ = 0 === caml_compare(a, x) ? 1 : 0;
            if (_B_) return _B_;
            param$0 = l;
        }
    }
    function memq(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1], _A_ = a === x ? 1 : 0;
            if (_A_) return _A_;
            param$0 = l;
        }
    }
    function assoc(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var l = param$0[2], match = param$0[1], b = match[2], a = match[1];
            if (0 === caml_compare(a, x)) return b;
            param$0 = l;
        }
    }
    function assoc_opt(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], match = param$0[1], b = match[2], a = match[1];
            if (0 === caml_compare(a, x)) return [
                0,
                b
            ];
            param$0 = l;
        }
    }
    function assq(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var l = param$0[2], match = param$0[1], b = match[2], a = match[1];
            if (a === x) return b;
            param$0 = l;
        }
    }
    function assq_opt(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], match = param$0[1], b = match[2], a = match[1];
            if (a === x) return [
                0,
                b
            ];
            param$0 = l;
        }
    }
    function mem_assoc(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1][1], _z_ = 0 === caml_compare(a, x) ? 1 : 0;
            if (_z_) return _z_;
            param$0 = l;
        }
    }
    function mem_assq(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1][1], _y_ = a === x ? 1 : 0;
            if (_y_) return _y_;
            param$0 = l;
        }
    }
    function remove_assoc(x, param) {
        if (!param) return 0;
        var l = param[2], pair = param[1], a = pair[1];
        return 0 === caml_compare(a, x) ? l : [
            0,
            pair,
            remove_assoc(x, l)
        ];
    }
    function remove_assq(x, param) {
        if (!param) return 0;
        var l = param[2], pair = param[1], a = pair[1];
        return a === x ? l : [
            0,
            pair,
            remove_assq(x, l)
        ];
    }
    function find(p, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var l = param$0[2], x = param$0[1];
            if (caml_call1(p, x)) return x;
            param$0 = l;
        }
    }
    function find_opt(p, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], x = param$0[1];
            if (caml_call1(p, x)) return [
                0,
                x
            ];
            param$0 = l;
        }
    }
    function find_index(p) {
        var i = 0;
        return function(param$0) {
            var i$0 = i, param = param$0;
            for(;;){
                if (!param) return 0;
                var l = param[2], a = param[1];
                if (caml_call1(p, a)) return [
                    0,
                    i$0
                ];
                var i$1 = i$0 + 1 | 0;
                i$0 = i$1;
                param = l;
            }
        };
    }
    function find_map(f, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], x = param$0[1], result = caml_call1(f, x);
            if (result) return result;
            param$0 = l;
        }
    }
    function find_mapi(f) {
        var i = 0;
        return function(param$0) {
            var i$0 = i, param = param$0;
            for(;;){
                if (!param) return 0;
                var l = param[2], x = param[1], result = caml_call2(f, i$0, x);
                if (result) return result;
                var i$1 = i$0 + 1 | 0;
                i$0 = i$1;
                param = l;
            }
        };
    }
    function find_all(p, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], x = param$0[1];
            if (caml_call1(p, x)) {
                var block = [
                    0,
                    x,
                    24029
                ], dst = block, offset = 1, param$1 = l;
                for(;;){
                    if (!param$1) {
                        dst[1 + offset] = 0;
                        return block;
                    }
                    var l$0 = param$1[2], x$0 = param$1[1];
                    if (caml_call1(p, x$0)) {
                        var dst$0 = [
                            0,
                            x$0,
                            24029
                        ];
                        dst[1 + offset] = dst$0;
                        dst = dst$0;
                        offset = 1;
                        param$1 = l$0;
                    } else param$1 = l$0;
                }
            } else param$0 = l;
        }
    }
    function filteri(p, l$1) {
        var i = 0, param = l$1;
        for(;;){
            if (!param) return 0;
            var l = param[2], x = param[1], i$0 = i + 1 | 0;
            if (caml_call2(p, i, x)) break;
            i = i$0;
            param = l;
        }
        var block = [
            0,
            x,
            24029
        ], dst = block, offset = 1, i$1 = i$0, param$0 = l;
        for(;;){
            if (!param$0) {
                dst[1 + offset] = 0;
                return block;
            }
            var l$0 = param$0[2], x$0 = param$0[1], i$2 = i$1 + 1 | 0;
            if (caml_call2(p, i$1, x$0)) {
                var dst$0 = [
                    0,
                    x$0,
                    24029
                ];
                dst[1 + offset] = dst$0;
                dst = dst$0;
                offset = 1;
                i$1 = i$2;
                param$0 = l$0;
            } else {
                i$1 = i$2;
                param$0 = l$0;
            }
        }
    }
    function filter_map(f, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], x = param$0[1], match = caml_call1(f, x);
            if (match) {
                var v = match[1], block = [
                    0,
                    v,
                    24029
                ], dst = block, offset = 1, param$1 = l;
                for(;;){
                    if (!param$1) {
                        dst[1 + offset] = 0;
                        return block;
                    }
                    var l$0 = param$1[2], x$0 = param$1[1], match$0 = caml_call1(f, x$0);
                    if (match$0) {
                        var v$0 = match$0[1], dst$0 = [
                            0,
                            v$0,
                            24029
                        ];
                        dst[1 + offset] = dst$0;
                        dst = dst$0;
                        offset = 1;
                        param$1 = l$0;
                    } else param$1 = l$0;
                }
            } else param$0 = l;
        }
    }
    function concat_map(f, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var xs = param$0[2], x = param$0[1], ys = caml_call1(f, x);
            if (ys) {
                var ys$1 = ys[2], y = ys[1], block = [
                    0,
                    y,
                    24029
                ], dst = block, offset = 1, ys$2 = ys$1, xs$1 = xs;
                for(;;)if (ys$2) {
                    var ys$3 = ys$2[2], y$0 = ys$2[1], dst$0 = [
                        0,
                        y$0,
                        24029
                    ];
                    dst[1 + offset] = dst$0;
                    dst = dst$0;
                    offset = 1;
                    ys$2 = ys$3;
                } else {
                    if (!xs$1) {
                        dst[1 + offset] = 0;
                        return block;
                    }
                    var xs$0 = xs$1[2], x$0 = xs$1[1], ys$0 = caml_call1(f, x$0);
                    ys$2 = ys$0;
                    xs$1 = xs$0;
                }
            } else param$0 = xs;
        }
    }
    function fold_left_map(f, accu, l) {
        var accu$0 = accu, l_accu = 0, param = l;
        for(;;){
            if (!param) return [
                0,
                accu$0,
                rev(l_accu)
            ];
            var l$0 = param[2], x = param[1], match = caml_call2(f, accu$0, x), x$0 = match[2], accu$1 = match[1], l_accu$0 = [
                0,
                x$0,
                l_accu
            ];
            accu$0 = accu$1;
            l_accu = l_accu$0;
            param = l$0;
        }
    }
    function partition(p, l) {
        var yes = 0, no = 0, param = l;
        for(;;){
            if (!param) {
                var _x_ = rev(no);
                return [
                    0,
                    rev(yes),
                    _x_
                ];
            }
            var l$0 = param[2], x = param[1];
            if (caml_call1(p, x)) {
                var yes$0 = [
                    0,
                    x,
                    yes
                ];
                yes = yes$0;
                param = l$0;
            } else {
                var no$0 = [
                    0,
                    x,
                    no
                ];
                no = no$0;
                param = l$0;
            }
        }
    }
    function partition_map(p, l) {
        var left = 0, right = 0, param = l;
        for(;;){
            if (!param) {
                var _w_ = rev(right);
                return [
                    0,
                    rev(left),
                    _w_
                ];
            }
            var l$0 = param[2], x = param[1], match = caml_call1(p, x);
            if (0 === match[0]) {
                var v = match[1], left$0 = [
                    0,
                    v,
                    left
                ];
                left = left$0;
                param = l$0;
            } else {
                var v$0 = match[1], right$0 = [
                    0,
                    v$0,
                    right
                ];
                right = right$0;
                param = l$0;
            }
        }
    }
    function split(param) {
        if (!param) return _a_;
        var l = param[2], match = param[1], y = match[2], x = match[1], match$0 = split(l), ry = match$0[2], rx = match$0[1];
        return [
            0,
            [
                0,
                x,
                rx
            ],
            [
                0,
                y,
                ry
            ]
        ];
    }
    function combine(l1, l2) {
        if (l1) {
            if (l2) {
                var l2$0 = l2[2], a2 = l2[1], l1$0 = l1[2], a1 = l1[1];
                return [
                    0,
                    [
                        0,
                        a1,
                        a2
                    ],
                    combine(l1$0, l2$0)
                ];
            }
        } else if (!l2) return 0;
        return caml_call1(Stdlib[1], cst_List_combine);
    }
    function merge(cmp, l1, l2) {
        if (!l1) return l2;
        if (!l2) return l1;
        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
        return 0 < caml_call2(cmp, h1, h2) ? [
            0,
            h2,
            merge(cmp, l1, t2)
        ] : [
            0,
            h1,
            merge(cmp, t1, l2)
        ];
    }
    function stable_sort(cmp, l) {
        function sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], s = 0 < caml_call2(cmp, x1, x2) ? [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ] : [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _v_ = l[2];
                if (_v_) {
                    var match$2 = _v_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _v_[1], x1$0 = l[1], s$0 = 0 < caml_call2(cmp, x1$0, x2$0) ? 0 < caml_call2(cmp, x1$0, x3) ? 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x2$0,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x2$0, x3) ? 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x3,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x1$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x1$0,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ];
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = n >> 1, n2 = n - n1 | 0, match$0 = rev_sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = rev_sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
                        if (0 < caml_call2(cmp, h1, h2)) {
                            var accu$0 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            accu = accu$0;
                            continue;
                        }
                        var accu$1 = [
                            0,
                            h2,
                            accu
                        ];
                        l2 = t2;
                        accu = accu$1;
                        continue;
                    }
                    var _u_ = rev_append(l1, accu);
                } else var _u_ = rev_append(l2, accu);
                return [
                    0,
                    _u_,
                    tl$0
                ];
            }
        }
        function rev_sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], s = 0 < caml_call2(cmp, x1, x2) ? [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ] : [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _t_ = l[2];
                if (_t_) {
                    var match$2 = _t_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _t_[1], x1$0 = l[1], s$0 = 0 < caml_call2(cmp, x1$0, x2$0) ? 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x1$0,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x1$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x3,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x2$0,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ];
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = n >> 1, n2 = n - n1 | 0, match$0 = sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
                        if (0 < caml_call2(cmp, h1, h2)) {
                            var accu$0 = [
                                0,
                                h2,
                                accu
                            ];
                            l2 = t2;
                            accu = accu$0;
                            continue;
                        }
                        var accu$1 = [
                            0,
                            h1,
                            accu
                        ];
                        l1 = t1;
                        accu = accu$1;
                        continue;
                    }
                    var _s_ = rev_append(l1, accu);
                } else var _s_ = rev_append(l2, accu);
                return [
                    0,
                    _s_,
                    tl$0
                ];
            }
        }
        var len = length(l);
        return 2 <= len ? sort(len, l)[1] : l;
    }
    function sort_uniq(cmp, l) {
        function sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], c$0 = caml_call2(cmp, x1, x2), s = 0 === c$0 ? [
                            0,
                            x1,
                            0
                        ] : 0 <= c$0 ? [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ] : [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _m_ = l[2];
                if (_m_) {
                    var match$2 = _m_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _m_[1], x1$0 = l[1], c$1 = caml_call2(cmp, x1$0, x2$0);
                        if (0 === c$1) var c$2 = caml_call2(cmp, x2$0, x3), _n_ = 0 === c$2 ? [
                            0,
                            x2$0,
                            0
                        ] : 0 <= c$2 ? [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                0
                            ]
                        ] : [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                0
                            ]
                        ], s$0 = _n_;
                        else if (0 <= c$1) {
                            var c$3 = caml_call2(cmp, x1$0, x3);
                            if (0 === c$3) var _o_ = [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ];
                            else if (0 <= c$3) var c$4 = caml_call2(cmp, x2$0, x3), _p_ = 0 === c$4 ? [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ] : 0 <= c$4 ? [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x1$0,
                                        0
                                    ]
                                ]
                            ] : [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x1$0,
                                        0
                                    ]
                                ]
                            ], _o_ = _p_;
                            else var _o_ = [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            var s$0 = _o_;
                        } else {
                            var c$5 = caml_call2(cmp, x2$0, x3);
                            if (0 === c$5) var _q_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ];
                            else if (0 <= c$5) var c$6 = caml_call2(cmp, x1$0, x3), _r_ = 0 === c$6 ? [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ] : 0 <= c$6 ? [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ]
                            ] : [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ]
                            ], _q_ = _r_;
                            else var _q_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            var s$0 = _q_;
                        }
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = n >> 1, n2 = n - n1 | 0, match$0 = rev_sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = rev_sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1], c = caml_call2(cmp, h1, h2);
                        if (0 === c) {
                            var accu$0 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            l2 = t2;
                            accu = accu$0;
                            continue;
                        }
                        if (0 < c) {
                            var accu$1 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            accu = accu$1;
                            continue;
                        }
                        var accu$2 = [
                            0,
                            h2,
                            accu
                        ];
                        l2 = t2;
                        accu = accu$2;
                        continue;
                    }
                    var _l_ = rev_append(l1, accu);
                } else var _l_ = rev_append(l2, accu);
                return [
                    0,
                    _l_,
                    tl$0
                ];
            }
        }
        function rev_sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], c$0 = caml_call2(cmp, x1, x2), s = 0 === c$0 ? [
                            0,
                            x1,
                            0
                        ] : 0 < c$0 ? [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ] : [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _f_ = l[2];
                if (_f_) {
                    var match$2 = _f_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _f_[1], x1$0 = l[1], c$1 = caml_call2(cmp, x1$0, x2$0);
                        if (0 === c$1) var c$2 = caml_call2(cmp, x2$0, x3), _g_ = 0 === c$2 ? [
                            0,
                            x2$0,
                            0
                        ] : 0 < c$2 ? [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                0
                            ]
                        ] : [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                0
                            ]
                        ], s$0 = _g_;
                        else if (0 < c$1) {
                            var c$3 = caml_call2(cmp, x2$0, x3);
                            if (0 === c$3) var _h_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ];
                            else if (0 < c$3) var _h_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            else var c$4 = caml_call2(cmp, x1$0, x3), _i_ = 0 === c$4 ? [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ] : 0 < c$4 ? [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ]
                            ] : [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ]
                            ], _h_ = _i_;
                            var s$0 = _h_;
                        } else {
                            var c$5 = caml_call2(cmp, x1$0, x3);
                            if (0 === c$5) var _j_ = [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ];
                            else if (0 < c$5) var _j_ = [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            else var c$6 = caml_call2(cmp, x2$0, x3), _k_ = 0 === c$6 ? [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ] : 0 < c$6 ? [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x1$0,
                                        0
                                    ]
                                ]
                            ] : [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x1$0,
                                        0
                                    ]
                                ]
                            ], _j_ = _k_;
                            var s$0 = _j_;
                        }
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = n >> 1, n2 = n - n1 | 0, match$0 = sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1], c = caml_call2(cmp, h1, h2);
                        if (0 === c) {
                            var accu$0 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            l2 = t2;
                            accu = accu$0;
                            continue;
                        }
                        if (0 <= c) {
                            var accu$1 = [
                                0,
                                h2,
                                accu
                            ];
                            l2 = t2;
                            accu = accu$1;
                            continue;
                        }
                        var accu$2 = [
                            0,
                            h1,
                            accu
                        ];
                        l1 = t1;
                        accu = accu$2;
                        continue;
                    }
                    var _e_ = rev_append(l1, accu);
                } else var _e_ = rev_append(l2, accu);
                return [
                    0,
                    _e_,
                    tl$0
                ];
            }
        }
        var len = length(l);
        return 2 <= len ? sort(len, l)[1] : l;
    }
    function compare_lengths(l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (!l1$0) return l2$0 ? -1 : 0;
            if (!l2$0) return 1;
            var l2$1 = l2$0[2], l1$1 = l1$0[2];
            l1$0 = l1$1;
            l2$0 = l2$1;
        }
    }
    function compare_length_with(l, n) {
        var l$0 = l, n$0 = n;
        for(;;){
            if (!l$0) return 0 === n$0 ? 0 : 0 < n$0 ? -1 : 1;
            var l$1 = l$0[2];
            if (0 >= n$0) return 1;
            var n$1 = n$0 - 1 | 0;
            l$0 = l$1;
            n$0 = n$1;
        }
    }
    function is_empty(param) {
        return param ? 0 : 1;
    }
    function equal(eq, l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], _d_ = caml_call2(eq, a1, a2);
                    if (!_d_) return _d_;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 1;
            return 0;
        }
    }
    function compare(cmp, l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (!l1$0) return l2$0 ? -1 : 0;
            var l1$1 = l1$0[2], a1 = l1$0[1];
            if (!l2$0) return 1;
            var l2$1 = l2$0[2], a2 = l2$0[1], c = caml_call2(cmp, a1, a2);
            if (0 !== c) return c;
            l1$0 = l1$1;
            l2$0 = l2$1;
        }
    }
    function to_seq(l) {
        function aux(l, param) {
            if (!l) return 0;
            var tail = l[2], x = l[1];
            return [
                0,
                x,
                function(_c_) {
                    return aux(tail, _c_);
                }
            ];
        }
        return function(_b_) {
            return aux(l, _b_);
        };
    }
    function of_seq(seq) {
        var match = caml_call1(seq, 0);
        if (!match) return 0;
        var seq$0 = match[2], x1 = match[1], match$0 = caml_call1(seq$0, 0);
        if (!match$0) return [
            0,
            x1,
            0
        ];
        var seq$1 = match$0[2], x2 = match$0[1], block = [
            0,
            x2,
            24029
        ], dst = block, offset = 1, seq$2 = seq$1;
        for(;;){
            var match$1 = caml_call1(seq$2, 0);
            if (match$1) {
                var seq$3 = match$1[2], x1$0 = match$1[1], match$2 = caml_call1(seq$3, 0);
                if (match$2) {
                    var seq$4 = match$2[2], x2$0 = match$2[1], dst$0 = [
                        0,
                        x2$0,
                        24029
                    ];
                    dst[1 + offset] = [
                        0,
                        x1$0,
                        dst$0
                    ];
                    dst = dst$0;
                    offset = 1;
                    seq$2 = seq$4;
                    continue;
                }
                dst[1 + offset] = [
                    0,
                    x1$0,
                    0
                ];
            } else dst[1 + offset] = 0;
            return [
                0,
                x1,
                block
            ];
        }
    }
    var Stdlib_List = [
        0,
        length,
        compare_lengths,
        compare_length_with,
        is_empty,
        cons,
        hd,
        tl,
        nth,
        nth_opt,
        rev,
        init,
        append,
        rev_append,
        flatten,
        flatten,
        equal,
        compare,
        iter,
        iteri,
        map,
        mapi,
        rev_map,
        filter_map,
        concat_map,
        fold_left_map,
        fold_left,
        fold_right,
        iter2,
        map2,
        rev_map2,
        fold_left2,
        fold_right2,
        for_all,
        exists,
        for_all2,
        exists2,
        mem,
        memq,
        find,
        find_opt,
        find_index,
        find_map,
        find_mapi,
        find_all,
        find_all,
        filteri,
        partition,
        partition_map,
        assoc,
        assoc_opt,
        assq,
        assq_opt,
        mem_assoc,
        mem_assq,
        remove_assoc,
        remove_assq,
        split,
        combine,
        stable_sort,
        stable_sort,
        stable_sort,
        sort_uniq,
        merge,
        to_seq,
        of_seq
    ];
    runtime.caml_register_global(17, Stdlib_List, "Stdlib__List");
    return;
})(globalThis);
//# 3797 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_hash = runtime.caml_hash;
    function abs(x) {
        return 0 <= x ? x : -x | 0;
    }
    function lognot(x) {
        return x ^ -1;
    }
    function equal(_b_, _a_) {
        return _b_ === _a_ ? 1 : 0;
    }
    var compare = runtime.caml_int_compare;
    function min(x, y) {
        return x <= y ? x : y;
    }
    function max(x, y) {
        return y <= x ? x : y;
    }
    function to_string(x) {
        return "" + x;
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    var Stdlib_Int = [
        0,
        0,
        1,
        -1,
        abs,
        2147483647,
        -2147483648,
        lognot,
        equal,
        compare,
        min,
        max,
        to_string,
        seeded_hash,
        hash
    ];
    runtime.caml_register_global(1, Stdlib_Int, "Stdlib__Int");
    return;
})(globalThis);
//# 3833 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_bytes_ml = "bytes.ml", cst_index_out_of_bounds$3 = "index out of bounds", caml_blit_bytes = runtime.caml_blit_bytes, caml_bswap16 = runtime.caml_bswap16, caml_bytes_get = runtime.caml_bytes_get, caml_bytes_get16 = runtime.caml_bytes_get16, caml_bytes_get32 = runtime.caml_bytes_get32, caml_bytes_get64 = runtime.caml_bytes_get64, caml_bytes_of_string = runtime.caml_bytes_of_string, caml_bytes_set = runtime.caml_bytes_set, caml_bytes_set16 = runtime.caml_bytes_set16, caml_bytes_set32 = runtime.caml_bytes_set32, caml_bytes_set64 = runtime.caml_bytes_set64, caml_bytes_unsafe_get = runtime.caml_bytes_unsafe_get, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_fill_bytes = runtime.caml_fill_bytes, caml_int32_bswap = runtime.caml_int32_bswap, caml_int64_bswap = runtime.caml_int64_bswap, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_string_of_bytes = runtime.caml_string_of_bytes, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Uchar = global_data.Stdlib__Uchar, Assert_failure = global_data.Assert_failure, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_Char = global_data.Stdlib__Char;
    function make(n, c) {
        var s = caml_create_bytes(n);
        caml_fill_bytes(s, 0, n, c);
        return s;
    }
    function init(n, f) {
        var s = caml_create_bytes(n), _ap_ = n - 1 | 0, _ao_ = 0;
        if (_ap_ >= 0) {
            var i = _ao_;
            for(;;){
                caml_bytes_unsafe_set(s, i, caml_call1(f, i));
                var _aq_ = i + 1 | 0;
                if (_ap_ === i) break;
                i = _aq_;
            }
        }
        return s;
    }
    var empty = caml_create_bytes(0), cst_String_sub_Bytes_sub = "String.sub / Bytes.sub", cst_Bytes_extend = "Bytes.extend", cst_String_fill_Bytes_fill = "String.fill / Bytes.fill", cst_Bytes_blit = "Bytes.blit", cst_String_blit_Bytes_blit_str = "String.blit / Bytes.blit_string", cst_Bytes_concat = "Bytes.concat", cst_String_index_from_Bytes_in = "String.index_from / Bytes.index_from", cst_String_index_from_opt_Byte = "String.index_from_opt / Bytes.index_from_opt", cst_String_rindex_from_Bytes_r = "String.rindex_from / Bytes.rindex_from", cst_String_rindex_from_opt_Byt = "String.rindex_from_opt / Bytes.rindex_from_opt", cst_String_contains_from_Bytes = "String.contains_from / Bytes.contains_from", cst_String_rcontains_from_Byte = "String.rcontains_from / Bytes.rcontains_from";
    function copy(s) {
        var len = caml_ml_bytes_length(s), r = caml_create_bytes(len);
        caml_blit_bytes(s, 0, r, 0, len);
        return r;
    }
    function to_string(b) {
        return caml_string_of_bytes(copy(b));
    }
    function of_string(s) {
        return copy(caml_bytes_of_string(s));
    }
    function sub(s, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs) {
            var r = caml_create_bytes(len);
            caml_blit_bytes(s, ofs, r, 0, len);
            return r;
        }
        return caml_call1(Stdlib[1], cst_String_sub_Bytes_sub);
    }
    function sub_string(b, ofs, len) {
        return caml_string_of_bytes(sub(b, ofs, len));
    }
    function symbol(a, b) {
        var c = a + b | 0, _an_ = b < 0 ? 1 : 0, match = c < 0 ? 1 : 0;
        a: {
            if (a < 0) {
                if (_an_ && !match) break a;
            } else if (!_an_ && match) break a;
            return c;
        }
        return caml_call1(Stdlib[1], cst_Bytes_extend);
    }
    function extend(s, left, right) {
        var len = symbol(symbol(caml_ml_bytes_length(s), left), right), r = caml_create_bytes(len);
        if (0 <= left) var dstoff = left, srcoff = 0;
        else var dstoff = 0, srcoff = -left | 0;
        var cpylen = caml_call2(Stdlib_Int[10], caml_ml_bytes_length(s) - srcoff | 0, len - dstoff | 0);
        if (0 < cpylen) caml_blit_bytes(s, srcoff, r, dstoff, cpylen);
        return r;
    }
    function fill(s, ofs, len, c) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs) return caml_fill_bytes(s, ofs, len, c);
        return caml_call1(Stdlib[1], cst_String_fill_Bytes_fill);
    }
    function blit(s1, ofs1, s2, ofs2, len) {
        if (0 <= len && 0 <= ofs1 && (caml_ml_bytes_length(s1) - len | 0) >= ofs1 && 0 <= ofs2 && (caml_ml_bytes_length(s2) - len | 0) >= ofs2) return caml_blit_bytes(s1, ofs1, s2, ofs2, len);
        return caml_call1(Stdlib[1], cst_Bytes_blit);
    }
    function blit_string(s1, ofs1, s2, ofs2, len) {
        if (0 <= len && 0 <= ofs1 && (runtime.caml_ml_string_length(s1) - len | 0) >= ofs1 && 0 <= ofs2 && (caml_ml_bytes_length(s2) - len | 0) >= ofs2) return runtime.caml_blit_string(s1, ofs1, s2, ofs2, len);
        return caml_call1(Stdlib[1], cst_String_blit_Bytes_blit_str);
    }
    function iter(f, a) {
        var _al_ = caml_ml_bytes_length(a) - 1 | 0, _ak_ = 0;
        if (_al_ >= 0) {
            var i = _ak_;
            for(;;){
                caml_call1(f, caml_bytes_unsafe_get(a, i));
                var _am_ = i + 1 | 0;
                if (_al_ === i) break;
                i = _am_;
            }
        }
        return 0;
    }
    function iteri(f, a) {
        var _ai_ = caml_ml_bytes_length(a) - 1 | 0, _ah_ = 0;
        if (_ai_ >= 0) {
            var i = _ah_;
            for(;;){
                caml_call2(f, i, caml_bytes_unsafe_get(a, i));
                var _aj_ = i + 1 | 0;
                if (_ai_ === i) break;
                i = _aj_;
            }
        }
        return 0;
    }
    function concat(sep, l) {
        if (!l) return empty;
        var seplen = caml_ml_bytes_length(sep);
        a: {
            b: {
                var acc = 0, param = l, pos$1 = 0;
                for(;;){
                    if (!param) break;
                    var hd = param[1];
                    if (!param[2]) break b;
                    var tl = param[2], x = (caml_ml_bytes_length(hd) + seplen | 0) + acc | 0, acc$0 = acc <= x ? x : caml_call1(Stdlib[1], cst_Bytes_concat);
                    acc = acc$0;
                    param = tl;
                }
                var _ag_ = acc;
                break a;
            }
            var _ag_ = caml_ml_bytes_length(hd) + acc | 0;
        }
        var dst = caml_create_bytes(_ag_), pos = pos$1, param$0 = l;
        for(;;){
            if (!param$0) return dst;
            var hd$0 = param$0[1];
            if (!param$0[2]) {
                caml_blit_bytes(hd$0, 0, dst, pos, caml_ml_bytes_length(hd$0));
                return dst;
            }
            var tl$0 = param$0[2];
            caml_blit_bytes(hd$0, 0, dst, pos, caml_ml_bytes_length(hd$0));
            caml_blit_bytes(sep, 0, dst, pos + caml_ml_bytes_length(hd$0) | 0, seplen);
            var pos$0 = (pos + caml_ml_bytes_length(hd$0) | 0) + seplen | 0;
            pos = pos$0;
            param$0 = tl$0;
        }
    }
    function cat(s1, s2) {
        var l1 = caml_ml_bytes_length(s1), l2 = caml_ml_bytes_length(s2), r = caml_create_bytes(l1 + l2 | 0);
        caml_blit_bytes(s1, 0, r, 0, l1);
        caml_blit_bytes(s2, 0, r, l1, l2);
        return r;
    }
    function is_space(param) {
        var _af_ = param - 9 | 0;
        a: {
            if (4 < _af_ >>> 0) {
                if (23 !== _af_) break a;
            } else if (2 === _af_) break a;
            return 1;
        }
        return 0;
    }
    function trim(s) {
        var len = caml_ml_bytes_length(s), i = [
            0,
            0
        ];
        for(;;){
            if (i[1] >= len) break;
            if (!is_space(caml_bytes_unsafe_get(s, i[1]))) break;
            i[1]++;
        }
        var j = [
            0,
            len - 1 | 0
        ];
        for(;;){
            if (i[1] <= j[1] && is_space(caml_bytes_unsafe_get(s, j[1]))) {
                j[1]--;
                continue;
            }
            return i[1] <= j[1] ? sub(s, i[1], (j[1] - i[1] | 0) + 1 | 0) : empty;
        }
    }
    function unsafe_escape(s) {
        var n = [
            0,
            0
        ], ___ = caml_ml_bytes_length(s) - 1 | 0, _Z_ = 0;
        if (___ >= 0) {
            var i$0 = _Z_;
            for(;;){
                var match = caml_bytes_unsafe_get(s, i$0);
                a: {
                    b: {
                        c: {
                            if (32 <= match) {
                                var _ac_ = match - 34 | 0;
                                if (58 < _ac_ >>> 0) {
                                    if (93 <= _ac_) break c;
                                } else if (56 < _ac_ - 1 >>> 0) break b;
                                var _ad_ = 1;
                                break a;
                            }
                            if (11 <= match) {
                                if (13 === match) break b;
                            } else if (8 <= match) break b;
                        }
                        var _ad_ = 4;
                        break a;
                    }
                    var _ad_ = 2;
                }
                n[1] = n[1] + _ad_ | 0;
                var _ae_ = i$0 + 1 | 0;
                if (___ === i$0) break;
                i$0 = _ae_;
            }
        }
        if (n[1] === caml_ml_bytes_length(s)) return s;
        var s$0 = caml_create_bytes(n[1]);
        n[1] = 0;
        var _aa_ = caml_ml_bytes_length(s) - 1 | 0, _$_ = 0;
        if (_aa_ >= 0) {
            var i = _$_;
            for(;;){
                var c = caml_bytes_unsafe_get(s, i);
                a: {
                    b: {
                        c: {
                            if (35 <= c) {
                                if (92 !== c) {
                                    if (127 <= c) break c;
                                    break b;
                                }
                            } else {
                                if (32 > c) {
                                    if (14 <= c) break c;
                                    switch(c){
                                        case 8:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 98);
                                            break a;
                                        case 9:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 116);
                                            break a;
                                        case 10:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 110);
                                            break a;
                                        case 13:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 114);
                                            break a;
                                        default:
                                            break c;
                                    }
                                }
                                if (34 > c) break b;
                            }
                            caml_bytes_unsafe_set(s$0, n[1], 92);
                            n[1]++;
                            caml_bytes_unsafe_set(s$0, n[1], c);
                            break a;
                        }
                        caml_bytes_unsafe_set(s$0, n[1], 92);
                        n[1]++;
                        caml_bytes_unsafe_set(s$0, n[1], 48 + (c / 100 | 0) | 0);
                        n[1]++;
                        caml_bytes_unsafe_set(s$0, n[1], 48 + ((c / 10 | 0) % 10 | 0) | 0);
                        n[1]++;
                        caml_bytes_unsafe_set(s$0, n[1], 48 + (c % 10 | 0) | 0);
                        break a;
                    }
                    caml_bytes_unsafe_set(s$0, n[1], c);
                }
                n[1]++;
                var _ab_ = i + 1 | 0;
                if (_aa_ === i) break;
                i = _ab_;
            }
        }
        return s$0;
    }
    function escaped(b) {
        var b$0 = copy(b);
        return unsafe_escape(b$0);
    }
    function map(f, s) {
        var l = caml_ml_bytes_length(s);
        if (0 === l) return s;
        var r = caml_create_bytes(l), _X_ = l - 1 | 0, _W_ = 0;
        if (_X_ >= 0) {
            var i = _W_;
            for(;;){
                caml_bytes_unsafe_set(r, i, caml_call1(f, caml_bytes_unsafe_get(s, i)));
                var _Y_ = i + 1 | 0;
                if (_X_ === i) break;
                i = _Y_;
            }
        }
        return r;
    }
    function mapi(f, s) {
        var l = caml_ml_bytes_length(s);
        if (0 === l) return s;
        var r = caml_create_bytes(l), _U_ = l - 1 | 0, _T_1 = 0;
        if (_U_ >= 0) {
            var i = _T_1;
            for(;;){
                caml_bytes_unsafe_set(r, i, caml_call2(f, i, caml_bytes_unsafe_get(s, i)));
                var _V_ = i + 1 | 0;
                if (_U_ === i) break;
                i = _V_;
            }
        }
        return r;
    }
    function fold_left(f, x, a) {
        var r = [
            0,
            x
        ], _R_ = caml_ml_bytes_length(a) - 1 | 0, _Q_ = 0;
        if (_R_ >= 0) {
            var i = _Q_;
            for(;;){
                r[1] = caml_call2(f, r[1], caml_bytes_unsafe_get(a, i));
                var _S_ = i + 1 | 0;
                if (_R_ === i) break;
                i = _S_;
            }
        }
        return r[1];
    }
    function fold_right(f, a, x) {
        var r = [
            0,
            x
        ], _O_ = caml_ml_bytes_length(a) - 1 | 0;
        if (_O_ >= 0) {
            var i = _O_;
            for(;;){
                r[1] = caml_call2(f, caml_bytes_unsafe_get(a, i), r[1]);
                var _P_ = i - 1 | 0;
                if (0 === i) break;
                i = _P_;
            }
        }
        return r[1];
    }
    function exists(p, s) {
        var n = caml_ml_bytes_length(s), i = 0;
        for(;;){
            if (i === n) return 0;
            if (caml_call1(p, caml_bytes_unsafe_get(s, i))) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function for_all(p, s) {
        var n = caml_ml_bytes_length(s), i = 0;
        for(;;){
            if (i === n) return 1;
            if (!caml_call1(p, caml_bytes_unsafe_get(s, i))) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function uppercase_ascii(s) {
        return map(Stdlib_Char[4], s);
    }
    function lowercase_ascii(s) {
        return map(Stdlib_Char[3], s);
    }
    function apply1(f, s) {
        if (0 === caml_ml_bytes_length(s)) return s;
        var r = copy(s);
        caml_bytes_unsafe_set(r, 0, caml_call1(f, caml_bytes_unsafe_get(s, 0)));
        return r;
    }
    function capitalize_ascii(s) {
        return apply1(Stdlib_Char[4], s);
    }
    function uncapitalize_ascii(s) {
        return apply1(Stdlib_Char[3], s);
    }
    function starts_with(prefix, s) {
        var len_s = caml_ml_bytes_length(s), len_pre = caml_ml_bytes_length(prefix), _N_ = len_pre <= len_s ? 1 : 0;
        if (!_N_) return _N_;
        var i = 0;
        for(;;){
            if (i === len_pre) return 1;
            if (caml_bytes_unsafe_get(s, i) !== caml_bytes_unsafe_get(prefix, i)) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function ends_with(suffix, s) {
        var len_s = caml_ml_bytes_length(s), len_suf = caml_ml_bytes_length(suffix), diff = len_s - len_suf | 0, _M_ = 0 <= diff ? 1 : 0;
        if (!_M_) return _M_;
        var i = 0;
        for(;;){
            if (i === len_suf) return 1;
            if (caml_bytes_unsafe_get(s, diff + i | 0) !== caml_bytes_unsafe_get(suffix, i)) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function index_rec(s, lim, i, c) {
        var i$0 = i;
        for(;;){
            if (lim <= i$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            if (caml_bytes_unsafe_get(s, i$0) === c) return i$0;
            var i$1 = i$0 + 1 | 0;
            i$0 = i$1;
        }
    }
    function index(s, c) {
        return index_rec(s, caml_ml_bytes_length(s), 0, c);
    }
    function index_rec_opt(s, lim, i, c) {
        var i$0 = i;
        for(;;){
            if (lim <= i$0) return 0;
            if (caml_bytes_unsafe_get(s, i$0) === c) return [
                0,
                i$0
            ];
            var i$1 = i$0 + 1 | 0;
            i$0 = i$1;
        }
    }
    function index_opt(s, c) {
        return index_rec_opt(s, caml_ml_bytes_length(s), 0, c);
    }
    function index_from(s, i, c) {
        var l = caml_ml_bytes_length(s);
        if (0 <= i && l >= i) return index_rec(s, l, i, c);
        return caml_call1(Stdlib[1], cst_String_index_from_Bytes_in);
    }
    function index_from_opt(s, i, c) {
        var l = caml_ml_bytes_length(s);
        if (0 <= i && l >= i) return index_rec_opt(s, l, i, c);
        return caml_call1(Stdlib[1], cst_String_index_from_opt_Byte);
    }
    function rindex_rec(s, i, c) {
        var i$0 = i;
        for(;;){
            if (0 > i$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            if (caml_bytes_unsafe_get(s, i$0) === c) return i$0;
            var i$1 = i$0 - 1 | 0;
            i$0 = i$1;
        }
    }
    function rindex(s, c) {
        return rindex_rec(s, caml_ml_bytes_length(s) - 1 | 0, c);
    }
    function rindex_from(s, i, c) {
        if (-1 <= i && caml_ml_bytes_length(s) > i) return rindex_rec(s, i, c);
        return caml_call1(Stdlib[1], cst_String_rindex_from_Bytes_r);
    }
    function rindex_rec_opt(s, i, c) {
        var i$0 = i;
        for(;;){
            if (0 > i$0) return 0;
            if (caml_bytes_unsafe_get(s, i$0) === c) return [
                0,
                i$0
            ];
            var i$1 = i$0 - 1 | 0;
            i$0 = i$1;
        }
    }
    function rindex_opt(s, c) {
        return rindex_rec_opt(s, caml_ml_bytes_length(s) - 1 | 0, c);
    }
    function rindex_from_opt(s, i, c) {
        if (-1 <= i && caml_ml_bytes_length(s) > i) return rindex_rec_opt(s, i, c);
        return caml_call1(Stdlib[1], cst_String_rindex_from_opt_Byt);
    }
    function contains_from(s, i, c) {
        var l = caml_ml_bytes_length(s);
        if (0 <= i && l >= i) try {
            index_rec(s, l, i, c);
            var _K_ = 1;
            return _K_;
        } catch (_L_) {
            var _J_ = caml_wrap_exception(_L_);
            if (_J_ === Stdlib[8]) return 0;
            throw caml_maybe_attach_backtrace(_J_, 0);
        }
        return caml_call1(Stdlib[1], cst_String_contains_from_Bytes);
    }
    function contains(s, c) {
        return contains_from(s, 0, c);
    }
    function rcontains_from(s, i, c) {
        if (0 <= i && caml_ml_bytes_length(s) > i) try {
            rindex_rec(s, i, c);
            var _H_ = 1;
            return _H_;
        } catch (_I_) {
            var _G_ = caml_wrap_exception(_I_);
            if (_G_ === Stdlib[8]) return 0;
            throw caml_maybe_attach_backtrace(_G_, 0);
        }
        return caml_call1(Stdlib[1], cst_String_rcontains_from_Byte);
    }
    var compare = runtime.caml_bytes_compare, cst_Bytes_of_seq_cannot_grow_b = "Bytes.of_seq: cannot grow bytes";
    function split_on_char(sep, s) {
        var r = [
            0,
            0
        ], j = [
            0,
            caml_ml_bytes_length(s)
        ], _C_ = caml_ml_bytes_length(s) - 1 | 0;
        if (_C_ >= 0) {
            var i = _C_;
            for(;;){
                if (caml_bytes_unsafe_get(s, i) === sep) {
                    var _E_ = r[1];
                    r[1] = [
                        0,
                        sub(s, i + 1 | 0, (j[1] - i | 0) - 1 | 0),
                        _E_
                    ];
                    j[1] = i;
                }
                var _F_ = i - 1 | 0;
                if (0 === i) break;
                i = _F_;
            }
        }
        var _D_ = r[1];
        return [
            0,
            sub(s, 0, j[1]),
            _D_
        ];
    }
    function to_seq(s) {
        function aux(i, param) {
            if (i === caml_ml_bytes_length(s)) return 0;
            var x = caml_bytes_get(s, i), _A_ = i + 1 | 0;
            return [
                0,
                x,
                function(_B_) {
                    return aux(_A_, _B_);
                }
            ];
        }
        var _y_ = 0;
        return function(_z_) {
            return aux(_y_, _z_);
        };
    }
    function to_seqi(s) {
        function aux(i, param) {
            if (i === caml_ml_bytes_length(s)) return 0;
            var x = caml_bytes_get(s, i), _w_ = i + 1 | 0;
            return [
                0,
                [
                    0,
                    i,
                    x
                ],
                function(_x_) {
                    return aux(_w_, _x_);
                }
            ];
        }
        var _u_ = 0;
        return function(_v_) {
            return aux(_u_, _v_);
        };
    }
    function of_seq(i) {
        var n = [
            0,
            0
        ], buf = [
            0,
            make(256, 0)
        ];
        caml_call2(Stdlib_Seq[4], function(c) {
            if (n[1] === caml_ml_bytes_length(buf[1])) {
                var new_len = caml_call2(Stdlib_Int[10], 2 * caml_ml_bytes_length(buf[1]) | 0, Stdlib_Sys[12]);
                if (caml_ml_bytes_length(buf[1]) === new_len) caml_call1(Stdlib[2], cst_Bytes_of_seq_cannot_grow_b);
                var new_buf = make(new_len, 0);
                blit(buf[1], 0, new_buf, 0, n[1]);
                buf[1] = new_buf;
            }
            caml_bytes_set(buf[1], n[1], c);
            n[1]++;
            return 0;
        }, i);
        return sub(buf[1], 0, n[1]);
    }
    function unsafe_get_uint16_le(b, i) {
        return Stdlib_Sys[11] ? caml_bswap16(caml_bytes_get16(b, i)) : caml_bytes_get16(b, i);
    }
    function unsafe_get_uint16_be(b, i) {
        return Stdlib_Sys[11] ? caml_bytes_get16(b, i) : caml_bswap16(caml_bytes_get16(b, i));
    }
    function get_int8(b, i) {
        var _s_ = Stdlib_Sys[10] - 8 | 0, _t_ = Stdlib_Sys[10] - 8 | 0;
        return caml_bytes_get(b, i) << _t_ >> _s_;
    }
    function get_uint16_le(b, i) {
        return Stdlib_Sys[11] ? caml_bswap16(caml_bytes_get16(b, i)) : caml_bytes_get16(b, i);
    }
    function get_uint16_be(b, i) {
        return Stdlib_Sys[11] ? caml_bytes_get16(b, i) : caml_bswap16(caml_bytes_get16(b, i));
    }
    function get_int16_ne(b, i) {
        var _q_ = Stdlib_Sys[10] - 16 | 0, _r_ = Stdlib_Sys[10] - 16 | 0;
        return caml_bytes_get16(b, i) << _r_ >> _q_;
    }
    function get_int16_le(b, i) {
        var _o_ = Stdlib_Sys[10] - 16 | 0, _p_ = Stdlib_Sys[10] - 16 | 0;
        return get_uint16_le(b, i) << _p_ >> _o_;
    }
    function get_int16_be(b, i) {
        var _m_ = Stdlib_Sys[10] - 16 | 0, _n_ = Stdlib_Sys[10] - 16 | 0;
        return get_uint16_be(b, i) << _n_ >> _m_;
    }
    function get_int32_le(b, i) {
        return Stdlib_Sys[11] ? caml_int32_bswap(caml_bytes_get32(b, i)) : caml_bytes_get32(b, i);
    }
    function get_int32_be(b, i) {
        return Stdlib_Sys[11] ? caml_bytes_get32(b, i) : caml_int32_bswap(caml_bytes_get32(b, i));
    }
    function get_int64_le(b, i) {
        return Stdlib_Sys[11] ? caml_int64_bswap(caml_bytes_get64(b, i)) : caml_bytes_get64(b, i);
    }
    function get_int64_be(b, i) {
        return Stdlib_Sys[11] ? caml_bytes_get64(b, i) : caml_int64_bswap(caml_bytes_get64(b, i));
    }
    function unsafe_set_uint16_le(b, i, x) {
        if (Stdlib_Sys[11]) {
            caml_bytes_set16(b, i, caml_bswap16(x));
            return;
        }
        caml_bytes_set16(b, i, x);
        return;
    }
    function unsafe_set_uint16_be(b, i, x) {
        if (Stdlib_Sys[11]) {
            caml_bytes_set16(b, i, x);
            return;
        }
        caml_bytes_set16(b, i, caml_bswap16(x));
        return;
    }
    function set_int16_le(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set16(b, i, caml_bswap16(x)) : caml_bytes_set16(b, i, x);
    }
    function set_int16_be(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set16(b, i, x) : caml_bytes_set16(b, i, caml_bswap16(x));
    }
    function set_int32_le(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set32(b, i, caml_int32_bswap(x)) : caml_bytes_set32(b, i, x);
    }
    function set_int32_be(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set32(b, i, x) : caml_bytes_set32(b, i, caml_int32_bswap(x));
    }
    function set_int64_le(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set64(b, i, caml_int64_bswap(x)) : caml_bytes_set64(b, i, x);
    }
    function set_int64_be(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set64(b, i, x) : caml_bytes_set64(b, i, caml_int64_bswap(x));
    }
    var set_uint8 = caml_bytes_set, set_uint16_ne = caml_bytes_set16, dec_invalid = Stdlib_Uchar[22], _a_ = [
        0,
        cst_bytes_ml,
        679,
        9
    ], _b_ = [
        0,
        cst_bytes_ml,
        654,
        20
    ], cst_index_out_of_bounds = cst_index_out_of_bounds$3, cst_index_out_of_bounds$0 = cst_index_out_of_bounds$3, _c_ = [
        0,
        cst_bytes_ml,
        777,
        9
    ], _d_ = [
        0,
        cst_bytes_ml,
        766,
        20
    ], cst_index_out_of_bounds$1 = cst_index_out_of_bounds$3, cst_index_out_of_bounds$2 = cst_index_out_of_bounds$3, _e_ = [
        0,
        cst_bytes_ml,
        831,
        9
    ], _f_ = [
        0,
        cst_bytes_ml,
        820,
        20
    ];
    function dec_ret(n, u) {
        var _l_ = caml_call1(Stdlib_Uchar[9], u);
        return caml_call2(Stdlib_Uchar[21], n, _l_);
    }
    function not_in_x80_to_xBF(b) {
        return 2 !== (b >>> 6 | 0) ? 1 : 0;
    }
    function not_in_xA0_to_xBF(b) {
        return 5 !== (b >>> 5 | 0) ? 1 : 0;
    }
    function not_in_x80_to_x9F(b) {
        return 4 !== (b >>> 5 | 0) ? 1 : 0;
    }
    function not_in_x90_to_xBF(b) {
        var _j_ = b < 144 ? 1 : 0, _k_ = _j_ || (191 < b ? 1 : 0);
        return _k_;
    }
    function not_in_x80_to_x8F(b) {
        return 8 !== (b >>> 4 | 0) ? 1 : 0;
    }
    function utf_8_uchar_3(b0, b1, b2) {
        return (b0 & 15) << 12 | (b1 & 63) << 6 | b2 & 63;
    }
    function utf_8_uchar_4(b0, b1, b2, b3) {
        return (b0 & 7) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6 | b3 & 63;
    }
    function get_utf_8_uchar(b, i) {
        var b0 = caml_bytes_get(b, i), max = caml_ml_bytes_length(b) - 1 | 0;
        a: {
            if (224 <= b0) {
                if (237 <= b0) {
                    if (245 <= b0) break a;
                    switch(b0 - 237 | 0){
                        case 0:
                            var i$0 = i + 1 | 0;
                            if (max < i$0) return caml_call1(dec_invalid, 1);
                            var b1$4 = caml_bytes_unsafe_get(b, i$0);
                            if (not_in_x80_to_x9F(b1$4)) return caml_call1(dec_invalid, 1);
                            var i$1 = i$0 + 1 | 0;
                            if (max < i$1) return caml_call1(dec_invalid, 2);
                            var b2$3 = caml_bytes_unsafe_get(b, i$1);
                            return not_in_x80_to_xBF(b2$3) ? caml_call1(dec_invalid, 2) : dec_ret(3, utf_8_uchar_3(b0, b1$4, b2$3));
                        case 3:
                            var i$4 = i + 1 | 0;
                            if (max < i$4) return caml_call1(dec_invalid, 1);
                            var b1$2 = caml_bytes_unsafe_get(b, i$4);
                            if (not_in_x90_to_xBF(b1$2)) return caml_call1(dec_invalid, 1);
                            var i$5 = i$4 + 1 | 0;
                            if (max < i$5) return caml_call1(dec_invalid, 2);
                            var b2$1 = caml_bytes_unsafe_get(b, i$5);
                            if (not_in_x80_to_xBF(b2$1)) return caml_call1(dec_invalid, 2);
                            var i$6 = i$5 + 1 | 0;
                            if (max < i$6) return caml_call1(dec_invalid, 3);
                            var b3$1 = caml_bytes_unsafe_get(b, i$6);
                            return not_in_x80_to_xBF(b3$1) ? caml_call1(dec_invalid, 3) : dec_ret(4, utf_8_uchar_4(b0, b1$2, b2$1, b3$1));
                        case 7:
                            var i$10 = i + 1 | 0;
                            if (max < i$10) return caml_call1(dec_invalid, 1);
                            var b1$0 = caml_bytes_unsafe_get(b, i$10);
                            if (not_in_x80_to_x8F(b1$0)) return caml_call1(dec_invalid, 1);
                            var i$11 = i$10 + 1 | 0;
                            if (max < i$11) return caml_call1(dec_invalid, 2);
                            var b2 = caml_bytes_unsafe_get(b, i$11);
                            if (not_in_x80_to_xBF(b2)) return caml_call1(dec_invalid, 2);
                            var i$12 = i$11 + 1 | 0;
                            if (max < i$12) return caml_call1(dec_invalid, 3);
                            var b3 = caml_bytes_unsafe_get(b, i$12);
                            return not_in_x80_to_xBF(b3) ? caml_call1(dec_invalid, 3) : dec_ret(4, utf_8_uchar_4(b0, b1$0, b2, b3));
                        case 1:
                        case 2:
                            break;
                        default:
                            var i$7 = i + 1 | 0;
                            if (max < i$7) return caml_call1(dec_invalid, 1);
                            var b1$1 = caml_bytes_unsafe_get(b, i$7);
                            if (not_in_x80_to_xBF(b1$1)) return caml_call1(dec_invalid, 1);
                            var i$8 = i$7 + 1 | 0;
                            if (max < i$8) return caml_call1(dec_invalid, 2);
                            var b2$0 = caml_bytes_unsafe_get(b, i$8);
                            if (not_in_x80_to_xBF(b2$0)) return caml_call1(dec_invalid, 2);
                            var i$9 = i$8 + 1 | 0;
                            if (max < i$9) return caml_call1(dec_invalid, 3);
                            var b3$0 = caml_bytes_unsafe_get(b, i$9);
                            return not_in_x80_to_xBF(b3$0) ? caml_call1(dec_invalid, 3) : dec_ret(4, utf_8_uchar_4(b0, b1$1, b2$0, b3$0));
                    }
                } else if (225 > b0) {
                    var i$13 = i + 1 | 0;
                    if (max < i$13) return caml_call1(dec_invalid, 1);
                    var b1$5 = caml_bytes_unsafe_get(b, i$13);
                    if (not_in_xA0_to_xBF(b1$5)) return caml_call1(dec_invalid, 1);
                    var i$14 = i$13 + 1 | 0;
                    if (max < i$14) return caml_call1(dec_invalid, 2);
                    var b2$4 = caml_bytes_unsafe_get(b, i$14);
                    return not_in_x80_to_xBF(b2$4) ? caml_call1(dec_invalid, 2) : dec_ret(3, utf_8_uchar_3(b0, b1$5, b2$4));
                }
                var i$2 = i + 1 | 0;
                if (max < i$2) return caml_call1(dec_invalid, 1);
                var b1$3 = caml_bytes_unsafe_get(b, i$2);
                if (not_in_x80_to_xBF(b1$3)) return caml_call1(dec_invalid, 1);
                var i$3 = i$2 + 1 | 0;
                if (max < i$3) return caml_call1(dec_invalid, 2);
                var b2$2 = caml_bytes_unsafe_get(b, i$3);
                return not_in_x80_to_xBF(b2$2) ? caml_call1(dec_invalid, 2) : dec_ret(3, utf_8_uchar_3(b0, b1$3, b2$2));
            }
            if (128 > b0) return dec_ret(1, b0);
            if (194 <= b0) {
                var i$15 = i + 1 | 0;
                if (max < i$15) return caml_call1(dec_invalid, 1);
                var b1 = caml_bytes_unsafe_get(b, i$15);
                return not_in_x80_to_xBF(b1) ? caml_call1(dec_invalid, 1) : dec_ret(2, (b0 & 31) << 6 | b1 & 63);
            }
        }
        return caml_call1(dec_invalid, 1);
    }
    function set_utf_8_uchar(b, i, u) {
        function set(_i_, _h_, _g_) {
            caml_bytes_unsafe_set(_i_, _h_, _g_);
            return;
        }
        var max = caml_ml_bytes_length(b) - 1 | 0, u$0 = caml_call1(Stdlib_Uchar[10], u);
        if (0 > u$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        if (127 >= u$0) {
            caml_bytes_set(b, i, u$0);
            return 1;
        }
        if (2047 >= u$0) {
            var last$1 = i + 1 | 0;
            return max < last$1 ? 0 : (caml_bytes_set(b, i, 192 | u$0 >>> 6 | 0), set(b, last$1, 128 | u$0 & 63), 2);
        }
        if (65535 >= u$0) {
            var last$0 = i + 2 | 0;
            return max < last$0 ? 0 : (caml_bytes_set(b, i, 224 | u$0 >>> 12 | 0), set(b, i + 1 | 0, 128 | (u$0 >>> 6 | 0) & 63), set(b, last$0, 128 | u$0 & 63), 3);
        }
        if (1114111 < u$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
        var last = i + 3 | 0;
        return max < last ? 0 : (caml_bytes_set(b, i, 240 | u$0 >>> 18 | 0), set(b, i + 1 | 0, 128 | (u$0 >>> 12 | 0) & 63), set(b, i + 2 | 0, 128 | (u$0 >>> 6 | 0) & 63), set(b, last, 128 | u$0 & 63), 4);
    }
    function is_valid_utf_8(b) {
        var max = caml_ml_bytes_length(b) - 1 | 0, i = 0;
        for(;;){
            if (max < i) return 1;
            var match = caml_bytes_unsafe_get(b, i);
            a: {
                if (224 <= match) {
                    if (237 <= match) {
                        if (245 <= match) break a;
                        switch(match - 237 | 0){
                            case 0:
                                var last = i + 2 | 0;
                                if (max >= last && !not_in_x80_to_x9F(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last))) {
                                    var i$0 = last + 1 | 0;
                                    i = i$0;
                                    continue;
                                }
                                return 0;
                            case 3:
                                var last$1 = i + 3 | 0;
                                if (max >= last$1 && !not_in_x90_to_xBF(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, i + 2 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$1))) {
                                    var i$2 = last$1 + 1 | 0;
                                    i = i$2;
                                    continue;
                                }
                                return 0;
                            case 7:
                                var last$3 = i + 3 | 0;
                                if (max >= last$3 && !not_in_x80_to_x8F(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, i + 2 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$3))) {
                                    var i$4 = last$3 + 1 | 0;
                                    i = i$4;
                                    continue;
                                }
                                return 0;
                            case 1:
                            case 2:
                                break;
                            default:
                                var last$2 = i + 3 | 0;
                                if (max >= last$2 && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, i + 2 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$2))) {
                                    var i$3 = last$2 + 1 | 0;
                                    i = i$3;
                                    continue;
                                }
                                return 0;
                        }
                    } else if (225 > match) {
                        var last$4 = i + 2 | 0;
                        if (max >= last$4 && !not_in_xA0_to_xBF(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$4))) {
                            var i$5 = last$4 + 1 | 0;
                            i = i$5;
                            continue;
                        }
                        return 0;
                    }
                    var last$0 = i + 2 | 0;
                    if (max >= last$0 && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$0))) {
                        var i$1 = last$0 + 1 | 0;
                        i = i$1;
                        continue;
                    }
                    return 0;
                }
                if (128 > match) {
                    var i$7 = i + 1 | 0;
                    i = i$7;
                    continue;
                }
                if (194 <= match) {
                    var last$5 = i + 1 | 0;
                    if (max >= last$5 && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$5))) {
                        var i$6 = last$5 + 1 | 0;
                        i = i$6;
                        continue;
                    }
                    return 0;
                }
            }
            return 0;
        }
    }
    function get_utf_16be_uchar(b, i) {
        var max = caml_ml_bytes_length(b) - 1 | 0;
        if (0 <= i && max >= i) {
            if (i === max) return caml_call1(dec_invalid, 1);
            var hi = unsafe_get_uint16_be(b, i);
            if (55296 <= hi && 57343 >= hi) {
                if (56319 < hi) return caml_call1(dec_invalid, 2);
                var last = i + 3 | 0;
                if (max < last) return caml_call1(dec_invalid, (max - i | 0) + 1 | 0);
                var lo = unsafe_get_uint16_be(b, i + 2 | 0);
                if (56320 <= lo && 57343 >= lo) {
                    var u = ((hi & 1023) << 10 | lo & 1023) + 65536 | 0;
                    return dec_ret(4, u);
                }
                return caml_call1(dec_invalid, 2);
            }
            return dec_ret(2, hi);
        }
        return caml_call1(Stdlib[1], cst_index_out_of_bounds);
    }
    function set_utf_16be_uchar(b, i, u) {
        var max = caml_ml_bytes_length(b) - 1 | 0;
        if (0 <= i && max >= i) {
            var u$0 = caml_call1(Stdlib_Uchar[10], u);
            if (0 > u$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _d_
            ], 1);
            if (65535 >= u$0) {
                var last$0 = i + 1 | 0;
                return max < last$0 ? 0 : (unsafe_set_uint16_be(b, i, u$0), 2);
            }
            if (1114111 < u$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _c_
            ], 1);
            var last = i + 3 | 0;
            if (max < last) return 0;
            var u$1 = u$0 - 65536 | 0, hi = 55296 | u$1 >>> 10 | 0, lo = 56320 | u$1 & 1023;
            unsafe_set_uint16_be(b, i, hi);
            unsafe_set_uint16_be(b, i + 2 | 0, lo);
            return 4;
        }
        return caml_call1(Stdlib[1], cst_index_out_of_bounds$0);
    }
    function is_valid_utf_16be(b) {
        var max = caml_ml_bytes_length(b) - 1 | 0, i = 0;
        for(;;){
            if (max < i) return 1;
            if (i === max) return 0;
            var u = unsafe_get_uint16_be(b, i);
            if (55296 <= u && 57343 >= u) {
                if (56319 < u) return 0;
                var last = i + 3 | 0;
                if (max < last) return 0;
                var u$0 = unsafe_get_uint16_be(b, i + 2 | 0);
                if (56320 <= u$0 && 57343 >= u$0) {
                    var i$1 = i + 4 | 0;
                    i = i$1;
                    continue;
                }
                return 0;
            }
            var i$0 = i + 2 | 0;
            i = i$0;
        }
    }
    function get_utf_16le_uchar(b, i) {
        var max = caml_ml_bytes_length(b) - 1 | 0;
        if (0 <= i && max >= i) {
            if (i === max) return caml_call1(dec_invalid, 1);
            var hi = unsafe_get_uint16_le(b, i);
            if (55296 <= hi && 57343 >= hi) {
                if (56319 < hi) return caml_call1(dec_invalid, 2);
                var last = i + 3 | 0;
                if (max < last) return caml_call1(dec_invalid, (max - i | 0) + 1 | 0);
                var lo = unsafe_get_uint16_le(b, i + 2 | 0);
                if (56320 <= lo && 57343 >= lo) {
                    var u = ((hi & 1023) << 10 | lo & 1023) + 65536 | 0;
                    return dec_ret(4, u);
                }
                return caml_call1(dec_invalid, 2);
            }
            return dec_ret(2, hi);
        }
        return caml_call1(Stdlib[1], cst_index_out_of_bounds$1);
    }
    function set_utf_16le_uchar(b, i, u) {
        var max = caml_ml_bytes_length(b) - 1 | 0;
        if (0 <= i && max >= i) {
            var u$0 = caml_call1(Stdlib_Uchar[10], u);
            if (0 > u$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _f_
            ], 1);
            if (65535 >= u$0) {
                var last$0 = i + 1 | 0;
                return max < last$0 ? 0 : (unsafe_set_uint16_le(b, i, u$0), 2);
            }
            if (1114111 < u$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _e_
            ], 1);
            var last = i + 3 | 0;
            if (max < last) return 0;
            var u$1 = u$0 - 65536 | 0, hi = 55296 | u$1 >>> 10 | 0, lo = 56320 | u$1 & 1023;
            unsafe_set_uint16_le(b, i, hi);
            unsafe_set_uint16_le(b, i + 2 | 0, lo);
            return 4;
        }
        return caml_call1(Stdlib[1], cst_index_out_of_bounds$2);
    }
    function is_valid_utf_16le(b) {
        var max = caml_ml_bytes_length(b) - 1 | 0, i = 0;
        for(;;){
            if (max < i) return 1;
            if (i === max) return 0;
            var u = unsafe_get_uint16_le(b, i);
            if (55296 <= u && 57343 >= u) {
                if (56319 < u) return 0;
                var last = i + 3 | 0;
                if (max < last) return 0;
                var u$0 = unsafe_get_uint16_le(b, i + 2 | 0);
                if (56320 <= u$0 && 57343 >= u$0) {
                    var i$1 = i + 4 | 0;
                    i = i$1;
                    continue;
                }
                return 0;
            }
            var i$0 = i + 2 | 0;
            i = i$0;
        }
    }
    var Stdlib_Bytes = [
        0,
        make,
        init,
        empty,
        copy,
        of_string,
        to_string,
        sub,
        sub_string,
        extend,
        fill,
        blit,
        blit_string,
        concat,
        cat,
        iter,
        iteri,
        map,
        mapi,
        fold_left,
        fold_right,
        for_all,
        exists,
        trim,
        escaped,
        index,
        index_opt,
        rindex,
        rindex_opt,
        index_from,
        index_from_opt,
        rindex_from,
        rindex_from_opt,
        contains,
        contains_from,
        rcontains_from,
        uppercase_ascii,
        lowercase_ascii,
        capitalize_ascii,
        uncapitalize_ascii,
        compare,
        runtime.caml_bytes_equal,
        starts_with,
        ends_with,
        caml_string_of_bytes,
        caml_bytes_of_string,
        split_on_char,
        to_seq,
        to_seqi,
        of_seq,
        get_utf_8_uchar,
        set_utf_8_uchar,
        is_valid_utf_8,
        get_utf_16be_uchar,
        set_utf_16be_uchar,
        is_valid_utf_16be,
        get_utf_16le_uchar,
        set_utf_16le_uchar,
        is_valid_utf_16le,
        caml_bytes_get,
        get_int8,
        caml_bytes_get16,
        get_uint16_be,
        get_uint16_le,
        get_int16_ne,
        get_int16_be,
        get_int16_le,
        caml_bytes_get32,
        get_int32_be,
        get_int32_le,
        caml_bytes_get64,
        get_int64_be,
        get_int64_le,
        set_uint8,
        caml_bytes_set,
        set_uint16_ne,
        set_int16_be,
        set_int16_le,
        caml_bytes_set16,
        set_int16_be,
        set_int16_le,
        caml_bytes_set32,
        set_int32_be,
        set_int32_le,
        caml_bytes_set64,
        set_int64_be,
        set_int64_le,
        unsafe_escape
    ];
    runtime.caml_register_global(30, Stdlib_Bytes, "Stdlib__Bytes");
    return;
})(globalThis);
//# 5055 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$0 = "", caml_blit_string = runtime.caml_blit_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_equal = runtime.caml_string_equal, caml_string_hash = runtime.caml_string_hash, caml_string_unsafe_get = runtime.caml_string_unsafe_get, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = cst$0, empty = cst$0, Stdlib = global_data.Stdlib, Stdlib_Bytes = global_data.Stdlib__Bytes, bts = Stdlib_Bytes[44], bos = Stdlib_Bytes[45];
    function make(n, c) {
        return caml_call1(bts, caml_call2(Stdlib_Bytes[1], n, c));
    }
    function init(n, f) {
        return caml_call1(bts, caml_call2(Stdlib_Bytes[2], n, f));
    }
    var of_bytes = Stdlib_Bytes[6], to_bytes = Stdlib_Bytes[5];
    function sub(s, ofs, len) {
        var _X_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call3(Stdlib_Bytes[7], _X_, ofs, len));
    }
    var blit = Stdlib_Bytes[12], cst_String_concat = "String.concat";
    function concat(sep, l) {
        if (!l) return cst;
        var seplen = caml_ml_string_length(sep);
        a: {
            b: {
                var acc = 0, param = l, pos$1 = 0;
                for(;;){
                    if (!param) break;
                    var hd = param[1];
                    if (!param[2]) break b;
                    var tl = param[2], x = (caml_ml_string_length(hd) + seplen | 0) + acc | 0, acc$0 = acc <= x ? x : caml_call1(Stdlib[1], cst_String_concat);
                    acc = acc$0;
                    param = tl;
                }
                var _W_ = acc;
                break a;
            }
            var _W_ = caml_ml_string_length(hd) + acc | 0;
        }
        var dst = runtime.caml_create_bytes(_W_), pos = pos$1, param$0 = l;
        for(;;){
            if (param$0) {
                var hd$0 = param$0[1];
                if (param$0[2]) {
                    var tl$0 = param$0[2];
                    caml_blit_string(hd$0, 0, dst, pos, caml_ml_string_length(hd$0));
                    caml_blit_string(sep, 0, dst, pos + caml_ml_string_length(hd$0) | 0, seplen);
                    var pos$0 = (pos + caml_ml_string_length(hd$0) | 0) + seplen | 0;
                    pos = pos$0;
                    param$0 = tl$0;
                    continue;
                }
                caml_blit_string(hd$0, 0, dst, pos, caml_ml_string_length(hd$0));
            }
            return caml_call1(bts, dst);
        }
    }
    var cat = Stdlib[28], cst_String_index_from_Bytes_in = "String.index_from / Bytes.index_from", cst_String_index_from_opt_Byte = "String.index_from_opt / Bytes.index_from_opt", cst_String_rindex_from_Bytes_r = "String.rindex_from / Bytes.rindex_from", cst_String_rindex_from_opt_Byt = "String.rindex_from_opt / Bytes.rindex_from_opt", cst_String_contains_from_Bytes = "String.contains_from / Bytes.contains_from", cst_String_rcontains_from_Byte = "String.rcontains_from / Bytes.rcontains_from";
    function iter(f, s) {
        var _U_ = caml_ml_string_length(s) - 1 | 0, _T_1 = 0;
        if (_U_ >= 0) {
            var i = _T_1;
            for(;;){
                caml_call1(f, caml_string_unsafe_get(s, i));
                var _V_ = i + 1 | 0;
                if (_U_ === i) break;
                i = _V_;
            }
        }
        return 0;
    }
    function iteri(f, s) {
        var _R_ = caml_ml_string_length(s) - 1 | 0, _Q_ = 0;
        if (_R_ >= 0) {
            var i = _Q_;
            for(;;){
                caml_call2(f, i, caml_string_unsafe_get(s, i));
                var _S_ = i + 1 | 0;
                if (_R_ === i) break;
                i = _S_;
            }
        }
        return 0;
    }
    function map(f, s) {
        var _P_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call2(Stdlib_Bytes[17], f, _P_));
    }
    function mapi(f, s) {
        var _O_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call2(Stdlib_Bytes[18], f, _O_));
    }
    function fold_right(f, x, a) {
        var _N_ = caml_call1(bos, x);
        return caml_call3(Stdlib_Bytes[20], f, _N_, a);
    }
    function fold_left(f, a, x) {
        var _M_ = caml_call1(bos, x);
        return caml_call3(Stdlib_Bytes[19], f, a, _M_);
    }
    function exists(f, s) {
        var _L_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[22], f, _L_);
    }
    function for_all(f, s) {
        var _K_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[21], f, _K_);
    }
    function is_space(param) {
        var _J_ = param - 9 | 0;
        a: {
            if (4 < _J_ >>> 0) {
                if (23 !== _J_) break a;
            } else if (2 === _J_) break a;
            return 1;
        }
        return 0;
    }
    function trim(s) {
        if (s == cst$0) return s;
        if (!is_space(caml_string_unsafe_get(s, 0)) && !is_space(caml_string_unsafe_get(s, caml_ml_string_length(s) - 1 | 0))) return s;
        var _I_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[23], _I_));
    }
    function escaped(s) {
        var b = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[87], b));
    }
    function index_rec(s, lim, i, c) {
        var i$0 = i;
        for(;;){
            if (lim <= i$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            if (caml_string_unsafe_get(s, i$0) === c) return i$0;
            var i$1 = i$0 + 1 | 0;
            i$0 = i$1;
        }
    }
    function index(s, c) {
        return index_rec(s, caml_ml_string_length(s), 0, c);
    }
    function index_rec_opt(s, lim, i, c) {
        var i$0 = i;
        for(;;){
            if (lim <= i$0) return 0;
            if (caml_string_unsafe_get(s, i$0) === c) return [
                0,
                i$0
            ];
            var i$1 = i$0 + 1 | 0;
            i$0 = i$1;
        }
    }
    function index_opt(s, c) {
        return index_rec_opt(s, caml_ml_string_length(s), 0, c);
    }
    function index_from(s, i, c) {
        var l = caml_ml_string_length(s);
        if (0 <= i && l >= i) return index_rec(s, l, i, c);
        return caml_call1(Stdlib[1], cst_String_index_from_Bytes_in);
    }
    function index_from_opt(s, i, c) {
        var l = caml_ml_string_length(s);
        if (0 <= i && l >= i) return index_rec_opt(s, l, i, c);
        return caml_call1(Stdlib[1], cst_String_index_from_opt_Byte);
    }
    function rindex_rec(s, i, c) {
        var i$0 = i;
        for(;;){
            if (0 > i$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            if (caml_string_unsafe_get(s, i$0) === c) return i$0;
            var i$1 = i$0 - 1 | 0;
            i$0 = i$1;
        }
    }
    function rindex(s, c) {
        return rindex_rec(s, caml_ml_string_length(s) - 1 | 0, c);
    }
    function rindex_from(s, i, c) {
        if (-1 <= i && caml_ml_string_length(s) > i) return rindex_rec(s, i, c);
        return caml_call1(Stdlib[1], cst_String_rindex_from_Bytes_r);
    }
    function rindex_rec_opt(s, i, c) {
        var i$0 = i;
        for(;;){
            if (0 > i$0) return 0;
            if (caml_string_unsafe_get(s, i$0) === c) return [
                0,
                i$0
            ];
            var i$1 = i$0 - 1 | 0;
            i$0 = i$1;
        }
    }
    function rindex_opt(s, c) {
        return rindex_rec_opt(s, caml_ml_string_length(s) - 1 | 0, c);
    }
    function rindex_from_opt(s, i, c) {
        if (-1 <= i && caml_ml_string_length(s) > i) return rindex_rec_opt(s, i, c);
        return caml_call1(Stdlib[1], cst_String_rindex_from_opt_Byt);
    }
    function contains_from(s, i, c) {
        var l = caml_ml_string_length(s);
        if (0 <= i && l >= i) try {
            index_rec(s, l, i, c);
            var _G_ = 1;
            return _G_;
        } catch (_H_) {
            var _F_ = caml_wrap_exception(_H_);
            if (_F_ === Stdlib[8]) return 0;
            throw caml_maybe_attach_backtrace(_F_, 0);
        }
        return caml_call1(Stdlib[1], cst_String_contains_from_Bytes);
    }
    function contains(s, c) {
        return contains_from(s, 0, c);
    }
    function rcontains_from(s, i, c) {
        if (0 <= i && caml_ml_string_length(s) > i) try {
            rindex_rec(s, i, c);
            var _D_ = 1;
            return _D_;
        } catch (_E_) {
            var _C_ = caml_wrap_exception(_E_);
            if (_C_ === Stdlib[8]) return 0;
            throw caml_maybe_attach_backtrace(_C_, 0);
        }
        return caml_call1(Stdlib[1], cst_String_rcontains_from_Byte);
    }
    function uppercase_ascii(s) {
        var _B_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[36], _B_));
    }
    function lowercase_ascii(s) {
        var _A_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[37], _A_));
    }
    function capitalize_ascii(s) {
        var _z_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[38], _z_));
    }
    function uncapitalize_ascii(s) {
        var _y_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[39], _y_));
    }
    function starts_with(prefix, s) {
        var len_s = caml_ml_string_length(s), len_pre = caml_ml_string_length(prefix), _x_ = len_pre <= len_s ? 1 : 0;
        if (!_x_) return _x_;
        var i = 0;
        for(;;){
            if (i === len_pre) return 1;
            if (caml_string_unsafe_get(s, i) !== caml_string_unsafe_get(prefix, i)) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function ends_with(suffix, s) {
        var len_s = caml_ml_string_length(s), len_suf = caml_ml_string_length(suffix), diff = len_s - len_suf | 0, _w_ = 0 <= diff ? 1 : 0;
        if (!_w_) return _w_;
        var i = 0;
        for(;;){
            if (i === len_suf) return 1;
            if (caml_string_unsafe_get(s, diff + i | 0) !== caml_string_unsafe_get(suffix, i)) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function hash(x) {
        return caml_string_hash(0, x);
    }
    function split_on_char(sep, s) {
        var r = [
            0,
            0
        ], j = [
            0,
            caml_ml_string_length(s)
        ], _s_ = caml_ml_string_length(s) - 1 | 0;
        if (_s_ >= 0) {
            var i = _s_;
            for(;;){
                if (caml_string_unsafe_get(s, i) === sep) {
                    var _u_ = r[1];
                    r[1] = [
                        0,
                        sub(s, i + 1 | 0, (j[1] - i | 0) - 1 | 0),
                        _u_
                    ];
                    j[1] = i;
                }
                var _v_ = i - 1 | 0;
                if (0 === i) break;
                i = _v_;
            }
        }
        var _t_ = r[1];
        return [
            0,
            sub(s, 0, j[1]),
            _t_
        ];
    }
    var compare = runtime.caml_string_compare;
    function to_seq(s) {
        var _r_ = caml_call1(bos, s);
        return caml_call1(Stdlib_Bytes[47], _r_);
    }
    function to_seqi(s) {
        var _q_ = caml_call1(bos, s);
        return caml_call1(Stdlib_Bytes[48], _q_);
    }
    function of_seq(g) {
        return caml_call1(bts, caml_call1(Stdlib_Bytes[49], g));
    }
    function get_utf_8_uchar(s, i) {
        var _p_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[50], _p_, i);
    }
    function is_valid_utf_8(s) {
        var _o_ = caml_call1(bos, s);
        return caml_call1(Stdlib_Bytes[52], _o_);
    }
    function get_utf_16be_uchar(s, i) {
        var _n_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[53], _n_, i);
    }
    function is_valid_utf_16be(s) {
        var _m_ = caml_call1(bos, s);
        return caml_call1(Stdlib_Bytes[55], _m_);
    }
    function get_utf_16le_uchar(s, i) {
        var _l_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[56], _l_, i);
    }
    function is_valid_utf_16le(s) {
        var _k_ = caml_call1(bos, s);
        return caml_call1(Stdlib_Bytes[58], _k_);
    }
    function get_int8(s, i) {
        var _j_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[60], _j_, i);
    }
    function get_uint16_le(s, i) {
        var _i_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[63], _i_, i);
    }
    function get_uint16_be(s, i) {
        var _h_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[62], _h_, i);
    }
    function get_int16_ne(s, i) {
        var _g_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[64], _g_, i);
    }
    function get_int16_le(s, i) {
        var _f_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[66], _f_, i);
    }
    function get_int16_be(s, i) {
        var _e_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[65], _e_, i);
    }
    function get_int32_le(s, i) {
        var _d_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[69], _d_, i);
    }
    function get_int32_be(s, i) {
        var _c_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[68], _c_, i);
    }
    function get_int64_le(s, i) {
        var _b_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[72], _b_, i);
    }
    function get_int64_be(s, i) {
        var _a_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[71], _a_, i);
    }
    var Stdlib_String = [
        0,
        make,
        init,
        empty,
        of_bytes,
        to_bytes,
        blit,
        concat,
        cat,
        caml_string_equal,
        compare,
        starts_with,
        ends_with,
        contains_from,
        rcontains_from,
        contains,
        sub,
        split_on_char,
        map,
        mapi,
        fold_left,
        fold_right,
        for_all,
        exists,
        trim,
        escaped,
        uppercase_ascii,
        lowercase_ascii,
        capitalize_ascii,
        uncapitalize_ascii,
        iter,
        iteri,
        index_from,
        index_from_opt,
        rindex_from,
        rindex_from_opt,
        index,
        index_opt,
        rindex,
        rindex_opt,
        to_seq,
        to_seqi,
        of_seq,
        get_utf_8_uchar,
        is_valid_utf_8,
        get_utf_16be_uchar,
        is_valid_utf_16be,
        get_utf_16le_uchar,
        is_valid_utf_16le,
        runtime.caml_string_get,
        get_int8,
        runtime.caml_string_get16,
        get_uint16_be,
        get_uint16_le,
        get_int16_ne,
        get_int16_be,
        get_int16_le,
        runtime.caml_string_get32,
        hash,
        caml_string_hash,
        get_int32_be,
        get_int32_le,
        runtime.caml_string_get64,
        get_int64_be,
        get_int64_le
    ];
    runtime.caml_register_global(12, Stdlib_String, "Stdlib__String");
    return;
})(globalThis);
//# 5618 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_array_sub = runtime.caml_array_sub, caml_check_bound = runtime.caml_check_bound, caml_make_vect = runtime.caml_make_vect, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Assert_failure = global_data.Assert_failure, Stdlib = global_data.Stdlib, Floatarray = [
        0
    ], cst_Array_init = "Array.init", cst_Array_make_matrix = "Array.make_matrix", cst_Array_init_matrix = "Array.init_matrix", cst_Array_sub = "Array.sub", cst_Array_fill = "Array.fill", cst_Array_blit = "Array.blit", cst_Array_iter2_arrays_must_ha = "Array.iter2: arrays must have the same length", cst_Array_map2_arrays_must_hav = "Array.map2: arrays must have the same length", cst_Array_for_all2 = "Array.for_all2", cst_Array_exists2 = "Array.exists2", cst_Array_combine = "Array.combine";
    function init(l, f) {
        if (0 === l) return [
            0
        ];
        if (0 > l) return caml_call1(Stdlib[1], cst_Array_init);
        var res = caml_make_vect(l, caml_call1(f, 0)), _aE_ = l - 1 | 0, _aD_ = 1;
        if (_aE_ >= 1) {
            var i = _aD_;
            for(;;){
                res[1 + i] = caml_call1(f, i);
                var _aF_ = i + 1 | 0;
                if (_aE_ === i) break;
                i = _aF_;
            }
        }
        return res;
    }
    function make_matrix(sx, sy, init) {
        if (sy < 0) caml_call1(Stdlib[1], cst_Array_make_matrix);
        var res = caml_make_vect(sx, [
            0
        ]);
        if (0 < sy) {
            var _aB_ = sx - 1 | 0, _aA_ = 0;
            if (_aB_ >= 0) {
                var x = _aA_;
                for(;;){
                    res[1 + x] = caml_make_vect(sy, init);
                    var _aC_ = x + 1 | 0;
                    if (_aB_ === x) break;
                    x = _aC_;
                }
            }
        }
        return res;
    }
    function init_matrix(sx, sy, f) {
        if (sy < 0) caml_call1(Stdlib[1], cst_Array_init_matrix);
        var res = caml_make_vect(sx, [
            0
        ]);
        if (0 < sy) {
            var _av_ = sx - 1 | 0, _au_ = 0;
            if (_av_ >= 0) {
                var x = _au_;
                for(;;){
                    var row = caml_make_vect(sy, caml_call2(f, x, 0)), _ax_ = sy - 1 | 0, _aw_ = 1;
                    if (_ax_ >= 1) {
                        var y = _aw_;
                        for(;;){
                            row[1 + y] = caml_call2(f, x, y);
                            var _az_ = y + 1 | 0;
                            if (_ax_ === y) break;
                            y = _az_;
                        }
                    }
                    res[1 + x] = row;
                    var _ay_ = x + 1 | 0;
                    if (_av_ === x) break;
                    x = _ay_;
                }
            }
        }
        return res;
    }
    function copy(a) {
        var l = a.length - 1;
        return 0 === l ? [
            0
        ] : caml_array_sub(a, 0, l);
    }
    function append(a1, a2) {
        var l1 = a1.length - 1;
        return 0 === l1 ? copy(a2) : 0 === a2.length - 1 ? caml_array_sub(a1, 0, l1) : runtime.caml_array_append(a1, a2);
    }
    function sub(a, ofs, len) {
        if (0 <= ofs && 0 <= len && (a.length - 1 - len | 0) >= ofs) return caml_array_sub(a, ofs, len);
        return caml_call1(Stdlib[1], cst_Array_sub);
    }
    function fill(a, ofs, len, v) {
        if (0 <= ofs && 0 <= len && (a.length - 1 - len | 0) >= ofs) return runtime.caml_array_fill(a, ofs, len, v);
        return caml_call1(Stdlib[1], cst_Array_fill);
    }
    function blit(a1, ofs1, a2, ofs2, len) {
        if (0 <= len && 0 <= ofs1 && (a1.length - 1 - len | 0) >= ofs1 && 0 <= ofs2 && (a2.length - 1 - len | 0) >= ofs2) return runtime.caml_array_blit(a1, ofs1, a2, ofs2, len);
        return caml_call1(Stdlib[1], cst_Array_blit);
    }
    function iter(f, a) {
        var _as_ = a.length - 2 | 0, _ar_ = 0;
        if (_as_ >= 0) {
            var i = _ar_;
            for(;;){
                caml_call1(f, a[1 + i]);
                var _at_ = i + 1 | 0;
                if (_as_ === i) break;
                i = _at_;
            }
        }
        return 0;
    }
    function iter2(f, a, b) {
        if (a.length - 1 !== b.length - 1) return caml_call1(Stdlib[1], cst_Array_iter2_arrays_must_ha);
        var _ap_ = a.length - 2 | 0, _ao_ = 0;
        if (_ap_ >= 0) {
            var i = _ao_;
            for(;;){
                caml_call2(f, a[1 + i], b[1 + i]);
                var _aq_ = i + 1 | 0;
                if (_ap_ === i) break;
                i = _aq_;
            }
        }
        return 0;
    }
    function map(f, a) {
        var l = a.length - 1;
        if (0 === l) return [
            0
        ];
        var r = caml_make_vect(l, caml_call1(f, a[1])), _am_ = l - 1 | 0, _al_ = 1;
        if (_am_ >= 1) {
            var i = _al_;
            for(;;){
                r[1 + i] = caml_call1(f, a[1 + i]);
                var _an_ = i + 1 | 0;
                if (_am_ === i) break;
                i = _an_;
            }
        }
        return r;
    }
    function map_inplace(f, a) {
        var _aj_ = a.length - 2 | 0, _ai_ = 0;
        if (_aj_ >= 0) {
            var i = _ai_;
            for(;;){
                a[1 + i] = caml_call1(f, a[1 + i]);
                var _ak_ = i + 1 | 0;
                if (_aj_ === i) break;
                i = _ak_;
            }
        }
        return 0;
    }
    function mapi_inplace(f, a) {
        var _ag_ = a.length - 2 | 0, _af_ = 0;
        if (_ag_ >= 0) {
            var i = _af_;
            for(;;){
                a[1 + i] = caml_call2(f, i, a[1 + i]);
                var _ah_ = i + 1 | 0;
                if (_ag_ === i) break;
                i = _ah_;
            }
        }
        return 0;
    }
    function map2(f, a, b) {
        var la = a.length - 1, lb = b.length - 1;
        if (la !== lb) return caml_call1(Stdlib[1], cst_Array_map2_arrays_must_hav);
        if (0 === la) return [
            0
        ];
        var r = caml_make_vect(la, caml_call2(f, a[1], b[1])), _ad_ = la - 1 | 0, _ac_ = 1;
        if (_ad_ >= 1) {
            var i = _ac_;
            for(;;){
                r[1 + i] = caml_call2(f, a[1 + i], b[1 + i]);
                var _ae_ = i + 1 | 0;
                if (_ad_ === i) break;
                i = _ae_;
            }
        }
        return r;
    }
    function iteri(f, a) {
        var _aa_ = a.length - 2 | 0, _$_ = 0;
        if (_aa_ >= 0) {
            var i = _$_;
            for(;;){
                caml_call2(f, i, a[1 + i]);
                var _ab_ = i + 1 | 0;
                if (_aa_ === i) break;
                i = _ab_;
            }
        }
        return 0;
    }
    function mapi(f, a) {
        var l = a.length - 1;
        if (0 === l) return [
            0
        ];
        var r = caml_make_vect(l, caml_call2(f, 0, a[1])), _Z_ = l - 1 | 0, _Y_ = 1;
        if (_Z_ >= 1) {
            var i = _Y_;
            for(;;){
                r[1 + i] = caml_call2(f, i, a[1 + i]);
                var ___ = i + 1 | 0;
                if (_Z_ === i) break;
                i = ___;
            }
        }
        return r;
    }
    function to_list(a) {
        var i$1 = a.length - 2 | 0, i = i$1, res = 0;
        for(;;){
            if (0 > i) return res;
            var res$0 = [
                0,
                a[1 + i],
                res
            ], i$0 = i - 1 | 0;
            i = i$0;
            res = res$0;
        }
    }
    function list_length(accu, param) {
        var accu$0 = accu, param$0 = param;
        for(;;){
            if (!param$0) return accu$0;
            var t = param$0[2], accu$1 = accu$0 + 1 | 0;
            accu$0 = accu$1;
            param$0 = t;
        }
    }
    function of_list(l) {
        if (!l) return [
            0
        ];
        var tl = l[2], hd = l[1], a = caml_make_vect(list_length(0, l), hd), i = 1, param = tl;
        for(;;){
            if (!param) return a;
            var tl$0 = param[2], hd$0 = param[1];
            a[1 + i] = hd$0;
            var i$0 = i + 1 | 0;
            i = i$0;
            param = tl$0;
        }
    }
    function fold_left(f, x, a) {
        var r = [
            0,
            x
        ], _W_ = a.length - 2 | 0, _V_ = 0;
        if (_W_ >= 0) {
            var i = _V_;
            for(;;){
                r[1] = caml_call2(f, r[1], a[1 + i]);
                var _X_ = i + 1 | 0;
                if (_W_ === i) break;
                i = _X_;
            }
        }
        return r[1];
    }
    function fold_left_map(f, acc, input_array) {
        var len = input_array.length - 1;
        if (0 === len) return [
            0,
            acc,
            [
                0
            ]
        ];
        var match = caml_call2(f, acc, input_array[1]), elt = match[2], acc$0 = match[1], output_array = caml_make_vect(len, elt), acc$1 = [
            0,
            acc$0
        ], _T_1 = len - 1 | 0, _S_ = 1;
        if (_T_1 >= 1) {
            var i = _S_;
            for(;;){
                var match$0 = caml_call2(f, acc$1[1], input_array[1 + i]), elt$0 = match$0[2], acc$2 = match$0[1];
                acc$1[1] = acc$2;
                output_array[1 + i] = elt$0;
                var _U_ = i + 1 | 0;
                if (_T_1 === i) break;
                i = _U_;
            }
        }
        return [
            0,
            acc$1[1],
            output_array
        ];
    }
    function fold_right(f, a, x) {
        var r = [
            0,
            x
        ], _Q_ = a.length - 2 | 0;
        if (_Q_ >= 0) {
            var i = _Q_;
            for(;;){
                r[1] = caml_call2(f, a[1 + i], r[1]);
                var _R_ = i - 1 | 0;
                if (0 === i) break;
                i = _R_;
            }
        }
        return r[1];
    }
    function exists(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (caml_call1(p, a[1 + i])) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function for_all(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 1;
            if (!caml_call1(p, a[1 + i])) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function for_all2(p, l1, l2) {
        var n1 = l1.length - 1, n2 = l2.length - 1;
        if (n1 !== n2) return caml_call1(Stdlib[1], cst_Array_for_all2);
        var i = 0;
        for(;;){
            if (i === n1) return 1;
            if (!caml_call2(p, l1[1 + i], l2[1 + i])) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function exists2(p, l1, l2) {
        var n1 = l1.length - 1, n2 = l2.length - 1;
        if (n1 !== n2) return caml_call1(Stdlib[1], cst_Array_exists2);
        var i = 0;
        for(;;){
            if (i === n1) return 0;
            if (caml_call2(p, l1[1 + i], l2[1 + i])) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function mem(x, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (0 === runtime.caml_compare(a[1 + i], x)) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function memq(x, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (x === a[1 + i]) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_opt(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var x = a[1 + i];
            if (caml_call1(p, x)) return [
                0,
                x
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_index(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (caml_call1(p, a[1 + i])) return [
                0,
                i
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_map(f, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var r = caml_call1(f, a[1 + i]);
            if (r) return r;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_mapi(f, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var r = caml_call2(f, i, a[1 + i]);
            if (r) return r;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function split(x) {
        if (runtime.caml_equal(x, [
            0
        ])) return [
            0,
            [
                0
            ],
            [
                0
            ]
        ];
        var match = x[1], b0 = match[2], a0 = match[1], n = x.length - 1, a = caml_make_vect(n, a0), b = caml_make_vect(n, b0), _O_ = n - 1 | 0, _N_ = 1;
        if (_O_ >= 1) {
            var i = _N_;
            for(;;){
                var match$0 = x[1 + i], bi = match$0[2], ai = match$0[1];
                a[1 + i] = ai;
                b[1 + i] = bi;
                var _P_ = i + 1 | 0;
                if (_O_ === i) break;
                i = _P_;
            }
        }
        return [
            0,
            a,
            b
        ];
    }
    function combine(a, b) {
        var na = a.length - 1, nb = b.length - 1;
        if (na !== nb) caml_call1(Stdlib[1], cst_Array_combine);
        if (0 === na) return [
            0
        ];
        var x = caml_make_vect(na, [
            0,
            a[1],
            b[1]
        ]), _L_ = na - 1 | 0, _K_ = 1;
        if (_L_ >= 1) {
            var i = _K_;
            for(;;){
                x[1 + i] = [
                    0,
                    a[1 + i],
                    b[1 + i]
                ];
                var _M_ = i + 1 | 0;
                if (_L_ === i) break;
                i = _M_;
            }
        }
        return x;
    }
    var Bottom = [
        248,
        "Stdlib.Array.Bottom",
        runtime.caml_fresh_oo_id(0)
    ], _a_ = [
        0,
        "array.ml",
        369,
        4
    ];
    function sort(cmp, a) {
        function maxson(l, i) {
            var i31 = ((i + i | 0) + i | 0) + 1 | 0, x = [
                0,
                i31
            ];
            if ((i31 + 2 | 0) < l) {
                var _D_ = i31 + 1 | 0, _E_ = caml_check_bound(a, _D_)[1 + _D_];
                if (caml_call2(cmp, caml_check_bound(a, i31)[1 + i31], _E_) < 0) x[1] = i31 + 1 | 0;
                var _F_ = i31 + 2 | 0, _G_ = caml_check_bound(a, _F_)[1 + _F_], _H_ = x[1];
                if (caml_call2(cmp, caml_check_bound(a, _H_)[1 + _H_], _G_) < 0) x[1] = i31 + 2 | 0;
                return x[1];
            }
            if ((i31 + 1 | 0) < l) {
                var _I_ = i31 + 1 | 0, _J_ = caml_check_bound(a, _I_)[1 + _I_];
                if (0 > caml_call2(cmp, caml_check_bound(a, i31)[1 + i31], _J_)) return i31 + 1 | 0;
            }
            if (i31 < l) return i31;
            throw caml_maybe_attach_backtrace([
                0,
                Bottom,
                i
            ], 1);
        }
        var l = a.length - 1, _x_ = ((l + 1 | 0) / 3 | 0) - 1 | 0;
        if (_x_ >= 0) {
            var i$6 = _x_;
            for(;;){
                var e$1 = caml_check_bound(a, i$6)[1 + i$6];
                try {
                    var i = i$6;
                    for(;;){
                        var j = maxson(l, i);
                        if (0 >= caml_call2(cmp, caml_check_bound(a, j)[1 + j], e$1)) break;
                        var _u_ = caml_check_bound(a, j)[1 + j];
                        caml_check_bound(a, i)[1 + i] = _u_;
                        i = j;
                    }
                    caml_check_bound(a, i)[1 + i] = e$1;
                } catch (exn$0) {
                    var exn = caml_wrap_exception(exn$0);
                    if (exn[1] !== Bottom) throw caml_maybe_attach_backtrace(exn, 0);
                    var i$0 = exn[2];
                    caml_check_bound(a, i$0)[1 + i$0] = e$1;
                }
                var _C_ = i$6 - 1 | 0;
                if (0 === i$6) break;
                i$6 = _C_;
            }
        }
        var _y_ = l - 1 | 0;
        if (_y_ >= 2) {
            var i$4 = _y_;
            for(;;){
                var e$0 = caml_check_bound(a, i$4)[1 + i$4];
                a[1 + i$4] = caml_check_bound(a, 0)[1];
                var i$5 = 0;
                try {
                    var i$1 = i$5;
                    for(;;){
                        var j$0 = maxson(i$4, i$1), _v_ = caml_check_bound(a, j$0)[1 + j$0];
                        caml_check_bound(a, i$1)[1 + i$1] = _v_;
                        i$1 = j$0;
                    }
                } catch (exn) {
                    var exn$0 = caml_wrap_exception(exn);
                    if (exn$0[1] !== Bottom) throw caml_maybe_attach_backtrace(exn$0, 0);
                    var i$2 = exn$0[2];
                    a: {
                        b: {
                            var i$3 = i$2;
                            for(;;){
                                var father = (i$3 - 1 | 0) / 3 | 0;
                                if (i$3 === father) throw caml_maybe_attach_backtrace([
                                    0,
                                    Assert_failure,
                                    _a_
                                ], 1);
                                if (0 <= caml_call2(cmp, caml_check_bound(a, father)[1 + father], e$0)) break;
                                var _w_ = caml_check_bound(a, father)[1 + father];
                                caml_check_bound(a, i$3)[1 + i$3] = _w_;
                                if (0 >= father) break b;
                                i$3 = father;
                            }
                            caml_check_bound(a, i$3)[1 + i$3] = e$0;
                            break a;
                        }
                        caml_check_bound(a, 0)[1] = e$0;
                    }
                    var _B_ = i$4 - 1 | 0;
                    if (2 === i$4) break;
                    i$4 = _B_;
                }
            }
        }
        var _z_ = 1 < l ? 1 : 0;
        if (_z_) {
            var e = caml_check_bound(a, 1)[2];
            a[2] = caml_check_bound(a, 0)[1];
            a[1] = e;
            var _A_ = 0;
        } else var _A_ = _z_;
        return _A_;
    }
    function stable_sort(cmp, a) {
        function merge(src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs) {
            var src1r = src1ofs + src1len | 0, src2r = src2ofs + src2len | 0, s2$1 = caml_check_bound(src2, src2ofs)[1 + src2ofs], s1$1 = caml_check_bound(a, src1ofs)[1 + src1ofs], i1 = src1ofs, s1 = s1$1, i2 = src2ofs, s2 = s2$1, d = dstofs;
            for(;;)if (0 < caml_call2(cmp, s1, s2)) {
                caml_check_bound(dst, d)[1 + d] = s2;
                var i2$0 = i2 + 1 | 0;
                if (i2$0 >= src2r) return blit(a, i1, dst, d + 1 | 0, src1r - i1 | 0);
                var d$0 = d + 1 | 0, s2$0 = caml_check_bound(src2, i2$0)[1 + i2$0];
                i2 = i2$0;
                s2 = s2$0;
                d = d$0;
            } else {
                caml_check_bound(dst, d)[1 + d] = s1;
                var i1$0 = i1 + 1 | 0;
                if (i1$0 >= src1r) return blit(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
                var d$1 = d + 1 | 0, s1$0 = caml_check_bound(a, i1$0)[1 + i1$0];
                i1 = i1$0;
                s1 = s1$0;
                d = d$1;
            }
        }
        function isortto(srcofs, dst, dstofs, len) {
            var _m_ = len - 1 | 0, _l_ = 0;
            if (_m_ >= 0) {
                var i = _l_;
                for(;;){
                    var _n_ = srcofs + i | 0, e = caml_check_bound(a, _n_)[1 + _n_], j = [
                        0,
                        (dstofs + i | 0) - 1 | 0
                    ];
                    for(;;){
                        if (dstofs > j[1]) break;
                        var _o_ = j[1];
                        if (0 >= caml_call2(cmp, caml_check_bound(dst, _o_)[1 + _o_], e)) break;
                        var _p_ = j[1], _q_ = caml_check_bound(dst, _p_)[1 + _p_], _r_ = j[1] + 1 | 0;
                        caml_check_bound(dst, _r_)[1 + _r_] = _q_;
                        j[1]--;
                    }
                    var _s_ = j[1] + 1 | 0;
                    caml_check_bound(dst, _s_)[1 + _s_] = e;
                    var _t_ = i + 1 | 0;
                    if (_m_ === i) break;
                    i = _t_;
                }
            }
            return 0;
        }
        function sortto(srcofs, dst, dstofs, len) {
            if (len <= 5) return isortto(srcofs, dst, dstofs, len);
            var l1 = len / 2 | 0, l2 = len - l1 | 0;
            sortto(srcofs + l1 | 0, dst, dstofs + l1 | 0, l2);
            sortto(srcofs, a, srcofs + l2 | 0, l1);
            return merge(srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs);
        }
        var l = a.length - 1;
        if (l <= 5) return isortto(0, a, 0, l);
        var l1 = l / 2 | 0, l2 = l - l1 | 0, t = caml_make_vect(l2, caml_check_bound(a, 0)[1]);
        sortto(l1, t, 0, l2);
        sortto(0, a, l2, l1);
        return merge(l2, l1, t, 0, l2, a, 0);
    }
    function shuffle(rand, a) {
        var _j_ = a.length - 2 | 0;
        if (_j_ >= 1) {
            var i = _j_;
            for(;;){
                var j = caml_call1(rand, i + 1 | 0), v = a[1 + i];
                a[1 + i] = caml_check_bound(a, j)[1 + j];
                a[1 + j] = v;
                var _k_ = i - 1 | 0;
                if (1 === i) break;
                i = _k_;
            }
        }
        return 0;
    }
    function to_seq(a) {
        function aux(i, param) {
            if (i >= a.length - 1) return 0;
            var x = a[1 + i], _h_ = i + 1 | 0;
            return [
                0,
                x,
                function(_i_) {
                    return aux(_h_, _i_);
                }
            ];
        }
        var _f_ = 0;
        return function(_g_) {
            return aux(_f_, _g_);
        };
    }
    function to_seqi(a) {
        function aux(i, param) {
            if (i >= a.length - 1) return 0;
            var x = a[1 + i], _d_ = i + 1 | 0;
            return [
                0,
                [
                    0,
                    i,
                    x
                ],
                function(_e_) {
                    return aux(_d_, _e_);
                }
            ];
        }
        var _b_ = 0;
        return function(_c_) {
            return aux(_b_, _c_);
        };
    }
    function of_seq(i$2) {
        var l = caml_call3(Stdlib_Seq[5], function(acc, x) {
            return [
                0,
                x,
                acc
            ];
        }, 0, i$2);
        if (!l) return [
            0
        ];
        var tl = l[2], hd = l[1], len = list_length(0, l), a = caml_make_vect(len, hd), i$1 = len - 2 | 0, i = i$1, param = tl;
        for(;;){
            if (!param) return a;
            var tl$0 = param[2], hd$0 = param[1];
            a[1 + i] = hd$0;
            var i$0 = i - 1 | 0;
            i = i$0;
            param = tl$0;
        }
    }
    var Stdlib_Array = [
        0,
        init,
        make_matrix,
        init_matrix,
        append,
        runtime.caml_array_concat,
        sub,
        copy,
        fill,
        blit,
        to_list,
        of_list,
        iter,
        iteri,
        map,
        map_inplace,
        mapi,
        mapi_inplace,
        fold_left,
        fold_left_map,
        fold_right,
        iter2,
        map2,
        for_all,
        exists,
        for_all2,
        exists2,
        mem,
        memq,
        find_opt,
        find_index,
        find_map,
        find_mapi,
        split,
        combine,
        sort,
        stable_sort,
        stable_sort,
        shuffle,
        to_seq,
        to_seqi,
        of_seq,
        Floatarray
    ];
    runtime.caml_register_global(16, Stdlib_Array, "Stdlib__Array");
    return;
})(globalThis);
//# 6405 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Float_array_blit$1 = "Float.array.blit", cst_float_ml = "float.ml", caml_array_get = runtime.caml_array_get, caml_array_set = runtime.caml_array_set, caml_float_compare = runtime.caml_float_compare, caml_floatarray_blit = runtime.caml_floatarray_blit, caml_floatarray_create = runtime.caml_floatarray_create, caml_hash = runtime.caml_hash, caml_make_vect = runtime.caml_make_vect, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_nextafter_float = runtime.caml_nextafter_float, caml_signbit_float = runtime.caml_signbit_float, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_List = global_data.Stdlib__List, Assert_failure = global_data.Assert_failure, Stdlib = global_data.Stdlib, infinity = Stdlib[22], neg_infinity = Stdlib[23], nan = Stdlib[24], signaling_nan = runtime.caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(1, 0, 32752));
    function is_finite(x) {
        return x - x == 0. ? 1 : 0;
    }
    function is_infinite(x) {
        return 1. / x == 0. ? 1 : 0;
    }
    function is_nan(x) {
        return x != x ? 1 : 0;
    }
    var max_float = Stdlib[25], min_float = Stdlib[26], epsilon = Stdlib[27], of_string_opt = Stdlib[36], to_string = Stdlib[35], cst_Float_Array_init = "Float.Array.init", cst_Float_Array_make_matrix = "Float.Array.make_matrix", cst_Float_Array_init_matrix = "Float.Array.init_matrix", cst_Float_Array_concat = "Float.Array.concat", _a_ = [
        0,
        cst_float_ml,
        254,
        14
    ], cst_Float_Array_sub = "Float.Array.sub", cst_Float_Array_fill = "Float.Array.fill", cst_Float_array_blit = cst_Float_array_blit$1, cst_Float_array_blit$0 = cst_Float_array_blit$1, cst_Float_Array_iter2_arrays_m = "Float.Array.iter2: arrays must have the same length", cst_Float_Array_map2_arrays_mu = "Float.Array.map2: arrays must have the same length";
    function is_integer(x) {
        var _ax_ = x == runtime.caml_trunc_float(x) ? 1 : 0;
        return _ax_ ? is_finite(x) : _ax_;
    }
    function succ(x) {
        return caml_nextafter_float(x, infinity);
    }
    function pred(x) {
        return caml_nextafter_float(x, neg_infinity);
    }
    function equal(x, y) {
        return 0 === caml_float_compare(x, y) ? 1 : 0;
    }
    function min(x, y) {
        a: if (!(x < y)) {
            if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
            return x != x ? x : y;
        }
        return y != y ? y : x;
    }
    function max(x, y) {
        a: if (!(x < y)) {
            if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
            return y != y ? y : x;
        }
        return x != x ? x : y;
    }
    function min_max(x, y) {
        if (x == x && y == y) {
            a: if (!(x < y)) {
                if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
                return [
                    0,
                    y,
                    x
                ];
            }
            return [
                0,
                x,
                y
            ];
        }
        return [
            0,
            nan,
            nan
        ];
    }
    function min_num(x, y) {
        a: if (!(x < y)) {
            if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
            return y != y ? x : y;
        }
        return x != x ? y : x;
    }
    function max_num(x, y) {
        a: if (!(x < y)) {
            if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
            return x != x ? y : x;
        }
        return y != y ? x : y;
    }
    function min_max_num(x, y) {
        if (x != x) return [
            0,
            y,
            y
        ];
        if (y != y) return [
            0,
            x,
            x
        ];
        a: if (!(x < y)) {
            if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
            return [
                0,
                y,
                x
            ];
        }
        return [
            0,
            x,
            y
        ];
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    function unsafe_fill(a, ofs, len, v) {
        var _av_ = (ofs + len | 0) - 1 | 0;
        if (_av_ >= ofs) {
            var i = ofs;
            for(;;){
                a[1 + i] = v;
                var _aw_ = i + 1 | 0;
                if (_av_ === i) break;
                i = _aw_;
            }
        }
        return 0;
    }
    function check(a, ofs, len, msg) {
        var _ar_ = ofs < 0 ? 1 : 0;
        if (_ar_) var _as_ = _ar_;
        else {
            var _at_ = len < 0 ? 1 : 0;
            if (_at_) var _as_ = _at_;
            else var _au_ = (ofs + len | 0) < 0 ? 1 : 0, _as_ = _au_ || (a.length - 1 < (ofs + len | 0) ? 1 : 0);
        }
        return _as_ ? caml_call1(Stdlib[1], msg) : _as_;
    }
    function make(n, v) {
        var result = caml_floatarray_create(n);
        unsafe_fill(result, 0, n, v);
        return result;
    }
    function init(l, f) {
        if (0 > l) return caml_call1(Stdlib[1], cst_Float_Array_init);
        var res = caml_floatarray_create(l), _ap_ = l - 1 | 0, _ao_ = 0;
        if (_ap_ >= 0) {
            var i = _ao_;
            for(;;){
                res[1 + i] = caml_call1(f, i);
                var _aq_ = i + 1 | 0;
                if (_ap_ === i) break;
                i = _aq_;
            }
        }
        return res;
    }
    function make_matrix(sx, sy, v) {
        if (sy < 0) caml_call1(Stdlib[1], cst_Float_Array_make_matrix);
        var res = caml_make_vect(sx, caml_floatarray_create(0));
        if (0 < sy) {
            var _am_ = sx - 1 | 0, _al_ = 0;
            if (_am_ >= 0) {
                var x = _al_;
                for(;;){
                    res[1 + x] = make(sy, v);
                    var _an_ = x + 1 | 0;
                    if (_am_ === x) break;
                    x = _an_;
                }
            }
        }
        return res;
    }
    function init_matrix(sx, sy, f) {
        if (sy < 0) caml_call1(Stdlib[1], cst_Float_Array_init_matrix);
        var res = caml_make_vect(sx, caml_floatarray_create(0));
        if (0 < sy) {
            var _ag_ = sx - 1 | 0, _af_ = 0;
            if (_ag_ >= 0) {
                var x = _af_;
                for(;;){
                    var row = caml_floatarray_create(sy), _ai_ = sy - 1 | 0, _ah_ = 0;
                    if (_ai_ >= 0) {
                        var y = _ah_;
                        for(;;){
                            row[1 + y] = caml_call2(f, x, y);
                            var _ak_ = y + 1 | 0;
                            if (_ai_ === y) break;
                            y = _ak_;
                        }
                    }
                    res[1 + x] = row;
                    var _aj_ = x + 1 | 0;
                    if (_ag_ === x) break;
                    x = _aj_;
                }
            }
        }
        return res;
    }
    function append(a1, a2) {
        var l1 = a1.length - 1, l2 = a2.length - 1, result = caml_floatarray_create(l1 + l2 | 0);
        caml_floatarray_blit(a1, 0, result, 0, l1);
        caml_floatarray_blit(a2, 0, result, l1, l2);
        return result;
    }
    function concat(l) {
        var acc = 0, param = l;
        for(;;){
            if (!param) break;
            var tl = param[2], hd = param[1], x = hd.length - 1 + acc | 0, acc$0 = acc <= x ? x : caml_call1(Stdlib[1], cst_Float_Array_concat);
            acc = acc$0;
            param = tl;
        }
        var result = caml_floatarray_create(acc), l$0 = l, i = 0;
        for(;;){
            if (!l$0) {
                if (i === acc) return result;
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _a_
                ], 1);
            }
            var tl$0 = l$0[2], hd$0 = l$0[1], hlen = hd$0.length - 1;
            caml_floatarray_blit(hd$0, 0, result, i, hlen);
            var i$0 = i + hlen | 0;
            l$0 = tl$0;
            i = i$0;
        }
    }
    function sub(a, ofs, len) {
        check(a, ofs, len, cst_Float_Array_sub);
        var result = caml_floatarray_create(len);
        caml_floatarray_blit(a, ofs, result, 0, len);
        return result;
    }
    function copy(a) {
        var l = a.length - 1, result = caml_floatarray_create(l);
        caml_floatarray_blit(a, 0, result, 0, l);
        return result;
    }
    function fill(a, ofs, len, v) {
        check(a, ofs, len, cst_Float_Array_fill);
        return unsafe_fill(a, ofs, len, v);
    }
    function blit(src, sofs, dst, dofs, len) {
        check(src, sofs, len, cst_Float_array_blit);
        check(dst, dofs, len, cst_Float_array_blit$0);
        return caml_floatarray_blit(src, sofs, dst, dofs, len);
    }
    function to_list(a) {
        return caml_call2(Stdlib_List[11], a.length - 1, function(_ae_) {
            return a[1 + _ae_];
        });
    }
    function of_list(l) {
        var result = caml_floatarray_create(caml_call1(Stdlib_List[1], l)), i = 0, l$0 = l;
        for(;;){
            if (!l$0) return result;
            var t = l$0[2], h = l$0[1];
            result[1 + i] = h;
            var i$0 = i + 1 | 0;
            i = i$0;
            l$0 = t;
        }
    }
    function iter(f, a) {
        var _ac_ = a.length - 2 | 0, _ab_ = 0;
        if (_ac_ >= 0) {
            var i = _ab_;
            for(;;){
                caml_call1(f, a[1 + i]);
                var _ad_ = i + 1 | 0;
                if (_ac_ === i) break;
                i = _ad_;
            }
        }
        return 0;
    }
    function iter2(f, a, b) {
        if (a.length - 1 !== b.length - 1) return caml_call1(Stdlib[1], cst_Float_Array_iter2_arrays_m);
        var _$_ = a.length - 2 | 0, ___ = 0;
        if (_$_ >= 0) {
            var i = ___;
            for(;;){
                caml_call2(f, a[1 + i], b[1 + i]);
                var _aa_ = i + 1 | 0;
                if (_$_ === i) break;
                i = _aa_;
            }
        }
        return 0;
    }
    function map(f, a) {
        var l = a.length - 1, r = caml_floatarray_create(l), _Y_ = l - 1 | 0, _X_ = 0;
        if (_Y_ >= 0) {
            var i = _X_;
            for(;;){
                r[1 + i] = caml_call1(f, a[1 + i]);
                var _Z_ = i + 1 | 0;
                if (_Y_ === i) break;
                i = _Z_;
            }
        }
        return r;
    }
    function map_inplace(f, a) {
        var _V_ = a.length - 2 | 0, _U_ = 0;
        if (_V_ >= 0) {
            var i = _U_;
            for(;;){
                a[1 + i] = caml_call1(f, a[1 + i]);
                var _W_ = i + 1 | 0;
                if (_V_ === i) break;
                i = _W_;
            }
        }
        return 0;
    }
    function map2(f, a, b) {
        var la = a.length - 1, lb = b.length - 1;
        if (la !== lb) return caml_call1(Stdlib[1], cst_Float_Array_map2_arrays_mu);
        var r = caml_floatarray_create(la), _S_ = la - 1 | 0, _R_ = 0;
        if (_S_ >= 0) {
            var i = _R_;
            for(;;){
                r[1 + i] = caml_call2(f, a[1 + i], b[1 + i]);
                var _T_1 = i + 1 | 0;
                if (_S_ === i) break;
                i = _T_1;
            }
        }
        return r;
    }
    function iteri(f, a) {
        var _P_ = a.length - 2 | 0, _O_ = 0;
        if (_P_ >= 0) {
            var i = _O_;
            for(;;){
                caml_call2(f, i, a[1 + i]);
                var _Q_ = i + 1 | 0;
                if (_P_ === i) break;
                i = _Q_;
            }
        }
        return 0;
    }
    function mapi(f, a) {
        var l = a.length - 1, r = caml_floatarray_create(l), _M_ = l - 1 | 0, _L_ = 0;
        if (_M_ >= 0) {
            var i = _L_;
            for(;;){
                r[1 + i] = caml_call2(f, i, a[1 + i]);
                var _N_ = i + 1 | 0;
                if (_M_ === i) break;
                i = _N_;
            }
        }
        return r;
    }
    function mapi_inplace(f, a) {
        var _J_ = a.length - 2 | 0, _I_ = 0;
        if (_J_ >= 0) {
            var i = _I_;
            for(;;){
                a[1 + i] = caml_call2(f, i, a[1 + i]);
                var _K_ = i + 1 | 0;
                if (_J_ === i) break;
                i = _K_;
            }
        }
        return 0;
    }
    function fold_left(f, x, a) {
        var r = [
            0,
            x
        ], _G_ = a.length - 2 | 0, _F_ = 0;
        if (_G_ >= 0) {
            var i = _F_;
            for(;;){
                r[1] = caml_call2(f, r[1], a[1 + i]);
                var _H_ = i + 1 | 0;
                if (_G_ === i) break;
                i = _H_;
            }
        }
        return r[1];
    }
    function fold_right(f, a, x) {
        var r = [
            0,
            x
        ], _D_ = a.length - 2 | 0;
        if (_D_ >= 0) {
            var i = _D_;
            for(;;){
                r[1] = caml_call2(f, a[1 + i], r[1]);
                var _E_ = i - 1 | 0;
                if (0 === i) break;
                i = _E_;
            }
        }
        return r[1];
    }
    function exists(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (caml_call1(p, a[1 + i])) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function for_all(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 1;
            if (!caml_call1(p, a[1 + i])) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function mem(x, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (0 === caml_float_compare(a[1 + i], x)) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function mem_ieee(x, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (x == a[1 + i]) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_opt(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var x = a[1 + i];
            if (caml_call1(p, x)) return [
                0,
                x
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_index(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (caml_call1(p, a[1 + i])) return [
                0,
                i
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_map(f, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var r = caml_call1(f, a[1 + i]);
            if (r) return r;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_mapi(f, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var r = caml_call2(f, i, a[1 + i]);
            if (r) return r;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    var Bottom = [
        248,
        "Stdlib.Float.Array.Bottom",
        runtime.caml_fresh_oo_id(0)
    ], _b_ = [
        0,
        cst_float_ml,
        484,
        6
    ];
    function sort(cmp, a) {
        function maxson(l, i) {
            var i31 = ((i + i | 0) + i | 0) + 1 | 0, x = [
                0,
                i31
            ];
            if ((i31 + 2 | 0) < l) {
                if (caml_call2(cmp, caml_array_get(a, i31), caml_array_get(a, i31 + 1 | 0)) < 0) x[1] = i31 + 1 | 0;
                if (caml_call2(cmp, caml_array_get(a, x[1]), caml_array_get(a, i31 + 2 | 0)) < 0) x[1] = i31 + 2 | 0;
                return x[1];
            }
            if ((i31 + 1 | 0) < l && 0 > caml_call2(cmp, caml_array_get(a, i31), caml_array_get(a, i31 + 1 | 0))) return i31 + 1 | 0;
            if (i31 < l) return i31;
            throw caml_maybe_attach_backtrace([
                0,
                Bottom,
                i
            ], 1);
        }
        var l = a.length - 1, _x_ = ((l + 1 | 0) / 3 | 0) - 1 | 0;
        if (_x_ >= 0) {
            var i$6 = _x_;
            for(;;){
                var e$1 = caml_array_get(a, i$6);
                try {
                    var i = i$6;
                    for(;;){
                        var j = maxson(l, i);
                        if (0 >= caml_call2(cmp, caml_array_get(a, j), e$1)) break;
                        caml_array_set(a, i, caml_array_get(a, j));
                        i = j;
                    }
                    caml_array_set(a, i, e$1);
                } catch (exn$0) {
                    var exn = caml_wrap_exception(exn$0);
                    if (exn[1] !== Bottom) throw caml_maybe_attach_backtrace(exn, 0);
                    var i$0 = exn[2];
                    caml_array_set(a, i$0, e$1);
                }
                var _C_ = i$6 - 1 | 0;
                if (0 === i$6) break;
                i$6 = _C_;
            }
        }
        var _y_ = l - 1 | 0;
        if (_y_ >= 2) {
            var i$4 = _y_;
            for(;;){
                var e$0 = caml_array_get(a, i$4);
                caml_array_set(a, i$4, caml_array_get(a, 0));
                var i$5 = 0;
                try {
                    var i$1 = i$5;
                    for(;;){
                        var j$0 = maxson(i$4, i$1);
                        caml_array_set(a, i$1, caml_array_get(a, j$0));
                        i$1 = j$0;
                    }
                } catch (exn) {
                    var exn$0 = caml_wrap_exception(exn);
                    if (exn$0[1] !== Bottom) throw caml_maybe_attach_backtrace(exn$0, 0);
                    var i$2 = exn$0[2];
                    a: {
                        b: {
                            var i$3 = i$2;
                            for(;;){
                                var father = (i$3 - 1 | 0) / 3 | 0;
                                if (i$3 === father) throw caml_maybe_attach_backtrace([
                                    0,
                                    Assert_failure,
                                    _b_
                                ], 1);
                                if (0 <= caml_call2(cmp, caml_array_get(a, father), e$0)) break;
                                caml_array_set(a, i$3, caml_array_get(a, father));
                                if (0 >= father) break b;
                                i$3 = father;
                            }
                            caml_array_set(a, i$3, e$0);
                            break a;
                        }
                        caml_array_set(a, 0, e$0);
                    }
                    var _B_ = i$4 - 1 | 0;
                    if (2 === i$4) break;
                    i$4 = _B_;
                }
            }
        }
        var _z_ = 1 < l ? 1 : 0;
        if (_z_) {
            var e = caml_array_get(a, 1);
            caml_array_set(a, 1, caml_array_get(a, 0));
            var _A_ = caml_array_set(a, 0, e);
        } else var _A_ = _z_;
        return _A_;
    }
    function stable_sort(cmp, a) {
        function merge(src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs) {
            var src1r = src1ofs + src1len | 0, src2r = src2ofs + src2len | 0, s2$1 = caml_array_get(src2, src2ofs), s1$1 = caml_array_get(a, src1ofs), i1 = src1ofs, s1 = s1$1, i2 = src2ofs, s2 = s2$1, d = dstofs;
            for(;;)if (0 < caml_call2(cmp, s1, s2)) {
                caml_array_set(dst, d, s2);
                var i2$0 = i2 + 1 | 0;
                if (i2$0 >= src2r) return blit(a, i1, dst, d + 1 | 0, src1r - i1 | 0);
                var d$0 = d + 1 | 0, s2$0 = caml_array_get(src2, i2$0);
                i2 = i2$0;
                s2 = s2$0;
                d = d$0;
            } else {
                caml_array_set(dst, d, s1);
                var i1$0 = i1 + 1 | 0;
                if (i1$0 >= src1r) return blit(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
                var d$1 = d + 1 | 0, s1$0 = caml_array_get(a, i1$0);
                i1 = i1$0;
                s1 = s1$0;
                d = d$1;
            }
        }
        function isortto(srcofs, dst, dstofs, len) {
            var _v_ = len - 1 | 0, _u_ = 0;
            if (_v_ >= 0) {
                var i = _u_;
                for(;;){
                    var e = caml_array_get(a, srcofs + i | 0), j = [
                        0,
                        (dstofs + i | 0) - 1 | 0
                    ];
                    for(;;){
                        if (dstofs > j[1]) break;
                        if (0 >= caml_call2(cmp, caml_array_get(dst, j[1]), e)) break;
                        caml_array_set(dst, j[1] + 1 | 0, caml_array_get(dst, j[1]));
                        j[1]--;
                    }
                    caml_array_set(dst, j[1] + 1 | 0, e);
                    var _w_ = i + 1 | 0;
                    if (_v_ === i) break;
                    i = _w_;
                }
            }
            return 0;
        }
        function sortto(srcofs, dst, dstofs, len) {
            if (len <= 5) return isortto(srcofs, dst, dstofs, len);
            var l1 = len / 2 | 0, l2 = len - l1 | 0;
            sortto(srcofs + l1 | 0, dst, dstofs + l1 | 0, l2);
            sortto(srcofs, a, srcofs + l2 | 0, l1);
            return merge(srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs);
        }
        var l = a.length - 1;
        if (l <= 5) return isortto(0, a, 0, l);
        var l1 = l / 2 | 0, l2 = l - l1 | 0, t = caml_floatarray_create(l2);
        sortto(l1, t, 0, l2);
        sortto(0, a, l2, l1);
        return merge(l2, l1, t, 0, l2, a, 0);
    }
    function shuffle(rand, a) {
        var _s_ = a.length - 2 | 0;
        if (_s_ >= 1) {
            var i = _s_;
            for(;;){
                var j = caml_call1(rand, i + 1 | 0), v = a[1 + i];
                a[1 + i] = caml_array_get(a, j);
                a[1 + j] = v;
                var _t_ = i - 1 | 0;
                if (1 === i) break;
                i = _t_;
            }
        }
        return 0;
    }
    function to_seq(a) {
        function aux(i, param) {
            if (i >= a.length - 1) return 0;
            var x = a[1 + i], _q_ = i + 1 | 0;
            return [
                0,
                x,
                function(_r_) {
                    return aux(_q_, _r_);
                }
            ];
        }
        var _o_ = 0;
        return function(_p_) {
            return aux(_o_, _p_);
        };
    }
    function to_seqi(a) {
        function aux(i, param) {
            if (i >= a.length - 1) return 0;
            var x = a[1 + i], _m_ = i + 1 | 0;
            return [
                0,
                [
                    0,
                    i,
                    x
                ],
                function(_n_) {
                    return aux(_m_, _n_);
                }
            ];
        }
        var _k_ = 0;
        return function(_l_) {
            return aux(_k_, _l_);
        };
    }
    function of_seq(i$2) {
        var l = caml_call3(Stdlib_Seq[5], function(acc, x) {
            return [
                0,
                x,
                acc
            ];
        }, 0, i$2), len = caml_call1(Stdlib_List[1], l), a = caml_floatarray_create(len), i$1 = len - 1 | 0, i = i$1, param = l;
        for(;;){
            if (!param) return a;
            var tl = param[2], hd = param[1];
            a[1 + i] = hd;
            var i$0 = i - 1 | 0;
            i = i$0;
            param = tl;
        }
    }
    function map_to_array(f, a) {
        var l = a.length - 1;
        if (0 === l) return [
            0
        ];
        var r = caml_make_vect(l, caml_call1(f, a[1])), _i_ = l - 1 | 0, _h_ = 1;
        if (_i_ >= 1) {
            var i = _h_;
            for(;;){
                r[1 + i] = caml_call1(f, a[1 + i]);
                var _j_ = i + 1 | 0;
                if (_i_ === i) break;
                i = _j_;
            }
        }
        return r;
    }
    function map_from_array(f, a) {
        var l = a.length - 1, r = caml_floatarray_create(l), _f_ = l - 1 | 0, _e_ = 0;
        if (_f_ >= 0) {
            var i = _e_;
            for(;;){
                r[1 + i] = caml_call1(f, a[1 + i]);
                var _g_ = i + 1 | 0;
                if (_f_ === i) break;
                i = _g_;
            }
        }
        return r;
    }
    var Stdlib_Float = [
        0,
        0.,
        1.,
        -1,
        succ,
        pred,
        infinity,
        neg_infinity,
        nan,
        signaling_nan,
        nan,
        3.141592653589793,
        max_float,
        min_float,
        epsilon,
        is_finite,
        is_infinite,
        is_nan,
        is_integer,
        of_string_opt,
        to_string,
        caml_float_compare,
        equal,
        min,
        max,
        min_max,
        min_num,
        max_num,
        min_max_num,
        seeded_hash,
        hash,
        [
            0,
            function(_d_) {
                return _d_.length - 1;
            },
            caml_array_get,
            caml_array_set,
            make,
            caml_floatarray_create,
            init,
            make_matrix,
            init_matrix,
            append,
            concat,
            sub,
            copy,
            fill,
            blit,
            to_list,
            of_list,
            iter,
            iteri,
            map,
            map_inplace,
            mapi,
            mapi_inplace,
            fold_left,
            fold_right,
            iter2,
            map2,
            for_all,
            exists,
            mem,
            mem_ieee,
            find_opt,
            find_index,
            find_map,
            find_mapi,
            sort,
            stable_sort,
            stable_sort,
            shuffle,
            to_seq,
            to_seqi,
            of_seq,
            map_to_array,
            map_from_array
        ],
        [
            0,
            function(_c_) {
                return _c_.length - 1;
            },
            caml_array_get,
            caml_array_set,
            make,
            caml_floatarray_create,
            init,
            make_matrix,
            init_matrix,
            append,
            concat,
            sub,
            copy,
            fill,
            blit,
            to_list,
            of_list,
            iter,
            iteri,
            map,
            map_inplace,
            mapi,
            mapi_inplace,
            fold_left,
            fold_right,
            iter2,
            map2,
            for_all,
            exists,
            mem,
            mem_ieee,
            find_opt,
            find_index,
            find_map,
            find_mapi,
            sort,
            stable_sort,
            stable_sort,
            shuffle,
            to_seq,
            to_seqi,
            of_seq,
            map_to_array,
            map_from_array
        ]
    ];
    runtime.caml_register_global(25, Stdlib_Float, "Stdlib__Float");
    return;
})(globalThis);
//# 7308 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_greaterequal = runtime.caml_greaterequal, caml_hash = runtime.caml_hash, caml_int_compare = runtime.caml_int_compare, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_mul = runtime.caml_mul, caml_wrap_exception = runtime.caml_wrap_exception, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Sys = global_data.Stdlib__Sys, Assert_failure = global_data.Assert_failure, zero = 0, one = 1;
    function succ(n) {
        return n + 1 | 0;
    }
    function pred(n) {
        return n - 1 | 0;
    }
    function abs(n) {
        return caml_greaterequal(n, 0) ? n : -n | 0;
    }
    function lognot(n) {
        return n ^ -1;
    }
    var _a_ = Stdlib_Sys[9], _b_ = [
        0,
        "int32.ml",
        69,
        6
    ], minus_one = -1, min_int = -2147483648, max_int = 2147483647;
    if (32 === _a_) var max_int$0 = Stdlib[19], unsigned_to_int = function(n) {
        if (caml_greaterequal(n, 0) && caml_lessequal(n, max_int$0)) return [
            0,
            n
        ];
        return 0;
    };
    else {
        if (64 !== _a_) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        var unsigned_to_int = function(n) {
            return [
                0,
                n & -1
            ];
        };
    }
    function to_string(n) {
        return runtime.caml_format_int("%d", n);
    }
    function of_string_opt(s) {
        try {
            var _d_ = [
                0,
                runtime.caml_int_of_string(s)
            ];
            return _d_;
        } catch (_e_) {
            var _c_ = caml_wrap_exception(_e_);
            if (_c_[1] === Stdlib[7]) return 0;
            throw caml_maybe_attach_backtrace(_c_, 0);
        }
    }
    var compare = caml_int_compare, equal = runtime.caml_equal;
    function unsigned_compare(n, m) {
        var y = m + 2147483648 | 0, x = n + 2147483648 | 0;
        return caml_int_compare(x, y);
    }
    function unsigned_lt(n, m) {
        return caml_lessthan(n + 2147483648 | 0, m + 2147483648 | 0);
    }
    function min(x, y) {
        return caml_lessequal(x, y) ? x : y;
    }
    function max(x, y) {
        return caml_greaterequal(x, y) ? x : y;
    }
    function unsigned_div(n, d) {
        if (caml_lessthan(d, 0)) return unsigned_lt(n, d) ? zero : one;
        var q = runtime.caml_div(n >>> 1 | 0, d) << 1, r = n - caml_mul(q, d) | 0;
        return unsigned_lt(r, d) ? q : q + 1 | 0;
    }
    function unsigned_rem(n, d) {
        return n - caml_mul(unsigned_div(n, d), d) | 0;
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    var Stdlib_Int32 = [
        0,
        zero,
        one,
        minus_one,
        unsigned_div,
        unsigned_rem,
        succ,
        pred,
        abs,
        max_int,
        min_int,
        lognot,
        unsigned_to_int,
        of_string_opt,
        to_string,
        compare,
        unsigned_compare,
        equal,
        min,
        max,
        seeded_hash,
        hash
    ];
    runtime.caml_register_global(15, Stdlib_Int32, "Stdlib__Int32");
    return;
})(globalThis);
//# 7411 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_greaterequal = runtime.caml_greaterequal, caml_hash = runtime.caml_hash, caml_int64_add = runtime.caml_int64_add, caml_int64_compare = runtime.caml_int64_compare, caml_int64_mul = runtime.caml_int64_mul, caml_int64_sub = runtime.caml_int64_sub, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception, global_data = runtime.caml_get_global_data(), _a_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), zero = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), one = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), minus_one = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 65535), min_int = runtime.caml_int64_create_lo_mi_hi(0, 0, 32768), max_int = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 32767), Stdlib = global_data.Stdlib, _b_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _c_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _d_ = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 65535);
    function succ(n) {
        return caml_int64_add(n, _a_);
    }
    function pred(n) {
        return caml_int64_sub(n, _b_);
    }
    function abs(n) {
        return caml_greaterequal(n, _c_) ? n : runtime.caml_int64_neg(n);
    }
    function lognot(n) {
        return runtime.caml_int64_xor(n, _d_);
    }
    var max_int$0 = runtime.caml_int64_of_int32(Stdlib[19]), _e_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0);
    function unsigned_to_int(n) {
        if (caml_greaterequal(n, _e_) && caml_lessequal(n, max_int$0)) return [
            0,
            runtime.caml_int64_to_int32(n)
        ];
        return 0;
    }
    function to_string(n) {
        return runtime.caml_int64_format("%d", n);
    }
    function of_string_opt(s) {
        try {
            var _g_ = [
                0,
                runtime.caml_int64_of_string(s)
            ];
            return _g_;
        } catch (_h_) {
            var _f_ = caml_wrap_exception(_h_);
            if (_f_[1] === Stdlib[7]) return 0;
            throw caml_maybe_attach_backtrace(_f_, 0);
        }
    }
    function compare(x, y) {
        return caml_int64_compare(x, y);
    }
    var equal = runtime.caml_equal;
    function unsigned_compare(n, m) {
        var y = caml_int64_sub(m, min_int), x = caml_int64_sub(n, min_int);
        return caml_int64_compare(x, y);
    }
    function unsigned_lt(n, m) {
        return caml_lessthan(caml_int64_sub(n, min_int), caml_int64_sub(m, min_int));
    }
    function min(x, y) {
        return caml_lessequal(x, y) ? x : y;
    }
    function max(x, y) {
        return caml_greaterequal(x, y) ? x : y;
    }
    function unsigned_div(n, d) {
        if (caml_lessthan(d, zero)) return unsigned_lt(n, d) ? zero : one;
        var q = runtime.caml_int64_shift_left(runtime.caml_int64_div(runtime.caml_int64_shift_right_unsigned(n, 1), d), 1), r = caml_int64_sub(n, caml_int64_mul(q, d));
        return unsigned_lt(r, d) ? q : caml_int64_add(q, _a_);
    }
    function unsigned_rem(n, d) {
        return caml_int64_sub(n, caml_int64_mul(unsigned_div(n, d), d));
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    var Stdlib_Int64 = [
        0,
        zero,
        one,
        minus_one,
        unsigned_div,
        unsigned_rem,
        succ,
        pred,
        abs,
        max_int,
        min_int,
        lognot,
        unsigned_to_int,
        of_string_opt,
        to_string,
        compare,
        unsigned_compare,
        equal,
        min,
        max,
        seeded_hash,
        hash
    ];
    runtime.caml_register_global(12, Stdlib_Int64, "Stdlib__Int64");
    return;
})(globalThis);
//# 7519 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_greaterequal = runtime.caml_greaterequal, caml_hash = runtime.caml_hash, caml_int_compare = runtime.caml_int_compare, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_mul = runtime.caml_mul, caml_wrap_exception = runtime.caml_wrap_exception, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Sys = global_data.Stdlib__Sys, zero = 0, one = 1;
    function succ(n) {
        return n + 1 | 0;
    }
    function pred(n) {
        return n - 1 | 0;
    }
    function abs(n) {
        return caml_greaterequal(n, 0) ? n : -n | 0;
    }
    var size = Stdlib_Sys[9], min_int = 1 << (size - 1 | 0), max_int = min_int - 1 | 0;
    function lognot(n) {
        return n ^ -1;
    }
    var max_int$0 = Stdlib[19];
    function unsigned_to_int(n) {
        if (caml_greaterequal(n, 0) && caml_lessequal(n, max_int$0)) return [
            0,
            n
        ];
        return 0;
    }
    function to_string(n) {
        return runtime.caml_format_int("%d", n);
    }
    function of_string_opt(s) {
        try {
            var _b_ = [
                0,
                runtime.caml_int_of_string(s)
            ];
            return _b_;
        } catch (_c_) {
            var _a_ = caml_wrap_exception(_c_);
            if (_a_[1] === Stdlib[7]) return 0;
            throw caml_maybe_attach_backtrace(_a_, 0);
        }
    }
    var compare = caml_int_compare;
    function equal(x, y) {
        return 0 === caml_int_compare(x, y) ? 1 : 0;
    }
    function unsigned_compare(n, m) {
        var y = m - min_int | 0, x = n - min_int | 0;
        return caml_int_compare(x, y);
    }
    function unsigned_lt(n, m) {
        return caml_lessthan(n - min_int | 0, m - min_int | 0);
    }
    function min(x, y) {
        return caml_lessequal(x, y) ? x : y;
    }
    function max(x, y) {
        return caml_greaterequal(x, y) ? x : y;
    }
    function unsigned_div(n, d) {
        if (caml_lessthan(d, 0)) return unsigned_lt(n, d) ? zero : one;
        var q = runtime.caml_div(n >>> 1 | 0, d) << 1, r = n - caml_mul(q, d) | 0;
        return unsigned_lt(r, d) ? q : q + 1 | 0;
    }
    function unsigned_rem(n, d) {
        return n - caml_mul(unsigned_div(n, d), d) | 0;
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    var Stdlib_Nativeint = [
        0,
        zero,
        one,
        -1,
        unsigned_div,
        unsigned_rem,
        succ,
        pred,
        abs,
        size,
        max_int,
        min_int,
        lognot,
        unsigned_to_int,
        of_string_opt,
        to_string,
        compare,
        unsigned_compare,
        equal,
        min,
        max,
        seeded_hash,
        hash
    ];
    runtime.caml_register_global(13, Stdlib_Nativeint, "Stdlib__Nativeint");
    return;
})(globalThis);
//# 7612 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "", caml_bytes_get = runtime.caml_bytes_get, caml_check_bound = runtime.caml_check_bound, caml_create_bytes = runtime.caml_create_bytes, caml_ml_bytes_length = runtime.caml_ml_bytes_length;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), dummy_pos = [
        0,
        cst,
        0,
        0,
        -1
    ], zero_pos = [
        0,
        cst,
        1,
        0,
        0
    ], Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib = global_data.Stdlib, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Int = global_data.Stdlib__Int, cst_Lexing_lex_refill_cannot_g = "Lexing.lex_refill: cannot grow buffer";
    function engine(tbl, state, buf) {
        var result = runtime.caml_lex_engine(tbl, state, buf), _n_ = 0 <= result ? 1 : 0, _o_ = _n_ ? buf[12] !== dummy_pos ? 1 : 0 : _n_;
        if (_o_) {
            buf[11] = buf[12];
            var _p_ = buf[12];
            buf[12] = [
                0,
                _p_[1],
                _p_[2],
                _p_[3],
                buf[4] + buf[6] | 0
            ];
        }
        return result;
    }
    function new_engine(tbl, state, buf) {
        var result = runtime.caml_new_lex_engine(tbl, state, buf), _k_ = 0 <= result ? 1 : 0, _l_ = _k_ ? buf[12] !== dummy_pos ? 1 : 0 : _k_;
        if (_l_) {
            buf[11] = buf[12];
            var _m_ = buf[12];
            buf[12] = [
                0,
                _m_[1],
                _m_[2],
                _m_[3],
                buf[4] + buf[6] | 0
            ];
        }
        return result;
    }
    function from_function(opt, read_fun) {
        var with_positions = opt ? opt[1] : 1, _f_ = with_positions ? zero_pos : dummy_pos, _g_ = with_positions ? zero_pos : dummy_pos, aux_buffer = caml_create_bytes(512);
        return [
            0,
            function(lexbuf) {
                var read = caml_call2(read_fun, aux_buffer, caml_ml_bytes_length(aux_buffer)), n = 0 < read ? read : (lexbuf[9] = 1, 0);
                if (caml_ml_bytes_length(lexbuf[2]) < (lexbuf[3] + n | 0)) {
                    if (((lexbuf[3] - lexbuf[5] | 0) + n | 0) <= caml_ml_bytes_length(lexbuf[2])) caml_call5(Stdlib_Bytes[11], lexbuf[2], lexbuf[5], lexbuf[2], 0, lexbuf[3] - lexbuf[5] | 0);
                    else {
                        var newlen = caml_call2(Stdlib_Int[10], 2 * caml_ml_bytes_length(lexbuf[2]) | 0, Stdlib_Sys[12]);
                        if (newlen < ((lexbuf[3] - lexbuf[5] | 0) + n | 0)) caml_call1(Stdlib[2], cst_Lexing_lex_refill_cannot_g);
                        var newbuf = caml_create_bytes(newlen);
                        caml_call5(Stdlib_Bytes[11], lexbuf[2], lexbuf[5], newbuf, 0, lexbuf[3] - lexbuf[5] | 0);
                        lexbuf[2] = newbuf;
                    }
                    var s = lexbuf[5];
                    lexbuf[4] = lexbuf[4] + s | 0;
                    lexbuf[6] = lexbuf[6] - s | 0;
                    lexbuf[5] = 0;
                    lexbuf[7] = lexbuf[7] - s | 0;
                    lexbuf[3] = lexbuf[3] - s | 0;
                    var t = lexbuf[10], _i_ = t.length - 2 | 0, _h_ = 0;
                    if (_i_ >= 0) {
                        var i = _h_;
                        for(;;){
                            var v = caml_check_bound(t, i)[1 + i];
                            if (0 <= v) caml_check_bound(t, i)[1 + i] = v - s | 0;
                            var _j_ = i + 1 | 0;
                            if (_i_ === i) break;
                            i = _j_;
                        }
                    }
                }
                caml_call5(Stdlib_Bytes[11], aux_buffer, 0, lexbuf[2], lexbuf[3], n);
                lexbuf[3] = lexbuf[3] + n | 0;
                return 0;
            },
            caml_create_bytes(1024),
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0
            ],
            _g_,
            _f_
        ];
    }
    function from_channel(with_positions, ic) {
        return from_function(with_positions, function(buf, n) {
            return caml_call4(Stdlib[84], ic, buf, 0, n);
        });
    }
    function from_string(opt, s) {
        var with_positions = opt ? opt[1] : 1, _d_ = with_positions ? zero_pos : dummy_pos, _e_ = with_positions ? zero_pos : dummy_pos;
        return [
            0,
            function(lexbuf) {
                lexbuf[9] = 1;
                return 0;
            },
            caml_call1(Stdlib_Bytes[5], s),
            runtime.caml_ml_string_length(s),
            0,
            0,
            0,
            0,
            0,
            1,
            [
                0
            ],
            _e_,
            _d_
        ];
    }
    function set_position(lexbuf, position) {
        lexbuf[12] = [
            0,
            lexbuf[12][1],
            position[2],
            position[3],
            position[4]
        ];
        lexbuf[4] = position[4];
        return 0;
    }
    function set_filename(lexbuf, fname) {
        var _c_ = lexbuf[12];
        lexbuf[12] = [
            0,
            fname,
            _c_[2],
            _c_[3],
            _c_[4]
        ];
        return 0;
    }
    function with_positions(lexbuf) {
        return lexbuf[12] !== dummy_pos ? 1 : 0;
    }
    function lexeme(lexbuf) {
        var len = lexbuf[6] - lexbuf[5] | 0;
        return caml_call3(Stdlib_Bytes[8], lexbuf[2], lexbuf[5], len);
    }
    function sub_lexeme(lexbuf, i1, i2) {
        var len = i2 - i1 | 0;
        return caml_call3(Stdlib_Bytes[8], lexbuf[2], i1, len);
    }
    function sub_lexeme_opt(lexbuf, i1, i2) {
        if (0 > i1) return 0;
        var len = i2 - i1 | 0;
        return [
            0,
            caml_call3(Stdlib_Bytes[8], lexbuf[2], i1, len)
        ];
    }
    function sub_lexeme_char(lexbuf, i) {
        return caml_bytes_get(lexbuf[2], i);
    }
    function sub_lexeme_char_opt(lexbuf, i) {
        return 0 <= i ? [
            0,
            caml_bytes_get(lexbuf[2], i)
        ] : 0;
    }
    function lexeme_char(lexbuf, i) {
        return caml_bytes_get(lexbuf[2], lexbuf[5] + i | 0);
    }
    function lexeme_start(lexbuf) {
        return lexbuf[11][4];
    }
    function lexeme_end(lexbuf) {
        return lexbuf[12][4];
    }
    function lexeme_start_p(lexbuf) {
        return lexbuf[11];
    }
    function lexeme_end_p(lexbuf) {
        return lexbuf[12];
    }
    function new_line(lexbuf) {
        var lcp = lexbuf[12], _a_ = lcp !== dummy_pos ? 1 : 0, _b_ = _a_ ? (lexbuf[12] = [
            0,
            lcp[1],
            lcp[2] + 1 | 0,
            lcp[4],
            lcp[4]
        ], 0) : _a_;
        return _b_;
    }
    function flush_input(lb) {
        lb[6] = 0;
        lb[4] = 0;
        var lcp = lb[12];
        if (lcp !== dummy_pos) lb[12] = [
            0,
            lcp[1],
            zero_pos[2],
            zero_pos[3],
            zero_pos[4]
        ];
        lb[3] = 0;
        return 0;
    }
    var Stdlib_Lexing = [
        0,
        dummy_pos,
        from_channel,
        from_string,
        from_function,
        set_position,
        set_filename,
        with_positions,
        lexeme,
        lexeme_char,
        lexeme_start,
        lexeme_end,
        lexeme_start_p,
        lexeme_end_p,
        new_line,
        flush_input,
        sub_lexeme,
        sub_lexeme_opt,
        sub_lexeme_char,
        sub_lexeme_char_opt,
        engine,
        new_engine
    ];
    runtime.caml_register_global(7, Stdlib_Lexing, "Stdlib__Lexing");
    return;
})(globalThis);
//# 7867 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_check_bound = runtime.caml_check_bound, caml_fresh_oo_id = runtime.caml_fresh_oo_id, caml_make_vect = runtime.caml_make_vect, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Stdlib_Obj = global_data.Stdlib__Obj, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Lexing = global_data.Stdlib__Lexing, YYexit = [
        248,
        "Stdlib.Parsing.YYexit",
        caml_fresh_oo_id(0)
    ], Parse_error = [
        248,
        "Stdlib.Parsing.Parse_error",
        caml_fresh_oo_id(0)
    ], env = [
        0,
        caml_make_vect(100, 0),
        caml_make_vect(100, 0),
        caml_make_vect(100, Stdlib_Lexing[1]),
        caml_make_vect(100, Stdlib_Lexing[1]),
        100,
        0,
        0,
        0,
        Stdlib_Lexing[1],
        Stdlib_Lexing[1],
        0,
        0,
        0,
        0,
        0,
        0
    ];
    function grow_stacks(param) {
        var oldsize = env[5], newsize = oldsize * 2 | 0, new_s = caml_make_vect(newsize, 0), new_v = caml_make_vect(newsize, 0), new_start = caml_make_vect(newsize, Stdlib_Lexing[1]), new_end = caml_make_vect(newsize, Stdlib_Lexing[1]);
        caml_call5(Stdlib_Array[9], env[1], 0, new_s, 0, oldsize);
        env[1] = new_s;
        caml_call5(Stdlib_Array[9], env[2], 0, new_v, 0, oldsize);
        env[2] = new_v;
        caml_call5(Stdlib_Array[9], env[3], 0, new_start, 0, oldsize);
        env[3] = new_start;
        caml_call5(Stdlib_Array[9], env[4], 0, new_end, 0, oldsize);
        env[4] = new_end;
        env[5] = newsize;
        return;
    }
    function clear_parser(param) {
        caml_call4(Stdlib_Array[8], env[2], 0, env[5], 0);
        env[8] = 0;
        return 0;
    }
    var current_lookahead_fun = [
        0,
        function(param) {
            return 0;
        }
    ], cst_syntax_error = "syntax error";
    function yyparse(tables, start, lexer, lexbuf) {
        var init_asp = env[11], init_sp = env[14], init_stackbase = env[6], init_state = env[15], init_curr_char = env[7], init_lval = env[8], init_errflag = env[16];
        env[6] = env[14] + 1 | 0;
        env[7] = start;
        env[10] = lexbuf[12];
        try {
            var cmd = 0, arg = 0;
            for(;;)switch(runtime.caml_parse_engine(tables, env, cmd, arg)){
                case 0:
                    var arg$0 = caml_call1(lexer, lexbuf);
                    env[9] = lexbuf[11];
                    env[10] = lexbuf[12];
                    cmd = 1;
                    arg = arg$0;
                    break;
                case 1:
                    throw caml_maybe_attach_backtrace(Parse_error, 1);
                case 2:
                    grow_stacks(0);
                    cmd = 2;
                    arg = 0;
                    break;
                case 3:
                    grow_stacks(0);
                    cmd = 3;
                    arg = 0;
                    break;
                case 4:
                    try {
                        var _i_ = env[13], _j_ = caml_call1(caml_check_bound(tables[1], _i_)[1 + _i_], env), _k_ = 4, value = _j_, action = _k_;
                    } catch (_m_) {
                        var _h_ = caml_wrap_exception(_m_);
                        if (_h_ !== Parse_error) throw caml_maybe_attach_backtrace(_h_, 0);
                        var value = 0, action = 5;
                    }
                    cmd = action;
                    arg = value;
                    break;
                default:
                    caml_call1(tables[14], cst_syntax_error);
                    cmd = 5;
                    arg = 0;
            }
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0), curr_char = env[7];
            env[11] = init_asp;
            env[14] = init_sp;
            env[6] = init_stackbase;
            env[15] = init_state;
            env[7] = init_curr_char;
            env[8] = init_lval;
            env[16] = init_errflag;
            if (exn[1] === YYexit) {
                var v = exn[2];
                return v;
            }
            current_lookahead_fun[1] = function(tok) {
                if (!caml_call1(Stdlib_Obj[1], tok)) return caml_check_bound(tables[2], tok)[1 + tok] === curr_char ? 1 : 0;
                var _l_ = runtime.caml_obj_tag(tok);
                return caml_check_bound(tables[3], _l_)[1 + _l_] === curr_char ? 1 : 0;
            };
            throw caml_maybe_attach_backtrace(exn, 0);
        }
    }
    function peek_val(env, n) {
        var _g_ = env[11] - n | 0;
        return caml_check_bound(env[2], _g_)[1 + _g_];
    }
    function symbol_start_pos(param) {
        var i$1 = env[12], i = i$1;
        for(;;){
            if (0 >= i) {
                var _f_ = env[11];
                return caml_check_bound(env[4], _f_)[1 + _f_];
            }
            var _d_ = (env[11] - i | 0) + 1 | 0, st = caml_check_bound(env[3], _d_)[1 + _d_], _e_ = (env[11] - i | 0) + 1 | 0, en = caml_check_bound(env[4], _e_)[1 + _e_];
            if (runtime.caml_notequal(st, en)) return st;
            var i$0 = i - 1 | 0;
            i = i$0;
        }
    }
    function symbol_end_pos(param) {
        var _c_ = env[11];
        return caml_check_bound(env[4], _c_)[1 + _c_];
    }
    function rhs_start_pos(n) {
        var _b_ = env[11] - (env[12] - n | 0) | 0;
        return caml_check_bound(env[3], _b_)[1 + _b_];
    }
    function rhs_end_pos(n) {
        var _a_ = env[11] - (env[12] - n | 0) | 0;
        return caml_check_bound(env[4], _a_)[1 + _a_];
    }
    function symbol_start(param) {
        return symbol_start_pos(0)[4];
    }
    function symbol_end(param) {
        return symbol_end_pos(0)[4];
    }
    function rhs_start(n) {
        return rhs_start_pos(n)[4];
    }
    function rhs_end(n) {
        return rhs_end_pos(n)[4];
    }
    function is_current_lookahead(tok) {
        return caml_call1(current_lookahead_fun[1], tok);
    }
    function parse_error(param) {
        return 0;
    }
    var Stdlib_Parsing = [
        0,
        symbol_start,
        symbol_end,
        rhs_start,
        rhs_end,
        symbol_start_pos,
        symbol_end_pos,
        rhs_start_pos,
        rhs_end_pos,
        clear_parser,
        Parse_error,
        runtime.caml_set_parser_trace,
        YYexit,
        yyparse,
        peek_val,
        is_current_lookahead,
        parse_error
    ];
    runtime.caml_register_global(7, Stdlib_Parsing, "Stdlib__Parsing");
    return;
})(globalThis);
//# 8081 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Set_bal$3 = "Set.bal", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_List = global_data.Stdlib__List, Assert_failure = global_data.Assert_failure, cst_Set_bal = cst_Set_bal$3, cst_Set_bal$0 = cst_Set_bal$3, cst_Set_bal$1 = cst_Set_bal$3, cst_Set_bal$2 = cst_Set_bal$3, cst_Set_remove_min_elt = "Set.remove_min_elt", _a_ = [
        0,
        0,
        0,
        0
    ], _b_ = [
        0,
        0,
        0
    ], _c_ = [
        0,
        "set.ml",
        571,
        18
    ], Stdlib_Set = [
        0,
        function(Ord) {
            function height(param) {
                if (!param) return 0;
                var h = param[4];
                return h;
            }
            function create(l, v, r) {
                if (l) var h = l[4], hl = h;
                else var hl = 0;
                if (r) var h$0 = r[4], hr = h$0;
                else var hr = 0;
                var _Y_ = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
                return [
                    0,
                    l,
                    v,
                    r,
                    _Y_
                ];
            }
            function bal(l, v, r) {
                if (l) var h = l[4], hl = h;
                else var hl = 0;
                if (r) var h$0 = r[4], hr = h$0;
                else var hr = 0;
                if ((hr + 2 | 0) < hl) {
                    if (!l) return caml_call1(Stdlib[1], cst_Set_bal$0);
                    var lr = l[3], lv = l[2], ll = l[1], _T_1 = height(lr);
                    if (_T_1 <= height(ll)) return create(ll, lv, create(lr, v, r));
                    if (!lr) return caml_call1(Stdlib[1], cst_Set_bal);
                    var lrr = lr[3], lrv = lr[2], lrl = lr[1], _U_ = create(lrr, v, r);
                    return create(create(ll, lv, lrl), lrv, _U_);
                }
                if ((hl + 2 | 0) >= hr) {
                    var _X_ = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
                    return [
                        0,
                        l,
                        v,
                        r,
                        _X_
                    ];
                }
                if (!r) return caml_call1(Stdlib[1], cst_Set_bal$2);
                var rr = r[3], rv = r[2], rl = r[1], _V_ = height(rl);
                if (_V_ <= height(rr)) return create(create(l, v, rl), rv, rr);
                if (!rl) return caml_call1(Stdlib[1], cst_Set_bal$1);
                var rlr = rl[3], rlv = rl[2], rll = rl[1], _W_ = create(rlr, rv, rr);
                return create(create(l, v, rll), rlv, _W_);
            }
            function add(x, t) {
                if (!t) return [
                    0,
                    0,
                    x,
                    0,
                    1
                ];
                var r = t[3], v = t[2], l = t[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return t;
                if (0 <= c) {
                    var rr = add(x, r);
                    return r === rr ? t : bal(l, v, rr);
                }
                var ll = add(x, l);
                return l === ll ? t : bal(ll, v, r);
            }
            function singleton(x) {
                return [
                    0,
                    0,
                    x,
                    0,
                    1
                ];
            }
            function add_min_element(x, param) {
                if (!param) return singleton(x);
                var r = param[3], v = param[2], l = param[1];
                return bal(add_min_element(x, l), v, r);
            }
            function add_max_element(x, param) {
                if (!param) return singleton(x);
                var r = param[3], v = param[2], l = param[1];
                return bal(l, v, add_max_element(x, r));
            }
            function join(l, v, r) {
                if (!l) return add_min_element(v, r);
                if (!r) return add_max_element(v, l);
                var rh = r[4], rr = r[3], rv = r[2], rl = r[1], lh = l[4], lr = l[3], lv = l[2], ll = l[1];
                return (rh + 2 | 0) < lh ? bal(ll, lv, join(lr, v, r)) : (lh + 2 | 0) < rh ? bal(join(l, v, rl), rv, rr) : create(l, v, r);
            }
            function min_elt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var l = param$0[1];
                    if (!l) {
                        var v = param$0[2];
                        return v;
                    }
                    param$0 = l;
                }
            }
            function min_elt_opt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var l = param$0[1];
                    if (!l) {
                        var v = param$0[2];
                        return [
                            0,
                            v
                        ];
                    }
                    param$0 = l;
                }
            }
            function max_elt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    if (!param$0[3]) {
                        var v = param$0[2];
                        return v;
                    }
                    var r = param$0[3];
                    param$0 = r;
                }
            }
            function max_elt_opt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    if (!param$0[3]) {
                        var v = param$0[2];
                        return [
                            0,
                            v
                        ];
                    }
                    var r = param$0[3];
                    param$0 = r;
                }
            }
            function remove_min_elt(param) {
                if (!param) return caml_call1(Stdlib[1], cst_Set_remove_min_elt);
                var l = param[1];
                if (l) {
                    var r = param[3], v = param[2];
                    return bal(remove_min_elt(l), v, r);
                }
                var r$0 = param[3];
                return r$0;
            }
            function concat(t1, t2) {
                if (!t1) return t2;
                if (!t2) return t1;
                var _S_ = remove_min_elt(t2);
                return join(t1, min_elt(t2), _S_);
            }
            function split(x, param) {
                if (!param) return _a_;
                var r = param[3], v = param[2], l = param[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return [
                    0,
                    l,
                    1,
                    r
                ];
                if (0 <= c) {
                    var match = split(x, r), rr = match[3], pres = match[2], lr = match[1];
                    return [
                        0,
                        join(l, v, lr),
                        pres,
                        rr
                    ];
                }
                var match$0 = split(x, l), rl = match$0[3], pres$0 = match$0[2], ll = match$0[1];
                return [
                    0,
                    ll,
                    pres$0,
                    join(rl, v, r)
                ];
            }
            var empty = 0;
            function is_empty(param) {
                return param ? 0 : 1;
            }
            function mem(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[3], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v), _R_ = 0 === c ? 1 : 0;
                    if (_R_) return _R_;
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function remove(x, t) {
                if (!t) return 0;
                var t2 = t[3], v = t[2], t1 = t[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) {
                    if (!t1) return t2;
                    if (!t2) return t1;
                    var _Q_ = remove_min_elt(t2);
                    return bal(t1, min_elt(t2), _Q_);
                }
                if (0 <= c) {
                    var rr = remove(x, t2);
                    return t2 === rr ? t : bal(t1, v, rr);
                }
                var ll = remove(x, t1);
                return t1 === ll ? t : bal(ll, v, t2);
            }
            function union(s1, s2) {
                if (!s1) return s2;
                if (!s2) return s1;
                var h2 = s2[4], r2 = s2[3], v2 = s2[2], l2 = s2[1], h1 = s1[4], r1 = s1[3], v1 = s1[2], l1 = s1[1];
                if (h2 <= h1) {
                    if (1 === h2) return add(v2, s1);
                    var match = split(v1, s2), r2$0 = match[3], l2$0 = match[1], _O_ = union(r1, r2$0);
                    return join(union(l1, l2$0), v1, _O_);
                }
                if (1 === h1) return add(v1, s2);
                var match$0 = split(v2, s1), r1$0 = match$0[3], l1$0 = match$0[1], _P_ = union(r1$0, r2);
                return join(union(l1$0, l2), v2, _P_);
            }
            function inter(s1, s2) {
                if (!s1) return 0;
                if (!s2) return 0;
                var r1 = s1[3], v1 = s1[2], l1 = s1[1], _L_ = split(v1, s2), l2 = _L_[1];
                if (_L_[2]) {
                    var r2 = _L_[3], _M_ = inter(r1, r2);
                    return join(inter(l1, l2), v1, _M_);
                }
                var r2$0 = _L_[3], _N_ = inter(r1, r2$0);
                return concat(inter(l1, l2), _N_);
            }
            function split_bis(x, param) {
                if (!param) return [
                    0,
                    0,
                    function(param) {
                        return 0;
                    }
                ];
                var r = param[3], v = param[2], l = param[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return 0;
                if (0 <= c) {
                    var match = split_bis(x, r);
                    if (!match) return 0;
                    var rr = match[2], lr = match[1];
                    return [
                        0,
                        join(l, v, lr),
                        rr
                    ];
                }
                var match$0 = split_bis(x, l);
                if (!match$0) return 0;
                var rl = match$0[2], ll = match$0[1];
                return [
                    0,
                    ll,
                    function(param) {
                        return join(rl(0), v, r);
                    }
                ];
            }
            function disjoint(s1, s2) {
                var s1$0 = s1, s2$0 = s2;
                for(;;){
                    if (s1$0 && s2$0) {
                        var r1 = s1$0[3], v1 = s1$0[2], l1 = s1$0[1];
                        if (s1$0 === s2$0) return 0;
                        var match = split_bis(v1, s2$0);
                        if (!match) return 0;
                        var r2 = match[2], l2 = match[1], _K_ = disjoint(l1, l2);
                        if (!_K_) return _K_;
                        var s2$1 = r2(0);
                        s1$0 = r1;
                        s2$0 = s2$1;
                        continue;
                    }
                    return 1;
                }
            }
            function diff(s1, s2) {
                if (!s1) return 0;
                if (!s2) return s1;
                var r1 = s1[3], v1 = s1[2], l1 = s1[1], _H_ = split(v1, s2), l2 = _H_[1];
                if (_H_[2]) {
                    var r2 = _H_[3], _I_ = diff(r1, r2);
                    return concat(diff(l1, l2), _I_);
                }
                var r2$0 = _H_[3], _J_ = diff(r1, r2$0);
                return join(diff(l1, l2), v1, _J_);
            }
            function cons_enum(s, e) {
                var s$0 = s, e$0 = e;
                for(;;){
                    if (!s$0) return e$0;
                    var r = s$0[3], v = s$0[2], l = s$0[1], e$1 = [
                        0,
                        v,
                        r,
                        e$0
                    ];
                    s$0 = l;
                    e$0 = e$1;
                }
            }
            function compare(s1, s2) {
                var e2$2 = cons_enum(s2, 0), e1$2 = cons_enum(s1, 0), e1 = e1$2, e2 = e2$2;
                for(;;){
                    if (!e1) return e2 ? -1 : 0;
                    if (!e2) return 1;
                    var e2$0 = e2[3], r2 = e2[2], v2 = e2[1], e1$0 = e1[3], r1 = e1[2], v1 = e1[1], c = caml_call2(Ord[1], v1, v2);
                    if (0 !== c) return c;
                    var e2$1 = cons_enum(r2, e2$0), e1$1 = cons_enum(r1, e1$0);
                    e1 = e1$1;
                    e2 = e2$1;
                }
            }
            function equal(s1, s2) {
                return 0 === compare(s1, s2) ? 1 : 0;
            }
            function subset(s1, s2) {
                var s1$0 = s1, s2$0 = s2;
                for(;;){
                    if (!s1$0) return 1;
                    if (!s2$0) return 0;
                    var r2 = s2$0[3], v2 = s2$0[2], l2 = s2$0[1], r1 = s1$0[3], v1 = s1$0[2], l1 = s1$0[1], c = caml_call2(Ord[1], v1, v2);
                    if (0 === c) {
                        var _E_ = subset(l1, l2);
                        if (!_E_) return _E_;
                        s1$0 = r1;
                        s2$0 = r2;
                    } else if (0 <= c) {
                        var _F_ = subset([
                            0,
                            0,
                            v1,
                            r1,
                            0
                        ], r2);
                        if (!_F_) return _F_;
                        s1$0 = l1;
                    } else {
                        var _G_ = subset([
                            0,
                            l1,
                            v1,
                            0,
                            0
                        ], l2);
                        if (!_G_) return _G_;
                        s1$0 = r1;
                    }
                }
            }
            function iter(f, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[3], v = param$0[2], l = param$0[1];
                    iter(f, l);
                    caml_call1(f, v);
                    param$0 = r;
                }
            }
            function fold(f, s, accu) {
                var s$0 = s, accu$0 = accu;
                for(;;){
                    if (!s$0) return accu$0;
                    var r = s$0[3], v = s$0[2], l = s$0[1], accu$1 = caml_call2(f, v, fold(f, l, accu$0));
                    s$0 = r;
                    accu$0 = accu$1;
                }
            }
            function for_all(p, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 1;
                    var r = param$0[3], v = param$0[2], l = param$0[1], _B_ = caml_call1(p, v);
                    if (_B_) {
                        var _C_ = for_all(p, l);
                        if (_C_) {
                            param$0 = r;
                            continue;
                        }
                        var _D_ = _C_;
                    } else var _D_ = _B_;
                    return _D_;
                }
            }
            function exists(p, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[3], v = param$0[2], l = param$0[1], _y_ = caml_call1(p, v);
                    if (_y_) var _z_ = _y_;
                    else {
                        var _A_ = exists(p, l);
                        if (!_A_) {
                            param$0 = r;
                            continue;
                        }
                        var _z_ = _A_;
                    }
                    return _z_;
                }
            }
            function filter(p, t) {
                if (!t) return 0;
                var r = t[3], v = t[2], l = t[1], l$0 = filter(p, l), pv = caml_call1(p, v), r$0 = filter(p, r);
                if (!pv) return concat(l$0, r$0);
                if (l === l$0 && r === r$0) return t;
                return join(l$0, v, r$0);
            }
            function partition(p, param) {
                if (!param) return _b_;
                var r = param[3], v = param[2], l = param[1], match = partition(p, l), lf = match[2], lt = match[1], pv = caml_call1(p, v), match$0 = partition(p, r), rf = match$0[2], rt = match$0[1];
                if (pv) {
                    var _w_ = concat(lf, rf);
                    return [
                        0,
                        join(lt, v, rt),
                        _w_
                    ];
                }
                var _x_ = join(lf, v, rf);
                return [
                    0,
                    concat(lt, rt),
                    _x_
                ];
            }
            function cardinal(param) {
                if (!param) return 0;
                var r = param[3], l = param[1], _v_ = cardinal(r);
                return (cardinal(l) + 1 | 0) + _v_ | 0;
            }
            function elements_aux(accu, param) {
                var accu$0 = accu, param$0 = param;
                for(;;){
                    if (!param$0) return accu$0;
                    var r = param$0[3], v = param$0[2], l = param$0[1], accu$1 = [
                        0,
                        v,
                        elements_aux(accu$0, r)
                    ];
                    accu$0 = accu$1;
                    param$0 = l;
                }
            }
            function elements(s) {
                return elements_aux(0, s);
            }
            function find(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r = param$0[3], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v);
                    if (0 === c) return v;
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function find_first(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r$0 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, param = l$0;
                        for(;;){
                            if (!param) return v0;
                            var r = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                param = l;
                            } else param = r;
                        }
                    } else param$1 = r$0;
                }
            }
            function find_first_opt(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) return 0;
                    var r$0 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, param = l$0;
                        for(;;){
                            if (!param) return [
                                0,
                                v0
                            ];
                            var r = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                param = l;
                            } else param = r;
                        }
                    } else param$1 = r$0;
                }
            }
            function find_last(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r$0 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, param = r$0;
                        for(;;){
                            if (!param) return v0;
                            var r = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                param = r;
                            } else param = l;
                        }
                    } else param$1 = l$0;
                }
            }
            function find_last_opt(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) return 0;
                    var r$0 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, param = r$0;
                        for(;;){
                            if (!param) return [
                                0,
                                v0
                            ];
                            var r = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                param = r;
                            } else param = l;
                        }
                    } else param$1 = l$0;
                }
            }
            function find_opt(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[3], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v);
                    if (0 === c) return [
                        0,
                        v
                    ];
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function try_join(l, v, r) {
                a: {
                    if (0 !== l) {
                        var _u_ = max_elt(l);
                        if (0 <= caml_call2(Ord[1], _u_, v)) break a;
                    }
                    if (0 !== r) {
                        var _t_ = min_elt(r);
                        if (0 <= caml_call2(Ord[1], v, _t_)) break a;
                    }
                    return join(l, v, r);
                }
                return union(l, add(v, r));
            }
            function map(f, t) {
                if (!t) return 0;
                var r = t[3], v = t[2], l = t[1], l$0 = map(f, l), v$0 = caml_call1(f, v), r$0 = map(f, r);
                if (l === l$0 && v === v$0 && r === r$0) return t;
                return try_join(l$0, v$0, r$0);
            }
            function filter_map(f, t) {
                if (!t) return 0;
                var r = t[3], v = t[2], l = t[1], t1 = filter_map(f, l), v$0 = caml_call1(f, v), t2 = filter_map(f, r);
                if (v$0) {
                    var v$1 = v$0[1];
                    if (l === t1 && v === v$1 && r === t2) return t;
                    return try_join(t1, v$1, t2);
                }
                if (!t1) return t2;
                if (!t2) return t1;
                var _s_ = remove_min_elt(t2);
                return try_join(t1, min_elt(t2), _s_);
            }
            function of_list(l) {
                if (!l) return empty;
                var _n_ = l[2], x0 = l[1];
                if (!_n_) return singleton(x0);
                var _o_ = _n_[2], x1 = _n_[1];
                if (!_o_) return add(x1, singleton(x0));
                var _p_ = _o_[2], x2 = _o_[1];
                if (!_p_) return add(x2, add(x1, singleton(x0)));
                var _q_ = _p_[2], x3 = _p_[1];
                if (!_q_) return add(x3, add(x2, add(x1, singleton(x0))));
                if (_q_[2]) {
                    var l$0 = caml_call2(Stdlib_List[62], Ord[1], l), sub = function(n, l) {
                        if (3 >= n >>> 0) switch(n){
                            case 0:
                                return [
                                    0,
                                    0,
                                    l
                                ];
                            case 1:
                                if (l) {
                                    var l$3 = l[2], x0 = l[1];
                                    return [
                                        0,
                                        [
                                            0,
                                            0,
                                            x0,
                                            0,
                                            1
                                        ],
                                        l$3
                                    ];
                                }
                                break;
                            case 2:
                                if (l) {
                                    var match$1 = l[2];
                                    if (match$1) {
                                        var l$4 = match$1[2], x1 = match$1[1], x0$0 = l[1];
                                        return [
                                            0,
                                            [
                                                0,
                                                [
                                                    0,
                                                    0,
                                                    x0$0,
                                                    0,
                                                    1
                                                ],
                                                x1,
                                                0,
                                                2
                                            ],
                                            l$4
                                        ];
                                    }
                                }
                                break;
                            default:
                                if (l) {
                                    var _r_ = l[2];
                                    if (_r_) {
                                        var match$2 = _r_[2];
                                        if (match$2) {
                                            var l$5 = match$2[2], x2 = match$2[1], x1$0 = _r_[1], x0$1 = l[1];
                                            return [
                                                0,
                                                [
                                                    0,
                                                    [
                                                        0,
                                                        0,
                                                        x0$1,
                                                        0,
                                                        1
                                                    ],
                                                    x1$0,
                                                    [
                                                        0,
                                                        0,
                                                        x2,
                                                        0,
                                                        1
                                                    ],
                                                    2
                                                ],
                                                l$5
                                            ];
                                        }
                                    }
                                }
                        }
                        var nl = n / 2 | 0, match = sub(nl, l), l$0 = match[2], left = match[1];
                        if (!l$0) throw caml_maybe_attach_backtrace([
                            0,
                            Assert_failure,
                            _c_
                        ], 1);
                        var l$1 = l$0[2], mid = l$0[1], match$0 = sub((n - nl | 0) - 1 | 0, l$1), l$2 = match$0[2], right = match$0[1];
                        return [
                            0,
                            create(left, mid, right),
                            l$2
                        ];
                    };
                    return sub(caml_call1(Stdlib_List[1], l$0), l$0)[1];
                }
                var x4 = _q_[1];
                return add(x4, add(x3, add(x2, add(x1, singleton(x0)))));
            }
            function add_seq(i, m) {
                return caml_call3(Stdlib_Seq[5], function(s, x) {
                    return add(x, s);
                }, m, i);
            }
            function of_seq(i) {
                return add_seq(i, empty);
            }
            function seq_of_enum(c, param) {
                if (!c) return 0;
                var rest = c[3], t = c[2], x = c[1], _l_ = cons_enum(t, rest);
                return [
                    0,
                    x,
                    function(_m_) {
                        return seq_of_enum(_l_, _m_);
                    }
                ];
            }
            function to_seq(c) {
                var _j_ = cons_enum(c, 0);
                return function(_k_) {
                    return seq_of_enum(_j_, _k_);
                };
            }
            function snoc_enum(s, e) {
                var s$0 = s, e$0 = e;
                for(;;){
                    if (!s$0) return e$0;
                    var r = s$0[3], v = s$0[2], l = s$0[1], e$1 = [
                        0,
                        v,
                        l,
                        e$0
                    ];
                    s$0 = r;
                    e$0 = e$1;
                }
            }
            function rev_seq_of_enum(c, param) {
                if (!c) return 0;
                var rest = c[3], t = c[2], x = c[1], _h_ = snoc_enum(t, rest);
                return [
                    0,
                    x,
                    function(_i_) {
                        return rev_seq_of_enum(_h_, _i_);
                    }
                ];
            }
            function to_rev_seq(c) {
                var _f_ = snoc_enum(c, 0);
                return function(_g_) {
                    return rev_seq_of_enum(_f_, _g_);
                };
            }
            function to_seq_from(low, s) {
                a: {
                    b: {
                        var s$0 = s, c = 0;
                        for(;;){
                            if (!s$0) break;
                            var r = s$0[3], v = s$0[2], l = s$0[1], n = caml_call2(Ord[1], v, low);
                            if (0 === n) break b;
                            if (0 <= n) {
                                var c$0 = [
                                    0,
                                    v,
                                    r,
                                    c
                                ];
                                s$0 = l;
                                c = c$0;
                            } else s$0 = r;
                        }
                        var _d_ = c;
                        break a;
                    }
                    var _d_ = [
                        0,
                        v,
                        r,
                        c
                    ];
                }
                return function(_e_) {
                    return seq_of_enum(_d_, _e_);
                };
            }
            return [
                0,
                empty,
                add,
                singleton,
                remove,
                union,
                inter,
                disjoint,
                diff,
                cardinal,
                elements,
                min_elt,
                min_elt_opt,
                max_elt,
                max_elt_opt,
                min_elt,
                min_elt_opt,
                find,
                find_opt,
                find_first,
                find_first_opt,
                find_last,
                find_last_opt,
                iter,
                fold,
                map,
                filter,
                filter_map,
                partition,
                split,
                is_empty,
                mem,
                equal,
                compare,
                subset,
                for_all,
                exists,
                elements,
                of_list,
                to_seq_from,
                to_seq,
                to_rev_seq,
                add_seq,
                of_seq
            ];
        }
    ];
    runtime.caml_register_global(12, Stdlib_Set, "Stdlib__Set");
    return;
})(globalThis);
//# 8900 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Map_bal$3 = "Map.bal", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Assert_failure = global_data.Assert_failure, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_List = global_data.Stdlib__List, cst_Map_bal = cst_Map_bal$3, cst_Map_bal$0 = cst_Map_bal$3, cst_Map_bal$1 = cst_Map_bal$3, cst_Map_bal$2 = cst_Map_bal$3, cst_Map_remove_min_elt = "Map.remove_min_elt", _a_ = [
        0,
        0,
        0,
        0
    ], _b_ = [
        0,
        "map.ml",
        408,
        10
    ], _c_ = [
        0,
        0,
        0
    ], Stdlib_Map = [
        0,
        function(Ord) {
            function height(param) {
                if (!param) return 0;
                var h = param[5];
                return h;
            }
            function create(l, x, d, r) {
                var hl = height(l), hr = height(r), _K_ = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
                return [
                    0,
                    l,
                    x,
                    d,
                    r,
                    _K_
                ];
            }
            function singleton(x, d) {
                return [
                    0,
                    0,
                    x,
                    d,
                    0,
                    1
                ];
            }
            function bal(l, x, d, r) {
                if (l) var h = l[5], hl = h;
                else var hl = 0;
                if (r) var h$0 = r[5], hr = h$0;
                else var hr = 0;
                if ((hr + 2 | 0) < hl) {
                    if (!l) return caml_call1(Stdlib[1], cst_Map_bal$0);
                    var lr = l[4], ld = l[3], lv = l[2], ll = l[1], _F_ = height(lr);
                    if (_F_ <= height(ll)) return create(ll, lv, ld, create(lr, x, d, r));
                    if (!lr) return caml_call1(Stdlib[1], cst_Map_bal);
                    var lrr = lr[4], lrd = lr[3], lrv = lr[2], lrl = lr[1], _G_ = create(lrr, x, d, r);
                    return create(create(ll, lv, ld, lrl), lrv, lrd, _G_);
                }
                if ((hl + 2 | 0) >= hr) {
                    var _J_ = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
                    return [
                        0,
                        l,
                        x,
                        d,
                        r,
                        _J_
                    ];
                }
                if (!r) return caml_call1(Stdlib[1], cst_Map_bal$2);
                var rr = r[4], rd = r[3], rv = r[2], rl = r[1], _H_ = height(rl);
                if (_H_ <= height(rr)) return create(create(l, x, d, rl), rv, rd, rr);
                if (!rl) return caml_call1(Stdlib[1], cst_Map_bal$1);
                var rlr = rl[4], rld = rl[3], rlv = rl[2], rll = rl[1], _I_ = create(rlr, rv, rd, rr);
                return create(create(l, x, d, rll), rlv, rld, _I_);
            }
            var empty = 0;
            function is_empty(param) {
                return param ? 0 : 1;
            }
            function add(x, data, m) {
                if (!m) return [
                    0,
                    0,
                    x,
                    data,
                    0,
                    1
                ];
                var h = m[5], r = m[4], d = m[3], v = m[2], l = m[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return d === data ? m : [
                    0,
                    l,
                    x,
                    data,
                    r,
                    h
                ];
                if (0 <= c) {
                    var rr = add(x, data, r);
                    return r === rr ? m : bal(l, v, d, rr);
                }
                var ll = add(x, data, l);
                return l === ll ? m : bal(ll, v, d, r);
            }
            function find(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v);
                    if (0 === c) return d;
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function find_first(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r$0 = param$1[4], d0$1 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, d0 = d0$1, param = l$0;
                        for(;;){
                            if (!param) return [
                                0,
                                v0,
                                d0
                            ];
                            var r = param[4], d0$0 = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                d0 = d0$0;
                                param = l;
                            } else param = r;
                        }
                    } else param$1 = r$0;
                }
            }
            function find_first_opt(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) return 0;
                    var r$0 = param$1[4], d0$1 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, d0 = d0$1, param = l$0;
                        for(;;){
                            if (!param) return [
                                0,
                                [
                                    0,
                                    v0,
                                    d0
                                ]
                            ];
                            var r = param[4], d0$0 = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                d0 = d0$0;
                                param = l;
                            } else param = r;
                        }
                    } else param$1 = r$0;
                }
            }
            function find_last(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r$0 = param$1[4], d0$1 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, d0 = d0$1, param = r$0;
                        for(;;){
                            if (!param) return [
                                0,
                                v0,
                                d0
                            ];
                            var r = param[4], d0$0 = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                d0 = d0$0;
                                param = r;
                            } else param = l;
                        }
                    } else param$1 = l$0;
                }
            }
            function find_last_opt(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) return 0;
                    var r$0 = param$1[4], d0$1 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, d0 = d0$1, param = r$0;
                        for(;;){
                            if (!param) return [
                                0,
                                [
                                    0,
                                    v0,
                                    d0
                                ]
                            ];
                            var r = param[4], d0$0 = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                d0 = d0$0;
                                param = r;
                            } else param = l;
                        }
                    } else param$1 = l$0;
                }
            }
            function find_opt(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v);
                    if (0 === c) return [
                        0,
                        d
                    ];
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function mem(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[4], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v), _E_ = 0 === c ? 1 : 0;
                    if (_E_) return _E_;
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function min_binding(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var l = param$0[1];
                    if (!l) {
                        var d = param$0[3], v = param$0[2];
                        return [
                            0,
                            v,
                            d
                        ];
                    }
                    param$0 = l;
                }
            }
            function min_binding_opt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var l = param$0[1];
                    if (!l) {
                        var d = param$0[3], v = param$0[2];
                        return [
                            0,
                            [
                                0,
                                v,
                                d
                            ]
                        ];
                    }
                    param$0 = l;
                }
            }
            function max_binding(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    if (!param$0[4]) {
                        var d = param$0[3], v = param$0[2];
                        return [
                            0,
                            v,
                            d
                        ];
                    }
                    var r = param$0[4];
                    param$0 = r;
                }
            }
            function max_binding_opt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    if (!param$0[4]) {
                        var d = param$0[3], v = param$0[2];
                        return [
                            0,
                            [
                                0,
                                v,
                                d
                            ]
                        ];
                    }
                    var r = param$0[4];
                    param$0 = r;
                }
            }
            function remove_min_binding(param) {
                if (!param) return caml_call1(Stdlib[1], cst_Map_remove_min_elt);
                var l = param[1];
                if (l) {
                    var r = param[4], d = param[3], v = param[2];
                    return bal(remove_min_binding(l), v, d, r);
                }
                var r$0 = param[4];
                return r$0;
            }
            function _d_(t1, t2) {
                if (!t1) return t2;
                if (!t2) return t1;
                var match = min_binding(t2), d = match[2], x = match[1];
                return bal(t1, x, d, remove_min_binding(t2));
            }
            function remove(x, m) {
                if (!m) return 0;
                var r = m[4], d = m[3], v = m[2], l = m[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return _d_(l, r);
                if (0 <= c) {
                    var rr = remove(x, r);
                    return r === rr ? m : bal(l, v, d, rr);
                }
                var ll = remove(x, l);
                return l === ll ? m : bal(ll, v, d, r);
            }
            function update(x, f, m) {
                if (!m) {
                    var match$0 = caml_call1(f, 0);
                    if (!match$0) return 0;
                    var data$0 = match$0[1];
                    return [
                        0,
                        0,
                        x,
                        data$0,
                        0,
                        1
                    ];
                }
                var h = m[5], r = m[4], d = m[3], v = m[2], l = m[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) {
                    var match = caml_call1(f, [
                        0,
                        d
                    ]);
                    if (!match) return _d_(l, r);
                    var data = match[1];
                    return d === data ? m : [
                        0,
                        l,
                        x,
                        data,
                        r,
                        h
                    ];
                }
                if (0 <= c) {
                    var rr = update(x, f, r);
                    return r === rr ? m : bal(l, v, d, rr);
                }
                var ll = update(x, f, l);
                return l === ll ? m : bal(ll, v, d, r);
            }
            function add_to_list(x, data, m) {
                function add(param) {
                    if (!param) return [
                        0,
                        [
                            0,
                            data,
                            0
                        ]
                    ];
                    var l = param[1];
                    return [
                        0,
                        [
                            0,
                            data,
                            l
                        ]
                    ];
                }
                return update(x, add, m);
            }
            function iter(f, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1];
                    iter(f, l);
                    caml_call2(f, v, d);
                    param$0 = r;
                }
            }
            function map(f, param) {
                if (!param) return 0;
                var h = param[5], r = param[4], d = param[3], v = param[2], l = param[1], l$0 = map(f, l), d$0 = caml_call1(f, d), r$0 = map(f, r);
                return [
                    0,
                    l$0,
                    v,
                    d$0,
                    r$0,
                    h
                ];
            }
            function mapi(f, param) {
                if (!param) return 0;
                var h = param[5], r = param[4], d = param[3], v = param[2], l = param[1], l$0 = mapi(f, l), d$0 = caml_call2(f, v, d), r$0 = mapi(f, r);
                return [
                    0,
                    l$0,
                    v,
                    d$0,
                    r$0,
                    h
                ];
            }
            function fold(f, m, accu) {
                var m$0 = m, accu$0 = accu;
                for(;;){
                    if (!m$0) return accu$0;
                    var r = m$0[4], d = m$0[3], v = m$0[2], l = m$0[1], accu$1 = caml_call3(f, v, d, fold(f, l, accu$0));
                    m$0 = r;
                    accu$0 = accu$1;
                }
            }
            function for_all(p, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 1;
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1], _B_ = caml_call2(p, v, d);
                    if (_B_) {
                        var _C_ = for_all(p, l);
                        if (_C_) {
                            param$0 = r;
                            continue;
                        }
                        var _D_ = _C_;
                    } else var _D_ = _B_;
                    return _D_;
                }
            }
            function exists(p, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1], _y_ = caml_call2(p, v, d);
                    if (_y_) var _z_ = _y_;
                    else {
                        var _A_ = exists(p, l);
                        if (!_A_) {
                            param$0 = r;
                            continue;
                        }
                        var _z_ = _A_;
                    }
                    return _z_;
                }
            }
            function add_min_binding(k, x, param) {
                if (!param) return singleton(k, x);
                var r = param[4], d = param[3], v = param[2], l = param[1];
                return bal(add_min_binding(k, x, l), v, d, r);
            }
            function add_max_binding(k, x, param) {
                if (!param) return singleton(k, x);
                var r = param[4], d = param[3], v = param[2], l = param[1];
                return bal(l, v, d, add_max_binding(k, x, r));
            }
            function join(l, v, d, r) {
                if (!l) return add_min_binding(v, d, r);
                if (!r) return add_max_binding(v, d, l);
                var rh = r[5], rr = r[4], rd = r[3], rv = r[2], rl = r[1], lh = l[5], lr = l[4], ld = l[3], lv = l[2], ll = l[1];
                return (rh + 2 | 0) < lh ? bal(ll, lv, ld, join(lr, v, d, r)) : (lh + 2 | 0) < rh ? bal(join(l, v, d, rl), rv, rd, rr) : create(l, v, d, r);
            }
            function concat(t1, t2) {
                if (!t1) return t2;
                if (!t2) return t1;
                var match = min_binding(t2), d = match[2], x = match[1];
                return join(t1, x, d, remove_min_binding(t2));
            }
            function concat_or_join(t1, v, d, t2) {
                if (!d) return concat(t1, t2);
                var d$0 = d[1];
                return join(t1, v, d$0, t2);
            }
            function split(x, param) {
                if (!param) return _a_;
                var r = param[4], d = param[3], v = param[2], l = param[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return [
                    0,
                    l,
                    [
                        0,
                        d
                    ],
                    r
                ];
                if (0 <= c) {
                    var match = split(x, r), rr = match[3], pres = match[2], lr = match[1];
                    return [
                        0,
                        join(l, v, d, lr),
                        pres,
                        rr
                    ];
                }
                var match$0 = split(x, l), rl = match$0[3], pres$0 = match$0[2], ll = match$0[1];
                return [
                    0,
                    ll,
                    pres$0,
                    join(rl, v, d, r)
                ];
            }
            function merge(f, s1, s2) {
                if (s1) {
                    var h1 = s1[5], r1 = s1[4], d1 = s1[3], v1 = s1[2], l1 = s1[1];
                    if (height(s2) <= h1) {
                        var match = split(v1, s2), r2 = match[3], d2 = match[2], l2 = match[1], _u_ = merge(f, r1, r2), _v_ = caml_call3(f, v1, [
                            0,
                            d1
                        ], d2);
                        return concat_or_join(merge(f, l1, l2), v1, _v_, _u_);
                    }
                } else if (!s2) return 0;
                if (!s2) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _b_
                ], 1);
                var r2$0 = s2[4], d2$0 = s2[3], v2 = s2[2], l2$0 = s2[1], match$0 = split(v2, s1), r1$0 = match$0[3], d1$0 = match$0[2], l1$0 = match$0[1], _w_ = merge(f, r1$0, r2$0), _x_ = caml_call3(f, v2, d1$0, [
                    0,
                    d2$0
                ]);
                return concat_or_join(merge(f, l1$0, l2$0), v2, _x_, _w_);
            }
            function union(f, s1, s2) {
                if (s1) {
                    if (s2) {
                        var h2 = s2[5], r2 = s2[4], d2 = s2[3], v2 = s2[2], l2 = s2[1], h1 = s1[5], r1 = s1[4], d1 = s1[3], v1 = s1[2], l1 = s1[1];
                        if (h2 <= h1) {
                            var match = split(v1, s2), r2$0 = match[3], d2$0 = match[2], l2$0 = match[1], l = union(f, l1, l2$0), r = union(f, r1, r2$0);
                            if (!d2$0) return join(l, v1, d1, r);
                            var d2$1 = d2$0[1];
                            return concat_or_join(l, v1, caml_call3(f, v1, d1, d2$1), r);
                        }
                        var match$0 = split(v2, s1), r1$0 = match$0[3], d1$0 = match$0[2], l1$0 = match$0[1], l$0 = union(f, l1$0, l2), r$0 = union(f, r1$0, r2);
                        if (!d1$0) return join(l$0, v2, d2, r$0);
                        var d1$1 = d1$0[1];
                        return concat_or_join(l$0, v2, caml_call3(f, v2, d1$1, d2), r$0);
                    }
                    var s = s1;
                } else var s = s2;
                return s;
            }
            function filter(p, m) {
                if (!m) return 0;
                var r = m[4], d = m[3], v = m[2], l = m[1], l$0 = filter(p, l), pvd = caml_call2(p, v, d), r$0 = filter(p, r);
                if (!pvd) return concat(l$0, r$0);
                if (l === l$0 && r === r$0) return m;
                return join(l$0, v, d, r$0);
            }
            function filter_map(f, param) {
                if (!param) return 0;
                var r = param[4], d = param[3], v = param[2], l = param[1], l$0 = filter_map(f, l), fvd = caml_call2(f, v, d), r$0 = filter_map(f, r);
                if (!fvd) return concat(l$0, r$0);
                var d$0 = fvd[1];
                return join(l$0, v, d$0, r$0);
            }
            function partition(p, param) {
                if (!param) return _c_;
                var r = param[4], d = param[3], v = param[2], l = param[1], match = partition(p, l), lf = match[2], lt = match[1], pvd = caml_call2(p, v, d), match$0 = partition(p, r), rf = match$0[2], rt = match$0[1];
                if (pvd) {
                    var _s_ = concat(lf, rf);
                    return [
                        0,
                        join(lt, v, d, rt),
                        _s_
                    ];
                }
                var _t_ = join(lf, v, d, rf);
                return [
                    0,
                    concat(lt, rt),
                    _t_
                ];
            }
            function cons_enum(m, e) {
                var m$0 = m, e$0 = e;
                for(;;){
                    if (!m$0) return e$0;
                    var r = m$0[4], d = m$0[3], v = m$0[2], l = m$0[1], e$1 = [
                        0,
                        v,
                        d,
                        r,
                        e$0
                    ];
                    m$0 = l;
                    e$0 = e$1;
                }
            }
            function compare(cmp, m1, m2) {
                var e2$2 = cons_enum(m2, 0), e1$2 = cons_enum(m1, 0), e1 = e1$2, e2 = e2$2;
                for(;;){
                    if (!e1) return e2 ? -1 : 0;
                    if (!e2) return 1;
                    var e2$0 = e2[4], r2 = e2[3], d2 = e2[2], v2 = e2[1], e1$0 = e1[4], r1 = e1[3], d1 = e1[2], v1 = e1[1], c = caml_call2(Ord[1], v1, v2);
                    if (0 !== c) return c;
                    var c$0 = caml_call2(cmp, d1, d2);
                    if (0 !== c$0) return c$0;
                    var e2$1 = cons_enum(r2, e2$0), e1$1 = cons_enum(r1, e1$0);
                    e1 = e1$1;
                    e2 = e2$1;
                }
            }
            function equal(cmp, m1, m2) {
                var e2$2 = cons_enum(m2, 0), e1$2 = cons_enum(m1, 0), e1 = e1$2, e2 = e2$2;
                for(;;){
                    if (!e1) return e2 ? 0 : 1;
                    if (!e2) return 0;
                    var e2$0 = e2[4], r2 = e2[3], d2 = e2[2], v2 = e2[1], e1$0 = e1[4], r1 = e1[3], d1 = e1[2], v1 = e1[1], _p_ = 0 === caml_call2(Ord[1], v1, v2) ? 1 : 0;
                    if (_p_) {
                        var _q_ = caml_call2(cmp, d1, d2);
                        if (_q_) {
                            var e2$1 = cons_enum(r2, e2$0), e1$1 = cons_enum(r1, e1$0);
                            e1 = e1$1;
                            e2 = e2$1;
                            continue;
                        }
                        var _r_ = _q_;
                    } else var _r_ = _p_;
                    return _r_;
                }
            }
            function cardinal(param) {
                if (!param) return 0;
                var r = param[4], l = param[1], _o_ = cardinal(r);
                return (cardinal(l) + 1 | 0) + _o_ | 0;
            }
            function bindings_aux(accu, param) {
                var accu$0 = accu, param$0 = param;
                for(;;){
                    if (!param$0) return accu$0;
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1], accu$1 = [
                        0,
                        [
                            0,
                            v,
                            d
                        ],
                        bindings_aux(accu$0, r)
                    ];
                    accu$0 = accu$1;
                    param$0 = l;
                }
            }
            function bindings(s) {
                return bindings_aux(0, s);
            }
            function of_list(bs) {
                return caml_call3(Stdlib_List[26], function(m, param) {
                    var v = param[2], k = param[1];
                    return add(k, v, m);
                }, empty, bs);
            }
            function add_seq(i, m) {
                return caml_call3(Stdlib_Seq[5], function(m, param) {
                    var v = param[2], k = param[1];
                    return add(k, v, m);
                }, m, i);
            }
            function of_seq(i) {
                return add_seq(i, empty);
            }
            function seq_of_enum(c, param) {
                if (!c) return 0;
                var rest = c[4], t = c[3], v = c[2], k = c[1], _m_ = cons_enum(t, rest);
                return [
                    0,
                    [
                        0,
                        k,
                        v
                    ],
                    function(_n_) {
                        return seq_of_enum(_m_, _n_);
                    }
                ];
            }
            function to_seq(m) {
                var _k_ = cons_enum(m, 0);
                return function(_l_) {
                    return seq_of_enum(_k_, _l_);
                };
            }
            function snoc_enum(s, e) {
                var s$0 = s, e$0 = e;
                for(;;){
                    if (!s$0) return e$0;
                    var r = s$0[4], d = s$0[3], v = s$0[2], l = s$0[1], e$1 = [
                        0,
                        v,
                        d,
                        l,
                        e$0
                    ];
                    s$0 = r;
                    e$0 = e$1;
                }
            }
            function rev_seq_of_enum(c, param) {
                if (!c) return 0;
                var rest = c[4], t = c[3], v = c[2], k = c[1], _i_ = snoc_enum(t, rest);
                return [
                    0,
                    [
                        0,
                        k,
                        v
                    ],
                    function(_j_) {
                        return rev_seq_of_enum(_i_, _j_);
                    }
                ];
            }
            function to_rev_seq(c) {
                var _g_ = snoc_enum(c, 0);
                return function(_h_) {
                    return rev_seq_of_enum(_g_, _h_);
                };
            }
            function to_seq_from(low, m) {
                a: {
                    b: {
                        var m$0 = m, c = 0;
                        for(;;){
                            if (!m$0) break;
                            var r = m$0[4], d = m$0[3], v = m$0[2], l = m$0[1], n = caml_call2(Ord[1], v, low);
                            if (0 === n) break b;
                            if (0 <= n) {
                                var c$0 = [
                                    0,
                                    v,
                                    d,
                                    r,
                                    c
                                ];
                                m$0 = l;
                                c = c$0;
                            } else m$0 = r;
                        }
                        var _e_ = c;
                        break a;
                    }
                    var _e_ = [
                        0,
                        v,
                        d,
                        r,
                        c
                    ];
                }
                return function(_f_) {
                    return seq_of_enum(_e_, _f_);
                };
            }
            return [
                0,
                empty,
                add,
                add_to_list,
                update,
                singleton,
                remove,
                merge,
                union,
                cardinal,
                bindings,
                min_binding,
                min_binding_opt,
                max_binding,
                max_binding_opt,
                min_binding,
                min_binding_opt,
                find,
                find_opt,
                find_first,
                find_first_opt,
                find_last,
                find_last_opt,
                iter,
                fold,
                map,
                mapi,
                filter,
                filter_map,
                partition,
                split,
                is_empty,
                mem,
                equal,
                compare,
                for_all,
                exists,
                bindings,
                of_list,
                to_seq,
                to_rev_seq,
                to_seq_from,
                add_seq,
                of_seq
            ];
        }
    ];
    runtime.caml_register_global(12, Stdlib_Map, "Stdlib__Map");
    return;
})(globalThis);
//# 9788 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_List = global_data.Stdlib__List, Empty = [
        248,
        "Stdlib.Stack.Empty",
        runtime.caml_fresh_oo_id(0)
    ];
    function create(param) {
        return [
            0,
            0,
            0
        ];
    }
    function clear(s) {
        s[1] = 0;
        s[2] = 0;
        return 0;
    }
    function copy(s) {
        return [
            0,
            s[1],
            s[2]
        ];
    }
    function push(x, s) {
        s[1] = [
            0,
            x,
            s[1]
        ];
        s[2] = s[2] + 1 | 0;
        return 0;
    }
    function pop(s) {
        var match = s[1];
        if (!match) throw caml_maybe_attach_backtrace(Empty, 1);
        var tl = match[2], hd = match[1];
        s[1] = tl;
        s[2] = s[2] - 1 | 0;
        return hd;
    }
    function pop_opt(s) {
        var match = s[1];
        if (!match) return 0;
        var tl = match[2], hd = match[1];
        s[1] = tl;
        s[2] = s[2] - 1 | 0;
        return [
            0,
            hd
        ];
    }
    function drop(s) {
        var match = s[1];
        if (!match) throw caml_maybe_attach_backtrace(Empty, 1);
        var tl = match[2];
        s[1] = tl;
        s[2] = s[2] - 1 | 0;
        return 0;
    }
    function top(s) {
        var match = s[1];
        if (!match) throw caml_maybe_attach_backtrace(Empty, 1);
        var hd = match[1];
        return hd;
    }
    function top_opt(s) {
        var match = s[1];
        if (!match) return 0;
        var hd = match[1];
        return [
            0,
            hd
        ];
    }
    function is_empty(s) {
        return 0 === s[1] ? 1 : 0;
    }
    function length(s) {
        return s[2];
    }
    function iter(f, s) {
        return caml_call2(Stdlib_List[18], f, s[1]);
    }
    function fold(f, acc, s) {
        return caml_call3(Stdlib_List[26], f, acc, s[1]);
    }
    function to_seq(s) {
        return caml_call1(Stdlib_List[64], s[1]);
    }
    function add_seq(q, i) {
        return caml_call2(Stdlib_Seq[4], function(x) {
            return push(x, q);
        }, i);
    }
    function of_seq(g) {
        var s = create(0);
        add_seq(s, g);
        return s;
    }
    var Stdlib_Stack = [
        0,
        Empty,
        create,
        push,
        pop,
        pop_opt,
        drop,
        top,
        top_opt,
        clear,
        copy,
        is_empty,
        length,
        iter,
        fold,
        to_seq,
        add_seq,
        of_seq
    ];
    runtime.caml_register_global(3, Stdlib_Stack, "Stdlib__Stack");
    return;
})(globalThis);
//# 9890 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Empty = [
        248,
        "Stdlib.Queue.Empty",
        runtime.caml_fresh_oo_id(0)
    ];
    function create(param) {
        return [
            0,
            0,
            0,
            0
        ];
    }
    function clear(q) {
        q[1] = 0;
        q[2] = 0;
        q[3] = 0;
        return 0;
    }
    function add(x, q) {
        var cell = [
            0,
            x,
            0
        ], match = q[3];
        return match ? (q[1] = q[1] + 1 | 0, match[2] = cell, q[3] = cell, 0) : (q[1] = 1, q[2] = cell, q[3] = cell, 0);
    }
    function peek(q) {
        var match = q[2];
        if (!match) throw caml_maybe_attach_backtrace(Empty, 1);
        var content = match[1];
        return content;
    }
    function peek_opt(q) {
        var match = q[2];
        if (!match) return 0;
        var content = match[1];
        return [
            0,
            content
        ];
    }
    function take(q) {
        var _f_ = q[2];
        if (!_f_) throw caml_maybe_attach_backtrace(Empty, 1);
        var content = _f_[1];
        if (_f_[2]) {
            var next = _f_[2];
            q[1] = q[1] - 1 | 0;
            q[2] = next;
            return content;
        }
        clear(q);
        return content;
    }
    function take_opt(q) {
        var _e_ = q[2];
        if (!_e_) return 0;
        var content = _e_[1];
        if (_e_[2]) {
            var next = _e_[2];
            q[1] = q[1] - 1 | 0;
            q[2] = next;
            return [
                0,
                content
            ];
        }
        clear(q);
        return [
            0,
            content
        ];
    }
    function copy(q) {
        var cell$0 = q[2], q_res = [
            0,
            q[1],
            0,
            0
        ], prev = 0, cell = cell$0;
        for(;;){
            if (!cell) {
                q_res[3] = prev;
                return q_res;
            }
            var content = cell[1], next = cell[2], prev$0 = [
                0,
                content,
                0
            ];
            if (prev) prev[2] = prev$0;
            else q_res[2] = prev$0;
            prev = prev$0;
            cell = next;
        }
    }
    function is_empty(q) {
        return 0 === q[1] ? 1 : 0;
    }
    function length(q) {
        return q[1];
    }
    function iter(f, q) {
        var cell$0 = q[2], cell = cell$0;
        for(;;){
            if (!cell) return 0;
            var content = cell[1], next = cell[2];
            caml_call1(f, content);
            cell = next;
        }
    }
    function fold(f, accu$1, q) {
        var cell$0 = q[2], accu = accu$1, cell = cell$0;
        for(;;){
            if (!cell) return accu;
            var content = cell[1], next = cell[2], accu$0 = caml_call2(f, accu, content);
            accu = accu$0;
            cell = next;
        }
    }
    function transfer(q1, q2) {
        var _d_ = 0 < q1[1] ? 1 : 0;
        if (!_d_) return _d_;
        var match = q2[3];
        return match ? (q2[1] = q2[1] + q1[1] | 0, match[2] = q1[2], q2[3] = q1[3], clear(q1)) : (q2[1] = q1[1], q2[2] = q1[2], q2[3] = q1[3], clear(q1));
    }
    function to_seq(q) {
        function aux(c, param) {
            if (!c) return 0;
            var x = c[1], next = c[2];
            return [
                0,
                x,
                function(_c_) {
                    return aux(next, _c_);
                }
            ];
        }
        var _a_ = q[2];
        return function(_b_) {
            return aux(_a_, _b_);
        };
    }
    function add_seq(q, i) {
        return caml_call2(Stdlib_Seq[4], function(x) {
            return add(x, q);
        }, i);
    }
    function of_seq(g) {
        var q = create(0);
        add_seq(q, g);
        return q;
    }
    var Stdlib_Queue = [
        0,
        Empty,
        create,
        add,
        add,
        take,
        take_opt,
        take,
        peek,
        peek_opt,
        peek,
        clear,
        copy,
        is_empty,
        length,
        iter,
        fold,
        transfer,
        to_seq,
        add_seq,
        of_seq
    ];
    runtime.caml_register_global(2, Stdlib_Queue, "Stdlib__Queue");
    return;
})(globalThis);
//# 10045 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_blit_string = runtime.caml_blit_string, caml_bswap16 = runtime.caml_bswap16, caml_bytes_get = runtime.caml_bytes_get, caml_bytes_set = runtime.caml_bytes_set, caml_bytes_set16 = runtime.caml_bytes_set16, caml_bytes_set32 = runtime.caml_bytes_set32, caml_bytes_set64 = runtime.caml_bytes_set64, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_int32_bswap = runtime.caml_int32_bswap, caml_int64_bswap = runtime.caml_int64_bswap, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib = global_data.Stdlib, Stdlib_String = global_data.Stdlib__String, Assert_failure = global_data.Assert_failure, cst_Buffer_sub = "Buffer.sub", cst_Buffer_blit = "Buffer.blit", cst_Buffer_nth = "Buffer.nth", cst_Buffer_add_cannot_grow_buf = "Buffer.add: cannot grow buffer";
    function create(n) {
        var n$0 = 1 <= n ? n : 1, n$1 = Stdlib_Sys[12] < n$0 ? Stdlib_Sys[12] : n$0, s = caml_create_bytes(n$1);
        return [
            0,
            [
                0,
                s,
                n$1
            ],
            0,
            s
        ];
    }
    function contents(b) {
        return caml_call3(Stdlib_Bytes[8], b[1][1], 0, b[2]);
    }
    function to_bytes(b) {
        return caml_call3(Stdlib_Bytes[7], b[1][1], 0, b[2]);
    }
    function sub(b, ofs, len) {
        if (0 <= ofs && 0 <= len && (b[2] - len | 0) >= ofs) return caml_call3(Stdlib_Bytes[8], b[1][1], ofs, len);
        return caml_call1(Stdlib[1], cst_Buffer_sub);
    }
    function blit(src, srcoff, dst, dstoff, len) {
        if (0 <= len && 0 <= srcoff && (src[2] - len | 0) >= srcoff && 0 <= dstoff && (caml_ml_bytes_length(dst) - len | 0) >= dstoff) return caml_call5(Stdlib_Bytes[11], src[1][1], srcoff, dst, dstoff, len);
        return caml_call1(Stdlib[1], cst_Buffer_blit);
    }
    function nth(b, ofs) {
        var position = b[2], match = b[1], length = match[2], buffer = match[1];
        if (0 <= ofs && position > ofs && length >= position) return runtime.caml_bytes_unsafe_get(buffer, ofs);
        return caml_call1(Stdlib[1], cst_Buffer_nth);
    }
    function length(b) {
        return b[2];
    }
    function clear(b) {
        b[2] = 0;
        return 0;
    }
    function reset(b) {
        b[2] = 0;
        var inner = [
            0,
            b[3],
            caml_ml_bytes_length(b[3])
        ];
        b[1] = inner;
        return 0;
    }
    function resize(b, more) {
        var old_pos = b[2], old_len = b[1][2], new_len = [
            0,
            old_len
        ];
        for(;;){
            if (new_len[1] >= (old_pos + more | 0)) break;
            new_len[1] = 2 * new_len[1] | 0;
        }
        if (Stdlib_Sys[12] < new_len[1]) {
            if ((old_pos + more | 0) <= Stdlib_Sys[12]) new_len[1] = Stdlib_Sys[12];
            else caml_call1(Stdlib[2], cst_Buffer_add_cannot_grow_buf);
        }
        var new_buffer = caml_create_bytes(new_len[1]);
        caml_call5(Stdlib_Bytes[11], b[1][1], 0, new_buffer, 0, b[2]);
        b[1] = [
            0,
            new_buffer,
            new_len[1]
        ];
        return;
    }
    function add_char(b, c) {
        var pos = b[2], match = b[1], length = match[2], buffer = match[1];
        if (length <= pos) {
            resize(b, 1);
            caml_bytes_set(b[1][1], b[2], c);
        } else caml_bytes_unsafe_set(buffer, pos, c);
        b[2] = pos + 1 | 0;
        return 0;
    }
    var uchar_utf_8_byte_length_max = 4, uchar_utf_16_byte_length_max = 4, cst_Buffer_add_substring_add_s = "Buffer.add_substring/add_subbytes", cst_Buffer_add_channel = "Buffer.add_channel", _a_ = [
        0,
        "buffer.ml",
        220,
        9
    ], cst_Buffer_truncate = "Buffer.truncate";
    function add_utf_8_uchar(b, u) {
        for(;;){
            var pos = b[2];
            if (b[1][2] <= pos) resize(b, uchar_utf_8_byte_length_max);
            var n = caml_call3(Stdlib_Bytes[51], b[1][1], pos, u);
            if (0 !== n) {
                b[2] = pos + n | 0;
                return 0;
            }
            resize(b, uchar_utf_8_byte_length_max);
        }
    }
    function add_utf_16be_uchar(b, u) {
        for(;;){
            var pos = b[2];
            if (b[1][2] <= pos) resize(b, uchar_utf_16_byte_length_max);
            var n = caml_call3(Stdlib_Bytes[54], b[1][1], pos, u);
            if (0 !== n) {
                b[2] = pos + n | 0;
                return 0;
            }
            resize(b, uchar_utf_16_byte_length_max);
        }
    }
    function add_utf_16le_uchar(b, u) {
        for(;;){
            var pos = b[2];
            if (b[1][2] <= pos) resize(b, uchar_utf_16_byte_length_max);
            var n = caml_call3(Stdlib_Bytes[57], b[1][1], pos, u);
            if (0 !== n) {
                b[2] = pos + n | 0;
                return 0;
            }
            resize(b, uchar_utf_16_byte_length_max);
        }
    }
    function add_substring(b, s, offset, len) {
        var _s_ = offset < 0 ? 1 : 0;
        if (_s_) var _t_ = _s_;
        else var _u_ = len < 0 ? 1 : 0, _t_ = _u_ || ((caml_ml_string_length(s) - len | 0) < offset ? 1 : 0);
        if (_t_) caml_call1(Stdlib[1], cst_Buffer_add_substring_add_s);
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + len | 0;
        if (length < new_position) {
            resize(b, len);
            caml_call5(Stdlib_Bytes[12], s, offset, b[1][1], b[2], len);
        } else caml_blit_string(s, offset, buffer, position, len);
        b[2] = new_position;
        return 0;
    }
    function add_subbytes(b, s, offset, len) {
        return add_substring(b, caml_call1(Stdlib_Bytes[44], s), offset, len);
    }
    function add_string(b, s) {
        var len = caml_ml_string_length(s), position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + len | 0;
        if (length < new_position) {
            resize(b, len);
            caml_call5(Stdlib_Bytes[12], s, 0, b[1][1], b[2], len);
        } else caml_blit_string(s, 0, buffer, position, len);
        b[2] = new_position;
        return 0;
    }
    function add_bytes(b, s) {
        return add_string(b, caml_call1(Stdlib_Bytes[44], s));
    }
    function add_buffer(b, bs) {
        return add_subbytes(b, bs[1][1], 0, bs[2]);
    }
    function add_channel(b, ic, to_read$1) {
        var _q_ = to_read$1 < 0 ? 1 : 0, _r_ = _q_ || (Stdlib_Sys[12] < to_read$1 ? 1 : 0);
        if (_r_) caml_call1(Stdlib[1], cst_Buffer_add_channel);
        if (b[1][2] < (b[2] + to_read$1 | 0)) resize(b, to_read$1);
        var ofs$1 = b[2], buf = b[1][1], already_read = 0, ofs = ofs$1, to_read = to_read$1;
        for(;;){
            if (0 !== to_read) {
                var r = caml_call4(Stdlib[84], ic, buf, ofs, to_read);
                if (0 !== r) {
                    var already_read$0 = already_read + r | 0, ofs$0 = ofs + r | 0, to_read$0 = to_read - r | 0;
                    already_read = already_read$0;
                    ofs = ofs$0;
                    to_read = to_read$0;
                    continue;
                }
            }
            b[2] = b[2] + already_read | 0;
            if (already_read < to_read$1) throw caml_maybe_attach_backtrace(Stdlib[12], 1);
            return 0;
        }
    }
    function output_buffer(oc, b) {
        return caml_call4(Stdlib[68], oc, b[1][1], 0, b[2]);
    }
    function add_substitute(b, f, s) {
        var lim$1 = caml_ml_string_length(s), previous = 32, i$4 = 0;
        for(;;){
            if (i$4 >= lim$1) {
                var _o_ = 92 === previous ? 1 : 0;
                return _o_ ? add_char(b, previous) : _o_;
            }
            var previous$0 = caml_string_get(s, i$4);
            if (36 === previous$0) {
                if (92 === previous) {
                    add_char(b, previous$0);
                    var i$5 = i$4 + 1 | 0;
                    previous = 32;
                    i$4 = i$5;
                } else {
                    var start = i$4 + 1 | 0;
                    try {
                        if (lim$1 <= start) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                        var opening = caml_string_get(s, start);
                        a: {
                            if (40 !== opening && 123 !== opening) {
                                var lim$0 = caml_ml_string_length(s);
                                b: {
                                    c: {
                                        d: {
                                            var i$2 = start;
                                            for(;;){
                                                if (lim$0 <= i$2) break c;
                                                var match = caml_string_get(s, i$2);
                                                if (91 <= match) {
                                                    if (97 <= match) {
                                                        if (123 <= match) break d;
                                                    } else if (95 !== match) break d;
                                                } else if (58 <= match) {
                                                    if (65 > match) break;
                                                } else if (48 > match) break d;
                                                var i$3 = i$2 + 1 | 0;
                                                i$2 = i$3;
                                            }
                                        }
                                        var stop$0 = i$2;
                                        break b;
                                    }
                                    var stop$0 = lim$0;
                                }
                                if (stop$0 === start) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                var val = [
                                    0,
                                    caml_call3(Stdlib_String[16], s, start, stop$0 - start | 0),
                                    stop$0
                                ];
                                break a;
                            }
                            var new_start = start + 1 | 0, k$2 = 0;
                            if (40 === opening) var closing = 41;
                            else {
                                if (123 !== opening) throw caml_maybe_attach_backtrace([
                                    0,
                                    Assert_failure,
                                    _a_
                                ], 1);
                                var closing = 125;
                            }
                            var lim = caml_ml_string_length(s), k = k$2, stop = new_start;
                            for(;;){
                                if (lim <= stop) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                if (caml_string_get(s, stop) === opening) {
                                    var i = stop + 1 | 0, k$0 = k + 1 | 0;
                                    k = k$0;
                                    stop = i;
                                } else if (caml_string_get(s, stop) === closing) {
                                    if (0 === k) break;
                                    var i$0 = stop + 1 | 0, k$1 = k - 1 | 0;
                                    k = k$1;
                                    stop = i$0;
                                } else {
                                    var i$1 = stop + 1 | 0;
                                    stop = i$1;
                                }
                            }
                            var val = [
                                0,
                                caml_call3(Stdlib_String[16], s, new_start, (stop - start | 0) - 1 | 0),
                                stop + 1 | 0
                            ];
                        }
                    } catch (_p_) {
                        var _n_ = caml_wrap_exception(_p_);
                        if (_n_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_n_, 0);
                        add_char(b, 36);
                        previous = 32;
                        i$4 = start;
                        continue;
                    }
                    var next_i = val[2], ident = val[1];
                    add_string(b, caml_call1(f, ident));
                    previous = 32;
                    i$4 = next_i;
                }
            } else {
                if (92 === previous) add_char(b, previous);
                if (92 !== previous$0) add_char(b, previous$0);
                var i$6 = i$4 + 1 | 0;
                previous = previous$0;
                i$4 = i$6;
            }
        }
    }
    function truncate(b, len) {
        if (0 <= len && b[2] >= len) {
            b[2] = len;
            return 0;
        }
        return caml_call1(Stdlib[1], cst_Buffer_truncate);
    }
    function to_seq(b) {
        function aux(i, param) {
            if (b[2] <= i) return 0;
            var x = caml_bytes_get(b[1][1], i), _l_ = i + 1 | 0;
            return [
                0,
                x,
                function(_m_) {
                    return aux(_l_, _m_);
                }
            ];
        }
        var _j_ = 0;
        return function(_k_) {
            return aux(_j_, _k_);
        };
    }
    function to_seqi(b) {
        function aux(i, param) {
            if (b[2] <= i) return 0;
            var x = caml_bytes_get(b[1][1], i), _h_ = i + 1 | 0;
            return [
                0,
                [
                    0,
                    i,
                    x
                ],
                function(_i_) {
                    return aux(_h_, _i_);
                }
            ];
        }
        var _f_ = 0;
        return function(_g_) {
            return aux(_f_, _g_);
        };
    }
    function add_seq(b, seq) {
        return caml_call2(Stdlib_Seq[4], function(_e_) {
            return add_char(b, _e_);
        }, seq);
    }
    function of_seq(i) {
        var b = create(32);
        add_seq(b, i);
        return b;
    }
    function add_int8(b, x) {
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + 1 | 0;
        if (length < new_position) {
            resize(b, 1);
            caml_bytes_set(b[1][1], b[2], x);
        } else caml_bytes_unsafe_set(buffer, position, x);
        b[2] = new_position;
        return 0;
    }
    function add_int16_ne(b, x) {
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + 2 | 0;
        if (length < new_position) {
            resize(b, 2);
            caml_bytes_set16(b[1][1], b[2], x);
        } else caml_bytes_set16(buffer, position, x);
        b[2] = new_position;
        return 0;
    }
    function add_int32_ne(b, x) {
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + 4 | 0;
        if (length < new_position) {
            resize(b, 4);
            caml_bytes_set32(b[1][1], b[2], x);
        } else caml_bytes_set32(buffer, position, x);
        b[2] = new_position;
        return 0;
    }
    function add_int64_ne(b, x) {
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + 8 | 0;
        if (length < new_position) {
            resize(b, 8);
            caml_bytes_set64(b[1][1], b[2], x);
        } else caml_bytes_set64(buffer, position, x);
        b[2] = new_position;
        return 0;
    }
    function add_int16_le(b, x) {
        var _d_ = Stdlib_Sys[11] ? caml_bswap16(x) : x;
        return add_int16_ne(b, _d_);
    }
    function add_int16_be(b, x) {
        var x$0 = Stdlib_Sys[11] ? x : caml_bswap16(x);
        return add_int16_ne(b, x$0);
    }
    function add_int32_le(b, x) {
        var _c_ = Stdlib_Sys[11] ? caml_int32_bswap(x) : x;
        return add_int32_ne(b, _c_);
    }
    function add_int32_be(b, x) {
        var x$0 = Stdlib_Sys[11] ? x : caml_int32_bswap(x);
        return add_int32_ne(b, x$0);
    }
    function add_int64_le(b, x) {
        var _b_ = Stdlib_Sys[11] ? caml_int64_bswap(x) : x;
        return add_int64_ne(b, _b_);
    }
    function add_int64_be(b, x) {
        var x$0 = Stdlib_Sys[11] ? x : caml_int64_bswap(x);
        return add_int64_ne(b, x$0);
    }
    var Stdlib_Buffer = [
        0,
        create,
        contents,
        to_bytes,
        sub,
        blit,
        nth,
        length,
        clear,
        reset,
        output_buffer,
        truncate,
        add_char,
        add_utf_8_uchar,
        add_utf_16le_uchar,
        add_utf_16be_uchar,
        add_string,
        add_bytes,
        add_substring,
        add_subbytes,
        add_substitute,
        add_buffer,
        add_channel,
        to_seq,
        to_seqi,
        add_seq,
        of_seq,
        add_int8,
        add_int8,
        add_int16_ne,
        add_int16_be,
        add_int16_le,
        add_int16_ne,
        add_int16_be,
        add_int16_le,
        add_int32_ne,
        add_int32_be,
        add_int32_le,
        add_int64_ne,
        add_int64_be,
        add_int64_le
    ];
    runtime.caml_register_global(14, Stdlib_Buffer, "Stdlib__Buffer");
    return;
})(globalThis);
//# 10568 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_mutex_lock = runtime.caml_ml_mutex_lock, caml_ml_mutex_unlock = runtime.caml_ml_mutex_unlock, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function protect(m, f) {
        caml_ml_mutex_lock(m);
        try {
            var x = caml_call1(f, 0);
        } catch (e$0) {
            var e = caml_wrap_exception(e$0);
            caml_ml_mutex_unlock(m);
            throw caml_maybe_attach_backtrace(e, 0);
        }
        caml_ml_mutex_unlock(m);
        return x;
    }
    var Stdlib_Mutex = [
        0,
        runtime.caml_ml_mutex_new,
        caml_ml_mutex_lock,
        runtime.caml_ml_mutex_try_lock,
        caml_ml_mutex_unlock,
        protect
    ];
    runtime.caml_register_global(0, Stdlib_Mutex, "Stdlib__Mutex");
    return;
})(globalThis);
//# 10606 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Stdlib_Condition = [
        0,
        runtime.caml_ml_condition_new,
        runtime.caml_ml_condition_wait,
        runtime.caml_ml_condition_signal,
        runtime.caml_ml_condition_broadcast
    ];
    runtime.caml_register_global(0, Stdlib_Condition, "Stdlib__Condition");
    return;
})(globalThis);
//# 10714 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_check_bound = runtime.caml_check_bound, caml_domain_dls_get = runtime.caml_domain_dls_get, caml_make_vect = runtime.caml_make_vect, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_domain_id = runtime.caml_ml_domain_id, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Stdlib_Condition = global_data.Stdlib__Condition, Stdlib_Mutex = global_data.Stdlib__Mutex, Stdlib_Atomic = global_data.Stdlib__Atomic, Stdlib = global_data.Stdlib, Stdlib_Array = global_data.Stdlib__Array, Stdlib_List = global_data.Stdlib__List, Assert_failure = global_data.Assert_failure;
    function cpu_relax(param) {
        return runtime.caml_ml_domain_cpu_relax(0);
    }
    var none = [
        0,
        0
    ];
    function create_dls(param) {
        var st = caml_make_vect(8, none);
        runtime.caml_domain_dls_set(st);
        return;
    }
    create_dls(0);
    var key_counter = caml_call1(Stdlib_Atomic[1], 0), parent_keys = caml_call1(Stdlib_Atomic[1], 0), _a_ = [
        0,
        "domain.ml",
        184,
        13
    ];
    function new_key(split_from_parent, init_orphan) {
        var idx = caml_call2(Stdlib_Atomic[7], key_counter, 1), k = [
            0,
            idx,
            init_orphan
        ];
        if (split_from_parent) {
            var split = split_from_parent[1], ki = [
                0,
                k,
                split
            ];
            for(;;){
                var l = caml_call1(Stdlib_Atomic[3], parent_keys);
                if (!(1 - caml_call3(Stdlib_Atomic[6], parent_keys, l, [
                    0,
                    ki,
                    l
                ]))) break;
            }
        }
        return k;
    }
    function maybe_grow(idx) {
        for(;;){
            var st = caml_domain_dls_get(0), sz = st.length - 1;
            if (idx < sz) return st;
            var new_sz = sz;
            for(;;){
                if (idx < new_sz) break;
                var s = 2 * new_sz | 0;
                new_sz = s;
            }
            var new_st = caml_make_vect(new_sz, none);
            caml_call5(Stdlib_Array[9], st, 0, new_st, 0, sz);
            if (runtime.caml_domain_dls_compare_and_set(st, new_st)) return new_st;
        }
    }
    function set(param, x) {
        var idx = param[1], st = maybe_grow(idx);
        caml_check_bound(st, idx)[1 + idx] = x;
        return 0;
    }
    function get(param) {
        var init = param[2], idx = param[1], st = maybe_grow(idx), oldval = caml_check_bound(st, idx)[1 + idx];
        if (oldval !== none) return oldval;
        var new_obj = caml_call1(init, 0), st$0 = caml_domain_dls_get(0), curval = caml_check_bound(st$0, idx)[1 + idx], _e_ = curval === oldval ? (st$0[1 + idx] = new_obj, 1) : 0;
        if (_e_) return new_obj;
        var updated_obj = caml_check_bound(st$0, idx)[1 + idx];
        if (updated_obj !== none) return updated_obj;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
    }
    function get_id(param) {
        var domain = param[1];
        return domain;
    }
    function self1(param) {
        return caml_ml_domain_id(0);
    }
    function is_main_domain(param) {
        return 0 === caml_ml_domain_id(0) ? 1 : 0;
    }
    var first_domain_spawned = caml_call1(Stdlib_Atomic[1], 0), first_spawn_function = [
        0,
        function(param) {
            return;
        }
    ], cst_first_domain_already_spawn = "first domain already spawned";
    function before_first_spawn(f) {
        if (caml_call1(Stdlib_Atomic[3], first_domain_spawned)) throw caml_maybe_attach_backtrace([
            0,
            Stdlib[6],
            cst_first_domain_already_spawn
        ], 1);
        var old_f = first_spawn_function[1];
        function new_f(param) {
            caml_call1(old_f, 0);
            return caml_call1(f, 0);
        }
        first_spawn_function[1] = new_f;
        return 0;
    }
    var at_exit_key = new_key(0, function(param) {
        return function(param) {
            return 0;
        };
    });
    function at_exit(f) {
        var old_exit = get(at_exit_key);
        function new_exit(param) {
            caml_call1(f, 0);
            return caml_call1(old_exit, 0);
        }
        return set(at_exit_key, new_exit);
    }
    function do_at_exit(param) {
        var f = get(at_exit_key);
        return caml_call1(f, 0);
    }
    Stdlib[104][1] = do_at_exit;
    function spawn(f) {
        if (1 - caml_call1(Stdlib_Atomic[3], first_domain_spawned)) {
            caml_call2(Stdlib_Atomic[4], first_domain_spawned, 1);
            caml_call1(first_spawn_function[1], 0);
            first_spawn_function[1] = function(param) {
                return 0;
            };
        }
        var _b_ = caml_call1(Stdlib_Atomic[3], parent_keys), pk = caml_call2(Stdlib_List[20], function(param) {
            var split = param[2], k = param[1];
            return [
                0,
                k,
                caml_call1(split, get(k))
            ];
        }, _b_), _c_ = caml_call1(Stdlib_Condition[1], 0), term_sync = [
            0,
            0,
            caml_call1(Stdlib_Mutex[1], 0),
            _c_
        ];
        function body(param) {
            try {
                create_dls(0);
                caml_call2(Stdlib_List[18], function(param) {
                    var v = param[2], k = param[1];
                    return set(k, v);
                }, pk);
                var res = caml_call1(f, 0);
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                try {
                    do_at_exit(0);
                } catch (_d_) {}
                throw caml_maybe_attach_backtrace(exn, 0);
            }
            do_at_exit(0);
            return res;
        }
        var domain = runtime.caml_domain_spawn(body, term_sync);
        return [
            0,
            domain,
            term_sync
        ];
    }
    function join(param) {
        var term_sync = param[2];
        function loop(param) {
            for(;;){
                var match = term_sync[1];
                if (match) {
                    var res = match[1];
                    return res;
                }
                caml_call2(Stdlib_Condition[2], term_sync[3], term_sync[2]);
            }
        }
        var match = caml_call2(Stdlib_Mutex[5], term_sync[2], loop);
        if (0 === match[0]) {
            var x = match[1];
            return x;
        }
        var ex = match[1];
        throw caml_maybe_attach_backtrace(ex, 1);
    }
    var recommended_domain_count = runtime.caml_recommended_domain_count, Stdlib_Domain = [
        0,
        spawn,
        join,
        get_id,
        self1,
        before_first_spawn,
        at_exit,
        cpu_relax,
        is_main_domain,
        recommended_domain_count,
        [
            0,
            new_key,
            get,
            set
        ]
    ];
    runtime.caml_register_global(9, Stdlib_Domain, "Stdlib__Domain");
    return;
})(globalThis);
//# 10919 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$43 = "", cst_and = " and ", cst_Li$3 = "%Li", cst_i$3 = "%i", cst_li$3 = "%li", cst_ni$3 = "%ni", cst_u$0 = "%u", cst$42 = "' '", cst$41 = "'#'", cst$39 = "'*'", cst$40 = "'+'", cst$44 = ", ", cst_0$3 = "0", cst_at_character_number = ": at character number ", cst$38 = "@[", cst$37 = "@{", cst_bad_input_format_type_mism = "bad input: format type mismatch between ", cst_bad_input_format_type_mism$0 = "bad input: format type mismatch between %S and %S", cst_camlinternalFormat_ml = "camlinternalFormat.ml", cst_invalid_format = "invalid format ", cst_precision$3 = "precision", caml_blit_string = runtime.caml_blit_string, caml_bytes_set = runtime.caml_bytes_set, caml_create_bytes = runtime.caml_create_bytes, caml_format_float = runtime.caml_format_float, caml_format_int = runtime.caml_format_int, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_notequal = runtime.caml_notequal, caml_string_get = runtime.caml_string_get, caml_string_unsafe_get = runtime.caml_string_unsafe_get, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), cst$9 = "%{", cst$10 = "%}", cst$11 = "%(", cst$12 = "%)", cst$13 = "%?", cst$18 = cst$37, cst$19 = cst$38, cst$20 = cst$37, cst$21 = cst$38, cst$22 = cst$37, cst$23 = cst$38, cst$26 = cst$39, cst$24 = "'-'", cst$25 = cst$39, cst$27 = cst$40, cst$28 = cst$41, cst$29 = cst$42, cst$30 = cst$40, cst$31 = "'_'", sub_format = [
        0,
        0,
        cst$43
    ], formatting_lit = [
        0,
        "@;",
        1,
        0
    ], cst$35 = cst$41, cst$32 = cst$40, cst$33 = cst$40, cst$34 = cst$42, cst$36 = cst$40, cst_unexpected_end_of_format = "unexpected end of format", cst$17 = ".", cst$14 = "%!", cst$15 = cst$37, cst$16 = cst$38, cst$8 = "%%", cst$0 = "@]", cst$1 = "@}", cst$2 = "@?", cst$3 = "@\n", cst$4 = "@.", cst$5 = "@@", cst$6 = "@%", cst$7 = "@", cst = ".*", Assert_failure = global_data.Assert_failure, CamlinternalFormatBasics = global_data.CamlinternalFormatBasics, Stdlib = global_data.Stdlib, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_String = global_data.Stdlib__String, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Char = global_data.Stdlib__Char, Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib_Int = global_data.Stdlib__Int, _a_ = [
        0,
        0,
        0
    ], cst_c = "%c", cst_s = "%s", cst_i = cst_i$3, cst_li = cst_li$3, cst_ni = cst_ni$3, cst_Li = cst_Li$3, cst_f = "%f", cst_B = "%B", cst_a = "%a", cst_t = "%t", cst_r = "%r", cst_r$0 = "%_r", cst_0c = "0c", _b_ = [
        0,
        cst_camlinternalFormat_ml,
        850,
        23
    ], _c_ = [
        0,
        cst_camlinternalFormat_ml,
        837,
        26
    ], _d_ = [
        0,
        cst_camlinternalFormat_ml,
        847,
        28
    ], _e_ = [
        0,
        cst_camlinternalFormat_ml,
        815,
        21
    ], _f_ = [
        0,
        cst_camlinternalFormat_ml,
        819,
        21
    ], _g_ = [
        0,
        cst_camlinternalFormat_ml,
        823,
        19
    ], _h_ = [
        0,
        cst_camlinternalFormat_ml,
        827,
        22
    ], _i_ = [
        0,
        cst_camlinternalFormat_ml,
        832,
        30
    ], _j_ = [
        0,
        cst_camlinternalFormat_ml,
        851,
        23
    ], _k_ = [
        0,
        cst_camlinternalFormat_ml,
        836,
        26
    ], _l_ = [
        0,
        cst_camlinternalFormat_ml,
        846,
        28
    ], _m_ = [
        0,
        cst_camlinternalFormat_ml,
        814,
        21
    ], _n_ = [
        0,
        cst_camlinternalFormat_ml,
        818,
        21
    ], _o_ = [
        0,
        cst_camlinternalFormat_ml,
        822,
        19
    ], _p_ = [
        0,
        cst_camlinternalFormat_ml,
        826,
        22
    ], _q_ = [
        0,
        cst_camlinternalFormat_ml,
        831,
        30
    ];
    function create_char_set(param) {
        return caml_call2(Stdlib_Bytes[1], 32, 0);
    }
    function add_in_char_set(char_set, c) {
        var str_ind = c >>> 3 | 0, mask = 1 << (c & 7), _cU_ = runtime.caml_bytes_get(char_set, str_ind) | mask;
        return caml_bytes_set(char_set, str_ind, caml_call1(Stdlib[29], _cU_));
    }
    function freeze_char_set(char_set) {
        return caml_call1(Stdlib_Bytes[6], char_set);
    }
    function rev_char_set(char_set) {
        var char_set$0 = create_char_set(0), i = 0;
        for(;;){
            var _cS_ = caml_string_get(char_set, i) ^ 255;
            caml_bytes_set(char_set$0, i, caml_call1(Stdlib[29], _cS_));
            var _cT_ = i + 1 | 0;
            if (31 === i) return caml_call1(Stdlib_Bytes[44], char_set$0);
            i = _cT_;
        }
    }
    function is_in_char_set(char_set, c) {
        var str_ind = c >>> 3 | 0, mask = 1 << (c & 7);
        return 0 !== (caml_string_get(char_set, str_ind) & mask) ? 1 : 0;
    }
    function pad_of_pad_opt(pad_opt) {
        if (!pad_opt) return 0;
        var width = pad_opt[1];
        return [
            0,
            1,
            width
        ];
    }
    function param_format_of_ignored_format(ign, fmt) {
        if (typeof ign === "number") switch(ign){
            case 0:
                return [
                    0,
                    [
                        0,
                        fmt
                    ]
                ];
            case 1:
                return [
                    0,
                    [
                        1,
                        fmt
                    ]
                ];
            case 2:
                return [
                    0,
                    [
                        19,
                        fmt
                    ]
                ];
            default:
                return [
                    0,
                    [
                        22,
                        fmt
                    ]
                ];
        }
        switch(ign[0]){
            case 0:
                var pad_opt = ign[1];
                return [
                    0,
                    [
                        2,
                        pad_of_pad_opt(pad_opt),
                        fmt
                    ]
                ];
            case 1:
                var pad_opt$0 = ign[1];
                return [
                    0,
                    [
                        3,
                        pad_of_pad_opt(pad_opt$0),
                        fmt
                    ]
                ];
            case 2:
                var pad_opt$1 = ign[2], iconv = ign[1];
                return [
                    0,
                    [
                        4,
                        iconv,
                        pad_of_pad_opt(pad_opt$1),
                        0,
                        fmt
                    ]
                ];
            case 3:
                var pad_opt$2 = ign[2], iconv$0 = ign[1];
                return [
                    0,
                    [
                        5,
                        iconv$0,
                        pad_of_pad_opt(pad_opt$2),
                        0,
                        fmt
                    ]
                ];
            case 4:
                var pad_opt$3 = ign[2], iconv$1 = ign[1];
                return [
                    0,
                    [
                        6,
                        iconv$1,
                        pad_of_pad_opt(pad_opt$3),
                        0,
                        fmt
                    ]
                ];
            case 5:
                var pad_opt$4 = ign[2], iconv$2 = ign[1];
                return [
                    0,
                    [
                        7,
                        iconv$2,
                        pad_of_pad_opt(pad_opt$4),
                        0,
                        fmt
                    ]
                ];
            case 6:
                var prec_opt = ign[2], pad_opt$5 = ign[1];
                if (prec_opt) var ndec = prec_opt[1], _cR_ = [
                    0,
                    ndec
                ];
                else var _cR_ = 0;
                return [
                    0,
                    [
                        8,
                        _a_,
                        pad_of_pad_opt(pad_opt$5),
                        _cR_,
                        fmt
                    ]
                ];
            case 7:
                var pad_opt$6 = ign[1];
                return [
                    0,
                    [
                        9,
                        pad_of_pad_opt(pad_opt$6),
                        fmt
                    ]
                ];
            case 8:
                var fmtty = ign[2], pad_opt$7 = ign[1];
                return [
                    0,
                    [
                        13,
                        pad_opt$7,
                        fmtty,
                        fmt
                    ]
                ];
            case 9:
                var fmtty$0 = ign[2], pad_opt$8 = ign[1];
                return [
                    0,
                    [
                        14,
                        pad_opt$8,
                        fmtty$0,
                        fmt
                    ]
                ];
            case 10:
                var char_set = ign[2], width_opt = ign[1];
                return [
                    0,
                    [
                        20,
                        width_opt,
                        char_set,
                        fmt
                    ]
                ];
            default:
                var counter = ign[1];
                return [
                    0,
                    [
                        21,
                        counter,
                        fmt
                    ]
                ];
        }
    }
    function default_float_precision(fconv) {
        return 5 === fconv[2] ? 12 : -6;
    }
    function buffer_create(init_size) {
        return [
            0,
            0,
            caml_create_bytes(init_size)
        ];
    }
    function buffer_check_size(buf, overhead) {
        var len = runtime.caml_ml_bytes_length(buf[2]), min_len = buf[1] + overhead | 0;
        if (len < min_len) {
            var new_len = caml_call2(Stdlib_Int[11], len * 2 | 0, min_len), new_str = caml_create_bytes(new_len);
            caml_call5(Stdlib_Bytes[11], buf[2], 0, new_str, 0, len);
            buf[2] = new_str;
        }
        return;
    }
    function buffer_add_char(buf, c) {
        buffer_check_size(buf, 1);
        caml_bytes_set(buf[2], buf[1], c);
        buf[1] = buf[1] + 1 | 0;
        return;
    }
    function buffer_add_string(buf, s) {
        var str_len = caml_ml_string_length(s);
        buffer_check_size(buf, str_len);
        caml_call5(Stdlib_String[6], s, 0, buf[2], buf[1], str_len);
        buf[1] = buf[1] + str_len | 0;
        return;
    }
    function buffer_contents(buf) {
        return caml_call3(Stdlib_Bytes[8], buf[2], 0, buf[1]);
    }
    function char_of_iconv(iconv) {
        switch(iconv){
            case 6:
            case 7:
                return 120;
            case 8:
            case 9:
                return 88;
            case 10:
            case 11:
                return 111;
            case 12:
            case 15:
                return 117;
            case 0:
            case 1:
            case 2:
            case 13:
                return 100;
            default:
                return 105;
        }
    }
    function char_of_fconv(opt, fconv) {
        var cF = opt ? opt[1] : 70;
        switch(fconv[2]){
            case 0:
                return 102;
            case 1:
                return 101;
            case 2:
                return 69;
            case 3:
                return 103;
            case 4:
                return 71;
            case 5:
                return cF;
            case 6:
                return 104;
            case 7:
                return 72;
            default:
                return 70;
        }
    }
    function bprint_padty(buf, padty) {
        switch(padty){
            case 0:
                return buffer_add_char(buf, 45);
            case 1:
                return;
            default:
                return buffer_add_char(buf, 48);
        }
    }
    function bprint_ignored_flag(buf, ign_flag) {
        return ign_flag ? buffer_add_char(buf, 95) : ign_flag;
    }
    function bprint_pad_opt(buf, pad_opt) {
        if (!pad_opt) return;
        var width = pad_opt[1];
        return buffer_add_string(buf, caml_call1(Stdlib_Int[12], width));
    }
    function bprint_padding(buf, pad) {
        if (typeof pad === "number") return;
        if (0 === pad[0]) {
            var n = pad[2], padty = pad[1];
            bprint_padty(buf, padty);
            return buffer_add_string(buf, caml_call1(Stdlib_Int[12], n));
        }
        var padty$0 = pad[1];
        bprint_padty(buf, padty$0);
        return buffer_add_char(buf, 42);
    }
    function bprint_precision(buf, prec) {
        if (typeof prec !== "number") {
            var n = prec[1];
            buffer_add_char(buf, 46);
            return buffer_add_string(buf, caml_call1(Stdlib_Int[12], n));
        }
        if (prec) return buffer_add_string(buf, cst);
        return;
    }
    function bprint_iconv_flag(buf, iconv) {
        switch(iconv){
            case 1:
            case 4:
                return buffer_add_char(buf, 43);
            case 2:
            case 5:
                return buffer_add_char(buf, 32);
            case 7:
            case 9:
            case 11:
            case 13:
            case 14:
            case 15:
                return buffer_add_char(buf, 35);
            default:
                return;
        }
    }
    function bprint_altint_fmt(buf, ign_flag, iconv, pad, prec, c) {
        buffer_add_char(buf, 37);
        bprint_ignored_flag(buf, ign_flag);
        bprint_iconv_flag(buf, iconv);
        bprint_padding(buf, pad);
        bprint_precision(buf, prec);
        buffer_add_char(buf, c);
        return buffer_add_char(buf, char_of_iconv(iconv));
    }
    function bprint_fconv_flag(buf, fconv) {
        switch(fconv[1]){
            case 0:
                break;
            case 1:
                buffer_add_char(buf, 43);
                break;
            default:
                buffer_add_char(buf, 32);
        }
        if (8 <= fconv[2]) return buffer_add_char(buf, 35);
        return;
    }
    function string_of_formatting_lit(formatting_lit) {
        if (typeof formatting_lit === "number") switch(formatting_lit){
            case 0:
                return cst$0;
            case 1:
                return cst$1;
            case 2:
                return cst$2;
            case 3:
                return cst$3;
            case 4:
                return cst$4;
            case 5:
                return cst$5;
            default:
                return cst$6;
        }
        switch(formatting_lit[0]){
            case 0:
                var str = formatting_lit[1];
                return str;
            case 1:
                var str$0 = formatting_lit[1];
                return str$0;
            default:
                var c = formatting_lit[1], _cQ_ = caml_call2(Stdlib_String[1], 1, c);
                return caml_call2(Stdlib[28], cst$7, _cQ_);
        }
    }
    function bprint_char_literal(buf, chr) {
        return 37 === chr ? buffer_add_string(buf, cst$8) : buffer_add_char(buf, chr);
    }
    function bprint_string_literal(buf, str) {
        var _cO_ = caml_ml_string_length(str) - 1 | 0, _cN_ = 0;
        if (_cO_ >= 0) {
            var i = _cN_;
            for(;;){
                bprint_char_literal(buf, caml_string_get(str, i));
                var _cP_ = i + 1 | 0;
                if (_cO_ === i) break;
                i = _cP_;
            }
        }
        return;
    }
    function bprint_fmtty(buf, fmtty) {
        var fmtty$0 = fmtty;
        for(;;){
            if (typeof fmtty$0 === "number") return;
            switch(fmtty$0[0]){
                case 0:
                    var fmtty$1 = fmtty$0[1];
                    buffer_add_string(buf, cst_c);
                    fmtty$0 = fmtty$1;
                    break;
                case 1:
                    var fmtty$2 = fmtty$0[1];
                    buffer_add_string(buf, cst_s);
                    fmtty$0 = fmtty$2;
                    break;
                case 2:
                    var fmtty$3 = fmtty$0[1];
                    buffer_add_string(buf, cst_i);
                    fmtty$0 = fmtty$3;
                    break;
                case 3:
                    var fmtty$4 = fmtty$0[1];
                    buffer_add_string(buf, cst_li);
                    fmtty$0 = fmtty$4;
                    break;
                case 4:
                    var fmtty$5 = fmtty$0[1];
                    buffer_add_string(buf, cst_ni);
                    fmtty$0 = fmtty$5;
                    break;
                case 5:
                    var fmtty$6 = fmtty$0[1];
                    buffer_add_string(buf, cst_Li);
                    fmtty$0 = fmtty$6;
                    break;
                case 6:
                    var fmtty$7 = fmtty$0[1];
                    buffer_add_string(buf, cst_f);
                    fmtty$0 = fmtty$7;
                    break;
                case 7:
                    var fmtty$8 = fmtty$0[1];
                    buffer_add_string(buf, cst_B);
                    fmtty$0 = fmtty$8;
                    break;
                case 8:
                    var fmtty$9 = fmtty$0[2], sub_fmtty = fmtty$0[1];
                    buffer_add_string(buf, cst$9);
                    bprint_fmtty(buf, sub_fmtty);
                    buffer_add_string(buf, cst$10);
                    fmtty$0 = fmtty$9;
                    break;
                case 9:
                    var fmtty$10 = fmtty$0[3], sub_fmtty$0 = fmtty$0[1];
                    buffer_add_string(buf, cst$11);
                    bprint_fmtty(buf, sub_fmtty$0);
                    buffer_add_string(buf, cst$12);
                    fmtty$0 = fmtty$10;
                    break;
                case 10:
                    var fmtty$11 = fmtty$0[1];
                    buffer_add_string(buf, cst_a);
                    fmtty$0 = fmtty$11;
                    break;
                case 11:
                    var fmtty$12 = fmtty$0[1];
                    buffer_add_string(buf, cst_t);
                    fmtty$0 = fmtty$12;
                    break;
                case 12:
                    var fmtty$13 = fmtty$0[1];
                    buffer_add_string(buf, cst$13);
                    fmtty$0 = fmtty$13;
                    break;
                case 13:
                    var fmtty$14 = fmtty$0[1];
                    buffer_add_string(buf, cst_r);
                    fmtty$0 = fmtty$14;
                    break;
                default:
                    var fmtty$15 = fmtty$0[1];
                    buffer_add_string(buf, cst_r$0);
                    fmtty$0 = fmtty$15;
            }
        }
    }
    function int_of_custom_arity(param) {
        if (!param) return 0;
        var x = param[1];
        return 1 + int_of_custom_arity(x) | 0;
    }
    function string_of_fmt(fmt) {
        var buf = buffer_create(16);
        function fmtiter(fmt, ign_flag) {
            var fmt$0 = fmt, ign_flag$0 = ign_flag;
            for(;;){
                if (typeof fmt$0 === "number") return;
                switch(fmt$0[0]){
                    case 0:
                        var rest = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        buffer_add_char(buf, 99);
                        fmt$0 = rest;
                        ign_flag$0 = 0;
                        break;
                    case 1:
                        var rest$0 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        buffer_add_char(buf, 67);
                        fmt$0 = rest$0;
                        ign_flag$0 = 0;
                        break;
                    case 2:
                        var rest$1 = fmt$0[2], pad = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_padding(buf, pad);
                        buffer_add_char(buf, 115);
                        fmt$0 = rest$1;
                        ign_flag$0 = 0;
                        break;
                    case 3:
                        var rest$2 = fmt$0[2], pad$0 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_padding(buf, pad$0);
                        buffer_add_char(buf, 83);
                        fmt$0 = rest$2;
                        ign_flag$0 = 0;
                        break;
                    case 4:
                        var rest$3 = fmt$0[4], prec = fmt$0[3], pad$1 = fmt$0[2], iconv = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_iconv_flag(buf, iconv);
                        bprint_padding(buf, pad$1);
                        bprint_precision(buf, prec);
                        buffer_add_char(buf, char_of_iconv(iconv));
                        fmt$0 = rest$3;
                        ign_flag$0 = 0;
                        break;
                    case 5:
                        var rest$4 = fmt$0[4], prec$0 = fmt$0[3], pad$2 = fmt$0[2], iconv$0 = fmt$0[1];
                        bprint_altint_fmt(buf, ign_flag$0, iconv$0, pad$2, prec$0, 108);
                        fmt$0 = rest$4;
                        ign_flag$0 = 0;
                        break;
                    case 6:
                        var rest$5 = fmt$0[4], prec$1 = fmt$0[3], pad$3 = fmt$0[2], iconv$1 = fmt$0[1];
                        bprint_altint_fmt(buf, ign_flag$0, iconv$1, pad$3, prec$1, 110);
                        fmt$0 = rest$5;
                        ign_flag$0 = 0;
                        break;
                    case 7:
                        var rest$6 = fmt$0[4], prec$2 = fmt$0[3], pad$4 = fmt$0[2], iconv$2 = fmt$0[1];
                        bprint_altint_fmt(buf, ign_flag$0, iconv$2, pad$4, prec$2, 76);
                        fmt$0 = rest$6;
                        ign_flag$0 = 0;
                        break;
                    case 8:
                        var rest$7 = fmt$0[4], prec$3 = fmt$0[3], pad$5 = fmt$0[2], fconv = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_fconv_flag(buf, fconv);
                        bprint_padding(buf, pad$5);
                        bprint_precision(buf, prec$3);
                        buffer_add_char(buf, char_of_fconv(0, fconv));
                        fmt$0 = rest$7;
                        ign_flag$0 = 0;
                        break;
                    case 9:
                        var rest$8 = fmt$0[2], pad$6 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_padding(buf, pad$6);
                        buffer_add_char(buf, 66);
                        fmt$0 = rest$8;
                        ign_flag$0 = 0;
                        break;
                    case 10:
                        var rest$9 = fmt$0[1];
                        buffer_add_string(buf, cst$14);
                        fmt$0 = rest$9;
                        break;
                    case 11:
                        var rest$10 = fmt$0[2], str = fmt$0[1];
                        bprint_string_literal(buf, str);
                        fmt$0 = rest$10;
                        break;
                    case 12:
                        var rest$11 = fmt$0[2], chr = fmt$0[1];
                        bprint_char_literal(buf, chr);
                        fmt$0 = rest$11;
                        break;
                    case 13:
                        var rest$12 = fmt$0[3], fmtty = fmt$0[2], pad_opt = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_pad_opt(buf, pad_opt);
                        buffer_add_char(buf, 123);
                        bprint_fmtty(buf, fmtty);
                        buffer_add_char(buf, 37);
                        buffer_add_char(buf, 125);
                        fmt$0 = rest$12;
                        ign_flag$0 = 0;
                        break;
                    case 14:
                        var rest$13 = fmt$0[3], fmtty$0 = fmt$0[2], pad_opt$0 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_pad_opt(buf, pad_opt$0);
                        buffer_add_char(buf, 40);
                        bprint_fmtty(buf, fmtty$0);
                        buffer_add_char(buf, 37);
                        buffer_add_char(buf, 41);
                        fmt$0 = rest$13;
                        ign_flag$0 = 0;
                        break;
                    case 15:
                        var rest$14 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        buffer_add_char(buf, 97);
                        fmt$0 = rest$14;
                        ign_flag$0 = 0;
                        break;
                    case 16:
                        var rest$15 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        buffer_add_char(buf, 116);
                        fmt$0 = rest$15;
                        ign_flag$0 = 0;
                        break;
                    case 17:
                        var rest$16 = fmt$0[2], fmting_lit = fmt$0[1];
                        bprint_string_literal(buf, string_of_formatting_lit(fmting_lit));
                        fmt$0 = rest$16;
                        break;
                    case 18:
                        var rest$17 = fmt$0[2], fmting_gen = fmt$0[1];
                        if (0 === fmting_gen[0]) {
                            var str$0 = fmting_gen[1][2];
                            buffer_add_string(buf, cst$15);
                            buffer_add_string(buf, str$0);
                        } else {
                            var str$1 = fmting_gen[1][2];
                            buffer_add_string(buf, cst$16);
                            buffer_add_string(buf, str$1);
                        }
                        fmt$0 = rest$17;
                        break;
                    case 19:
                        var rest$18 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        buffer_add_char(buf, 114);
                        fmt$0 = rest$18;
                        ign_flag$0 = 0;
                        break;
                    case 20:
                        var rest$19 = fmt$0[3], char_set = fmt$0[2], width_opt = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_pad_opt(buf, width_opt);
                        var print_char = function(buf, i) {
                            var c = caml_call1(Stdlib[29], i);
                            return 37 === c ? (buffer_add_char(buf, 37), buffer_add_char(buf, 37)) : 64 === c ? (buffer_add_char(buf, 37), buffer_add_char(buf, 64)) : buffer_add_char(buf, c);
                        };
                        buffer_add_char(buf, 91);
                        var set = is_in_char_set(char_set, 0) ? (buffer_add_char(buf, 94), rev_char_set(char_set)) : char_set;
                        let set$0 = set;
                        var is_alone = function(c) {
                            var after = caml_call1(Stdlib_Char[1], c + 1 | 0), before = caml_call1(Stdlib_Char[1], c - 1 | 0), _cJ_ = is_in_char_set(set$0, c);
                            if (_cJ_) var _cK_ = is_in_char_set(set$0, before), _cL_ = _cK_ ? is_in_char_set(set$0, after) : _cK_, _cM_ = 1 - _cL_;
                            else var _cM_ = _cJ_;
                            return _cM_;
                        };
                        if (is_alone(93)) buffer_add_char(buf, 93);
                        a: b: {
                            c: {
                                d: {
                                    var i = 1;
                                    for(;;){
                                        if (i >= 256) break;
                                        if (is_in_char_set(set, caml_call1(Stdlib[29], i))) {
                                            var switcher = caml_call1(Stdlib[29], i) - 45 | 0;
                                            if (48 < switcher >>> 0) {
                                                if (210 <= switcher) break d;
                                            } else if (46 < switcher - 1 >>> 0) {
                                                var i$2 = i + 1 | 0;
                                                i = i$2;
                                                continue;
                                            }
                                            var i$1 = i + 1 | 0;
                                            if (is_in_char_set(set, caml_call1(Stdlib[29], i$1))) {
                                                var switcher$0 = caml_call1(Stdlib[29], i$1) - 45 | 0;
                                                if (48 < switcher$0 >>> 0) {
                                                    if (210 <= switcher$0) break c;
                                                } else if (46 < switcher$0 - 1 >>> 0 && !is_in_char_set(set, caml_call1(Stdlib[29], i$1 + 1 | 0))) {
                                                    print_char(buf, i$1 - 1 | 0);
                                                    var i$5 = i$1 + 1 | 0;
                                                    i = i$5;
                                                    continue;
                                                }
                                                if (is_in_char_set(set, caml_call1(Stdlib[29], i$1 + 1 | 0))) {
                                                    var j = i$1 + 2 | 0, i$3 = i$1 - 1 | 0, j$0 = j;
                                                    for(;;){
                                                        if (256 === j$0) break;
                                                        if (!is_in_char_set(set, caml_call1(Stdlib[29], j$0))) break;
                                                        var j$1 = j$0 + 1 | 0;
                                                        j$0 = j$1;
                                                    }
                                                    print_char(buf, i$3);
                                                    print_char(buf, 45);
                                                    print_char(buf, j$0 - 1 | 0);
                                                    if (j$0 >= 256) break b;
                                                    var i$7 = j$0 + 1 | 0;
                                                    i = i$7;
                                                } else {
                                                    print_char(buf, i$1 - 1 | 0);
                                                    print_char(buf, i$1);
                                                    var i$4 = i$1 + 2 | 0;
                                                    i = i$4;
                                                }
                                            } else {
                                                print_char(buf, i$1 - 1 | 0);
                                                var i$6 = i$1 + 1 | 0;
                                                i = i$6;
                                            }
                                        } else {
                                            var i$0 = i + 1 | 0;
                                            i = i$0;
                                        }
                                    }
                                    break a;
                                }
                                print_char(buf, 255);
                                break a;
                            }
                            print_char(buf, 254);
                            print_char(buf, 255);
                            break a;
                        }
                        if (is_alone(45)) buffer_add_char(buf, 45);
                        buffer_add_char(buf, 93);
                        fmt$0 = rest$19;
                        ign_flag$0 = 0;
                        break;
                    case 21:
                        var rest$20 = fmt$0[2], counter = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        switch(counter){
                            case 0:
                                var _cF_ = 108;
                                break;
                            case 1:
                                var _cF_ = 110;
                                break;
                            default:
                                var _cF_ = 78;
                        }
                        buffer_add_char(buf, _cF_);
                        fmt$0 = rest$20;
                        ign_flag$0 = 0;
                        break;
                    case 22:
                        var rest$21 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_string_literal(buf, cst_0c);
                        fmt$0 = rest$21;
                        ign_flag$0 = 0;
                        break;
                    case 23:
                        var rest$22 = fmt$0[2], ign = fmt$0[1], fmt$1 = param_format_of_ignored_format(ign, rest$22)[1];
                        fmt$0 = fmt$1;
                        ign_flag$0 = 1;
                        break;
                    default:
                        var rest$23 = fmt$0[3], arity = fmt$0[1], _cH_ = int_of_custom_arity(arity), _cG_ = 1;
                        if (_cH_ >= 1) {
                            var i$8 = _cG_;
                            for(;;){
                                buffer_add_char(buf, 37);
                                bprint_ignored_flag(buf, ign_flag$0);
                                buffer_add_char(buf, 63);
                                var _cI_ = i$8 + 1 | 0;
                                if (_cH_ === i$8) break;
                                i$8 = _cI_;
                            }
                        }
                        fmt$0 = rest$23;
                        ign_flag$0 = 0;
                }
            }
        }
        fmtiter(fmt, 0);
        return buffer_contents(buf);
    }
    function symm(param) {
        if (typeof param === "number") return 0;
        switch(param[0]){
            case 0:
                var rest = param[1];
                return [
                    0,
                    symm(rest)
                ];
            case 1:
                var rest$0 = param[1];
                return [
                    1,
                    symm(rest$0)
                ];
            case 2:
                var rest$1 = param[1];
                return [
                    2,
                    symm(rest$1)
                ];
            case 3:
                var rest$2 = param[1];
                return [
                    3,
                    symm(rest$2)
                ];
            case 4:
                var rest$3 = param[1];
                return [
                    4,
                    symm(rest$3)
                ];
            case 5:
                var rest$4 = param[1];
                return [
                    5,
                    symm(rest$4)
                ];
            case 6:
                var rest$5 = param[1];
                return [
                    6,
                    symm(rest$5)
                ];
            case 7:
                var rest$6 = param[1];
                return [
                    7,
                    symm(rest$6)
                ];
            case 8:
                var rest$7 = param[2], ty = param[1];
                return [
                    8,
                    ty,
                    symm(rest$7)
                ];
            case 9:
                var rest$8 = param[3], ty2 = param[2], ty1 = param[1];
                return [
                    9,
                    ty2,
                    ty1,
                    symm(rest$8)
                ];
            case 10:
                var rest$9 = param[1];
                return [
                    10,
                    symm(rest$9)
                ];
            case 11:
                var rest$10 = param[1];
                return [
                    11,
                    symm(rest$10)
                ];
            case 12:
                var rest$11 = param[1];
                return [
                    12,
                    symm(rest$11)
                ];
            case 13:
                var rest$12 = param[1];
                return [
                    13,
                    symm(rest$12)
                ];
            default:
                var rest$13 = param[1];
                return [
                    14,
                    symm(rest$13)
                ];
        }
    }
    function fmtty_rel_det(param) {
        if (typeof param === "number") return [
            0,
            function(param) {
                return;
            },
            function(param) {
                return;
            },
            function(param) {
                return;
            },
            function(param) {
                return;
            }
        ];
        switch(param[0]){
            case 0:
                var rest = param[1], match = fmtty_rel_det(rest), de = match[4], ed = match[3], af = match[2], fa = match[1];
                return [
                    0,
                    function(param) {
                        fa(0);
                        return;
                    },
                    function(param) {
                        af(0);
                        return;
                    },
                    ed,
                    de
                ];
            case 1:
                var rest$0 = param[1], match$0 = fmtty_rel_det(rest$0), de$0 = match$0[4], ed$0 = match$0[3], af$0 = match$0[2], fa$0 = match$0[1];
                return [
                    0,
                    function(param) {
                        fa$0(0);
                        return;
                    },
                    function(param) {
                        af$0(0);
                        return;
                    },
                    ed$0,
                    de$0
                ];
            case 2:
                var rest$1 = param[1], match$1 = fmtty_rel_det(rest$1), de$1 = match$1[4], ed$1 = match$1[3], af$1 = match$1[2], fa$1 = match$1[1];
                return [
                    0,
                    function(param) {
                        fa$1(0);
                        return;
                    },
                    function(param) {
                        af$1(0);
                        return;
                    },
                    ed$1,
                    de$1
                ];
            case 3:
                var rest$2 = param[1], match$2 = fmtty_rel_det(rest$2), de$2 = match$2[4], ed$2 = match$2[3], af$2 = match$2[2], fa$2 = match$2[1];
                return [
                    0,
                    function(param) {
                        fa$2(0);
                        return;
                    },
                    function(param) {
                        af$2(0);
                        return;
                    },
                    ed$2,
                    de$2
                ];
            case 4:
                var rest$3 = param[1], match$3 = fmtty_rel_det(rest$3), de$3 = match$3[4], ed$3 = match$3[3], af$3 = match$3[2], fa$3 = match$3[1];
                return [
                    0,
                    function(param) {
                        fa$3(0);
                        return;
                    },
                    function(param) {
                        af$3(0);
                        return;
                    },
                    ed$3,
                    de$3
                ];
            case 5:
                var rest$4 = param[1], match$4 = fmtty_rel_det(rest$4), de$4 = match$4[4], ed$4 = match$4[3], af$4 = match$4[2], fa$4 = match$4[1];
                return [
                    0,
                    function(param) {
                        fa$4(0);
                        return;
                    },
                    function(param) {
                        af$4(0);
                        return;
                    },
                    ed$4,
                    de$4
                ];
            case 6:
                var rest$5 = param[1], match$5 = fmtty_rel_det(rest$5), de$5 = match$5[4], ed$5 = match$5[3], af$5 = match$5[2], fa$5 = match$5[1];
                return [
                    0,
                    function(param) {
                        fa$5(0);
                        return;
                    },
                    function(param) {
                        af$5(0);
                        return;
                    },
                    ed$5,
                    de$5
                ];
            case 7:
                var rest$6 = param[1], match$6 = fmtty_rel_det(rest$6), de$6 = match$6[4], ed$6 = match$6[3], af$6 = match$6[2], fa$6 = match$6[1];
                return [
                    0,
                    function(param) {
                        fa$6(0);
                        return;
                    },
                    function(param) {
                        af$6(0);
                        return;
                    },
                    ed$6,
                    de$6
                ];
            case 8:
                var rest$7 = param[2], match$7 = fmtty_rel_det(rest$7), de$7 = match$7[4], ed$7 = match$7[3], af$7 = match$7[2], fa$7 = match$7[1];
                return [
                    0,
                    function(param) {
                        fa$7(0);
                        return;
                    },
                    function(param) {
                        af$7(0);
                        return;
                    },
                    ed$7,
                    de$7
                ];
            case 9:
                var rest$8 = param[3], ty2 = param[2], ty1 = param[1], match$8 = fmtty_rel_det(rest$8), de$8 = match$8[4], ed$8 = match$8[3], af$8 = match$8[2], fa$8 = match$8[1], ty = trans(symm(ty1), ty2), match$9 = fmtty_rel_det(ty), jd = match$9[4], dj = match$9[3], ga = match$9[2], ag = match$9[1];
                return [
                    0,
                    function(param) {
                        fa$8(0);
                        ag(0);
                        return;
                    },
                    function(param) {
                        ga(0);
                        af$8(0);
                        return;
                    },
                    function(param) {
                        ed$8(0);
                        dj(0);
                        return;
                    },
                    function(param) {
                        jd(0);
                        de$8(0);
                        return;
                    }
                ];
            case 10:
                var rest$9 = param[1], match$10 = fmtty_rel_det(rest$9), de$9 = match$10[4], ed$9 = match$10[3], af$9 = match$10[2], fa$9 = match$10[1];
                return [
                    0,
                    function(param) {
                        fa$9(0);
                        return;
                    },
                    function(param) {
                        af$9(0);
                        return;
                    },
                    ed$9,
                    de$9
                ];
            case 11:
                var rest$10 = param[1], match$11 = fmtty_rel_det(rest$10), de$10 = match$11[4], ed$10 = match$11[3], af$10 = match$11[2], fa$10 = match$11[1];
                return [
                    0,
                    function(param) {
                        fa$10(0);
                        return;
                    },
                    function(param) {
                        af$10(0);
                        return;
                    },
                    ed$10,
                    de$10
                ];
            case 12:
                var rest$11 = param[1], match$12 = fmtty_rel_det(rest$11), de$11 = match$12[4], ed$11 = match$12[3], af$11 = match$12[2], fa$11 = match$12[1];
                return [
                    0,
                    function(param) {
                        fa$11(0);
                        return;
                    },
                    function(param) {
                        af$11(0);
                        return;
                    },
                    ed$11,
                    de$11
                ];
            case 13:
                var rest$12 = param[1], match$13 = fmtty_rel_det(rest$12), de$12 = match$13[4], ed$12 = match$13[3], af$12 = match$13[2], fa$12 = match$13[1];
                return [
                    0,
                    function(param) {
                        fa$12(0);
                        return;
                    },
                    function(param) {
                        af$12(0);
                        return;
                    },
                    function(param) {
                        ed$12(0);
                        return;
                    },
                    function(param) {
                        de$12(0);
                        return;
                    }
                ];
            default:
                var rest$13 = param[1], match$14 = fmtty_rel_det(rest$13), de$13 = match$14[4], ed$13 = match$14[3], af$13 = match$14[2], fa$13 = match$14[1];
                return [
                    0,
                    function(param) {
                        fa$13(0);
                        return;
                    },
                    function(param) {
                        af$13(0);
                        return;
                    },
                    function(param) {
                        ed$13(0);
                        return;
                    },
                    function(param) {
                        de$13(0);
                        return;
                    }
                ];
        }
    }
    function trans(ty1, ty2) {
        a: {
            b: {
                c: {
                    d: {
                        e: {
                            f: {
                                g: {
                                    if (typeof ty1 !== "number") {
                                        switch(ty1[0]){
                                            case 0:
                                                var rest1 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 0:
                                                        var rest2 = ty2[1];
                                                        return [
                                                            0,
                                                            trans(rest1, rest2)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 1:
                                                var rest1$0 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 1:
                                                        var rest2$0 = ty2[1];
                                                        return [
                                                            1,
                                                            trans(rest1$0, rest2$0)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 2:
                                                var rest1$1 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 2:
                                                        var rest2$1 = ty2[1];
                                                        return [
                                                            2,
                                                            trans(rest1$1, rest2$1)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 3:
                                                var rest1$2 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 3:
                                                        var rest2$2 = ty2[1];
                                                        return [
                                                            3,
                                                            trans(rest1$2, rest2$2)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 4:
                                                var rest1$3 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 4:
                                                        var rest2$3 = ty2[1];
                                                        return [
                                                            4,
                                                            trans(rest1$3, rest2$3)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 5:
                                                var rest1$4 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 5:
                                                        var rest2$4 = ty2[1];
                                                        return [
                                                            5,
                                                            trans(rest1$4, rest2$4)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 6:
                                                var rest1$5 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 6:
                                                        var rest2$5 = ty2[1];
                                                        return [
                                                            6,
                                                            trans(rest1$5, rest2$5)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 7:
                                                var rest1$6 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 7:
                                                        var rest2$6 = ty2[1];
                                                        return [
                                                            7,
                                                            trans(rest1$6, rest2$6)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 8:
                                                var rest1$7 = ty1[2], ty1$0 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 8:
                                                        var rest2$7 = ty2[2], ty2$0 = ty2[1], _cE_ = trans(rest1$7, rest2$7);
                                                        return [
                                                            8,
                                                            trans(ty1$0, ty2$0),
                                                            _cE_
                                                        ];
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _k_
                                                ], 1);
                                            case 9:
                                                var rest1$8 = ty1[3], ty12 = ty1[2], ty11 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        var rest2$8 = ty2[3], ty22 = ty2[2], ty21 = ty2[1], ty = trans(symm(ty12), ty21), match = fmtty_rel_det(ty), f4 = match[4], f2 = match[2];
                                                        f2(0);
                                                        f4(0);
                                                        return [
                                                            9,
                                                            ty11,
                                                            ty22,
                                                            trans(rest1$8, rest2$8)
                                                        ];
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _l_
                                                ], 1);
                                            case 10:
                                                var rest1$9 = ty1[1];
                                                if (typeof ty2 !== "number" && 10 === ty2[0]) {
                                                    var rest2$9 = ty2[1];
                                                    return [
                                                        10,
                                                        trans(rest1$9, rest2$9)
                                                    ];
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _m_
                                                ], 1);
                                            case 11:
                                                var rest1$10 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        var rest2$10 = ty2[1];
                                                        return [
                                                            11,
                                                            trans(rest1$10, rest2$10)
                                                        ];
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _n_
                                                ], 1);
                                            case 12:
                                                var rest1$11 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        var rest2$11 = ty2[1];
                                                        return [
                                                            12,
                                                            trans(rest1$11, rest2$11)
                                                        ];
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _o_
                                                ], 1);
                                            case 13:
                                                var rest1$12 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        var rest2$12 = ty2[1];
                                                        return [
                                                            13,
                                                            trans(rest1$12, rest2$12)
                                                        ];
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _p_
                                                ], 1);
                                            default:
                                                var rest1$13 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        var rest2$13 = ty2[1];
                                                        return [
                                                            14,
                                                            trans(rest1$13, rest2$13)
                                                        ];
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _q_
                                                ], 1);
                                        }
                                        throw caml_maybe_attach_backtrace([
                                            0,
                                            Assert_failure,
                                            _j_
                                        ], 1);
                                    }
                                    if (typeof ty2 === "number") return 0;
                                    switch(ty2[0]){
                                        case 10:
                                            break a;
                                        case 11:
                                            break b;
                                        case 12:
                                            break c;
                                        case 13:
                                            break d;
                                        case 14:
                                            break e;
                                        case 8:
                                            break f;
                                        case 9:
                                            break;
                                        default:
                                            throw caml_maybe_attach_backtrace([
                                                0,
                                                Assert_failure,
                                                _b_
                                            ], 1);
                                    }
                                }
                                throw caml_maybe_attach_backtrace([
                                    0,
                                    Assert_failure,
                                    _d_
                                ], 1);
                            }
                            throw caml_maybe_attach_backtrace([
                                0,
                                Assert_failure,
                                _c_
                            ], 1);
                        }
                        throw caml_maybe_attach_backtrace([
                            0,
                            Assert_failure,
                            _i_
                        ], 1);
                    }
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _h_
                    ], 1);
                }
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _g_
                ], 1);
            }
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _f_
            ], 1);
        }
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
    }
    function fmtty_of_fmt(fmtty) {
        var fmtty$0 = fmtty;
        for(;;){
            if (typeof fmtty$0 === "number") return 0;
            switch(fmtty$0[0]){
                case 0:
                    var rest = fmtty$0[1];
                    return [
                        0,
                        fmtty_of_fmt(rest)
                    ];
                case 1:
                    var rest$0 = fmtty$0[1];
                    return [
                        0,
                        fmtty_of_fmt(rest$0)
                    ];
                case 2:
                    var rest$1 = fmtty$0[2], pad = fmtty$0[1];
                    return fmtty_of_padding_fmtty(pad, [
                        1,
                        fmtty_of_fmt(rest$1)
                    ]);
                case 3:
                    var rest$2 = fmtty$0[2], pad$0 = fmtty$0[1];
                    return fmtty_of_padding_fmtty(pad$0, [
                        1,
                        fmtty_of_fmt(rest$2)
                    ]);
                case 4:
                    var rest$3 = fmtty$0[4], prec = fmtty$0[3], pad$1 = fmtty$0[2], ty_rest = fmtty_of_fmt(rest$3), prec_ty = fmtty_of_precision_fmtty(prec, [
                        2,
                        ty_rest
                    ]);
                    return fmtty_of_padding_fmtty(pad$1, prec_ty);
                case 5:
                    var rest$4 = fmtty$0[4], prec$0 = fmtty$0[3], pad$2 = fmtty$0[2], ty_rest$0 = fmtty_of_fmt(rest$4), prec_ty$0 = fmtty_of_precision_fmtty(prec$0, [
                        3,
                        ty_rest$0
                    ]);
                    return fmtty_of_padding_fmtty(pad$2, prec_ty$0);
                case 6:
                    var rest$5 = fmtty$0[4], prec$1 = fmtty$0[3], pad$3 = fmtty$0[2], ty_rest$1 = fmtty_of_fmt(rest$5), prec_ty$1 = fmtty_of_precision_fmtty(prec$1, [
                        4,
                        ty_rest$1
                    ]);
                    return fmtty_of_padding_fmtty(pad$3, prec_ty$1);
                case 7:
                    var rest$6 = fmtty$0[4], prec$2 = fmtty$0[3], pad$4 = fmtty$0[2], ty_rest$2 = fmtty_of_fmt(rest$6), prec_ty$2 = fmtty_of_precision_fmtty(prec$2, [
                        5,
                        ty_rest$2
                    ]);
                    return fmtty_of_padding_fmtty(pad$4, prec_ty$2);
                case 8:
                    var rest$7 = fmtty$0[4], prec$3 = fmtty$0[3], pad$5 = fmtty$0[2], ty_rest$3 = fmtty_of_fmt(rest$7), prec_ty$3 = fmtty_of_precision_fmtty(prec$3, [
                        6,
                        ty_rest$3
                    ]);
                    return fmtty_of_padding_fmtty(pad$5, prec_ty$3);
                case 9:
                    var rest$8 = fmtty$0[2], pad$6 = fmtty$0[1];
                    return fmtty_of_padding_fmtty(pad$6, [
                        7,
                        fmtty_of_fmt(rest$8)
                    ]);
                case 10:
                    var fmtty$1 = fmtty$0[1];
                    fmtty$0 = fmtty$1;
                    break;
                case 11:
                    var fmtty$2 = fmtty$0[2];
                    fmtty$0 = fmtty$2;
                    break;
                case 12:
                    var fmtty$3 = fmtty$0[2];
                    fmtty$0 = fmtty$3;
                    break;
                case 13:
                    var rest$9 = fmtty$0[3], ty = fmtty$0[2];
                    return [
                        8,
                        ty,
                        fmtty_of_fmt(rest$9)
                    ];
                case 14:
                    var rest$10 = fmtty$0[3], ty$0 = fmtty$0[2];
                    return [
                        9,
                        ty$0,
                        ty$0,
                        fmtty_of_fmt(rest$10)
                    ];
                case 15:
                    var rest$11 = fmtty$0[1];
                    return [
                        10,
                        fmtty_of_fmt(rest$11)
                    ];
                case 16:
                    var rest$12 = fmtty$0[1];
                    return [
                        11,
                        fmtty_of_fmt(rest$12)
                    ];
                case 17:
                    var fmtty$4 = fmtty$0[2];
                    fmtty$0 = fmtty$4;
                    break;
                case 18:
                    var rest$13 = fmtty$0[2], formatting_gen = fmtty$0[1], _cB_ = fmtty_of_fmt(rest$13);
                    if (0 === formatting_gen[0]) var fmt = formatting_gen[1][1], _cC_ = fmtty_of_fmt(fmt);
                    else var fmt$0 = formatting_gen[1][1], _cC_ = fmtty_of_fmt(fmt$0);
                    return caml_call2(CamlinternalFormatBasics[1], _cC_, _cB_);
                case 19:
                    var rest$14 = fmtty$0[1];
                    return [
                        13,
                        fmtty_of_fmt(rest$14)
                    ];
                case 20:
                    var rest$15 = fmtty$0[3];
                    return [
                        1,
                        fmtty_of_fmt(rest$15)
                    ];
                case 21:
                    var rest$16 = fmtty$0[2];
                    return [
                        2,
                        fmtty_of_fmt(rest$16)
                    ];
                case 22:
                    var rest$17 = fmtty$0[1];
                    return [
                        0,
                        fmtty_of_fmt(rest$17)
                    ];
                case 23:
                    var fmtty$5 = fmtty$0[2], ign = fmtty$0[1];
                    if (typeof ign === "number") switch(ign){
                        case 0:
                            fmtty$0 = fmtty$5;
                            break;
                        case 1:
                            fmtty$0 = fmtty$5;
                            break;
                        case 2:
                            return [
                                14,
                                fmtty_of_fmt(fmtty$5)
                            ];
                        default:
                            fmtty$0 = fmtty$5;
                    }
                    else switch(ign[0]){
                        case 0:
                            fmtty$0 = fmtty$5;
                            break;
                        case 1:
                            fmtty$0 = fmtty$5;
                            break;
                        case 2:
                            fmtty$0 = fmtty$5;
                            break;
                        case 3:
                            fmtty$0 = fmtty$5;
                            break;
                        case 4:
                            fmtty$0 = fmtty$5;
                            break;
                        case 5:
                            fmtty$0 = fmtty$5;
                            break;
                        case 6:
                            fmtty$0 = fmtty$5;
                            break;
                        case 7:
                            fmtty$0 = fmtty$5;
                            break;
                        case 8:
                            fmtty$0 = fmtty$5;
                            break;
                        case 9:
                            var fmtty$6 = ign[2], _cD_ = fmtty_of_fmt(fmtty$5);
                            return caml_call2(CamlinternalFormatBasics[1], fmtty$6, _cD_);
                        case 10:
                            fmtty$0 = fmtty$5;
                            break;
                        default:
                            fmtty$0 = fmtty$5;
                    }
                    break;
                default:
                    var rest$18 = fmtty$0[3], arity = fmtty$0[1];
                    return fmtty_of_custom(arity, fmtty_of_fmt(rest$18));
            }
        }
    }
    function fmtty_of_custom(arity, fmtty) {
        if (!arity) return fmtty;
        var arity$0 = arity[1];
        return [
            12,
            fmtty_of_custom(arity$0, fmtty)
        ];
    }
    function fmtty_of_padding_fmtty(pad, fmtty) {
        return typeof pad === "number" ? fmtty : 0 === pad[0] ? fmtty : [
            2,
            fmtty
        ];
    }
    function fmtty_of_precision_fmtty(prec, fmtty) {
        return typeof prec === "number" ? prec ? [
            2,
            fmtty
        ] : fmtty : fmtty;
    }
    var Type_mismatch = [
        248,
        "CamlinternalFormat.Type_mismatch",
        runtime.caml_fresh_oo_id(0)
    ], cst_d = "%d", cst_d$0 = "%+d", cst_d$1 = "% d", cst_i$0 = cst_i$3, cst_i$1 = "%+i", cst_i$2 = "% i", cst_x = "%x", cst_x$0 = "%#x", cst_X = "%X", cst_X$0 = "%#X", cst_o = "%o", cst_o$0 = "%#o", cst_u = cst_u$0, cst_Ld = "%Ld", cst_Ld$0 = "%+Ld", cst_Ld$1 = "% Ld", cst_Li$0 = cst_Li$3, cst_Li$1 = "%+Li", cst_Li$2 = "% Li", cst_Lx = "%Lx", cst_Lx$0 = "%#Lx", cst_LX = "%LX", cst_LX$0 = "%#LX", cst_Lo = "%Lo", cst_Lo$0 = "%#Lo", cst_Lu = "%Lu", cst_ld = "%ld", cst_ld$0 = "%+ld", cst_ld$1 = "% ld", cst_li$0 = cst_li$3, cst_li$1 = "%+li", cst_li$2 = "% li", cst_lx = "%lx", cst_lx$0 = "%#lx", cst_lX = "%lX", cst_lX$0 = "%#lX", cst_lo = "%lo", cst_lo$0 = "%#lo", cst_lu = "%lu", cst_nd = "%nd", cst_nd$0 = "%+nd", cst_nd$1 = "% nd", cst_ni$0 = cst_ni$3, cst_ni$1 = "%+ni", cst_ni$2 = "% ni", cst_nx = "%nx", cst_nx$0 = "%#nx", cst_nX = "%nX", cst_nX$0 = "%#nX", cst_no = "%no", cst_no$0 = "%#no", cst_nu = "%nu", _r_ = [
        0,
        103
    ], cst_neg_infinity = "neg_infinity", cst_infinity = "infinity", cst_nan = "nan", _s_ = [
        0,
        cst_camlinternalFormat_ml,
        1558,
        4
    ], cst_Printf_bad_conversion = "Printf: bad conversion %[", _t_ = [
        0,
        cst_camlinternalFormat_ml,
        1626,
        39
    ], _u_ = [
        0,
        cst_camlinternalFormat_ml,
        1649,
        31
    ], _v_ = [
        0,
        cst_camlinternalFormat_ml,
        1650,
        31
    ], cst_Printf_bad_conversion$0 = "Printf: bad conversion %_", _w_ = [
        0,
        cst_camlinternalFormat_ml,
        1830,
        8
    ], _x_ = [
        0,
        0,
        4
    ], _y_ = [
        0,
        [
            11,
            "invalid box description ",
            [
                3,
                0,
                0
            ]
        ],
        "invalid box description %S"
    ], _z_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst$44,
                            [
                                2,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, %s"
    ], cst_non_zero_widths_are_unsupp = "non-zero widths are unsupported for %c conversions", _A_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ", '",
                            [
                                0,
                                [
                                    11,
                                    "' without ",
                                    [
                                        2,
                                        0,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, '%c' without %s"
    ], _B_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst$44,
                            [
                                2,
                                0,
                                [
                                    11,
                                    " expected, read ",
                                    [
                                        1,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, %s expected, read %C"
    ], _C_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ", duplicate flag ",
                            [
                                1,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, duplicate flag %C"
    ], cst_padding = "padding", _D_ = [
        0,
        1,
        0
    ], cst_0 = cst_0$3, _E_ = [
        0,
        0
    ], cst_precision = cst_precision$3, _F_ = [
        1,
        0
    ], _G_ = [
        1,
        1
    ], cst_precision$0 = cst_precision$3, _H_ = [
        1,
        1
    ], cst_precision$1 = cst_precision$3, cst_0$0 = cst_0$3, _I_ = [
        1,
        1
    ], cst_0$1 = cst_0$3, cst_0$2 = "'0'", _J_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ', invalid conversion "',
                            [
                                12,
                                37,
                                [
                                    0,
                                    [
                                        12,
                                        34,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        'invalid format %S: at character number %d, invalid conversion "%%%c"'
    ], _K_ = [
        0,
        0
    ], cst_padding$0 = "`padding'", _L_ = [
        0,
        0
    ], cst_precision$2 = "`precision'", _M_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ", flag ",
                            [
                                1,
                                [
                                    11,
                                    " is only allowed after the '",
                                    [
                                        12,
                                        37,
                                        [
                                            11,
                                            "', before padding and precision",
                                            0
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, flag %C is only allowed after the '%%', before padding and precision"
    ], _N_ = [
        0,
        [
            12,
            64,
            0
        ]
    ], _O_ = [
        0,
        "@ ",
        1,
        0
    ], _P_ = [
        0,
        "@,",
        0,
        0
    ], _Q_ = [
        2,
        60
    ], _R_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    ": '",
                    [
                        12,
                        37,
                        [
                            11,
                            "' alone is not accepted in character sets, use ",
                            [
                                12,
                                37,
                                [
                                    12,
                                    37,
                                    [
                                        11,
                                        " instead at position ",
                                        [
                                            4,
                                            0,
                                            0,
                                            0,
                                            [
                                                12,
                                                46,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: '%%' alone is not accepted in character sets, use %%%% instead at position %d."
    ], _S_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    ": integer ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " is greater than the limit ",
                            [
                                4,
                                0,
                                0,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: integer %d is greater than the limit %d"
    ], _T_1 = [
        0,
        cst_camlinternalFormat_ml,
        2837,
        11
    ], cst_digit = "digit", _U_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    ': unclosed sub-format, expected "',
                    [
                        12,
                        37,
                        [
                            0,
                            [
                                11,
                                '" at character number ',
                                [
                                    4,
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        'invalid format %S: unclosed sub-format, expected "%%%c" at character number %d'
    ], cst_character = "character ')'", cst_character$0 = "character '}'", _V_ = [
        0,
        cst_camlinternalFormat_ml,
        2899,
        34
    ], _W_ = [
        0,
        cst_camlinternalFormat_ml,
        2935,
        28
    ], _X_ = [
        0,
        cst_camlinternalFormat_ml,
        2957,
        11
    ], _Y_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst$44,
                            [
                                2,
                                0,
                                [
                                    11,
                                    " is incompatible with '",
                                    [
                                        0,
                                        [
                                            11,
                                            "' in sub-format ",
                                            [
                                                3,
                                                0,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, %s is incompatible with '%c' in sub-format %S"
    ], _Z_ = [
        0,
        [
            11,
            cst_bad_input_format_type_mism,
            [
                3,
                0,
                [
                    11,
                    cst_and,
                    [
                        3,
                        0,
                        0
                    ]
                ]
            ]
        ],
        cst_bad_input_format_type_mism$0
    ], ___ = [
        0,
        [
            11,
            cst_bad_input_format_type_mism,
            [
                3,
                0,
                [
                    11,
                    cst_and,
                    [
                        3,
                        0,
                        0
                    ]
                ]
            ]
        ],
        cst_bad_input_format_type_mism$0
    ];
    function type_padding(pad, fmtty) {
        if (typeof pad === "number") return [
            0,
            0,
            fmtty
        ];
        if (0 === pad[0]) {
            var w = pad[2], padty = pad[1];
            return [
                0,
                [
                    0,
                    padty,
                    w
                ],
                fmtty
            ];
        }
        if (typeof fmtty !== "number" && 2 === fmtty[0]) {
            var rest = fmtty[1], padty$0 = pad[1];
            return [
                0,
                [
                    1,
                    padty$0
                ],
                rest
            ];
        }
        throw caml_maybe_attach_backtrace(Type_mismatch, 1);
    }
    function type_padprec(pad, prec, fmtty) {
        var match = type_padding(pad, fmtty);
        if (typeof prec !== "number") {
            var rest$1 = match[2], pad$2 = match[1], p = prec[1];
            return [
                0,
                pad$2,
                [
                    0,
                    p
                ],
                rest$1
            ];
        }
        if (!prec) {
            var rest$0 = match[2], pad$1 = match[1];
            return [
                0,
                pad$1,
                0,
                rest$0
            ];
        }
        var match$0 = match[2];
        if (typeof match$0 !== "number" && 2 === match$0[0]) {
            var rest = match$0[1], pad$0 = match[1];
            return [
                0,
                pad$0,
                1,
                rest
            ];
        }
        throw caml_maybe_attach_backtrace(Type_mismatch, 1);
    }
    function type_format(fmt, fmtty) {
        var _cA_ = type_format_gen(fmt, fmtty);
        if (typeof _cA_[2] !== "number") throw caml_maybe_attach_backtrace(Type_mismatch, 1);
        var fmt$0 = _cA_[1];
        return fmt$0;
    }
    function type_format_gen(fmt, fmtty0) {
        if (typeof fmt === "number") return [
            0,
            0,
            fmtty0
        ];
        switch(fmt[0]){
            case 0:
                if (typeof fmtty0 !== "number" && 0 === fmtty0[0]) {
                    var fmtty_rest = fmtty0[1], fmt_rest = fmt[1], match = type_format_gen(fmt_rest, fmtty_rest), fmtty = match[2], fmt$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            fmt$0
                        ],
                        fmtty
                    ];
                }
                break;
            case 1:
                if (typeof fmtty0 !== "number" && 0 === fmtty0[0]) {
                    var fmtty_rest$0 = fmtty0[1], fmt_rest$0 = fmt[1], match$0 = type_format_gen(fmt_rest$0, fmtty_rest$0), fmtty$0 = match$0[2], fmt$1 = match$0[1];
                    return [
                        0,
                        [
                            1,
                            fmt$1
                        ],
                        fmtty$0
                    ];
                }
                break;
            case 2:
                var fmt_rest$1 = fmt[2], pad = fmt[1], match$1 = type_padding(pad, fmtty0), pad$0 = match$1[1], match$2 = match$1[2];
                if (typeof match$2 !== "number" && 1 === match$2[0]) {
                    var fmtty_rest$1 = match$2[1], match$3 = type_format_gen(fmt_rest$1, fmtty_rest$1), fmtty$1 = match$3[2], fmt$2 = match$3[1];
                    return [
                        0,
                        [
                            2,
                            pad$0,
                            fmt$2
                        ],
                        fmtty$1
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 3:
                var fmt_rest$2 = fmt[2], pad$1 = fmt[1], match$4 = type_padding(pad$1, fmtty0), pad$2 = match$4[1], match$5 = match$4[2];
                if (typeof match$5 !== "number" && 1 === match$5[0]) {
                    var fmtty_rest$2 = match$5[1], match$6 = type_format_gen(fmt_rest$2, fmtty_rest$2), fmtty$2 = match$6[2], fmt$3 = match$6[1];
                    return [
                        0,
                        [
                            3,
                            pad$2,
                            fmt$3
                        ],
                        fmtty$2
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 4:
                var fmt_rest$3 = fmt[4], prec = fmt[3], pad$3 = fmt[2], iconv = fmt[1], match$7 = type_padprec(pad$3, prec, fmtty0), pad$4 = match$7[1], match$8 = match$7[3];
                if (typeof match$8 !== "number" && 2 === match$8[0]) {
                    var fmtty_rest$3 = match$8[1], prec$0 = match$7[2], match$9 = type_format_gen(fmt_rest$3, fmtty_rest$3), fmtty$3 = match$9[2], fmt$4 = match$9[1];
                    return [
                        0,
                        [
                            4,
                            iconv,
                            pad$4,
                            prec$0,
                            fmt$4
                        ],
                        fmtty$3
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 5:
                var fmt_rest$4 = fmt[4], prec$1 = fmt[3], pad$5 = fmt[2], iconv$0 = fmt[1], match$10 = type_padprec(pad$5, prec$1, fmtty0), pad$6 = match$10[1], match$11 = match$10[3];
                if (typeof match$11 !== "number" && 3 === match$11[0]) {
                    var fmtty_rest$4 = match$11[1], prec$2 = match$10[2], match$12 = type_format_gen(fmt_rest$4, fmtty_rest$4), fmtty$4 = match$12[2], fmt$5 = match$12[1];
                    return [
                        0,
                        [
                            5,
                            iconv$0,
                            pad$6,
                            prec$2,
                            fmt$5
                        ],
                        fmtty$4
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 6:
                var fmt_rest$5 = fmt[4], prec$3 = fmt[3], pad$7 = fmt[2], iconv$1 = fmt[1], match$13 = type_padprec(pad$7, prec$3, fmtty0), pad$8 = match$13[1], match$14 = match$13[3];
                if (typeof match$14 !== "number" && 4 === match$14[0]) {
                    var fmtty_rest$5 = match$14[1], prec$4 = match$13[2], match$15 = type_format_gen(fmt_rest$5, fmtty_rest$5), fmtty$5 = match$15[2], fmt$6 = match$15[1];
                    return [
                        0,
                        [
                            6,
                            iconv$1,
                            pad$8,
                            prec$4,
                            fmt$6
                        ],
                        fmtty$5
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 7:
                var fmt_rest$6 = fmt[4], prec$5 = fmt[3], pad$9 = fmt[2], iconv$2 = fmt[1], match$16 = type_padprec(pad$9, prec$5, fmtty0), pad$10 = match$16[1], match$17 = match$16[3];
                if (typeof match$17 !== "number" && 5 === match$17[0]) {
                    var fmtty_rest$6 = match$17[1], prec$6 = match$16[2], match$18 = type_format_gen(fmt_rest$6, fmtty_rest$6), fmtty$6 = match$18[2], fmt$7 = match$18[1];
                    return [
                        0,
                        [
                            7,
                            iconv$2,
                            pad$10,
                            prec$6,
                            fmt$7
                        ],
                        fmtty$6
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 8:
                var fmt_rest$7 = fmt[4], prec$7 = fmt[3], pad$11 = fmt[2], fconv = fmt[1], match$19 = type_padprec(pad$11, prec$7, fmtty0), pad$12 = match$19[1], match$20 = match$19[3];
                if (typeof match$20 !== "number" && 6 === match$20[0]) {
                    var fmtty_rest$7 = match$20[1], prec$8 = match$19[2], match$21 = type_format_gen(fmt_rest$7, fmtty_rest$7), fmtty$7 = match$21[2], fmt$8 = match$21[1];
                    return [
                        0,
                        [
                            8,
                            fconv,
                            pad$12,
                            prec$8,
                            fmt$8
                        ],
                        fmtty$7
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 9:
                var fmt_rest$8 = fmt[2], pad$13 = fmt[1], match$22 = type_padding(pad$13, fmtty0), pad$14 = match$22[1], match$23 = match$22[2];
                if (typeof match$23 !== "number" && 7 === match$23[0]) {
                    var fmtty_rest$8 = match$23[1], match$24 = type_format_gen(fmt_rest$8, fmtty_rest$8), fmtty$8 = match$24[2], fmt$9 = match$24[1];
                    return [
                        0,
                        [
                            9,
                            pad$14,
                            fmt$9
                        ],
                        fmtty$8
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 10:
                var fmt_rest$9 = fmt[1], match$25 = type_format_gen(fmt_rest$9, fmtty0), fmtty$9 = match$25[2], fmt$10 = match$25[1];
                return [
                    0,
                    [
                        10,
                        fmt$10
                    ],
                    fmtty$9
                ];
            case 11:
                var fmt_rest$10 = fmt[2], str = fmt[1], match$26 = type_format_gen(fmt_rest$10, fmtty0), fmtty$10 = match$26[2], fmt$11 = match$26[1];
                return [
                    0,
                    [
                        11,
                        str,
                        fmt$11
                    ],
                    fmtty$10
                ];
            case 12:
                var fmt_rest$11 = fmt[2], chr = fmt[1], match$27 = type_format_gen(fmt_rest$11, fmtty0), fmtty$11 = match$27[2], fmt$12 = match$27[1];
                return [
                    0,
                    [
                        12,
                        chr,
                        fmt$12
                    ],
                    fmtty$11
                ];
            case 13:
                if (typeof fmtty0 !== "number" && 8 === fmtty0[0]) {
                    var fmtty_rest$9 = fmtty0[2], sub_fmtty = fmtty0[1], fmt_rest$12 = fmt[3], sub_fmtty$0 = fmt[2], pad_opt = fmt[1];
                    if (caml_notequal([
                        0,
                        sub_fmtty$0
                    ], [
                        0,
                        sub_fmtty
                    ])) throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    var match$28 = type_format_gen(fmt_rest$12, fmtty_rest$9), fmtty$12 = match$28[2], fmt$13 = match$28[1];
                    return [
                        0,
                        [
                            13,
                            pad_opt,
                            sub_fmtty,
                            fmt$13
                        ],
                        fmtty$12
                    ];
                }
                break;
            case 14:
                if (typeof fmtty0 !== "number" && 9 === fmtty0[0]) {
                    var fmtty_rest$10 = fmtty0[3], sub_fmtty1 = fmtty0[1], fmt_rest$13 = fmt[3], sub_fmtty$1 = fmt[2], pad_opt$0 = fmt[1], _cy_ = [
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub_fmtty1)
                    ];
                    if (caml_notequal([
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub_fmtty$1)
                    ], _cy_)) throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    var match$29 = type_format_gen(fmt_rest$13, caml_call1(CamlinternalFormatBasics[2], fmtty_rest$10)), fmtty$13 = match$29[2], fmt$14 = match$29[1];
                    return [
                        0,
                        [
                            14,
                            pad_opt$0,
                            sub_fmtty1,
                            fmt$14
                        ],
                        fmtty$13
                    ];
                }
                break;
            case 15:
                if (typeof fmtty0 !== "number" && 10 === fmtty0[0]) {
                    var fmtty_rest$11 = fmtty0[1], fmt_rest$14 = fmt[1], match$30 = type_format_gen(fmt_rest$14, fmtty_rest$11), fmtty$14 = match$30[2], fmt$15 = match$30[1];
                    return [
                        0,
                        [
                            15,
                            fmt$15
                        ],
                        fmtty$14
                    ];
                }
                break;
            case 16:
                if (typeof fmtty0 !== "number" && 11 === fmtty0[0]) {
                    var fmtty_rest$12 = fmtty0[1], fmt_rest$15 = fmt[1], match$31 = type_format_gen(fmt_rest$15, fmtty_rest$12), fmtty$15 = match$31[2], fmt$16 = match$31[1];
                    return [
                        0,
                        [
                            16,
                            fmt$16
                        ],
                        fmtty$15
                    ];
                }
                break;
            case 17:
                var fmt_rest$16 = fmt[2], formatting_lit = fmt[1], match$32 = type_format_gen(fmt_rest$16, fmtty0), fmtty$16 = match$32[2], fmt$17 = match$32[1];
                return [
                    0,
                    [
                        17,
                        formatting_lit,
                        fmt$17
                    ],
                    fmtty$16
                ];
            case 18:
                var fmt_rest$17 = fmt[2], formatting_gen = fmt[1];
                if (0 === formatting_gen[0]) {
                    var match$36 = formatting_gen[1], str$0 = match$36[2], fmt1 = match$36[1], match$37 = type_format_gen(fmt1, fmtty0), fmtty2 = match$37[2], fmt2 = match$37[1], match$38 = type_format_gen(fmt_rest$17, fmtty2), fmtty3 = match$38[2], fmt3 = match$38[1];
                    return [
                        0,
                        [
                            18,
                            [
                                0,
                                [
                                    0,
                                    fmt2,
                                    str$0
                                ]
                            ],
                            fmt3
                        ],
                        fmtty3
                    ];
                }
                var match$39 = formatting_gen[1], str$1 = match$39[2], fmt1$0 = match$39[1], match$40 = type_format_gen(fmt1$0, fmtty0), fmtty2$0 = match$40[2], fmt2$0 = match$40[1], match$41 = type_format_gen(fmt_rest$17, fmtty2$0), fmtty3$0 = match$41[2], fmt3$0 = match$41[1];
                return [
                    0,
                    [
                        18,
                        [
                            1,
                            [
                                0,
                                fmt2$0,
                                str$1
                            ]
                        ],
                        fmt3$0
                    ],
                    fmtty3$0
                ];
            case 19:
                if (typeof fmtty0 !== "number" && 13 === fmtty0[0]) {
                    var fmtty_rest$13 = fmtty0[1], fmt_rest$18 = fmt[1], match$33 = type_format_gen(fmt_rest$18, fmtty_rest$13), fmtty$17 = match$33[2], fmt$18 = match$33[1];
                    return [
                        0,
                        [
                            19,
                            fmt$18
                        ],
                        fmtty$17
                    ];
                }
                break;
            case 20:
                if (typeof fmtty0 !== "number" && 1 === fmtty0[0]) {
                    var fmtty_rest$14 = fmtty0[1], fmt_rest$19 = fmt[3], char_set = fmt[2], width_opt = fmt[1], match$34 = type_format_gen(fmt_rest$19, fmtty_rest$14), fmtty$18 = match$34[2], fmt$19 = match$34[1];
                    return [
                        0,
                        [
                            20,
                            width_opt,
                            char_set,
                            fmt$19
                        ],
                        fmtty$18
                    ];
                }
                break;
            case 21:
                if (typeof fmtty0 !== "number" && 2 === fmtty0[0]) {
                    var fmtty_rest$15 = fmtty0[1], fmt_rest$20 = fmt[2], counter = fmt[1], match$35 = type_format_gen(fmt_rest$20, fmtty_rest$15), fmtty$19 = match$35[2], fmt$20 = match$35[1];
                    return [
                        0,
                        [
                            21,
                            counter,
                            fmt$20
                        ],
                        fmtty$19
                    ];
                }
                break;
            case 23:
                var rest = fmt[2], ign = fmt[1];
                if (typeof ign !== "number") switch(ign[0]){
                    case 0:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 1:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 2:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 3:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 4:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 5:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 6:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 7:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 8:
                        var sub_fmtty$2 = ign[2], pad_opt$1 = ign[1];
                        return type_ignored_param_one([
                            8,
                            pad_opt$1,
                            sub_fmtty$2
                        ], rest, fmtty0);
                    case 9:
                        var sub_fmtty$3 = ign[2], pad_opt$2 = ign[1], _cz_ = type_ignored_format_substituti(sub_fmtty$3, rest, fmtty0), match$43 = _cz_[2], fmtty$21 = match$43[2], fmt$22 = match$43[1], sub_fmtty$4 = _cz_[1];
                        return [
                            0,
                            [
                                23,
                                [
                                    9,
                                    pad_opt$2,
                                    sub_fmtty$4
                                ],
                                fmt$22
                            ],
                            fmtty$21
                        ];
                    case 10:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    default:
                        return type_ignored_param_one(ign, rest, fmtty0);
                }
                switch(ign){
                    case 0:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 1:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 2:
                        if (typeof fmtty0 !== "number" && 14 === fmtty0[0]) {
                            var fmtty_rest$16 = fmtty0[1], match$42 = type_format_gen(rest, fmtty_rest$16), fmtty$20 = match$42[2], fmt$21 = match$42[1];
                            return [
                                0,
                                [
                                    23,
                                    2,
                                    fmt$21
                                ],
                                fmtty$20
                            ];
                        }
                        throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    default:
                        return type_ignored_param_one(ign, rest, fmtty0);
                }
        }
        throw caml_maybe_attach_backtrace(Type_mismatch, 1);
    }
    function type_ignored_param_one(ign, fmt, fmtty) {
        var match = type_format_gen(fmt, fmtty), fmtty$0 = match[2], fmt$0 = match[1];
        return [
            0,
            [
                23,
                ign,
                fmt$0
            ],
            fmtty$0
        ];
    }
    function type_ignored_format_substituti(sub_fmtty, fmt, fmtty) {
        if (typeof sub_fmtty === "number") return [
            0,
            0,
            type_format_gen(fmt, fmtty)
        ];
        switch(sub_fmtty[0]){
            case 0:
                if (typeof fmtty !== "number" && 0 === fmtty[0]) {
                    var fmtty_rest = fmtty[1], sub_fmtty_rest = sub_fmtty[1], match = type_ignored_format_substituti(sub_fmtty_rest, fmt, fmtty_rest), fmt$0 = match[2], sub_fmtty_rest$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            sub_fmtty_rest$0
                        ],
                        fmt$0
                    ];
                }
                break;
            case 1:
                if (typeof fmtty !== "number" && 1 === fmtty[0]) {
                    var fmtty_rest$0 = fmtty[1], sub_fmtty_rest$1 = sub_fmtty[1], match$0 = type_ignored_format_substituti(sub_fmtty_rest$1, fmt, fmtty_rest$0), fmt$1 = match$0[2], sub_fmtty_rest$2 = match$0[1];
                    return [
                        0,
                        [
                            1,
                            sub_fmtty_rest$2
                        ],
                        fmt$1
                    ];
                }
                break;
            case 2:
                if (typeof fmtty !== "number" && 2 === fmtty[0]) {
                    var fmtty_rest$1 = fmtty[1], sub_fmtty_rest$3 = sub_fmtty[1], match$1 = type_ignored_format_substituti(sub_fmtty_rest$3, fmt, fmtty_rest$1), fmt$2 = match$1[2], sub_fmtty_rest$4 = match$1[1];
                    return [
                        0,
                        [
                            2,
                            sub_fmtty_rest$4
                        ],
                        fmt$2
                    ];
                }
                break;
            case 3:
                if (typeof fmtty !== "number" && 3 === fmtty[0]) {
                    var fmtty_rest$2 = fmtty[1], sub_fmtty_rest$5 = sub_fmtty[1], match$2 = type_ignored_format_substituti(sub_fmtty_rest$5, fmt, fmtty_rest$2), fmt$3 = match$2[2], sub_fmtty_rest$6 = match$2[1];
                    return [
                        0,
                        [
                            3,
                            sub_fmtty_rest$6
                        ],
                        fmt$3
                    ];
                }
                break;
            case 4:
                if (typeof fmtty !== "number" && 4 === fmtty[0]) {
                    var fmtty_rest$3 = fmtty[1], sub_fmtty_rest$7 = sub_fmtty[1], match$3 = type_ignored_format_substituti(sub_fmtty_rest$7, fmt, fmtty_rest$3), fmt$4 = match$3[2], sub_fmtty_rest$8 = match$3[1];
                    return [
                        0,
                        [
                            4,
                            sub_fmtty_rest$8
                        ],
                        fmt$4
                    ];
                }
                break;
            case 5:
                if (typeof fmtty !== "number" && 5 === fmtty[0]) {
                    var fmtty_rest$4 = fmtty[1], sub_fmtty_rest$9 = sub_fmtty[1], match$4 = type_ignored_format_substituti(sub_fmtty_rest$9, fmt, fmtty_rest$4), fmt$5 = match$4[2], sub_fmtty_rest$10 = match$4[1];
                    return [
                        0,
                        [
                            5,
                            sub_fmtty_rest$10
                        ],
                        fmt$5
                    ];
                }
                break;
            case 6:
                if (typeof fmtty !== "number" && 6 === fmtty[0]) {
                    var fmtty_rest$5 = fmtty[1], sub_fmtty_rest$11 = sub_fmtty[1], match$5 = type_ignored_format_substituti(sub_fmtty_rest$11, fmt, fmtty_rest$5), fmt$6 = match$5[2], sub_fmtty_rest$12 = match$5[1];
                    return [
                        0,
                        [
                            6,
                            sub_fmtty_rest$12
                        ],
                        fmt$6
                    ];
                }
                break;
            case 7:
                if (typeof fmtty !== "number" && 7 === fmtty[0]) {
                    var fmtty_rest$6 = fmtty[1], sub_fmtty_rest$13 = sub_fmtty[1], match$6 = type_ignored_format_substituti(sub_fmtty_rest$13, fmt, fmtty_rest$6), fmt$7 = match$6[2], sub_fmtty_rest$14 = match$6[1];
                    return [
                        0,
                        [
                            7,
                            sub_fmtty_rest$14
                        ],
                        fmt$7
                    ];
                }
                break;
            case 8:
                if (typeof fmtty !== "number" && 8 === fmtty[0]) {
                    var fmtty_rest$7 = fmtty[2], sub2_fmtty = fmtty[1], sub_fmtty_rest$15 = sub_fmtty[2], sub2_fmtty$0 = sub_fmtty[1];
                    if (caml_notequal([
                        0,
                        sub2_fmtty$0
                    ], [
                        0,
                        sub2_fmtty
                    ])) throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    var match$7 = type_ignored_format_substituti(sub_fmtty_rest$15, fmt, fmtty_rest$7), fmt$8 = match$7[2], sub_fmtty_rest$16 = match$7[1];
                    return [
                        0,
                        [
                            8,
                            sub2_fmtty,
                            sub_fmtty_rest$16
                        ],
                        fmt$8
                    ];
                }
                break;
            case 9:
                if (typeof fmtty !== "number" && 9 === fmtty[0]) {
                    var fmtty_rest$8 = fmtty[3], sub2_fmtty$1 = fmtty[2], sub1_fmtty = fmtty[1], sub_fmtty_rest$17 = sub_fmtty[3], sub2_fmtty$2 = sub_fmtty[2], sub1_fmtty$0 = sub_fmtty[1], _cw_ = [
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub1_fmtty)
                    ];
                    if (caml_notequal([
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub1_fmtty$0)
                    ], _cw_)) throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    var _cx_ = [
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub2_fmtty$1)
                    ];
                    if (caml_notequal([
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub2_fmtty$2)
                    ], _cx_)) throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    var sub_fmtty$0 = trans(symm(sub1_fmtty), sub2_fmtty$1), match$8 = fmtty_rel_det(sub_fmtty$0), f4 = match$8[4], f2 = match$8[2];
                    f2(0);
                    f4(0);
                    var match$9 = type_ignored_format_substituti(caml_call1(CamlinternalFormatBasics[2], sub_fmtty_rest$17), fmt, fmtty_rest$8), fmt$9 = match$9[2], sub_fmtty_rest$18 = match$9[1];
                    return [
                        0,
                        [
                            9,
                            sub1_fmtty,
                            sub2_fmtty$1,
                            symm(sub_fmtty_rest$18)
                        ],
                        fmt$9
                    ];
                }
                break;
            case 10:
                if (typeof fmtty !== "number" && 10 === fmtty[0]) {
                    var fmtty_rest$9 = fmtty[1], sub_fmtty_rest$19 = sub_fmtty[1], match$10 = type_ignored_format_substituti(sub_fmtty_rest$19, fmt, fmtty_rest$9), fmt$10 = match$10[2], sub_fmtty_rest$20 = match$10[1];
                    return [
                        0,
                        [
                            10,
                            sub_fmtty_rest$20
                        ],
                        fmt$10
                    ];
                }
                break;
            case 11:
                if (typeof fmtty !== "number" && 11 === fmtty[0]) {
                    var fmtty_rest$10 = fmtty[1], sub_fmtty_rest$21 = sub_fmtty[1], match$11 = type_ignored_format_substituti(sub_fmtty_rest$21, fmt, fmtty_rest$10), fmt$11 = match$11[2], sub_fmtty_rest$22 = match$11[1];
                    return [
                        0,
                        [
                            11,
                            sub_fmtty_rest$22
                        ],
                        fmt$11
                    ];
                }
                break;
            case 13:
                if (typeof fmtty !== "number" && 13 === fmtty[0]) {
                    var fmtty_rest$11 = fmtty[1], sub_fmtty_rest$23 = sub_fmtty[1], match$12 = type_ignored_format_substituti(sub_fmtty_rest$23, fmt, fmtty_rest$11), fmt$12 = match$12[2], sub_fmtty_rest$24 = match$12[1];
                    return [
                        0,
                        [
                            13,
                            sub_fmtty_rest$24
                        ],
                        fmt$12
                    ];
                }
                break;
            case 14:
                if (typeof fmtty !== "number" && 14 === fmtty[0]) {
                    var fmtty_rest$12 = fmtty[1], sub_fmtty_rest$25 = sub_fmtty[1], match$13 = type_ignored_format_substituti(sub_fmtty_rest$25, fmt, fmtty_rest$12), fmt$13 = match$13[2], sub_fmtty_rest$26 = match$13[1];
                    return [
                        0,
                        [
                            14,
                            sub_fmtty_rest$26
                        ],
                        fmt$13
                    ];
                }
                break;
        }
        throw caml_maybe_attach_backtrace(Type_mismatch, 1);
    }
    function recast(fmt, fmtty) {
        var _cv_ = symm(fmtty);
        return type_format(fmt, caml_call1(CamlinternalFormatBasics[2], _cv_));
    }
    function fix_padding(padty, width, str) {
        var len = caml_ml_string_length(str), padty$0 = 0 <= width ? padty : 0, width$0 = caml_call1(Stdlib[18], width);
        if (width$0 <= len) return str;
        var _cu_ = 2 === padty$0 ? 48 : 32, res = caml_call2(Stdlib_Bytes[1], width$0, _cu_);
        switch(padty$0){
            case 0:
                caml_call5(Stdlib_String[6], str, 0, res, 0, len);
                break;
            case 1:
                caml_call5(Stdlib_String[6], str, 0, res, width$0 - len | 0, len);
                break;
            default:
                a: if (0 < len) {
                    if (43 !== caml_string_get(str, 0) && 45 !== caml_string_get(str, 0) && 32 !== caml_string_get(str, 0)) break a;
                    caml_bytes_set(res, 0, caml_string_get(str, 0));
                    caml_call5(Stdlib_String[6], str, 1, res, (width$0 - len | 0) + 1 | 0, len - 1 | 0);
                    break;
                }
                a: if (1 < len && 48 === caml_string_get(str, 0)) {
                    if (120 !== caml_string_get(str, 1) && 88 !== caml_string_get(str, 1)) break a;
                    caml_bytes_set(res, 1, caml_string_get(str, 1));
                    caml_call5(Stdlib_String[6], str, 2, res, (width$0 - len | 0) + 2 | 0, len - 2 | 0);
                    break;
                }
                caml_call5(Stdlib_String[6], str, 0, res, width$0 - len | 0, len);
        }
        return caml_call1(Stdlib_Bytes[44], res);
    }
    function fix_int_precision(prec, str) {
        var prec$0 = caml_call1(Stdlib[18], prec), len = caml_ml_string_length(str), c = caml_string_get(str, 0);
        a: {
            b: {
                if (58 > c) {
                    if (32 !== c) {
                        if (43 > c) break a;
                        switch(c - 43 | 0){
                            case 5:
                                c: if (len < (prec$0 + 2 | 0) && 1 < len) {
                                    if (120 !== caml_string_get(str, 1) && 88 !== caml_string_get(str, 1)) break c;
                                    var res$1 = caml_call2(Stdlib_Bytes[1], prec$0 + 2 | 0, 48);
                                    caml_bytes_set(res$1, 1, caml_string_get(str, 1));
                                    caml_call5(Stdlib_String[6], str, 2, res$1, (prec$0 - len | 0) + 4 | 0, len - 2 | 0);
                                    return caml_call1(Stdlib_Bytes[44], res$1);
                                }
                                break b;
                            case 0:
                            case 2:
                                break;
                            case 1:
                            case 3:
                            case 4:
                                break a;
                            default:
                                break b;
                        }
                    }
                    if (len >= (prec$0 + 1 | 0)) break a;
                    var res$0 = caml_call2(Stdlib_Bytes[1], prec$0 + 1 | 0, 48);
                    caml_bytes_set(res$0, 0, c);
                    caml_call5(Stdlib_String[6], str, 1, res$0, (prec$0 - len | 0) + 2 | 0, len - 1 | 0);
                    return caml_call1(Stdlib_Bytes[44], res$0);
                }
                if (71 <= c) {
                    if (5 < c - 97 >>> 0) break a;
                } else if (65 > c) break a;
            }
            if (len < prec$0) {
                var res = caml_call2(Stdlib_Bytes[1], prec$0, 48);
                caml_call5(Stdlib_String[6], str, 0, res, prec$0 - len | 0, len);
                return caml_call1(Stdlib_Bytes[44], res);
            }
        }
        return str;
    }
    function string_to_caml_string(str) {
        var str$0 = caml_call1(Stdlib_String[25], str), l = caml_ml_string_length(str$0), res = caml_call2(Stdlib_Bytes[1], l + 2 | 0, 34);
        caml_blit_string(str$0, 0, res, 1, l);
        return caml_call1(Stdlib_Bytes[44], res);
    }
    function format_of_fconv(fconv, prec) {
        var prec$0 = caml_call1(Stdlib[18], prec), symb = char_of_fconv(_r_, fconv), buf = buffer_create(16);
        buffer_add_char(buf, 37);
        bprint_fconv_flag(buf, fconv);
        buffer_add_char(buf, 46);
        buffer_add_string(buf, caml_call1(Stdlib_Int[12], prec$0));
        buffer_add_char(buf, symb);
        return buffer_contents(buf);
    }
    function transform_int_alt(iconv, s) {
        if (13 > iconv) return s;
        var n = [
            0,
            0
        ], _cp_ = caml_ml_string_length(s) - 1 | 0, _co_ = 0;
        if (_cp_ >= 0) {
            var i$0 = _co_;
            for(;;){
                if (9 >= caml_string_unsafe_get(s, i$0) - 48 >>> 0) n[1]++;
                var _ct_ = i$0 + 1 | 0;
                if (_cp_ === i$0) break;
                i$0 = _ct_;
            }
        }
        var digits = n[1], buf = caml_create_bytes(caml_ml_string_length(s) + ((digits - 1 | 0) / 3 | 0) | 0), pos = [
            0,
            0
        ];
        function put(c) {
            caml_bytes_set(buf, pos[1], c);
            pos[1]++;
            return;
        }
        var left = [
            0,
            ((digits - 1 | 0) % 3 | 0) + 1 | 0
        ], _cr_ = caml_ml_string_length(s) - 1 | 0, _cq_ = 0;
        if (_cr_ >= 0) {
            var i = _cq_;
            for(;;){
                var c = caml_string_unsafe_get(s, i);
                if (9 < c - 48 >>> 0) put(c);
                else {
                    if (0 === left[1]) {
                        put(95);
                        left[1] = 3;
                    }
                    left[1]--;
                    put(c);
                }
                var _cs_ = i + 1 | 0;
                if (_cr_ === i) break;
                i = _cs_;
            }
        }
        return caml_call1(Stdlib_Bytes[44], buf);
    }
    function convert_int(iconv, n) {
        switch(iconv){
            case 1:
                var _cn_ = cst_d$0;
                break;
            case 2:
                var _cn_ = cst_d$1;
                break;
            case 4:
                var _cn_ = cst_i$1;
                break;
            case 5:
                var _cn_ = cst_i$2;
                break;
            case 6:
                var _cn_ = cst_x;
                break;
            case 7:
                var _cn_ = cst_x$0;
                break;
            case 8:
                var _cn_ = cst_X;
                break;
            case 9:
                var _cn_ = cst_X$0;
                break;
            case 10:
                var _cn_ = cst_o;
                break;
            case 11:
                var _cn_ = cst_o$0;
                break;
            case 0:
            case 13:
                var _cn_ = cst_d;
                break;
            case 3:
            case 14:
                var _cn_ = cst_i$0;
                break;
            default:
                var _cn_ = cst_u;
        }
        return transform_int_alt(iconv, caml_format_int(_cn_, n));
    }
    function convert_int32(iconv, n) {
        switch(iconv){
            case 1:
                var _cm_ = cst_ld$0;
                break;
            case 2:
                var _cm_ = cst_ld$1;
                break;
            case 4:
                var _cm_ = cst_li$1;
                break;
            case 5:
                var _cm_ = cst_li$2;
                break;
            case 6:
                var _cm_ = cst_lx;
                break;
            case 7:
                var _cm_ = cst_lx$0;
                break;
            case 8:
                var _cm_ = cst_lX;
                break;
            case 9:
                var _cm_ = cst_lX$0;
                break;
            case 10:
                var _cm_ = cst_lo;
                break;
            case 11:
                var _cm_ = cst_lo$0;
                break;
            case 0:
            case 13:
                var _cm_ = cst_ld;
                break;
            case 3:
            case 14:
                var _cm_ = cst_li$0;
                break;
            default:
                var _cm_ = cst_lu;
        }
        return transform_int_alt(iconv, caml_format_int(_cm_, n));
    }
    function convert_nativeint(iconv, n) {
        switch(iconv){
            case 1:
                var _cl_ = cst_nd$0;
                break;
            case 2:
                var _cl_ = cst_nd$1;
                break;
            case 4:
                var _cl_ = cst_ni$1;
                break;
            case 5:
                var _cl_ = cst_ni$2;
                break;
            case 6:
                var _cl_ = cst_nx;
                break;
            case 7:
                var _cl_ = cst_nx$0;
                break;
            case 8:
                var _cl_ = cst_nX;
                break;
            case 9:
                var _cl_ = cst_nX$0;
                break;
            case 10:
                var _cl_ = cst_no;
                break;
            case 11:
                var _cl_ = cst_no$0;
                break;
            case 0:
            case 13:
                var _cl_ = cst_nd;
                break;
            case 3:
            case 14:
                var _cl_ = cst_ni$0;
                break;
            default:
                var _cl_ = cst_nu;
        }
        return transform_int_alt(iconv, caml_format_int(_cl_, n));
    }
    function convert_int64(iconv, n) {
        switch(iconv){
            case 1:
                var _ck_ = cst_Ld$0;
                break;
            case 2:
                var _ck_ = cst_Ld$1;
                break;
            case 4:
                var _ck_ = cst_Li$1;
                break;
            case 5:
                var _ck_ = cst_Li$2;
                break;
            case 6:
                var _ck_ = cst_Lx;
                break;
            case 7:
                var _ck_ = cst_Lx$0;
                break;
            case 8:
                var _ck_ = cst_LX;
                break;
            case 9:
                var _ck_ = cst_LX$0;
                break;
            case 10:
                var _ck_ = cst_Lo;
                break;
            case 11:
                var _ck_ = cst_Lo$0;
                break;
            case 0:
            case 13:
                var _ck_ = cst_Ld;
                break;
            case 3:
            case 14:
                var _ck_ = cst_Li$0;
                break;
            default:
                var _ck_ = cst_Lu;
        }
        return transform_int_alt(iconv, runtime.caml_int64_format(_ck_, n));
    }
    function convert_float(fconv, prec, x) {
        function hex(param) {
            switch(fconv[1]){
                case 0:
                    var sign = 45;
                    break;
                case 1:
                    var sign = 43;
                    break;
                default:
                    var sign = 32;
            }
            return runtime.caml_hexstring_of_float(x, prec, sign);
        }
        function caml_special_val(str) {
            var match = runtime.caml_classify_float(x);
            return 3 === match ? x < 0. ? cst_neg_infinity : cst_infinity : 4 <= match ? cst_nan : str;
        }
        switch(fconv[2]){
            case 5:
                var str = caml_format_float(format_of_fconv(fconv, prec), x), len = caml_ml_string_length(str), i = 0;
                for(;;){
                    if (i === len) var _ch_ = 0;
                    else {
                        var _cg_ = caml_string_get(str, i) - 46 | 0;
                        a: {
                            if (23 < _cg_ >>> 0) {
                                if (55 === _cg_) break a;
                            } else if (21 < _cg_ - 1 >>> 0) break a;
                            var i$0 = i + 1 | 0;
                            i = i$0;
                            continue;
                        }
                        var _ch_ = 1;
                    }
                    var _ci_ = _ch_ ? str : caml_call2(Stdlib[28], str, cst$17);
                    return caml_special_val(_ci_);
                }
            case 6:
                return hex(0);
            case 7:
                var _cj_ = hex(0);
                return caml_call1(Stdlib_String[26], _cj_);
            case 8:
                return caml_special_val(hex(0));
            default:
                return caml_format_float(format_of_fconv(fconv, prec), x);
        }
    }
    function string_of_fmtty(fmtty) {
        var buf = buffer_create(16);
        bprint_fmtty(buf, fmtty);
        return buffer_contents(buf);
    }
    function make_printf$0(counter, k, acc, fmt) {
        var k$0 = k, acc$0 = acc, fmt$0 = fmt;
        for(;;){
            if (typeof fmt$0 === "number") return caml_call1(k$0, acc$0);
            switch(fmt$0[0]){
                case 0:
                    var rest = fmt$0[1];
                    return function(c) {
                        var new_acc = [
                            5,
                            acc$0,
                            c
                        ];
                        return make_printf(k$0, new_acc, rest);
                    };
                case 1:
                    var rest$0 = fmt$0[1];
                    return function(c) {
                        var str = caml_call1(Stdlib_Char[2], c), l = caml_ml_string_length(str), res = caml_call2(Stdlib_Bytes[1], l + 2 | 0, 39);
                        caml_blit_string(str, 0, res, 1, l);
                        var new_acc = [
                            4,
                            acc$0,
                            caml_call1(Stdlib_Bytes[44], res)
                        ];
                        return make_printf(k$0, new_acc, rest$0);
                    };
                case 2:
                    var rest$1 = fmt$0[2], pad = fmt$0[1];
                    return make_padding(k$0, acc$0, rest$1, pad, function(str) {
                        return str;
                    });
                case 3:
                    var rest$2 = fmt$0[2], pad$0 = fmt$0[1];
                    return make_padding(k$0, acc$0, rest$2, pad$0, string_to_caml_string);
                case 4:
                    var rest$3 = fmt$0[4], prec = fmt$0[3], pad$1 = fmt$0[2], iconv = fmt$0[1];
                    return make_int_padding_precision(k$0, acc$0, rest$3, pad$1, prec, convert_int, iconv);
                case 5:
                    var rest$4 = fmt$0[4], prec$0 = fmt$0[3], pad$2 = fmt$0[2], iconv$0 = fmt$0[1];
                    return make_int_padding_precision(k$0, acc$0, rest$4, pad$2, prec$0, convert_int32, iconv$0);
                case 6:
                    var rest$5 = fmt$0[4], prec$1 = fmt$0[3], pad$3 = fmt$0[2], iconv$1 = fmt$0[1];
                    return make_int_padding_precision(k$0, acc$0, rest$5, pad$3, prec$1, convert_nativeint, iconv$1);
                case 7:
                    var rest$6 = fmt$0[4], prec$2 = fmt$0[3], pad$4 = fmt$0[2], iconv$2 = fmt$0[1];
                    return make_int_padding_precision(k$0, acc$0, rest$6, pad$4, prec$2, convert_int64, iconv$2);
                case 8:
                    var rest$7 = fmt$0[4], prec$3 = fmt$0[3], pad$5 = fmt$0[2], fconv = fmt$0[1];
                    if (typeof pad$5 === "number") {
                        if (typeof prec$3 === "number") return prec$3 ? function(p, x) {
                            var str = convert_float(fconv, p, x);
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str
                            ], rest$7);
                        } : function(x) {
                            var str = convert_float(fconv, default_float_precision(fconv), x);
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str
                            ], rest$7);
                        };
                        var p = prec$3[1];
                        return function(x) {
                            var str = convert_float(fconv, p, x);
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str
                            ], rest$7);
                        };
                    }
                    if (0 === pad$5[0]) {
                        var w = pad$5[2], padty = pad$5[1];
                        if (typeof prec$3 === "number") return prec$3 ? function(p, x) {
                            var str = fix_padding(padty, w, convert_float(fconv, p, x));
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str
                            ], rest$7);
                        } : function(x) {
                            var str = convert_float(fconv, default_float_precision(fconv), x), str$0 = fix_padding(padty, w, str);
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str$0
                            ], rest$7);
                        };
                        var p$0 = prec$3[1];
                        return function(x) {
                            var str = fix_padding(padty, w, convert_float(fconv, p$0, x));
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str
                            ], rest$7);
                        };
                    }
                    var padty$0 = pad$5[1];
                    if (typeof prec$3 === "number") return prec$3 ? function(w, p, x) {
                        var str = fix_padding(padty$0, w, convert_float(fconv, p, x));
                        return make_printf(k$0, [
                            4,
                            acc$0,
                            str
                        ], rest$7);
                    } : function(w, x) {
                        var str = convert_float(fconv, default_float_precision(fconv), x), str$0 = fix_padding(padty$0, w, str);
                        return make_printf(k$0, [
                            4,
                            acc$0,
                            str$0
                        ], rest$7);
                    };
                    var p$1 = prec$3[1];
                    return function(w, x) {
                        var str = fix_padding(padty$0, w, convert_float(fconv, p$1, x));
                        return make_printf(k$0, [
                            4,
                            acc$0,
                            str
                        ], rest$7);
                    };
                case 9:
                    var rest$8 = fmt$0[2], pad$6 = fmt$0[1];
                    return make_padding(k$0, acc$0, rest$8, pad$6, Stdlib[30]);
                case 10:
                    var rest$9 = fmt$0[1], acc$1 = [
                        7,
                        acc$0
                    ];
                    acc$0 = acc$1;
                    fmt$0 = rest$9;
                    break;
                case 11:
                    var rest$10 = fmt$0[2], str = fmt$0[1], acc$2 = [
                        2,
                        acc$0,
                        str
                    ];
                    acc$0 = acc$2;
                    fmt$0 = rest$10;
                    break;
                case 12:
                    var rest$11 = fmt$0[2], chr = fmt$0[1], acc$3 = [
                        3,
                        acc$0,
                        chr
                    ];
                    acc$0 = acc$3;
                    fmt$0 = rest$11;
                    break;
                case 13:
                    var rest$12 = fmt$0[3], sub_fmtty = fmt$0[2], ty = string_of_fmtty(sub_fmtty);
                    return function(str) {
                        return make_printf(k$0, [
                            4,
                            acc$0,
                            ty
                        ], rest$12);
                    };
                case 14:
                    var rest$13 = fmt$0[3], fmtty = fmt$0[2];
                    return function(param) {
                        var fmt = param[1], _cf_ = recast(fmt, fmtty);
                        return make_printf(k$0, acc$0, caml_call2(CamlinternalFormatBasics[3], _cf_, rest$13));
                    };
                case 15:
                    var rest$14 = fmt$0[1];
                    return function(f, x) {
                        return make_printf(k$0, [
                            6,
                            acc$0,
                            function(o) {
                                return caml_call2(f, o, x);
                            }
                        ], rest$14);
                    };
                case 16:
                    var rest$15 = fmt$0[1];
                    return function(f) {
                        return make_printf(k$0, [
                            6,
                            acc$0,
                            f
                        ], rest$15);
                    };
                case 17:
                    var rest$16 = fmt$0[2], fmting_lit = fmt$0[1], acc$4 = [
                        0,
                        acc$0,
                        fmting_lit
                    ];
                    acc$0 = acc$4;
                    fmt$0 = rest$16;
                    break;
                case 18:
                    var _cd_ = fmt$0[1];
                    if (0 === _cd_[0]) {
                        var rest$17 = fmt$0[2], fmt$1 = _cd_[1][1];
                        let acc = acc$0, k = k$0, rest = rest$17;
                        var k$1 = function(kacc) {
                            return make_printf(k, [
                                1,
                                acc,
                                [
                                    0,
                                    kacc
                                ]
                            ], rest);
                        };
                        k$0 = k$1;
                        acc$0 = 0;
                        fmt$0 = fmt$1;
                    } else {
                        var rest$18 = fmt$0[2], fmt$2 = _cd_[1][1];
                        let acc = acc$0, k = k$0, rest = rest$18;
                        var k$2 = function(kacc) {
                            return make_printf(k, [
                                1,
                                acc,
                                [
                                    1,
                                    kacc
                                ]
                            ], rest);
                        };
                        k$0 = k$2;
                        acc$0 = 0;
                        fmt$0 = fmt$2;
                    }
                    break;
                case 19:
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _s_
                    ], 1);
                case 20:
                    var rest$19 = fmt$0[3], new_acc = [
                        8,
                        acc$0,
                        cst_Printf_bad_conversion
                    ];
                    return function(param) {
                        return make_printf(k$0, new_acc, rest$19);
                    };
                case 21:
                    var rest$20 = fmt$0[2];
                    return function(n) {
                        var new_acc = [
                            4,
                            acc$0,
                            caml_format_int(cst_u$0, n)
                        ];
                        return make_printf(k$0, new_acc, rest$20);
                    };
                case 22:
                    var rest$21 = fmt$0[1];
                    return function(c) {
                        var new_acc = [
                            5,
                            acc$0,
                            c
                        ];
                        return make_printf(k$0, new_acc, rest$21);
                    };
                case 23:
                    var rest$22 = fmt$0[2], ign = fmt$0[1];
                    if (counter >= 50) return caml_trampoline_return(make_ignored_param$0, [
                        0,
                        k$0,
                        acc$0,
                        ign,
                        rest$22
                    ]);
                    var counter$1 = counter + 1 | 0;
                    return make_ignored_param$0(counter$1, k$0, acc$0, ign, rest$22);
                default:
                    var rest$23 = fmt$0[3], f = fmt$0[2], arity = fmt$0[1], _ce_ = caml_call1(f, 0);
                    if (counter >= 50) return caml_trampoline_return(make_custom$0, [
                        0,
                        k$0,
                        acc$0,
                        rest$23,
                        arity,
                        _ce_
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return make_custom$0(counter$0, k$0, acc$0, rest$23, arity, _ce_);
            }
        }
    }
    function make_printf(k, acc, fmt) {
        return caml_trampoline(make_printf$0(0, k, acc, fmt));
    }
    function make_ignored_param$0(counter, k, acc, ign, fmt) {
        if (typeof ign === "number") switch(ign){
            case 0:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$0 = counter + 1 | 0;
                return make_invalid_arg(counter$0, k, acc, fmt);
            case 1:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$1 = counter + 1 | 0;
                return make_invalid_arg(counter$1, k, acc, fmt);
            case 2:
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _t_
                ], 1);
            default:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$2 = counter + 1 | 0;
                return make_invalid_arg(counter$2, k, acc, fmt);
        }
        switch(ign[0]){
            case 0:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$3 = counter + 1 | 0;
                return make_invalid_arg(counter$3, k, acc, fmt);
            case 1:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$4 = counter + 1 | 0;
                return make_invalid_arg(counter$4, k, acc, fmt);
            case 2:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$5 = counter + 1 | 0;
                return make_invalid_arg(counter$5, k, acc, fmt);
            case 3:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$6 = counter + 1 | 0;
                return make_invalid_arg(counter$6, k, acc, fmt);
            case 4:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$7 = counter + 1 | 0;
                return make_invalid_arg(counter$7, k, acc, fmt);
            case 5:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$8 = counter + 1 | 0;
                return make_invalid_arg(counter$8, k, acc, fmt);
            case 6:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$9 = counter + 1 | 0;
                return make_invalid_arg(counter$9, k, acc, fmt);
            case 7:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$10 = counter + 1 | 0;
                return make_invalid_arg(counter$10, k, acc, fmt);
            case 8:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$11 = counter + 1 | 0;
                return make_invalid_arg(counter$11, k, acc, fmt);
            case 9:
                var fmtty = ign[2];
                if (counter >= 50) return caml_trampoline_return(make_from_fmtty$0, [
                    0,
                    k,
                    acc,
                    fmtty,
                    fmt
                ]);
                var counter$14 = counter + 1 | 0;
                return make_from_fmtty$0(counter$14, k, acc, fmtty, fmt);
            case 10:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$12 = counter + 1 | 0;
                return make_invalid_arg(counter$12, k, acc, fmt);
            default:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$13 = counter + 1 | 0;
                return make_invalid_arg(counter$13, k, acc, fmt);
        }
    }
    function make_ignored_param(k, acc, ign, fmt) {
        return caml_trampoline(make_ignored_param$0(0, k, acc, ign, fmt));
    }
    function make_from_fmtty$0(counter, k, acc, fmtty, fmt) {
        if (typeof fmtty !== "number") switch(fmtty[0]){
            case 0:
                var rest = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest, fmt);
                };
            case 1:
                var rest$0 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$0, fmt);
                };
            case 2:
                var rest$1 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$1, fmt);
                };
            case 3:
                var rest$2 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$2, fmt);
                };
            case 4:
                var rest$3 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$3, fmt);
                };
            case 5:
                var rest$4 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$4, fmt);
                };
            case 6:
                var rest$5 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$5, fmt);
                };
            case 7:
                var rest$6 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$6, fmt);
                };
            case 8:
                var rest$7 = fmtty[2];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$7, fmt);
                };
            case 9:
                var rest$8 = fmtty[3], ty2 = fmtty[2], ty1 = fmtty[1], ty = trans(symm(ty1), ty2);
                return function(param) {
                    return make_from_fmtty(k, acc, caml_call2(CamlinternalFormatBasics[1], ty, rest$8), fmt);
                };
            case 10:
                var rest$9 = fmtty[1];
                return function(_cc_, param) {
                    return make_from_fmtty(k, acc, rest$9, fmt);
                };
            case 11:
                var rest$10 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$10, fmt);
                };
            case 12:
                var rest$11 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$11, fmt);
                };
            case 13:
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _u_
                ], 1);
            default:
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _v_
                ], 1);
        }
        if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
            0,
            k,
            acc,
            fmt
        ]);
        var counter$0 = counter + 1 | 0;
        return make_invalid_arg(counter$0, k, acc, fmt);
    }
    function make_from_fmtty(k, acc, fmtty, fmt) {
        return caml_trampoline(make_from_fmtty$0(0, k, acc, fmtty, fmt));
    }
    function make_invalid_arg(counter, k, acc, fmt) {
        var _cb_ = [
            8,
            acc,
            cst_Printf_bad_conversion$0
        ];
        if (counter >= 50) return caml_trampoline_return(make_printf$0, [
            0,
            k,
            _cb_,
            fmt
        ]);
        var counter$0 = counter + 1 | 0;
        return make_printf$0(counter$0, k, _cb_, fmt);
    }
    function make_padding(k, acc, fmt, pad, trans) {
        if (typeof pad === "number") return function(x) {
            var new_acc = [
                4,
                acc,
                caml_call1(trans, x)
            ];
            return make_printf(k, new_acc, fmt);
        };
        if (0 === pad[0]) {
            var width = pad[2], padty = pad[1];
            return function(x) {
                var new_acc = [
                    4,
                    acc,
                    fix_padding(padty, width, caml_call1(trans, x))
                ];
                return make_printf(k, new_acc, fmt);
            };
        }
        var padty$0 = pad[1];
        return function(w, x) {
            var new_acc = [
                4,
                acc,
                fix_padding(padty$0, w, caml_call1(trans, x))
            ];
            return make_printf(k, new_acc, fmt);
        };
    }
    function make_int_padding_precision(k, acc, fmt, pad, prec, trans, iconv) {
        if (typeof pad === "number") {
            if (typeof prec === "number") return prec ? function(p, x) {
                var str = fix_int_precision(p, caml_call2(trans, iconv, x));
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            } : function(x) {
                var str = caml_call2(trans, iconv, x);
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            };
            var p = prec[1];
            return function(x) {
                var str = fix_int_precision(p, caml_call2(trans, iconv, x));
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            };
        }
        if (0 === pad[0]) {
            var w = pad[2], padty = pad[1];
            if (typeof prec === "number") return prec ? function(p, x) {
                var str = fix_padding(padty, w, fix_int_precision(p, caml_call2(trans, iconv, x)));
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            } : function(x) {
                var str = fix_padding(padty, w, caml_call2(trans, iconv, x));
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            };
            var p$0 = prec[1];
            return function(x) {
                var str = fix_padding(padty, w, fix_int_precision(p$0, caml_call2(trans, iconv, x)));
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            };
        }
        var padty$0 = pad[1];
        if (typeof prec === "number") return prec ? function(w, p, x) {
            var str = fix_padding(padty$0, w, fix_int_precision(p, caml_call2(trans, iconv, x)));
            return make_printf(k, [
                4,
                acc,
                str
            ], fmt);
        } : function(w, x) {
            var str = fix_padding(padty$0, w, caml_call2(trans, iconv, x));
            return make_printf(k, [
                4,
                acc,
                str
            ], fmt);
        };
        var p$1 = prec[1];
        return function(w, x) {
            var str = fix_padding(padty$0, w, fix_int_precision(p$1, caml_call2(trans, iconv, x)));
            return make_printf(k, [
                4,
                acc,
                str
            ], fmt);
        };
    }
    function make_custom$0(counter, k, acc, rest, arity, f) {
        if (arity) {
            var arity$0 = arity[1];
            return function(x) {
                return make_custom(k, acc, rest, arity$0, caml_call1(f, x));
            };
        }
        var _ca_ = [
            4,
            acc,
            f
        ];
        if (counter >= 50) return caml_trampoline_return(make_printf$0, [
            0,
            k,
            _ca_,
            rest
        ]);
        var counter$0 = counter + 1 | 0;
        return make_printf$0(counter$0, k, _ca_, rest);
    }
    function make_custom(k, acc, rest, arity, f) {
        return caml_trampoline(make_custom$0(0, k, acc, rest, arity, f));
    }
    function make_iprintf$0(counter, k, o, fmt) {
        var k$0 = k, fmt$0 = fmt;
        for(;;){
            if (typeof fmt$0 === "number") return caml_call1(k$0, o);
            switch(fmt$0[0]){
                case 0:
                    var rest = fmt$0[1], x = make_iprintf(k$0, o, rest);
                    return function(_b$_) {
                        return x;
                    };
                case 1:
                    var rest$0 = fmt$0[1], x$0 = make_iprintf(k$0, o, rest$0);
                    return function(_b__) {
                        return x$0;
                    };
                case 2:
                    var _bM_ = fmt$0[1];
                    if (typeof _bM_ === "number") {
                        var rest$1 = fmt$0[2], x$1 = make_iprintf(k$0, o, rest$1);
                        return function(_b9_) {
                            return x$1;
                        };
                    }
                    if (0 === _bM_[0]) {
                        var rest$2 = fmt$0[2], x$2 = make_iprintf(k$0, o, rest$2);
                        return function(_b8_) {
                            return x$2;
                        };
                    }
                    var rest$3 = fmt$0[2], x$3 = make_iprintf(k$0, o, rest$3), x$4 = function(_b7_) {
                        return x$3;
                    };
                    return function(_b6_) {
                        return x$4;
                    };
                case 3:
                    var _bN_ = fmt$0[1];
                    if (typeof _bN_ === "number") {
                        var rest$4 = fmt$0[2], x$5 = make_iprintf(k$0, o, rest$4);
                        return function(_b5_) {
                            return x$5;
                        };
                    }
                    if (0 === _bN_[0]) {
                        var rest$5 = fmt$0[2], x$6 = make_iprintf(k$0, o, rest$5);
                        return function(_b4_) {
                            return x$6;
                        };
                    }
                    var rest$6 = fmt$0[2], x$7 = make_iprintf(k$0, o, rest$6), x$8 = function(_b3_) {
                        return x$7;
                    };
                    return function(_b2_) {
                        return x$8;
                    };
                case 4:
                    var rest$7 = fmt$0[4], prec = fmt$0[3], pad = fmt$0[2];
                    return fn_of_padding_precision(k$0, o, rest$7, pad, prec);
                case 5:
                    var rest$8 = fmt$0[4], prec$0 = fmt$0[3], pad$0 = fmt$0[2];
                    return fn_of_padding_precision(k$0, o, rest$8, pad$0, prec$0);
                case 6:
                    var rest$9 = fmt$0[4], prec$1 = fmt$0[3], pad$1 = fmt$0[2];
                    return fn_of_padding_precision(k$0, o, rest$9, pad$1, prec$1);
                case 7:
                    var rest$10 = fmt$0[4], prec$2 = fmt$0[3], pad$2 = fmt$0[2];
                    return fn_of_padding_precision(k$0, o, rest$10, pad$2, prec$2);
                case 8:
                    var rest$11 = fmt$0[4], prec$3 = fmt$0[3], pad$3 = fmt$0[2];
                    return fn_of_padding_precision(k$0, o, rest$11, pad$3, prec$3);
                case 9:
                    var _bO_ = fmt$0[1];
                    if (typeof _bO_ === "number") {
                        var rest$12 = fmt$0[2], x$9 = make_iprintf(k$0, o, rest$12);
                        return function(_b1_) {
                            return x$9;
                        };
                    }
                    if (0 === _bO_[0]) {
                        var rest$13 = fmt$0[2], x$10 = make_iprintf(k$0, o, rest$13);
                        return function(_b0_) {
                            return x$10;
                        };
                    }
                    var rest$14 = fmt$0[2], x$11 = make_iprintf(k$0, o, rest$14), x$12 = function(_bZ_) {
                        return x$11;
                    };
                    return function(_bY_) {
                        return x$12;
                    };
                case 10:
                    var rest$15 = fmt$0[1];
                    fmt$0 = rest$15;
                    break;
                case 11:
                    var rest$16 = fmt$0[2];
                    fmt$0 = rest$16;
                    break;
                case 12:
                    var rest$17 = fmt$0[2];
                    fmt$0 = rest$17;
                    break;
                case 13:
                    var rest$18 = fmt$0[3], x$13 = make_iprintf(k$0, o, rest$18);
                    return function(_bX_) {
                        return x$13;
                    };
                case 14:
                    var rest$19 = fmt$0[3], fmtty = fmt$0[2];
                    return function(param) {
                        var fmt = param[1], _bW_ = recast(fmt, fmtty);
                        return make_iprintf(k$0, o, caml_call2(CamlinternalFormatBasics[3], _bW_, rest$19));
                    };
                case 15:
                    var rest$20 = fmt$0[1], x$14 = make_iprintf(k$0, o, rest$20), x$15 = function(_bV_) {
                        return x$14;
                    };
                    return function(_bU_) {
                        return x$15;
                    };
                case 16:
                    var rest$21 = fmt$0[1], x$16 = make_iprintf(k$0, o, rest$21);
                    return function(_bT_) {
                        return x$16;
                    };
                case 17:
                    var rest$22 = fmt$0[2];
                    fmt$0 = rest$22;
                    break;
                case 18:
                    var _bP_ = fmt$0[1];
                    if (0 === _bP_[0]) {
                        var rest$23 = fmt$0[2], fmt$1 = _bP_[1][1];
                        let k = k$0, rest = rest$23;
                        var k$1 = function(koc) {
                            return make_iprintf(k, koc, rest);
                        };
                        k$0 = k$1;
                        fmt$0 = fmt$1;
                    } else {
                        var rest$24 = fmt$0[2], fmt$2 = _bP_[1][1];
                        let k = k$0, rest = rest$24;
                        var k$2 = function(koc) {
                            return make_iprintf(k, koc, rest);
                        };
                        k$0 = k$2;
                        fmt$0 = fmt$2;
                    }
                    break;
                case 19:
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _w_
                    ], 1);
                case 20:
                    var rest$25 = fmt$0[3], x$17 = make_iprintf(k$0, o, rest$25);
                    return function(_bS_) {
                        return x$17;
                    };
                case 21:
                    var rest$26 = fmt$0[2], x$18 = make_iprintf(k$0, o, rest$26);
                    return function(_bR_) {
                        return x$18;
                    };
                case 22:
                    var rest$27 = fmt$0[1], x$19 = make_iprintf(k$0, o, rest$27);
                    return function(_bQ_) {
                        return x$19;
                    };
                case 23:
                    var rest$28 = fmt$0[2], ign = fmt$0[1];
                    return make_ignored_param(function(param) {
                        return caml_call1(k$0, o);
                    }, 0, ign, rest$28);
                default:
                    var rest$29 = fmt$0[3], arity = fmt$0[1];
                    if (counter >= 50) return caml_trampoline_return(fn_of_custom_arity$0, [
                        0,
                        k$0,
                        o,
                        rest$29,
                        arity
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return fn_of_custom_arity$0(counter$0, k$0, o, rest$29, arity);
            }
        }
    }
    function make_iprintf(k, o, fmt) {
        return caml_trampoline(make_iprintf$0(0, k, o, fmt));
    }
    function fn_of_padding_precision(k, o, fmt, pad, prec) {
        if (typeof pad === "number") {
            if (typeof prec !== "number") {
                var x$2 = make_iprintf(k, o, fmt);
                return function(_bL_) {
                    return x$2;
                };
            }
            if (prec) {
                var x = make_iprintf(k, o, fmt), x$0 = function(_bK_) {
                    return x;
                };
                return function(_bJ_) {
                    return x$0;
                };
            }
            var x$1 = make_iprintf(k, o, fmt);
            return function(_bI_) {
                return x$1;
            };
        }
        if (0 === pad[0]) {
            if (typeof prec !== "number") {
                var x$6 = make_iprintf(k, o, fmt);
                return function(_bH_) {
                    return x$6;
                };
            }
            if (prec) {
                var x$3 = make_iprintf(k, o, fmt), x$4 = function(_bG_) {
                    return x$3;
                };
                return function(_bF_) {
                    return x$4;
                };
            }
            var x$5 = make_iprintf(k, o, fmt);
            return function(_bE_) {
                return x$5;
            };
        }
        if (typeof prec !== "number") {
            var x$12 = make_iprintf(k, o, fmt), x$13 = function(_bD_) {
                return x$12;
            };
            return function(_bC_) {
                return x$13;
            };
        }
        if (prec) {
            var x$7 = make_iprintf(k, o, fmt), x$8 = function(_bB_) {
                return x$7;
            }, x$9 = function(_bA_) {
                return x$8;
            };
            return function(_bz_) {
                return x$9;
            };
        }
        var x$10 = make_iprintf(k, o, fmt);
        function x$11(_by_) {
            return x$10;
        }
        return function(_bx_) {
            return x$11;
        };
    }
    function fn_of_custom_arity$0(counter, k, o, fmt, param) {
        if (param) {
            var arity = param[1], x = fn_of_custom_arity(k, o, fmt, arity);
            return function(_bw_) {
                return x;
            };
        }
        if (counter >= 50) return caml_trampoline_return(make_iprintf$0, [
            0,
            k,
            o,
            fmt
        ]);
        var counter$0 = counter + 1 | 0;
        return make_iprintf$0(counter$0, k, o, fmt);
    }
    function fn_of_custom_arity(k, o, fmt, param) {
        return caml_trampoline(fn_of_custom_arity$0(0, k, o, fmt, param));
    }
    function output_acc(o, acc) {
        var acc$0 = acc;
        for(;;){
            if (typeof acc$0 === "number") return 0;
            switch(acc$0[0]){
                case 0:
                    var fmting_lit = acc$0[2], p = acc$0[1], s = string_of_formatting_lit(fmting_lit);
                    output_acc(o, p);
                    return caml_call2(Stdlib[66], o, s);
                case 1:
                    var match = acc$0[2], p$0 = acc$0[1];
                    if (0 === match[0]) {
                        var acc$1 = match[1];
                        output_acc(o, p$0);
                        caml_call2(Stdlib[66], o, cst$18);
                        acc$0 = acc$1;
                    } else {
                        var acc$2 = match[1];
                        output_acc(o, p$0);
                        caml_call2(Stdlib[66], o, cst$19);
                        acc$0 = acc$2;
                    }
                    break;
                case 6:
                    var f = acc$0[2], p$3 = acc$0[1];
                    output_acc(o, p$3);
                    return caml_call1(f, o);
                case 7:
                    var p$4 = acc$0[1];
                    output_acc(o, p$4);
                    return caml_call1(Stdlib[63], o);
                case 8:
                    var msg = acc$0[2], p$5 = acc$0[1];
                    output_acc(o, p$5);
                    return caml_call1(Stdlib[1], msg);
                case 2:
                case 4:
                    var s$0 = acc$0[2], p$1 = acc$0[1];
                    output_acc(o, p$1);
                    return caml_call2(Stdlib[66], o, s$0);
                default:
                    var c = acc$0[2], p$2 = acc$0[1];
                    output_acc(o, p$2);
                    return caml_call2(Stdlib[65], o, c);
            }
        }
    }
    function bufput_acc(b, acc) {
        var acc$0 = acc;
        for(;;){
            if (typeof acc$0 === "number") return 0;
            switch(acc$0[0]){
                case 0:
                    var fmting_lit = acc$0[2], p = acc$0[1], s = string_of_formatting_lit(fmting_lit);
                    bufput_acc(b, p);
                    return caml_call2(Stdlib_Buffer[16], b, s);
                case 1:
                    var match = acc$0[2], p$0 = acc$0[1];
                    if (0 === match[0]) {
                        var acc$1 = match[1];
                        bufput_acc(b, p$0);
                        caml_call2(Stdlib_Buffer[16], b, cst$20);
                        acc$0 = acc$1;
                    } else {
                        var acc$2 = match[1];
                        bufput_acc(b, p$0);
                        caml_call2(Stdlib_Buffer[16], b, cst$21);
                        acc$0 = acc$2;
                    }
                    break;
                case 6:
                    var f = acc$0[2], p$3 = acc$0[1];
                    bufput_acc(b, p$3);
                    return caml_call1(f, b);
                case 7:
                    var acc$3 = acc$0[1];
                    acc$0 = acc$3;
                    break;
                case 8:
                    var msg = acc$0[2], p$4 = acc$0[1];
                    bufput_acc(b, p$4);
                    return caml_call1(Stdlib[1], msg);
                case 2:
                case 4:
                    var s$0 = acc$0[2], p$1 = acc$0[1];
                    bufput_acc(b, p$1);
                    return caml_call2(Stdlib_Buffer[16], b, s$0);
                default:
                    var c = acc$0[2], p$2 = acc$0[1];
                    bufput_acc(b, p$2);
                    return caml_call2(Stdlib_Buffer[12], b, c);
            }
        }
    }
    function strput_acc(b, acc) {
        var acc$0 = acc;
        for(;;){
            if (typeof acc$0 === "number") return 0;
            switch(acc$0[0]){
                case 0:
                    var fmting_lit = acc$0[2], p = acc$0[1], s = string_of_formatting_lit(fmting_lit);
                    strput_acc(b, p);
                    return caml_call2(Stdlib_Buffer[16], b, s);
                case 1:
                    var match = acc$0[2], p$0 = acc$0[1];
                    if (0 === match[0]) {
                        var acc$1 = match[1];
                        strput_acc(b, p$0);
                        caml_call2(Stdlib_Buffer[16], b, cst$22);
                        acc$0 = acc$1;
                    } else {
                        var acc$2 = match[1];
                        strput_acc(b, p$0);
                        caml_call2(Stdlib_Buffer[16], b, cst$23);
                        acc$0 = acc$2;
                    }
                    break;
                case 6:
                    var f = acc$0[2], p$3 = acc$0[1];
                    strput_acc(b, p$3);
                    var _bv_ = caml_call1(f, 0);
                    return caml_call2(Stdlib_Buffer[16], b, _bv_);
                case 7:
                    var acc$3 = acc$0[1];
                    acc$0 = acc$3;
                    break;
                case 8:
                    var msg = acc$0[2], p$4 = acc$0[1];
                    strput_acc(b, p$4);
                    return caml_call1(Stdlib[1], msg);
                case 2:
                case 4:
                    var s$0 = acc$0[2], p$1 = acc$0[1];
                    strput_acc(b, p$1);
                    return caml_call2(Stdlib_Buffer[16], b, s$0);
                default:
                    var c = acc$0[2], p$2 = acc$0[1];
                    strput_acc(b, p$2);
                    return caml_call2(Stdlib_Buffer[12], b, c);
            }
        }
    }
    function failwith_message(param) {
        var fmt = param[1], buf = caml_call1(Stdlib_Buffer[1], 256);
        function k(acc) {
            strput_acc(buf, acc);
            var _bu_ = caml_call1(Stdlib_Buffer[2], buf);
            return caml_call1(Stdlib[2], _bu_);
        }
        return make_printf(k, 0, fmt);
    }
    function open_box_of_string(str) {
        if (str == cst$43) return _x_;
        var len = caml_ml_string_length(str);
        function invalid_box(param) {
            return caml_call1(failwith_message(_y_), str);
        }
        function parse_spaces(i) {
            var i$0 = i;
            for(;;){
                if (i$0 === len) return i$0;
                var match = caml_string_get(str, i$0);
                if (9 !== match && 32 !== match) return i$0;
                var i$1 = i$0 + 1 | 0;
                i$0 = i$1;
            }
        }
        var wstart = parse_spaces(0);
        a: b: {
            var wend = wstart;
            for(;;){
                if (wend === len) break b;
                if (25 < caml_string_get(str, wend) - 97 >>> 0) break;
                var j = wend + 1 | 0;
                wend = j;
            }
            break a;
        }
        var box_name = caml_call3(Stdlib_String[16], str, wstart, wend - wstart | 0), nstart = parse_spaces(wend);
        a: b: {
            var nend = nstart;
            for(;;){
                if (nend === len) break b;
                var match = caml_string_get(str, nend);
                if (48 <= match) {
                    if (58 <= match) break;
                } else if (45 !== match) break;
                var j$0 = nend + 1 | 0;
                nend = j$0;
            }
            break a;
        }
        if (nstart === nend) var indent = 0;
        else try {
            var _bs_ = runtime.caml_int_of_string(caml_call3(Stdlib_String[16], str, nstart, nend - nstart | 0)), indent = _bs_;
        } catch (_bt_) {
            var _br_ = caml_wrap_exception(_bt_);
            if (_br_[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(_br_, 0);
            var indent = invalid_box(0);
        }
        var exp_end = parse_spaces(nend);
        if (exp_end !== len) invalid_box(0);
        a: {
            if (box_name !== cst$43 && box_name !== "b") {
                if (box_name === "h") {
                    var box_type = 0;
                    break a;
                }
                if (box_name === "hov") {
                    var box_type = 3;
                    break a;
                }
                if (box_name === "hv") {
                    var box_type = 2;
                    break a;
                }
                if (box_name !== "v") {
                    var box_type = invalid_box(0);
                    break a;
                }
                var box_type = 1;
                break a;
            }
            var box_type = 4;
        }
        return [
            0,
            indent,
            box_type
        ];
    }
    function make_padding_fmt_ebb(pad, fmt) {
        if (typeof pad === "number") return [
            0,
            0,
            fmt
        ];
        if (0 === pad[0]) {
            var w = pad[2], s = pad[1];
            return [
                0,
                [
                    0,
                    s,
                    w
                ],
                fmt
            ];
        }
        var s$0 = pad[1];
        return [
            0,
            [
                1,
                s$0
            ],
            fmt
        ];
    }
    function make_padprec_fmt_ebb(pad, prec, fmt) {
        if (typeof prec === "number") var match = prec ? [
            0,
            1
        ] : [
            0,
            0
        ];
        else var p = prec[1], match = [
            0,
            [
                0,
                p
            ]
        ];
        var prec$0 = match[1];
        if (typeof pad === "number") return [
            0,
            0,
            prec$0,
            fmt
        ];
        if (0 === pad[0]) {
            var w = pad[2], s = pad[1];
            return [
                0,
                [
                    0,
                    s,
                    w
                ],
                prec$0,
                fmt
            ];
        }
        var s$0 = pad[1];
        return [
            0,
            [
                1,
                s$0
            ],
            prec$0,
            fmt
        ];
    }
    function fmt_ebb_of_string(legacy_behavior, str) {
        if (legacy_behavior) var flag = legacy_behavior[1], legacy_behavior$0 = flag;
        else var legacy_behavior$0 = 1;
        function invalid_format_message(str_ind, msg) {
            return caml_call3(failwith_message(_z_), str, str_ind, msg);
        }
        function invalid_format_without(str_ind, c, s) {
            return caml_call4(failwith_message(_A_), str, str_ind, c, s);
        }
        function expected_character(str_ind, expected, read) {
            return caml_call4(failwith_message(_B_), str, str_ind, expected, read);
        }
        function parse(lit_start, end_ind) {
            a: {
                var str_ind = lit_start;
                for(;;){
                    if (str_ind === end_ind) return add_literal(lit_start, str_ind, 0);
                    var match = caml_string_get(str, str_ind);
                    if (37 === match) break;
                    if (64 === match) break a;
                    var str_ind$1 = str_ind + 1 | 0;
                    str_ind = str_ind$1;
                }
                var str_ind$2 = str_ind + 1 | 0;
                if (str_ind$2 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                var match$1 = 95 === caml_string_get(str, str_ind$2) ? parse_flags(str_ind, str_ind$2 + 1 | 0, end_ind, 1) : parse_flags(str_ind, str_ind$2, end_ind, 0), fmt_rest = match$1[1];
                return add_literal(lit_start, str_ind, fmt_rest);
            }
            var str_ind$0 = str_ind + 1 | 0;
            a: if (str_ind$0 === end_ind) var match$0 = _N_;
            else {
                var c = caml_string_get(str, str_ind$0);
                if (65 <= c) {
                    if (94 <= c) {
                        var switcher = c - 123 | 0;
                        if (2 >= switcher >>> 0) switch(switcher){
                            case 0:
                                var match$0 = parse_tag(1, str_ind$0 + 1 | 0, end_ind);
                                break a;
                            case 1:
                                break;
                            default:
                                var fmt_rest$2 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                    0,
                                    [
                                        17,
                                        1,
                                        fmt_rest$2
                                    ]
                                ];
                                break a;
                        }
                    } else if (91 <= c) switch(c - 91 | 0){
                        case 0:
                            var match$0 = parse_tag(0, str_ind$0 + 1 | 0, end_ind);
                            break a;
                        case 1:
                            break;
                        default:
                            var fmt_rest$3 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    0,
                                    fmt_rest$3
                                ]
                            ];
                            break a;
                    }
                } else {
                    if (10 === c) {
                        var fmt_rest$4 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                            0,
                            [
                                17,
                                3,
                                fmt_rest$4
                            ]
                        ];
                        break a;
                    }
                    if (32 <= c) switch(c - 32 | 0){
                        case 0:
                            var fmt_rest$5 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    _O_,
                                    fmt_rest$5
                                ]
                            ];
                            break a;
                        case 5:
                            if ((str_ind$0 + 1 | 0) < end_ind && 37 === caml_string_get(str, str_ind$0 + 1 | 0)) {
                                var fmt_rest$6 = parse(str_ind$0 + 2 | 0, end_ind)[1], match$0 = [
                                    0,
                                    [
                                        17,
                                        6,
                                        fmt_rest$6
                                    ]
                                ];
                                break a;
                            }
                            var fmt_rest$7 = parse(str_ind$0, end_ind)[1], match$0 = [
                                0,
                                [
                                    12,
                                    64,
                                    fmt_rest$7
                                ]
                            ];
                            break a;
                        case 12:
                            var fmt_rest$8 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    _P_,
                                    fmt_rest$8
                                ]
                            ];
                            break a;
                        case 14:
                            var fmt_rest$9 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    4,
                                    fmt_rest$9
                                ]
                            ];
                            break a;
                        case 27:
                            var str_ind$3 = str_ind$0 + 1 | 0;
                            b: try {
                                var _bg_ = str_ind$3 === end_ind ? 1 : 0, _bh_ = _bg_ || (60 !== caml_string_get(str, str_ind$3) ? 1 : 0);
                                if (_bh_) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                var str_ind_1 = parse_spaces(str_ind$3 + 1 | 0, end_ind), match$2 = caml_string_get(str, str_ind_1);
                                c: {
                                    if (48 <= match$2) {
                                        if (58 > match$2) break c;
                                    } else if (45 === match$2) break c;
                                    throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                }
                                var match$3 = parse_integer(str_ind_1, end_ind), width = match$3[2], str_ind_2 = match$3[1], str_ind_3 = parse_spaces(str_ind_2, end_ind), switcher$0 = caml_string_get(str, str_ind_3) - 45 | 0;
                                if (12 < switcher$0 >>> 0) {
                                    if (17 === switcher$0) {
                                        var s = caml_call3(Stdlib_String[16], str, str_ind$3 - 2 | 0, (str_ind_3 - str_ind$3 | 0) + 3 | 0), _bi_ = [
                                            0,
                                            s,
                                            width,
                                            0
                                        ], _bj_ = str_ind_3 + 1 | 0, formatting_lit$0 = _bi_, next_ind = _bj_;
                                        break b;
                                    }
                                } else if (1 < switcher$0 - 1 >>> 0) {
                                    var match$4 = parse_integer(str_ind_3, end_ind), offset = match$4[2], str_ind_4 = match$4[1], str_ind_5 = parse_spaces(str_ind_4, end_ind);
                                    if (62 !== caml_string_get(str, str_ind_5)) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                    var s$0 = caml_call3(Stdlib_String[16], str, str_ind$3 - 2 | 0, (str_ind_5 - str_ind$3 | 0) + 3 | 0), _bk_ = [
                                        0,
                                        s$0,
                                        width,
                                        offset
                                    ], _bl_ = str_ind_5 + 1 | 0, formatting_lit$0 = _bk_, next_ind = _bl_;
                                    break b;
                                }
                                throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                            } catch (_bq_) {
                                var _bf_ = caml_wrap_exception(_bq_);
                                if (_bf_ !== Stdlib[8] && _bf_[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(_bf_, 0);
                                var formatting_lit$0 = formatting_lit, next_ind = str_ind$3;
                            }
                            var fmt_rest$12 = parse(next_ind, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    formatting_lit$0,
                                    fmt_rest$12
                                ]
                            ];
                            break a;
                        case 28:
                            var str_ind$4 = str_ind$0 + 1 | 0;
                            try {
                                var str_ind_1$0 = parse_spaces(str_ind$4, end_ind), match$6 = caml_string_get(str, str_ind_1$0);
                                b: {
                                    c: {
                                        if (48 <= match$6) {
                                            if (58 > match$6) break c;
                                        } else if (45 === match$6) break c;
                                        var _bo_ = 0;
                                        break b;
                                    }
                                    var match$7 = parse_integer(str_ind_1$0, end_ind), size = match$7[2], str_ind_2$0 = match$7[1], str_ind_3$0 = parse_spaces(str_ind_2$0, end_ind);
                                    if (62 !== caml_string_get(str, str_ind_3$0)) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                    var s$1 = caml_call3(Stdlib_String[16], str, str_ind$4 - 2 | 0, (str_ind_3$0 - str_ind$4 | 0) + 3 | 0), _bo_ = [
                                        0,
                                        [
                                            0,
                                            str_ind_3$0 + 1 | 0,
                                            [
                                                1,
                                                s$1,
                                                size
                                            ]
                                        ]
                                    ];
                                }
                                var _bn_ = _bo_;
                            } catch (_bp_) {
                                var _bm_ = caml_wrap_exception(_bp_);
                                if (_bm_ !== Stdlib[8] && _bm_[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(_bm_, 0);
                                var _bn_ = 0;
                            }
                            if (_bn_) var match$5 = _bn_[1], formatting_lit$1 = match$5[2], next_ind$0 = match$5[1], fmt_rest$13 = parse(next_ind$0, end_ind)[1], _be_ = [
                                0,
                                [
                                    17,
                                    formatting_lit$1,
                                    fmt_rest$13
                                ]
                            ];
                            else var fmt_rest$14 = parse(str_ind$4, end_ind)[1], _be_ = [
                                0,
                                [
                                    17,
                                    _Q_,
                                    fmt_rest$14
                                ]
                            ];
                            var match$0 = _be_;
                            break a;
                        case 31:
                            var fmt_rest$10 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    2,
                                    fmt_rest$10
                                ]
                            ];
                            break a;
                        case 32:
                            var fmt_rest$11 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    5,
                                    fmt_rest$11
                                ]
                            ];
                            break a;
                    }
                }
                var fmt_rest$1 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                    0,
                    [
                        17,
                        [
                            2,
                            c
                        ],
                        fmt_rest$1
                    ]
                ];
            }
            var fmt_rest$0 = match$0[1];
            return add_literal(lit_start, str_ind, fmt_rest$0);
        }
        function parse_flags(pct_ind, str_ind, end_ind, ign) {
            var zero = [
                0,
                0
            ], minus = [
                0,
                0
            ], plus = [
                0,
                0
            ], space = [
                0,
                0
            ], hash = [
                0,
                0
            ];
            function set_flag(str_ind, flag) {
                var _bb_ = flag[1], _bc_ = _bb_ ? 1 - legacy_behavior$0 : _bb_;
                if (_bc_) {
                    var _bd_ = caml_string_get(str, str_ind);
                    caml_call3(failwith_message(_C_), str, str_ind, _bd_);
                }
                flag[1] = 1;
                return;
            }
            a: b: {
                var str_ind$0 = str_ind;
                c: for(;;){
                    if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                    var switcher = caml_string_get(str, str_ind$0) - 32 | 0;
                    if (16 < switcher >>> 0) break b;
                    switch(switcher){
                        case 0:
                            set_flag(str_ind$0, space);
                            var str_ind$1 = str_ind$0 + 1 | 0;
                            str_ind$0 = str_ind$1;
                            break;
                        case 3:
                            set_flag(str_ind$0, hash);
                            var str_ind$2 = str_ind$0 + 1 | 0;
                            str_ind$0 = str_ind$2;
                            break;
                        case 11:
                            set_flag(str_ind$0, plus);
                            var str_ind$3 = str_ind$0 + 1 | 0;
                            str_ind$0 = str_ind$3;
                            break;
                        case 13:
                            set_flag(str_ind$0, minus);
                            var str_ind$4 = str_ind$0 + 1 | 0;
                            str_ind$0 = str_ind$4;
                            break;
                        case 16:
                            set_flag(str_ind$0, zero);
                            var str_ind$5 = str_ind$0 + 1 | 0;
                            str_ind$0 = str_ind$5;
                            break;
                        default:
                            break c;
                    }
                }
                break a;
            }
            var space$0 = space[1], hash$0 = hash[1], plus$0 = plus[1], minus$0 = minus[1], zero$0 = zero[1];
            if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
            var padty = zero$0 ? minus$0 ? legacy_behavior$0 ? 0 : incompatible_flag(pct_ind, str_ind$0, 45, cst_0) : 2 : minus$0 ? 0 : 1, match = caml_string_get(str, str_ind$0);
            if (48 <= match) {
                if (58 > match) {
                    var match$0 = parse_positive(str_ind$0, end_ind, 0), width = match$0[2], new_ind = match$0[1];
                    return parse_after_padding(pct_ind, new_ind, end_ind, minus$0, plus$0, hash$0, space$0, ign, [
                        0,
                        padty,
                        width
                    ]);
                }
            } else if (42 === match) return parse_after_padding(pct_ind, str_ind$0 + 1 | 0, end_ind, minus$0, plus$0, hash$0, space$0, ign, [
                1,
                padty
            ]);
            switch(padty){
                case 0:
                    if (1 - legacy_behavior$0) invalid_format_without(str_ind$0 - 1 | 0, 45, cst_padding);
                    return parse_after_padding(pct_ind, str_ind$0, end_ind, minus$0, plus$0, hash$0, space$0, ign, 0);
                case 1:
                    return parse_after_padding(pct_ind, str_ind$0, end_ind, minus$0, plus$0, hash$0, space$0, ign, 0);
                default:
                    return parse_after_padding(pct_ind, str_ind$0, end_ind, minus$0, plus$0, hash$0, space$0, ign, _D_);
            }
        }
        function parse_after_padding(pct_ind, str_ind, end_ind, minus, plus, hash, space, ign, pad) {
            if (str_ind === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
            var symb = caml_string_get(str, str_ind);
            if (46 !== symb) return parse_conversion(pct_ind, str_ind + 1 | 0, end_ind, plus, hash, space, ign, pad, 0, pad, symb);
            var str_ind$0 = str_ind + 1 | 0;
            if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
            function parse_literal(minus, str_ind) {
                var match = parse_positive(str_ind, end_ind, 0), prec = match[2], new_ind = match[1];
                return parse_after_precision(pct_ind, new_ind, end_ind, minus, plus, hash, space, ign, pad, [
                    0,
                    prec
                ]);
            }
            var symb$0 = caml_string_get(str, str_ind$0);
            if (48 <= symb$0) {
                if (58 > symb$0) return parse_literal(minus, str_ind$0);
            } else if (42 <= symb$0) switch(symb$0 - 42 | 0){
                case 0:
                    return parse_after_precision(pct_ind, str_ind$0 + 1 | 0, end_ind, minus, plus, hash, space, ign, pad, 1);
                case 1:
                case 3:
                    if (legacy_behavior$0) {
                        var _ba_ = str_ind$0 + 1 | 0, minus$0 = minus || (45 === symb$0 ? 1 : 0);
                        return parse_literal(minus$0, _ba_);
                    }
                    break;
            }
            return legacy_behavior$0 ? parse_after_precision(pct_ind, str_ind$0, end_ind, minus, plus, hash, space, ign, pad, _E_) : invalid_format_without(str_ind$0 - 1 | 0, 46, cst_precision);
        }
        function parse_after_precision(pct_ind, str_ind, end_ind, minus, plus, hash, space, ign, pad, prec) {
            if (str_ind === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
            function parse_conv(padprec) {
                return parse_conversion(pct_ind, str_ind + 1 | 0, end_ind, plus, hash, space, ign, pad, prec, padprec, caml_string_get(str, str_ind));
            }
            if (typeof pad !== "number") return parse_conv(pad);
            if (typeof prec === "number" && !prec) return parse_conv(0);
            if (minus) {
                if (typeof prec === "number") return parse_conv(_F_);
                var n = prec[1];
                return parse_conv([
                    0,
                    0,
                    n
                ]);
            }
            if (typeof prec === "number") return parse_conv(_G_);
            var n$0 = prec[1];
            return parse_conv([
                0,
                1,
                n$0
            ]);
        }
        function parse_conversion(pct_ind, str_ind, end_ind, plus, hash, space, ign, pad, prec, padprec, symb) {
            var plus_used = [
                0,
                0
            ], hash_used = [
                0,
                0
            ], space_used = [
                0,
                0
            ], ign_used = [
                0,
                0
            ], pad_used = [
                0,
                0
            ], prec_used = [
                0,
                0
            ];
            function get_plus(param) {
                plus_used[1] = 1;
                return plus;
            }
            function get_hash(param) {
                hash_used[1] = 1;
                return hash;
            }
            function get_space(param) {
                space_used[1] = 1;
                return space;
            }
            function get_ign(param) {
                ign_used[1] = 1;
                return ign;
            }
            function get_pad(param) {
                pad_used[1] = 1;
                return pad;
            }
            function get_prec(param) {
                prec_used[1] = 1;
                return prec;
            }
            function get_padprec(param) {
                pad_used[1] = 1;
                return padprec;
            }
            function get_int_pad(param) {
                var pad = get_pad(0), match = get_prec(0);
                if (typeof match === "number" && !match) return pad;
                if (typeof pad === "number") return 0;
                if (0 !== pad[0]) return 2 <= pad[1] ? legacy_behavior$0 ? _H_ : incompatible_flag(pct_ind, str_ind, 48, cst_precision$1) : pad;
                if (2 > pad[1]) return pad;
                var n = pad[2];
                return legacy_behavior$0 ? [
                    0,
                    1,
                    n
                ] : incompatible_flag(pct_ind, str_ind, 48, cst_precision$0);
            }
            function check_no_0(symb, pad) {
                if (typeof pad === "number") return pad;
                if (0 !== pad[0]) return 2 <= pad[1] ? legacy_behavior$0 ? _I_ : incompatible_flag(pct_ind, str_ind, symb, cst_0$1) : pad;
                if (2 > pad[1]) return pad;
                var width = pad[2];
                return legacy_behavior$0 ? [
                    0,
                    1,
                    width
                ] : incompatible_flag(pct_ind, str_ind, symb, cst_0$0);
            }
            function opt_of_pad(c, pad) {
                if (typeof pad === "number") return 0;
                if (0 === pad[0]) switch(pad[1]){
                    case 0:
                        var width = pad[2];
                        return legacy_behavior$0 ? [
                            0,
                            width
                        ] : incompatible_flag(pct_ind, str_ind, c, cst$24);
                    case 1:
                        var width$0 = pad[2];
                        return [
                            0,
                            width$0
                        ];
                    default:
                        var width$1 = pad[2];
                        return legacy_behavior$0 ? [
                            0,
                            width$1
                        ] : incompatible_flag(pct_ind, str_ind, c, cst_0$2);
                }
                return incompatible_flag(pct_ind, str_ind, c, cst$25);
            }
            function get_pad_opt(c) {
                return opt_of_pad(c, get_pad(0));
            }
            function get_padprec_opt(c) {
                return opt_of_pad(c, get_padprec(0));
            }
            a: {
                if (124 > symb) switch(symb){
                    case 33:
                        var fmt_rest$5 = parse(str_ind, end_ind)[1], fmt_result = [
                            0,
                            [
                                10,
                                fmt_rest$5
                            ]
                        ];
                        break a;
                    case 40:
                        var sub_end = search_subformat_end(str_ind, end_ind, 41), fmt_rest$7 = parse(sub_end + 2 | 0, end_ind)[1], sub_fmt = parse(str_ind, sub_end)[1], sub_fmtty = fmtty_of_fmt(sub_fmt);
                        if (get_ign(0)) var ignored$2 = [
                            9,
                            get_pad_opt(95),
                            sub_fmtty
                        ], _aJ_ = [
                            0,
                            [
                                23,
                                ignored$2,
                                fmt_rest$7
                            ]
                        ];
                        else var _aJ_ = [
                            0,
                            [
                                14,
                                get_pad_opt(40),
                                sub_fmtty,
                                fmt_rest$7
                            ]
                        ];
                        var fmt_result = _aJ_;
                        break a;
                    case 44:
                        var fmt_result = parse(str_ind, end_ind);
                        break a;
                    case 67:
                        var fmt_rest$10 = parse(str_ind, end_ind)[1], _aL_ = get_ign(0) ? [
                            0,
                            [
                                23,
                                1,
                                fmt_rest$10
                            ]
                        ] : [
                            0,
                            [
                                1,
                                fmt_rest$10
                            ]
                        ], fmt_result = _aL_;
                        break a;
                    case 78:
                        var fmt_rest$14 = parse(str_ind, end_ind)[1], counter$0 = 2;
                        if (get_ign(0)) var ignored$6 = [
                            11,
                            counter$0
                        ], _aR_ = [
                            0,
                            [
                                23,
                                ignored$6,
                                fmt_rest$14
                            ]
                        ];
                        else var _aR_ = [
                            0,
                            [
                                21,
                                counter$0,
                                fmt_rest$14
                            ]
                        ];
                        var fmt_result = _aR_;
                        break a;
                    case 83:
                        var pad$6 = check_no_0(symb, get_padprec(0)), fmt_rest$15 = parse(str_ind, end_ind)[1];
                        if (get_ign(0)) var ignored$7 = [
                            1,
                            get_padprec_opt(95)
                        ], _aS_ = [
                            0,
                            [
                                23,
                                ignored$7,
                                fmt_rest$15
                            ]
                        ];
                        else var match$5 = make_padding_fmt_ebb(pad$6, fmt_rest$15), fmt_rest$16 = match$5[2], pad$7 = match$5[1], _aS_ = [
                            0,
                            [
                                3,
                                pad$7,
                                fmt_rest$16
                            ]
                        ];
                        var fmt_result = _aS_;
                        break a;
                    case 91:
                        if (str_ind === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                        var char_set = create_char_set(0), add_range = function(c$0, c) {
                            if (c >= c$0) {
                                var i = c$0;
                                for(;;){
                                    add_in_char_set(char_set, caml_call1(Stdlib[29], i));
                                    var _a$_ = i + 1 | 0;
                                    if (c === i) break;
                                    i = _a$_;
                                }
                            }
                            return;
                        }, fail_single_percent = function(str_ind) {
                            return caml_call2(failwith_message(_R_), str, str_ind);
                        }, parse_char_set_content = function(counter, str_ind, end_ind) {
                            var str_ind$0 = str_ind;
                            for(;;){
                                if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                                var c = caml_string_get(str, str_ind$0);
                                if (45 !== c) {
                                    if (93 === c) return str_ind$0 + 1 | 0;
                                    var _a__ = str_ind$0 + 1 | 0;
                                    if (counter >= 50) return caml_trampoline_return(parse_char_set_after_char$0, [
                                        0,
                                        _a__,
                                        end_ind,
                                        c
                                    ]);
                                    var counter$0 = counter + 1 | 0;
                                    return parse_char_set_after_char$0(counter$0, _a__, end_ind, c);
                                }
                                add_in_char_set(char_set, 45);
                                var str_ind$1 = str_ind$0 + 1 | 0;
                                str_ind$0 = str_ind$1;
                            }
                        }, parse_char_set_after_char$0 = function(counter, str_ind, end_ind, c) {
                            var str_ind$0 = str_ind, c$0 = c;
                            for(;;){
                                if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                                var c$1 = caml_string_get(str, str_ind$0);
                                a: {
                                    if (46 <= c$1) {
                                        if (64 !== c$1) {
                                            if (93 !== c$1) break a;
                                            add_in_char_set(char_set, c$0);
                                            return str_ind$0 + 1 | 0;
                                        }
                                    } else if (37 !== c$1) {
                                        if (45 > c$1) break a;
                                        var str_ind$2 = str_ind$0 + 1 | 0;
                                        if (str_ind$2 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                                        var c$2 = caml_string_get(str, str_ind$2);
                                        if (37 === c$2) {
                                            if ((str_ind$2 + 1 | 0) === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                                            var c$3 = caml_string_get(str, str_ind$2 + 1 | 0);
                                            if (37 !== c$3 && 64 !== c$3) return fail_single_percent(str_ind$2);
                                            add_range(c$0, c$3);
                                            var _a8_ = str_ind$2 + 2 | 0;
                                            if (counter >= 50) return caml_trampoline_return(parse_char_set_content, [
                                                0,
                                                _a8_,
                                                end_ind
                                            ]);
                                            var counter$1 = counter + 1 | 0;
                                            return parse_char_set_content(counter$1, _a8_, end_ind);
                                        }
                                        if (93 === c$2) {
                                            add_in_char_set(char_set, c$0);
                                            add_in_char_set(char_set, 45);
                                            return str_ind$2 + 1 | 0;
                                        }
                                        add_range(c$0, c$2);
                                        var _a9_ = str_ind$2 + 1 | 0;
                                        if (counter >= 50) return caml_trampoline_return(parse_char_set_content, [
                                            0,
                                            _a9_,
                                            end_ind
                                        ]);
                                        var counter$0 = counter + 1 | 0;
                                        return parse_char_set_content(counter$0, _a9_, end_ind);
                                    }
                                    if (37 === c$0) {
                                        add_in_char_set(char_set, c$1);
                                        var _a7_ = str_ind$0 + 1 | 0;
                                        if (counter >= 50) return caml_trampoline_return(parse_char_set_content, [
                                            0,
                                            _a7_,
                                            end_ind
                                        ]);
                                        var counter$2 = counter + 1 | 0;
                                        return parse_char_set_content(counter$2, _a7_, end_ind);
                                    }
                                }
                                if (37 === c$0) fail_single_percent(str_ind$0);
                                add_in_char_set(char_set, c$0);
                                var str_ind$1 = str_ind$0 + 1 | 0;
                                str_ind$0 = str_ind$1;
                                c$0 = c$1;
                            }
                        }, parse_char_set_after_char = function(str_ind, end_ind, c) {
                            return caml_trampoline(parse_char_set_after_char$0(0, str_ind, end_ind, c));
                        };
                        if (str_ind === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                        if (94 === caml_string_get(str, str_ind)) var str_ind$0 = str_ind + 1 | 0, reverse = 1, str_ind$1 = str_ind$0;
                        else var reverse = 0, str_ind$1 = str_ind;
                        if (str_ind$1 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                        var c = caml_string_get(str, str_ind$1), next_ind = parse_char_set_after_char(str_ind$1 + 1 | 0, end_ind, c), char_set$0 = freeze_char_set(char_set), char_set$1 = reverse ? rev_char_set(char_set$0) : char_set$0, fmt_rest$19 = parse(next_ind, end_ind)[1];
                        if (get_ign(0)) var ignored$9 = [
                            10,
                            get_pad_opt(95),
                            char_set$1
                        ], _aX_ = [
                            0,
                            [
                                23,
                                ignored$9,
                                fmt_rest$19
                            ]
                        ];
                        else var _aX_ = [
                            0,
                            [
                                20,
                                get_pad_opt(91),
                                char_set$1,
                                fmt_rest$19
                            ]
                        ];
                        var fmt_result = _aX_;
                        break a;
                    case 97:
                        var fmt_rest$20 = parse(str_ind, end_ind)[1], fmt_result = [
                            0,
                            [
                                15,
                                fmt_rest$20
                            ]
                        ];
                        break a;
                    case 99:
                        var char_format = function(fmt_rest) {
                            return get_ign(0) ? [
                                0,
                                [
                                    23,
                                    0,
                                    fmt_rest
                                ]
                            ] : [
                                0,
                                [
                                    0,
                                    fmt_rest
                                ]
                            ];
                        }, fmt_rest$21 = parse(str_ind, end_ind)[1], match$7 = get_pad_opt(99);
                        if (match$7) {
                            if (0 === match$7[1]) var _aY_ = get_ign(0) ? [
                                0,
                                [
                                    23,
                                    3,
                                    fmt_rest$21
                                ]
                            ] : [
                                0,
                                [
                                    22,
                                    fmt_rest$21
                                ]
                            ], _aZ_ = _aY_;
                            else var _aZ_ = legacy_behavior$0 ? char_format(fmt_rest$21) : invalid_format_message(str_ind, cst_non_zero_widths_are_unsupp);
                            var _a0_ = _aZ_;
                        } else var _a0_ = char_format(fmt_rest$21);
                        var fmt_result = _a0_;
                        break a;
                    case 114:
                        var fmt_rest$22 = parse(str_ind, end_ind)[1], _a1_ = get_ign(0) ? [
                            0,
                            [
                                23,
                                2,
                                fmt_rest$22
                            ]
                        ] : [
                            0,
                            [
                                19,
                                fmt_rest$22
                            ]
                        ], fmt_result = _a1_;
                        break a;
                    case 115:
                        var pad$9 = check_no_0(symb, get_padprec(0)), fmt_rest$23 = parse(str_ind, end_ind)[1];
                        if (get_ign(0)) var ignored$10 = [
                            0,
                            get_padprec_opt(95)
                        ], _a2_ = [
                            0,
                            [
                                23,
                                ignored$10,
                                fmt_rest$23
                            ]
                        ];
                        else var match$8 = make_padding_fmt_ebb(pad$9, fmt_rest$23), fmt_rest$24 = match$8[2], pad$10 = match$8[1], _a2_ = [
                            0,
                            [
                                2,
                                pad$10,
                                fmt_rest$24
                            ]
                        ];
                        var fmt_result = _a2_;
                        break a;
                    case 116:
                        var fmt_rest$25 = parse(str_ind, end_ind)[1], fmt_result = [
                            0,
                            [
                                16,
                                fmt_rest$25
                            ]
                        ];
                        break a;
                    case 123:
                        var sub_end$0 = search_subformat_end(str_ind, end_ind, 125), sub_fmt$0 = parse(str_ind, sub_end$0)[1], fmt_rest$26 = parse(sub_end$0 + 2 | 0, end_ind)[1], sub_fmtty$0 = fmtty_of_fmt(sub_fmt$0);
                        if (get_ign(0)) var ignored$11 = [
                            8,
                            get_pad_opt(95),
                            sub_fmtty$0
                        ], _a3_ = [
                            0,
                            [
                                23,
                                ignored$11,
                                fmt_rest$26
                            ]
                        ];
                        else var _a3_ = [
                            0,
                            [
                                13,
                                get_pad_opt(123),
                                sub_fmtty$0,
                                fmt_rest$26
                            ]
                        ];
                        var fmt_result = _a3_;
                        break a;
                    case 66:
                    case 98:
                        var pad$3 = check_no_0(symb, get_padprec(0)), fmt_rest$8 = parse(str_ind, end_ind)[1];
                        if (get_ign(0)) var ignored$3 = [
                            7,
                            get_padprec_opt(95)
                        ], _aK_ = [
                            0,
                            [
                                23,
                                ignored$3,
                                fmt_rest$8
                            ]
                        ];
                        else var match$3 = make_padding_fmt_ebb(pad$3, fmt_rest$8), fmt_rest$9 = match$3[2], pad$4 = match$3[1], _aK_ = [
                            0,
                            [
                                9,
                                pad$4,
                                fmt_rest$9
                            ]
                        ];
                        var fmt_result = _aK_;
                        break a;
                    case 37:
                    case 64:
                        var fmt_rest$6 = parse(str_ind, end_ind)[1], fmt_result = [
                            0,
                            [
                                12,
                                symb,
                                fmt_rest$6
                            ]
                        ];
                        break a;
                    case 76:
                    case 108:
                    case 110:
                        if (str_ind !== end_ind) {
                            var symb$0 = caml_string_get(str, str_ind), _a4_ = symb$0 - 88 | 0;
                            b: {
                                if (32 >= _a4_ >>> 0) switch(_a4_){
                                    case 0:
                                    case 12:
                                    case 17:
                                    case 23:
                                    case 29:
                                    case 32:
                                        var _aQ_ = 1;
                                        break b;
                                }
                                var _aQ_ = 0;
                            }
                            if (_aQ_) break;
                        }
                        var fmt_rest$13 = parse(str_ind, end_ind)[1];
                        b: {
                            if (108 <= symb) {
                                if (111 > symb) switch(symb - 108 | 0){
                                    case 0:
                                        var counter = 0;
                                        break b;
                                    case 1:
                                        break;
                                    default:
                                        var counter = 1;
                                        break b;
                                }
                            } else if (76 === symb) {
                                var counter = 2;
                                break b;
                            }
                            throw caml_maybe_attach_backtrace([
                                0,
                                Assert_failure,
                                _V_
                            ], 1);
                        }
                        if (get_ign(0)) var ignored$5 = [
                            11,
                            counter
                        ], _aP_ = [
                            0,
                            [
                                23,
                                ignored$5,
                                fmt_rest$13
                            ]
                        ];
                        else var _aP_ = [
                            0,
                            [
                                21,
                                counter,
                                fmt_rest$13
                            ]
                        ];
                        var fmt_result = _aP_;
                        break a;
                    case 32:
                    case 35:
                    case 43:
                    case 45:
                    case 95:
                        var fmt_result = caml_call3(failwith_message(_M_), str, pct_ind, symb);
                        break a;
                    case 88:
                    case 100:
                    case 105:
                    case 111:
                    case 117:
                    case 120:
                        var _aT_ = get_space(0), _aU_ = get_hash(0), iconv$2 = compute_int_conv(pct_ind, str_ind, get_plus(0), _aU_, _aT_, symb), fmt_rest$17 = parse(str_ind, end_ind)[1];
                        if (get_ign(0)) var ignored$8 = [
                            2,
                            iconv$2,
                            get_pad_opt(95)
                        ], _aV_ = [
                            0,
                            [
                                23,
                                ignored$8,
                                fmt_rest$17
                            ]
                        ];
                        else var _aW_ = get_prec(0), match$6 = make_padprec_fmt_ebb(get_int_pad(0), _aW_, fmt_rest$17), fmt_rest$18 = match$6[3], prec$4 = match$6[2], pad$8 = match$6[1], _aV_ = [
                            0,
                            [
                                4,
                                iconv$2,
                                pad$8,
                                prec$4,
                                fmt_rest$18
                            ]
                        ];
                        var fmt_result = _aV_;
                        break a;
                    case 69:
                    case 70:
                    case 71:
                    case 72:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                        var space$1 = get_space(0), hash$1 = get_hash(0), plus$2 = get_plus(0), flag = plus$2 ? space$1 ? legacy_behavior$0 ? 1 : incompatible_flag(pct_ind, str_ind, 32, cst$36) : 1 : space$1 ? 2 : 0;
                        b: {
                            c: if (73 <= symb) {
                                var switcher = symb - 101 | 0;
                                if (3 >= switcher >>> 0) {
                                    switch(switcher){
                                        case 0:
                                            var _a5_ = 1;
                                            break;
                                        case 1:
                                            var _a5_ = 0;
                                            break;
                                        case 2:
                                            var _a5_ = 3;
                                            break;
                                        default:
                                            var _a5_ = 6;
                                    }
                                    var kind = _a5_;
                                    break b;
                                }
                            } else if (69 <= symb) {
                                switch(symb - 69 | 0){
                                    case 0:
                                        var _a6_ = 2;
                                        break;
                                    case 1:
                                        break c;
                                    case 2:
                                        var _a6_ = 4;
                                        break;
                                    default:
                                        var _a6_ = 7;
                                }
                                var kind = _a6_;
                                break b;
                            }
                            if (hash$1) {
                                if (70 === symb) {
                                    var kind = 8;
                                    break b;
                                }
                            } else if (70 === symb) {
                                var kind = 5;
                                break b;
                            }
                            throw caml_maybe_attach_backtrace([
                                0,
                                Assert_failure,
                                _X_
                            ], 1);
                        }
                        var fconv = [
                            0,
                            flag,
                            kind
                        ], fmt_rest$11 = parse(str_ind, end_ind)[1];
                        if (get_ign(0)) {
                            var match = get_prec(0);
                            if (typeof match === "number") var _aM_ = match ? incompatible_flag(pct_ind, str_ind, 95, cst$26) : 0;
                            else var ndec = match[1], _aM_ = [
                                0,
                                ndec
                            ];
                            var ignored$4 = [
                                6,
                                get_pad_opt(95),
                                _aM_
                            ], _aN_ = [
                                0,
                                [
                                    23,
                                    ignored$4,
                                    fmt_rest$11
                                ]
                            ];
                        } else var _aO_ = get_prec(0), match$4 = make_padprec_fmt_ebb(get_pad(0), _aO_, fmt_rest$11), fmt_rest$12 = match$4[3], prec$3 = match$4[2], pad$5 = match$4[1], _aN_ = [
                            0,
                            [
                                8,
                                fconv,
                                pad$5,
                                prec$3,
                                fmt_rest$12
                            ]
                        ];
                        var fmt_result = _aN_;
                        break a;
                }
                b: if (108 <= symb) {
                    if (111 > symb) {
                        switch(symb - 108 | 0){
                            case 0:
                                var _at_ = caml_string_get(str, str_ind), _au_ = get_space(0), _av_ = get_hash(0), iconv = compute_int_conv(pct_ind, str_ind + 1 | 0, get_plus(0), _av_, _au_, _at_), fmt_rest = parse(str_ind + 1 | 0, end_ind)[1];
                                if (get_ign(0)) var ignored = [
                                    3,
                                    iconv,
                                    get_pad_opt(95)
                                ], _aw_ = [
                                    0,
                                    [
                                        23,
                                        ignored,
                                        fmt_rest
                                    ]
                                ];
                                else var _ay_ = get_prec(0), match$0 = make_padprec_fmt_ebb(get_int_pad(0), _ay_, fmt_rest), fmt_rest$0 = match$0[3], prec$0 = match$0[2], pad$0 = match$0[1], _aw_ = [
                                    0,
                                    [
                                        5,
                                        iconv,
                                        pad$0,
                                        prec$0,
                                        fmt_rest$0
                                    ]
                                ];
                                var _ax_ = _aw_;
                                break;
                            case 1:
                                break b;
                            default:
                                var _az_ = caml_string_get(str, str_ind), _aA_ = get_space(0), _aB_ = get_hash(0), iconv$0 = compute_int_conv(pct_ind, str_ind + 1 | 0, get_plus(0), _aB_, _aA_, _az_), fmt_rest$1 = parse(str_ind + 1 | 0, end_ind)[1];
                                if (get_ign(0)) var ignored$0 = [
                                    4,
                                    iconv$0,
                                    get_pad_opt(95)
                                ], _aC_ = [
                                    0,
                                    [
                                        23,
                                        ignored$0,
                                        fmt_rest$1
                                    ]
                                ];
                                else var _aD_ = get_prec(0), match$1 = make_padprec_fmt_ebb(get_int_pad(0), _aD_, fmt_rest$1), fmt_rest$2 = match$1[3], prec$1 = match$1[2], pad$1 = match$1[1], _aC_ = [
                                    0,
                                    [
                                        6,
                                        iconv$0,
                                        pad$1,
                                        prec$1,
                                        fmt_rest$2
                                    ]
                                ];
                                var _ax_ = _aC_;
                        }
                        var fmt_result = _ax_;
                        break a;
                    }
                } else if (76 === symb) {
                    var _aE_ = caml_string_get(str, str_ind), _aF_ = get_space(0), _aG_ = get_hash(0), iconv$1 = compute_int_conv(pct_ind, str_ind + 1 | 0, get_plus(0), _aG_, _aF_, _aE_), fmt_rest$3 = parse(str_ind + 1 | 0, end_ind)[1];
                    if (get_ign(0)) var ignored$1 = [
                        5,
                        iconv$1,
                        get_pad_opt(95)
                    ], _aH_ = [
                        0,
                        [
                            23,
                            ignored$1,
                            fmt_rest$3
                        ]
                    ];
                    else var _aI_ = get_prec(0), match$2 = make_padprec_fmt_ebb(get_int_pad(0), _aI_, fmt_rest$3), fmt_rest$4 = match$2[3], prec$2 = match$2[2], pad$2 = match$2[1], _aH_ = [
                        0,
                        [
                            7,
                            iconv$1,
                            pad$2,
                            prec$2,
                            fmt_rest$4
                        ]
                    ];
                    var fmt_result = _aH_;
                    break a;
                }
                var fmt_result = caml_call3(failwith_message(_J_), str, str_ind - 1 | 0, symb);
            }
            if (1 - legacy_behavior$0) {
                var _ak_ = 1 - plus_used[1], plus$0 = _ak_ ? plus : _ak_;
                if (plus$0) incompatible_flag(pct_ind, str_ind, symb, cst$27);
                var _al_ = 1 - hash_used[1], hash$0 = _al_ ? hash : _al_;
                if (hash$0) incompatible_flag(pct_ind, str_ind, symb, cst$28);
                var _am_ = 1 - space_used[1], space$0 = _am_ ? space : _am_;
                if (space$0) incompatible_flag(pct_ind, str_ind, symb, cst$29);
                var _an_ = 1 - pad_used[1], _ao_ = _an_ ? caml_notequal([
                    0,
                    pad
                ], _K_) : _an_;
                if (_ao_) incompatible_flag(pct_ind, str_ind, symb, cst_padding$0);
                var _ap_ = 1 - prec_used[1], _aq_ = _ap_ ? caml_notequal([
                    0,
                    prec
                ], _L_) : _ap_;
                if (_aq_) {
                    var _ar_ = ign ? 95 : symb;
                    incompatible_flag(pct_ind, str_ind, _ar_, cst_precision$2);
                }
                var plus$1 = ign ? plus : ign;
                if (plus$1) incompatible_flag(pct_ind, str_ind, 95, cst$30);
            }
            var _as_ = 1 - ign_used[1], ign$0 = _as_ ? ign : _as_;
            a: if (ign$0) {
                b: {
                    if (38 <= symb) {
                        if (44 !== symb && 64 !== symb) break b;
                    } else if (33 !== symb && 37 > symb) break b;
                    if (legacy_behavior$0) break a;
                }
                incompatible_flag(pct_ind, str_ind, symb, cst$31);
            }
            return fmt_result;
        }
        function parse_tag(is_open_tag, str_ind, end_ind) {
            try {
                if (str_ind === end_ind) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                if (60 !== caml_string_get(str, str_ind)) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                var ind = caml_call3(Stdlib_String[32], str, str_ind + 1 | 0, 62);
                if (end_ind <= ind) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                var sub_str = caml_call3(Stdlib_String[16], str, str_ind, (ind - str_ind | 0) + 1 | 0), fmt_rest$0 = parse(ind + 1 | 0, end_ind)[1], sub_fmt = parse(str_ind, ind + 1 | 0)[1], sub_format$0 = [
                    0,
                    sub_fmt,
                    sub_str
                ], formatting$0 = is_open_tag ? [
                    0,
                    sub_format$0
                ] : [
                    1,
                    sub_format$0
                ], _ai_ = [
                    0,
                    [
                        18,
                        formatting$0,
                        fmt_rest$0
                    ]
                ];
                return _ai_;
            } catch (_aj_) {
                var _ah_ = caml_wrap_exception(_aj_);
                if (_ah_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_ah_, 0);
                var fmt_rest = parse(str_ind, end_ind)[1], formatting = is_open_tag ? [
                    0,
                    sub_format
                ] : [
                    1,
                    sub_format
                ];
                return [
                    0,
                    [
                        18,
                        formatting,
                        fmt_rest
                    ]
                ];
            }
        }
        function parse_spaces(str_ind, end_ind) {
            var str_ind$0 = str_ind;
            for(;;){
                if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                if (32 !== caml_string_get(str, str_ind$0)) return str_ind$0;
                var str_ind$1 = str_ind$0 + 1 | 0;
                str_ind$0 = str_ind$1;
            }
        }
        function parse_positive(str_ind, end_ind, acc) {
            var str_ind$0 = str_ind, acc$0 = acc;
            for(;;){
                if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                var c = caml_string_get(str, str_ind$0);
                if (9 < c - 48 >>> 0) return [
                    0,
                    str_ind$0,
                    acc$0
                ];
                var new_acc = (acc$0 * 10 | 0) + (c - 48 | 0) | 0;
                if (Stdlib_Sys[12] < new_acc) {
                    var _ag_ = Stdlib_Sys[12];
                    return caml_call3(failwith_message(_S_), str, new_acc, _ag_);
                }
                var str_ind$1 = str_ind$0 + 1 | 0;
                str_ind$0 = str_ind$1;
                acc$0 = new_acc;
            }
        }
        function parse_integer(str_ind, end_ind) {
            if (str_ind === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
            var match = caml_string_get(str, str_ind);
            if (48 <= match) {
                if (58 > match) return parse_positive(str_ind, end_ind, 0);
            } else if (45 === match) {
                if ((str_ind + 1 | 0) === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                var c = caml_string_get(str, str_ind + 1 | 0);
                if (9 < c - 48 >>> 0) return expected_character(str_ind + 1 | 0, cst_digit, c);
                var match$0 = parse_positive(str_ind + 1 | 0, end_ind, 0), n = match$0[2], next_ind = match$0[1];
                return [
                    0,
                    next_ind,
                    -n | 0
                ];
            }
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _T_1
            ], 1);
        }
        function add_literal(lit_start, str_ind, fmt) {
            var size = str_ind - lit_start | 0;
            return 0 === size ? [
                0,
                fmt
            ] : 1 === size ? [
                0,
                [
                    12,
                    caml_string_get(str, lit_start),
                    fmt
                ]
            ] : [
                0,
                [
                    11,
                    caml_call3(Stdlib_String[16], str, lit_start, size),
                    fmt
                ]
            ];
        }
        function search_subformat_end(str_ind, end_ind, c) {
            var str_ind$0 = str_ind;
            for(;;){
                if (str_ind$0 === end_ind) caml_call3(failwith_message(_U_), str, c, end_ind);
                if (37 === caml_string_get(str, str_ind$0)) {
                    if ((str_ind$0 + 1 | 0) === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                    if (caml_string_get(str, str_ind$0 + 1 | 0) === c) return str_ind$0;
                    var match = caml_string_get(str, str_ind$0 + 1 | 0);
                    if (95 <= match) {
                        if (123 <= match) {
                            if (126 > match) switch(match - 123 | 0){
                                case 0:
                                    var sub_end = search_subformat_end(str_ind$0 + 2 | 0, end_ind, 125), str_ind$2 = sub_end + 2 | 0;
                                    str_ind$0 = str_ind$2;
                                    continue;
                                case 1:
                                    break;
                                default:
                                    return expected_character(str_ind$0 + 1 | 0, cst_character, 125);
                            }
                        } else if (96 > match) {
                            if ((str_ind$0 + 2 | 0) === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                            var match$0 = caml_string_get(str, str_ind$0 + 2 | 0);
                            if (40 === match$0) {
                                var sub_end$0 = search_subformat_end(str_ind$0 + 3 | 0, end_ind, 41), str_ind$3 = sub_end$0 + 2 | 0;
                                str_ind$0 = str_ind$3;
                                continue;
                            }
                            if (123 === match$0) {
                                var sub_end$1 = search_subformat_end(str_ind$0 + 3 | 0, end_ind, 125), str_ind$4 = sub_end$1 + 2 | 0;
                                str_ind$0 = str_ind$4;
                                continue;
                            }
                            var str_ind$5 = str_ind$0 + 3 | 0;
                            str_ind$0 = str_ind$5;
                            continue;
                        }
                    } else {
                        if (40 === match) {
                            var sub_end$2 = search_subformat_end(str_ind$0 + 2 | 0, end_ind, 41), str_ind$6 = sub_end$2 + 2 | 0;
                            str_ind$0 = str_ind$6;
                            continue;
                        }
                        if (41 === match) return expected_character(str_ind$0 + 1 | 0, cst_character$0, 41);
                    }
                    var str_ind$1 = str_ind$0 + 2 | 0;
                    str_ind$0 = str_ind$1;
                } else {
                    var str_ind$7 = str_ind$0 + 1 | 0;
                    str_ind$0 = str_ind$7;
                }
            }
        }
        function compute_int_conv(pct_ind, str_ind, plus, hash, space, symb) {
            var plus$0 = plus, hash$0 = hash, space$0 = space;
            for(;;){
                a: {
                    if (plus$0) {
                        if (!hash$0) {
                            if (space$0) break a;
                            if (100 === symb) return 1;
                            if (105 === symb) return 4;
                            break a;
                        }
                    } else {
                        if (!hash$0) {
                            if (space$0) {
                                if (100 === symb) return 2;
                                if (105 === symb) return 5;
                                break a;
                            }
                            var switcher$1 = symb - 88 | 0;
                            if (32 < switcher$1 >>> 0) break a;
                            switch(switcher$1){
                                case 0:
                                    return 8;
                                case 12:
                                    return 0;
                                case 17:
                                    return 3;
                                case 23:
                                    return 10;
                                case 29:
                                    return 12;
                                case 32:
                                    return 6;
                                default:
                                    break a;
                            }
                        }
                        if (!space$0) {
                            var switcher$0 = symb - 88 | 0;
                            if (32 >= switcher$0 >>> 0) switch(switcher$0){
                                case 0:
                                    return 9;
                                case 12:
                                    return 13;
                                case 17:
                                    return 14;
                                case 23:
                                    return 11;
                                case 29:
                                    return 15;
                                case 32:
                                    return 7;
                            }
                        }
                    }
                    var switcher = symb - 88 | 0;
                    if (32 >= switcher >>> 0) switch(switcher){
                        case 0:
                            if (legacy_behavior$0) return 9;
                            break;
                        case 23:
                            if (legacy_behavior$0) return 11;
                            break;
                        case 32:
                            if (legacy_behavior$0) return 7;
                            break;
                        case 12:
                        case 17:
                        case 29:
                            if (!legacy_behavior$0) return incompatible_flag(pct_ind, str_ind, symb, cst$35);
                            hash$0 = 0;
                            continue;
                    }
                }
                if (plus$0) {
                    if (space$0) {
                        if (!legacy_behavior$0) return incompatible_flag(pct_ind, str_ind, 32, cst$32);
                        space$0 = 0;
                    } else {
                        if (!legacy_behavior$0) return incompatible_flag(pct_ind, str_ind, symb, cst$33);
                        plus$0 = 0;
                    }
                } else {
                    if (!space$0) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _W_
                    ], 1);
                    if (!legacy_behavior$0) return incompatible_flag(pct_ind, str_ind, symb, cst$34);
                    space$0 = 0;
                }
            }
        }
        function incompatible_flag(pct_ind, str_ind, symb, option) {
            var subfmt = caml_call3(Stdlib_String[16], str, pct_ind, str_ind - pct_ind | 0);
            return caml_call5(failwith_message(_Y_), str, pct_ind, option, symb, subfmt);
        }
        return parse(0, caml_ml_string_length(str));
    }
    function format_of_string_fmtty(str, fmtty) {
        var fmt = fmt_ebb_of_string(0, str)[1];
        try {
            var _ae_ = [
                0,
                type_format(fmt, fmtty),
                str
            ];
            return _ae_;
        } catch (_af_) {
            var _ac_ = caml_wrap_exception(_af_);
            if (_ac_ !== Type_mismatch) throw caml_maybe_attach_backtrace(_ac_, 0);
            var _ad_ = string_of_fmtty(fmtty);
            return caml_call2(failwith_message(_Z_), str, _ad_);
        }
    }
    function format_of_string_format(str, param) {
        var str$0 = param[2], fmt = param[1], fmt$0 = fmt_ebb_of_string(0, str)[1];
        try {
            var _aa_ = [
                0,
                type_format(fmt$0, fmtty_of_fmt(fmt)),
                str
            ];
            return _aa_;
        } catch (_ab_) {
            var _$_ = caml_wrap_exception(_ab_);
            if (_$_ === Type_mismatch) return caml_call2(failwith_message(___), str, str$0);
            throw caml_maybe_attach_backtrace(_$_, 0);
        }
    }
    var CamlinternalFormat = [
        0,
        is_in_char_set,
        rev_char_set,
        create_char_set,
        add_in_char_set,
        freeze_char_set,
        param_format_of_ignored_format,
        make_printf,
        make_iprintf,
        output_acc,
        bufput_acc,
        strput_acc,
        type_format,
        fmt_ebb_of_string,
        format_of_string_fmtty,
        format_of_string_format,
        char_of_iconv,
        string_of_formatting_lit,
        string_of_fmtty,
        string_of_fmt,
        open_box_of_string,
        symm,
        trans,
        recast
    ];
    runtime.caml_register_global(197, CamlinternalFormat, "CamlinternalFormat");
    return;
})(globalThis);
//# 16222 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Buffer = global_data.Stdlib__Buffer, CamlinternalFormat = global_data.CamlinternalFormat, Stdlib = global_data.Stdlib;
    function kfprintf(k, o, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            caml_call2(CamlinternalFormat[9], o, acc);
            return caml_call1(k, o);
        }, 0, fmt);
    }
    function kbprintf(k, b, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            caml_call2(CamlinternalFormat[10], b, acc);
            return caml_call1(k, b);
        }, 0, fmt);
    }
    function ikfprintf(k, oc, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[8], k, oc, fmt);
    }
    function fprintf(oc, fmt) {
        return kfprintf(function(_d_) {
            return 0;
        }, oc, fmt);
    }
    function bprintf(b, fmt) {
        return kbprintf(function(_c_) {
            return 0;
        }, b, fmt);
    }
    function ifprintf(oc, fmt) {
        return ikfprintf(function(_b_) {
            return 0;
        }, oc, fmt);
    }
    function ibprintf(b, fmt) {
        return ikfprintf(function(_a_) {
            return 0;
        }, b, fmt);
    }
    function printf(fmt) {
        return fprintf(Stdlib[39], fmt);
    }
    function eprintf(fmt) {
        return fprintf(Stdlib[40], fmt);
    }
    function ksprintf(k, param) {
        var fmt = param[1];
        function k$0(acc) {
            var buf = caml_call1(Stdlib_Buffer[1], 64);
            caml_call2(CamlinternalFormat[11], buf, acc);
            return caml_call1(k, caml_call1(Stdlib_Buffer[2], buf));
        }
        return caml_call3(CamlinternalFormat[7], k$0, 0, fmt);
    }
    function sprintf(fmt) {
        return ksprintf(function(s) {
            return s;
        }, fmt);
    }
    var Stdlib_Printf = [
        0,
        fprintf,
        printf,
        eprintf,
        sprintf,
        bprintf,
        ifprintf,
        ibprintf,
        kfprintf,
        ikfprintf,
        ksprintf,
        kbprintf,
        ikfprintf,
        ksprintf
    ];
    runtime.caml_register_global(3, Stdlib_Printf, "Stdlib__Printf");
    return;
})(globalThis);
//# 17055 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$8 = "", cst$10 = "  ", cst_Display_this_list_of_optio$1 = " Display this list of options", cst_s = "%s", cst_help$4 = "--help", cst_help$3 = "-help", cst$9 = ".\n", cst_a_float$1 = "a float", cst_an_integer$1 = "an integer", caml_check_bound = runtime.caml_check_bound, caml_equal = runtime.caml_equal, caml_fresh_oo_id = runtime.caml_fresh_oo_id, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_sys_argv = runtime.caml_sys_argv, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), cst$7 = "\n", cst$4 = cst$8, cst$5 = " ", cst$6 = cst$8, cst$2 = "(?)", cst$3 = "-", cst = "}", cst$0 = "|", cst$1 = "{", Stdlib = global_data.Stdlib, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_List = global_data.Stdlib__List, Stdlib_String = global_data.Stdlib__String, Stdlib_Int = global_data.Stdlib__Int, Bad = [
        248,
        "Stdlib.Arg.Bad",
        caml_fresh_oo_id(0)
    ], Help = [
        248,
        "Stdlib.Arg.Help",
        caml_fresh_oo_id(0)
    ], Stop = [
        248,
        "Stdlib.Arg.Stop",
        caml_fresh_oo_id(0)
    ], cst_none = "<none>", _a_ = [
        0,
        [
            11,
            cst$10,
            [
                2,
                0,
                [
                    12,
                    32,
                    [
                        2,
                        0,
                        [
                            12,
                            10,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "  %s %s\n"
    ], _b_ = [
        0,
        [
            11,
            cst$10,
            [
                2,
                0,
                [
                    12,
                    32,
                    [
                        2,
                        0,
                        [
                            2,
                            0,
                            [
                                12,
                                10,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "  %s %s%s\n"
    ], _c_ = [
        0,
        cst_help$3
    ], cst_Display_this_list_of_optio = cst_Display_this_list_of_optio$1, cst_help = cst_help$3, cst_Display_this_list_of_optio$0 = cst_Display_this_list_of_optio$1, cst_help$0 = cst_help$4, cst_help$1 = cst_help$4, cst_help$2 = cst_help$3, _d_ = [
        0,
        [
            2,
            0,
            [
                12,
                10,
                0
            ]
        ],
        "%s\n"
    ], _e_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ];
    function assoc3(x, l) {
        var l$0 = l;
        for(;;){
            if (!l$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var match = l$0[1], y2 = match[2], y1 = match[1];
            if (caml_equal(y1, x)) return y2;
            var t = l$0[2];
            l$0 = t;
        }
    }
    function make_symlist(prefix, sep, suffix, l) {
        if (!l) return cst_none;
        var t = l[2], h = l[1], _az_ = caml_call2(Stdlib[28], prefix, h), _aA_ = caml_call3(Stdlib_List[26], function(x, y) {
            var _aB_ = caml_call2(Stdlib[28], sep, y);
            return caml_call2(Stdlib[28], x, _aB_);
        }, _az_, t);
        return caml_call2(Stdlib[28], _aA_, suffix);
    }
    function help_action(param) {
        throw caml_maybe_attach_backtrace([
            0,
            Stop,
            _c_
        ], 1);
    }
    function add_help(speclist) {
        try {
            assoc3(cst_help$2, speclist);
            var _aw_ = 0, add1 = _aw_;
        } catch (_ay_) {
            var _as_ = caml_wrap_exception(_ay_);
            if (_as_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_as_, 0);
            var add1 = [
                0,
                [
                    0,
                    cst_help,
                    [
                        0,
                        help_action
                    ],
                    cst_Display_this_list_of_optio
                ],
                0
            ];
        }
        try {
            assoc3(cst_help$1, speclist);
            var _av_ = 0, add2 = _av_;
        } catch (_ax_) {
            var _at_ = caml_wrap_exception(_ax_);
            if (_at_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_at_, 0);
            var add2 = [
                0,
                [
                    0,
                    cst_help$0,
                    [
                        0,
                        help_action
                    ],
                    cst_Display_this_list_of_optio$0
                ],
                0
            ];
        }
        var _au_ = caml_call2(Stdlib[37], add1, add2);
        return caml_call2(Stdlib[37], speclist, _au_);
    }
    function usage_b(buf, speclist, errmsg) {
        caml_call3(Stdlib_Printf[5], buf, _d_, errmsg);
        var _ap_ = add_help(speclist);
        return caml_call2(Stdlib_List[18], function(param) {
            var doc = param[3], spec = param[2], key = param[1], _aq_ = 0 < caml_ml_string_length(doc) ? 1 : 0;
            if (!_aq_) return _aq_;
            if (11 !== spec[0]) return caml_call4(Stdlib_Printf[5], buf, _a_, key, doc);
            var l = spec[1], _ar_ = make_symlist(cst$1, cst$0, cst, l);
            return caml_call5(Stdlib_Printf[5], buf, _b_, key, _ar_, doc);
        }, _ap_);
    }
    function usage_string(speclist, errmsg) {
        var b = caml_call1(Stdlib_Buffer[1], 200);
        usage_b(b, speclist, errmsg);
        return caml_call1(Stdlib_Buffer[2], b);
    }
    function usage(speclist, errmsg) {
        var _ao_ = usage_string(speclist, errmsg);
        return caml_call2(Stdlib_Printf[3], _e_, _ao_);
    }
    var current = [
        0,
        0
    ], _f_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": unknown option '",
                [
                    2,
                    0,
                    [
                        11,
                        "'.\n",
                        0
                    ]
                ]
            ]
        ],
        "%s: unknown option '%s'.\n"
    ], _g_ = [
        0,
        cst_help$3
    ], _h_ = [
        0,
        cst_help$4
    ], _i_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": wrong argument '",
                [
                    2,
                    0,
                    [
                        11,
                        "'; option '",
                        [
                            2,
                            0,
                            [
                                11,
                                "' expects ",
                                [
                                    2,
                                    0,
                                    [
                                        11,
                                        cst$9,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s: wrong argument '%s'; option '%s' expects %s.\n"
    ], _j_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": option '",
                [
                    2,
                    0,
                    [
                        11,
                        "' needs an argument.\n",
                        0
                    ]
                ]
            ]
        ],
        "%s: option '%s' needs an argument.\n"
    ], _k_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": ",
                [
                    2,
                    0,
                    [
                        11,
                        cst$9,
                        0
                    ]
                ]
            ]
        ],
        "%s: %s.\n"
    ], cst_no_argument = "no argument", cst_a_boolean = "a boolean", cst_an_integer = cst_an_integer$1, cst_an_integer$0 = cst_an_integer$1, cst_a_float = cst_a_float$1, cst_a_float$0 = cst_a_float$1, cst_one_of = "one of: ", cst_Arg_Expand_is_is_only_allo = "Arg.Expand is is only allowed with Arg.parse_and_expand_argv_dynamic", _l_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], _m_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], _n_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], _o_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], _p_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], _q_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ];
    function int_of_string_opt(x) {
        try {
            var _am_ = [
                0,
                runtime.caml_int_of_string(x)
            ];
            return _am_;
        } catch (_an_) {
            var _al_ = caml_wrap_exception(_an_);
            if (_al_[1] === Stdlib[7]) return 0;
            throw caml_maybe_attach_backtrace(_al_, 0);
        }
    }
    function float_of_string_opt(x) {
        try {
            var _aj_ = [
                0,
                runtime.caml_float_of_string(x)
            ];
            return _aj_;
        } catch (_ak_) {
            var _ai_ = caml_wrap_exception(_ak_);
            if (_ai_[1] === Stdlib[7]) return 0;
            throw caml_maybe_attach_backtrace(_ai_, 0);
        }
    }
    function parse_and_expand_argv_dynamic_(allow_expand, current, argv, speclist, anonfun, errmsg) {
        var initpos = current[1];
        function convert_error(error) {
            var b = caml_call1(Stdlib_Buffer[1], 200), progname = initpos < argv[1].length - 1 ? caml_check_bound(argv[1], initpos)[1 + initpos] : cst$2;
            switch(error[0]){
                case 0:
                    var s = error[1];
                    if (s !== cst_help$4 && s !== cst_help$3) caml_call4(Stdlib_Printf[5], b, _f_, progname, s);
                    break;
                case 1:
                    var expected = error[3], arg = error[2], opt = error[1];
                    caml_call6(Stdlib_Printf[5], b, _i_, progname, arg, opt, expected);
                    break;
                case 2:
                    var s$0 = error[1];
                    caml_call4(Stdlib_Printf[5], b, _j_, progname, s$0);
                    break;
                default:
                    var s$1 = error[1];
                    caml_call4(Stdlib_Printf[5], b, _k_, progname, s$1);
            }
            usage_b(b, speclist[1], errmsg);
            if (!caml_equal(error, _g_) && !caml_equal(error, _h_)) return [
                0,
                Bad,
                caml_call1(Stdlib_Buffer[2], b)
            ];
            return [
                0,
                Help,
                caml_call1(Stdlib_Buffer[2], b)
            ];
        }
        current[1]++;
        for(;;){
            if (current[1] >= argv[1].length - 1) return 0;
            try {
                var _V_ = current[1], s = caml_check_bound(argv[1], _V_)[1 + _V_];
                if (caml_call2(Stdlib_String[11], cst$3, s)) {
                    try {
                        var follow$1 = 0, _Z_ = assoc3(s, speclist[1]), follow$0 = follow$1, action = _Z_;
                    } catch (_ag_) {
                        var _W_ = caml_wrap_exception(_ag_);
                        if (_W_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_W_, 0);
                        try {
                            var i = caml_call2(Stdlib_String[36], s, 61), len = caml_ml_string_length(s), arg = caml_call3(Stdlib_String[16], s, i + 1 | 0, len - (i + 1 | 0) | 0), keyword = caml_call3(Stdlib_String[16], s, 0, i), follow = [
                                0,
                                arg
                            ], _Y_ = assoc3(keyword, speclist[1]), follow$0 = follow, action = _Y_;
                        } catch (_ah_) {
                            var _X_ = caml_wrap_exception(_ah_);
                            if (_X_ === Stdlib[8]) throw caml_maybe_attach_backtrace([
                                0,
                                Stop,
                                [
                                    0,
                                    s
                                ]
                            ], 1);
                            throw caml_maybe_attach_backtrace(_X_, 0);
                        }
                    }
                    let s$0 = s, follow$2 = follow$0;
                    var no_arg = function(param) {
                        if (!follow$2) return;
                        var arg = follow$2[1];
                        throw caml_maybe_attach_backtrace([
                            0,
                            Stop,
                            [
                                1,
                                s$0,
                                arg,
                                cst_no_argument
                            ]
                        ], 1);
                    }, get_arg = function(param) {
                        if (follow$2) {
                            var arg = follow$2[1];
                            return arg;
                        }
                        if ((current[1] + 1 | 0) >= argv[1].length - 1) throw caml_maybe_attach_backtrace([
                            0,
                            Stop,
                            [
                                2,
                                s$0
                            ]
                        ], 1);
                        var _af_ = current[1] + 1 | 0;
                        return caml_check_bound(argv[1], _af_)[1 + _af_];
                    }, consume_arg = function(param) {
                        return follow$2 ? 0 : (current[1]++, 0);
                    }, treat_action = function(param) {
                        switch(param[0]){
                            case 0:
                                var f = param[1];
                                no_arg$0(0);
                                return caml_call1(f, 0);
                            case 1:
                                var f$0 = param[1], arg = get_arg$0(0);
                                try {
                                    var _$_ = [
                                        0,
                                        caml_call1(Stdlib[32], arg)
                                    ], match = _$_;
                                } catch (_ae_) {
                                    var ___ = caml_wrap_exception(_ae_);
                                    if (___[1] !== Stdlib[6]) throw caml_maybe_attach_backtrace(___, 0);
                                    var match = 0;
                                }
                                if (!match) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg,
                                        cst_a_boolean
                                    ]
                                ], 1);
                                var s = match[1];
                                caml_call1(f$0, s);
                                return consume_arg$0(0);
                            case 2:
                                var r = param[1];
                                no_arg$0(0);
                                r[1] = 1;
                                return 0;
                            case 3:
                                var r$0 = param[1];
                                no_arg$0(0);
                                r$0[1] = 0;
                                return 0;
                            case 4:
                                var f$1 = param[1], arg$0 = get_arg$0(0);
                                caml_call1(f$1, arg$0);
                                return consume_arg$0(0);
                            case 5:
                                var r$1 = param[1];
                                r$1[1] = get_arg$0(0);
                                return consume_arg$0(0);
                            case 6:
                                var f$2 = param[1], arg$1 = get_arg$0(0), match$0 = int_of_string_opt(arg$1);
                                if (!match$0) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg$1,
                                        cst_an_integer
                                    ]
                                ], 1);
                                var x = match$0[1];
                                caml_call1(f$2, x);
                                return consume_arg$0(0);
                            case 7:
                                var r$2 = param[1], arg$2 = get_arg$0(0), match$1 = int_of_string_opt(arg$2);
                                if (!match$1) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg$2,
                                        cst_an_integer$0
                                    ]
                                ], 1);
                                var x$0 = match$1[1];
                                r$2[1] = x$0;
                                return consume_arg$0(0);
                            case 8:
                                var f$3 = param[1], arg$3 = get_arg$0(0), match$2 = float_of_string_opt(arg$3);
                                if (!match$2) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg$3,
                                        cst_a_float
                                    ]
                                ], 1);
                                var x$1 = match$2[1];
                                caml_call1(f$3, x$1);
                                return consume_arg$0(0);
                            case 9:
                                var r$3 = param[1], arg$4 = get_arg$0(0), match$3 = float_of_string_opt(arg$4);
                                if (!match$3) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg$4,
                                        cst_a_float$0
                                    ]
                                ], 1);
                                var x$2 = match$3[1];
                                r$3[1] = x$2;
                                return consume_arg$0(0);
                            case 10:
                                var specs = param[1];
                                no_arg$0(0);
                                return caml_call2(Stdlib_List[18], treat_action$0, specs);
                            case 11:
                                var f$4 = param[2], symb = param[1], arg$5 = get_arg$0(0);
                                if (caml_call2(Stdlib_List[37], arg$5, symb)) {
                                    caml_call1(f$4, arg$5);
                                    return consume_arg$0(0);
                                }
                                var _aa_ = make_symlist(cst$6, cst$5, cst$4, symb);
                                throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg$5,
                                        caml_call2(Stdlib[28], cst_one_of, _aa_)
                                    ]
                                ], 1);
                            case 12:
                                var f$5 = param[1];
                                no_arg$0(0);
                                for(;;){
                                    if (current[1] >= (argv[1].length - 2 | 0)) return 0;
                                    var _ab_ = current[1] + 1 | 0;
                                    caml_call1(f$5, caml_check_bound(argv[1], _ab_)[1 + _ab_]);
                                    consume_arg$0(0);
                                }
                                break;
                            case 13:
                                var f$6 = param[1];
                                no_arg$0(0);
                                var acc = [
                                    0,
                                    0
                                ];
                                for(;;){
                                    if (current[1] >= (argv[1].length - 2 | 0)) return caml_call1(f$6, caml_call1(Stdlib_List[10], acc[1]));
                                    var _ad_ = current[1] + 1 | 0, _ac_ = acc[1];
                                    acc[1] = [
                                        0,
                                        caml_check_bound(argv[1], _ad_)[1 + _ad_],
                                        _ac_
                                    ];
                                    consume_arg$0(0);
                                }
                                break;
                            default:
                                var f$7 = param[1];
                                if (1 - allow_expand) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stdlib[6],
                                    cst_Arg_Expand_is_is_only_allo
                                ], 1);
                                var arg$6 = get_arg$0(0), newarg = caml_call1(f$7, arg$6);
                                consume_arg$0(0);
                                var before = caml_call3(Stdlib_Array[6], argv[1], 0, current[1] + 1 | 0), after = caml_call3(Stdlib_Array[6], argv[1], current[1] + 1 | 0, (argv[1].length - 1 - current[1] | 0) - 1 | 0);
                                argv[1] = caml_call1(Stdlib_Array[5], [
                                    0,
                                    before,
                                    [
                                        0,
                                        newarg,
                                        [
                                            0,
                                            after,
                                            0
                                        ]
                                    ]
                                ]);
                                return 0;
                        }
                    };
                    let no_arg$0 = no_arg, get_arg$0 = get_arg, consume_arg$0 = consume_arg, treat_action$0 = treat_action;
                    treat_action(action);
                } else caml_call1(anonfun, s);
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                if (exn[1] === Bad) {
                    var m = exn[2];
                    throw caml_maybe_attach_backtrace(convert_error([
                        3,
                        m
                    ]), 1);
                }
                if (exn[1] !== Stop) throw caml_maybe_attach_backtrace(exn, 0);
                var e = exn[2];
                throw caml_maybe_attach_backtrace(convert_error(e), 1);
            }
            current[1]++;
        }
    }
    function parse_and_expand_argv_dynamic(current, argv, speclist, anonfun, errmsg) {
        return parse_and_expand_argv_dynamic_(1, current, argv, speclist, anonfun, errmsg);
    }
    function parse_argv_dynamic(opt, argv, speclist, anonfun, errmsg) {
        var current$0 = opt ? opt[1] : current;
        return parse_and_expand_argv_dynamic_(0, current$0, [
            0,
            argv
        ], speclist, anonfun, errmsg);
    }
    function parse_argv(opt, argv, speclist, anonfun, errmsg) {
        var current$0 = opt ? opt[1] : current;
        return parse_argv_dynamic([
            0,
            current$0
        ], argv, [
            0,
            speclist
        ], anonfun, errmsg);
    }
    function parse(l, f, msg) {
        try {
            var _U_ = parse_argv(0, caml_sys_argv(0), l, f, msg);
            return _U_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] === Bad) {
                var msg$0 = exn[2];
                caml_call2(Stdlib_Printf[3], _l_, msg$0);
                return caml_call1(Stdlib[99], 2);
            }
            if (exn[1] !== Help) throw caml_maybe_attach_backtrace(exn, 0);
            var msg$1 = exn[2];
            caml_call2(Stdlib_Printf[2], _m_, msg$1);
            return caml_call1(Stdlib[99], 0);
        }
    }
    function parse_dynamic(l, f, msg) {
        try {
            var _T_1 = parse_argv_dynamic(0, caml_sys_argv(0), l, f, msg);
            return _T_1;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] === Bad) {
                var msg$0 = exn[2];
                caml_call2(Stdlib_Printf[3], _n_, msg$0);
                return caml_call1(Stdlib[99], 2);
            }
            if (exn[1] !== Help) throw caml_maybe_attach_backtrace(exn, 0);
            var msg$1 = exn[2];
            caml_call2(Stdlib_Printf[2], _o_, msg$1);
            return caml_call1(Stdlib[99], 0);
        }
    }
    function parse_expand(l, f, msg) {
        try {
            var argv = [
                0,
                caml_sys_argv(0)
            ], spec = [
                0,
                l
            ], current$0 = [
                0,
                current[1]
            ], _S_ = parse_and_expand_argv_dynamic(current$0, argv, spec, f, msg);
            return _S_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] === Bad) {
                var msg$0 = exn[2];
                caml_call2(Stdlib_Printf[3], _p_, msg$0);
                return caml_call1(Stdlib[99], 2);
            }
            if (exn[1] !== Help) throw caml_maybe_attach_backtrace(exn, 0);
            var msg$1 = exn[2];
            caml_call2(Stdlib_Printf[2], _q_, msg$1);
            return caml_call1(Stdlib[99], 0);
        }
    }
    function second_word(s) {
        var len = caml_ml_string_length(s);
        function loop(n) {
            var n$0 = n;
            for(;;){
                if (len <= n$0) return len;
                if (32 !== caml_string_get(s, n$0)) return n$0;
                var n$1 = n$0 + 1 | 0;
                n$0 = n$1;
            }
        }
        try {
            var n$0 = caml_call2(Stdlib_String[36], s, 9);
        } catch (_Q_) {
            var _O_ = caml_wrap_exception(_Q_);
            if (_O_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_O_, 0);
            try {
                var n = caml_call2(Stdlib_String[36], s, 32);
            } catch (_R_) {
                var _P_ = caml_wrap_exception(_R_);
                if (_P_ === Stdlib[8]) return len;
                throw caml_maybe_attach_backtrace(_P_, 0);
            }
            return loop(n + 1 | 0);
        }
        return loop(n$0 + 1 | 0);
    }
    function max_arg_len(cur, param) {
        var doc = param[3], spec = param[2], kwd = param[1];
        if (11 === spec[0]) return caml_call2(Stdlib_Int[11], cur, caml_ml_string_length(kwd));
        var _N_ = caml_ml_string_length(kwd) + second_word(doc) | 0;
        return caml_call2(Stdlib_Int[11], cur, _N_);
    }
    function replace_leading_tab(s) {
        var seen = [
            0,
            0
        ];
        return caml_call2(Stdlib_String[18], function(c) {
            if (9 === c && !seen[1]) {
                seen[1] = 1;
                return 32;
            }
            return c;
        }, s);
    }
    function align(opt, speclist) {
        var limit = opt ? opt[1] : Stdlib[19], completed = add_help(speclist), len = caml_call3(Stdlib_List[26], max_arg_len, 0, completed), len$0 = caml_call2(Stdlib_Int[10], len, limit);
        return caml_call2(Stdlib_List[20], function(ksd) {
            var kwd = ksd[1], spec = ksd[2];
            if (ksd[3] === cst$8) return ksd;
            if (11 === spec[0]) {
                var msg$0 = ksd[3], cutcol$0 = second_word(msg$0), _K_ = caml_call2(Stdlib_Int[11], 0, len$0 - cutcol$0 | 0) + 3 | 0, spaces$0 = caml_call2(Stdlib_String[1], _K_, 32), _L_ = replace_leading_tab(msg$0), _M_ = caml_call2(Stdlib[28], spaces$0, _L_);
                return [
                    0,
                    kwd,
                    spec,
                    caml_call2(Stdlib[28], cst$7, _M_)
                ];
            }
            var msg = ksd[3], spec$0 = ksd[2], cutcol = second_word(msg), kwd_len = caml_ml_string_length(kwd), diff = (len$0 - kwd_len | 0) - cutcol | 0;
            if (0 >= diff) return [
                0,
                kwd,
                spec$0,
                replace_leading_tab(msg)
            ];
            var spaces = caml_call2(Stdlib_String[1], diff, 32), _I_ = replace_leading_tab(msg), prefix = caml_call3(Stdlib_String[16], _I_, 0, cutcol), suffix = caml_call3(Stdlib_String[16], msg, cutcol, caml_ml_string_length(msg) - cutcol | 0), _J_ = caml_call2(Stdlib[28], spaces, suffix);
            return [
                0,
                kwd,
                spec$0,
                caml_call2(Stdlib[28], prefix, _J_)
            ];
        }, completed);
    }
    function read_aux(trim, sep, file) {
        var ic = caml_call1(Stdlib[80], file), buf = caml_call1(Stdlib_Buffer[1], 200), words = [
            0,
            0
        ];
        function stash(param) {
            var word = caml_call1(Stdlib_Buffer[2], buf);
            if (trim) {
                var len = caml_ml_string_length(word);
                a: {
                    if (0 < len && 13 === caml_string_get(word, len - 1 | 0)) {
                        var _H_ = caml_call3(Stdlib_String[16], word, 0, len - 1 | 0);
                        break a;
                    }
                    var _H_ = word;
                }
                var word$0 = _H_;
            } else var word$0 = word;
            words[1] = [
                0,
                word$0,
                words[1]
            ];
            return caml_call1(Stdlib_Buffer[8], buf);
        }
        try {
            for(;;){
                var c = caml_call1(Stdlib[82], ic);
                if (c === sep) stash(0);
                else caml_call2(Stdlib_Buffer[12], buf, c);
            }
        } catch (_G_) {
            var _E_ = caml_wrap_exception(_G_);
            if (_E_ !== Stdlib[12]) throw caml_maybe_attach_backtrace(_E_, 0);
            if (0 < caml_call1(Stdlib_Buffer[7], buf)) stash(0);
            caml_call1(Stdlib[93], ic);
            var _F_ = caml_call1(Stdlib_List[10], words[1]);
            return caml_call1(Stdlib_Array[11], _F_);
        }
    }
    var _r_ = 10, _s_ = 1;
    function read_arg(_D_) {
        return read_aux(_s_, _r_, _D_);
    }
    var _t_ = 0, _u_ = 0, _v_ = [
        0,
        [
            2,
            0,
            [
                0,
                0
            ]
        ],
        "%s%c"
    ];
    function read_arg0(_C_) {
        return read_aux(_u_, _t_, _C_);
    }
    function write_aux(sep, file, args) {
        var oc = caml_call1(Stdlib[61], file);
        caml_call2(Stdlib_Array[12], function(s) {
            return caml_call4(Stdlib_Printf[1], oc, _v_, s, sep);
        }, args);
        return caml_call1(Stdlib[76], oc);
    }
    var _w_ = 10;
    function write_arg(_A_, _B_) {
        return write_aux(_w_, _A_, _B_);
    }
    var _x_ = 0;
    function write_arg0(_y_, _z_) {
        return write_aux(_x_, _y_, _z_);
    }
    var Stdlib_Arg = [
        0,
        parse,
        parse_dynamic,
        parse_argv,
        parse_argv_dynamic,
        parse_and_expand_argv_dynamic,
        parse_expand,
        Help,
        Bad,
        usage,
        usage_string,
        align,
        current,
        read_arg,
        read_arg0,
        write_arg,
        write_arg0
    ];
    runtime.caml_register_global(55, Stdlib_Arg, "Stdlib__Arg");
    return;
})(globalThis);
//# 17766 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$4 = "", cst_s = "%s\n", cst_Program_not_linked_with_g_$0 = "(Program not linked with -g, cannot print stack backtrace)\n", cst_characters = ", characters ", cst_Fatal_error_exception = "Fatal error: exception ", cst_Fatal_error_exception_s = "Fatal error: exception %s\n", cst_Uncaught_exception = "Uncaught exception: ", cst_Uncaught_exception_s = "Uncaught exception: %s\n", caml_check_bound = runtime.caml_check_bound, caml_get_exception_raw_backtra = runtime.caml_get_exception_raw_backtrace, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_tag = runtime.caml_obj_tag, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    function caml_call8(f, a0, a1, a2, a3, a4, a5, a6, a7) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 8 ? f(a0, a1, a2, a3, a4, a5, a6, a7) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$4, cst$3 = cst$4, partial = [
        4,
        0,
        0,
        0,
        [
            12,
            45,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ]
    ], cst$1 = cst$4, cst$2 = cst$4, cst = "_", locfmt = [
        0,
        [
            11,
            'File "',
            [
                2,
                0,
                [
                    11,
                    '", line ',
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst_characters,
                            [
                                4,
                                0,
                                0,
                                0,
                                [
                                    12,
                                    45,
                                    [
                                        4,
                                        0,
                                        0,
                                        0,
                                        [
                                            11,
                                            ": ",
                                            [
                                                2,
                                                0,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        'File "%s", line %d, characters %d-%d: %s'
    ], Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Atomic = global_data.Stdlib__Atomic, Stdlib = global_data.Stdlib, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_Obj = global_data.Stdlib__Obj, printers = caml_call1(Stdlib_Atomic[1], 0), _a_ = [
        0,
        [
            3,
            0,
            0
        ],
        "%S"
    ], _b_ = [
        0,
        [
            4,
            0,
            0,
            0,
            0
        ],
        "%d"
    ], _c_ = [
        0,
        [
            11,
            ", ",
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        ", %s%s"
    ], _d_ = [
        0,
        [
            12,
            40,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        41,
                        0
                    ]
                ]
            ]
        ],
        "(%s%s)"
    ], _e_ = [
        0,
        [
            12,
            40,
            [
                2,
                0,
                [
                    12,
                    41,
                    0
                ]
            ]
        ],
        "(%s)"
    ], cst_Out_of_memory = "Out of memory", cst_Stack_overflow = "Stack overflow", cst_Pattern_matching_failed = "Pattern matching failed", cst_Assertion_failed = "Assertion failed", cst_Undefined_recursive_module = "Undefined recursive module", _f_ = [
        0,
        [
            11,
            cst_Uncaught_exception,
            [
                2,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        cst_Uncaught_exception_s
    ], _g_ = [
        0,
        [
            11,
            cst_Uncaught_exception,
            [
                2,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        cst_Uncaught_exception_s
    ], cst_Raised_at = "Raised at", cst_Re_raised_at = "Re-raised at", cst_Raised_by_primitive_operat = "Raised by primitive operation at", cst_Called_from = "Called from", _h_ = [
        0,
        [
            12,
            32,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        " %d"
    ], cst_inlined = " (inlined)", _i_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    2,
                    0,
                    [
                        11,
                        ' in file "',
                        [
                            2,
                            0,
                            [
                                12,
                                34,
                                [
                                    2,
                                    0,
                                    [
                                        11,
                                        ", line",
                                        [
                                            2,
                                            0,
                                            [
                                                11,
                                                cst_characters,
                                                partial
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        '%s %s in file "%s"%s, line%s, characters %d-%d'
    ], _j_ = [
        0,
        [
            11,
            "s ",
            [
                4,
                0,
                0,
                0,
                [
                    12,
                    45,
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "s %d-%d"
    ], _k_ = [
        0,
        [
            2,
            0,
            [
                11,
                " unknown location",
                0
            ]
        ],
        "%s unknown location"
    ], _l_ = [
        0,
        [
            2,
            0,
            [
                12,
                10,
                0
            ]
        ],
        cst_s
    ], _m_ = [
        0,
        [
            11,
            cst_Program_not_linked_with_g_$0,
            0
        ],
        cst_Program_not_linked_with_g_$0
    ], _n_ = [
        0,
        [
            2,
            0,
            [
                12,
                10,
                0
            ]
        ],
        cst_s
    ], cst_Program_not_linked_with_g_ = cst_Program_not_linked_with_g_$0;
    function field(x, i) {
        var f = x[1 + i];
        if (!caml_call1(Stdlib_Obj[1], f)) return caml_call2(Stdlib_Printf[4], _b_, f);
        var _ah_ = Stdlib_Obj[15];
        if (caml_obj_tag(f) === _ah_) return caml_call2(Stdlib_Printf[4], _a_, f);
        var _ai_ = Stdlib_Obj[16];
        return caml_obj_tag(f) === _ai_ ? caml_call1(Stdlib[35], f) : cst;
    }
    function other_fields(x, i) {
        if (x.length - 1 <= i) return cst$0;
        var _af_ = other_fields(x, i + 1 | 0), _ag_ = field(x, i);
        return caml_call3(Stdlib_Printf[4], _c_, _ag_, _af_);
    }
    function use_printers(x) {
        var param = caml_call1(Stdlib_Atomic[3], printers);
        for(;;){
            if (!param) return 0;
            var tl = param[2], hd = param[1];
            a: {
                try {
                    var val = caml_call1(hd, x);
                } catch (_ae_) {
                    break a;
                }
                if (val) {
                    var s = val[1];
                    return [
                        0,
                        s
                    ];
                }
            }
            param = tl;
        }
    }
    function string_of_extension_constructo(t) {
        if (0 === caml_obj_tag(t)) {
            var constructor = t[1][1], match = t.length - 1;
            if (2 < match >>> 0) var _aa_ = other_fields(t, 2), _ab_ = field(t, 1), _ad_ = caml_call3(Stdlib_Printf[4], _d_, _ab_, _aa_);
            else switch(match){
                case 0:
                    var _ad_ = cst$1;
                    break;
                case 1:
                    var _ad_ = cst$2;
                    break;
                default:
                    var _ac_ = field(t, 1), _ad_ = caml_call2(Stdlib_Printf[4], _e_, _ac_);
            }
            var match$0 = [
                0,
                constructor,
                [
                    0,
                    _ad_
                ]
            ];
        } else var match$0 = [
            0,
            t[1],
            0
        ];
        var fields_opt = match$0[2], constructor$0 = match$0[1];
        if (!fields_opt) return constructor$0;
        var f = fields_opt[1];
        return caml_call2(Stdlib[28], constructor$0, f);
    }
    function to_string_default(x) {
        if (x === Stdlib[9]) return cst_Out_of_memory;
        if (x === Stdlib[10]) return cst_Stack_overflow;
        if (x[1] === Stdlib[4]) {
            var match = x[2], char$0 = match[3], line = match[2], file = match[1];
            return caml_call6(Stdlib_Printf[4], locfmt, file, line, char$0, char$0 + 5 | 0, cst_Pattern_matching_failed);
        }
        if (x[1] === Stdlib[5]) {
            var match$0 = x[2], char$1 = match$0[3], line$0 = match$0[2], file$0 = match$0[1];
            return caml_call6(Stdlib_Printf[4], locfmt, file$0, line$0, char$1, char$1 + 6 | 0, cst_Assertion_failed);
        }
        if (x[1] !== Stdlib[15]) return string_of_extension_constructo(x);
        var match$1 = x[2], char$2 = match$1[3], line$1 = match$1[2], file$1 = match$1[1];
        return caml_call6(Stdlib_Printf[4], locfmt, file$1, line$1, char$2, char$2 + 6 | 0, cst_Undefined_recursive_module);
    }
    function to_string(e) {
        var match = use_printers(e);
        if (!match) return to_string_default(e);
        var s = match[1];
        return s;
    }
    function print(fct, arg) {
        try {
            var _$_ = caml_call1(fct, arg);
            return _$_;
        } catch (x$0) {
            var x = caml_wrap_exception(x$0), ___ = to_string(x);
            caml_call2(Stdlib_Printf[3], _f_, ___);
            caml_call1(Stdlib[63], Stdlib[40]);
            throw caml_maybe_attach_backtrace(x, 0);
        }
    }
    function catch$0(fct, arg) {
        try {
            var _Z_ = caml_call1(fct, arg);
            return _Z_;
        } catch (x$0) {
            var x = caml_wrap_exception(x$0);
            caml_call1(Stdlib[63], Stdlib[39]);
            var _Y_ = to_string(x);
            caml_call2(Stdlib_Printf[3], _g_, _Y_);
            return caml_call1(Stdlib[99], 2);
        }
    }
    function raw_backtrace_entries(bt) {
        return bt;
    }
    function convert_raw_backtrace(bt) {
        return [
            0,
            runtime.caml_convert_raw_backtrace(bt)
        ];
    }
    function format_backtrace_slot(pos, slot) {
        function info(is_raise) {
            return is_raise ? 0 === pos ? cst_Raised_at : cst_Re_raised_at : 0 === pos ? cst_Raised_by_primitive_operat : cst_Called_from;
        }
        if (0 === slot[0]) {
            var lines = slot[3] === slot[6] ? caml_call2(Stdlib_Printf[4], _h_, slot[3]) : caml_call3(Stdlib_Printf[4], _j_, slot[3], slot[6]), _R_ = slot[7], _S_ = slot[4], _T_1 = slot[8] ? cst_inlined : cst$3, _U_ = slot[2], _V_ = slot[9], _W_ = info(slot[1]);
            return [
                0,
                caml_call8(Stdlib_Printf[4], _i_, _W_, _V_, _U_, _T_1, lines, _S_, _R_)
            ];
        }
        if (slot[1]) return 0;
        var _X_ = info(0);
        return [
            0,
            caml_call2(Stdlib_Printf[4], _k_, _X_)
        ];
    }
    function print_raw_backtrace(outchan, raw_backtrace) {
        var backtrace = convert_raw_backtrace(raw_backtrace);
        if (!backtrace) return caml_call2(Stdlib_Printf[1], outchan, _m_);
        var a = backtrace[1], _P_ = a.length - 2 | 0, _O_ = 0;
        if (_P_ >= 0) {
            var i = _O_;
            for(;;){
                var match = format_backtrace_slot(i, caml_check_bound(a, i)[1 + i]);
                if (match) {
                    var str = match[1];
                    caml_call3(Stdlib_Printf[1], outchan, _l_, str);
                }
                var _Q_ = i + 1 | 0;
                if (_P_ === i) break;
                i = _Q_;
            }
        }
        return 0;
    }
    function print_backtrace(outchan) {
        return print_raw_backtrace(outchan, caml_get_exception_raw_backtra(0));
    }
    function raw_backtrace_to_string(raw_backtrace) {
        var backtrace = convert_raw_backtrace(raw_backtrace);
        if (!backtrace) return cst_Program_not_linked_with_g_;
        var a = backtrace[1], b = caml_call1(Stdlib_Buffer[1], 1024), _M_ = a.length - 2 | 0, _L_ = 0;
        if (_M_ >= 0) {
            var i = _L_;
            for(;;){
                var match = format_backtrace_slot(i, caml_check_bound(a, i)[1 + i]);
                if (match) {
                    var str = match[1];
                    caml_call3(Stdlib_Printf[5], b, _n_, str);
                }
                var _N_ = i + 1 | 0;
                if (_M_ === i) break;
                i = _N_;
            }
        }
        return caml_call1(Stdlib_Buffer[2], b);
    }
    function backtrace_slot_is_raise(param) {
        return 0 === param[0] ? param[1] : param[1];
    }
    function backtrace_slot_is_inline(param) {
        return 0 === param[0] ? param[8] : 0;
    }
    function backtrace_slot_location(param) {
        return 0 === param[0] ? [
            0,
            [
                0,
                param[2],
                param[3],
                param[4],
                param[5],
                param[6],
                param[7]
            ]
        ] : 0;
    }
    function backtrace_slot_defname(param) {
        if (0 === param[0] && param[9] !== cst$4) return [
            0,
            param[9]
        ];
        return 0;
    }
    function backtrace_slots(raw_backtrace) {
        var match = convert_raw_backtrace(raw_backtrace);
        if (!match) return 0;
        var backtrace = match[1], i$1 = backtrace.length - 2 | 0, i = i$1;
        for(;;){
            if (-1 === i) var _K_ = 0;
            else {
                var _J_ = 0 === caml_check_bound(backtrace, i)[1 + i][0] ? 1 : 0;
                if (!_J_) {
                    var i$0 = i - 1 | 0;
                    i = i$0;
                    continue;
                }
                var _K_ = _J_;
            }
            return _K_ ? [
                0,
                backtrace
            ] : 0;
        }
    }
    function backtrace_slots_of_raw_entry(entry) {
        return backtrace_slots([
            0,
            entry
        ]);
    }
    function raw_backtrace_length(bt) {
        return bt.length - 1;
    }
    function get_backtrace(param) {
        return raw_backtrace_to_string(caml_get_exception_raw_backtra(0));
    }
    function register_printer(fn) {
        for(;;){
            var old_printers = caml_call1(Stdlib_Atomic[3], printers), new_printers = [
                0,
                fn,
                old_printers
            ], success = caml_call3(Stdlib_Atomic[6], printers, old_printers, new_printers), _I_ = 1 - success;
            if (!_I_) return _I_;
        }
    }
    function exn_slot(x) {
        return 0 === caml_obj_tag(x) ? x[1] : x;
    }
    function exn_slot_id(x) {
        var slot = exn_slot(x);
        return slot[2];
    }
    function exn_slot_name(x) {
        var slot = exn_slot(x);
        return slot[1];
    }
    var errors = [
        0,
        cst$4,
        "(Cannot print locations:\n bytecode executable program file not found)",
        "(Cannot print locations:\n bytecode executable program file appears to be corrupt)",
        "(Cannot print locations:\n bytecode executable program file has wrong magic number)",
        "(Cannot print locations:\n bytecode executable program file cannot be opened;\n -- too many open files. Try running with OCAMLRUNPARAM=b=2)"
    ].slice(), _o_ = [
        0,
        [
            11,
            cst_Fatal_error_exception,
            [
                2,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        cst_Fatal_error_exception_s
    ];
    function default_uncaught_exception_han(exn, raw_backtrace) {
        var _F_ = to_string(exn);
        caml_call2(Stdlib_Printf[3], _o_, _F_);
        print_raw_backtrace(Stdlib[40], raw_backtrace);
        var status = runtime.caml_ml_debug_info_status(0);
        if (status < 0) {
            var _G_ = caml_call1(Stdlib[18], status), _H_ = caml_check_bound(errors, _G_)[1 + _G_];
            caml_call1(Stdlib[53], _H_);
        }
        return caml_call1(Stdlib[63], Stdlib[40]);
    }
    var uncaught_exception_handler = [
        0,
        default_uncaught_exception_han
    ];
    function set_uncaught_exception_handler(fn) {
        uncaught_exception_handler[1] = fn;
        return 0;
    }
    var empty_backtrace = [
        0
    ], cst_Fatal_error_out_of_memory_ = "Fatal error: out of memory in uncaught exception handler", _p_ = [
        0,
        [
            11,
            cst_Fatal_error_exception,
            [
                2,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        cst_Fatal_error_exception_s
    ], _q_ = [
        0,
        [
            11,
            "Fatal error in uncaught exception handler: exception ",
            [
                2,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        "Fatal error in uncaught exception handler: exception %s\n"
    ];
    function handle_uncaught_exception(exn$0, debugger_in_use) {
        try {
            try {
                var raw_backtrace = debugger_in_use ? empty_backtrace : caml_get_exception_raw_backtra(0);
                try {
                    caml_call1(Stdlib[103], 0);
                } catch (_E_) {}
                try {
                    var _A_ = caml_call2(uncaught_exception_handler[1], exn$0, raw_backtrace), _z_ = _A_;
                } catch (exn$1) {
                    var exn = caml_wrap_exception(exn$1), raw_backtrace$0 = caml_get_exception_raw_backtra(0), _x_ = to_string(exn$0);
                    caml_call2(Stdlib_Printf[3], _p_, _x_);
                    print_raw_backtrace(Stdlib[40], raw_backtrace);
                    var _y_ = to_string(exn);
                    caml_call2(Stdlib_Printf[3], _q_, _y_);
                    print_raw_backtrace(Stdlib[40], raw_backtrace$0);
                    var _z_ = caml_call1(Stdlib[63], Stdlib[40]);
                }
                var _B_ = _z_;
            } catch (_D_) {
                var _w_ = caml_wrap_exception(_D_);
                if (_w_ !== Stdlib[9]) throw caml_maybe_attach_backtrace(_w_, 0);
                var _B_ = caml_call1(Stdlib[53], cst_Fatal_error_out_of_memory_);
            }
            return _B_;
        } catch (_C_) {
            return 0;
        }
    }
    runtime.caml_register_named_value("Printexc.handle_uncaught_exception", handle_uncaught_exception);
    var Stdlib_Printexc = [
        0,
        to_string,
        to_string_default,
        print,
        catch$0,
        print_backtrace,
        get_backtrace,
        runtime.caml_record_backtrace,
        runtime.caml_backtrace_status,
        register_printer,
        use_printers,
        raw_backtrace_entries,
        function(_v_) {
            return caml_get_exception_raw_backtra(_v_);
        },
        print_raw_backtrace,
        raw_backtrace_to_string,
        default_uncaught_exception_han,
        set_uncaught_exception_handler,
        backtrace_slots,
        backtrace_slots_of_raw_entry,
        [
            0,
            backtrace_slot_is_raise,
            backtrace_slot_is_inline,
            backtrace_slot_location,
            backtrace_slot_defname,
            format_backtrace_slot
        ],
        raw_backtrace_length,
        function(_u_, _t_) {
            return runtime.caml_raw_backtrace_slot(_u_, _t_);
        },
        function(_s_) {
            return runtime.caml_convert_raw_backtrace_slot(_s_);
        },
        function(_r_) {
            return runtime.caml_raw_backtrace_next_slot(_r_);
        },
        exn_slot_id,
        exn_slot_name,
        string_of_extension_constructo
    ];
    runtime.caml_register_global(43, Stdlib_Printexc, "Stdlib__Printexc");
    return;
})(globalThis);
//# 18261 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_restore_raw_backtrace = runtime.caml_restore_raw_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Stdlib_Printexc = global_data.Stdlib__Printexc, Stdlib = global_data.Stdlib;
    function const$0(c, param) {
        return c;
    }
    function compose(f, g, x) {
        return caml_call1(f, caml_call1(g, x));
    }
    function flip(f, x, y) {
        return caml_call2(f, y, x);
    }
    function negate(p, v) {
        return 1 - caml_call1(p, v);
    }
    var Finally_raised = [
        248,
        "Stdlib.Fun.Finally_raised",
        runtime.caml_fresh_oo_id(0)
    ], cst_Fun_Finally_raised = "Fun.Finally_raised: ";
    caml_call1(Stdlib_Printexc[9], function(param) {
        if (param[1] !== Finally_raised) return 0;
        var exn = param[2], _a_ = caml_call1(Stdlib_Printexc[1], exn);
        return [
            0,
            caml_call2(Stdlib[28], cst_Fun_Finally_raised, _a_)
        ];
    });
    function protect(finally$0, work) {
        function finally_no_exn(param) {
            try {
                caml_call1(finally$0, 0);
                return;
            } catch (e$0) {
                var e = caml_wrap_exception(e$0), bt = caml_call1(Stdlib_Printexc[12], 0), exn = [
                    0,
                    Finally_raised,
                    e
                ];
                caml_restore_raw_backtrace(exn, bt);
                throw caml_maybe_attach_backtrace(exn, 0);
            }
        }
        try {
            var result = caml_call1(work, 0);
        } catch (work_exn$0) {
            var work_exn = caml_wrap_exception(work_exn$0), work_bt = caml_call1(Stdlib_Printexc[12], 0);
            finally_no_exn(0);
            caml_restore_raw_backtrace(work_exn, work_bt);
            throw caml_maybe_attach_backtrace(work_exn, 0);
        }
        finally_no_exn(0);
        return result;
    }
    var Stdlib_Fun = [
        0,
        const$0,
        compose,
        flip,
        negate,
        protect,
        Finally_raised
    ];
    runtime.caml_register_global(4, Stdlib_Fun, "Stdlib__Fun");
    return;
})(globalThis);
//# 18513 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_ba_dim_1 = runtime.caml_ba_dim_1, caml_create_bytes = runtime.caml_create_bytes, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_input_bigarray = runtime.caml_ml_input_bigarray, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Fun = global_data.Stdlib__Fun, stdin = Stdlib[38], open_bin = Stdlib[80], open_text = Stdlib[79], open_gen = Stdlib[81];
    function with_open(openfun, s, f) {
        var ic = caml_call1(openfun, s);
        return caml_call2(Stdlib_Fun[5], function(param) {
            return caml_call1(Stdlib[94], ic);
        }, function(param) {
            return caml_call1(f, ic);
        });
    }
    function with_open_bin(s, f) {
        return with_open(Stdlib[80], s, f);
    }
    function with_open_text(s, f) {
        return with_open(Stdlib[79], s, f);
    }
    function with_open_gen(flags, perm, s, f) {
        return with_open(caml_call2(Stdlib[81], flags, perm), s, f);
    }
    var seek = Stdlib[96][4], pos = Stdlib[96][5], length = Stdlib[96][6], close = Stdlib[93], close_noerr = Stdlib[94];
    function input_char(ic) {
        try {
            var c = caml_call1(Stdlib[82], ic);
        } catch (_x_) {
            var _w_ = caml_wrap_exception(_x_);
            if (_w_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_w_, 0);
        }
        return [
            0,
            c
        ];
    }
    function input_byte(ic) {
        try {
            var n = caml_call1(Stdlib[87], ic);
        } catch (_v_) {
            var _u_ = caml_wrap_exception(_v_);
            if (_u_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_u_, 0);
        }
        return [
            0,
            n
        ];
    }
    function input_line(ic) {
        try {
            var s = caml_call1(Stdlib[83], ic);
        } catch (_t_) {
            var _s_ = caml_wrap_exception(_t_);
            if (_s_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_s_, 0);
        }
        return [
            0,
            s
        ];
    }
    var input = Stdlib[84], cst_input_bigarray = "input_bigarray", _a_ = [
        0,
        0
    ], _b_ = [
        0,
        0
    ], cst_really_input_bigarray = "really_input_bigarray", cst_In_channel_input_all_chann = "In_channel.input_all: channel content is larger than maximum string length";
    function input_bigarray(ic, buf, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ba_dim_1(buf) - len | 0) >= ofs) return caml_ml_input_bigarray(ic, buf, ofs, len);
        return caml_call1(Stdlib[1], cst_input_bigarray);
    }
    function really_input(ic, buf, pos, len) {
        try {
            caml_call4(Stdlib[85], ic, buf, pos, len);
            return _a_;
        } catch (_r_) {
            var _q_ = caml_wrap_exception(_r_);
            if (_q_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_q_, 0);
        }
    }
    function really_input_bigarray(ic, buf, ofs$1, len$1) {
        if (0 <= ofs$1 && 0 <= len$1 && (caml_ba_dim_1(buf) - len$1 | 0) >= ofs$1) {
            var ofs = ofs$1, len = len$1;
            for(;;){
                if (0 >= len) return _b_;
                var r = caml_ml_input_bigarray(ic, buf, ofs, len);
                if (0 === r) return 0;
                var len$0 = len - r | 0, ofs$0 = ofs + r | 0;
                ofs = ofs$0;
                len = len$0;
            }
        }
        return caml_call1(Stdlib[1], cst_really_input_bigarray);
    }
    function really_input_string(ic, len) {
        try {
            var s = caml_call2(Stdlib[86], ic, len);
        } catch (_p_) {
            var _o_ = caml_wrap_exception(_p_);
            if (_o_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_o_, 0);
        }
        return [
            0,
            s
        ];
    }
    function read_upto(ic, buf, ofs, len) {
        var ofs$0 = ofs, len$0 = len;
        for(;;){
            if (0 !== len$0) {
                var r = caml_call4(Stdlib[84], ic, buf, ofs$0, len$0);
                if (0 !== r) {
                    var len$1 = len$0 - r | 0, ofs$1 = ofs$0 + r | 0;
                    ofs$0 = ofs$1;
                    len$0 = len$1;
                    continue;
                }
            }
            return ofs$0 - ofs | 0;
        }
    }
    function ensure(buf, ofs, n) {
        var len = caml_ml_bytes_length(buf);
        if ((ofs + n | 0) <= len) return buf;
        var new_len = [
            0,
            len
        ];
        for(;;){
            if (new_len[1] >= (ofs + n | 0)) break;
            new_len[1] = (2 * new_len[1] | 0) + 1 | 0;
        }
        var new_len$0 = new_len[1], new_len$1 = new_len$0 <= Stdlib_Sys[12] ? new_len$0 : ofs < Stdlib_Sys[12] ? Stdlib_Sys[12] : caml_call1(Stdlib[2], cst_In_channel_input_all_chann), new_buf = caml_create_bytes(new_len$1);
        caml_call5(Stdlib_Bytes[11], buf, 0, new_buf, 0, ofs);
        return new_buf;
    }
    function input_all(ic) {
        var chunk_size = 65536;
        try {
            var _k_ = caml_call1(Stdlib[91], ic), _l_ = caml_call1(Stdlib[92], ic) - _k_ | 0, initial_size = _l_;
        } catch (_n_) {
            var _i_ = caml_wrap_exception(_n_);
            if (_i_[1] !== Stdlib[11]) throw caml_maybe_attach_backtrace(_i_, 0);
            var initial_size = -1;
        }
        var initial_size$0 = 0 <= initial_size ? initial_size : chunk_size, initial_size$1 = initial_size$0 <= Stdlib_Sys[12] ? initial_size$0 : Stdlib_Sys[12], buf = caml_create_bytes(initial_size$1), nread = read_upto(ic, buf, 0, initial_size$1);
        if (nread < initial_size$1) return caml_call3(Stdlib_Bytes[8], buf, 0, nread);
        try {
            var c = caml_call1(Stdlib[82], ic);
        } catch (_m_) {
            var _j_ = caml_wrap_exception(_m_);
            if (_j_ === Stdlib[12]) return caml_call1(Stdlib_Bytes[44], buf);
            throw caml_maybe_attach_backtrace(_j_, 0);
        }
        var buf$2 = ensure(buf, nread, 65537);
        runtime.caml_bytes_set(buf$2, nread, c);
        var ofs$1 = nread + 1 | 0, buf$0 = buf$2, ofs = ofs$1;
        for(;;){
            var buf$1 = ensure(buf$0, ofs, chunk_size), rem = caml_ml_bytes_length(buf$1) - ofs | 0, r = read_upto(ic, buf$1, ofs, rem);
            if (r < rem) return caml_call3(Stdlib_Bytes[8], buf$1, 0, ofs + r | 0);
            var ofs$0 = ofs + rem | 0;
            buf$0 = buf$1;
            ofs = ofs$0;
        }
    }
    function input_lines(ic) {
        try {
            var line = caml_call1(Stdlib[83], ic);
        } catch (_h_) {
            var _e_ = caml_wrap_exception(_h_);
            if (_e_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_e_, 0);
        }
        var block = [
            0,
            line,
            24029
        ], dst = block, offset = 1;
        for(;;){
            try {
                var line$0 = caml_call1(Stdlib[83], ic);
            } catch (_g_) {
                var _f_ = caml_wrap_exception(_g_);
                if (_f_ !== Stdlib[12]) throw caml_maybe_attach_backtrace(_f_, 0);
                dst[1 + offset] = 0;
                return block;
            }
            var dst$0 = [
                0,
                line$0,
                24029
            ];
            dst[1 + offset] = dst$0;
            dst = dst$0;
            offset = 1;
        }
    }
    function fold_lines(f, accu, ic) {
        var accu$0 = accu;
        for(;;){
            try {
                var line = caml_call1(Stdlib[83], ic);
            } catch (_d_) {
                var _c_ = caml_wrap_exception(_d_);
                if (_c_ === Stdlib[12]) return accu$0;
                throw caml_maybe_attach_backtrace(_c_, 0);
            }
            var accu$1 = caml_call2(f, accu$0, line);
            accu$0 = accu$1;
        }
    }
    var set_binary_mode = Stdlib[95], Stdlib_In_channel = [
        0,
        stdin,
        open_bin,
        open_text,
        open_gen,
        with_open_bin,
        with_open_text,
        with_open_gen,
        close,
        close_noerr,
        input_char,
        input_byte,
        input_line,
        really_input_string,
        input_all,
        input_lines,
        input,
        input_bigarray,
        really_input,
        really_input_bigarray,
        fold_lines,
        seek,
        pos,
        length,
        set_binary_mode,
        runtime.caml_ml_is_binary_mode,
        runtime.caml_sys_isatty
    ];
    runtime.caml_register_global(9, Stdlib_In_channel, "Stdlib__In_channel");
    return;
})(globalThis);
//# 18890 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "", cst_Digest_of_hex$1 = "Digest.of_hex", cst_Digest_substring$1 = "Digest.substring", cst_Digest_to_hex$1 = "Digest.to_hex", caml_blake2_final = runtime.caml_blake2_final, caml_blake2_string = runtime.caml_blake2_string, caml_blake2_update = runtime.caml_blake2_update, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_md5_chan = runtime.caml_md5_chan, caml_md5_string = runtime.caml_md5_string, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_In_channel = global_data.Stdlib__In_channel, Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib_Int = global_data.Stdlib__Int, Stdlib_String = global_data.Stdlib__String, Stdlib_Char = global_data.Stdlib__Char, cst_Digest_of_hex = cst_Digest_of_hex$1, cst_Digest_BLAKE2_wrong_hash_s = "Digest.BLAKE2: wrong hash size", cst_Digest_substring = cst_Digest_substring$1, cst_Digest_to_hex = cst_Digest_to_hex$1, cst_Digest_of_hex$0 = cst_Digest_of_hex$1;
    function hex_of_string(d) {
        function char_hex(n) {
            var _l_ = 10 <= n ? (97 + n | 0) - 10 | 0 : 48 + n | 0;
            return caml_call1(Stdlib_Char[1], _l_);
        }
        var len = caml_ml_string_length(d), result = caml_create_bytes(len * 2 | 0), _j_ = len - 1 | 0, _i_ = 0;
        if (_j_ >= 0) {
            var i = _i_;
            for(;;){
                var x = caml_string_get(d, i);
                caml_bytes_unsafe_set(result, i * 2 | 0, char_hex(x >>> 4 | 0));
                caml_bytes_unsafe_set(result, (i * 2 | 0) + 1 | 0, char_hex(x & 15));
                var _k_ = i + 1 | 0;
                if (_j_ === i) break;
                i = _k_;
            }
        }
        return caml_call1(Stdlib_Bytes[44], result);
    }
    function string_of_hex(s) {
        function digit(c) {
            if (65 <= c) {
                if (97 <= c) {
                    if (103 > c) return (c - 97 | 0) + 10 | 0;
                } else if (71 > c) return (c - 65 | 0) + 10 | 0;
            } else if (9 >= c - 48 >>> 0) return c - 48 | 0;
            return caml_call1(Stdlib[1], cst_Digest_of_hex);
        }
        return caml_call2(Stdlib_String[2], caml_ml_string_length(s) / 2 | 0, function(i) {
            var i$0 = 2 * i | 0, _g_ = digit(caml_string_get(s, i$0 + 1 | 0)), _h_ = (digit(caml_string_get(s, i$0)) << 4) + _g_ | 0;
            return caml_call1(Stdlib_Char[1], _h_);
        });
    }
    function BLAKE2(X) {
        var _a_ = X[1] < 1 ? 1 : 0, _b_ = _a_ || (64 < X[1] ? 1 : 0);
        if (_b_) caml_call1(Stdlib[1], cst_Digest_BLAKE2_wrong_hash_s);
        var hash_length = X[1], compare = Stdlib_String[10], equal = Stdlib_String[9];
        function string(str) {
            return caml_blake2_string(hash_length, cst, str, 0, caml_ml_string_length(str));
        }
        function bytes(b) {
            return string(caml_call1(Stdlib_Bytes[44], b));
        }
        function substring(str, ofs, len) {
            var _d_ = ofs < 0 ? 1 : 0;
            if (_d_) var _e_ = _d_;
            else var _f_ = len < 0 ? 1 : 0, _e_ = _f_ || ((caml_ml_string_length(str) - len | 0) < ofs ? 1 : 0);
            if (_e_) caml_call1(Stdlib[1], cst_Digest_substring);
            return caml_blake2_string(hash_length, cst, str, ofs, len);
        }
        function subbytes(b, ofs, len) {
            return substring(caml_call1(Stdlib_Bytes[44], b), ofs, len);
        }
        function channel(ic, toread) {
            var buf_size = 4096, buf = caml_create_bytes(4096), ctx = runtime.caml_blake2_create(hash_length, cst);
            if (0 <= toread) {
                var toread$0 = toread;
                for(;;){
                    if (0 === toread$0) return caml_blake2_final(ctx, hash_length);
                    var _c_ = caml_call2(Stdlib_Int[10], buf_size, toread$0), n = caml_call4(Stdlib_In_channel[16], ic, buf, 0, _c_);
                    if (0 === n) throw caml_maybe_attach_backtrace(Stdlib[12], 1);
                    caml_blake2_update(ctx, caml_call1(Stdlib_Bytes[44], buf), 0, n);
                    var toread$1 = toread$0 - n | 0;
                    toread$0 = toread$1;
                }
            } else for(;;){
                var n$0 = caml_call4(Stdlib_In_channel[16], ic, buf, 0, buf_size);
                if (0 === n$0) return caml_blake2_final(ctx, hash_length);
                caml_blake2_update(ctx, caml_call1(Stdlib_Bytes[44], buf), 0, n$0);
            }
        }
        function file(filename) {
            return caml_call2(Stdlib_In_channel[5], filename, function(ic) {
                return channel(ic, -1);
            });
        }
        function output(chan, digest) {
            return caml_call2(Stdlib[66], chan, digest);
        }
        function input(chan) {
            return caml_call2(Stdlib[86], chan, hash_length);
        }
        function to_hex(d) {
            if (caml_ml_string_length(d) !== hash_length) caml_call1(Stdlib[1], cst_Digest_to_hex);
            return hex_of_string(d);
        }
        function of_hex(s) {
            if (caml_ml_string_length(s) !== (hash_length * 2 | 0)) caml_call1(Stdlib[1], cst_Digest_of_hex$0);
            return string_of_hex(s);
        }
        return [
            0,
            hash_length,
            compare,
            equal,
            string,
            bytes,
            substring,
            subbytes,
            channel,
            file,
            output,
            input,
            to_hex,
            of_hex
        ];
    }
    var BLAKE128 = BLAKE2([
        0,
        16
    ]), BLAKE256 = BLAKE2([
        0,
        32
    ]), BLAKE512 = BLAKE2([
        0,
        64
    ]), compare = Stdlib_String[10], equal = Stdlib_String[9], cst_Digest_substring$0 = cst_Digest_substring$1, cst_Digest_to_hex$0 = cst_Digest_to_hex$1, cst_Digest_from_hex = "Digest.from_hex";
    function string(str) {
        return caml_md5_string(str, 0, caml_ml_string_length(str));
    }
    function bytes(b) {
        return string(caml_call1(Stdlib_Bytes[44], b));
    }
    function substring(str, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_string_length(str) - len | 0) >= ofs) return caml_md5_string(str, ofs, len);
        return caml_call1(Stdlib[1], cst_Digest_substring$0);
    }
    function subbytes(b, ofs, len) {
        return substring(caml_call1(Stdlib_Bytes[44], b), ofs, len);
    }
    function file(filename) {
        return caml_call2(Stdlib_In_channel[5], filename, function(ic) {
            return caml_md5_chan(ic, -1);
        });
    }
    function output(chan, digest) {
        return caml_call2(Stdlib[66], chan, digest);
    }
    function input(chan) {
        return caml_call2(Stdlib[86], chan, 16);
    }
    function to_hex(d) {
        if (16 !== caml_ml_string_length(d)) caml_call1(Stdlib[1], cst_Digest_to_hex$0);
        return hex_of_string(d);
    }
    function of_hex(s) {
        if (32 !== caml_ml_string_length(s)) caml_call1(Stdlib[1], cst_Digest_from_hex);
        return string_of_hex(s);
    }
    var Stdlib_Digest = [
        0,
        compare,
        equal,
        string,
        bytes,
        substring,
        subbytes,
        caml_md5_chan,
        file,
        output,
        input,
        to_hex,
        of_hex,
        of_hex,
        BLAKE128,
        BLAKE256,
        BLAKE512,
        [
            0,
            16,
            compare,
            equal,
            string,
            bytes,
            substring,
            subbytes,
            caml_md5_chan,
            file,
            output,
            input,
            to_hex,
            of_hex
        ]
    ];
    runtime.caml_register_global(17, Stdlib_Digest, "Stdlib__Digest");
    return;
})(globalThis);
//# 19147 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Bigarray_Array3_of_array_n$1 = "Bigarray.Array3.of_array: non-cubic data", caml_ba_change_layout = runtime.caml_ba_change_layout, caml_ba_create = runtime.caml_ba_create, caml_ba_dim_1 = runtime.caml_ba_dim_1, caml_ba_dim_2 = runtime.caml_ba_dim_2, caml_ba_kind = runtime.caml_ba_kind, caml_ba_num_dims = runtime.caml_ba_num_dims, caml_ba_reshape = runtime.caml_ba_reshape, caml_ba_set_1 = runtime.caml_ba_set_1, caml_ba_set_2 = runtime.caml_ba_set_2, caml_ba_set_3 = runtime.caml_ba_set_3, caml_ba_set_generic = runtime.caml_ba_set_generic, caml_ba_slice = runtime.caml_ba_slice, caml_check_bound = runtime.caml_check_bound, caml_make_vect = runtime.caml_make_vect, caml_mul = runtime.caml_mul;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Sys = global_data.Stdlib__Sys;
    function kind_size_in_bytes(param) {
        switch(param){
            case 0:
                return 4;
            case 1:
                return 8;
            case 2:
                return 1;
            case 3:
                return 1;
            case 4:
                return 2;
            case 5:
                return 2;
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
                return Stdlib_Sys[9] / 8 | 0;
            case 9:
                return Stdlib_Sys[9] / 8 | 0;
            case 10:
                return 8;
            case 11:
                return 16;
            case 12:
                return 1;
            default:
                return 2;
        }
    }
    var cst_Bigarray_Array2_of_array_n = "Bigarray.Array2.of_array: non-rectangular data", cst_Bigarray_Array3_of_array_n = cst_Bigarray_Array3_of_array_n$1, cst_Bigarray_Array3_of_array_n$0 = cst_Bigarray_Array3_of_array_n$1, cst_Bigarray_array0_of_genarra = "Bigarray.array0_of_genarray", cst_Bigarray_array1_of_genarra = "Bigarray.array1_of_genarray", cst_Bigarray_array2_of_genarra = "Bigarray.array2_of_genarray", cst_Bigarray_array3_of_genarra = "Bigarray.array3_of_genarray";
    function cloop(arr, idx, f, col, max) {
        if (col === idx.length - 1) {
            caml_ba_set_generic(arr, idx, caml_call1(f, idx));
            return;
        }
        var _am_ = caml_check_bound(max, col)[1 + col] - 1 | 0, _al_ = 0;
        if (_am_ >= 0) {
            var j = _al_;
            for(;;){
                caml_check_bound(idx, col)[1 + col] = j;
                cloop(arr, idx, f, col + 1 | 0, max);
                var _an_ = j + 1 | 0;
                if (_am_ === j) break;
                j = _an_;
            }
        }
        return;
    }
    function floop(arr, idx, f, col, max) {
        if (0 > col) {
            caml_ba_set_generic(arr, idx, caml_call1(f, idx));
            return;
        }
        var _aj_ = caml_check_bound(max, col)[1 + col], _ai_ = 1;
        if (_aj_ >= 1) {
            var j = _ai_;
            for(;;){
                caml_check_bound(idx, col)[1 + col] = j;
                floop(arr, idx, f, col - 1 | 0, max);
                var _ak_ = j + 1 | 0;
                if (_aj_ === j) break;
                j = _ak_;
            }
        }
        return;
    }
    function init(kind, layout, dims, f) {
        var arr = caml_ba_create(kind, layout, dims), dlen = dims.length - 1;
        return layout ? (floop(arr, caml_make_vect(dlen, 1), f, dlen - 1 | 0, dims), arr) : (cloop(arr, caml_make_vect(dlen, 0), f, 0, dims), arr);
    }
    function dims(a) {
        var n = caml_ba_num_dims(a), d = caml_make_vect(n, 0), _af_ = n - 1 | 0, _ae_ = 0;
        if (_af_ >= 0) {
            var i = _ae_;
            for(;;){
                var _ag_ = runtime.caml_ba_dim(a, i);
                caml_check_bound(d, i)[1 + i] = _ag_;
                var _ah_ = i + 1 | 0;
                if (_af_ === i) break;
                i = _ah_;
            }
        }
        return d;
    }
    function size_in_bytes(arr) {
        var _ac_ = dims(arr), _ad_ = caml_call3(Stdlib_Array[18], caml_mul, 1, _ac_);
        return caml_mul(kind_size_in_bytes(caml_ba_kind(arr)), _ad_);
    }
    function create(kind, layout) {
        return caml_ba_create(kind, layout, [
            0
        ]);
    }
    function get(arr) {
        return runtime.caml_ba_get_generic(arr, [
            0
        ]);
    }
    function set(arr) {
        var _aa_ = [
            0
        ];
        return function(_ab_) {
            return caml_ba_set_generic(arr, _aa_, _ab_);
        };
    }
    function size_in_bytes$0(arr) {
        return kind_size_in_bytes(caml_ba_kind(arr));
    }
    function of_value(kind, layout, v) {
        var a = create(kind, layout);
        set(a)(v);
        return a;
    }
    function create$0(kind, layout, dim) {
        return caml_ba_create(kind, layout, [
            0,
            dim
        ]);
    }
    function size_in_bytes$1(arr) {
        var _$_ = caml_ba_dim_1(arr);
        return caml_mul(kind_size_in_bytes(caml_ba_kind(arr)), _$_);
    }
    function slice(a, n) {
        return runtime.caml_ba_layout(a) ? caml_ba_slice(a, [
            0,
            n
        ]) : caml_ba_slice(a, [
            0,
            n
        ]);
    }
    function init$0(kind, layout, dim, f) {
        var arr = create$0(kind, layout, dim);
        if (layout) {
            var _Z_ = 1;
            if (dim >= 1) {
                var i$0 = _Z_;
                for(;;){
                    caml_ba_set_1(arr, i$0, caml_call1(f, i$0));
                    var ___ = i$0 + 1 | 0;
                    if (dim === i$0) break;
                    i$0 = ___;
                }
            }
            return arr;
        }
        var _X_ = dim - 1 | 0, _W_ = 0;
        if (_X_ >= 0) {
            var i = _W_;
            for(;;){
                caml_ba_set_1(arr, i, caml_call1(f, i));
                var _Y_ = i + 1 | 0;
                if (_X_ === i) break;
                i = _Y_;
            }
        }
        return arr;
    }
    function of_array(kind, layout, data) {
        var ba = create$0(kind, layout, data.length - 1), ofs = layout ? 1 : 0, _U_ = data.length - 2 | 0, _T_1 = 0;
        if (_U_ >= 0) {
            var i = _T_1;
            for(;;){
                caml_ba_set_1(ba, i + ofs | 0, caml_check_bound(data, i)[1 + i]);
                var _V_ = i + 1 | 0;
                if (_U_ === i) break;
                i = _V_;
            }
        }
        return ba;
    }
    function create$1(kind, layout, dim1, dim2) {
        return caml_ba_create(kind, layout, [
            0,
            dim1,
            dim2
        ]);
    }
    function size_in_bytes$2(arr) {
        var _R_ = caml_ba_dim_2(arr), _S_ = caml_ba_dim_1(arr);
        return caml_mul(caml_mul(kind_size_in_bytes(caml_ba_kind(arr)), _S_), _R_);
    }
    function slice_left(a, n) {
        return caml_ba_slice(a, [
            0,
            n
        ]);
    }
    function slice_right(a, n) {
        return caml_ba_slice(a, [
            0,
            n
        ]);
    }
    function init$1(kind, layout, dim1, dim2, f) {
        var arr = create$1(kind, layout, dim1, dim2);
        if (layout) {
            var _N_ = 1;
            if (dim2 >= 1) {
                var j$0 = _N_;
                for(;;){
                    var _O_ = 1;
                    if (dim1 >= 1) {
                        var i$0 = _O_;
                        for(;;){
                            caml_ba_set_2(arr, i$0, j$0, caml_call2(f, i$0, j$0));
                            var _Q_ = i$0 + 1 | 0;
                            if (dim1 === i$0) break;
                            i$0 = _Q_;
                        }
                    }
                    var _P_ = j$0 + 1 | 0;
                    if (dim2 === j$0) break;
                    j$0 = _P_;
                }
            }
            return arr;
        }
        var _I_ = dim1 - 1 | 0, _H_ = 0;
        if (_I_ >= 0) {
            var i = _H_;
            for(;;){
                var _K_ = dim2 - 1 | 0, _J_ = 0;
                if (_K_ >= 0) {
                    var j = _J_;
                    for(;;){
                        caml_ba_set_2(arr, i, j, caml_call2(f, i, j));
                        var _M_ = j + 1 | 0;
                        if (_K_ === j) break;
                        j = _M_;
                    }
                }
                var _L_ = i + 1 | 0;
                if (_I_ === i) break;
                i = _L_;
            }
        }
        return arr;
    }
    function of_array$0(kind, layout, data) {
        var dim1 = data.length - 1, dim2 = 0 === dim1 ? 0 : caml_check_bound(data, 0)[1].length - 1, ba = create$1(kind, layout, dim1, dim2), ofs = layout ? 1 : 0, _C_ = dim1 - 1 | 0, _B_ = 0;
        if (_C_ >= 0) {
            var i = _B_;
            for(;;){
                var row = caml_check_bound(data, i)[1 + i];
                if (row.length - 1 !== dim2) caml_call1(Stdlib[1], cst_Bigarray_Array2_of_array_n);
                var _E_ = dim2 - 1 | 0, _D_ = 0;
                if (_E_ >= 0) {
                    var j = _D_;
                    for(;;){
                        caml_ba_set_2(ba, i + ofs | 0, j + ofs | 0, caml_check_bound(row, j)[1 + j]);
                        var _G_ = j + 1 | 0;
                        if (_E_ === j) break;
                        j = _G_;
                    }
                }
                var _F_ = i + 1 | 0;
                if (_C_ === i) break;
                i = _F_;
            }
        }
        return ba;
    }
    function create$2(kind, layout, dim1, dim2, dim3) {
        return caml_ba_create(kind, layout, [
            0,
            dim1,
            dim2,
            dim3
        ]);
    }
    function size_in_bytes$3(arr) {
        var _y_ = runtime.caml_ba_dim_3(arr), _z_ = caml_ba_dim_2(arr), _A_ = caml_ba_dim_1(arr);
        return caml_mul(caml_mul(caml_mul(kind_size_in_bytes(caml_ba_kind(arr)), _A_), _z_), _y_);
    }
    function slice_left_1(a, n, m) {
        return caml_ba_slice(a, [
            0,
            n,
            m
        ]);
    }
    function slice_right_1(a, n, m) {
        return caml_ba_slice(a, [
            0,
            n,
            m
        ]);
    }
    function slice_left_2(a, n) {
        return caml_ba_slice(a, [
            0,
            n
        ]);
    }
    function slice_right_2(a, n) {
        return caml_ba_slice(a, [
            0,
            n
        ]);
    }
    function init$2(kind, layout, dim1, dim2, dim3, f) {
        var arr = create$2(kind, layout, dim1, dim2, dim3);
        if (layout) {
            var _s_ = 1;
            if (dim3 >= 1) {
                var k$0 = _s_;
                for(;;){
                    var _t_ = 1;
                    if (dim2 >= 1) {
                        var j$0 = _t_;
                        for(;;){
                            var _v_ = 1;
                            if (dim1 >= 1) {
                                var i$0 = _v_;
                                for(;;){
                                    caml_ba_set_3(arr, i$0, j$0, k$0, caml_call3(f, i$0, j$0, k$0));
                                    var _x_ = i$0 + 1 | 0;
                                    if (dim1 === i$0) break;
                                    i$0 = _x_;
                                }
                            }
                            var _w_ = j$0 + 1 | 0;
                            if (dim2 === j$0) break;
                            j$0 = _w_;
                        }
                    }
                    var _u_ = k$0 + 1 | 0;
                    if (dim3 === k$0) break;
                    k$0 = _u_;
                }
            }
            return arr;
        }
        var _k_ = dim1 - 1 | 0, _j_ = 0;
        if (_k_ >= 0) {
            var i = _j_;
            for(;;){
                var _m_ = dim2 - 1 | 0, _l_ = 0;
                if (_m_ >= 0) {
                    var j = _l_;
                    for(;;){
                        var _p_ = dim3 - 1 | 0, _o_ = 0;
                        if (_p_ >= 0) {
                            var k = _o_;
                            for(;;){
                                caml_ba_set_3(arr, i, j, k, caml_call3(f, i, j, k));
                                var _r_ = k + 1 | 0;
                                if (_p_ === k) break;
                                k = _r_;
                            }
                        }
                        var _q_ = j + 1 | 0;
                        if (_m_ === j) break;
                        j = _q_;
                    }
                }
                var _n_ = i + 1 | 0;
                if (_k_ === i) break;
                i = _n_;
            }
        }
        return arr;
    }
    function of_array$1(kind, layout, data) {
        var dim1 = data.length - 1, dim2 = 0 === dim1 ? 0 : caml_check_bound(data, 0)[1].length - 1, dim3 = 0 === dim2 ? 0 : caml_check_bound(caml_check_bound(data, 0)[1], 0)[1].length - 1, ba = create$2(kind, layout, dim1, dim2, dim3), ofs = layout ? 1 : 0, _b_ = dim1 - 1 | 0, _a_ = 0;
        if (_b_ >= 0) {
            var i = _a_;
            for(;;){
                var row = caml_check_bound(data, i)[1 + i];
                if (row.length - 1 !== dim2) caml_call1(Stdlib[1], cst_Bigarray_Array3_of_array_n);
                var _d_ = dim2 - 1 | 0, _c_ = 0;
                if (_d_ >= 0) {
                    var j = _c_;
                    for(;;){
                        var col = caml_check_bound(row, j)[1 + j];
                        if (col.length - 1 !== dim3) caml_call1(Stdlib[1], cst_Bigarray_Array3_of_array_n$0);
                        var _g_ = dim3 - 1 | 0, _f_ = 0;
                        if (_g_ >= 0) {
                            var k = _f_;
                            for(;;){
                                caml_ba_set_3(ba, i + ofs | 0, j + ofs | 0, k + ofs | 0, caml_check_bound(col, k)[1 + k]);
                                var _i_ = k + 1 | 0;
                                if (_g_ === k) break;
                                k = _i_;
                            }
                        }
                        var _h_ = j + 1 | 0;
                        if (_d_ === j) break;
                        j = _h_;
                    }
                }
                var _e_ = i + 1 | 0;
                if (_b_ === i) break;
                i = _e_;
            }
        }
        return ba;
    }
    function array0_of_genarray(a) {
        return 0 === caml_ba_num_dims(a) ? a : caml_call1(Stdlib[1], cst_Bigarray_array0_of_genarra);
    }
    function array1_of_genarray(a) {
        return 1 === caml_ba_num_dims(a) ? a : caml_call1(Stdlib[1], cst_Bigarray_array1_of_genarra);
    }
    function array2_of_genarray(a) {
        return 2 === caml_ba_num_dims(a) ? a : caml_call1(Stdlib[1], cst_Bigarray_array2_of_genarra);
    }
    function array3_of_genarray(a) {
        return 3 === caml_ba_num_dims(a) ? a : caml_call1(Stdlib[1], cst_Bigarray_array3_of_genarra);
    }
    function reshape_0(a) {
        return caml_ba_reshape(a, [
            0
        ]);
    }
    function reshape_1(a, dim1) {
        return caml_ba_reshape(a, [
            0,
            dim1
        ]);
    }
    function reshape_2(a, dim1, dim2) {
        return caml_ba_reshape(a, [
            0,
            dim1,
            dim2
        ]);
    }
    function reshape_3(a, dim1, dim2, dim3) {
        return caml_ba_reshape(a, [
            0,
            dim1,
            dim2,
            dim3
        ]);
    }
    var Stdlib_Bigarray = [
        0,
        13,
        0,
        1,
        10,
        11,
        2,
        3,
        4,
        5,
        8,
        6,
        7,
        9,
        12,
        kind_size_in_bytes,
        0,
        1,
        [
            0,
            init,
            dims,
            size_in_bytes
        ],
        [
            0,
            create,
            of_value,
            caml_ba_change_layout,
            size_in_bytes$0,
            get,
            set,
            of_value
        ],
        [
            0,
            create$0,
            init$0,
            caml_ba_change_layout,
            size_in_bytes$1,
            slice,
            of_array
        ],
        [
            0,
            create$1,
            init$1,
            caml_ba_change_layout,
            size_in_bytes$2,
            slice_left,
            slice_right,
            of_array$0
        ],
        [
            0,
            create$2,
            init$2,
            caml_ba_change_layout,
            size_in_bytes$3,
            slice_left_1,
            slice_right_1,
            slice_left_2,
            slice_right_2,
            of_array$1
        ],
        array0_of_genarray,
        array1_of_genarray,
        array2_of_genarray,
        array3_of_genarray,
        caml_ba_reshape,
        reshape_0,
        reshape_1,
        reshape_2,
        reshape_3
    ];
    runtime.caml_register_global(10, Stdlib_Bigarray, "Stdlib__Bigarray");
    return;
})(globalThis);
//# 19681 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_ba_blit = runtime.caml_ba_blit, caml_ba_set_1 = runtime.caml_ba_set_1, caml_bytes_set = runtime.caml_bytes_set, caml_create_bytes = runtime.caml_create_bytes, caml_greaterthan = runtime.caml_greaterthan, caml_int64_add = runtime.caml_int64_add, caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_shift_right_unsigne = runtime.caml_int64_shift_right_unsigned, caml_int64_sub = runtime.caml_int64_sub, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_lxm_next = runtime.caml_lxm_next, caml_mod = runtime.caml_mod, caml_notequal = runtime.caml_notequal, caml_sys_random_seed = runtime.caml_sys_random_seed;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), serialization_prefix = "lxm1:", Stdlib_Domain = global_data.Stdlib__Domain, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Int32 = global_data.Stdlib__Int32, Stdlib_Int64 = global_data.Stdlib__Int64, Stdlib = global_data.Stdlib, Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib_Digest = global_data.Stdlib__Digest, Stdlib_String = global_data.Stdlib__String, Stdlib_Bigarray = global_data.Stdlib__Bigarray, Stdlib_Nativeint = global_data.Stdlib__Nativeint, _a_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _b_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _c_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _d_ = runtime.caml_int64_create_lo_mi_hi(2, 0, 0), _e_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0);
    function create(param) {
        return caml_call3(Stdlib_Bigarray[20][1], 7, 0, 4);
    }
    function set(s, i1, i2, i3, i4) {
        caml_ba_set_1(s, 0, runtime.caml_int64_or(i1, _a_));
        caml_ba_set_1(s, 1, i2);
        var i3$0 = caml_notequal(i3, _b_) ? i3 : _e_;
        caml_ba_set_1(s, 2, i3$0);
        var i4$0 = caml_notequal(i4, _c_) ? i4 : _d_;
        return caml_ba_set_1(s, 3, i4$0);
    }
    function mk(i1, i2, i3, i4) {
        var s = create(0);
        set(s, i1, i2, i3, i4);
        return s;
    }
    var serialization_prefix_len = 5, cst_Random_State_of_binary_str = "Random.State.of_binary_string: expected a format compatible with OCaml ";
    function to_binary_string(s) {
        var buf = caml_create_bytes(37);
        caml_call5(Stdlib_Bytes[12], serialization_prefix, 0, buf, 0, serialization_prefix_len);
        var i = 0;
        for(;;){
            var _y_ = runtime.caml_ba_get_1(s, i);
            caml_call3(Stdlib_Bytes[86], buf, 5 + (i * 8 | 0) | 0, _y_);
            var _z_ = i + 1 | 0;
            if (3 === i) return caml_call1(Stdlib_Bytes[44], buf);
            i = _z_;
        }
    }
    function of_binary_string(buf) {
        var _v_ = runtime.caml_ml_string_length(buf) !== 37 ? 1 : 0, _w_ = _v_ || 1 - caml_call2(Stdlib_String[11], serialization_prefix, buf);
        if (_w_) {
            var _x_ = caml_call2(Stdlib[28], cst_Random_State_of_binary_str, Stdlib_Sys[46]);
            caml_call1(Stdlib[2], _x_);
        }
        var i1 = caml_call2(Stdlib_String[64], buf, 5), i2 = caml_call2(Stdlib_String[64], buf, 13), i3 = caml_call2(Stdlib_String[64], buf, 21), i4 = caml_call2(Stdlib_String[64], buf, 29);
        return mk(i1, i2, i3, i4);
    }
    function copy(src) {
        var dst = create(0);
        caml_ba_blit(src, dst);
        return dst;
    }
    function reinit(s, seed) {
        var n = seed.length - 1, b = caml_create_bytes((n * 8 | 0) + 1 | 0), _p_ = n - 1 | 0, _o_ = 0;
        if (_p_ >= 0) {
            var i = _o_;
            for(;;){
                var _t_ = caml_int64_of_int32(runtime.caml_check_bound(seed, i)[1 + i]);
                caml_call3(Stdlib_Bytes[86], b, i * 8 | 0, _t_);
                var _u_ = i + 1 | 0;
                if (_p_ === i) break;
                i = _u_;
            }
        }
        caml_bytes_set(b, n * 8 | 0, 1);
        var d1 = caml_call1(Stdlib_Digest[4], b);
        caml_bytes_set(b, n * 8 | 0, 2);
        var d2 = caml_call1(Stdlib_Digest[4], b), _q_ = caml_call2(Stdlib_String[64], d2, 8), _r_ = caml_call2(Stdlib_String[64], d2, 0), _s_ = caml_call2(Stdlib_String[64], d1, 8);
        return set(s, caml_call2(Stdlib_String[64], d1, 0), _s_, _r_, _q_);
    }
    function make(seed) {
        var s = create(0);
        reinit(s, seed);
        return s;
    }
    function make_self_init(param) {
        return make(caml_sys_random_seed(0));
    }
    var max_int31 = 1073741823, max_int32 = 2147483647, cst_Random_int = "Random.int", cst_Random_full_int = "Random.full_int", cst_Random_int_in_range = "Random.int_in_range", cst_Random_int32 = "Random.int32", cst_Random_int32_in_range = "Random.int32_in_range";
    function bits(s) {
        return caml_int64_to_int32(caml_lxm_next(s)) & 1073741823;
    }
    function int_aux(s, n, mask) {
        for(;;){
            var r = caml_int64_to_int32(caml_lxm_next(s)) & mask, v = caml_mod(r, n);
            if (((mask - n | 0) + 1 | 0) >= (r - v | 0)) return v;
        }
    }
    function int$0(s, bound) {
        if (1073741823 >= bound && 0 < bound) return int_aux(s, bound, max_int31);
        return caml_call1(Stdlib[1], cst_Random_int);
    }
    function full_int(s, bound) {
        if (0 >= bound) return caml_call1(Stdlib[1], cst_Random_full_int);
        var _n_ = bound <= 1073741823 ? max_int31 : bound <= 2147483647 ? max_int32 : Stdlib[19];
        return int_aux(s, bound, _n_);
    }
    function int_in_range_aux(s, min, max, mask, nbits) {
        var span = (max - min | 0) + 1 | 0;
        if (span <= mask && 0 < span) return min + int_aux(s, span, mask) | 0;
        for(;;){
            var drop = Stdlib_Sys[10] - nbits | 0, r = caml_int64_to_int32(caml_lxm_next(s)) << drop >> drop;
            if (r >= min && max >= r) return r;
        }
    }
    function int_in_range(s, min, max) {
        if (max < min) caml_call1(Stdlib[1], cst_Random_int_in_range);
        if (-1073741824 <= min && max <= 1073741823) return int_in_range_aux(s, min, max, max_int31, 31);
        if (-2147483648 <= min && max <= 2147483647) return int_in_range_aux(s, min, max, max_int32, 32);
        return int_in_range_aux(s, min, max, Stdlib[19], Stdlib_Sys[10]);
    }
    function bits32(s) {
        return caml_int64_to_int32(caml_lxm_next(s));
    }
    function int32aux(s, n) {
        for(;;){
            var r = bits32(s) >>> 1 | 0, v = caml_mod(r, n);
            if (!caml_greaterthan(r - v | 0, (Stdlib_Int32[9] - n | 0) + 1 | 0)) return v;
        }
    }
    function int32(s, bound) {
        return caml_lessequal(bound, 0) ? caml_call1(Stdlib[1], cst_Random_int32) : int32aux(s, bound);
    }
    function int32_in_range(s, min, max) {
        if (caml_greaterthan(min, max)) return caml_call1(Stdlib[1], cst_Random_int32_in_range);
        var span = caml_call1(Stdlib_Int32[6], max - min | 0);
        if (!caml_lessequal(span, Stdlib_Int32[1])) return min + int32aux(s, span) | 0;
        for(;;){
            var r = caml_int64_to_int32(caml_lxm_next(s));
            if (!caml_lessthan(r, min) && !caml_greaterthan(r, max)) return r;
        }
    }
    var bits64 = caml_lxm_next, _f_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _g_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), cst_Random_int64 = "Random.int64", cst_Random_int64_in_range = "Random.int64_in_range";
    function int64aux(s, n) {
        for(;;){
            var r = caml_int64_shift_right_unsigne(caml_lxm_next(s), 1), v = runtime.caml_int64_mod(r, n);
            if (!caml_greaterthan(caml_int64_sub(r, v), caml_int64_add(caml_int64_sub(Stdlib_Int64[9], n), _f_))) return v;
        }
    }
    function int64(s, bound) {
        return caml_lessequal(bound, _g_) ? caml_call1(Stdlib[1], cst_Random_int64) : int64aux(s, bound);
    }
    function int64_in_range(s, min, max) {
        if (caml_greaterthan(min, max)) return caml_call1(Stdlib[1], cst_Random_int64_in_range);
        var span = caml_call1(Stdlib_Int64[6], caml_int64_sub(max, min));
        if (!caml_lessequal(span, Stdlib_Int64[1])) return caml_int64_add(min, int64aux(s, span));
        for(;;){
            var r = caml_lxm_next(s);
            if (!caml_lessthan(r, min) && !caml_greaterthan(r, max)) return r;
        }
    }
    var _j_ = runtime.caml_int64_create_lo_mi_hi(14371852, 15349651, 22696), _k_ = runtime.caml_int64_create_lo_mi_hi(12230193, 11438743, 35013), _l_ = runtime.caml_int64_create_lo_mi_hi(1424933, 15549263, 2083), _m_ = runtime.caml_int64_create_lo_mi_hi(9492471, 4696708, 43520), _h_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _i_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), nativebits = 32 === Stdlib_Nativeint[9] ? function(s) {
        return bits32(s);
    } : function(s) {
        return caml_int64_to_int32(caml_lxm_next(s));
    }, nativeint = 32 === Stdlib_Nativeint[9] ? function(s, bound) {
        return int32(s, bound);
    } : function(s, bound) {
        return caml_int64_to_int32(int64(s, caml_int64_of_int32(bound)));
    }, nativeint_in_range = 32 === Stdlib_Nativeint[9] ? function(s, min, max) {
        return int32_in_range(s, min, max);
    } : function(s, min, max) {
        return caml_int64_to_int32(int64_in_range(s, caml_int64_of_int32(min), caml_int64_of_int32(max)));
    };
    function float$0(s, bound) {
        for(;;){
            var b = caml_lxm_next(s), n = caml_int64_shift_right_unsigne(b, 11);
            if (caml_notequal(n, _h_)) return runtime.caml_int64_to_float(n) * 1.1102230246251565e-16 * bound;
        }
    }
    function bool(s) {
        return caml_lessthan(caml_lxm_next(s), _i_);
    }
    function split(s) {
        var i1 = caml_lxm_next(s), i2 = caml_lxm_next(s), i3 = caml_lxm_next(s), i4 = caml_lxm_next(s);
        return mk(i1, i2, i3, i4);
    }
    function mk_default(param) {
        return mk(_m_, _l_, _k_, _j_);
    }
    var random_key = caml_call2(Stdlib_Domain[10][1], [
        0,
        split
    ], mk_default);
    function bits$0(param) {
        return bits(caml_call1(Stdlib_Domain[10][2], random_key));
    }
    function int$1(bound) {
        return int$0(caml_call1(Stdlib_Domain[10][2], random_key), bound);
    }
    function full_int$0(bound) {
        return full_int(caml_call1(Stdlib_Domain[10][2], random_key), bound);
    }
    function int_in_range$0(min, max) {
        return int_in_range(caml_call1(Stdlib_Domain[10][2], random_key), min, max);
    }
    function int32$0(bound) {
        return int32(caml_call1(Stdlib_Domain[10][2], random_key), bound);
    }
    function int32_in_range$0(min, max) {
        return int32_in_range(caml_call1(Stdlib_Domain[10][2], random_key), min, max);
    }
    function nativeint$0(bound) {
        return nativeint(caml_call1(Stdlib_Domain[10][2], random_key), bound);
    }
    function nativeint_in_range$0(min, max) {
        return nativeint_in_range(caml_call1(Stdlib_Domain[10][2], random_key), min, max);
    }
    function int64$0(bound) {
        return int64(caml_call1(Stdlib_Domain[10][2], random_key), bound);
    }
    function int64_in_range$0(min, max) {
        return int64_in_range(caml_call1(Stdlib_Domain[10][2], random_key), min, max);
    }
    function float$1(scale) {
        return float$0(caml_call1(Stdlib_Domain[10][2], random_key), scale);
    }
    function bool$0(param) {
        return bool(caml_call1(Stdlib_Domain[10][2], random_key));
    }
    function bits32$0(param) {
        return bits32(caml_call1(Stdlib_Domain[10][2], random_key));
    }
    function bits64$0(param) {
        var s = caml_call1(Stdlib_Domain[10][2], random_key);
        return caml_lxm_next(s);
    }
    function nativebits$0(param) {
        return nativebits(caml_call1(Stdlib_Domain[10][2], random_key));
    }
    function full_init(seed) {
        return reinit(caml_call1(Stdlib_Domain[10][2], random_key), seed);
    }
    function init(seed) {
        return full_init([
            0,
            seed
        ]);
    }
    function self_init(param) {
        return full_init(caml_sys_random_seed(0));
    }
    function split$0(param) {
        return split(caml_call1(Stdlib_Domain[10][2], random_key));
    }
    function get_state(param) {
        return copy(caml_call1(Stdlib_Domain[10][2], random_key));
    }
    function set_state(src) {
        var dst = caml_call1(Stdlib_Domain[10][2], random_key);
        return caml_ba_blit(src, dst);
    }
    var Stdlib_Random = [
        0,
        init,
        full_init,
        self_init,
        bits$0,
        int$1,
        full_int$0,
        int_in_range$0,
        int32$0,
        int32_in_range$0,
        nativeint$0,
        nativeint_in_range$0,
        int64$0,
        int64_in_range$0,
        float$1,
        bool$0,
        bits32$0,
        bits64$0,
        nativebits$0,
        [
            0,
            make,
            make_self_init,
            copy,
            bits,
            int$0,
            full_int,
            int_in_range,
            int32,
            int32_in_range,
            nativeint,
            nativeint_in_range,
            int64,
            int64_in_range,
            float$0,
            bool,
            bits32,
            bits64,
            nativebits,
            split,
            to_binary_string,
            of_binary_string
        ],
        get_state,
        set_state,
        split$0
    ];
    runtime.caml_register_global(35, Stdlib_Random, "Stdlib__Random");
    return;
})(globalThis);
//# 20096 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_check_bound = runtime.caml_check_bound, caml_compare = runtime.caml_compare, caml_hash = runtime.caml_hash, caml_make_vect = runtime.caml_make_vect, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_sys_getenv = runtime.caml_sys_getenv, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), _d_ = [
        0,
        0
    ], cst = "", Stdlib_Sys = global_data.Stdlib__Sys, Stdlib = global_data.Stdlib, Stdlib_Atomic = global_data.Stdlib__Atomic, Stdlib_Domain = global_data.Stdlib__Domain, Stdlib_Random = global_data.Stdlib__Random, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Array = global_data.Stdlib__Array;
    global_data.Assert_failure;
    var Stdlib_String = global_data.Stdlib__String;
    function ongoing_traversal(h) {
        var _an_ = h.length - 1 < 4 ? 1 : 0, _ao_ = _an_ || (h[4] < 0 ? 1 : 0);
        return _ao_;
    }
    function flip_ongoing_traversal(h) {
        h[4] = -h[4] | 0;
        return 0;
    }
    var cst_Hashtbl_unsupported_hash_t = "Hashtbl: unsupported hash table format";
    try {
        var _f_ = caml_sys_getenv("OCAMLRUNPARAM"), params = _f_;
    } catch (_al_) {
        var _a_ = caml_wrap_exception(_al_);
        if (_a_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_a_, 0);
        try {
            var _e_ = caml_sys_getenv("CAMLRUNPARAM"), _c_ = _e_;
        } catch (_am_) {
            var _b_ = caml_wrap_exception(_am_);
            if (_b_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_b_, 0);
            var _c_ = cst;
        }
        var params = _c_;
    }
    var randomized_default = caml_call2(Stdlib_String[15], params, 82), randomized = caml_call1(Stdlib_Atomic[1], randomized_default);
    function randomize(param) {
        return caml_call2(Stdlib_Atomic[4], randomized, 1);
    }
    function is_randomized(param) {
        return caml_call1(Stdlib_Atomic[3], randomized);
    }
    var prng_key = caml_call2(Stdlib_Domain[10][1], 0, Stdlib_Random[19][2]);
    function power_2_above(x, n) {
        var x$0 = x;
        for(;;){
            if (n <= x$0) return x$0;
            if (Stdlib_Sys[13] < (x$0 * 2 | 0)) return x$0;
            var x$1 = x$0 * 2 | 0;
            x$0 = x$1;
        }
    }
    function create(opt, initial_size) {
        var random = opt ? opt[1] : caml_call1(Stdlib_Atomic[3], randomized), s = power_2_above(16, initial_size);
        if (random) var _ak_ = caml_call1(Stdlib_Domain[10][2], prng_key), seed = caml_call1(Stdlib_Random[19][4], _ak_);
        else var seed = 0;
        return [
            0,
            0,
            caml_make_vect(s, 0),
            seed,
            s
        ];
    }
    function clear(h) {
        var _aj_ = 0 < h[1] ? 1 : 0;
        return _aj_ ? (h[1] = 0, caml_call4(Stdlib_Array[8], h[2], 0, h[2].length - 1, 0)) : _aj_;
    }
    function reset(h) {
        var len = h[2].length - 1;
        if (4 <= h.length - 1 && len !== caml_call1(Stdlib[18], h[4])) {
            h[1] = 0;
            h[2] = caml_make_vect(caml_call1(Stdlib[18], h[4]), 0);
            return 0;
        }
        return clear(h);
    }
    function copy_bucketlist(param) {
        if (!param) return 0;
        var key = param[1], data = param[2], next = param[3], prec$1 = [
            0,
            key,
            data,
            next
        ], prec = prec$1, param$0 = next;
        for(;;){
            if (!param$0) return prec$1;
            var key$0 = param$0[1], data$0 = param$0[2], next$0 = param$0[3], prec$0 = [
                0,
                key$0,
                data$0,
                next$0
            ];
            prec[3] = prec$0;
            prec = prec$0;
            param$0 = next$0;
        }
    }
    function copy(h) {
        var _ag_ = h[4], _ah_ = h[3], _ai_ = caml_call2(Stdlib_Array[14], copy_bucketlist, h[2]);
        return [
            0,
            h[1],
            _ai_,
            _ah_,
            _ag_
        ];
    }
    function length(h) {
        return h[1];
    }
    function insert_all_buckets(indexfun, inplace, odata, ndata) {
        var nsize = ndata.length - 1, ndata_tail = caml_make_vect(nsize, 0), _aa_ = odata.length - 2 | 0, _$_ = 0;
        if (_aa_ >= 0) {
            var i$0 = _$_;
            for(;;){
                var cell$1 = caml_check_bound(odata, i$0)[1 + i$0], cell = cell$1;
                for(;;){
                    if (!cell) break;
                    var key = cell[1], data = cell[2], next = cell[3], cell$0 = inplace ? cell : [
                        0,
                        key,
                        data,
                        0
                    ], nidx = caml_call1(indexfun, key), match = caml_check_bound(ndata_tail, nidx)[1 + nidx];
                    if (match) match[3] = cell$0;
                    else caml_check_bound(ndata, nidx)[1 + nidx] = cell$0;
                    caml_check_bound(ndata_tail, nidx)[1 + nidx] = cell$0;
                    cell = next;
                }
                var _af_ = i$0 + 1 | 0;
                if (_aa_ === i$0) break;
                i$0 = _af_;
            }
        }
        if (inplace) {
            var _ac_ = nsize - 1 | 0, _ab_ = 0;
            if (_ac_ >= 0) {
                var i = _ab_;
                for(;;){
                    var match$0 = caml_check_bound(ndata_tail, i)[1 + i];
                    if (match$0) match$0[3] = 0;
                    var _ae_ = i + 1 | 0;
                    if (_ac_ === i) break;
                    i = _ae_;
                }
            }
            var _ad_ = 0;
        } else var _ad_ = inplace;
        return _ad_;
    }
    function resize(indexfun, h) {
        var odata = h[2], osize = odata.length - 1, nsize = osize * 2 | 0, ___ = nsize < Stdlib_Sys[13] ? 1 : 0;
        if (!___) return ___;
        var ndata = caml_make_vect(nsize, 0), inplace = 1 - ongoing_traversal(h);
        h[2] = ndata;
        return insert_all_buckets(caml_call1(indexfun, h), inplace, odata, ndata);
    }
    function iter(f, h) {
        var old_trav = ongoing_traversal(h);
        if (1 - old_trav) flip_ongoing_traversal(h);
        try {
            var d = h[2], _W_ = d.length - 2 | 0, _V_ = 0;
            if (_W_ >= 0) {
                var i = _V_;
                for(;;){
                    var param = caml_check_bound(d, i)[1 + i];
                    for(;;){
                        if (!param) break;
                        var key = param[1], data = param[2], next = param[3];
                        caml_call2(f, key, data);
                        param = next;
                    }
                    var _Z_ = i + 1 | 0;
                    if (_W_ === i) break;
                    i = _Z_;
                }
            }
            var _X_ = 1 - old_trav, _Y_ = _X_ ? flip_ongoing_traversal(h) : _X_;
            return _Y_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (old_trav) throw caml_maybe_attach_backtrace(exn, 0);
            flip_ongoing_traversal(h);
            throw caml_maybe_attach_backtrace(exn, 0);
        }
    }
    function filter_map_inplace(f, h) {
        var d = h[2], old_trav = ongoing_traversal(h);
        if (1 - old_trav) flip_ongoing_traversal(h);
        try {
            var _R_ = d.length - 2 | 0, _Q_ = 0;
            if (_R_ >= 0) {
                var i = _Q_;
                for(;;){
                    var slot$0 = caml_check_bound(h[2], i)[1 + i], prec = 0, slot = slot$0;
                    for(;;){
                        if (!slot) break;
                        var key = slot[1], data = slot[2], next = slot[3], match = caml_call2(f, key, data);
                        if (match) {
                            var data$0 = match[1];
                            if (prec) prec[3] = slot;
                            else caml_check_bound(h[2], i)[1 + i] = slot;
                            slot[2] = data$0;
                            prec = slot;
                            slot = next;
                        } else {
                            h[1] = h[1] - 1 | 0;
                            slot = next;
                        }
                    }
                    if (prec) prec[3] = 0;
                    else caml_check_bound(h[2], i)[1 + i] = 0;
                    var _U_ = i + 1 | 0;
                    if (_R_ === i) break;
                    i = _U_;
                }
            }
            var _S_ = 1 - old_trav, _T_1 = _S_ ? flip_ongoing_traversal(h) : _S_;
            return _T_1;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (old_trav) throw caml_maybe_attach_backtrace(exn, 0);
            flip_ongoing_traversal(h);
            throw caml_maybe_attach_backtrace(exn, 0);
        }
    }
    function fold(f, h, init) {
        var old_trav = ongoing_traversal(h);
        if (1 - old_trav) flip_ongoing_traversal(h);
        try {
            var d = h[2], accu$1 = [
                0,
                init
            ], _N_ = d.length - 2 | 0, _M_ = 0;
            if (_N_ >= 0) {
                var i = _M_;
                for(;;){
                    var accu$2 = accu$1[1], b$0 = caml_check_bound(d, i)[1 + i], b = b$0, accu = accu$2;
                    for(;;){
                        if (!b) break;
                        var key = b[1], data = b[2], next = b[3], accu$0 = caml_call3(f, key, data, accu);
                        b = next;
                        accu = accu$0;
                    }
                    accu$1[1] = accu;
                    var _P_ = i + 1 | 0;
                    if (_N_ === i) break;
                    i = _P_;
                }
            }
            if (1 - old_trav) flip_ongoing_traversal(h);
            var _O_ = accu$1[1];
            return _O_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (old_trav) throw caml_maybe_attach_backtrace(exn, 0);
            flip_ongoing_traversal(h);
            throw caml_maybe_attach_backtrace(exn, 0);
        }
    }
    function bucket_length(accu, param) {
        var accu$0 = accu, param$0 = param;
        for(;;){
            if (!param$0) return accu$0;
            var next = param$0[3], accu$1 = accu$0 + 1 | 0;
            accu$0 = accu$1;
            param$0 = next;
        }
    }
    function stats(h) {
        var mbl = caml_call3(Stdlib_Array[18], function(m, b) {
            var _L_ = bucket_length(0, b);
            return caml_call2(Stdlib_Int[11], m, _L_);
        }, 0, h[2]), histo = caml_make_vect(mbl + 1 | 0, 0);
        caml_call2(Stdlib_Array[12], function(b) {
            var l = bucket_length(0, b);
            histo[1 + l] = caml_check_bound(histo, l)[1 + l] + 1 | 0;
            return 0;
        }, h[2]);
        return [
            0,
            h[1],
            h[2].length - 1,
            mbl,
            histo
        ];
    }
    function to_seq(tbl) {
        var tbl_data = tbl[2];
        function aux(i, buck, param) {
            var i$0 = i, buck$0 = buck;
            for(;;){
                if (buck$0) {
                    var key = buck$0[1], data = buck$0[2], next = buck$0[3];
                    return [
                        0,
                        [
                            0,
                            key,
                            data
                        ],
                        function(_K_) {
                            return aux(i$0, next, _K_);
                        }
                    ];
                }
                if (i$0 === tbl_data.length - 1) return 0;
                var buck$1 = caml_check_bound(tbl_data, i$0)[1 + i$0], i$1 = i$0 + 1 | 0;
                i$0 = i$1;
                buck$0 = buck$1;
            }
        }
        var _H_ = 0, _I_ = 0;
        return function(_J_) {
            return aux(_I_, _H_, _J_);
        };
    }
    function to_seq_keys(m) {
        var _F_ = to_seq(m);
        return caml_call2(Stdlib_Seq[29], function(_G_) {
            return _G_[1];
        }, _F_);
    }
    function to_seq_values(m) {
        var _D_ = to_seq(m);
        return caml_call2(Stdlib_Seq[29], function(_E_) {
            return _E_[2];
        }, _D_);
    }
    function MakeSeeded(H) {
        function key_index(h, key) {
            var _C_ = h[2].length - 2 | 0;
            return caml_call2(H[2], h[3], key) & _C_;
        }
        function add(h, key, data) {
            var i = key_index(h, key), bucket = [
                0,
                key,
                data,
                caml_check_bound(h[2], i)[1 + i]
            ];
            caml_check_bound(h[2], i)[1 + i] = bucket;
            h[1] = h[1] + 1 | 0;
            var _B_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
            return _B_ ? resize(key_index, h) : _B_;
        }
        function remove(h, key) {
            var i = key_index(h, key), c = caml_check_bound(h[2], i)[1 + i], prec$0 = 0, prec = c;
            for(;;){
                if (!prec) return 0;
                var k = prec[1], next = prec[3];
                if (caml_call2(H[1], k, key)) {
                    h[1] = h[1] - 1 | 0;
                    return prec$0 ? (prec$0[3] = next, 0) : (caml_check_bound(h[2], i)[1 + i] = next, 0);
                }
                prec$0 = prec;
                prec = next;
            }
        }
        function find(h, key) {
            var _A_ = key_index(h, key), match = caml_check_bound(h[2], _A_)[1 + _A_];
            if (!match) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var k1 = match[1], d1 = match[2], next1 = match[3];
            if (caml_call2(H[1], key, k1)) return d1;
            if (!next1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var k2 = next1[1], d2 = next1[2], next2 = next1[3];
            if (caml_call2(H[1], key, k2)) return d2;
            if (!next2) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var k3 = next2[1], d3 = next2[2], next3 = next2[3];
            if (caml_call2(H[1], key, k3)) return d3;
            var param = next3;
            for(;;){
                if (!param) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                var k = param[1], data = param[2], next = param[3];
                if (caml_call2(H[1], key, k)) return data;
                param = next;
            }
        }
        function find_opt(h, key) {
            var _z_ = key_index(h, key), match = caml_check_bound(h[2], _z_)[1 + _z_];
            if (!match) return 0;
            var k1 = match[1], d1 = match[2], next1 = match[3];
            if (caml_call2(H[1], key, k1)) return [
                0,
                d1
            ];
            if (!next1) return 0;
            var k2 = next1[1], d2 = next1[2], next2 = next1[3];
            if (caml_call2(H[1], key, k2)) return [
                0,
                d2
            ];
            if (!next2) return 0;
            var k3 = next2[1], d3 = next2[2], next3 = next2[3];
            if (caml_call2(H[1], key, k3)) return [
                0,
                d3
            ];
            var param = next3;
            for(;;){
                if (!param) return 0;
                var k = param[1], data = param[2], next = param[3];
                if (caml_call2(H[1], key, k)) return [
                    0,
                    data
                ];
                param = next;
            }
        }
        function find_all(h, key) {
            var _y_ = key_index(h, key), param = caml_check_bound(h[2], _y_)[1 + _y_];
            for(;;){
                if (!param) return 0;
                var k = param[1], d = param[2], next = param[3];
                if (caml_call2(H[1], k, key)) break;
                param = next;
            }
            var block = [
                0,
                d,
                24029
            ], dst = block, offset = 1, param$0 = next;
            for(;;){
                if (!param$0) {
                    dst[1 + offset] = 0;
                    return block;
                }
                var k$0 = param$0[1], d$0 = param$0[2], next$0 = param$0[3];
                if (caml_call2(H[1], k$0, key)) {
                    var dst$0 = [
                        0,
                        d$0,
                        24029
                    ];
                    dst[1 + offset] = dst$0;
                    dst = dst$0;
                    offset = 1;
                    param$0 = next$0;
                } else param$0 = next$0;
            }
        }
        function replace(h, key, data) {
            var i = key_index(h, key), l = caml_check_bound(h[2], i)[1 + i], slot = l;
            for(;;){
                if (slot) {
                    var k = slot[1], next = slot[3];
                    if (!caml_call2(H[1], k, key)) {
                        slot = next;
                        continue;
                    }
                    slot[1] = key;
                    slot[2] = data;
                    var _v_ = 0;
                } else var _v_ = 1;
                if (_v_) {
                    caml_check_bound(h[2], i)[1 + i] = [
                        0,
                        key,
                        data,
                        l
                    ];
                    h[1] = h[1] + 1 | 0;
                    var _w_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
                    if (_w_) return resize(key_index, h);
                    var _x_ = _w_;
                } else var _x_ = _v_;
                return _x_;
            }
        }
        function mem(h, key) {
            var _u_ = key_index(h, key), param = caml_check_bound(h[2], _u_)[1 + _u_];
            for(;;){
                if (!param) return 0;
                var k = param[1], next = param[3], _t_ = caml_call2(H[1], k, key);
                if (_t_) return _t_;
                param = next;
            }
        }
        function add_seq(tbl, i) {
            return caml_call2(Stdlib_Seq[4], function(param) {
                var v = param[2], k = param[1];
                return add(tbl, k, v);
            }, i);
        }
        function replace_seq(tbl, i) {
            return caml_call2(Stdlib_Seq[4], function(param) {
                var v = param[2], k = param[1];
                return replace(tbl, k, v);
            }, i);
        }
        function of_seq(i) {
            var tbl = create(0, 16);
            replace_seq(tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            iter,
            filter_map_inplace,
            fold,
            length,
            stats,
            to_seq,
            to_seq_keys,
            to_seq_values,
            add_seq,
            replace_seq,
            of_seq
        ];
    }
    function Make(H) {
        var equal = H[1];
        function seeded_hash(seed, x) {
            return caml_call1(H[2], x);
        }
        var include = MakeSeeded([
            0,
            equal,
            seeded_hash
        ]), _s_ = include[1], clear = include[2], reset = include[3], copy = include[4], add = include[5], remove = include[6], find = include[7], find_opt = include[8], find_all = include[9], replace = include[10], mem = include[11], iter = include[12], filter_map_inplace = include[13], fold = include[14], length = include[15], stats = include[16], to_seq = include[17], to_seq_keys = include[18], to_seq_values = include[19], add_seq = include[20], replace_seq = include[21];
        function create(sz) {
            return caml_call2(_s_, _d_, sz);
        }
        function of_seq(i) {
            var tbl = caml_call2(_s_, _d_, 16);
            caml_call2(replace_seq, tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            iter,
            filter_map_inplace,
            fold,
            length,
            stats,
            to_seq,
            to_seq_keys,
            to_seq_values,
            add_seq,
            replace_seq,
            of_seq
        ];
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    function hash_param(n1, n2, x) {
        return caml_hash(n1, n2, 0, x);
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function key_index(h, key) {
        return 4 <= h.length - 1 ? caml_hash(10, 100, h[3], key) & (h[2].length - 2 | 0) : caml_call1(Stdlib[1], cst_Hashtbl_unsupported_hash_t);
    }
    function add(h, key, data) {
        var i = key_index(h, key), bucket = [
            0,
            key,
            data,
            caml_check_bound(h[2], i)[1 + i]
        ];
        caml_check_bound(h[2], i)[1 + i] = bucket;
        h[1] = h[1] + 1 | 0;
        var _r_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
        return _r_ ? resize(key_index, h) : _r_;
    }
    function remove(h, key) {
        var i = key_index(h, key), c = caml_check_bound(h[2], i)[1 + i], prec$0 = 0, prec = c;
        for(;;){
            if (!prec) return 0;
            var k = prec[1], next = prec[3];
            if (0 === caml_compare(k, key)) {
                h[1] = h[1] - 1 | 0;
                return prec$0 ? (prec$0[3] = next, 0) : (caml_check_bound(h[2], i)[1 + i] = next, 0);
            }
            prec$0 = prec;
            prec = next;
        }
    }
    function find(h, key) {
        var _q_ = key_index(h, key), match = caml_check_bound(h[2], _q_)[1 + _q_];
        if (!match) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
        var k1 = match[1], d1 = match[2], next1 = match[3];
        if (0 === caml_compare(key, k1)) return d1;
        if (!next1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
        var k2 = next1[1], d2 = next1[2], next2 = next1[3];
        if (0 === caml_compare(key, k2)) return d2;
        if (!next2) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
        var k3 = next2[1], d3 = next2[2], next3 = next2[3];
        if (0 === caml_compare(key, k3)) return d3;
        var param = next3;
        for(;;){
            if (!param) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var k = param[1], data = param[2], next = param[3];
            if (0 === caml_compare(key, k)) return data;
            param = next;
        }
    }
    function find_opt(h, key) {
        var _p_ = key_index(h, key), match = caml_check_bound(h[2], _p_)[1 + _p_];
        if (!match) return 0;
        var k1 = match[1], d1 = match[2], next1 = match[3];
        if (0 === caml_compare(key, k1)) return [
            0,
            d1
        ];
        if (!next1) return 0;
        var k2 = next1[1], d2 = next1[2], next2 = next1[3];
        if (0 === caml_compare(key, k2)) return [
            0,
            d2
        ];
        if (!next2) return 0;
        var k3 = next2[1], d3 = next2[2], next3 = next2[3];
        if (0 === caml_compare(key, k3)) return [
            0,
            d3
        ];
        var param = next3;
        for(;;){
            if (!param) return 0;
            var k = param[1], data = param[2], next = param[3];
            if (0 === caml_compare(key, k)) return [
                0,
                data
            ];
            param = next;
        }
    }
    function find_all(h, key) {
        var _o_ = key_index(h, key), param = caml_check_bound(h[2], _o_)[1 + _o_];
        for(;;){
            if (!param) return 0;
            var k = param[1], data = param[2], next = param[3];
            if (0 === caml_compare(k, key)) break;
            param = next;
        }
        var block = [
            0,
            data,
            24029
        ], dst = block, offset = 1, param$0 = next;
        for(;;){
            if (!param$0) {
                dst[1 + offset] = 0;
                return block;
            }
            var k$0 = param$0[1], data$0 = param$0[2], next$0 = param$0[3];
            if (0 === caml_compare(k$0, key)) {
                var dst$0 = [
                    0,
                    data$0,
                    24029
                ];
                dst[1 + offset] = dst$0;
                dst = dst$0;
                offset = 1;
                param$0 = next$0;
            } else param$0 = next$0;
        }
    }
    function replace(h, key, data) {
        var i = key_index(h, key), l = caml_check_bound(h[2], i)[1 + i], slot = l;
        for(;;){
            if (slot) {
                var k = slot[1], next = slot[3];
                if (0 !== caml_compare(k, key)) {
                    slot = next;
                    continue;
                }
                slot[1] = key;
                slot[2] = data;
                var _l_ = 0;
            } else var _l_ = 1;
            if (_l_) {
                caml_check_bound(h[2], i)[1 + i] = [
                    0,
                    key,
                    data,
                    l
                ];
                h[1] = h[1] + 1 | 0;
                var _m_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
                if (_m_) return resize(key_index, h);
                var _n_ = _m_;
            } else var _n_ = _l_;
            return _n_;
        }
    }
    function mem(h, key) {
        var _k_ = key_index(h, key), param = caml_check_bound(h[2], _k_)[1 + _k_];
        for(;;){
            if (!param) return 0;
            var k = param[1], next = param[3], _j_ = 0 === caml_compare(k, key) ? 1 : 0;
            if (_j_) return _j_;
            param = next;
        }
    }
    function add_seq(tbl, i) {
        return caml_call2(Stdlib_Seq[4], function(param) {
            var v = param[2], k = param[1];
            return add(tbl, k, v);
        }, i);
    }
    function replace_seq(tbl, i) {
        return caml_call2(Stdlib_Seq[4], function(param) {
            var v = param[2], k = param[1];
            return replace(tbl, k, v);
        }, i);
    }
    function of_seq(i) {
        var tbl = create(0, 16);
        replace_seq(tbl, i);
        return tbl;
    }
    function rebuild(opt, h) {
        var random = opt ? opt[1] : caml_call1(Stdlib_Atomic[3], randomized), s = power_2_above(16, h[2].length - 1);
        if (random) var _g_ = caml_call1(Stdlib_Domain[10][2], prng_key), seed = caml_call1(Stdlib_Random[19][4], _g_);
        else var seed = 4 <= h.length - 1 ? h[3] : 0;
        var _h_ = 4 <= h.length - 1 ? h[4] : s, h$0 = [
            0,
            h[1],
            caml_make_vect(s, 0),
            seed,
            _h_
        ];
        insert_all_buckets(function(_i_) {
            return key_index(h$0, _i_);
        }, 0, h[2], h$0[2]);
        return h$0;
    }
    var Stdlib_Hashtbl = [
        0,
        create,
        clear,
        reset,
        copy,
        add,
        find,
        find_opt,
        find_all,
        mem,
        remove,
        replace,
        iter,
        filter_map_inplace,
        fold,
        length,
        randomize,
        is_randomized,
        rebuild,
        stats,
        to_seq,
        to_seq_keys,
        to_seq_values,
        add_seq,
        replace_seq,
        of_seq,
        Make,
        MakeSeeded,
        hash,
        seeded_hash,
        hash_param,
        caml_hash
    ];
    runtime.caml_register_global(16, Stdlib_Hashtbl, "Stdlib__Hashtbl");
    return;
})(globalThis);
//# 21397 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$16 = "", cst$15 = ">", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), cst$14 = ".", cst$11 = cst$15, cst$12 = "<\/", cst$13 = cst$16, cst$8 = cst$15, cst$9 = "<", cst$10 = cst$16, cst$7 = "\n", cst$3 = cst$16, cst$4 = cst$16, cst$5 = cst$16, cst$6 = cst$16, cst = cst$16, cst$0 = cst$16, cst$1 = cst$16, cst$2 = cst$16, _a_ = [
        0,
        cst$16,
        0,
        cst$16
    ], Stdlib_Queue = global_data.Stdlib__Queue, CamlinternalFormat = global_data.CamlinternalFormat, Stdlib = global_data.Stdlib, Stdlib_String = global_data.Stdlib__String, Stdlib_Domain = global_data.Stdlib__Domain, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_Array = global_data.Stdlib__Array, Stdlib_List = global_data.Stdlib__List, Stdlib_Stack = global_data.Stdlib__Stack, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Bytes = global_data.Stdlib__Bytes;
    function id(x) {
        return x;
    }
    var zero = 0, unknown = -1, String_tag = [
        248,
        "Stdlib.Format.String_tag",
        runtime.caml_fresh_oo_id(0)
    ];
    function pp_enqueue(state, token) {
        state[13] = state[13] + token[3] | 0;
        return caml_call2(Stdlib_Queue[3], token, state[28]);
    }
    var pp_infinity = 1000000010, _b_ = [
        0,
        cst$16
    ], _c_ = [
        1,
        "margin <= max_indent"
    ], _d_ = [
        1,
        "margin >= pp_infinity"
    ], _e_ = [
        0,
        0
    ], _f_ = [
        1,
        "max_indent < 2"
    ], cst_Format_pp_set_geometry = "Format.pp_set_geometry: ";
    function pp_output_string(state, s) {
        return caml_call3(state[17], s, 0, caml_ml_string_length(s));
    }
    function pp_output_newline(state) {
        return caml_call1(state[19], 0);
    }
    function format_pp_text(state, size, text) {
        state[9] = state[9] - size | 0;
        pp_output_string(state, text);
        state[11] = 0;
        return;
    }
    function format_string(state, s) {
        var _a__ = s !== cst$16 ? 1 : 0;
        return _a__ ? format_pp_text(state, caml_ml_string_length(s), s) : _a__;
    }
    function break_new_line(state, param, width) {
        var after = param[3], offset = param[2], before = param[1];
        format_string(state, before);
        pp_output_newline(state);
        state[11] = 1;
        var indent = (state[6] - width | 0) + offset | 0, real_indent = caml_call2(Stdlib_Int[10], state[8], indent);
        state[10] = real_indent;
        state[9] = state[6] - state[10] | 0;
        var n = state[10];
        caml_call1(state[21], n);
        return format_string(state, after);
    }
    function break_same_line(state, param) {
        var after = param[3], width = param[2], before = param[1];
        format_string(state, before);
        state[9] = state[9] - width | 0;
        caml_call1(state[20], width);
        return format_string(state, after);
    }
    function format_pp_token(state, size$0, param) {
        if (typeof param === "number") switch(param){
            case 0:
                var match$3 = caml_call1(Stdlib_Stack[8], state[3]);
                if (!match$3) return;
                var tabs = match$3[1][1], add_tab = function(n, ls) {
                    if (!ls) return [
                        0,
                        n,
                        0
                    ];
                    var l = ls[2], x = ls[1];
                    return runtime.caml_lessthan(n, x) ? [
                        0,
                        n,
                        ls
                    ] : [
                        0,
                        x,
                        add_tab(n, l)
                    ];
                };
                tabs[1] = add_tab(state[6] - state[9] | 0, tabs[1]);
                return;
            case 1:
                caml_call1(Stdlib_Stack[5], state[2]);
                return;
            case 2:
                caml_call1(Stdlib_Stack[5], state[3]);
                return;
            case 3:
                var match$4 = caml_call1(Stdlib_Stack[8], state[2]);
                if (!match$4) return pp_output_newline(state);
                var width$0 = match$4[1][2];
                return break_new_line(state, _a_, width$0);
            case 4:
                var _a8_ = state[10] !== (state[6] - state[9] | 0) ? 1 : 0;
                if (!_a8_) return _a8_;
                var match$1 = caml_call1(Stdlib_Queue[6], state[28]);
                if (!match$1) return;
                var match$2 = match$1[1], size = match$2[1], length = match$2[3];
                state[12] = state[12] - length | 0;
                state[9] = state[9] + size | 0;
                return;
            default:
                var match$5 = caml_call1(Stdlib_Stack[5], state[5]);
                if (!match$5) return;
                var tag_name = match$5[1], marker = caml_call1(state[25], tag_name);
                return pp_output_string(state, marker);
        }
        switch(param[0]){
            case 0:
                var s = param[1];
                return format_pp_text(state, size$0, s);
            case 1:
                var breaks = param[2], fits = param[1], off = breaks[2], before = breaks[1], match$6 = caml_call1(Stdlib_Stack[8], state[2]);
                if (!match$6) return;
                var match$7 = match$6[1], width$1 = match$7[2], box_type$0 = match$7[1];
                switch(box_type$0){
                    case 0:
                        return break_same_line(state, fits);
                    case 1:
                        return break_new_line(state, breaks, width$1);
                    case 2:
                        return break_new_line(state, breaks, width$1);
                    case 3:
                        return state[9] < (size$0 + caml_ml_string_length(before) | 0) ? break_new_line(state, breaks, width$1) : break_same_line(state, fits);
                    case 4:
                        return state[11] ? break_same_line(state, fits) : state[9] < (size$0 + caml_ml_string_length(before) | 0) ? break_new_line(state, breaks, width$1) : ((state[6] - width$1 | 0) + off | 0) < state[10] ? break_new_line(state, breaks, width$1) : break_same_line(state, fits);
                    default:
                        return break_same_line(state, fits);
                }
            case 2:
                var off$0 = param[2], n = param[1], insertion_point = state[6] - state[9] | 0, match$8 = caml_call1(Stdlib_Stack[8], state[3]);
                if (!match$8) return;
                var tabs$0 = match$8[1][1], match$9 = tabs$0[1];
                if (match$9) {
                    var first = match$9[1], param$0 = tabs$0[1];
                    for(;;){
                        if (param$0) {
                            var tail = param$0[2], head = param$0[1];
                            if (insertion_point > head) {
                                param$0 = tail;
                                continue;
                            }
                            var _a9_ = head;
                        } else var _a9_ = first;
                        var tab = _a9_;
                        break;
                    }
                } else var tab = insertion_point;
                var offset = tab - insertion_point | 0;
                return 0 <= offset ? break_same_line(state, [
                    0,
                    cst$0,
                    offset + n | 0,
                    cst
                ]) : break_new_line(state, [
                    0,
                    cst$2,
                    tab + off$0 | 0,
                    cst$1
                ], state[6]);
            case 3:
                var ty = param[2], off$1 = param[1], insertion_point$0 = state[6] - state[9] | 0;
                if (state[8] < insertion_point$0) {
                    var match = caml_call1(Stdlib_Stack[8], state[2]);
                    if (match) {
                        var match$0 = match[1], width = match$0[2], box_type = match$0[1];
                        if (state[9] < width && 3 >= box_type - 1 >>> 0) break_new_line(state, _a_, width);
                    } else pp_output_newline(state);
                }
                var width$2 = state[9] - off$1 | 0, box_type$1 = 1 === ty ? 1 : state[9] < size$0 ? ty : 5;
                return caml_call2(Stdlib_Stack[3], [
                    0,
                    box_type$1,
                    width$2
                ], state[2]);
            case 4:
                var tbox = param[1];
                return caml_call2(Stdlib_Stack[3], tbox, state[3]);
            default:
                var tag_name$0 = param[1], marker$0 = caml_call1(state[24], tag_name$0);
                pp_output_string(state, marker$0);
                return caml_call2(Stdlib_Stack[3], tag_name$0, state[5]);
        }
    }
    function advance_left(state) {
        for(;;){
            var match = caml_call1(Stdlib_Queue[9], state[28]);
            if (!match) return 0;
            var match$0 = match[1], size = match$0[1], length = match$0[3], token = match$0[2], pending_count = state[13] - state[12] | 0, _a6_ = 0 <= size ? 1 : 0, _a7_ = _a6_ || (state[9] <= pending_count ? 1 : 0);
            if (!_a7_) return _a7_;
            caml_call1(Stdlib_Queue[5], state[28]);
            var size$0 = 0 <= size ? size : pp_infinity;
            format_pp_token(state, size$0, token);
            state[12] = length + state[12] | 0;
        }
    }
    function enqueue_advance(state, tok) {
        pp_enqueue(state, tok);
        return advance_left(state);
    }
    function enqueue_string_as(state, size, s) {
        return enqueue_advance(state, [
            0,
            size,
            [
                0,
                s
            ],
            size
        ]);
    }
    function initialize_scan_stack(stack) {
        caml_call1(Stdlib_Stack[9], stack);
        var queue_elem = [
            0,
            unknown,
            _b_,
            0
        ];
        return caml_call2(Stdlib_Stack[3], [
            0,
            -1,
            queue_elem
        ], stack);
    }
    function set_size(state, ty) {
        var match = caml_call1(Stdlib_Stack[8], state[1]);
        if (!match) return;
        var match$0 = match[1], queue_elem = match$0[2], left_total = match$0[1], size = queue_elem[1];
        if (left_total < state[12]) return initialize_scan_stack(state[1]);
        var _a5_ = queue_elem[2];
        if (typeof _a5_ !== "number") switch(_a5_[0]){
            case 3:
                if (1 - ty) {
                    var x$0 = state[13] + size | 0;
                    queue_elem[1] = x$0;
                    caml_call1(Stdlib_Stack[5], state[1]);
                }
                return;
            case 1:
            case 2:
                if (ty) {
                    var x = state[13] + size | 0;
                    queue_elem[1] = x;
                    caml_call1(Stdlib_Stack[5], state[1]);
                }
                return;
        }
        return;
    }
    function scan_push(state, b, token) {
        pp_enqueue(state, token);
        if (b) set_size(state, 1);
        var elem = [
            0,
            state[13],
            token
        ];
        return caml_call2(Stdlib_Stack[3], elem, state[1]);
    }
    function pp_open_box_gen(state, indent, br_ty) {
        state[14] = state[14] + 1 | 0;
        if (state[14] < state[15]) {
            var size = -state[13] | 0, elem = [
                0,
                size,
                [
                    3,
                    indent,
                    br_ty
                ],
                0
            ];
            return scan_push(state, 0, elem);
        }
        var _a4_ = state[14] === state[15] ? 1 : 0;
        if (!_a4_) return _a4_;
        var s = state[16], x = caml_ml_string_length(s);
        return enqueue_string_as(state, x, s);
    }
    function pp_close_box(state, param) {
        var _a2_ = 1 < state[14] ? 1 : 0;
        if (_a2_) {
            if (state[14] < state[15]) {
                pp_enqueue(state, [
                    0,
                    zero,
                    1,
                    0
                ]);
                set_size(state, 1);
                set_size(state, 0);
            }
            state[14] = state[14] - 1 | 0;
            var _a3_ = 0;
        } else var _a3_ = _a2_;
        return _a3_;
    }
    function pp_open_stag(state, tag_name) {
        if (state[22]) {
            caml_call2(Stdlib_Stack[3], tag_name, state[4]);
            caml_call1(state[26], tag_name);
        }
        var _a1_ = state[23];
        if (!_a1_) return _a1_;
        var token = [
            5,
            tag_name
        ];
        return pp_enqueue(state, [
            0,
            zero,
            token,
            0
        ]);
    }
    function pp_close_stag(state, param) {
        if (state[23]) pp_enqueue(state, [
            0,
            zero,
            5,
            0
        ]);
        var _aZ_ = state[22];
        if (_aZ_) {
            var match = caml_call1(Stdlib_Stack[5], state[4]);
            if (match) {
                var tag_name = match[1];
                return caml_call1(state[27], tag_name);
            }
            var _a0_ = 0;
        } else var _a0_ = _aZ_;
        return _a0_;
    }
    function pp_set_print_tags(state, b) {
        state[22] = b;
        return 0;
    }
    function pp_set_mark_tags(state, b) {
        state[23] = b;
        return 0;
    }
    function pp_get_print_tags(state, param) {
        return state[22];
    }
    function pp_get_mark_tags(state, param) {
        return state[23];
    }
    function pp_set_tags(state, b) {
        pp_set_print_tags(state, b);
        return pp_set_mark_tags(state, b);
    }
    function pp_get_formatter_stag_function(state, param) {
        return [
            0,
            state[24],
            state[25],
            state[26],
            state[27]
        ];
    }
    function pp_set_formatter_stag_function(state, param) {
        var pct = param[4], pot = param[3], mct = param[2], mot = param[1];
        state[24] = mot;
        state[25] = mct;
        state[26] = pot;
        state[27] = pct;
        return 0;
    }
    function pp_rinit(state) {
        state[12] = 1;
        state[13] = 1;
        caml_call1(Stdlib_Queue[11], state[28]);
        initialize_scan_stack(state[1]);
        caml_call1(Stdlib_Stack[9], state[2]);
        caml_call1(Stdlib_Stack[9], state[3]);
        caml_call1(Stdlib_Stack[9], state[4]);
        caml_call1(Stdlib_Stack[9], state[5]);
        state[10] = 0;
        state[14] = 0;
        state[9] = state[6];
        return pp_open_box_gen(state, 0, 3);
    }
    function pp_flush_queue(state, end_with_newline) {
        caml_call2(Stdlib_Stack[13], function(param) {
            return pp_close_stag(state, 0);
        }, state[4]);
        for(;;){
            if (1 >= state[14]) {
                state[13] = pp_infinity;
                advance_left(state);
                if (end_with_newline) pp_output_newline(state);
                return pp_rinit(state);
            }
            pp_close_box(state, 0);
        }
    }
    function pp_print_as_size(state, size, s) {
        var _aY_ = state[14] < state[15] ? 1 : 0;
        return _aY_ ? enqueue_string_as(state, size, s) : _aY_;
    }
    function pp_print_as(state, isize, s) {
        return pp_print_as_size(state, isize, s);
    }
    function pp_print_string(state, s) {
        var isize = caml_ml_string_length(s);
        return pp_print_as_size(state, isize, s);
    }
    function pp_print_bytes(state, s) {
        var s$0 = caml_call1(Stdlib_Bytes[6], s), isize = runtime.caml_ml_bytes_length(s);
        return pp_print_as_size(state, isize, s$0);
    }
    function pp_print_int(state, i) {
        return pp_print_string(state, caml_call1(Stdlib_Int[12], i));
    }
    function pp_print_float(state, f) {
        return pp_print_string(state, caml_call1(Stdlib[35], f));
    }
    function pp_print_bool(state, b) {
        return pp_print_string(state, caml_call1(Stdlib[30], b));
    }
    function pp_print_char(state, c) {
        var s = caml_call2(Stdlib_String[1], 1, c);
        return pp_print_as_size(state, 1, s);
    }
    function pp_print_nothing(state, param) {
        return 0;
    }
    function pp_open_hbox(state, param) {
        return pp_open_box_gen(state, 0, 0);
    }
    function pp_open_vbox(state, indent) {
        return pp_open_box_gen(state, indent, 1);
    }
    function pp_open_hvbox(state, indent) {
        return pp_open_box_gen(state, indent, 2);
    }
    function pp_open_hovbox(state, indent) {
        return pp_open_box_gen(state, indent, 3);
    }
    function pp_open_box(state, indent) {
        return pp_open_box_gen(state, indent, 4);
    }
    function pp_print_newline(state, param) {
        pp_flush_queue(state, 1);
        return caml_call1(state[18], 0);
    }
    function pp_print_flush(state, param) {
        pp_flush_queue(state, 0);
        return caml_call1(state[18], 0);
    }
    function pp_force_newline(state, param) {
        var _aX_ = state[14] < state[15] ? 1 : 0;
        return _aX_ ? enqueue_advance(state, [
            0,
            zero,
            3,
            0
        ]) : _aX_;
    }
    function pp_print_if_newline(state, param) {
        var _aW_ = state[14] < state[15] ? 1 : 0;
        return _aW_ ? enqueue_advance(state, [
            0,
            zero,
            4,
            0
        ]) : _aW_;
    }
    function pp_print_custom_break(state, fits, breaks) {
        var after = fits[3], width = fits[2], before = fits[1], _aV_ = state[14] < state[15] ? 1 : 0;
        if (!_aV_) return _aV_;
        var size = -state[13] | 0, token = [
            1,
            fits,
            breaks
        ], length = (caml_ml_string_length(before) + width | 0) + caml_ml_string_length(after) | 0, elem = [
            0,
            size,
            token,
            length
        ];
        return scan_push(state, 1, elem);
    }
    function pp_print_break(state, width, offset) {
        return pp_print_custom_break(state, [
            0,
            cst$6,
            width,
            cst$5
        ], [
            0,
            cst$4,
            offset,
            cst$3
        ]);
    }
    function pp_print_space(state, param) {
        return pp_print_break(state, 1, 0);
    }
    function pp_print_cut(state, param) {
        return pp_print_break(state, 0, 0);
    }
    function pp_open_tbox(state, param) {
        state[14] = state[14] + 1 | 0;
        var _aU_ = state[14] < state[15] ? 1 : 0;
        if (!_aU_) return _aU_;
        var elem = [
            0,
            zero,
            [
                4,
                [
                    0,
                    [
                        0,
                        0
                    ]
                ]
            ],
            0
        ];
        return enqueue_advance(state, elem);
    }
    function pp_close_tbox(state, param) {
        var _aR_ = 1 < state[14] ? 1 : 0;
        if (_aR_) {
            var _aS_ = state[14] < state[15] ? 1 : 0;
            if (_aS_) {
                var elem = [
                    0,
                    zero,
                    2,
                    0
                ];
                enqueue_advance(state, elem);
                state[14] = state[14] - 1 | 0;
                var _aT_ = 0;
            } else var _aT_ = _aS_;
        } else var _aT_ = _aR_;
        return _aT_;
    }
    function pp_print_tbreak(state, width, offset) {
        var _aQ_ = state[14] < state[15] ? 1 : 0;
        if (!_aQ_) return _aQ_;
        var size = -state[13] | 0, elem = [
            0,
            size,
            [
                2,
                width,
                offset
            ],
            width
        ];
        return scan_push(state, 1, elem);
    }
    function pp_print_tab(state, param) {
        return pp_print_tbreak(state, 0, 0);
    }
    function pp_set_tab(state, param) {
        var _aP_ = state[14] < state[15] ? 1 : 0;
        if (!_aP_) return _aP_;
        var elem = [
            0,
            zero,
            0,
            0
        ];
        return enqueue_advance(state, elem);
    }
    function pp_set_max_boxes(state, n) {
        var _aN_ = 1 < n ? 1 : 0, _aO_ = _aN_ ? (state[15] = n, 0) : _aN_;
        return _aO_;
    }
    function pp_get_max_boxes(state, param) {
        return state[15];
    }
    function pp_over_max_boxes(state, param) {
        return state[14] === state[15] ? 1 : 0;
    }
    function pp_set_ellipsis_text(state, s) {
        state[16] = s;
        return 0;
    }
    function pp_get_ellipsis_text(state, param) {
        return state[16];
    }
    function pp_limit(n) {
        return n < 1000000010 ? n : 1000000009;
    }
    function pp_set_max_indent(state, n$0) {
        var _aM_ = 1 < n$0 ? 1 : 0;
        if (!_aM_) return _aM_;
        var n$1 = state[6] - n$0 | 0, _aL_ = 1 <= n$1 ? 1 : 0;
        if (!_aL_) return _aL_;
        var n = pp_limit(n$1);
        state[7] = n;
        state[8] = state[6] - state[7] | 0;
        return pp_rinit(state);
    }
    function pp_get_max_indent(state, param) {
        return state[8];
    }
    function pp_set_margin(state, n) {
        var _aJ_ = 1 <= n ? 1 : 0;
        if (!_aJ_) return _aJ_;
        var n$0 = pp_limit(n);
        state[6] = n$0;
        if (state[8] <= state[6]) var new_max_indent = state[8];
        else var _aK_ = caml_call2(Stdlib_Int[11], state[6] - state[7] | 0, state[6] / 2 | 0), new_max_indent = caml_call2(Stdlib_Int[11], _aK_, 1);
        return pp_set_max_indent(state, new_max_indent);
    }
    function validate_geometry(param) {
        var margin = param[2], max_indent = param[1];
        return 2 <= max_indent ? margin <= max_indent ? _c_ : 1000000010 <= margin ? _d_ : _e_ : _f_;
    }
    function check_geometry(geometry) {
        return 0 === validate_geometry(geometry)[0] ? 1 : 0;
    }
    function pp_get_margin(state, param) {
        return state[6];
    }
    function pp_set_full_geometry(state, param) {
        var margin = param[2], max_indent = param[1];
        pp_set_margin(state, margin);
        pp_set_max_indent(state, max_indent);
        return 0;
    }
    function pp_set_geometry(state, max_indent, margin) {
        var geometry = [
            0,
            max_indent,
            margin
        ], match = validate_geometry(geometry);
        if (0 === match[0]) return pp_set_full_geometry(state, geometry);
        var msg = match[1], _aI_ = caml_call2(Stdlib[28], cst_Format_pp_set_geometry, msg);
        throw caml_maybe_attach_backtrace([
            0,
            Stdlib[6],
            _aI_
        ], 1);
    }
    function pp_safe_set_geometry(state, max_indent, margin) {
        var geometry = [
            0,
            max_indent,
            margin
        ];
        return 0 === validate_geometry(geometry)[0] ? pp_set_full_geometry(state, geometry) : 0;
    }
    function pp_get_geometry(state, param) {
        return [
            0,
            state[8],
            state[6]
        ];
    }
    function pp_update_geometry(state, update) {
        var geometry = pp_get_geometry(state, 0);
        return pp_set_full_geometry(state, caml_call1(update, geometry));
    }
    function pp_set_formatter_out_functions(state, param) {
        var j = param[5], i = param[4], h = param[3], g = param[2], f = param[1];
        state[17] = f;
        state[18] = g;
        state[19] = h;
        state[20] = i;
        state[21] = j;
        return 0;
    }
    function pp_get_formatter_out_functions(state, param) {
        return [
            0,
            state[17],
            state[18],
            state[19],
            state[20],
            state[21]
        ];
    }
    function pp_set_formatter_output_functi(state, f, g) {
        state[17] = f;
        state[18] = g;
        return 0;
    }
    function pp_get_formatter_output_functi(state, param) {
        return [
            0,
            state[17],
            state[18]
        ];
    }
    function display_newline(state, param) {
        return caml_call3(state[17], cst$7, 0, 1);
    }
    var blank_line = caml_call2(Stdlib_String[1], 80, 32), _g_ = [
        3,
        0,
        3
    ];
    function display_blanks(state, n) {
        var n$0 = n;
        for(;;){
            var _aH_ = 0 < n$0 ? 1 : 0;
            if (!_aH_) return _aH_;
            if (80 >= n$0) return caml_call3(state[17], blank_line, 0, n$0);
            caml_call3(state[17], blank_line, 0, 80);
            var n$1 = n$0 - 80 | 0;
            n$0 = n$1;
        }
    }
    function pp_set_formatter_out_channel(state, oc) {
        state[17] = caml_call1(Stdlib[69], oc);
        state[18] = function(param) {
            return caml_call1(Stdlib[63], oc);
        };
        state[19] = function(_aG_) {
            return display_newline(state, _aG_);
        };
        state[20] = function(_aF_) {
            return display_blanks(state, _aF_);
        };
        state[21] = function(_aE_) {
            return display_blanks(state, _aE_);
        };
        return 0;
    }
    function default_pp_mark_open_tag(param) {
        if (param[1] !== String_tag) return cst$10;
        var s = param[2], _aD_ = caml_call2(Stdlib[28], s, cst$8);
        return caml_call2(Stdlib[28], cst$9, _aD_);
    }
    function default_pp_mark_close_tag(param) {
        if (param[1] !== String_tag) return cst$13;
        var s = param[2], _aC_ = caml_call2(Stdlib[28], s, cst$11);
        return caml_call2(Stdlib[28], cst$12, _aC_);
    }
    function default_pp_print_open_tag(_aB_) {
        return 0;
    }
    function default_pp_print_close_tag(_aA_) {
        return 0;
    }
    function pp_make_formatter(f, g, h, i, j) {
        var pp_queue = caml_call1(Stdlib_Queue[2], 0), sys_tok = [
            0,
            unknown,
            _g_,
            0
        ];
        caml_call2(Stdlib_Queue[3], sys_tok, pp_queue);
        var scan_stack = caml_call1(Stdlib_Stack[2], 0);
        initialize_scan_stack(scan_stack);
        caml_call2(Stdlib_Stack[3], [
            0,
            1,
            sys_tok
        ], scan_stack);
        var pp_margin = 78, _aw_ = Stdlib[19], _ax_ = caml_call1(Stdlib_Stack[2], 0), _ay_ = caml_call1(Stdlib_Stack[2], 0), _az_ = caml_call1(Stdlib_Stack[2], 0);
        return [
            0,
            scan_stack,
            caml_call1(Stdlib_Stack[2], 0),
            _az_,
            _ay_,
            _ax_,
            pp_margin,
            10,
            68,
            pp_margin,
            0,
            1,
            1,
            1,
            1,
            _aw_,
            cst$14,
            f,
            g,
            h,
            i,
            j,
            0,
            0,
            default_pp_mark_open_tag,
            default_pp_mark_close_tag,
            default_pp_print_open_tag,
            default_pp_print_close_tag,
            pp_queue
        ];
    }
    function formatter_of_out_functions(out_funs) {
        return pp_make_formatter(out_funs[1], out_funs[2], out_funs[3], out_funs[4], out_funs[5]);
    }
    function make_formatter(output, flush) {
        var ppf = pp_make_formatter(output, flush, function(_av_) {
            return 0;
        }, function(_au_) {
            return 0;
        }, function(_at_) {
            return 0;
        });
        ppf[19] = function(_as_) {
            return display_newline(ppf, _as_);
        };
        ppf[20] = function(_ar_) {
            return display_blanks(ppf, _ar_);
        };
        ppf[21] = function(_aq_) {
            return display_blanks(ppf, _aq_);
        };
        return ppf;
    }
    function formatter_of_out_channel(oc) {
        return make_formatter(caml_call1(Stdlib[69], oc), function(param) {
            return caml_call1(Stdlib[63], oc);
        });
    }
    function formatter_of_buffer(b) {
        return make_formatter(caml_call1(Stdlib_Buffer[18], b), function(_ap_) {
            return 0;
        });
    }
    var pp_buffer_size = 512;
    function pp_make_buffer(param) {
        return caml_call1(Stdlib_Buffer[1], pp_buffer_size);
    }
    var stdbuf = pp_make_buffer(0), std_formatter = formatter_of_out_channel(Stdlib[39]), err_formatter = formatter_of_out_channel(Stdlib[40]), str_formatter = formatter_of_buffer(stdbuf), stdbuf_key = caml_call2(Stdlib_Domain[10][1], 0, pp_make_buffer);
    caml_call2(Stdlib_Domain[10][3], stdbuf_key, stdbuf);
    var str_formatter_key = caml_call2(Stdlib_Domain[10][1], 0, function(param) {
        return formatter_of_buffer(caml_call1(Stdlib_Domain[10][2], stdbuf_key));
    });
    caml_call2(Stdlib_Domain[10][3], str_formatter_key, str_formatter);
    function buffered_out_string(key, str, ofs, len) {
        var _ao_ = caml_call1(Stdlib_Domain[10][2], key);
        return caml_call4(Stdlib_Buffer[18], _ao_, str, ofs, len);
    }
    function buffered_out_flush(oc, key, param) {
        var buf = caml_call1(Stdlib_Domain[10][2], key), len = caml_call1(Stdlib_Buffer[7], buf), str = caml_call1(Stdlib_Buffer[2], buf);
        caml_call4(Stdlib[69], oc, str, 0, len);
        caml_call1(Stdlib[63], oc);
        return caml_call1(Stdlib_Buffer[8], buf);
    }
    var std_buf_key = caml_call2(Stdlib_Domain[10][1], 0, function(param) {
        return caml_call1(Stdlib_Buffer[1], pp_buffer_size);
    }), err_buf_key = caml_call2(Stdlib_Domain[10][1], 0, function(param) {
        return caml_call1(Stdlib_Buffer[1], pp_buffer_size);
    }), std_formatter_key = caml_call2(Stdlib_Domain[10][1], 0, function(param) {
        var _ac_ = Stdlib[39], ppf = pp_make_formatter(function(_al_, _am_, _an_) {
            return buffered_out_string(std_buf_key, _al_, _am_, _an_);
        }, function(_ak_) {
            return buffered_out_flush(_ac_, std_buf_key, _ak_);
        }, function(_aj_) {
            return 0;
        }, function(_ai_) {
            return 0;
        }, function(_ah_) {
            return 0;
        });
        ppf[19] = function(_ag_) {
            return display_newline(ppf, _ag_);
        };
        ppf[20] = function(_af_) {
            return display_blanks(ppf, _af_);
        };
        ppf[21] = function(_ae_) {
            return display_blanks(ppf, _ae_);
        };
        caml_call1(Stdlib_Domain[6], function(_ad_) {
            return pp_print_flush(ppf, _ad_);
        });
        return ppf;
    });
    caml_call2(Stdlib_Domain[10][3], std_formatter_key, std_formatter);
    var err_formatter_key = caml_call2(Stdlib_Domain[10][1], 0, function(param) {
        var _S_ = Stdlib[40], ppf = pp_make_formatter(function(_$_, _aa_, _ab_) {
            return buffered_out_string(err_buf_key, _$_, _aa_, _ab_);
        }, function(___) {
            return buffered_out_flush(_S_, err_buf_key, ___);
        }, function(_Z_) {
            return 0;
        }, function(_Y_) {
            return 0;
        }, function(_X_) {
            return 0;
        });
        ppf[19] = function(_W_) {
            return display_newline(ppf, _W_);
        };
        ppf[20] = function(_V_) {
            return display_blanks(ppf, _V_);
        };
        ppf[21] = function(_U_) {
            return display_blanks(ppf, _U_);
        };
        caml_call1(Stdlib_Domain[6], function(_T_1) {
            return pp_print_flush(ppf, _T_1);
        });
        return ppf;
    });
    caml_call2(Stdlib_Domain[10][3], err_formatter_key, err_formatter);
    function get_std_formatter(param) {
        return caml_call1(Stdlib_Domain[10][2], std_formatter_key);
    }
    function get_err_formatter(param) {
        return caml_call1(Stdlib_Domain[10][2], err_formatter_key);
    }
    function get_str_formatter(param) {
        return caml_call1(Stdlib_Domain[10][2], str_formatter_key);
    }
    function get_stdbuf(param) {
        return caml_call1(Stdlib_Domain[10][2], stdbuf_key);
    }
    function flush_buffer_formatter(buf, ppf) {
        pp_flush_queue(ppf, 0);
        var s = caml_call1(Stdlib_Buffer[2], buf);
        caml_call1(Stdlib_Buffer[9], buf);
        return s;
    }
    function flush_str_formatter(param) {
        var stdbuf = caml_call1(Stdlib_Domain[10][2], stdbuf_key), str_formatter = caml_call1(Stdlib_Domain[10][2], str_formatter_key);
        return flush_buffer_formatter(stdbuf, str_formatter);
    }
    function make_synchronized_formatter(output, flush) {
        return caml_call2(Stdlib_Domain[10][1], 0, function(param) {
            var buf = caml_call1(Stdlib_Buffer[1], pp_buffer_size), output$0 = caml_call1(Stdlib_Buffer[18], buf);
            function flush$0(param) {
                var _R_ = caml_call1(Stdlib_Buffer[7], buf);
                caml_call3(output, caml_call1(Stdlib_Buffer[2], buf), 0, _R_);
                caml_call1(Stdlib_Buffer[8], buf);
                return caml_call1(flush, 0);
            }
            return make_formatter(output$0, flush$0);
        });
    }
    function synchronized_formatter_of_out_(oc) {
        return make_synchronized_formatter(caml_call1(Stdlib[69], oc), function(param) {
            return caml_call1(Stdlib[63], oc);
        });
    }
    function make_symbolic_output_buffer(param) {
        return [
            0,
            0
        ];
    }
    function clear_symbolic_output_buffer(sob) {
        sob[1] = 0;
        return 0;
    }
    function get_symbolic_output_buffer(sob) {
        return caml_call1(Stdlib_List[10], sob[1]);
    }
    function flush_symbolic_output_buffer(sob) {
        var items = get_symbolic_output_buffer(sob);
        clear_symbolic_output_buffer(sob);
        return items;
    }
    function add_symbolic_output_item(sob, item) {
        sob[1] = [
            0,
            item,
            sob[1]
        ];
        return 0;
    }
    function formatter_of_symbolic_output_b(sob) {
        function f(s, i, n) {
            return add_symbolic_output_item(sob, [
                0,
                caml_call3(Stdlib_String[16], s, i, n)
            ]);
        }
        function g(_Q_) {
            return add_symbolic_output_item(sob, 0);
        }
        function h(_P_) {
            return add_symbolic_output_item(sob, 1);
        }
        function i(n) {
            return add_symbolic_output_item(sob, [
                1,
                n
            ]);
        }
        function j(n) {
            return add_symbolic_output_item(sob, [
                2,
                n
            ]);
        }
        return pp_make_formatter(f, g, h, i, j);
    }
    function open_hbox(v) {
        return pp_open_hbox(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function open_vbox(v) {
        return pp_open_vbox(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function open_hvbox(v) {
        return pp_open_hvbox(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function open_hovbox(v) {
        return pp_open_hovbox(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function open_box(v) {
        return pp_open_box(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function close_box(v) {
        return pp_close_box(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function open_stag(v) {
        return pp_open_stag(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function close_stag(v) {
        return pp_close_stag(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_as(isize, w) {
        var state = caml_call1(Stdlib_Domain[10][2], std_formatter_key);
        return pp_print_as_size(state, isize, w);
    }
    function print_string(v) {
        return pp_print_string(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_bytes(v) {
        return pp_print_bytes(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_int(v) {
        return pp_print_int(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_float(v) {
        return pp_print_float(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_char(v) {
        return pp_print_char(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_bool(v) {
        return pp_print_bool(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_break(v, w) {
        return pp_print_break(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v, w);
    }
    function print_cut(v) {
        return pp_print_cut(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_space(v) {
        return pp_print_space(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function force_newline(v) {
        return pp_force_newline(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_flush(v) {
        return pp_print_flush(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_newline(v) {
        return pp_print_newline(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_if_newline(v) {
        return pp_print_if_newline(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function open_tbox(v) {
        return pp_open_tbox(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function close_tbox(v) {
        return pp_close_tbox(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_tbreak(v, w) {
        return pp_print_tbreak(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v, w);
    }
    function set_tab(v) {
        return pp_set_tab(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function print_tab(v) {
        return pp_print_tab(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function set_margin(v) {
        return pp_set_margin(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function get_margin(v) {
        var state = caml_call1(Stdlib_Domain[10][2], std_formatter_key);
        return state[6];
    }
    function set_max_indent(v) {
        return pp_set_max_indent(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function get_max_indent(v) {
        var state = caml_call1(Stdlib_Domain[10][2], std_formatter_key);
        return state[8];
    }
    function set_geometry(max_indent, margin) {
        return pp_set_geometry(caml_call1(Stdlib_Domain[10][2], std_formatter_key), max_indent, margin);
    }
    function safe_set_geometry(max_indent, margin) {
        return pp_safe_set_geometry(caml_call1(Stdlib_Domain[10][2], std_formatter_key), max_indent, margin);
    }
    function get_geometry(v) {
        return pp_get_geometry(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function update_geometry(v) {
        return pp_update_geometry(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function set_max_boxes(v) {
        return pp_set_max_boxes(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function get_max_boxes(v) {
        var state = caml_call1(Stdlib_Domain[10][2], std_formatter_key);
        return state[15];
    }
    function over_max_boxes(v) {
        return pp_over_max_boxes(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function set_ellipsis_text(v) {
        return pp_set_ellipsis_text(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function get_ellipsis_text(v) {
        var state = caml_call1(Stdlib_Domain[10][2], std_formatter_key);
        return state[16];
    }
    function set_formatter_out_channel(v) {
        return pp_set_formatter_out_channel(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function set_formatter_out_functions(v) {
        return pp_set_formatter_out_functions(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function get_formatter_out_functions(v) {
        return pp_get_formatter_out_functions(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function set_formatter_output_functions(v, w) {
        return pp_set_formatter_output_functi(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v, w);
    }
    function get_formatter_output_functions(v) {
        return pp_get_formatter_output_functi(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function set_formatter_stag_functions(v) {
        return pp_set_formatter_stag_function(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function get_formatter_stag_functions(v) {
        return pp_get_formatter_stag_function(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function set_print_tags(v) {
        return pp_set_print_tags(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function get_print_tags(v) {
        var state = caml_call1(Stdlib_Domain[10][2], std_formatter_key);
        return state[22];
    }
    function set_mark_tags(v) {
        return pp_set_mark_tags(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function get_mark_tags(v) {
        var state = caml_call1(Stdlib_Domain[10][2], std_formatter_key);
        return state[23];
    }
    function set_tags(v) {
        return pp_set_tags(caml_call1(Stdlib_Domain[10][2], std_formatter_key), v);
    }
    function pp_print_iter(opt, iter, pp_v, ppf, v) {
        var pp_sep = opt ? opt[1] : pp_print_cut, is_first = [
            0,
            1
        ];
        function pp_v$0(v) {
            if (is_first[1]) is_first[1] = 0;
            else caml_call2(pp_sep, ppf, 0);
            return caml_call2(pp_v, ppf, v);
        }
        return caml_call2(iter, pp_v$0, v);
    }
    function pp_print_list(opt, pp_v, ppf, v) {
        var pp_sep = opt ? opt[1] : pp_print_cut;
        return pp_print_iter([
            0,
            pp_sep
        ], Stdlib_List[18], pp_v, ppf, v);
    }
    function pp_print_array(opt, pp_v, ppf, v) {
        var pp_sep = opt ? opt[1] : pp_print_cut;
        return pp_print_iter([
            0,
            pp_sep
        ], Stdlib_Array[12], pp_v, ppf, v);
    }
    function pp_print_seq(opt, pp_v, ppf, seq) {
        var pp_sep = opt ? opt[1] : pp_print_cut;
        return pp_print_iter([
            0,
            pp_sep
        ], Stdlib_Seq[4], pp_v, ppf, seq);
    }
    function pp_print_text(ppf, s) {
        var len = caml_ml_string_length(s), left = [
            0,
            0
        ], right = [
            0,
            0
        ];
        function flush(param) {
            pp_print_string(ppf, caml_call3(Stdlib_String[16], s, left[1], right[1] - left[1] | 0));
            right[1]++;
            left[1] = right[1];
            return 0;
        }
        for(;;){
            if (right[1] === len) {
                var _O_ = left[1] !== len ? 1 : 0;
                return _O_ ? flush(0) : _O_;
            }
            var match = runtime.caml_string_get(s, right[1]);
            if (10 === match) {
                flush(0);
                pp_force_newline(ppf, 0);
            } else if (32 === match) {
                flush(0);
                pp_print_space(ppf, 0);
            } else right[1]++;
        }
    }
    function pp_print_option(opt, pp_v, ppf, param) {
        var none = opt ? opt[1] : function(_N_, param) {
            return 0;
        };
        if (!param) return caml_call2(none, ppf, 0);
        var v = param[1];
        return caml_call2(pp_v, ppf, v);
    }
    function pp_print_result(ok, error, ppf, param) {
        if (0 === param[0]) {
            var v = param[1];
            return caml_call2(ok, ppf, v);
        }
        var e = param[1];
        return caml_call2(error, ppf, e);
    }
    function pp_print_either(left, right, ppf, param) {
        if (0 === param[0]) {
            var l = param[1];
            return caml_call2(left, ppf, l);
        }
        var r = param[1];
        return caml_call2(right, ppf, r);
    }
    function compute_tag(output, tag_acc) {
        var buf = caml_call1(Stdlib_Buffer[1], 16), ppf = formatter_of_buffer(buf);
        caml_call2(output, ppf, tag_acc);
        pp_print_flush(ppf, 0);
        var len = caml_call1(Stdlib_Buffer[7], buf);
        return 2 <= len ? caml_call3(Stdlib_Buffer[4], buf, 1, len - 2 | 0) : caml_call1(Stdlib_Buffer[2], buf);
    }
    function output_formatting_lit(ppf, fmting_lit) {
        if (typeof fmting_lit === "number") switch(fmting_lit){
            case 0:
                return pp_close_box(ppf, 0);
            case 1:
                return pp_close_stag(ppf, 0);
            case 2:
                return pp_print_flush(ppf, 0);
            case 3:
                return pp_force_newline(ppf, 0);
            case 4:
                return pp_print_newline(ppf, 0);
            case 5:
                return pp_print_char(ppf, 64);
            default:
                return pp_print_char(ppf, 37);
        }
        switch(fmting_lit[0]){
            case 0:
                var offset = fmting_lit[3], width = fmting_lit[2];
                return pp_print_break(ppf, width, offset);
            case 1:
                return 0;
            default:
                var c = fmting_lit[1];
                pp_print_char(ppf, 64);
                return pp_print_char(ppf, c);
        }
    }
    function output_acc(ppf, acc) {
        if (typeof acc === "number") return 0;
        a: {
            b: {
                c: {
                    switch(acc[0]){
                        case 0:
                            var f = acc[2], p = acc[1];
                            output_acc(ppf, p);
                            return output_formatting_lit(ppf, f);
                        case 1:
                            var match = acc[2], p$0 = acc[1];
                            if (0 === match[0]) {
                                var acc$0 = match[1];
                                output_acc(ppf, p$0);
                                return pp_open_stag(ppf, [
                                    0,
                                    String_tag,
                                    compute_tag(output_acc, acc$0)
                                ]);
                            }
                            var acc$1 = match[1];
                            output_acc(ppf, p$0);
                            var _E_ = compute_tag(output_acc, acc$1), match$0 = caml_call1(CamlinternalFormat[20], _E_), bty = match$0[2], indent = match$0[1];
                            return pp_open_box_gen(ppf, indent, bty);
                        case 2:
                            var _F_ = acc[1];
                            if (typeof _F_ !== "number" && 0 === _F_[0]) {
                                var _G_ = _F_[2];
                                if (typeof _G_ !== "number" && 1 === _G_[0]) {
                                    var s$0 = acc[2], size = _G_[2], p$2 = _F_[1];
                                    break b;
                                }
                            }
                            var s = acc[2], p$1 = _F_;
                            break a;
                        case 3:
                            var _H_ = acc[1];
                            if (typeof _H_ !== "number" && 0 === _H_[0]) {
                                var _I_ = _H_[2];
                                if (typeof _I_ !== "number" && 1 === _I_[0]) {
                                    var c$0 = acc[2], size$0 = _I_[2], p$4 = _H_[1];
                                    break;
                                }
                            }
                            var c = acc[2], p$3 = _H_;
                            break c;
                        case 4:
                            var _J_ = acc[1];
                            if (typeof _J_ !== "number" && 0 === _J_[0]) {
                                var _K_ = _J_[2];
                                if (typeof _K_ !== "number" && 1 === _K_[0]) {
                                    var s$0 = acc[2], size = _K_[2], p$2 = _J_[1];
                                    break b;
                                }
                            }
                            var s = acc[2], p$1 = _J_;
                            break a;
                        case 5:
                            var _L_ = acc[1];
                            if (typeof _L_ !== "number" && 0 === _L_[0]) {
                                var _M_ = _L_[2];
                                if (typeof _M_ !== "number" && 1 === _M_[0]) {
                                    var c$0 = acc[2], size$0 = _M_[2], p$4 = _L_[1];
                                    break;
                                }
                            }
                            var c = acc[2], p$3 = _L_;
                            break c;
                        case 6:
                            var f$0 = acc[2], p$5 = acc[1];
                            output_acc(ppf, p$5);
                            return caml_call1(f$0, ppf);
                        case 7:
                            var p$6 = acc[1];
                            output_acc(ppf, p$6);
                            return pp_print_flush(ppf, 0);
                        default:
                            var msg = acc[2], p$7 = acc[1];
                            output_acc(ppf, p$7);
                            return caml_call1(Stdlib[1], msg);
                    }
                    output_acc(ppf, p$4);
                    return pp_print_as_size(ppf, size$0, caml_call2(Stdlib_String[1], 1, c$0));
                }
                output_acc(ppf, p$3);
                return pp_print_char(ppf, c);
            }
            output_acc(ppf, p$2);
            return pp_print_as_size(ppf, size, s$0);
        }
        output_acc(ppf, p$1);
        return pp_print_string(ppf, s);
    }
    function strput_acc(ppf, acc) {
        if (typeof acc === "number") return 0;
        a: {
            b: {
                c: {
                    switch(acc[0]){
                        case 0:
                            var f = acc[2], p = acc[1];
                            strput_acc(ppf, p);
                            return output_formatting_lit(ppf, f);
                        case 1:
                            var match = acc[2], p$0 = acc[1];
                            if (0 === match[0]) {
                                var acc$0 = match[1];
                                strput_acc(ppf, p$0);
                                return pp_open_stag(ppf, [
                                    0,
                                    String_tag,
                                    compute_tag(strput_acc, acc$0)
                                ]);
                            }
                            var acc$1 = match[1];
                            strput_acc(ppf, p$0);
                            var _v_ = compute_tag(strput_acc, acc$1), match$0 = caml_call1(CamlinternalFormat[20], _v_), bty = match$0[2], indent = match$0[1];
                            return pp_open_box_gen(ppf, indent, bty);
                        case 2:
                            var _w_ = acc[1];
                            if (typeof _w_ !== "number" && 0 === _w_[0]) {
                                var _x_ = _w_[2];
                                if (typeof _x_ !== "number" && 1 === _x_[0]) {
                                    var s$0 = acc[2], size = _x_[2], p$2 = _w_[1];
                                    break b;
                                }
                            }
                            var s = acc[2], p$1 = _w_;
                            break a;
                        case 3:
                            var _y_ = acc[1];
                            if (typeof _y_ !== "number" && 0 === _y_[0]) {
                                var _z_ = _y_[2];
                                if (typeof _z_ !== "number" && 1 === _z_[0]) {
                                    var c$0 = acc[2], size$0 = _z_[2], p$4 = _y_[1];
                                    break;
                                }
                            }
                            var c = acc[2], p$3 = _y_;
                            break c;
                        case 4:
                            var _A_ = acc[1];
                            if (typeof _A_ !== "number" && 0 === _A_[0]) {
                                var _B_ = _A_[2];
                                if (typeof _B_ !== "number" && 1 === _B_[0]) {
                                    var s$0 = acc[2], size = _B_[2], p$2 = _A_[1];
                                    break b;
                                }
                            }
                            var s = acc[2], p$1 = _A_;
                            break a;
                        case 5:
                            var _C_ = acc[1];
                            if (typeof _C_ !== "number" && 0 === _C_[0]) {
                                var _D_ = _C_[2];
                                if (typeof _D_ !== "number" && 1 === _D_[0]) {
                                    var c$0 = acc[2], size$0 = _D_[2], p$4 = _C_[1];
                                    break;
                                }
                            }
                            var c = acc[2], p$3 = _C_;
                            break c;
                        case 6:
                            var p$5 = acc[1];
                            if (typeof p$5 !== "number" && 0 === p$5[0]) {
                                var match$1 = p$5[2];
                                if (typeof match$1 !== "number" && 1 === match$1[0]) {
                                    var f$1 = acc[2], size$1 = match$1[2], p$6 = p$5[1];
                                    strput_acc(ppf, p$6);
                                    return pp_print_as_size(ppf, size$1, caml_call1(f$1, 0));
                                }
                            }
                            var f$0 = acc[2];
                            strput_acc(ppf, p$5);
                            return pp_print_string(ppf, caml_call1(f$0, 0));
                        case 7:
                            var p$7 = acc[1];
                            strput_acc(ppf, p$7);
                            return pp_print_flush(ppf, 0);
                        default:
                            var msg = acc[2], p$8 = acc[1];
                            strput_acc(ppf, p$8);
                            return caml_call1(Stdlib[1], msg);
                    }
                    strput_acc(ppf, p$4);
                    return pp_print_as_size(ppf, size$0, caml_call2(Stdlib_String[1], 1, c$0));
                }
                strput_acc(ppf, p$3);
                return pp_print_char(ppf, c);
            }
            strput_acc(ppf, p$2);
            return pp_print_as_size(ppf, size, s$0);
        }
        strput_acc(ppf, p$1);
        return pp_print_string(ppf, s);
    }
    function kfprintf(k, ppf, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            output_acc(ppf, acc);
            return caml_call1(k, ppf);
        }, 0, fmt);
    }
    function ikfprintf(k, ppf, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[8], k, ppf, fmt);
    }
    function ifprintf(ppf, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[8], function(_u_) {
            return 0;
        }, 0, fmt);
    }
    function fprintf(ppf) {
        function _r_(_t_) {
            return 0;
        }
        return function(_s_) {
            return kfprintf(_r_, ppf, _s_);
        };
    }
    function printf(param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            return output_acc(caml_call1(Stdlib_Domain[10][2], std_formatter_key), acc);
        }, 0, fmt);
    }
    function eprintf(param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            return output_acc(caml_call1(Stdlib_Domain[10][2], err_formatter_key), acc);
        }, 0, fmt);
    }
    function kdprintf(k, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            return caml_call1(k, function(ppf) {
                return output_acc(ppf, acc);
            });
        }, 0, fmt);
    }
    function dprintf(fmt) {
        return kdprintf(function(i) {
            return i;
        }, fmt);
    }
    function ksprintf(k, param) {
        var fmt = param[1], b = pp_make_buffer(0), ppf = formatter_of_buffer(b);
        function k$0(acc) {
            strput_acc(ppf, acc);
            return caml_call1(k, flush_buffer_formatter(b, ppf));
        }
        return caml_call3(CamlinternalFormat[7], k$0, 0, fmt);
    }
    function sprintf(fmt) {
        return ksprintf(id, fmt);
    }
    function kasprintf(k, param) {
        var fmt = param[1], b = pp_make_buffer(0), ppf = formatter_of_buffer(b);
        function k$0(acc) {
            output_acc(ppf, acc);
            return caml_call1(k, flush_buffer_formatter(b, ppf));
        }
        return caml_call3(CamlinternalFormat[7], k$0, 0, fmt);
    }
    function asprintf(fmt) {
        return kasprintf(id, fmt);
    }
    function flush_standard_formatters(param) {
        pp_print_flush(caml_call1(Stdlib_Domain[10][2], std_formatter_key), 0);
        return pp_print_flush(caml_call1(Stdlib_Domain[10][2], err_formatter_key), 0);
    }
    caml_call1(Stdlib[100], flush_standard_formatters);
    caml_call1(Stdlib_Domain[5], function(param) {
        flush_standard_formatters(0);
        var fs = pp_get_formatter_out_functions(std_formatter, 0), _h_ = Stdlib[39];
        pp_set_formatter_out_functions(std_formatter, [
            0,
            function(_o_, _p_, _q_) {
                return buffered_out_string(std_buf_key, _o_, _p_, _q_);
            },
            function(_n_) {
                return buffered_out_flush(_h_, std_buf_key, _n_);
            },
            fs[3],
            fs[4],
            fs[5]
        ]);
        var fs$0 = pp_get_formatter_out_functions(err_formatter, 0), _i_ = Stdlib[40];
        return pp_set_formatter_out_functions(err_formatter, [
            0,
            function(_k_, _l_, _m_) {
                return buffered_out_string(err_buf_key, _k_, _l_, _m_);
            },
            function(_j_) {
                return buffered_out_flush(_i_, err_buf_key, _j_);
            },
            fs$0[3],
            fs$0[4],
            fs$0[5]
        ]);
    });
    var Stdlib_Format = [
        0,
        pp_open_box,
        open_box,
        pp_close_box,
        close_box,
        pp_open_hbox,
        open_hbox,
        pp_open_vbox,
        open_vbox,
        pp_open_hvbox,
        open_hvbox,
        pp_open_hovbox,
        open_hovbox,
        pp_print_string,
        print_string,
        pp_print_bytes,
        print_bytes,
        pp_print_as,
        print_as,
        pp_print_int,
        print_int,
        pp_print_float,
        print_float,
        pp_print_char,
        print_char,
        pp_print_bool,
        print_bool,
        pp_print_nothing,
        pp_print_space,
        print_space,
        pp_print_cut,
        print_cut,
        pp_print_break,
        print_break,
        pp_print_custom_break,
        pp_force_newline,
        force_newline,
        pp_print_if_newline,
        print_if_newline,
        pp_print_flush,
        print_flush,
        pp_print_newline,
        print_newline,
        pp_infinity,
        pp_set_margin,
        set_margin,
        pp_get_margin,
        get_margin,
        pp_set_max_indent,
        set_max_indent,
        pp_get_max_indent,
        get_max_indent,
        check_geometry,
        pp_set_geometry,
        set_geometry,
        pp_safe_set_geometry,
        safe_set_geometry,
        pp_update_geometry,
        update_geometry,
        pp_get_geometry,
        get_geometry,
        pp_set_max_boxes,
        set_max_boxes,
        pp_get_max_boxes,
        get_max_boxes,
        pp_over_max_boxes,
        over_max_boxes,
        pp_open_tbox,
        open_tbox,
        pp_close_tbox,
        close_tbox,
        pp_set_tab,
        set_tab,
        pp_print_tab,
        print_tab,
        pp_print_tbreak,
        print_tbreak,
        pp_set_ellipsis_text,
        set_ellipsis_text,
        pp_get_ellipsis_text,
        get_ellipsis_text,
        String_tag,
        pp_open_stag,
        open_stag,
        pp_close_stag,
        close_stag,
        pp_set_tags,
        set_tags,
        pp_set_print_tags,
        set_print_tags,
        pp_set_mark_tags,
        set_mark_tags,
        pp_get_print_tags,
        get_print_tags,
        pp_get_mark_tags,
        get_mark_tags,
        pp_set_formatter_out_channel,
        set_formatter_out_channel,
        pp_set_formatter_output_functi,
        set_formatter_output_functions,
        pp_get_formatter_output_functi,
        get_formatter_output_functions,
        pp_set_formatter_out_functions,
        set_formatter_out_functions,
        pp_get_formatter_out_functions,
        get_formatter_out_functions,
        pp_set_formatter_stag_function,
        set_formatter_stag_functions,
        pp_get_formatter_stag_function,
        get_formatter_stag_functions,
        formatter_of_out_channel,
        synchronized_formatter_of_out_,
        std_formatter,
        get_std_formatter,
        err_formatter,
        get_err_formatter,
        formatter_of_buffer,
        stdbuf,
        get_stdbuf,
        str_formatter,
        get_str_formatter,
        flush_str_formatter,
        make_formatter,
        make_synchronized_formatter,
        formatter_of_out_functions,
        make_symbolic_output_buffer,
        clear_symbolic_output_buffer,
        get_symbolic_output_buffer,
        flush_symbolic_output_buffer,
        add_symbolic_output_item,
        formatter_of_symbolic_output_b,
        pp_print_iter,
        pp_print_list,
        pp_print_array,
        pp_print_seq,
        pp_print_text,
        pp_print_option,
        pp_print_result,
        pp_print_either,
        fprintf,
        printf,
        eprintf,
        sprintf,
        asprintf,
        dprintf,
        ifprintf,
        kfprintf,
        kdprintf,
        ikfprintf,
        ksprintf,
        kasprintf
    ];
    runtime.caml_register_global(38, Stdlib_Format, "Stdlib__Format");
    return;
})(globalThis);
//# 23087 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$5 = '"', cst$6 = "-", cst_character = "character ", cst_scanf_ml = "scanf.ml", cst_scanf_bad_conversion$3 = 'scanf: bad conversion "%*"', cst_scanning_of = "scanning of ", caml_bytes_get = runtime.caml_bytes_get, caml_int_of_string = runtime.caml_int_of_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$3 = cst$5, cst$4 = cst$5, cst$1 = cst$5, cst$2 = cst$5, cst$0 = cst$5, cst_not_a_valid_float_in_hexad = "not a valid float in hexadecimal notation", cst_no_dot_or_exponent_part_fo = "no dot or exponent part found in float token", cst = cst$6, cst_binary = "binary", cst_octal = "octal", cst_hexadecimal = "hexadecimal", cst_a_Char = "a Char", cst_a_String = "a String", CamlinternalFormat = global_data.CamlinternalFormat, CamlinternalFormatBasics = global_data.CamlinternalFormatBasics, Stdlib_String = global_data.Stdlib__String, Stdlib = global_data.Stdlib, Assert_failure = global_data.Assert_failure, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Buffer = global_data.Stdlib__Buffer, null_char = 0, cst_unnamed_function = "unnamed function", cst_unnamed_character_string = "unnamed character string", cst_unnamed_Stdlib_input_chann = "unnamed Stdlib input channel";
    function next_char(ib) {
        try {
            var c = caml_call1(ib[7], 0);
            ib[2] = c;
            ib[3] = 1;
            ib[4] = ib[4] + 1 | 0;
            if (10 === c) ib[5] = ib[5] + 1 | 0;
            return c;
        } catch (_aY_) {
            var _aX_ = caml_wrap_exception(_aY_);
            if (_aX_ !== Stdlib[12]) throw caml_maybe_attach_backtrace(_aX_, 0);
            ib[2] = null_char;
            ib[3] = 0;
            ib[1] = 1;
            return null_char;
        }
    }
    function peek_char(ib) {
        return ib[3] ? ib[2] : next_char(ib);
    }
    function checked_peek_char(ib) {
        var c = peek_char(ib);
        if (ib[1]) throw caml_maybe_attach_backtrace(Stdlib[12], 1);
        return c;
    }
    function end_of_input(ib) {
        peek_char(ib);
        return ib[1];
    }
    function beginning_of_input(ib) {
        return 0 === ib[4] ? 1 : 0;
    }
    function name_of_input(ib) {
        var match = ib[9];
        if (typeof match === "number") return 0 === match ? cst_unnamed_function : cst_unnamed_character_string;
        if (0 === match[0]) return cst_unnamed_Stdlib_input_chann;
        var fname = match[1];
        return fname;
    }
    function char_count(ib) {
        return ib[3] ? ib[4] - 1 | 0 : ib[4];
    }
    function invalidate_current_char(ib) {
        ib[3] = 0;
        return 0;
    }
    function token_string(ib) {
        var token_buffer = ib[8], tok = caml_call1(Stdlib_Buffer[2], token_buffer);
        caml_call1(Stdlib_Buffer[8], token_buffer);
        ib[6] = ib[6] + 1 | 0;
        return tok;
    }
    function ignore_char(width, ib) {
        var width$0 = width - 1 | 0;
        invalidate_current_char(ib);
        return width$0;
    }
    function store_char(width, ib, c) {
        caml_call2(Stdlib_Buffer[12], ib[8], c);
        return ignore_char(width, ib);
    }
    var default_token_buffer_size = 1024;
    function create(iname, next) {
        return [
            0,
            0,
            null_char,
            0,
            0,
            0,
            0,
            next,
            caml_call1(Stdlib_Buffer[1], default_token_buffer_size),
            iname
        ];
    }
    function from_string(s) {
        var i = [
            0,
            0
        ], len = caml_ml_string_length(s);
        function next(param) {
            if (len <= i[1]) throw caml_maybe_attach_backtrace(Stdlib[12], 1);
            var c = caml_string_get(s, i[1]);
            i[1]++;
            return c;
        }
        return create(1, next);
    }
    var _a_ = 0;
    function from_function(_aW_) {
        return create(_a_, _aW_);
    }
    var len = 1024;
    function scan_close_at_end(ic) {
        caml_call1(Stdlib[93], ic);
        throw caml_maybe_attach_backtrace(Stdlib[12], 1);
    }
    function scan_raise_at_end(ic) {
        throw caml_maybe_attach_backtrace(Stdlib[12], 1);
    }
    function from_ic(scan_close_ic, iname, ic) {
        var buf = runtime.caml_create_bytes(1024), i = [
            0,
            0
        ], lim = [
            0,
            0
        ], eof = [
            0,
            0
        ];
        function next(param) {
            if (i[1] < lim[1]) {
                var c = caml_bytes_get(buf, i[1]);
                i[1]++;
                return c;
            }
            if (eof[1]) throw caml_maybe_attach_backtrace(Stdlib[12], 1);
            lim[1] = caml_call4(Stdlib[84], ic, buf, 0, len);
            return 0 === lim[1] ? (eof[1] = 1, caml_call1(scan_close_ic, ic)) : (i[1] = 1, caml_bytes_get(buf, 0));
        }
        return create(iname, next);
    }
    var stdin = from_ic(scan_raise_at_end, [
        1,
        cst,
        Stdlib[38]
    ], Stdlib[38]);
    function open_in_file(open_in, fname) {
        if (fname === cst$6) return stdin;
        var ic = caml_call1(open_in, fname);
        return from_ic(scan_close_at_end, [
            1,
            fname,
            ic
        ], ic);
    }
    var _b_ = Stdlib[79];
    function open_in(_aV_) {
        return open_in_file(_b_, _aV_);
    }
    var _c_ = Stdlib[80];
    function open_in_bin(_aU_) {
        return open_in_file(_c_, _aU_);
    }
    function from_channel(ic) {
        return from_ic(scan_raise_at_end, [
            0,
            ic
        ], ic);
    }
    function close_in(ib) {
        var match = ib[9];
        if (typeof match === "number") return 0;
        if (0 === match[0]) {
            var ic = match[1];
            return caml_call1(Stdlib[93], ic);
        }
        var ic$0 = match[2];
        return caml_call1(Stdlib[93], ic$0);
    }
    var Scan_failure = [
        248,
        "Stdlib.Scanf.Scan_failure",
        runtime.caml_fresh_oo_id(0)
    ], _d_ = [
        0,
        [
            11,
            "illegal escape character ",
            [
                1,
                0
            ]
        ],
        "illegal escape character %C"
    ], _e_ = [
        0,
        [
            11,
            cst_scanning_of,
            [
                2,
                0,
                [
                    11,
                    " failed: the specified length was too short for token",
                    0
                ]
            ]
        ],
        "scanning of %s failed: the specified length was too short for token"
    ], _f_ = [
        0,
        [
            11,
            cst_scanning_of,
            [
                2,
                0,
                [
                    11,
                    " failed: premature end of file occurred before end of token",
                    0
                ]
            ]
        ],
        "scanning of %s failed: premature end of file occurred before end of token"
    ], _g_ = [
        0,
        [
            11,
            "looking for ",
            [
                1,
                [
                    11,
                    ", found ",
                    [
                        1,
                        0
                    ]
                ]
            ]
        ],
        "looking for %C, found %C"
    ], _h_ = [
        0,
        [
            11,
            "invalid boolean '",
            [
                2,
                0,
                [
                    12,
                    39,
                    0
                ]
            ]
        ],
        "invalid boolean '%s'"
    ], _i_ = [
        0,
        cst_scanf_ml,
        516,
        9
    ], cst_0b = "0b", cst_0o = "0o", cst_0u = "0u", cst_0x = "0x", cst_decimal_digits = "decimal digits", _j_ = [
        0,
        [
            11,
            cst_character,
            [
                1,
                [
                    11,
                    " is not a decimal digit",
                    0
                ]
            ]
        ],
        "character %C is not a decimal digit"
    ], cst_digits = "digits", _k_ = [
        0,
        [
            11,
            cst_character,
            [
                1,
                [
                    11,
                    " is not a valid ",
                    [
                        2,
                        0,
                        [
                            11,
                            " digit",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "character %C is not a valid %s digit"
    ], cst_an = "an", cst_nfinity = "nfinity", cst_x = "x", _l_ = [
        0,
        [
            11,
            "bad character decimal encoding \\",
            [
                0,
                [
                    0,
                    [
                        0,
                        0
                    ]
                ]
            ]
        ],
        "bad character decimal encoding \\%c%c%c"
    ], _m_ = [
        0,
        [
            11,
            "bad character hexadecimal encoding \\",
            [
                0,
                [
                    0,
                    0
                ]
            ]
        ],
        "bad character hexadecimal encoding \\%c%c"
    ], _n_ = [
        0,
        [
            11,
            "the character ",
            [
                1,
                [
                    11,
                    " cannot start a boolean",
                    0
                ]
            ]
        ],
        "the character %C cannot start a boolean"
    ], _o_ = [
        0,
        [
            11,
            "scanf: bad input at char number ",
            [
                4,
                3,
                0,
                0,
                [
                    11,
                    ": ",
                    [
                        2,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "scanf: bad input at char number %i: %s"
    ], _p_ = [
        0,
        37,
        ""
    ], _q_ = [
        0,
        123
    ], _r_ = [
        0,
        91
    ], cst_end_of_input_not_found = "end of input not found", cst_scanf_bad_conversion_a = 'scanf: bad conversion "%a"', cst_scanf_bad_conversion_t = 'scanf: bad conversion "%t"', cst_scanf_missing_reader = "scanf: missing reader", _s_ = [
        0,
        cst_scanf_ml,
        1414,
        13
    ], cst_scanf_bad_conversion_custo = 'scanf: bad conversion "%?" (custom converter)', cst_scanf_bad_conversion = cst_scanf_bad_conversion$3, cst_scanf_bad_conversion$0 = cst_scanf_bad_conversion$3, cst_scanf_bad_conversion$1 = 'scanf: bad conversion "%-"', cst_scanf_bad_conversion$2 = cst_scanf_bad_conversion$3, cst_in_format = ' in format "', _t_ = [
        0,
        [
            3,
            0,
            [
                10,
                0
            ]
        ],
        "%S%!"
    ];
    function bad_input(s) {
        throw caml_maybe_attach_backtrace([
            0,
            Scan_failure,
            s
        ], 1);
    }
    function bad_input_escape(c) {
        return bad_input(caml_call2(Stdlib_Printf[4], _d_, c));
    }
    function bad_token_length(message) {
        return bad_input(caml_call2(Stdlib_Printf[4], _e_, message));
    }
    function bad_hex_float(param) {
        return bad_input(cst_not_a_valid_float_in_hexad);
    }
    function character_mismatch(c, ci) {
        return bad_input(caml_call3(Stdlib_Printf[4], _g_, c, ci));
    }
    function check_char(ib, c$0) {
        if (10 === c$0) {
            var ci = checked_peek_char(ib);
            return 10 === ci ? invalidate_current_char(ib) : 13 === ci ? (invalidate_current_char(ib), check_this_char(ib, 10)) : character_mismatch(10, ci);
        }
        if (32 !== c$0) return check_this_char(ib, c$0);
        for(;;){
            var c = peek_char(ib), _aS_ = 1 - ib[1];
            if (!_aS_) return _aS_;
            var _aT_ = c - 9 | 0;
            a: {
                if (4 < _aT_ >>> 0) {
                    if (23 === _aT_) break a;
                } else if (1 < _aT_ - 2 >>> 0) break a;
                return 0;
            }
            invalidate_current_char(ib);
        }
    }
    function check_this_char(ib, c) {
        var ci = checked_peek_char(ib);
        return ci === c ? invalidate_current_char(ib) : character_mismatch(c, ci);
    }
    function token_char(ib) {
        return caml_string_get(token_string(ib), 0);
    }
    function token_bool(ib) {
        var s = token_string(ib);
        return s !== "false" ? s !== "true" ? bad_input(caml_call2(Stdlib_Printf[4], _h_, s)) : 1 : 0;
    }
    function integer_conversion_of_char(param) {
        var switcher = param - 88 | 0;
        if (32 >= switcher >>> 0) switch(switcher){
            case 10:
                return 0;
            case 12:
                return 1;
            case 17:
                return 2;
            case 23:
                return 3;
            case 29:
                return 4;
            case 0:
            case 32:
                return 5;
        }
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _i_
        ], 1);
    }
    function token_int_literal(conv, ib) {
        switch(conv){
            case 0:
                var _aO_ = token_string(ib), tok = caml_call2(Stdlib[28], cst_0b, _aO_);
                break;
            case 3:
                var _aP_ = token_string(ib), tok = caml_call2(Stdlib[28], cst_0o, _aP_);
                break;
            case 4:
                var _aQ_ = token_string(ib), tok = caml_call2(Stdlib[28], cst_0u, _aQ_);
                break;
            case 5:
                var _aR_ = token_string(ib), tok = caml_call2(Stdlib[28], cst_0x, _aR_);
                break;
            default:
                var tok = token_string(ib);
        }
        var l = caml_ml_string_length(tok);
        if (0 !== l && 43 === caml_string_get(tok, 0)) return caml_call3(Stdlib_String[16], tok, 1, l - 1 | 0);
        return tok;
    }
    function token_float(ib) {
        return runtime.caml_float_of_string(token_string(ib));
    }
    function scan_decimal_digit_star(width, ib) {
        var width$0 = width;
        for(;;){
            if (0 === width$0) return width$0;
            var c = peek_char(ib);
            if (ib[1]) return width$0;
            if (58 <= c) {
                if (95 === c) {
                    var width$1 = ignore_char(width$0, ib);
                    width$0 = width$1;
                    continue;
                }
            } else if (48 <= c) {
                var width$2 = store_char(width$0, ib, c);
                width$0 = width$2;
                continue;
            }
            return width$0;
        }
    }
    function scan_decimal_digit_plus(width, ib) {
        if (0 === width) return bad_token_length(cst_decimal_digits);
        var c = checked_peek_char(ib);
        if (9 < c - 48 >>> 0) return bad_input(caml_call2(Stdlib_Printf[4], _j_, c));
        var width$0 = store_char(width, ib, c);
        return scan_decimal_digit_star(width$0, ib);
    }
    function scan_digit_plus(basis, digitp, width$2, ib) {
        if (0 === width$2) return bad_token_length(cst_digits);
        var c$0 = checked_peek_char(ib);
        if (!caml_call1(digitp, c$0)) return bad_input(caml_call3(Stdlib_Printf[4], _k_, c$0, basis));
        var width$3 = store_char(width$2, ib, c$0), width = width$3;
        for(;;){
            if (0 === width) return width;
            var c = peek_char(ib);
            if (ib[1]) return width;
            if (caml_call1(digitp, c)) {
                var width$0 = store_char(width, ib, c);
                width = width$0;
            } else {
                if (95 !== c) return width;
                var width$1 = ignore_char(width, ib);
                width = width$1;
            }
        }
    }
    function is_binary_digit(param) {
        return 1 < param - 48 >>> 0 ? 0 : 1;
    }
    function is_octal_digit(param) {
        return 7 < param - 48 >>> 0 ? 0 : 1;
    }
    function is_hexa_digit(param) {
        var _aN_ = param - 48 | 0;
        a: {
            if (22 < _aN_ >>> 0) {
                if (5 < _aN_ - 49 >>> 0) break a;
            } else if (6 >= _aN_ - 10 >>> 0) break a;
            return 1;
        }
        return 0;
    }
    function scan_sign(width, ib) {
        var c = checked_peek_char(ib), switcher = c - 43 | 0;
        if (2 >= switcher >>> 0) switch(switcher){
            case 0:
                return store_char(width, ib, c);
            case 1:
                break;
            default:
                return store_char(width, ib, c);
        }
        return width;
    }
    function scan_optionally_signed_decimal(width, ib) {
        var width$0 = scan_sign(width, ib);
        return scan_decimal_digit_plus(width$0, ib);
    }
    function scan_int_conversion(conv, width$1, ib) {
        switch(conv){
            case 0:
                return scan_digit_plus(cst_binary, is_binary_digit, width$1, ib);
            case 1:
                return scan_optionally_signed_decimal(width$1, ib);
            case 2:
                var width$0 = scan_sign(width$1, ib), c = checked_peek_char(ib);
                if (48 !== c) return scan_decimal_digit_plus(width$0, ib);
                var width = store_char(width$0, ib, c);
                if (0 === width) return width;
                var c$0 = peek_char(ib);
                if (ib[1]) return width;
                a: {
                    if (99 <= c$0) {
                        if (111 === c$0) return scan_digit_plus(cst_octal, is_octal_digit, store_char(width, ib, c$0), ib);
                        if (120 === c$0) break a;
                    } else {
                        if (88 === c$0) break a;
                        if (98 <= c$0) return scan_digit_plus(cst_binary, is_binary_digit, store_char(width, ib, c$0), ib);
                    }
                    return scan_decimal_digit_star(width, ib);
                }
                return scan_digit_plus(cst_hexadecimal, is_hexa_digit, store_char(width, ib, c$0), ib);
            case 3:
                return scan_digit_plus(cst_octal, is_octal_digit, width$1, ib);
            case 4:
                return scan_decimal_digit_plus(width$1, ib);
            default:
                return scan_digit_plus(cst_hexadecimal, is_hexa_digit, width$1, ib);
        }
    }
    function scan_fractional_part(width, ib) {
        if (0 === width) return width;
        var c = peek_char(ib);
        return ib[1] ? width : 9 < c - 48 >>> 0 ? width : scan_decimal_digit_star(store_char(width, ib, c), ib);
    }
    function scan_exponent_part(width, ib) {
        if (0 === width) return width;
        var c = peek_char(ib);
        if (ib[1]) return width;
        if (69 !== c && 101 !== c) return width;
        return scan_optionally_signed_decimal(store_char(width, ib, c), ib);
    }
    function scan_float(width$1, precision, ib) {
        var width = scan_sign(width$1, ib), width$0 = scan_decimal_digit_star(width, ib);
        if (0 === width$0) return [
            0,
            width$0,
            precision
        ];
        var c = peek_char(ib);
        if (ib[1]) return [
            0,
            width$0,
            precision
        ];
        if (46 !== c) return [
            0,
            scan_exponent_part(width$0, ib),
            precision
        ];
        var width$2 = store_char(width$0, ib, c), precision$0 = caml_call2(Stdlib_Int[10], width$2, precision), width$3 = width$2 - (precision$0 - scan_fractional_part(precision$0, ib) | 0) | 0;
        return [
            0,
            scan_exponent_part(width$3, ib),
            precision$0
        ];
    }
    function check_case_insensitive_string(width, ib, error, str) {
        function lowercase(c) {
            return 25 < c - 65 >>> 0 ? c : caml_call1(Stdlib[29], (c - 65 | 0) + 97 | 0);
        }
        var len = caml_ml_string_length(str), width$0 = [
            0,
            width
        ], _aK_ = len - 1 | 0, _aJ_ = 0;
        if (_aK_ >= 0) {
            var i = _aJ_;
            for(;;){
                var c = peek_char(ib), _aL_ = lowercase(caml_string_get(str, i));
                if (lowercase(c) !== _aL_) caml_call1(error, 0);
                if (0 === width$0[1]) caml_call1(error, 0);
                width$0[1] = store_char(width$0[1], ib, c);
                var _aM_ = i + 1 | 0;
                if (_aK_ === i) break;
                i = _aM_;
            }
        }
        return width$0[1];
    }
    function scan_hex_float(width, precision, ib) {
        var _aw_ = 0 === width ? 1 : 0, _ax_ = _aw_ || end_of_input(ib);
        if (_ax_) bad_input(cst_not_a_valid_float_in_hexad);
        var width$0 = scan_sign(width, ib), _ay_ = 0 === width$0 ? 1 : 0, _az_ = _ay_ || end_of_input(ib);
        if (_az_) bad_input(cst_not_a_valid_float_in_hexad);
        var c = peek_char(ib);
        a: {
            if (78 <= c) {
                var switcher = c - 79 | 0;
                if (30 < switcher >>> 0) {
                    if (32 <= switcher) break a;
                    var width$1 = store_char(width$0, ib, c), _aA_ = 0 === width$1 ? 1 : 0, _aB_ = _aA_ || end_of_input(ib);
                    if (_aB_) bad_input(cst_not_a_valid_float_in_hexad);
                    return check_case_insensitive_string(width$1, ib, bad_hex_float, cst_an);
                }
                if (26 !== switcher) break a;
            } else {
                if (48 === c) {
                    var width$3 = store_char(width$0, ib, c), _aE_ = 0 === width$3 ? 1 : 0, _aF_ = _aE_ || end_of_input(ib);
                    if (_aF_) bad_input(cst_not_a_valid_float_in_hexad);
                    var width$4 = check_case_insensitive_string(width$3, ib, bad_hex_float, cst_x);
                    if (0 !== width$4 && !end_of_input(ib)) {
                        var _aG_ = peek_char(ib) - 46 | 0;
                        b: {
                            c: {
                                if (34 < _aG_ >>> 0) {
                                    if (66 === _aG_) break c;
                                } else if (32 < _aG_ - 1 >>> 0) break c;
                                var width$5 = scan_digit_plus(cst_hexadecimal, is_hexa_digit, width$4, ib);
                                break b;
                            }
                            var width$5 = width$4;
                        }
                        if (0 !== width$5 && !end_of_input(ib)) {
                            var c$0 = peek_char(ib);
                            if (46 === c$0) {
                                var width$6 = store_char(width$5, ib, c$0);
                                b: {
                                    if (0 !== width$6 && !end_of_input(ib)) {
                                        var match = peek_char(ib);
                                        c: {
                                            if (80 !== match && 112 !== match) {
                                                var precision$0 = caml_call2(Stdlib_Int[10], width$6, precision), width$10 = width$6 - (precision$0 - scan_digit_plus(cst_hexadecimal, is_hexa_digit, precision$0, ib) | 0) | 0;
                                                break c;
                                            }
                                            var width$10 = width$6;
                                        }
                                        var width$7 = width$10;
                                        break b;
                                    }
                                    var width$7 = width$6;
                                }
                                var width$8 = width$7;
                            } else var width$8 = width$5;
                            if (0 !== width$8 && !end_of_input(ib)) {
                                var c$1 = peek_char(ib);
                                if (80 !== c$1 && 112 !== c$1) return width$8;
                                var width$9 = store_char(width$8, ib, c$1), _aH_ = 0 === width$9 ? 1 : 0, _aI_ = _aH_ || end_of_input(ib);
                                if (_aI_) bad_input(cst_not_a_valid_float_in_hexad);
                                return scan_optionally_signed_decimal(width$9, ib);
                            }
                            return width$8;
                        }
                        return width$5;
                    }
                    return width$4;
                }
                if (73 !== c) break a;
            }
            var width$2 = store_char(width$0, ib, c), _aC_ = 0 === width$2 ? 1 : 0, _aD_ = _aC_ || end_of_input(ib);
            if (_aD_) bad_input(cst_not_a_valid_float_in_hexad);
            return check_case_insensitive_string(width$2, ib, bad_hex_float, cst_nfinity);
        }
        return bad_input(cst_not_a_valid_float_in_hexad);
    }
    function scan_caml_float_rest(width, precision, ib) {
        var _as_ = 0 === width ? 1 : 0, _at_ = _as_ || end_of_input(ib);
        if (_at_) bad_input(cst_no_dot_or_exponent_part_fo);
        var width$0 = scan_decimal_digit_star(width, ib), _au_ = 0 === width$0 ? 1 : 0, _av_ = _au_ || end_of_input(ib);
        if (_av_) bad_input(cst_no_dot_or_exponent_part_fo);
        var c = peek_char(ib), switcher = c - 69 | 0;
        if (32 < switcher >>> 0) {
            if (-23 === switcher) {
                var width$1 = store_char(width$0, ib, c), precision$0 = caml_call2(Stdlib_Int[10], width$1, precision), width_precision = scan_fractional_part(precision$0, ib), frac_width = precision$0 - width_precision | 0, width$2 = width$1 - frac_width | 0;
                return scan_exponent_part(width$2, ib);
            }
        } else if (30 < switcher - 1 >>> 0) return scan_exponent_part(width$0, ib);
        return bad_input(cst_no_dot_or_exponent_part_fo);
    }
    function scan_caml_float(width, precision, ib) {
        var _ae_ = 0 === width ? 1 : 0, _af_ = _ae_ || end_of_input(ib);
        if (_af_) bad_input(cst_no_dot_or_exponent_part_fo);
        var width$0 = scan_sign(width, ib), _ag_ = 0 === width$0 ? 1 : 0, _ah_ = _ag_ || end_of_input(ib);
        if (_ah_) bad_input(cst_no_dot_or_exponent_part_fo);
        var c = peek_char(ib);
        if (49 <= c) {
            if (58 > c) {
                var width$1 = store_char(width$0, ib, c), _ai_ = 0 === width$1 ? 1 : 0, _aj_ = _ai_ || end_of_input(ib);
                if (_aj_) bad_input(cst_no_dot_or_exponent_part_fo);
                return scan_caml_float_rest(width$1, precision, ib);
            }
        } else if (48 <= c) {
            var width$2 = store_char(width$0, ib, c), _ak_ = 0 === width$2 ? 1 : 0, _al_ = _ak_ || end_of_input(ib);
            if (_al_) bad_input(cst_no_dot_or_exponent_part_fo);
            var c$0 = peek_char(ib);
            if (88 !== c$0 && 120 !== c$0) return scan_caml_float_rest(width$2, precision, ib);
            var width$3 = store_char(width$2, ib, c$0), _am_ = 0 === width$3 ? 1 : 0, _an_ = _am_ || end_of_input(ib);
            if (_an_) bad_input(cst_no_dot_or_exponent_part_fo);
            var width$10 = scan_digit_plus(cst_hexadecimal, is_hexa_digit, width$3, ib), _ao_ = 0 === width$10 ? 1 : 0, _ap_ = _ao_ || end_of_input(ib);
            if (_ap_) bad_input(cst_no_dot_or_exponent_part_fo);
            var c$1 = peek_char(ib), switcher = c$1 - 80 | 0;
            a: {
                b: {
                    if (32 < switcher >>> 0) {
                        if (-34 === switcher) {
                            var width$4 = store_char(width$10, ib, c$1);
                            c: {
                                if (0 !== width$4 && !end_of_input(ib)) {
                                    var match = peek_char(ib);
                                    d: {
                                        if (80 !== match && 112 !== match) {
                                            var precision$0 = caml_call2(Stdlib_Int[10], width$4, precision), width$9 = width$4 - (precision$0 - scan_digit_plus(cst_hexadecimal, is_hexa_digit, precision$0, ib) | 0) | 0;
                                            break d;
                                        }
                                        var width$9 = width$4;
                                    }
                                    var width$5 = width$9;
                                    break c;
                                }
                                var width$5 = width$4;
                            }
                            var width$6 = width$5;
                            break b;
                        }
                    } else if (30 < switcher - 1 >>> 0) {
                        var width$6 = width$10;
                        break b;
                    }
                    var width$7 = bad_input(cst_no_dot_or_exponent_part_fo);
                    break a;
                }
                var width$7 = width$6;
            }
            if (0 !== width$7 && !end_of_input(ib)) {
                var c$2 = peek_char(ib);
                if (80 !== c$2 && 112 !== c$2) return width$7;
                var width$8 = store_char(width$7, ib, c$2), _aq_ = 0 === width$8 ? 1 : 0, _ar_ = _aq_ || end_of_input(ib);
                if (_ar_) bad_input(cst_not_a_valid_float_in_hexad);
                return scan_optionally_signed_decimal(width$8, ib);
            }
            return width$7;
        }
        return bad_input(cst_no_dot_or_exponent_part_fo);
    }
    function scan_string(stp, width, ib) {
        var width$0 = width;
        for(;;){
            if (0 === width$0) return width$0;
            var c = peek_char(ib);
            if (ib[1]) return width$0;
            if (!stp) {
                var _ad_ = c - 9 | 0;
                a: {
                    if (4 < _ad_ >>> 0) {
                        if (23 === _ad_) break a;
                    } else if (1 < _ad_ - 2 >>> 0) break a;
                    var width$2 = store_char(width$0, ib, c);
                    width$0 = width$2;
                    continue;
                }
                return width$0;
            }
            var c$0 = stp[1];
            if (c === c$0) {
                invalidate_current_char(ib);
                return width$0;
            }
            var width$1 = store_char(width$0, ib, c);
            width$0 = width$1;
        }
    }
    function hexadecimal_value_of_char(c) {
        return 97 <= c ? c - 87 | 0 : 65 <= c ? c - 55 | 0 : c - 48 | 0;
    }
    function check_next_char(message, width, ib) {
        if (0 === width) return bad_token_length(message);
        var c = peek_char(ib);
        return ib[1] ? bad_input(caml_call2(Stdlib_Printf[4], _f_, message)) : c;
    }
    function scan_backslash_char(width, ib) {
        var c0 = check_next_char(cst_a_Char, width, ib);
        a: {
            if (40 <= c0) {
                if (58 > c0) {
                    if (48 > c0) break a;
                    var get_digit$0 = function(param) {
                        var c = next_char(ib);
                        return 9 < c - 48 >>> 0 ? bad_input_escape(c) : c;
                    }, c1$0 = get_digit$0(0), c2$0 = get_digit$0(0), c = ((100 * (c0 - 48 | 0) | 0) + (10 * (c1$0 - 48 | 0) | 0) | 0) + (c2$0 - 48 | 0) | 0;
                    b: {
                        if (0 <= c && 255 >= c) {
                            var _ab_ = caml_call1(Stdlib[29], c);
                            break b;
                        }
                        var _ab_ = bad_input(caml_call4(Stdlib_Printf[4], _l_, c0, c1$0, c2$0));
                    }
                    return store_char(width - 2 | 0, ib, _ab_);
                }
                var switcher = c0 - 92 | 0;
                if (28 < switcher >>> 0) break a;
                switch(switcher){
                    case 28:
                        var get_digit = function(param) {
                            var c = next_char(ib), _ac_ = c - 48 | 0;
                            a: {
                                if (22 < _ac_ >>> 0) {
                                    if (5 < _ac_ - 49 >>> 0) break a;
                                } else if (6 >= _ac_ - 10 >>> 0) break a;
                                return c;
                            }
                            return bad_input_escape(c);
                        }, c1 = get_digit(0), c2 = get_digit(0), ___ = hexadecimal_value_of_char(c2), c$0 = (16 * hexadecimal_value_of_char(c1) | 0) + ___ | 0;
                        b: {
                            if (0 <= c$0 && 255 >= c$0) {
                                var _aa_ = caml_call1(Stdlib[29], c$0);
                                break b;
                            }
                            var _aa_ = bad_input(caml_call3(Stdlib_Printf[4], _m_, c1, c2));
                        }
                        return store_char(width - 2 | 0, ib, _aa_);
                    case 0:
                    case 6:
                    case 18:
                    case 22:
                    case 24:
                        break;
                    default:
                        break a;
                }
            } else if (34 !== c0 && 39 > c0) break a;
            b: {
                if (110 <= c0) {
                    if (117 > c0) switch(c0 - 110 | 0){
                        case 0:
                            var _$_ = 10;
                            break b;
                        case 4:
                            var _$_ = 13;
                            break b;
                        case 6:
                            var _$_ = 9;
                            break b;
                    }
                } else if (98 === c0) {
                    var _$_ = 8;
                    break b;
                }
                var _$_ = c0;
            }
            return store_char(width, ib, _$_);
        }
        return bad_input_escape(c0);
    }
    function scan_caml_string(width, ib) {
        function find_stop$0(counter, width) {
            var width$0 = width;
            for(;;){
                var c = check_next_char(cst_a_String, width$0, ib);
                if (34 === c) return ignore_char(width$0, ib);
                if (92 === c) {
                    var width$1 = ignore_char(width$0, ib), match = check_next_char(cst_a_String, width$1, ib);
                    if (10 === match) {
                        var _Y_ = ignore_char(width$1, ib);
                        if (counter >= 50) return caml_trampoline_return(skip_spaces, [
                            0,
                            _Y_
                        ]);
                        var counter$0 = counter + 1 | 0;
                        return skip_spaces(counter$0, _Y_);
                    }
                    if (13 === match) {
                        var width$3 = ignore_char(width$1, ib);
                        if (10 === check_next_char(cst_a_String, width$3, ib)) {
                            var _Z_ = ignore_char(width$3, ib);
                            if (counter >= 50) return caml_trampoline_return(skip_spaces, [
                                0,
                                _Z_
                            ]);
                            var counter$1 = counter + 1 | 0;
                            return skip_spaces(counter$1, _Z_);
                        }
                        var width$5 = store_char(width$3, ib, 13);
                        width$0 = width$5;
                    } else {
                        var width$4 = scan_backslash_char(width$1, ib);
                        width$0 = width$4;
                    }
                } else {
                    var width$2 = store_char(width$0, ib, c);
                    width$0 = width$2;
                }
            }
        }
        function find_stop(width) {
            return caml_trampoline(find_stop$0(0, width));
        }
        function skip_spaces(counter, width) {
            var width$0 = width;
            for(;;){
                if (32 !== check_next_char(cst_a_String, width$0, ib)) {
                    if (counter >= 50) return caml_trampoline_return(find_stop$0, [
                        0,
                        width$0
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return find_stop$0(counter$0, width$0);
                }
                var width$1 = ignore_char(width$0, ib);
                width$0 = width$1;
            }
        }
        var c = checked_peek_char(ib);
        return 34 === c ? find_stop(ignore_char(width, ib)) : character_mismatch(34, c);
    }
    function scan_chars_in_char_set(char_set, scan_indic, width, ib) {
        function scan_chars(i, stp) {
            var i$0 = i;
            for(;;){
                var c = peek_char(ib), _U_ = 0 < i$0 ? 1 : 0;
                if (_U_) {
                    var _V_ = 1 - ib[1];
                    if (_V_) var _W_ = caml_call2(CamlinternalFormat[1], char_set, c), _X_ = _W_ ? c !== stp ? 1 : 0 : _W_;
                    else var _X_ = _V_;
                } else var _X_ = _U_;
                if (!_X_) return _X_;
                store_char(Stdlib[19], ib, c);
                var i$1 = i$0 - 1 | 0;
                i$0 = i$1;
            }
        }
        if (!scan_indic) return scan_chars(width, -1);
        var c = scan_indic[1];
        scan_chars(width, c);
        var _T_1 = 1 - ib[1];
        if (!_T_1) return _T_1;
        var ci = peek_char(ib);
        return c === ci ? invalidate_current_char(ib) : character_mismatch(c, ci);
    }
    function scanf_bad_input(ib, x) {
        if (x[1] === Scan_failure) var s = x[2];
        else {
            if (x[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(x, 1);
            var s = x[2];
        }
        var i = char_count(ib);
        return bad_input(caml_call3(Stdlib_Printf[4], _o_, i, s));
    }
    function width_of_pad_opt(pad_opt) {
        if (!pad_opt) return Stdlib[19];
        var width = pad_opt[1];
        return width;
    }
    function stopper_of_formatting_lit(fmting) {
        if (6 === fmting) return _p_;
        var str = caml_call1(CamlinternalFormat[17], fmting), stp = caml_string_get(str, 1), sub_str = caml_call3(Stdlib_String[16], str, 2, caml_ml_string_length(str) - 2 | 0);
        return [
            0,
            stp,
            sub_str
        ];
    }
    function take_format_readers$0(counter, k, fmt) {
        var fmt$0 = fmt;
        for(;;){
            if (typeof fmt$0 === "number") return caml_call1(k, 0);
            switch(fmt$0[0]){
                case 0:
                    var rest = fmt$0[1];
                    fmt$0 = rest;
                    break;
                case 1:
                    var rest$0 = fmt$0[1];
                    fmt$0 = rest$0;
                    break;
                case 2:
                    var rest$1 = fmt$0[2];
                    fmt$0 = rest$1;
                    break;
                case 3:
                    var rest$2 = fmt$0[2];
                    fmt$0 = rest$2;
                    break;
                case 4:
                    var rest$3 = fmt$0[4];
                    fmt$0 = rest$3;
                    break;
                case 5:
                    var rest$4 = fmt$0[4];
                    fmt$0 = rest$4;
                    break;
                case 6:
                    var rest$5 = fmt$0[4];
                    fmt$0 = rest$5;
                    break;
                case 7:
                    var rest$6 = fmt$0[4];
                    fmt$0 = rest$6;
                    break;
                case 8:
                    var rest$7 = fmt$0[4];
                    fmt$0 = rest$7;
                    break;
                case 9:
                    var rest$8 = fmt$0[2];
                    fmt$0 = rest$8;
                    break;
                case 10:
                    var rest$9 = fmt$0[1];
                    fmt$0 = rest$9;
                    break;
                case 11:
                    var rest$10 = fmt$0[2];
                    fmt$0 = rest$10;
                    break;
                case 12:
                    var rest$11 = fmt$0[2];
                    fmt$0 = rest$11;
                    break;
                case 13:
                    var rest$12 = fmt$0[3];
                    fmt$0 = rest$12;
                    break;
                case 14:
                    var rest$13 = fmt$0[3], fmtty = fmt$0[2], _Q_ = caml_call1(CamlinternalFormat[21], fmtty), _R_ = caml_call1(CamlinternalFormatBasics[2], _Q_);
                    if (counter >= 50) return caml_trampoline_return(take_fmtty_format_readers$0, [
                        0,
                        k,
                        _R_,
                        rest$13
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return take_fmtty_format_readers$0(counter$0, k, _R_, rest$13);
                case 15:
                    var rest$14 = fmt$0[1];
                    fmt$0 = rest$14;
                    break;
                case 16:
                    var rest$15 = fmt$0[1];
                    fmt$0 = rest$15;
                    break;
                case 17:
                    var rest$16 = fmt$0[2];
                    fmt$0 = rest$16;
                    break;
                case 18:
                    var _S_ = fmt$0[1];
                    if (0 === _S_[0]) {
                        var rest$17 = fmt$0[2], fmt$1 = _S_[1][1], fmt$2 = caml_call2(CamlinternalFormatBasics[3], fmt$1, rest$17);
                        fmt$0 = fmt$2;
                    } else {
                        var rest$18 = fmt$0[2], fmt$3 = _S_[1][1], fmt$4 = caml_call2(CamlinternalFormatBasics[3], fmt$3, rest$18);
                        fmt$0 = fmt$4;
                    }
                    break;
                case 19:
                    var fmt_rest = fmt$0[1];
                    return function(reader) {
                        function new_k(readers_rest) {
                            return caml_call1(k, [
                                0,
                                reader,
                                readers_rest
                            ]);
                        }
                        return take_format_readers(new_k, fmt_rest);
                    };
                case 20:
                    var rest$19 = fmt$0[3];
                    fmt$0 = rest$19;
                    break;
                case 21:
                    var rest$20 = fmt$0[2];
                    fmt$0 = rest$20;
                    break;
                case 22:
                    var rest$21 = fmt$0[1];
                    fmt$0 = rest$21;
                    break;
                case 23:
                    var rest$22 = fmt$0[2], ign = fmt$0[1];
                    if (typeof ign === "number") switch(ign){
                        case 0:
                            fmt$0 = rest$22;
                            break;
                        case 1:
                            fmt$0 = rest$22;
                            break;
                        case 2:
                            return function(reader) {
                                function new_k(readers_rest) {
                                    return caml_call1(k, [
                                        0,
                                        reader,
                                        readers_rest
                                    ]);
                                }
                                return take_format_readers(new_k, rest$22);
                            };
                        default:
                            fmt$0 = rest$22;
                    }
                    else switch(ign[0]){
                        case 0:
                            fmt$0 = rest$22;
                            break;
                        case 1:
                            fmt$0 = rest$22;
                            break;
                        case 2:
                            fmt$0 = rest$22;
                            break;
                        case 3:
                            fmt$0 = rest$22;
                            break;
                        case 4:
                            fmt$0 = rest$22;
                            break;
                        case 5:
                            fmt$0 = rest$22;
                            break;
                        case 6:
                            fmt$0 = rest$22;
                            break;
                        case 7:
                            fmt$0 = rest$22;
                            break;
                        case 8:
                            fmt$0 = rest$22;
                            break;
                        case 9:
                            var fmtty$0 = ign[2];
                            if (counter >= 50) return caml_trampoline_return(take_fmtty_format_readers$0, [
                                0,
                                k,
                                fmtty$0,
                                rest$22
                            ]);
                            var counter$1 = counter + 1 | 0;
                            return take_fmtty_format_readers$0(counter$1, k, fmtty$0, rest$22);
                        case 10:
                            fmt$0 = rest$22;
                            break;
                        default:
                            fmt$0 = rest$22;
                    }
                    break;
                default:
                    var rest$23 = fmt$0[3];
                    fmt$0 = rest$23;
            }
        }
    }
    function take_format_readers(k, fmt) {
        return caml_trampoline(take_format_readers$0(0, k, fmt));
    }
    function take_fmtty_format_readers$0(counter, k, fmtty, fmt) {
        var fmtty$0 = fmtty;
        for(;;){
            if (typeof fmtty$0 === "number") {
                if (counter >= 50) return caml_trampoline_return(take_format_readers$0, [
                    0,
                    k,
                    fmt
                ]);
                var counter$0 = counter + 1 | 0;
                return take_format_readers$0(counter$0, k, fmt);
            }
            switch(fmtty$0[0]){
                case 0:
                    var fmtty$1 = fmtty$0[1];
                    fmtty$0 = fmtty$1;
                    break;
                case 1:
                    var fmtty$2 = fmtty$0[1];
                    fmtty$0 = fmtty$2;
                    break;
                case 2:
                    var fmtty$3 = fmtty$0[1];
                    fmtty$0 = fmtty$3;
                    break;
                case 3:
                    var fmtty$4 = fmtty$0[1];
                    fmtty$0 = fmtty$4;
                    break;
                case 4:
                    var fmtty$5 = fmtty$0[1];
                    fmtty$0 = fmtty$5;
                    break;
                case 5:
                    var fmtty$6 = fmtty$0[1];
                    fmtty$0 = fmtty$6;
                    break;
                case 6:
                    var fmtty$7 = fmtty$0[1];
                    fmtty$0 = fmtty$7;
                    break;
                case 7:
                    var fmtty$8 = fmtty$0[1];
                    fmtty$0 = fmtty$8;
                    break;
                case 8:
                    var fmtty$9 = fmtty$0[2];
                    fmtty$0 = fmtty$9;
                    break;
                case 9:
                    var rest = fmtty$0[3], ty2 = fmtty$0[2], ty1 = fmtty$0[1], _P_ = caml_call1(CamlinternalFormat[21], ty1), ty = caml_call2(CamlinternalFormat[22], _P_, ty2), fmtty$10 = caml_call2(CamlinternalFormatBasics[1], ty, rest);
                    fmtty$0 = fmtty$10;
                    break;
                case 10:
                    var fmtty$11 = fmtty$0[1];
                    fmtty$0 = fmtty$11;
                    break;
                case 11:
                    var fmtty$12 = fmtty$0[1];
                    fmtty$0 = fmtty$12;
                    break;
                case 12:
                    var fmtty$13 = fmtty$0[1];
                    fmtty$0 = fmtty$13;
                    break;
                case 13:
                    var fmt_rest = fmtty$0[1];
                    return function(reader) {
                        function new_k(readers_rest) {
                            return caml_call1(k, [
                                0,
                                reader,
                                readers_rest
                            ]);
                        }
                        return take_fmtty_format_readers(new_k, fmt_rest, fmt);
                    };
                default:
                    var fmt_rest$0 = fmtty$0[1];
                    return function(reader) {
                        function new_k(readers_rest) {
                            return caml_call1(k, [
                                0,
                                reader,
                                readers_rest
                            ]);
                        }
                        return take_fmtty_format_readers(new_k, fmt_rest$0, fmt);
                    };
            }
        }
    }
    function take_fmtty_format_readers(k, fmtty, fmt) {
        return caml_trampoline(take_fmtty_format_readers$0(0, k, fmtty, fmt));
    }
    function make_scanf(ib, fmt, readers) {
        var fmt$0 = fmt;
        for(;;){
            if (typeof fmt$0 === "number") return 0;
            switch(fmt$0[0]){
                case 0:
                    var rest = fmt$0[1];
                    store_char(0, ib, checked_peek_char(ib));
                    var c$0 = token_char(ib);
                    return [
                        0,
                        c$0,
                        make_scanf(ib, rest, readers)
                    ];
                case 1:
                    var rest$0 = fmt$0[1], find_stop = function(width) {
                        var c = check_next_char(cst_a_Char, width, ib);
                        return 39 === c ? ignore_char(width, ib) : character_mismatch(39, c);
                    }, c = checked_peek_char(ib), width$0 = 0;
                    if (39 === c) {
                        var width = ignore_char(width$0, ib), c$3 = check_next_char(cst_a_Char, width, ib);
                        if (92 === c$3) find_stop(scan_backslash_char(ignore_char(width, ib), ib));
                        else find_stop(store_char(width, ib, c$3));
                    } else character_mismatch(39, c);
                    var c$1 = token_char(ib);
                    return [
                        0,
                        c$1,
                        make_scanf(ib, rest$0, readers)
                    ];
                case 2:
                    var pad = fmt$0[1], match = fmt$0[2];
                    if (typeof match !== "number") switch(match[0]){
                        case 17:
                            var rest$2 = match[2], fmting_lit = match[1], match$0 = stopper_of_formatting_lit(fmting_lit), str = match$0[2], stp = match$0[1], scan$0 = function(width, param, ib) {
                                return scan_string([
                                    0,
                                    stp
                                ], width, ib);
                            }, str_rest = [
                                11,
                                str,
                                rest$2
                            ];
                            return pad_prec_scanf(ib, str_rest, readers, pad, 0, scan$0, token_string);
                        case 18:
                            var _D_ = match[1];
                            if (0 === _D_[0]) {
                                var rest$3 = match[2], fmt$1 = _D_[1][1], scan$1 = function(width, param, ib) {
                                    return scan_string(_q_, width, ib);
                                };
                                return pad_prec_scanf(ib, caml_call2(CamlinternalFormatBasics[3], fmt$1, rest$3), readers, pad, 0, scan$1, token_string);
                            }
                            var rest$4 = match[2], fmt$2 = _D_[1][1], scan$2 = function(width, param, ib) {
                                return scan_string(_r_, width, ib);
                            };
                            return pad_prec_scanf(ib, caml_call2(CamlinternalFormatBasics[3], fmt$2, rest$4), readers, pad, 0, scan$2, token_string);
                    }
                    var rest$1 = fmt$0[2], scan = function(width, param, ib) {
                        return scan_string(0, width, ib);
                    };
                    return pad_prec_scanf(ib, rest$1, readers, pad, 0, scan, token_string);
                case 3:
                    var rest$5 = fmt$0[2], pad$0 = fmt$0[1], scan$3 = function(width, param, ib) {
                        return scan_caml_string(width, ib);
                    };
                    return pad_prec_scanf(ib, rest$5, readers, pad$0, 0, scan$3, token_string);
                case 4:
                    var rest$6 = fmt$0[4], prec = fmt$0[3], pad$1 = fmt$0[2], iconv = fmt$0[1], conv = integer_conversion_of_char(caml_call1(CamlinternalFormat[16], iconv)), scan$4 = function(width, param, ib) {
                        return scan_int_conversion(conv, width, ib);
                    };
                    return pad_prec_scanf(ib, rest$6, readers, pad$1, prec, scan$4, function(ib) {
                        return caml_int_of_string(token_int_literal(conv, ib));
                    });
                case 5:
                    var rest$7 = fmt$0[4], prec$0 = fmt$0[3], pad$2 = fmt$0[2], iconv$0 = fmt$0[1], conv$0 = integer_conversion_of_char(caml_call1(CamlinternalFormat[16], iconv$0)), scan$5 = function(width, param, ib) {
                        return scan_int_conversion(conv$0, width, ib);
                    };
                    return pad_prec_scanf(ib, rest$7, readers, pad$2, prec$0, scan$5, function(ib) {
                        return caml_int_of_string(token_int_literal(conv$0, ib));
                    });
                case 6:
                    var rest$8 = fmt$0[4], prec$1 = fmt$0[3], pad$3 = fmt$0[2], iconv$1 = fmt$0[1], conv$1 = integer_conversion_of_char(caml_call1(CamlinternalFormat[16], iconv$1)), scan$6 = function(width, param, ib) {
                        return scan_int_conversion(conv$1, width, ib);
                    };
                    return pad_prec_scanf(ib, rest$8, readers, pad$3, prec$1, scan$6, function(ib) {
                        return caml_int_of_string(token_int_literal(conv$1, ib));
                    });
                case 7:
                    var rest$9 = fmt$0[4], prec$2 = fmt$0[3], pad$4 = fmt$0[2], iconv$2 = fmt$0[1], conv$2 = integer_conversion_of_char(caml_call1(CamlinternalFormat[16], iconv$2)), scan$7 = function(width, param, ib) {
                        return scan_int_conversion(conv$2, width, ib);
                    };
                    return pad_prec_scanf(ib, rest$9, readers, pad$4, prec$2, scan$7, function(ib) {
                        return runtime.caml_int64_of_string(token_int_literal(conv$2, ib));
                    });
                case 8:
                    switch(fmt$0[1][2]){
                        case 5:
                        case 8:
                            var rest$11 = fmt$0[4], prec$4 = fmt$0[3], pad$6 = fmt$0[2];
                            return pad_prec_scanf(ib, rest$11, readers, pad$6, prec$4, scan_caml_float, token_float);
                        case 6:
                        case 7:
                            var rest$12 = fmt$0[4], prec$5 = fmt$0[3], pad$7 = fmt$0[2];
                            return pad_prec_scanf(ib, rest$12, readers, pad$7, prec$5, scan_hex_float, token_float);
                        default:
                            var rest$10 = fmt$0[4], prec$3 = fmt$0[3], pad$5 = fmt$0[2];
                            return pad_prec_scanf(ib, rest$10, readers, pad$5, prec$3, scan_float, token_float);
                    }
                case 9:
                    var rest$13 = fmt$0[2], pad$8 = fmt$0[1], scan$8 = function(_O_, param, ib) {
                        var c = checked_peek_char(ib), m = 102 === c ? 5 : 116 === c ? 4 : bad_input(caml_call2(Stdlib_Printf[4], _n_, c));
                        return scan_string(0, m, ib);
                    };
                    return pad_prec_scanf(ib, rest$13, readers, pad$8, 0, scan$8, token_bool);
                case 10:
                    var rest$14 = fmt$0[1];
                    if (!end_of_input(ib)) return bad_input(cst_end_of_input_not_found);
                    fmt$0 = rest$14;
                    break;
                case 11:
                    var rest$15 = fmt$0[2], str$0 = fmt$0[1];
                    caml_call2(Stdlib_String[30], function(_N_) {
                        return check_char(ib, _N_);
                    }, str$0);
                    fmt$0 = rest$15;
                    break;
                case 12:
                    var rest$16 = fmt$0[2], chr = fmt$0[1];
                    check_char(ib, chr);
                    fmt$0 = rest$16;
                    break;
                case 13:
                    var rest$17 = fmt$0[3], fmtty = fmt$0[2], pad_opt = fmt$0[1];
                    scan_caml_string(width_of_pad_opt(pad_opt), ib);
                    var s = token_string(ib);
                    try {
                        var _E_ = caml_call2(CamlinternalFormat[14], s, fmtty), fmt$3 = _E_;
                    } catch (exn$0) {
                        var exn = caml_wrap_exception(exn$0);
                        if (exn[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(exn, 0);
                        var msg = exn[2], fmt$3 = bad_input(msg);
                    }
                    return [
                        0,
                        fmt$3,
                        make_scanf(ib, rest$17, readers)
                    ];
                case 14:
                    var rest$18 = fmt$0[3], fmtty$0 = fmt$0[2], pad_opt$0 = fmt$0[1];
                    scan_caml_string(width_of_pad_opt(pad_opt$0), ib);
                    var s$0 = token_string(ib);
                    try {
                        var fmt$6 = caml_call2(CamlinternalFormat[13], 0, s$0)[1], fmt$7 = caml_call2(CamlinternalFormat[13], 0, s$0)[1], _G_ = caml_call1(CamlinternalFormat[21], fmtty$0), _H_ = caml_call1(CamlinternalFormatBasics[2], _G_), fmt$8 = caml_call2(CamlinternalFormat[12], fmt$7, _H_), _I_ = caml_call1(CamlinternalFormatBasics[2], fmtty$0), _J_ = caml_call2(CamlinternalFormat[12], fmt$6, _I_), fmt$5 = fmt$8, fmt$4 = _J_;
                    } catch (exn) {
                        var exn$0 = caml_wrap_exception(exn);
                        if (exn$0[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(exn$0, 0);
                        var msg$0 = exn$0[2], _F_ = bad_input(msg$0), fmt$5 = _F_[2], fmt$4 = _F_[1];
                    }
                    return [
                        0,
                        [
                            0,
                            fmt$4,
                            s$0
                        ],
                        make_scanf(ib, caml_call2(CamlinternalFormatBasics[3], fmt$5, rest$18), readers)
                    ];
                case 15:
                    return caml_call1(Stdlib[1], cst_scanf_bad_conversion_a);
                case 16:
                    return caml_call1(Stdlib[1], cst_scanf_bad_conversion_t);
                case 17:
                    var rest$19 = fmt$0[2], formatting_lit = fmt$0[1], _K_ = caml_call1(CamlinternalFormat[17], formatting_lit);
                    caml_call2(Stdlib_String[30], function(_M_) {
                        return check_char(ib, _M_);
                    }, _K_);
                    fmt$0 = rest$19;
                    break;
                case 18:
                    var _L_ = fmt$0[1];
                    if (0 === _L_[0]) {
                        var rest$20 = fmt$0[2], fmt$9 = _L_[1][1];
                        check_char(ib, 64);
                        check_char(ib, 123);
                        var fmt$10 = caml_call2(CamlinternalFormatBasics[3], fmt$9, rest$20);
                        fmt$0 = fmt$10;
                    } else {
                        var rest$21 = fmt$0[2], fmt$11 = _L_[1][1];
                        check_char(ib, 64);
                        check_char(ib, 91);
                        var fmt$12 = caml_call2(CamlinternalFormatBasics[3], fmt$11, rest$21);
                        fmt$0 = fmt$12;
                    }
                    break;
                case 19:
                    var fmt_rest = fmt$0[1];
                    if (!readers) return caml_call1(Stdlib[1], cst_scanf_missing_reader);
                    var readers_rest = readers[2], reader = readers[1], x = caml_call1(reader, ib);
                    return [
                        0,
                        x,
                        make_scanf(ib, fmt_rest, readers_rest)
                    ];
                case 20:
                    var width_opt = fmt$0[1], match$1 = fmt$0[3];
                    if (typeof match$1 !== "number" && 17 === match$1[0]) {
                        var rest$23 = match$1[2], fmting_lit$0 = match$1[1], char_set$0 = fmt$0[2], match$2 = stopper_of_formatting_lit(fmting_lit$0), str$1 = match$2[2], stp$0 = match$2[1], width$2 = width_of_pad_opt(width_opt);
                        scan_chars_in_char_set(char_set$0, [
                            0,
                            stp$0
                        ], width$2, ib);
                        var s$2 = token_string(ib), str_rest$0 = [
                            11,
                            str$1,
                            rest$23
                        ];
                        return [
                            0,
                            s$2,
                            make_scanf(ib, str_rest$0, readers)
                        ];
                    }
                    var rest$22 = fmt$0[3], char_set = fmt$0[2], width$1 = width_of_pad_opt(width_opt);
                    scan_chars_in_char_set(char_set, 0, width$1, ib);
                    var s$1 = token_string(ib);
                    return [
                        0,
                        s$1,
                        make_scanf(ib, rest$22, readers)
                    ];
                case 21:
                    var rest$24 = fmt$0[2], counter = fmt$0[1];
                    switch(counter){
                        case 0:
                            var count = ib[5];
                            break;
                        case 1:
                            var count = char_count(ib);
                            break;
                        default:
                            var count = ib[6];
                    }
                    return [
                        0,
                        count,
                        make_scanf(ib, rest$24, readers)
                    ];
                case 22:
                    var rest$25 = fmt$0[1], c$2 = checked_peek_char(ib);
                    return [
                        0,
                        c$2,
                        make_scanf(ib, rest$25, readers)
                    ];
                case 23:
                    var rest$26 = fmt$0[2], ign = fmt$0[1], fmt$13 = caml_call2(CamlinternalFormat[6], ign, rest$26)[1], match$3 = make_scanf(ib, fmt$13, readers);
                    if (!match$3) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _s_
                    ], 1);
                    var arg_rest = match$3[2];
                    return arg_rest;
                default:
                    return caml_call1(Stdlib[1], cst_scanf_bad_conversion_custo);
            }
        }
    }
    function pad_prec_scanf(ib, fmt, readers, pad, prec, scan, token) {
        if (typeof pad === "number") {
            if (typeof prec !== "number") {
                var p = prec[1];
                caml_call3(scan, Stdlib[19], p, ib);
                var x$0 = caml_call1(token, ib);
                return [
                    0,
                    x$0,
                    make_scanf(ib, fmt, readers)
                ];
            }
            if (prec) return caml_call1(Stdlib[1], cst_scanf_bad_conversion);
            caml_call3(scan, Stdlib[19], Stdlib[19], ib);
            var x = caml_call1(token, ib);
            return [
                0,
                x,
                make_scanf(ib, fmt, readers)
            ];
        }
        if (0 !== pad[0]) return caml_call1(Stdlib[1], cst_scanf_bad_conversion$2);
        if (!pad[1]) return caml_call1(Stdlib[1], cst_scanf_bad_conversion$1);
        var w = pad[2];
        if (typeof prec !== "number") {
            var p$0 = prec[1];
            caml_call3(scan, w, p$0, ib);
            var x$2 = caml_call1(token, ib);
            return [
                0,
                x$2,
                make_scanf(ib, fmt, readers)
            ];
        }
        if (prec) return caml_call1(Stdlib[1], cst_scanf_bad_conversion$0);
        caml_call3(scan, w, Stdlib[19], ib);
        var x$1 = caml_call1(token, ib);
        return [
            0,
            x$1,
            make_scanf(ib, fmt, readers)
        ];
    }
    function kscanf_gen(ib, ef, af, param) {
        var str = param[2], fmt = param[1];
        function k(readers, f$1) {
            caml_call1(Stdlib_Buffer[9], ib[8]);
            try {
                var args$1 = make_scanf(ib, fmt, readers);
            } catch (exc$0) {
                var exc = caml_wrap_exception(exc$0);
                if (exc[1] !== Scan_failure && exc[1] !== Stdlib[7] && exc !== Stdlib[12]) {
                    if (exc[1] !== Stdlib[6]) throw caml_maybe_attach_backtrace(exc, 0);
                    var msg = exc[2], _z_ = caml_call1(Stdlib_String[25], str), _A_ = caml_call2(Stdlib[28], _z_, cst$0), _B_ = caml_call2(Stdlib[28], cst_in_format, _A_), _C_ = caml_call2(Stdlib[28], msg, _B_);
                    return caml_call1(Stdlib[1], _C_);
                }
                return caml_call2(ef, ib, exc);
            }
            var f = f$1, args = args$1;
            for(;;){
                if (!args) return caml_call1(af, f);
                var args$0 = args[2], x = args[1], f$0 = caml_call1(f, x);
                f = f$0;
                args = args$0;
            }
        }
        return take_format_readers(k, fmt);
    }
    function kscanf(ib, ef, fmt) {
        return kscanf_gen(ib, ef, function(x) {
            return x;
        }, fmt);
    }
    function kscanf_opt(ib, fmt) {
        return kscanf_gen(ib, function(_y_, param) {
            return 0;
        }, function(x) {
            return [
                0,
                x
            ];
        }, fmt);
    }
    function bscanf(ib, fmt) {
        return kscanf(ib, scanf_bad_input, fmt);
    }
    function bscanf_opt(ib, fmt) {
        return kscanf_opt(ib, fmt);
    }
    function ksscanf(s, ef, fmt) {
        return kscanf(from_string(s), ef, fmt);
    }
    function sscanf(s, fmt) {
        return kscanf(from_string(s), scanf_bad_input, fmt);
    }
    function sscanf_opt(s, fmt) {
        return kscanf_opt(from_string(s), fmt);
    }
    function scanf(fmt) {
        return kscanf(stdin, scanf_bad_input, fmt);
    }
    function scanf_opt(fmt) {
        return kscanf_opt(stdin, fmt);
    }
    function bscanf_format(ib, format, f) {
        scan_caml_string(Stdlib[19], ib);
        var str = token_string(ib);
        try {
            var _x_ = caml_call2(CamlinternalFormat[15], str, format), fmt = _x_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(exn, 0);
            var msg = exn[2], fmt = bad_input(msg);
        }
        return caml_call1(f, fmt);
    }
    function sscanf_format(s, format, f) {
        return bscanf_format(from_string(s), format, f);
    }
    function format_from_string(s, fmt) {
        var _v_ = caml_call1(Stdlib_String[25], s), _w_ = caml_call2(Stdlib[28], _v_, cst$1);
        return sscanf_format(caml_call2(Stdlib[28], cst$2, _w_), fmt, function(x) {
            return x;
        });
    }
    function unescaped(s) {
        var _u_ = caml_call2(Stdlib[28], s, cst$3);
        return caml_call1(sscanf(caml_call2(Stdlib[28], cst$4, _u_), _t_), function(x) {
            return x;
        });
    }
    var Stdlib_Scanf = [
        0,
        [
            0,
            stdin,
            open_in,
            open_in_bin,
            close_in,
            open_in,
            open_in_bin,
            from_string,
            from_function,
            from_channel,
            end_of_input,
            beginning_of_input,
            name_of_input
        ],
        Scan_failure,
        bscanf,
        bscanf_opt,
        sscanf,
        sscanf_opt,
        scanf,
        scanf_opt,
        kscanf,
        ksscanf,
        bscanf_format,
        sscanf_format,
        format_from_string,
        unescaped
    ];
    runtime.caml_register_global(64, Stdlib_Scanf, "Stdlib__Scanf");
    return;
})(globalThis);
//# 24849 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_register_named_value = runtime.caml_register_named_value, global_data = runtime.caml_get_global_data(), Stdlib_Obj = global_data.Stdlib__Obj, register = caml_register_named_value;
    function register_exception(name, exn) {
        var _a_ = Stdlib_Obj[10], slot = runtime.caml_obj_tag(exn) === _a_ ? exn : exn[1];
        return caml_register_named_value(name, slot);
    }
    var Stdlib_Callback = [
        0,
        register,
        register_exception
    ];
    runtime.caml_register_global(1, Stdlib_Callback, "Stdlib__Callback");
    return;
})(globalThis);
//# 24872 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_camlinternalOO_ml = "camlinternalOO.ml", caml_check_bound = runtime.caml_check_bound, caml_div = runtime.caml_div, caml_get_public_method = runtime.caml_get_public_method, caml_make_vect = runtime.caml_make_vect, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_block = runtime.caml_obj_block, caml_set_oo_id = runtime.caml_set_oo_id, caml_string_compare = runtime.caml_string_compare, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Assert_failure = global_data.Assert_failure, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Obj = global_data.Stdlib__Obj, Stdlib = global_data.Stdlib, Stdlib_Array = global_data.Stdlib__Array, Stdlib_List = global_data.Stdlib__List, Stdlib_Map = global_data.Stdlib__Map;
    function copy(o) {
        var o$0 = o.slice();
        return caml_set_oo_id(o$0);
    }
    var params = [
        0,
        1,
        1,
        1,
        3,
        16
    ];
    function public_method_label(s) {
        var accu = [
            0,
            0
        ], _al_ = runtime.caml_ml_string_length(s) - 1 | 0, _ak_ = 0;
        if (_al_ >= 0) {
            var i = _ak_;
            for(;;){
                var _am_ = runtime.caml_string_get(s, i);
                accu[1] = (223 * accu[1] | 0) + _am_ | 0;
                var _an_ = i + 1 | 0;
                if (_al_ === i) break;
                i = _an_;
            }
        }
        accu[1] = accu[1] & 2147483647;
        var tag = 1073741823 < accu[1] ? accu[1] + 2147483648 | 0 : accu[1];
        return tag;
    }
    var compare = caml_string_compare, Vars = caml_call1(Stdlib_Map[1], [
        0,
        compare
    ]), compare$0 = caml_string_compare, Meths = caml_call1(Stdlib_Map[1], [
        0,
        compare$0
    ]), compare$1 = runtime.caml_int_compare, Labs = caml_call1(Stdlib_Map[1], [
        0,
        compare$1
    ]), dummy_table = [
        0,
        0,
        [
            0,
            0
        ],
        Meths[1],
        Labs[1],
        0,
        0,
        Vars[1],
        0
    ], table_count = [
        0,
        0
    ], dummy_met = caml_obj_block(0, 0), initial_object_size = 2;
    function fit_size(n) {
        return 2 < n ? fit_size((n + 1 | 0) / 2 | 0) * 2 | 0 : n;
    }
    function new_table(pub_labels) {
        table_count[1]++;
        var len = pub_labels.length - 1, methods = caml_make_vect((len * 2 | 0) + 2 | 0, dummy_met);
        caml_check_bound(methods, 0)[1] = len;
        var _ad_ = Stdlib_Sys[9], _ae_ = (runtime.caml_mul(fit_size(len), _ad_) / 8 | 0) - 1 | 0;
        caml_check_bound(methods, 1)[2] = _ae_;
        var _ag_ = len - 1 | 0, _af_ = 0;
        if (_ag_ >= 0) {
            var i = _af_;
            for(;;){
                var _ai_ = (i * 2 | 0) + 3 | 0, _ah_ = caml_check_bound(pub_labels, i)[1 + i];
                caml_check_bound(methods, _ai_)[1 + _ai_] = _ah_;
                var _aj_ = i + 1 | 0;
                if (_ag_ === i) break;
                i = _aj_;
            }
        }
        return [
            0,
            initial_object_size,
            methods,
            Meths[1],
            Labs[1],
            0,
            0,
            Vars[1],
            0
        ];
    }
    function resize(array, new_size) {
        var old_size = array[2].length - 1, _ab_ = old_size < new_size ? 1 : 0;
        if (_ab_) {
            var new_buck = caml_make_vect(new_size, dummy_met);
            caml_call5(Stdlib_Array[9], array[2], 0, new_buck, 0, old_size);
            array[2] = new_buck;
            var _ac_ = 0;
        } else var _ac_ = _ab_;
        return _ac_;
    }
    var method_count = [
        0,
        0
    ], inst_var_count = [
        0,
        0
    ], _a_ = [
        0,
        cst_camlinternalOO_ml,
        279,
        50
    ], _b_ = [
        0,
        cst_camlinternalOO_ml,
        407,
        13
    ], _c_ = [
        0,
        cst_camlinternalOO_ml,
        410,
        13
    ], _d_ = [
        0,
        cst_camlinternalOO_ml,
        413,
        13
    ], _e_ = [
        0,
        cst_camlinternalOO_ml,
        416,
        13
    ], _f_ = [
        0,
        cst_camlinternalOO_ml,
        419,
        13
    ], _g_ = [
        0,
        cst_camlinternalOO_ml,
        437,
        17
    ];
    function new_method(table) {
        var index = table[2].length - 1;
        resize(table, index + 1 | 0);
        return index;
    }
    function get_method_label(table, name) {
        try {
            var _$_ = caml_call2(Meths[17], name, table[3]);
            return _$_;
        } catch (_aa_) {
            var ___ = caml_wrap_exception(_aa_);
            if (___ !== Stdlib[8]) throw caml_maybe_attach_backtrace(___, 0);
            var label = new_method(table);
            table[3] = caml_call3(Meths[2], name, label, table[3]);
            table[4] = caml_call3(Labs[2], label, 1, table[4]);
            return label;
        }
    }
    function get_method_labels(table, names) {
        return caml_call2(Stdlib_Array[14], function(_Z_) {
            return get_method_label(table, _Z_);
        }, names);
    }
    function set_method(table, label, element) {
        method_count[1]++;
        return caml_call2(Labs[17], label, table[4]) ? (resize(table, label + 1 | 0), caml_check_bound(table[2], label)[1 + label] = element, 0) : (table[6] = [
            0,
            [
                0,
                label,
                element
            ],
            table[6]
        ], 0);
    }
    function get_method(table, label) {
        try {
            var _X_ = caml_call2(Stdlib_List[49], label, table[6]);
            return _X_;
        } catch (_Y_) {
            var _W_ = caml_wrap_exception(_Y_);
            if (_W_ === Stdlib[8]) return caml_check_bound(table[2], label)[1 + label];
            throw caml_maybe_attach_backtrace(_W_, 0);
        }
    }
    function to_list(arr) {
        return 0 === arr ? 0 : caml_call1(Stdlib_Array[10], arr);
    }
    function narrow(table, vars, virt_meths, concr_meths) {
        var vars$0 = to_list(vars), virt_meths$0 = to_list(virt_meths), concr_meths$0 = to_list(concr_meths), virt_meth_labs = caml_call2(Stdlib_List[20], function(_V_) {
            return get_method_label(table, _V_);
        }, virt_meths$0), concr_meth_labs = caml_call2(Stdlib_List[20], function(_U_) {
            return get_method_label(table, _U_);
        }, concr_meths$0);
        table[5] = [
            0,
            [
                0,
                table[3],
                table[4],
                table[6],
                table[7],
                virt_meth_labs,
                vars$0
            ],
            table[5]
        ];
        table[7] = caml_call3(Vars[24], function(lab, info, tvars) {
            return caml_call2(Stdlib_List[37], lab, vars$0) ? caml_call3(Vars[2], lab, info, tvars) : tvars;
        }, table[7], Vars[1]);
        var by_name = [
            0,
            Meths[1]
        ], by_label = [
            0,
            Labs[1]
        ];
        caml_call3(Stdlib_List[28], function(met, label) {
            by_name[1] = caml_call3(Meths[2], met, label, by_name[1]);
            var _P_ = by_label[1];
            try {
                var _S_ = caml_call2(Labs[17], label, table[4]), _R_ = _S_;
            } catch (_T_1) {
                var _Q_ = caml_wrap_exception(_T_1);
                if (_Q_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_Q_, 0);
                var _R_ = 1;
            }
            by_label[1] = caml_call3(Labs[2], label, _R_, _P_);
            return 0;
        }, concr_meths$0, concr_meth_labs);
        caml_call3(Stdlib_List[28], function(met, label) {
            by_name[1] = caml_call3(Meths[2], met, label, by_name[1]);
            by_label[1] = caml_call3(Labs[2], label, 0, by_label[1]);
            return 0;
        }, virt_meths$0, virt_meth_labs);
        table[3] = by_name[1];
        table[4] = by_label[1];
        table[6] = caml_call3(Stdlib_List[27], function(met, hm) {
            var lab = met[1];
            return caml_call2(Stdlib_List[37], lab, virt_meth_labs) ? hm : [
                0,
                met,
                hm
            ];
        }, table[6], 0);
        return 0;
    }
    function widen(table) {
        var match = caml_call1(Stdlib_List[6], table[5]), vars = match[6], virt_meths = match[5], saved_vars = match[4], saved_hidden_meths = match[3], by_label = match[2], by_name = match[1];
        table[5] = caml_call1(Stdlib_List[7], table[5]);
        table[7] = caml_call3(Stdlib_List[26], function(s, v) {
            var _O_ = caml_call2(Vars[17], v, table[7]);
            return caml_call3(Vars[2], v, _O_, s);
        }, saved_vars, vars);
        table[3] = by_name;
        table[4] = by_label;
        table[6] = caml_call3(Stdlib_List[27], function(met, hm) {
            var lab = met[1];
            return caml_call2(Stdlib_List[37], lab, virt_meths) ? hm : [
                0,
                met,
                hm
            ];
        }, table[6], saved_hidden_meths);
        return 0;
    }
    function new_variable(table, name) {
        try {
            var _M_ = caml_call2(Vars[17], name, table[7]);
            return _M_;
        } catch (_N_) {
            var _L_ = caml_wrap_exception(_N_);
            if (_L_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_L_, 0);
            var index = table[1];
            table[1] = index + 1 | 0;
            if (name !== "") table[7] = caml_call3(Vars[2], name, index, table[7]);
            return index;
        }
    }
    function to_array(arr) {
        return runtime.caml_equal(arr, 0) ? [
            0
        ] : arr;
    }
    function new_methods_variables(table, meths, vals) {
        var meths$0 = to_array(meths), nmeths = meths$0.length - 1, nvals = vals.length - 1, res = caml_make_vect(nmeths + nvals | 0, 0), _D_ = nmeths - 1 | 0, _C_ = 0;
        if (_D_ >= 0) {
            var i$0 = _C_;
            for(;;){
                var _J_ = get_method_label(table, caml_check_bound(meths$0, i$0)[1 + i$0]);
                caml_check_bound(res, i$0)[1 + i$0] = _J_;
                var _K_ = i$0 + 1 | 0;
                if (_D_ === i$0) break;
                i$0 = _K_;
            }
        }
        var _F_ = nvals - 1 | 0, _E_ = 0;
        if (_F_ >= 0) {
            var i = _E_;
            for(;;){
                var _H_ = i + nmeths | 0, _G_ = new_variable(table, caml_check_bound(vals, i)[1 + i]);
                caml_check_bound(res, _H_)[1 + _H_] = _G_;
                var _I_ = i + 1 | 0;
                if (_F_ === i) break;
                i = _I_;
            }
        }
        return res;
    }
    function get_variable(table, name) {
        try {
            var _A_ = caml_call2(Vars[17], name, table[7]);
            return _A_;
        } catch (_B_) {
            var _z_ = caml_wrap_exception(_B_);
            if (_z_ === Stdlib[8]) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _a_
            ], 1);
            throw caml_maybe_attach_backtrace(_z_, 0);
        }
    }
    function get_variables(table, names) {
        return caml_call2(Stdlib_Array[14], function(_y_) {
            return get_variable(table, _y_);
        }, names);
    }
    function add_initializer(table, f) {
        table[8] = [
            0,
            f,
            table[8]
        ];
        return 0;
    }
    function create_table(public_methods) {
        if (0 === public_methods) return new_table([
            0
        ]);
        var tags = caml_call2(Stdlib_Array[14], public_method_label, public_methods), table = new_table(tags);
        caml_call2(Stdlib_Array[13], function(i, met) {
            var lab = (i * 2 | 0) + 2 | 0;
            table[3] = caml_call3(Meths[2], met, lab, table[3]);
            table[4] = caml_call3(Labs[2], lab, 1, table[4]);
            return 0;
        }, public_methods);
        return table;
    }
    function init_class(table) {
        inst_var_count[1] = (inst_var_count[1] + table[1] | 0) - 1 | 0;
        table[8] = caml_call1(Stdlib_List[10], table[8]);
        var _x_ = Stdlib_Sys[9];
        return resize(table, 3 + caml_div(caml_check_bound(table[2], 1)[2] * 16 | 0, _x_) | 0);
    }
    function inherits(cla, vals, virt_meths, concr_meths, param, top) {
        var env = param[4], super$0 = param[2];
        narrow(cla, vals, virt_meths, concr_meths);
        var init = top ? caml_call2(super$0, cla, env) : caml_call1(super$0, cla);
        widen(cla);
        var _s_ = to_array(concr_meths), _t_ = [
            0,
            caml_call2(Stdlib_Array[14], function(nm) {
                return get_method(cla, get_method_label(cla, nm));
            }, _s_),
            0
        ], _u_ = to_array(vals), _v_ = [
            0,
            [
                0,
                init
            ],
            [
                0,
                caml_call2(Stdlib_Array[14], function(_w_) {
                    return get_variable(cla, _w_);
                }, _u_),
                _t_
            ]
        ];
        return caml_call1(Stdlib_Array[5], _v_);
    }
    function make_class(pub_meths, class_init) {
        var table = create_table(pub_meths), env_init = caml_call1(class_init, table);
        init_class(table);
        return [
            0,
            caml_call1(env_init, 0),
            class_init,
            env_init,
            0
        ];
    }
    function make_class_store(pub_meths, class_init, init_table) {
        var table = create_table(pub_meths), env_init = caml_call1(class_init, table);
        init_class(table);
        init_table[2] = class_init;
        init_table[1] = env_init;
        return 0;
    }
    function dummy_class(loc) {
        function undef(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Stdlib[15],
                loc
            ], 1);
        }
        return [
            0,
            undef,
            undef,
            undef,
            0
        ];
    }
    function create_object(table) {
        var obj = caml_obj_block(Stdlib_Obj[10], table[1]);
        obj[1] = table[2];
        return caml_set_oo_id(obj);
    }
    function create_object_opt(obj_0, table) {
        if (obj_0) return obj_0;
        var obj = caml_obj_block(Stdlib_Obj[10], table[1]);
        obj[1] = table[2];
        return caml_set_oo_id(obj);
    }
    function iter_f(obj, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], f = param$0[1];
            caml_call1(f, obj);
            param$0 = l;
        }
    }
    function run_initializers(obj, table) {
        var inits = table[8], _r_ = 0 !== inits ? 1 : 0;
        return _r_ ? iter_f(obj, inits) : _r_;
    }
    function run_initializers_opt(obj_0, obj, table) {
        if (obj_0) return obj;
        var inits = table[8];
        if (0 !== inits) iter_f(obj, inits);
        return obj;
    }
    function create_object_and_run_initiali(obj_0, table) {
        if (obj_0) return obj_0;
        var obj = create_object(table);
        run_initializers(obj, table);
        return obj;
    }
    function get_data(param) {
        if (param) return param[2];
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
    }
    function build_path(n, keys, tables) {
        var res = [
            0,
            0,
            0,
            0
        ], r = [
            0,
            res
        ], _o_ = 0;
        if (n >= 0) {
            var i = _o_;
            for(;;){
                var _p_ = r[1];
                r[1] = [
                    0,
                    caml_check_bound(keys, i)[1 + i],
                    _p_,
                    0
                ];
                var _q_ = i + 1 | 0;
                if (n === i) break;
                i = _q_;
            }
        }
        var v = r[1];
        if (!tables) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        tables[2] = v;
        return res;
    }
    function lookup_tables(root, keys) {
        var root_data = get_data(root);
        if (!root_data) return build_path(keys.length - 2 | 0, keys, root);
        var i$1 = keys.length - 2 | 0, i = i$1, tables$0 = root_data;
        for(;;){
            if (0 > i) return tables$0;
            var key = caml_check_bound(keys, i)[1 + i], tables$1 = tables$0;
            for(;;){
                if (!tables$1) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _d_
                ], 1);
                if (tables$1[1] === key) break;
                if (!tables$1) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _f_
                ], 1);
                var tables = tables$1[3];
                if (!tables) {
                    var next = [
                        0,
                        key,
                        0,
                        0
                    ];
                    if (!tables$1) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _c_
                    ], 1);
                    tables$1[3] = next;
                    return build_path(i - 1 | 0, keys, next);
                }
                tables$1 = tables;
            }
            var tables_data = get_data(tables$1);
            if (!tables_data) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _g_
            ], 1);
            var i$0 = i - 1 | 0;
            i = i$0;
            tables$0 = tables_data;
        }
    }
    function new_cache(table) {
        var n = new_method(table);
        a: {
            if (0 !== (n % 2 | 0)) {
                var _n_ = Stdlib_Sys[9];
                if ((2 + caml_div(caml_check_bound(table[2], 1)[2] * 16 | 0, _n_) | 0) >= n) {
                    var n$0 = new_method(table);
                    break a;
                }
            }
            var n$0 = n;
        }
        caml_check_bound(table[2], n$0)[1 + n$0] = 0;
        return n$0;
    }
    function set_methods(table, methods) {
        var len = methods.length - 1, i = [
            0,
            0
        ];
        for(;;){
            if (i[1] >= len) return 0;
            var _h_ = i[1], label = caml_check_bound(methods, _h_)[1 + _h_], next = function(param) {
                i[1]++;
                var _m_ = i[1];
                return caml_check_bound(methods, _m_)[1 + _m_];
            }, clo = next(0);
            if (typeof clo === "number") switch(clo){
                case 0:
                    var x = next(0);
                    let x$20 = x;
                    var clo$0 = function(obj) {
                        return x$20;
                    };
                    break;
                case 1:
                    var n = next(0);
                    let n$38 = n;
                    var clo$0 = function(obj) {
                        return obj[1 + n$38];
                    };
                    break;
                case 2:
                    var e = next(0), n$0 = next(0);
                    let e$10 = e, n$37 = n$0;
                    var clo$0 = function(obj) {
                        return obj[1 + e$10][1 + n$37];
                    };
                    break;
                case 3:
                    var n$1 = next(0);
                    let n$36 = n$1;
                    var clo$0 = function(obj) {
                        return caml_call1(obj[1][1 + n$36], obj);
                    };
                    break;
                case 4:
                    var n$2 = next(0);
                    let n$35 = n$2;
                    var clo$0 = function(obj, x) {
                        obj[1 + n$35] = x;
                        return 0;
                    };
                    break;
                case 5:
                    var f = next(0), x$0 = next(0);
                    let f$20 = f, x$19 = x$0;
                    var clo$0 = function(obj) {
                        return caml_call1(f$20, x$19);
                    };
                    break;
                case 6:
                    var f$0 = next(0), n$3 = next(0);
                    let f$19 = f$0, n$34 = n$3;
                    var clo$0 = function(obj) {
                        return caml_call1(f$19, obj[1 + n$34]);
                    };
                    break;
                case 7:
                    var f$1 = next(0), e$0 = next(0), n$4 = next(0);
                    let f$18 = f$1, e$9 = e$0, n$33 = n$4;
                    var clo$0 = function(obj) {
                        return caml_call1(f$18, obj[1 + e$9][1 + n$33]);
                    };
                    break;
                case 8:
                    var f$2 = next(0), n$5 = next(0);
                    let f$17 = f$2, n$32 = n$5;
                    var clo$0 = function(obj) {
                        return caml_call1(f$17, caml_call1(obj[1][1 + n$32], obj));
                    };
                    break;
                case 9:
                    var f$3 = next(0), x$1 = next(0), y = next(0);
                    let f$16 = f$3, x$18 = x$1, y$0 = y;
                    var clo$0 = function(obj) {
                        return caml_call2(f$16, x$18, y$0);
                    };
                    break;
                case 10:
                    var f$4 = next(0), x$2 = next(0), n$6 = next(0);
                    let f$15 = f$4, x$17 = x$2, n$31 = n$6;
                    var clo$0 = function(obj) {
                        return caml_call2(f$15, x$17, obj[1 + n$31]);
                    };
                    break;
                case 11:
                    var f$5 = next(0), x$3 = next(0), e$1 = next(0), n$7 = next(0);
                    let f$14 = f$5, x$16 = x$3, e$8 = e$1, n$30 = n$7;
                    var clo$0 = function(obj) {
                        return caml_call2(f$14, x$16, obj[1 + e$8][1 + n$30]);
                    };
                    break;
                case 12:
                    var f$6 = next(0), x$4 = next(0), n$8 = next(0);
                    let f$13 = f$6, x$15 = x$4, n$29 = n$8;
                    var clo$0 = function(obj) {
                        return caml_call2(f$13, x$15, caml_call1(obj[1][1 + n$29], obj));
                    };
                    break;
                case 13:
                    var f$7 = next(0), n$9 = next(0), x$5 = next(0);
                    let f$12 = f$7, n$28 = n$9, x$14 = x$5;
                    var clo$0 = function(obj) {
                        return caml_call2(f$12, obj[1 + n$28], x$14);
                    };
                    break;
                case 14:
                    var f$8 = next(0), e$2 = next(0), n$10 = next(0), x$6 = next(0);
                    let f$11 = f$8, e$7 = e$2, n$27 = n$10, x$13 = x$6;
                    var clo$0 = function(obj) {
                        return caml_call2(f$11, obj[1 + e$7][1 + n$27], x$13);
                    };
                    break;
                case 15:
                    var f$9 = next(0), n$11 = next(0), x$7 = next(0);
                    let f$10 = f$9, n$26 = n$11, x$12 = x$7;
                    var clo$0 = function(obj) {
                        return caml_call2(f$10, caml_call1(obj[1][1 + n$26], obj), x$12);
                    };
                    break;
                case 16:
                    var n$12 = next(0), x$8 = next(0);
                    let n$25 = n$12, x$11 = x$8;
                    var clo$0 = function(obj) {
                        return caml_call2(obj[1][1 + n$25], obj, x$11);
                    };
                    break;
                case 17:
                    var n$13 = next(0), m = next(0);
                    let n$24 = n$13, m$12 = m;
                    var clo$0 = function(obj) {
                        return caml_call2(obj[1][1 + n$24], obj, obj[1 + m$12]);
                    };
                    break;
                case 18:
                    var n$14 = next(0), e$3 = next(0), m$0 = next(0);
                    let n$23 = n$14, e$6 = e$3, m$11 = m$0;
                    var clo$0 = function(obj) {
                        return caml_call2(obj[1][1 + n$23], obj, obj[1 + e$6][1 + m$11]);
                    };
                    break;
                case 19:
                    var n$15 = next(0), m$1 = next(0);
                    let n$22 = n$15, m$10 = m$1;
                    var clo$0 = function(obj) {
                        var _l_ = caml_call1(obj[1][1 + m$10], obj);
                        return caml_call2(obj[1][1 + n$22], obj, _l_);
                    };
                    break;
                case 20:
                    var m$2 = next(0), x$9 = next(0);
                    new_cache(table);
                    let m$9 = m$2, x$10 = x$9;
                    var clo$0 = function(obj) {
                        return caml_call1(caml_get_public_method(x$10, m$9, 0), x$10);
                    };
                    break;
                case 21:
                    var m$3 = next(0), n$16 = next(0);
                    new_cache(table);
                    let m$8 = m$3, n$21 = n$16;
                    var clo$0 = function(obj) {
                        var _k_ = obj[1 + n$21];
                        return caml_call1(caml_get_public_method(_k_, m$8, 0), _k_);
                    };
                    break;
                case 22:
                    var m$4 = next(0), e$4 = next(0), n$17 = next(0);
                    new_cache(table);
                    let m$7 = m$4, e$5 = e$4, n$20 = n$17;
                    var clo$0 = function(obj) {
                        var _j_ = obj[1 + e$5][1 + n$20];
                        return caml_call1(caml_get_public_method(_j_, m$7, 0), _j_);
                    };
                    break;
                default:
                    var m$5 = next(0), n$18 = next(0);
                    new_cache(table);
                    let m$6 = m$5, n$19 = n$18;
                    var clo$0 = function(obj) {
                        var _i_ = caml_call1(obj[1][1 + n$19], obj);
                        return caml_call1(caml_get_public_method(_i_, m$6, 0), _i_);
                    };
            }
            else var clo$0 = clo;
            set_method(table, label, clo$0);
            i[1]++;
        }
    }
    function stats(param) {
        return [
            0,
            table_count[1],
            method_count[1],
            inst_var_count[1]
        ];
    }
    var CamlinternalOO = [
        0,
        public_method_label,
        new_method,
        new_variable,
        new_methods_variables,
        get_variable,
        get_variables,
        get_method_label,
        get_method_labels,
        get_method,
        set_method,
        set_methods,
        narrow,
        widen,
        add_initializer,
        dummy_table,
        create_table,
        init_class,
        inherits,
        make_class,
        make_class_store,
        dummy_class,
        copy,
        create_object,
        create_object_opt,
        run_initializers,
        run_initializers_opt,
        create_object_and_run_initiali,
        lookup_tables,
        params,
        stats
    ];
    runtime.caml_register_global(17, CamlinternalOO, "CamlinternalOO");
    return;
})(globalThis);
//# 25659 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_camlinternalMod_ml = "camlinternalMod.ml", caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_tag = runtime.caml_obj_tag;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, CamlinternalLazy = global_data.CamlinternalLazy, CamlinternalOO = global_data.CamlinternalOO, Assert_failure = global_data.Assert_failure, cst_CamlinternalMod_init_mod_n = "CamlinternalMod.init_mod: not a module", _a_ = [
        0,
        cst_camlinternalMod_ml,
        72,
        5
    ], _b_ = [
        0,
        cst_camlinternalMod_ml,
        81,
        2
    ], cst_CamlinternalMod_update_mod = "CamlinternalMod.update_mod: not a module";
    function init_mod_block(loc, comps$0) {
        var length = comps$0.length - 1, modu = runtime.caml_obj_block(0, length), _h_ = length - 1 | 0, _g_ = 0;
        if (_h_ >= 0) {
            var i = _g_;
            for(;;){
                var shape = caml_check_bound(comps$0, i)[1 + i];
                if (typeof shape === "number") switch(shape){
                    case 0:
                        let i$1 = i;
                        var fn = function(x) {
                            var fn = modu[1 + i$1];
                            if (fn$0 === fn) throw caml_maybe_attach_backtrace([
                                0,
                                Stdlib[15],
                                loc
                            ], 1);
                            return caml_call1(fn, x);
                        };
                        let fn$0 = fn;
                        var init = fn;
                        break;
                    case 1:
                        var l = [];
                        let l$0 = l, i$0 = i;
                        runtime.caml_update_dummy(l, [
                            246,
                            function(param) {
                                var l = modu[1 + i$0];
                                if (l$0 === l) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stdlib[15],
                                    loc
                                ], 1);
                                var _j_ = caml_obj_tag(l);
                                if (250 === _j_) return l[1];
                                if (246 !== _j_ && 244 !== _j_) return l;
                                return caml_call1(CamlinternalLazy[2], l);
                            }
                        ]);
                        var init = l;
                        break;
                    default:
                        var init = caml_call1(CamlinternalOO[21], loc);
                }
                else if (0 === shape[0]) var comps = shape[1], init = init_mod_block(loc, comps);
                else var v = shape[1], init = v;
                modu[1 + i] = init;
                var _i_ = i + 1 | 0;
                if (_h_ === i) break;
                i = _i_;
            }
        }
        return modu;
    }
    function init_mod(loc, shape) {
        if (typeof shape !== "number" && 0 === shape[0]) {
            var comps = shape[1];
            return init_mod_block(loc, comps);
        }
        return caml_call1(Stdlib[2], cst_CamlinternalMod_init_mod_n);
    }
    function update_mod_block(comps$0, modu, n) {
        if (0 === caml_obj_tag(n) && comps$0.length - 1 <= n.length - 1) {
            var _e_ = comps$0.length - 2 | 0, _d_ = 0;
            if (_e_ >= 0) {
                var i = _d_;
                for(;;){
                    var n$0 = n[1 + i], shape = caml_check_bound(comps$0, i)[1 + i];
                    a: if (typeof shape === "number") {
                        if (2 === shape) {
                            if (0 === caml_obj_tag(n$0) && 4 === n$0.length - 1) {
                                var cl = modu[1 + i], j = 0;
                                for(;;){
                                    cl[1 + j] = n$0[1 + j];
                                    var _c_ = j + 1 | 0;
                                    if (3 === j) break;
                                    j = _c_;
                                }
                                break a;
                            }
                            throw caml_maybe_attach_backtrace([
                                0,
                                Assert_failure,
                                _a_
                            ], 1);
                        }
                        modu[1 + i] = n$0;
                    } else if (0 === shape[0]) {
                        var comps = shape[1];
                        update_mod_block(comps, modu[1 + i], n$0);
                    }
                    var _f_ = i + 1 | 0;
                    if (_e_ === i) break;
                    i = _f_;
                }
            }
            return 0;
        }
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
    }
    function update_mod(shape, o, n) {
        if (typeof shape !== "number" && 0 === shape[0]) {
            var comps = shape[1];
            return update_mod_block(comps, o, n);
        }
        return caml_call1(Stdlib[2], cst_CamlinternalMod_update_mod);
    }
    var CamlinternalMod = [
        0,
        init_mod,
        update_mod
    ];
    runtime.caml_register_global(8, CamlinternalMod, "CamlinternalMod");
    return;
})(globalThis);
//# 25799 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_check_bound = runtime.caml_check_bound, caml_make_vect = runtime.caml_make_vect, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), _c_ = [
        0,
        0
    ], _b_ = [
        0,
        0
    ], _a_ = [
        0,
        0
    ], Stdlib_List = global_data.Stdlib__List, Stdlib = global_data.Stdlib, Stdlib_Obj = global_data.Stdlib__Obj, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, CamlinternalLazy = global_data.CamlinternalLazy, Stdlib_Random = global_data.Stdlib__Random;
    function MakeSeeded(H) {
        var prng = [
            246,
            function(_at_) {
                return caml_call1(Stdlib_Random[19][2], 0);
            }
        ];
        function create(opt, initial_size) {
            var random = opt ? opt[1] : caml_call1(Stdlib_Hashtbl[17], 0);
            a: b: {
                var x = 16;
                for(;;){
                    if (initial_size <= x) break b;
                    if (Stdlib_Sys[13] < (x * 2 | 0)) break;
                    var x$0 = x * 2 | 0;
                    x = x$0;
                }
                break a;
            }
            if (random) {
                var _ar_ = runtime.caml_obj_tag(prng);
                a: if (250 === _ar_) var _as_ = prng[1];
                else {
                    if (246 !== _ar_ && 244 !== _ar_) {
                        var _as_ = prng;
                        break a;
                    }
                    var _as_ = caml_call1(CamlinternalLazy[2], prng);
                }
                var seed = caml_call1(Stdlib_Random[19][4], _as_);
            } else var seed = 0;
            return [
                0,
                0,
                caml_make_vect(x, 0),
                seed,
                x
            ];
        }
        function clear(h) {
            h[1] = 0;
            var len = h[2].length - 1, _ap_ = len - 1 | 0, _ao_ = 0;
            if (_ap_ >= 0) {
                var i = _ao_;
                for(;;){
                    caml_check_bound(h[2], i)[1 + i] = 0;
                    var _aq_ = i + 1 | 0;
                    if (_ap_ === i) break;
                    i = _aq_;
                }
            }
            return 0;
        }
        function reset(h) {
            var len = h[2].length - 1;
            return len === h[4] ? clear(h) : (h[1] = 0, h[2] = caml_make_vect(h[4], 0), 0);
        }
        function copy(h) {
            var _al_ = h[4], _am_ = h[3], _an_ = caml_call1(Stdlib_Array[7], h[2]);
            return [
                0,
                h[1],
                _an_,
                _am_,
                _al_
            ];
        }
        function key_index(h, hkey) {
            return hkey & (h[2].length - 2 | 0);
        }
        function clean(h) {
            function do_bucket(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var hkey = param$0[1], rest = param$0[3], c = param$0[2];
                    if (caml_call1(H[6], c)) {
                        var rest$0 = param$0[3], c$0 = param$0[2];
                        return [
                            0,
                            hkey,
                            c$0,
                            do_bucket(rest$0)
                        ];
                    }
                    h[1] = h[1] - 1 | 0;
                    param$0 = rest;
                }
            }
            var d = h[2], _aj_ = d.length - 2 | 0, _ai_ = 0;
            if (_aj_ >= 0) {
                var i = _ai_;
                for(;;){
                    d[1 + i] = do_bucket(caml_check_bound(d, i)[1 + i]);
                    var _ak_ = i + 1 | 0;
                    if (_aj_ === i) break;
                    i = _ak_;
                }
            }
            return 0;
        }
        function resize(h) {
            var odata = h[2], osize = odata.length - 1, nsize = osize * 2 | 0;
            clean(h);
            var _ac_ = nsize < Stdlib_Sys[13] ? 1 : 0, _ad_ = _ac_ ? (osize >>> 1 | 0) <= h[1] ? 1 : 0 : _ac_;
            if (_ad_) {
                var ndata = caml_make_vect(nsize, 0);
                h[2] = ndata;
                var insert_bucket = function(param) {
                    if (!param) return;
                    var rest = param[3], data = param[2], hkey = param[1];
                    insert_bucket(rest);
                    var nidx = key_index(h, hkey);
                    ndata[1 + nidx] = [
                        0,
                        hkey,
                        data,
                        caml_check_bound(ndata, nidx)[1 + nidx]
                    ];
                    return;
                }, _af_ = osize - 1 | 0, _ae_ = 0;
                if (_af_ >= 0) {
                    var i = _ae_;
                    for(;;){
                        insert_bucket(caml_check_bound(odata, i)[1 + i]);
                        var _ah_ = i + 1 | 0;
                        if (_af_ === i) break;
                        i = _ah_;
                    }
                }
                var _ag_ = 0;
            } else var _ag_ = _ad_;
            return _ag_;
        }
        function add(h, key, info) {
            var hkey = caml_call2(H[2], h[3], key), i = key_index(h, hkey), container = caml_call2(H[1], key, info), bucket = [
                0,
                hkey,
                container,
                caml_check_bound(h[2], i)[1 + i]
            ];
            caml_check_bound(h[2], i)[1 + i] = bucket;
            h[1] = h[1] + 1 | 0;
            var _ab_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
            return _ab_ ? resize(h) : _ab_;
        }
        function remove(h, key) {
            var hkey = caml_call2(H[2], h[3], key);
            function remove_bucket(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var hk = param$0[1], next = param$0[3], c = param$0[2];
                    if (hkey !== hk) {
                        var next$0 = param$0[3], c$0 = param$0[2];
                        return [
                            0,
                            hk,
                            c$0,
                            remove_bucket(next$0)
                        ];
                    }
                    switch(caml_call2(H[3], c, key)){
                        case 0:
                            h[1] = h[1] - 1 | 0;
                            return next;
                        case 1:
                            return [
                                0,
                                hk,
                                c,
                                remove_bucket(next)
                            ];
                        default:
                            h[1] = h[1] - 1 | 0;
                            param$0 = next;
                    }
                }
            }
            var i = key_index(h, hkey), _aa_ = remove_bucket(caml_check_bound(h[2], i)[1 + i]);
            caml_check_bound(h[2], i)[1 + i] = _aa_;
            return 0;
        }
        function find(h, key) {
            var hkey = caml_call2(H[2], h[3], key), _$_ = key_index(h, hkey), param = caml_check_bound(h[2], _$_)[1 + _$_];
            for(;;){
                if (!param) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                var hk = param[1], rest = param[3], c = param[2];
                if (hkey === hk) switch(caml_call2(H[3], c, key)){
                    case 0:
                        var match = caml_call1(H[4], c);
                        if (match) {
                            var d = match[1];
                            return d;
                        }
                        param = rest;
                        break;
                    case 1:
                        param = rest;
                        break;
                    default:
                        param = rest;
                }
                else {
                    var rest$0 = param[3];
                    param = rest$0;
                }
            }
        }
        function find_opt(h, key) {
            var hkey = caml_call2(H[2], h[3], key), ___ = key_index(h, hkey), param = caml_check_bound(h[2], ___)[1 + ___];
            for(;;){
                if (!param) return 0;
                var hk = param[1], rest = param[3], c = param[2];
                if (hkey === hk) switch(caml_call2(H[3], c, key)){
                    case 0:
                        var d = caml_call1(H[4], c);
                        if (d) return d;
                        param = rest;
                        break;
                    case 1:
                        param = rest;
                        break;
                    default:
                        param = rest;
                }
                else {
                    var rest$0 = param[3];
                    param = rest$0;
                }
            }
        }
        function find_all(h, key) {
            var hkey = caml_call2(H[2], h[3], key);
            function find_in_bucket(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var hk = param$0[1], rest = param$0[3], c = param$0[2];
                    if (hkey === hk) switch(caml_call2(H[3], c, key)){
                        case 0:
                            var match = caml_call1(H[4], c);
                            if (match) {
                                var d = match[1];
                                return [
                                    0,
                                    d,
                                    find_in_bucket(rest)
                                ];
                            }
                            param$0 = rest;
                            break;
                        case 1:
                            param$0 = rest;
                            break;
                        default:
                            param$0 = rest;
                    }
                    else {
                        var rest$0 = param$0[3];
                        param$0 = rest$0;
                    }
                }
            }
            var _Z_ = key_index(h, hkey);
            return find_in_bucket(caml_check_bound(h[2], _Z_)[1 + _Z_]);
        }
        function replace(h, key, info) {
            var hkey = caml_call2(H[2], h[3], key), i = key_index(h, hkey), l = caml_check_bound(h[2], i)[1 + i];
            try {
                var param = l;
                for(;;){
                    if (!param) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var hk = param[1], next = param[3], c = param[2];
                    if (hkey === hk) {
                        if (!caml_call2(H[3], c, key)) {
                            var _V_ = caml_call3(H[5], c, key, info);
                            return _V_;
                        }
                        param = next;
                    } else {
                        var next$0 = param[3];
                        param = next$0;
                    }
                }
            } catch (_Y_) {
                var _W_ = caml_wrap_exception(_Y_);
                if (_W_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_W_, 0);
                var container = caml_call2(H[1], key, info);
                caml_check_bound(h[2], i)[1 + i] = [
                    0,
                    hkey,
                    container,
                    l
                ];
                h[1] = h[1] + 1 | 0;
                var _X_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
                return _X_ ? resize(h) : _X_;
            }
        }
        function mem(h, key) {
            var hkey = caml_call2(H[2], h[3], key), _U_ = key_index(h, hkey), param = caml_check_bound(h[2], _U_)[1 + _U_];
            for(;;){
                if (!param) return 0;
                var hk = param[1], rest = param[3], c = param[2];
                if (hk === hkey) {
                    if (!caml_call2(H[3], c, key)) return 1;
                    param = rest;
                } else {
                    var rest$0 = param[3];
                    param = rest$0;
                }
            }
        }
        function length(h) {
            return h[1];
        }
        function bucket_length(accu, param) {
            var accu$0 = accu, param$0 = param;
            for(;;){
                if (!param$0) return accu$0;
                var rest = param$0[3], accu$1 = accu$0 + 1 | 0;
                accu$0 = accu$1;
                param$0 = rest;
            }
        }
        function stats(h) {
            var mbl = caml_call3(Stdlib_Array[18], function(m, b) {
                var _T_1 = bucket_length(0, b);
                return caml_call2(Stdlib_Int[11], m, _T_1);
            }, 0, h[2]), histo = caml_make_vect(mbl + 1 | 0, 0);
            caml_call2(Stdlib_Array[12], function(b) {
                var l = bucket_length(0, b);
                histo[1 + l] = caml_check_bound(histo, l)[1 + l] + 1 | 0;
                return 0;
            }, h[2]);
            return [
                0,
                h[1],
                h[2].length - 1,
                mbl,
                histo
            ];
        }
        function bucket_length_alive(accu, param) {
            var accu$0 = accu, param$0 = param;
            for(;;){
                if (!param$0) return accu$0;
                var rest = param$0[3], c = param$0[2];
                if (caml_call1(H[6], c)) {
                    var accu$1 = accu$0 + 1 | 0;
                    accu$0 = accu$1;
                    param$0 = rest;
                } else {
                    var rest$0 = param$0[3];
                    param$0 = rest$0;
                }
            }
        }
        function stats_alive(h) {
            var size = [
                0,
                0
            ], mbl = caml_call3(Stdlib_Array[18], function(m, b) {
                var _S_ = bucket_length_alive(0, b);
                return caml_call2(Stdlib_Int[11], m, _S_);
            }, 0, h[2]), histo = caml_make_vect(mbl + 1 | 0, 0);
            caml_call2(Stdlib_Array[12], function(b) {
                var l = bucket_length_alive(0, b);
                size[1] = size[1] + l | 0;
                histo[1 + l] = caml_check_bound(histo, l)[1 + l] + 1 | 0;
                return 0;
            }, h[2]);
            return [
                0,
                size[1],
                h[2].length - 1,
                mbl,
                histo
            ];
        }
        function add_seq(tbl, i) {
            return caml_call2(Stdlib_Seq[4], function(param) {
                var v = param[2], k = param[1];
                return add(tbl, k, v);
            }, i);
        }
        function replace_seq(tbl, i) {
            return caml_call2(Stdlib_Seq[4], function(param) {
                var v = param[2], k = param[1];
                return replace(tbl, k, v);
            }, i);
        }
        function of_seq(i) {
            var tbl = create(0, 16);
            replace_seq(tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            length,
            stats,
            add_seq,
            replace_seq,
            of_seq,
            clean,
            stats_alive
        ];
    }
    function create(param) {
        return caml_call1(Stdlib_Obj[23][1], 1);
    }
    function get_key(t) {
        var x = caml_call2(Stdlib_Obj[23][3], t, 0);
        return x;
    }
    function set_key(t, k) {
        return caml_call3(Stdlib_Obj[23][5], t, 0, k);
    }
    function check_key(t) {
        return caml_call2(Stdlib_Obj[23][7], t, 0);
    }
    function get_data(t) {
        var x = caml_call1(Stdlib_Obj[23][9], t);
        return x;
    }
    function set_data(t, d) {
        return caml_call2(Stdlib_Obj[23][11], t, d);
    }
    function make(key, data) {
        var eph = create(0);
        set_data(eph, data);
        set_key(eph, key);
        return eph;
    }
    function query(eph, key) {
        var match = get_key(eph);
        if (!match) return 0;
        var k = match[1];
        return k === key ? get_data(eph) : 0;
    }
    function MakeSeeded$0(H) {
        function create$0(k, d) {
            var c = create(0);
            set_data(c, d);
            set_key(c, k);
            return c;
        }
        var seeded_hash = H[2];
        function equal(c, k) {
            var match = get_key(c);
            if (!match) return 2;
            var k$0 = match[1];
            return caml_call2(H[1], k, k$0) ? 0 : 1;
        }
        function set_key_data(c, k, d) {
            caml_call1(Stdlib_Obj[23][12], c);
            set_key(c, k);
            return set_data(c, d);
        }
        return MakeSeeded([
            0,
            create$0,
            seeded_hash,
            equal,
            get_data,
            set_key_data,
            check_key
        ]);
    }
    function Make(H) {
        var equal = H[1];
        function seeded_hash(seed, x) {
            return caml_call1(H[2], x);
        }
        var include = MakeSeeded$0([
            0,
            equal,
            seeded_hash
        ]), _R_ = include[1], clear = include[2], reset = include[3], copy = include[4], add = include[5], remove = include[6], find = include[7], find_opt = include[8], find_all = include[9], replace = include[10], mem = include[11], length = include[12], stats = include[13], add_seq = include[14], replace_seq = include[15], clean = include[17], stats_alive = include[18];
        function create(sz) {
            return caml_call2(_R_, _a_, sz);
        }
        function of_seq(i) {
            var tbl = caml_call2(_R_, _a_, 16);
            caml_call2(replace_seq, tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            length,
            stats,
            add_seq,
            replace_seq,
            of_seq,
            clean,
            stats_alive
        ];
    }
    function make$0(param) {
        return [
            0,
            0
        ];
    }
    function add(b, k, d) {
        var _Q_ = b[1];
        b[1] = [
            0,
            make(k, d),
            _Q_
        ];
        return 0;
    }
    function test_key(k, e) {
        var match = get_key(e);
        if (match) {
            var x = match[1];
            if (x === k) return 1;
        }
        return 0;
    }
    function remove(b, k) {
        var l$0 = b[1], l = l$0, acc = 0;
        for(;;){
            if (!l) return 0;
            var h = l[1], t = l[2];
            if (test_key(k, h)) {
                b[1] = caml_call2(Stdlib_List[13], acc, t);
                return 0;
            }
            var t$0 = l[2], acc$0 = [
                0,
                h,
                acc
            ];
            l = t$0;
            acc = acc$0;
        }
    }
    function find(b, k) {
        var match = caml_call2(Stdlib_List[40], function(_P_) {
            return test_key(k, _P_);
        }, b[1]);
        if (!match) return 0;
        var e = match[1];
        return get_data(e);
    }
    function length(b) {
        return caml_call1(Stdlib_List[1], b[1]);
    }
    function clear(b) {
        b[1] = 0;
        return 0;
    }
    function create$0(param) {
        return caml_call1(Stdlib_Obj[23][1], 2);
    }
    function get_key1(t) {
        var x = caml_call2(Stdlib_Obj[23][3], t, 0);
        return x;
    }
    function set_key1(t, k) {
        return caml_call3(Stdlib_Obj[23][5], t, 0, k);
    }
    function get_key2(t) {
        var x = caml_call2(Stdlib_Obj[23][3], t, 1);
        return x;
    }
    function set_key2(t, k) {
        return caml_call3(Stdlib_Obj[23][5], t, 1, k);
    }
    function get_data$0(t) {
        var x = caml_call1(Stdlib_Obj[23][9], t);
        return x;
    }
    function set_data$0(t, d) {
        return caml_call2(Stdlib_Obj[23][11], t, d);
    }
    function make$1(key1, key2, data) {
        var eph = create$0(0);
        set_data$0(eph, data);
        set_key1(eph, key1);
        set_key2(eph, key2);
        return eph;
    }
    function query$0(eph, key1, key2) {
        var match = get_key1(eph);
        if (!match) return 0;
        var k = match[1];
        if (k !== key1) return 0;
        var match$0 = get_key2(eph);
        if (!match$0) return 0;
        var k$0 = match$0[1];
        return k$0 === key2 ? get_data$0(eph) : 0;
    }
    function MakeSeeded$1(H1, H2) {
        function create(param, d) {
            var k2 = param[2], k1 = param[1], c = create$0(0);
            set_data$0(c, d);
            set_key1(c, k1);
            set_key2(c, k2);
            return c;
        }
        function seeded_hash(seed, param) {
            var k2 = param[2], k1 = param[1], _O_ = caml_call2(H2[2], seed, k2) * 65599 | 0;
            return caml_call2(H1[2], seed, k1) + _O_ | 0;
        }
        function equal(c, param) {
            var k2 = param[2], k1 = param[1], match = get_key1(c), match$0 = get_key2(c);
            if (match && match$0) {
                var k2$0 = match$0[1], k1$0 = match[1];
                if (caml_call2(H1[1], k1, k1$0) && caml_call2(H2[1], k2, k2$0)) return 0;
                return 1;
            }
            return 2;
        }
        function set_key_data(c, param, d) {
            var k2 = param[2], k1 = param[1];
            caml_call1(Stdlib_Obj[23][12], c);
            set_key1(c, k1);
            set_key2(c, k2);
            return set_data$0(c, d);
        }
        function check_key(c) {
            var _N_ = caml_call2(Stdlib_Obj[23][7], c, 0);
            return _N_ ? caml_call2(Stdlib_Obj[23][7], c, 1) : _N_;
        }
        return MakeSeeded([
            0,
            create,
            seeded_hash,
            equal,
            get_data$0,
            set_key_data,
            check_key
        ]);
    }
    function Make$0(H1, H2) {
        var equal = H2[1];
        function seeded_hash(seed, x) {
            return caml_call1(H2[2], x);
        }
        var equal$0 = H1[1];
        function seeded_hash$0(seed, x) {
            return caml_call1(H1[2], x);
        }
        var include = MakeSeeded$1([
            0,
            equal$0,
            seeded_hash$0
        ], [
            0,
            equal,
            seeded_hash
        ]), _M_ = include[1], clear = include[2], reset = include[3], copy = include[4], add = include[5], remove = include[6], find = include[7], find_opt = include[8], find_all = include[9], replace = include[10], mem = include[11], length = include[12], stats = include[13], add_seq = include[14], replace_seq = include[15], clean = include[17], stats_alive = include[18];
        function create(sz) {
            return caml_call2(_M_, _b_, sz);
        }
        function of_seq(i) {
            var tbl = caml_call2(_M_, _b_, 16);
            caml_call2(replace_seq, tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            length,
            stats,
            add_seq,
            replace_seq,
            of_seq,
            clean,
            stats_alive
        ];
    }
    function make$2(param) {
        return [
            0,
            0
        ];
    }
    function add$0(b, k1, k2, d) {
        var _L_ = b[1];
        b[1] = [
            0,
            make$1(k1, k2, d),
            _L_
        ];
        return 0;
    }
    function test_keys(k1, k2, e) {
        var match = get_key1(e), match$0 = get_key2(e);
        if (match && match$0) {
            var x2 = match$0[1], x1 = match[1];
            if (x1 === k1 && x2 === k2) return 1;
        }
        return 0;
    }
    function remove$0(b, k1, k2) {
        var l$0 = b[1], l = l$0, acc = 0;
        for(;;){
            if (!l) return 0;
            var h = l[1], t = l[2];
            if (test_keys(k1, k2, h)) {
                b[1] = caml_call2(Stdlib_List[13], acc, t);
                return 0;
            }
            var t$0 = l[2], acc$0 = [
                0,
                h,
                acc
            ];
            l = t$0;
            acc = acc$0;
        }
    }
    function find$0(b, k1, k2) {
        var match = caml_call2(Stdlib_List[40], function(_K_) {
            return test_keys(k1, k2, _K_);
        }, b[1]);
        if (!match) return 0;
        var e = match[1];
        return get_data$0(e);
    }
    function length$0(b) {
        return caml_call1(Stdlib_List[1], b[1]);
    }
    function clear$0(b) {
        b[1] = 0;
        return 0;
    }
    function create$1(n) {
        return caml_call1(Stdlib_Obj[23][1], n);
    }
    function length$1(k) {
        return caml_call1(Stdlib_Obj[23][2], k);
    }
    function get_key$0(t, n) {
        var x = caml_call2(Stdlib_Obj[23][3], t, n);
        return x;
    }
    function set_key$0(t, n, k) {
        return caml_call3(Stdlib_Obj[23][5], t, n, k);
    }
    function get_data$1(t) {
        var x = caml_call1(Stdlib_Obj[23][9], t);
        return x;
    }
    function set_data$1(t, d) {
        return caml_call2(Stdlib_Obj[23][11], t, d);
    }
    function make$3(keys, data) {
        var l = keys.length - 1, eph = create$1(l);
        set_data$1(eph, data);
        var _I_ = l - 1 | 0, _H_ = 0;
        if (_I_ >= 0) {
            var i = _H_;
            for(;;){
                set_key$0(eph, i, caml_check_bound(keys, i)[1 + i]);
                var _J_ = i + 1 | 0;
                if (_I_ === i) break;
                i = _J_;
            }
        }
        return eph;
    }
    function query$1(eph, keys) {
        var l = length$1(eph);
        try {
            if (l !== keys.length - 1) throw caml_maybe_attach_backtrace(Stdlib[3], 1);
            var _D_ = l - 1 | 0, _C_ = 0;
            if (_D_ >= 0) {
                var i = _C_;
                for(;;){
                    var match = get_key$0(eph, i);
                    if (!match) throw caml_maybe_attach_backtrace(Stdlib[3], 1);
                    var k = match[1];
                    if (k !== caml_check_bound(keys, i)[1 + i]) throw caml_maybe_attach_backtrace(Stdlib[3], 1);
                    var _F_ = i + 1 | 0;
                    if (_D_ === i) break;
                    i = _F_;
                }
            }
            var _E_ = get_data$1(eph);
            return _E_;
        } catch (_G_) {
            var _B_ = caml_wrap_exception(_G_);
            if (_B_ === Stdlib[3]) return 0;
            throw caml_maybe_attach_backtrace(_B_, 0);
        }
    }
    function MakeSeeded$2(H) {
        function create(k, d) {
            var c = create$1(k.length - 1);
            set_data$1(c, d);
            var _z_ = k.length - 2 | 0, _y_ = 0;
            if (_z_ >= 0) {
                var i = _y_;
                for(;;){
                    set_key$0(c, i, caml_check_bound(k, i)[1 + i]);
                    var _A_ = i + 1 | 0;
                    if (_z_ === i) break;
                    i = _A_;
                }
            }
            return c;
        }
        function seeded_hash(seed, k) {
            var h = [
                0,
                0
            ], _u_ = k.length - 2 | 0, _t_ = 0;
            if (_u_ >= 0) {
                var i = _t_;
                for(;;){
                    var _v_ = h[1], _w_ = caml_check_bound(k, i)[1 + i];
                    h[1] = (caml_call2(H[2], seed, _w_) * 65599 | 0) + _v_ | 0;
                    var _x_ = i + 1 | 0;
                    if (_u_ === i) break;
                    i = _x_;
                }
            }
            return h[1];
        }
        function equal(c, k) {
            var len = k.length - 1, len$0 = length$1(c);
            if (len !== len$0) return 1;
            var i$1 = len - 1 | 0, i = i$1;
            for(;;){
                if (0 > i) return 0;
                var match = get_key$0(c, i);
                if (!match) return 2;
                var ki = match[1], _s_ = caml_check_bound(k, i)[1 + i];
                if (!caml_call2(H[1], _s_, ki)) return 1;
                var i$0 = i - 1 | 0;
                i = i$0;
            }
        }
        function set_key_data(c, k, d) {
            caml_call1(Stdlib_Obj[23][12], c);
            var _q_ = k.length - 2 | 0, _p_ = 0;
            if (_q_ >= 0) {
                var i = _p_;
                for(;;){
                    set_key$0(c, i, caml_check_bound(k, i)[1 + i]);
                    var _r_ = i + 1 | 0;
                    if (_q_ === i) break;
                    i = _r_;
                }
            }
            return set_data$1(c, d);
        }
        function check_key(c) {
            var i$1 = length$1(c) - 1 | 0, i = i$1;
            for(;;){
                var _n_ = i < 0 ? 1 : 0;
                if (_n_) var _o_ = _n_;
                else {
                    var _m_ = caml_call2(Stdlib_Obj[23][7], c, i);
                    if (_m_) {
                        var i$0 = i - 1 | 0;
                        i = i$0;
                        continue;
                    }
                    var _o_ = _m_;
                }
                return _o_;
            }
        }
        return MakeSeeded([
            0,
            create,
            seeded_hash,
            equal,
            get_data$1,
            set_key_data,
            check_key
        ]);
    }
    function Make$1(H) {
        var equal = H[1];
        function seeded_hash(seed, x) {
            return caml_call1(H[2], x);
        }
        var include = MakeSeeded$2([
            0,
            equal,
            seeded_hash
        ]), _l_ = include[1], clear = include[2], reset = include[3], copy = include[4], add = include[5], remove = include[6], find = include[7], find_opt = include[8], find_all = include[9], replace = include[10], mem = include[11], length = include[12], stats = include[13], add_seq = include[14], replace_seq = include[15], clean = include[17], stats_alive = include[18];
        function create(sz) {
            return caml_call2(_l_, _c_, sz);
        }
        function of_seq(i) {
            var tbl = caml_call2(_l_, _c_, 16);
            caml_call2(replace_seq, tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            length,
            stats,
            add_seq,
            replace_seq,
            of_seq,
            clean,
            stats_alive
        ];
    }
    function make$4(param) {
        return [
            0,
            0
        ];
    }
    function add$1(b, k, d) {
        var _k_ = b[1];
        b[1] = [
            0,
            make$3(k, d),
            _k_
        ];
        return 0;
    }
    function test_keys$0(k, e) {
        try {
            if (length$1(e) !== k.length - 1) throw caml_maybe_attach_backtrace(Stdlib[3], 1);
            var _g_ = k.length - 2 | 0, _f_ = 0;
            if (_g_ >= 0) {
                var i = _f_;
                for(;;){
                    var match = get_key$0(e, i);
                    if (match) {
                        var x = match[1];
                        if (x === caml_check_bound(k, i)[1 + i]) {
                            var _i_ = i + 1 | 0;
                            if (_g_ === i) break;
                            i = _i_;
                            continue;
                        }
                    }
                    throw caml_maybe_attach_backtrace(Stdlib[3], 1);
                }
            }
            var _h_ = 1;
            return _h_;
        } catch (_j_) {
            var _e_ = caml_wrap_exception(_j_);
            if (_e_ === Stdlib[3]) return 0;
            throw caml_maybe_attach_backtrace(_e_, 0);
        }
    }
    function remove$1(b, k) {
        var l$0 = b[1], l = l$0, acc = 0;
        for(;;){
            if (!l) return 0;
            var h = l[1], t = l[2];
            if (test_keys$0(k, h)) {
                b[1] = caml_call2(Stdlib_List[13], acc, t);
                return 0;
            }
            var t$0 = l[2], acc$0 = [
                0,
                h,
                acc
            ];
            l = t$0;
            acc = acc$0;
        }
    }
    function find$1(b, k) {
        var match = caml_call2(Stdlib_List[40], function(_d_) {
            return test_keys$0(k, _d_);
        }, b[1]);
        if (!match) return 0;
        var e = match[1];
        return get_data$1(e);
    }
    function length$2(b) {
        return caml_call1(Stdlib_List[1], b[1]);
    }
    function clear$1(b) {
        b[1] = 0;
        return 0;
    }
    var Stdlib_Ephemeron = [
        0,
        [
            0,
            make,
            query,
            Make,
            MakeSeeded$0,
            [
                0,
                make$0,
                add,
                remove,
                find,
                length,
                clear
            ]
        ],
        [
            0,
            make$1,
            query$0,
            Make$0,
            MakeSeeded$1,
            [
                0,
                make$2,
                add$0,
                remove$0,
                find$0,
                length$0,
                clear$0
            ]
        ],
        [
            0,
            make$3,
            query$1,
            Make$1,
            MakeSeeded$2,
            [
                0,
                make$4,
                add$1,
                remove$1,
                find$1,
                length$2,
                clear$1
            ]
        ]
    ];
    runtime.caml_register_global(13, Stdlib_Ephemeron, "Stdlib__Ephemeron");
    return;
})(globalThis);
//# 26783 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$19 = "", cst$23 = " ", cst_2$1 = " 2>", cst_2_1$1 = " 2>&1", cst$22 = " <", cst$21 = " >", cst$20 = '"', cst$24 = ".", cst$25 = "..", cst$28 = "../", cst$27 = "./", cst$26 = "/", cst_dev_null = "/dev/null", caml_equal = runtime.caml_equal, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_sys_getenv = runtime.caml_sys_getenv, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), cst$18 = cst$19, cst$17 = cst$19, cst$16 = cst$19, cst$8 = cst$21, cst$15 = cst$19, cst$9 = cst$22, cst$14 = cst$19, cst$10 = cst$23, cst$11 = cst$23, cst$12 = cst$20, cst$13 = cst$19, cst$6 = cst$20, cst$7 = cst$19, cst$4 = cst$19, cst = cst$21, cst$3 = cst$19, cst$0 = cst$22, cst$2 = cst$19, cst$1 = cst$23, null$0 = cst_dev_null, current_dir_name = cst$24, parent_dir_name = cst$25, dir_sep = cst$26, quotequote = "'\\''", null$1 = "NUL", current_dir_name$0 = cst$24, parent_dir_name$0 = cst$25, dir_sep$0 = "\\", cst$5 = cst$24, null$2 = cst_dev_null, current_dir_name$1 = cst$24, parent_dir_name$1 = cst$25, dir_sep$1 = cst$26, Stdlib = global_data.Stdlib, Stdlib_Domain = global_data.Stdlib__Domain, Stdlib_Random = global_data.Stdlib__Random, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_String = global_data.Stdlib__String, Stdlib_List = global_data.Stdlib__List, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_Sys = global_data.Stdlib__Sys;
    function generic_basename(is_dir_sep, current_dir_name, name) {
        if (name == cst$19) return current_dir_name;
        var n$3 = caml_ml_string_length(name) - 1 | 0, n = n$3;
        for(;;){
            if (0 > n) return caml_call3(Stdlib_String[16], name, 0, 1);
            if (!caml_call2(is_dir_sep, name, n)) break;
            var n$0 = n - 1 | 0;
            n = n$0;
        }
        var p = n + 1 | 0, n$1 = n;
        for(;;){
            if (0 > n$1) return caml_call3(Stdlib_String[16], name, 0, p);
            if (caml_call2(is_dir_sep, name, n$1)) return caml_call3(Stdlib_String[16], name, n$1 + 1 | 0, (p - n$1 | 0) - 1 | 0);
            var n$2 = n$1 - 1 | 0;
            n$1 = n$2;
        }
    }
    function generic_dirname(is_dir_sep, current_dir_name, name) {
        if (name == cst$19) return current_dir_name;
        var n$5 = caml_ml_string_length(name) - 1 | 0, n = n$5;
        for(;;){
            if (0 > n) return caml_call3(Stdlib_String[16], name, 0, 1);
            if (!caml_call2(is_dir_sep, name, n)) break;
            var n$0 = n - 1 | 0;
            n = n$0;
        }
        var n$1 = n;
        for(;;){
            if (0 > n$1) return current_dir_name;
            if (caml_call2(is_dir_sep, name, n$1)) break;
            var n$2 = n$1 - 1 | 0;
            n$1 = n$2;
        }
        var n$3 = n$1;
        for(;;){
            if (0 > n$3) return caml_call3(Stdlib_String[16], name, 0, 1);
            if (!caml_call2(is_dir_sep, name, n$3)) return caml_call3(Stdlib_String[16], name, 0, n$3 + 1 | 0);
            var n$4 = n$3 - 1 | 0;
            n$3 = n$4;
        }
    }
    function is_dir_sep(s, i) {
        return 47 === caml_string_get(s, i) ? 1 : 0;
    }
    function is_relative(n) {
        var _aH_ = caml_ml_string_length(n) < 1 ? 1 : 0, _aI_ = _aH_ || (47 !== caml_string_get(n, 0) ? 1 : 0);
        return _aI_;
    }
    function is_implicit(n) {
        var _aC_ = is_relative(n);
        if (_aC_) {
            var _aD_ = caml_ml_string_length(n) < 2 ? 1 : 0, _aE_ = _aD_ || (caml_call3(Stdlib_String[16], n, 0, 2) !== cst$27 ? 1 : 0);
            if (_aE_) var _aF_ = caml_ml_string_length(n) < 3 ? 1 : 0, _aG_ = _aF_ || (caml_call3(Stdlib_String[16], n, 0, 3) !== cst$28 ? 1 : 0);
            else var _aG_ = _aE_;
        } else var _aG_ = _aC_;
        return _aG_;
    }
    function check_suffix(name, suff) {
        return caml_call2(Stdlib_String[12], suff, name);
    }
    function chop_suffix_opt(suffix, filename) {
        var len_s = caml_ml_string_length(suffix), len_f = caml_ml_string_length(filename);
        if (len_s > len_f) return 0;
        var r = caml_call3(Stdlib_String[16], filename, len_f - len_s | 0, len_s);
        return r == suffix ? [
            0,
            caml_call3(Stdlib_String[16], filename, 0, len_f - len_s | 0)
        ] : 0;
    }
    var _h_ = [
        0,
        7,
        0
    ], _g_ = [
        0,
        1,
        [
            0,
            3,
            [
                0,
                5,
                0
            ]
        ]
    ], _f_ = [
        0,
        [
            2,
            0,
            [
                4,
                6,
                [
                    0,
                    2,
                    6
                ],
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s%06x%s"
    ], cst_Filename_chop_extension = "Filename.chop_extension", cst_Filename_chop_suffix = "Filename.chop_suffix", _d_ = [
        0,
        cst$20,
        0
    ], cst_2_1$0 = cst_2_1$1, cst_2$0 = cst_2$1, cst_Filename_quote_command_bad = "Filename.quote_command: bad file name ", _c_ = [
        0,
        cst$20,
        0
    ], cst_2_1 = cst_2_1$1, cst_2 = cst_2$1, cst_tmp = "/tmp";
    try {
        var _j_ = caml_sys_getenv("TMPDIR"), temp_dir_name = _j_;
    } catch (_aB_) {
        var _a_ = caml_wrap_exception(_aB_);
        if (_a_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_a_, 0);
        var temp_dir_name = cst_tmp;
    }
    function quote(s) {
        var l = caml_ml_string_length(s), b = caml_call1(Stdlib_Buffer[1], l + 20 | 0);
        caml_call2(Stdlib_Buffer[12], b, 39);
        var _ay_ = l - 1 | 0, _ax_ = 0;
        if (_ay_ >= 0) {
            var i = _ax_;
            for(;;){
                if (39 === caml_string_get(s, i)) caml_call2(Stdlib_Buffer[16], b, quotequote);
                else {
                    var _aA_ = caml_string_get(s, i);
                    caml_call2(Stdlib_Buffer[12], b, _aA_);
                }
                var _az_ = i + 1 | 0;
                if (_ay_ === i) break;
                i = _az_;
            }
        }
        caml_call2(Stdlib_Buffer[12], b, 39);
        return caml_call1(Stdlib_Buffer[2], b);
    }
    function quote_command(cmd, stdin, stdout, stderr, args) {
        if (stderr) {
            var f = stderr[1];
            if (caml_equal(stderr, stdout)) var _am_ = cst_2_1;
            else var _aw_ = quote(f), _am_ = caml_call2(Stdlib[28], cst_2, _aw_);
            var _an_ = _am_;
        } else var _an_ = cst$4;
        if (stdout) var f$0 = stdout[1], _ao_ = quote(f$0), _ap_ = caml_call2(Stdlib[28], cst, _ao_);
        else var _ap_ = cst$3;
        var _aq_ = caml_call2(Stdlib[28], _ap_, _an_);
        if (stdin) var f$1 = stdin[1], _ar_ = quote(f$1), _as_ = caml_call2(Stdlib[28], cst$0, _ar_);
        else var _as_ = cst$2;
        var _at_ = caml_call2(Stdlib[28], _as_, _aq_), _au_ = caml_call2(Stdlib_List[20], quote, [
            0,
            cmd,
            args
        ]), _av_ = caml_call2(Stdlib_String[7], cst$1, _au_);
        return caml_call2(Stdlib[28], _av_, _at_);
    }
    function basename(_al_) {
        return generic_basename(is_dir_sep, current_dir_name, _al_);
    }
    function dirname(_ak_) {
        return generic_dirname(is_dir_sep, current_dir_name, _ak_);
    }
    var Unix = [
        0,
        null$0,
        current_dir_name,
        parent_dir_name,
        dir_sep,
        is_dir_sep,
        is_relative,
        is_implicit,
        check_suffix,
        chop_suffix_opt,
        temp_dir_name,
        quote,
        quote_command,
        basename,
        dirname
    ];
    function is_dir_sep$0(s, i) {
        var c = caml_string_get(s, i), _ah_ = 47 === c ? 1 : 0;
        if (_ah_) var _ai_ = _ah_;
        else var _aj_ = 92 === c ? 1 : 0, _ai_ = _aj_ || (58 === c ? 1 : 0);
        return _ai_;
    }
    function is_relative$0(n) {
        var _ab_ = caml_ml_string_length(n) < 1 ? 1 : 0, _ac_ = _ab_ || (47 !== caml_string_get(n, 0) ? 1 : 0);
        if (_ac_) {
            var _ad_ = caml_ml_string_length(n) < 1 ? 1 : 0, _ae_ = _ad_ || (92 !== caml_string_get(n, 0) ? 1 : 0);
            if (_ae_) var _af_ = caml_ml_string_length(n) < 2 ? 1 : 0, _ag_ = _af_ || (58 !== caml_string_get(n, 1) ? 1 : 0);
            else var _ag_ = _ae_;
        } else var _ag_ = _ac_;
        return _ag_;
    }
    function is_implicit$0(n) {
        var _U_ = is_relative$0(n);
        if (_U_) {
            var _V_ = caml_ml_string_length(n) < 2 ? 1 : 0, _W_ = _V_ || (caml_call3(Stdlib_String[16], n, 0, 2) !== cst$27 ? 1 : 0);
            if (_W_) {
                var _X_ = caml_ml_string_length(n) < 2 ? 1 : 0, _Y_ = _X_ || (caml_call3(Stdlib_String[16], n, 0, 2) !== ".\\" ? 1 : 0);
                if (_Y_) {
                    var _Z_ = caml_ml_string_length(n) < 3 ? 1 : 0, ___ = _Z_ || (caml_call3(Stdlib_String[16], n, 0, 3) !== cst$28 ? 1 : 0);
                    if (___) var _$_ = caml_ml_string_length(n) < 3 ? 1 : 0, _aa_ = _$_ || (caml_call3(Stdlib_String[16], n, 0, 3) !== "..\\" ? 1 : 0);
                    else var _aa_ = ___;
                } else var _aa_ = _Y_;
            } else var _aa_ = _W_;
        } else var _aa_ = _U_;
        return _aa_;
    }
    function check_suffix$0(name, suff) {
        var _R_ = caml_ml_string_length(suff) <= caml_ml_string_length(name) ? 1 : 0;
        if (_R_) var s = caml_call3(Stdlib_String[16], name, caml_ml_string_length(name) - caml_ml_string_length(suff) | 0, caml_ml_string_length(suff)), _S_ = caml_call1(Stdlib_String[27], suff), _T_1 = caml_call1(Stdlib_String[27], s) == _S_ ? 1 : 0;
        else var _T_1 = _R_;
        return _T_1;
    }
    function chop_suffix_opt$0(suffix, filename) {
        var len_s = caml_ml_string_length(suffix), len_f = caml_ml_string_length(filename);
        if (len_s > len_f) return 0;
        var r = caml_call3(Stdlib_String[16], filename, len_f - len_s | 0, len_s), _Q_ = caml_call1(Stdlib_String[27], suffix);
        return caml_call1(Stdlib_String[27], r) == _Q_ ? [
            0,
            caml_call3(Stdlib_String[16], filename, 0, len_f - len_s | 0)
        ] : 0;
    }
    try {
        var _i_ = caml_sys_getenv("TEMP"), temp_dir_name$0 = _i_;
    } catch (_P_) {
        var _b_ = caml_wrap_exception(_P_);
        if (_b_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_b_, 0);
        var temp_dir_name$0 = cst$5;
    }
    function quote$0(s) {
        var l = caml_ml_string_length(s), b = caml_call1(Stdlib_Buffer[1], l + 20 | 0);
        caml_call2(Stdlib_Buffer[12], b, 34);
        function loop$0(counter, i) {
            var i$0 = i;
            for(;;){
                if (i$0 === l) return caml_call2(Stdlib_Buffer[12], b, 34);
                var c = caml_string_get(s, i$0);
                if (34 === c) {
                    var _N_ = 0;
                    if (counter >= 50) return caml_trampoline_return(loop_bs, [
                        0,
                        _N_,
                        i$0
                    ]);
                    var counter$1 = counter + 1 | 0;
                    return loop_bs(counter$1, _N_, i$0);
                }
                if (92 === c) {
                    var _O_ = 0;
                    if (counter >= 50) return caml_trampoline_return(loop_bs, [
                        0,
                        _O_,
                        i$0
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return loop_bs(counter$0, _O_, i$0);
                }
                caml_call2(Stdlib_Buffer[12], b, c);
                var i$1 = i$0 + 1 | 0;
                i$0 = i$1;
            }
        }
        function loop(i) {
            return caml_trampoline(loop$0(0, i));
        }
        function loop_bs(counter, n, i) {
            var n$0 = n, i$0 = i;
            for(;;){
                if (i$0 === l) {
                    caml_call2(Stdlib_Buffer[12], b, 34);
                    return add_bs(n$0);
                }
                var match = caml_string_get(s, i$0);
                if (34 === match) {
                    add_bs((2 * n$0 | 0) + 1 | 0);
                    caml_call2(Stdlib_Buffer[12], b, 34);
                    var _M_ = i$0 + 1 | 0;
                    if (counter >= 50) return caml_trampoline_return(loop$0, [
                        0,
                        _M_
                    ]);
                    var counter$1 = counter + 1 | 0;
                    return loop$0(counter$1, _M_);
                }
                if (92 !== match) {
                    add_bs(n$0);
                    if (counter >= 50) return caml_trampoline_return(loop$0, [
                        0,
                        i$0
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return loop$0(counter$0, i$0);
                }
                var i$1 = i$0 + 1 | 0, n$1 = n$0 + 1 | 0;
                n$0 = n$1;
                i$0 = i$1;
            }
        }
        function add_bs(n) {
            var _K_ = 1;
            if (n >= 1) {
                var j = _K_;
                for(;;){
                    caml_call2(Stdlib_Buffer[12], b, 92);
                    var _L_ = j + 1 | 0;
                    if (n === j) break;
                    j = _L_;
                }
            }
            return;
        }
        loop(0);
        return caml_call1(Stdlib_Buffer[2], b);
    }
    function quote_cmd_filename(f) {
        if (!caml_call2(Stdlib_String[23], function(param) {
            if (34 !== param && 37 !== param) return 0;
            return 1;
        }, f)) return caml_call2(Stdlib_String[15], f, 32) ? caml_call2(Stdlib_String[7], cst$7, [
            0,
            cst$6,
            [
                0,
                f,
                _c_
            ]
        ]) : f;
        var _J_ = caml_call2(Stdlib[28], cst_Filename_quote_command_bad, f);
        return caml_call1(Stdlib[2], _J_);
    }
    function quote_command$0(cmd, stdin, stdout, stderr, args) {
        if (stderr) {
            var f = stderr[1];
            if (caml_equal(stderr, stdout)) var _w_ = cst_2_1$0;
            else var _H_ = quote_cmd_filename(f), _w_ = caml_call2(Stdlib[28], cst_2$0, _H_);
            var _x_ = _w_;
        } else var _x_ = cst$16;
        var _y_ = [
            0,
            _x_,
            _d_
        ];
        if (stdout) var f$0 = stdout[1], _z_ = quote_cmd_filename(f$0), _A_ = caml_call2(Stdlib[28], cst$8, _z_);
        else var _A_ = cst$15;
        var _B_ = [
            0,
            _A_,
            _y_
        ];
        if (stdin) var f$1 = stdin[1], _C_ = quote_cmd_filename(f$1), _D_ = caml_call2(Stdlib[28], cst$9, _C_);
        else var _D_ = cst$14;
        var _E_ = caml_call2(Stdlib_List[20], quote$0, args), s = caml_call2(Stdlib_String[7], cst$10, _E_), b = caml_call1(Stdlib_Buffer[1], caml_ml_string_length(s) + 20 | 0);
        caml_call2(Stdlib_String[30], function(c) {
            a: {
                if (62 <= c) {
                    var _I_ = c - 63 | 0;
                    if (60 < _I_ >>> 0) {
                        if (62 <= _I_) break a;
                    } else if (31 !== _I_) break a;
                } else if (42 <= c) {
                    if (60 !== c) break a;
                } else {
                    if (33 > c) break a;
                    switch(c - 33 | 0){
                        case 2:
                        case 3:
                        case 6:
                            break a;
                    }
                }
                caml_call2(Stdlib_Buffer[12], b, 94);
                return caml_call2(Stdlib_Buffer[12], b, c);
            }
            return caml_call2(Stdlib_Buffer[12], b, c);
        }, s);
        var _F_ = [
            0,
            cst$11,
            [
                0,
                caml_call1(Stdlib_Buffer[2], b),
                [
                    0,
                    _D_,
                    _B_
                ]
            ]
        ], _G_ = [
            0,
            cst$12,
            [
                0,
                quote_cmd_filename(cmd),
                _F_
            ]
        ];
        return caml_call2(Stdlib_String[7], cst$13, _G_);
    }
    function drive_and_path(s) {
        var _s_ = 2 <= caml_ml_string_length(s) ? 1 : 0;
        if (_s_) {
            var param = caml_string_get(s, 0);
            a: {
                b: {
                    if (91 <= param) {
                        if (25 < param - 97 >>> 0) break b;
                    } else if (65 > param) break b;
                    var _t_ = 1;
                    break a;
                }
                var _t_ = 0;
            }
            var _u_ = _t_ ? 58 === caml_string_get(s, 1) ? 1 : 0 : _t_;
        } else var _u_ = _s_;
        if (!_u_) return [
            0,
            cst$17,
            s
        ];
        var _v_ = caml_call3(Stdlib_String[16], s, 2, caml_ml_string_length(s) - 2 | 0);
        return [
            0,
            caml_call3(Stdlib_String[16], s, 0, 2),
            _v_
        ];
    }
    function dirname$0(s) {
        var match = drive_and_path(s), path = match[2], drive = match[1], dir = generic_dirname(is_dir_sep$0, current_dir_name$0, path);
        return caml_call2(Stdlib[28], drive, dir);
    }
    function basename$0(s) {
        var path = drive_and_path(s)[2];
        return generic_basename(is_dir_sep$0, current_dir_name$0, path);
    }
    var Win32 = [
        0,
        null$1,
        current_dir_name$0,
        parent_dir_name$0,
        dir_sep$0,
        is_dir_sep$0,
        is_relative$0,
        is_implicit$0,
        check_suffix$0,
        chop_suffix_opt$0,
        temp_dir_name$0,
        quote$0,
        quote_command$0,
        basename$0,
        dirname$0
    ];
    function basename$1(_r_) {
        return generic_basename(is_dir_sep$0, current_dir_name$1, _r_);
    }
    function dirname$1(_q_) {
        return generic_dirname(is_dir_sep$0, current_dir_name$1, _q_);
    }
    var Cygwin = [
        0,
        null$2,
        current_dir_name$1,
        parent_dir_name$1,
        dir_sep$1,
        is_dir_sep$0,
        is_relative$0,
        is_implicit$0,
        check_suffix$0,
        chop_suffix_opt$0,
        temp_dir_name,
        quote,
        quote_command,
        basename$1,
        dirname$1
    ], _e_ = Stdlib_Sys[4], Sysdeps = _e_ !== "Cygwin" ? _e_ !== "Win32" ? Unix : Win32 : Cygwin, null$3 = Sysdeps[1], current_dir_name$2 = Sysdeps[2], parent_dir_name$2 = Sysdeps[3], dir_sep$2 = Sysdeps[4], is_dir_sep$1 = Sysdeps[5], is_relative$1 = Sysdeps[6], is_implicit$1 = Sysdeps[7], check_suffix$1 = Sysdeps[8], chop_suffix_opt$1 = Sysdeps[9], temp_dir_name$1 = Sysdeps[10], quote$1 = Sysdeps[11], quote_command$1 = Sysdeps[12], basename$2 = Sysdeps[13], dirname$2 = Sysdeps[14];
    function concat(dirname, filename) {
        var l = caml_ml_string_length(dirname);
        if (0 !== l && !is_dir_sep$1(dirname, l - 1 | 0)) {
            var _p_ = caml_call2(Stdlib[28], dir_sep$2, filename);
            return caml_call2(Stdlib[28], dirname, _p_);
        }
        return caml_call2(Stdlib[28], dirname, filename);
    }
    function chop_suffix(name, suff) {
        return check_suffix$1(name, suff) ? caml_call3(Stdlib_String[16], name, 0, caml_ml_string_length(name) - caml_ml_string_length(suff) | 0) : caml_call1(Stdlib[1], cst_Filename_chop_suffix);
    }
    function extension_len(name) {
        var i$3 = caml_ml_string_length(name) - 1 | 0, i0 = i$3;
        for(;;){
            if (0 <= i0 && !is_dir_sep$1(name, i0)) {
                if (46 === caml_string_get(name, i0)) break;
                var i$2 = i0 - 1 | 0;
                i0 = i$2;
                continue;
            }
            return 0;
        }
        var i$1 = i0 - 1 | 0, i = i$1;
        for(;;){
            if (0 <= i && !is_dir_sep$1(name, i)) {
                if (46 !== caml_string_get(name, i)) return caml_ml_string_length(name) - i0 | 0;
                var i$0 = i - 1 | 0;
                i = i$0;
                continue;
            }
            return 0;
        }
    }
    function extension(name) {
        var l = extension_len(name);
        return 0 === l ? cst$18 : caml_call3(Stdlib_String[16], name, caml_ml_string_length(name) - l | 0, l);
    }
    function chop_extension(name) {
        var l = extension_len(name);
        return 0 === l ? caml_call1(Stdlib[1], cst_Filename_chop_extension) : caml_call3(Stdlib_String[16], name, 0, caml_ml_string_length(name) - l | 0);
    }
    function remove_extension(name) {
        var l = extension_len(name);
        return 0 === l ? name : caml_call3(Stdlib_String[16], name, 0, caml_ml_string_length(name) - l | 0);
    }
    var prng_key = caml_call2(Stdlib_Domain[10][1], 0, Stdlib_Random[19][2]);
    function temp_file_name(temp_dir, prefix, suffix) {
        var random_state = caml_call1(Stdlib_Domain[10][2], prng_key), rnd = caml_call1(Stdlib_Random[19][4], random_state) & 16777215;
        return concat(temp_dir, caml_call4(Stdlib_Printf[4], _f_, prefix, rnd, suffix));
    }
    var current_temp_dir_name = caml_call2(Stdlib_Domain[10][1], [
        0,
        function(_o_) {
            return _o_;
        }
    ], function(param) {
        return temp_dir_name$1;
    });
    function set_temp_dir_name(s) {
        return caml_call2(Stdlib_Domain[10][3], current_temp_dir_name, s);
    }
    function get_temp_dir_name(param) {
        return caml_call1(Stdlib_Domain[10][2], current_temp_dir_name);
    }
    function temp_file(opt, prefix, suffix) {
        var temp_dir = opt ? opt[1] : caml_call1(Stdlib_Domain[10][2], current_temp_dir_name), counter = 0;
        for(;;){
            var name = temp_file_name(temp_dir, prefix, suffix);
            try {
                runtime.caml_sys_close(runtime.caml_sys_open(name, _g_, 384));
                return name;
            } catch (e$0) {
                var e = caml_wrap_exception(e$0);
                if (e[1] !== Stdlib[11]) throw caml_maybe_attach_backtrace(e, 0);
                if (20 <= counter) throw caml_maybe_attach_backtrace(e, 0);
                var counter$0 = counter + 1 | 0;
                counter = counter$0;
            }
        }
    }
    function open_temp_file(_m_, _l_, opt, prefix, suffix) {
        var mode = _m_ ? _m_[1] : _h_, perms = _l_ ? _l_[1] : 384, temp_dir = opt ? opt[1] : caml_call1(Stdlib_Domain[10][2], current_temp_dir_name), counter = 0;
        for(;;){
            var name = temp_file_name(temp_dir, prefix, suffix);
            try {
                var _n_ = [
                    0,
                    name,
                    caml_call3(Stdlib[62], [
                        0,
                        1,
                        [
                            0,
                            3,
                            [
                                0,
                                5,
                                mode
                            ]
                        ]
                    ], perms, name)
                ];
                return _n_;
            } catch (e$0) {
                var e = caml_wrap_exception(e$0);
                if (e[1] !== Stdlib[11]) throw caml_maybe_attach_backtrace(e, 0);
                if (20 <= counter) throw caml_maybe_attach_backtrace(e, 0);
                var counter$0 = counter + 1 | 0;
                counter = counter$0;
            }
        }
    }
    function temp_dir(_k_, opt, prefix, suffix) {
        var temp_dir = _k_ ? _k_[1] : caml_call1(Stdlib_Domain[10][2], current_temp_dir_name), perms = opt ? opt[1] : 448, counter = 0;
        for(;;){
            var name = temp_file_name(temp_dir, prefix, suffix);
            try {
                runtime.caml_sys_mkdir(name, perms);
                return name;
            } catch (e$0) {
                var e = caml_wrap_exception(e$0);
                if (e[1] !== Stdlib[11]) throw caml_maybe_attach_backtrace(e, 0);
                if (20 <= counter) throw caml_maybe_attach_backtrace(e, 0);
                var counter$0 = counter + 1 | 0;
                counter = counter$0;
            }
        }
    }
    var Stdlib_Filename = [
        0,
        current_dir_name$2,
        parent_dir_name$2,
        dir_sep$2,
        concat,
        is_relative$1,
        is_implicit$1,
        check_suffix$1,
        chop_suffix,
        chop_suffix_opt$1,
        extension,
        remove_extension,
        chop_extension,
        basename$2,
        dirname$2,
        null$3,
        temp_file,
        open_temp_file,
        temp_dir,
        get_temp_dir_name,
        set_temp_dir_name,
        quote$1,
        quote_command$1
    ];
    runtime.caml_register_global(66, Stdlib_Filename, "Stdlib__Filename");
    return;
})(globalThis);
//# 27661 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_Array = global_data.Stdlib__Array, init = Stdlib_Array[1], make_matrix = Stdlib_Array[2], init_matrix = Stdlib_Array[3], append = Stdlib_Array[4], concat = Stdlib_Array[5], sub = Stdlib_Array[6], copy = Stdlib_Array[7], fill = Stdlib_Array[8], blit = Stdlib_Array[9], to_list = Stdlib_Array[10], of_list = Stdlib_Array[11], iter = Stdlib_Array[12], iteri = Stdlib_Array[13], map = Stdlib_Array[14], map_inplace = Stdlib_Array[15], mapi = Stdlib_Array[16], mapi_inplace = Stdlib_Array[17], fold_left = Stdlib_Array[18], fold_left_map = Stdlib_Array[19], fold_right = Stdlib_Array[20], iter2 = Stdlib_Array[21], map2 = Stdlib_Array[22], for_all = Stdlib_Array[23], exists = Stdlib_Array[24], for_all2 = Stdlib_Array[25], exists2 = Stdlib_Array[26], mem = Stdlib_Array[27], memq = Stdlib_Array[28], find_opt = Stdlib_Array[29], find_index = Stdlib_Array[30], find_map = Stdlib_Array[31], find_mapi = Stdlib_Array[32], split = Stdlib_Array[33], combine = Stdlib_Array[34], sort = Stdlib_Array[35], stable_sort = Stdlib_Array[36], fast_sort = Stdlib_Array[37], shuffle = Stdlib_Array[38], to_seq = Stdlib_Array[39], to_seqi = Stdlib_Array[40], of_seq = Stdlib_Array[41], Floatarray = Stdlib_Array[42], Stdlib_ArrayLabels = [
        0,
        init,
        make_matrix,
        init_matrix,
        append,
        concat,
        sub,
        copy,
        fill,
        blit,
        to_list,
        of_list,
        iter,
        iteri,
        map,
        map_inplace,
        mapi,
        mapi_inplace,
        fold_left,
        fold_left_map,
        fold_right,
        iter2,
        map2,
        for_all,
        exists,
        for_all2,
        exists2,
        mem,
        memq,
        find_opt,
        find_index,
        find_map,
        find_mapi,
        split,
        combine,
        sort,
        stable_sort,
        fast_sort,
        shuffle,
        to_seq,
        to_seqi,
        of_seq,
        Floatarray
    ];
    runtime.caml_register_global(1, Stdlib_ArrayLabels, "Stdlib__ArrayLabels");
    return;
})(globalThis);
//# 27761 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_List = global_data.Stdlib__List, length = Stdlib_List[1], compare_lengths = Stdlib_List[2], compare_length_with = Stdlib_List[3], is_empty = Stdlib_List[4], cons = Stdlib_List[5], hd = Stdlib_List[6], tl = Stdlib_List[7], nth = Stdlib_List[8], nth_opt = Stdlib_List[9], rev = Stdlib_List[10], init = Stdlib_List[11], append = Stdlib_List[12], rev_append = Stdlib_List[13], concat = Stdlib_List[14], flatten = Stdlib_List[15], equal = Stdlib_List[16], compare = Stdlib_List[17], iter = Stdlib_List[18], iteri = Stdlib_List[19], map = Stdlib_List[20], mapi = Stdlib_List[21], rev_map = Stdlib_List[22], filter_map = Stdlib_List[23], concat_map = Stdlib_List[24], fold_left_map = Stdlib_List[25], fold_left = Stdlib_List[26], fold_right = Stdlib_List[27], iter2 = Stdlib_List[28], map2 = Stdlib_List[29], rev_map2 = Stdlib_List[30], fold_left2 = Stdlib_List[31], fold_right2 = Stdlib_List[32], for_all = Stdlib_List[33], exists = Stdlib_List[34], for_all2 = Stdlib_List[35], exists2 = Stdlib_List[36], mem = Stdlib_List[37], memq = Stdlib_List[38], find = Stdlib_List[39], find_opt = Stdlib_List[40], find_index = Stdlib_List[41], find_map = Stdlib_List[42], find_mapi = Stdlib_List[43], filter = Stdlib_List[44], find_all = Stdlib_List[45], filteri = Stdlib_List[46], partition = Stdlib_List[47], partition_map = Stdlib_List[48], assoc = Stdlib_List[49], assoc_opt = Stdlib_List[50], assq = Stdlib_List[51], assq_opt = Stdlib_List[52], mem_assoc = Stdlib_List[53], mem_assq = Stdlib_List[54], remove_assoc = Stdlib_List[55], remove_assq = Stdlib_List[56], split = Stdlib_List[57], combine = Stdlib_List[58], sort = Stdlib_List[59], stable_sort = Stdlib_List[60], fast_sort = Stdlib_List[61], sort_uniq = Stdlib_List[62], merge = Stdlib_List[63], to_seq = Stdlib_List[64], of_seq = Stdlib_List[65], Stdlib_ListLabels = [
        0,
        length,
        compare_lengths,
        compare_length_with,
        is_empty,
        cons,
        hd,
        tl,
        nth,
        nth_opt,
        rev,
        init,
        append,
        rev_append,
        concat,
        flatten,
        equal,
        compare,
        iter,
        iteri,
        map,
        mapi,
        rev_map,
        filter_map,
        concat_map,
        fold_left_map,
        fold_left,
        fold_right,
        iter2,
        map2,
        rev_map2,
        fold_left2,
        fold_right2,
        for_all,
        exists,
        for_all2,
        exists2,
        mem,
        memq,
        find,
        find_opt,
        find_index,
        find_map,
        find_mapi,
        filter,
        find_all,
        filteri,
        partition,
        partition_map,
        assoc,
        assoc_opt,
        assq,
        assq_opt,
        mem_assoc,
        mem_assq,
        remove_assoc,
        remove_assq,
        split,
        combine,
        sort,
        stable_sort,
        fast_sort,
        sort_uniq,
        merge,
        to_seq,
        of_seq
    ];
    runtime.caml_register_global(1, Stdlib_ListLabels, "Stdlib__ListLabels");
    return;
})(globalThis);
//# 27907 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_Bytes = global_data.Stdlib__Bytes, make = Stdlib_Bytes[1], init = Stdlib_Bytes[2], empty = Stdlib_Bytes[3], copy = Stdlib_Bytes[4], of_string = Stdlib_Bytes[5], to_string = Stdlib_Bytes[6], sub = Stdlib_Bytes[7], sub_string = Stdlib_Bytes[8], extend = Stdlib_Bytes[9], fill = Stdlib_Bytes[10], blit = Stdlib_Bytes[11], blit_string = Stdlib_Bytes[12], concat = Stdlib_Bytes[13], cat = Stdlib_Bytes[14], iter = Stdlib_Bytes[15], iteri = Stdlib_Bytes[16], map = Stdlib_Bytes[17], mapi = Stdlib_Bytes[18], fold_left = Stdlib_Bytes[19], fold_right = Stdlib_Bytes[20], for_all = Stdlib_Bytes[21], exists = Stdlib_Bytes[22], trim = Stdlib_Bytes[23], escaped = Stdlib_Bytes[24], index = Stdlib_Bytes[25], index_opt = Stdlib_Bytes[26], rindex = Stdlib_Bytes[27], rindex_opt = Stdlib_Bytes[28], index_from = Stdlib_Bytes[29], index_from_opt = Stdlib_Bytes[30], rindex_from = Stdlib_Bytes[31], rindex_from_opt = Stdlib_Bytes[32], contains = Stdlib_Bytes[33], contains_from = Stdlib_Bytes[34], rcontains_from = Stdlib_Bytes[35], uppercase_ascii = Stdlib_Bytes[36], lowercase_ascii = Stdlib_Bytes[37], capitalize_ascii = Stdlib_Bytes[38], uncapitalize_ascii = Stdlib_Bytes[39], compare = Stdlib_Bytes[40], equal = Stdlib_Bytes[41], starts_with = Stdlib_Bytes[42], ends_with = Stdlib_Bytes[43], unsafe_to_string = Stdlib_Bytes[44], unsafe_of_string = Stdlib_Bytes[45], split_on_char = Stdlib_Bytes[46], to_seq = Stdlib_Bytes[47], to_seqi = Stdlib_Bytes[48], of_seq = Stdlib_Bytes[49], get_utf_8_uchar = Stdlib_Bytes[50], set_utf_8_uchar = Stdlib_Bytes[51], is_valid_utf_8 = Stdlib_Bytes[52], get_utf_16be_uchar = Stdlib_Bytes[53], set_utf_16be_uchar = Stdlib_Bytes[54], is_valid_utf_16be = Stdlib_Bytes[55], get_utf_16le_uchar = Stdlib_Bytes[56], set_utf_16le_uchar = Stdlib_Bytes[57], is_valid_utf_16le = Stdlib_Bytes[58], get_uint8 = Stdlib_Bytes[59], get_int8 = Stdlib_Bytes[60], get_uint16_ne = Stdlib_Bytes[61], get_uint16_be = Stdlib_Bytes[62], get_uint16_le = Stdlib_Bytes[63], get_int16_ne = Stdlib_Bytes[64], get_int16_be = Stdlib_Bytes[65], get_int16_le = Stdlib_Bytes[66], get_int32_ne = Stdlib_Bytes[67], get_int32_be = Stdlib_Bytes[68], get_int32_le = Stdlib_Bytes[69], get_int64_ne = Stdlib_Bytes[70], get_int64_be = Stdlib_Bytes[71], get_int64_le = Stdlib_Bytes[72], set_uint8 = Stdlib_Bytes[73], set_int8 = Stdlib_Bytes[74], set_uint16_ne = Stdlib_Bytes[75], set_uint16_be = Stdlib_Bytes[76], set_uint16_le = Stdlib_Bytes[77], set_int16_ne = Stdlib_Bytes[78], set_int16_be = Stdlib_Bytes[79], set_int16_le = Stdlib_Bytes[80], set_int32_ne = Stdlib_Bytes[81], set_int32_be = Stdlib_Bytes[82], set_int32_le = Stdlib_Bytes[83], set_int64_ne = Stdlib_Bytes[84], set_int64_be = Stdlib_Bytes[85], set_int64_le = Stdlib_Bytes[86], unsafe_escape = Stdlib_Bytes[87], Stdlib_BytesLabels = [
        0,
        make,
        init,
        empty,
        copy,
        of_string,
        to_string,
        sub,
        sub_string,
        extend,
        fill,
        blit,
        blit_string,
        concat,
        cat,
        iter,
        iteri,
        map,
        mapi,
        fold_left,
        fold_right,
        for_all,
        exists,
        trim,
        escaped,
        index,
        index_opt,
        rindex,
        rindex_opt,
        index_from,
        index_from_opt,
        rindex_from,
        rindex_from_opt,
        contains,
        contains_from,
        rcontains_from,
        uppercase_ascii,
        lowercase_ascii,
        capitalize_ascii,
        uncapitalize_ascii,
        compare,
        equal,
        starts_with,
        ends_with,
        unsafe_to_string,
        unsafe_of_string,
        split_on_char,
        to_seq,
        to_seqi,
        of_seq,
        get_utf_8_uchar,
        set_utf_8_uchar,
        is_valid_utf_8,
        get_utf_16be_uchar,
        set_utf_16be_uchar,
        is_valid_utf_16be,
        get_utf_16le_uchar,
        set_utf_16le_uchar,
        is_valid_utf_16le,
        get_uint8,
        get_int8,
        get_uint16_ne,
        get_uint16_be,
        get_uint16_le,
        get_int16_ne,
        get_int16_be,
        get_int16_le,
        get_int32_ne,
        get_int32_be,
        get_int32_le,
        get_int64_ne,
        get_int64_be,
        get_int64_le,
        set_uint8,
        set_int8,
        set_uint16_ne,
        set_uint16_be,
        set_uint16_le,
        set_int16_ne,
        set_int16_be,
        set_int16_le,
        set_int32_ne,
        set_int32_be,
        set_int32_le,
        set_int64_ne,
        set_int64_be,
        set_int64_le,
        unsafe_escape
    ];
    runtime.caml_register_global(1, Stdlib_BytesLabels, "Stdlib__BytesLabels");
    return;
})(globalThis);
//# 28097 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_String = global_data.Stdlib__String, make = Stdlib_String[1], init = Stdlib_String[2], empty = Stdlib_String[3], of_bytes = Stdlib_String[4], to_bytes = Stdlib_String[5], blit = Stdlib_String[6], concat = Stdlib_String[7], cat = Stdlib_String[8], equal = Stdlib_String[9], compare = Stdlib_String[10], starts_with = Stdlib_String[11], ends_with = Stdlib_String[12], contains_from = Stdlib_String[13], rcontains_from = Stdlib_String[14], contains = Stdlib_String[15], sub = Stdlib_String[16], split_on_char = Stdlib_String[17], map = Stdlib_String[18], mapi = Stdlib_String[19], fold_left = Stdlib_String[20], fold_right = Stdlib_String[21], for_all = Stdlib_String[22], exists = Stdlib_String[23], trim = Stdlib_String[24], escaped = Stdlib_String[25], uppercase_ascii = Stdlib_String[26], lowercase_ascii = Stdlib_String[27], capitalize_ascii = Stdlib_String[28], uncapitalize_ascii = Stdlib_String[29], iter = Stdlib_String[30], iteri = Stdlib_String[31], index_from = Stdlib_String[32], index_from_opt = Stdlib_String[33], rindex_from = Stdlib_String[34], rindex_from_opt = Stdlib_String[35], index = Stdlib_String[36], index_opt = Stdlib_String[37], rindex = Stdlib_String[38], rindex_opt = Stdlib_String[39], to_seq = Stdlib_String[40], to_seqi = Stdlib_String[41], of_seq = Stdlib_String[42], get_utf_8_uchar = Stdlib_String[43], is_valid_utf_8 = Stdlib_String[44], get_utf_16be_uchar = Stdlib_String[45], is_valid_utf_16be = Stdlib_String[46], get_utf_16le_uchar = Stdlib_String[47], is_valid_utf_16le = Stdlib_String[48], get_uint8 = Stdlib_String[49], get_int8 = Stdlib_String[50], get_uint16_ne = Stdlib_String[51], get_uint16_be = Stdlib_String[52], get_uint16_le = Stdlib_String[53], get_int16_ne = Stdlib_String[54], get_int16_be = Stdlib_String[55], get_int16_le = Stdlib_String[56], get_int32_ne = Stdlib_String[57], hash = Stdlib_String[58], seeded_hash = Stdlib_String[59], get_int32_be = Stdlib_String[60], get_int32_le = Stdlib_String[61], get_int64_ne = Stdlib_String[62], get_int64_be = Stdlib_String[63], get_int64_le = Stdlib_String[64], Stdlib_StringLabels = [
        0,
        make,
        init,
        empty,
        of_bytes,
        to_bytes,
        blit,
        concat,
        cat,
        equal,
        compare,
        starts_with,
        ends_with,
        contains_from,
        rcontains_from,
        contains,
        sub,
        split_on_char,
        map,
        mapi,
        fold_left,
        fold_right,
        for_all,
        exists,
        trim,
        escaped,
        uppercase_ascii,
        lowercase_ascii,
        capitalize_ascii,
        uncapitalize_ascii,
        iter,
        iteri,
        index_from,
        index_from_opt,
        rindex_from,
        rindex_from_opt,
        index,
        index_opt,
        rindex,
        rindex_opt,
        to_seq,
        to_seqi,
        of_seq,
        get_utf_8_uchar,
        is_valid_utf_8,
        get_utf_16be_uchar,
        is_valid_utf_16be,
        get_utf_16le_uchar,
        is_valid_utf_16le,
        get_uint8,
        get_int8,
        get_uint16_ne,
        get_uint16_be,
        get_uint16_le,
        get_int16_ne,
        get_int16_be,
        get_int16_le,
        get_int32_ne,
        hash,
        seeded_hash,
        get_int32_be,
        get_int32_le,
        get_int64_ne,
        get_int64_be,
        get_int64_le
    ];
    runtime.caml_register_global(1, Stdlib_StringLabels, "Stdlib__StringLabels");
    return;
})(globalThis);
//# 28242 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_Set = global_data.Stdlib__Set, Stdlib_Map = global_data.Stdlib__Map, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Stdlib_MoreLabels = [
        0,
        Stdlib_Hashtbl,
        Stdlib_Map,
        Stdlib_Set
    ];
    runtime.caml_register_global(3, Stdlib_MoreLabels, "Stdlib__MoreLabels");
    return;
})(globalThis);
//# 28258 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Stdlib_StdLabels = [
        0
    ];
    runtime.caml_register_global(0, Stdlib_StdLabels, "Stdlib__StdLabels");
    return;
})(globalThis);
//# 1 "../.js/default/js_of_ocaml-compiler.runtime/jsoo_runtime.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/js_of_ocaml-compiler.runtime/jsoo_runtime.cma.js"
//# 18 "../.js/default/js_of_ocaml-compiler.runtime/jsoo_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, s = "5.8.2", git_version = "", Jsoo_runtime_Runtime_version = [
        0,
        s,
        git_version
    ];
    runtime.caml_register_global(2, Jsoo_runtime_Runtime_version, "Jsoo_runtime__Runtime_version");
    return;
})(globalThis);
//# 33 "../.js/default/js_of_ocaml-compiler.runtime/jsoo_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Jsoo_runtime_Runtime_version = global_data.Jsoo_runtime__Runtime_version, Stdlib_Callback = global_data.Stdlib__Callback, Js = [
        0
    ], Config = [
        0
    ], version = Jsoo_runtime_Runtime_version[1], git_version = Jsoo_runtime_Runtime_version[2], Sys = [
        0,
        Config,
        version,
        git_version
    ], Exn = [
        248,
        "Jsoo_runtime.Error.Exn",
        runtime.caml_fresh_oo_id(0)
    ];
    caml_call2(Stdlib_Callback[2], "jsError", [
        0,
        Exn,
        [
            0
        ]
    ]);
    function raise(exn) {
        throw exn;
    }
    var Error1 = [
        0,
        raise,
        runtime.caml_exn_with_js_backtrace,
        runtime.caml_js_error_option_of_exception,
        Exn
    ], For_compatibility_only = [
        0
    ], Bigstring = [
        0
    ], Typed_array = [
        0,
        Bigstring
    ], Int64 = [
        0
    ], Jsoo_runtime = [
        0,
        Js,
        Sys,
        Error1,
        For_compatibility_only,
        Typed_array,
        Int64
    ];
    runtime.caml_register_global(5, Jsoo_runtime, "Jsoo_runtime");
    return;
})(globalThis);
//# 1 "../.js/default/brr/brr.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/brr/brr.cma.js"
//# 6 "../.js/default/brr/brr.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_length = "length", caml_equal = runtime.caml_equal, caml_js_meth_call = runtime.caml_js_meth_call, caml_list_of_js_array = runtime.caml_list_of_js_array;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Uchar = global_data.Stdlib__Uchar, Stdlib = global_data.Stdlib, jv_global = globalThis1;
    function length(s) {
        return s[cst_length];
    }
    function jstr_of_int(opt, i) {
        var base = opt ? opt[1] : 10;
        return i.toString(base);
    }
    function get(s, i) {
        if (s[cst_length] <= i) {
            var len = s[cst_length], s1 = jstr_of_int(0, len - 1 | 0), s1$0 = jstr_of_int(0, i), s0 = "index ".concat(s1$0), s0$1 = s0.concat(" not in bounds [0;"), s0$0 = s0$1.concat(s1), _b_ = runtime.caml_string_of_jsstring(s0$0.concat("]"));
            return caml_call1(Stdlib[1], _b_);
        }
        var u = s.codePointAt(i);
        a: {
            if (55296 <= u && 57343 >= u) {
                var u$0 = 65533;
                break a;
            }
            var u$0 = u;
        }
        return caml_call1(Stdlib_Uchar[9], u$0);
    }
    function jstr_of_uchar_int(i) {
        return jv_global["String"].fromCodePoint(i);
    }
    function get_jstr(s, i) {
        var _a_ = get(s, i);
        return jstr_of_uchar_int(caml_call1(Stdlib_Uchar[10], _a_));
    }
    var empty = "", sp = " ", nl = "\n";
    function append(s0, s1) {
        return s0.concat(s1);
    }
    function concat(opt, ss) {
        var sep = opt ? opt[1] : empty;
        return runtime.caml_list_to_js_array(ss).join(sep);
    }
    function pad_start(opt, len, s) {
        var pad = opt ? opt[1] : sp;
        return s.padStart(len, pad);
    }
    function pad_end(opt, len, s) {
        var pad = opt ? opt[1] : sp;
        return s.padEnd(len, pad);
    }
    function repeat(n, s) {
        return s.repeat(n);
    }
    function find_sub(opt, sub, s) {
        var start = opt ? opt[1] : 0, i = s.indexOf(sub, start);
        return -1 === i ? 0 : [
            0,
            i
        ];
    }
    function find_last_sub(before, sub, s) {
        if (before) var b = before[1], before$0 = b;
        else var before$0 = s[cst_length];
        var pos = before$0 - sub[cst_length] | 0;
        if (0 > pos) return 0;
        var i = s.lastIndexOf(sub, pos);
        return -1 === i ? 0 : [
            0,
            i
        ];
    }
    function slice(opt, stop, s) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], args = [
            0,
            start,
            stop$0
        ];
        else var args = [
            0,
            start
        ];
        return caml_js_meth_call(s, "slice", args);
    }
    function sub(opt, len, s) {
        var start = opt ? opt[1] : 0;
        if (len) var len$0 = len[1], args = [
            0,
            start,
            len$0
        ];
        else var args = [
            0,
            start
        ];
        return caml_js_meth_call(s, "substr", args);
    }
    function cuts(sep, s) {
        return caml_list_of_js_array(s.split(sep));
    }
    var iterator = Symbol.iterator;
    function fold_uchars(f, s, acc) {
        var it = s[iterator](), acc$0 = acc;
        for(;;){
            var r = it.next();
            if (r["done"] | 0) return acc$0;
            var u = r["value"].codePointAt(0);
            a: {
                if (55296 <= u && 57343 >= u) {
                    var u$0 = 65533;
                    break a;
                }
                var u$0 = u;
            }
            var acc$1 = caml_call2(f, caml_call1(Stdlib_Uchar[9], u$0), acc$0);
            acc$0 = acc$1;
        }
    }
    function fold_jstr_uchars(f, s, acc) {
        function f$0(u, acc) {
            return caml_call2(f, jstr_of_uchar_int(caml_call1(Stdlib_Uchar[10], u)), acc);
        }
        return fold_uchars(f$0, s, acc);
    }
    function trim(s) {
        return s.trim();
    }
    function normalized(nf, s) {
        var nf$0 = 868484048 <= nf ? 868484049 <= nf ? "NFKD" : "NFKC" : 3894540 <= nf ? "NFD" : "NFC";
        return s.normalize(nf$0);
    }
    function lowercased(s) {
        return s.toLowerCase();
    }
    function uppercased(s) {
        return s.toUpperCase();
    }
    function is_empty(s) {
        return 0 === s[cst_length] ? 1 : 0;
    }
    function starts_with(prefix, s) {
        return s.startsWith(prefix) | 0;
    }
    function includes(affix, s) {
        return s.includes(affix) | 0;
    }
    function ends_with(suffix, s) {
        return s.endsWith(suffix) | 0;
    }
    var equal = caml_equal, compare = runtime.caml_compare;
    function of_uchar(u) {
        return jstr_of_uchar_int(caml_call1(Stdlib_Uchar[10], u));
    }
    function of_char(c) {
        return jstr_of_uchar_int(c);
    }
    var number = jv_global["Number"];
    function to_int(base, s) {
        if (base) var b = base[1], args = [
            0,
            s,
            b
        ];
        else var args = [
            0,
            s
        ];
        var n = caml_js_meth_call(number, "parseInt", args);
        return caml_equal(n, n) ? [
            0,
            n
        ] : 0;
    }
    function to_float(s) {
        return number.parseFloat(s);
    }
    function of_float(frac, n) {
        if (!frac) return n.toString();
        var frac$0 = frac[1];
        return n.toFixed(frac$0);
    }
    var Jstr = [
        0,
        length,
        get,
        get_jstr,
        empty,
        sp,
        nl,
        append,
        append,
        concat,
        pad_start,
        pad_end,
        repeat,
        find_sub,
        find_last_sub,
        slice,
        sub,
        cuts,
        fold_uchars,
        fold_jstr_uchars,
        trim,
        normalized,
        lowercased,
        uppercased,
        is_empty,
        starts_with,
        includes,
        ends_with,
        equal,
        compare,
        of_uchar,
        of_char,
        to_int,
        jstr_of_int,
        to_float,
        of_float
    ];
    runtime.caml_register_global(46, Jstr, "Jstr");
    return;
})(globalThis);
//# 200 "../.js/default/brr/brr.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Array = "Array", cst_name = "name", cst_value = "value", caml_js_get = runtime.caml_js_get, caml_js_set = runtime.caml_js_set, caml_js_strict_equals = runtime.caml_js_strict_equals, caml_js_to_bool = runtime.caml_js_to_bool, caml_js_wrap_callback_strict = runtime.caml_js_wrap_callback_strict, caml_string_compare = runtime.caml_string_compare, caml_string_of_jsstring = runtime.caml_string_of_jsstring;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Array = global_data.Stdlib__Array, Stdlib_List = global_data.Stdlib__List, Jsoo_runtime = global_data.Jsoo_runtime, null$0 = null, undefined$0 = undefined;
    function is_null(v) {
        return v === null$0 ? 1 : 0;
    }
    function is_undefined(v) {
        return v === undefined$0 ? 1 : 0;
    }
    function is_none(v) {
        var _g_ = v === null$0 ? 1 : 0;
        return _g_ ? _g_ : v === undefined$0 ? 1 : 0;
    }
    function is_some(v) {
        return 1 - is_none(v);
    }
    function to_option(conv, v) {
        return is_none(v) ? 0 : [
            0,
            caml_call1(conv, v)
        ];
    }
    function of_option(none, conv, param) {
        if (!param) return none;
        var v = param[1];
        return caml_call1(conv, v);
    }
    var global = globalThis1;
    function set_if_some(o, p, param) {
        if (!param) return 0;
        var v = param[1];
        return o[p] = v;
    }
    function find(o, p) {
        var v = o[p];
        return is_none(v) ? 0 : [
            0,
            v
        ];
    }
    function find_map(f, o, p) {
        var v = o[p];
        return is_none(v) ? 0 : [
            0,
            caml_call1(f, v)
        ];
    }
    function find_path(o, param) {
        var o$0 = o, param$0 = param;
        for(;;){
            if (!param$0) return [
                0,
                o$0
            ];
            var ps = param$0[2], p = param$0[1], match = find(o$0, p);
            if (!match) return 0;
            var o$1 = match[1];
            o$0 = o$1;
            param$0 = ps;
        }
    }
    var true$0 = true, false$0 = false;
    function find$0(o, p) {
        var b = o[p];
        return is_none(b) ? 0 : [
            0,
            b | 0
        ];
    }
    function get(o, p) {
        return o[p] | 0;
    }
    function set(o, p, b) {
        return o[p] = !!b;
    }
    function set_if_some$0(o, p, param) {
        if (!param) return 0;
        var b = param[1];
        return set(o, p, b);
    }
    var Bool = [
        0,
        find$0,
        get,
        set,
        set_if_some$0
    ];
    function find$1(o, p) {
        var i = o[p];
        return is_none(i) ? 0 : [
            0,
            i
        ];
    }
    var get$0 = caml_js_get, set$0 = caml_js_set;
    function set_if_some$1(o, p, param) {
        if (!param) return 0;
        var i = param[1];
        return o[p] = i;
    }
    var Int = [
        0,
        find$1,
        get$0,
        set$0,
        set_if_some$1
    ];
    function find$2(o, p) {
        var f = o[p];
        return is_none(f) ? 0 : [
            0,
            f
        ];
    }
    var get$1 = caml_js_get, set$1 = caml_js_set;
    function set_if_some$2(o, p, param) {
        if (!param) return 0;
        var f = param[1];
        return o[p] = f;
    }
    var Float = [
        0,
        find$2,
        get$1,
        set$1,
        set_if_some$2
    ];
    function find$3(o, p) {
        var f = o[p];
        return is_none(f) ? 0 : [
            0,
            f | 0
        ];
    }
    function get$2(o, p) {
        return o[p] | 0;
    }
    var set$2 = caml_js_set;
    function set_if_some$3(o, p, param) {
        if (!param) return 0;
        var f = param[1];
        return o[p] = f;
    }
    var Int32 = [
        0,
        find$3,
        get$2,
        set$2,
        set_if_some$3
    ];
    function find$4(o, p) {
        var s = o[p];
        return is_none(s) ? 0 : [
            0,
            s
        ];
    }
    var get$3 = caml_js_get, set$3 = caml_js_set;
    function set_if_some$4(o, p, param) {
        if (!param) return 0;
        var f = param[1];
        return o[p] = f;
    }
    function is_array(jv) {
        return global[cst_Array].isArray(jv) | 0;
    }
    function create(n) {
        return new global[cst_Array](n);
    }
    function length(a) {
        return a["length"];
    }
    var Jarray = [
        0,
        create,
        length
    ];
    function to_array(conv, v) {
        var len = caml_call1(Jarray[2], v);
        return caml_call2(Stdlib_Array[1], len, function(i) {
            return caml_call1(conv, v[i]);
        });
    }
    function of_array(conv, a) {
        var len = a.length - 1, ja = caml_call1(Jarray[1], len), _e_ = len - 1 | 0, _d_ = 0;
        if (_e_ >= 0) {
            var i = _d_;
            for(;;){
                ja[i] = caml_call1(conv, runtime.caml_check_bound(a, i)[1 + i]);
                var _f_ = i + 1 | 0;
                if (_e_ === i) break;
                i = _f_;
            }
        }
        return ja;
    }
    function to_list(conv, v) {
        var len = caml_call1(Jarray[2], v);
        return caml_call2(Stdlib_List[11], len, function(i) {
            return caml_call1(conv, v[i]);
        });
    }
    function of_list(conv, l) {
        var ja = caml_call1(Jarray[1], 0), i = 0, param = l;
        for(;;){
            if (!param) return ja;
            var vs = param[2], v = param[1];
            ja[i] = caml_call1(conv, v);
            var i$0 = i + 1 | 0;
            i = i$0;
            param = vs;
        }
    }
    function v(name, msg) {
        var e = new global["Error"](msg);
        if (!name) return e;
        var n = name[1];
        e[cst_name] = n;
        return e;
    }
    function name(e) {
        return e[cst_name];
    }
    function enum$0(e) {
        var match = caml_string_of_jsstring(e[cst_name]), switch$0 = caml_string_compare(match, "NotAllowedError");
        if (0 <= switch$0) {
            if (0 >= switch$0) return 971339429;
            var switch$1 = caml_string_compare(match, "SyntaxError");
            if (0 <= switch$1) {
                if (0 >= switch$1) return 148000204;
                if (match === "TimeoutError") return -129520566;
                if (match === "TransactionInactiveError") return -28376747;
                if (match === "TypeMismatchError") return -823442212;
                if (match === "URLMismatchError") return 147573767;
                if (match === "UnknownError") return -1064646157;
                if (match === "VersionError") return -1025659903;
                if (match === "WrongDocumentError") return -937074026;
            } else {
                if (match === "NotFoundError") return 829592127;
                if (match === "NotReadableError") return -119831547;
                if (match === "NotSupportedError") return -935732949;
                if (match === "OperationError") return 115193424;
                if (match === "QuotaExceededError") return 246360739;
                if (match === "ReadOnlyError") return 842968798;
                if (match === "SecurityError") return 496062953;
            }
        } else {
            var switch$2 = caml_string_compare(match, "InvalidAccessError");
            if (0 <= switch$2) {
                if (0 >= switch$2) return 753062229;
                if (match === "InvalidCharacterError") return 197539530;
                if (match === "InvalidModificationError") return 943132429;
                if (match === "InvalidNodeTypeError") return -94613768;
                if (match === "InvalidStateError") return 986514226;
                if (match === "NamespaceError") return 861236164;
                if (match === "NetworkError") return 943709719;
                if (match === "NoModificationAllowedError") return 320841004;
            } else {
                if (match === "AbortError") return 183065241;
                if (match === "ConstraintError") return 539235142;
                if (match === "DataCloneError") return 1031143793;
                if (match === "DataError") return 483354835;
                if (match === "EncodingError") return 518067260;
                if (match === "HierarchyRequestError") return 227342318;
                if (match === "IndexSizeError") return 89185783;
            }
        }
        return -912009552;
    }
    function message(e) {
        return e["message"];
    }
    function stack(e) {
        return e["stack"];
    }
    function throw$0(name, msg) {
        var e = v(name, msg);
        return caml_call1(function(exn) {
            throw exn;
        }, e);
    }
    var Error1 = Jsoo_runtime[3][4], symbol = Symbol.iterator;
    function iterable(o) {
        var match = to_option(function(_c_) {
            return _c_;
        }, o[symbol]);
        if (!match) return 0;
        var func = match[1];
        return func();
    }
    function iterator(o) {
        return o[symbol]();
    }
    function next(it) {
        return it.next();
    }
    function result_done(o) {
        var match = to_option(caml_js_to_bool, o["done"]);
        if (!match) return 0;
        var d = match[1];
        return d;
    }
    function result_value(o) {
        return to_option(function(_b_) {
            return _b_;
        }, o[cst_value]);
    }
    function get_result_value(o) {
        return o[cst_value];
    }
    function fold(of_jv, f, it, acc) {
        var acc$0 = acc;
        for(;;){
            var r = it.next();
            if (result_done(r)) return acc$0;
            var acc$1 = caml_call2(f, caml_call1(of_jv, r[cst_value]), acc$0);
            acc$0 = acc$1;
        }
    }
    function fold_bindings(key, value, f, it, acc) {
        var acc$0 = acc;
        for(;;){
            var r = it.next();
            if (result_done(r)) return acc$0;
            var arr = r[cst_value], _a_ = caml_call1(value, arr[1]), acc$1 = caml_call3(f, caml_call1(key, arr[0]), _a_, acc$0);
            acc$0 = acc$1;
        }
    }
    var promise = global["Promise"];
    function create$0(f) {
        function g(res, rej) {
            return caml_call2(f, function(x) {
                return res(x);
            }, function(x) {
                return rej(x);
            });
        }
        return new promise(caml_js_wrap_callback_strict(2, g));
    }
    function resolve(v) {
        return promise.resolve(v);
    }
    function reject(v) {
        return promise.reject(v);
    }
    function await$0(p, k) {
        p.then(caml_js_wrap_callback_strict(1, k));
        return 0;
    }
    function bind(p, res) {
        return p.then(caml_js_wrap_callback_strict(1, res));
    }
    function then(p, res, rej) {
        return p.then(caml_js_wrap_callback_strict(1, res), caml_js_wrap_callback_strict(1, rej));
    }
    function all(arr) {
        return promise.all(arr);
    }
    function find$5(o, p) {
        var v = o[p];
        return is_none(v) ? 0 : [
            0,
            v
        ];
    }
    function find_map$0(f, o, p) {
        var v = o[p];
        return is_none(v) ? 0 : [
            0,
            caml_call1(f, v)
        ];
    }
    function obj(props) {
        return runtime.caml_js_object(caml_call2(Stdlib_Array[14], function(param) {
            var v = param[2], p = param[1];
            return [
                0,
                caml_string_of_jsstring(p),
                v
            ];
        }, props));
    }
    function call(o, m, args) {
        return runtime.caml_js_meth_call(o, caml_string_of_jsstring(m), args);
    }
    function has(p, v) {
        return is_some(v[p]);
    }
    function defined(v) {
        return is_some(v);
    }
    var Id = [
        0
    ], Jv = [
        0,
        caml_js_strict_equals,
        runtime.caml_js_typeof,
        runtime.caml_js_instanceof,
        null$0,
        undefined$0,
        is_null,
        is_undefined,
        is_none,
        is_some,
        to_option,
        of_option,
        global,
        find,
        find_map,
        find_path,
        set_if_some,
        true$0,
        false$0,
        Bool,
        Int,
        Float,
        Int32,
        [
            0,
            find$4,
            get$3,
            set$3,
            set_if_some$4
        ],
        runtime.caml_jsstring_of_string,
        caml_string_of_jsstring,
        is_array,
        to_array,
        of_array,
        to_list,
        of_list,
        Jarray,
        [
            0,
            v,
            name,
            enum$0,
            message,
            stack
        ],
        Error1,
        throw$0,
        [
            0,
            result_done,
            result_value,
            get_result_value,
            iterable,
            iterator,
            next,
            fold,
            fold_bindings
        ],
        [
            0,
            create$0,
            resolve,
            reject,
            await$0,
            bind,
            then,
            all
        ],
        find$5,
        find_map$0,
        obj,
        call,
        has,
        defined,
        Id
    ];
    runtime.caml_register_global(62, Jv, "Jv");
    return;
})(globalThis);
//# 570 "../.js/default/brr/brr.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_fut = "fut", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Result = global_data.Stdlib__Result, Jv = global_data.Jv, Assert_failure = global_data.Assert_failure, _a_ = [
        0,
        "src/fut.ml",
        34,
        25
    ];
    function promise(f) {
        return f[cst_fut];
    }
    function create(param) {
        function not_set(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _a_
            ], 1);
        }
        function is_set(param) {
            return caml_call2(Jv[34], 0, "The future is already set");
        }
        var setter = [
            0,
            not_set
        ];
        function set_setter(resolve, reject) {
            setter[1] = resolve;
            return 0;
        }
        var p = caml_call1(Jv[36][1], set_setter);
        function set(v) {
            caml_call1(setter[1], v);
            setter[1] = is_set;
            return 0;
        }
        return [
            0,
            {
                fut: p
            },
            set
        ];
    }
    function await$0(f, k) {
        var _k_ = f[cst_fut];
        return caml_call2(Jv[36][4], _k_, k);
    }
    function return$0(v) {
        var p = caml_call1(Jv[36][2], v);
        return {
            fut: p
        };
    }
    function bind(f, fn) {
        var _j_ = f[cst_fut], p = caml_call2(Jv[36][5], _j_, function(v) {
            var f = caml_call1(fn, v);
            return f[cst_fut];
        });
        return {
            fut: p
        };
    }
    function map(fn, f) {
        return bind(f, function(v) {
            return return$0(caml_call1(fn, v));
        });
    }
    function pair(f0, f1) {
        var _h_ = f0[cst_fut], p = caml_call1(caml_call1(Jv[36][5], _h_), function(v0) {
            var _i_ = f1[cst_fut];
            return caml_call1(caml_call1(Jv[36][5], _i_), function(v1) {
                return caml_call1(Jv[36][2], [
                    0,
                    v0,
                    v1
                ]);
            });
        });
        return {
            fut: p
        };
    }
    function of_list(fs) {
        var arr = caml_call2(Jv[30], promise, fs), all = caml_call1(Jv[36][7], arr);
        function to_list(l) {
            var _f_ = caml_call2(Jv[29], function(_g_) {
                return _g_;
            }, l);
            return caml_call1(Jv[36][2], _f_);
        }
        var p = caml_call2(Jv[36][5], all, to_list);
        return {
            fut: p
        };
    }
    function tick(ms) {
        var p = caml_call1(Jv[36][1], function(res, rej) {
            Jv[12]["setTimeout"](runtime.caml_js_wrap_callback_strict(1, res), ms);
            return 0;
        });
        return {
            fut: p
        };
    }
    function ok(v) {
        return return$0([
            0,
            v
        ]);
    }
    function error(e) {
        return return$0([
            1,
            e
        ]);
    }
    function of_promise(ok, error, p) {
        function ok$0(v) {
            var _e_ = [
                0,
                caml_call1(ok, v)
            ];
            return caml_call1(Jv[36][2], _e_);
        }
        function error$0(e) {
            var _d_ = [
                1,
                caml_call1(error, e)
            ];
            return caml_call1(Jv[36][2], _d_);
        }
        var p$0 = caml_call3(Jv[36][6], p, ok$0, error$0);
        return {
            fut: p$0
        };
    }
    function to_promise(ok, error, f) {
        return caml_call1(Jv[36][1], function(res, rej) {
            return await$0(f, function(param) {
                if (0 === param[0]) {
                    var v = param[1];
                    return caml_call1(res, caml_call1(ok, v));
                }
                var e = param[1];
                return caml_call1(rej, caml_call1(error, e));
            });
        });
    }
    function of_promise$0(ok, v) {
        return of_promise(ok, function(_c_) {
            return _c_;
        }, v);
    }
    function to_promise$0(ok, v) {
        return to_promise(ok, function(_b_) {
            return _b_;
        }, v);
    }
    function let$0(f, fn) {
        return map(fn, f);
    }
    var Syntax = [
        0,
        bind,
        pair,
        let$0,
        pair
    ];
    function result_pair(r0, r1) {
        if (0 === r0[0]) {
            var v0 = r0[1];
            if (0 === r1[0]) {
                var v1 = r1[1];
                return [
                    0,
                    [
                        0,
                        v0,
                        v1
                    ]
                ];
            }
            var r = r1;
        } else var r = r0;
        return r;
    }
    function let$1(f, fn) {
        return bind(f, function(e) {
            if (0 !== e[0]) return return$0(e);
            var v = e[1];
            return caml_call1(fn, v);
        });
    }
    function and(f0, f1) {
        return map(result_pair, pair(f0, f1));
    }
    function let$2(f, fn) {
        return map(caml_call1(Stdlib_Result[8], fn), f);
    }
    var Fut = [
        0,
        create,
        await$0,
        return$0,
        map,
        bind,
        pair,
        of_list,
        tick,
        ok,
        error,
        of_promise$0,
        to_promise$0,
        of_promise,
        to_promise,
        Syntax,
        [
            0,
            let$1,
            and,
            let$2,
            and
        ]
    ];
    runtime.caml_register_global(9, Fut, "Fut");
    return;
})(globalThis);
//# 752 "../.js/default/brr/brr.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = " ", cst_Float32Array = "Float32Array", cst_Float64Array = "Float64Array", cst_Int16Array = "Int16Array", cst_Int32Array = "Int32Array", cst_Int8Array = "Int8Array", cst_Uint16Array = "Uint16Array", cst_Uint32Array = "Uint32Array", cst_Uint8Array = "Uint8Array", cst_Uint8ClampedArray = "Uint8ClampedArray", cst_abort = "abort", cst_activeElement = "activeElement", cst_altKey$1 = "altKey", cst_append = "append", cst_auto = "auto", cst_blur = "blur", cst_body = "body", cst_bubbles$1 = "bubbles", cst_buffer = "buffer", cst_button$0 = "button", cst_byteLength$1 = "byteLength", cst_cancelable$1 = "cancelable", cst_checked = "checked", cst_classList = "classList", cst_clear$0 = "clear", cst_click = "click", cst_close = "close", cst_code$0 = "code", cst_composed$1 = "composed", cst_console = "console", cst_copy = "copy", cst_ctrlKey$1 = "ctrlKey", cst_data$1 = "data", cst_dataTransfer$1 = "dataTransfer", cst_dblclick = "dblclick", cst_dir$0 = "dir", cst_documentElement = "documentElement", cst_dropEffect$1 = "dropEffect", cst_effectAllowed$1 = "effectAllowed", cst_error$0 = "error", cst_firstChild = "firstChild", cst_focus = "focus", cst_hash$2 = "hash", cst_head = "head", cst_height$1 = "height", cst_hidden = "hidden", cst_hostname$1 = "hostname", cst_id = "id", cst_input = "input", cst_isComposing$1 = "isComposing", cst_lastModified$1 = "lastModified", cst_length$4 = "length", cst_link = "link", cst_location$0 = "location", cst_map = "map", cst_mark = "mark", cst_measure = "measure", cst_metaKey$1 = "metaKey", cst_name$2 = "name", cst_nodeType$1 = "nodeType", cst_open = "open", cst_ownerDocument = "ownerDocument", cst_pathname$1 = "pathname", cst_pointerLockElement = "pointerLockElement", cst_port$1 = "port", cst_progress = "progress", cst_protocol$1 = "protocol", cst_relatedTarget$1 = "relatedTarget", cst_reload = "reload", cst_scrollRestoration$1 = "scrollRestoration", cst_search$2 = "search", cst_select = "select", cst_shiftKey$1 = "shiftKey", cst_state = "state", cst_style = "style", cst_table$0 = "table", cst_time$0 = "time", cst_timeStamp$1 = "timeStamp", cst_title$1 = "title", cst_type$4 = "type", cst_value = "value", cst_width$1 = "width", cst_window = "window", caml_js_from_bool = runtime.caml_js_from_bool, caml_js_get = runtime.caml_js_get, caml_js_meth_call = runtime.caml_js_meth_call, caml_js_set = runtime.caml_js_set, caml_js_wrap_callback_strict = runtime.caml_js_wrap_callback_strict, caml_list_of_js_array = runtime.caml_list_of_js_array, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Jv = global_data.Jv, Jstr = global_data.Jstr, Fut = global_data.Fut, Stdlib_List = global_data.Stdlib__List, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Option = global_data.Stdlib__Option, Stdlib_Bigarray = global_data.Stdlib__Bigarray, Stdlib_Sys = global_data.Stdlib__Sys, Type = [
        0
    ], cst_bubbles = cst_bubbles$1, cst_cancelable = cst_cancelable$1, cst_composed = cst_composed$1;
    function init(bubbles, cancelable, composed, param) {
        var o = {};
        caml_call3(Jv[19][4], o, cst_bubbles, bubbles);
        caml_call3(Jv[19][4], o, cst_cancelable, cancelable);
        caml_call3(Jv[19][4], o, cst_composed, composed);
        return o;
    }
    var event = Jv[12]["Event"], cst_type = cst_type$4, cst_eventPhase = "eventPhase", cst_bubbles$0 = cst_bubbles$1, cst_cancelable$0 = cst_cancelable$1, cst_defaultPrevented = "defaultPrevented", cst_composed$0 = cst_composed$1, cst_isTrusted = "isTrusted", cst_timeStamp = cst_timeStamp$1, cst_capture = "capture", cst_once = "once", cst_passive = "passive", _a_ = [
        0,
        1
    ];
    function create(opt, t) {
        var init = opt ? opt[1] : {};
        return new event(t, init);
    }
    function type(e) {
        return caml_call2(Jv[23][2], e, cst_type);
    }
    function target(e) {
        return e["target"];
    }
    function current_target(e) {
        return e["currentTarget"];
    }
    function composed_path(e) {
        var _db_ = e.composedPath();
        return caml_call2(Jv[29], function(_dc_) {
            return _dc_;
        }, _db_);
    }
    function event_phase(e) {
        var switcher = caml_call2(Jv[20][2], e, cst_eventPhase) - 1 | 0;
        if (2 < switcher >>> 0) return 870530776;
        switch(switcher){
            case 0:
                return 497141539;
            case 1:
                return -276077507;
            default:
                return 608305129;
        }
    }
    function bubbles(e) {
        return caml_call2(Jv[19][2], e, cst_bubbles$0);
    }
    function stop_propagation(e) {
        e.stopPropagation();
        return 0;
    }
    function stop_immediate_propagation(e) {
        e.stopImmediatePropagation();
        return 0;
    }
    function cancelable(e) {
        return caml_call2(Jv[19][2], e, cst_cancelable$0);
    }
    function prevent_default(e) {
        e.preventDefault();
        return 0;
    }
    function default_prevented(e) {
        return caml_call2(Jv[19][2], e, cst_defaultPrevented);
    }
    function composed(e) {
        return caml_call2(Jv[19][2], e, cst_composed$0);
    }
    function is_trusted(e) {
        return caml_call2(Jv[19][2], e, cst_isTrusted);
    }
    function timestamp_ms(e) {
        return caml_call2(Jv[21][2], e, cst_timeStamp);
    }
    function dispatch(e, t) {
        return t.dispatchEvent(e) | 0;
    }
    function listen_opts(capture, once, passive, param) {
        var o = {};
        caml_call3(Jv[19][4], o, cst_capture, capture);
        caml_call3(Jv[19][4], o, cst_once, once);
        caml_call3(Jv[19][4], o, cst_passive, passive);
        return o;
    }
    function listen(opt, type, f, t) {
        var opts = opt ? opt[1] : {}, f$0 = caml_js_wrap_callback_strict(1, f);
        function unlisten(param) {
            t.removeEventListener(type, f$0, opts);
            return 0;
        }
        t.addEventListener(type, f$0, opts);
        return unlisten;
    }
    function unlisten(unlisten) {
        return caml_call1(unlisten, 0);
    }
    function next(capture, type, t) {
        var match = caml_call1(Fut[1], 0), set = match[2], fut = match[1], opts = listen_opts(capture, _a_, 0, 0);
        listen([
            0,
            opts
        ], type, set, t);
        return fut;
    }
    var none = "none", copy = cst_copy, copy_link = "copyLink", copy_move = "copyMove", link = cst_link, link_move = "linkMove", move = "move", all = "all", uninitialized = "uninitialized", Effect = [
        0,
        none,
        copy,
        copy_link,
        copy_move,
        link,
        link_move,
        move,
        all,
        uninitialized
    ], file = "file", string = "string", Kind = [
        0,
        file,
        string
    ], cst_kind = "kind", cst_type$0 = cst_type$4;
    function kind(i) {
        return caml_call2(Jv[23][2], i, cst_kind);
    }
    function type$0(i) {
        return caml_call2(Jv[23][2], i, cst_type$0);
    }
    function get_file(i) {
        var _c$_ = i.getAsFile();
        return caml_call2(Jv[10], function(_da_) {
            return _da_;
        }, _c$_);
    }
    function get_jstr(i) {
        var match = caml_call1(Fut[1], 0), set_str = match[2], str = match[1], set_str$0 = caml_js_wrap_callback_strict(1, set_str);
        i.getAsString(set_str$0);
        return str;
    }
    var Item = [
        0,
        Kind,
        kind,
        type$0,
        get_file,
        get_jstr
    ], cst_length = cst_length$4, cst_dropEffect = cst_dropEffect$1, cst_dropEffect$0 = cst_dropEffect$1, cst_effectAllowed = cst_effectAllowed$1, cst_effectAllowed$0 = cst_effectAllowed$1, cst_clipboardData = "clipboardData";
    function length(l) {
        return caml_call2(Jv[20][2], l, cst_length);
    }
    function add_jstr(l, type, str) {
        var _c9_ = l.add(str, type);
        return caml_call1(caml_call1(Jv[10], function(_c__) {
            return _c__;
        }), _c9_);
    }
    function add_file(t, file) {
        var _c7_ = t.add(file);
        return caml_call1(caml_call1(Jv[10], function(_c8_) {
            return _c8_;
        }), _c7_);
    }
    function remove(l, i) {
        l.remove(i);
        return 0;
    }
    function clear(l) {
        l.clear();
        return 0;
    }
    function items(l) {
        var acc = [
            0,
            0
        ], _c4_ = length(l) - 1 | 0;
        if (_c4_ >= 0) {
            var i = _c4_;
            for(;;){
                var _c5_ = acc[1];
                acc[1] = [
                    0,
                    l[i],
                    _c5_
                ];
                var _c6_ = i - 1 | 0;
                if (0 === i) break;
                i = _c6_;
            }
        }
        return acc[1];
    }
    function drop_effect(d) {
        return caml_call2(Jv[23][2], d, cst_dropEffect);
    }
    function set_drop_effect(d, e) {
        return caml_call3(Jv[23][3], d, cst_dropEffect$0, e);
    }
    function effect_allowed(d) {
        return caml_call2(Jv[23][2], d, cst_effectAllowed);
    }
    function set_effect_allowed(d, e) {
        return caml_call3(Jv[23][3], d, cst_effectAllowed$0, e);
    }
    function items$0(d) {
        return d["items"];
    }
    function data(c) {
        return caml_call3(Jv[14], function(_c3_) {
            return _c3_;
        }, c, cst_clipboardData);
    }
    var Clipboard = [
        0,
        data
    ], cst_data = cst_data$1;
    function data$0(i) {
        return caml_call2(Jv[23][2], i, cst_data);
    }
    var Composition = [
        0,
        data$0
    ], cst_message = "message", cst_filename = "filename", cst_lineno = "lineno", cst_colno = "colno";
    function message(e) {
        return caml_call2(Jv[23][2], e, cst_message);
    }
    function filename(e) {
        return caml_call2(Jv[23][2], e, cst_filename);
    }
    function lineno(e) {
        return caml_call2(Jv[20][2], e, cst_lineno);
    }
    function colno(e) {
        return caml_call2(Jv[20][2], e, cst_colno);
    }
    function error(e) {
        return e[cst_error$0];
    }
    var Error1 = [
        0,
        message,
        filename,
        lineno,
        colno,
        error
    ];
    function wait_until(e, fut) {
        e.waitUntil(caml_call2(Fut[12], function(_c2_) {
            return _c2_;
        }, fut));
        return 0;
    }
    var Extendable = [
        0,
        wait_until
    ], cst_relatedTarget = cst_relatedTarget$1;
    function related_target(m) {
        return caml_call3(Jv[14], function(_c1_) {
            return _c1_;
        }, m, cst_relatedTarget);
    }
    var Focus = [
        0,
        related_target
    ], cst_oldURL = "oldURL", cst_newURL = "newURL";
    function old_url(e) {
        return caml_call2(Jv[23][2], e, cst_oldURL);
    }
    function new_url(e) {
        return caml_call2(Jv[23][2], e, cst_newURL);
    }
    var Hash_change = [
        0,
        old_url,
        new_url
    ], cst_data$0 = cst_data$1, cst_dataTransfer = cst_dataTransfer$1, cst_inputType = "inputType", cst_isComposing = cst_isComposing$1;
    function data$1(i) {
        return caml_call2(Jv[23][2], i, cst_data$0);
    }
    function data_transfer(i) {
        return caml_call2(Jv[13], i, cst_dataTransfer);
    }
    function input_type(i) {
        return caml_call2(Jv[23][2], i, cst_inputType);
    }
    function is_composing(i) {
        return caml_call2(Jv[19][2], i, cst_isComposing);
    }
    var Input = [
        0,
        data$1,
        data_transfer,
        input_type,
        is_composing
    ], Location = [
        0,
        0,
        1,
        2,
        3
    ], cst_key = "key", cst_code = cst_code$0, cst_location = cst_location$0, cst_repeat = "repeat", cst_isComposing$0 = cst_isComposing$1, cst_altKey = cst_altKey$1, cst_ctrlKey = cst_ctrlKey$1, cst_shiftKey = cst_shiftKey$1, cst_metaKey = cst_metaKey$1;
    function key(k) {
        return caml_call2(Jv[23][2], k, cst_key);
    }
    function code(k) {
        return caml_call2(Jv[23][2], k, cst_code);
    }
    function location(k) {
        return caml_call2(Jv[20][2], k, cst_location);
    }
    function repeat(k) {
        return caml_call2(Jv[19][2], k, cst_repeat);
    }
    function is_composing$0(k) {
        return caml_call2(Jv[19][2], k, cst_isComposing$0);
    }
    function alt_key(k) {
        return caml_call2(Jv[19][2], k, cst_altKey);
    }
    function ctrl_key(k) {
        return caml_call2(Jv[19][2], k, cst_ctrlKey);
    }
    function shift_key(k) {
        return caml_call2(Jv[19][2], k, cst_shiftKey);
    }
    function meta_key(k) {
        return caml_call2(Jv[19][2], k, cst_metaKey);
    }
    function get_modifier_state(k, key) {
        return k.getModifierState(key) | 0;
    }
    var Keyboard = [
        0,
        Location,
        key,
        code,
        location,
        repeat,
        is_composing$0,
        alt_key,
        ctrl_key,
        shift_key,
        meta_key,
        get_modifier_state
    ], cst_relatedTarget$0 = cst_relatedTarget$1, cst_offsetX = "offsetX", cst_offsetY = "offsetY", cst_clientX = "clientX", cst_clientY = "clientY", cst_pageX = "pageX", cst_pageY = "pageY", cst_screenX = "screenX", cst_screenY = "screenY", cst_movementX = "movementX", cst_movementY = "movementY", cst_button = cst_button$0, cst_buttons = "buttons", cst_altKey$0 = cst_altKey$1, cst_ctrlKey$0 = cst_ctrlKey$1, cst_shiftKey$0 = cst_shiftKey$1, cst_metaKey$0 = cst_metaKey$1;
    function related_target$0(m) {
        return caml_call3(Jv[14], function(_c0_) {
            return _c0_;
        }, m, cst_relatedTarget$0);
    }
    function offset_x(m) {
        return caml_call2(Jv[21][2], m, cst_offsetX);
    }
    function offset_y(m) {
        return caml_call2(Jv[21][2], m, cst_offsetY);
    }
    function client_x(m) {
        return caml_call2(Jv[21][2], m, cst_clientX);
    }
    function client_y(m) {
        return caml_call2(Jv[21][2], m, cst_clientY);
    }
    function page_x(m) {
        return caml_call2(Jv[21][2], m, cst_pageX);
    }
    function page_y(m) {
        return caml_call2(Jv[21][2], m, cst_pageY);
    }
    function screen_x(m) {
        return caml_call2(Jv[21][2], m, cst_screenX);
    }
    function screen_y(m) {
        return caml_call2(Jv[21][2], m, cst_screenY);
    }
    function movement_x(m) {
        return caml_call2(Jv[21][2], m, cst_movementX);
    }
    function movement_y(m) {
        return caml_call2(Jv[21][2], m, cst_movementY);
    }
    function button(m) {
        return caml_call2(Jv[20][2], m, cst_button);
    }
    function buttons(m) {
        return caml_call2(Jv[20][2], m, cst_buttons);
    }
    function alt_key$0(m) {
        return caml_call2(Jv[19][2], m, cst_altKey$0);
    }
    function ctrl_key$0(m) {
        return caml_call2(Jv[19][2], m, cst_ctrlKey$0);
    }
    function shift_key$0(m) {
        return caml_call2(Jv[19][2], m, cst_shiftKey$0);
    }
    function meta_key$0(m) {
        return caml_call2(Jv[19][2], m, cst_metaKey$0);
    }
    function get_modifier_state$0(m, key) {
        return m.getModifierState(key) | 0;
    }
    var Mouse = [
        0,
        related_target$0,
        offset_x,
        offset_y,
        client_x,
        client_y,
        page_x,
        page_y,
        screen_x,
        screen_y,
        movement_x,
        movement_y,
        button,
        buttons,
        alt_key$0,
        ctrl_key$0,
        shift_key$0,
        meta_key$0,
        get_modifier_state$0
    ], cst_dataTransfer$0 = cst_dataTransfer$1;
    function data_transfer$0(d) {
        return caml_call3(Jv[14], function(_cZ_) {
            return _cZ_;
        }, d, cst_dataTransfer$0);
    }
    var Drag = [
        0,
        data_transfer$0
    ], cst_pointerId = "pointerId", cst_width = cst_width$1, cst_height = cst_height$1, cst_pressure = "pressure", cst_tangentialPressure = "tangentialPressure", cst_tiltX = "tiltX", cst_tiltY = "tiltY", cst_twist = "twist", cst_altitudeAngle = "altitudeAngle", cst_azimuthAngle = "azimuthAngle", cst_pointerType = "pointerType", cst_isPrimary = "isPrimary";
    function id(p) {
        return caml_call2(Jv[20][2], p, cst_pointerId);
    }
    function width(p) {
        return caml_call2(Jv[21][2], p, cst_width);
    }
    function height(p) {
        return caml_call2(Jv[21][2], p, cst_height);
    }
    function pressure(p) {
        return caml_call2(Jv[21][2], p, cst_pressure);
    }
    function tangential_pressure(p) {
        return caml_call2(Jv[21][2], p, cst_tangentialPressure);
    }
    function tilt_x(p) {
        return caml_call2(Jv[20][2], p, cst_tiltX);
    }
    function tilt_y(p) {
        return caml_call2(Jv[20][2], p, cst_tiltY);
    }
    function twist(p) {
        return caml_call2(Jv[20][2], p, cst_twist);
    }
    function altitude_angle(p) {
        return caml_call2(Jv[21][2], p, cst_altitudeAngle);
    }
    function azimuth_angle(p) {
        return caml_call2(Jv[21][2], p, cst_azimuthAngle);
    }
    function type$1(p) {
        return caml_call2(Jv[23][2], p, cst_pointerType);
    }
    function is_primary(p) {
        return caml_call2(Jv[19][2], p, cst_isPrimary);
    }
    function get_coalesced_events(p) {
        var _cX_ = p.getCoalescedEvents();
        return caml_call2(Jv[29], function(_cY_) {
            return _cY_;
        }, _cX_);
    }
    function get_predicted_events(p) {
        var _cV_ = p.getPredictedEvents();
        return caml_call2(Jv[29], function(_cW_) {
            return _cW_;
        }, _cV_);
    }
    var Pointer = [
        0,
        id,
        width,
        height,
        pressure,
        tangential_pressure,
        tilt_x,
        tilt_y,
        twist,
        altitude_angle,
        azimuth_angle,
        type$1,
        is_primary,
        get_coalesced_events,
        get_predicted_events
    ], Delta_mode = [
        0,
        0,
        1,
        2
    ], cst_deltaX = "deltaX", cst_deltaY = "deltaY", cst_deltaZ = "deltaZ", cst_deltaMode = "deltaMode";
    function delta_x(w) {
        return caml_call2(Jv[21][2], w, cst_deltaX);
    }
    function delta_y(w) {
        return caml_call2(Jv[21][2], w, cst_deltaY);
    }
    function delta_z(w) {
        return caml_call2(Jv[21][2], w, cst_deltaZ);
    }
    function delta_mode(w) {
        return caml_call2(Jv[20][2], w, cst_deltaMode);
    }
    var Wheel = [
        0,
        Delta_mode,
        delta_x,
        delta_y,
        delta_z,
        delta_mode
    ], abort = cst_abort, activate = "activate", auxclick = cst_dblclick, beforeinput = "beforeinput", beforeunload = "beforeunload", blur = cst_blur, canplay = "canplay", canplaythrough = "canplaythrough", change = "change", click = cst_click, clipboardchange = "clipboardchange", close = cst_close, compositionend = "compositionend", compositionstart = "compositionstart", compositionudpate = "compositionupdate", controllerchange = "controllerchange", copy$0 = cst_copy, cut = "cut", dblclick = cst_dblclick, dom_content_loaded = "DOMContentLoaded", drag = "drag", dragend = "dragend", dragenter = "dragenter", dragexit = "dragexit", dragleave = "dragleave", dragover = "dragover", dragstart = "dragstart", drop = "drop", durationchange = "durationchange", emptied = "emptied", ended = "ended", error$0 = cst_error$0, focus = cst_focus, focusin = "focusin", focusout = "focusout", fullscreenchange = "fullscreenchange", fullscreenerror = "fullscreenerror", gotpointercapture = "gotpointercapture", hashchange = "hashchange", input = cst_input, install = "install", keydown = "keydown", keyup = "keyup", languagechange = "languagechange", load = "load", loadeddata = "loadeddata", loadedmetadata = "loadedmetadata", loadstart = "loadstart", lostpointercapture = "lostpointercapture", mousedown = "mousedown", mouseenter = "mouseenter", mouseleave = "mouseleave", mousemove = "mousemove", mouseout = "mouseout", mouseover = "mouseover", mouseup = "mouseup", open = cst_open, paste = "paste", pause = "pause", play = "play", playing = "playing", pointercancel = "pointercancel", pointerdown = "pointerdown", pointerenter = "pointerenter", pointerleave = "pointerleave", pointerlockchange = "pointerlockchange", pointerlockerror = "pointerlockerror", pointermove = "pointermove", pointerout = "pointerout", pointerover = "pointerover", pointerrawupdate = "pointerrawupdate", pointerup = "pointerup", progress = cst_progress, ratechange = "ratechange", reset = "reset", resize = "resize", scroll = "scroll", seeked = "seeked", seeking = "seeking", select = cst_select, stalled = "stalled", statechange = "statechange", suspend = "suspend", timeupdate = "timeupdate", unload = "unload", updatefound = "updatefound", visibilitychange = "visibilitychange", volumechange = "volumechange", waiting = "waiting", wheel = "wheel", array_buffer = Jv[12]["ArrayBuffer"], cst_byteLength = cst_byteLength$1, cst_byteOffset = "byteOffset", cst_byteLength$0 = cst_byteLength$1;
    function create$0(n) {
        return new array_buffer(n);
    }
    function byte_length(a) {
        return caml_call2(Jv[20][2], a, cst_byteLength);
    }
    function slice(opt, stop, a) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = byte_length(a);
        return a.slice(start, stop$1);
    }
    function buffer(o) {
        return o[cst_buffer];
    }
    function byte_offset(o) {
        return caml_call2(Jv[20][2], o, cst_byteOffset);
    }
    function byte_length$0(o) {
        return caml_call2(Jv[20][2], o, cst_byteLength$0);
    }
    var dataview = Jv[12]["DataView"], cst_length$0 = cst_length$4, cst_name = cst_name$2;
    function of_buffer(opt, byte_length$0, b) {
        var byte_offset = opt ? opt[1] : 0;
        if (byte_length$0) var l = byte_length$0[1], byte_length$1 = l;
        else var byte_length$1 = byte_length(b);
        return new dataview(b, byte_offset, byte_length$1);
    }
    function get_int8(b, i) {
        return b.getInt8(i);
    }
    function get_int16_be(b, i) {
        return b.getInt16(i);
    }
    function get_int16_le(b, i) {
        return b.getInt16(i, Jv[17]);
    }
    function get_int32_be(b, i) {
        return b.getInt32(i) | 0;
    }
    function get_int32_le(b, i) {
        return b.getInt32(i, Jv[17]) | 0;
    }
    function get_uint8(b, i) {
        return b.getUint8(i);
    }
    function get_uint16_be(b, i) {
        return b.getUint16(i);
    }
    function get_uint16_le(b, i) {
        return b.getUint16(i, Jv[17]);
    }
    function get_uint32_be(b, i) {
        return b.getUint32(i) | 0;
    }
    function get_uint32_le(b, i) {
        return b.getUint32(i, Jv[17]) | 0;
    }
    function get_float32_be(b, i) {
        return b.getFloat32(i);
    }
    function get_float32_le(b, i) {
        return b.getFloat32(i, Jv[17]);
    }
    function get_float64_be(b, i) {
        return b.getFloat64(i);
    }
    function get_float64_le(b, i) {
        return b.getFloat64(i, Jv[17]);
    }
    function set_int8(b, i, v) {
        b.setInt8(i, v);
        return 0;
    }
    function set_int16_be(b, i, v) {
        b.setInt16(i, v);
        return 0;
    }
    function set_int16_le(b, i, v) {
        b.setInt16(i, v, Jv[17]);
        return 0;
    }
    function set_int32_be(b, i, v) {
        b.setInt32(i, v);
        return 0;
    }
    function set_int32_le(b, i, v) {
        b.setInt32(i, v, Jv[17]);
        return 0;
    }
    function set_uint8(b, i, v) {
        b.setUint8(i, v);
        return 0;
    }
    function set_uint16_be(b, i, v) {
        b.setUint16(i, v);
        return 0;
    }
    function set_uint16_le(b, i, v) {
        b.setUint16(i, v, Jv[17]);
        return 0;
    }
    function set_uint32_be(b, i, v) {
        b.setUint32(i, v);
        return 0;
    }
    function set_uint32_le(b, i, v) {
        b.setUint32(i, v, Jv[17]);
        return 0;
    }
    function set_float32_be(b, i, v) {
        b.setFloat32(i, v);
        return 0;
    }
    function set_float32_le(b, i, v) {
        b.setFloat32(i, v, Jv[17]);
        return 0;
    }
    function set_float64_be(b, i, v) {
        b.setFloat64(i, v);
        return 0;
    }
    function set_float64_le(b, i, v) {
        b.setFloat64(i, v, Jv[17]);
        return 0;
    }
    function type_size_in_bytes(param) {
        switch(param){
            case 8:
                return 8;
            case 1:
            case 5:
                return 2;
            case 0:
            case 3:
            case 4:
                return 1;
            default:
                return 4;
        }
    }
    function cons_of_type(param) {
        switch(param){
            case 0:
                return Jv[12][cst_Int8Array];
            case 1:
                return Jv[12][cst_Int16Array];
            case 2:
                return Jv[12][cst_Int32Array];
            case 3:
                return Jv[12][cst_Uint8Array];
            case 4:
                return Jv[12][cst_Uint8ClampedArray];
            case 5:
                return Jv[12][cst_Uint16Array];
            case 6:
                return Jv[12][cst_Uint32Array];
            case 7:
                return Jv[12][cst_Float32Array];
            default:
                return Jv[12][cst_Float64Array];
        }
    }
    function create$1(t, n) {
        return new (cons_of_type(t))(n);
    }
    function of_buffer$0(t, opt, length, b) {
        var byte_offset = opt ? opt[1] : 0;
        if (length) var l = length[1], args = [
            0,
            b,
            byte_offset,
            l
        ];
        else var args = [
            0,
            b,
            byte_offset
        ];
        return runtime.caml_js_new(cons_of_type(t), args);
    }
    function length$0(a) {
        return caml_call2(Jv[20][2], a, cst_length$0);
    }
    function type$2(a) {
        var _cT_ = a["constructor"], s = runtime.caml_string_of_jsstring(caml_call2(Jv[23][2], _cT_, cst_name));
        if (s === cst_Float32Array) return 7;
        if (s === cst_Float64Array) return 8;
        if (s === cst_Int16Array) return 1;
        if (s === cst_Int32Array) return 2;
        if (s === cst_Int8Array) return 0;
        if (s === cst_Uint16Array) return 5;
        if (s === cst_Uint32Array) return 6;
        if (s === cst_Uint8Array) return 3;
        if (s === cst_Uint8ClampedArray) return 4;
        var t = runtime.caml_jsstring_of_string(s), _cU_ = caml_call2(Jstr[7], "Unknown typed array: ", t);
        return caml_call2(Jv[34], 0, _cU_);
    }
    function elt_to_jv(a) {
        switch(type$2(a)){
            case 0:
                return function(_cS_) {
                    return _cS_;
                };
            case 1:
                return function(_cR_) {
                    return _cR_;
                };
            case 2:
                return function(_cQ_) {
                    return _cQ_;
                };
            case 3:
                return function(_cP_) {
                    return _cP_;
                };
            case 4:
                return function(_cO_) {
                    return _cO_;
                };
            case 5:
                return function(_cN_) {
                    return _cN_;
                };
            case 6:
                return function(_cM_) {
                    return _cM_;
                };
            case 7:
                return function(_cL_) {
                    return _cL_;
                };
            default:
                return function(_cK_) {
                    return _cK_;
                };
        }
    }
    function elt_of_jv(a) {
        switch(type$2(a)){
            case 0:
                return function(_cJ_) {
                    return _cJ_;
                };
            case 1:
                return function(_cI_) {
                    return _cI_;
                };
            case 2:
                return function(_cH_) {
                    return _cH_ | 0;
                };
            case 3:
                return function(_cG_) {
                    return _cG_;
                };
            case 4:
                return function(_cF_) {
                    return _cF_;
                };
            case 5:
                return function(_cE_) {
                    return _cE_;
                };
            case 6:
                return function(_cD_) {
                    return _cD_ | 0;
                };
            case 7:
                return function(_cC_) {
                    return _cC_;
                };
            default:
                return function(_cB_) {
                    return _cB_;
                };
        }
    }
    var _b_ = Stdlib_Sys[5];
    a: {
        var cst_timeOrigin = "timeOrigin", cst_redirectCount = "redirectCount", cst_type$3 = "type'", cst_loadEventEnd = "loadEventEnd", cst_loadEventStart = "loadEventStart", cst_domComplete = "domComplete", cst_domContentLoadedEventEnd = "domContentLoadedEventEnd", cst_domContentLoadedEventStart = "domContentLoadedEventStart", cst_domInteractive = "domInteractive", cst_unloadEventEnd = "unloadEventEnd", cst_unloadEventStart = "unloadEventStart", cst_decodedBodySize = "decodedBodySize", cst_encodedBodySize = "encodedBodySize", cst_transferSize = "transferSize", cst_responseEnd = "responseEnd", cst_responseStart = "responseStart", cst_requestStart = "requestStart", cst_secureConnectionStart = "secureConnectionStart", cst_connectEnd = "connectEnd", cst_connectStart = "connectStart", cst_domainLookupEnd = "domainLookupEnd", cst_domainLookupStart = "domainLookupStart", cst_fetchStart = "fetchStart", cst_redirectEnd = "redirectEnd", cst_redirectStart = "redirectStart", cst_workerStart = "workerStart", cst_nextHopProtocol = "nextHopProtocol", cst_initiatorType = "initiatorType", cst_duration = "duration", cst_endTime = "endTime", cst_startTime = "startTime", cst_entryType = "entryType", cst_name$1 = cst_name$2, cst_onLine = "onLine", cst_languages = "languages", cst_language = "language", cst_scrollRestoration$0 = cst_scrollRestoration$1, cst_scrollRestoration = cst_scrollRestoration$1, cst_length$3 = cst_length$4, cst_matches = "matches", cst_devicePixelRatio = "devicePixelRatio", cst_scrollY = "scrollY", cst_scrollX = "scrollX", cst_closed = "closed", cst_timeStamp$0 = cst_timeStamp$1, cst_profileEnd = "profileEnd", cst_profile = "profile", cst_timeEnd = "timeEnd", cst_timeLog = "timeLog", cst_time = cst_time$0, cst_countReset = "countReset", cst_count = "count", cst_groupCollapsed = "groupCollapsed", cst_group = "group", cst_groupEnd = "groupEnd", cst_table = cst_table$0, cst_dir = cst_dir$0, cst_assert = "assert", cst_debug = "debug", cst_info = "info", cst_warn = "warn", cst_error = cst_error$0, cst_trace = "trace", cst_log = "log", cst_clear = cst_clear$0, cst_aborted = "aborted", cst_fullscreenEnabled = "fullscreenEnabled", cst_visibilityState = "visibilityState", cst_title$0 = cst_title$1, cst_title = cst_title$1, cst_referrer = "referrer", cst_files = "files", cst_navigationUI = "navigationUI", _q_ = [
            0,
            0
        ], _p_ = [
            0,
            1
        ], cst_scrollHeight = "scrollHeight", cst_scrollWidth = "scrollWidth", cst_scrollTop = "scrollTop", cst_scrollLeft = "scrollLeft", cst_height$0 = cst_height$1, cst_width$0 = cst_width$1, cst_y = "y", cst_x = "x", cst_clientHeight = "clientHeight", cst_clientWidth = "clientWidth", cst_clientTop = "clientTop", cst_clientLeft = "clientLeft", cst_nextElementSibling = "nextElementSibling", cst_previousElementSibling = "previousElementSibling", cst_parentNode = "parentNode", cst_length$2 = cst_length$4, cst_nodeValue = "nodeValue", cst_nodeName = "nodeName", cst_nodeType$0 = cst_nodeType$1, cst_nodeType = cst_nodeType$1, cst_length$1 = cst_length$4, cst_hash$1 = cst_hash$2, cst_search$1 = cst_search$2, _n_ = [
            0,
            1
        ], cst_hash$0 = cst_hash$2, _m_ = [
            0,
            1
        ], cst_search$0 = cst_search$2, _l_ = [
            0,
            1
        ], cst_pathname$0 = cst_pathname$1, cst_port$0 = cst_port$1, cst_hostname$0 = cst_hostname$1, cst_protocol$0 = cst_protocol$1, _k_ = [
            0,
            -1
        ], cst_protocol = cst_protocol$1, cst_hostname = cst_hostname$1, cst_port = cst_port$1, cst_pathname = cst_pathname$1, cst_search = cst_search$2, cst_hash = cst_hash$2, cst_lastModified$0 = cst_lastModified$1, cst_webkitRelativePath = "webkitRelativePath", cst_name$0 = cst_name$2, cst_lastModified = cst_lastModified$1, cst_lengthComputable = "lengthComputable", cst_loaded = "loaded", cst_total = "total", _j_ = [
            0,
            1
        ], cst_type$2 = cst_type$4, cst_size = "size", cst_type$1 = cst_type$4, cst_endings = "endings", _c_ = [
            0,
            7
        ], _d_ = [
            0,
            8
        ], _e_ = [
            0,
            0
        ], _f_ = [
            0,
            3
        ], _g_ = [
            0,
            1
        ], _h_ = [
            0,
            5
        ], _i_ = [
            0,
            2
        ], cst_utf_8 = "utf-8", cst_isSecureContext = "isSecureContext";
        if (typeof _b_ !== "number" && _b_[1] === "wasm_of_ocaml") {
            var compiled_to_wasm = 1;
            break a;
        }
        var compiled_to_wasm = 0;
    }
    var get = compiled_to_wasm ? function(a, i) {
        var _cA_ = a[i];
        return elt_of_jv(a)(_cA_);
    } : caml_js_get, set = compiled_to_wasm ? function(a, i, v) {
        return a[i] = elt_to_jv(a)(v);
    } : caml_js_set;
    function set_tarray(a, dst, b) {
        a.set(b, dst);
        return 0;
    }
    function fill(opt, stop, v, a) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = length$0(a);
        a.fill(elt_to_jv(a)(v), start, stop$1);
        return 0;
    }
    function copy_within(opt, stop, dst, a) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = length$0(a);
        a.copyWithin(dst, start, stop$1);
        return 0;
    }
    function slice$0(opt, stop, a) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = byte_length$0(a);
        return a.slice(start, stop$1);
    }
    function sub(opt, stop, a) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = byte_length$0(a);
        return a.subArray(start, stop$1);
    }
    function find(sat, a) {
        var of_jv = elt_of_jv(a);
        function sat$0(v, i) {
            return !!caml_call2(sat, i, of_jv(v));
        }
        var _cz_ = a.find(caml_js_wrap_callback_strict(2, sat$0));
        return caml_call2(Jv[10], of_jv, _cz_);
    }
    function find_index(sat, a) {
        var of_jv = elt_of_jv(a);
        function sat$0(v, i) {
            return !!caml_call2(sat, i, of_jv(v));
        }
        var i = a.findIndex(caml_js_wrap_callback_strict(2, sat$0));
        return -1 === i ? 0 : [
            0,
            i
        ];
    }
    function for_all(sat, a) {
        var of_jv = elt_of_jv(a);
        function sat$0(v, i) {
            return !!caml_call2(sat, i, of_jv(v));
        }
        return a.every(caml_js_wrap_callback_strict(2, sat$0)) | 0;
    }
    function exists(sat, a) {
        var of_jv = elt_of_jv(a);
        function sat$0(v, i) {
            return !!caml_call2(sat, i, of_jv(v));
        }
        return a.every(caml_js_wrap_callback_strict(2, sat$0)) | 0;
    }
    function filter(sat, a) {
        var of_jv = elt_of_jv(a);
        function sat$0(v, i) {
            return !!caml_call2(sat, i, of_jv(v));
        }
        return a.filter(caml_js_wrap_callback_strict(2, sat$0));
    }
    function iter(f, a) {
        var of_jv = elt_of_jv(a);
        function f$0(v, i) {
            return caml_call2(f, i, of_jv(v));
        }
        a.forEach(caml_js_wrap_callback_strict(2, f$0));
        return 0;
    }
    function map(f, a) {
        var of_jv = elt_of_jv(a);
        function f$0(v) {
            return caml_call1(f, of_jv(v));
        }
        return a.map(caml_js_wrap_callback_strict(1, f$0));
    }
    function fold_left(f, acc, a) {
        var of_jv = elt_of_jv(a);
        function f$0(acc, v) {
            return caml_call2(f, acc, of_jv(v));
        }
        return a.reduce(caml_js_wrap_callback_strict(2, f$0), acc);
    }
    function fold_right(f, a, acc) {
        var of_jv = elt_of_jv(a);
        function f$0(acc, v) {
            return caml_call2(f, of_jv(v), acc);
        }
        return a.reduceRight(caml_js_wrap_callback_strict(2, f$0), acc);
    }
    function reverse(a) {
        return a.reverse();
    }
    function of_tarray(t, a) {
        return new (cons_of_type(t))(a);
    }
    function of_int_array(t, a) {
        var _cx_ = caml_call2(Jv[28], function(_cy_) {
            return _cy_;
        }, a);
        return new (cons_of_type(t))(_cx_);
    }
    function of_float_array(t, a) {
        var _cv_ = caml_call2(Jv[28], function(_cw_) {
            return _cw_;
        }, a);
        return new (cons_of_type(t))(_cv_);
    }
    function to_int_jstr(opt, b) {
        var sep = opt ? opt[1] : Jstr[5];
        return b.join(sep);
    }
    function to_hex_jstr(opt, a) {
        var sep = opt ? opt[1] : Jstr[4], hex = "0123456789abcdef", d = of_buffer(0, 0, a[cst_buffer]), s = [
            0,
            Jstr[4]
        ], _cp_ = byte_length$0(d) - 1 | 0, _co_ = 0;
        if (_cp_ >= 0) {
            var i = _co_;
            for(;;){
                var b = d.getUint8(i), sep$0 = 0 === i ? Jstr[4] : sep, _cq_ = caml_call2(Jstr[3], hex, b & 15), _cr_ = caml_call2(Jstr[3], hex, b >>> 4 | 0), _cs_ = caml_call2(Jstr[8], s[1], sep$0), _ct_ = caml_call2(Jstr[8], _cs_, _cr_);
                s[1] = caml_call2(Jstr[8], _ct_, _cq_);
                var _cu_ = i + 1 | 0;
                if (_cp_ === i) break;
                i = _cu_;
            }
        }
        return s[1];
    }
    function uint8_of_buffer(b) {
        return of_buffer$0(3, 0, 0, b);
    }
    function of_jstr(s) {
        var enc = new Jv[12]["TextEncoder"];
        return enc.encode(s);
    }
    function to_jstr(a) {
        var _cm_ = {
            fatal: Jv[17]
        }, _cn_ = caml_call1(Jv[24], cst_utf_8), dec = new Jv[12]["TextDecoder"](_cn_, _cm_);
        try {
            var s = dec.decode(a);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            s
        ];
    }
    function of_binary_jstr(s) {
        try {
            var n = caml_call1(Jstr[1], s), b = new array_buffer(n), d = of_buffer(0, 0, b), _ci_ = caml_call1(Jstr[1], s) - 1 | 0, _ch_ = 0;
            if (_ci_ >= 0) {
                var i = _ch_;
                for(;;){
                    var c = s.charCodeAt(i);
                    if (255 < c) var _cc_ = caml_call2(Jstr[33], 0, c), _cd_ = caml_call2(Jstr[33], 0, i), _ce_ = caml_call2(Jstr[8], _cd_, ": char code "), _cf_ = caml_call2(Jstr[8], _ce_, _cc_), _cg_ = caml_call2(Jstr[8], _cf_, "exceeds 255"), _ck_ = caml_call2(Jv[34], 0, _cg_);
                    else var _ck_ = c;
                    set_int8(d, i, _ck_);
                    var _cl_ = i + 1 | 0;
                    if (_ci_ === i) break;
                    i = _cl_;
                }
            }
            var _cj_ = [
                0,
                of_buffer$0(0, 0, 0, b)
            ];
            return _cj_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
    }
    function to_binary_jstr(a) {
        var d = of_buffer(0, 0, a[cst_buffer]), s = [
            0,
            Jstr[4]
        ], _ca_ = byte_length$0(d) - 1 | 0, _b$_ = 0;
        if (_ca_ >= 0) {
            var i = _b$_;
            for(;;){
                var b = d.getUint8(i), _b__ = Jv[12]["String"].fromCharCode(b);
                s[1] = caml_call2(Jstr[8], s[1], _b__);
                var _cb_ = i + 1 | 0;
                if (_ca_ === i) break;
                i = _cb_;
            }
        }
        return s[1];
    }
    function type_to_bigarray_kind(param) {
        switch(param){
            case 0:
                return Stdlib_Bigarray[6];
            case 1:
                return Stdlib_Bigarray[8];
            case 2:
                return Stdlib_Bigarray[11];
            case 3:
                return Stdlib_Bigarray[7];
            case 4:
                return Stdlib_Bigarray[7];
            case 5:
                return Stdlib_Bigarray[9];
            case 6:
                return Stdlib_Bigarray[11];
            case 7:
                return Stdlib_Bigarray[2];
            default:
                return Stdlib_Bigarray[3];
        }
    }
    function type_of_bigarray_kind(param) {
        switch(param){
            case 0:
                return _c_;
            case 1:
                return _d_;
            case 2:
                return _e_;
            case 3:
                return _f_;
            case 4:
                return _g_;
            case 5:
                return _h_;
            case 6:
                return _i_;
            default:
                return 0;
        }
    }
    var transparent = "transparent", native$0 = "native", Ending_type = [
        0,
        transparent,
        native$0
    ];
    function init$0(type, endings, param) {
        var o = {};
        caml_call3(Jv[23][4], o, cst_type$1, type);
        caml_call3(Jv[23][4], o, cst_endings, endings);
        return o;
    }
    var blob = Jv[12]["Blob"];
    function of_jstr$0(opt, s) {
        var init = opt ? opt[1] : Jv[5], a = caml_call1(Jv[31][1], 1);
        a[0] = s;
        return new blob(a, init);
    }
    function of_array_buffer(opt, b) {
        var init = opt ? opt[1] : Jv[5];
        return new blob(runtime.caml_js_from_array([
            0,
            b
        ]), init);
    }
    function byte_length$1(b) {
        return caml_call2(Jv[20][2], b, cst_size);
    }
    function type$3(b) {
        return caml_call2(Jv[23][2], b, cst_type$2);
    }
    function slice$1(_b9_, stop, opt, b) {
        var start = _b9_ ? _b9_[1] : 0, type = opt ? opt[1] : Jstr[4];
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = byte_length$1(b);
        return b.slice(start, stop$1, type);
    }
    function stream(b) {
        return b["stream"];
    }
    function file_reader(progress$0, conv) {
        function progress_data(e) {
            if (!caml_call2(Jv[19][2], e, cst_lengthComputable)) return 0;
            var loaded = caml_call2(Jv[21][2], e, cst_loaded), total = caml_call2(Jv[21][2], e, cst_total);
            return [
                0,
                [
                    0,
                    loaded,
                    total
                ]
            ];
        }
        var reader = new Jv[12]["FileReader"], match = caml_call1(Fut[1], 0), set_fut = match[2], fut = match[1];
        function ok(e) {
            if (progress$0) {
                var progress = progress$0[1];
                caml_call1(progress, progress_data(e));
            }
            return caml_call1(set_fut, [
                0,
                caml_call1(conv, reader["result"])
            ]);
        }
        function error(e) {
            return caml_call1(set_fut, [
                1,
                reader[cst_error$0]
            ]);
        }
        var opts = listen_opts(0, _j_, 0, 0);
        listen([
            0,
            opts
        ], load, ok, reader);
        listen([
            0,
            opts
        ], error$0, error, reader);
        if (progress$0) {
            var progress$1 = progress$0[1], progress$2 = function(e) {
                return caml_call1(progress$1, progress_data(e));
            };
            listen(0, progress, progress$2, reader);
        }
        return [
            0,
            fut,
            reader
        ];
    }
    function array_buffer$0(progress, b) {
        if (progress) {
            var match = file_reader(progress, function(_b8_) {
                return _b8_;
            }), reader = match[2], fut = match[1];
            reader.readAsArrayBuffer(b);
            return fut;
        }
        var _b6_ = b.arrayBuffer();
        return caml_call2(Fut[11], function(_b7_) {
            return _b7_;
        }, _b6_);
    }
    function text(progress, b) {
        if (progress) {
            var match = file_reader(progress, function(_b5_) {
                return _b5_;
            }), reader = match[2], fut = match[1];
            reader.readAsText(b);
            return fut;
        }
        var _b3_ = b.text();
        return caml_call2(Fut[11], function(_b4_) {
            return _b4_;
        }, _b3_);
    }
    function data_uri(progress, b) {
        var match = file_reader(progress, function(_b2_) {
            return _b2_;
        }), reader = match[2], fut = match[1];
        reader.readAsDataURL(b);
        return fut;
    }
    function init$1(blob_init, last_modified_ms, param) {
        if (blob_init) var b = blob_init[1], o = b;
        else var o = {};
        caml_call3(Jv[20][4], o, cst_lastModified, last_modified_ms);
        return o;
    }
    var file$0 = Jv[12]["File"];
    function of_blob(opt, name, b) {
        var init = opt ? opt[1] : {};
        return new file$0(b, name, init);
    }
    function name(f) {
        return caml_call2(Jv[23][2], f, cst_name$0);
    }
    function relative_path(f) {
        var p = caml_call3(Jv[14], function(_b1_) {
            return _b1_;
        }, f, cst_webkitRelativePath);
        return caml_call2(Stdlib_Option[3], p, Jstr[4]);
    }
    function last_modified_ms(f) {
        return caml_call2(Jv[20][2], f, cst_lastModified$0);
    }
    function data_utf_8_of_jstr(s) {
        return to_binary_jstr(of_jstr(s));
    }
    function data_utf_8_to_jstr(d) {
        var e = of_binary_jstr(d);
        if (0 !== e[0]) return e;
        var t = e[1];
        return to_jstr(t);
    }
    function data_of_binary_jstr(_b0_) {
        return _b0_;
    }
    function data_to_binary_jstr(_bZ_) {
        return _bZ_;
    }
    function encode(bs) {
        try {
            var v = Jv[12]["btoa"](bs);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            v
        ];
    }
    function decode(s) {
        try {
            var v = Jv[12]["atob"](s);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            v
        ];
    }
    var Base64 = [
        0,
        data_utf_8_of_jstr,
        data_utf_8_to_jstr,
        data_of_binary_jstr,
        data_to_binary_jstr,
        encode,
        decode
    ], json = Jv[12]["JSON"];
    function encode$0(v) {
        return json.stringify(v);
    }
    function decode$0(s) {
        try {
            var v = json.parse(s);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            v
        ];
    }
    var encode$1 = Jv[12]["encodeURI"], decode$1 = Jv[12]["decodeURI"], encode_component = Jv[12]["encodeURIComponent"], decode_component = Jv[12]["decodeURIComponent"], url = Jv[12]["URL"];
    function v(base, s) {
        if (!base) return new url(s);
        var b = base[1];
        return new url(s, b);
    }
    function with_uri(scheme, host, port, path, query, fragment, u) {
        var u$0 = new url(u);
        try {
            caml_call3(Jv[23][4], u$0, cst_protocol, scheme);
            caml_call3(Jv[23][4], u$0, cst_hostname, host);
            if (port) {
                var p = port[1], arg = Jstr[33], _bX_ = caml_call2(Stdlib_Option[7], function(eta) {
                    return caml_call2(arg, 0, eta);
                }, p);
                caml_call3(Jv[23][4], u$0, cst_port, _bX_);
            }
            caml_call3(Jv[23][4], u$0, cst_pathname, path);
            caml_call3(Jv[23][4], u$0, cst_search, query);
            caml_call3(Jv[23][4], u$0, cst_hash, fragment);
            var _bY_ = [
                0,
                u$0
            ];
            return _bY_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
    }
    function scheme(u) {
        var p = caml_call2(Jv[23][2], u, cst_protocol$0);
        return 0 === caml_call1(Jstr[1], p) ? p : caml_call3(Jstr[15], 0, _k_, p);
    }
    function host(u) {
        return caml_call2(Jv[23][2], u, cst_hostname$0);
    }
    function port(u) {
        var p = caml_call2(Jv[23][2], u, cst_port$0);
        return caml_call1(Jstr[24], p) ? 0 : caml_call2(Jstr[32], 0, p);
    }
    var prefix = "/";
    function path(u) {
        return caml_call2(Jv[23][2], u, cst_pathname$0);
    }
    function query(u) {
        var q = caml_call2(Jv[23][2], u, cst_search$0);
        return caml_call1(Jstr[24], q) ? q : caml_call3(Jstr[15], _l_, 0, q);
    }
    function fragment(u) {
        var f = caml_call2(Jv[23][2], u, cst_hash$0);
        return caml_call1(Jstr[24], f) ? f : caml_call3(Jstr[15], _m_, 0, f);
    }
    function path_segments(u) {
        function decode_seg(s) {
            return decode_component(s);
        }
        try {
            var p = path(u), p$0 = caml_call2(Jstr[25], prefix, p) ? caml_call3(Jstr[15], _n_, 0, p) : p, _bV_ = caml_call2(Jstr[17], prefix, p$0), _bW_ = [
                0,
                caml_call2(Stdlib_List[20], decode_seg, _bV_)
            ];
            return _bW_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
    }
    function with_path_segments(u, segs) {
        function encode_seg(s) {
            var _bU_ = encode_component(s);
            return caml_call2(Jstr[7], prefix, _bU_);
        }
        try {
            var u$0 = new url(u), _bS_ = caml_call2(Stdlib_List[20], encode_seg, segs), path = caml_call2(Jstr[9], 0, _bS_);
            u$0[cst_pathname$1] = path;
            var _bT_ = [
                0,
                u$0
            ];
            return _bT_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
    }
    var usp = Jv[12]["URLSearchParams"];
    function is_empty(p) {
        var _bQ_ = p.entries(), _bR_ = caml_call1(Jv[35][6], _bQ_);
        return caml_call1(Jv[35][1], _bR_);
    }
    function mem(k, p) {
        return p.has(k) | 0;
    }
    function find$0(k, p) {
        var _bO_ = p.get(k);
        return caml_call2(Jv[10], function(_bP_) {
            return _bP_;
        }, _bO_);
    }
    function find_all(k, p) {
        return caml_list_of_js_array(p.getAll(k));
    }
    function fold(f, p, acc) {
        function key(_bN_) {
            return _bN_;
        }
        function value(_bM_) {
            return _bM_;
        }
        var _bL_ = p.entries();
        return caml_call5(Jv[35][8], key, value, f, _bL_, acc);
    }
    function of_jstr$1(s) {
        return new usp(s);
    }
    function to_jstr$0(p) {
        return p.toString();
    }
    function of_assoc(l) {
        var s = Jstr[4], p = new usp(s);
        caml_call2(Stdlib_List[18], function(param) {
            var v = param[2], k = param[1];
            p.append(k, v);
            return 0;
        }, l);
        return p;
    }
    function to_assoc(p) {
        var _bK_ = fold(function(k, v, acc) {
            return [
                0,
                [
                    0,
                    k,
                    v
                ],
                acc
            ];
        }, p, 0);
        return caml_call1(Stdlib_List[10], _bK_);
    }
    function of_obj(o) {
        return new usp(o);
    }
    function query_params(u) {
        var s = query(u);
        return new usp(s);
    }
    function with_query_params(u, ps) {
        var u$0 = new url(u), _bJ_ = ps.toString();
        caml_call3(Jv[23][3], u$0, cst_search$1, _bJ_);
        return u$0;
    }
    function fragment_params(u) {
        var s = fragment(u);
        return new usp(s);
    }
    function with_fragment_params(u, ps) {
        var u$0 = new url(u), _bI_ = ps.toString();
        caml_call3(Jv[23][3], u$0, cst_hash$1, _bI_);
        return u$0;
    }
    function to_jstr$1(u) {
        return u.toString();
    }
    function of_jstr$2(base, s) {
        try {
            var v$0 = v(base, s);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            v$0
        ];
    }
    function code$0(f, s) {
        try {
            var v = f(s);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            v
        ];
    }
    function encode$2(s) {
        return code$0(encode$1, s);
    }
    function decode$2(s) {
        return code$0(decode$1, s);
    }
    function encode_component$0(s) {
        return code$0(encode_component, s);
    }
    function decode_component$0(s) {
        return code$0(decode_component, s);
    }
    function v$0(n, v) {
        return [
            0,
            n,
            v
        ];
    }
    var void$0 = [
        0,
        Jstr[4],
        Jstr[4]
    ];
    function is_void(param) {
        var v = param[2], n = param[1], _bH_ = caml_call1(Jstr[24], n);
        return _bH_ ? caml_call1(Jstr[24], v) : _bH_;
    }
    function if$0(b, at) {
        return b ? at : void$0;
    }
    function if_some(param) {
        if (!param) return void$0;
        var at = param[1];
        return at;
    }
    function true$0(n) {
        return [
            0,
            n,
            Jstr[4]
        ];
    }
    function int$0(n, i) {
        return [
            0,
            n,
            caml_call2(Jstr[33], 0, i)
        ];
    }
    function float$0(n, f) {
        return [
            0,
            n,
            caml_call2(Jstr[35], 0, f)
        ];
    }
    function to_pair(_bG_) {
        return _bG_;
    }
    function add_if(b, at, l) {
        return b ? [
            0,
            at,
            l
        ] : l;
    }
    function add_if_some(name, o, l) {
        if (!o) return l;
        var a = o[1];
        return [
            0,
            [
                0,
                name,
                a
            ],
            l
        ];
    }
    var accesskey = "accesskey", action = "action", autocomplete = "autocomplete", autofocus = "autofocus", charset = "charset", checked = cst_checked, class$0 = "class", cols = "cols", content = "content", contenteditable = "contenteditable", defer = "defer", dir = cst_dir$0, disabled = "disabled", download = "download", draggable = "draggable", for$0 = "for", height$0 = cst_height$1, hidden = cst_hidden, href = "href", id$0 = cst_id, lang = "lang", list = "list", media = "media", method = "method", name$0 = cst_name$2, placeholder = "placeholder", rel = "rel", required = "required", rows = "rows", selected = "selected", spellcheck = "spellcheck", src = "src", style = cst_style, tabindex = "tabindex", title = cst_title$1, type$4 = cst_type$4, value = cst_value, width$0 = cst_width$1, wrap = "wrap", Name = [
        0,
        accesskey,
        action,
        autocomplete,
        autofocus,
        charset,
        checked,
        class$0,
        cols,
        content,
        contenteditable,
        defer,
        dir,
        disabled,
        download,
        draggable,
        for$0,
        height$0,
        hidden,
        href,
        id$0,
        lang,
        list,
        media,
        method,
        name$0,
        placeholder,
        rel,
        required,
        rows,
        selected,
        spellcheck,
        src,
        style,
        tabindex,
        title,
        type$4,
        value,
        width$0,
        wrap
    ];
    function accesskey$0(s) {
        var n = Name[1];
        return [
            0,
            n,
            s
        ];
    }
    function action$0(s) {
        var n = Name[2];
        return [
            0,
            n,
            s
        ];
    }
    function autocomplete$0(s) {
        var n = Name[3];
        return [
            0,
            n,
            s
        ];
    }
    var autofocus$0 = true$0(Name[4]), n = Name[5];
    function charset$0(v) {
        return [
            0,
            n,
            v
        ];
    }
    var checked$0 = true$0(Name[6]);
    function class$1(s) {
        var n = Name[7];
        return [
            0,
            n,
            s
        ];
    }
    function cols$0(i) {
        return int$0(Name[8], i);
    }
    function content$0(s) {
        var n = Name[9];
        return [
            0,
            n,
            s
        ];
    }
    function contenteditable$0(s) {
        return true$0(Name[10]);
    }
    var defer$0 = true$0(Name[11]);
    function dir$0(s) {
        var n = Name[12];
        return [
            0,
            n,
            s
        ];
    }
    var disabled$0 = true$0(Name[13]);
    function download$0(s) {
        var n = Name[14];
        return [
            0,
            n,
            s
        ];
    }
    function draggable$0(s) {
        var n = Name[15];
        return [
            0,
            n,
            s
        ];
    }
    function for$1(s) {
        var n = Name[16];
        return [
            0,
            n,
            s
        ];
    }
    function height$1(i) {
        return int$0(Name[17], i);
    }
    var hidden$0 = true$0(Name[18]);
    function href$0(s) {
        var n = Name[19];
        return [
            0,
            n,
            s
        ];
    }
    function id$1(s) {
        var n = Name[20];
        return [
            0,
            n,
            s
        ];
    }
    function lang$0(s) {
        var n = Name[21];
        return [
            0,
            n,
            s
        ];
    }
    function list$0(s) {
        var n = Name[22];
        return [
            0,
            n,
            s
        ];
    }
    function media$0(s) {
        var n = Name[23];
        return [
            0,
            n,
            s
        ];
    }
    function method$0(s) {
        var n = Name[24];
        return [
            0,
            n,
            s
        ];
    }
    function name$1(s) {
        var n = Name[25];
        return [
            0,
            n,
            s
        ];
    }
    function placeholder$0(s) {
        var n = Name[26];
        return [
            0,
            n,
            s
        ];
    }
    function rel$0(s) {
        var n = Name[27];
        return [
            0,
            n,
            s
        ];
    }
    var required$0 = true$0(Name[28]);
    function rows$0(i) {
        return int$0(Name[29], i);
    }
    var selected$0 = true$0(Name[30]), n$0 = Name[31];
    function spellcheck$0(v) {
        return [
            0,
            n$0,
            v
        ];
    }
    function src$0(s) {
        var n = Name[32];
        return [
            0,
            n,
            s
        ];
    }
    function style$0(s) {
        var n = Name[33];
        return [
            0,
            n,
            s
        ];
    }
    function tabindex$0(i) {
        return int$0(Name[34], i);
    }
    function title$0(s) {
        var n = Name[35];
        return [
            0,
            n,
            s
        ];
    }
    function type$5(s) {
        var n = Name[36];
        return [
            0,
            n,
            s
        ];
    }
    function value$0(s) {
        var n = Name[37];
        return [
            0,
            n,
            s
        ];
    }
    function width$1(i) {
        return int$0(Name[38], i);
    }
    function wrap$0(s) {
        var n = Name[37];
        return [
            0,
            n,
            s
        ];
    }
    var global_document = Jv[12]["document"];
    function document1(e) {
        return e[cst_ownerDocument];
    }
    var global_root = caml_call1(Jv[8], global_document) ? Jv[5] : global_document[cst_documentElement];
    function el_list_of_node_list(nl) {
        var acc = [
            0,
            0
        ], len = caml_call2(Jv[20][2], nl, cst_length$1), _bD_ = len - 1 | 0;
        if (_bD_ >= 0) {
            var i = _bD_;
            for(;;){
                var _bE_ = acc[1];
                acc[1] = [
                    0,
                    nl[i],
                    _bE_
                ];
                var _bF_ = i - 1 | 0;
                if (0 === i) break;
                i = _bF_;
            }
        }
        return acc[1];
    }
    function _o_(e, n) {
        e.appendChild(n);
        return 0;
    }
    function v$1(_bB_, opt, name, cs) {
        var d = _bB_ ? _bB_[1] : global_document, at$0 = opt ? opt[1] : 0, e = d.createElement(name), ss = 0, clss = 0, param = at$0;
        for(;;){
            if (!param) break;
            var at = param[2], match = param[1], v = match[2], a = match[1];
            if (caml_call1(Jstr[24], a)) param = at;
            else if (caml_call2(Jstr[28], a, Name[33])) {
                var ss$0 = [
                    0,
                    v,
                    ss
                ];
                ss = ss$0;
                param = at;
            } else if (caml_call2(Jstr[28], a, Name[7])) {
                var clss$0 = caml_call1(Jstr[24], v) ? clss : [
                    0,
                    v,
                    clss
                ];
                clss = clss$0;
                param = at;
            } else {
                e.setAttribute(a, v);
                param = at;
            }
        }
        if (0 !== ss) {
            var a$0 = Name[33], _bz_ = caml_call1(Stdlib_List[10], ss), v$0 = caml_call2(Jstr[9], [
                0,
                ";"
            ], _bz_);
            e.setAttribute(a$0, v$0);
        }
        if (0 !== clss) {
            var a$1 = Name[7], _bA_ = caml_call1(Stdlib_List[10], clss), v$1 = caml_call2(Jstr[9], [
                0,
                cst
            ], _bA_);
            e.setAttribute(a$1, v$1);
        }
        caml_call2(Stdlib_List[18], function(_bC_) {
            return _o_(e, _bC_);
        }, cs);
        return e;
    }
    function txt(opt, s) {
        var d = opt ? opt[1] : global_document;
        return d.createTextNode(s);
    }
    function txt$0(opt, s) {
        var d = opt ? opt[1] : global_document;
        return d.createTextNode(caml_call1(Jv[24], s));
    }
    function sp(opt, param) {
        return txt(0, cst);
    }
    function nbsp(opt, param) {
        return txt(0, "\xa0");
    }
    function is_txt(e) {
        return 3 === caml_call2(Jv[20][2], e, cst_nodeType) ? 1 : 0;
    }
    function is_el(e) {
        return 1 === caml_call2(Jv[20][2], e, cst_nodeType$0) ? 1 : 0;
    }
    function tag_name(e) {
        var _by_ = caml_call2(Jv[23][2], e, cst_nodeName);
        return caml_call1(Jstr[22], _by_);
    }
    function has_tag_name(n, e) {
        var _bx_ = tag_name(e);
        return caml_call2(Jstr[28], n, _bx_);
    }
    function txt_text(txt) {
        return is_txt(txt) ? caml_call2(Jv[23][2], txt, cst_nodeValue) : Jstr[4];
    }
    function find_by_class(opt, c) {
        var root = opt ? opt[1] : global_root;
        return el_list_of_node_list(root.getElementsByClassName(c));
    }
    function find_by_tag_name(opt, n) {
        var root = opt ? opt[1] : global_root;
        return el_list_of_node_list(root.getElementsByTagName(n));
    }
    function find_first_by_selector(opt, sel) {
        var root = opt ? opt[1] : global_root, _bv_ = root.querySelector(sel);
        return caml_call1(caml_call1(Jv[10], function(_bw_) {
            return _bw_;
        }), _bv_);
    }
    function fold_find_by_selector(opt, f, sel, acc) {
        var root = opt ? opt[1] : global_root, nl = root.querySelectorAll(sel), acc$0 = [
            0,
            acc
        ], _bs_ = caml_call2(Jv[20][2], nl, cst_length$2) - 1 | 0, _br_ = 0;
        if (_bs_ >= 0) {
            var i = _br_;
            for(;;){
                var _bt_ = acc$0[1];
                acc$0[1] = caml_call2(f, nl[i], _bt_);
                var _bu_ = i + 1 | 0;
                if (_bs_ === i) break;
                i = _bu_;
            }
        }
        return acc$0[1];
    }
    function parent(e) {
        var match = caml_call2(Jv[13], e, cst_parentNode);
        if (match) {
            var e$0 = match[1];
            if (is_el(e$0)) return [
                0,
                e$0
            ];
        }
        return 0;
    }
    function children(opt, e) {
        var only_els = opt ? opt[1] : 0;
        return only_els ? el_list_of_node_list(e["children"]) : el_list_of_node_list(e["childNodes"]);
    }
    function set_children(e, l) {
        for(;;){
            var _bp_ = e[cst_firstChild];
            if (caml_call1(Jv[6], _bp_)) break;
            e.removeChild(e[cst_firstChild]);
        }
        return caml_call2(Stdlib_List[18], function(_bq_) {
            return _o_(e, _bq_);
        }, l);
    }
    function prepend_children(e, l) {
        caml_js_meth_call(e, "prepend", caml_call1(Stdlib_Array[11], l));
        return 0;
    }
    function append_children(e, l) {
        caml_js_meth_call(e, cst_append, caml_call1(Stdlib_Array[11], l));
        return 0;
    }
    function previous_sibling(e) {
        return caml_call2(Jv[13], e, cst_previousElementSibling);
    }
    function next_sibling(e) {
        return caml_call2(Jv[13], e, cst_nextElementSibling);
    }
    function insert_siblings(loc, e, l) {
        if (-126259180 === loc) caml_js_meth_call(e, "replaceWith", caml_call1(Stdlib_Array[11], l));
        else if (818927100 <= loc) caml_js_meth_call(e, "after", caml_call1(Stdlib_Array[11], l));
        else caml_js_meth_call(e, "before", caml_call1(Stdlib_Array[11], l));
        return 0;
    }
    function remove$0(e) {
        e.remove(e);
        return 0;
    }
    function at(a, e) {
        var _bn_ = e.getAttribute(a);
        return caml_call2(Jv[10], function(_bo_) {
            return _bo_;
        }, _bn_);
    }
    function set_at(a, v, e) {
        if (caml_call1(Jstr[24], a)) return 0;
        if (v) {
            var v$0 = v[1];
            e.setAttribute(a, v$0);
            return 0;
        }
        e.removeAttribute(a);
        return 0;
    }
    function jv_to_bool(b) {
        return caml_call1(Jv[7], b) ? 0 : b | 0;
    }
    function jv_to_int(i) {
        return caml_call1(Jv[7], i) ? 0 : i;
    }
    function jv_to_float(f) {
        return caml_call1(Jv[7], f) ? 0. : f;
    }
    function jv_to_jstr(s) {
        return caml_call1(Jv[7], s) ? Jstr[4] : s;
    }
    function bool(n) {
        return [
            0,
            n,
            jv_to_bool,
            caml_js_from_bool
        ];
    }
    function int$1(n) {
        return [
            0,
            n,
            jv_to_int,
            function(_bm_) {
                return _bm_;
            }
        ];
    }
    function float$1(n) {
        return [
            0,
            n,
            jv_to_float,
            function(_bl_) {
                return _bl_;
            }
        ];
    }
    function jstr(n) {
        return [
            0,
            n,
            jv_to_jstr,
            function(_bk_) {
                return _bk_;
            }
        ];
    }
    var checked$1 = bool(cst_checked), height$2 = int$1(cst_height$1), id$2 = jstr(cst_id), name$2 = jstr(cst_name$2), title$1 = jstr(cst_title$1), value$1 = jstr(cst_value), width$2 = int$1(cst_width$1);
    function prop(p, e) {
        var _bj_ = e[p[1]];
        return caml_call1(p[2], _bj_);
    }
    function set_prop(p, v, e) {
        var _bi_ = caml_call1(p[3], v);
        e[p[1]] = _bi_;
        return 0;
    }
    function class$2(c, e) {
        return e[cst_classList].contains(c) | 0;
    }
    function set_class(c, b, e) {
        return b ? (e[cst_classList].add(c), 0) : (e[cst_classList].remove(c), 0);
    }
    var background_color = "background-color", bottom = "bottom", color = "color", cursor = "cursor", display = "display", height$3 = cst_height$1, left = "left", position = "position", right = "right", top = "top", visibility = "visibility", width$3 = cst_width$1, z_index = "z-index", Style = [
        0,
        background_color,
        bottom,
        color,
        cursor,
        display,
        height$3,
        left,
        position,
        right,
        top,
        visibility,
        width$3,
        z_index
    ];
    function computed_style(opt, p, e) {
        var w = opt ? opt[1] : Jv[12][cst_window], style = w.getComputedStyle(e), v = style[p];
        return caml_call1(Jv[8], v) ? Jstr[4] : v;
    }
    function inline_style(p, e) {
        var style = e[cst_style];
        if (caml_call1(Jv[8], style)) return Jstr[4];
        var v = style[p];
        return caml_call1(Jv[8], v) ? Jstr[4] : v;
    }
    function set_inline_style(opt, p, v, e) {
        var important = opt ? opt[1] : 0, priority = important ? "important" : Jstr[4], style = e[cst_style];
        return caml_call1(Jv[8], style) ? 0 : (style.setProperty(p, v, priority), 0);
    }
    function remove_inline_style(p, e) {
        var style = e[cst_style];
        return caml_call1(Jv[8], style) ? 0 : (style.removeProperty(p), 0);
    }
    function inner_x(e) {
        return caml_call2(Jv[21][2], e, cst_clientLeft);
    }
    function inner_y(e) {
        return caml_call2(Jv[21][2], e, cst_clientTop);
    }
    function inner_w(e) {
        return caml_call2(Jv[21][2], e, cst_clientWidth);
    }
    function inner_h(e) {
        return caml_call2(Jv[21][2], e, cst_clientHeight);
    }
    function bound_x(e) {
        var _bh_ = e.getBoundingClientRect();
        return caml_call2(Jv[21][2], _bh_, cst_x);
    }
    function bound_y(e) {
        var _bg_ = e.getBoundingClientRect();
        return caml_call2(Jv[21][2], _bg_, cst_y);
    }
    function bound_w(e) {
        var _bf_ = e.getBoundingClientRect();
        return caml_call2(Jv[21][2], _bf_, cst_width$0);
    }
    function bound_h(e) {
        var _be_ = e.getBoundingClientRect();
        return caml_call2(Jv[21][2], _be_, cst_height$0);
    }
    function scroll_x(e) {
        return caml_call2(Jv[21][2], e, cst_scrollLeft);
    }
    function scroll_y(e) {
        return caml_call2(Jv[21][2], e, cst_scrollTop);
    }
    function scroll_w(e) {
        return caml_call2(Jv[21][2], e, cst_scrollWidth);
    }
    function scroll_h(e) {
        return caml_call2(Jv[21][2], e, cst_scrollHeight);
    }
    function scroll_into_view(opt, e) {
        var align_v = opt ? opt[1] : 389604418, align = 389604418 <= align_v ? 1 : 0;
        e.scrollIntoView(!!align);
        return 0;
    }
    function has_focus(e) {
        var _bc_ = e[cst_ownerDocument][cst_activeElement], match = caml_call2(Jv[10], function(_bd_) {
            return _bd_;
        }, _bc_);
        if (!match) return 0;
        var e$0 = match[1];
        return e === e$0 ? 1 : 0;
    }
    function set_has_focus(b, e) {
        if (b) e.focus();
        else e.blur();
        return 0;
    }
    function is_locking_pointer(e) {
        var _ba_ = e[cst_ownerDocument][cst_pointerLockElement], match = caml_call2(Jv[10], function(_bb_) {
            return _bb_;
        }, _ba_);
        if (!match) return 0;
        var e$0 = match[1];
        return e === e$0 ? 1 : 0;
    }
    function request_pointer_lock(e) {
        var match = caml_call1(Fut[1], 0), set = match[2], fut = match[1], d = e[cst_ownerDocument], opts = listen_opts(0, _p_, 0, 0), unlisten$0 = [
            0,
            function(param) {
                return 0;
            }
        ];
        function locked(ev) {
            caml_call1(set, _q_);
            return caml_call1(unlisten$0[1], 0);
        }
        function error(ev) {
            var err = caml_call2(Jv[32][1], 0, "Could not lock pointer");
            caml_call1(set, [
                1,
                err
            ]);
            return caml_call1(unlisten$0[1], 0);
        }
        var k = listen([
            0,
            opts
        ], pointerlockchange, locked, d), k$0 = listen([
            0,
            opts
        ], pointerlockerror, error, d);
        unlisten$0[1] = function(param) {
            unlisten(k);
            return unlisten(k$0);
        };
        e.requestPointerLock();
        return fut;
    }
    function click$0(e) {
        e.click();
        return 0;
    }
    function select_text(e) {
        e.select();
        return 0;
    }
    var auto = cst_auto, hide = "hide", show = "show", Navigation_ui = [
        0,
        auto,
        hide,
        show
    ];
    function fullscreen_opts(navigation_ui, param) {
        var o = {};
        caml_call3(Jv[23][4], o, cst_navigationUI, navigation_ui);
        return o;
    }
    function request_fullscreen(opt, e) {
        var opts = opt ? opt[1] : {}, _a__ = e.requestFullscreen(opts);
        return caml_call1(caml_call1(Fut[11], function(_a$_) {
            return 0;
        }), _a__);
    }
    function files(e) {
        var match = caml_call2(Jv[13], e, cst_files);
        if (!match) return 0;
        var files = match[1];
        return caml_call2(Jv[29], function(_a9_) {
            return _a9_;
        }, files);
    }
    var Input$0 = [
        0,
        files
    ], a = "a", abbr = "abbr", address = "address", area = "area", article = "article", aside = "aside", audio = "audio", b = "b", base = "base", bdi = "bdi", bdo = "bdo", blockquote = "blockquote", body = cst_body, br = "br", button$0 = cst_button$0, canvas = "canvas", caption = "caption", cite = "cite", code$1 = cst_code$0, col = "col", colgroup = "colgroup", command = "command", datalist = "datalist", dd = "dd", del = "del", details = "details", dfn = "dfn", div = "div", dl = "dl", dt = "dt", em = "em", embed = "embed", fieldset = "fieldset", figcaption = "figcaption", figure = "figure", footer = "footer", form = "form", h1 = "h1", h2 = "h2", h3 = "h3", h4 = "h4", h5 = "h5", h6 = "h6", head = cst_head, header = "header", hgroup = "hgroup", hr = "hr", html = "html", i = "i", iframe = "iframe", img = "img", input$0 = cst_input, ins = "ins", kbd = "kbd", keygen = "keygen", label = "label", legend = "legend", li = "li", link$0 = cst_link, map$0 = cst_map, mark = cst_mark, menu = "menu", meta = "meta", meter = "meter", nav = "nav", noscript = "noscript", object = "object", ol = "ol", optgroup = "optgroup", option = "option", output = "output", p = "p", pre = "pre", progress$0 = cst_progress, q = "q", rp = "rp", rt = "rt", ruby = "ruby", s = "s", samp = "samp", script = "script", section = "section", select$0 = cst_select, small = "small", source = "source", span = "span", strong = "strong", style$1 = cst_style, sub$0 = "sub", summary = "summary", sup = "sup", table = cst_table$0, tbody = "tbody", td = "td", textarea = "textarea", tfoot = "tfoot", th = "th", thead = "thead", time = cst_time$0, title$2 = cst_title$1, tr = "tr", track = "track", u = "u", ul = "ul", var$0 = "var", video = "video", wbr = "wbr", Name$0 = [
        0,
        a,
        abbr,
        address,
        area,
        article,
        aside,
        audio,
        b,
        base,
        bdi,
        bdo,
        blockquote,
        body,
        br,
        button$0,
        canvas,
        caption,
        cite,
        code$1,
        col,
        colgroup,
        command,
        datalist,
        dd,
        del,
        details,
        dfn,
        div,
        dl,
        dt,
        em,
        embed,
        fieldset,
        figcaption,
        figure,
        footer,
        form,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        head,
        header,
        hgroup,
        hr,
        html,
        i,
        iframe,
        img,
        input$0,
        ins,
        kbd,
        keygen,
        label,
        legend,
        li,
        link$0,
        map$0,
        mark,
        menu,
        meta,
        meter,
        nav,
        noscript,
        object,
        ol,
        optgroup,
        option,
        output,
        p,
        "param",
        pre,
        progress$0,
        q,
        rp,
        rt,
        ruby,
        s,
        samp,
        script,
        section,
        select$0,
        small,
        source,
        span,
        strong,
        style$1,
        sub$0,
        summary,
        sup,
        table,
        tbody,
        td,
        textarea,
        tfoot,
        th,
        thead,
        time,
        title$2,
        tr,
        track,
        u,
        ul,
        var$0,
        video,
        wbr
    ];
    function void_cons(name, d, at, param) {
        return v$1(d, at, name, 0);
    }
    var name$3 = Name$0[1];
    function a$0(d, at, cs) {
        return v$1(d, at, name$3, cs);
    }
    var name$4 = Name$0[2];
    function abbr$0(d, at, cs) {
        return v$1(d, at, name$4, cs);
    }
    var name$5 = Name$0[3];
    function address$0(d, at, cs) {
        return v$1(d, at, name$5, cs);
    }
    var _r_ = Name$0[4];
    function area$0(_a6_, _a7_, _a8_) {
        return void_cons(_r_, _a6_, _a7_, _a8_);
    }
    var name$6 = Name$0[5];
    function article$0(d, at, cs) {
        return v$1(d, at, name$6, cs);
    }
    var name$7 = Name$0[6];
    function aside$0(d, at, cs) {
        return v$1(d, at, name$7, cs);
    }
    var name$8 = Name$0[7];
    function audio$0(d, at, cs) {
        return v$1(d, at, name$8, cs);
    }
    var name$9 = Name$0[8];
    function b$0(d, at, cs) {
        return v$1(d, at, name$9, cs);
    }
    var _s_ = Name$0[9];
    function base$0(_a3_, _a4_, _a5_) {
        return void_cons(_s_, _a3_, _a4_, _a5_);
    }
    var name$10 = Name$0[10];
    function bdi$0(d, at, cs) {
        return v$1(d, at, name$10, cs);
    }
    var name$11 = Name$0[11];
    function bdo$0(d, at, cs) {
        return v$1(d, at, name$11, cs);
    }
    var name$12 = Name$0[12];
    function blockquote$0(d, at, cs) {
        return v$1(d, at, name$12, cs);
    }
    var name$13 = Name$0[13];
    function body$0(d, at, cs) {
        return v$1(d, at, name$13, cs);
    }
    var _t_ = Name$0[14];
    function br$0(_a0_, _a1_, _a2_) {
        return void_cons(_t_, _a0_, _a1_, _a2_);
    }
    var name$14 = Name$0[15];
    function button$1(d, at, cs) {
        return v$1(d, at, name$14, cs);
    }
    var name$15 = Name$0[16];
    function canvas$0(d, at, cs) {
        return v$1(d, at, name$15, cs);
    }
    var name$16 = Name$0[17];
    function caption$0(d, at, cs) {
        return v$1(d, at, name$16, cs);
    }
    var name$17 = Name$0[18];
    function cite$0(d, at, cs) {
        return v$1(d, at, name$17, cs);
    }
    var name$18 = Name$0[19];
    function code$2(d, at, cs) {
        return v$1(d, at, name$18, cs);
    }
    var _u_ = Name$0[20];
    function col$0(_aX_, _aY_, _aZ_) {
        return void_cons(_u_, _aX_, _aY_, _aZ_);
    }
    var name$19 = Name$0[21];
    function colgroup$0(d, at, cs) {
        return v$1(d, at, name$19, cs);
    }
    var name$20 = Name$0[22];
    function command$0(d, at, cs) {
        return v$1(d, at, name$20, cs);
    }
    var name$21 = Name$0[23];
    function datalist$0(d, at, cs) {
        return v$1(d, at, name$21, cs);
    }
    var name$22 = Name$0[24];
    function dd$0(d, at, cs) {
        return v$1(d, at, name$22, cs);
    }
    var name$23 = Name$0[25];
    function del$0(d, at, cs) {
        return v$1(d, at, name$23, cs);
    }
    var name$24 = Name$0[26];
    function details$0(d, at, cs) {
        return v$1(d, at, name$24, cs);
    }
    var name$25 = Name$0[27];
    function dfn$0(d, at, cs) {
        return v$1(d, at, name$25, cs);
    }
    var name$26 = Name$0[28];
    function div$0(d, at, cs) {
        return v$1(d, at, name$26, cs);
    }
    var name$27 = Name$0[29];
    function dl$0(d, at, cs) {
        return v$1(d, at, name$27, cs);
    }
    var name$28 = Name$0[30];
    function dt$0(d, at, cs) {
        return v$1(d, at, name$28, cs);
    }
    var name$29 = Name$0[31];
    function em$0(d, at, cs) {
        return v$1(d, at, name$29, cs);
    }
    var _v_ = Name$0[32];
    function embed$0(_aU_, _aV_, _aW_) {
        return void_cons(_v_, _aU_, _aV_, _aW_);
    }
    var name$30 = Name$0[33];
    function fieldset$0(d, at, cs) {
        return v$1(d, at, name$30, cs);
    }
    var name$31 = Name$0[34];
    function figcaption$0(d, at, cs) {
        return v$1(d, at, name$31, cs);
    }
    var name$32 = Name$0[35];
    function figure$0(d, at, cs) {
        return v$1(d, at, name$32, cs);
    }
    var name$33 = Name$0[36];
    function footer$0(d, at, cs) {
        return v$1(d, at, name$33, cs);
    }
    var name$34 = Name$0[37];
    function form$0(d, at, cs) {
        return v$1(d, at, name$34, cs);
    }
    var name$35 = Name$0[38];
    function h1$0(d, at, cs) {
        return v$1(d, at, name$35, cs);
    }
    var name$36 = Name$0[39];
    function h2$0(d, at, cs) {
        return v$1(d, at, name$36, cs);
    }
    var name$37 = Name$0[40];
    function h3$0(d, at, cs) {
        return v$1(d, at, name$37, cs);
    }
    var name$38 = Name$0[41];
    function h4$0(d, at, cs) {
        return v$1(d, at, name$38, cs);
    }
    var name$39 = Name$0[42];
    function h5$0(d, at, cs) {
        return v$1(d, at, name$39, cs);
    }
    var name$40 = Name$0[43];
    function h6$0(d, at, cs) {
        return v$1(d, at, name$40, cs);
    }
    var name$41 = Name$0[44];
    function head$0(d, at, cs) {
        return v$1(d, at, name$41, cs);
    }
    var name$42 = Name$0[45];
    function header$0(d, at, cs) {
        return v$1(d, at, name$42, cs);
    }
    var name$43 = Name$0[46];
    function hgroup$0(d, at, cs) {
        return v$1(d, at, name$43, cs);
    }
    var _w_ = Name$0[47];
    function hr$0(_aR_, _aS_, _aT_) {
        return void_cons(_w_, _aR_, _aS_, _aT_);
    }
    var name$44 = Name$0[48];
    function html$0(d, at, cs) {
        return v$1(d, at, name$44, cs);
    }
    var name$45 = Name$0[49];
    function i$0(d, at, cs) {
        return v$1(d, at, name$45, cs);
    }
    var name$46 = Name$0[50];
    function iframe$0(d, at, cs) {
        return v$1(d, at, name$46, cs);
    }
    var _x_ = Name$0[51];
    function img$0(_aO_, _aP_, _aQ_) {
        return void_cons(_x_, _aO_, _aP_, _aQ_);
    }
    var _y_ = Name$0[52];
    function input$1(_aL_, _aM_, _aN_) {
        return void_cons(_y_, _aL_, _aM_, _aN_);
    }
    var name$47 = Name$0[53];
    function ins$0(d, at, cs) {
        return v$1(d, at, name$47, cs);
    }
    var name$48 = Name$0[54];
    function kbd$0(d, at, cs) {
        return v$1(d, at, name$48, cs);
    }
    var name$49 = Name$0[55];
    function keygen$0(d, at, cs) {
        return v$1(d, at, name$49, cs);
    }
    var name$50 = Name$0[56];
    function label$0(d, at, cs) {
        return v$1(d, at, name$50, cs);
    }
    var name$51 = Name$0[57];
    function legend$0(d, at, cs) {
        return v$1(d, at, name$51, cs);
    }
    var name$52 = Name$0[58];
    function li$0(d, at, cs) {
        return v$1(d, at, name$52, cs);
    }
    var _z_ = Name$0[59];
    function link$1(_aI_, _aJ_, _aK_) {
        return void_cons(_z_, _aI_, _aJ_, _aK_);
    }
    var name$53 = Name$0[60];
    function map$1(d, at, cs) {
        return v$1(d, at, name$53, cs);
    }
    var name$54 = Name$0[61];
    function mark$0(d, at, cs) {
        return v$1(d, at, name$54, cs);
    }
    var name$55 = Name$0[62];
    function menu$0(d, at, cs) {
        return v$1(d, at, name$55, cs);
    }
    var _A_ = Name$0[63];
    function meta$0(_aF_, _aG_, _aH_) {
        return void_cons(_A_, _aF_, _aG_, _aH_);
    }
    var name$56 = Name$0[64];
    function meter$0(d, at, cs) {
        return v$1(d, at, name$56, cs);
    }
    var name$57 = Name$0[65];
    function nav$0(d, at, cs) {
        return v$1(d, at, name$57, cs);
    }
    var name$58 = Name$0[66];
    function noscript$0(d, at, cs) {
        return v$1(d, at, name$58, cs);
    }
    var name$59 = Name$0[67];
    function object$0(d, at, cs) {
        return v$1(d, at, name$59, cs);
    }
    var name$60 = Name$0[68];
    function ol$0(d, at, cs) {
        return v$1(d, at, name$60, cs);
    }
    var name$61 = Name$0[69];
    function optgroup$0(d, at, cs) {
        return v$1(d, at, name$61, cs);
    }
    var name$62 = Name$0[70];
    function option$0(d, at, cs) {
        return v$1(d, at, name$62, cs);
    }
    var name$63 = Name$0[71];
    function output$0(d, at, cs) {
        return v$1(d, at, name$63, cs);
    }
    var name$64 = Name$0[72];
    function p$0(d, at, cs) {
        return v$1(d, at, name$64, cs);
    }
    var _B_ = Name$0[73], name$65 = Name$0[74];
    function pre$0(d, at, cs) {
        return v$1(d, at, name$65, cs);
    }
    var name$66 = Name$0[75];
    function progress$1(d, at, cs) {
        return v$1(d, at, name$66, cs);
    }
    var name$67 = Name$0[76];
    function q$0(d, at, cs) {
        return v$1(d, at, name$67, cs);
    }
    var name$68 = Name$0[77];
    function rp$0(d, at, cs) {
        return v$1(d, at, name$68, cs);
    }
    var name$69 = Name$0[78];
    function rt$0(d, at, cs) {
        return v$1(d, at, name$69, cs);
    }
    var name$70 = Name$0[79];
    function ruby$0(d, at, cs) {
        return v$1(d, at, name$70, cs);
    }
    var name$71 = Name$0[80];
    function s$0(d, at, cs) {
        return v$1(d, at, name$71, cs);
    }
    var name$72 = Name$0[81];
    function samp$0(d, at, cs) {
        return v$1(d, at, name$72, cs);
    }
    var name$73 = Name$0[82];
    function script$0(d, at, cs) {
        return v$1(d, at, name$73, cs);
    }
    var name$74 = Name$0[83];
    function section$0(d, at, cs) {
        return v$1(d, at, name$74, cs);
    }
    var name$75 = Name$0[84];
    function select$1(d, at, cs) {
        return v$1(d, at, name$75, cs);
    }
    var name$76 = Name$0[85];
    function small$0(d, at, cs) {
        return v$1(d, at, name$76, cs);
    }
    var _C_ = Name$0[86];
    function source$0(_aC_, _aD_, _aE_) {
        return void_cons(_C_, _aC_, _aD_, _aE_);
    }
    var name$77 = Name$0[87];
    function span$0(d, at, cs) {
        return v$1(d, at, name$77, cs);
    }
    var name$78 = Name$0[88];
    function strong$0(d, at, cs) {
        return v$1(d, at, name$78, cs);
    }
    var name$79 = Name$0[89];
    function style$2(d, at, cs) {
        return v$1(d, at, name$79, cs);
    }
    var name$80 = Name$0[90];
    function sub$1(d, at, cs) {
        return v$1(d, at, name$80, cs);
    }
    var name$81 = Name$0[91];
    function summary$0(d, at, cs) {
        return v$1(d, at, name$81, cs);
    }
    var name$82 = Name$0[92];
    function sup$0(d, at, cs) {
        return v$1(d, at, name$82, cs);
    }
    var name$83 = Name$0[93];
    function table$0(d, at, cs) {
        return v$1(d, at, name$83, cs);
    }
    var name$84 = Name$0[94];
    function tbody$0(d, at, cs) {
        return v$1(d, at, name$84, cs);
    }
    var name$85 = Name$0[95];
    function td$0(d, at, cs) {
        return v$1(d, at, name$85, cs);
    }
    var name$86 = Name$0[96];
    function textarea$0(d, at, cs) {
        return v$1(d, at, name$86, cs);
    }
    var name$87 = Name$0[97];
    function tfoot$0(d, at, cs) {
        return v$1(d, at, name$87, cs);
    }
    var name$88 = Name$0[98];
    function th$0(d, at, cs) {
        return v$1(d, at, name$88, cs);
    }
    var name$89 = Name$0[99];
    function thead$0(d, at, cs) {
        return v$1(d, at, name$89, cs);
    }
    var name$90 = Name$0[100];
    function time$0(d, at, cs) {
        return v$1(d, at, name$90, cs);
    }
    var name$91 = Name$0[101];
    function title$3(d, at, cs) {
        return v$1(d, at, name$91, cs);
    }
    var name$92 = Name$0[102];
    function tr$0(d, at, cs) {
        return v$1(d, at, name$92, cs);
    }
    var _D_ = Name$0[103];
    function track$0(_az_, _aA_, _aB_) {
        return void_cons(_D_, _az_, _aA_, _aB_);
    }
    var name$93 = Name$0[104];
    function u$0(d, at, cs) {
        return v$1(d, at, name$93, cs);
    }
    var name$94 = Name$0[105];
    function ul$0(d, at, cs) {
        return v$1(d, at, name$94, cs);
    }
    var name$95 = Name$0[106];
    function var$1(d, at, cs) {
        return v$1(d, at, name$95, cs);
    }
    var name$96 = Name$0[107];
    function video$0(d, at, cs) {
        return v$1(d, at, name$96, cs);
    }
    var _E_ = Name$0[108];
    function wbr$0(_aw_, _ax_, _ay_) {
        return void_cons(_E_, _aw_, _ax_, _ay_);
    }
    function as_target(d) {
        return d;
    }
    function root(d) {
        return d[cst_documentElement];
    }
    function body$1(d) {
        var b = d[cst_body];
        return caml_call1(Jv[9], b) ? b : caml_call2(Jv[34], 0, "Document body is null. Try to defer your script execution.");
    }
    function head$1(d) {
        return d[cst_head];
    }
    function active_el(d) {
        var _au_ = d[cst_activeElement];
        return caml_call2(Jv[10], function(_av_) {
            return _av_;
        }, _au_);
    }
    function find_el_by_id(d, id) {
        var _as_ = d.getElementById(id);
        return caml_call2(Jv[10], function(_at_) {
            return _at_;
        }, _as_);
    }
    function find_els_by_name(d, n) {
        return el_list_of_node_list(d.getElementsByName(n));
    }
    function referrer(d) {
        return caml_call2(Jv[23][2], d, cst_referrer);
    }
    function title$4(d) {
        return caml_call2(Jv[23][2], d, cst_title);
    }
    function set_title(d, t) {
        return caml_call3(Jv[23][3], d, cst_title$0, t);
    }
    var hidden$1 = cst_hidden, visible = "visible", Visibility_state = [
        0,
        hidden$1,
        visible
    ];
    function visibility_state(d) {
        return caml_call2(Jv[23][2], d, cst_visibilityState);
    }
    function pointer_lock_element(d) {
        var _aq_ = d[cst_pointerLockElement];
        return caml_call1(caml_call1(Jv[10], function(_ar_) {
            return _ar_;
        }), _aq_);
    }
    function exit_pointer_lock(d) {
        var fut = next(0, pointerlockchange, d);
        d.exitPointerLock();
        return fut;
    }
    function fullscreen_available(d) {
        return caml_call2(Jv[19][2], d, cst_fullscreenEnabled);
    }
    function fullscreen_element(d) {
        var _ao_ = d["fullscreenElement"];
        return caml_call1(caml_call1(Jv[10], function(_ap_) {
            return _ap_;
        }), _ao_);
    }
    function exit_fullscreen(d) {
        var _am_ = d.exitFullscreen();
        return caml_call1(caml_call1(Fut[11], function(_an_) {
            return 0;
        }), _am_);
    }
    function aborted(s) {
        return caml_call2(Jv[19][2], s, cst_aborted);
    }
    var abort$0 = cst_abort, Signal = [
        0,
        aborted,
        abort$0
    ];
    function controller(param) {
        return new Jv[12]["AbortController"];
    }
    function signal(c) {
        return c["signal"];
    }
    function abort$1(c) {
        c.abort();
        return 0;
    }
    var Abort = [
        0,
        Signal,
        controller,
        signal,
        abort$1
    ];
    function call(c, meth, args) {
        caml_js_meth_call(c, meth, args);
        return 0;
    }
    var c = [
        0,
        Jv[12][cst_console]
    ];
    function get$0(param) {
        return c[1];
    }
    function set$0(n) {
        c[1] = n;
        return 0;
    }
    function clear$0(param) {
        return call(c[1], cst_clear, [
            0
        ]);
    }
    function msg(v) {
        return [
            0,
            v,
            0
        ];
    }
    function str(v) {
        return caml_call1(Jv[6], v) ? "null" : caml_call1(Jv[7], v) ? "undefined" : v.toString();
    }
    function msg_to_jv_array(msg) {
        var a = caml_call1(Jv[31][1], 0), i = 0, param = msg;
        for(;;){
            if (!param) return runtime.caml_js_to_array(a);
            var vs = param[2], v = param[1];
            a[i] = v;
            var i$0 = i + 1 | 0;
            i = i$0;
            param = vs;
        }
    }
    function log(msg) {
        var _al_ = msg_to_jv_array(msg);
        return call(c[1], cst_log, _al_);
    }
    function trace(msg) {
        var _ak_ = msg_to_jv_array(msg);
        return call(c[1], cst_trace, _ak_);
    }
    function error$1(msg) {
        var _aj_ = msg_to_jv_array(msg);
        return call(c[1], cst_error, _aj_);
    }
    function warn(msg) {
        var _ai_ = msg_to_jv_array(msg);
        return call(c[1], cst_warn, _ai_);
    }
    function info(msg) {
        var _ah_ = msg_to_jv_array(msg);
        return call(c[1], cst_info, _ah_);
    }
    function debug(msg) {
        var _ag_ = msg_to_jv_array(msg);
        return call(c[1], cst_debug, _ag_);
    }
    function assert(b, msg) {
        var _af_ = msg_to_jv_array([
            0,
            !!b,
            msg
        ]);
        return call(c[1], cst_assert, _af_);
    }
    function dir$1(o) {
        return call(c[1], cst_dir, [
            0,
            o
        ]);
    }
    function table$1(cols, v) {
        if (cols) var l = cols[1], msg = [
            0,
            v,
            runtime.caml_list_to_js_array(l)
        ];
        else var msg = [
            0,
            v
        ];
        return call(c[1], cst_table, msg);
    }
    function group_end(param) {
        return call(c[1], cst_groupEnd, [
            0
        ]);
    }
    function group(opt, msg) {
        var closed = opt ? opt[1] : 0;
        if (closed) {
            var _ad_ = msg_to_jv_array(msg);
            return call(c[1], cst_groupCollapsed, _ad_);
        }
        var _ae_ = msg_to_jv_array(msg);
        return call(c[1], cst_group, _ae_);
    }
    function count(label) {
        return call(c[1], cst_count, [
            0,
            label
        ]);
    }
    function count_reset(label) {
        return call(c[1], cst_countReset, [
            0,
            label
        ]);
    }
    function time$1(label) {
        return call(c[1], cst_time, [
            0,
            label
        ]);
    }
    function time_log(label, msg) {
        var _ac_ = msg_to_jv_array([
            0,
            label,
            msg
        ]);
        return call(c[1], cst_timeLog, _ac_);
    }
    function time_end(label) {
        return call(c[1], cst_timeEnd, [
            0,
            label
        ]);
    }
    function profile(label) {
        return call(c[1], cst_profile, [
            0,
            label
        ]);
    }
    function profile_end(label) {
        return call(c[1], cst_profileEnd, [
            0,
            label
        ]);
    }
    function time_stamp(label) {
        return call(c[1], cst_timeStamp$0, [
            0,
            label
        ]);
    }
    function log_result(_ab_, opt, r) {
        var ok = _ab_ ? _ab_[1] : function(v) {
            return [
                0,
                v,
                0
            ];
        }, err = opt ? opt[1] : function(e) {
            return [
                0,
                str(e),
                0
            ];
        };
        if (0 === r[0]) {
            var v = r[1];
            log(caml_call1(ok, v));
        } else {
            var e = r[1];
            error$1(caml_call1(err, e));
        }
        return r;
    }
    function log_if_error(_aa_, opt, use, param) {
        var l = _aa_ ? _aa_[1] : error$1, error_msg = opt ? opt[1] : function(e) {
            return [
                0,
                str(e),
                0
            ];
        };
        if (0 === param[0]) {
            var v = param[1];
            return v;
        }
        var e = param[1];
        caml_call1(l, caml_call1(error_msg, e));
        return use;
    }
    function log_if_error$0(l, error_msg, use, r) {
        return [
            0,
            log_if_error(l, error_msg, use, r)
        ];
    }
    function as_target$0(w) {
        return w;
    }
    function closed(w) {
        return caml_call2(Jv[19][2], w, cst_closed);
    }
    function scroll_x$0(w) {
        return caml_call2(Jv[21][2], w, cst_scrollX);
    }
    function scroll_y$0(w) {
        return caml_call2(Jv[21][2], w, cst_scrollY);
    }
    function device_pixel_ratio(w) {
        return caml_call2(Jv[21][2], w, cst_devicePixelRatio);
    }
    function matches_media(w, s) {
        var o = w.matchMedia(s);
        return caml_call2(Jv[19][2], o, cst_matches);
    }
    function prefers_dark_color_scheme(w) {
        return matches_media(w, "(prefers-color-scheme: dark)");
    }
    function open$0(_Z_, opt, w, u) {
        var features = _Z_ ? _Z_[1] : Jstr[4], name = opt ? opt[1] : Jstr[4], ___ = w.open(u, name, features);
        return caml_call1(caml_call1(Jv[10], function(_$_) {
            return _$_;
        }), ___);
    }
    function close$0(w) {
        w.close();
        return 0;
    }
    function print(w) {
        w.print();
        return 0;
    }
    function reload(w) {
        w[cst_location$0].reload();
        return 0;
    }
    function location$0(w) {
        return new url(w[cst_location$0]);
    }
    function set_location(w, u) {
        return w[cst_location$0] = u;
    }
    var auto$0 = cst_auto, manual = "manual", Scroll_restoration = [
        0,
        auto$0,
        manual
    ];
    function length$1(h) {
        return caml_call2(Jv[20][2], h, cst_length$3);
    }
    function scroll_restoration(h) {
        return caml_call2(Jv[23][2], h, cst_scrollRestoration);
    }
    function set_scroll_restoration(h, r) {
        return caml_call3(Jv[23][3], h, cst_scrollRestoration$0, r);
    }
    function back(h) {
        h.back();
        return 0;
    }
    function forward(h) {
        h.forward();
        return 0;
    }
    function go(h, d) {
        h.go(d);
        return 0;
    }
    function state(h) {
        return h[cst_state];
    }
    function push_state(_Y_, _X_, opt, h) {
        var state = _Y_ ? _Y_[1] : Jv[4], title = _X_ ? _X_[1] : Jstr[4], uri = opt ? opt[1] : Jv[4];
        h.pushState(state, title, uri);
        return 0;
    }
    function replace_state(_W_, _V_, opt, h) {
        var state = _W_ ? _W_[1] : Jv[4], title = _V_ ? _V_[1] : Jstr[4], uri = opt ? opt[1] : Jv[4];
        h.replaceState(state, title, uri);
        return 0;
    }
    function state$0(e) {
        return e[cst_state];
    }
    var Popstate = [
        0,
        state$0
    ], popstate = "popstate", Ev = [
        0,
        Popstate,
        popstate
    ], History = [
        0,
        Scroll_restoration,
        length$1,
        scroll_restoration,
        set_scroll_restoration,
        back,
        forward,
        go,
        state,
        push_state,
        replace_state,
        Ev
    ];
    function history(w) {
        return w["history"];
    }
    var Window = [
        0,
        as_target$0,
        closed,
        scroll_x$0,
        scroll_y$0,
        device_pixel_ratio,
        matches_media,
        prefers_dark_color_scheme,
        open$0,
        close$0,
        print,
        reload,
        location$0,
        set_location,
        History,
        history
    ];
    function languages(n) {
        var match = caml_call2(Jv[13], n, cst_languages);
        if (match) {
            var a = match[1];
            return caml_list_of_js_array(a);
        }
        var match$0 = caml_call2(Jv[23][1], n, cst_language);
        if (!match$0) return 0;
        var v = match$0[1];
        return [
            0,
            v,
            0
        ];
    }
    function max_touch_points(n) {
        var t = n["maxTouchPoints"];
        return caml_call1(Jv[8], t) ? 0 : t;
    }
    function online(n) {
        return caml_call2(Jv[19][2], n, cst_onLine);
    }
    var Navigator = [
        0,
        languages,
        max_touch_points,
        online
    ], frame = "frame", navigation = "navigation", resource = "resource", mark$1 = cst_mark, measure = cst_measure, paint = "paint", longtask = "longtask", Type$0 = [
        0,
        frame,
        navigation,
        resource,
        mark$1,
        measure,
        paint,
        longtask
    ];
    function name$97(e) {
        return caml_call2(Jv[23][2], e, cst_name$1);
    }
    function type$6(e) {
        return caml_call2(Jv[23][2], e, cst_entryType);
    }
    function start_time(e) {
        return caml_call2(Jv[21][2], e, cst_startTime);
    }
    function end_time(e) {
        return caml_call2(Jv[21][2], e, cst_endTime);
    }
    function duration(e) {
        return caml_call2(Jv[21][2], e, cst_duration);
    }
    function to_json(e) {
        return e.toJSON();
    }
    function as_entry(_U_) {
        return _U_;
    }
    function initiator_type(e) {
        return caml_call2(Jv[23][2], e, cst_initiatorType);
    }
    function next_hop_protocol(e) {
        return caml_call2(Jv[23][2], e, cst_nextHopProtocol);
    }
    function worker_start(e) {
        return caml_call2(Jv[21][2], e, cst_workerStart);
    }
    function redirect_start(e) {
        return caml_call2(Jv[21][2], e, cst_redirectStart);
    }
    function redirect_end(e) {
        return caml_call2(Jv[21][2], e, cst_redirectEnd);
    }
    function fetch_start(e) {
        return caml_call2(Jv[21][2], e, cst_fetchStart);
    }
    function domain_lookup_start(e) {
        return caml_call2(Jv[21][2], e, cst_domainLookupStart);
    }
    function domain_lookup_end(e) {
        return caml_call2(Jv[21][2], e, cst_domainLookupEnd);
    }
    function connect_start(e) {
        return caml_call2(Jv[21][2], e, cst_connectStart);
    }
    function connect_end(e) {
        return caml_call2(Jv[21][2], e, cst_connectEnd);
    }
    function secure_connection_start(e) {
        return caml_call2(Jv[21][2], e, cst_secureConnectionStart);
    }
    function request_start(e) {
        return caml_call2(Jv[21][2], e, cst_requestStart);
    }
    function response_start(e) {
        return caml_call2(Jv[21][2], e, cst_responseStart);
    }
    function response_end(e) {
        return caml_call2(Jv[21][2], e, cst_responseEnd);
    }
    function transfer_size(e) {
        return caml_call2(Jv[20][2], e, cst_transferSize);
    }
    function encoded_body_size(e) {
        return caml_call2(Jv[20][2], e, cst_encodedBodySize);
    }
    function decoded_body_size(e) {
        return caml_call2(Jv[20][2], e, cst_decodedBodySize);
    }
    var Resource_timing = [
        0,
        as_entry,
        initiator_type,
        next_hop_protocol,
        worker_start,
        redirect_start,
        redirect_end,
        fetch_start,
        domain_lookup_start,
        domain_lookup_end,
        connect_start,
        connect_end,
        secure_connection_start,
        request_start,
        response_start,
        response_end,
        transfer_size,
        encoded_body_size,
        decoded_body_size
    ], navigate = "navigate", reload$0 = cst_reload, back_forward = "back_forward", prerender = "prerender", Type$1 = [
        0,
        navigate,
        reload$0,
        back_forward,
        prerender
    ];
    function as_resource_timing(_T_1) {
        return _T_1;
    }
    function as_entry$0(_S_) {
        return _S_;
    }
    function unload_event_start(e) {
        return caml_call2(Jv[21][2], e, cst_unloadEventStart);
    }
    function unload_event_end(e) {
        return caml_call2(Jv[21][2], e, cst_unloadEventEnd);
    }
    function dom_interactive(e) {
        return caml_call2(Jv[21][2], e, cst_domInteractive);
    }
    function dom_content_loaded_event_start(e) {
        return caml_call2(Jv[21][2], e, cst_domContentLoadedEventStart);
    }
    function dom_content_loaded_event_end(e) {
        return caml_call2(Jv[21][2], e, cst_domContentLoadedEventEnd);
    }
    function dom_complete(e) {
        return caml_call2(Jv[21][2], e, cst_domComplete);
    }
    function load_event_start(e) {
        return caml_call2(Jv[21][2], e, cst_loadEventStart);
    }
    function load_event_end(e) {
        return caml_call2(Jv[21][2], e, cst_loadEventEnd);
    }
    function type$7(e) {
        return caml_call2(Jv[23][2], e, cst_type$3);
    }
    function redirect_count(e) {
        return caml_call2(Jv[20][2], e, cst_redirectCount);
    }
    function as_resource_timing$0(_R_) {
        return _R_;
    }
    function as_navigation_timing(_Q_) {
        return _Q_;
    }
    function time_origin_ms(p) {
        return caml_call2(Jv[21][2], p, cst_timeOrigin);
    }
    function clear_marks(p, n) {
        if (n) var n$0 = n[1], args = [
            0,
            n$0
        ];
        else var args = [
            0
        ];
        caml_js_meth_call(p, "clearMarks", args);
        return 0;
    }
    function clear_measures(p, n) {
        if (n) var n$0 = n[1], args = [
            0,
            n$0
        ];
        else var args = [
            0
        ];
        caml_js_meth_call(p, "clearMeasures", args);
        return 0;
    }
    function clear_resource_timings(p) {
        p.clearResourceTimings();
        return 0;
    }
    function get_entries(type, name, p) {
        if (name) {
            var n = name[1];
            if (type) {
                var t = type[1], _I_ = p.getEntriesByName(n, t);
                return caml_call1(caml_call1(Jv[29], function(_P_) {
                    return _P_;
                }), _I_);
            }
            var _J_ = p.getEntriesByName(n);
            return caml_call1(caml_call1(Jv[29], function(_O_) {
                return _O_;
            }), _J_);
        }
        if (type) {
            var t$0 = type[1], _K_ = p.getEntriesByType(t$0);
            return caml_call1(caml_call1(Jv[29], function(_N_) {
                return _N_;
            }), _K_);
        }
        var _L_ = p.getEntries();
        return caml_call1(caml_call1(Jv[29], function(_M_) {
            return _M_;
        }), _L_);
    }
    function mark$2(p, n) {
        p.mark(n);
        return 0;
    }
    function measure$0(start, stop, p, n) {
        if (start) {
            var s = start[1];
            if (stop) {
                var e = stop[1];
                p.measure(s, e);
                return 0;
            }
            p.measure(s);
            return 0;
        }
        if (stop) {
            var e$0 = stop[1];
            p.measure(Jv[5], e$0);
            return 0;
        }
        p.measure();
        return 0;
    }
    function now_ms(p) {
        return p.now();
    }
    function to_json$0(p) {
        return p.toJSON();
    }
    var console1 = Jv[12][cst_console], navigator = Jv[12]["navigator"], performance1 = Jv[12]["performance"], window = Jv[12][cst_window], is_secure_context = caml_call2(Jv[19][2], Jv[12], cst_isSecureContext), target$0 = Jv[12];
    function set_timeout(ms, f) {
        return Jv[12].setTimeout(caml_js_wrap_callback_strict(1, f), ms);
    }
    function set_interval(ms, f) {
        return Jv[12].setInterval(caml_js_wrap_callback_strict(1, f), ms);
    }
    function stop_timer(tid) {
        Jv[12].clearTimeout(tid);
        return 0;
    }
    function request_animation_frame(f) {
        return Jv[12].requestAnimationFrame(caml_js_wrap_callback_strict(1, f));
    }
    function cancel_animation_frame(fid) {
        Jv[12].cancelAnimationFrame(fid);
        return 0;
    }
    var Brr = [
        0,
        [
            0,
            [
                0,
                create$0,
                byte_length,
                slice
            ],
            [
                0,
                of_buffer,
                buffer,
                byte_offset,
                byte_length$0,
                get_int8,
                get_int16_be,
                get_int16_le,
                get_int32_be,
                get_int32_le,
                get_uint8,
                get_uint16_be,
                get_uint16_le,
                get_uint32_be,
                get_uint32_le,
                get_float32_be,
                get_float32_le,
                get_float64_be,
                get_float64_le,
                set_int8,
                set_int16_be,
                set_int16_le,
                set_int32_be,
                set_int32_le,
                set_uint8,
                set_uint16_be,
                set_uint16_le,
                set_uint32_be,
                set_uint32_le,
                set_float32_be,
                set_float32_le,
                set_float64_be,
                set_float64_le
            ],
            type_size_in_bytes,
            create$1,
            of_buffer$0,
            buffer,
            byte_offset,
            byte_length$0,
            length$0,
            type$2,
            get,
            set,
            set_tarray,
            fill,
            copy_within,
            slice$0,
            sub,
            find,
            find_index,
            for_all,
            exists,
            filter,
            iter,
            map,
            fold_left,
            fold_right,
            reverse,
            of_tarray,
            uint8_of_buffer,
            of_int_array,
            of_float_array,
            of_jstr,
            to_jstr,
            of_binary_jstr,
            to_binary_jstr,
            to_int_jstr,
            to_hex_jstr,
            type_to_bigarray_kind,
            type_of_bigarray_kind
        ],
        [
            0,
            Ending_type,
            init$0,
            of_jstr$0,
            of_array_buffer,
            byte_length$1,
            type$3,
            slice$1,
            array_buffer$0,
            stream,
            text,
            data_uri
        ],
        [
            0,
            init$1,
            of_blob,
            name,
            relative_path,
            last_modified_ms
        ],
        Base64,
        [
            0,
            encode$0,
            decode$0
        ],
        [
            0,
            v,
            scheme,
            host,
            port,
            path,
            query,
            fragment,
            with_uri,
            path_segments,
            with_path_segments,
            [
                0,
                is_empty,
                mem,
                find$0,
                find_all,
                fold,
                of_obj,
                of_jstr$1,
                to_jstr$0,
                of_assoc,
                to_assoc
            ],
            query_params,
            with_query_params,
            fragment_params,
            with_fragment_params,
            of_jstr$2,
            to_jstr$1,
            encode$2,
            decode$2,
            encode_component$0,
            decode_component$0
        ],
        [
            0,
            Type,
            init,
            create,
            type,
            target,
            current_target,
            composed_path,
            event_phase,
            bubbles,
            stop_propagation,
            stop_immediate_propagation,
            cancelable,
            prevent_default,
            default_prevented,
            composed,
            is_trusted,
            timestamp_ms,
            dispatch,
            listen_opts,
            listen,
            unlisten,
            next,
            [
                0,
                Effect,
                Item,
                [
                    0,
                    length,
                    add_jstr,
                    add_file,
                    remove,
                    clear,
                    caml_js_get,
                    items
                ],
                drop_effect,
                set_drop_effect,
                effect_allowed,
                set_effect_allowed,
                items$0
            ],
            Clipboard,
            Composition,
            Error1,
            Extendable,
            Focus,
            Hash_change,
            Input,
            Keyboard,
            Mouse,
            Drag,
            Pointer,
            Wheel,
            abort,
            activate,
            auxclick,
            beforeinput,
            beforeunload,
            blur,
            canplay,
            canplaythrough,
            change,
            click,
            clipboardchange,
            close,
            compositionend,
            compositionstart,
            compositionudpate,
            controllerchange,
            copy$0,
            cut,
            dblclick,
            dom_content_loaded,
            drag,
            dragend,
            dragenter,
            dragexit,
            dragleave,
            dragover,
            dragstart,
            drop,
            durationchange,
            emptied,
            ended,
            error$0,
            focus,
            focusin,
            focusout,
            fullscreenchange,
            fullscreenerror,
            gotpointercapture,
            hashchange,
            input,
            install,
            keydown,
            keyup,
            languagechange,
            load,
            loadeddata,
            loadedmetadata,
            loadstart,
            lostpointercapture,
            mousedown,
            mouseenter,
            mouseleave,
            mousemove,
            mouseout,
            mouseover,
            mouseup,
            open,
            paste,
            pause,
            play,
            playing,
            pointercancel,
            pointerdown,
            pointerenter,
            pointerleave,
            pointerlockchange,
            pointerlockerror,
            pointermove,
            pointerout,
            pointerover,
            pointerrawupdate,
            pointerup,
            progress,
            ratechange,
            reset,
            resize,
            scroll,
            seeked,
            seeking,
            select,
            statechange,
            stalled,
            suspend,
            timeupdate,
            unload,
            updatefound,
            visibilitychange,
            volumechange,
            waiting,
            wheel
        ],
        [
            0,
            v$0,
            void$0,
            is_void,
            true$0,
            int$0,
            float$0,
            if$0,
            if_some,
            to_pair,
            add_if,
            add_if_some,
            Name,
            accesskey$0,
            action$0,
            autocomplete$0,
            autofocus$0,
            charset$0,
            checked$0,
            class$1,
            cols$0,
            content$0,
            contenteditable$0,
            defer$0,
            dir$0,
            disabled$0,
            download$0,
            draggable$0,
            for$1,
            height$1,
            hidden$0,
            href$0,
            id$1,
            lang$0,
            list$0,
            media$0,
            method$0,
            name$1,
            placeholder$0,
            rel$0,
            required$0,
            rows$0,
            selected$0,
            spellcheck$0,
            src$0,
            style$0,
            tabindex$0,
            title$0,
            type$5,
            value$0,
            wrap$0,
            width$1
        ],
        [
            0,
            v$1,
            txt,
            txt$0,
            sp,
            nbsp,
            is_txt,
            is_el,
            tag_name,
            has_tag_name,
            txt_text,
            document1,
            find_by_class,
            find_by_tag_name,
            find_first_by_selector,
            fold_find_by_selector,
            parent,
            children,
            set_children,
            prepend_children,
            append_children,
            previous_sibling,
            next_sibling,
            insert_siblings,
            remove$0,
            at,
            set_at,
            [
                0,
                bool,
                int$1,
                float$1,
                jstr,
                checked$1,
                height$2,
                id$2,
                name$2,
                title$1,
                value$1,
                width$2
            ],
            prop,
            set_prop,
            class$2,
            set_class,
            Style,
            computed_style,
            inline_style,
            set_inline_style,
            remove_inline_style,
            inner_x,
            inner_y,
            inner_w,
            inner_h,
            bound_x,
            bound_y,
            bound_w,
            bound_h,
            scroll_x,
            scroll_y,
            scroll_w,
            scroll_h,
            scroll_into_view,
            has_focus,
            set_has_focus,
            is_locking_pointer,
            request_pointer_lock,
            Navigation_ui,
            fullscreen_opts,
            request_fullscreen,
            click$0,
            select_text,
            Input$0,
            Name$0,
            a$0,
            abbr$0,
            address$0,
            area$0,
            article$0,
            aside$0,
            audio$0,
            b$0,
            base$0,
            bdi$0,
            bdo$0,
            blockquote$0,
            body$0,
            br$0,
            button$1,
            canvas$0,
            caption$0,
            cite$0,
            code$2,
            col$0,
            colgroup$0,
            command$0,
            datalist$0,
            dd$0,
            del$0,
            details$0,
            dfn$0,
            div$0,
            dl$0,
            dt$0,
            em$0,
            embed$0,
            fieldset$0,
            figcaption$0,
            figure$0,
            footer$0,
            form$0,
            h1$0,
            h2$0,
            h3$0,
            h4$0,
            h5$0,
            h6$0,
            head$0,
            header$0,
            hgroup$0,
            hr$0,
            html$0,
            i$0,
            iframe$0,
            img$0,
            input$1,
            ins$0,
            kbd$0,
            keygen$0,
            label$0,
            legend$0,
            li$0,
            link$1,
            map$1,
            mark$0,
            menu$0,
            meta$0,
            meter$0,
            nav$0,
            noscript$0,
            object$0,
            ol$0,
            optgroup$0,
            option$0,
            output$0,
            p$0,
            function(_F_, _G_, _H_) {
                return void_cons(_B_, _F_, _G_, _H_);
            },
            pre$0,
            progress$1,
            q$0,
            rp$0,
            rt$0,
            ruby$0,
            s$0,
            samp$0,
            script$0,
            section$0,
            select$1,
            small$0,
            source$0,
            span$0,
            strong$0,
            style$2,
            sub$1,
            summary$0,
            sup$0,
            table$0,
            tbody$0,
            td$0,
            textarea$0,
            tfoot$0,
            th$0,
            thead$0,
            time$0,
            title$3,
            tr$0,
            track$0,
            u$0,
            ul$0,
            var$1,
            video$0,
            wbr$0
        ],
        [
            0,
            as_target,
            find_el_by_id,
            find_els_by_name,
            root,
            body$1,
            head$1,
            active_el,
            referrer,
            title$4,
            set_title,
            Visibility_state,
            visibility_state,
            pointer_lock_element,
            exit_pointer_lock,
            fullscreen_available,
            fullscreen_element,
            exit_fullscreen
        ],
        Abort,
        [
            0,
            get$0,
            set$0,
            clear$0,
            msg,
            str,
            log_result,
            log_if_error,
            log_if_error$0,
            log,
            trace,
            error$1,
            warn,
            info,
            debug,
            assert,
            dir$1,
            table$1,
            group,
            group_end,
            count,
            count_reset,
            time$1,
            time_log,
            time_end,
            profile,
            profile_end,
            time_stamp
        ],
        Window,
        Navigator,
        [
            0,
            [
                0,
                Type$0,
                name$97,
                type$6,
                start_time,
                end_time,
                duration,
                to_json,
                Resource_timing,
                [
                    0,
                    Type$1,
                    as_entry$0,
                    as_resource_timing,
                    unload_event_start,
                    unload_event_end,
                    dom_interactive,
                    dom_content_loaded_event_start,
                    dom_content_loaded_event_end,
                    dom_complete,
                    load_event_start,
                    load_event_end,
                    type$7,
                    redirect_count
                ],
                as_resource_timing$0,
                as_navigation_timing
            ],
            time_origin_ms,
            clear_marks,
            clear_measures,
            clear_resource_timings,
            get_entries,
            mark$2,
            measure$0,
            now_ms,
            to_json$0
        ],
        [
            0,
            console1,
            global_document,
            navigator,
            performance1,
            window,
            target$0,
            is_secure_context,
            set_timeout,
            set_interval,
            stop_timer,
            request_animation_frame,
            cancel_animation_frame
        ]
    ];
    runtime.caml_register_global(774, Brr, "Brr");
    return;
})(globalThis);
//# 1 "../.js/default/brr_svg/brr_svg.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/brr_svg/brr_svg.cma.js"
//# 6 "../.js/default/brr_svg/brr_svg.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_color_profile = "color-profile", cst_cursor = "cursor", cst_filter = "filter", cst_glyphRef = "glyphRef", cst_mask = "mask", cst_path = "path", cst_style = "style", cst_title = "title";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Jv = global_data.Jv, Stdlib_List = global_data.Stdlib__List, Jstr = global_data.Jstr, xlink = "http://www.w3.org/1999/xlink", xml = "http://www.w3.org/XML/1998/namespace", NS = [
        0,
        xlink,
        xml
    ], accentheight = "accent-height", accumulate = "accumulate", additive = "additive", alignmentbaseline = "alignment-baseline", alphabetic = "alphabetic", amplitude = "amplitude", arabicform = "arabic-form", ascent = "ascent", attributename = "attributeName", attributetype = "attributeType", azimuth = "azimuth", basefrequency = "baseFrequency", baselineshift = "baseline-shift", baseprofile = "baseProfile", bbox = "bbox", begin = "begin", bias = "bias", by = "by", calcmode = "calcMode", capheight = "cap-height", class$0 = "class", clip = "clip", clippath = "clip-path", clippathunits = "clipPathUnits", cliprule = "clip-rule", color = "color", colorinterpolation = "color-interpolation", colorinterpolationfilters = "color-interpolation-filters", colorprofile = cst_color_profile, colorrendering = "color-rendering", contentscripttype = "contentScriptType", contentstyletype = "contentStyleType", cursor = cst_cursor, cx = "cx", cy = "cy", d = "d", descent = "descent", diffuseconstant = "diffuseConstant", direction = "direction", display = "display", divisor = "divisor", dominantbaseline = "dominant-baseline", dur = "dur", dx = "dx", dy = "dy", edgemode = "edgeMode", elevation = "elevation", enablebackground = "enable-background", end = "end", exponent = "exponent", externalresourcesrequired = "externalResourcesRequired", fill = "fill", fillopacity = "fill-opacity", fillrule = "fill-rule", filter = cst_filter, filterres = "filterRes", filterunits = "filterUnits", floodcolor = "flood-color", floodopacity = "flood-opacity", fontfamily = "font-family", fontsize = "font-size", fontsizeadjust = "font-size-adjust", fontstretch = "font-stretch", fontstyle = "font-style", fontvariant = "font-variant", fontweight = "font-weight", format = "format", from = "from", fx = "fx", fy = "fy", g1 = "g1", g2 = "g2", glyphname = "glyph-name", glyphorientationhorizontal = "glyph-orientation-horizontal", glyphorientationvertical = "glyph-orientation-vertical", glyphref = cst_glyphRef, gradienttransform = "gradientTransform", gradientunits = "gradientUnits", hanging = "hanging", height = "height", horizadvx = "horiz-adv-x", horizoriginx = "horiz-origin-x", horizoriginy = "horiz-origin-y", id = "id", ideographic = "ideographic", imagerendering = "image-rendering", in$0 = "in", in2 = "in2", intercept = "intercept", k = "k", k1 = "k1", k2 = "k2", k3 = "k3", k4 = "k4", kernelmatrix = "kernelMatrix", kernelunitlength = "kernelUnitLength", kerning = "kerning", keypoints = "keyPoints", keysplines = "keySplines", keyTimes = "keyTimes", lang = "lang", lengthadjust = "lengthAdjust", letterspacing = "letter-spacing", lightingcolor = "lighting-color", limitingconeangle = "limitingConeAngle", local = "local", markerend = "marker-end", markerheight = "markerHeight", markermid = "marker-mid", markerstart = "marker-start", markerunits = "markerUnits", markerwidth = "markerWidth", mask = cst_mask, maskcontentunits = "maskContentUnits", maskunits = "maskUnits", mathematical = "mathematical", max = "max", media = "media", method = "method", min = "min", mode = "mode", name = "name", numoctaves = "numOctaves", offset = "offset", opacity = "opacity", operator = "operator", order = "order", orient = "orient", orientation = "orientation", origin = "origin", overflow = "overflow", overlineposition = "overline-position", overlinethickness = "overline-thickness", panose1 = "panose-1", path = cst_path, pathlength = "pathLength", patterncontentunits = "patternContentUnits", patterntransform = "patternTransform", patternunits = "patternUnits", pointerevents = "pointer-events", points = "points", pointsatx = "pointsAtX", pointsaty = "pointsAtY", pointsatz = "pointsAtZ", preservealpha = "preserveAlpha", preserveaspectratio = "preserveAspectRatio", primitiveunits = "primitiveUnits", r = "r", radius = "radius", refx = "refX", refy = "refY", renderingintent = "rendering-intent", repeatcount = "repeatCount", repeatdur = "repeatDur", requiredextensions = "requiredExtensions", requiredfeatures = "requiredFeatures", restart = "restart", result = "result", rotate = "rotate", rx = "rx", ry = "ry", scale = "scale", seed = "seed", shaperendering = "shape-rendering", slope = "slope", spacing = "spacing", specularconstant = "specularConstant", specularexponent = "specularExponent", spreadmethod = "spreadMethod", startoffset = "startOffset", stddeviation = "stdDeviation", stemh = "stemh", stemv = "stemv", stitchtiles = "stitchTiles", stopcolor = "stop-color", stopopacity = "stop-opacity", strikethroughposition = "strikethrough-position", strikethroughthickness = "strikethrough-thickness", string = "string", stroke = "stroke", strokedasharray = "stroke-dasharray", strokedashoffset = "stroke-dashoffset", strokelinecap = "stroke-linecap", strokelinejoin = "stroke-linejoin", strokemiterlimit = "stroke-miterlimit", strokeopacity = "stroke-opacity", strokewidth = "stroke-width", style = cst_style, surfacescale = "surfaceScale", systemlanguage = "systemLanguage", tablevalues = "tableValues", target = "target", targetx = "targetX", targety = "targetY", textanchor = "text-anchor", textdecoration = "text-decoration", textlength = "textLength", textrendering = "text-rendering", title = cst_title, to = "to", transform = "transform", type = "type", u1 = "u1", u2 = "u2", underlineposition = "underline-position", underlinethickness = "underline-thickness", unicode = "unicode", unicodebidi = "unicode-bidi", unicoderange = "unicode-range", unitsperem = "units-per-em", valphabetic = "v-alphabetic", values = "values", version = "version", vertadvy = "vert-adv-y", vertoriginx = "vert-origin-x", vertoriginy = "vert-origin-y", vhanging = "v-hanging", videographic = "v-ideographic", viewbox = "viewBox", viewtarget = "viewTarget", visibility = "visibility", vmathematical = "v-mathematical", width = "width", widths = "widths", wordspacing = "word-spacing", writingmode = "writing-mode", x = "x", x1 = "x1", x2 = "x2", xchannelselector = "xChannelSelector", xheight = "x-height", xlinkactuate = "xlink:actuate", xlinkarcrole = "xlink:arcrole", xlinkhref = "xlink:href", xlinkrole = "xlink:role", xlinkshow = "xlink:show", xlinktitle = "xlink:title", xlinktype = "xlink:type", xmlbase = "xml:base", xmllang = "xml:lang", xmlspace = "xml:space", y = "y", y1 = "y1", y2 = "y2", ychannelselector = "yChannelSelector", z = "z", zoomandpan = "zoomAndPan", Name = [
        0,
        accentheight,
        accumulate,
        additive,
        alignmentbaseline,
        alphabetic,
        amplitude,
        arabicform,
        ascent,
        attributename,
        attributetype,
        azimuth,
        basefrequency,
        baselineshift,
        baseprofile,
        bbox,
        begin,
        bias,
        by,
        calcmode,
        capheight,
        class$0,
        clip,
        clippath,
        clippathunits,
        cliprule,
        color,
        colorinterpolation,
        colorinterpolationfilters,
        colorprofile,
        colorrendering,
        contentscripttype,
        contentstyletype,
        cursor,
        cx,
        cy,
        d,
        descent,
        diffuseconstant,
        direction,
        display,
        divisor,
        dominantbaseline,
        dur,
        dx,
        dy,
        edgemode,
        elevation,
        enablebackground,
        end,
        exponent,
        externalresourcesrequired,
        fill,
        fillopacity,
        fillrule,
        filter,
        filterres,
        filterunits,
        floodcolor,
        floodopacity,
        fontfamily,
        fontsize,
        fontsizeadjust,
        fontstretch,
        fontstyle,
        fontvariant,
        fontweight,
        format,
        from,
        fx,
        fy,
        g1,
        g2,
        glyphname,
        glyphorientationhorizontal,
        glyphorientationvertical,
        glyphref,
        gradienttransform,
        gradientunits,
        hanging,
        height,
        horizadvx,
        horizoriginx,
        horizoriginy,
        id,
        ideographic,
        imagerendering,
        in$0,
        in2,
        intercept,
        k,
        k1,
        k2,
        k3,
        k4,
        kernelmatrix,
        kernelunitlength,
        kerning,
        keypoints,
        keysplines,
        keyTimes,
        lang,
        lengthadjust,
        letterspacing,
        lightingcolor,
        limitingconeangle,
        local,
        markerend,
        markerheight,
        markermid,
        markerstart,
        markerunits,
        markerwidth,
        mask,
        maskcontentunits,
        maskunits,
        mathematical,
        max,
        media,
        method,
        min,
        mode,
        name,
        numoctaves,
        offset,
        opacity,
        operator,
        order,
        orient,
        orientation,
        origin,
        overflow,
        overlineposition,
        overlinethickness,
        panose1,
        path,
        pathlength,
        patterncontentunits,
        patterntransform,
        patternunits,
        pointerevents,
        points,
        pointsatx,
        pointsaty,
        pointsatz,
        preservealpha,
        preserveaspectratio,
        primitiveunits,
        r,
        radius,
        refx,
        refy,
        renderingintent,
        repeatcount,
        repeatdur,
        requiredextensions,
        requiredfeatures,
        restart,
        result,
        rotate,
        rx,
        ry,
        scale,
        seed,
        shaperendering,
        slope,
        spacing,
        specularconstant,
        specularexponent,
        spreadmethod,
        startoffset,
        stddeviation,
        stemh,
        stemv,
        stitchtiles,
        stopcolor,
        stopopacity,
        strikethroughposition,
        strikethroughthickness,
        string,
        stroke,
        strokedasharray,
        strokedashoffset,
        strokelinecap,
        strokelinejoin,
        strokemiterlimit,
        strokeopacity,
        strokewidth,
        style,
        surfacescale,
        systemlanguage,
        tablevalues,
        target,
        targetx,
        targety,
        textanchor,
        textdecoration,
        textlength,
        textrendering,
        title,
        to,
        transform,
        type,
        u1,
        u2,
        underlineposition,
        underlinethickness,
        unicode,
        unicodebidi,
        unicoderange,
        unitsperem,
        valphabetic,
        values,
        version,
        vertadvy,
        vertoriginx,
        vertoriginy,
        vhanging,
        videographic,
        viewbox,
        viewtarget,
        visibility,
        vmathematical,
        width,
        widths,
        wordspacing,
        writingmode,
        x,
        x1,
        x2,
        xchannelselector,
        xheight,
        xlinkactuate,
        xlinkarcrole,
        xlinkhref,
        xlinkrole,
        xlinkshow,
        xlinktitle,
        xlinktype,
        xmlbase,
        xmllang,
        xmlspace,
        y,
        y1,
        y2,
        ychannelselector,
        z,
        zoomandpan
    ];
    function v(ns, n, v) {
        return [
            0,
            ns,
            n,
            v
        ];
    }
    function accentheight$0(s) {
        var n = Name[1];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function accumulate$0(s) {
        var n = Name[2];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function additive$0(s) {
        var n = Name[3];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function alignmentbaseline$0(s) {
        var n = Name[4];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function alphabetic$0(s) {
        var n = Name[5];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function amplitude$0(s) {
        var n = Name[6];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function arabicform$0(s) {
        var n = Name[7];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function ascent$0(s) {
        var n = Name[8];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function attributename$0(s) {
        var n = Name[9];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function attributetype$0(s) {
        var n = Name[10];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function azimuth$0(s) {
        var n = Name[11];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function basefrequency$0(s) {
        var n = Name[12];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function baselineshift$0(s) {
        var n = Name[13];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function baseprofile$0(s) {
        var n = Name[14];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function bbox$0(s) {
        var n = Name[15];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function begin$0(s) {
        var n = Name[16];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function bias$0(s) {
        var n = Name[17];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function by$0(s) {
        var n = Name[18];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function calcmode$0(s) {
        var n = Name[19];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function capheight$0(s) {
        var n = Name[20];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function class$1(s) {
        var n = Name[21];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function clip$0(s) {
        var n = Name[22];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function clippath$0(s) {
        var n = Name[23];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function clippathunits$0(s) {
        var n = Name[24];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function cliprule$0(s) {
        var n = Name[25];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function color$0(s) {
        var n = Name[26];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function colorinterpolation$0(s) {
        var n = Name[27];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function colorinterpolationfilters$0(s) {
        var n = Name[28];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function colorprofile$0(s) {
        var n = Name[29];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function colorrendering$0(s) {
        var n = Name[30];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function contentscripttype$0(s) {
        var n = Name[31];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function contentstyletype$0(s) {
        var n = Name[32];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function cursor$0(s) {
        var n = Name[33];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function cx$0(s) {
        var n = Name[34];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function cy$0(s) {
        var n = Name[35];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function d$0(s) {
        var n = Name[36];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function descent$0(s) {
        var n = Name[37];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function diffuseconstant$0(s) {
        var n = Name[38];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function direction$0(s) {
        var n = Name[39];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function display$0(s) {
        var n = Name[40];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function divisor$0(s) {
        var n = Name[41];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function dominantbaseline$0(s) {
        var n = Name[42];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function dur$0(s) {
        var n = Name[43];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function dx$0(s) {
        var n = Name[44];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function dy$0(s) {
        var n = Name[45];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function edgemode$0(s) {
        var n = Name[46];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function elevation$0(s) {
        var n = Name[47];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function enablebackground$0(s) {
        var n = Name[48];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function end$0(s) {
        var n = Name[49];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function exponent$0(s) {
        var n = Name[50];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function externalresourcesrequired$0(s) {
        var n = Name[51];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fill$0(s) {
        var n = Name[52];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fillopacity$0(s) {
        var n = Name[53];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fillrule$0(s) {
        var n = Name[54];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function filter$0(s) {
        var n = Name[55];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function filterres$0(s) {
        var n = Name[56];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function filterunits$0(s) {
        var n = Name[57];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function floodcolor$0(s) {
        var n = Name[58];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function floodopacity$0(s) {
        var n = Name[59];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontfamily$0(s) {
        var n = Name[60];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontsize$0(s) {
        var n = Name[61];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontsizeadjust$0(s) {
        var n = Name[62];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontstretch$0(s) {
        var n = Name[63];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontstyle$0(s) {
        var n = Name[64];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontvariant$0(s) {
        var n = Name[65];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontweight$0(s) {
        var n = Name[66];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function format$0(s) {
        var n = Name[67];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function from$0(s) {
        var n = Name[68];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fx$0(s) {
        var n = Name[69];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fy$0(s) {
        var n = Name[70];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function g1$0(s) {
        var n = Name[71];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function g2$0(s) {
        var n = Name[72];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function glyphname$0(s) {
        var n = Name[73];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function glyphorientationhorizontal$0(s) {
        var n = Name[74];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function glyphorientationvertical$0(s) {
        var n = Name[75];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function glyphref$0(s) {
        var n = Name[76];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function gradienttransform$0(s) {
        var n = Name[77];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function gradientunits$0(s) {
        var n = Name[78];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function hanging$0(s) {
        var n = Name[79];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function height$0(s) {
        var n = Name[80];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function horizadvx$0(s) {
        var n = Name[81];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function horizoriginx$0(s) {
        var n = Name[82];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function horizoriginy$0(s) {
        var n = Name[83];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function id$0(s) {
        var n = Name[84];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function ideographic$0(s) {
        var n = Name[85];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function imagerendering$0(s) {
        var n = Name[86];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function in$1(s) {
        var n = Name[87];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function in2$0(s) {
        var n = Name[88];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function intercept$0(s) {
        var n = Name[89];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function k$0(s) {
        var n = Name[90];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function k1$0(s) {
        var n = Name[91];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function k2$0(s) {
        var n = Name[92];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function k3$0(s) {
        var n = Name[93];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function k4$0(s) {
        var n = Name[94];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function kernelmatrix$0(s) {
        var n = Name[95];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function kernelunitlength$0(s) {
        var n = Name[96];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function kerning$0(s) {
        var n = Name[97];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function keypoints$0(s) {
        var n = Name[98];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function keysplines$0(s) {
        var n = Name[99];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function keyTimes$0(s) {
        var n = Name[100];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function lang$0(s) {
        var n = Name[101];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function lengthadjust$0(s) {
        var n = Name[102];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function letterspacing$0(s) {
        var n = Name[103];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function lightingcolor$0(s) {
        var n = Name[104];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function limitingconeangle$0(s) {
        var n = Name[105];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function local$0(s) {
        var n = Name[106];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markerend$0(s) {
        var n = Name[107];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markerheight$0(s) {
        var n = Name[108];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markermid$0(s) {
        var n = Name[109];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markerstart$0(s) {
        var n = Name[110];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markerunits$0(s) {
        var n = Name[111];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markerwidth$0(s) {
        var n = Name[112];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function mask$0(s) {
        var n = Name[113];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function maskcontentunits$0(s) {
        var n = Name[114];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function maskunits$0(s) {
        var n = Name[115];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function mathematical$0(s) {
        var n = Name[116];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function max$0(s) {
        var n = Name[117];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function media$0(s) {
        var n = Name[118];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function method$0(s) {
        var n = Name[119];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function min$0(s) {
        var n = Name[120];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function mode$0(s) {
        var n = Name[121];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function name$0(s) {
        var n = Name[122];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function numoctaves$0(s) {
        var n = Name[123];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function offset$0(s) {
        var n = Name[124];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function opacity$0(s) {
        var n = Name[125];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function operator$0(s) {
        var n = Name[126];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function order$0(s) {
        var n = Name[127];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function orient$0(s) {
        var n = Name[128];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function orientation$0(s) {
        var n = Name[129];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function origin$0(s) {
        var n = Name[130];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function overflow$0(s) {
        var n = Name[131];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function overlineposition$0(s) {
        var n = Name[132];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function overlinethickness$0(s) {
        var n = Name[133];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function panose1$0(s) {
        var n = Name[134];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function path$0(s) {
        var n = Name[135];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function pathlength$0(s) {
        var n = Name[136];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function patterncontentunits$0(s) {
        var n = Name[137];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function patterntransform$0(s) {
        var n = Name[138];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function patternunits$0(s) {
        var n = Name[139];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function pointerevents$0(s) {
        var n = Name[140];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function points$0(s) {
        var n = Name[141];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function pointsatx$0(s) {
        var n = Name[142];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function pointsaty$0(s) {
        var n = Name[143];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function pointsatz$0(s) {
        var n = Name[144];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function preservealpha$0(s) {
        var n = Name[145];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function preserveaspectratio$0(s) {
        var n = Name[146];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function primitiveunits$0(s) {
        var n = Name[147];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function r$0(s) {
        var n = Name[148];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function radius$0(s) {
        var n = Name[149];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function refx$0(s) {
        var n = Name[150];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function refy$0(s) {
        var n = Name[151];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function renderingintent$0(s) {
        var n = Name[152];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function repeatcount$0(s) {
        var n = Name[153];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function repeatdur$0(s) {
        var n = Name[154];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function requiredextensions$0(s) {
        var n = Name[155];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function requiredfeatures$0(s) {
        var n = Name[156];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function restart$0(s) {
        var n = Name[157];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function result$0(s) {
        var n = Name[158];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function rotate$0(s) {
        var n = Name[159];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function rx$0(s) {
        var n = Name[160];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function ry$0(s) {
        var n = Name[161];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function scale$0(s) {
        var n = Name[162];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function seed$0(s) {
        var n = Name[163];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function shaperendering$0(s) {
        var n = Name[164];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function slope$0(s) {
        var n = Name[165];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function spacing$0(s) {
        var n = Name[166];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function specularconstant$0(s) {
        var n = Name[167];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function specularexponent$0(s) {
        var n = Name[168];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function spreadmethod$0(s) {
        var n = Name[169];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function startoffset$0(s) {
        var n = Name[170];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stddeviation$0(s) {
        var n = Name[171];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stemh$0(s) {
        var n = Name[172];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stemv$0(s) {
        var n = Name[173];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stitchtiles$0(s) {
        var n = Name[174];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stopcolor$0(s) {
        var n = Name[175];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stopopacity$0(s) {
        var n = Name[176];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strikethroughposition$0(s) {
        var n = Name[177];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strikethroughthickness$0(s) {
        var n = Name[178];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function string$0(s) {
        var n = Name[179];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stroke$0(s) {
        var n = Name[180];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokedasharray$0(s) {
        var n = Name[181];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokedashoffset$0(s) {
        var n = Name[182];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokelinecap$0(s) {
        var n = Name[183];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokelinejoin$0(s) {
        var n = Name[184];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokemiterlimit$0(s) {
        var n = Name[185];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokeopacity$0(s) {
        var n = Name[186];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokewidth$0(s) {
        var n = Name[187];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function style$0(s) {
        var n = Name[188];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function surfacescale$0(s) {
        var n = Name[189];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function systemlanguage$0(s) {
        var n = Name[190];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function tablevalues$0(s) {
        var n = Name[191];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function target$0(s) {
        var n = Name[192];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function targetx$0(s) {
        var n = Name[193];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function targety$0(s) {
        var n = Name[194];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function textanchor$0(s) {
        var n = Name[195];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function textdecoration$0(s) {
        var n = Name[196];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function textlength$0(s) {
        var n = Name[197];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function textrendering$0(s) {
        var n = Name[198];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function title$0(s) {
        var n = Name[199];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function to$0(s) {
        var n = Name[200];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function transform$0(s) {
        var n = Name[201];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function type$0(s) {
        var n = Name[202];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function u1$0(s) {
        var n = Name[203];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function u2$0(s) {
        var n = Name[204];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function underlineposition$0(s) {
        var n = Name[205];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function underlinethickness$0(s) {
        var n = Name[206];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function unicode$0(s) {
        var n = Name[207];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function unicodebidi$0(s) {
        var n = Name[208];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function unicoderange$0(s) {
        var n = Name[209];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function unitsperem$0(s) {
        var n = Name[210];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function valphabetic$0(s) {
        var n = Name[211];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function values$0(s) {
        var n = Name[212];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function version$0(s) {
        var n = Name[213];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function vertadvy$0(s) {
        var n = Name[214];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function vertoriginx$0(s) {
        var n = Name[215];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function vertoriginy$0(s) {
        var n = Name[216];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function vhanging$0(s) {
        var n = Name[217];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function videographic$0(s) {
        var n = Name[218];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function viewbox$0(s) {
        var n = Name[219];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function viewtarget$0(s) {
        var n = Name[220];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function visibility$0(s) {
        var n = Name[221];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function vmathematical$0(s) {
        var n = Name[222];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function width$0(s) {
        var n = Name[223];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function widths$0(s) {
        var n = Name[224];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function wordspacing$0(s) {
        var n = Name[225];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function writingmode$0(s) {
        var n = Name[226];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function x$0(s) {
        var n = Name[227];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function x1$0(s) {
        var n = Name[228];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function x2$0(s) {
        var n = Name[229];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function xchannelselector$0(s) {
        var n = Name[230];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function xheight$0(s) {
        var n = Name[231];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function xlinkactuate$0(s) {
        var n = Name[232], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinkarcrole$0(s) {
        var n = Name[233], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinkhref$0(s) {
        var n = Name[234], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinkrole$0(s) {
        var n = Name[235], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinkshow$0(s) {
        var n = Name[236], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinktitle$0(s) {
        var n = Name[237], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinktype$0(s) {
        var n = Name[238], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xmlbase$0(s) {
        var n = Name[239], ns = [
            0,
            NS[2]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xmllang$0(s) {
        var n = Name[240], ns = [
            0,
            NS[2]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xmlspace$0(s) {
        var n = Name[241], ns = [
            0,
            NS[2]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function y$0(s) {
        var n = Name[242];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function y1$0(s) {
        var n = Name[243];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function y2$0(s) {
        var n = Name[244];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function ychannelselector$0(s) {
        var n = Name[245];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function z$0(s) {
        var n = Name[246];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function zoomandpan$0(s) {
        var n = Name[247];
        return [
            0,
            0,
            n,
            s
        ];
    }
    var a = "a", altglyph = "altGlyph", altglyphdef = "altGlyphDef", altglyphitem = "altGlyphItem", animate = "animate", animatecolor = "animateColor", animatemotion = "animateMotion", animatetransform = "animateTransform", circle = "circle", clippath$1 = "clipPath", colorprofile$1 = cst_color_profile, cursor$1 = cst_cursor, defs = "defs", desc = "desc", ellipse = "ellipse", feblend = "feBlend", fecolormatrix = "feColorMatrix", fecomponenttransfer = "feComponentTransfer", fecomposite = "feComposite", feconvolvematrix = "feConvolveMatrix", fediffuselighting = "feDiffuseLighting", fedisplacementmap = "feDisplacementMap", fedistantlight = "feDistantLight", feflood = "feFlood", fefunca = "feFuncA", fefuncb = "feFuncB", fefuncg = "feFuncG", fefuncr = "feFuncR", fegaussianblur = "feGaussianBlur", feimage = "feImage", femerge = "feMerge", femergenode = "feMergeNode", femorphology = "feMorphology", feoffset = "feOffset", fepointlight = "fePointLight", fespecularlighting = "feSpecularLighting", fespotlight = "feSpotLight", fetile = "feTile", feturbulence = "feTurbulence", filter$1 = cst_filter, font = "font", fontface = "fontFace", fontfaceformat = "fontFaceFormat", fontfacename = "fontFaceName", fontfacesrc = "fontFaceSrc", fontfaceuri = "fontFaceUri", foreignobject = "foreignObject", g = "g", glyph = "glyph", glyphref$1 = cst_glyphRef, hkern = "hkern", image = "image", line = "line", lineargradient = "linearGradient", marker = "marker", mask$1 = cst_mask, metadata = "metadata", missingglyph = "missingGlyph", mpath = "mpath", path$1 = cst_path, pattern = "pattern", polygon = "svpolygong", polyline = "polyline", radialgradient = "radialGradient", rect = "rect", script = "script", set = "set", stop = "stop", style$1 = cst_style, svg = "svg", switch$0 = "switch", symbol = "symbol", text = "text'", textpath = "textPath", title$1 = cst_title, tref = "tref", tspan = "tspan", use = "use", view = "view", vkern = "vkern", Name$0 = [
        0,
        a,
        altglyph,
        altglyphdef,
        altglyphitem,
        animate,
        animatecolor,
        animatemotion,
        animatetransform,
        circle,
        clippath$1,
        colorprofile$1,
        cursor$1,
        defs,
        desc,
        ellipse,
        feblend,
        fecolormatrix,
        fecomponenttransfer,
        fecomposite,
        feconvolvematrix,
        fediffuselighting,
        fedisplacementmap,
        fedistantlight,
        feflood,
        fefunca,
        fefuncb,
        fefuncg,
        fefuncr,
        fegaussianblur,
        feimage,
        femerge,
        femergenode,
        femorphology,
        feoffset,
        fepointlight,
        fespecularlighting,
        fespotlight,
        fetile,
        feturbulence,
        filter$1,
        font,
        fontface,
        fontfaceformat,
        fontfacename,
        fontfacesrc,
        fontfaceuri,
        foreignobject,
        g,
        glyph,
        glyphref$1,
        hkern,
        image,
        line,
        lineargradient,
        marker,
        mask$1,
        metadata,
        missingglyph,
        mpath,
        path$1,
        pattern,
        polygon,
        polyline,
        radialgradient,
        rect,
        script,
        set,
        stop,
        style$1,
        svg,
        switch$0,
        symbol,
        text,
        textpath,
        title$1,
        tref,
        tspan,
        use,
        view,
        vkern
    ], global_document = Jv[12]["document"];
    function v$0(_a_, opt, name, cs) {
        var d = _a_ ? _a_[1] : global_document, at = opt ? opt[1] : 0, e = d.createElementNS("http://www.w3.org/2000/svg", name);
        caml_call2(Stdlib_List[18], function(param) {
            var v = param[3], a = param[2], ns = param[1];
            return caml_call2(Jstr[28], a, Name[21]) ? caml_call1(Jstr[24], v) ? 0 : (e["classList"].add(v), 0) : (e.setAttributeNS(caml_call3(Jv[11], Jv[5], function(_b_) {
                return _b_;
            }, ns), a, v), 0);
        }, at);
        caml_call2(Stdlib_List[18], function(n) {
            e.appendChild(n);
            return 0;
        }, cs);
        return e;
    }
    function txt(opt, s) {
        var d = opt ? opt[1] : global_document;
        return d.createTextNode(s);
    }
    function txt$0(opt, s) {
        var d = opt ? opt[1] : global_document;
        return d.createTextNode(caml_call1(Jv[24], s));
    }
    var name$1 = Name$0[1];
    function a$0(d, at, cs) {
        return v$0(d, at, name$1, cs);
    }
    var name$2 = Name$0[2];
    function altglyph$0(d, at, cs) {
        return v$0(d, at, name$2, cs);
    }
    var name$3 = Name$0[3];
    function altglyphdef$0(d, at, cs) {
        return v$0(d, at, name$3, cs);
    }
    var name$4 = Name$0[4];
    function altglyphitem$0(d, at, cs) {
        return v$0(d, at, name$4, cs);
    }
    var name$5 = Name$0[5];
    function animate$0(d, at, cs) {
        return v$0(d, at, name$5, cs);
    }
    var name$6 = Name$0[6];
    function animatecolor$0(d, at, cs) {
        return v$0(d, at, name$6, cs);
    }
    var name$7 = Name$0[7];
    function animatemotion$0(d, at, cs) {
        return v$0(d, at, name$7, cs);
    }
    var name$8 = Name$0[8];
    function animatetransform$0(d, at, cs) {
        return v$0(d, at, name$8, cs);
    }
    var name$9 = Name$0[9];
    function circle$0(d, at, cs) {
        return v$0(d, at, name$9, cs);
    }
    var name$10 = Name$0[10];
    function clippath$2(d, at, cs) {
        return v$0(d, at, name$10, cs);
    }
    var name$11 = Name$0[11];
    function colorprofile$2(d, at, cs) {
        return v$0(d, at, name$11, cs);
    }
    var name$12 = Name$0[12];
    function cursor$2(d, at, cs) {
        return v$0(d, at, name$12, cs);
    }
    var name$13 = Name$0[13];
    function defs$0(d, at, cs) {
        return v$0(d, at, name$13, cs);
    }
    var name$14 = Name$0[14];
    function desc$0(d, at, cs) {
        return v$0(d, at, name$14, cs);
    }
    var name$15 = Name$0[15];
    function ellipse$0(d, at, cs) {
        return v$0(d, at, name$15, cs);
    }
    var name$16 = Name$0[16];
    function feblend$0(d, at, cs) {
        return v$0(d, at, name$16, cs);
    }
    var name$17 = Name$0[17];
    function fecolormatrix$0(d, at, cs) {
        return v$0(d, at, name$17, cs);
    }
    var name$18 = Name$0[18];
    function fecomponenttransfer$0(d, at, cs) {
        return v$0(d, at, name$18, cs);
    }
    var name$19 = Name$0[19];
    function fecomposite$0(d, at, cs) {
        return v$0(d, at, name$19, cs);
    }
    var name$20 = Name$0[20];
    function feconvolvematrix$0(d, at, cs) {
        return v$0(d, at, name$20, cs);
    }
    var name$21 = Name$0[21];
    function fediffuselighting$0(d, at, cs) {
        return v$0(d, at, name$21, cs);
    }
    var name$22 = Name$0[22];
    function fedisplacementmap$0(d, at, cs) {
        return v$0(d, at, name$22, cs);
    }
    var name$23 = Name$0[23];
    function fedistantlight$0(d, at, cs) {
        return v$0(d, at, name$23, cs);
    }
    var name$24 = Name$0[24];
    function feflood$0(d, at, cs) {
        return v$0(d, at, name$24, cs);
    }
    var name$25 = Name$0[25];
    function fefunca$0(d, at, cs) {
        return v$0(d, at, name$25, cs);
    }
    var name$26 = Name$0[26];
    function fefuncb$0(d, at, cs) {
        return v$0(d, at, name$26, cs);
    }
    var name$27 = Name$0[27];
    function fefuncg$0(d, at, cs) {
        return v$0(d, at, name$27, cs);
    }
    var name$28 = Name$0[28];
    function fefuncr$0(d, at, cs) {
        return v$0(d, at, name$28, cs);
    }
    var name$29 = Name$0[29];
    function fegaussianblur$0(d, at, cs) {
        return v$0(d, at, name$29, cs);
    }
    var name$30 = Name$0[30];
    function feimage$0(d, at, cs) {
        return v$0(d, at, name$30, cs);
    }
    var name$31 = Name$0[31];
    function femerge$0(d, at, cs) {
        return v$0(d, at, name$31, cs);
    }
    var name$32 = Name$0[32];
    function femergenode$0(d, at, cs) {
        return v$0(d, at, name$32, cs);
    }
    var name$33 = Name$0[33];
    function femorphology$0(d, at, cs) {
        return v$0(d, at, name$33, cs);
    }
    var name$34 = Name$0[34];
    function feoffset$0(d, at, cs) {
        return v$0(d, at, name$34, cs);
    }
    var name$35 = Name$0[35];
    function fepointlight$0(d, at, cs) {
        return v$0(d, at, name$35, cs);
    }
    var name$36 = Name$0[36];
    function fespecularlighting$0(d, at, cs) {
        return v$0(d, at, name$36, cs);
    }
    var name$37 = Name$0[37];
    function fespotlight$0(d, at, cs) {
        return v$0(d, at, name$37, cs);
    }
    var name$38 = Name$0[38];
    function fetile$0(d, at, cs) {
        return v$0(d, at, name$38, cs);
    }
    var name$39 = Name$0[39];
    function feturbulence$0(d, at, cs) {
        return v$0(d, at, name$39, cs);
    }
    var name$40 = Name$0[40];
    function filter$2(d, at, cs) {
        return v$0(d, at, name$40, cs);
    }
    var name$41 = Name$0[41];
    function font$0(d, at, cs) {
        return v$0(d, at, name$41, cs);
    }
    var name$42 = Name$0[42];
    function fontface$0(d, at, cs) {
        return v$0(d, at, name$42, cs);
    }
    var name$43 = Name$0[43];
    function fontfaceformat$0(d, at, cs) {
        return v$0(d, at, name$43, cs);
    }
    var name$44 = Name$0[44];
    function fontfacename$0(d, at, cs) {
        return v$0(d, at, name$44, cs);
    }
    var name$45 = Name$0[45];
    function fontfacesrc$0(d, at, cs) {
        return v$0(d, at, name$45, cs);
    }
    var name$46 = Name$0[46];
    function fontfaceuri$0(d, at, cs) {
        return v$0(d, at, name$46, cs);
    }
    var name$47 = Name$0[47];
    function foreignobject$0(d, at, cs) {
        return v$0(d, at, name$47, cs);
    }
    var name$48 = Name$0[48];
    function g$0(d, at, cs) {
        return v$0(d, at, name$48, cs);
    }
    var name$49 = Name$0[49];
    function glyph$0(d, at, cs) {
        return v$0(d, at, name$49, cs);
    }
    var name$50 = Name$0[50];
    function glyphref$2(d, at, cs) {
        return v$0(d, at, name$50, cs);
    }
    var name$51 = Name$0[51];
    function hkern$0(d, at, cs) {
        return v$0(d, at, name$51, cs);
    }
    var name$52 = Name$0[52];
    function image$0(d, at, cs) {
        return v$0(d, at, name$52, cs);
    }
    var name$53 = Name$0[53];
    function line$0(d, at, cs) {
        return v$0(d, at, name$53, cs);
    }
    var name$54 = Name$0[54];
    function lineargradient$0(d, at, cs) {
        return v$0(d, at, name$54, cs);
    }
    var name$55 = Name$0[55];
    function marker$0(d, at, cs) {
        return v$0(d, at, name$55, cs);
    }
    var name$56 = Name$0[56];
    function mask$2(d, at, cs) {
        return v$0(d, at, name$56, cs);
    }
    var name$57 = Name$0[57];
    function metadata$0(d, at, cs) {
        return v$0(d, at, name$57, cs);
    }
    var name$58 = Name$0[58];
    function missingglyph$0(d, at, cs) {
        return v$0(d, at, name$58, cs);
    }
    var name$59 = Name$0[59];
    function mpath$0(d, at, cs) {
        return v$0(d, at, name$59, cs);
    }
    var name$60 = Name$0[60];
    function path$2(d, at, cs) {
        return v$0(d, at, name$60, cs);
    }
    var name$61 = Name$0[61];
    function pattern$0(d, at, cs) {
        return v$0(d, at, name$61, cs);
    }
    var name$62 = Name$0[62];
    function polygon$0(d, at, cs) {
        return v$0(d, at, name$62, cs);
    }
    var name$63 = Name$0[63];
    function polyline$0(d, at, cs) {
        return v$0(d, at, name$63, cs);
    }
    var name$64 = Name$0[64];
    function radialgradient$0(d, at, cs) {
        return v$0(d, at, name$64, cs);
    }
    var name$65 = Name$0[65];
    function rect$0(d, at, cs) {
        return v$0(d, at, name$65, cs);
    }
    var name$66 = Name$0[66];
    function script$0(d, at, cs) {
        return v$0(d, at, name$66, cs);
    }
    var name$67 = Name$0[67];
    function set$0(d, at, cs) {
        return v$0(d, at, name$67, cs);
    }
    var name$68 = Name$0[68];
    function stop$0(d, at, cs) {
        return v$0(d, at, name$68, cs);
    }
    var name$69 = Name$0[69];
    function style$2(d, at, cs) {
        return v$0(d, at, name$69, cs);
    }
    var name$70 = Name$0[70];
    function svg$0(d, at, cs) {
        return v$0(d, at, name$70, cs);
    }
    var name$71 = Name$0[71];
    function switch$1(d, at, cs) {
        return v$0(d, at, name$71, cs);
    }
    var name$72 = Name$0[72];
    function symbol$0(d, at, cs) {
        return v$0(d, at, name$72, cs);
    }
    var name$73 = Name$0[73];
    function text$0(d, at, cs) {
        return v$0(d, at, name$73, cs);
    }
    var name$74 = Name$0[74];
    function textpath$0(d, at, cs) {
        return v$0(d, at, name$74, cs);
    }
    var name$75 = Name$0[75];
    function title$2(d, at, cs) {
        return v$0(d, at, name$75, cs);
    }
    var name$76 = Name$0[76];
    function tref$0(d, at, cs) {
        return v$0(d, at, name$76, cs);
    }
    var name$77 = Name$0[77];
    function tspan$0(d, at, cs) {
        return v$0(d, at, name$77, cs);
    }
    var name$78 = Name$0[78];
    function use$0(d, at, cs) {
        return v$0(d, at, name$78, cs);
    }
    var name$79 = Name$0[79];
    function view$0(d, at, cs) {
        return v$0(d, at, name$79, cs);
    }
    var name$80 = Name$0[80];
    function vkern$0(d, at, cs) {
        return v$0(d, at, name$80, cs);
    }
    var Brr_svg = [
        0,
        NS,
        [
            0,
            v,
            Name,
            accentheight$0,
            accumulate$0,
            additive$0,
            alignmentbaseline$0,
            alphabetic$0,
            amplitude$0,
            arabicform$0,
            ascent$0,
            attributename$0,
            attributetype$0,
            azimuth$0,
            basefrequency$0,
            baselineshift$0,
            baseprofile$0,
            bbox$0,
            begin$0,
            bias$0,
            by$0,
            calcmode$0,
            capheight$0,
            class$1,
            clip$0,
            clippath$0,
            clippathunits$0,
            cliprule$0,
            color$0,
            colorinterpolation$0,
            colorinterpolationfilters$0,
            colorprofile$0,
            colorrendering$0,
            contentscripttype$0,
            contentstyletype$0,
            cursor$0,
            cx$0,
            cy$0,
            d$0,
            descent$0,
            diffuseconstant$0,
            direction$0,
            display$0,
            divisor$0,
            dominantbaseline$0,
            dur$0,
            dx$0,
            dy$0,
            edgemode$0,
            elevation$0,
            enablebackground$0,
            end$0,
            exponent$0,
            externalresourcesrequired$0,
            fill$0,
            fillopacity$0,
            fillrule$0,
            filter$0,
            filterres$0,
            filterunits$0,
            floodcolor$0,
            floodopacity$0,
            fontfamily$0,
            fontsize$0,
            fontsizeadjust$0,
            fontstretch$0,
            fontstyle$0,
            fontvariant$0,
            fontweight$0,
            format$0,
            from$0,
            fx$0,
            fy$0,
            g1$0,
            g2$0,
            glyphname$0,
            glyphorientationhorizontal$0,
            glyphorientationvertical$0,
            glyphref$0,
            gradienttransform$0,
            gradientunits$0,
            hanging$0,
            height$0,
            horizadvx$0,
            horizoriginx$0,
            horizoriginy$0,
            id$0,
            ideographic$0,
            imagerendering$0,
            in$1,
            in2$0,
            intercept$0,
            k$0,
            k1$0,
            k2$0,
            k3$0,
            k4$0,
            kernelmatrix$0,
            kernelunitlength$0,
            kerning$0,
            keypoints$0,
            keysplines$0,
            keyTimes$0,
            lang$0,
            lengthadjust$0,
            letterspacing$0,
            lightingcolor$0,
            limitingconeangle$0,
            local$0,
            markerend$0,
            markerheight$0,
            markermid$0,
            markerstart$0,
            markerunits$0,
            markerwidth$0,
            mask$0,
            maskcontentunits$0,
            maskunits$0,
            mathematical$0,
            max$0,
            media$0,
            method$0,
            min$0,
            mode$0,
            name$0,
            numoctaves$0,
            offset$0,
            opacity$0,
            operator$0,
            order$0,
            orient$0,
            orientation$0,
            origin$0,
            overflow$0,
            overlineposition$0,
            overlinethickness$0,
            panose1$0,
            path$0,
            pathlength$0,
            patterncontentunits$0,
            patterntransform$0,
            patternunits$0,
            pointerevents$0,
            points$0,
            pointsatx$0,
            pointsaty$0,
            pointsatz$0,
            preservealpha$0,
            preserveaspectratio$0,
            primitiveunits$0,
            r$0,
            radius$0,
            refx$0,
            refy$0,
            renderingintent$0,
            repeatcount$0,
            repeatdur$0,
            requiredextensions$0,
            requiredfeatures$0,
            restart$0,
            result$0,
            rotate$0,
            rx$0,
            ry$0,
            scale$0,
            seed$0,
            shaperendering$0,
            slope$0,
            spacing$0,
            specularconstant$0,
            specularexponent$0,
            spreadmethod$0,
            startoffset$0,
            stddeviation$0,
            stemh$0,
            stemv$0,
            stitchtiles$0,
            stopcolor$0,
            stopopacity$0,
            strikethroughposition$0,
            strikethroughthickness$0,
            string$0,
            stroke$0,
            strokedasharray$0,
            strokedashoffset$0,
            strokelinecap$0,
            strokelinejoin$0,
            strokemiterlimit$0,
            strokeopacity$0,
            strokewidth$0,
            style$0,
            surfacescale$0,
            systemlanguage$0,
            tablevalues$0,
            target$0,
            targetx$0,
            targety$0,
            textanchor$0,
            textdecoration$0,
            textlength$0,
            textrendering$0,
            title$0,
            to$0,
            transform$0,
            type$0,
            u1$0,
            u2$0,
            underlineposition$0,
            underlinethickness$0,
            unicode$0,
            unicodebidi$0,
            unicoderange$0,
            unitsperem$0,
            valphabetic$0,
            values$0,
            version$0,
            vertadvy$0,
            vertoriginx$0,
            vertoriginy$0,
            vhanging$0,
            videographic$0,
            viewbox$0,
            viewtarget$0,
            visibility$0,
            vmathematical$0,
            width$0,
            widths$0,
            wordspacing$0,
            writingmode$0,
            x$0,
            x1$0,
            x2$0,
            xchannelselector$0,
            xheight$0,
            xlinkactuate$0,
            xlinkarcrole$0,
            xlinkhref$0,
            xlinkrole$0,
            xlinkshow$0,
            xlinktitle$0,
            xlinktype$0,
            xmlbase$0,
            xmllang$0,
            xmlspace$0,
            y$0,
            y1$0,
            y2$0,
            ychannelselector$0,
            z$0,
            zoomandpan$0
        ],
        [
            0,
            v$0,
            Name$0,
            txt,
            txt$0,
            a$0,
            altglyph$0,
            altglyphdef$0,
            altglyphitem$0,
            animate$0,
            animatecolor$0,
            animatemotion$0,
            animatetransform$0,
            circle$0,
            clippath$2,
            colorprofile$2,
            cursor$2,
            defs$0,
            desc$0,
            ellipse$0,
            feblend$0,
            fecolormatrix$0,
            fecomponenttransfer$0,
            fecomposite$0,
            feconvolvematrix$0,
            fediffuselighting$0,
            fedisplacementmap$0,
            fedistantlight$0,
            feflood$0,
            fefunca$0,
            fefuncb$0,
            fefuncg$0,
            fefuncr$0,
            fegaussianblur$0,
            feimage$0,
            femerge$0,
            femergenode$0,
            femorphology$0,
            feoffset$0,
            fepointlight$0,
            fespecularlighting$0,
            fespotlight$0,
            fetile$0,
            feturbulence$0,
            filter$2,
            font$0,
            fontface$0,
            fontfaceformat$0,
            fontfacename$0,
            fontfacesrc$0,
            fontfaceuri$0,
            foreignobject$0,
            g$0,
            glyph$0,
            glyphref$2,
            hkern$0,
            image$0,
            line$0,
            lineargradient$0,
            marker$0,
            mask$2,
            metadata$0,
            missingglyph$0,
            mpath$0,
            path$2,
            pattern$0,
            polygon$0,
            polyline$0,
            radialgradient$0,
            rect$0,
            script$0,
            set$0,
            stop$0,
            style$2,
            svg$0,
            switch$1,
            symbol$0,
            text$0,
            textpath$0,
            title$2,
            tref$0,
            tspan$0,
            use$0,
            view$0,
            vkern$0
        ]
    ];
    runtime.caml_register_global(341, Brr_svg, "Brr_svg");
    return;
})(globalThis);
//# 1 "../.js/default/fmt/fmt.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/fmt/fmt.cma.js"
//# 6 "../.js/default/fmt/fmt.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$20 = "", cst_02x = "%02x", cst_Ld_s = "%Ld%s", cst_Ld_Ld_s = "%Ld.%Ld%s", cst_Lda = "%Lda", cst_d_s_s = "%d%s%s", cst_d_d_s_s = "%d.%d%s%s", cst_g = "%g", cst_0$0 = "0", cst_30$1 = "30", cst_31$1 = "31", cst_32$1 = "32", cst_33$1 = "33", cst_34$1 = "34", cst_35$1 = "35", cst_36$1 = "36", cst_37$1 = "37", cst$19 = ";", cst_1$0 = "<1>", cst_2$0 = "<2>", cst_v = "<v>", cst$18 = "@ ", cst$21 = "@,", cst_A$0 = "A", cst_N$0 = "N", cst_None = "None", cst_Unknown = "Unknown", cst_f$0 = "f", cst_h$1 = "h", cst_hashtbl = "hashtbl", cst_m$0 = "m", cst_min$1 = "min", cst_ok$0 = "ok", cst_queue = "queue", cst_s$1 = "s", cst_src_fmt_ml = "src/fmt.ml", cst_stack = "stack", cst_t$0 = "t", caml_check_bound = runtime.caml_check_bound, caml_div = runtime.caml_div, caml_fresh_oo_id = runtime.caml_fresh_oo_id, caml_int64_add = runtime.caml_int64_add, caml_int64_div = runtime.caml_int64_div, caml_int64_mul = runtime.caml_int64_mul, caml_int64_sub = runtime.caml_int64_sub, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_mod = runtime.caml_mod, caml_mul = runtime.caml_mul, caml_notequal = runtime.caml_notequal, caml_string_get = runtime.caml_string_get, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    function caml_call8(f, a0, a1, a2, a3, a4, a5, a6, a7) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 8 ? f(a0, a1, a2, a3, a4, a5, a6, a7) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7
        ]);
    }
    function caml_call9(f, a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 9 ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7,
            a8
        ]);
    }
    function caml_call11(f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 11 ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7,
            a8,
            a9,
            a10
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst_us = "us", cst_ms = "ms", cst_s = cst_s$1, _ap_ = runtime.caml_int64_create_lo_mi_hi(60, 0, 0), cst_s$0 = cst_s$1, cst_min = cst_min$1, _aq_ = runtime.caml_int64_create_lo_mi_hi(60, 0, 0), cst_min$0 = cst_min$1, cst_h = cst_h$1, _ar_ = runtime.caml_int64_create_lo_mi_hi(24, 0, 0), cst_h$0 = cst_h$1, cst_d = "d", y = runtime.caml_int64_create_lo_mi_hi(366, 0, 0), fmt$13 = [
        0,
        [
            12,
            58,
            [
                17,
                [
                    0,
                    cst$18,
                    1,
                    0
                ],
                0
            ]
        ],
        ":@ "
    ], zero = cst_0$0, cst$17 = cst$19, cst$16 = "\x1b[", cst$15 = cst$20, fmt$12 = [
        0,
        [
            11,
            cst_Unknown,
            0
        ],
        cst_Unknown
    ], partial = [
        15,
        [
            11,
            " ?",
            [
                17,
                0,
                0
            ]
        ]
    ], cst$14 = "...", cst$13 = cst$20, cst$12 = ": ", fmt$11 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                8
            ],
            0,
            0
        ],
        "%08x"
    ], kstr$0 = "K", i = "i", fmt$3 = [
        0,
        [
            12,
            59,
            [
                17,
                [
                    0,
                    cst$21,
                    0,
                    0
                ],
                0
            ]
        ],
        ";@,"
    ], cst$10 = " }", cst$11 = "{ ", fmt$2 = [
        0,
        [
            11,
            cst_queue,
            0
        ],
        cst_queue
    ], fmt$1 = [
        0,
        [
            11,
            cst_stack,
            0
        ],
        cst_stack
    ], fmt$0 = [
        0,
        [
            11,
            cst_hashtbl,
            0
        ],
        cst_hashtbl
    ], cst$9 = '"', cst$7 = "}", cst$8 = "{", cst$5 = "|]", cst$6 = "[|", cst$3 = "]", cst$4 = "[", cst$1 = ")", cst$2 = "(", cst$0 = cst$19, cst = ",", us_span = runtime.caml_int64_create_lo_mi_hi(1000, 0, 0), ms_span = runtime.caml_int64_create_lo_mi_hi(1000000, 0, 0), sec_span = runtime.caml_int64_create_lo_mi_hi(10144256, 59, 0), min_span = runtime.caml_int64_create_lo_mi_hi(4675584, 3576, 0), hour_span = runtime.caml_int64_create_lo_mi_hi(12099584, 214576, 0), day_span = runtime.caml_int64_create_lo_mi_hi(5177344, 5149841, 0), year_span = runtime.caml_int64_create_lo_mi_hi(16171008, 1931345, 112), fmt$4 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                7
            ],
            0,
            0
        ],
        "%07x"
    ], fmt$5 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                6
            ],
            0,
            0
        ],
        "%06x"
    ], fmt$6 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                5
            ],
            0,
            0
        ],
        "%05x"
    ], fmt$7 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                4
            ],
            0,
            0
        ],
        "%04x"
    ], fmt$8 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                3
            ],
            0,
            0
        ],
        "%03x"
    ], fmt$9 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                2
            ],
            0,
            0
        ],
        cst_02x
    ], fmt$10 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                1
            ],
            0,
            0
        ],
        "%01x"
    ], Stdlib_Int64 = global_data.Stdlib__Int64, Stdlib_String = global_data.Stdlib__String, Stdlib_Fun = global_data.Stdlib__Fun, Stdlib_Format = global_data.Stdlib__Format, Stdlib_Buffer = global_data.Stdlib__Buffer, Assert_failure = global_data.Assert_failure, Stdlib_Option = global_data.Stdlib__Option, Stdlib_List = global_data.Stdlib__List, Stdlib = global_data.Stdlib, Stdlib_Queue = global_data.Stdlib__Queue, Stdlib_Stack = global_data.Stdlib__Stack, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Stdlib_Uchar = global_data.Stdlib__Uchar, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Printexc = global_data.Stdlib__Printexc, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Map = global_data.Stdlib__Map, stdout = Stdlib_Format[112], stderr = Stdlib_Format[114], pf = Stdlib_Format[139], pr = Stdlib_Format[140], epr = Stdlib_Format[141], str = Stdlib_Format[143], kpf = Stdlib_Format[146], kstr = Stdlib_Format[150], _a_ = [
        0,
        1
    ], _b_ = [
        0,
        1
    ], _d_ = [
        0,
        1
    ], _e_ = [
        0,
        1
    ];
    function failwith(fmt) {
        return caml_call2(kstr, Stdlib[2], fmt);
    }
    function failwith_notrace(fmt) {
        return caml_call2(kstr, function(s) {
            throw [
                0,
                Stdlib[7],
                s
            ];
        }, fmt);
    }
    function invalid_arg(fmt) {
        return caml_call2(kstr, Stdlib[1], fmt);
    }
    function error(fmt) {
        return caml_call2(kstr, function(s) {
            return [
                1,
                s
            ];
        }, fmt);
    }
    function error_msg(fmt) {
        return caml_call2(kstr, function(s) {
            return [
                1,
                [
                    0,
                    3854881,
                    s
                ]
            ];
        }, fmt);
    }
    function flush(ppf, param) {
        return caml_call2(Stdlib_Format[39], ppf, 0);
    }
    function nop(fmt, ppf) {
        return 0;
    }
    function any(fmt, ppf, param) {
        return caml_call2(pf, ppf, fmt);
    }
    function using(f, pp, ppf, v) {
        return caml_call2(pp, ppf, caml_call1(f, v));
    }
    function const$0(pp_v, v, ppf, param) {
        return caml_call2(pp_v, ppf, v);
    }
    function fmt(fmt, ppf) {
        return caml_call2(pf, ppf, fmt);
    }
    function cut(ppf, param) {
        return caml_call2(Stdlib_Format[30], ppf, 0);
    }
    function sp(ppf, param) {
        return caml_call2(Stdlib_Format[28], ppf, 0);
    }
    function sps(n, ppf, param) {
        return caml_call3(Stdlib_Format[32], ppf, n, 0);
    }
    function comma(ppf, param) {
        caml_call2(Stdlib_Format[13], ppf, cst);
        return sp(ppf, 0);
    }
    function semi(ppf, param) {
        caml_call2(Stdlib_Format[13], ppf, cst$0);
        return sp(ppf, 0);
    }
    function iter(opt, iter, pp_elt, ppf, v) {
        var pp_sep = opt ? opt[1] : cut, is_first = [
            0,
            1
        ];
        function pp_elt$0(v) {
            if (is_first[1]) is_first[1] = 0;
            else caml_call2(pp_sep, ppf, 0);
            return caml_call2(pp_elt, ppf, v);
        }
        return caml_call2(iter, pp_elt$0, v);
    }
    function iter_bindings(opt, iter, pp_binding, ppf, v) {
        var pp_sep = opt ? opt[1] : cut, is_first = [
            0,
            1
        ];
        function pp_binding$0(k, v) {
            if (is_first[1]) is_first[1] = 0;
            else caml_call2(pp_sep, ppf, 0);
            return caml_call2(pp_binding, ppf, [
                0,
                k,
                v
            ]);
        }
        return caml_call2(iter, pp_binding$0, v);
    }
    function append(pp_v0, pp_v1, ppf, v) {
        caml_call2(pp_v0, ppf, v);
        return caml_call2(pp_v1, ppf, v);
    }
    function concat(sep, pps, ppf, v) {
        return iter(sep, Stdlib_List[18], function(ppf, pp) {
            return caml_call2(pp, ppf, v);
        }, ppf, pps);
    }
    function box(opt, pp_v, ppf, v) {
        var indent = opt ? opt[1] : 0;
        caml_call2(Stdlib_Format[1], ppf, indent);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[3], ppf, 0);
    }
    function hbox(pp_v, ppf, v) {
        caml_call2(Stdlib_Format[5], ppf, 0);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[3], ppf, 0);
    }
    function vbox(opt, pp_v, ppf, v) {
        var indent = opt ? opt[1] : 0;
        caml_call2(Stdlib_Format[7], ppf, indent);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[3], ppf, 0);
    }
    function hvbox(opt, pp_v, ppf, v) {
        var indent = opt ? opt[1] : 0;
        caml_call2(Stdlib_Format[9], ppf, indent);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[3], ppf, 0);
    }
    function hovbox(opt, pp_v, ppf, v) {
        var indent = opt ? opt[1] : 0;
        caml_call2(Stdlib_Format[11], ppf, indent);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[3], ppf, 0);
    }
    function surround(s1, s2, pp_v, ppf, v) {
        caml_call2(Stdlib_Format[13], ppf, s1);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[13], ppf, s2);
    }
    function parens(pp_v) {
        function _dG_(_dJ_, _dK_) {
            return surround(cst$2, cst$1, pp_v, _dJ_, _dK_);
        }
        return function(_dH_, _dI_) {
            return box(_a_, _dG_, _dH_, _dI_);
        };
    }
    function brackets(pp_v) {
        function _dB_(_dE_, _dF_) {
            return surround(cst$4, cst$3, pp_v, _dE_, _dF_);
        }
        return function(_dC_, _dD_) {
            return box(_b_, _dB_, _dC_, _dD_);
        };
    }
    function braces(pp_v) {
        function _dw_(_dz_, _dA_) {
            return surround(cst$8, cst$7, pp_v, _dz_, _dA_);
        }
        return function(_dx_, _dy_) {
            return box(_d_, _dw_, _dx_, _dy_);
        };
    }
    function quote(opt, pp_v) {
        var mark = opt ? opt[1] : cst$9;
        function pp_mark(ppf, param) {
            return caml_call3(Stdlib_Format[17], ppf, 1, mark);
        }
        function _do_(_du_, _dv_) {
            return append(pp_mark, pp_v, _du_, _dv_);
        }
        function _dp_(_ds_, _dt_) {
            return append(_do_, pp_mark, _ds_, _dt_);
        }
        return function(_dq_, _dr_) {
            return box(_e_, _dp_, _dq_, _dr_);
        };
    }
    var bool = Stdlib_Format[25], int$0 = Stdlib_Format[19], _f_ = [
        0,
        [
            6,
            0,
            0,
            0,
            0
        ],
        "%nd"
    ], _g_ = [
        0,
        [
            5,
            0,
            0,
            0,
            0
        ],
        "%ld"
    ], _h_ = [
        0,
        [
            7,
            0,
            0,
            0,
            0
        ],
        "%Ld"
    ], _i_ = [
        0,
        [
            4,
            12,
            0,
            0,
            0
        ],
        "%u"
    ], _j_ = [
        0,
        [
            5,
            12,
            0,
            0,
            0
        ],
        "%lu"
    ], _k_ = [
        0,
        [
            7,
            12,
            0,
            0,
            0
        ],
        "%Lu"
    ], _l_ = [
        0,
        [
            6,
            12,
            0,
            0,
            0
        ],
        "%nu"
    ];
    function nativeint(ppf, v) {
        return caml_call3(pf, ppf, _f_, v);
    }
    function int32(ppf, v) {
        return caml_call3(pf, ppf, _g_, v);
    }
    function int64(ppf, v) {
        return caml_call3(pf, ppf, _h_, v);
    }
    function uint(ppf, v) {
        return caml_call3(pf, ppf, _i_, v);
    }
    function uint32(ppf, v) {
        return caml_call3(pf, ppf, _j_, v);
    }
    function uint64(ppf, v) {
        return caml_call3(pf, ppf, _k_, v);
    }
    function unativeint(ppf, v) {
        return caml_call3(pf, ppf, _l_, v);
    }
    var char$0 = Stdlib_Format[23], string = Stdlib_Format[13], cst_No_backtrace_available = "No backtrace available.", _m_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_v,
                        0
                    ],
                    cst_v
                ]
            ],
            [
                11,
                "Exception: ",
                [
                    15,
                    [
                        17,
                        [
                            0,
                            cst$21,
                            0,
                            0
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<v>Exception: %a@,%a@]"
    ], _n_ = [
        0,
        [
            8,
            [
                0,
                0,
                3
            ],
            0,
            0,
            0
        ],
        cst_g
    ], _o_ = [
        0,
        [
            8,
            [
                0,
                0,
                3
            ],
            0,
            0,
            0
        ],
        cst_g
    ], _p_ = [
        0,
        [
            8,
            [
                0,
                0,
                3
            ],
            0,
            0,
            0
        ],
        cst_g
    ];
    function buffer(ppf, b) {
        return caml_call2(string, ppf, caml_call1(Stdlib_Buffer[2], b));
    }
    function exn(ppf, e) {
        return caml_call2(string, ppf, caml_call1(Stdlib_Printexc[1], e));
    }
    function exn_backtrace(ppf, param) {
        var bt = param[2], e = param[1];
        function pp_backtrace_str(ppf, s) {
            var stop = caml_ml_string_length(s) - 1 | 0;
            if (s == cst$20) return caml_call2(string, ppf, cst_No_backtrace_available);
            var left = 0, right = 0;
            for(;;){
                if (right === stop) return caml_call2(string, ppf, caml_call3(Stdlib_String[16], s, left, right - left | 0));
                if (10 === caml_string_get(s, right)) {
                    caml_call2(string, ppf, caml_call3(Stdlib_String[16], s, left, right - left | 0));
                    cut(ppf, 0);
                    var right$0 = right + 1 | 0, left$0 = right + 1 | 0;
                    left = left$0;
                    right = right$0;
                } else {
                    var right$1 = right + 1 | 0;
                    right = right$1;
                }
            }
        }
        return caml_call6(pf, ppf, _m_, exn, e, pp_backtrace_str, caml_call1(Stdlib_Printexc[14], bt));
    }
    function float$0(ppf, v) {
        return caml_call3(pf, ppf, _n_, v);
    }
    function round_dfrac(d, x) {
        if (x - Math.floor(x + 0.5) == 0.) return x;
        var m = Math.pow(10., d);
        return Math.floor(x * m + 0.5) / m;
    }
    function float_dfrac(d, ppf, f) {
        return caml_call3(pf, ppf, _o_, round_dfrac(d, f));
    }
    function float_dsig(d, ppf, f) {
        if (f == 0.) var _dn_ = 0.;
        else var m = Math.pow(10., Math.floor(runtime.caml_log10_float(Math.abs(f)))), _dn_ = round_dfrac(d, f / m) * m;
        return caml_call3(pf, ppf, _p_, _dn_);
    }
    function pair(opt, pp_fst, pp_snd, ppf, param) {
        var pp_sep = opt ? opt[1] : cut, snd = param[2], fst = param[1];
        caml_call2(pp_fst, ppf, fst);
        caml_call2(pp_sep, ppf, 0);
        return caml_call2(pp_snd, ppf, snd);
    }
    function option(opt, pp_v, ppf, param) {
        var pp_none = opt ? opt[1] : nop;
        if (!param) return caml_call2(pp_none, ppf, 0);
        var v = param[1];
        return caml_call2(pp_v, ppf, v);
    }
    function result(ok, error, ppf, param) {
        if (0 === param[0]) {
            var v = param[1];
            return caml_call2(ok, ppf, v);
        }
        var e = param[1];
        return caml_call2(error, ppf, e);
    }
    function list(sep, pp_elt) {
        var _dk_ = Stdlib_List[18];
        return function(_dl_, _dm_) {
            return iter(sep, _dk_, pp_elt, _dl_, _dm_);
        };
    }
    function array(sep, pp_elt) {
        var _dh_ = Stdlib_Array[12];
        return function(_di_, _dj_) {
            return iter(sep, _dh_, pp_elt, _di_, _dj_);
        };
    }
    function seq(sep, pp_elt) {
        var _de_ = Stdlib_Seq[4];
        return function(_df_, _dg_) {
            return iter(sep, _de_, pp_elt, _df_, _dg_);
        };
    }
    function hashtbl(sep, pp_binding) {
        var _db_ = Stdlib_Hashtbl[12];
        return function(_dc_, _dd_) {
            return iter_bindings(sep, _db_, pp_binding, _dc_, _dd_);
        };
    }
    function queue(sep, pp_elt) {
        var _c9_ = Stdlib_Queue[15], _c__ = 0;
        return function(_c$_, _da_) {
            return iter(_c__, _c9_, pp_elt, _c$_, _da_);
        };
    }
    function stack(sep, pp_elt) {
        var _c5_ = Stdlib_Stack[13], _c6_ = 0;
        return function(_c7_, _c8_) {
            return iter(_c6_, _c5_, pp_elt, _c7_, _c8_);
        };
    }
    var sig_names = [
        0,
        [
            0,
            Stdlib_Sys[16],
            "SIGABRT"
        ],
        [
            0,
            [
                0,
                Stdlib_Sys[17],
                "SIGALRM"
            ],
            [
                0,
                [
                    0,
                    Stdlib_Sys[18],
                    "SIGFPE"
                ],
                [
                    0,
                    [
                        0,
                        Stdlib_Sys[19],
                        "SIGHUP"
                    ],
                    [
                        0,
                        [
                            0,
                            Stdlib_Sys[20],
                            "SIGILL"
                        ],
                        [
                            0,
                            [
                                0,
                                Stdlib_Sys[21],
                                "SIGINT"
                            ],
                            [
                                0,
                                [
                                    0,
                                    Stdlib_Sys[22],
                                    "SIGKILL"
                                ],
                                [
                                    0,
                                    [
                                        0,
                                        Stdlib_Sys[23],
                                        "SIGPIPE"
                                    ],
                                    [
                                        0,
                                        [
                                            0,
                                            Stdlib_Sys[24],
                                            "SIGQUIT"
                                        ],
                                        [
                                            0,
                                            [
                                                0,
                                                Stdlib_Sys[25],
                                                "SIGSEGV"
                                            ],
                                            [
                                                0,
                                                [
                                                    0,
                                                    Stdlib_Sys[26],
                                                    "SIGTERM"
                                                ],
                                                [
                                                    0,
                                                    [
                                                        0,
                                                        Stdlib_Sys[27],
                                                        "SIGUSR1"
                                                    ],
                                                    [
                                                        0,
                                                        [
                                                            0,
                                                            Stdlib_Sys[28],
                                                            "SIGUSR2"
                                                        ],
                                                        [
                                                            0,
                                                            [
                                                                0,
                                                                Stdlib_Sys[29],
                                                                "SIGCHLD"
                                                            ],
                                                            [
                                                                0,
                                                                [
                                                                    0,
                                                                    Stdlib_Sys[30],
                                                                    "SIGCONT"
                                                                ],
                                                                [
                                                                    0,
                                                                    [
                                                                        0,
                                                                        Stdlib_Sys[31],
                                                                        "SIGSTOP"
                                                                    ],
                                                                    [
                                                                        0,
                                                                        [
                                                                            0,
                                                                            Stdlib_Sys[32],
                                                                            "SIGTSTP"
                                                                        ],
                                                                        [
                                                                            0,
                                                                            [
                                                                                0,
                                                                                Stdlib_Sys[33],
                                                                                "SIGTTIN"
                                                                            ],
                                                                            [
                                                                                0,
                                                                                [
                                                                                    0,
                                                                                    Stdlib_Sys[34],
                                                                                    "SIGTTOU"
                                                                                ],
                                                                                [
                                                                                    0,
                                                                                    [
                                                                                        0,
                                                                                        Stdlib_Sys[35],
                                                                                        "SIGVTALRM"
                                                                                    ],
                                                                                    [
                                                                                        0,
                                                                                        [
                                                                                            0,
                                                                                            Stdlib_Sys[36],
                                                                                            "SIGPROF"
                                                                                        ],
                                                                                        [
                                                                                            0,
                                                                                            [
                                                                                                0,
                                                                                                Stdlib_Sys[37],
                                                                                                "SIGBUS"
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                [
                                                                                                    0,
                                                                                                    Stdlib_Sys[38],
                                                                                                    "SIGPOLL"
                                                                                                ],
                                                                                                [
                                                                                                    0,
                                                                                                    [
                                                                                                        0,
                                                                                                        Stdlib_Sys[39],
                                                                                                        "SIGSYS"
                                                                                                    ],
                                                                                                    [
                                                                                                        0,
                                                                                                        [
                                                                                                            0,
                                                                                                            Stdlib_Sys[40],
                                                                                                            "SIGTRAP"
                                                                                                        ],
                                                                                                        [
                                                                                                            0,
                                                                                                            [
                                                                                                                0,
                                                                                                                Stdlib_Sys[41],
                                                                                                                "SIGURG"
                                                                                                            ],
                                                                                                            [
                                                                                                                0,
                                                                                                                [
                                                                                                                    0,
                                                                                                                    Stdlib_Sys[42],
                                                                                                                    "SIGXCPU"
                                                                                                                ],
                                                                                                                [
                                                                                                                    0,
                                                                                                                    [
                                                                                                                        0,
                                                                                                                        Stdlib_Sys[43],
                                                                                                                        "SIGXFSZ"
                                                                                                                    ],
                                                                                                                    0
                                                                                                                ]
                                                                                                            ]
                                                                                                        ]
                                                                                                    ]
                                                                                                ]
                                                                                            ]
                                                                                        ]
                                                                                    ]
                                                                                ]
                                                                            ]
                                                                        ]
                                                                    ]
                                                                ]
                                                            ]
                                                        ]
                                                    ]
                                                ]
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ], _c_ = [
        0,
        2
    ], _q_ = [
        0,
        [
            11,
            "SIG(",
            [
                4,
                0,
                0,
                0,
                [
                    12,
                    41,
                    0
                ]
            ]
        ],
        "SIG(%d)"
    ], _r_ = [
        0,
        [
            11,
            "U+",
            [
                4,
                8,
                [
                    0,
                    2,
                    4
                ],
                0,
                0
            ]
        ],
        "U+%04X"
    ], _s_ = [
        0,
        [
            3,
            0,
            0
        ],
        "%S"
    ], _t_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_2$0,
                        0
                    ],
                    cst_2$0
                ]
            ],
            [
                11,
                "Some",
                [
                    17,
                    [
                        0,
                        cst$18,
                        1,
                        0
                    ],
                    [
                        18,
                        [
                            1,
                            [
                                0,
                                0,
                                cst$20
                            ]
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                [
                                    17,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<2>Some@ @[%a@]@]"
    ], _u_ = [
        0,
        [
            11,
            cst_None,
            0
        ],
        cst_None
    ], _v_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_2$0,
                        0
                    ],
                    cst_2$0
                ]
            ],
            [
                11,
                "Ok",
                [
                    17,
                    [
                        0,
                        cst$18,
                        1,
                        0
                    ],
                    [
                        18,
                        [
                            1,
                            [
                                0,
                                0,
                                cst$20
                            ]
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                [
                                    17,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<2>Ok@ @[%a@]@]"
    ], _w_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_2$0,
                        0
                    ],
                    cst_2$0
                ]
            ],
            [
                11,
                "Error",
                [
                    17,
                    [
                        0,
                        cst$18,
                        1,
                        0
                    ],
                    [
                        18,
                        [
                            1,
                            [
                                0,
                                0,
                                cst$20
                            ]
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                [
                                    17,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<2>Error@ @[%a@]@]"
    ], _x_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_1$0,
                        0
                    ],
                    cst_1$0
                ]
            ],
            [
                15,
                [
                    11,
                    " =",
                    [
                        17,
                        [
                            0,
                            cst$18,
                            1,
                            0
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<1>%a =@ %a@]"
    ], _y_ = [
        0,
        2
    ];
    function signal(ppf, s) {
        var match = caml_call2(Stdlib_List[52], s, sig_names);
        if (!match) return caml_call3(pf, ppf, _q_, s);
        var name = match[1];
        return caml_call2(string, ppf, name);
    }
    function uchar(ppf, u) {
        return caml_call3(pf, ppf, _r_, caml_call1(Stdlib_Uchar[10], u));
    }
    function string$0(ppf, s) {
        return caml_call3(pf, ppf, _s_, s);
    }
    function pair$0(pp_fst, pp_snd) {
        var _c2_ = 0, _c3_ = 0;
        function _c4_(ppf, v) {
            return box(_c3_, pp_fst, ppf, v[1]);
        }
        return parens(function(ppf, v) {
            append(_c4_, comma, ppf, v);
            return box(_c2_, pp_snd, ppf, v[2]);
        });
    }
    function option$0(pp_v, ppf, param) {
        if (!param) return caml_call2(pf, ppf, _u_);
        var v = param[1];
        return caml_call4(pf, ppf, _t_, pp_v, v);
    }
    function result$0(ok, error, ppf, param) {
        if (0 === param[0]) {
            var v = param[1];
            return caml_call4(pf, ppf, _v_, ok, v);
        }
        var e = param[1];
        return caml_call4(pf, ppf, _w_, error, e);
    }
    function iter$0(iter_f, pp_name, pp_elt) {
        var _cX_ = 0;
        function _cY_(_c0_, _c1_) {
            return box(_cX_, pp_elt, _c0_, _c1_);
        }
        var _cZ_ = [
            0,
            sp
        ];
        return parens(function(ppf, v) {
            append(pp_name, sp, ppf, v);
            return iter(_cZ_, iter_f, _cY_, ppf, v);
        });
    }
    function iter_bindings$0(iter_f, pp_name, pp_k, pp_v) {
        var _cV_ = pair$0(pp_k, pp_v), _cW_ = [
            0,
            sp
        ];
        return parens(function(ppf, v) {
            append(pp_name, sp, ppf, v);
            return iter_bindings(_cW_, iter_f, _cV_, ppf, v);
        });
    }
    function list$0(pp_elt) {
        var _cS_ = 0;
        return brackets(list([
            0,
            semi
        ], function(_cT_, _cU_) {
            return box(_cS_, pp_elt, _cT_, _cU_);
        }));
    }
    function array$0(pp_elt) {
        var _cL_ = 0, pp_v = array([
            0,
            semi
        ], function(_cQ_, _cR_) {
            return box(_cL_, pp_elt, _cQ_, _cR_);
        });
        function _cK_(_cO_, _cP_) {
            return surround(cst$6, cst$5, pp_v, _cO_, _cP_);
        }
        return function(_cM_, _cN_) {
            return box(_c_, _cK_, _cM_, _cN_);
        };
    }
    function seq$0(pp_elt) {
        var _cH_ = 0;
        return brackets(seq([
            0,
            semi
        ], function(_cI_, _cJ_) {
            return box(_cH_, pp_elt, _cI_, _cJ_);
        }));
    }
    function hashtbl$0(pp_k, pp_v) {
        return iter_bindings$0(Stdlib_Hashtbl[12], function(ppf, _cG_) {
            return caml_call2(pf, ppf, fmt$0);
        }, pp_k, pp_v);
    }
    function stack$0(pp_elt) {
        return iter$0(Stdlib_Stack[13], function(ppf, _cF_) {
            return caml_call2(pf, ppf, fmt$1);
        }, pp_elt);
    }
    function queue$0(pp_elt) {
        return iter$0(Stdlib_Queue[15], function(ppf, _cE_) {
            return caml_call2(pf, ppf, fmt$2);
        }, pp_elt);
    }
    function field(opt, l, prj, pp_v, ppf, v) {
        var label = opt ? opt[1] : string$0;
        return caml_call6(pf, ppf, _x_, label, l, pp_v, caml_call1(prj, v));
    }
    function record(pps) {
        var _cq_ = [
            0,
            function(ppf, _cD_) {
                return caml_call2(pf, ppf, fmt$3);
            }
        ];
        function _cr_(_cB_, _cC_) {
            return concat(_cq_, pps, _cB_, _cC_);
        }
        var _cs_ = 0;
        function _ct_(_cz_, _cA_) {
            return vbox(_cs_, _cr_, _cz_, _cA_);
        }
        function _cu_(_cx_, _cy_) {
            return surround(cst$11, cst$10, _ct_, _cx_, _cy_);
        }
        return function(_cv_, _cw_) {
            return box(_y_, _cu_, _cv_, _cw_);
        };
    }
    function ipow10(n) {
        var acc = 1, n$0 = n;
        for(;;){
            if (0 === n$0) return acc;
            var n$1 = n$0 - 1 | 0, acc$0 = acc * 10 | 0;
            acc = acc$0;
            n$0 = n$1;
        }
    }
    var si_symb = [
        0,
        "y",
        "z",
        "a",
        cst_f$0,
        "p",
        "n",
        "u",
        cst_m$0,
        cst$20,
        "k",
        "M",
        "G",
        "T",
        "P",
        "E",
        "Z",
        "Y"
    ].slice(), si_symb_max = 16, _z_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        cst_d_s_s
    ], _A_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        cst_d_s_s
    ], _B_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    4,
                    0,
                    0,
                    0,
                    [
                        2,
                        0,
                        [
                            2,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        cst_d_d_s_s
    ], _C_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        cst_d_s_s
    ], _D_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    4,
                    0,
                    0,
                    0,
                    [
                        2,
                        0,
                        [
                            2,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        cst_d_d_s_s
    ], _E_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    4,
                    0,
                    [
                        0,
                        2,
                        2
                    ],
                    0,
                    [
                        2,
                        0,
                        [
                            2,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "%d.%02d%s%s"
    ], _F_ = [
        0,
        [
            11,
            "~scale is ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    ", must be in [-8;8]",
                    0
                ]
            ]
        ],
        "~scale is %d, must be in [-8;8]"
    ], _G_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        cst_d_s_s
    ], cst_B = "B", _H_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                66,
                0
            ]
        ],
        "%dB"
    ], _I_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%d%s%sB"
    ], _J_ = [
        0,
        [
            15,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%a%s%sB"
    ], _K_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                77,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%dM%sB"
    ], _L_ = [
        0,
        [
            15,
            [
                12,
                77,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%aM%sB"
    ], _M_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                71,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%dG%sB"
    ], _N_ = [
        0,
        [
            15,
            [
                12,
                71,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%aG%sB"
    ], _O_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                84,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%dT%sB"
    ], _P_ = [
        0,
        [
            15,
            [
                12,
                84,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%aT%sB"
    ], _Q_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                80,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%dP%sB"
    ], _R_ = [
        0,
        [
            15,
            [
                12,
                80,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%aP%sB"
    ], _S_ = runtime.caml_int64_create_lo_mi_hi(100, 0, 0), _T_1 = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _U_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                2,
                0,
                0
            ]
        ],
        cst_Ld_s
    ], _V_ = runtime.caml_int64_create_lo_mi_hi(10, 0, 0), _W_ = runtime.caml_int64_create_lo_mi_hi(10, 0, 0), _X_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _Y_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _Z_ = runtime.caml_int64_create_lo_mi_hi(10, 0, 0), ___ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    7,
                    0,
                    0,
                    0,
                    [
                        2,
                        0,
                        0
                    ]
                ]
            ]
        ],
        cst_Ld_Ld_s
    ], _$_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                2,
                0,
                0
            ]
        ],
        cst_Ld_s
    ], _aa_ = runtime.caml_int64_create_lo_mi_hi(100, 0, 0), _ab_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _ac_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _ad_ = runtime.caml_int64_create_lo_mi_hi(100, 0, 0), _ae_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _af_ = runtime.caml_int64_create_lo_mi_hi(10, 0, 0), _ag_ = runtime.caml_int64_create_lo_mi_hi(10, 0, 0), _ah_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    7,
                    0,
                    0,
                    0,
                    [
                        2,
                        0,
                        0
                    ]
                ]
            ]
        ],
        cst_Ld_Ld_s
    ], _ai_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    7,
                    0,
                    [
                        0,
                        2,
                        2
                    ],
                    0,
                    [
                        2,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "%Ld.%02Ld%s"
    ], _aj_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                2,
                0,
                0
            ]
        ],
        cst_Ld_s
    ], _ak_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _al_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                2,
                0,
                0
            ]
        ],
        cst_Ld_s
    ], _am_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _an_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    7,
                    0,
                    0,
                    0,
                    [
                        2,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "%Ld%s%Ld%s"
    ], _ao_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                11,
                "ns",
                0
            ]
        ],
        "%Ldns"
    ], _as_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _at_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                97,
                0
            ]
        ],
        cst_Lda
    ], _au_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _av_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                97,
                0
            ]
        ],
        cst_Lda
    ], _aw_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                97,
                [
                    7,
                    0,
                    0,
                    0,
                    [
                        12,
                        100,
                        0
                    ]
                ]
            ]
        ],
        "%Lda%Ldd"
    ];
    function si_size(scale, u, ppf, s$2) {
        var s$3 = s$2;
        for(;;){
            var _co_ = scale < -8 ? 1 : 0, _cp_ = _co_ || (8 < scale ? 1 : 0);
            if (_cp_) return caml_call1(invalid_arg(_F_), scale);
            if (0 === s$3) var pow_div_3 = 0;
            else {
                var p = -1, x = s$3;
                for(;;){
                    if (0 === x) break;
                    var x$0 = x / 10 | 0, p$0 = p + 1 | 0;
                    p = p$0;
                    x = x$0;
                }
                var pow_div_3 = p / 3 | 0;
            }
            var symb = (scale + 8 | 0) + pow_div_3 | 0;
            if (16 < symb) var factor = ipow10((8 - scale | 0) * 3 | 0), symb$0 = si_symb_max;
            else var factor$0 = ipow10(pow_div_3 * 3 | 0), factor = factor$0, symb$0 = symb;
            if (1 === factor) return caml_call5(pf, ppf, _G_, s$3, caml_check_bound(si_symb, symb$0)[1 + symb$0], u);
            var symb$1 = caml_check_bound(si_symb, symb$0)[1 + symb$0], m = caml_div(s$3, factor), n = caml_mod(s$3, factor);
            if (100 <= m) {
                var m_up = 0 < n ? m + 1 | 0 : m;
                if (1000 > m_up) return caml_call5(pf, ppf, _z_, m_up, symb$1, u);
                var s = caml_mul(m_up, factor);
                s$3 = s;
            } else if (10 <= m) {
                var f_factor = factor / 10 | 0, f_m = caml_div(n, f_factor), f_n = caml_mod(n, f_factor), f_m_up = 0 < f_n ? f_m + 1 | 0 : f_m;
                if (0 === f_m_up) return caml_call5(pf, ppf, _A_, m, symb$1, u);
                if (10 > f_m_up) return caml_call6(pf, ppf, _B_, m, f_m_up, symb$1, u);
                var s$0 = caml_mul(m, factor) + caml_mul(f_m_up, f_factor) | 0;
                s$3 = s$0;
            } else {
                var f_factor$0 = factor / 100 | 0, f_m$0 = caml_div(n, f_factor$0), f_n$0 = caml_mod(n, f_factor$0), f_m_up$0 = 0 < f_n$0 ? f_m$0 + 1 | 0 : f_m$0;
                if (0 === f_m_up$0) return caml_call5(pf, ppf, _C_, m, symb$1, u);
                if (100 > f_m_up$0) return 0 === (f_m_up$0 % 10 | 0) ? caml_call6(pf, ppf, _D_, m, f_m_up$0 / 10 | 0, symb$1, u) : caml_call6(pf, ppf, _E_, m, f_m_up$0, symb$1, u);
                var s$1 = caml_mul(m, factor) + caml_mul(f_m_up$0, f_factor$0) | 0;
                s$3 = s$1;
            }
        }
    }
    function byte_size(ppf, s) {
        return si_size(0, cst_B, ppf, s);
    }
    function bi_byte_size(ppf, s) {
        var _cl_ = 1;
        function pp_frac(_cm_, _cn_) {
            return float_dfrac(_cl_, _cm_, _cn_);
        }
        function div_round_up(m, n) {
            return caml_div((m + n | 0) - 1 | 0, n);
        }
        var k = 1024;
        if (s < 1024) return caml_call3(pf, ppf, _H_, s);
        var m = 1048576;
        if (s < 1048576) {
            var sk = s / 1024 | 0;
            return 10 <= sk ? caml_call5(pf, ppf, _I_, div_round_up(s, k), kstr$0, i) : caml_call6(pf, ppf, _J_, pp_frac, s / 1024, kstr$0, i);
        }
        var g = 1073741824;
        if (s < 1073741824) {
            var sm = s / 1048576 | 0;
            return 10 <= sm ? caml_call4(pf, ppf, _K_, div_round_up(s, m), i) : caml_call5(pf, ppf, _L_, pp_frac, s / 1048576, i);
        }
        var t = 0;
        if (s < 0) {
            var sg = s / 1073741824 | 0;
            return 10 <= sg ? caml_call4(pf, ppf, _M_, div_round_up(s, g), i) : caml_call5(pf, ppf, _N_, pp_frac, s / 1073741824, i);
        }
        var p = 0;
        if (s < 0) {
            var st = caml_div(s, 0);
            return 10 <= st ? caml_call4(pf, ppf, _O_, div_round_up(s, t), i) : caml_call5(pf, ppf, _P_, pp_frac, s / 0, i);
        }
        var sp = caml_div(s, 0);
        return 10 <= sp ? caml_call4(pf, ppf, _Q_, div_round_up(s, p), i) : caml_call5(pf, ppf, _R_, pp_frac, s / 0, i);
    }
    function unsigned_compare(x0, x1) {
        return caml_call2(Stdlib_Int64[15], caml_int64_sub(x0, Stdlib_Int64[10]), caml_int64_sub(x1, Stdlib_Int64[10]));
    }
    function unsigned_div(n, d) {
        if (runtime.caml_lessthan(d, Stdlib_Int64[1])) return 0 <= unsigned_compare(n, d) ? Stdlib_Int64[2] : Stdlib_Int64[1];
        var q = runtime.caml_int64_shift_left(caml_int64_div(runtime.caml_int64_shift_right_unsigned(n, 1), d), 1), r = caml_int64_sub(n, caml_int64_mul(q, d));
        return 0 <= unsigned_compare(r, d) ? caml_call1(Stdlib_Int64[6], q) : q;
    }
    function unsigned_rem(n, d) {
        return caml_int64_sub(n, caml_int64_mul(caml_call2(Stdlib_Int64[4], n, d), d));
    }
    function pp_si_span(counter, unit_str, si_unit, si_higher_unit, ppf, span) {
        function geq(x, y) {
            return 0 <= unsigned_compare(x, y) ? 1 : 0;
        }
        var m = unsigned_div(span, si_unit), n = unsigned_rem(span, si_unit);
        if (geq(m, _S_)) {
            var m_up = caml_call2(Stdlib_Int64[17], n, _T_1) ? m : caml_call1(Stdlib_Int64[6], m), span$0 = caml_int64_mul(m_up, si_unit);
            if (!geq(span$0, si_higher_unit)) return caml_call4(pf, ppf, _U_, m_up, unit_str);
            if (counter >= 50) return caml_trampoline_return(uint64_ns_span$0, [
                0,
                ppf,
                span$0
            ]);
            var counter$0 = counter + 1 | 0;
            return uint64_ns_span$0(counter$0, ppf, span$0);
        }
        if (geq(m, _V_)) {
            var f_factor = unsigned_div(si_unit, _W_), f_m = unsigned_div(n, f_factor), f_n = unsigned_rem(n, f_factor), f_m_up = caml_call2(Stdlib_Int64[17], f_n, _X_) ? f_m : caml_call1(Stdlib_Int64[6], f_m);
            if (!caml_notequal(f_m_up, _Y_)) return caml_call4(pf, ppf, _$_, m, unit_str);
            if (!geq(f_m_up, _Z_)) return caml_call5(pf, ppf, ___, m, f_m_up, unit_str);
            var _cj_ = caml_int64_add(caml_int64_mul(m, si_unit), caml_int64_mul(f_m_up, f_factor));
            if (counter >= 50) return caml_trampoline_return(uint64_ns_span$0, [
                0,
                ppf,
                _cj_
            ]);
            var counter$1 = counter + 1 | 0;
            return uint64_ns_span$0(counter$1, ppf, _cj_);
        }
        var f_factor$0 = unsigned_div(si_unit, _aa_), f_m$0 = unsigned_div(n, f_factor$0), f_n$0 = unsigned_rem(n, f_factor$0), f_m_up$0 = caml_call2(Stdlib_Int64[17], f_n$0, _ab_) ? f_m$0 : caml_call1(Stdlib_Int64[6], f_m$0);
        if (!caml_notequal(f_m_up$0, _ac_)) return caml_call4(pf, ppf, _aj_, m, unit_str);
        if (!geq(f_m_up$0, _ad_)) return caml_call2(Stdlib_Int64[17], runtime.caml_int64_mod(f_m_up$0, _af_), _ae_) ? caml_call5(pf, ppf, _ah_, m, caml_int64_div(f_m_up$0, _ag_), unit_str) : caml_call5(pf, ppf, _ai_, m, f_m_up$0, unit_str);
        var _ck_ = caml_int64_add(caml_int64_mul(m, si_unit), caml_int64_mul(f_m_up$0, f_factor$0));
        if (counter >= 50) return caml_trampoline_return(uint64_ns_span$0, [
            0,
            ppf,
            _ck_
        ]);
        var counter$2 = counter + 1 | 0;
        return uint64_ns_span$0(counter$2, ppf, _ck_);
    }
    function pp_non_si(counter, unit_str, unit, unit_lo_str, unit_lo, unit_lo_size, ppf, span) {
        var m = unsigned_div(span, unit), n = unsigned_rem(span, unit);
        if (caml_call2(Stdlib_Int64[17], n, _ak_)) return caml_call4(pf, ppf, _al_, m, unit_str);
        var f_m = unsigned_div(n, unit_lo), f_n = unsigned_rem(n, unit_lo), f_m_up = caml_call2(Stdlib_Int64[17], f_n, _am_) ? f_m : caml_call1(Stdlib_Int64[6], f_m);
        if (0 > unsigned_compare(f_m_up, unit_lo_size)) return caml_call6(pf, ppf, _an_, m, unit_str, f_m_up, unit_lo_str);
        var _ci_ = caml_int64_add(caml_int64_mul(m, unit), caml_int64_mul(f_m_up, unit_lo));
        if (counter >= 50) return caml_trampoline_return(uint64_ns_span$0, [
            0,
            ppf,
            _ci_
        ]);
        var counter$0 = counter + 1 | 0;
        return uint64_ns_span$0(counter$0, ppf, _ci_);
    }
    function uint64_ns_span$0(counter, ppf, span) {
        function lt(x, y) {
            return -1 === unsigned_compare(x, y) ? 1 : 0;
        }
        if (lt(span, us_span)) return caml_call3(pf, ppf, _ao_, span);
        if (lt(span, ms_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_si_span, [
                0,
                cst_us,
                us_span,
                ms_span,
                ppf,
                span
            ]);
            var counter$3 = counter + 1 | 0;
            return pp_si_span(counter$3, cst_us, us_span, ms_span, ppf, span);
        }
        if (lt(span, sec_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_si_span, [
                0,
                cst_ms,
                ms_span,
                sec_span,
                ppf,
                span
            ]);
            var counter$4 = counter + 1 | 0;
            return pp_si_span(counter$4, cst_ms, ms_span, sec_span, ppf, span);
        }
        if (lt(span, min_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_si_span, [
                0,
                cst_s,
                sec_span,
                min_span,
                ppf,
                span
            ]);
            var counter$5 = counter + 1 | 0;
            return pp_si_span(counter$5, cst_s, sec_span, min_span, ppf, span);
        }
        if (lt(span, hour_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_non_si, [
                0,
                cst_min,
                min_span,
                cst_s$0,
                sec_span,
                _ap_,
                ppf,
                span
            ]);
            var counter$0 = counter + 1 | 0;
            return pp_non_si(counter$0, cst_min, min_span, cst_s$0, sec_span, _ap_, ppf, span);
        }
        if (lt(span, day_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_non_si, [
                0,
                cst_h,
                hour_span,
                cst_min$0,
                min_span,
                _aq_,
                ppf,
                span
            ]);
            var counter$1 = counter + 1 | 0;
            return pp_non_si(counter$1, cst_h, hour_span, cst_min$0, min_span, _aq_, ppf, span);
        }
        if (lt(span, year_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_non_si, [
                0,
                cst_d,
                day_span,
                cst_h$0,
                hour_span,
                _ar_,
                ppf,
                span
            ]);
            var counter$2 = counter + 1 | 0;
            return pp_non_si(counter$2, cst_d, day_span, cst_h$0, hour_span, _ar_, ppf, span);
        }
        var m = unsigned_div(span, year_span), n = unsigned_rem(span, year_span);
        if (caml_call2(Stdlib_Int64[17], n, _as_)) return caml_call3(pf, ppf, _at_, m);
        var f_m = unsigned_div(n, day_span), f_n = unsigned_rem(n, day_span), f_m_up = caml_call2(Stdlib_Int64[17], f_n, _au_) ? f_m : caml_call1(Stdlib_Int64[6], f_m);
        return 0 <= unsigned_compare(f_m_up, y) ? caml_call3(pf, ppf, _av_, caml_call1(Stdlib_Int64[6], m)) : caml_call4(pf, ppf, _aw_, m, f_m_up);
    }
    function uint64_ns_span(ppf, span) {
        return caml_trampoline(uint64_ns_span$0(0, ppf, span));
    }
    function iter_vec(f, param) {
        var get = param[2], n = param[1], _cg_ = n - 1 | 0, _cf_ = 0;
        if (_cg_ >= 0) {
            var i = _cf_;
            for(;;){
                caml_call2(f, i, caml_call1(get, i));
                var _ch_ = i + 1 | 0;
                if (_cg_ === i) break;
                i = _ch_;
            }
        }
        return 0;
    }
    function vec(sep) {
        return function(_cc_, _cd_, _ce_) {
            return iter_bindings(sep, iter_vec, _cc_, _cd_, _ce_);
        };
    }
    function _ax_(s) {
        return [
            0,
            caml_ml_string_length(s),
            function(_cb_) {
                return caml_string_get(s, _cb_);
            }
        ];
    }
    function on_string(_b__, _b$_, _ca_) {
        return using(_ax_, _b__, _b$_, _ca_);
    }
    function _ay_(b) {
        return [
            0,
            runtime.caml_ml_bytes_length(b),
            function(_b9_) {
                return runtime.caml_bytes_get(b, _b9_);
            }
        ];
    }
    function on_bytes(_b6_, _b7_, _b8_) {
        return using(_ay_, _b6_, _b7_, _b8_);
    }
    var prefix0x = [
        0,
        [
            0,
            15,
            function(ppf) {
                return caml_call2(pf, ppf, fmt$10);
            }
        ],
        [
            0,
            [
                0,
                255,
                function(ppf) {
                    return caml_call2(pf, ppf, fmt$9);
                }
            ],
            [
                0,
                [
                    0,
                    4095,
                    function(ppf) {
                        return caml_call2(pf, ppf, fmt$8);
                    }
                ],
                [
                    0,
                    [
                        0,
                        65535,
                        function(ppf) {
                            return caml_call2(pf, ppf, fmt$7);
                        }
                    ],
                    [
                        0,
                        [
                            0,
                            1048575,
                            function(ppf) {
                                return caml_call2(pf, ppf, fmt$6);
                            }
                        ],
                        [
                            0,
                            [
                                0,
                                16777215,
                                function(ppf) {
                                    return caml_call2(pf, ppf, fmt$5);
                                }
                            ],
                            [
                                0,
                                [
                                    0,
                                    268435455,
                                    function(ppf) {
                                        return caml_call2(pf, ppf, fmt$4);
                                    }
                                ],
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ], _az_ = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                2
            ],
            0,
            0
        ],
        cst_02x
    ], _aA_ = [
        0,
        cst_src_fmt_ml,
        549,
        13
    ], _aB_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    4,
                    0,
                    0,
                    0,
                    0
                ]
            ]
        ],
        "%d.%d"
    ], _aC_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    4,
                    0,
                    0,
                    0,
                    [
                        12,
                        45,
                        [
                            4,
                            0,
                            0,
                            0,
                            [
                                12,
                                46,
                                [
                                    4,
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%d.%d-%d.%d"
    ], _aD_ = [
        0,
        [
            15,
            [
                12,
                44,
                [
                    17,
                    [
                        0,
                        cst$18,
                        1,
                        0
                    ],
                    0
                ]
            ]
        ],
        "%a,@ "
    ], _aE_ = [
        0,
        [
            11,
            "or",
            [
                17,
                [
                    0,
                    cst$18,
                    1,
                    0
                ],
                [
                    15,
                    0
                ]
            ]
        ],
        "or@ %a"
    ], _aF_ = [
        0,
        cst_src_fmt_ml,
        587,
        12
    ], _aG_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$20
                ]
            ],
            [
                11,
                "one",
                [
                    17,
                    [
                        0,
                        cst$18,
                        1,
                        0
                    ],
                    [
                        11,
                        "of",
                        [
                            17,
                            [
                                0,
                                cst$18,
                                1,
                                0
                            ],
                            [
                                15,
                                [
                                    17,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[one@ of@ %a@]"
    ], _aH_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$20
                ]
            ],
            [
                11,
                "either ",
                [
                    15,
                    [
                        11,
                        " or",
                        [
                            17,
                            [
                                0,
                                cst$18,
                                1,
                                0
                            ],
                            [
                                15,
                                [
                                    17,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[either %a or@ %a@]"
    ], _aI_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$20
                ]
            ],
            [
                15,
                [
                    12,
                    32,
                    [
                        2,
                        0,
                        [
                            12,
                            32,
                            [
                                15,
                                [
                                    15,
                                    [
                                        12,
                                        46,
                                        [
                                            17,
                                            [
                                                0,
                                                cst$18,
                                                1,
                                                0
                                            ],
                                            [
                                                11,
                                                "Did you mean ",
                                                partial
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[%a %s %a%a.@ Did you mean %a ?@]"
    ], _aJ_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$20
                ]
            ],
            [
                15,
                [
                    12,
                    32,
                    [
                        2,
                        0,
                        [
                            12,
                            32,
                            [
                                15,
                                [
                                    15,
                                    [
                                        12,
                                        46,
                                        [
                                            17,
                                            0,
                                            0
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[%a %s %a%a.@]"
    ];
    function ascii(_b3_, opt, param, ppf, v) {
        var w = _b3_ ? _b3_[1] : 0;
        if (opt) var subst = opt[1];
        else var v$0 = 46, subst = function(ppf, _b5_) {
            return caml_call2(char$0, ppf, v$0);
        };
        var n = v[1];
        function pp_char(ppf, param) {
            var c = param[2];
            if (32 <= c && 127 > c) return caml_call2(char$0, ppf, c);
            return caml_call2(subst, ppf, 0);
        }
        vec(0)(pp_char, ppf, v);
        var _b4_ = n < w ? 1 : 0;
        return _b4_ ? sps(w - n | 0, ppf, 0) : _b4_;
    }
    function octets(_bY_, opt, param, ppf, v) {
        var w = _bY_ ? _bY_[1] : 0, sep = opt ? opt[1] : sp, n = v[1];
        function pp_sep(ppf, i) {
            var _b1_ = 0 < i ? 1 : 0, _b2_ = _b1_ ? 0 === (i % 2 | 0) ? 1 : 0 : _b1_;
            return _b2_ ? caml_call2(sep, ppf, 0) : _b2_;
        }
        function pp_char(ppf, param) {
            var c = param[2], i = param[1];
            pp_sep(ppf, i);
            return caml_call3(pf, ppf, _az_, c);
        }
        vec([
            0,
            nop
        ])(pp_char, ppf, v);
        var _bZ_ = w - 1 | 0;
        if (_bZ_ >= n) {
            var i = n;
            for(;;){
                pp_sep(ppf, i);
                sps(2, ppf, 0);
                var _b0_ = i + 1 | 0;
                if (_bZ_ === i) break;
                i = _b0_;
            }
        }
        return 0;
    }
    function addresses(addr, opt, pp_vec, ppf, v) {
        var w = opt ? opt[1] : 16, n$0 = v[1];
        if (addr) var pp$0 = addr[1], addr$0 = pp$0;
        else {
            var max = caml_mul(caml_div(n$0 - 1 | 0, w), w), match = caml_call2(Stdlib_List[40], function(param) {
                var x = param[1];
                return max <= x ? 1 : 0;
            }, prefix0x);
            if (match) var pp = match[1][2], pp_v0 = pp;
            else var pp_v0 = function(ppf) {
                return caml_call2(pf, ppf, fmt$11);
            };
            var addr$0 = function(ppf, v) {
                caml_call2(pp_v0, ppf, v);
                return caml_call2(string, ppf, cst$12);
            };
        }
        function pp_sub(ppf, param) {
            var sub = param[2], i = param[1];
            caml_call2(addr$0, ppf, caml_mul(i, w));
            return box(0, pp_vec, ppf, sub);
        }
        var get = v[2], n = v[1], _bS_ = [
            0,
            caml_div(n - 1 | 0, w) + 1 | 0,
            function(j) {
                var off = caml_mul(w, j);
                return [
                    0,
                    caml_call2(Stdlib[16], w, n - off | 0),
                    function(i) {
                        return caml_call1(get, i + off | 0);
                    }
                ];
            }
        ], _bT_ = vec(0);
        return vbox(0, function(_bU_, _bV_) {
            var _bX_ = _bV_, _bW_ = _bU_;
            return _bT_(pp_sub, _bW_, _bX_);
        }, ppf, _bS_);
    }
    function hex(opt, param) {
        var w = opt ? opt[1] : 16, _by_ = 0, _bz_ = 0, _bA_ = [
            0,
            w
        ], _bE_ = 0, _bF_ = 0, _bG_ = [
            0,
            w
        ];
        function _bB_(_bQ_, _bR_) {
            return ascii(_bA_, _bz_, _by_, _bQ_, _bR_);
        }
        var _bC_ = 0, _bD_ = 2;
        function _bH_(_bO_, _bP_) {
            return octets(_bG_, _bF_, _bE_, _bO_, _bP_);
        }
        var _bI_ = 0;
        function _bJ_(ppf, v) {
            box(_bI_, _bH_, ppf, v);
            sps(_bD_, ppf, v);
            return box(_bC_, _bB_, ppf, v);
        }
        var _bK_ = [
            0,
            w
        ], _bL_ = 0;
        return function(_bM_, _bN_) {
            return addresses(_bL_, _bK_, _bJ_, _bM_, _bN_);
        };
    }
    function is_nl(c) {
        return 10 === c ? 1 : 0;
    }
    function is_nl_or_sp(c) {
        var _bx_ = 10 === c ? 1 : 0, _bw_ = _bx_ || (32 === c ? 1 : 0);
        return _bw_;
    }
    function is_white(param) {
        a: {
            if (14 <= param) {
                if (32 === param) break a;
            } else if (9 <= param) break a;
            return 0;
        }
        return 1;
    }
    function not_white(c) {
        return 1 - is_white(c);
    }
    function not_white_or_nl(c) {
        var _bv_ = 10 === c ? 1 : 0;
        return _bv_ ? _bv_ : not_white(c);
    }
    function stop_at(sat, start, max, s) {
        var start$0 = start;
        for(;;){
            if (max < start$0) return start$0;
            if (caml_call1(sat, caml_string_get(s, start$0))) return start$0;
            var start$1 = start$0 + 1 | 0;
            start$0 = start$1;
        }
    }
    function sub(s, start, stop, max) {
        if (start === stop) return cst$13;
        if (0 === start && max < stop) return s;
        return caml_call3(Stdlib_String[16], s, start, stop - start | 0);
    }
    function words(ppf, s) {
        var max = caml_ml_string_length(s) - 1 | 0, start$1 = stop_at(not_white, 0, max, s);
        if (max < start$1) return 0;
        var start = start$1;
        for(;;){
            var stop = stop_at(is_white, start, max, s);
            if (max < stop) {
                var _bt_ = sub(s, start, stop, max);
                return caml_call2(Stdlib_Format[13], ppf, _bt_);
            }
            var _bu_ = sub(s, start, stop, max);
            caml_call2(Stdlib_Format[13], ppf, _bu_);
            var start$0 = stop_at(not_white, stop, max, s);
            if (max < start$0) return 0;
            caml_call2(Stdlib_Format[28], ppf, 0);
            start = start$0;
        }
    }
    function paragraphs(ppf, s) {
        var max = caml_ml_string_length(s) - 1 | 0, start$3 = stop_at(not_white, 0, max, s);
        if (max < start$3) return 0;
        var start = start$3;
        for(;;){
            var stop = stop_at(is_white, start, max, s);
            if (max < stop) {
                var _br_ = sub(s, start, stop, max);
                return caml_call2(Stdlib_Format[13], ppf, _br_);
            }
            var _bs_ = sub(s, start, stop, max);
            caml_call2(Stdlib_Format[13], ppf, _bs_);
            var start$0 = stop_at(not_white_or_nl, stop, max, s);
            if (max < start$0) return 0;
            if (10 === caml_string_get(s, start$0)) {
                var start$1 = stop_at(not_white_or_nl, start$0 + 1 | 0, max, s);
                if (max < start$1) return 0;
                if (10 === caml_string_get(s, start$1)) {
                    var start$2 = stop_at(not_white, start$1 + 1 | 0, max, s);
                    if (max < start$2) return 0;
                    caml_call2(Stdlib_Format[35], ppf, 0);
                    caml_call2(Stdlib_Format[35], ppf, 0);
                    start = start$2;
                } else {
                    caml_call2(Stdlib_Format[28], ppf, 0);
                    start = start$1;
                }
            } else {
                caml_call2(Stdlib_Format[28], ppf, 0);
                start = start$0;
            }
        }
    }
    function text(ppf, s) {
        var max = caml_ml_string_length(s) - 1 | 0, start = 0;
        for(;;){
            var stop = stop_at(is_nl_or_sp, start, max, s);
            if (max < stop) {
                var _bp_ = sub(s, start, stop, max);
                return caml_call2(Stdlib_Format[13], ppf, _bp_);
            }
            var _bq_ = sub(s, start, stop, max);
            caml_call2(Stdlib_Format[13], ppf, _bq_);
            var match = caml_string_get(s, stop);
            if (10 === match) caml_call2(Stdlib_Format[35], ppf, 0);
            else {
                if (32 !== match) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _aA_
                ], 1);
                caml_call2(Stdlib_Format[28], ppf, 0);
            }
            var start$0 = stop + 1 | 0;
            start = start$0;
        }
    }
    function lines(ppf, s) {
        var max = caml_ml_string_length(s) - 1 | 0, start = 0;
        for(;;){
            var stop = stop_at(is_nl, start, max, s);
            if (max < stop) {
                var _bn_ = sub(s, start, stop, max);
                return caml_call2(Stdlib_Format[13], ppf, _bn_);
            }
            var _bo_ = sub(s, start, stop, max);
            caml_call2(Stdlib_Format[13], ppf, _bo_);
            caml_call2(Stdlib_Format[35], ppf, 0);
            var start$0 = stop + 1 | 0;
            start = start$0;
        }
    }
    function truncated(max, ppf, s) {
        if (caml_ml_string_length(s) <= max) return caml_call2(Stdlib_Format[13], ppf, s);
        var _bk_ = max - 4 | 0, _bj_ = 0;
        if (_bk_ >= 0) {
            var i = _bj_;
            for(;;){
                var _bl_ = caml_string_get(s, i);
                caml_call2(Stdlib_Format[23], ppf, _bl_);
                var _bm_ = i + 1 | 0;
                if (_bk_ === i) break;
                i = _bm_;
            }
        }
        return caml_call2(Stdlib_Format[13], ppf, cst$14);
    }
    function text_loc(ppf, param) {
        var _bi_ = param[2], c1 = _bi_[2], l1 = _bi_[1], match = param[1], c0 = match[2], l0 = match[1];
        if (l0 === l1 && c0 === c1) return caml_call4(pf, ppf, _aB_, l0, c0);
        return caml_call6(pf, ppf, _aC_, l0, c0, l1, c1);
    }
    function one_of(opt, pp_v, ppf, vs) {
        var empty = opt ? opt[1] : nop;
        if (!vs) return caml_call2(empty, ppf, 0);
        var v = vs[1], _bh_ = vs[2];
        if (!_bh_) return caml_call2(pp_v, ppf, v);
        if (_bh_[2]) {
            var loop = function(ppf, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _aF_
                    ], 1);
                    var v = param$0[1];
                    if (!param$0[2]) return caml_call4(pf, ppf, _aE_, pp_v, v);
                    var vs = param$0[2];
                    caml_call4(pf, ppf, _aD_, pp_v, v);
                    param$0 = vs;
                }
            };
            return caml_call4(pf, ppf, _aG_, loop, vs);
        }
        var v1 = _bh_[1];
        return caml_call6(pf, ppf, _aH_, pp_v, v, pp_v, v1);
    }
    function did_you_mean(_bc_, opt, kind, pp_v, ppf, param) {
        var pre = _bc_ ? _bc_[1] : function(ppf, _bg_) {
            return caml_call2(pf, ppf, fmt$12);
        }, post = opt ? opt[1] : nop, hints = param[2], v = param[1];
        if (!hints) return caml_call9(pf, ppf, _aJ_, pre, 0, kind, pp_v, v, post, 0);
        var _bd_ = 0;
        return caml_call11(pf, ppf, _aI_, pre, 0, kind, pp_v, v, post, 0, function(_be_, _bf_) {
            return one_of(_bd_, pp_v, _be_, _bf_);
        }, hints);
    }
    var Imap = caml_call1(Stdlib_Map[1], [
        0,
        Stdlib_Int[9]
    ]), id = [
        0,
        0
    ];
    function attr(enc, dec) {
        id[1]++;
        return [
            0,
            id[1],
            enc,
            dec
        ];
    }
    var Fmt_store_get = [
        248,
        "Fmt.Fmt_store_get",
        caml_fresh_oo_id(0)
    ], Fmt_store_set = [
        248,
        "Fmt.Fmt_store_set",
        caml_fresh_oo_id(0)
    ], cst_ok = cst_ok$0, cst_t = cst_t$0, cst_f = cst_f$0, _aK_ = [
        0,
        cst_src_fmt_ml,
        638,
        55
    ];
    function store_op(op, ppf) {
        var funs = caml_call2(Stdlib_Format[108], ppf, 0);
        return caml_call1(funs[1], op);
    }
    function get(attr, ppf) {
        var dec = attr[3], s = store_op([
            0,
            Fmt_store_get,
            attr
        ], ppf);
        return s !== cst$20 ? [
            0,
            caml_call1(dec, s)
        ] : 0;
    }
    function set(attr, v, ppf) {
        for(;;){
            if (store_op([
                0,
                Fmt_store_set,
                attr,
                v
            ], ppf) === cst_ok$0) return 0;
            var funs = caml_call2(Stdlib_Format[108], ppf, 0), other = funs[1], s = [
                0,
                Imap[1]
            ];
            let s$0 = s, other$0 = other;
            var mark_open_stag = function(stag) {
                if (stag[1] === Fmt_store_get) {
                    var id = stag[2][1], _a$_ = caml_call2(Imap[18], id, s$0[1]);
                    return caml_call2(Stdlib_Option[3], _a$_, cst$15);
                }
                if (stag[1] !== Fmt_store_set) return caml_call1(other$0, stag);
                var v = stag[3], match = stag[2], enc = match[2], id$0 = match[1], _ba_ = s$0[1], _bb_ = caml_call1(enc, v);
                s$0[1] = caml_call3(Imap[2], id$0, _bb_, _ba_);
                return cst_ok;
            };
            caml_call2(Stdlib_Format[106], ppf, [
                0,
                mark_open_stag,
                funs[2],
                funs[3],
                funs[4]
            ]);
        }
    }
    function def(x, param) {
        if (!param) return x;
        var y = param[1];
        return y;
    }
    function enc(param) {
        return param ? cst_t : cst_f;
    }
    function dec(param) {
        if (param === cst_f$0) return 0;
        if (param !== cst_t$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _aK_
        ], 1);
        return 1;
    }
    var utf_8_attr = attr(enc, dec), cst_N = cst_N$0, cst_A = cst_A$0, _aL_ = [
        0,
        cst_src_fmt_ml,
        647,
        60
    ];
    function utf_8(ppf) {
        return def(1, get(utf_8_attr, ppf));
    }
    function set_utf_8(ppf, x) {
        return set(utf_8_attr, x, ppf);
    }
    function enc$0(param) {
        return 870530776 <= param ? cst_N : cst_A;
    }
    function dec$0(param) {
        if (param === cst_A$0) return 323557469;
        if (param !== cst_N$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _aL_
        ], 1);
        return 870530776;
    }
    var style_renderer_attr = attr(enc$0, dec$0), cst_m = cst_m$0;
    function style_renderer(ppf) {
        return def(870530776, get(style_renderer_attr, ppf));
    }
    function set_style_renderer(ppf, x) {
        return set(style_renderer_attr, x, ppf);
    }
    function with_buffer(like, buf) {
        var ppf = caml_call1(Stdlib_Format[116], buf);
        if (!like) return ppf;
        var like$0 = like[1], funs = caml_call2(Stdlib_Format[108], like$0, 0);
        caml_call2(Stdlib_Format[106], ppf, funs);
        return ppf;
    }
    function str_like(ppf, fmt) {
        var buf = caml_call1(Stdlib_Buffer[1], 64), bppf = with_buffer([
            0,
            ppf
        ], buf);
        function flush(ppf) {
            caml_call2(Stdlib_Format[39], ppf, 0);
            var s = caml_call1(Stdlib_Buffer[2], buf);
            caml_call1(Stdlib_Buffer[9], buf);
            return s;
        }
        return caml_call3(Stdlib_Format[146], flush, bppf, fmt);
    }
    function if_utf_8(pp_u, pp) {
        return function(ppf, v) {
            var pp_u$0 = utf_8(ppf) ? pp_u : pp;
            return caml_call2(pp_u$0, ppf, v);
        };
    }
    function pp_sgr(ppf, style) {
        caml_call3(Stdlib_Format[17], ppf, 0, cst$16);
        caml_call3(Stdlib_Format[17], ppf, 0, style);
        return caml_call3(Stdlib_Format[17], ppf, 0, cst_m);
    }
    var curr_style = attr(function(_a__) {
        return _a__;
    }, function(_a9_) {
        return _a9_;
    }), cst_3 = "3", cst_0 = cst_0$0, cst_32 = cst_32$1, cst_36 = cst_36$1, cst_34 = cst_34$1, cst_1 = "1", cst_4 = "4", cst_2 = "2", cst_33 = cst_33$1, cst_31 = cst_31$1, cst_7 = "7", cst_35 = cst_35$1, cst_37 = cst_37$1, cst_30 = cst_30$1, cst_32$0 = cst_32$1, cst_36$0 = cst_36$1, cst_34$0 = cst_34$1, cst_33$0 = cst_33$1, cst_31$0 = cst_31$1, cst_37$0 = cst_37$1, cst_35$0 = cst_35$1, cst_30$0 = cst_30$1, cst_92 = "92", cst_96 = "96", cst_94 = "94", cst_93 = "93", cst_91 = "91", cst_97 = "97", cst_95 = "95", cst_90 = "90", cst_42 = "42", cst_46 = "46", cst_44 = "44", cst_43 = "43", cst_41 = "41", cst_47 = "47", cst_45 = "45", cst_40 = "40", cst_102 = "102", cst_106 = "106", cst_104 = "104", cst_103 = "103", cst_101 = "101", cst_107 = "107", cst_105 = "105", cst_100 = "100", _aM_ = [
        0,
        15713,
        82908052
    ], _aN_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_1$0,
                        0
                    ],
                    cst_1$0
                ]
            ],
            [
                15,
                [
                    15,
                    [
                        15,
                        [
                            17,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "@[<1>%a%a%a@]"
    ], _aO_ = [
        0,
        [
            15,
            0
        ],
        "%a"
    ];
    function styled(style, pp_v, ppf, v) {
        if (870530776 <= style_renderer(ppf)) return caml_call2(pp_v, ppf, v);
        var match = get(curr_style, ppf);
        if (match) var s = match[1], prev = s;
        else {
            set(curr_style, zero, ppf);
            var prev = zero;
        }
        if (typeof style === "number") var here = 698610924 <= style ? 749039939 <= style ? 870530776 <= style ? 989373200 <= style ? cst_3 : cst_0 : 756711075 <= style ? cst_32 : cst_36 : 737308346 === style ? cst_34 : 737455525 <= style ? cst_1 : cst_4 : -397582078 <= style ? 82908052 <= style ? 242899572 <= style ? cst_2 : cst_33 : 4100401 <= style ? cst_31 : cst_7 : -605101559 === style ? cst_35 : -588596599 <= style ? cst_37 : cst_30;
        else if (15713 <= style[1]) {
            var _a5_ = style[2];
            if (typeof _a5_ === "number") var here = 82908052 <= _a5_ ? 749039939 <= _a5_ ? 756711075 <= _a5_ ? cst_32$0 : cst_36$0 : 737308346 <= _a5_ ? cst_34$0 : cst_33$0 : -588596599 <= _a5_ ? 4100401 <= _a5_ ? cst_31$0 : cst_37$0 : -605101559 <= _a5_ ? cst_35$0 : cst_30$0;
            else var _a6_ = _a5_[2], here = 82908052 <= _a6_ ? 749039939 <= _a6_ ? 756711075 <= _a6_ ? cst_92 : cst_96 : 737308346 <= _a6_ ? cst_94 : cst_93 : -588596599 <= _a6_ ? 4100401 <= _a6_ ? cst_91 : cst_97 : -605101559 <= _a6_ ? cst_95 : cst_90;
        } else {
            var _a7_ = style[2];
            if (typeof _a7_ === "number") var here = 82908052 <= _a7_ ? 749039939 <= _a7_ ? 756711075 <= _a7_ ? cst_42 : cst_46 : 737308346 <= _a7_ ? cst_44 : cst_43 : -588596599 <= _a7_ ? 4100401 <= _a7_ ? cst_41 : cst_47 : -605101559 <= _a7_ ? cst_45 : cst_40;
            else var _a8_ = _a7_[2], here = 82908052 <= _a8_ ? 749039939 <= _a8_ ? 756711075 <= _a8_ ? cst_102 : cst_106 : 737308346 <= _a8_ ? cst_104 : cst_103 : -588596599 <= _a8_ ? 4100401 <= _a8_ ? cst_101 : cst_107 : -605101559 <= _a8_ ? cst_105 : cst_100;
        }
        a: {
            if (typeof style === "number" && 870530776 === style) {
                var curr = here;
                break a;
            }
            var curr = caml_call2(Stdlib_String[7], cst$17, [
                0,
                prev,
                [
                    0,
                    here,
                    0
                ]
            ]);
        }
        function finally$0(param) {
            return set(curr_style, prev, ppf);
        }
        set(curr_style, curr, ppf);
        return caml_call1(caml_call1(Stdlib_Fun[5], finally$0), function(param) {
            pp_sgr(ppf, here);
            caml_call2(pp_v, ppf, v);
            return pp_sgr(ppf, prev);
        });
    }
    function id$0(_a4_) {
        return _a4_;
    }
    function label(_a2_, _a3_) {
        return styled(_aM_, string, _a2_, _a3_);
    }
    function field$0(_a0_, opt, l, prj, pp_v, ppf, v) {
        var label$0 = _a0_ ? _a0_[1] : label, sep = opt ? opt[1] : function(ppf, _a1_) {
            return caml_call2(pf, ppf, fmt$13);
        };
        return caml_call8(pf, ppf, _aN_, label$0, l, sep, 0, pp_v, caml_call1(prj, v));
    }
    function record$0(opt, pps) {
        var sep = opt ? opt[1] : cut, _aT_ = [
            0,
            sep
        ];
        function _aU_(_aY_, _aZ_) {
            return concat(_aT_, pps, _aY_, _aZ_);
        }
        var _aV_ = 0;
        return function(_aW_, _aX_) {
            return vbox(_aV_, _aU_, _aW_, _aX_);
        };
    }
    function of_to_string(f, ppf, v) {
        return caml_call2(string, ppf, caml_call1(f, v));
    }
    function to_to_string(pp_v, v) {
        return caml_call3(str, _aO_, pp_v, v);
    }
    function prefix(pp_p, pp_v, ppf, v) {
        caml_call2(pp_p, ppf, 0);
        return caml_call2(pp_v, ppf, v);
    }
    function suffix(pp_s, pp_v, ppf, v) {
        caml_call2(pp_v, ppf, v);
        return caml_call2(pp_s, ppf, 0);
    }
    function styled_unit(style, fmt) {
        function _aP_(ppf, _aS_) {
            return caml_call2(pf, ppf, fmt);
        }
        return function(_aQ_, _aR_) {
            return styled(style, _aP_, _aQ_, _aR_);
        };
    }
    var Fmt = [
        0,
        stdout,
        stderr,
        pf,
        pr,
        epr,
        str,
        kpf,
        kstr,
        str_like,
        with_buffer,
        failwith,
        failwith_notrace,
        invalid_arg,
        error,
        error_msg,
        flush,
        nop,
        any,
        using,
        const$0,
        fmt,
        cut,
        sp,
        sps,
        comma,
        semi,
        append,
        append,
        concat,
        iter,
        iter_bindings,
        box,
        hbox,
        vbox,
        hvbox,
        hovbox,
        parens,
        brackets,
        braces,
        quote,
        id$0,
        field$0,
        record$0,
        bool,
        int$0,
        nativeint,
        int32,
        int64,
        uint,
        unativeint,
        uint32,
        uint64,
        float$0,
        float_dfrac,
        float_dsig,
        char$0,
        string,
        buffer,
        exn,
        exn_backtrace,
        pair,
        option,
        result,
        list,
        array,
        seq,
        hashtbl,
        queue,
        stack,
        [
            0,
            signal,
            uchar,
            string$0,
            pair$0,
            option$0,
            result$0,
            list$0,
            array$0,
            seq$0,
            hashtbl$0,
            queue$0,
            stack$0,
            field,
            record,
            iter$0,
            iter_bindings$0
        ],
        si_size,
        byte_size,
        bi_byte_size,
        uint64_ns_span,
        on_bytes,
        on_string,
        ascii,
        octets,
        addresses,
        hex,
        words,
        paragraphs,
        text,
        lines,
        truncated,
        text_loc,
        one_of,
        did_you_mean,
        if_utf_8,
        utf_8,
        set_utf_8,
        styled,
        style_renderer,
        set_style_renderer,
        of_to_string,
        to_to_string,
        str,
        kstr,
        str_like,
        any,
        any,
        prefix,
        suffix,
        styled_unit
    ];
    runtime.caml_register_global(267, Fmt, "Fmt");
    return;
})(globalThis);
//# 1 "../.js/default/note/note.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/note/note.cma.js"
//# 6 "../.js/default/note/note.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_option_is_None$1 = "option is None", cst_src_note_ml = "src/note.ml", caml_equal = runtime.caml_equal, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_List = global_data.Stdlib__List, Stdlib_Format = global_data.Stdlib__Format, CamlinternalMod = global_data.CamlinternalMod, Stdlib_Set = global_data.Stdlib__Set, Src = caml_call2(CamlinternalMod[1], [
        0,
        cst_src_note_ml,
        19,
        6
    ], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ]), C = caml_call2(CamlinternalMod[1], [
        0,
        cst_src_note_ml,
        99,
        6
    ], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ]), Logr = caml_call2(CamlinternalMod[1], [
        0,
        cst_src_note_ml,
        232,
        6
    ], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ]), Srcs = caml_call1(Stdlib_Set[1], [
        0,
        Src[1]
    ]);
    function create(srcs) {
        return [
            0,
            srcs,
            Srcs[1],
            0
        ];
    }
    function create$0(param) {
        return create(Srcs[1]);
    }
    var nil = create$0(0), delayed = create$0(0), cst_step_already_executed = "step already executed";
    function add_src(step, src) {
        step[1] = caml_call2(Srcs[2], src, step[1]);
        return;
    }
    function add_delayed(step, src) {
        step[2] = caml_call2(Srcs[2], src, step[2]);
        return 0;
    }
    function add_cleanup(step, clean) {
        step[3] = [
            0,
            clean,
            step[3]
        ];
        return 0;
    }
    function already_executed(param) {
        return caml_call1(Stdlib[1], cst_step_already_executed);
    }
    function execute_delayed$0(counter, srcs) {
        var ds = create(srcs);
        delayed[1] = srcs;
        caml_call2(Srcs[23], function(param) {
            var s = param[1], c = caml_call1(Src[3], s);
            caml_call2(C[15], delayed, c);
            return caml_call2(C[7], c, ds);
        }, srcs);
        if (counter >= 50) return caml_trampoline_return(execute$0, [
            0,
            ds
        ]);
        var counter$0 = counter + 1 | 0;
        return execute$0(counter$0, ds);
    }
    function execute_delayed(srcs) {
        return caml_trampoline(execute_delayed$0(0, srcs));
    }
    function execute$0(counter, step) {
        function update_src_logs(src) {
            var _dO_ = caml_call1(Src[5], src), _dP_ = caml_call1(Logr[9], step);
            return caml_call2(Stdlib_List[18], _dP_, _dO_);
        }
        caml_call2(Srcs[23], update_src_logs, step[1]);
        caml_call2(Srcs[23], Src[8], step[1]);
        caml_call2(Stdlib_List[18], function(f) {
            return caml_call1(f, 0);
        }, step[3]);
        step[3] = 0;
        add_cleanup(step, already_executed);
        if (caml_call1(Srcs[30], step[2])) return 0;
        var _dN_ = step[2];
        if (counter >= 50) return caml_trampoline_return(execute_delayed$0, [
            0,
            _dN_
        ]);
        var counter$0 = counter + 1 | 0;
        return execute_delayed$0(counter$0, _dN_);
    }
    function execute(step) {
        return caml_trampoline(execute$0(0, step));
    }
    function id(param) {
        var s = param[1];
        return s[1];
    }
    function cell(s) {
        return s[2];
    }
    function untyped(s) {
        return s[4];
    }
    function compare(_dM_, param) {
        var t = param[1], s = _dM_[1];
        return runtime.caml_int_compare(s[1], t[1]);
    }
    function logrs(param) {
        var s = param[1];
        return s[3];
    }
    function add_logr(logr, param) {
        var s = param[1];
        s[3] = [
            0,
            logr,
            s[3]
        ];
        return 0;
    }
    function rem_logr(logr, param) {
        var s = param[1], acc = 0, param$0 = s[3];
        for(;;){
            if (param$0) {
                var v = param$0[1], vs = param$0[2];
                if (v !== logr) {
                    var vs$0 = param$0[2], acc$0 = [
                        0,
                        v,
                        acc
                    ];
                    acc = acc$0;
                    param$0 = vs$0;
                    continue;
                }
                var _dL_ = caml_call2(Stdlib_List[13], vs, acc);
            } else var _dL_ = acc;
            s[3] = _dL_;
            return 0;
        }
    }
    function reset_stamp(param) {
        var s = param[1];
        return caml_call2(C[7], s[2], nil);
    }
    var Step = [
        248,
        "Note.Src.Step",
        runtime.caml_fresh_oo_id(0)
    ];
    function find_active_step(step, ss) {
        if (step !== nil) return step;
        function find_not_nil(param) {
            var s = param[1], step = caml_call1(C[6], s[2]), _dK_ = step !== nil ? 1 : 0;
            if (_dK_) throw [
                0,
                Step,
                step
            ];
            return _dK_;
        }
        try {
            caml_call2(Srcs[23], find_not_nil, ss);
            return nil;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Step) throw caml_maybe_attach_backtrace(exn, 0);
            var s = exn[2];
            return s;
        }
    }
    var id$0 = [
        0,
        0
    ];
    function create$1(eq, v) {
        function update(_dJ_, param) {
            return 0;
        }
        var cell = caml_call5(C[1], eq, nil, Srcs[1], v, update), src = [];
        id$0[1]++;
        runtime.caml_update_dummy(src, [
            0,
            id$0[1],
            cell,
            0,
            [
                0,
                src
            ]
        ]);
        var _dI_ = caml_call1(Srcs[3], src[4]);
        caml_call2(C[10], cell, _dI_);
        caml_call2(C[11], cell, 0);
        return src;
    }
    caml_call3(CamlinternalMod[2], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ], Src, [
        0,
        compare,
        id,
        cell,
        untyped,
        logrs,
        add_logr,
        rem_logr,
        reset_stamp,
        find_active_step,
        create$1
    ]);
    var cst_TOOD = "TOOD", _a_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    ""
                ]
            ],
            [
                12,
                123,
                [
                    15,
                    [
                        12,
                        125,
                        [
                            17,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "@[{%a}@]"
    ];
    function create$2(opt, step, srcs, value, update) {
        var eq = opt ? opt[1] : caml_equal;
        return [
            0,
            eq,
            step,
            srcs,
            1,
            value,
            1,
            update
        ];
    }
    function const$0(opt, v) {
        var eq = opt ? opt[1] : caml_equal;
        return [
            0,
            eq,
            nil,
            Srcs[1],
            0,
            v,
            0,
            function(_dH_, param) {
                return 0;
            }
        ];
    }
    function eq(c) {
        return c[1];
    }
    function set_eq(c, eq) {
        c[1] = eq;
        return 0;
    }
    function with_eq(eq, c) {
        return [
            0,
            eq,
            c[2],
            c[3],
            c[4],
            c[5],
            c[6],
            c[7]
        ];
    }
    function stamp(c) {
        return c[2];
    }
    function set_stamp(c, stamp) {
        c[2] = stamp;
        return 0;
    }
    function srcs_changed(c) {
        return c[4];
    }
    function set_srcs_changed(c, bool) {
        c[4] = bool;
        return 0;
    }
    function srcs(c) {
        return c[3];
    }
    function set_srcs(c, srcs) {
        c[4] = 1;
        c[3] = srcs;
        return 0;
    }
    function value(c) {
        return c[5];
    }
    function value_changed(c) {
        return c[6];
    }
    function set_value(c, v) {
        return caml_call2(c[1], v, c[5]) ? 0 : (c[6] = 1, c[5] = v, 0);
    }
    function update(step, c) {
        var _dE_ = step !== nil ? 1 : 0, _dF_ = _dE_ ? c[2] !== step ? 1 : 0 : _dE_;
        if (!_dF_) return _dF_;
        c[2] = step;
        c[4] = 0;
        c[6] = 0;
        var _dG_ = caml_call2(Srcs[6], c[3], step[1]);
        return caml_call1(Srcs[30], _dG_) ? 0 : caml_call2(c[7], step, c);
    }
    function set_update(c, u) {
        c[7] = u;
        return 0;
    }
    function src_update(step, c, v) {
        c[6] = 0;
        return caml_call2(c[1], v, c[5]) ? 0 : (c[2] = step, c[6] = 1, c[5] = v, 1);
    }
    function up_to_date_value(c) {
        var step = caml_call2(Src[9], nil, c[3]);
        update(step, c);
        return c[5];
    }
    function reset_instant(c) {
        c[6] = 0;
        c[5] = 0;
        return 0;
    }
    function set_instant(step, c, v) {
        return v ? (c[6] = 1, c[5] = v, add_cleanup(step, function(param) {
            return reset_instant(c);
        })) : 0;
    }
    function create_instant(step, srcs, value, update) {
        var value_changed = value ? 1 : 0, c = [
            0,
            caml_equal,
            step,
            srcs,
            1,
            value,
            value_changed,
            update
        ], _dD_ = value_changed ? runtime.caml_notequal(step, nil) : value_changed;
        if (_dD_) add_cleanup(step, function(param) {
            return reset_instant(c);
        });
        return c;
    }
    function delay(i, z) {
        return caml_call1(Stdlib[2], cst_TOOD);
    }
    function fix(eq, i, cf) {
        var src = caml_call2(Src[10], eq, i), src$0 = [
            0,
            src
        ], d = caml_call1(Src[3], src), match = caml_call1(cf, d), r = match[2], c = match[1], c_update = c[7];
        function c_update$0(step, self1) {
            caml_call2(c_update, step, self1);
            var _dC_ = c[6];
            return _dC_ ? add_delayed(step, src$0) : _dC_;
        }
        function d_update(step, self1) {
            return step === delayed ? set_value(self1, c[5]) : 0;
        }
        c[7] = c_update$0;
        d[7] = d_update;
        var _dB_ = caml_call1(C[8], c), step = caml_call2(Src[9], nil, _dB_);
        update(step, c);
        if (step === nil) execute_delayed(caml_call1(Srcs[3], src$0));
        return r;
    }
    function defer(init, c) {
        var src = caml_call2(Src[10], [
            0,
            c[1]
        ], init), src$0 = [
            0,
            src
        ], d = caml_call1(Src[3], src);
        function update(step, self1) {
            if (step === delayed) return set_value(self1, c[5]);
            caml_call2(C[15], step, c);
            if (caml_call1(C[9], c)) {
                var _dz_ = caml_call1(C[8], c);
                caml_call2(C[10], d, _dz_);
            }
            var _dA_ = caml_call1(C[13], c);
            return _dA_ ? add_delayed(step, src$0) : _dA_;
        }
        d[7] = update;
        var step = caml_call2(Src[9], nil, c[3]);
        update(step, c);
        update(step, d);
        if (step === nil) execute_delayed(caml_call1(Srcs[3], src$0));
        return d;
    }
    function dump_src_ids(ppf, c) {
        var _dw_ = caml_call1(Srcs[10], c[3]), _dx_ = caml_call2(Stdlib_List[20], function(s) {
            return caml_call1(Src[2], s);
        }, _dw_), _dy_ = caml_call2(Stdlib_Format[132], [
            0,
            Stdlib_Format[28]
        ], Stdlib_Format[19]);
        return caml_call4(Stdlib_Format[139], ppf, _a_, _dy_, _dx_);
    }
    caml_call3(CamlinternalMod[2], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ], C, [
        0,
        create$2,
        const$0,
        eq,
        set_eq,
        with_eq,
        stamp,
        set_stamp,
        srcs,
        srcs_changed,
        set_srcs,
        set_srcs_changed,
        value,
        value_changed,
        set_value,
        update,
        set_update,
        src_update,
        up_to_date_value,
        create_instant,
        reset_instant,
        set_instant,
        delay,
        fix,
        defer,
        dump_src_ids
    ]);
    function const$1(v) {
        return [
            0,
            0,
            function(param) {
                return v;
            }
        ];
    }
    function obs_cell(c) {
        return [
            0,
            [
                0,
                [
                    0,
                    c
                ],
                0
            ],
            function(param) {
                return caml_call1(C[12], c);
            }
        ];
    }
    function app(_du_, param) {
        var v = param[2], vcs = param[1], f = _du_[2], fcs = _du_[1];
        return [
            0,
            caml_call2(Stdlib_List[13], fcs, vcs),
            function(param) {
                var _dv_ = caml_call1(v, 0);
                return caml_call1(caml_call1(f, 0), _dv_);
            }
        ];
    }
    function update_srcs(l) {
        function add_cell(acc, param) {
            var c = param[1], _dt_ = caml_call1(C[8], c);
            return caml_call2(Srcs[5], acc, _dt_);
        }
        var new_srcs = caml_call3(Stdlib_List[26], add_cell, Srcs[1], l[3]), rems = caml_call2(Srcs[8], l[2], new_srcs), adds = caml_call2(Srcs[8], new_srcs, l[2]), _dr_ = caml_call1(Src[7], l);
        caml_call2(Srcs[23], _dr_, rems);
        var _ds_ = caml_call1(Src[6], l);
        caml_call2(Srcs[23], _ds_, adds);
        l[2] = new_srcs;
        return;
    }
    function update$0(step, l) {
        var _dp_ = step !== nil ? 1 : 0, _dq_ = _dp_ ? step !== l[1] ? 1 : 0 : _dp_;
        if (!_dq_) return _dq_;
        l[1] = step;
        var srcs_changed = 0, value_changed = 0, param = l[3];
        for(;;){
            if (!param) {
                if (srcs_changed) update_srcs(l);
                return value_changed ? caml_call1(l[4], 0) : value_changed;
            }
            var cs = param[2], c = param[1][1];
            caml_call2(C[15], step, c);
            var value_changed$0 = value_changed || caml_call1(C[13], c), srcs_changed$0 = srcs_changed || caml_call1(C[9], c);
            srcs_changed = srcs_changed$0;
            value_changed = value_changed$0;
            param = cs;
        }
    }
    function force(l) {
        var step = caml_call2(Src[9], nil, l[2]);
        update$0(step, l);
        return caml_call1(l[4], 0);
    }
    function create$3(opt, param) {
        var now = opt ? opt[1] : 1, log = param[2], cells = param[1], l = [
            0,
            nil,
            Srcs[1],
            cells,
            log
        ];
        update_srcs(l);
        if (now) force(l);
        return l;
    }
    function for_cell(now, c, log) {
        return create$3(now, [
            0,
            [
                0,
                [
                    0,
                    c
                ],
                0
            ],
            function(param) {
                return caml_call1(log, caml_call1(C[12], c));
            }
        ]);
    }
    function destroy(l) {
        var _dn_ = l[2], _do_ = caml_call1(Src[7], l);
        return caml_call2(Srcs[23], _do_, _dn_);
    }
    var held = [
        0,
        0
    ];
    function hold(l) {
        held[1] = [
            0,
            l,
            held[1]
        ];
        return 0;
    }
    function may_hold(param) {
        if (!param) return 0;
        var l = param[1];
        return hold(l);
    }
    function unhold_all(param) {
        caml_call2(Stdlib_List[18], destroy, held[1]);
        held[1] = 0;
        return 0;
    }
    caml_call3(CamlinternalMod[2], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ], Logr, [
        0,
        const$1,
        obs_cell,
        app,
        app,
        create$3,
        for_cell,
        force,
        destroy,
        update$0,
        hold,
        may_hold,
        unhold_all
    ]);
    var obs = Logr[2];
    function log(now, e, f) {
        function wrap(param) {
            if (!param) return 0;
            var v = param[1];
            return caml_call1(f, v);
        }
        return [
            0,
            caml_call3(Logr[6], now, e, wrap)
        ];
    }
    function create$4(param) {
        var src = caml_call2(Src[10], 0, 0);
        function send(step, v) {
            if (step) var step$0 = step[1], exec = 0, step$1 = step$0;
            else var step$2 = create$0(0), exec = 1, step$1 = step$2;
            var _dl_ = caml_call1(Src[3], src);
            caml_call2(C[7], _dl_, step$1);
            var _dm_ = caml_call1(Src[3], src);
            caml_call3(C[21], step$1, _dm_, [
                0,
                v
            ]);
            add_src(step$1, caml_call1(Src[4], src));
            return exec ? execute(step$1) : exec;
        }
        return [
            0,
            caml_call1(Src[3], src),
            send
        ];
    }
    var value$0 = C[18], never = caml_call2(C[2], 0, 0), cst_option_is_None = cst_option_is_None$1;
    function bind(e, f) {
        var _c9_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _c9_);
        caml_call2(C[15], step, e);
        var match = caml_call1(C[12], e);
        if (match) var curr = match[1], current = caml_call1(f, curr);
        else var current = never;
        var current$0 = [
            0,
            current
        ];
        function update(step, self1) {
            caml_call2(C[15], step, e);
            var match = caml_call1(C[12], e);
            if (match) {
                var curr = match[1];
                current$0[1] = caml_call1(f, curr);
                caml_call2(C[15], step, current$0[1]);
                var _db_ = caml_call1(C[8], current$0[1]), _dc_ = caml_call1(C[8], e), _dd_ = caml_call2(Srcs[5], _dc_, _db_);
                caml_call2(C[10], self1, _dd_);
                var _de_ = caml_call1(C[12], current$0[1]);
                return caml_call3(C[21], step, self1, _de_);
            }
            caml_call2(C[15], step, current$0[1]);
            var _df_ = caml_call1(C[9], e), _dg_ = _df_ || caml_call1(C[9], current$0[1]);
            if (_dg_) {
                var _dh_ = caml_call1(C[8], current$0[1]), _di_ = caml_call1(C[8], e), _dj_ = caml_call2(Srcs[5], _di_, _dh_);
                caml_call2(C[10], self1, _dj_);
            }
            var _dk_ = caml_call1(C[12], current$0[1]);
            return caml_call3(C[21], step, self1, _dk_);
        }
        var _c__ = caml_call1(C[8], current$0[1]), step$0 = caml_call2(Src[9], step, _c__);
        caml_call2(C[15], step$0, current$0[1]);
        var _c$_ = caml_call1(C[8], current$0[1]), _da_ = caml_call1(C[8], e), srcs = caml_call2(Srcs[5], _da_, _c$_), init = caml_call1(C[12], current$0[1]);
        return caml_call4(C[19], step$0, srcs, init, update);
    }
    function join(ee) {
        return bind(ee, function(e) {
            return e;
        });
    }
    function swap(es) {
        var _cW_ = caml_call1(C[8], es), step = caml_call2(Src[9], nil, _cW_);
        caml_call2(C[15], step, es);
        var current = [
            0,
            caml_call1(C[12], es)
        ];
        function update(step, self1) {
            caml_call2(C[15], step, es);
            if (caml_call1(C[13], es)) {
                current[1] = caml_call1(C[12], es);
                caml_call2(C[15], step, current[1]);
                var _c0_ = caml_call1(C[8], current[1]), _c1_ = caml_call1(C[8], es), _c2_ = caml_call2(Srcs[5], _c1_, _c0_);
                caml_call2(C[10], self1, _c2_);
            } else {
                caml_call2(C[15], step, current[1]);
                var _c4_ = caml_call1(C[9], es), _c5_ = _c4_ || caml_call1(C[9], current[1]);
                if (_c5_) {
                    var _c6_ = caml_call1(C[8], current[1]), _c7_ = caml_call1(C[8], es), _c8_ = caml_call2(Srcs[5], _c7_, _c6_);
                    caml_call2(C[10], self1, _c8_);
                }
            }
            var _c3_ = caml_call1(C[12], current[1]);
            return caml_call3(C[21], step, self1, _c3_);
        }
        var _cX_ = caml_call1(C[8], current[1]), step$0 = caml_call2(Src[9], step, _cX_);
        caml_call2(C[15], step$0, current[1]);
        var _cY_ = caml_call1(C[8], current[1]), _cZ_ = caml_call1(C[8], es), srcs = caml_call2(Srcs[5], _cZ_, _cY_), init = caml_call1(C[12], current[1]);
        return caml_call4(C[19], step$0, srcs, init, update);
    }
    function map(f, e) {
        function map(f, param) {
            if (!param) return 0;
            var v = param[1];
            return [
                0,
                caml_call1(f, v)
            ];
        }
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _cU_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _cU_);
            }
            var _cV_ = map(f, caml_call1(C[12], e));
            return caml_call3(C[21], step, self1, _cV_);
        }
        var _cR_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _cR_);
        caml_call2(C[15], step, e);
        var _cS_ = map(f, caml_call1(C[12], e)), _cT_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _cT_, _cS_, update);
    }
    function stamp$0(e, v) {
        function stamp(param) {
            return param ? [
                0,
                v
            ] : 0;
        }
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _cP_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _cP_);
            }
            var _cQ_ = stamp(caml_call1(C[12], e));
            return caml_call3(C[21], step, self1, _cQ_);
        }
        var _cN_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _cN_);
        caml_call2(C[15], step, e);
        var init = stamp(caml_call1(C[12], e)), _cO_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _cO_, init, update);
    }
    function filter(f, e) {
        function filter(f, occ) {
            if (!occ) return 0;
            var v = occ[1];
            return caml_call1(f, v) ? occ : 0;
        }
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _cL_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _cL_);
            }
            var _cM_ = filter(f, caml_call1(C[12], e));
            return caml_call3(C[21], step, self1, _cM_);
        }
        var _cJ_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _cJ_);
        caml_call2(C[15], step, e);
        var init = filter(f, caml_call1(C[12], e)), _cK_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _cK_, init, update);
    }
    function filter_map(f, e) {
        function filter_map(f, param) {
            if (!param) return 0;
            var v = param[1];
            return caml_call1(f, v);
        }
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _cH_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _cH_);
            }
            var _cI_ = filter_map(f, caml_call1(C[12], e));
            return caml_call3(C[21], step, self1, _cI_);
        }
        var _cF_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _cF_);
        caml_call2(C[15], step, e);
        var init = filter_map(f, caml_call1(C[12], e)), _cG_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _cG_, init, update);
    }
    function select(es) {
        function add_srcs(acc, e) {
            var _cE_ = caml_call1(C[8], e);
            return caml_call2(Srcs[5], acc, _cE_);
        }
        function or_srcs_changed(acc, e) {
            return acc ? acc : caml_call1(C[9], e);
        }
        function update(step, self1) {
            var _cA_ = caml_call1(C[15], step);
            caml_call2(Stdlib_List[18], _cA_, es);
            var srcs_changed = caml_call3(Stdlib_List[26], or_srcs_changed, 0, es);
            if (srcs_changed) {
                var _cB_ = caml_call3(Stdlib_List[26], add_srcs, Srcs[1], es);
                caml_call2(C[10], self1, _cB_);
            }
            a: {
                try {
                    var e = caml_call2(Stdlib_List[39], function(e) {
                        return 0 !== caml_call1(C[12], e) ? 1 : 0;
                    }, es);
                } catch (_cD_) {
                    var _cC_ = caml_wrap_exception(_cD_);
                    if (_cC_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_cC_, 0);
                    var v = 0;
                    break a;
                }
                var v = caml_call1(C[12], e);
            }
            return caml_call3(C[21], step, self1, v);
        }
        function find_step(step, e) {
            var _cz_ = caml_call1(C[8], e);
            return caml_call2(Src[9], step, _cz_);
        }
        var step = caml_call3(Stdlib_List[26], find_step, nil, es), _cw_ = caml_call1(C[15], step);
        caml_call2(Stdlib_List[18], _cw_, es);
        a: {
            try {
                var e = caml_call2(Stdlib_List[39], function(e) {
                    return 0 !== caml_call1(C[12], e) ? 1 : 0;
                }, es);
            } catch (_cy_) {
                var _cx_ = caml_wrap_exception(_cy_);
                if (_cx_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_cx_, 0);
                var init = 0;
                break a;
            }
            var init = caml_call1(C[12], e);
        }
        var srcs = caml_call3(Stdlib_List[26], add_srcs, Srcs[1], es);
        return caml_call4(C[19], step, srcs, init, update);
    }
    function accum(acc, e) {
        var acc$0 = [
            0,
            acc
        ];
        function accum(param) {
            if (!param) return 0;
            var f = param[1];
            acc$0[1] = caml_call1(f, acc$0[1]);
            return [
                0,
                acc$0[1]
            ];
        }
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _cu_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _cu_);
            }
            var _cv_ = accum(caml_call1(C[12], e));
            return caml_call3(C[21], step, self1, _cv_);
        }
        var _cs_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _cs_);
        caml_call2(C[15], step, e);
        var init = accum(caml_call1(C[12], e)), _ct_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _ct_, init, update);
    }
    function until(opt, next, e) {
        var limit = opt ? opt[1] : 0;
        function nop(step, self1) {
            return 0;
        }
        function update(step, self1) {
            caml_call2(C[15], step, next);
            caml_call2(C[15], step, e);
            if (caml_call1(C[12], next)) {
                caml_call2(C[10], self1, Srcs[1]);
                caml_call2(C[16], self1, nop);
                var _cl_ = limit ? caml_call1(C[12], e) : 0;
                return caml_call3(C[21], step, self1, _cl_);
            }
            var _cm_ = caml_call1(C[9], next), _cn_ = _cm_ || caml_call1(C[9], e);
            if (_cn_) {
                var _co_ = caml_call1(C[8], e), _cp_ = caml_call1(C[8], next), _cq_ = caml_call2(Srcs[5], _cp_, _co_);
                caml_call2(C[10], self1, _cq_);
            }
            var _cr_ = caml_call1(C[12], e);
            return caml_call3(C[21], step, self1, _cr_);
        }
        var _cg_ = caml_call1(C[8], next), step = caml_call2(Src[9], nil, _cg_), _ch_ = caml_call1(C[8], e), step$0 = caml_call2(Src[9], step, _ch_);
        caml_call2(C[15], step$0, next);
        caml_call2(C[15], step$0, e);
        if (caml_call1(C[12], next)) {
            var init = limit ? caml_call1(C[12], e) : 0;
            return caml_call4(C[19], step$0, Srcs[1], init, nop);
        }
        var _ci_ = caml_call1(C[8], e), _cj_ = caml_call1(C[8], next), srcs = caml_call2(Srcs[5], _cj_, _ci_), _ck_ = caml_call1(C[12], e);
        return caml_call4(C[19], step$0, srcs, _ck_, update);
    }
    function follow(e, on) {
        function deps_srcs(e, on) {
            var _ce_ = caml_call1(C[8], on), _cf_ = caml_call1(C[8], e);
            return caml_call2(Srcs[5], _cf_, _ce_);
        }
        function update_deps(step, e, on) {
            caml_call2(C[15], step, e);
            return caml_call2(C[15], step, on);
        }
        function follow(e, on) {
            if (e && on) return e;
            return 0;
        }
        function update(step, self1) {
            update_deps(step, e, on);
            var _b$_ = caml_call1(C[9], e), _ca_ = _b$_ || caml_call1(C[9], on);
            if (_ca_) {
                var _cb_ = deps_srcs(e, on);
                caml_call2(C[10], self1, _cb_);
            }
            var _cc_ = caml_call1(C[12], on), _cd_ = follow(caml_call1(C[12], e), _cc_);
            return caml_call3(C[21], step, self1, _cd_);
        }
        var _b7_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _b7_), _b8_ = caml_call1(C[8], on), step$0 = caml_call2(Src[9], step, _b8_);
        update_deps(step$0, e, on);
        var _b9_ = caml_call1(C[12], on), init = follow(caml_call1(C[12], e), _b9_), _b__ = deps_srcs(e, on);
        return caml_call4(C[19], step$0, _b__, init, update);
    }
    function defer$0(e) {
        return caml_call2(C[24], 0, e);
    }
    function fix$0(ef) {
        return caml_call3(C[23], 0, 0, ef);
    }
    function on_some(e) {
        return filter_map(function(x) {
            return x;
        }, e);
    }
    function some(e) {
        return map(function(v) {
            return [
                0,
                v
            ];
        }, e);
    }
    function value$1(e, default$0) {
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _b6_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _b6_);
            }
            var match = caml_call1(C[12], e);
            if (match) var v = match[1], v$0 = v || (caml_call2(C[15], step, default$0), [
                0,
                caml_call1(C[12], default$0)
            ]), occ = v$0;
            else var occ = 0;
            return caml_call3(C[21], step, self1, occ);
        }
        var _b4_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _b4_);
        caml_call2(C[15], step, e);
        caml_call2(C[15], step, default$0);
        var match = caml_call1(C[12], e);
        if (match) var v = match[1], v$0 = v || [
            0,
            caml_call1(C[12], default$0)
        ], init = v$0;
        else var init = 0;
        var _b5_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _b5_, init, update);
    }
    function get(e) {
        return map(function(param) {
            if (!param) return caml_call1(Stdlib[1], cst_option_is_None);
            var v = param[1];
            return v;
        }, e);
    }
    function bind$0(e, f) {
        return map(function(param) {
            if (!param) return 0;
            var v = param[1];
            return caml_call1(f, v);
        }, e);
    }
    function join$0(e) {
        return map(function(param) {
            if (param) {
                var o = param[1];
                if (o) return o;
            }
            return 0;
        }, e);
    }
    function is_none(e) {
        return map(function(param) {
            return param ? 0 : 1;
        }, e);
    }
    function is_some(e) {
        return map(function(param) {
            return param ? 1 : 0;
        }, e);
    }
    function map$0(f, e) {
        return map(function(param) {
            if (!param) return 0;
            var v = param[1];
            return [
                0,
                caml_call1(f, v)
            ];
        }, e);
    }
    function fst(e) {
        return map(function(_b3_) {
            return _b3_[1];
        }, e);
    }
    function snd(e) {
        return map(function(_b2_) {
            return _b2_[2];
        }, e);
    }
    function v(e0, e1) {
        function update(step, self1) {
            caml_call2(C[15], step, e0);
            caml_call2(C[15], step, e1);
            var _bX_ = caml_call1(C[9], e0), _bY_ = _bX_ || caml_call1(C[9], e1);
            if (_bY_) {
                var _bZ_ = caml_call1(C[8], e1), _b0_ = caml_call1(C[8], e0), _b1_ = caml_call2(Srcs[5], _b0_, _bZ_);
                caml_call2(C[10], self1, _b1_);
            }
            var match = caml_call1(C[12], e0), match$0 = caml_call1(C[12], e1);
            a: {
                if (match && match$0) {
                    var v1 = match$0[1], v0 = match[1], occ = [
                        0,
                        [
                            0,
                            v0,
                            v1
                        ]
                    ];
                    break a;
                }
                var occ = 0;
            }
            return caml_call3(C[21], step, self1, occ);
        }
        var _bT_ = caml_call1(C[8], e0), step = caml_call2(Src[9], nil, _bT_), _bU_ = caml_call1(C[8], e1), step$0 = caml_call2(Src[9], step, _bU_), _bV_ = caml_call1(C[8], e1), _bW_ = caml_call1(C[8], e0), srcs = caml_call2(Srcs[5], _bW_, _bV_), match = caml_call1(C[12], e0), match$0 = caml_call1(C[12], e1);
        a: {
            if (match && match$0) {
                var v1 = match$0[1], v0 = match[1], init = [
                    0,
                    [
                        0,
                        v0,
                        v1
                    ]
                ];
                break a;
            }
            var init = 0;
        }
        return caml_call4(C[19], step$0, srcs, init, update);
    }
    var Pair = [
        0,
        fst,
        snd,
        v
    ], dump_src_ids$0 = C[25], log$0 = Logr[6], obs$0 = Logr[2], eq$0 = C[3], with_eq$0 = C[5];
    function create$5(eq, v) {
        var src = caml_call2(Src[10], eq, v);
        function set(step, v) {
            if (step) var step$0 = step[1], exec = 0, step$1 = step$0;
            else var step$2 = create$0(0), exec = 1, step$1 = step$2;
            var cell = caml_call1(Src[3], src);
            if (caml_call3(C[17], step$1, cell, v)) add_src(step$1, caml_call1(Src[4], src));
            return exec ? execute(step$1) : exec;
        }
        return [
            0,
            caml_call1(Src[3], src),
            set
        ];
    }
    var value$2 = C[18], rough_value = C[12], const$2 = C[2];
    function bind$1(v, f) {
        var _bC_ = caml_call1(C[8], v), step = caml_call2(Src[9], nil, _bC_);
        caml_call2(C[15], step, v);
        var current = [
            0,
            caml_call1(f, caml_call1(C[12], v))
        ];
        function update(step, self1) {
            caml_call2(C[15], step, v);
            if (caml_call1(C[13], v)) {
                current[1] = caml_call1(f, caml_call1(C[12], v));
                caml_call2(C[15], step, current[1]);
                var _bH_ = caml_call1(C[3], current[1]);
                caml_call2(C[4], self1, _bH_);
                var _bI_ = caml_call1(C[8], current[1]), _bJ_ = caml_call1(C[8], v), _bK_ = caml_call2(Srcs[5], _bJ_, _bI_);
                caml_call2(C[10], self1, _bK_);
                var _bL_ = caml_call1(C[12], current[1]);
                return caml_call2(C[14], self1, _bL_);
            }
            caml_call2(C[15], step, current[1]);
            var _bM_ = caml_call1(C[9], v), _bN_ = _bM_ || caml_call1(C[9], current[1]);
            if (_bN_) {
                var _bO_ = caml_call1(C[8], current[1]), _bP_ = caml_call1(C[8], v), _bQ_ = caml_call2(Srcs[5], _bP_, _bO_);
                caml_call2(C[10], self1, _bQ_);
            }
            var _bR_ = caml_call1(C[13], current[1]);
            if (!_bR_) return _bR_;
            var _bS_ = caml_call1(C[12], current[1]);
            return caml_call2(C[14], self1, _bS_);
        }
        var _bD_ = caml_call1(C[8], current[1]), step$0 = caml_call2(Src[9], step, _bD_);
        caml_call2(C[15], step$0, current[1]);
        var _bE_ = caml_call1(C[8], current[1]), _bF_ = caml_call1(C[8], v), srcs = caml_call2(Srcs[5], _bF_, _bE_), init = caml_call1(C[12], current[1]), _bG_ = [
            0,
            caml_call1(C[3], current[1])
        ];
        return caml_call5(C[1], _bG_, step$0, srcs, init, update);
    }
    function hold$0(eq, i, e) {
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _bB_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _bB_);
            }
            var match = caml_call1(C[12], e);
            if (!match) return 0;
            var v = match[1];
            return caml_call2(C[14], self1, v);
        }
        var _bz_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _bz_);
        caml_call2(C[15], step, e);
        var match = caml_call1(C[12], e);
        if (match) var v = match[1], init = v;
        else var init = i;
        var _bA_ = caml_call1(C[8], e);
        return caml_call5(C[1], eq, step, _bA_, init, update);
    }
    function join$1(ss) {
        return bind$1(ss, function(s) {
            return s;
        });
    }
    function swap$0(s, se) {
        return join$1(hold$0([
            0,
            function(_by_, _bx_) {
                return _by_ === _bx_ ? 1 : 0;
            }
        ], s, se));
    }
    function changes(s) {
        function update(step, self1) {
            caml_call2(C[15], step, s);
            if (caml_call1(C[9], s)) {
                var _bu_ = caml_call1(C[8], s);
                caml_call2(C[10], self1, _bu_);
            }
            var _bv_ = caml_call1(C[13], s);
            if (!_bv_) return _bv_;
            var _bw_ = [
                0,
                caml_call1(C[12], s)
            ];
            return caml_call3(C[21], step, self1, _bw_);
        }
        var _bs_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _bs_);
        caml_call2(C[15], step, s);
        var _bt_ = caml_call1(C[8], s);
        return caml_call4(C[19], step, _bt_, 0, update);
    }
    function sample(s, on, f) {
        function update(step, self1) {
            caml_call2(C[15], step, on);
            caml_call2(C[15], step, s);
            var _bm_ = caml_call1(C[9], on), _bn_ = _bm_ || caml_call1(C[9], s);
            if (_bn_) {
                var _bo_ = caml_call1(C[8], on), _bp_ = caml_call1(C[8], s), _bq_ = caml_call2(Srcs[5], _bp_, _bo_);
                caml_call2(C[10], self1, _bq_);
            }
            var match = caml_call1(C[12], on);
            if (!match) return 0;
            var v = match[1], _br_ = [
                0,
                caml_call2(f, caml_call1(C[12], s), v)
            ];
            return caml_call3(C[21], step, self1, _br_);
        }
        var _bi_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _bi_), _bj_ = caml_call1(C[8], on), step$0 = caml_call2(Src[9], step, _bj_);
        caml_call2(C[15], step$0, on);
        caml_call2(C[15], step$0, s);
        var _bk_ = caml_call1(C[8], on), _bl_ = caml_call1(C[8], s), srcs = caml_call2(Srcs[5], _bl_, _bk_), match = caml_call1(C[12], on);
        if (match) var v = match[1], init = [
            0,
            caml_call2(f, caml_call1(C[12], s), v)
        ];
        else var init = 0;
        return caml_call4(C[19], step$0, srcs, init, update);
    }
    function sample_filter(s, on, f) {
        return on_some(sample(s, on, f));
    }
    function snapshot(s, on) {
        return sample(s, on, function(v, param) {
            return v;
        });
    }
    function map$1(eq, f, v) {
        function update(step, self1) {
            caml_call2(C[15], step, v);
            if (caml_call1(C[9], v)) {
                var _bf_ = caml_call1(C[8], v);
                caml_call2(C[10], self1, _bf_);
            }
            var _bg_ = caml_call1(C[13], v);
            if (!_bg_) return _bg_;
            var _bh_ = caml_call1(f, caml_call1(C[12], v));
            return caml_call2(C[14], self1, _bh_);
        }
        var _bc_ = caml_call1(C[8], v), step = caml_call2(Src[9], nil, _bc_);
        caml_call2(C[15], step, v);
        var _bd_ = caml_call1(f, caml_call1(C[12], v)), _be_ = caml_call1(C[8], v);
        return caml_call5(C[1], eq, step, _be_, _bd_, update);
    }
    function app$0(eq, f, v) {
        function update(step, self1) {
            caml_call2(C[15], step, f);
            caml_call2(C[15], step, v);
            var _a5_ = caml_call1(C[9], f), _a6_ = _a5_ || caml_call1(C[9], v);
            if (_a6_) {
                var _a7_ = caml_call1(C[8], v), _a8_ = caml_call1(C[8], f), _a9_ = caml_call2(Srcs[5], _a8_, _a7_);
                caml_call2(C[10], self1, _a9_);
            }
            var _a__ = caml_call1(C[13], f), _a$_ = _a__ || caml_call1(C[13], v);
            if (!_a$_) return _a$_;
            var _ba_ = caml_call1(C[12], v), _bb_ = caml_call1(caml_call1(C[12], f), _ba_);
            return caml_call2(C[14], self1, _bb_);
        }
        var _a0_ = caml_call1(C[8], f), step = caml_call2(Src[9], nil, _a0_), _a1_ = caml_call1(C[8], v), step$0 = caml_call2(Src[9], step, _a1_);
        caml_call2(C[15], step$0, f);
        caml_call2(C[15], step$0, v);
        var _a2_ = caml_call1(C[8], v), _a3_ = caml_call1(C[8], f), srcs = caml_call2(Srcs[5], _a3_, _a2_), _a4_ = caml_call1(C[12], v), init = caml_call1(caml_call1(C[12], f), _a4_);
        return caml_call5(C[1], eq, step$0, srcs, init, update);
    }
    function accum$0(eq, i, e) {
        return hold$0(eq, i, accum(i, e));
    }
    function until$0(opt, init, next, s) {
        var limit = opt ? opt[1] : 0;
        function nop(step, self1) {
            return 0;
        }
        function update(step, self1) {
            caml_call2(C[15], step, next);
            caml_call2(C[15], step, s);
            if (caml_call1(C[12], next)) {
                caml_call2(C[10], self1, Srcs[1]);
                caml_call2(C[16], self1, nop);
                if (!limit) return 0;
                var _aT_ = caml_call1(C[12], s);
                return caml_call2(C[14], self1, _aT_);
            }
            var _aU_ = caml_call1(C[9], next), _aV_ = _aU_ || caml_call1(C[9], s);
            if (_aV_) {
                var _aW_ = caml_call1(C[8], s), _aX_ = caml_call1(C[8], next), _aY_ = caml_call2(Srcs[5], _aX_, _aW_);
                caml_call2(C[10], self1, _aY_);
            }
            var _aZ_ = caml_call1(C[12], s);
            return caml_call2(C[14], self1, _aZ_);
        }
        var _aL_ = caml_call1(C[8], next), step = caml_call2(Src[9], nil, _aL_), _aM_ = caml_call1(C[8], s), step$0 = caml_call2(Src[9], step, _aM_);
        caml_call2(C[15], step$0, next);
        caml_call2(C[15], step$0, s);
        if (!caml_call1(C[12], next)) {
            var _aP_ = caml_call1(C[8], s), _aQ_ = caml_call1(C[8], next), srcs = caml_call2(Srcs[5], _aQ_, _aP_), _aR_ = caml_call1(C[12], s), _aS_ = [
                0,
                caml_call1(eq$0, s)
            ];
            return caml_call5(C[1], _aS_, step$0, srcs, _aR_, update);
        }
        if (init) var i = init[1], init$0 = i;
        else var init$0 = caml_call1(C[12], s);
        var _aN_ = Srcs[1], _aO_ = [
            0,
            caml_call1(eq$0, s)
        ];
        return caml_call5(C[1], _aO_, step$0, _aN_, init$0, nop);
    }
    function follow$0(init, s, on) {
        function deps_srcs(s, on) {
            var _aJ_ = caml_call1(C[8], on), _aK_ = caml_call1(C[8], s);
            return caml_call2(Srcs[5], _aK_, _aJ_);
        }
        function update_deps(step, s, on) {
            caml_call2(C[15], step, s);
            return caml_call2(C[15], step, on);
        }
        function update(step, self1) {
            update_deps(step, s, on);
            var _aE_ = caml_call1(C[9], s), _aF_ = _aE_ || caml_call1(C[9], on);
            if (_aF_) {
                var _aG_ = deps_srcs(s, on);
                caml_call2(C[10], self1, _aG_);
            }
            var _aH_ = caml_call1(C[12], on);
            if (!_aH_) return _aH_;
            var _aI_ = caml_call1(C[12], s);
            return caml_call2(C[14], self1, _aI_);
        }
        var _aA_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _aA_), _aB_ = caml_call1(C[8], on), step$0 = caml_call2(Src[9], step, _aB_);
        update_deps(step$0, s, on);
        if (init) var i = init[1], init$0 = i;
        else var init$0 = caml_call1(C[12], s);
        var _aC_ = deps_srcs(s, on), _aD_ = [
            0,
            caml_call1(eq$0, s)
        ];
        return caml_call5(C[1], _aD_, step$0, _aC_, init$0, update);
    }
    var delay$0 = C[22];
    function defer$1(init, s) {
        if (init) var init$0 = init[1], init$1 = init$0;
        else {
            var _az_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _az_);
            caml_call2(C[15], step, s);
            var init$1 = caml_call1(C[12], s);
        }
        return caml_call2(C[24], init$1, s);
    }
    var fix$1 = C[23];
    function l1(eq, f, x) {
        return map$1(eq, f, x);
    }
    function l2(eq, f, x, y) {
        function update(step, self1) {
            caml_call2(C[15], step, x);
            caml_call2(C[15], step, y);
            var _aq_ = caml_call1(C[9], x), _ar_ = _aq_ || caml_call1(C[9], y);
            if (_ar_) {
                var _as_ = caml_call1(C[8], y), _at_ = caml_call1(C[8], x), _au_ = caml_call2(Srcs[5], _at_, _as_);
                caml_call2(C[10], self1, _au_);
            }
            var _av_ = caml_call1(C[13], x), _aw_ = _av_ || caml_call1(C[13], y);
            if (!_aw_) return _aw_;
            var _ax_ = caml_call1(C[12], y), _ay_ = caml_call2(f, caml_call1(C[12], x), _ax_);
            return caml_call2(C[14], self1, _ay_);
        }
        var _al_ = caml_call1(C[8], x), step = caml_call2(Src[9], nil, _al_), _am_ = caml_call1(C[8], y), step$0 = caml_call2(Src[9], step, _am_);
        caml_call2(C[15], step$0, x);
        caml_call2(C[15], step$0, y);
        var _an_ = caml_call1(C[8], y), _ao_ = caml_call1(C[8], x), srcs = caml_call2(Srcs[5], _ao_, _an_), _ap_ = caml_call1(C[12], y), init = caml_call2(f, caml_call1(C[12], x), _ap_);
        return caml_call5(C[1], eq, step$0, srcs, init, update);
    }
    function l3(eq, f, x, y, z) {
        function srcs_union(x, y, z) {
            var _ah_ = caml_call1(C[8], z), _ai_ = caml_call1(C[8], y), _aj_ = caml_call2(Srcs[5], _ai_, _ah_), _ak_ = caml_call1(C[8], x);
            return caml_call2(Srcs[5], _ak_, _aj_);
        }
        function update(step, self1) {
            caml_call2(C[15], step, x);
            caml_call2(C[15], step, y);
            caml_call2(C[15], step, z);
            var _Z_ = caml_call1(C[9], x);
            if (_Z_) var ___ = _Z_;
            else var _ag_ = caml_call1(C[9], y), ___ = _ag_ || caml_call1(C[9], z);
            if (___) {
                var _$_ = srcs_union(x, y, z);
                caml_call2(C[10], self1, _$_);
            }
            var _aa_ = caml_call1(C[13], x);
            if (_aa_) var _ab_ = _aa_;
            else var _af_ = caml_call1(C[13], y), _ab_ = _af_ || caml_call1(C[13], z);
            if (!_ab_) return _ab_;
            var _ac_ = caml_call1(C[12], z), _ad_ = caml_call1(C[12], y), _ae_ = caml_call3(f, caml_call1(C[12], x), _ad_, _ac_);
            return caml_call2(C[14], self1, _ae_);
        }
        var _U_ = caml_call1(C[8], x), step = caml_call2(Src[9], nil, _U_), _V_ = caml_call1(C[8], y), step$0 = caml_call2(Src[9], step, _V_), _W_ = caml_call1(C[8], z), step$1 = caml_call2(Src[9], step$0, _W_);
        caml_call2(C[15], step$1, x);
        caml_call2(C[15], step$1, y);
        caml_call2(C[15], step$1, z);
        var srcs = srcs_union(x, y, z), _X_ = caml_call1(C[12], z), _Y_ = caml_call1(C[12], y), init = caml_call3(f, caml_call1(C[12], x), _Y_, _X_);
        return caml_call5(C[1], eq, step$1, srcs, init, update);
    }
    function eq$1(_T_1, _S_) {
        return _T_1 === _S_ ? 1 : 0;
    }
    var false$0 = caml_call2(const$2, 0, 0), true$0 = caml_call2(const$2, 0, 1);
    function not(s) {
        return map$1([
            0,
            eq$1
        ], function(_R_) {
            return 1 - _R_;
        }, s);
    }
    function _b_(_P_, _O_) {
        var _Q_ = _P_ ? _O_ : _P_;
        return _Q_;
    }
    var _c_ = 0;
    function symbol(_M_, _N_) {
        return l2(_c_, _b_, _M_, _N_);
    }
    function _d_(_K_, _J_) {
        var _L_ = _K_ || _J_;
        return _L_;
    }
    var _e_ = 0, _f_ = [
        0,
        0
    ];
    function symbol$0(_H_, _I_) {
        return l2(_e_, _d_, _H_, _I_);
    }
    function edge(s) {
        return changes(s);
    }
    function edge_detect(edge, s) {
        function update(step, self1) {
            caml_call2(C[15], step, s);
            if (caml_call1(C[9], s)) {
                var _E_ = caml_call1(C[8], s);
                caml_call2(C[10], self1, _E_);
            }
            var _F_ = caml_call1(C[13], s), _G_ = _F_ ? caml_equal(caml_call1(C[12], s), edge) : _F_;
            return _G_ ? caml_call3(C[21], step, self1, _f_) : _G_;
        }
        var _C_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _C_);
        caml_call2(C[15], step, s);
        var _D_ = caml_call1(C[8], s);
        return caml_call4(C[19], step, _D_, 0, update);
    }
    function rise(s) {
        return edge_detect(1, s);
    }
    function fall(s) {
        return edge_detect(0, s);
    }
    function flip(init, e) {
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _A_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _A_);
            }
            if (!caml_call1(C[12], e)) return 0;
            var _B_ = 1 - caml_call1(C[12], self1);
            return caml_call2(C[14], self1, _B_);
        }
        var _y_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _y_);
        caml_call2(C[15], step, e);
        var init$0 = caml_call1(C[12], e) ? 1 - init : init, _z_ = caml_call1(C[8], e);
        return caml_call5(C[1], [
            0,
            eq$1
        ], step, _z_, init$0, update);
    }
    function eq$2(eq) {
        return function(v0, v1) {
            if (v0) {
                if (v1) {
                    var v1$0 = v1[1], v0$0 = v0[1];
                    return caml_call2(eq, v0$0, v1$0);
                }
            } else if (!v1) return 1;
            return 0;
        };
    }
    var none = caml_call2(const$2, 0, 0), cst_option_is_None$0 = cst_option_is_None$1;
    function some$0(s) {
        return map$1([
            0,
            eq$2(caml_call1(eq$0, s))
        ], function(v) {
            return [
                0,
                v
            ];
        }, s);
    }
    function hold_value(i, s) {
        function update(step, self1) {
            caml_call2(C[15], step, s);
            if (caml_call1(C[9], s)) {
                var _x_ = caml_call1(C[8], s);
                caml_call2(C[10], self1, _x_);
            }
            var match = caml_call1(C[12], s);
            if (!match) return 0;
            var v = match[1];
            return caml_call2(C[14], self1, v);
        }
        function eq(v$0, v) {
            return caml_call3(C[3], s, [
                0,
                v$0
            ], [
                0,
                v
            ]);
        }
        var _v_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _v_);
        caml_call2(C[15], step, s);
        var match = caml_call1(C[12], s);
        if (match) var v = match[1], init = v;
        else var init = i;
        var _w_ = caml_call1(C[8], s);
        return caml_call5(C[1], [
            0,
            eq
        ], step, _w_, init, update);
    }
    function value$3(s, default$0) {
        function update(step, self1) {
            caml_call2(C[15], step, default$0);
            caml_call2(C[15], step, s);
            var _n_ = caml_call1(C[9], default$0), _o_ = _n_ || caml_call1(C[9], s);
            if (_o_) {
                var _p_ = caml_call1(C[8], s), _q_ = caml_call1(C[8], default$0), _r_ = caml_call2(Srcs[5], _q_, _p_);
                caml_call2(C[10], self1, _r_);
            }
            var _s_ = caml_call1(C[13], default$0), _t_ = _s_ || caml_call1(C[13], s);
            if (!_t_) return _t_;
            var match = caml_call1(C[12], s);
            if (match) {
                var v = match[1];
                return caml_call2(C[14], self1, v);
            }
            var _u_ = caml_call1(C[12], default$0);
            return caml_call2(C[14], self1, _u_);
        }
        var _i_ = caml_call1(C[8], default$0), step = caml_call2(Src[9], nil, _i_), _j_ = caml_call1(C[8], s), step$0 = caml_call2(Src[9], step, _j_);
        caml_call2(C[15], step$0, default$0);
        caml_call2(C[15], step$0, s);
        var match = caml_call1(C[12], s);
        if (match) var v = match[1], init = v;
        else var init = caml_call1(C[12], default$0);
        var _k_ = caml_call1(C[8], s), _l_ = caml_call1(C[8], default$0), srcs = caml_call2(Srcs[5], _l_, _k_), _m_ = [
            0,
            caml_call1(eq$0, default$0)
        ];
        return caml_call5(C[1], _m_, step$0, srcs, init, update);
    }
    function get$0(eq, s) {
        return map$1(eq, function(param) {
            if (!param) return caml_call1(Stdlib[1], cst_option_is_None$0);
            var v = param[1];
            return v;
        }, s);
    }
    function bind$2(eq, s, f) {
        return map$1(eq, function(param) {
            if (!param) return 0;
            var v = param[1];
            return caml_call1(f, v);
        }, s);
    }
    function join$2(eq, s) {
        return map$1(eq, function(param) {
            if (param) {
                var o = param[1];
                if (o) return o;
            }
            return 0;
        }, s);
    }
    function is_none$0(s) {
        return map$1([
            0,
            eq$1
        ], function(param) {
            return param ? 0 : 1;
        }, s);
    }
    function is_some$0(s) {
        return map$1([
            0,
            eq$1
        ], function(param) {
            return param ? 1 : 0;
        }, s);
    }
    function map$2(eq, f, s) {
        return map$1(eq, function(param) {
            if (!param) return 0;
            var v = param[1];
            return [
                0,
                caml_call1(f, v)
            ];
        }, s);
    }
    function fst$0(eq, s) {
        return map$1(eq, function(_h_) {
            return _h_[1];
        }, s);
    }
    function snd$0(eq, s) {
        return map$1(eq, function(_g_) {
            return _g_[2];
        }, s);
    }
    function v$0(s0, s1) {
        return l2(0, function(x, y) {
            return [
                0,
                x,
                y
            ];
        }, s0, s1);
    }
    var Pair$0 = [
        0,
        fst$0,
        snd$0,
        v$0
    ], dump_src_ids$1 = C[25], Note = [
        0,
        [
            0,
            create$0,
            execute
        ],
        [
            0,
            Logr[1],
            Logr[3],
            Logr[4],
            Logr[5],
            Logr[7],
            Logr[8],
            Logr[10],
            Logr[11],
            Logr[12]
        ],
        [
            0,
            obs,
            log,
            create$4,
            value$0,
            never,
            bind,
            join,
            swap,
            map,
            stamp$0,
            filter,
            filter_map,
            select,
            accum,
            until,
            follow,
            defer$0,
            fix$0,
            [
                0,
                on_some,
                some,
                value$1,
                get,
                bind$0,
                join$0,
                map$0,
                is_none,
                is_some
            ],
            Pair,
            dump_src_ids$0
        ],
        [
            0,
            obs$0,
            log$0,
            create$5,
            eq$0,
            with_eq$0,
            value$2,
            rough_value,
            const$2,
            hold$0,
            bind$1,
            join$1,
            swap$0,
            changes,
            map$1,
            app$0,
            sample,
            sample_filter,
            snapshot,
            accum$0,
            until$0,
            follow$0,
            defer$1,
            delay$0,
            fix$1,
            l1,
            l2,
            l3,
            [
                0,
                false$0,
                true$0,
                not,
                symbol,
                symbol$0,
                edge,
                rise,
                fall,
                flip
            ],
            [
                0,
                eq$2,
                hold_value,
                none,
                some$0,
                value$3,
                get$0,
                bind$2,
                join$2,
                map$2,
                is_none$0,
                is_some$0
            ],
            Pair$0,
            dump_src_ids$1
        ]
    ];
    runtime.caml_register_global(21, Note, "Note");
    return;
})(globalThis);
//# 1 "../.js/default/note.brr/note_brr.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/note.brr/note_brr.cma.js"
//# 6 "../.js/default/note.brr/note_brr.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_brr_add$1 = "brr_add", cst_brr_rem$1 = "brr_rem", cst_length$3 = "length", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), cst = "*", cst_brr_rem = cst_brr_rem$1, Note = global_data.Note, Brr = global_data.Brr, Jv = global_data.Jv, Stdlib_List = global_data.Stdlib__List, Jstr = global_data.Jstr, Assert_failure = global_data.Assert_failure, Fut = global_data.Fut, _a_ = [
        0,
        "src/brr/note_brr.ml",
        23,
        16
    ], _b_ = [
        0,
        1
    ];
    function to_event(f) {
        var match = caml_call1(Note[3][3], 0), send_e = match[2], e = match[1];
        function send_e$0(v) {
            caml_call1(caml_call1(Brr[16][8], 0), function(param) {
                return caml_call2(send_e, 0, v);
            });
            return 0;
        }
        caml_call2(Fut[2], f, send_e$0);
        return e;
    }
    function of_event(e) {
        var match = caml_call1(Fut[1], 0), set_fut = match[2], fut = match[1], logr = [
            0,
            0
        ];
        function set_fut$0(v) {
            caml_call1(caml_call1(Brr[16][8], 0), function(param) {
                var match = logr[1];
                if (!match) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _a_
                ], 1);
                var logr$0 = match[1];
                caml_call1(Note[2][6], logr$0);
                return caml_call1(set_fut, v);
            });
            return 0;
        }
        var s = caml_call3(Note[3][2], _b_, e, set_fut$0);
        return s ? (logr[1] = s, [
            0,
            fut
        ]) : 0;
    }
    var Futr = [
        0,
        to_event,
        of_event
    ];
    function tick(param) {
        return [
            0,
            "tick",
            0
        ];
    }
    function log_value(_x_, opt, id, x) {
        var l = _x_ ? _x_[1] : Brr[12][14], v = opt ? opt[1] : function(v) {
            return [
                0,
                v,
                0
            ];
        }, _y_ = caml_call1(v, x);
        caml_call1(l, [
            0,
            caml_call2(Jstr[8], runtime.caml_jsstring_of_string(id), ":"),
            _y_
        ]);
        return x;
    }
    function log(opt, l, v, id, e) {
        var obs = opt ? opt[1] : 0;
        if (!obs) return caml_call2(Note[3][9], function(_w_) {
            return log_value(l, v, id, _w_);
        }, e);
        var _v_ = caml_call3(Note[3][2], 0, e, function(ev) {
            log_value(l, v, id, ev);
            return 0;
        });
        caml_call1(Note[2][8], _v_);
        return e;
    }
    var E = [
        0,
        log
    ];
    function log$0(opt, l, v, id, s) {
        var obs = opt ? opt[1] : 0;
        if (obs) {
            var _s_ = caml_call3(Note[4][2], 0, s, function(sv) {
                log_value(l, v, id, sv);
                return 0;
            });
            caml_call1(Note[2][7], _s_);
            return s;
        }
        var _t_ = [
            0,
            caml_call1(Note[4][4], s)
        ];
        return caml_call3(Note[4][14], _t_, function(_u_) {
            return log_value(l, v, id, _u_);
        }, s);
    }
    var S = [
        0,
        log$0
    ], Consoler = [
        0,
        tick,
        log_value,
        E,
        S
    ], cst_length = cst_length$3, cst_length$0 = cst_length$3, cst_length$1 = cst_length$3, cst_length$2 = cst_length$3, cst_brr_rem$0 = cst_brr_rem$1, cst_brr_add$0 = cst_brr_add$1;
    function instruct(_r_, opt, e) {
        var propagate = _r_ ? _r_[1] : 1, default$0 = opt ? opt[1] : 1;
        if (!default$0) caml_call1(Brr[7][13], e);
        return propagate ? 0 : caml_call1(Brr[7][10], e);
    }
    function endless_listen(opt, propagate, default$0, t, type, f) {
        var capture = opt ? opt[1] : 0, opts = capture ? [
            0,
            caml_call4(Brr[7][19], [
                0,
                capture
            ], 0, 0, 0)
        ] : 0;
        function f$0(ev) {
            instruct(propagate, default$0, ev);
            return caml_call1(f, ev);
        }
        caml_call4(Brr[7][20], opts, type, f$0, t);
        return 0;
    }
    function on_target(opt, propagate, default$0, type, f, t) {
        var capture = opt ? opt[1] : 0, opts = capture ? [
            0,
            caml_call4(Brr[7][19], [
                0,
                capture
            ], 0, 0, 0)
        ] : 0, match = caml_call1(Note[3][3], 0), send_e = match[2], e = match[1];
        function f$0(ev) {
            instruct(propagate, default$0, ev);
            return caml_call2(send_e, 0, caml_call1(f, ev));
        }
        caml_call4(Brr[7][20], opts, type, f$0, t);
        return e;
    }
    function on_targets(opt, propagate, default$0, type, f, ts) {
        var capture = opt ? opt[1] : 0, opts = capture ? [
            0,
            caml_call4(Brr[7][19], [
                0,
                capture
            ], 0, 0, 0)
        ] : 0, match = caml_call1(Note[3][3], 0), send_e = match[2], e = match[1];
        function f$0(ev) {
            instruct(propagate, default$0, ev);
            return caml_call2(send_e, 0, caml_call2(f, caml_call1(Brr[7][5], ev), ev));
        }
        caml_call2(Stdlib_List[18], function(t) {
            caml_call4(Brr[7][20], opts, type, f$0, t);
            return 0;
        }, ts);
        return e;
    }
    function on_el(capture, propagate, default$0, type, f, el) {
        return on_target(capture, propagate, default$0, type, f, el);
    }
    function on_els(opt, propagate, default$0, type, f, els) {
        var capture = opt ? opt[1] : 0, opts = capture ? [
            0,
            caml_call4(Brr[7][19], [
                0,
                capture
            ], 0, 0, 0)
        ] : 0, match = caml_call1(Note[3][3], 0), send_e = match[2], e = match[1];
        function f$0(ev) {
            instruct(propagate, default$0, ev);
            return caml_call2(send_e, 0, caml_call2(f, caml_call1(Brr[7][5], ev), ev));
        }
        caml_call2(Stdlib_List[18], function(el) {
            caml_call4(Brr[7][20], opts, type, f$0, el);
            return 0;
        }, els);
        return e;
    }
    function unit(e) {
        return 0;
    }
    function stamp(v, e) {
        return v;
    }
    function listen(opt, propagate, default$0, t, type, f) {
        var capture = opt ? opt[1] : 0, opts = capture ? [
            0,
            caml_call4(Brr[7][19], [
                0,
                capture
            ], 0, 0, 0)
        ] : 0;
        function f$0(ev) {
            instruct(propagate, default$0, ev);
            return caml_call1(f, ev);
        }
        var k = caml_call4(Brr[7][20], opts, type, f$0, t);
        return function(param) {
            return caml_call1(Brr[7][21], k);
        };
    }
    function add_xxx_fun(xxx, f, e) {
        var fs = e[xxx], fs$0 = caml_call1(Jv[7], fs) ? [
            0,
            f,
            0
        ] : [
            0,
            f,
            fs
        ];
        return e[xxx] = fs$0;
    }
    function invoke_funs(xxx, node) {
        var star = caml_call1(Jv[24], cst);
        if (!caml_call1(Brr[9][7], node)) return;
        function invoke_node_funs(n) {
            var funs = n[xxx];
            caml_call2(Stdlib_List[18], function(f) {
                return caml_call1(f, 0);
            }, funs);
            n[xxx] = 0;
            return;
        }
        var ns = node.querySelectorAll(star), _p_ = caml_call2(Jv[20][2], ns, cst_length) - 1 | 0, _o_ = 0;
        if (_p_ >= 0) {
            var i = _o_;
            for(;;){
                var n = ns.item(i);
                invoke_node_funs(n);
                var _q_ = i + 1 | 0;
                if (_p_ === i) break;
                i = _q_;
            }
        }
        return invoke_node_funs(node);
    }
    function obs(records, obs) {
        function in_html_dom(n) {
            var _n_ = Brr[16][2];
            return n.getRootNode() === _n_ ? 1 : 0;
        }
        var _f_ = caml_call2(Jv[20][2], records, cst_length$0) - 1 | 0, _e_ = 0;
        if (_f_ >= 0) {
            var i = _e_;
            for(;;){
                var r = records[i], adds = r["addedNodes"], _h_ = caml_call2(Jv[20][2], adds, cst_length$1) - 1 | 0, _g_ = 0;
                if (_h_ >= 0) {
                    var i$1 = _g_;
                    for(;;){
                        var n$0 = adds.item(i$1);
                        if (in_html_dom(n$0)) invoke_funs(cst_brr_add$0, n$0);
                        var _m_ = i$1 + 1 | 0;
                        if (_h_ === i$1) break;
                        i$1 = _m_;
                    }
                }
                var rems = r["removedNodes"], _j_ = caml_call2(Jv[20][2], rems, cst_length$2) - 1 | 0, _i_ = 0;
                if (_j_ >= 0) {
                    var i$0 = _i_;
                    for(;;){
                        var n = rems.item(i$0);
                        if (1 - in_html_dom(n)) invoke_funs(cst_brr_rem$0, n);
                        var _l_ = i$0 + 1 | 0;
                        if (_j_ === i$0) break;
                        i$0 = _l_;
                    }
                }
                var _k_ = i + 1 | 0;
                if (_f_ === i) break;
                i = _k_;
            }
        }
        return 0;
    }
    var mutation_observer = Jv[12]["MutationObserver"];
    a: {
        var cst_brr_add = cst_brr_add$1;
        if (!caml_call1(Jv[8], mutation_observer) && !caml_call1(Jv[8], Brr[16][2])) {
            var obs$0 = new mutation_observer(runtime.caml_js_wrap_callback_strict(2, obs)), opts = {
                childList: Jv[17],
                subtree: Jv[17]
            }, root = caml_call1(Brr[10][4], Brr[16][2]);
            obs$0.observe(root, opts);
            break a;
        }
    }
    function add_logr(e, l) {
        return add_xxx_fun(cst_brr_rem, function(param) {
            return caml_call1(Note[2][6], l);
        }, e);
    }
    function may_add_logr(e, param) {
        if (!param) return 0;
        var l = param[1];
        return add_logr(e, l);
    }
    function set_children(e, on) {
        var _d_ = caml_call1(Brr[9][18], e);
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, _d_));
    }
    function def_children(e, cs) {
        var _c_ = caml_call1(Brr[9][18], e);
        return add_logr(e, caml_call3(Note[4][2], 0, cs, _c_));
    }
    function set_at(a, on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call3(Brr[9][26], a, v, e);
        }));
    }
    function def_at(a, vs, e) {
        return add_logr(e, caml_call3(Note[4][2], 0, vs, function(v) {
            return caml_call3(Brr[9][26], a, v, e);
        }));
    }
    function set_class(c, on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call3(Brr[9][31], c, v, e);
        }));
    }
    function def_class(c, bs, e) {
        return add_logr(e, caml_call3(Note[4][2], 0, bs, function(v) {
            return caml_call3(Brr[9][31], c, v, e);
        }));
    }
    function set_prop(p, on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call3(Brr[9][29], p, v, e);
        }));
    }
    function def_prop(p, vs, e) {
        return add_logr(e, caml_call3(Note[4][2], 0, vs, function(v) {
            return caml_call3(Brr[9][29], p, v, e);
        }));
    }
    function set_inline_style(important, p, on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call4(Brr[9][35], important, p, v, e);
        }));
    }
    function def_inline_style(important, p, vs, e) {
        return add_logr(e, caml_call3(Note[4][2], 0, vs, function(v) {
            return caml_call4(Brr[9][35], important, p, v, e);
        }));
    }
    function set_has_focus(on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call2(Brr[9][51], v, e);
        }));
    }
    function def_has_focus(b, e) {
        return add_logr(e, caml_call3(Note[4][2], 0, b, function(v) {
            return caml_call2(Brr[9][51], v, e);
        }));
    }
    function on_add(f, e) {
        return add_xxx_fun(cst_brr_add, f, e);
    }
    function on_rem(f, e) {
        return add_xxx_fun(cst_brr_rem, f, e);
    }
    function call(f, on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call2(f, v, e);
        }));
    }
    function hold_logr(e, l) {
        return add_logr(e, l);
    }
    function may_hold_logr(e, l) {
        return may_add_logr(e, l);
    }
    var Note_brr = [
        0,
        Futr,
        Consoler,
        [
            0,
            on_target,
            on_targets,
            on_el,
            on_els,
            unit,
            stamp,
            instruct,
            listen,
            endless_listen
        ],
        [
            0,
            set_children,
            def_children,
            set_at,
            def_at,
            set_prop,
            def_prop,
            set_class,
            def_class,
            set_inline_style,
            def_inline_style,
            set_has_focus,
            def_has_focus,
            on_add,
            on_rem,
            call,
            hold_logr,
            may_hold_logr
        ]
    ];
    runtime.caml_register_global(33, Note_brr, "Note_brr");
    return;
})(globalThis);
//# 1 "../.js/default/ppx_inline_test.config/inline_test_config.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_inline_test.config/inline_test_config.cma.js"
//# 5 "../.js/default/ppx_inline_test.config/inline_test_config.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function pre_test_hook(_a_) {
        return 0;
    }
    var Inline_test_config = [
        0,
        pre_test_hook
    ];
    runtime.caml_register_global(0, Inline_test_config, "Inline_test_config");
    return;
})(globalThis);
//# 1 "../.js/default/base.base_internalhash_types/base_internalhash_types.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/base.base_internalhash_types/base_internalhash_types.cma.js"
//# 5 "../.js/default/base.base_internalhash_types/base_internalhash_types.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_internalhash_types = [
        0
    ];
    runtime.caml_register_global(0, Base_internalhash_types, "Base_internalhash_types");
    return;
})(globalThis);
//# 1 "../.js/default/sexplib0/sexplib0.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/sexplib0/sexplib0.cma.js"
//# 19 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$11 = "(", cst$12 = "()", cst$13 = ")", caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_fresh_oo_id = runtime.caml_fresh_oo_id, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_string_unsafe_get = runtime.caml_string_unsafe_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$2 = cst$11, cst$3 = cst$12, cst$4 = cst$13, cst$5 = " ", cst$6 = cst$11, cst$7 = cst$12, cst$8 = cst$13, cst$10 = cst$12, cst$9 = cst$12, cst = "\\", cst$0 = ' "', cst$1 = '"', Stdlib_StringLabels = global_data.Stdlib__StringLabels, Stdlib_ListLabels = global_data.Stdlib__ListLabels, Stdlib_Format = global_data.Stdlib__Format, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_BytesLabels = global_data.Stdlib__BytesLabels, Stdlib_Char = global_data.Stdlib__Char, Stdlib_Bytes = global_data.Stdlib__Bytes;
    function sexp_of_t(t) {
        return t;
    }
    function t_of_sexp(t) {
        return t;
    }
    function compare(a$0, b$0) {
        if (a$0 === b$0) return 0;
        if (0 === a$0[0]) {
            var a$1 = a$0[1];
            if (0 !== b$0[0]) return -1;
            var b$1 = b$0[1];
            return caml_call2(Stdlib_StringLabels[10], a$1, b$1);
        }
        var a$2 = a$0[1];
        if (0 === b$0[0]) return 1;
        var b$2 = b$0[1], a = a$2, b = b$2;
        for(;;){
            if (!a) return b ? -1 : 0;
            if (!b) return 1;
            var ys = b[2], y = b[1], xs = a[2], x = a[1], res = compare(x, y);
            if (0 !== res) return res;
            a = xs;
            b = ys;
        }
    }
    function equal(a, b) {
        var _D_ = a === b ? 1 : 0;
        if (_D_) var _E_ = _D_;
        else {
            if (0 === a[0]) {
                var a$0 = a[1];
                if (0 === b[0]) {
                    var b$0 = b[1];
                    return caml_call2(Stdlib_StringLabels[9], a$0, b$0);
                }
            } else {
                var a$1 = a[1];
                if (0 !== b[0]) {
                    var b$1 = b[1];
                    return caml_call3(Stdlib_ListLabels[16], equal, a$1, b$1);
                }
            }
            var _E_ = 0;
        }
        return _E_;
    }
    var Not_found_s = [
        248,
        "Sexplib0__Sexp.Not_found_s",
        caml_fresh_oo_id(0)
    ], Of_sexp_error = [
        248,
        "Sexplib0__Sexp.Of_sexp_error",
        caml_fresh_oo_id(0)
    ], default_indent = [
        0,
        1
    ], cst_n = "\\n", _a_ = [
        0,
        0,
        0
    ], _b_ = [
        0,
        [
            15,
            [
                17,
                2,
                0
            ]
        ],
        "%a@?"
    ];
    function must_escape(str) {
        var len = caml_ml_string_length(str), _t_ = 0 === len ? 1 : 0;
        if (_t_) return _t_;
        var ix$1 = len - 1 | 0, ix = ix$1;
        for(;;){
            var match = caml_string_get(str, ix);
            a: {
                b: {
                    if (92 <= match) {
                        var switcher = match - 93 | 0;
                        if (33 < switcher >>> 0) {
                            if (0 <= switcher) break a;
                            break b;
                        }
                        if (31 === switcher) {
                            var _u_ = 0 < ix ? 1 : 0;
                            if (_u_) {
                                var next = ix - 1 | 0, _v_ = caml_string_get(str, next), _w_ = caml_call2(Stdlib_Char[6], _v_, 35);
                                if (!_w_) {
                                    ix = next;
                                    continue;
                                }
                                var _x_ = _w_;
                            } else var _x_ = _u_;
                            return _x_;
                        }
                    } else if (42 <= match) {
                        if (59 === match) break b;
                    } else {
                        if (33 > match) break a;
                        switch(match - 33 | 0){
                            case 2:
                                var _z_ = 0 < ix ? 1 : 0;
                                if (_z_) {
                                    var next$0 = ix - 1 | 0, _A_ = caml_string_get(str, next$0), _B_ = caml_call2(Stdlib_Char[6], _A_, 124);
                                    if (!_B_) {
                                        ix = next$0;
                                        continue;
                                    }
                                    var _C_ = _B_;
                                } else var _C_ = _z_;
                                return _C_;
                            case 1:
                            case 7:
                            case 8:
                                break b;
                        }
                    }
                    var _y_ = 0 < ix ? 1 : 0;
                    if (!_y_) return _y_;
                    var ix$0 = ix - 1 | 0;
                    ix = ix$0;
                    continue;
                }
                return 1;
            }
            return 1;
        }
    }
    function escaped(s) {
        var n = [
            0,
            0
        ], _j_ = caml_ml_string_length(s) - 1 | 0, _i_ = 0;
        if (_j_ >= 0) {
            var i$0 = _i_;
            for(;;){
                var match = caml_string_unsafe_get(s, i$0);
                a: {
                    b: {
                        c: {
                            if (32 <= match) {
                                var _q_ = match - 34 | 0;
                                if (58 < _q_ >>> 0) {
                                    if (93 <= _q_) break c;
                                } else if (56 < _q_ - 1 >>> 0) break b;
                                var _r_ = 1;
                                break a;
                            }
                            if (11 <= match) {
                                if (13 === match) break b;
                            } else if (8 <= match) break b;
                        }
                        var _r_ = 4;
                        break a;
                    }
                    var _r_ = 2;
                }
                n[1] = n[1] + _r_ | 0;
                var _s_ = i$0 + 1 | 0;
                if (_j_ === i$0) break;
                i$0 = _s_;
            }
        }
        if (n[1] === caml_ml_string_length(s)) return s;
        var s$0 = caml_create_bytes(n[1]);
        n[1] = 0;
        var _l_ = caml_ml_string_length(s) - 1 | 0, _k_ = 0;
        if (_l_ >= 0) {
            var i = _k_;
            for(;;){
                var c = caml_string_unsafe_get(s, i);
                a: {
                    b: {
                        c: {
                            if (35 <= c) {
                                if (92 !== c) {
                                    if (127 <= c) break c;
                                    break b;
                                }
                            } else {
                                if (32 > c) {
                                    if (14 <= c) break c;
                                    switch(c){
                                        case 8:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 98);
                                            break a;
                                        case 9:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 116);
                                            break a;
                                        case 10:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 110);
                                            break a;
                                        case 13:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 114);
                                            break a;
                                        default:
                                            break c;
                                    }
                                }
                                if (34 > c) break b;
                            }
                            caml_bytes_unsafe_set(s$0, n[1], 92);
                            n[1]++;
                            caml_bytes_unsafe_set(s$0, n[1], c);
                            break a;
                        }
                        caml_bytes_unsafe_set(s$0, n[1], 92);
                        n[1]++;
                        var _n_ = caml_call1(Stdlib_Char[1], 48 + (c / 100 | 0) | 0);
                        caml_bytes_unsafe_set(s$0, n[1], _n_);
                        n[1]++;
                        var _o_ = caml_call1(Stdlib_Char[1], 48 + ((c / 10 | 0) % 10 | 0) | 0);
                        caml_bytes_unsafe_set(s$0, n[1], _o_);
                        n[1]++;
                        var _p_ = caml_call1(Stdlib_Char[1], 48 + (c % 10 | 0) | 0);
                        caml_bytes_unsafe_set(s$0, n[1], _p_);
                        break a;
                    }
                    caml_bytes_unsafe_set(s$0, n[1], c);
                }
                n[1]++;
                var _m_ = i + 1 | 0;
                if (_l_ === i) break;
                i = _m_;
            }
        }
        return caml_call1(Stdlib_BytesLabels[44], s$0);
    }
    function esc_str(str) {
        var estr = escaped(str), elen = caml_ml_string_length(estr), res = caml_create_bytes(elen + 2 | 0);
        caml_call5(Stdlib_Bytes[12], estr, 0, res, 1, elen);
        caml_bytes_unsafe_set(res, 0, 34);
        caml_bytes_unsafe_set(res, elen + 1 | 0, 34);
        return caml_call1(Stdlib_BytesLabels[44], res);
    }
    function index_of_newline(str, start) {
        return caml_call3(Stdlib_StringLabels[33], str, start, 10);
    }
    function mach_maybe_esc_str(str) {
        return must_escape(str) ? esc_str(str) : str;
    }
    function pp_hum_indent(indent, ppf, param) {
        if (0 === param[0]) {
            var str = param[1];
            if (!must_escape(str)) return caml_call2(Stdlib_Format[13], ppf, str);
            var match = index_of_newline(str, 0);
            if (match) var index = match[1], _f_ = (index + 1 | 0) === caml_ml_string_length(str) ? 1 : 0;
            else var _f_ = 1;
            if (_f_) {
                var _g_ = esc_str(str);
                return caml_call2(Stdlib_Format[13], ppf, _g_);
            }
            caml_call2(Stdlib_Format[1], ppf, 0);
            caml_call2(Stdlib_Format[13], ppf, cst$0);
            var index$0 = 0;
            for(;;){
                var next_newline = index_of_newline(str, index$0);
                if (next_newline) var end_pos = next_newline[1], end_pos$0 = end_pos;
                else var end_pos$0 = caml_ml_string_length(str);
                var next_line = caml_call3(Stdlib_StringLabels[16], str, index$0, end_pos$0 - index$0 | 0), _h_ = escaped(next_line);
                caml_call2(Stdlib_Format[13], ppf, _h_);
                if (!next_newline) {
                    caml_call2(Stdlib_Format[13], ppf, cst$1);
                    return caml_call2(Stdlib_Format[3], ppf, 0);
                }
                var newline_index = next_newline[1];
                caml_call2(Stdlib_Format[13], ppf, cst);
                caml_call2(Stdlib_Format[35], ppf, 0);
                caml_call2(Stdlib_Format[13], ppf, cst_n);
                var index$1 = newline_index + 1 | 0;
                index$0 = index$1;
            }
        } else {
            var match$0 = param[1];
            if (!match$0) return caml_call2(Stdlib_Format[13], ppf, cst$3);
            var t = match$0[2], h = match$0[1];
            caml_call2(Stdlib_Format[1], ppf, indent);
            caml_call2(Stdlib_Format[13], ppf, cst$2);
            pp_hum_indent(indent, ppf, h);
            var param$0 = t;
            for(;;){
                if (!param$0) {
                    caml_call2(Stdlib_Format[13], ppf, cst$4);
                    return caml_call2(Stdlib_Format[3], ppf, 0);
                }
                var t$0 = param$0[2], h$0 = param$0[1];
                caml_call2(Stdlib_Format[28], ppf, 0);
                pp_hum_indent(indent, ppf, h$0);
                param$0 = t$0;
            }
        }
    }
    function pp_mach_internal(may_need_space, ppf, param) {
        if (0 === param[0]) {
            var str = param[1], str$0 = mach_maybe_esc_str(str), new_may_need_space = str$0 === str ? 1 : 0, new_may_need_space$0 = may_need_space ? new_may_need_space : may_need_space;
            if (new_may_need_space$0) caml_call2(Stdlib_Format[13], ppf, cst$5);
            caml_call2(Stdlib_Format[13], ppf, str$0);
            return new_may_need_space;
        }
        var match = param[1];
        if (!match) {
            caml_call2(Stdlib_Format[13], ppf, cst$7);
            return 0;
        }
        var t = match[2], h = match[1];
        caml_call2(Stdlib_Format[13], ppf, cst$6);
        var may_need_space$0 = pp_mach_internal(0, ppf, h), may_need_space$1 = may_need_space$0, param$0 = t;
        for(;;){
            if (!param$0) {
                caml_call2(Stdlib_Format[13], ppf, cst$8);
                return 0;
            }
            var t$0 = param$0[2], h$0 = param$0[1], may_need_space$2 = pp_mach_internal(may_need_space$1, ppf, h$0);
            may_need_space$1 = may_need_space$2;
            param$0 = t$0;
        }
    }
    function pp_hum(ppf, sexp) {
        return pp_hum_indent(default_indent[1], ppf, sexp);
    }
    function pp_mach(ppf, sexp) {
        pp_mach_internal(0, ppf, sexp);
        return 0;
    }
    function size_loop(acc, param) {
        var c = acc[2], v = acc[1];
        if (0 === param[0]) {
            var str = param[1];
            return [
                0,
                v + 1 | 0,
                c + caml_ml_string_length(str) | 0
            ];
        }
        var lst = param[1];
        return caml_call3(Stdlib_ListLabels[26], size_loop, acc, lst);
    }
    function size(sexp) {
        return size_loop(_a_, sexp);
    }
    function to_buffer_hum(buf, opt, sexp) {
        var indent = opt ? opt[1] : default_indent[1], ppf = caml_call1(Stdlib_Format[116], buf);
        return caml_call4(Stdlib_Format[139], ppf, _b_, function(_d_, _e_) {
            return pp_hum_indent(indent, _d_, _e_);
        }, sexp);
    }
    function to_buffer_mach(buf, sexp) {
        function loop(may_need_space, param) {
            if (0 === param[0]) {
                var str = param[1], str$0 = mach_maybe_esc_str(str), new_may_need_space = str$0 === str ? 1 : 0, new_may_need_space$0 = may_need_space ? new_may_need_space : may_need_space;
                if (new_may_need_space$0) caml_call2(Stdlib_Buffer[12], buf, 32);
                caml_call2(Stdlib_Buffer[16], buf, str$0);
                return new_may_need_space;
            }
            var match = param[1];
            if (!match) {
                caml_call2(Stdlib_Buffer[16], buf, cst$9);
                return 0;
            }
            var t = match[2], h = match[1];
            caml_call2(Stdlib_Buffer[12], buf, 40);
            var may_need_space$0 = loop(0, h), may_need_space$1 = may_need_space$0, param$0 = t;
            for(;;){
                if (!param$0) {
                    caml_call2(Stdlib_Buffer[12], buf, 41);
                    return 0;
                }
                var t$0 = param$0[2], h$0 = param$0[1], may_need_space$2 = loop(may_need_space$1, h$0);
                may_need_space$1 = may_need_space$2;
                param$0 = t$0;
            }
        }
        loop(0, sexp);
        return 0;
    }
    function to_buffer_gen(buf, add_char, add_string, sexp) {
        function loop(may_need_space, param) {
            if (0 === param[0]) {
                var str = param[1], str$0 = mach_maybe_esc_str(str), new_may_need_space = str$0 === str ? 1 : 0, new_may_need_space$0 = may_need_space ? new_may_need_space : may_need_space;
                if (new_may_need_space$0) caml_call2(add_char, buf, 32);
                caml_call2(add_string, buf, str$0);
                return new_may_need_space;
            }
            var match = param[1];
            if (!match) {
                caml_call2(add_string, buf, cst$10);
                return 0;
            }
            var t = match[2], h = match[1];
            caml_call2(add_char, buf, 40);
            var may_need_space$0 = loop(0, h), may_need_space$1 = may_need_space$0, param$0 = t;
            for(;;){
                if (!param$0) {
                    caml_call2(add_char, buf, 41);
                    return 0;
                }
                var t$0 = param$0[2], h$0 = param$0[1], may_need_space$2 = loop(may_need_space$1, h$0);
                may_need_space$1 = may_need_space$2;
                param$0 = t$0;
            }
        }
        loop(0, sexp);
        return 0;
    }
    function buffer(param) {
        return caml_call1(Stdlib_Buffer[1], 1024);
    }
    function to_string_hum(indent, sexp) {
        if (0 === sexp[0]) {
            var str = sexp[1], _c_ = index_of_newline(str, 0) ? 0 : 1;
            if (_c_) return mach_maybe_esc_str(str);
        }
        var buf = buffer(0);
        to_buffer_hum(buf, indent, sexp);
        return caml_call1(Stdlib_Buffer[2], buf);
    }
    function to_string_mach(sexp) {
        if (0 === sexp[0]) {
            var str = sexp[1];
            return mach_maybe_esc_str(str);
        }
        var buf = buffer(0);
        to_buffer_mach(buf, sexp);
        return caml_call1(Stdlib_Buffer[2], buf);
    }
    var of_float_style = [
        0,
        1009018843
    ], of_int_style = [
        0,
        1009018843
    ];
    function message(name, fields) {
        function conv_fields(param) {
            if (!param) return 0;
            var rest = param[2], match = param[1], fsexp = match[2], fname = match[1];
            return fname !== "" ? [
                0,
                [
                    1,
                    [
                        0,
                        [
                            0,
                            fname
                        ],
                        [
                            0,
                            fsexp,
                            0
                        ]
                    ]
                ],
                conv_fields(rest)
            ] : [
                0,
                fsexp,
                conv_fields(rest)
            ];
        }
        return [
            1,
            [
                0,
                [
                    0,
                    name
                ],
                conv_fields(fields)
            ]
        ];
    }
    var Sexplib0_Sexp = [
        0,
        t_of_sexp,
        sexp_of_t,
        equal,
        compare,
        Not_found_s,
        Of_sexp_error,
        message,
        default_indent,
        pp_hum,
        pp_hum_indent,
        pp_mach,
        pp_mach,
        to_string_hum,
        to_string_mach,
        to_string_mach,
        of_float_style,
        of_int_style,
        [
            0,
            size,
            buffer,
            to_buffer_mach,
            to_buffer_hum,
            to_buffer_mach,
            to_buffer_gen,
            mach_maybe_esc_str,
            must_escape,
            esc_str
        ]
    ];
    runtime.caml_register_global(25, Sexplib0_Sexp, "Sexplib0__Sexp");
    return;
})(globalThis);
//# 575 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, doc_comment_tag = "sexp_grammar.doc_comment", type_name_tag = "sexp_grammar.type_name", assoc_tag = "sexp_grammar.assoc", assoc_key_tag = "sexp_grammar.assoc.key", assoc_value_tag = "sexp_grammar.assoc.value", completion_suggested = "sexp_grammar.completion-suggested";
    function coerce(t) {
        return t;
    }
    function tag(param, key, value) {
        return [
            5,
            [
                0,
                key,
                value,
                param
            ]
        ];
    }
    var Sexplib0_Sexp_grammar = [
        0,
        coerce,
        tag,
        doc_comment_tag,
        type_name_tag,
        assoc_tag,
        assoc_key_tag,
        assoc_value_tag,
        completion_suggested
    ];
    runtime.caml_register_global(6, Sexplib0_Sexp_grammar, "Sexplib0__Sexp_grammar");
    return;
})(globalThis);
//# 606 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), unit_sexp_grammar = [
        2,
        0
    ], sexp_t_sexp_grammar = [
        0,
        "Sexp.t"
    ], empty_sexp_grammar = [
        4,
        0
    ], Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Stdlib_ListLabels = global_data.Stdlib__ListLabels;
    function sexp_grammar_with_tags(grammar, tags) {
        return caml_call3(Stdlib_ListLabels[27], function(param, grammar) {
            var value = param[2], key = param[1];
            return [
                5,
                [
                    0,
                    key,
                    value,
                    grammar
                ]
            ];
        }, tags, grammar);
    }
    function sexp_grammar_with_tag_list(x, tags) {
        return caml_call3(Stdlib_ListLabels[27], function(param, grammar) {
            var value = param[2], key = param[1];
            return [
                0,
                [
                    0,
                    key,
                    value,
                    grammar
                ]
            ];
        }, tags, x);
    }
    function ref_sexp_grammar(grammar) {
        return caml_call1(Sexplib0_Sexp_grammar[1], grammar);
    }
    function lazy_t_sexp_grammar(grammar) {
        return caml_call1(Sexplib0_Sexp_grammar[1], grammar);
    }
    function option_sexp_grammar(param) {
        return [
            1,
            param
        ];
    }
    function list_sexp_grammar(param) {
        return [
            2,
            [
                1,
                param
            ]
        ];
    }
    function array_sexp_grammar(param) {
        return [
            2,
            [
                1,
                param
            ]
        ];
    }
    var Sexplib0_Sexp_conv_grammar = [
        0,
        sexp_grammar_with_tags,
        sexp_grammar_with_tag_list,
        unit_sexp_grammar,
        0,
        4,
        4,
        1,
        2,
        3,
        2,
        2,
        2,
        sexp_t_sexp_grammar,
        ref_sexp_grammar,
        lazy_t_sexp_grammar,
        option_sexp_grammar,
        list_sexp_grammar,
        array_sexp_grammar,
        empty_sexp_grammar,
        empty_sexp_grammar
    ];
    runtime.caml_register_global(5, Sexplib0_Sexp_conv_grammar, "Sexplib0__Sexp_conv_grammar");
    return;
})(globalThis);
//# 687 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Assert_failure$0 = "Assert_failure", cst_None = "None", cst_Some = "Some", cst_none = "none", cst_option_of_sexp_only_none_c$1 = "option_of_sexp: only none can be atom", cst_some = "some", cst_src_sexp_conv_ml = "src/sexp_conv.ml", caml_check_bound = runtime.caml_check_bound, caml_float_of_string = runtime.caml_float_of_string, caml_format_float = runtime.caml_format_float, caml_int_of_string = runtime.caml_int_of_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Assert_failure = global_data.Assert_failure, Stdlib = global_data.Stdlib, Sexplib0_Sexp = global_data.Sexplib0__Sexp, Stdlib_Arg = global_data.Stdlib__Arg, Stdlib_Lazy = global_data.Stdlib__Lazy, Stdlib_Parsing = global_data.Stdlib__Parsing, Stdlib_Queue = global_data.Stdlib__Queue, Stdlib_Scanf = global_data.Stdlib__Scanf, Stdlib_Stack = global_data.Stdlib__Stack, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_MoreLabels = global_data.Stdlib__MoreLabels, Stdlib_ListLabels = global_data.Stdlib__ListLabels, Stdlib_BytesLabels = global_data.Stdlib__BytesLabels, Stdlib_Printexc = global_data.Stdlib__Printexc, Stdlib_Obj = global_data.Stdlib__Obj, CamlinternalLazy = global_data.CamlinternalLazy, Stdlib_Nativeint = global_data.Stdlib__Nativeint, Stdlib_Int64 = global_data.Stdlib__Int64, Stdlib_Int32 = global_data.Stdlib__Int32, Stdlib_StringLabels = global_data.Stdlib__StringLabels, Stdlib_Ephemeron = global_data.Stdlib__Ephemeron, Sexplib0_Sexp_conv_grammar = global_data.Sexplib0__Sexp_conv_grammar, default_string_of_float = [
        0,
        function(x) {
            var y = caml_format_float("%.15G", x);
            return caml_float_of_string(y) == x ? y : caml_format_float("%.17G", x);
        }
    ], read_old_option_format = [
        0,
        1
    ], write_old_option_format = [
        0,
        1
    ], _a_ = [
        1,
        0
    ], _b_ = [
        0,
        cst_some
    ], _c_ = [
        1,
        0
    ], _d_ = [
        0,
        cst_none
    ], _e_ = [
        0,
        "<opaque>"
    ], _f_ = [
        0,
        "<fun>"
    ];
    function list_map(f, l) {
        return caml_call2(Stdlib_ListLabels[20], f, l);
    }
    function sexp_of_unit(param) {
        return _a_;
    }
    function sexp_of_bool(b) {
        return [
            0,
            caml_call1(Stdlib[30], b)
        ];
    }
    function sexp_of_string(str) {
        return [
            0,
            str
        ];
    }
    function sexp_of_bytes(bytes) {
        return [
            0,
            caml_call1(Stdlib_BytesLabels[6], bytes)
        ];
    }
    function sexp_of_char(c) {
        return [
            0,
            caml_call2(Stdlib_StringLabels[1], 1, c)
        ];
    }
    function sexp_of_int(n) {
        return [
            0,
            caml_call1(Stdlib[33], n)
        ];
    }
    function sexp_of_float(n) {
        return [
            0,
            caml_call1(default_string_of_float[1], n)
        ];
    }
    function sexp_of_int32(n) {
        return [
            0,
            caml_call1(Stdlib_Int32[14], n)
        ];
    }
    function sexp_of_int64(n) {
        return [
            0,
            caml_call1(Stdlib_Int64[14], n)
        ];
    }
    function sexp_of_nativeint(n) {
        return [
            0,
            caml_call1(Stdlib_Nativeint[15], n)
        ];
    }
    function sexp_of_ref(sexp_of_a, rf) {
        return caml_call1(sexp_of_a, rf[1]);
    }
    function sexp_of_lazy_t(sexp_of_a, lv) {
        var _aJ_ = runtime.caml_obj_tag(lv);
        a: if (250 === _aJ_) var _aK_ = lv[1];
        else {
            if (246 !== _aJ_ && 244 !== _aJ_) {
                var _aK_ = lv;
                break a;
            }
            var _aK_ = caml_call1(CamlinternalLazy[2], lv);
        }
        return caml_call1(sexp_of_a, _aK_);
    }
    function sexp_of_option(sexp_of_a, param) {
        if (!param) return write_old_option_format[1] ? _c_ : _d_;
        var x = param[1];
        return write_old_option_format[1] ? [
            1,
            [
                0,
                caml_call1(sexp_of_a, x),
                0
            ]
        ] : [
            1,
            [
                0,
                _b_,
                [
                    0,
                    caml_call1(sexp_of_a, x),
                    0
                ]
            ]
        ];
    }
    function sexp_of_pair(sexp_of_a, sexp_of_b, param) {
        var b = param[2], a = param[1], _aI_ = [
            0,
            caml_call1(sexp_of_b, b),
            0
        ];
        return [
            1,
            [
                0,
                caml_call1(sexp_of_a, a),
                _aI_
            ]
        ];
    }
    function sexp_of_triple(sexp_of_a, sexp_of_b, sexp_of_c, param) {
        var c = param[3], b = param[2], a = param[1], _aG_ = [
            0,
            caml_call1(sexp_of_c, c),
            0
        ], _aH_ = [
            0,
            caml_call1(sexp_of_b, b),
            _aG_
        ];
        return [
            1,
            [
                0,
                caml_call1(sexp_of_a, a),
                _aH_
            ]
        ];
    }
    function sexp_of_list(sexp_of_a, lst) {
        return [
            1,
            caml_call2(Stdlib_ListLabels[20], sexp_of_a, lst)
        ];
    }
    function sexp_of_array(sexp_of_a, ar) {
        var lst_ref = [
            0,
            0
        ], _aD_ = ar.length - 2 | 0;
        if (_aD_ >= 0) {
            var i = _aD_;
            for(;;){
                var _aE_ = lst_ref[1];
                lst_ref[1] = [
                    0,
                    caml_call1(sexp_of_a, caml_check_bound(ar, i)[1 + i]),
                    _aE_
                ];
                var _aF_ = i - 1 | 0;
                if (0 === i) break;
                i = _aF_;
            }
        }
        return [
            1,
            lst_ref[1]
        ];
    }
    function sexp_of_hashtbl(sexp_of_key, sexp_of_val, htbl) {
        function coll(k, v, acc) {
            var _aC_ = [
                0,
                caml_call1(sexp_of_val, v),
                0
            ];
            return [
                0,
                [
                    1,
                    [
                        0,
                        caml_call1(sexp_of_key, k),
                        _aC_
                    ]
                ],
                acc
            ];
        }
        return [
            1,
            caml_call3(Stdlib_MoreLabels[1][14], coll, htbl, 0)
        ];
    }
    function sexp_of_opaque(param) {
        return _e_;
    }
    function sexp_of_fun(param) {
        return _f_;
    }
    function equal(_aB_, _aA_) {
        return _aB_ === _aA_ ? 1 : 0;
    }
    var hash = Stdlib_Obj[22][3], Exn_table = caml_call1(Stdlib_Ephemeron[1][3], [
        0,
        equal,
        hash
    ]), the_exn_table = caml_call1(Exn_table[1], 17);
    function add(opt, param, extension_constructor, sexp_of_exn) {
        var printexc = opt ? opt[1] : 1;
        return caml_call3(Exn_table[5], the_exn_table, extension_constructor, [
            0,
            sexp_of_exn,
            printexc
        ]);
    }
    function find_auto(for_printexc, exn) {
        var extension_constructor = caml_call1(Stdlib_Obj[22][1], exn), match = caml_call2(Exn_table[8], the_exn_table, extension_constructor);
        if (!match) return 0;
        var match$0 = match[1], printexc = match$0[2], sexp_of_exn = match$0[1];
        if (for_printexc && !printexc) return 0;
        return [
            0,
            caml_call1(sexp_of_exn, exn)
        ];
    }
    function size(param) {
        return caml_call1(Exn_table[18], the_exn_table)[1];
    }
    var For_unit_tests_only = [
        0,
        size
    ], _g_ = [
        0,
        2
    ];
    function sexp_of_exn_opt(exn) {
        return find_auto(0, exn);
    }
    function sexp_of_exn(exn) {
        var match = sexp_of_exn_opt(exn);
        if (!match) return [
            1,
            [
                0,
                [
                    0,
                    caml_call1(Stdlib_Printexc[1], exn)
                ],
                0
            ]
        ];
        var sexp = match[1];
        return sexp;
    }
    function exn_to_string(e) {
        var _az_ = sexp_of_exn(e);
        return caml_call2(Sexplib0_Sexp[13], 0, _az_);
    }
    caml_call1(Stdlib_Printexc[9], function(exn) {
        var match = find_auto(1, exn);
        if (!match) return 0;
        var sexp = match[1];
        return [
            0,
            caml_call2(Sexplib0_Sexp[13], _g_, sexp)
        ];
    });
    var _h_ = [
        0,
        2
    ];
    function printexc_prefer_sexp(exn) {
        var match = sexp_of_exn_opt(exn);
        if (!match) return caml_call1(Stdlib_Printexc[1], exn);
        var sexp = match[1];
        return caml_call2(Sexplib0_Sexp[13], _h_, sexp);
    }
    var Of_sexp_error = Sexplib0_Sexp[6], record_check_extra_fields = [
        0,
        1
    ], cst_unit_of_sexp_empty_list_ne = "unit_of_sexp: empty list needed", cst_bool_of_sexp_unknown_strin = "bool_of_sexp: unknown string", cst_bool_of_sexp_atom_needed = "bool_of_sexp: atom needed", cst_string_of_sexp_atom_needed = "string_of_sexp: atom needed", cst_bytes_of_sexp_atom_needed = "bytes_of_sexp: atom needed", cst_char_of_sexp_atom_string_m = "char_of_sexp: atom string must contain one character only", cst_char_of_sexp_atom_needed = "char_of_sexp: atom needed", cst_int_of_sexp = "int_of_sexp: ", cst_int_of_sexp_atom_needed = "int_of_sexp: atom needed", cst_float_of_sexp = "float_of_sexp: ", cst_float_of_sexp_atom_needed = "float_of_sexp: atom needed", cst_int32_of_sexp = "int32_of_sexp: ", cst_int32_of_sexp_atom_needed = "int32_of_sexp: atom needed", cst_int64_of_sexp = "int64_of_sexp: ", cst_int64_of_sexp_atom_needed = "int64_of_sexp: atom needed", cst_nativeint_of_sexp = "nativeint_of_sexp: ", cst_nativeint_of_sexp_atom_nee = "nativeint_of_sexp: atom needed", cst_option_of_sexp_only_none_c = cst_option_of_sexp_only_none_c$1, cst_option_of_sexp_list_must_r = "option_of_sexp: list must represent optional value", cst_option_of_sexp_only_none_c$0 = cst_option_of_sexp_only_none_c$1, cst_option_of_sexp_list_must_b = "option_of_sexp: list must be (some el)", cst_pair_of_sexp_list_needed = "pair_of_sexp: list needed", cst_pair_of_sexp_list_must_con = "pair_of_sexp: list must contain exactly two elements only", cst_triple_of_sexp_list_needed = "triple_of_sexp: list needed", cst_triple_of_sexp_list_must_c = "triple_of_sexp: list must contain exactly three elements only", cst_list_of_sexp_list_needed = "list_of_sexp: list needed", cst_array_of_sexp_list_needed = "array_of_sexp: list needed", cst_hashtbl_of_sexp_list_neede = "hashtbl_of_sexp: list needed", cst_hashtbl_of_sexp_tuple_list = "hashtbl_of_sexp: tuple list needed", cst_opaque_of_sexp_cannot_conv = "opaque_of_sexp: cannot convert opaque values", cst_fun_of_sexp_cannot_convert = "fun_of_sexp: cannot convert function values";
    function of_sexp_error_exn(exc, sexp) {
        throw caml_maybe_attach_backtrace([
            0,
            Of_sexp_error,
            exc,
            sexp
        ], 1);
    }
    function of_sexp_error(what, sexp) {
        throw caml_maybe_attach_backtrace([
            0,
            Of_sexp_error,
            [
                0,
                Stdlib[7],
                what
            ],
            sexp
        ], 1);
    }
    function unit_of_sexp(sexp) {
        if (1 === sexp[0] && !sexp[1]) return 0;
        return of_sexp_error(cst_unit_of_sexp_empty_list_ne, sexp);
    }
    function bool_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_bool_of_sexp_atom_needed, sexp);
        var _ay_ = sexp[1];
        a: if (_ay_ !== "False") {
            if (_ay_ !== "True") {
                if (_ay_ === "false") break a;
                if (_ay_ !== "true") return of_sexp_error(cst_bool_of_sexp_unknown_strin, sexp);
            }
            return 1;
        }
        return 0;
    }
    function string_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_string_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        return str;
    }
    function bytes_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_bytes_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        return caml_call1(Stdlib_BytesLabels[5], str);
    }
    function char_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_char_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        if (1 !== runtime.caml_ml_string_length(str)) of_sexp_error(cst_char_of_sexp_atom_string_m, sexp);
        return runtime.caml_string_get(str, 0);
    }
    function int_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_int_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        try {
            var _ax_ = caml_int_of_string(str);
            return _ax_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), _aw_ = exn_to_string(exc);
            return of_sexp_error(caml_call2(Stdlib[28], cst_int_of_sexp, _aw_), sexp);
        }
    }
    function float_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_float_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        try {
            var _av_ = caml_float_of_string(str);
            return _av_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), _au_ = exn_to_string(exc);
            return of_sexp_error(caml_call2(Stdlib[28], cst_float_of_sexp, _au_), sexp);
        }
    }
    function int32_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_int32_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        try {
            var _at_ = caml_int_of_string(str);
            return _at_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), _as_ = exn_to_string(exc);
            return of_sexp_error(caml_call2(Stdlib[28], cst_int32_of_sexp, _as_), sexp);
        }
    }
    function int64_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_int64_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        try {
            var _ar_ = runtime.caml_int64_of_string(str);
            return _ar_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), _aq_ = exn_to_string(exc);
            return of_sexp_error(caml_call2(Stdlib[28], cst_int64_of_sexp, _aq_), sexp);
        }
    }
    function nativeint_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_nativeint_of_sexp_atom_nee, sexp);
        var str = sexp[1];
        try {
            var _ap_ = caml_int_of_string(str);
            return _ap_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), _ao_ = exn_to_string(exc);
            return of_sexp_error(caml_call2(Stdlib[28], cst_nativeint_of_sexp, _ao_), sexp);
        }
    }
    function ref_of_sexp(a_of_sexp, sexp) {
        return [
            0,
            caml_call1(a_of_sexp, sexp)
        ];
    }
    function lazy_t_of_sexp(a_of_sexp, sexp) {
        var _an_ = caml_call1(a_of_sexp, sexp);
        return caml_call1(Stdlib_Lazy[4], _an_);
    }
    function option_of_sexp(a_of_sexp, sexp) {
        if (!read_old_option_format[1]) {
            if (0 === sexp[0]) {
                var _ai_ = sexp[1];
                if (_ai_ !== cst_None && _ai_ !== cst_none) return of_sexp_error(cst_option_of_sexp_only_none_c$0, sexp);
                return 0;
            }
            var _aj_ = sexp[1];
            a: if (_aj_) {
                var _ak_ = _aj_[1];
                if (0 === _ak_[0]) {
                    var _al_ = _ak_[1];
                    if (_al_ !== cst_Some && _al_ !== cst_some) break a;
                    var _am_ = _aj_[2];
                    if (_am_ && !_am_[2]) {
                        var el$0 = _am_[1];
                        return [
                            0,
                            caml_call1(a_of_sexp, el$0)
                        ];
                    }
                }
            }
            return of_sexp_error(cst_option_of_sexp_list_must_b, sexp);
        }
        if (0 === sexp[0]) {
            var _ad_ = sexp[1];
            if (_ad_ !== cst_None && _ad_ !== cst_none) return of_sexp_error(cst_option_of_sexp_only_none_c, sexp);
        } else {
            var _ae_ = sexp[1];
            if (_ae_) {
                var _af_ = _ae_[1];
                a: {
                    if (_ae_[2]) {
                        b: if (0 === _af_[0]) {
                            var _ag_ = _af_[1];
                            if (_ag_ !== cst_Some && _ag_ !== cst_some) break b;
                            var _ah_ = _ae_[2];
                            if (!_ah_[2]) {
                                var el = _ah_[1];
                                break a;
                            }
                        }
                        return of_sexp_error(cst_option_of_sexp_list_must_r, sexp);
                    }
                    var el = _af_;
                }
                return [
                    0,
                    caml_call1(a_of_sexp, el)
                ];
            }
        }
        return 0;
    }
    function pair_of_sexp(a_of_sexp, b_of_sexp, sexp) {
        if (0 === sexp[0]) return of_sexp_error(cst_pair_of_sexp_list_needed, sexp);
        var _ab_ = sexp[1];
        if (_ab_) {
            var _ac_ = _ab_[2];
            if (_ac_ && !_ac_[2]) {
                var b_sexp = _ac_[1], a_sexp = _ab_[1], a = caml_call1(a_of_sexp, a_sexp), b = caml_call1(b_of_sexp, b_sexp);
                return [
                    0,
                    a,
                    b
                ];
            }
        }
        return of_sexp_error(cst_pair_of_sexp_list_must_con, sexp);
    }
    function triple_of_sexp(a_of_sexp, b_of_sexp, c_of_sexp, sexp) {
        if (0 === sexp[0]) return of_sexp_error(cst_triple_of_sexp_list_needed, sexp);
        var ___ = sexp[1];
        if (___) {
            var _$_ = ___[2];
            if (_$_) {
                var _aa_ = _$_[2];
                if (_aa_ && !_aa_[2]) {
                    var c_sexp = _aa_[1], b_sexp = _$_[1], a_sexp = ___[1], a = caml_call1(a_of_sexp, a_sexp), b = caml_call1(b_of_sexp, b_sexp), c = caml_call1(c_of_sexp, c_sexp);
                    return [
                        0,
                        a,
                        b,
                        c
                    ];
                }
            }
        }
        return of_sexp_error(cst_triple_of_sexp_list_must_c, sexp);
    }
    function list_of_sexp(a_of_sexp, sexp) {
        if (0 === sexp[0]) return of_sexp_error(cst_list_of_sexp_list_needed, sexp);
        var lst = sexp[1];
        return caml_call2(Stdlib_ListLabels[20], a_of_sexp, lst);
    }
    function array_of_sexp(a_of_sexp, sexp) {
        if (0 === sexp[0]) return of_sexp_error(cst_array_of_sexp_list_needed, sexp);
        var match = sexp[1];
        if (!match) return [
            0
        ];
        var t = match[2], h = match[1], len = caml_call1(Stdlib_ListLabels[1], t) + 1 | 0, res = runtime.caml_make_vect(len, caml_call1(a_of_sexp, h)), i = 1, param = t;
        for(;;){
            if (!param) return res;
            var t$0 = param[2], h$0 = param[1], _Z_ = caml_call1(a_of_sexp, h$0);
            caml_check_bound(res, i)[1 + i] = _Z_;
            var i$0 = i + 1 | 0;
            i = i$0;
            param = t$0;
        }
    }
    function hashtbl_of_sexp(key_of_sexp, val_of_sexp, sexp) {
        if (0 === sexp[0]) return of_sexp_error(cst_hashtbl_of_sexp_list_neede, sexp);
        var lst = sexp[1], htbl = caml_call2(Stdlib_MoreLabels[1][1], 0, 0);
        function act(param) {
            if (1 === param[0]) {
                var _V_ = param[1];
                if (_V_) {
                    var _W_ = _V_[2];
                    if (_W_ && !_W_[2]) {
                        var v_sexp = _W_[1], k_sexp = _V_[1], _X_ = caml_call1(val_of_sexp, v_sexp), _Y_ = caml_call1(key_of_sexp, k_sexp);
                        return caml_call3(Stdlib_MoreLabels[1][5], htbl, _Y_, _X_);
                    }
                }
            }
            return of_sexp_error(cst_hashtbl_of_sexp_tuple_list, sexp);
        }
        caml_call2(Stdlib_ListLabels[18], act, lst);
        return htbl;
    }
    function opaque_of_sexp(sexp) {
        return of_sexp_error(cst_opaque_of_sexp_cannot_conv, sexp);
    }
    function fun_of_sexp(sexp) {
        return of_sexp_error(cst_fun_of_sexp_cannot_convert, sexp);
    }
    var sexp_grammar_with_tags = Sexplib0_Sexp_conv_grammar[1], sexp_grammar_with_tag_list = Sexplib0_Sexp_conv_grammar[2], unit_sexp_grammar = Sexplib0_Sexp_conv_grammar[3], bool_sexp_grammar = Sexplib0_Sexp_conv_grammar[4], string_sexp_grammar = Sexplib0_Sexp_conv_grammar[5], bytes_sexp_grammar = Sexplib0_Sexp_conv_grammar[6], char_sexp_grammar = Sexplib0_Sexp_conv_grammar[7], int_sexp_grammar = Sexplib0_Sexp_conv_grammar[8], float_sexp_grammar = Sexplib0_Sexp_conv_grammar[9], int32_sexp_grammar = Sexplib0_Sexp_conv_grammar[10], int64_sexp_grammar = Sexplib0_Sexp_conv_grammar[11], nativeint_sexp_grammar = Sexplib0_Sexp_conv_grammar[12], sexp_t_sexp_grammar = Sexplib0_Sexp_conv_grammar[13], ref_sexp_grammar = Sexplib0_Sexp_conv_grammar[14], lazy_t_sexp_grammar = Sexplib0_Sexp_conv_grammar[15], option_sexp_grammar = Sexplib0_Sexp_conv_grammar[16], list_sexp_grammar = Sexplib0_Sexp_conv_grammar[17], array_sexp_grammar = Sexplib0_Sexp_conv_grammar[18], opaque_sexp_grammar = Sexplib0_Sexp_conv_grammar[19], fun_sexp_grammar = Sexplib0_Sexp_conv_grammar[20], _i_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    2,
                    0,
                    [
                        12,
                        58,
                        [
                            4,
                            0,
                            0,
                            0,
                            [
                                12,
                                58,
                                [
                                    4,
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s %s:%d:%d"
    ];
    function get_flc_error(name, param) {
        var chr = param[3], line = param[2], file = param[1];
        return [
            0,
            caml_call5(Stdlib_Printf[4], _i_, name, file, line, chr)
        ];
    }
    var _j_ = [
        0,
        "Sys.Break"
    ], _k_ = [
        0,
        cst_src_sexp_conv_ml,
        394,
        15
    ], _l_ = [
        0,
        "Stack.Empty"
    ], _m_ = [
        0,
        cst_src_sexp_conv_ml,
        390,
        15
    ], _n_ = [
        0,
        "Scanf.Scan_failure"
    ], _o_ = [
        0,
        cst_src_sexp_conv_ml,
        386,
        15
    ], _p_ = [
        0,
        "Queue.Empty"
    ], _q_ = [
        0,
        cst_src_sexp_conv_ml,
        382,
        15
    ], _r_ = [
        0,
        "Parsing.Parse_error"
    ], _s_ = [
        0,
        cst_src_sexp_conv_ml,
        378,
        15
    ], _t_ = [
        0,
        "Lazy.Undefined"
    ], _u_ = [
        0,
        cst_src_sexp_conv_ml,
        374,
        15
    ], _v_ = [
        0,
        "Arg.Bad"
    ], _w_ = [
        0,
        cst_src_sexp_conv_ml,
        370,
        15
    ], _x_ = [
        0,
        "Arg.Help"
    ], _y_ = [
        0,
        cst_src_sexp_conv_ml,
        366,
        15
    ], _z_ = [
        0,
        "Sys_error"
    ], _A_ = [
        0,
        cst_src_sexp_conv_ml,
        362,
        15
    ], _B_ = [
        0,
        "Not_found_s"
    ], _C_ = [
        0,
        cst_src_sexp_conv_ml,
        358,
        15
    ], cst_Match_failure = "Match_failure", _D_ = [
        0,
        cst_src_sexp_conv_ml,
        354,
        15
    ], _E_ = [
        0,
        "Invalid_argument"
    ], _F_ = [
        0,
        cst_src_sexp_conv_ml,
        350,
        15
    ], _G_ = [
        0,
        "Not_found"
    ], _H_ = [
        0,
        cst_src_sexp_conv_ml,
        346,
        15
    ], _I_ = [
        0,
        "Failure"
    ], _J_ = [
        0,
        cst_src_sexp_conv_ml,
        342,
        15
    ], _K_ = [
        0,
        "End_of_file"
    ], _L_ = [
        0,
        cst_src_sexp_conv_ml,
        338,
        15
    ], _M_ = [
        0,
        "Exit"
    ], _N_ = [
        0,
        cst_src_sexp_conv_ml,
        334,
        15
    ], cst_Assert_failure = cst_Assert_failure$0, _O_ = [
        0,
        cst_src_sexp_conv_ml,
        330,
        15
    ], _P_ = [
        0,
        0
    ], _Q_ = [
        0,
        0
    ];
    caml_call2(Stdlib_ListLabels[18], function(param) {
        var handler = param[2], extension_constructor = param[1];
        return add(_Q_, _P_, extension_constructor, handler);
    }, [
        0,
        [
            0,
            Stdlib[5],
            function(param) {
                if (param[1] !== Stdlib[5]) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _O_
                ], 1);
                var arg = param[2];
                return get_flc_error(cst_Assert_failure, arg);
            }
        ],
        [
            0,
            [
                0,
                Stdlib[3],
                function(param) {
                    if (param === Stdlib[3]) return _M_;
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _N_
                    ], 1);
                }
            ],
            [
                0,
                [
                    0,
                    Stdlib[12],
                    function(param) {
                        if (param === Stdlib[12]) return _K_;
                        throw caml_maybe_attach_backtrace([
                            0,
                            Assert_failure,
                            _L_
                        ], 1);
                    }
                ],
                [
                    0,
                    [
                        0,
                        Stdlib[7],
                        function(param) {
                            if (param[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace([
                                0,
                                Assert_failure,
                                _J_
                            ], 1);
                            var arg = param[2];
                            return [
                                1,
                                [
                                    0,
                                    _I_,
                                    [
                                        0,
                                        [
                                            0,
                                            arg
                                        ],
                                        0
                                    ]
                                ]
                            ];
                        }
                    ],
                    [
                        0,
                        [
                            0,
                            Stdlib[8],
                            function(param) {
                                if (param === Stdlib[8]) return _G_;
                                throw caml_maybe_attach_backtrace([
                                    0,
                                    Assert_failure,
                                    _H_
                                ], 1);
                            }
                        ],
                        [
                            0,
                            [
                                0,
                                Stdlib[6],
                                function(param) {
                                    if (param[1] !== Stdlib[6]) throw caml_maybe_attach_backtrace([
                                        0,
                                        Assert_failure,
                                        _F_
                                    ], 1);
                                    var arg = param[2];
                                    return [
                                        1,
                                        [
                                            0,
                                            _E_,
                                            [
                                                0,
                                                [
                                                    0,
                                                    arg
                                                ],
                                                0
                                            ]
                                        ]
                                    ];
                                }
                            ],
                            [
                                0,
                                [
                                    0,
                                    Stdlib[4],
                                    function(param) {
                                        if (param[1] !== Stdlib[4]) throw caml_maybe_attach_backtrace([
                                            0,
                                            Assert_failure,
                                            _D_
                                        ], 1);
                                        var arg = param[2];
                                        return get_flc_error(cst_Match_failure, arg);
                                    }
                                ],
                                [
                                    0,
                                    [
                                        0,
                                        Sexplib0_Sexp[5],
                                        function(param) {
                                            if (param[1] !== Sexplib0_Sexp[5]) throw caml_maybe_attach_backtrace([
                                                0,
                                                Assert_failure,
                                                _C_
                                            ], 1);
                                            var arg = param[2];
                                            return [
                                                1,
                                                [
                                                    0,
                                                    _B_,
                                                    [
                                                        0,
                                                        arg,
                                                        0
                                                    ]
                                                ]
                                            ];
                                        }
                                    ],
                                    [
                                        0,
                                        [
                                            0,
                                            Stdlib[11],
                                            function(param) {
                                                if (param[1] !== Stdlib[11]) throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _A_
                                                ], 1);
                                                var arg = param[2];
                                                return [
                                                    1,
                                                    [
                                                        0,
                                                        _z_,
                                                        [
                                                            0,
                                                            [
                                                                0,
                                                                arg
                                                            ],
                                                            0
                                                        ]
                                                    ]
                                                ];
                                            }
                                        ],
                                        [
                                            0,
                                            [
                                                0,
                                                Stdlib_Arg[7],
                                                function(param) {
                                                    if (param[1] !== Stdlib_Arg[7]) throw caml_maybe_attach_backtrace([
                                                        0,
                                                        Assert_failure,
                                                        _y_
                                                    ], 1);
                                                    var arg = param[2];
                                                    return [
                                                        1,
                                                        [
                                                            0,
                                                            _x_,
                                                            [
                                                                0,
                                                                [
                                                                    0,
                                                                    arg
                                                                ],
                                                                0
                                                            ]
                                                        ]
                                                    ];
                                                }
                                            ],
                                            [
                                                0,
                                                [
                                                    0,
                                                    Stdlib_Arg[8],
                                                    function(param) {
                                                        if (param[1] !== Stdlib_Arg[8]) throw caml_maybe_attach_backtrace([
                                                            0,
                                                            Assert_failure,
                                                            _w_
                                                        ], 1);
                                                        var arg = param[2];
                                                        return [
                                                            1,
                                                            [
                                                                0,
                                                                _v_,
                                                                [
                                                                    0,
                                                                    [
                                                                        0,
                                                                        arg
                                                                    ],
                                                                    0
                                                                ]
                                                            ]
                                                        ];
                                                    }
                                                ],
                                                [
                                                    0,
                                                    [
                                                        0,
                                                        Stdlib_Lazy[1],
                                                        function(param) {
                                                            if (param === Stdlib_Lazy[1]) return _t_;
                                                            throw caml_maybe_attach_backtrace([
                                                                0,
                                                                Assert_failure,
                                                                _u_
                                                            ], 1);
                                                        }
                                                    ],
                                                    [
                                                        0,
                                                        [
                                                            0,
                                                            Stdlib_Parsing[10],
                                                            function(param) {
                                                                if (param === Stdlib_Parsing[10]) return _r_;
                                                                throw caml_maybe_attach_backtrace([
                                                                    0,
                                                                    Assert_failure,
                                                                    _s_
                                                                ], 1);
                                                            }
                                                        ],
                                                        [
                                                            0,
                                                            [
                                                                0,
                                                                Stdlib_Queue[1],
                                                                function(param) {
                                                                    if (param === Stdlib_Queue[1]) return _p_;
                                                                    throw caml_maybe_attach_backtrace([
                                                                        0,
                                                                        Assert_failure,
                                                                        _q_
                                                                    ], 1);
                                                                }
                                                            ],
                                                            [
                                                                0,
                                                                [
                                                                    0,
                                                                    Stdlib_Scanf[2],
                                                                    function(param) {
                                                                        if (param[1] !== Stdlib_Scanf[2]) throw caml_maybe_attach_backtrace([
                                                                            0,
                                                                            Assert_failure,
                                                                            _o_
                                                                        ], 1);
                                                                        var arg = param[2];
                                                                        return [
                                                                            1,
                                                                            [
                                                                                0,
                                                                                _n_,
                                                                                [
                                                                                    0,
                                                                                    [
                                                                                        0,
                                                                                        arg
                                                                                    ],
                                                                                    0
                                                                                ]
                                                                            ]
                                                                        ];
                                                                    }
                                                                ],
                                                                [
                                                                    0,
                                                                    [
                                                                        0,
                                                                        Stdlib_Stack[1],
                                                                        function(param) {
                                                                            if (param === Stdlib_Stack[1]) return _l_;
                                                                            throw caml_maybe_attach_backtrace([
                                                                                0,
                                                                                Assert_failure,
                                                                                _m_
                                                                            ], 1);
                                                                        }
                                                                    ],
                                                                    [
                                                                        0,
                                                                        [
                                                                            0,
                                                                            Stdlib_Sys[44],
                                                                            function(param) {
                                                                                if (param === Stdlib_Sys[44]) return _j_;
                                                                                throw caml_maybe_attach_backtrace([
                                                                                    0,
                                                                                    Assert_failure,
                                                                                    _k_
                                                                                ], 1);
                                                                            }
                                                                        ],
                                                                        0
                                                                    ]
                                                                ]
                                                            ]
                                                        ]
                                                    ]
                                                ]
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ]);
    var _R_ = [
        0,
        "Sexplib.Conv.Of_sexp_error"
    ], _S_ = [
        0,
        cst_src_sexp_conv_ml,
        406,
        15
    ], _T_1 = [
        0,
        0
    ], _U_ = [
        0,
        1
    ];
    caml_call2(Stdlib_ListLabels[18], function(param) {
        var handler = param[2], extension_constructor = param[1];
        return add(_U_, _T_1, extension_constructor, handler);
    }, [
        0,
        [
            0,
            Of_sexp_error,
            function(param) {
                if (param[1] !== Of_sexp_error) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _S_
                ], 1);
                var sexp = param[3], exc = param[2];
                return [
                    1,
                    [
                        0,
                        _R_,
                        [
                            0,
                            sexp_of_exn(exc),
                            [
                                0,
                                sexp,
                                0
                            ]
                        ]
                    ]
                ];
            }
        ],
        0
    ]);
    var Sexplib0_Sexp_conv = [
        0,
        default_string_of_float,
        write_old_option_format,
        read_old_option_format,
        list_map,
        sexp_of_unit,
        sexp_of_bool,
        sexp_of_string,
        sexp_of_bytes,
        sexp_of_char,
        sexp_of_int,
        sexp_of_float,
        sexp_of_int32,
        sexp_of_int64,
        sexp_of_nativeint,
        sexp_of_ref,
        sexp_of_lazy_t,
        sexp_of_option,
        sexp_of_pair,
        sexp_of_triple,
        sexp_of_list,
        sexp_of_array,
        sexp_of_hashtbl,
        sexp_of_opaque,
        sexp_of_fun,
        Of_sexp_error,
        record_check_extra_fields,
        of_sexp_error,
        of_sexp_error_exn,
        unit_of_sexp,
        bool_of_sexp,
        string_of_sexp,
        bytes_of_sexp,
        char_of_sexp,
        int_of_sexp,
        float_of_sexp,
        int32_of_sexp,
        int64_of_sexp,
        nativeint_of_sexp,
        ref_of_sexp,
        lazy_t_of_sexp,
        option_of_sexp,
        pair_of_sexp,
        triple_of_sexp,
        list_of_sexp,
        array_of_sexp,
        hashtbl_of_sexp,
        opaque_of_sexp,
        fun_of_sexp,
        sexp_grammar_with_tags,
        sexp_grammar_with_tag_list,
        unit_sexp_grammar,
        bool_sexp_grammar,
        string_sexp_grammar,
        bytes_sexp_grammar,
        char_sexp_grammar,
        int_sexp_grammar,
        float_sexp_grammar,
        int32_sexp_grammar,
        int64_sexp_grammar,
        nativeint_sexp_grammar,
        sexp_t_sexp_grammar,
        ref_sexp_grammar,
        lazy_t_sexp_grammar,
        option_sexp_grammar,
        list_sexp_grammar,
        array_sexp_grammar,
        opaque_sexp_grammar,
        fun_sexp_grammar,
        sexp_of_exn,
        printexc_prefer_sexp,
        sexp_of_exn_opt,
        [
            0,
            add,
            For_unit_tests_only
        ]
    ];
    runtime.caml_register_global(117, Sexplib0_Sexp_conv, "Sexplib0__Sexp_conv");
    return;
})(globalThis);
//# 1513 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = " ", cst_has_incorrect_number_of_ar = " has incorrect number of arguments", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, msg = "this constructor does not take arguments", msg$0 = "this constructor requires arguments", msg$1 = "expected a variant type, saw a nested list", msg$2 = "expected a variant type, saw an empty list", msg$3 = "unexpected variant constructor", msg$4 = "record conversion: a [sexp.bool] field was given a payload.", msg$5 = "record conversion: only pairs expected, their first element must be an atom", msg$6 = "list instead of atom for record expected", msg$7 = "cannot convert values of types resulting from polymorphic record fields", msg$8 = "no matching variant found", msg$9 = "polymorphic variant does not take arguments", msg$10 = "polymorphic variant tag takes an argument", msg$11 = "a nested list is an invalid polymorphic variant", msg$12 = "the empty list is an invalid polymorphic variant", msg$13 = "trying to convert an empty type", Stdlib_ListLabels = global_data.Stdlib__ListLabels, Stdlib_StringLabels = global_data.Stdlib__StringLabels, Stdlib_Printf = global_data.Stdlib__Printf, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, Of_sexp_error = Sexplib0_Sexp_conv[25], _a_ = [
        0,
        [
            2,
            0,
            [
                11,
                "_of_sexp: ",
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s_of_sexp: %s"
    ], _b_ = [
        0,
        [
            11,
            "tuple of size ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " expected",
                    0
                ]
            ]
        ],
        "tuple of size %d expected"
    ], _c_ = [
        0,
        [
            2,
            0,
            [
                11,
                "_of_sexp: expected a pair beginning with label ",
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s_of_sexp: expected a pair beginning with label %s"
    ], _d_ = [
        0,
        [
            2,
            0,
            [
                11,
                "_of_sexp: incorrect label for element ",
                [
                    2,
                    0,
                    [
                        11,
                        " at position ",
                        [
                            4,
                            3,
                            0,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "%s_of_sexp: incorrect label for element %s at position %i"
    ], _e_ = [
        0,
        [
            11,
            "sum tag ",
            [
                3,
                0,
                [
                    11,
                    cst_has_incorrect_number_of_ar,
                    0
                ]
            ]
        ],
        "sum tag %S has incorrect number of arguments"
    ], _f_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": ",
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s: %s"
    ], cst_duplicate_fields = "duplicate fields", cst_extra_fields = "extra fields", _g_ = [
        0,
        [
            11,
            "the following record elements were undefined: ",
            [
                2,
                0,
                0
            ]
        ],
        "the following record elements were undefined: %s"
    ];
    function error(loc, sexp, msg) {
        var _k_ = caml_call3(Stdlib_Printf[4], _a_, loc, msg);
        return caml_call2(Sexplib0_Sexp_conv[27], _k_, sexp);
    }
    function simple_error(msg, loc, sexp) {
        return error(loc, sexp, msg);
    }
    function tuple_of_size_n_expected(loc, n, sexp) {
        return error(loc, sexp, caml_call2(Stdlib_Printf[4], _b_, n));
    }
    function tuple_pair_expected(loc, name, sexp) {
        var msg = caml_call3(Stdlib_Printf[4], _c_, loc, name);
        return caml_call2(Sexplib0_Sexp_conv[27], msg, sexp);
    }
    function tuple_incorrect_label(loc, name, pos, sexp) {
        var msg = caml_call4(Stdlib_Printf[4], _d_, loc, name, pos);
        return caml_call2(Sexplib0_Sexp_conv[27], msg, sexp);
    }
    function stag_no_args(loc, sexp) {
        return error(loc, sexp, msg);
    }
    function stag_incorrect_n_args(loc, tag, sexp) {
        return error(loc, sexp, caml_call2(Stdlib_Printf[4], _e_, tag));
    }
    function stag_takes_args(loc, sexp) {
        return error(loc, sexp, msg$0);
    }
    function nested_list_invalid_sum(loc, sexp) {
        return error(loc, sexp, msg$1);
    }
    function empty_list_invalid_sum(loc, sexp) {
        return error(loc, sexp, msg$2);
    }
    function unexpected_stag(loc, sexp) {
        return error(loc, sexp, msg$3);
    }
    function record_sexp_bool_with_payload(loc, sexp) {
        return error(loc, sexp, msg$4);
    }
    function record_only_pairs_expected(loc, sexp) {
        return error(loc, sexp, msg$5);
    }
    function record_invalid_fields(what, loc, fld_names, sexp) {
        var fld_names_str = caml_call2(Stdlib_StringLabels[7], cst, fld_names);
        return error(loc, sexp, caml_call3(Stdlib_Printf[4], _f_, what, fld_names_str));
    }
    function record_duplicate_fields(loc, fld_names, sexp) {
        return record_invalid_fields(cst_duplicate_fields, loc, fld_names, sexp);
    }
    function record_extra_fields(loc, fld_names, sexp) {
        return record_invalid_fields(cst_extra_fields, loc, fld_names, sexp);
    }
    function record_get_undefined_loop(fields, param) {
        var fields$0 = fields, param$0 = param;
        for(;;){
            if (!param$0) {
                var _j_ = caml_call1(Stdlib_ListLabels[10], fields$0);
                return caml_call2(Stdlib_StringLabels[7], cst$0, _j_);
            }
            var _i_ = param$0[1];
            if (_i_[1]) {
                var rest = param$0[2], field = _i_[2], fields$1 = [
                    0,
                    field,
                    fields$0
                ];
                fields$0 = fields$1;
                param$0 = rest;
            } else {
                var rest$0 = param$0[2];
                param$0 = rest$0;
            }
        }
    }
    function record_undefined_elements(loc, sexp, lst) {
        var undefined$0 = record_get_undefined_loop(0, lst), msg = caml_call2(Stdlib_Printf[4], _g_, undefined$0);
        return error(loc, sexp, msg);
    }
    function record_list_instead_atom(loc, sexp) {
        return error(loc, sexp, msg$6);
    }
    function record_poly_field_value(loc, sexp) {
        return error(loc, sexp, msg$7);
    }
    var No_variant_match = [
        248,
        "Sexplib0__Sexp_conv_error.No_variant_match",
        runtime.caml_fresh_oo_id(0)
    ], _h_ = [
        0,
        [
            11,
            "polymorphic variant tag ",
            [
                3,
                0,
                [
                    11,
                    cst_has_incorrect_number_of_ar,
                    0
                ]
            ]
        ],
        "polymorphic variant tag %S has incorrect number of arguments"
    ];
    function no_variant_match(param) {
        throw caml_maybe_attach_backtrace(No_variant_match, 1);
    }
    function no_matching_variant_found(loc, sexp) {
        return error(loc, sexp, msg$8);
    }
    function ptag_no_args(loc, sexp) {
        return error(loc, sexp, msg$9);
    }
    function ptag_incorrect_n_args(loc, cnstr, sexp) {
        return error(loc, sexp, caml_call2(Stdlib_Printf[4], _h_, cnstr));
    }
    function ptag_takes_args(loc, sexp) {
        return error(loc, sexp, msg$10);
    }
    function nested_list_invalid_poly_var(loc, sexp) {
        return error(loc, sexp, msg$11);
    }
    function empty_list_invalid_poly_var(loc, sexp) {
        return error(loc, sexp, msg$12);
    }
    function empty_type(loc, sexp) {
        return error(loc, sexp, msg$13);
    }
    var Sexplib0_Sexp_conv_error = [
        0,
        Of_sexp_error,
        error,
        simple_error,
        tuple_of_size_n_expected,
        tuple_pair_expected,
        tuple_incorrect_label,
        stag_no_args,
        stag_incorrect_n_args,
        stag_takes_args,
        nested_list_invalid_sum,
        empty_list_invalid_sum,
        unexpected_stag,
        record_sexp_bool_with_payload,
        record_only_pairs_expected,
        record_invalid_fields,
        record_duplicate_fields,
        record_extra_fields,
        record_get_undefined_loop,
        record_undefined_elements,
        record_list_instead_atom,
        record_poly_field_value,
        No_variant_match,
        no_variant_match,
        no_matching_variant_found,
        ptag_no_args,
        ptag_incorrect_n_args,
        ptag_takes_args,
        nested_list_invalid_poly_var,
        empty_list_invalid_poly_var,
        empty_type
    ];
    runtime.caml_register_global(32, Sexplib0_Sexp_conv_error, "Sexplib0__Sexp_conv_error");
    return;
})(globalThis);
//# 2352 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Sexplib0_Sexpable = [
        0
    ];
    runtime.caml_register_global(0, Sexplib0_Sexpable, "Sexplib0__Sexpable");
    return;
})(globalThis);
//# 1 "../.js/default/base.shadow_stdlib/shadow_stdlib.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/base.shadow_stdlib/shadow_stdlib.cma.js"
//# 6 "../.js/default/base.shadow_stdlib/shadow_stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, invalid_arg = Stdlib[1], failwith = Stdlib[2], Exit = Stdlib[3], Not_found = Stdlib[8], min = Stdlib[16], max = Stdlib[17], abs = Stdlib[18], max_int = Stdlib[19], min_int = Stdlib[20], lnot = Stdlib[21], infinity = Stdlib[22], neg_infinity = Stdlib[23], nan = Stdlib[24], max_float = Stdlib[25], min_float = Stdlib[26], epsilon_float = Stdlib[27], symbol_concat = Stdlib[28], char_of_int = Stdlib[29], string_of_bool = Stdlib[30], bool_of_string_opt = Stdlib[31], bool_of_string = Stdlib[32], string_of_int = Stdlib[33], int_of_string_opt = Stdlib[34], string_of_float = Stdlib[35], float_of_string_opt = Stdlib[36], symbol = Stdlib[37], stdin = Stdlib[38], stdout = Stdlib[39], stderr = Stdlib[40], print_char = Stdlib[41], print_string = Stdlib[42], print_bytes = Stdlib[43], print_int = Stdlib[44], print_float = Stdlib[45], print_endline = Stdlib[46], print_newline = Stdlib[47], prerr_char = Stdlib[48], prerr_string = Stdlib[49], prerr_bytes = Stdlib[50], prerr_int = Stdlib[51], prerr_float = Stdlib[52], prerr_endline = Stdlib[53], prerr_newline = Stdlib[54], read_line = Stdlib[55], read_int_opt = Stdlib[56], read_int = Stdlib[57], read_float_opt = Stdlib[58], read_float = Stdlib[59], open_out = Stdlib[60], open_out_bin = Stdlib[61], open_out_gen = Stdlib[62], flush = Stdlib[63], flush_all = Stdlib[64], output_char = Stdlib[65], output_string = Stdlib[66], output_bytes = Stdlib[67], output = Stdlib[68], output_substring = Stdlib[69], output_byte = Stdlib[70], output_binary_int = Stdlib[71], output_value = Stdlib[72], seek_out = Stdlib[73], pos_out = Stdlib[74], out_channel_length = Stdlib[75], close_out = Stdlib[76], close_out_noerr = Stdlib[77], set_binary_mode_out = Stdlib[78], open_in = Stdlib[79], open_in_bin = Stdlib[80], open_in_gen = Stdlib[81], input_char = Stdlib[82], input_line = Stdlib[83], input = Stdlib[84], really_input = Stdlib[85], really_input_string = Stdlib[86], input_byte = Stdlib[87], input_binary_int = Stdlib[88], input_value = Stdlib[89], seek_in = Stdlib[90], pos_in = Stdlib[91], in_channel_length = Stdlib[92], close_in = Stdlib[93], close_in_noerr = Stdlib[94], set_binary_mode_in = Stdlib[95], string_of_format = Stdlib[97], symbol$0 = Stdlib[98], exit = Stdlib[99], at_exit = Stdlib[100], valid_float_lexem = Stdlib[101], unsafe_really_input = Stdlib[102], do_at_exit = Stdlib[103], do_domain_local_at_exit = Stdlib[104], Shadow_stdlib = [
        0,
        invalid_arg,
        failwith,
        Exit,
        Not_found,
        min,
        max,
        abs,
        max_int,
        min_int,
        lnot,
        infinity,
        neg_infinity,
        nan,
        max_float,
        min_float,
        epsilon_float,
        symbol_concat,
        char_of_int,
        string_of_bool,
        bool_of_string_opt,
        bool_of_string,
        string_of_int,
        int_of_string_opt,
        string_of_float,
        float_of_string_opt,
        symbol,
        stdin,
        stdout,
        stderr,
        print_char,
        print_string,
        print_bytes,
        print_int,
        print_float,
        print_endline,
        print_newline,
        prerr_char,
        prerr_string,
        prerr_bytes,
        prerr_int,
        prerr_float,
        prerr_endline,
        prerr_newline,
        read_line,
        read_int_opt,
        read_int,
        read_float_opt,
        read_float,
        open_out,
        open_out_bin,
        open_out_gen,
        flush,
        flush_all,
        output_char,
        output_string,
        output_bytes,
        output,
        output_substring,
        output_byte,
        output_binary_int,
        output_value,
        seek_out,
        pos_out,
        out_channel_length,
        close_out,
        close_out_noerr,
        set_binary_mode_out,
        open_in,
        open_in_bin,
        open_in_gen,
        input_char,
        input_line,
        input,
        really_input,
        really_input_string,
        input_byte,
        input_binary_int,
        input_value,
        seek_in,
        pos_in,
        in_channel_length,
        close_in,
        close_in_noerr,
        set_binary_mode_in,
        string_of_format,
        symbol$0,
        exit,
        at_exit,
        valid_float_lexem,
        unsafe_really_input,
        do_at_exit,
        do_domain_local_at_exit
    ];
    runtime.caml_register_global(1, Shadow_stdlib, "Shadow_stdlib");
    return;
})(globalThis);
//# 1 "../.js/default/ocaml_intrinsics_kernel/ocaml_intrinsics_kernel.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ocaml_intrinsics_kernel/ocaml_intrinsics_kernel.cma.js"
//# 368 "../.js/default/ocaml_intrinsics_kernel/ocaml_intrinsics_kernel.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Ocaml_intrinsics_kernel_Float = [
        0
    ];
    runtime.caml_register_global(0, Ocaml_intrinsics_kernel_Float, "Ocaml_intrinsics_kernel__Float");
    return;
})(globalThis);
//# 1 "../.js/default/base/base.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/base/base.cma.js"
//# 15 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Bool0 = [
        0
    ];
    runtime.caml_register_global(0, Base_Bool0, "Base__Bool0");
    return;
})(globalThis);
//# 24 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_obj_dup = runtime.caml_obj_dup;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function globalize_bool(b) {
        return b;
    }
    function globalize_char(c) {
        return c;
    }
    function globalize_unit(u) {
        return u;
    }
    function globalize_array(param, a) {
        return a.slice();
    }
    function globalize_list(f, param) {
        if (!param) return 0;
        var xs = param[2], x = param[1], _b_ = globalize_list(f, xs);
        return [
            0,
            caml_call1(f, x),
            _b_
        ];
    }
    function globalize_option(f, param) {
        if (!param) return 0;
        var x = param[1];
        return [
            0,
            caml_call1(f, x)
        ];
    }
    function globalize_result(globalize_a, globalize_b, t) {
        if (0 === t[0]) {
            var a = t[1];
            return [
                0,
                caml_call1(globalize_a, a)
            ];
        }
        var b = t[1];
        return [
            1,
            caml_call1(globalize_b, b)
        ];
    }
    function globalize_ref(param, r) {
        return [
            0,
            r[1]
        ];
    }
    function globalize_lazy_t(param, t) {
        return t;
    }
    var Base_Globalize = [
        0,
        globalize_bool,
        globalize_char,
        caml_obj_dup,
        function(_a_) {
            return _a_;
        },
        caml_obj_dup,
        caml_obj_dup,
        caml_obj_dup,
        caml_obj_dup,
        caml_obj_dup,
        globalize_unit,
        globalize_array,
        globalize_lazy_t,
        globalize_list,
        globalize_option,
        globalize_result,
        globalize_ref
    ];
    runtime.caml_register_global(0, Base_Globalize, "Base__Globalize");
    return;
})(globalThis);
//# 79 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_compare = runtime.caml_compare;
    function descending(x, y) {
        return caml_compare(y, x);
    }
    function max(x, y) {
        return runtime.caml_csel_value(runtime.caml_greaterequal(x, y), x, y);
    }
    function min(x, y) {
        return runtime.caml_csel_value(runtime.caml_lessequal(x, y), x, y);
    }
    var Base_Poly0 = [
        0,
        caml_compare,
        descending,
        min,
        max
    ];
    runtime.caml_register_global(0, Base_Poly0, "Base__Poly0");
    return;
})(globalThis);
//# 98 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bytes_compare = runtime.caml_bytes_compare, caml_bytes_equal = runtime.caml_bytes_equal, caml_bytes_greaterequal = runtime.caml_bytes_greaterequal, caml_bytes_lessequal = runtime.caml_bytes_lessequal, caml_equal = runtime.caml_equal, caml_greaterequal = runtime.caml_greaterequal, caml_greaterthan = runtime.caml_greaterthan, caml_int_compare = runtime.caml_int_compare, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_notequal = runtime.caml_notequal, caml_string_compare = runtime.caml_string_compare, caml_string_equal = runtime.caml_string_equal, caml_string_greaterequal = runtime.caml_string_greaterequal, caml_string_lessequal = runtime.caml_string_lessequal;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Poly0 = global_data.Base__Poly0, Shadow_stdlib = global_data.Shadow_stdlib, Stdlib = global_data.Stdlib, Stdlib_MoreLabels = global_data.Stdlib__MoreLabels, Exit = Shadow_stdlib[3], Not_found = Shadow_stdlib[4], max_int = Shadow_stdlib[8], min_int = Shadow_stdlib[9], infinity = Shadow_stdlib[11], neg_infinity = Shadow_stdlib[12], nan = Shadow_stdlib[13], max_float = Shadow_stdlib[14], min_float = Shadow_stdlib[15], epsilon_float = Shadow_stdlib[16], char_of_int = Shadow_stdlib[18], string_of_bool = Shadow_stdlib[19], bool_of_string_opt = Shadow_stdlib[20], bool_of_string = Shadow_stdlib[21], string_of_int = Shadow_stdlib[22], int_of_string_opt = Shadow_stdlib[23], string_of_float = Shadow_stdlib[24], float_of_string_opt = Shadow_stdlib[25], stdin = Shadow_stdlib[27], stdout = Shadow_stdlib[28], stderr = Shadow_stdlib[29], print_char = Shadow_stdlib[30], print_string = Shadow_stdlib[31], print_bytes = Shadow_stdlib[32], print_int = Shadow_stdlib[33], print_float = Shadow_stdlib[34], print_endline = Shadow_stdlib[35], print_newline = Shadow_stdlib[36], prerr_char = Shadow_stdlib[37], prerr_string = Shadow_stdlib[38], prerr_bytes = Shadow_stdlib[39], prerr_int = Shadow_stdlib[40], prerr_float = Shadow_stdlib[41], prerr_endline = Shadow_stdlib[42], prerr_newline = Shadow_stdlib[43], read_line = Shadow_stdlib[44], read_int_opt = Shadow_stdlib[45], read_int = Shadow_stdlib[46], read_float_opt = Shadow_stdlib[47], read_float = Shadow_stdlib[48], open_out = Shadow_stdlib[49], open_out_bin = Shadow_stdlib[50], open_out_gen = Shadow_stdlib[51], flush = Shadow_stdlib[52], flush_all = Shadow_stdlib[53], output_char = Shadow_stdlib[54], output_string = Shadow_stdlib[55], output_bytes = Shadow_stdlib[56], output = Shadow_stdlib[57], output_substring = Shadow_stdlib[58], output_byte = Shadow_stdlib[59], output_binary_int = Shadow_stdlib[60], output_value = Shadow_stdlib[61], seek_out = Shadow_stdlib[62], pos_out = Shadow_stdlib[63], out_channel_length = Shadow_stdlib[64], close_out = Shadow_stdlib[65], close_out_noerr = Shadow_stdlib[66], set_binary_mode_out = Shadow_stdlib[67], open_in = Shadow_stdlib[68], open_in_bin = Shadow_stdlib[69], open_in_gen = Shadow_stdlib[70], input_char = Shadow_stdlib[71], input_line = Shadow_stdlib[72], input = Shadow_stdlib[73], really_input = Shadow_stdlib[74], really_input_string = Shadow_stdlib[75], input_byte = Shadow_stdlib[76], input_binary_int = Shadow_stdlib[77], input_value = Shadow_stdlib[78], seek_in = Shadow_stdlib[79], pos_in = Shadow_stdlib[80], in_channel_length = Shadow_stdlib[81], close_in = Shadow_stdlib[82], close_in_noerr = Shadow_stdlib[83], set_binary_mode_in = Shadow_stdlib[84], string_of_format = Shadow_stdlib[85], symbol = Shadow_stdlib[86], exit = Shadow_stdlib[87], at_exit = Shadow_stdlib[88], valid_float_lexem = Shadow_stdlib[89], unsafe_really_input = Shadow_stdlib[90], do_at_exit = Shadow_stdlib[91], do_domain_local_at_exit = Shadow_stdlib[92], invalid_arg = Stdlib[1], failwith = Stdlib[2], Exit$0 = Stdlib[3], Match_failure = Stdlib[4], Assert_failure = Stdlib[5], Invalid_argument = Stdlib[6], Failure = Stdlib[7], Not_found$0 = Stdlib[8], Out_of_memory = Stdlib[9], Stack_overflow = Stdlib[10], Sys_error = Stdlib[11], End_of_file = Stdlib[12], Division_by_zero = Stdlib[13], Sys_blocked_io = Stdlib[14], Undefined_recursive_module = Stdlib[15], min = Stdlib[16], max = Stdlib[17], abs = Stdlib[18], max_int$0 = Stdlib[19], min_int$0 = Stdlib[20], lnot = Stdlib[21], infinity$0 = Stdlib[22], neg_infinity$0 = Stdlib[23], nan$0 = Stdlib[24], max_float$0 = Stdlib[25], min_float$0 = Stdlib[26], epsilon_float$0 = Stdlib[27], symbol_concat = Stdlib[28], char_of_int$0 = Stdlib[29], string_of_bool$0 = Stdlib[30], bool_of_string_opt$0 = Stdlib[31], bool_of_string$0 = Stdlib[32], string_of_int$0 = Stdlib[33], int_of_string_opt$0 = Stdlib[34], string_of_float$0 = Stdlib[35], float_of_string_opt$0 = Stdlib[36], symbol$0 = Stdlib[37], stdin$0 = Stdlib[38], stdout$0 = Stdlib[39], stderr$0 = Stdlib[40], print_char$0 = Stdlib[41], print_string$0 = Stdlib[42], print_bytes$0 = Stdlib[43], print_int$0 = Stdlib[44], print_float$0 = Stdlib[45], print_endline$0 = Stdlib[46], print_newline$0 = Stdlib[47], prerr_char$0 = Stdlib[48], prerr_string$0 = Stdlib[49], prerr_bytes$0 = Stdlib[50], prerr_int$0 = Stdlib[51], prerr_float$0 = Stdlib[52], prerr_endline$0 = Stdlib[53], prerr_newline$0 = Stdlib[54], read_line$0 = Stdlib[55], read_int_opt$0 = Stdlib[56], read_int$0 = Stdlib[57], read_float_opt$0 = Stdlib[58], read_float$0 = Stdlib[59], open_out$0 = Stdlib[60], open_out_bin$0 = Stdlib[61], open_out_gen$0 = Stdlib[62], flush$0 = Stdlib[63], flush_all$0 = Stdlib[64], output_char$0 = Stdlib[65], output_string$0 = Stdlib[66], output_bytes$0 = Stdlib[67], output$0 = Stdlib[68], output_substring$0 = Stdlib[69], output_byte$0 = Stdlib[70], output_binary_int$0 = Stdlib[71], output_value$0 = Stdlib[72], seek_out$0 = Stdlib[73], pos_out$0 = Stdlib[74], out_channel_length$0 = Stdlib[75], close_out$0 = Stdlib[76], close_out_noerr$0 = Stdlib[77], set_binary_mode_out$0 = Stdlib[78], open_in$0 = Stdlib[79], open_in_bin$0 = Stdlib[80], open_in_gen$0 = Stdlib[81], input_char$0 = Stdlib[82], input_line$0 = Stdlib[83], input$0 = Stdlib[84], really_input$0 = Stdlib[85], really_input_string$0 = Stdlib[86], input_byte$0 = Stdlib[87], input_binary_int$0 = Stdlib[88], input_value$0 = Stdlib[89], seek_in$0 = Stdlib[90], pos_in$0 = Stdlib[91], in_channel_length$0 = Stdlib[92], close_in$0 = Stdlib[93], close_in_noerr$0 = Stdlib[94], set_binary_mode_in$0 = Stdlib[95], LargeFile = Stdlib[96], string_of_format$0 = Stdlib[97], symbol$1 = Stdlib[98], exit$0 = Stdlib[99], at_exit$0 = Stdlib[100], valid_float_lexem$0 = Stdlib[101], unsafe_really_input$0 = Stdlib[102], do_at_exit$0 = Stdlib[103], do_domain_local_at_exit$0 = Stdlib[104], Hashtbl = Stdlib_MoreLabels[1], Map = Stdlib_MoreLabels[2], Set = Stdlib_MoreLabels[3], Stdlib$0 = [
        0,
        invalid_arg,
        failwith,
        Exit$0,
        Match_failure,
        Assert_failure,
        Invalid_argument,
        Failure,
        Not_found$0,
        Out_of_memory,
        Stack_overflow,
        Sys_error,
        End_of_file,
        Division_by_zero,
        Sys_blocked_io,
        Undefined_recursive_module,
        min,
        max,
        abs,
        max_int$0,
        min_int$0,
        lnot,
        infinity$0,
        neg_infinity$0,
        nan$0,
        max_float$0,
        min_float$0,
        epsilon_float$0,
        symbol_concat,
        char_of_int$0,
        string_of_bool$0,
        bool_of_string_opt$0,
        bool_of_string$0,
        string_of_int$0,
        int_of_string_opt$0,
        string_of_float$0,
        float_of_string_opt$0,
        symbol$0,
        stdin$0,
        stdout$0,
        stderr$0,
        print_char$0,
        print_string$0,
        print_bytes$0,
        print_int$0,
        print_float$0,
        print_endline$0,
        print_newline$0,
        prerr_char$0,
        prerr_string$0,
        prerr_bytes$0,
        prerr_int$0,
        prerr_float$0,
        prerr_endline$0,
        prerr_newline$0,
        read_line$0,
        read_int_opt$0,
        read_int$0,
        read_float_opt$0,
        read_float$0,
        open_out$0,
        open_out_bin$0,
        open_out_gen$0,
        flush$0,
        flush_all$0,
        output_char$0,
        output_string$0,
        output_bytes$0,
        output$0,
        output_substring$0,
        output_byte$0,
        output_binary_int$0,
        output_value$0,
        seek_out$0,
        pos_out$0,
        out_channel_length$0,
        close_out$0,
        close_out_noerr$0,
        set_binary_mode_out$0,
        open_in$0,
        open_in_bin$0,
        open_in_gen$0,
        input_char$0,
        input_line$0,
        input$0,
        really_input$0,
        really_input_string$0,
        input_byte$0,
        input_binary_int$0,
        input_value$0,
        seek_in$0,
        pos_in$0,
        in_channel_length$0,
        close_in$0,
        close_in_noerr$0,
        set_binary_mode_in$0,
        LargeFile,
        string_of_format$0,
        symbol$1,
        exit$0,
        at_exit$0,
        valid_float_lexem$0,
        unsafe_really_input$0,
        do_at_exit$0,
        do_domain_local_at_exit$0,
        Hashtbl,
        Map,
        Set
    ];
    function bool_to_int(x) {
        return x;
    }
    function symbol$2(_F_, _E_) {
        return _F_ !== _E_ ? 1 : 0;
    }
    var symbol$3 = runtime.caml_mul;
    function symbol$4(_D_, _C_) {
        return Math.pow(_D_, _C_);
    }
    function symbol$5(_B_, _A_) {
        return _B_ * _A_;
    }
    function symbol$6(_z_, _y_) {
        return _z_ + _y_ | 0;
    }
    function symbol$7(_x_, _w_) {
        return _x_ + _w_;
    }
    function symbol$8(_v_, _u_) {
        return _v_ - _u_ | 0;
    }
    function symbol$9(_t_, _s_) {
        return _t_ - _s_;
    }
    var symbol$10 = runtime.caml_div;
    function symbol$11(_r_, _q_) {
        return _r_ / _q_;
    }
    var ascending = caml_int_compare;
    function descending(x, y) {
        return caml_int_compare(y, x);
    }
    function max$0(x, y) {
        return runtime.caml_csel_value(y <= x ? 1 : 0, x, y);
    }
    function min$0(x, y) {
        return runtime.caml_csel_value(x <= y ? 1 : 0, x, y);
    }
    var Int_replace_polymorphic_compar = [
        0,
        ascending,
        descending,
        max$0,
        min$0
    ], ascending$0 = Int_replace_polymorphic_compar[1], descending$0 = Int_replace_polymorphic_compar[2], max$1 = Int_replace_polymorphic_compar[3], min$1 = Int_replace_polymorphic_compar[4], symbol$12 = caml_lessthan, symbol$13 = caml_lessequal, symbol$14 = caml_notequal, symbol$15 = caml_equal, symbol$16 = caml_greaterthan, symbol$17 = caml_greaterequal;
    function ascending$1(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$1(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare = caml_int_compare, compare_local = caml_int_compare, equal = caml_equal, equal_local = caml_equal;
    function max$2(x, y) {
        return runtime.caml_csel_value(caml_greaterequal(x, y), x, y);
    }
    function min$2(x, y) {
        return runtime.caml_csel_value(caml_lessequal(x, y), x, y);
    }
    var Int32_replace_polymorphic_comp = [
        0,
        symbol$12,
        symbol$13,
        symbol$14,
        symbol$15,
        symbol$16,
        symbol$17,
        ascending$1,
        descending$1,
        compare,
        compare_local,
        equal,
        equal_local,
        max$2,
        min$2
    ];
    function ascending$2(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$2(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    function max$3(x, y) {
        return runtime.caml_csel_value(caml_greaterequal(x, y), x, y);
    }
    function min$3(x, y) {
        return runtime.caml_csel_value(caml_lessequal(x, y), x, y);
    }
    var Int64_replace_polymorphic_comp = [
        0,
        ascending$2,
        descending$2,
        max$3,
        min$3
    ], symbol$18 = caml_lessthan, symbol$19 = caml_lessequal, symbol$20 = caml_notequal, symbol$21 = caml_equal, symbol$22 = caml_greaterthan, symbol$23 = caml_greaterequal;
    function ascending$3(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$3(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$0 = caml_int_compare, compare_local$0 = caml_int_compare, equal$0 = caml_equal, equal_local$0 = caml_equal;
    function max$4(x, y) {
        return runtime.caml_csel_value(caml_greaterequal(x, y), x, y);
    }
    function min$4(x, y) {
        return runtime.caml_csel_value(caml_lessequal(x, y), x, y);
    }
    var Nativeint_replace_polymorphic_ = [
        0,
        symbol$18,
        symbol$19,
        symbol$20,
        symbol$21,
        symbol$22,
        symbol$23,
        ascending$3,
        descending$3,
        compare$0,
        compare_local$0,
        equal$0,
        equal_local$0,
        max$4,
        min$4
    ];
    function symbol$24(x, y) {
        return x < y ? 1 : 0;
    }
    function symbol$25(x, y) {
        return x <= y ? 1 : 0;
    }
    function symbol$26(x, y) {
        return x !== y ? 1 : 0;
    }
    function symbol$27(x, y) {
        return x === y ? 1 : 0;
    }
    function symbol$28(x, y) {
        return y < x ? 1 : 0;
    }
    function symbol$29(x, y) {
        return y <= x ? 1 : 0;
    }
    function ascending$4(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$4(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$1 = caml_int_compare, compare_local$1 = caml_int_compare;
    function equal$1(x, y) {
        return x === y ? 1 : 0;
    }
    function equal_local$1(x, y) {
        return x === y ? 1 : 0;
    }
    function max$5(x, y) {
        return runtime.caml_csel_value(y <= x ? 1 : 0, x, y);
    }
    function min$5(x, y) {
        return runtime.caml_csel_value(x <= y ? 1 : 0, x, y);
    }
    var Bool_replace_polymorphic_compa = [
        0,
        symbol$24,
        symbol$25,
        symbol$26,
        symbol$27,
        symbol$28,
        symbol$29,
        ascending$4,
        descending$4,
        compare$1,
        compare_local$1,
        equal$1,
        equal_local$1,
        max$5,
        min$5
    ];
    function symbol$30(x, y) {
        return x < y ? 1 : 0;
    }
    function symbol$31(x, y) {
        return x <= y ? 1 : 0;
    }
    function symbol$32(x, y) {
        return x !== y ? 1 : 0;
    }
    function symbol$33(x, y) {
        return x === y ? 1 : 0;
    }
    function symbol$34(x, y) {
        return y < x ? 1 : 0;
    }
    function symbol$35(x, y) {
        return y <= x ? 1 : 0;
    }
    function ascending$5(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$5(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$2 = caml_int_compare, compare_local$2 = caml_int_compare;
    function equal$2(x, y) {
        return x === y ? 1 : 0;
    }
    function equal_local$2(x, y) {
        return x === y ? 1 : 0;
    }
    function max$6(x, y) {
        return runtime.caml_csel_value(y <= x ? 1 : 0, x, y);
    }
    function min$6(x, y) {
        return runtime.caml_csel_value(x <= y ? 1 : 0, x, y);
    }
    var Char_replace_polymorphic_compa = [
        0,
        symbol$30,
        symbol$31,
        symbol$32,
        symbol$33,
        symbol$34,
        symbol$35,
        ascending$5,
        descending$5,
        compare$2,
        compare_local$2,
        equal$2,
        equal_local$2,
        max$6,
        min$6
    ];
    function symbol$36(x, y) {
        return x < y ? 1 : 0;
    }
    function symbol$37(x, y) {
        return x <= y ? 1 : 0;
    }
    function symbol$38(x, y) {
        return x !== y ? 1 : 0;
    }
    function symbol$39(x, y) {
        return x === y ? 1 : 0;
    }
    function symbol$40(x, y) {
        return y < x ? 1 : 0;
    }
    function symbol$41(x, y) {
        return y <= x ? 1 : 0;
    }
    function ascending$6(x, y) {
        return caml_call2(Int_replace_polymorphic_compar[1], x, y);
    }
    function descending$6(x, y) {
        return caml_call2(Int_replace_polymorphic_compar[2], x, y);
    }
    var compare$3 = caml_int_compare;
    function equal$3(x, y) {
        return x === y ? 1 : 0;
    }
    var compare_local$3 = caml_int_compare;
    function equal_local$3(x, y) {
        return x === y ? 1 : 0;
    }
    function max$7(x, y) {
        return runtime.caml_csel_value(y <= x ? 1 : 0, x, y);
    }
    function min$7(x, y) {
        return runtime.caml_csel_value(x <= y ? 1 : 0, x, y);
    }
    var Uchar_replace_polymorphic_comp = [
        0,
        symbol$36,
        symbol$37,
        symbol$38,
        symbol$39,
        symbol$40,
        symbol$41,
        ascending$6,
        descending$6,
        compare$3,
        equal$3,
        compare_local$3,
        equal_local$3,
        max$7,
        min$7
    ];
    function ascending$7(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$7(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare_local$4 = runtime.caml_float_compare;
    function equal_local$4(x, y) {
        return x == y ? 1 : 0;
    }
    function max$8(x, y) {
        return runtime.caml_csel_value(y <= x ? 1 : 0, x, y);
    }
    function min$8(x, y) {
        return runtime.caml_csel_value(x <= y ? 1 : 0, x, y);
    }
    var Float_replace_polymorphic_comp = [
        0,
        ascending$7,
        descending$7,
        compare_local$4,
        equal_local$4,
        max$8,
        min$8
    ], symbol$42 = runtime.caml_string_lessthan, symbol$43 = caml_string_lessequal, symbol$44 = runtime.caml_string_notequal, symbol$45 = caml_string_equal, symbol$46 = runtime.caml_string_greaterthan, symbol$47 = caml_string_greaterequal;
    function ascending$8(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$8(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$4 = caml_string_compare, compare_local$5 = caml_string_compare, equal$4 = caml_string_equal, equal_local$5 = caml_string_equal;
    function max$9(x, y) {
        return runtime.caml_csel_value(caml_string_greaterequal(x, y), x, y);
    }
    function min$9(x, y) {
        return runtime.caml_csel_value(caml_string_lessequal(x, y), x, y);
    }
    var String_replace_polymorphic_com = [
        0,
        symbol$42,
        symbol$43,
        symbol$44,
        symbol$45,
        symbol$46,
        symbol$47,
        ascending$8,
        descending$8,
        compare$4,
        compare_local$5,
        equal$4,
        equal_local$5,
        max$9,
        min$9
    ], symbol$48 = runtime.caml_bytes_lessthan, symbol$49 = caml_bytes_lessequal, symbol$50 = runtime.caml_bytes_notequal, symbol$51 = caml_bytes_equal, symbol$52 = runtime.caml_bytes_greaterthan, symbol$53 = caml_bytes_greaterequal;
    function ascending$9(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$9(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$5 = caml_bytes_compare, compare_local$6 = caml_bytes_compare, equal$5 = caml_bytes_equal, equal_local$6 = caml_bytes_equal;
    function max$10(x, y) {
        return runtime.caml_csel_value(caml_bytes_greaterequal(x, y), x, y);
    }
    function min$10(x, y) {
        return runtime.caml_csel_value(caml_bytes_lessequal(x, y), x, y);
    }
    var Bytes_replace_polymorphic_comp = [
        0,
        symbol$48,
        symbol$49,
        symbol$50,
        symbol$51,
        symbol$52,
        symbol$53,
        ascending$9,
        descending$9,
        compare$5,
        compare_local$6,
        equal$5,
        equal_local$6,
        max$10,
        min$10
    ], symbol$54 = Stdlib$0[37], symbol_concat$0 = Stdlib$0[28];
    function symbol$55(_p_) {
        return -_p_ | 0;
    }
    function symbol$56(_o_) {
        return -_o_;
    }
    function asr(_n_, _m_) {
        return _n_ >> _m_;
    }
    function land(_l_, _k_) {
        return _l_ & _k_;
    }
    var lnot$0 = Stdlib$0[21];
    function lor(_j_, _i_) {
        return _j_ | _i_;
    }
    function lsl(_h_, _g_) {
        return _h_ << _g_;
    }
    function lsr(_f_, _e_) {
        return _f_ >>> _e_ | 0;
    }
    function lxor(_d_, _c_) {
        return _d_ ^ _c_;
    }
    var mod = runtime.caml_mod, abs$0 = Stdlib$0[18], failwith$0 = Stdlib$0[2];
    function fst(_b_) {
        return _b_[1];
    }
    var invalid_arg$0 = Stdlib$0[1];
    function snd(_a_) {
        return _a_[2];
    }
    var float_of_string = runtime.caml_float_of_string, am_testing = runtime.Base_am_testing(0), Base_Import0 = [
        0,
        Exit,
        Not_found,
        max_int,
        min_int,
        infinity,
        neg_infinity,
        nan,
        max_float,
        min_float,
        epsilon_float,
        char_of_int,
        string_of_bool,
        bool_of_string_opt,
        bool_of_string,
        string_of_int,
        int_of_string_opt,
        string_of_float,
        float_of_string_opt,
        stdin,
        stdout,
        stderr,
        print_char,
        print_string,
        print_bytes,
        print_int,
        print_float,
        print_endline,
        print_newline,
        prerr_char,
        prerr_string,
        prerr_bytes,
        prerr_int,
        prerr_float,
        prerr_endline,
        prerr_newline,
        read_line,
        read_int_opt,
        read_int,
        read_float_opt,
        read_float,
        open_out,
        open_out_bin,
        open_out_gen,
        flush,
        flush_all,
        output_char,
        output_string,
        output_bytes,
        output,
        output_substring,
        output_byte,
        output_binary_int,
        output_value,
        seek_out,
        pos_out,
        out_channel_length,
        close_out,
        close_out_noerr,
        set_binary_mode_out,
        open_in,
        open_in_bin,
        open_in_gen,
        input_char,
        input_line,
        input,
        really_input,
        really_input_string,
        input_byte,
        input_binary_int,
        input_value,
        seek_in,
        pos_in,
        in_channel_length,
        close_in,
        close_in_noerr,
        set_binary_mode_in,
        string_of_format,
        symbol,
        exit,
        at_exit,
        valid_float_lexem,
        unsafe_really_input,
        do_at_exit,
        do_domain_local_at_exit,
        Stdlib$0,
        bool_to_int,
        symbol$2,
        symbol$3,
        symbol$4,
        symbol$5,
        symbol$6,
        symbol$7,
        symbol$8,
        symbol$9,
        symbol$10,
        symbol$11,
        Int_replace_polymorphic_compar,
        ascending$0,
        descending$0,
        max$1,
        min$1,
        Int32_replace_polymorphic_comp,
        Int64_replace_polymorphic_comp,
        Nativeint_replace_polymorphic_,
        Bool_replace_polymorphic_compa,
        Char_replace_polymorphic_compa,
        Uchar_replace_polymorphic_comp,
        Float_replace_polymorphic_comp,
        String_replace_polymorphic_com,
        Bytes_replace_polymorphic_comp,
        symbol$54,
        symbol_concat$0,
        symbol$55,
        symbol$56,
        asr,
        land,
        lnot$0,
        lor,
        lsl,
        lsr,
        lxor,
        mod,
        abs$0,
        failwith$0,
        fst,
        invalid_arg$0,
        snd,
        float_of_string,
        am_testing
    ];
    runtime.caml_register_global(4, Base_Import0, "Base__Import0");
    return;
})(globalThis);
//# 871 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, to_string = Stdlib[33], of_string = runtime.caml_int_of_string, of_string_opt = Stdlib[34];
    function to_float(_d_) {
        return _d_;
    }
    function of_float(_c_) {
        return _c_ | 0;
    }
    var max_value = Stdlib[19], min_value = Stdlib[20];
    function succ(_b_) {
        return _b_ + 1 | 0;
    }
    function pred(_a_) {
        return _a_ - 1 | 0;
    }
    var Base_Int0 = [
        0,
        to_string,
        of_string,
        of_string_opt,
        to_float,
        of_float,
        max_value,
        min_value,
        succ,
        pred
    ];
    runtime.caml_register_global(1, Base_Int0, "Base__Int0");
    return;
})(globalThis);
//# 905 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Stdlib_Printf = global_data.Stdlib__Printf, sprintf = Stdlib_Printf[4], bprintf = Stdlib_Printf[5], ifprintf = Stdlib_Printf[6], ksprintf = Stdlib_Printf[10], kbprintf = Stdlib_Printf[11];
    function failwithf(fmt) {
        return caml_call2(ksprintf, function(s, param) {
            return caml_call1(Base_Import0[124], s);
        }, fmt);
    }
    function invalid_argf(fmt) {
        return caml_call2(ksprintf, function(s, param) {
            return caml_call1(Base_Import0[126], s);
        }, fmt);
    }
    var Base_Printf = [
        0,
        ifprintf,
        sprintf,
        bprintf,
        ksprintf,
        kbprintf,
        failwithf,
        invalid_argf
    ];
    runtime.caml_register_global(2, Base_Printf, "Base__Printf");
    return;
})(globalThis);
//# 957 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_sys_argv = runtime.caml_sys_argv, caml_sys_getenv = runtime.caml_sys_getenv, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Base_Printf = global_data.Base__Printf, Stdlib_Sys = global_data.Stdlib__Sys, backend_type = Stdlib_Sys[5], interactive = Stdlib_Sys[3], os_type = Stdlib_Sys[4], unix = Stdlib_Sys[6], win32 = Stdlib_Sys[7], cygwin = Stdlib_Sys[8], word_size_in_bits = Stdlib_Sys[9], int_size_in_bits = Stdlib_Sys[10], big_endian = Stdlib_Sys[11], max_string_length = Stdlib_Sys[12], max_array_length = Stdlib_Sys[13], runtime_variant = runtime.caml_runtime_variant, runtime_parameters = runtime.caml_runtime_parameters, argv = caml_sys_argv(0);
    function get_argv(param) {
        return caml_sys_argv(0);
    }
    var ocaml_version = Stdlib_Sys[46], enable_runtime_warnings = Stdlib_Sys[49], runtime_warnings_enabled = Stdlib_Sys[50], _a_ = [
        0,
        [
            11,
            "Sys.getenv_exn: environment variable ",
            [
                2,
                0,
                [
                    11,
                    " is not set",
                    0
                ]
            ]
        ],
        "Sys.getenv_exn: environment variable %s is not set"
    ];
    function Make_immediate64(_h_, _g_) {
        return caml_call1(caml_call1(Stdlib_Sys[51][1], _h_), _g_);
    }
    function getenv_exn(var$0) {
        try {
            var _e_ = caml_sys_getenv(var$0);
            return _e_;
        } catch (_f_) {
            var _d_ = caml_wrap_exception(_f_);
            if (_d_ === Base_Import0[85][8]) return caml_call3(Base_Printf[6], _a_, var$0, 0);
            throw caml_maybe_attach_backtrace(_d_, 0);
        }
    }
    function getenv(var$0) {
        try {
            var x = caml_sys_getenv(var$0);
        } catch (_c_) {
            var _b_ = caml_wrap_exception(_c_);
            if (_b_ === Base_Import0[85][8]) return 0;
            throw caml_maybe_attach_backtrace(_b_, 0);
        }
        return [
            0,
            x
        ];
    }
    var Break = Stdlib_Sys[44], Base_Sys0 = [
        0,
        backend_type,
        interactive,
        os_type,
        unix,
        win32,
        cygwin,
        word_size_in_bits,
        int_size_in_bits,
        big_endian,
        max_string_length,
        max_array_length,
        runtime_variant,
        runtime_parameters,
        argv,
        get_argv,
        ocaml_version,
        enable_runtime_warnings,
        runtime_warnings_enabled,
        Make_immediate64,
        getenv_exn,
        getenv,
        Break
    ];
    runtime.caml_register_global(4, Base_Sys0, "Base__Sys0");
    return;
})(globalThis);
//# 1060 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_check_bound = runtime.caml_check_bound, caml_make_vect = runtime.caml_make_vect;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_ArrayLabels = global_data.Stdlib__ArrayLabels, Base_Import0 = global_data.Base__Import0, Base_Int0 = global_data.Base__Int0;
    global_data.Stdlib;
    var Base_Printf = global_data.Base__Printf, Base_Sys0 = global_data.Base__Sys0, invalid_argf = Base_Printf[7], Array1 = [
        0
    ], max_length = Base_Sys0[11];
    function create(len, x) {
        return caml_make_vect(len, x);
    }
    function create_local(len, x) {
        return caml_make_vect(len, x);
    }
    function create_float_uninitialized(len) {
        return runtime.caml_make_float_vect(len);
    }
    var append = Stdlib_ArrayLabels[4], blit = Stdlib_ArrayLabels[9], concat = Stdlib_ArrayLabels[5], copy = Stdlib_ArrayLabels[7], fill = Stdlib_ArrayLabels[8], cst_Array_init = "Array.init";
    function init(len, f) {
        if (0 === len) return [
            0
        ];
        if (0 > len) return caml_call1(Base_Import0[126], cst_Array_init);
        var x = caml_call1(f, 0), res = caml_make_vect(len, x), _s_ = caml_call1(Base_Int0[9], len), _r_ = 1;
        if (_s_ >= 1) {
            var i = _r_;
            for(;;){
                res[1 + i] = caml_call1(f, i);
                var _t_ = i + 1 | 0;
                if (_s_ === i) break;
                i = _t_;
            }
        }
        return res;
    }
    var make_matrix = Stdlib_ArrayLabels[2], of_list = Stdlib_ArrayLabels[11], sub = Stdlib_ArrayLabels[6], to_list = Stdlib_ArrayLabels[10];
    function fold(t, init, f) {
        var r = [
            0,
            init
        ], _p_ = caml_call2(Base_Import0[93], t.length - 1, 1), _o_ = 0;
        if (_p_ >= 0) {
            var i = _o_;
            for(;;){
                r[1] = caml_call2(f, r[1], t[1 + i]);
                var _q_ = i + 1 | 0;
                if (_p_ === i) break;
                i = _q_;
            }
        }
        return r[1];
    }
    function fold_right(t, f, init) {
        var r = [
            0,
            init
        ], _m_ = caml_call2(Base_Import0[93], t.length - 1, 1);
        if (_m_ >= 0) {
            var i = _m_;
            for(;;){
                r[1] = caml_call2(f, t[1 + i], r[1]);
                var _n_ = i - 1 | 0;
                if (0 === i) break;
                i = _n_;
            }
        }
        return r[1];
    }
    function iter(t, f) {
        var _k_ = caml_call2(Base_Import0[93], t.length - 1, 1), _j_ = 0;
        if (_k_ >= 0) {
            var i = _j_;
            for(;;){
                caml_call1(f, t[1 + i]);
                var _l_ = i + 1 | 0;
                if (_k_ === i) break;
                i = _l_;
            }
        }
        return 0;
    }
    function iteri(t, f) {
        var _h_ = caml_call2(Base_Import0[93], t.length - 1, 1), _g_ = 0;
        if (_h_ >= 0) {
            var i = _g_;
            for(;;){
                caml_call2(f, i, t[1 + i]);
                var _i_ = i + 1 | 0;
                if (_h_ === i) break;
                i = _i_;
            }
        }
        return 0;
    }
    function map(t, f) {
        var len = t.length - 1;
        if (0 === len) return [
            0
        ];
        var x = caml_call1(f, t[1]), r = caml_make_vect(len, x), _e_ = caml_call2(Base_Import0[93], len, 1), _d_ = 1;
        if (_e_ >= 1) {
            var i = _d_;
            for(;;){
                r[1 + i] = caml_call1(f, t[1 + i]);
                var _f_ = i + 1 | 0;
                if (_e_ === i) break;
                i = _f_;
            }
        }
        return r;
    }
    function mapi(t, f) {
        var len = t.length - 1;
        if (0 === len) return [
            0
        ];
        var x = caml_call2(f, 0, t[1]), r = caml_make_vect(len, x), _b_ = caml_call2(Base_Import0[93], len, 1), _a_ = 1;
        if (_b_ >= 1) {
            var i = _a_;
            for(;;){
                r[1 + i] = caml_call2(f, i, t[1 + i]);
                var _c_ = i + 1 | 0;
                if (_b_ === i) break;
                i = _c_;
            }
        }
        return r;
    }
    function stable_sort(t, compare) {
        return caml_call2(Stdlib_ArrayLabels[36], compare, t);
    }
    function swap(t, i, j) {
        var elt_i = caml_check_bound(t, i)[1 + i], elt_j = caml_check_bound(t, j)[1 + j];
        t[1 + i] = elt_j;
        t[1 + j] = elt_i;
        return 0;
    }
    var Base_Array0 = [
        0,
        invalid_argf,
        Array1,
        max_length,
        create,
        create_local,
        create_float_uninitialized,
        append,
        blit,
        concat,
        copy,
        fill,
        init,
        make_matrix,
        of_list,
        sub,
        to_list,
        fold,
        fold_right,
        iter,
        iteri,
        map,
        mapi,
        stable_sort,
        swap
    ];
    runtime.caml_register_global(10, Base_Array0, "Base__Array0");
    return;
})(globalThis);
//# 1263 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Printf = global_data.Base__Printf, Stdlib_Char = global_data.Stdlib__Char, failwithf = Base_Printf[6], escaped = Stdlib_Char[2], lowercase = Stdlib_Char[3];
    function to_int(_e_) {
        return _e_;
    }
    function unsafe_of_int(_d_) {
        return _d_;
    }
    var uppercase = Stdlib_Char[4];
    function int_is_ok(i) {
        var _b_ = 0 <= i ? 1 : 0, _c_ = _b_ ? i <= 255 ? 1 : 0 : _b_;
        return _c_;
    }
    var _a_ = [
        0,
        [
            11,
            "Char.of_int_exn got integer out of range: ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "Char.of_int_exn got integer out of range: %d"
    ];
    function of_int(i) {
        return int_is_ok(i) ? [
            0,
            i
        ] : 0;
    }
    function of_int_exn(i) {
        return int_is_ok(i) ? i : caml_call3(failwithf, _a_, i, 0);
    }
    function equal(t1, t2) {
        return t1 === t2 ? 1 : 0;
    }
    var Base_Char0 = [
        0,
        failwithf,
        escaped,
        lowercase,
        to_int,
        unsafe_of_int,
        uppercase,
        int_is_ok,
        0,
        255,
        of_int,
        of_int_exn,
        equal
    ];
    runtime.caml_register_global(3, Base_Char0, "Base__Char0");
    return;
})(globalThis);
//# 1317 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Hash_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Hash_intf, "Base__Hash_intf");
    return;
})(globalThis);
//# 1327 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Stdlib_ListLabels = global_data.Stdlib__ListLabels, hd_exn = Stdlib_ListLabels[6], rev_append = Stdlib_ListLabels[13], tl_exn = Stdlib_ListLabels[7], unzip = Stdlib_ListLabels[57], cst_List_exists2 = "List.exists2", cst_List_fold_left2 = "List.fold_left2", cst_List_for_all2 = "List.for_all2", cst_List_iter2 = "List.iter2", cst_List_rev_map2 = "List.rev_map2";
    function length(l$0) {
        var len = 0, param = l$0;
        for(;;){
            if (!param) return len;
            var l = param[2], len$0 = caml_call2(Base_Import0[91], len, 1);
            len = len$0;
            param = l;
        }
    }
    function exists(t, f) {
        var t$0 = t;
        for(;;){
            if (!t$0) return 0;
            var xs = t$0[2], x = t$0[1];
            if (caml_call1(f, x)) return 1;
            t$0 = xs;
        }
    }
    function exists2_ok(l1, l2, f) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], _c_ = caml_call2(f, a1, a2);
                    if (_c_) return _c_;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 0;
            return caml_call1(Base_Import0[126], cst_List_exists2);
        }
    }
    function fold(t, init, f) {
        var t$0 = t, init$0 = init;
        for(;;){
            if (!t$0) return init$0;
            var l = t$0[2], a = t$0[1], init$1 = caml_call2(f, init$0, a);
            t$0 = l;
            init$0 = init$1;
        }
    }
    function fold2_ok(l1, l2, init, f) {
        var l1$0 = l1, l2$0 = l2, init$0 = init;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], init$1 = caml_call3(f, init$0, a1, a2);
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    init$0 = init$1;
                    continue;
                }
            } else if (!l2$0) return init$0;
            return caml_call1(Base_Import0[126], cst_List_fold_left2);
        }
    }
    function for_all(t, f) {
        return 1 - exists(t, function(x) {
            return 1 - caml_call1(f, x);
        });
    }
    function for_all2_ok(l1, l2, f) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], _b_ = caml_call2(f, a1, a2);
                    if (!_b_) return _b_;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 1;
            return caml_call1(Base_Import0[126], cst_List_for_all2);
        }
    }
    function iter(t, f) {
        var t$0 = t;
        for(;;){
            if (!t$0) return 0;
            var l = t$0[2], a = t$0[1];
            caml_call1(f, a);
            t$0 = l;
        }
    }
    function iter2_ok(l1, l2, f) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1];
                    caml_call2(f, a1, a2);
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 0;
            return caml_call1(Base_Import0[126], cst_List_iter2);
        }
    }
    function nontail_map(t, f) {
        if (!t) return 0;
        var xs = t[2], x = t[1], y = caml_call1(f, x);
        return [
            0,
            y,
            nontail_map(xs, f)
        ];
    }
    function nontail_mapi(t, f) {
        return caml_call2(Stdlib_ListLabels[21], f, t);
    }
    function partition(t, f) {
        return caml_call2(Stdlib_ListLabels[47], f, t);
    }
    function rev_map(l$0, f) {
        var accu = 0, param = l$0;
        for(;;){
            if (!param) return accu;
            var l = param[2], a = param[1], accu$0 = [
                0,
                caml_call1(f, a),
                accu
            ];
            accu = accu$0;
            param = l;
        }
    }
    function rev_map2_ok(l1$1, l2$1, f) {
        var accu = 0, l1 = l1$1, l2 = l2$1;
        for(;;){
            if (l1) {
                if (l2) {
                    var l2$0 = l2[2], a2 = l2[1], l1$0 = l1[2], a1 = l1[1], accu$0 = [
                        0,
                        caml_call2(f, a1, a2),
                        accu
                    ];
                    accu = accu$0;
                    l1 = l1$0;
                    l2 = l2$0;
                    continue;
                }
            } else if (!l2) return accu;
            return caml_call1(Base_Import0[126], cst_List_rev_map2);
        }
    }
    function rev(res) {
        if (res) {
            var match = res[2];
            if (match) {
                var rest = match[2], y = match[1], x = res[1];
                return caml_call2(rev_append, rest, [
                    0,
                    y,
                    [
                        0,
                        x,
                        0
                    ]
                ]);
            }
        }
        return res;
    }
    function fold_right(l, f, init) {
        return l ? fold(rev(l), init, function(a, b) {
            return caml_call2(f, b, a);
        }) : init;
    }
    function fold_right2_ok(l1, l2, f, init) {
        if (!l1 && !l2) return init;
        var _a_ = rev(l2);
        return fold2_ok(rev(l1), _a_, init, function(a, b, c) {
            return caml_call3(f, b, c, a);
        });
    }
    var Base_List0 = [
        0,
        hd_exn,
        rev_append,
        tl_exn,
        unzip,
        length,
        exists,
        exists2_ok,
        fold,
        fold2_ok,
        for_all,
        for_all2_ok,
        iter,
        iter2_ok,
        nontail_map,
        nontail_mapi,
        partition,
        rev_map,
        rev_map2_ok,
        rev,
        fold_right,
        fold_right2_ok
    ];
    runtime.caml_register_global(7, Base_List0, "Base__List0");
    return;
})(globalThis);
//# 1571 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), description = "internalhash", Base_Import0 = global_data.Base__Import0, Base_Int0 = global_data.Base__Int0, CamlinternalLazy = global_data.CamlinternalLazy, Base_List0 = global_data.Base__List0, Base_Char0 = global_data.Base__Char0;
    function Folding(Hash) {
        function hash_fold_unit(s, param) {
            return s;
        }
        var hash_fold_int = Hash[2], hash_fold_int64 = Hash[3], hash_fold_float = Hash[4], hash_fold_string = Hash[5];
        function as_int(f, s, x) {
            return caml_call2(hash_fold_int, s, caml_call1(f, x));
        }
        function _H_(_ah_) {
            return _ah_;
        }
        function hash_fold_int32(_af_, _ag_) {
            return as_int(_H_, _af_, _ag_);
        }
        var _I_ = Base_Char0[4];
        function hash_fold_char(_ad_, _ae_) {
            return as_int(_I_, _ad_, _ae_);
        }
        function _J_(param) {
            return param ? 1 : 0;
        }
        function hash_fold_bool(_ab_, _ac_) {
            return as_int(_J_, _ab_, _ac_);
        }
        function hash_fold_nativeint(s, x) {
            return caml_call2(hash_fold_int64, s, runtime.caml_int64_of_int32(x));
        }
        function hash_fold_option(hash_fold_elem, s, param) {
            if (!param) return caml_call2(hash_fold_int, s, 0);
            var x = param[1];
            return caml_call2(hash_fold_elem, caml_call2(hash_fold_int, s, 1), x);
        }
        function hash_fold_list(hash_fold_elem, s$1, list$1) {
            var s$2 = caml_call2(hash_fold_int, s$1, caml_call1(Base_List0[5], list$1)), s = s$2, list = list$1;
            for(;;){
                if (!list) return s;
                var list$0 = list[2], x = list[1], s$0 = caml_call2(hash_fold_elem, s, x);
                s = s$0;
                list = list$0;
            }
        }
        function hash_fold_lazy_t(hash_fold_elem, s, x) {
            var _$_ = runtime.caml_obj_tag(x);
            a: if (250 === _$_) var _aa_ = x[1];
            else {
                if (246 !== _$_ && 244 !== _$_) {
                    var _aa_ = x;
                    break a;
                }
                var _aa_ = caml_call1(CamlinternalLazy[2], x);
            }
            return caml_call2(hash_fold_elem, s, _aa_);
        }
        function hash_fold_ref_frozen(hash_fold_elem, s, x) {
            return caml_call2(hash_fold_elem, s, x[1]);
        }
        function hash_fold_array_frozen(hash_fold_elem, s$1, array) {
            var s$2 = caml_call2(hash_fold_int, s$1, array.length - 1), s = s$2, i = 0;
            for(;;){
                if (i === array.length - 1) return s;
                var e = array[1 + i], i$0 = caml_call2(Base_Import0[91], i, 1), s$0 = caml_call2(hash_fold_elem, s, e);
                s = s$0;
                i = i$0;
            }
        }
        function hash_nativeint(x) {
            var _Z_ = caml_call1(Hash[6], 0), ___ = hash_fold_nativeint(caml_call2(Hash[7], 0, _Z_), x);
            return caml_call1(Hash[8], ___);
        }
        function hash_int64(x) {
            var _X_ = caml_call1(Hash[6], 0), _Y_ = caml_call2(hash_fold_int64, caml_call2(Hash[7], 0, _X_), x);
            return caml_call1(Hash[8], _Y_);
        }
        function hash_int32(x) {
            var _V_ = caml_call1(Hash[6], 0), _W_ = as_int(_H_, caml_call2(Hash[7], 0, _V_), x);
            return caml_call1(Hash[8], _W_);
        }
        function hash_char(x) {
            var _T_1 = caml_call1(Hash[6], 0), _U_ = as_int(_I_, caml_call2(Hash[7], 0, _T_1), x);
            return caml_call1(Hash[8], _U_);
        }
        function hash_int(x) {
            var _R_ = caml_call1(Hash[6], 0), _S_ = caml_call2(hash_fold_int, caml_call2(Hash[7], 0, _R_), x);
            return caml_call1(Hash[8], _S_);
        }
        function hash_bool(x) {
            var _P_ = caml_call1(Hash[6], 0), _Q_ = as_int(_J_, caml_call2(Hash[7], 0, _P_), x);
            return caml_call1(Hash[8], _Q_);
        }
        function hash_string(x) {
            var _N_ = caml_call1(Hash[6], 0), _O_ = caml_call2(hash_fold_string, caml_call2(Hash[7], 0, _N_), x);
            return caml_call1(Hash[8], _O_);
        }
        function hash_float(x) {
            var _L_ = caml_call1(Hash[6], 0), _M_ = caml_call2(hash_fold_float, caml_call2(Hash[7], 0, _L_), x);
            return caml_call1(Hash[8], _M_);
        }
        function hash_unit(x) {
            var _K_ = caml_call1(Hash[6], 0), s = caml_call2(Hash[7], 0, _K_);
            return caml_call1(Hash[8], s);
        }
        return [
            0,
            hash_fold_nativeint,
            hash_fold_int64,
            hash_fold_int32,
            hash_fold_char,
            hash_fold_int,
            hash_fold_bool,
            hash_fold_string,
            hash_fold_float,
            hash_fold_unit,
            hash_fold_option,
            hash_fold_list,
            hash_fold_lazy_t,
            hash_fold_ref_frozen,
            hash_fold_array_frozen,
            hash_nativeint,
            hash_int64,
            hash_int32,
            hash_char,
            hash_int,
            hash_bool,
            hash_string,
            hash_float,
            hash_unit
        ];
    }
    function F(Hash) {
        var description = Hash[1], fold_int = Hash[2], fold_int64 = Hash[3], fold_float = Hash[4], fold_string = Hash[5], alloc = Hash[6], reset = Hash[7], get_hash_value = Hash[8], For_tests = Hash[9];
        function create(seed, param) {
            return caml_call2(reset, seed, caml_call1(alloc, 0));
        }
        function of_fold(hash_fold_t, t) {
            return caml_call1(get_hash_value, caml_call2(hash_fold_t, create(0, 0), t));
        }
        var Builtin = Folding(Hash);
        function run(seed, folder, x) {
            var _F_ = caml_call1(Hash[6], 0), _G_ = caml_call2(folder, caml_call2(Hash[7], seed, _F_), x);
            return caml_call1(Hash[8], _G_);
        }
        return [
            0,
            description,
            fold_int,
            fold_int64,
            fold_float,
            fold_string,
            alloc,
            reset,
            get_hash_value,
            For_tests,
            create,
            of_fold,
            Builtin,
            run
        ];
    }
    function alloc(param) {
        return 0;
    }
    function reset(opt, t) {
        var seed = opt ? opt[1] : 0;
        return seed;
    }
    var compare_state = runtime.caml_int_compare;
    function state_to_string(state) {
        return caml_call1(Base_Int0[1], state);
    }
    var For_tests = [
        0,
        compare_state,
        state_to_string
    ];
    function create(seed, param) {
        return reset(seed, 0);
    }
    function run(seed, folder, x) {
        return runtime.Base_internalhash_get_hash_value(caml_call2(folder, reset(seed, 0), x));
    }
    function of_fold(hash_fold_t, t) {
        return runtime.Base_internalhash_get_hash_value(caml_call2(hash_fold_t, create(0, 0), t));
    }
    var Folding$0 = Folding([
        0,
        description,
        function(_E_, _D_) {
            return runtime.Base_internalhash_fold_int(_E_, _D_);
        },
        function(_C_, _B_) {
            return runtime.Base_internalhash_fold_int64(_C_, _B_);
        },
        function(_A_, _z_) {
            return runtime.Base_internalhash_fold_float(_A_, _z_);
        },
        function(_y_, _x_) {
            return runtime.Base_internalhash_fold_string(_y_, _x_);
        },
        alloc,
        reset,
        function(_w_) {
            return runtime.Base_internalhash_get_hash_value(_w_);
        },
        For_tests
    ]), hash_fold_nativeint = Folding$0[1], hash_fold_int64 = Folding$0[2], hash_fold_int32 = Folding$0[3], hash_fold_char = Folding$0[4], hash_fold_int = Folding$0[5], hash_fold_bool = Folding$0[6], hash_fold_string = Folding$0[7], hash_fold_float = Folding$0[8], hash_fold_unit = Folding$0[9], hash_fold_option = Folding$0[10], hash_fold_list = Folding$0[11], hash_fold_lazy_t = Folding$0[12], hash_fold_ref_frozen = Folding$0[13], hash_fold_array_frozen = Folding$0[14], hash_nativeint = Folding$0[15], hash_int64 = Folding$0[16], hash_int32 = Folding$0[17], hash_string = Folding$0[21], hash_char = Base_Char0[4];
    function hash_int(t) {
        var _k_ = caml_call2(Base_Import0[119], t, 21), _l_ = caml_call1(Base_Import0[117], t), t$0 = caml_call2(Base_Import0[91], _l_, _k_), _m_ = caml_call2(Base_Import0[120], t$0, 24), t$1 = caml_call2(Base_Import0[121], t$0, _m_), _n_ = caml_call2(Base_Import0[119], t$1, 8), _o_ = caml_call2(Base_Import0[119], t$1, 3), _p_ = caml_call2(Base_Import0[91], t$1, _o_), t$2 = caml_call2(Base_Import0[91], _p_, _n_), _q_ = caml_call2(Base_Import0[120], t$2, 14), t$3 = caml_call2(Base_Import0[121], t$2, _q_), _r_ = caml_call2(Base_Import0[119], t$3, 4), _s_ = caml_call2(Base_Import0[119], t$3, 2), _t_ = caml_call2(Base_Import0[91], t$3, _s_), t$4 = caml_call2(Base_Import0[91], _t_, _r_), _u_ = caml_call2(Base_Import0[120], t$4, 28), t$5 = caml_call2(Base_Import0[121], t$4, _u_), _v_ = caml_call2(Base_Import0[119], t$5, 31);
        return caml_call2(Base_Import0[91], t$5, _v_);
    }
    function hash_bool(x) {
        return x ? 1 : 0;
    }
    function hash_unit(param) {
        return 0;
    }
    var Base_Hash = [
        0,
        F,
        description,
        function(_j_, _i_) {
            return runtime.Base_internalhash_fold_int(_j_, _i_);
        },
        function(_h_, _g_) {
            return runtime.Base_internalhash_fold_int64(_h_, _g_);
        },
        function(_f_, _e_) {
            return runtime.Base_internalhash_fold_float(_f_, _e_);
        },
        function(_d_, _c_) {
            return runtime.Base_internalhash_fold_string(_d_, _c_);
        },
        alloc,
        reset,
        function(_b_) {
            return runtime.Base_internalhash_get_hash_value(_b_);
        },
        For_tests,
        create,
        of_fold,
        [
            0,
            hash_fold_nativeint,
            hash_fold_int64,
            hash_fold_int32,
            hash_fold_char,
            hash_fold_int,
            hash_fold_bool,
            hash_fold_string,
            hash_fold_float,
            hash_fold_unit,
            hash_fold_option,
            hash_fold_list,
            hash_fold_lazy_t,
            hash_fold_ref_frozen,
            hash_fold_array_frozen,
            hash_nativeint,
            hash_int64,
            hash_int32,
            hash_char,
            hash_int,
            hash_bool,
            hash_string,
            function(_a_) {
                return runtime.Base_hash_double(_a_);
            },
            hash_unit
        ],
        run
    ];
    runtime.caml_register_global(6, Base_Hash, "Base__Hash");
    return;
})(globalThis);
//# 1910 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_which_is_abstract_in_an_im = ", which is abstract in an implementation.", caml_bytes_compare = runtime.caml_bytes_compare, caml_bytes_equal = runtime.caml_bytes_equal, caml_equal = runtime.caml_equal, caml_float_compare = runtime.caml_float_compare, caml_int64_compare = runtime.caml_int64_compare, caml_int_compare = runtime.caml_int_compare, caml_string_compare = runtime.caml_string_compare, caml_string_equal = runtime.caml_string_equal;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Base_Printf = global_data.Base__Printf, _a_ = [
        0,
        [
            11,
            "Compare called on the type ",
            [
                2,
                0,
                [
                    11,
                    cst_which_is_abstract_in_an_im,
                    0
                ]
            ]
        ],
        "Compare called on the type %s, which is abstract in an implementation."
    ], _b_ = [
        0,
        [
            11,
            "Equal called on the type ",
            [
                2,
                0,
                [
                    11,
                    cst_which_is_abstract_in_an_im,
                    0
                ]
            ]
        ],
        "Equal called on the type %s, which is abstract in an implementation."
    ];
    function compare_abstract(type_name, _F_, param) {
        return caml_call3(Base_Printf[4], Base_Import0[124], _a_, type_name);
    }
    function equal_abstract(type_name, _E_, param) {
        return caml_call3(Base_Printf[4], Base_Import0[124], _b_, type_name);
    }
    var Comparable = [
        0
    ], Equal = [
        0
    ], compare_bool = caml_int_compare, compare_bool_local = caml_int_compare, compare_char = caml_int_compare, compare_char_local = caml_int_compare, compare_float = caml_float_compare, compare_float_local = caml_float_compare, compare_int = caml_int_compare, compare_int_local = caml_int_compare, compare_int32 = caml_int_compare, compare_int32_local = caml_int_compare;
    function compare_int64(_D_, _C_) {
        return caml_int64_compare(_D_, _C_);
    }
    function compare_int64_local(_B_, _A_) {
        return caml_int64_compare(_B_, _A_);
    }
    var compare_nativeint = caml_int_compare, compare_nativeint_local = caml_int_compare, compare_string = caml_string_compare, compare_string_local = caml_string_compare, compare_bytes = caml_bytes_compare, compare_bytes_local = caml_bytes_compare, compare_unit = caml_int_compare, compare_unit_local = caml_int_compare;
    function compare_array_local(compare_elt, a, b) {
        if (a === b) return 0;
        var len_a = a.length - 1, len_b = b.length - 1, ret = caml_int_compare(len_a, len_b);
        if (0 !== ret) return ret;
        var i = 0;
        for(;;){
            if (i === len_a) return 0;
            var l = a[1 + i], r = b[1 + i], res = caml_call2(compare_elt, l, r);
            if (0 !== res) return res;
            var i$0 = caml_call2(Base_Import0[91], i, 1);
            i = i$0;
        }
    }
    function compare_array(compare_elt, a, b) {
        return compare_array_local(compare_elt, a, b);
    }
    function compare_list(compare_elt, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (!a$0) return b$0 ? -1 : 0;
            if (!b$0) return 1;
            var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], res = caml_call2(compare_elt, x, y);
            if (0 !== res) return res;
            a$0 = xs;
            b$0 = ys;
        }
    }
    function compare_list_local(compare_elt_local, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (!a$0) return b$0 ? -1 : 0;
            if (!b$0) return 1;
            var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], res = caml_call2(compare_elt_local, x, y);
            if (0 !== res) return res;
            a$0 = xs;
            b$0 = ys;
        }
    }
    function compare_option(compare_elt, a, b) {
        if (!a) return b ? -1 : 0;
        var a$0 = a[1];
        if (!b) return 1;
        var b$0 = b[1];
        return caml_call2(compare_elt, a$0, b$0);
    }
    function compare_option_local(compare_elt_local, a, b) {
        if (!a) return b ? -1 : 0;
        var a$0 = a[1];
        if (!b) return 1;
        var b$0 = b[1];
        return caml_call2(compare_elt_local, a$0, b$0);
    }
    function compare_ref(compare_elt, a, b) {
        return caml_call2(compare_elt, a[1], b[1]);
    }
    function compare_ref_local(compare_elt, a, b) {
        return caml_call2(compare_elt, a[1], b[1]);
    }
    function equal_bool(_z_, _y_) {
        return _z_ === _y_ ? 1 : 0;
    }
    function equal_bool_local(_x_, _w_) {
        return _x_ === _w_ ? 1 : 0;
    }
    function equal_char(_v_, _u_) {
        return _v_ === _u_ ? 1 : 0;
    }
    function equal_char_local(_t_, _s_) {
        return _t_ === _s_ ? 1 : 0;
    }
    function equal_int(_r_, _q_) {
        return _r_ === _q_ ? 1 : 0;
    }
    function equal_int_local(_p_, _o_) {
        return _p_ === _o_ ? 1 : 0;
    }
    var equal_int32 = caml_equal, equal_int32_local = caml_equal, equal_int64 = caml_equal, equal_int64_local = caml_equal, equal_nativeint = caml_equal, equal_nativeint_local = caml_equal, equal_string = caml_string_equal, equal_string_local = caml_string_equal, equal_bytes = caml_bytes_equal, equal_bytes_local = caml_bytes_equal;
    function equal_unit(_n_, _m_) {
        return _n_ === _m_ ? 1 : 0;
    }
    function equal_unit_local(_l_, _k_) {
        return _l_ === _k_ ? 1 : 0;
    }
    function equal_float(x, y) {
        return caml_float_compare(x, y) === 0 ? 1 : 0;
    }
    function equal_float_local(x, y) {
        return caml_float_compare(x, y) === 0 ? 1 : 0;
    }
    function equal_array_local(equal_elt, a, b) {
        var _e_ = a === b ? 1 : 0;
        if (_e_) var _f_ = _e_;
        else {
            var len_a = a.length - 1, len_b = b.length - 1, _g_ = len_a === len_b ? 1 : 0;
            if (_g_) {
                var i = 0;
                for(;;){
                    var _h_ = i === len_a ? 1 : 0;
                    if (_h_) var _i_ = _h_;
                    else {
                        var l = a[1 + i], r = b[1 + i], _j_ = caml_call2(equal_elt, l, r);
                        if (_j_) {
                            var i$0 = caml_call2(Base_Import0[91], i, 1);
                            i = i$0;
                            continue;
                        }
                        var _i_ = _j_;
                    }
                    return _i_;
                }
            }
            var _f_ = _g_;
        }
        return _f_;
    }
    function equal_array(equal_elt, a, b) {
        return equal_array_local(equal_elt, a, b);
    }
    function equal_list(equal_elt, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (a$0) {
                if (b$0) {
                    var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], _d_ = caml_call2(equal_elt, x, y);
                    if (!_d_) return _d_;
                    a$0 = xs;
                    b$0 = ys;
                    continue;
                }
            } else if (!b$0) return 1;
            return 0;
        }
    }
    function equal_list_local(equal_elt_local, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (a$0) {
                if (b$0) {
                    var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], _c_ = caml_call2(equal_elt_local, x, y);
                    if (!_c_) return _c_;
                    a$0 = xs;
                    b$0 = ys;
                    continue;
                }
            } else if (!b$0) return 1;
            return 0;
        }
    }
    function equal_option(equal_elt, a, b) {
        if (a) {
            if (b) {
                var b$0 = b[1], a$0 = a[1];
                return caml_call2(equal_elt, a$0, b$0);
            }
        } else if (!b) return 1;
        return 0;
    }
    function equal_option_local(equal_elt_local, a, b) {
        if (a) {
            if (b) {
                var b$0 = b[1], a$0 = a[1];
                return caml_call2(equal_elt_local, a$0, b$0);
            }
        } else if (!b) return 1;
        return 0;
    }
    function equal_ref(equal_elt, a, b) {
        return caml_call2(equal_elt, a[1], b[1]);
    }
    function equal_ref_local(equal_elt, a, b) {
        return caml_call2(equal_elt, a[1], b[1]);
    }
    var Base_Ppx_compare_lib = [
        0,
        compare_abstract,
        equal_abstract,
        Comparable,
        Equal,
        [
            0,
            compare_bool,
            compare_char,
            compare_float,
            compare_int,
            compare_int32,
            compare_int64,
            compare_nativeint,
            compare_string,
            compare_bytes,
            compare_unit,
            compare_array,
            compare_list,
            compare_option,
            compare_ref,
            equal_bool,
            equal_char,
            equal_float,
            equal_int,
            equal_int32,
            equal_int64,
            equal_nativeint,
            equal_string,
            equal_bytes,
            equal_unit,
            equal_array,
            equal_list,
            equal_option,
            equal_ref,
            compare_bool_local,
            compare_char_local,
            compare_float_local,
            compare_int_local,
            compare_int32_local,
            compare_int64_local,
            compare_nativeint_local,
            compare_string_local,
            compare_bytes_local,
            compare_unit_local,
            compare_array_local,
            compare_list_local,
            compare_option_local,
            compare_ref_local,
            equal_bool_local,
            equal_char_local,
            equal_float_local,
            equal_int_local,
            equal_int32_local,
            equal_int64_local,
            equal_nativeint_local,
            equal_string_local,
            equal_bytes_local,
            equal_unit_local,
            equal_array_local,
            equal_list_local,
            equal_option_local,
            equal_ref_local
        ]
    ];
    runtime.caml_register_global(4, Base_Ppx_compare_lib, "Base__Ppx_compare_lib");
    return;
})(globalThis);
//# 2262 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Ppx_compare_lib = global_data.Base__Ppx_compare_lib, Base_Globalize = global_data.Base__Globalize, Base_Hash = global_data.Base__Hash, Sexplib0_Sexp = global_data.Sexplib0__Sexp, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, t_of_sexp = Sexplib0_Sexp[1], sexp_of_t = Sexplib0_Sexp[2], equal = Sexplib0_Sexp[3], Not_found_s = Sexplib0_Sexp[5], Of_sexp_error = Sexplib0_Sexp[6], message = Sexplib0_Sexp[7], default_indent = Sexplib0_Sexp[8], pp_hum = Sexplib0_Sexp[9], pp_hum_indent = Sexplib0_Sexp[10], pp_mach = Sexplib0_Sexp[11], pp = Sexplib0_Sexp[12], to_string_hum = Sexplib0_Sexp[13], to_string_mach = Sexplib0_Sexp[14], to_string = Sexplib0_Sexp[15], of_float_style = Sexplib0_Sexp[16], of_int_style = Sexplib0_Sexp[17], Private = Sexplib0_Sexp[18];
    function compare_local(a_001, b_002) {
        if (a_001 === b_002) return 0;
        if (0 === a_001[0]) {
            var a_003 = a_001[1];
            if (0 !== b_002[0]) return -1;
            var b_004 = b_002[1];
            return caml_call2(Base_Ppx_compare_lib[5][36], a_003, b_004);
        }
        var a_005 = a_001[1];
        if (0 === b_002[0]) return 1;
        var b_006 = b_002[1];
        return caml_call3(Base_Ppx_compare_lib[5][40], compare_local, a_005, b_006);
    }
    function compare(a, b) {
        return compare_local(a, b);
    }
    function globalize(x_009) {
        if (0 === x_009[0]) {
            var arg_010 = x_009[1];
            return [
                0,
                caml_call1(Base_Globalize[9], arg_010)
            ];
        }
        var arg_011 = x_009[1];
        return [
            1,
            caml_call2(Base_Globalize[13], globalize, arg_011)
        ];
    }
    var letrec_function_context = [];
    function hash_fold_t(hsv, arg) {
        if (0 === arg[0]) {
            var a0 = arg[1], hsv$0 = caml_call2(Base_Hash[3], hsv, 0);
            return caml_call2(Base_Hash[13][7], hsv$0, a0);
        }
        var a0$0 = arg[1], hsv$1 = caml_call2(Base_Hash[3], hsv, 1);
        return caml_call3(Base_Hash[13][11], hash_fold_t, hsv$1, a0$0);
    }
    function hash(x) {
        return caml_call1(letrec_function_context[1], x);
    }
    function func(arg) {
        var hsv = caml_call2(Base_Hash[11], 0, 0), _a_ = hash_fold_t(hsv, arg);
        return caml_call1(Base_Hash[9], _a_);
    }
    runtime.caml_update_dummy(letrec_function_context, [
        0,
        func
    ]);
    var t_sexp_grammar = Sexplib0_Sexp_conv[61];
    function invariant(param) {
        return 0;
    }
    function equal_local(a, b) {
        return 0 === compare_local(a, b) ? 1 : 0;
    }
    var Base_Sexp = [
        0,
        globalize,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        equal,
        compare,
        Not_found_s,
        Of_sexp_error,
        message,
        default_indent,
        pp_hum,
        pp_hum_indent,
        pp_mach,
        pp,
        to_string_hum,
        to_string_mach,
        to_string,
        of_float_style,
        of_int_style,
        Private,
        equal_local,
        compare_local,
        t_sexp_grammar,
        invariant,
        0
    ];
    runtime.caml_register_global(5, Base_Sexp, "Base__Sexp");
    return;
})(globalThis);
//# 2382 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, Base_Hash = global_data.Base__Hash, Base_Ppx_compare_lib = global_data.Base__Ppx_compare_lib, Base_Globalize = global_data.Base__Globalize, Base_Sexp = global_data.Base__Sexp, Exit = Base_Import0[1], Not_found = Base_Import0[2], max_int = Base_Import0[3], min_int = Base_Import0[4], infinity = Base_Import0[5], neg_infinity = Base_Import0[6], nan = Base_Import0[7], max_float = Base_Import0[8], min_float = Base_Import0[9], epsilon_float = Base_Import0[10], char_of_int = Base_Import0[11], string_of_bool = Base_Import0[12], bool_of_string_opt = Base_Import0[13], bool_of_string = Base_Import0[14], string_of_int = Base_Import0[15], int_of_string_opt = Base_Import0[16], string_of_float = Base_Import0[17], float_of_string_opt = Base_Import0[18], stdin = Base_Import0[19], stdout = Base_Import0[20], stderr = Base_Import0[21], print_char = Base_Import0[22], print_string = Base_Import0[23], print_bytes = Base_Import0[24], print_int = Base_Import0[25], print_float = Base_Import0[26], print_endline = Base_Import0[27], print_newline = Base_Import0[28], prerr_char = Base_Import0[29], prerr_string = Base_Import0[30], prerr_bytes = Base_Import0[31], prerr_int = Base_Import0[32], prerr_float = Base_Import0[33], prerr_endline = Base_Import0[34], prerr_newline = Base_Import0[35], read_line = Base_Import0[36], read_int_opt = Base_Import0[37], read_int = Base_Import0[38], read_float_opt = Base_Import0[39], read_float = Base_Import0[40], open_out = Base_Import0[41], open_out_bin = Base_Import0[42], open_out_gen = Base_Import0[43], flush = Base_Import0[44], flush_all = Base_Import0[45], output_char = Base_Import0[46], output_string = Base_Import0[47], output_bytes = Base_Import0[48], output = Base_Import0[49], output_substring = Base_Import0[50], output_byte = Base_Import0[51], output_binary_int = Base_Import0[52], output_value = Base_Import0[53], seek_out = Base_Import0[54], pos_out = Base_Import0[55], out_channel_length = Base_Import0[56], close_out = Base_Import0[57], close_out_noerr = Base_Import0[58], set_binary_mode_out = Base_Import0[59], open_in = Base_Import0[60], open_in_bin = Base_Import0[61], open_in_gen = Base_Import0[62], input_char = Base_Import0[63], input_line = Base_Import0[64], input = Base_Import0[65], really_input = Base_Import0[66], really_input_string = Base_Import0[67], input_byte = Base_Import0[68], input_binary_int = Base_Import0[69], input_value = Base_Import0[70], seek_in = Base_Import0[71], pos_in = Base_Import0[72], in_channel_length = Base_Import0[73], close_in = Base_Import0[74], close_in_noerr = Base_Import0[75], set_binary_mode_in = Base_Import0[76], string_of_format = Base_Import0[77], symbol = Base_Import0[78], exit = Base_Import0[79], at_exit = Base_Import0[80], valid_float_lexem = Base_Import0[81], unsafe_really_input = Base_Import0[82], do_at_exit = Base_Import0[83], do_domain_local_at_exit = Base_Import0[84], Stdlib = Base_Import0[85], bool_to_int = Base_Import0[86], symbol$0 = Base_Import0[87], symbol$1 = Base_Import0[88], symbol$2 = Base_Import0[89], symbol$3 = Base_Import0[90], symbol$4 = Base_Import0[91], symbol$5 = Base_Import0[92], symbol$6 = Base_Import0[93], symbol$7 = Base_Import0[94], symbol$8 = Base_Import0[95], symbol$9 = Base_Import0[96], Int_replace_polymorphic_compar = Base_Import0[97], ascending = Base_Import0[98], descending = Base_Import0[99], max = Base_Import0[100], min = Base_Import0[101], Int32_replace_polymorphic_comp = Base_Import0[102], Int64_replace_polymorphic_comp = Base_Import0[103], Nativeint_replace_polymorphic_ = Base_Import0[104], Bool_replace_polymorphic_compa = Base_Import0[105], Char_replace_polymorphic_compa = Base_Import0[106], Uchar_replace_polymorphic_comp = Base_Import0[107], Float_replace_polymorphic_comp = Base_Import0[108], String_replace_polymorphic_com = Base_Import0[109], Bytes_replace_polymorphic_comp = Base_Import0[110], symbol$10 = Base_Import0[111], symbol_concat = Base_Import0[112], symbol$11 = Base_Import0[113], symbol$12 = Base_Import0[114], asr = Base_Import0[115], land = Base_Import0[116], lnot = Base_Import0[117], lor = Base_Import0[118], lsl = Base_Import0[119], lsr = Base_Import0[120], lxor = Base_Import0[121], mod = Base_Import0[122], abs = Base_Import0[123], failwith = Base_Import0[124], fst = Base_Import0[125], invalid_arg = Base_Import0[126], snd = Base_Import0[127], float_of_string = Base_Import0[128], am_testing = Base_Import0[129], default_string_of_float = Sexplib0_Sexp_conv[1], write_old_option_format = Sexplib0_Sexp_conv[2], read_old_option_format = Sexplib0_Sexp_conv[3], list_map = Sexplib0_Sexp_conv[4], sexp_of_unit = Sexplib0_Sexp_conv[5], sexp_of_bool = Sexplib0_Sexp_conv[6], sexp_of_string = Sexplib0_Sexp_conv[7], sexp_of_bytes = Sexplib0_Sexp_conv[8], sexp_of_char = Sexplib0_Sexp_conv[9], sexp_of_int = Sexplib0_Sexp_conv[10], sexp_of_float = Sexplib0_Sexp_conv[11], sexp_of_int32 = Sexplib0_Sexp_conv[12], sexp_of_int64 = Sexplib0_Sexp_conv[13], sexp_of_nativeint = Sexplib0_Sexp_conv[14], sexp_of_ref = Sexplib0_Sexp_conv[15], sexp_of_lazy_t = Sexplib0_Sexp_conv[16], sexp_of_option = Sexplib0_Sexp_conv[17], sexp_of_pair = Sexplib0_Sexp_conv[18], sexp_of_triple = Sexplib0_Sexp_conv[19], sexp_of_list = Sexplib0_Sexp_conv[20], sexp_of_array = Sexplib0_Sexp_conv[21], sexp_of_hashtbl = Sexplib0_Sexp_conv[22], sexp_of_opaque = Sexplib0_Sexp_conv[23], sexp_of_fun = Sexplib0_Sexp_conv[24], Of_sexp_error = Sexplib0_Sexp_conv[25], record_check_extra_fields = Sexplib0_Sexp_conv[26], of_sexp_error = Sexplib0_Sexp_conv[27], of_sexp_error_exn = Sexplib0_Sexp_conv[28], unit_of_sexp = Sexplib0_Sexp_conv[29], bool_of_sexp = Sexplib0_Sexp_conv[30], string_of_sexp = Sexplib0_Sexp_conv[31], bytes_of_sexp = Sexplib0_Sexp_conv[32], char_of_sexp = Sexplib0_Sexp_conv[33], int_of_sexp = Sexplib0_Sexp_conv[34], float_of_sexp = Sexplib0_Sexp_conv[35], int32_of_sexp = Sexplib0_Sexp_conv[36], int64_of_sexp = Sexplib0_Sexp_conv[37], nativeint_of_sexp = Sexplib0_Sexp_conv[38], ref_of_sexp = Sexplib0_Sexp_conv[39], lazy_t_of_sexp = Sexplib0_Sexp_conv[40], option_of_sexp = Sexplib0_Sexp_conv[41], pair_of_sexp = Sexplib0_Sexp_conv[42], triple_of_sexp = Sexplib0_Sexp_conv[43], list_of_sexp = Sexplib0_Sexp_conv[44], array_of_sexp = Sexplib0_Sexp_conv[45], hashtbl_of_sexp = Sexplib0_Sexp_conv[46], opaque_of_sexp = Sexplib0_Sexp_conv[47], fun_of_sexp = Sexplib0_Sexp_conv[48], sexp_grammar_with_tags = Sexplib0_Sexp_conv[49], sexp_grammar_with_tag_list = Sexplib0_Sexp_conv[50], unit_sexp_grammar = Sexplib0_Sexp_conv[51], bool_sexp_grammar = Sexplib0_Sexp_conv[52], string_sexp_grammar = Sexplib0_Sexp_conv[53], bytes_sexp_grammar = Sexplib0_Sexp_conv[54], char_sexp_grammar = Sexplib0_Sexp_conv[55], int_sexp_grammar = Sexplib0_Sexp_conv[56], float_sexp_grammar = Sexplib0_Sexp_conv[57], int32_sexp_grammar = Sexplib0_Sexp_conv[58], int64_sexp_grammar = Sexplib0_Sexp_conv[59], nativeint_sexp_grammar = Sexplib0_Sexp_conv[60], sexp_t_sexp_grammar = Sexplib0_Sexp_conv[61], ref_sexp_grammar = Sexplib0_Sexp_conv[62], lazy_t_sexp_grammar = Sexplib0_Sexp_conv[63], option_sexp_grammar = Sexplib0_Sexp_conv[64], list_sexp_grammar = Sexplib0_Sexp_conv[65], array_sexp_grammar = Sexplib0_Sexp_conv[66], opaque_sexp_grammar = Sexplib0_Sexp_conv[67], fun_sexp_grammar = Sexplib0_Sexp_conv[68], sexp_of_exn = Sexplib0_Sexp_conv[69], printexc_prefer_sexp = Sexplib0_Sexp_conv[70], sexp_of_exn_opt = Sexplib0_Sexp_conv[71], Exn_converter = Sexplib0_Sexp_conv[72], _a_ = Base_Hash[13], hash_fold_nativeint = _a_[1], hash_fold_int64 = _a_[2], hash_fold_int32 = _a_[3], hash_fold_char = _a_[4], hash_fold_int = _a_[5], hash_fold_bool = _a_[6], hash_fold_string = _a_[7], hash_fold_float = _a_[8], hash_fold_unit = _a_[9], hash_fold_option = _a_[10], hash_fold_list = _a_[11], hash_fold_lazy_t = _a_[12], hash_fold_ref_frozen = _a_[13], hash_fold_array_frozen = _a_[14], hash_nativeint = _a_[15], hash_int64 = _a_[16], hash_int32 = _a_[17], hash_char = _a_[18], hash_int = _a_[19], hash_bool = _a_[20], hash_string = _a_[21], hash_float = _a_[22], hash_unit = _a_[23], _b_ = Base_Ppx_compare_lib[5], compare_bool = _b_[1], compare_char = _b_[2], compare_float = _b_[3], compare_int = _b_[4], compare_int32 = _b_[5], compare_int64 = _b_[6], compare_nativeint = _b_[7], compare_string = _b_[8], compare_bytes = _b_[9], compare_unit = _b_[10], compare_array = _b_[11], compare_list = _b_[12], compare_option = _b_[13], compare_ref = _b_[14], equal_bool = _b_[15], equal_char = _b_[16], equal_float = _b_[17], equal_int = _b_[18], equal_int32 = _b_[19], equal_int64 = _b_[20], equal_nativeint = _b_[21], equal_string = _b_[22], equal_bytes = _b_[23], equal_unit = _b_[24], equal_array = _b_[25], equal_list = _b_[26], equal_option = _b_[27], equal_ref = _b_[28], compare_bool_local = _b_[29], compare_char_local = _b_[30], compare_float_local = _b_[31], compare_int_local = _b_[32], compare_int32_local = _b_[33], compare_int64_local = _b_[34], compare_nativeint_local = _b_[35], compare_string_local = _b_[36], compare_bytes_local = _b_[37], compare_unit_local = _b_[38], compare_array_local = _b_[39], compare_list_local = _b_[40], compare_option_local = _b_[41], compare_ref_local = _b_[42], equal_bool_local = _b_[43], equal_char_local = _b_[44], equal_float_local = _b_[45], equal_int_local = _b_[46], equal_int32_local = _b_[47], equal_int64_local = _b_[48], equal_nativeint_local = _b_[49], equal_string_local = _b_[50], equal_bytes_local = _b_[51], equal_unit_local = _b_[52], equal_array_local = _b_[53], equal_list_local = _b_[54], equal_option_local = _b_[55], equal_ref_local = _b_[56], globalize_bool = Base_Globalize[1], globalize_char = Base_Globalize[2], globalize_float = Base_Globalize[3], globalize_int = Base_Globalize[4], globalize_int32 = Base_Globalize[5], globalize_int64 = Base_Globalize[6], globalize_nativeint = Base_Globalize[7], globalize_bytes = Base_Globalize[8], globalize_string = Base_Globalize[9], globalize_unit = Base_Globalize[10], globalize_array = Base_Globalize[11], globalize_lazy_t = Base_Globalize[12], globalize_list = Base_Globalize[13], globalize_option = Base_Globalize[14], globalize_result = Base_Globalize[15], globalize_ref = Base_Globalize[16], Not_found_s = Base_Sexp[8], Base_Import = [
        0,
        Exit,
        Not_found,
        max_int,
        min_int,
        infinity,
        neg_infinity,
        nan,
        max_float,
        min_float,
        epsilon_float,
        char_of_int,
        string_of_bool,
        bool_of_string_opt,
        bool_of_string,
        string_of_int,
        int_of_string_opt,
        string_of_float,
        float_of_string_opt,
        stdin,
        stdout,
        stderr,
        print_char,
        print_string,
        print_bytes,
        print_int,
        print_float,
        print_endline,
        print_newline,
        prerr_char,
        prerr_string,
        prerr_bytes,
        prerr_int,
        prerr_float,
        prerr_endline,
        prerr_newline,
        read_line,
        read_int_opt,
        read_int,
        read_float_opt,
        read_float,
        open_out,
        open_out_bin,
        open_out_gen,
        flush,
        flush_all,
        output_char,
        output_string,
        output_bytes,
        output,
        output_substring,
        output_byte,
        output_binary_int,
        output_value,
        seek_out,
        pos_out,
        out_channel_length,
        close_out,
        close_out_noerr,
        set_binary_mode_out,
        open_in,
        open_in_bin,
        open_in_gen,
        input_char,
        input_line,
        input,
        really_input,
        really_input_string,
        input_byte,
        input_binary_int,
        input_value,
        seek_in,
        pos_in,
        in_channel_length,
        close_in,
        close_in_noerr,
        set_binary_mode_in,
        string_of_format,
        symbol,
        exit,
        at_exit,
        valid_float_lexem,
        unsafe_really_input,
        do_at_exit,
        do_domain_local_at_exit,
        Stdlib,
        bool_to_int,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        symbol$5,
        symbol$6,
        symbol$7,
        symbol$8,
        symbol$9,
        Int_replace_polymorphic_compar,
        ascending,
        descending,
        max,
        min,
        Int32_replace_polymorphic_comp,
        Int64_replace_polymorphic_comp,
        Nativeint_replace_polymorphic_,
        Bool_replace_polymorphic_compa,
        Char_replace_polymorphic_compa,
        Uchar_replace_polymorphic_comp,
        Float_replace_polymorphic_comp,
        String_replace_polymorphic_com,
        Bytes_replace_polymorphic_comp,
        symbol$10,
        symbol_concat,
        symbol$11,
        symbol$12,
        asr,
        land,
        lnot,
        lor,
        lsl,
        lsr,
        lxor,
        mod,
        abs,
        failwith,
        fst,
        invalid_arg,
        snd,
        float_of_string,
        am_testing,
        default_string_of_float,
        write_old_option_format,
        read_old_option_format,
        list_map,
        sexp_of_unit,
        sexp_of_bool,
        sexp_of_string,
        sexp_of_bytes,
        sexp_of_char,
        sexp_of_int,
        sexp_of_float,
        sexp_of_int32,
        sexp_of_int64,
        sexp_of_nativeint,
        sexp_of_ref,
        sexp_of_lazy_t,
        sexp_of_option,
        sexp_of_pair,
        sexp_of_triple,
        sexp_of_list,
        sexp_of_array,
        sexp_of_hashtbl,
        sexp_of_opaque,
        sexp_of_fun,
        Of_sexp_error,
        record_check_extra_fields,
        of_sexp_error,
        of_sexp_error_exn,
        unit_of_sexp,
        bool_of_sexp,
        string_of_sexp,
        bytes_of_sexp,
        char_of_sexp,
        int_of_sexp,
        float_of_sexp,
        int32_of_sexp,
        int64_of_sexp,
        nativeint_of_sexp,
        ref_of_sexp,
        lazy_t_of_sexp,
        option_of_sexp,
        pair_of_sexp,
        triple_of_sexp,
        list_of_sexp,
        array_of_sexp,
        hashtbl_of_sexp,
        opaque_of_sexp,
        fun_of_sexp,
        sexp_grammar_with_tags,
        sexp_grammar_with_tag_list,
        unit_sexp_grammar,
        bool_sexp_grammar,
        string_sexp_grammar,
        bytes_sexp_grammar,
        char_sexp_grammar,
        int_sexp_grammar,
        float_sexp_grammar,
        int32_sexp_grammar,
        int64_sexp_grammar,
        nativeint_sexp_grammar,
        sexp_t_sexp_grammar,
        ref_sexp_grammar,
        lazy_t_sexp_grammar,
        option_sexp_grammar,
        list_sexp_grammar,
        array_sexp_grammar,
        opaque_sexp_grammar,
        fun_sexp_grammar,
        sexp_of_exn,
        printexc_prefer_sexp,
        sexp_of_exn_opt,
        Exn_converter,
        hash_fold_nativeint,
        hash_fold_int64,
        hash_fold_int32,
        hash_fold_char,
        hash_fold_int,
        hash_fold_bool,
        hash_fold_string,
        hash_fold_float,
        hash_fold_unit,
        hash_fold_option,
        hash_fold_list,
        hash_fold_lazy_t,
        hash_fold_ref_frozen,
        hash_fold_array_frozen,
        hash_nativeint,
        hash_int64,
        hash_int32,
        hash_char,
        hash_int,
        hash_bool,
        hash_string,
        hash_float,
        hash_unit,
        compare_bool,
        compare_char,
        compare_float,
        compare_int,
        compare_int32,
        compare_int64,
        compare_nativeint,
        compare_string,
        compare_bytes,
        compare_unit,
        compare_array,
        compare_list,
        compare_option,
        compare_ref,
        equal_bool,
        equal_char,
        equal_float,
        equal_int,
        equal_int32,
        equal_int64,
        equal_nativeint,
        equal_string,
        equal_bytes,
        equal_unit,
        equal_array,
        equal_list,
        equal_option,
        equal_ref,
        compare_bool_local,
        compare_char_local,
        compare_float_local,
        compare_int_local,
        compare_int32_local,
        compare_int64_local,
        compare_nativeint_local,
        compare_string_local,
        compare_bytes_local,
        compare_unit_local,
        compare_array_local,
        compare_list_local,
        compare_option_local,
        compare_ref_local,
        equal_bool_local,
        equal_char_local,
        equal_float_local,
        equal_int_local,
        equal_int32_local,
        equal_int64_local,
        equal_nativeint_local,
        equal_string_local,
        equal_bytes_local,
        equal_unit_local,
        equal_array_local,
        equal_list_local,
        equal_option_local,
        equal_ref_local,
        globalize_bool,
        globalize_char,
        globalize_float,
        globalize_int,
        globalize_int32,
        globalize_int64,
        globalize_nativeint,
        globalize_bytes,
        globalize_string,
        globalize_unit,
        globalize_array,
        globalize_lazy_t,
        globalize_list,
        globalize_option,
        globalize_result,
        globalize_ref,
        Not_found_s
    ];
    runtime.caml_register_global(6, Base_Import, "Base__Import");
    return;
})(globalThis);
//# 2999 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Sys0 = global_data.Base__Sys0, Base_Import = global_data.Base__Import, _a_ = [
        0,
        "W64"
    ], _b_ = [
        0,
        "W32"
    ];
    function sexp_of_t(param) {
        return param ? _a_ : _b_;
    }
    function num_bits(param) {
        return param ? 64 : 32;
    }
    var _c_ = Base_Sys0[7], cst_unknown_word_size = "unknown word size", word_size = 32 === _c_ ? 0 : 64 === _c_ ? 1 : caml_call1(Base_Import[124], cst_unknown_word_size), Base_Word_size = [
        0,
        sexp_of_t,
        num_bits,
        word_size
    ];
    runtime.caml_register_global(5, Base_Word_size, "Base__Word_size");
    return;
})(globalThis);
//# 3040 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Format = global_data.Stdlib__Format, Base_Import = global_data.Base__Import, r = [
        0,
        [
            0,
            "Base.Sexp.pp_hum",
            0
        ]
    ], cst_pp = ".pp";
    function all(param) {
        return r[1];
    }
    function register(p) {
        r[1] = [
            0,
            p,
            r[1]
        ];
        return 0;
    }
    function Register_pp(M) {
        var pp = M[1];
        register(caml_call2(Base_Import[112], M[2], cst_pp));
        return [
            0,
            pp
        ];
    }
    var Base_Pretty_printer = [
        0,
        all,
        function(M) {
            var module_name = M[1];
            function pp(formatter, t) {
                var _b_ = caml_call1(M[2], t);
                return caml_call2(Stdlib_Format[13], formatter, _b_);
            }
            return [
                0,
                Register_pp([
                    0,
                    pp,
                    module_name
                ])[1]
            ];
        },
        function(_a_) {
            return [
                0,
                Register_pp(_a_)[1]
            ];
        },
        register
    ];
    runtime.caml_register_global(4, Base_Pretty_printer, "Base__Pretty_printer");
    return;
})(globalThis);
//# 3089 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_2 = "<2>", cst_src_exn_ml = "src/exn.ml", caml_fresh_oo_id = runtime.caml_fresh_oo_id, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), module_name = "Base.Exn", Stdlib_Printexc = global_data.Stdlib__Printexc, Base_Import = global_data.Base__Import, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Format = global_data.Stdlib__Format, Base_Sexp = global_data.Base__Sexp, Base_Printf = global_data.Base__Printf, Assert_failure = global_data.Assert_failure, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, Base_Pretty_printer = global_data.Base__Pretty_printer, sexp_of_t = Base_Import[198], exit = Base_Import[85][99], Finally = [
        248,
        "Base__Exn.Finally",
        caml_fresh_oo_id(0)
    ], _a_ = [
        0,
        "exn.ml.Finally"
    ], _b_ = [
        0,
        cst_src_exn_ml,
        19,
        11
    ];
    caml_call4(Sexplib0_Sexp_conv[72][1], 0, 0, Finally, function(param) {
        if (param[1] !== Finally) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        var arg1_002 = param[3], arg0_001 = param[2], res0_003 = caml_call1(sexp_of_t, arg0_001), res1_004 = caml_call1(sexp_of_t, arg1_002);
        return [
            1,
            [
                0,
                _a_,
                [
                    0,
                    res0_003,
                    [
                        0,
                        res1_004,
                        0
                    ]
                ]
            ]
        ];
    });
    var Reraised = [
        248,
        "Base__Exn.Reraised",
        caml_fresh_oo_id(0)
    ], _c_ = [
        0,
        "exn.ml.Reraised"
    ], _d_ = [
        0,
        cst_src_exn_ml,
        32,
        11
    ];
    caml_call4(Sexplib0_Sexp_conv[72][1], 0, 0, Reraised, function(param) {
        if (param[1] !== Reraised) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _d_
        ], 1);
        var arg1_006 = param[3], arg0_005 = param[2], res0_007 = caml_call1(Base_Import[136], arg0_005), res1_008 = caml_call1(sexp_of_t, arg1_006);
        return [
            1,
            [
                0,
                _c_,
                [
                    0,
                    res0_007,
                    [
                        0,
                        res1_008,
                        0
                    ]
                ]
            ]
        ];
    });
    var Sexp = [
        248,
        "Base__Exn.Sexp",
        caml_fresh_oo_id(0)
    ], _e_ = [
        0,
        cst_src_exn_ml,
        53,
        6
    ];
    caml_call4(Sexplib0_Sexp_conv[72][1], 0, 0, Sexp, function(param) {
        if (param[1] !== Sexp) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
        var t = param[2];
        return t;
    });
    var _f_ = [
        0,
        2
    ];
    function create_s(sexp) {
        return [
            0,
            Sexp,
            sexp
        ];
    }
    function raise_with_original_backtrace(t, backtrace) {
        runtime.caml_restore_raw_backtrace(t, backtrace);
        throw caml_maybe_attach_backtrace(t, 0);
    }
    function reraise(exn, str) {
        var exn$0 = [
            0,
            Reraised,
            str,
            exn
        ];
        if (!runtime.Base_caml_exn_is_most_recent_exn(exn)) throw caml_maybe_attach_backtrace(exn$0, 1);
        var bt = caml_call1(Stdlib_Printexc[12], 0);
        return raise_with_original_backtrace(exn$0, bt);
    }
    function reraisef(exc, format) {
        return caml_call2(Base_Printf[4], function(str, param) {
            return reraise(exc, str);
        }, format);
    }
    function to_string(exc) {
        var _u_ = caml_call1(Base_Import[198], exc);
        return caml_call2(Base_Sexp[16], _f_, _u_);
    }
    function to_string_mach(exc) {
        var _t_ = caml_call1(Base_Import[198], exc);
        return caml_call1(Base_Sexp[17], _t_);
    }
    var sexp_of_t$0 = Base_Import[198];
    function protectx(f, x, finally$0) {
        try {
            var res = caml_call1(f, x);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0), bt = caml_call1(Stdlib_Printexc[12], 0);
            try {
                caml_call1(finally$0, x);
            } catch (final_exn$0) {
                var final_exn = caml_wrap_exception(final_exn$0);
                return raise_with_original_backtrace([
                    0,
                    Finally,
                    exn,
                    final_exn
                ], bt);
            }
            return raise_with_original_backtrace(exn, bt);
        }
        caml_call1(finally$0, x);
        return res;
    }
    function protect(f, finally$0) {
        return protectx(f, 0, finally$0);
    }
    function does_raise(f) {
        try {
            caml_call1(f, 0);
            var _r_ = 0;
            return _r_;
        } catch (_s_) {
            return 1;
        }
    }
    function pp(ppf, t) {
        var match = caml_call1(Base_Import[200], t);
        if (match) {
            var sexp = match[1];
            return caml_call2(Base_Sexp[12], ppf, sexp);
        }
        var _q_ = caml_call1(Stdlib_Printexc[1], t);
        return caml_call2(Stdlib_Format[13], ppf, _q_);
    }
    var include = caml_call1(Base_Pretty_printer[3], [
        0,
        pp,
        module_name
    ]), pp$0 = include[1], _g_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_2,
                        0
                    ],
                    cst_2
                ]
            ],
            [
                11,
                "Uncaught exception:",
                [
                    17,
                    3,
                    [
                        17,
                        3,
                        [
                            18,
                            [
                                1,
                                [
                                    0,
                                    0,
                                    ""
                                ]
                            ],
                            [
                                15,
                                [
                                    17,
                                    0,
                                    [
                                        17,
                                        0,
                                        [
                                            17,
                                            3,
                                            [
                                                17,
                                                4,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<2>Uncaught exception:@\n@\n@[%a@]@]@\n@."
    ], _h_ = [
        0,
        [
            11,
            "Exn.handle_uncaught could not print; exiting anyway\n",
            [
                10,
                0
            ]
        ],
        "Exn.handle_uncaught could not print; exiting anyway\n%!"
    ];
    function print_with_backtrace(exc, raw_backtrace) {
        caml_call3(Stdlib_Format[141], _g_, pp$0, exc);
        if (caml_call1(Stdlib_Printexc[8], 0)) caml_call2(Stdlib_Printexc[13], Base_Import[85][40], raw_backtrace);
        return caml_call1(Base_Import[85][63], Base_Import[85][40]);
    }
    function handle_uncaught_aux(do_at_exit, exit, f) {
        try {
            var _m_ = caml_call1(f, 0);
            return _m_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), raw_backtrace = caml_call1(Stdlib_Printexc[12], 0);
            if (do_at_exit) try {
                caml_call1(Base_Import[85][103], 0);
            } catch (_p_) {}
            try {
                print_with_backtrace(exc, raw_backtrace);
            } catch (_n_) {
                try {
                    caml_call1(Stdlib_Printf[3], _h_);
                } catch (_o_) {}
            }
            return caml_call1(exit, 1);
        }
    }
    function handle_uncaught_and_exit(f) {
        return handle_uncaught_aux(1, exit, f);
    }
    function handle_uncaught(must_exit, f) {
        var exit$0 = must_exit ? exit : function(_l_) {
            return 0;
        };
        return handle_uncaught_aux(must_exit, exit$0, f);
    }
    function reraise_uncaught(str, func) {
        try {
            var _k_ = caml_call1(func, 0);
            return _k_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0), bt = caml_call1(Stdlib_Printexc[12], 0);
            return raise_with_original_backtrace([
                0,
                Reraised,
                str,
                exn
            ], bt);
        }
    }
    function raise_without_backtrace(e) {
        runtime.Base_clear_caml_backtrace_pos(0);
        throw e;
    }
    function initialize_module(param) {
        return caml_call1(Stdlib_Printexc[16], print_with_backtrace);
    }
    function clear_backtrace(_j_) {
        return runtime.Base_clear_caml_backtrace_pos(_j_);
    }
    var Private = [
        0,
        clear_backtrace
    ], Base_Exn = [
        0,
        sexp_of_t$0,
        pp$0,
        Finally,
        Reraised,
        create_s,
        raise_without_backtrace,
        raise_with_original_backtrace,
        reraise,
        reraisef,
        to_string,
        to_string_mach,
        protectx,
        protect,
        handle_uncaught,
        handle_uncaught_and_exit,
        reraise_uncaught,
        does_raise,
        function(_i_) {
            return runtime.Base_caml_exn_is_most_recent_exn(_i_);
        },
        initialize_module,
        Private
    ];
    runtime.caml_register_global(21, Base_Exn, "Base__Exn");
    return;
})(globalThis);
//# 3335 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Exn = global_data.Base__Exn, cst_Return = "Return", cst_use_of_return_from_a_with_ = "use of [return] from a [with_return] that already returned";
    function with_return(f) {
        var Return = [
            248,
            cst_Return,
            runtime.caml_fresh_oo_id(0)
        ], is_alive = [
            0,
            1
        ];
        function return$0(a) {
            if (1 - is_alive[1]) caml_call1(Base_Import[124], cst_use_of_return_from_a_with_);
            return caml_call1(Base_Exn[6], [
                0,
                Return,
                a
            ]);
        }
        try {
            var a$0 = caml_call1(f, return$0);
            is_alive[1] = 0;
            return a$0;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            is_alive[1] = 0;
            if (exn[1] !== Return) throw caml_maybe_attach_backtrace(exn, 0);
            var a = exn[2];
            return a;
        }
    }
    function with_return_option(f) {
        return with_return(function(return$0) {
            caml_call1(f, function(a) {
                return caml_call1(return$0, [
                    0,
                    a
                ]);
            });
            return 0;
        });
    }
    function prepend(param, f) {
        return function(x) {
            return caml_call1(param, caml_call1(f, x));
        };
    }
    var Base_With_return = [
        0,
        with_return,
        with_return_option,
        prepend
    ];
    runtime.caml_register_global(4, Base_With_return, "Base__With_return");
    return;
})(globalThis);
//# 3451 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function S_to_S2(X) {
        var symbol_bind = X[1], symbol_map = X[2], Monad_infix = X[3], bind = X[4], return$0 = X[5], map = X[6], join = X[7], ignore_m = X[8], all = X[9], all_unit = X[10], Let_syntax = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function S2_to_S3(X) {
        var symbol_bind = X[1], symbol_map = X[2], Let_syntax = X[3], Monad_infix = X[4], bind = X[5], return$0 = X[6], map = X[7], join = X[8], ignore_m = X[9], all = X[10], all_unit = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function S_to_S_indexed(X) {
        var symbol_bind = X[1], symbol_map = X[2], Monad_infix = X[3], bind = X[4], return$0 = X[5], map = X[6], join = X[7], ignore_m = X[8], all = X[9], all_unit = X[10], Let_syntax = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function S2_to_S(X) {
        var symbol_bind = X[1], symbol_map = X[2], Let_syntax = X[3], Monad_infix = X[4], bind = X[5], return$0 = X[6], map = X[7], join = X[8], ignore_m = X[9], all = X[10], all_unit = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit,
            Let_syntax
        ];
    }
    function S3_to_S2(X) {
        var symbol_bind = X[1], symbol_map = X[2], Let_syntax = X[3], Monad_infix = X[4], bind = X[5], return$0 = X[6], map = X[7], join = X[8], ignore_m = X[9], all = X[10], all_unit = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function S_indexed_to_S2(X) {
        var symbol_bind = X[1], symbol_map = X[2], Let_syntax = X[3], Monad_infix = X[4], bind = X[5], return$0 = X[6], map = X[7], join = X[8], ignore_m = X[9], all = X[10], all_unit = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    var Base_Monad_intf = [
        0,
        S_to_S2,
        S2_to_S3,
        S_to_S_indexed,
        S2_to_S,
        S3_to_S2,
        S_indexed_to_S2
    ];
    runtime.caml_register_global(0, Base_Monad_intf, "Base__Monad_intf");
    return;
})(globalThis);
//# 3626 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Base_List0 = global_data.Base__List0;
    function Make_general(_A_) {
        var bind = _A_[1], return$0 = _A_[3];
        function map_via_bind(ma, f) {
            return caml_call2(_A_[1], ma, function(a) {
                var _B_ = caml_call1(f, a);
                return caml_call1(_A_[3], _B_);
            });
        }
        var match = _A_[2];
        if (typeof match === "number") var map = map_via_bind;
        else var x = match[2], map = x;
        function symbol_bind(t, f) {
            return caml_call2(bind, t, f);
        }
        function symbol_map(t, f) {
            return caml_call2(map, t, f);
        }
        var Monad_infix = [
            0,
            symbol_bind,
            symbol_map
        ], symbol_bind$0 = Monad_infix[1], symbol_map$0 = Monad_infix[2], symbol_bind$1 = Monad_infix[1], symbol_map$1 = Monad_infix[2];
        function both(a, b) {
            return caml_call2(symbol_bind$1, a, function(a) {
                return caml_call2(symbol_map$1, b, function(b) {
                    return [
                        0,
                        a,
                        b
                    ];
                });
            });
        }
        var Open_on_rhs = [
            0
        ], Let_syntax = [
            0,
            return$0,
            bind,
            map,
            both,
            Open_on_rhs
        ], Let_syntax$0 = [
            0,
            return$0,
            symbol_bind$1,
            symbol_map$1,
            Let_syntax
        ];
        function join(t) {
            return caml_call2(symbol_bind$0, t, function(t) {
                return t;
            });
        }
        function ignore_m(t) {
            return caml_call2(map, t, function(param) {
                return 0;
            });
        }
        function loop(vs, param) {
            if (!param) return caml_call1(return$0, caml_call1(Base_List0[19], vs));
            var ts = param[2], t = param[1];
            return caml_call2(symbol_bind$0, t, function(v) {
                return loop([
                    0,
                    v,
                    vs
                ], ts);
            });
        }
        function all(ts) {
            return loop(0, ts);
        }
        function all_unit(param) {
            if (!param) return caml_call1(return$0, 0);
            var ts = param[2], t = param[1];
            return caml_call2(symbol_bind$0, t, function(param) {
                return all_unit(ts);
            });
        }
        return [
            0,
            bind,
            return$0,
            ,
            map,
            Monad_infix,
            symbol_bind$0,
            symbol_map$0,
            Let_syntax$0,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function Make_indexed(M) {
        var bind = M[1], map = M[2], return$0 = M[3], _z_ = Make_general([
            0,
            bind,
            map,
            return$0
        ]);
        return [
            0,
            _z_[6],
            _z_[7],
            _z_[8],
            _z_[5],
            _z_[1],
            _z_[2],
            _z_[4],
            _z_[9],
            _z_[10],
            _z_[11],
            _z_[12]
        ];
    }
    function Make3(M) {
        var bind = M[1], map = M[2], return$0 = M[3], _y_ = Make_general([
            0,
            bind,
            map,
            return$0
        ]);
        return [
            0,
            _y_[6],
            _y_[7],
            _y_[8],
            _y_[5],
            _y_[1],
            _y_[2],
            _y_[4],
            _y_[9],
            _y_[10],
            _y_[11],
            _y_[12]
        ];
    }
    function Make2(M) {
        var bind = M[1], map = M[2], return$0 = M[3], _x_ = Make_general([
            0,
            bind,
            map,
            return$0
        ]);
        return [
            0,
            _x_[6],
            _x_[7],
            _x_[8],
            _x_[5],
            _x_[1],
            _x_[2],
            _x_[4],
            _x_[9],
            _x_[10],
            _x_[11],
            _x_[12]
        ];
    }
    function Make(M) {
        var bind = M[1], return$0 = M[2], map = M[3], _w_ = Make_general([
            0,
            bind,
            map,
            return$0
        ]);
        return [
            0,
            _w_[6],
            _w_[7],
            _w_[5],
            _w_[1],
            _w_[2],
            _w_[4],
            _w_[9],
            _w_[10],
            _w_[11],
            _w_[12],
            _w_[8]
        ];
    }
    function Make2_local(_t_) {
        var bind = _t_[1], return$0 = _t_[3];
        function map_via_bind(ma, f) {
            var res = caml_call2(_t_[1], ma, function(a) {
                var _v_ = caml_call1(f, a);
                return caml_call1(_t_[3], _v_);
            });
            return res;
        }
        var match = _t_[2];
        if (typeof match === "number") var map = map_via_bind;
        else var x = match[2], map = x;
        function symbol_bind(t, f) {
            return caml_call2(bind, t, f);
        }
        function symbol_map(t, f) {
            return caml_call2(map, t, f);
        }
        var Monad_infix = [
            0,
            symbol_bind,
            symbol_map
        ], symbol_bind$0 = Monad_infix[1], symbol_map$0 = Monad_infix[2], symbol_bind$1 = Monad_infix[1], symbol_map$1 = Monad_infix[2];
        function both(a, b) {
            var res = caml_call2(bind, a, function(a) {
                var res = caml_call2(map, b, function(b) {
                    return [
                        0,
                        a,
                        b
                    ];
                });
                return res;
            });
            return res;
        }
        var Open_on_rhs = [
            0
        ], Let_syntax = [
            0,
            return$0,
            bind,
            map,
            both,
            Open_on_rhs
        ], Let_syntax$0 = [
            0,
            return$0,
            symbol_bind$1,
            symbol_map$1,
            Let_syntax
        ];
        function join(t) {
            return caml_call2(symbol_bind$0, t, function(_u_) {
                return _u_;
            });
        }
        function ignore_m(t) {
            var res = caml_call2(map, t, function(param) {
                return 0;
            });
            return res;
        }
        function loop(vs, param) {
            if (!param) return caml_call1(return$0, caml_call1(Base_List0[19], vs));
            var ts = param[2], t = param[1];
            return caml_call2(symbol_bind$0, t, function(v) {
                return loop([
                    0,
                    v,
                    vs
                ], ts);
            });
        }
        function all(ts) {
            return loop(0, ts);
        }
        function all_unit(param) {
            if (!param) return caml_call1(return$0, 0);
            var ts = param[2], t = param[1];
            return caml_call2(symbol_bind$0, t, function(param) {
                return all_unit(ts);
            });
        }
        return [
            0,
            bind,
            return$0,
            ,
            map,
            Monad_infix,
            symbol_bind$0,
            symbol_map$0,
            Let_syntax$0,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function Make_local(M) {
        var bind = M[1], return$0 = M[2], map = M[3], _s_ = Make2_local([
            0,
            bind,
            map,
            return$0
        ]);
        return [
            0,
            _s_[6],
            _s_[7],
            _s_[5],
            _s_[1],
            _s_[2],
            _s_[4],
            _s_[9],
            _s_[10],
            _s_[11],
            _s_[12],
            _s_[8]
        ];
    }
    function Of_monad_general(Monad, M) {
        function return$0(a) {
            var _r_ = caml_call1(Monad[3], a);
            return caml_call1(M[2], _r_);
        }
        function bind(t, f) {
            var _o_ = caml_call1(M[1], t), _p_ = caml_call2(Monad[1], _o_, function(a) {
                var _q_ = caml_call1(f, a);
                return caml_call1(M[1], _q_);
            });
            return caml_call1(M[2], _p_);
        }
        var map = [
            0,
            -198771759,
            function(t, f) {
                var _m_ = caml_call1(M[1], t), _n_ = caml_call2(Monad[2], _m_, f);
                return caml_call1(M[2], _n_);
            }
        ];
        return Make_general([
            0,
            bind,
            map,
            return$0
        ]);
    }
    function bind(a, f) {
        return caml_call1(f, a);
    }
    function map(a, f) {
        return caml_call1(f, a);
    }
    function symbol_map(a, f) {
        return caml_call1(f, a);
    }
    function symbol_bind(a, f) {
        return caml_call1(f, a);
    }
    function return$0(_l_) {
        return _l_;
    }
    function both(a, b) {
        return [
            0,
            a,
            b
        ];
    }
    var Open_on_rhs = [
        0
    ], Let_syntax = [
        0,
        return$0,
        bind,
        map,
        both,
        Open_on_rhs
    ], Base_Monad = [
        0,
        Make,
        Make2,
        Make3,
        Make_indexed,
        Make_local,
        function(_j_) {
            var _k_ = Make2_local(_j_);
            return [
                0,
                _k_[6],
                _k_[7],
                _k_[8],
                _k_[5],
                _k_[1],
                _k_[2],
                _k_[4],
                _k_[9],
                _k_[10],
                _k_[11],
                _k_[12]
            ];
        },
        function(Monad, M) {
            var to_monad = M[1], of_monad = M[2], bind = Monad[4], return$0 = Monad[5], map = Monad[6], _i_ = Of_monad_general([
                0,
                bind,
                map,
                return$0
            ], [
                0,
                to_monad,
                of_monad
            ]);
            return [
                0,
                _i_[6],
                _i_[7],
                _i_[5],
                _i_[1],
                _i_[2],
                _i_[4],
                _i_[9],
                _i_[10],
                _i_[11],
                _i_[12],
                _i_[8]
            ];
        },
        function(Monad, M) {
            var to_monad = M[1], of_monad = M[2], bind = Monad[5], return$0 = Monad[6], map = Monad[7], _h_ = Of_monad_general([
                0,
                bind,
                map,
                return$0
            ], [
                0,
                to_monad,
                of_monad
            ]);
            return [
                0,
                _h_[6],
                _h_[7],
                _h_[8],
                _h_[5],
                _h_[1],
                _h_[2],
                _h_[4],
                _h_[9],
                _h_[10],
                _h_[11],
                _h_[12]
            ];
        },
        function(Monad, M) {
            var to_monad = M[1], of_monad = M[2], bind = Monad[5], return$0 = Monad[6], map = Monad[7], _g_ = Of_monad_general([
                0,
                bind,
                map,
                return$0
            ], [
                0,
                to_monad,
                of_monad
            ]);
            return [
                0,
                _g_[6],
                _g_[7],
                _g_[8],
                _g_[5],
                _g_[1],
                _g_[2],
                _g_[4],
                _g_[9],
                _g_[10],
                _g_[11],
                _g_[12]
            ];
        },
        function(Monad, M) {
            var to_monad = M[1], of_monad = M[2], bind = Monad[5], return$0 = Monad[6], map = Monad[7], _f_ = Of_monad_general([
                0,
                bind,
                map,
                return$0
            ], [
                0,
                to_monad,
                of_monad
            ]);
            return [
                0,
                _f_[6],
                _f_[7],
                _f_[8],
                _f_[5],
                _f_[1],
                _f_[2],
                _f_[4],
                _f_[9],
                _f_[10],
                _f_[11],
                _f_[12]
            ];
        },
        [
            0,
            symbol_bind,
            symbol_map,
            [
                0,
                symbol_bind,
                symbol_map
            ],
            bind,
            function(_e_) {
                return _e_;
            },
            map,
            function(_d_) {
                return _d_;
            },
            function(_c_) {
                return 0;
            },
            function(_b_) {
                return _b_;
            },
            function(_a_) {
                return 0;
            },
            [
                0,
                return$0,
                symbol_bind,
                symbol_map,
                Let_syntax
            ]
        ]
    ];
    runtime.caml_register_global(1, Base_Monad, "Base__Monad");
    return;
})(globalThis);
//# 4051 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_T = [
        0
    ];
    runtime.caml_register_global(0, Base_T, "Base__T");
    return;
})(globalThis);
//# 4060 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Applicative_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Applicative_intf, "Base__Applicative_intf");
    return;
})(globalThis);
//# 4071 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_List0 = global_data.Base__List0;
    function S_to_S2(X) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], apply = X[8], map2 = X[9], map3 = X[10], all = X[11], all_unit = X[12], Applicative_infix = X[13];
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function S2_to_S(T, X) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], apply = X[8], map2 = X[9], map3 = X[10], all = X[11], all_unit = X[12], Applicative_infix = X[13];
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function S2_to_S3(X) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], apply = X[8], map2 = X[9], map3 = X[10], all = X[11], all_unit = X[12], Applicative_infix = X[13];
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function S3_to_S2(T, X) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], apply = X[8], map2 = X[9], map3 = X[10], all = X[11], all_unit = X[12], Applicative_infix = X[13];
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function S3_to_S(T1, T2, X) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], apply = X[8], map2 = X[9], map3 = X[10], all = X[11], all_unit = X[12], Applicative_infix = X[13];
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function Make3(_O_) {
        var return$0 = _O_[1], symbol = _O_[2];
        function derived_map(t, f) {
            return caml_call2(symbol, caml_call1(return$0, f), t);
        }
        var match = _O_[3];
        if (typeof match === "number") var map = derived_map;
        else var x = match[2], map = x;
        function symbol_map(t, f) {
            return caml_call2(map, t, f);
        }
        function map2(ta, tb, f) {
            return caml_call2(symbol, caml_call2(map, ta, f), tb);
        }
        function map3(ta, tb, tc, f) {
            return caml_call2(symbol, caml_call2(symbol, caml_call2(map, ta, f), tb), tc);
        }
        function all(ts) {
            function _R_(x, xs) {
                return [
                    0,
                    x,
                    xs
                ];
            }
            var _Q_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[20], ts, function(_S_) {
                return function(_T_1) {
                    return map2(_S_, _T_1, _R_);
                };
            }, _Q_);
        }
        function both(ta, tb) {
            return map2(ta, tb, function(a, b) {
                return [
                    0,
                    a,
                    b
                ];
            });
        }
        function symbol$0(u, v) {
            return caml_call2(symbol, caml_call2(symbol, caml_call1(return$0, function(param, y) {
                return y;
            }), u), v);
        }
        function symbol$1(u, v) {
            return caml_call2(symbol, caml_call2(symbol, caml_call1(return$0, function(x, param) {
                return x;
            }), u), v);
        }
        function all_unit(ts) {
            var _P_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[8], ts, _P_, symbol$0);
        }
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$1,
            symbol$0,
            symbol_map,
            symbol,
            map2,
            map3,
            all,
            all_unit,
            [
                0,
                symbol,
                symbol$1,
                symbol$0,
                symbol_map
            ]
        ];
    }
    function Make2(X) {
        var return$0 = X[1], apply = X[2], map = X[3];
        return Make3([
            0,
            return$0,
            apply,
            map
        ]);
    }
    function Make(X) {
        var return$0 = X[1], apply = X[2], map = X[3];
        return Make2([
            0,
            return$0,
            apply,
            map
        ]);
    }
    function Make_let_syntax3(X, Intf, Impl) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], return$1 = X[1], map$0 = X[2], both$0 = X[3], symbol$2 = X[4], symbol$3 = X[5], symbol$4 = X[6], symbol_map$0 = X[7], Let_syntax = [
            0,
            return$1,
            map$0,
            both$0,
            symbol$2,
            symbol$3,
            symbol$4,
            symbol_map$0,
            Impl
        ], Let_syntax$0 = [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            Let_syntax
        ];
        return [
            0,
            Let_syntax$0
        ];
    }
    function Make_let_syntax2(X, Intf, Impl) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7];
        return Make_let_syntax3([
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map
        ], Intf, Impl);
    }
    function Make3_using_map2(_H_) {
        var return$0 = _H_[1], map2 = _H_[2];
        function symbol(tf, ta) {
            return caml_call3(map2, tf, ta, function(f, a) {
                return caml_call1(f, a);
            });
        }
        function derived_map(t, f) {
            return symbol(caml_call1(return$0, f), t);
        }
        var match = _H_[3];
        if (typeof match === "number") var map = derived_map;
        else var x = match[2], map = x;
        function symbol_map(t, f) {
            return caml_call2(map, t, f);
        }
        function both(ta, tb) {
            return caml_call3(map2, ta, tb, function(a, b) {
                return [
                    0,
                    a,
                    b
                ];
            });
        }
        function map3(ta, tb, tc, f) {
            return caml_call3(map2, caml_call3(map2, ta, tb, f), tc, function(fab, c) {
                return caml_call1(fab, c);
            });
        }
        function all(ts) {
            function _K_(x, xs) {
                return [
                    0,
                    x,
                    xs
                ];
            }
            var _J_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[20], ts, function(_L_) {
                var _M_ = caml_call1(map2, _L_);
                return function(_N_) {
                    return caml_call2(_M_, _N_, _K_);
                };
            }, _J_);
        }
        function symbol$0(u, v) {
            return caml_call3(map2, u, v, function(param, y) {
                return y;
            });
        }
        function symbol$1(u, v) {
            return caml_call3(map2, u, v, function(x, param) {
                return x;
            });
        }
        function all_unit(ts) {
            var _I_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[8], ts, _I_, symbol$0);
        }
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$1,
            symbol$0,
            symbol_map,
            symbol,
            map2,
            map3,
            all,
            all_unit,
            [
                0,
                symbol,
                symbol$1,
                symbol$0,
                symbol_map
            ]
        ];
    }
    function Make2_using_map2(X) {
        var return$0 = X[1], map2 = X[2], map = X[3];
        return Make3_using_map2([
            0,
            return$0,
            map2,
            map
        ]);
    }
    function Make_using_map2(X) {
        var return$0 = X[1], map2 = X[2], map = X[3];
        return Make2_using_map2([
            0,
            return$0,
            map2,
            map
        ]);
    }
    function Make3_using_map2_local(_A_) {
        var return$0 = _A_[1], map2 = _A_[2];
        function symbol(tf, ta) {
            return caml_call3(map2, tf, ta, function(f, a) {
                return caml_call1(f, a);
            });
        }
        function derived_map(t, f) {
            return caml_call3(map2, caml_call1(return$0, 0), t, function(param) {
                return f;
            });
        }
        var match = _A_[3];
        if (typeof match === "number") var map = derived_map;
        else var map$0 = match[2], map = map$0;
        function symbol_map(t, f) {
            return caml_call2(map, t, f);
        }
        function both(ta, tb) {
            return caml_call3(map2, ta, tb, function(a, b) {
                return [
                    0,
                    a,
                    b
                ];
            });
        }
        function map3(ta, tb, tc, f) {
            var res = caml_call3(map2, both(ta, tb), tc, function(param, c) {
                var b = param[2], a = param[1];
                return caml_call3(f, a, b, c);
            });
            return res;
        }
        function all(ts) {
            function _D_(x, xs) {
                return [
                    0,
                    x,
                    xs
                ];
            }
            var _C_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[20], ts, function(_E_) {
                var _F_ = caml_call1(map2, _E_);
                return function(_G_) {
                    return caml_call2(_F_, _G_, _D_);
                };
            }, _C_);
        }
        function symbol$0(u, v) {
            return caml_call3(map2, u, v, function(param, y) {
                return y;
            });
        }
        function symbol$1(u, v) {
            return caml_call3(map2, u, v, function(x, param) {
                return x;
            });
        }
        function all_unit(ts) {
            var _B_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[8], ts, _B_, symbol$0);
        }
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$1,
            symbol$0,
            symbol_map,
            symbol,
            map2,
            map3,
            all,
            all_unit,
            [
                0,
                symbol,
                symbol$1,
                symbol$0,
                symbol_map
            ]
        ];
    }
    function Make2_using_map2_local(X) {
        var return$0 = X[1], map2 = X[2], map = X[3];
        return Make3_using_map2_local([
            0,
            return$0,
            map2,
            map
        ]);
    }
    function Make_using_map2_local(X) {
        var return$0 = X[1], map2 = X[2], map = X[3];
        return Make2_using_map2_local([
            0,
            return$0,
            map2,
            map
        ]);
    }
    function Of_monad2(M) {
        var return$0 = M[6];
        function apply(mf, mx) {
            return caml_call2(M[5], mf, function(f) {
                return caml_call2(M[7], mx, f);
            });
        }
        var map = [
            0,
            -198771759,
            M[7]
        ];
        return Make2([
            0,
            return$0,
            apply,
            map
        ]);
    }
    function Of_monad(M) {
        var symbol_bind = M[1], symbol_map = M[2], Monad_infix = M[3], bind = M[4], return$0 = M[5], map = M[6], join = M[7], ignore_m = M[8], all = M[9], all_unit = M[10], Let_syntax = M[11];
        return Of_monad2([
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ]);
    }
    function Compose(F, G) {
        function return$0(a) {
            var _z_ = caml_call1(F[1], a);
            return caml_call1(G[1], _z_);
        }
        function apply(tf, tx) {
            var _y_ = caml_call2(G[2], tf, F[8]);
            return caml_call2(G[8], _y_, tx);
        }
        function custom_map(t, f) {
            var _w_ = F[2];
            return caml_call2(G[2], t, function(_x_) {
                return caml_call2(_w_, _x_, f);
            });
        }
        var map = [
            0,
            -198771759,
            custom_map
        ], include = Make([
            0,
            return$0,
            apply,
            map
        ]), return$1 = include[1], map$0 = include[2], both = include[3], symbol = include[4], symbol$0 = include[5], symbol$1 = include[6], symbol_map = include[7], apply$0 = include[8], map2 = include[9], map3 = include[10], all = include[11], all_unit = include[12], Applicative_infix = include[13];
        return [
            0,
            return$1,
            map$0,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply$0,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function Pair(F, G) {
        function return$0(a) {
            var _v_ = caml_call1(G[1], a);
            return [
                0,
                caml_call1(F[1], a),
                _v_
            ];
        }
        function apply(tf, tx) {
            var _q_ = caml_call1(Base_Import[127], tx), _r_ = caml_call1(Base_Import[127], tf), _s_ = caml_call2(G[8], _r_, _q_), _t_ = caml_call1(Base_Import[125], tx), _u_ = caml_call1(Base_Import[125], tf);
            return [
                0,
                caml_call2(F[8], _u_, _t_),
                _s_
            ];
        }
        function custom_map(t, f) {
            var _n_ = caml_call1(Base_Import[127], t), _o_ = caml_call2(G[2], _n_, f), _p_ = caml_call1(Base_Import[125], t);
            return [
                0,
                caml_call2(F[2], _p_, f),
                _o_
            ];
        }
        var map = [
            0,
            -198771759,
            custom_map
        ], include = Make([
            0,
            return$0,
            apply,
            map
        ]), return$1 = include[1], map$0 = include[2], both = include[3], symbol = include[4], symbol$0 = include[5], symbol$1 = include[6], symbol_map = include[7], apply$0 = include[8], map2 = include[9], map3 = include[10], all = include[11], all_unit = include[12], Applicative_infix = include[13];
        return [
            0,
            return$1,
            map$0,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply$0,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function return$0(_m_) {
        return _m_;
    }
    function map2(a, b, f) {
        return caml_call2(f, a, b);
    }
    var map = [
        0,
        -198771759,
        function(a, f) {
            return caml_call1(f, a);
        }
    ], include = Make_using_map2_local([
        0,
        return$0,
        map2,
        map
    ]), return$1 = include[1], map$0 = include[2], both = include[3], symbol = include[4], symbol$0 = include[5], symbol$1 = include[6], symbol_map = include[7], apply = include[8], map2$0 = include[9], map3 = include[10], all = include[11], all_unit = include[12], Applicative_infix = include[13], Ident = [
        0,
        return$1,
        map$0,
        both,
        symbol,
        symbol$0,
        symbol$1,
        symbol_map,
        apply,
        map2$0,
        map3,
        all,
        all_unit,
        Applicative_infix
    ], Base_Applicative = [
        0,
        Ident,
        S2_to_S,
        S_to_S2,
        S3_to_S2,
        S3_to_S,
        S2_to_S3,
        Make,
        Make2,
        Make3,
        function(X, Intf, Impl) {
            var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], _k_ = Make_let_syntax2([
                0,
                return$0,
                map,
                both,
                symbol,
                symbol$0,
                symbol$1,
                symbol_map
            ], Intf, Impl)[1], _l_ = _k_[8];
            return [
                0,
                [
                    0,
                    _k_[1],
                    _k_[4],
                    _k_[5],
                    _k_[6],
                    _k_[7],
                    [
                        0,
                        _l_[1],
                        _l_[2],
                        _l_[3],
                        _l_[8]
                    ]
                ]
            ];
        },
        function(_h_, _g_, _f_) {
            var _i_ = Make_let_syntax2(_h_, _g_, _f_)[1], _j_ = _i_[8];
            return [
                0,
                [
                    0,
                    _i_[1],
                    _i_[4],
                    _i_[5],
                    _i_[6],
                    _i_[7],
                    [
                        0,
                        _j_[1],
                        _j_[2],
                        _j_[3],
                        _j_[8]
                    ]
                ]
            ];
        },
        function(_c_, _b_, _a_) {
            var _d_ = Make_let_syntax3(_c_, _b_, _a_)[1], _e_ = _d_[8];
            return [
                0,
                [
                    0,
                    _d_[1],
                    _d_[4],
                    _d_[5],
                    _d_[6],
                    _d_[7],
                    [
                        0,
                        _e_[1],
                        _e_[2],
                        _e_[3],
                        _e_[8]
                    ]
                ]
            ];
        },
        Make_using_map2,
        Make2_using_map2,
        Make3_using_map2,
        Make_using_map2_local,
        Make2_using_map2_local,
        Make3_using_map2_local,
        Of_monad,
        Of_monad2,
        Compose,
        Pair
    ];
    runtime.caml_register_global(2, Base_Applicative, "Base__Applicative");
    return;
})(globalThis);
//# 4755 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var Module = [
        0
    ];
    function of_module(M) {
        return M[1];
    }
    function to_module(t) {
        return [
            0,
            t
        ];
    }
    function make(compare, sexp_of_t) {
        var comparator = [
            0,
            compare,
            sexp_of_t
        ];
        return [
            0,
            comparator
        ];
    }
    function S_to_S1(S) {
        var comparator = S[1];
        return [
            0,
            comparator
        ];
    }
    function Make1(M) {
        var comparator = [
            0,
            M[1],
            M[2]
        ];
        return [
            0,
            comparator
        ];
    }
    var compare = runtime.caml_compare, _a_ = [
        0,
        "_"
    ];
    function sexp_of_t(param) {
        return _a_;
    }
    var include = Make1([
        0,
        compare,
        sexp_of_t
    ]), comparator = include[1], Poly = [
        0,
        comparator
    ];
    function Derived(M) {
        function comparator(a) {
            var _e_ = caml_call1(M[2], a[2]);
            return [
                0,
                caml_call1(M[1], a[1]),
                _e_
            ];
        }
        return [
            0,
            comparator
        ];
    }
    function Derived2(M) {
        function comparator(a, b) {
            var _d_ = caml_call2(M[2], a[2], b[2]);
            return [
                0,
                caml_call2(M[1], a[1], b[1]),
                _d_
            ];
        }
        return [
            0,
            comparator
        ];
    }
    function Derived_phantom(M) {
        function comparator(a) {
            var _c_ = caml_call1(M[2], a[2]);
            return [
                0,
                caml_call1(M[1], a[1]),
                _c_
            ];
        }
        return [
            0,
            comparator
        ];
    }
    function Derived2_phantom(M) {
        function comparator(a, b) {
            var _b_ = caml_call2(M[2], a[2], b[2]);
            return [
                0,
                caml_call2(M[1], a[1], b[1]),
                _b_
            ];
        }
        return [
            0,
            comparator
        ];
    }
    var Base_Comparator = [
        0,
        make,
        Poly,
        Module,
        of_module,
        to_module,
        S_to_S1,
        function(M) {
            var comparator = [
                0,
                M[1],
                M[2]
            ];
            return [
                0,
                comparator
            ];
        },
        Make1,
        Derived,
        Derived2,
        Derived_phantom,
        Derived2_phantom
    ];
    runtime.caml_register_global(1, Base_Comparator, "Base__Comparator");
    return;
})(globalThis);
//# 5047 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_int$3 = "int", cst_int32$3 = "int32", cst_int64$3 = "int64", cst_nativeint$2 = "nativeint", cst_src_int_conversions_ml = "src/int_conversions.ml", caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_shift_right = runtime.caml_int64_shift_right, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, Base_Sys0 = global_data.Base__Sys0, Base_Word_size = global_data.Base__Word_size, Assert_failure = global_data.Assert_failure, Stdlib_Int32 = global_data.Stdlib__Int32, Stdlib_Int64 = global_data.Stdlib__Int64, Stdlib_Nativeint = global_data.Stdlib__Nativeint, Base_Int0 = global_data.Base__Int0, _a_ = [
        0,
        [
            11,
            "conversion from ",
            [
                2,
                0,
                [
                    11,
                    " to ",
                    [
                        2,
                        0,
                        [
                            11,
                            " failed: ",
                            [
                                2,
                                0,
                                [
                                    11,
                                    " is out of range",
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "conversion from %s to %s failed: %s is out of range"
    ];
    function convert_failure(x, a, b, to_string) {
        var _H_ = caml_call1(to_string, x);
        return caml_call5(Base_Printf[6], _a_, a, b, _H_, 0);
    }
    var num_bits_int = Base_Sys0[8], num_bits_nativeint = caml_call1(Base_Word_size[2], Base_Word_size[3]), cst_int63 = "int63", cst_int64$2 = cst_int64$3, cst_nativeint$1 = cst_nativeint$2, cst_int64$1 = cst_int64$3, cst_int32$2 = cst_int32$3, cst_nativeint$0 = cst_nativeint$2, cst_int32$1 = cst_int32$3, cst_int64$0 = cst_int64$3, cst_int$2 = cst_int$3, cst_nativeint = cst_nativeint$2, cst_int$1 = cst_int$3, cst_int64 = cst_int64$3, _d_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), cst_int$0 = cst_int$3, cst_int32$0 = cst_int32$3, cst_int32 = cst_int32$3, cst_int = cst_int$3, _k_ = [
        0,
        cst_src_int_conversions_ml,
        19,
        9
    ], _j_ = [
        0,
        cst_src_int_conversions_ml,
        82,
        9
    ], _i_ = [
        0,
        cst_src_int_conversions_ml,
        103,
        9
    ], _h_ = [
        0,
        cst_src_int_conversions_ml,
        155,
        9
    ], _g_ = [
        0,
        cst_src_int_conversions_ml,
        183,
        9
    ], num_bits_int32 = 32, num_bits_int64 = 64;
    if (63 !== num_bits_int && 31 !== num_bits_int && 32 !== num_bits_int) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _k_
    ], 1);
    var min_int32 = Stdlib_Int32[10], max_int32 = Stdlib_Int32[9], min_int64 = Stdlib_Int64[10], max_int64 = Stdlib_Int64[9], min_nativeint = Stdlib_Nativeint[11], max_nativeint = Stdlib_Nativeint[10], int64_to_string = Stdlib_Int64[14], nativeint_to_string = Stdlib_Nativeint[15];
    function int32_to_int_trunc(_G_) {
        return _G_;
    }
    function int_to_int32_trunc(_F_) {
        return _F_;
    }
    var _b_ = Base_Import[85][33], _c_ = Stdlib_Int32[14], int_is_representable_as_int32 = num_bits_int <= 32 ? function(param) {
        return 1;
    } : function(x) {
        var _D_ = caml_call2(Base_Import[228], min_int32, x) <= 0 ? 1 : 0, _E_ = _D_ ? caml_call2(Base_Import[228], x, max_int32) <= 0 ? 1 : 0 : _D_;
        return _E_;
    };
    if (32 <= num_bits_int) var int32_is_representable_as_int = function(param) {
        return 1;
    };
    else var min$1 = Base_Int0[7], max$1 = Base_Int0[6], int32_is_representable_as_int = function(x) {
        var _B_ = caml_call2(Base_Import[229], min$1, x) <= 0 ? 1 : 0, _C_ = _B_ ? caml_call2(Base_Import[229], x, max$1) <= 0 ? 1 : 0 : _B_;
        return _C_;
    };
    function int_to_int32(x) {
        return int_is_representable_as_int32(x) ? [
            0,
            x
        ] : 0;
    }
    function int32_to_int(x) {
        return int32_is_representable_as_int(x) ? [
            0,
            x
        ] : 0;
    }
    function int_to_int32_exn(x) {
        return int_is_representable_as_int32(x) ? x : convert_failure(x, cst_int, cst_int32, _b_);
    }
    function int32_to_int_exn(x) {
        return int32_is_representable_as_int(x) ? x : convert_failure(x, cst_int32$0, cst_int$0, _c_);
    }
    if (num_bits_int >= 64) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _j_
    ], 1);
    var int_to_int64 = caml_int64_of_int32, int64_to_int_trunc = caml_int64_to_int32, min$4 = caml_int64_of_int32(Base_Int0[7]), max$4 = caml_int64_of_int32(Base_Int0[6]);
    function int64_is_representable_as_int(x) {
        var _z_ = caml_call2(Base_Import[230], min$4, x) <= 0 ? 1 : 0, _A_ = _z_ ? caml_call2(Base_Import[230], x, max$4) <= 0 ? 1 : 0 : _z_;
        return _A_;
    }
    function int64_to_int(x) {
        return int64_is_representable_as_int(x) ? [
            0,
            caml_int64_to_int32(x)
        ] : 0;
    }
    function int64_to_int_exn(x) {
        return int64_is_representable_as_int(x) ? caml_int64_to_int32(x) : convert_failure(runtime.caml_int64_add(x, _d_), cst_int64, cst_int$1, int64_to_string);
    }
    if (num_bits_int > num_bits_nativeint) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _i_
    ], 1);
    function int_to_nativeint(_y_) {
        return _y_;
    }
    function nativeint_to_int_trunc(_x_) {
        return _x_;
    }
    if (num_bits_nativeint <= num_bits_int) var _e_ = function(param) {
        return 1;
    };
    else var min$0 = Base_Int0[7], max$0 = Base_Int0[6], _e_ = function(x) {
        var _v_ = caml_call2(Base_Import[231], min$0, x) <= 0 ? 1 : 0, _w_ = _v_ ? caml_call2(Base_Import[231], x, max$0) <= 0 ? 1 : 0 : _v_;
        return _w_;
    };
    function nativeint_to_int(x) {
        return _e_(x) ? [
            0,
            x
        ] : 0;
    }
    function nativeint_to_int_exn(x) {
        return _e_(x) ? x : convert_failure(x, cst_nativeint, cst_int$2, nativeint_to_string);
    }
    var int32_to_int64 = caml_int64_of_int32, int64_to_int32_trunc = caml_int64_to_int32, min$3 = caml_int64_of_int32(min_int32), max$3 = caml_int64_of_int32(max_int32);
    function int64_is_representable_as_int3(x) {
        var _t_ = caml_call2(Base_Import[230], min$3, x) <= 0 ? 1 : 0, _u_ = _t_ ? caml_call2(Base_Import[230], x, max$3) <= 0 ? 1 : 0 : _t_;
        return _u_;
    }
    function int64_to_int32(x) {
        return int64_is_representable_as_int3(x) ? [
            0,
            caml_int64_to_int32(x)
        ] : 0;
    }
    function int64_to_int32_exn(x) {
        return int64_is_representable_as_int3(x) ? caml_int64_to_int32(x) : convert_failure(x, cst_int64$0, cst_int32$1, int64_to_string);
    }
    if (32 > num_bits_nativeint) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _h_
    ], 1);
    function int32_to_nativeint(_s_) {
        return _s_;
    }
    function nativeint_to_int32_trunc(_r_) {
        return _r_;
    }
    var _f_ = num_bits_nativeint <= 32 ? function(param) {
        return 1;
    } : function(x) {
        var _p_ = caml_call2(Base_Import[231], min_int32, x) <= 0 ? 1 : 0, _q_ = _p_ ? caml_call2(Base_Import[231], x, max_int32) <= 0 ? 1 : 0 : _p_;
        return _q_;
    };
    function nativeint_to_int32(x) {
        return _f_(x) ? [
            0,
            x
        ] : 0;
    }
    function nativeint_to_int32_exn(x) {
        return _f_(x) ? x : convert_failure(x, cst_nativeint$0, cst_int32$2, nativeint_to_string);
    }
    if (num_bits_nativeint > 64) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _g_
    ], 1);
    var int64_to_nativeint_trunc = caml_int64_to_int32, nativeint_to_int64 = caml_int64_of_int32;
    if (64 <= num_bits_nativeint) var int64_is_representable_as_nati = function(param) {
        return 1;
    };
    else var min$2 = caml_int64_of_int32(min_nativeint), max$2 = caml_int64_of_int32(max_nativeint), int64_is_representable_as_nati = function(x) {
        var _n_ = caml_call2(Base_Import[230], min$2, x) <= 0 ? 1 : 0, _o_ = _n_ ? caml_call2(Base_Import[230], x, max$2) <= 0 ? 1 : 0 : _n_;
        return _o_;
    };
    function int64_to_nativeint(x) {
        return int64_is_representable_as_nati(x) ? [
            0,
            caml_int64_to_int32(x)
        ] : 0;
    }
    function int64_to_nativeint_exn(x) {
        return int64_is_representable_as_nati(x) ? caml_int64_to_int32(x) : convert_failure(x, cst_int64$1, cst_nativeint$1, int64_to_string);
    }
    var min = caml_int64_shift_right(min_int64, 1), max = caml_int64_shift_right(max_int64, 1);
    function int64_is_representable_as_int6(x) {
        var _l_ = caml_call2(Base_Import[230], min, x) <= 0 ? 1 : 0, _m_ = _l_ ? caml_call2(Base_Import[230], x, max) <= 0 ? 1 : 0 : _l_;
        return _m_;
    }
    function int64_fit_on_int63_exn(x) {
        return int64_is_representable_as_int6(x) ? 0 : convert_failure(x, cst_int64$2, cst_int63, int64_to_string);
    }
    var Base_Int_conversions = [
        0,
        int_to_int32,
        int_to_int32_exn,
        int_to_int32_trunc,
        int_to_int64,
        int_to_nativeint,
        int32_to_int,
        int32_to_int_exn,
        int32_to_int_trunc,
        int32_to_int64,
        int32_to_nativeint,
        int32_is_representable_as_int,
        int64_to_int,
        int64_to_int_exn,
        int64_to_int_trunc,
        int64_to_int32,
        int64_to_int32_exn,
        int64_to_int32_trunc,
        int64_to_nativeint,
        int64_to_nativeint_exn,
        int64_to_nativeint_trunc,
        int64_fit_on_int63_exn,
        int64_is_representable_as_int6,
        nativeint_to_int,
        nativeint_to_int_exn,
        nativeint_to_int_trunc,
        nativeint_to_int32,
        nativeint_to_int32_exn,
        nativeint_to_int32_trunc,
        nativeint_to_int64,
        num_bits_int,
        num_bits_int32,
        num_bits_int64,
        num_bits_nativeint
    ];
    runtime.caml_register_global(33, Base_Int_conversions, "Base__Int_conversions");
    return;
})(globalThis);
//# 5364 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_Uchar = global_data.Stdlib__Uchar, succ = Stdlib_Uchar[5], pred = Stdlib_Uchar[6], is_valid = Stdlib_Uchar[7], is_char = Stdlib_Uchar[11], unsafe_to_char = Stdlib_Uchar[14], unsafe_of_int = Stdlib_Uchar[9], of_int = Stdlib_Uchar[8], to_int = Stdlib_Uchar[10], of_char = Stdlib_Uchar[12], compare = Stdlib_Uchar[16], equal = Stdlib_Uchar[15], min_value = Stdlib_Uchar[1], max_value = Stdlib_Uchar[2], byte_order_mark = Stdlib_Uchar[3], replacement_char = Stdlib_Uchar[4], utf_8_byte_length = Stdlib_Uchar[23], utf_16_byte_length = Stdlib_Uchar[24], utf_decode_is_valid = Stdlib_Uchar[18], utf_decode_uchar = Stdlib_Uchar[19], utf_decode_length = Stdlib_Uchar[20], utf_decode = Stdlib_Uchar[21], utf_decode_invalid = Stdlib_Uchar[22], Base_Uchar0 = [
        0,
        succ,
        pred,
        is_valid,
        is_char,
        unsafe_to_char,
        unsafe_of_int,
        of_int,
        to_int,
        of_char,
        compare,
        equal,
        min_value,
        max_value,
        byte_order_mark,
        replacement_char,
        utf_8_byte_length,
        utf_16_byte_length,
        utf_decode_is_valid,
        utf_decode_uchar,
        utf_decode_length,
        utf_decode,
        utf_decode_invalid
    ];
    runtime.caml_register_global(1, Base_Uchar0, "Base__Uchar0");
    return;
})(globalThis);
//# 5424 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, Base_Import0 = global_data.Base__Import0, Base_Char0 = global_data.Base__Char0, Stdlib_StringLabels = global_data.Stdlib__StringLabels, Base_Int_conversions = global_data.Base__Int_conversions, Base_Uchar0 = global_data.Base__Uchar0, Stdlib = global_data.Stdlib, Base_Sys0 = global_data.Base__Sys0, String1 = [
        0
    ], max_length = Base_Sys0[10], symbol_concat = Base_Import0[112], capitalize = Stdlib_StringLabels[28], compare = Stdlib_StringLabels[10], escaped = Stdlib_StringLabels[25], lowercase = Stdlib_StringLabels[27], make = Stdlib_StringLabels[1], sub = Stdlib_StringLabels[16], uncapitalize = Stdlib_StringLabels[29], uppercase = Stdlib_StringLabels[26], is_valid_utf_8 = Stdlib_StringLabels[44], is_valid_utf_16le = Stdlib_StringLabels[48], is_valid_utf_16be = Stdlib_StringLabels[46], cst_index_out_of_bounds = "index out of bounds";
    function get_utf_8_uchar(t, byte_pos) {
        return caml_call2(Stdlib_StringLabels[43], t, byte_pos);
    }
    function get_utf_16le_uchar(t, byte_pos) {
        return caml_call2(Stdlib_StringLabels[47], t, byte_pos);
    }
    function get_utf_16be_uchar(t, byte_pos) {
        return caml_call2(Stdlib_StringLabels[45], t, byte_pos);
    }
    function get_utf_32_uchar(get_int32, t, byte_pos) {
        var len = caml_ml_string_length(t), _j_ = 0 <= byte_pos ? 1 : 0, _k_ = _j_ ? byte_pos < len ? 1 : 0 : _j_;
        if (!_k_) throw caml_maybe_attach_backtrace([
            0,
            Stdlib[6],
            cst_index_out_of_bounds
        ], 1);
        var bytes_read = caml_call2(Base_Import0[93], len, byte_pos);
        if (2 >= bytes_read - 1 >>> 0) return caml_call1(Base_Uchar0[22], bytes_read);
        var int32 = caml_call2(get_int32, t, byte_pos);
        if (!caml_call1(Base_Int_conversions[11], int32)) return caml_call1(Base_Uchar0[22], 4);
        var int$0 = caml_call1(Base_Int_conversions[8], int32);
        if (!caml_call1(Base_Uchar0[3], int$0)) return caml_call1(Base_Uchar0[22], 4);
        var _l_ = caml_call1(Base_Uchar0[6], int$0);
        return caml_call2(Base_Uchar0[21], 4, _l_);
    }
    function get_utf_32le_uchar(t, byte_pos) {
        return get_utf_32_uchar(Stdlib_StringLabels[61], t, byte_pos);
    }
    function get_utf_32be_uchar(t, byte_pos) {
        return get_utf_32_uchar(Stdlib_StringLabels[60], t, byte_pos);
    }
    function concat(opt, l) {
        var sep = opt ? opt[1] : cst$0;
        if (!l) return cst;
        if (l[2]) return caml_call2(Stdlib_StringLabels[7], sep, l);
        var x = l[1];
        return x;
    }
    function iter(t, f) {
        var _h_ = caml_call2(Base_Import0[93], caml_ml_string_length(t), 1), _g_ = 0;
        if (_h_ >= 0) {
            var i = _g_;
            for(;;){
                caml_call1(f, runtime.caml_string_unsafe_get(t, i));
                var _i_ = i + 1 | 0;
                if (_h_ === i) break;
                i = _i_;
            }
        }
        return 0;
    }
    function back_up_at_newline(t, pos, eol) {
        a: {
            if (0 < pos[1]) {
                var _e_ = caml_string_get(t, caml_call2(Base_Import0[93], pos[1], 1));
                if (caml_call2(Base_Char0[12], _e_, 13)) {
                    var _f_ = 2;
                    break a;
                }
            }
            var _f_ = 1;
        }
        pos[1] = caml_call2(Base_Import0[93], pos[1], _f_);
        eol[1] = caml_call2(Base_Import0[91], pos[1], 1);
        return;
    }
    function split_lines(t) {
        var n = caml_ml_string_length(t);
        if (0 === n) return 0;
        var pos = [
            0,
            caml_call2(Base_Import0[93], n, 1)
        ], eol = [
            0,
            n
        ], ac = [
            0,
            0
        ], _a_ = caml_string_get(t, pos[1]);
        if (caml_call2(Base_Char0[12], _a_, 10)) back_up_at_newline(t, pos, eol);
        for(;;){
            if (0 > pos[1]) {
                var _d_ = ac[1];
                return [
                    0,
                    caml_call3(sub, t, 0, eol[1]),
                    _d_
                ];
            }
            var _b_ = caml_string_get(t, pos[1]);
            if (caml_call2(Base_Char0[12], _b_, 10)) {
                var start = caml_call2(Base_Import0[91], pos[1], 1), _c_ = ac[1];
                ac[1] = [
                    0,
                    caml_call3(sub, t, start, caml_call2(Base_Import0[93], eol[1], start)),
                    _c_
                ];
                back_up_at_newline(t, pos, eol);
            } else pos[1]--;
        }
    }
    var Base_String0 = [
        0,
        String1,
        max_length,
        symbol_concat,
        capitalize,
        compare,
        escaped,
        lowercase,
        make,
        sub,
        uncapitalize,
        uppercase,
        is_valid_utf_8,
        is_valid_utf_16le,
        is_valid_utf_16be,
        get_utf_8_uchar,
        get_utf_16le_uchar,
        get_utf_16be_uchar,
        get_utf_32le_uchar,
        get_utf_32be_uchar,
        concat,
        iter,
        split_lines
    ];
    runtime.caml_register_global(10, Base_String0, "Base__String0");
    return;
})(globalThis);
//# 5604 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = ":";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = cst$1, cst$0 = cst$1, Base_Import = global_data.Base__Import, Base_Int0 = global_data.Base__Int0, Base_String0 = global_data.Base__String0, Base_Hash = global_data.Base__Hash, Base_Comparator = global_data.Base__Comparator, _a_ = [
        0,
        "pos_cnum"
    ], _b_ = [
        0,
        "pos_bol"
    ], _c_ = [
        0,
        "pos_lnum"
    ], _d_ = [
        0,
        "pos_fname"
    ];
    function compare_local(a_001, b_002) {
        if (a_001 === b_002) return 0;
        var n = caml_call2(Base_Import[260], a_001[1], b_002[1]);
        if (0 !== n) return n;
        var n$0 = caml_call2(Base_Import[256], a_001[2], b_002[2]);
        if (0 !== n$0) return n$0;
        var n$1 = caml_call2(Base_Import[256], a_001[3], b_002[3]);
        return 0 === n$1 ? caml_call2(Base_Import[256], a_001[4], b_002[4]) : n$1;
    }
    function compare(a, b) {
        return compare_local(a, b);
    }
    function hash_fold_t(hsv, arg) {
        var hsv$0 = caml_call2(Base_Import[208], hsv, arg[1]), hsv$1 = caml_call2(Base_Import[206], hsv$0, arg[2]), hsv$2 = caml_call2(Base_Import[206], hsv$1, arg[3]);
        return caml_call2(Base_Import[206], hsv$2, arg[4]);
    }
    function hash(arg) {
        var hsv = caml_call2(Base_Hash[11], 0, 0), _h_ = hash_fold_t(hsv, arg);
        return caml_call1(Base_Hash[9], _h_);
    }
    function sexp_of_t(param) {
        var pos_cnum_010 = param[4], pos_bol_008 = param[3], pos_lnum_006 = param[2], pos_fname_004 = param[1], arg_011 = caml_call1(Base_Import[139], pos_cnum_010), bnds_003 = [
            0,
            [
                1,
                [
                    0,
                    _a_,
                    [
                        0,
                        arg_011,
                        0
                    ]
                ]
            ],
            0
        ], arg_009 = caml_call1(Base_Import[139], pos_bol_008), bnds_003$0 = [
            0,
            [
                1,
                [
                    0,
                    _b_,
                    [
                        0,
                        arg_009,
                        0
                    ]
                ]
            ],
            bnds_003
        ], arg_007 = caml_call1(Base_Import[139], pos_lnum_006), bnds_003$1 = [
            0,
            [
                1,
                [
                    0,
                    _c_,
                    [
                        0,
                        arg_007,
                        0
                    ]
                ]
            ],
            bnds_003$0
        ], arg_005 = caml_call1(Base_Import[136], pos_fname_004), bnds_003$2 = [
            0,
            [
                1,
                [
                    0,
                    _d_,
                    [
                        0,
                        arg_005,
                        0
                    ]
                ]
            ],
            bnds_003$1
        ];
        return [
            1,
            bnds_003$2
        ];
    }
    var T = [
        0,
        compare_local,
        compare,
        hash_fold_t,
        hash,
        sexp_of_t
    ], compare_local$0 = T[1], compare$0 = T[2], hash_fold_t$0 = T[3], hash$0 = T[4], include = caml_call1(Base_Comparator[7], [
        0,
        T[2],
        T[5]
    ]), comparator = include[1];
    function make_location_string(pos_fname, pos_lnum, pos_cnum, pos_bol) {
        var _e_ = caml_call2(Base_Import[93], pos_cnum, pos_bol), _f_ = [
            0,
            cst,
            [
                0,
                caml_call1(Base_Int0[1], _e_),
                0
            ]
        ], _g_ = [
            0,
            pos_fname,
            [
                0,
                cst$0,
                [
                    0,
                    caml_call1(Base_Int0[1], pos_lnum),
                    _f_
                ]
            ]
        ];
        return caml_call2(Base_String0[20], 0, _g_);
    }
    function to_string(param) {
        var pos_cnum = param[4], pos_bol = param[3], pos_lnum = param[2], pos_fname = param[1];
        return make_location_string(pos_fname, pos_lnum, pos_cnum, pos_bol);
    }
    function sexp_of_t$0(t) {
        return [
            0,
            to_string(t)
        ];
    }
    var Base_Source_code_position0 = [
        0,
        T,
        compare_local$0,
        compare$0,
        hash_fold_t$0,
        hash$0,
        comparator,
        make_location_string,
        to_string,
        sexp_of_t$0
    ];
    runtime.caml_register_global(11, Base_Source_code_position0, "Base__Source_code_position0");
    return;
})(globalThis);
//# 5725 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_List0 = global_data.Base__List0, hd_exn = Base_List0[1], rev_append = Base_List0[2], tl_exn = Base_List0[3], unzip = Base_List0[4], length = Base_List0[5], exists = Base_List0[6], exists2_ok = Base_List0[7], fold = Base_List0[8], fold2_ok = Base_List0[9], for_all = Base_List0[10], for_all2_ok = Base_List0[11], iter = Base_List0[12], iter2_ok = Base_List0[13], nontail_map = Base_List0[14], nontail_mapi = Base_List0[15], partition = Base_List0[16], rev_map = Base_List0[17], rev_map2_ok = Base_List0[18], rev = Base_List0[19], fold_right = Base_List0[20], fold_right2_ok = Base_List0[21];
    function is_empty(param) {
        return param ? 0 : 1;
    }
    function partition_map(t, f) {
        var t$0 = t, fst = 0, snd = 0;
        for(;;){
            if (!t$0) {
                var _a_ = caml_call1(rev, snd);
                return [
                    0,
                    caml_call1(rev, fst),
                    _a_
                ];
            }
            var t$1 = t$0[2], x = t$0[1], match = caml_call1(f, x);
            if (0 === match[0]) {
                var y = match[1], fst$0 = [
                    0,
                    y,
                    fst
                ];
                t$0 = t$1;
                fst = fst$0;
            } else {
                var y$0 = match[1], snd$0 = [
                    0,
                    y$0,
                    snd
                ];
                t$0 = t$1;
                snd = snd$0;
            }
        }
    }
    var Base_List1 = [
        0,
        hd_exn,
        rev_append,
        tl_exn,
        unzip,
        length,
        exists,
        exists2_ok,
        fold,
        fold2_ok,
        for_all,
        for_all2_ok,
        iter,
        iter2_ok,
        nontail_map,
        nontail_mapi,
        partition,
        rev_map,
        rev_map2_ok,
        rev,
        fold_right,
        fold_right2_ok,
        is_empty,
        partition_map
    ];
    runtime.caml_register_global(1, Base_List1, "Base__List1");
    return;
})(globalThis);
//# 5808 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Error$0 = "Error", cst_Ok$0 = "Ok", cst_error = "error", cst_ok = "ok", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), error_source_005 = "result.ml.t", Base_List1 = global_data.Base__List1, Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, Base_Hash = global_data.Base__Hash, Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, Base_Monad = global_data.Base__Monad, _a_ = [
        0,
        cst_Ok$0
    ], _b_ = [
        0,
        cst_Error$0
    ], cst_Error = cst_Error$0, cst_Ok = cst_Ok$0;
    function t_of_sexp(of_a_001, of_b_002, sexp_007) {
        a: {
            if (0 === sexp_007[0]) {
                var _e_ = sexp_007[1];
                b: if (_e_ !== cst_Error$0) {
                    if (_e_ !== cst_Ok$0) {
                        if (_e_ === cst_error) break b;
                        if (_e_ !== cst_ok) break a;
                    }
                    return caml_call2(Sexplib0_Sexp_conv_error[9], error_source_005, sexp_007);
                }
                return caml_call2(Sexplib0_Sexp_conv_error[9], error_source_005, sexp_007);
            }
            var _f_ = sexp_007[1];
            if (!_f_) return caml_call2(Sexplib0_Sexp_conv_error[11], error_source_005, sexp_007);
            var _g_ = _f_[1];
            if (0 !== _g_[0]) return caml_call2(Sexplib0_Sexp_conv_error[10], error_source_005, sexp_007);
            var tag_008 = _g_[1];
            b: if (tag_008 !== cst_Error$0) {
                if (tag_008 !== cst_Ok$0) {
                    if (tag_008 === cst_error) break b;
                    if (tag_008 !== cst_ok) break a;
                }
                var sexp_args_009 = _f_[2];
                if (sexp_args_009 && !sexp_args_009[2]) {
                    var arg0_010 = sexp_args_009[1], res0_011 = caml_call1(of_a_001, arg0_010);
                    return [
                        0,
                        res0_011
                    ];
                }
                return caml_call3(Sexplib0_Sexp_conv_error[8], error_source_005, tag_008, sexp_007);
            }
            var sexp_args_014 = _f_[2];
            if (sexp_args_014 && !sexp_args_014[2]) {
                var arg0_015 = sexp_args_014[1], res0_016 = caml_call1(of_b_002, arg0_015);
                return [
                    1,
                    res0_016
                ];
            }
            return caml_call3(Sexplib0_Sexp_conv_error[8], error_source_005, tag_008, sexp_007);
        }
        return caml_call2(Sexplib0_Sexp_conv_error[12], error_source_005, sexp_007);
    }
    function sexp_of_t(of_a_019, of_b_020, param) {
        if (0 === param[0]) {
            var arg0_021 = param[1], res0_022 = caml_call1(of_a_019, arg0_021);
            return [
                1,
                [
                    0,
                    _a_,
                    [
                        0,
                        res0_022,
                        0
                    ]
                ]
            ];
        }
        var arg0_023 = param[1], res0_024 = caml_call1(of_b_020, arg0_023);
        return [
            1,
            [
                0,
                _b_,
                [
                    0,
                    res0_024,
                    0
                ]
            ]
        ];
    }
    function t_sexp_grammar(a_sexp_grammar, b_sexp_grammar) {
        return [
            3,
            [
                0,
                2,
                [
                    0,
                    [
                        1,
                        [
                            0,
                            cst_Ok,
                            [
                                0,
                                [
                                    0,
                                    a_sexp_grammar,
                                    0
                                ]
                            ]
                        ]
                    ],
                    [
                        0,
                        [
                            1,
                            [
                                0,
                                cst_Error,
                                [
                                    0,
                                    [
                                        0,
                                        b_sexp_grammar,
                                        0
                                    ]
                                ]
                            ]
                        ],
                        0
                    ]
                ]
            ]
        ];
    }
    function compare_local(cmp_a, cmp_b, a_033, b_034) {
        if (a_033 === b_034) return 0;
        if (0 === a_033[0]) {
            var a_035 = a_033[1];
            if (0 !== b_034[0]) return -1;
            var b_036 = b_034[1];
            return caml_call2(cmp_a, a_035, b_036);
        }
        var a_037 = a_033[1];
        if (0 === b_034[0]) return 1;
        var b_038 = b_034[1];
        return caml_call2(cmp_b, a_037, b_038);
    }
    function compare(cmp_a, cmp_b, a_027, b_028) {
        if (a_027 === b_028) return 0;
        if (0 === a_027[0]) {
            var a_029 = a_027[1];
            if (0 !== b_028[0]) return -1;
            var b_030 = b_028[1];
            return caml_call2(cmp_a, a_029, b_030);
        }
        var a_031 = a_027[1];
        if (0 === b_028[0]) return 1;
        var b_032 = b_028[1];
        return caml_call2(cmp_b, a_031, b_032);
    }
    function equal_local(cmp_a, cmp_b, a_045, b_046) {
        if (a_045 === b_046) return 1;
        if (0 === a_045[0]) {
            var a_047 = a_045[1];
            if (0 !== b_046[0]) return 0;
            var b_048 = b_046[1];
            return caml_call2(cmp_a, a_047, b_048);
        }
        var a_049 = a_045[1];
        if (0 === b_046[0]) return 0;
        var b_050 = b_046[1];
        return caml_call2(cmp_b, a_049, b_050);
    }
    function equal(cmp_a, cmp_b, a_039, b_040) {
        if (a_039 === b_040) return 1;
        if (0 === a_039[0]) {
            var a_041 = a_039[1];
            if (0 !== b_040[0]) return 0;
            var b_042 = b_040[1];
            return caml_call2(cmp_a, a_041, b_042);
        }
        var a_043 = a_039[1];
        if (0 === b_040[0]) return 0;
        var b_044 = b_040[1];
        return caml_call2(cmp_b, a_043, b_044);
    }
    function hash_fold_t(hash_fold_a, hash_fold_b, hsv, arg) {
        if (0 === arg[0]) {
            var a0 = arg[1], hsv$0 = caml_call2(Base_Hash[3], hsv, 0);
            return caml_call2(hash_fold_a, hsv$0, a0);
        }
        var a0$0 = arg[1], hsv$1 = caml_call2(Base_Hash[3], hsv, 1);
        return caml_call2(hash_fold_b, hsv$1, a0$0);
    }
    var globalize = Base_Import[295];
    function bind(x, f) {
        if (0 !== x[0]) return x;
        var x$0 = x[1];
        return caml_call1(f, x$0);
    }
    var map = [
        0,
        -198771759,
        function(x, f) {
            if (0 !== x[0]) return x;
            var x$0 = x[1];
            return [
                0,
                caml_call1(f, x$0)
            ];
        }
    ];
    function return$0(x) {
        return [
            0,
            x
        ];
    }
    var include = caml_call1(Base_Monad[6], [
        0,
        bind,
        map,
        return$0
    ]), symbol_bind = include[1], symbol_map = include[2], Let_syntax = include[3], Monad_infix = include[4], bind$0 = include[5], return$1 = include[6], map$0 = include[7], join = include[8], ignore_m = include[9], all = include[10], all_unit = include[11];
    function invariant(check_ok, check_error, t) {
        if (0 === t[0]) {
            var ok = t[1];
            return caml_call1(check_ok, ok);
        }
        var error = t[1];
        return caml_call1(check_error, error);
    }
    function fail(x) {
        return [
            1,
            x
        ];
    }
    function failf(format) {
        return caml_call2(Base_Printf[4], fail, format);
    }
    function map_error(t, f) {
        if (0 === t[0]) return t;
        var x = t[1];
        return [
            1,
            caml_call1(f, x)
        ];
    }
    function bind$1(x, f) {
        if (0 === x[0]) return x;
        var e = x[1];
        return caml_call1(f, e);
    }
    var map$1 = [
        0,
        -198771759,
        map_error
    ];
    function return$2(e) {
        return [
            1,
            e
        ];
    }
    var Error1 = caml_call1(Base_Monad[6], [
        0,
        bind$1,
        map$1,
        return$2
    ]), _c_ = [
        0,
        0
    ];
    function is_ok(param) {
        return 0 === param[0] ? 1 : 0;
    }
    function is_error(param) {
        return 0 === param[0] ? 0 : 1;
    }
    function ok(param) {
        if (0 !== param[0]) return 0;
        var x = param[1];
        return [
            0,
            x
        ];
    }
    function error(param) {
        if (0 === param[0]) return 0;
        var x = param[1];
        return [
            0,
            x
        ];
    }
    function of_option(opt, error) {
        if (!opt) return [
            1,
            error
        ];
        var x = opt[1];
        return [
            0,
            x
        ];
    }
    function iter(v, f) {
        if (0 !== v[0]) return 0;
        var x = v[1];
        return caml_call1(f, x);
    }
    function iter_error(v, f) {
        if (0 === v[0]) return 0;
        var x = v[1];
        return caml_call1(f, x);
    }
    function to_either(param) {
        if (0 === param[0]) {
            var x = param[1];
            return [
                0,
                x
            ];
        }
        var x$0 = param[1];
        return [
            1,
            x$0
        ];
    }
    function of_either(param) {
        if (0 === param[0]) {
            var x = param[1];
            return [
                0,
                x
            ];
        }
        var x$0 = param[1];
        return [
            1,
            x$0
        ];
    }
    function ok_if_true(bool, error) {
        return bool ? _c_ : [
            1,
            error
        ];
    }
    function try_with(f) {
        try {
            var _d_ = [
                0,
                caml_call1(f, 0)
            ];
            return _d_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            return [
                1,
                exn
            ];
        }
    }
    function ok_exn(param) {
        if (0 === param[0]) {
            var x = param[1];
            return x;
        }
        var exn = param[1];
        throw caml_maybe_attach_backtrace(exn, 1);
    }
    function ok_or_failwith(param) {
        if (0 === param[0]) {
            var x = param[1];
            return x;
        }
        var str = param[1];
        return caml_call1(Base_Import[124], str);
    }
    function combine(t1, t2, ok, err) {
        if (0 === t1[0]) {
            var ok1 = t1[1];
            if (0 === t2[0]) {
                var ok2 = t2[1];
                return [
                    0,
                    caml_call2(ok, ok1, ok2)
                ];
            }
            var e = t2[1];
        } else {
            var err1 = t1[1];
            if (0 !== t2[0]) {
                var err2 = t2[1];
                return [
                    1,
                    caml_call2(err, err1, err2)
                ];
            }
            var e = err1;
        }
        return [
            1,
            e
        ];
    }
    function combine_errors(l) {
        var match = caml_call2(Base_List1[23], l, to_either), errs = match[2], ok = match[1];
        return errs ? [
            1,
            errs
        ] : [
            0,
            ok
        ];
    }
    function combine_errors_unit(l) {
        return caml_call2(map$0, combine_errors(l), function(param) {
            return 0;
        });
    }
    var Base_Result = [
        0,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        compare,
        compare_local,
        equal,
        equal_local,
        hash_fold_t,
        globalize,
        symbol_bind,
        symbol_map,
        Let_syntax,
        Monad_infix,
        bind$0,
        return$1,
        join,
        ignore_m,
        all,
        all_unit,
        Error1,
        invariant,
        fail,
        failf,
        is_ok,
        is_error,
        ok,
        ok_exn,
        ok_or_failwith,
        error,
        of_option,
        iter,
        iter_error,
        map$0,
        map_error,
        combine,
        combine_errors,
        combine_errors_unit,
        to_either,
        of_either,
        ok_if_true,
        try_with,
        [
            0,
            is_ok,
            is_error
        ]
    ];
    runtime.caml_register_global(20, Base_Result, "Base__Result");
    return;
})(globalThis);
//# 6164 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Continue_or_stop = [
        0
    ], Export = [
        0,
        Continue_or_stop
    ], Continue_or_stop$0 = Export[1], Base_Container_intf = [
        0,
        Export,
        Continue_or_stop$0
    ];
    runtime.caml_register_global(0, Base_Container_intf, "Base__Container_intf");
    return;
})(globalThis);
//# 6180 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Array0 = global_data.Base__Array0, Base_List0 = global_data.Base__List0, Base_Import = global_data.Base__Import, Base_With_return = global_data.Base__With_return, with_return = Base_With_return[1];
    function iter(fold, t, f) {
        return caml_call3(fold, t, 0, function(param, a) {
            return caml_call1(f, a);
        });
    }
    function count(fold, t, f) {
        return caml_call3(fold, t, 0, function(n, a) {
            return caml_call1(f, a) ? caml_call2(Base_Import[91], n, 1) : n;
        });
    }
    function sum(fold, M, t, f) {
        return caml_call3(fold, t, M[1], function(n, a) {
            var _n_ = caml_call1(f, a);
            return caml_call2(M[2], n, _n_);
        });
    }
    function fold_result(fold, init, f, t) {
        return caml_call1(with_return, function(param) {
            return [
                0,
                caml_call3(fold, t, init, function(acc, item) {
                    var e = caml_call2(f, acc, item);
                    if (0 !== e[0]) return caml_call1(param, e);
                    var x = e[1];
                    return x;
                })
            ];
        });
    }
    function fold_until(fold, init, f, finish, t) {
        return caml_call1(with_return, function(param) {
            return caml_call1(finish, caml_call3(fold, t, init, function(acc, item) {
                var match = caml_call2(f, acc, item);
                if (0 === match[0]) {
                    var x = match[1];
                    return x;
                }
                var x$0 = match[1];
                return caml_call1(param, x$0);
            }));
        });
    }
    function min_elt(fold, t, compare) {
        return caml_call3(fold, t, 0, function(acc, elt) {
            if (!acc) return [
                0,
                elt
            ];
            var min = acc[1];
            return 0 < caml_call2(compare, min, elt) ? [
                0,
                elt
            ] : acc;
        });
    }
    function max_elt(fold, t, compare) {
        return caml_call3(fold, t, 0, function(acc, elt) {
            if (!acc) return [
                0,
                elt
            ];
            var max = acc[1];
            return 0 <= caml_call2(compare, max, elt) ? acc : [
                0,
                elt
            ];
        });
    }
    function length(fold, c) {
        return caml_call3(fold, c, 0, function(acc, param) {
            return caml_call2(Base_Import[91], acc, 1);
        });
    }
    function is_empty(iter, c) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, c, function(param) {
                return caml_call1(r, 0);
            });
            return 1;
        });
    }
    function mem(iter, c, x, equal) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, c, function(y) {
                var _m_ = caml_call2(equal, x, y);
                return _m_ ? caml_call1(r, 1) : _m_;
            });
            return 0;
        });
    }
    function exists(iter, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, c, function(x) {
                var _l_ = caml_call1(f, x);
                return _l_ ? caml_call1(r, 1) : _l_;
            });
            return 0;
        });
    }
    function for_all(iter, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, c, function(x) {
                var _k_ = 1 - caml_call1(f, x);
                return _k_ ? caml_call1(r, 0) : _k_;
            });
            return 1;
        });
    }
    function find_map(iter, t, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, t, function(x) {
                var res = caml_call1(f, x);
                return res ? caml_call1(r, res) : 0;
            });
            return 0;
        });
    }
    function find(iter, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, c, function(x) {
                var _j_ = caml_call1(f, x);
                return _j_ ? caml_call1(r, [
                    0,
                    x
                ]) : _j_;
            });
            return 0;
        });
    }
    function to_list(fold, c) {
        var _i_ = caml_call3(fold, c, 0, function(acc, x) {
            return [
                0,
                x,
                acc
            ];
        });
        return caml_call1(Base_List0[19], _i_);
    }
    function to_array(length, iter, c) {
        var array = [
            0,
            [
                0
            ]
        ], i = [
            0,
            0
        ];
        caml_call2(iter, c, function(x) {
            if (0 === i[1]) {
                var _g_ = caml_call1(length, c);
                array[1] = caml_call2(Base_Array0[4], _g_, x);
            }
            var _h_ = i[1];
            runtime.caml_check_bound(array[1], _h_)[1 + _h_] = x;
            i[1]++;
            return 0;
        });
        return array[1];
    }
    function Make_gen(T) {
        var fold = T[1], match = T[2];
        if (typeof match === "number") var iter$0 = function(t, f) {
            return iter(fold, t, f);
        };
        else var iter$1 = match[2], iter$0 = iter$1;
        var match$0 = T[3];
        if (typeof match$0 === "number") var length$0 = function(t) {
            return length(fold, t);
        };
        else var length$1 = match$0[2], length$0 = length$1;
        function is_empty$0(t) {
            return is_empty(iter$0, t);
        }
        function mem$0(t, x, equal) {
            return mem(iter$0, t, x, equal);
        }
        function sum$0(m, t) {
            return function(_f_) {
                return sum(fold, m, t, _f_);
            };
        }
        function count$0(t, f) {
            return count(fold, t, f);
        }
        function exists$0(t, f) {
            return exists(iter$0, t, f);
        }
        function for_all$0(t, f) {
            return for_all(iter$0, t, f);
        }
        function find_map$0(t, f) {
            return find_map(iter$0, t, f);
        }
        function find$0(t, f) {
            return find(iter$0, t, f);
        }
        function to_list$0(t) {
            return to_list(fold, t);
        }
        function to_array$0(t) {
            return to_array(length$0, iter$0, t);
        }
        function min_elt$0(t, compare) {
            return min_elt(fold, t, compare);
        }
        function max_elt$0(t, compare) {
            return max_elt(fold, t, compare);
        }
        function fold_result$0(t, init, f) {
            return fold_result(fold, init, f, t);
        }
        function fold_until$0(t, init, f, finish) {
            return fold_until(fold, init, f, finish, t);
        }
        return [
            0,
            length$0,
            is_empty$0,
            mem$0,
            iter$0,
            fold,
            fold_result$0,
            fold_until$0,
            exists$0,
            for_all$0,
            count$0,
            sum$0,
            find$0,
            find_map$0,
            to_list$0,
            to_array$0,
            min_elt$0,
            max_elt$0
        ];
    }
    function Make_gen_with_creators(T) {
        var include = Make_gen([
            0,
            T[1],
            T[2],
            T[3]
        ]), length = include[1], is_empty = include[2], mem = include[3], iter = include[4], fold = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], of_list = T[4], of_array = T[5], concat = T[6], concat_of_array = T[7];
        function append(a, b) {
            return caml_call1(concat, caml_call1(concat_of_array, [
                0,
                a,
                b
            ]));
        }
        function concat_map(t, f) {
            var _e_ = caml_call1(to_array, t);
            return caml_call1(concat, caml_call1(concat_of_array, caml_call2(Base_Array0[21], _e_, f)));
        }
        function filter_map(t, f) {
            return concat_map(t, function(x) {
                var match = caml_call1(f, x);
                if (!match) return caml_call1(of_array, [
                    0
                ]);
                var y = match[1];
                return caml_call1(of_array, [
                    0,
                    y
                ]);
            });
        }
        function map(t, f) {
            return filter_map(t, function(x) {
                return [
                    0,
                    caml_call1(f, x)
                ];
            });
        }
        function filter(t, f) {
            return filter_map(t, function(x) {
                return caml_call1(f, x) ? [
                    0,
                    x
                ] : 0;
            });
        }
        function partition_map(t, f) {
            var _c_ = caml_call1(to_array, t), array = caml_call2(Base_Array0[21], _c_, f), xs = caml_call3(Base_Array0[18], array, function(either, acc) {
                if (0 !== either[0]) return acc;
                var x = either[1];
                return [
                    0,
                    x,
                    acc
                ];
            }, 0), ys = caml_call3(Base_Array0[18], array, function(either, acc) {
                if (0 === either[0]) return acc;
                var x = either[1];
                return [
                    0,
                    x,
                    acc
                ];
            }, 0), _d_ = caml_call1(of_list, ys);
            return [
                0,
                caml_call1(of_list, xs),
                _d_
            ];
        }
        function partition_tf(t, f) {
            return partition_map(t, function(x) {
                return caml_call1(f, x) ? [
                    0,
                    x
                ] : [
                    1,
                    x
                ];
            });
        }
        return [
            0,
            length,
            is_empty,
            mem,
            iter,
            fold,
            fold_result,
            fold_until,
            exists,
            for_all,
            count,
            sum,
            find,
            find_map,
            to_list,
            to_array,
            min_elt,
            max_elt,
            of_list,
            of_array,
            append,
            concat,
            map,
            filter,
            filter_map,
            concat_map,
            partition_tf,
            partition_map
        ];
    }
    var Base_Container = [
        0,
        iter,
        count,
        min_elt,
        max_elt,
        length,
        to_list,
        sum,
        fold_result,
        fold_until,
        is_empty,
        mem,
        exists,
        for_all,
        find,
        find_map,
        to_array,
        function(T) {
            var fold = T[1], iter = T[2], length = T[3], include = Make_gen([
                0,
                fold,
                iter,
                length
            ]), length$0 = include[1], is_empty = include[2], mem = include[3], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17];
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt
            ];
        },
        function(T) {
            var fold = T[2], iter = T[3], length = T[4], include = Make_gen([
                0,
                fold,
                iter,
                length
            ]), length$0 = include[1], is_empty = include[2], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], _b_ = include[3];
            function mem(t, x) {
                return caml_call3(_b_, t, x, T[1][1]);
            }
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt
            ];
        },
        Make_gen,
        function(T) {
            var fold = T[1], iter = T[2], length = T[3], of_list = T[4], of_array = T[5], concat = T[6], include = Make_gen_with_creators([
                0,
                fold,
                iter,
                length,
                of_list,
                of_array,
                concat,
                of_array
            ]), length$0 = include[1], is_empty = include[2], mem = include[3], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], of_list$0 = include[18], of_array$0 = include[19], append = include[20], concat$0 = include[21], map = include[22], filter = include[23], filter_map = include[24], concat_map = include[25], partition_tf = include[26], partition_map = include[27];
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                of_list$0,
                of_array$0,
                append,
                concat$0,
                map,
                filter,
                filter_map,
                concat_map,
                partition_tf,
                partition_map
            ];
        },
        function(T) {
            var fold = T[2], iter = T[3], length = T[4], of_list = T[5], of_array = T[6], concat = T[7], concat_of_array = Base_Array0[16], include = Make_gen_with_creators([
                0,
                fold,
                iter,
                length,
                of_list,
                of_array,
                concat,
                concat_of_array
            ]), length$0 = include[1], is_empty = include[2], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], of_list$0 = include[18], of_array$0 = include[19], append = include[20], concat$0 = include[21], map = include[22], filter = include[23], filter_map = include[24], concat_map = include[25], partition_tf = include[26], partition_map = include[27], _a_ = include[3];
            function mem(t, x) {
                return caml_call3(_a_, t, x, T[1][1]);
            }
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                of_list$0,
                of_array$0,
                append,
                concat$0,
                map,
                filter,
                filter_map,
                concat_map,
                partition_tf,
                partition_map
            ];
        },
        Make_gen_with_creators
    ];
    runtime.caml_register_global(4, Base_Container, "Base__Container");
    return;
})(globalThis);
//# 6802 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Indexed_container_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Indexed_container_intf, "Base__Indexed_container_intf");
    return;
})(globalThis);
//# 6813 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Array0 = global_data.Base__Array0, Base_Container = global_data.Base__Container, Base_Import = global_data.Base__Import, Base_With_return = global_data.Base__With_return, with_return = Base_With_return[1];
    function iteri(fold, t, f) {
        caml_call3(fold, t, 0, function(i, x) {
            caml_call2(f, i, x);
            return caml_call2(Base_Import[91], i, 1);
        });
        return 0;
    }
    function foldi(fold, t, init, f) {
        var i = [
            0,
            0
        ];
        return caml_call3(fold, t, init, function(acc, v) {
            var acc$0 = caml_call3(f, i[1], acc, v);
            i[1] = caml_call2(Base_Import[91], i[1], 1);
            return acc$0;
        });
    }
    function counti(foldi, t, f) {
        return caml_call3(foldi, t, 0, function(i, n, a) {
            return caml_call2(f, i, a) ? caml_call2(Base_Import[91], n, 1) : n;
        });
    }
    function existsi(iteri, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iteri, c, function(i, x) {
                var _h_ = caml_call2(f, i, x);
                return _h_ ? caml_call1(r, 1) : _h_;
            });
            return 0;
        });
    }
    function for_alli(iteri, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iteri, c, function(i, x) {
                var _g_ = 1 - caml_call2(f, i, x);
                return _g_ ? caml_call1(r, 0) : _g_;
            });
            return 1;
        });
    }
    function find_mapi(iteri, t, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iteri, t, function(i, x) {
                var res = caml_call2(f, i, x);
                return res ? caml_call1(r, res) : 0;
            });
            return 0;
        });
    }
    function findi(iteri, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iteri, c, function(i, x) {
                var _f_ = caml_call2(f, i, x);
                return _f_ ? caml_call1(r, [
                    0,
                    [
                        0,
                        i,
                        x
                    ]
                ]) : _f_;
            });
            return 0;
        });
    }
    function Make_gen_with_container(T, _e_) {
        var length = _e_[1], is_empty = _e_[2], mem = _e_[3], iter = _e_[4], fold = _e_[5], fold_result = _e_[6], fold_until = _e_[7], exists = _e_[8], for_all = _e_[9], count = _e_[10], sum = _e_[11], find = _e_[12], find_map = _e_[13], to_list = _e_[14], to_array = _e_[15], min_elt = _e_[16], max_elt = _e_[17], match = T[4];
        if (typeof match === "number") var iteri$0 = function(t, f) {
            return iteri(fold, t, f);
        };
        else var iteri$1 = match[2], iteri$0 = iteri$1;
        var match$0 = T[5];
        if (typeof match$0 === "number") var foldi$0 = function(t, init, f) {
            return foldi(fold, t, init, f);
        };
        else var foldi$1 = match$0[2], foldi$0 = foldi$1;
        function counti$0(t, f) {
            return counti(foldi$0, t, f);
        }
        function existsi$0(t, f) {
            return existsi(iteri$0, t, f);
        }
        function for_alli$0(t, f) {
            return for_alli(iteri$0, t, f);
        }
        function find_mapi$0(t, f) {
            return find_mapi(iteri$0, t, f);
        }
        function findi$0(t, f) {
            return findi(iteri$0, t, f);
        }
        return [
            0,
            length,
            is_empty,
            mem,
            iter,
            fold,
            fold_result,
            fold_until,
            exists,
            for_all,
            count,
            sum,
            find,
            find_map,
            to_list,
            to_array,
            min_elt,
            max_elt,
            foldi$0,
            iteri$0,
            existsi$0,
            for_alli$0,
            counti$0,
            findi$0,
            find_mapi$0
        ];
    }
    function Make_gen(T) {
        var C = caml_call1(Base_Container[19], [
            0,
            T[1],
            T[2],
            T[3]
        ]), include = Make_gen_with_container(T, C), length = include[1], is_empty = include[2], mem = include[3], iter = include[4], fold = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], foldi = include[18], iteri = include[19], existsi = include[20], for_alli = include[21], counti = include[22], findi = include[23], find_mapi = include[24];
        return [
            0,
            length,
            is_empty,
            mem,
            iter,
            fold,
            fold_result,
            fold_until,
            exists,
            for_all,
            count,
            sum,
            find,
            find_map,
            to_list,
            to_array,
            min_elt,
            max_elt,
            foldi,
            iteri,
            existsi,
            for_alli,
            counti,
            findi,
            find_mapi
        ];
    }
    function Make_gen_with_creators(T) {
        var C = caml_call1(Base_Container[22], [
            0,
            T[5],
            T[6],
            T[7],
            T[2],
            T[3],
            T[4],
            T[1]
        ]), of_list = C[18], of_array = C[19], append = C[20], concat = C[21], map = C[22], filter = C[23], filter_map = C[24], concat_map = C[25], partition_tf = C[26], partition_map = C[27], include = Make_gen_with_container([
            0,
            T[5],
            T[6],
            T[7],
            T[8],
            T[9]
        ], [
            0,
            C[1],
            C[2],
            C[3],
            C[4],
            C[5],
            C[6],
            C[7],
            C[8],
            C[9],
            C[10],
            C[11],
            C[12],
            C[13],
            C[14],
            C[15],
            C[16],
            C[17]
        ]), length = include[1], is_empty = include[2], mem = include[3], iter = include[4], fold = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], foldi = include[18], iteri = include[19], existsi = include[20], for_alli = include[21], counti = include[22], findi = include[23], find_mapi = include[24];
        function derived_init(n, f) {
            return caml_call1(of_array, caml_call2(Base_Array0[12], n, f));
        }
        var match = T[10];
        if (typeof match === "number") var derived_init$0 = derived_init;
        else var init = match[2], derived_init$0 = init;
        function derived_concat_mapi(t, f) {
            var _c_ = caml_call1(to_array, t), _d_ = caml_call2(Base_Array0[22], _c_, f);
            return caml_call1(concat, caml_call1(T[1], _d_));
        }
        var match$0 = T[11];
        if (typeof match$0 === "number") var concat_mapi = derived_concat_mapi;
        else var concat_mapi$0 = match$0[2], concat_mapi = concat_mapi$0;
        function filter_mapi(t, f) {
            return caml_call2(concat_mapi, t, function(i, x) {
                var match = caml_call2(f, i, x);
                if (!match) return caml_call1(of_array, [
                    0
                ]);
                var y = match[1];
                return caml_call1(of_array, [
                    0,
                    y
                ]);
            });
        }
        function mapi(t, f) {
            return filter_mapi(t, function(i, x) {
                return [
                    0,
                    caml_call2(f, i, x)
                ];
            });
        }
        function filteri(t, f) {
            return filter_mapi(t, function(i, x) {
                return caml_call2(f, i, x) ? [
                    0,
                    x
                ] : 0;
            });
        }
        return [
            0,
            of_list,
            of_array,
            append,
            concat,
            map,
            filter,
            filter_map,
            concat_map,
            partition_tf,
            partition_map,
            length,
            is_empty,
            mem,
            iter,
            fold,
            fold_result,
            fold_until,
            exists,
            for_all,
            count,
            sum,
            find,
            find_map,
            to_list,
            to_array,
            min_elt,
            max_elt,
            foldi,
            iteri,
            existsi,
            for_alli,
            counti,
            findi,
            find_mapi,
            derived_init$0,
            mapi,
            filteri,
            filter_mapi,
            concat_mapi
        ];
    }
    var Base_Indexed_container = [
        0,
        foldi,
        iteri,
        counti,
        existsi,
        for_alli,
        findi,
        find_mapi,
        function(T) {
            var fold = T[1], iter = T[2], length = T[3], iteri = T[4], foldi = T[5], include = Make_gen([
                0,
                fold,
                iter,
                length,
                iteri,
                foldi
            ]), length$0 = include[1], is_empty = include[2], mem = include[3], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], foldi$0 = include[18], iteri$0 = include[19], existsi = include[20], for_alli = include[21], counti = include[22], findi = include[23], find_mapi = include[24];
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                foldi$0,
                iteri$0,
                existsi,
                for_alli,
                counti,
                findi,
                find_mapi
            ];
        },
        function(T) {
            var fold = T[2], iter = T[3], length = T[4], iteri = T[5], foldi = T[6], include = Make_gen([
                0,
                fold,
                iter,
                length,
                iteri,
                foldi
            ]), length$0 = include[1], is_empty = include[2], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], foldi$0 = include[18], iteri$0 = include[19], existsi = include[20], for_alli = include[21], counti = include[22], findi = include[23], find_mapi = include[24], _b_ = include[3];
            function mem(t, x) {
                return caml_call3(_b_, t, x, T[1][1]);
            }
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                foldi$0,
                iteri$0,
                existsi,
                for_alli,
                counti,
                findi,
                find_mapi
            ];
        },
        Make_gen,
        function(T) {
            var of_list = T[1], of_array = T[2], concat = T[3], fold = T[4], iter = T[5], length = T[6], iteri = T[7], foldi = T[8], init = T[9], concat_mapi = T[10], include = Make_gen_with_creators([
                0,
                of_array,
                of_list,
                of_array,
                concat,
                fold,
                iter,
                length,
                iteri,
                foldi,
                init,
                concat_mapi
            ]), of_list$0 = include[1], of_array$0 = include[2], append = include[3], concat$0 = include[4], map = include[5], filter = include[6], filter_map = include[7], concat_map = include[8], partition_tf = include[9], partition_map = include[10], length$0 = include[11], is_empty = include[12], mem = include[13], iter$0 = include[14], fold$0 = include[15], fold_result = include[16], fold_until = include[17], exists = include[18], for_all = include[19], count = include[20], sum = include[21], find = include[22], find_map = include[23], to_list = include[24], to_array = include[25], min_elt = include[26], max_elt = include[27], foldi$0 = include[28], iteri$0 = include[29], existsi = include[30], for_alli = include[31], counti = include[32], findi = include[33], find_mapi = include[34], init$0 = include[35], mapi = include[36], filteri = include[37], filter_mapi = include[38], concat_mapi$0 = include[39];
            return [
                0,
                of_list$0,
                of_array$0,
                append,
                concat$0,
                map,
                filter,
                filter_map,
                concat_map,
                partition_tf,
                partition_map,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                foldi$0,
                iteri$0,
                existsi,
                for_alli,
                counti,
                findi,
                find_mapi,
                init$0,
                mapi,
                filteri,
                filter_mapi,
                concat_mapi$0
            ];
        },
        function(T) {
            var of_list = T[2], of_array = T[3], concat = T[4], fold = T[5], iter = T[6], length = T[7], iteri = T[8], foldi = T[9], init = T[10], concat_mapi = T[11], concat_of_array = Base_Array0[16], include = Make_gen_with_creators([
                0,
                concat_of_array,
                of_list,
                of_array,
                concat,
                fold,
                iter,
                length,
                iteri,
                foldi,
                init,
                concat_mapi
            ]), of_list$0 = include[1], of_array$0 = include[2], append = include[3], concat$0 = include[4], map = include[5], filter = include[6], filter_map = include[7], concat_map = include[8], partition_tf = include[9], partition_map = include[10], length$0 = include[11], is_empty = include[12], iter$0 = include[14], fold$0 = include[15], fold_result = include[16], fold_until = include[17], exists = include[18], for_all = include[19], count = include[20], sum = include[21], find = include[22], find_map = include[23], to_list = include[24], to_array = include[25], min_elt = include[26], max_elt = include[27], foldi$0 = include[28], iteri$0 = include[29], existsi = include[30], for_alli = include[31], counti = include[32], findi = include[33], find_mapi = include[34], init$0 = include[35], mapi = include[36], filteri = include[37], filter_mapi = include[38], concat_mapi$0 = include[39], _a_ = include[13];
            function mem(t, x) {
                return caml_call3(_a_, t, x, T[1][1]);
            }
            return [
                0,
                of_list$0,
                of_array$0,
                append,
                concat$0,
                map,
                filter,
                filter_map,
                concat_map,
                partition_tf,
                partition_map,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                foldi$0,
                iteri$0,
                existsi,
                for_alli,
                counti,
                findi,
                find_mapi,
                init$0,
                mapi,
                filteri,
                filter_mapi,
                concat_mapi$0
            ];
        },
        Make_gen_with_creators
    ];
    runtime.caml_register_global(4, Base_Indexed_container, "Base__Indexed_container");
    return;
})(globalThis);
//# 7721 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Info_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Info_intf, "Base__Info_intf");
    return;
})(globalThis);
//# 7731 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, invalid_argf = Base_Printf[7], _a_ = [
        0,
        [
            11,
            "Negative position: ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "Negative position: %d"
    ], _b_ = [
        0,
        [
            11,
            "Negative length: ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "Negative length: %d"
    ], _c_ = [
        0,
        [
            11,
            "pos + len past end: ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " + ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " > ",
                            [
                                4,
                                0,
                                0,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "pos + len past end: %d + %d > %d"
    ];
    function slow_check_pos_len_exn(pos, len, total_length) {
        if (pos < 0) caml_call3(invalid_argf, _a_, pos, 0);
        if (len < 0) caml_call3(invalid_argf, _b_, len, 0);
        var _h_ = caml_call2(Base_Import[93], total_length, len) < pos ? 1 : 0;
        return _h_ ? caml_call5(invalid_argf, _c_, pos, len, total_length, 0) : _h_;
    }
    function check_pos_len_exn(pos, len, total_length) {
        var stop = caml_call2(Base_Import[91], pos, len), _d_ = caml_call2(Base_Import[93], total_length, stop), _e_ = caml_call2(Base_Import[118], pos, len), _f_ = caml_call2(Base_Import[118], _e_, stop), _g_ = caml_call2(Base_Import[118], _f_, _d_) < 0 ? 1 : 0;
        return _g_ ? slow_check_pos_len_exn(pos, len, total_length) : _g_;
    }
    function get_pos_len_exn(opt, len, param, total_length) {
        var pos = opt ? opt[1] : 0;
        if (len) var i = len[1], len$0 = i;
        else var len$0 = caml_call2(Base_Import[93], total_length, pos);
        check_pos_len_exn(pos, len$0, total_length);
        return [
            0,
            pos,
            len$0
        ];
    }
    var Private = [
        0,
        slow_check_pos_len_exn
    ], Base_Ordered_collection_common = [
        0,
        get_pos_len_exn,
        check_pos_len_exn,
        Private
    ];
    runtime.caml_register_global(5, Base_Ordered_collection_common, "Base__Ordered_collection_common0");
    return;
})(globalThis);
//# 7805 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Domain = global_data.Stdlib__Domain, Stdlib_Random = global_data.Stdlib__Random;
    function of_state(_b_) {
        return _b_;
    }
    var Repr = [
        0,
        of_state
    ];
    function assign(t, state) {
        var _a_ = caml_call1(Stdlib_Domain[10][2], t), dst = caml_call1(Repr[1], _a_), src = caml_call1(Repr[1], state);
        return runtime.caml_ba_blit(src, dst);
    }
    function make(state) {
        function split_from_parent(v) {
            return caml_call1(Stdlib_Random[19][19], v);
        }
        var t = caml_call2(Stdlib_Domain[10][1], [
            0,
            split_from_parent
        ], function(param) {
            return state;
        });
        caml_call1(Stdlib_Domain[10][2], t);
        return t;
    }
    function make_lazy(f) {
        function split_from_parent(v) {
            return caml_call1(Stdlib_Random[19][19], v);
        }
        return caml_call2(Stdlib_Domain[10][1], [
            0,
            split_from_parent
        ], f);
    }
    function get_state(t) {
        return caml_call1(Stdlib_Domain[10][2], t);
    }
    var Base_Random_repr = [
        0,
        Repr,
        assign,
        make,
        make_lazy,
        get_state
    ];
    runtime.caml_register_global(2, Base_Random_repr, "Base__Random_repr");
    return;
})(globalThis);
//# 7860 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_greaterequal = runtime.caml_greaterequal, caml_int64_add = runtime.caml_int64_add, caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_shift_left = runtime.caml_int64_shift_left, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_int64_xor = runtime.caml_int64_xor;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Base_Random_repr = global_data.Base__Random_repr, Base_Import = global_data.Base__Import, Stdlib_Int64 = global_data.Stdlib__Int64, Stdlib_Nativeint = global_data.Stdlib__Nativeint, Stdlib_Int32 = global_data.Stdlib__Int32, Base_Int0 = global_data.Base__Int0, Base_Printf = global_data.Base__Printf, Stdlib_Random = global_data.Stdlib__Random, Base_Char0 = global_data.Base__Char0, Base_Word_size = global_data.Base__Word_size, cst_initializing_Random_with_a = "initializing Random with a nondeterministic seed is forbidden in inline tests";
    function forbid_nondeterminism_in_tests(allow_in_tests) {
        var _D_ = Base_Import[129];
        if (!_D_) return _D_;
        if (allow_in_tests && allow_in_tests[1]) return;
        return caml_call1(Base_Import[124], cst_initializing_Random_with_a);
    }
    function bits(t) {
        var _C_ = caml_call1(Base_Random_repr[5], t);
        return caml_call1(Stdlib_Random[19][4], _C_);
    }
    function bits64(t) {
        var _B_ = caml_call1(Base_Random_repr[5], t);
        return caml_call1(Stdlib_Random[19][17], _B_);
    }
    function bool(t) {
        var _A_ = caml_call1(Base_Random_repr[5], t);
        return caml_call1(Stdlib_Random[19][15], _A_);
    }
    function int$0(t, x) {
        var _z_ = caml_call1(Base_Random_repr[5], t);
        return caml_call2(Stdlib_Random[19][5], _z_, x);
    }
    function int32(t, x) {
        var _y_ = caml_call1(Base_Random_repr[5], t);
        return caml_call2(Stdlib_Random[19][8], _y_, x);
    }
    function int64(t, x) {
        var _x_ = caml_call1(Base_Random_repr[5], t);
        return caml_call2(Stdlib_Random[19][12], _x_, x);
    }
    function nativeint(t, x) {
        var _w_ = caml_call1(Base_Random_repr[5], t);
        return caml_call2(Stdlib_Random[19][10], _w_, x);
    }
    function make(seed) {
        var _v_ = caml_call1(Stdlib_Random[19][1], seed);
        return caml_call1(Base_Random_repr[3], _v_);
    }
    function copy(t) {
        var _t_ = caml_call1(Base_Random_repr[5], t), _u_ = caml_call1(Stdlib_Random[19][3], _t_);
        return caml_call1(Base_Random_repr[3], _u_);
    }
    function char$0(t) {
        var _s_ = int$0(t, 256);
        return caml_call1(Base_Char0[5], _s_);
    }
    function ascii(t) {
        var _r_ = int$0(t, 128);
        return caml_call1(Base_Char0[5], _r_);
    }
    function make_self_init(allow_in_tests, param) {
        forbid_nondeterminism_in_tests(allow_in_tests);
        return caml_call1(Base_Random_repr[4], Stdlib_Random[19][2]);
    }
    var assign = Base_Random_repr[2], cst_float = "float", cst_int64 = "int64", _b_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), cst_nativeint = "nativeint", cst_int32 = "int32", cst_int = "int", _a_ = [
        0,
        [
            11,
            "Random.",
            [
                2,
                0,
                [
                    11,
                    ": crossed bounds [",
                    [
                        2,
                        0,
                        [
                            11,
                            " > ",
                            [
                                2,
                                0,
                                [
                                    12,
                                    93,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "Random.%s: crossed bounds [%s > %s]"
    ];
    if (Base_Import[129]) {
        var t = caml_call1(Stdlib_Random[20], 0);
        caml_call1(Stdlib_Random[1], 137);
        var default$0 = caml_call1(Base_Random_repr[3], t);
    } else var default$0 = make_self_init(0, 0);
    function int_on_64bits(t, bound) {
        return 1073741823 < bound ? caml_int64_to_int32(int64(t, caml_int64_of_int32(bound))) : int$0(t, bound);
    }
    function int_on_32bits(t, bound) {
        return 1073741823 < bound ? int32(t, bound) : int$0(t, bound);
    }
    var int$1 = Base_Word_size[3] ? int_on_64bits : int_on_32bits;
    function bits$0(state) {
        return caml_int64_of_int32(bits(state));
    }
    function full_range_int64(state) {
        var _p_ = caml_int64_shift_left(bits$0(state), 60), _q_ = caml_int64_xor(caml_int64_shift_left(bits$0(state), 30), _p_);
        return caml_int64_xor(bits$0(state), _q_);
    }
    function full_range_int32(state) {
        var _o_ = bits(state) << 30;
        return bits(state) ^ _o_;
    }
    function full_range_int_on_64bits(state) {
        return caml_int64_to_int32(full_range_int64(state));
    }
    function full_range_int_on_32bits(state) {
        return full_range_int32(state);
    }
    var full_range_int_on_64bits$0 = Base_Word_size[3] ? full_range_int_on_64bits : full_range_int_on_32bits;
    function full_range_nativeint_on_64bits(state) {
        return caml_int64_to_int32(full_range_int64(state));
    }
    function full_range_nativeint_on_32bits(state) {
        return full_range_int32(state);
    }
    var full_range_nativeint = Base_Word_size[3] ? full_range_nativeint_on_64bits : full_range_nativeint_on_32bits;
    function raise_crossed_bounds(name, lower_bound, upper_bound, string_of_bound) {
        var _m_ = caml_call1(string_of_bound, upper_bound), _n_ = caml_call1(string_of_bound, lower_bound);
        return caml_call5(Base_Printf[6], _a_, name, _n_, _m_, 0);
    }
    function int_incl(state, lo, hi) {
        if (hi < lo) raise_crossed_bounds(cst_int, lo, hi, Base_Int0[1]);
        var diff = caml_call2(Base_Import[93], hi, lo);
        if (diff === Base_Int0[6]) {
            var _i_ = Base_Int0[6], _j_ = full_range_int_on_64bits$0(state), _k_ = caml_call2(Base_Import[116], _j_, _i_);
            return caml_call2(Base_Import[91], lo, _k_);
        }
        if (0 <= diff) {
            var _l_ = int$1(state, caml_call1(Base_Int0[8], diff));
            return caml_call2(Base_Import[91], lo, _l_);
        }
        for(;;){
            var int$0 = full_range_int_on_64bits$0(state);
            if (lo <= int$0 && int$0 <= hi) return int$0;
        }
    }
    function int32_incl(state, lo, hi) {
        if (caml_call2(Base_Import[102][5], lo, hi)) raise_crossed_bounds(cst_int32, lo, hi, Stdlib_Int32[14]);
        var diff = hi - lo | 0;
        if (caml_call2(Base_Import[102][4], diff, Stdlib_Int32[9])) {
            var _h_ = Stdlib_Int32[9];
            return lo + (full_range_int32(state) & _h_) | 0;
        }
        if (caml_call2(Base_Import[102][6], diff, 0)) return lo + int32(state, caml_call1(Stdlib_Int32[6], diff)) | 0;
        for(;;){
            var int$0 = full_range_int32(state);
            if (caml_call2(Base_Import[102][6], int$0, lo) && caml_call2(Base_Import[102][2], int$0, hi)) return int$0;
        }
    }
    function nativeint_incl(state, lo, hi) {
        if (caml_call2(Base_Import[104][5], lo, hi)) raise_crossed_bounds(cst_nativeint, lo, hi, Stdlib_Nativeint[15]);
        var diff = hi - lo | 0;
        if (caml_call2(Base_Import[104][4], diff, Stdlib_Nativeint[10])) {
            var _g_ = Stdlib_Nativeint[10];
            return lo + (full_range_nativeint(state) & _g_) | 0;
        }
        if (caml_call2(Base_Import[104][6], diff, 0)) return lo + nativeint(state, caml_call1(Stdlib_Nativeint[6], diff)) | 0;
        for(;;){
            var int$0 = full_range_nativeint(state);
            if (caml_call2(Base_Import[104][6], int$0, lo) && caml_call2(Base_Import[104][2], int$0, hi)) return int$0;
        }
    }
    function int64_incl(state, lo, hi) {
        if (runtime.caml_greaterthan(lo, hi)) raise_crossed_bounds(cst_int64, lo, hi, Stdlib_Int64[14]);
        var diff = runtime.caml_int64_sub(hi, lo);
        if (runtime.caml_equal(diff, Stdlib_Int64[9])) {
            var _f_ = Stdlib_Int64[9];
            return caml_int64_add(lo, runtime.caml_int64_and(full_range_int64(state), _f_));
        }
        if (caml_greaterequal(diff, _b_)) return caml_int64_add(lo, int64(state, caml_call1(Stdlib_Int64[6], diff)));
        for(;;){
            var int$0 = full_range_int64(state);
            if (caml_greaterequal(int$0, lo) && runtime.caml_lessequal(int$0, hi)) return int$0;
        }
    }
    function float$0(state, hi) {
        for(;;){
            var scale = 9.313225746154785e-10, r1 = bits(state), r2 = bits(state), _d_ = caml_call2(Base_Import[90], r1, scale), _e_ = caml_call2(Base_Import[92], _d_, r2), result = caml_call2(Base_Import[90], _e_, scale);
            if (result < 1.) return caml_call2(Base_Import[90], result, hi);
        }
    }
    function float_range(state, lo, hi) {
        if (hi < lo) raise_crossed_bounds(cst_float, lo, hi, Base_Import[85][35]);
        var _c_ = float$0(state, caml_call2(Base_Import[94], hi, lo));
        return caml_call2(Base_Import[92], lo, _c_);
    }
    function bits$1(param) {
        return bits(default$0);
    }
    function bits64$0(param) {
        return bits64(default$0);
    }
    function int$2(x) {
        return int$1(default$0, x);
    }
    function int32$0(x) {
        return int32(default$0, x);
    }
    function nativeint$0(x) {
        return nativeint(default$0, x);
    }
    function int64$0(x) {
        return int64(default$0, x);
    }
    function float$1(x) {
        return float$0(default$0, x);
    }
    function int_incl$0(x, y) {
        return int_incl(default$0, x, y);
    }
    function int32_incl$0(x, y) {
        return int32_incl(default$0, x, y);
    }
    function nativeint_incl$0(x, y) {
        return nativeint_incl(default$0, x, y);
    }
    function int64_incl$0(x, y) {
        return int64_incl(default$0, x, y);
    }
    function float_range$0(x, y) {
        return float_range(default$0, x, y);
    }
    function bool$0(param) {
        return bool(default$0);
    }
    function char$1(param) {
        return char$0(default$0);
    }
    function ascii$0(param) {
        return ascii(default$0);
    }
    function full_init(seed) {
        return caml_call2(assign, default$0, caml_call1(Stdlib_Random[19][1], seed));
    }
    function init(seed) {
        return full_init([
            0,
            seed
        ]);
    }
    function self_init(allow_in_tests, param) {
        forbid_nondeterminism_in_tests(allow_in_tests);
        return full_init(runtime.caml_sys_random_seed(0));
    }
    function set_state(s) {
        return caml_call2(assign, default$0, caml_call1(Base_Random_repr[5], s));
    }
    var Base_Random = [
        0,
        init,
        full_init,
        self_init,
        bits$1,
        bits64$0,
        int$2,
        int32$0,
        nativeint$0,
        int64$0,
        float$1,
        int_incl$0,
        int32_incl$0,
        nativeint_incl$0,
        int64_incl$0,
        float_range$0,
        bool$0,
        char$1,
        ascii$0,
        [
            0,
            default$0,
            make,
            make_self_init,
            copy,
            bits,
            bits64,
            int$1,
            int32,
            nativeint,
            int64,
            float$0,
            int_incl,
            int32_incl,
            nativeint_incl,
            int64_incl,
            float_range,
            bool,
            char$0,
            ascii
        ],
        set_state
    ];
    runtime.caml_register_global(22, Base_Random, "Base__Random");
    return;
})(globalThis);
//# 8190 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Random = global_data.Base__Random, Base_Import = global_data.Base__Import, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common0, Base_Array0 = global_data.Base__Array0, invalid_argf = Base_Array0[1], Array1 = Base_Array0[2], max_length = Base_Array0[3], create = Base_Array0[4], create_local = Base_Array0[5], create_float_uninitialized = Base_Array0[6], append = Base_Array0[7], blit = Base_Array0[8], concat = Base_Array0[9], copy = Base_Array0[10], fill = Base_Array0[11], init = Base_Array0[12], make_matrix = Base_Array0[13], of_list = Base_Array0[14], sub = Base_Array0[15], to_list = Base_Array0[16], fold = Base_Array0[17], fold_right = Base_Array0[18], iter = Base_Array0[19], iteri = Base_Array0[20], map = Base_Array0[21], mapi = Base_Array0[22], stable_sort = Base_Array0[23], swap = Base_Array0[24];
    function permute(_a_, opt, len, t) {
        var random_state = _a_ ? _a_[1] : Base_Random[19][1], pos = opt ? opt[1] : 0, total_length = t.length - 1;
        if (len) var l = len[1], len$0 = l;
        else var len$0 = caml_call2(Base_Import[93], total_length, pos);
        caml_call3(Base_Ordered_collection_common[2], pos, len$0, total_length);
        var num_swaps = caml_call2(Base_Import[93], len$0, 1);
        if (num_swaps >= 1) {
            var i = num_swaps;
            for(;;){
                var this_i = caml_call2(Base_Import[91], pos, i), _b_ = caml_call2(Base_Import[91], i, 1), _c_ = caml_call2(Base_Random[19][7], random_state, _b_), random_i = caml_call2(Base_Import[91], pos, _c_);
                caml_call3(swap, t, this_i, random_i);
                var _d_ = i - 1 | 0;
                if (1 === i) break;
                i = _d_;
            }
        }
        return 0;
    }
    var Base_Array_permute = [
        0,
        invalid_argf,
        Array1,
        max_length,
        create,
        create_local,
        create_float_uninitialized,
        append,
        blit,
        concat,
        copy,
        fill,
        init,
        make_matrix,
        of_list,
        sub,
        to_list,
        fold,
        fold_right,
        iter,
        iteri,
        map,
        mapi,
        stable_sort,
        swap,
        permute
    ];
    runtime.caml_register_global(4, Base_Array_permute, "Base__Array_permute");
    return;
})(globalThis);
//# 8306 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Equal = "Equal", cst_Greater = "Greater", cst_Less = "Less", cst_equal = "equal", cst_greater = "greater", cst_less = "less", caml_int_compare = runtime.caml_int_compare;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), all = [
        0,
        0,
        [
            0,
            1,
            [
                0,
                2,
                0
            ]
        ]
    ], error_source_005 = "ordering.ml.t", t_sexp_grammar = [
        3,
        [
            0,
            2,
            [
                0,
                [
                    1,
                    [
                        0,
                        cst_Less,
                        0
                    ]
                ],
                [
                    0,
                    [
                        1,
                        [
                            0,
                            cst_Equal,
                            0
                        ]
                    ],
                    [
                        0,
                        [
                            1,
                            [
                                0,
                                cst_Greater,
                                0
                            ]
                        ],
                        0
                    ]
                ]
            ]
        ]
    ], Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, Base_Hash = global_data.Base__Hash, compare_local = caml_int_compare, _a_ = [
        0,
        cst_Less
    ], _b_ = [
        0,
        cst_Equal
    ], _c_ = [
        0,
        cst_Greater
    ];
    function compare(a, b) {
        return caml_int_compare(a, b);
    }
    function hash_fold_t(hsv, arg) {
        switch(arg){
            case 0:
                var _i_ = 0;
                break;
            case 1:
                var _i_ = 1;
                break;
            default:
                var _i_ = 2;
        }
        return caml_call2(Base_Hash[3], hsv, _i_);
    }
    function hash(arg) {
        var hsv = caml_call2(Base_Hash[11], 0, 0), _h_ = hash_fold_t(hsv, arg);
        return caml_call1(Base_Hash[9], _h_);
    }
    function t_of_sexp(sexp_006) {
        a: {
            if (0 === sexp_006[0]) {
                var _d_ = sexp_006[1];
                b: if (_d_ !== cst_Equal) {
                    c: if (_d_ !== cst_Greater) {
                        if (_d_ !== cst_Less) {
                            if (_d_ === cst_equal) break b;
                            if (_d_ === cst_greater) break c;
                            if (_d_ !== cst_less) break a;
                        }
                        return 0;
                    }
                    return 2;
                }
                return 1;
            }
            var _e_ = sexp_006[1];
            if (!_e_) return caml_call2(Sexplib0_Sexp_conv_error[11], error_source_005, sexp_006);
            var _f_ = _e_[1];
            if (0 !== _f_[0]) return caml_call2(Sexplib0_Sexp_conv_error[10], error_source_005, sexp_006);
            var _g_ = _f_[1];
            b: if (_g_ !== cst_Equal) {
                c: if (_g_ !== cst_Greater) {
                    if (_g_ !== cst_Less) {
                        if (_g_ === cst_equal) break b;
                        if (_g_ === cst_greater) break c;
                        if (_g_ !== cst_less) break a;
                    }
                    return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_005, sexp_006);
                }
                return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_005, sexp_006);
            }
            return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_005, sexp_006);
        }
        return caml_call2(Sexplib0_Sexp_conv_error[12], error_source_005, sexp_006);
    }
    function sexp_of_t(param) {
        switch(param){
            case 0:
                return _a_;
            case 1:
                return _b_;
            default:
                return _c_;
        }
    }
    function equal(a, b) {
        return 0 === caml_int_compare(a, b) ? 1 : 0;
    }
    function equal_local(a, b) {
        return 0 === caml_int_compare(a, b) ? 1 : 0;
    }
    var Export = [
        0
    ];
    function of_int(n) {
        return 0 <= n ? 0 === n ? 1 : 2 : 0;
    }
    function to_int(param) {
        switch(param){
            case 0:
                return -1;
            case 1:
                return 0;
            default:
                return 1;
        }
    }
    var Base_Ordering = [
        0,
        compare,
        compare_local,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        all,
        equal,
        equal_local,
        of_int,
        to_int,
        Export
    ];
    runtime.caml_register_global(20, Base_Ordering, "Base__Ordering");
    return;
})(globalThis);
//# 8445 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = " <> ", cst$0 = ": ", cst_List_map2$1 = "List.map2", cst_List_map3$1 = "List.map3", cst_List_range_stride_function$2 = "List.range': stride function cannot change direction", cst_length_mismatch_in = "length mismatch in ", cst_src_list_ml = "src/list.ml", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), error_source_036 = "list.ml.Assoc.t", Base_Import = global_data.Base__Import, Base_Container = global_data.Base__Container, Assert_failure = global_data.Assert_failure, Base_Random = global_data.Base__Random, Base_Array0 = global_data.Base__Array0, Base_Array_permute = global_data.Base__Array_permute, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, Base_Result = global_data.Base__Result, Base_Ordering = global_data.Base__Ordering, Base_List1 = global_data.Base__List1, Base_Printf = global_data.Base__Printf, Base_Applicative = global_data.Base__Applicative, Base_Monad = global_data.Base__Monad, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, hd_exn = Base_List1[1], rev_append = Base_List1[2], tl_exn = Base_List1[3], length = Base_List1[5], exists = Base_List1[6], exists2_ok = Base_List1[7], fold = Base_List1[8], fold2_ok = Base_List1[9], for_all = Base_List1[10], for_all2_ok = Base_List1[11], iter = Base_List1[12], iter2_ok = Base_List1[13], rev_map = Base_List1[17], rev_map2_ok = Base_List1[18], rev = Base_List1[19], fold_right = Base_List1[20], fold_right2_ok = Base_List1[21], is_empty = Base_List1[22], partition_map = Base_List1[23], invalid_argf = Base_Printf[7], globalize = Base_Import[293], t_of_sexp = Base_Import[173], sexp_of_t = Base_Import[149], _a_ = [
        0,
        "Ok"
    ], _b_ = [
        0,
        "Unequal_lengths"
    ], cst_List_range_stride_function = "List.range': stride function cannot return the same value", cst_List_range_stride_function$0 = cst_List_range_stride_function$2, cst_List_range_stride_function$1 = cst_List_range_stride_function$2, cst_List_range_stride_must_be_ = "List.range: stride must be non-zero", _c_ = [
        0,
        [
            11,
            "List.nth_exn ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " called on list of length ",
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "List.nth_exn %d called on list of length %d"
    ], _d_ = [
        0,
        [
            11,
            cst_length_mismatch_in,
            [
                2,
                0,
                [
                    11,
                    cst$0,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst,
                            [
                                4,
                                0,
                                0,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "length mismatch in %s: %d <> %d"
    ], _e_ = [
        0,
        [
            11,
            cst_length_mismatch_in,
            [
                2,
                0,
                [
                    11,
                    cst$0,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst,
                            [
                                4,
                                0,
                                0,
                                0,
                                [
                                    11,
                                    " || ",
                                    [
                                        4,
                                        0,
                                        0,
                                        0,
                                        [
                                            11,
                                            cst,
                                            [
                                                4,
                                                0,
                                                0,
                                                0,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "length mismatch in %s: %d <> %d || %d <> %d"
    ], cst_iter2_exn = "iter2_exn", cst_rev_map2_exn = "rev_map2_exn", cst_fold2_exn = "fold2_exn", cst_fold_right2_exn = "fold_right2_exn", cst_for_all2_exn = "for_all2_exn", cst_exists2_exn = "exists2_exn";
    function t_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Import[194], a_sexp_grammar);
    }
    function compare_local(cmp_a, a_014, b_015) {
        if (a_014 === b_015) return 0;
        if (!a_014) return b_015 ? 1 : 0;
        var a_016 = a_014[1];
        if (!b_015) return -1;
        var b_017 = b_015[1];
        return caml_call2(cmp_a, a_016, b_017);
    }
    function compare(cmp_a, a_010, b_011) {
        if (a_010 === b_011) return 0;
        if (!a_010) return b_011 ? 1 : 0;
        var a_012 = a_010[1];
        if (!b_011) return -1;
        var b_013 = b_011[1];
        return caml_call2(cmp_a, a_012, b_013);
    }
    function sexp_of_t$0(of_a_018, param) {
        if (!param) return _b_;
        var arg0_019 = param[1], res0_020 = caml_call1(of_a_018, arg0_019);
        return [
            1,
            [
                0,
                _a_,
                [
                    0,
                    res0_020,
                    0
                ]
            ]
        ];
    }
    function invariant(f, t) {
        return caml_call2(iter, t, f);
    }
    function of_list(t) {
        return t;
    }
    function singleton(x) {
        return [
            0,
            x,
            0
        ];
    }
    function range(compare, stride, _bw_, opt, start_i, stop_i) {
        var start = _bw_ ? _bw_[1] : 104758188, stop = opt ? opt[1] : -160346914, next_i = caml_call1(stride, start_i);
        function order(x, y) {
            var _bx_ = caml_call2(compare, x, y);
            return caml_call1(Base_Ordering[11], _bx_);
        }
        function raise_stride_cannot_return_sam(param) {
            return caml_call1(Base_Import[126], cst_List_range_stride_function);
        }
        switch(order(start_i, next_i)){
            case 0:
                var initial_stride_order = 847855481;
                break;
            case 1:
                var initial_stride_order = raise_stride_cannot_return_sam(0);
                break;
            default:
                var initial_stride_order = 85047514;
        }
        var start_i$0 = 104758188 <= start ? start_i : next_i, i_to_stop_order = order(start_i$0, stop_i);
        a: {
            switch(i_to_stop_order){
                case 0:
                    if (847855481 > initial_stride_order) break a;
                    break;
                case 1:
                    return 104758188 <= stop ? [
                        0,
                        start_i$0,
                        0
                    ] : 0;
                default:
                    if (847855481 <= initial_stride_order) break a;
            }
            var next_i$0 = caml_call1(stride, start_i$0);
            b: {
                switch(order(start_i$0, next_i$0)){
                    case 0:
                        if (847855481 > initial_stride_order) break b;
                        break;
                    case 1:
                        return raise_stride_cannot_return_sam(0);
                    default:
                        if (847855481 <= initial_stride_order) break b;
                }
                var block = [
                    0,
                    start_i$0,
                    24029
                ], dst = block, offset = 1, i = next_i$0;
                for(;;){
                    var i_to_stop_order$0 = order(i, stop_i);
                    c: {
                        d: {
                            switch(i_to_stop_order$0){
                                case 0:
                                    if (847855481 <= initial_stride_order) break d;
                                    break;
                                case 1:
                                    if (104758188 <= stop) {
                                        dst[1 + offset] = [
                                            0,
                                            i,
                                            0
                                        ];
                                        break c;
                                    }
                                    dst[1 + offset] = 0;
                                    break c;
                                default:
                                    if (847855481 > initial_stride_order) break d;
                            }
                            dst[1 + offset] = 0;
                            break c;
                        }
                        var next_i$1 = caml_call1(stride, i);
                        d: {
                            switch(order(i, next_i$1)){
                                case 0:
                                    if (847855481 <= initial_stride_order) break d;
                                    break;
                                case 1:
                                    dst[1 + offset] = raise_stride_cannot_return_sam(0);
                                    break c;
                                default:
                                    if (847855481 > initial_stride_order) break d;
                            }
                            dst[1 + offset] = caml_call1(Base_Import[126], cst_List_range_stride_function$1);
                            break c;
                        }
                        var dst$0 = [
                            0,
                            i,
                            24029
                        ];
                        dst[1 + offset] = dst$0;
                        dst = dst$0;
                        offset = 1;
                        i = next_i$1;
                        continue;
                    }
                    return block;
                }
            }
            return caml_call1(Base_Import[126], cst_List_range_stride_function$0);
        }
        return 0;
    }
    function range$0(_bv_, _bu_, opt, start_i, stop_i) {
        var stride = _bv_ ? _bv_[1] : 1, start = _bu_ ? _bu_[1] : 104758188, stop = opt ? opt[1] : -160346914;
        if (0 === stride) caml_call1(Base_Import[126], cst_List_range_stride_must_be_);
        return range(runtime.caml_int_compare, function(x) {
            return caml_call2(Base_Import[91], x, stride);
        }, [
            0,
            start
        ], [
            0,
            stop
        ], start_i, stop_i);
    }
    function hd(t) {
        if (!t) return 0;
        var x = t[1];
        return [
            0,
            x
        ];
    }
    function tl(t) {
        if (!t) return 0;
        var t$0 = t[2];
        return [
            0,
            t$0
        ];
    }
    function nth(t, n) {
        if (0 > n) return 0;
        var t$0 = t, n$0 = n;
        for(;;){
            if (!t$0) return 0;
            var t$1 = t$0[2], a = t$0[1];
            if (0 === n$0) return [
                0,
                a
            ];
            var n$1 = caml_call2(Base_Import[93], n$0, 1);
            t$0 = t$1;
            n$0 = n$1;
        }
    }
    function nth_exn(t, n) {
        var match = nth(t, n);
        if (!match) return caml_call4(invalid_argf, _c_, n, caml_call1(length, t), 0);
        var a = match[1];
        return a;
    }
    function unordered_append(l1, l2) {
        if (l1) {
            if (l2) return caml_call2(rev_append, l1, l2);
            var l = l1;
        } else var l = l2;
        return l;
    }
    function of_lists(l1, l2) {
        var a = l1, b = l2, shared_length = 0;
        for(;;){
            if (a) {
                if (b) {
                    var b$0 = b[2], a$0 = a[2], shared_length$0 = caml_call2(Base_Import[91], shared_length, 1);
                    a = a$0;
                    b = b$0;
                    shared_length = shared_length$0;
                    continue;
                }
            } else if (!b) return [
                0,
                shared_length
            ];
            return [
                1,
                shared_length,
                a,
                b
            ];
        }
    }
    function check_length2_exn(name, l1, l2) {
        var match = of_lists(l1, l2);
        if (0 === match[0]) return;
        var tail_of_b = match[3], tail_of_a = match[2], shared_length = match[1], _br_ = caml_call1(length, tail_of_b), _bs_ = caml_call2(Base_Import[91], shared_length, _br_), _bt_ = caml_call1(length, tail_of_a);
        return caml_call5(invalid_argf, _d_, name, caml_call2(Base_Import[91], shared_length, _bt_), _bs_, 0);
    }
    function check_length2(l1, l2, f) {
        return 0 === of_lists(l1, l2)[0] ? [
            0,
            caml_call2(f, l1, l2)
        ] : 0;
    }
    function of_lists$0(l1, l2, l3) {
        var a = l1, b = l2, c = l3, shared_length = 0;
        for(;;){
            if (a) {
                if (b && c) {
                    var c$0 = c[2], b$0 = b[2], a$0 = a[2], shared_length$0 = caml_call2(Base_Import[91], shared_length, 1);
                    a = a$0;
                    b = b$0;
                    c = c$0;
                    shared_length = shared_length$0;
                    continue;
                }
            } else if (!b && !c) return [
                0,
                shared_length
            ];
            return [
                1,
                shared_length,
                a,
                b,
                c
            ];
        }
    }
    function check_length3_exn(name, l1, l2, l3) {
        var match = of_lists$0(l1, l2, l3);
        if (0 === match[0]) return;
        var tail_of_c = match[4], tail_of_b = match[3], tail_of_a = match[2], shared_length = match[1], _bo_ = caml_call1(length, tail_of_a), n1 = caml_call2(Base_Import[91], shared_length, _bo_), _bp_ = caml_call1(length, tail_of_b), n2 = caml_call2(Base_Import[91], shared_length, _bp_), _bq_ = caml_call1(length, tail_of_c), n3 = caml_call2(Base_Import[91], shared_length, _bq_);
        return caml_call7(invalid_argf, _e_, name, n1, n2, n2, n3, 0);
    }
    function check_length3(l1, l2, l3, f) {
        return 0 === of_lists$0(l1, l2, l3)[0] ? [
            0,
            caml_call3(f, l1, l2, l3)
        ] : 0;
    }
    function iter2(l1, l2, f) {
        return check_length2(l1, l2, function(_bl_) {
            var _bm_ = caml_call1(iter2_ok, _bl_);
            return function(_bn_) {
                return caml_call2(_bm_, _bn_, f);
            };
        });
    }
    function iter2_exn(l1, l2, f) {
        check_length2_exn(cst_iter2_exn, l1, l2);
        return caml_call3(iter2_ok, l1, l2, f);
    }
    function rev_map2(l1, l2, f) {
        return check_length2(l1, l2, function(_bi_) {
            var _bj_ = caml_call1(rev_map2_ok, _bi_);
            return function(_bk_) {
                return caml_call2(_bj_, _bk_, f);
            };
        });
    }
    function rev_map2_exn(l1, l2, f) {
        check_length2_exn(cst_rev_map2_exn, l1, l2);
        return caml_call3(rev_map2_ok, l1, l2, f);
    }
    function fold2(l1, l2, init, f) {
        return check_length2(l1, l2, function(_bf_) {
            var _bg_ = caml_call1(fold2_ok, _bf_);
            return function(_bh_) {
                return caml_call3(_bg_, _bh_, init, f);
            };
        });
    }
    function fold2_exn(l1, l2, init, f) {
        check_length2_exn(cst_fold2_exn, l1, l2);
        return caml_call4(fold2_ok, l1, l2, init, f);
    }
    function fold_right2(l1, l2, f, init) {
        return check_length2(l1, l2, function(_bc_) {
            var _bd_ = caml_call1(fold_right2_ok, _bc_);
            return function(_be_) {
                return caml_call3(_bd_, _be_, f, init);
            };
        });
    }
    function fold_right2_exn(l1, l2, f, init) {
        check_length2_exn(cst_fold_right2_exn, l1, l2);
        return caml_call4(fold_right2_ok, l1, l2, f, init);
    }
    function for_all2(l1, l2, f) {
        return check_length2(l1, l2, function(_a$_) {
            var _ba_ = caml_call1(for_all2_ok, _a$_);
            return function(_bb_) {
                return caml_call2(_ba_, _bb_, f);
            };
        });
    }
    function for_all2_exn(l1, l2, f) {
        check_length2_exn(cst_for_all2_exn, l1, l2);
        return caml_call3(for_all2_ok, l1, l2, f);
    }
    function exists2(l1, l2, f) {
        return check_length2(l1, l2, function(_a8_) {
            var _a9_ = caml_call1(exists2_ok, _a8_);
            return function(_a__) {
                return caml_call2(_a9_, _a__, f);
            };
        });
    }
    function exists2_exn(l1, l2, f) {
        check_length2_exn(cst_exists2_exn, l1, l2);
        return caml_call3(exists2_ok, l1, l2, f);
    }
    function mem(t, a, equal) {
        var param = t;
        for(;;){
            if (!param) return 0;
            var bs = param[2], b = param[1], _a7_ = caml_call2(equal, a, b);
            if (_a7_) return _a7_;
            param = bs;
        }
    }
    function rev_filter(t, f) {
        var accu = 0, param = t;
        for(;;){
            if (!param) return accu;
            var l = param[2], x = param[1];
            if (caml_call1(f, x)) {
                var accu$0 = [
                    0,
                    x,
                    accu
                ];
                accu = accu$0;
                param = l;
            } else param = l;
        }
    }
    function filter(l, f) {
        var l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1];
            if (caml_call1(f, hd)) {
                var block = [
                    0,
                    hd,
                    24029
                ], dst = block, offset = 1, l$1 = tl;
                for(;;){
                    if (!l$1) {
                        dst[1 + offset] = 0;
                        return block;
                    }
                    var tl$0 = l$1[2], hd$0 = l$1[1];
                    if (caml_call1(f, hd$0)) {
                        var dst$0 = [
                            0,
                            hd$0,
                            24029
                        ];
                        dst[1 + offset] = dst$0;
                        dst = dst$0;
                        offset = 1;
                        l$1 = tl$0;
                    } else l$1 = tl$0;
                }
            } else l$0 = tl;
        }
    }
    function find_map(t, f) {
        var param = t;
        for(;;){
            if (!param) return 0;
            var l = param[2], x = param[1], r = caml_call1(f, x);
            if (r) return r;
            param = l;
        }
    }
    var not_found = [
        0,
        Base_Import[297],
        [
            0,
            "List.find_map_exn: not found"
        ]
    ];
    function find_map_exn(t, f) {
        var match = find_map(t, f);
        if (!match) throw caml_maybe_attach_backtrace(not_found, 1);
        var x = match[1];
        return x;
    }
    function find(t, f) {
        var param = t;
        for(;;){
            if (!param) return 0;
            var l = param[2], x = param[1];
            if (caml_call1(f, x)) return [
                0,
                x
            ];
            param = l;
        }
    }
    var not_found$0 = [
        0,
        Base_Import[297],
        [
            0,
            "List.find_exn: not found"
        ]
    ];
    function find_exn(t, f) {
        var t$0 = t;
        for(;;){
            if (!t$0) throw caml_maybe_attach_backtrace(not_found$0, 1);
            var t$1 = t$0[2], x = t$0[1];
            if (caml_call1(f, x)) return x;
            t$0 = t$1;
        }
    }
    function findi(t, f) {
        var i = 0, t$0 = t;
        for(;;){
            if (!t$0) return 0;
            var l = t$0[2], x = t$0[1];
            if (caml_call2(f, i, x)) return [
                0,
                [
                    0,
                    i,
                    x
                ]
            ];
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            t$0 = l;
        }
    }
    var not_found$1 = [
        0,
        Base_Import[297],
        [
            0,
            "List.findi_exn: not found"
        ]
    ];
    function findi_exn(t, f) {
        var match = findi(t, f);
        if (!match) throw caml_maybe_attach_backtrace(not_found$1, 1);
        var x = match[1];
        return x;
    }
    function find_mapi(t, f) {
        var i = 0, t$0 = t;
        for(;;){
            if (!t$0) return 0;
            var l = t$0[2], x = t$0[1], result = caml_call2(f, i, x);
            if (result) return result;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            t$0 = l;
        }
    }
    var not_found$2 = [
        0,
        Base_Import[297],
        [
            0,
            "List.find_mapi_exn: not found"
        ]
    ];
    function find_mapi_exn(t, f) {
        var match = find_mapi(t, f);
        if (!match) throw caml_maybe_attach_backtrace(not_found$2, 1);
        var x = match[1];
        return x;
    }
    function for_alli(t, f) {
        var i = 0, t$0 = t;
        for(;;){
            if (!t$0) return 1;
            var tl = t$0[2], hd = t$0[1], _a6_ = caml_call2(f, i, hd);
            if (!_a6_) return _a6_;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            t$0 = tl;
        }
    }
    function existsi(t, f) {
        var i = 0, t$0 = t;
        for(;;){
            if (!t$0) return 0;
            var tl = t$0[2], hd = t$0[1], _a5_ = caml_call2(f, i, hd);
            if (_a5_) return _a5_;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            t$0 = tl;
        }
    }
    var of_array = Base_Array0[16], to_array = Base_Array0[14], cst_List_map2 = cst_List_map2$1, cst_List_map2$0 = cst_List_map2$1, cst_map2_exn = "map2_exn", _f_ = [
        0,
        cst_src_list_ml,
        476,
        11
    ], cst_rev_map3_exn = "rev_map3_exn", cst_List_map3 = cst_List_map3$1, cst_List_map3$0 = cst_List_map3$1, cst_map3_exn = "map3_exn", _g_ = [
        0,
        [
            11,
            "length mismatch in zip_exn: ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    cst,
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "length mismatch in zip_exn: %d <> %d"
    ], cst_List_reduce_exn = "List.reduce_exn", _h_ = [
        0,
        cst_src_list_ml,
        626,
        14
    ], cst_List_reduce_balanced_exn = "List.reduce_balanced_exn";
    function to_list(t) {
        return t;
    }
    function append(l1$0, l2) {
        if (!l2) return l1$0;
        if (!l1$0) return l2;
        var _aZ_ = l1$0[2], x1 = l1$0[1];
        if (!_aZ_) return [
            0,
            x1,
            l2
        ];
        var _a0_ = _aZ_[2], x2 = _aZ_[1];
        if (!_a0_) return [
            0,
            x1,
            [
                0,
                x2,
                l2
            ]
        ];
        var _a1_ = _a0_[2], x3 = _a0_[1];
        if (!_a1_) return [
            0,
            x1,
            [
                0,
                x2,
                [
                    0,
                    x3,
                    l2
                ]
            ]
        ];
        var match = _a1_[2], x4 = _a1_[1];
        if (!match) return [
            0,
            x1,
            [
                0,
                x2,
                [
                    0,
                    x3,
                    [
                        0,
                        x4,
                        l2
                    ]
                ]
            ]
        ];
        var tl = match[2], x5 = match[1], block = [
            0,
            x5,
            24029
        ], dst = block, offset = 1, l1 = tl;
        for(;;){
            if (l1) {
                var _a2_ = l1[2], x1$0 = l1[1];
                if (_a2_) {
                    var _a3_ = _a2_[2], x2$0 = _a2_[1];
                    if (_a3_) {
                        var _a4_ = _a3_[2], x3$0 = _a3_[1];
                        if (_a4_) {
                            var match$0 = _a4_[2], x4$0 = _a4_[1];
                            if (match$0) {
                                var tl$0 = match$0[2], x5$0 = match$0[1], dst$0 = [
                                    0,
                                    x5$0,
                                    24029
                                ];
                                dst[1 + offset] = [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x2$0,
                                        [
                                            0,
                                            x3$0,
                                            [
                                                0,
                                                x4$0,
                                                dst$0
                                            ]
                                        ]
                                    ]
                                ];
                                dst = dst$0;
                                offset = 1;
                                l1 = tl$0;
                                continue;
                            }
                            dst[1 + offset] = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3$0,
                                        [
                                            0,
                                            x4$0,
                                            l2
                                        ]
                                    ]
                                ]
                            ];
                        } else dst[1 + offset] = [
                            0,
                            x1$0,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3$0,
                                    l2
                                ]
                            ]
                        ];
                    } else dst[1 + offset] = [
                        0,
                        x1$0,
                        [
                            0,
                            x2$0,
                            l2
                        ]
                    ];
                } else dst[1 + offset] = [
                    0,
                    x1$0,
                    l2
                ];
            } else dst[1 + offset] = l2;
            return [
                0,
                x1,
                [
                    0,
                    x2,
                    [
                        0,
                        x3,
                        [
                            0,
                            x4,
                            block
                        ]
                    ]
                ]
            ];
        }
    }
    function map(l, f) {
        if (!l) return 0;
        var tl = l[2], x = l[1], block = [
            0,
            caml_call1(f, x),
            24029
        ], dst = block, offset = 1, l$0 = tl;
        for(;;){
            if (!l$0) {
                dst[1 + offset] = 0;
                return block;
            }
            var tl$0 = l$0[2], x$0 = l$0[1], dst$0 = [
                0,
                caml_call1(f, x$0),
                24029
            ];
            dst[1 + offset] = dst$0;
            dst = dst$0;
            offset = 1;
            l$0 = tl$0;
        }
    }
    function folding_map(t, init, f) {
        var acc = [
            0,
            init
        ];
        return map(t, function(x) {
            var match = caml_call2(f, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
    }
    function fold_map(t, init, f) {
        var acc = [
            0,
            init
        ], result = map(t, function(x) {
            var match = caml_call2(f, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
        return [
            0,
            acc[1],
            result
        ];
    }
    function symbol_map(l, f) {
        return map(l, f);
    }
    function map2_ok(l1, l2, f) {
        if (l1) {
            if (l2) {
                var l2$0 = l2[2], x2 = l2[1], l1$0 = l1[2], x1 = l1[1], block = [
                    0,
                    caml_call2(f, x1, x2),
                    24029
                ], dst = block, offset = 1, l1$1 = l1$0, l2$1 = l2$0;
                for(;;){
                    a: {
                        if (l1$1) {
                            if (l2$1) {
                                var l2$2 = l2$1[2], x2$0 = l2$1[1], l1$2 = l1$1[2], x1$0 = l1$1[1], dst$0 = [
                                    0,
                                    caml_call2(f, x1$0, x2$0),
                                    24029
                                ];
                                dst[1 + offset] = dst$0;
                                dst = dst$0;
                                offset = 1;
                                l1$1 = l1$2;
                                l2$1 = l2$2;
                                continue;
                            }
                        } else if (!l2$1) {
                            dst[1 + offset] = 0;
                            break a;
                        }
                        dst[1 + offset] = caml_call1(Base_Import[126], cst_List_map2$0);
                    }
                    return block;
                }
            }
        } else if (!l2) return 0;
        return caml_call1(Base_Import[126], cst_List_map2);
    }
    function map2(l1, l2, f) {
        return check_length2(l1, l2, function(_aX_) {
            return function(_aY_) {
                return map2_ok(_aX_, _aY_, f);
            };
        });
    }
    function map2_exn(l1, l2, f) {
        check_length2_exn(cst_map2_exn, l1, l2);
        return map2_ok(l1, l2, f);
    }
    function rev_map3_ok(l1, l2, l3, f) {
        var l1$0 = l1, l2$0 = l2, l3$0 = l3, ac = 0;
        for(;;){
            if (l1$0) {
                if (l2$0 && l3$0) {
                    var l3$1 = l3$0[2], x3 = l3$0[1], l2$1 = l2$0[2], x2 = l2$0[1], l1$1 = l1$0[2], x1 = l1$0[1], ac$0 = [
                        0,
                        caml_call3(f, x1, x2, x3),
                        ac
                    ];
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    l3$0 = l3$1;
                    ac = ac$0;
                    continue;
                }
            } else if (!l2$0 && !l3$0) return ac;
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _f_
            ], 1);
        }
    }
    function rev_map3(l1, l2, l3, f) {
        return check_length3(l1, l2, l3, function(_aU_) {
            return function(_aV_) {
                return function(_aW_) {
                    return rev_map3_ok(_aU_, _aV_, _aW_, f);
                };
            };
        });
    }
    function rev_map3_exn(l1, l2, l3, f) {
        check_length3_exn(cst_rev_map3_exn, l1, l2, l3);
        return rev_map3_ok(l1, l2, l3, f);
    }
    function map3_ok(l1, l2, l3, f) {
        if (l1) {
            if (l2 && l3) {
                var l3$0 = l3[2], x3 = l3[1], l2$0 = l2[2], x2 = l2[1], l1$0 = l1[2], x1 = l1[1], block = [
                    0,
                    caml_call3(f, x1, x2, x3),
                    24029
                ], dst = block, offset = 1, l1$1 = l1$0, l2$1 = l2$0, l3$1 = l3$0;
                for(;;){
                    a: {
                        if (l1$1) {
                            if (l2$1 && l3$1) {
                                var l3$2 = l3$1[2], x3$0 = l3$1[1], l2$2 = l2$1[2], x2$0 = l2$1[1], l1$2 = l1$1[2], x1$0 = l1$1[1], dst$0 = [
                                    0,
                                    caml_call3(f, x1$0, x2$0, x3$0),
                                    24029
                                ];
                                dst[1 + offset] = dst$0;
                                dst = dst$0;
                                offset = 1;
                                l1$1 = l1$2;
                                l2$1 = l2$2;
                                l3$1 = l3$2;
                                continue;
                            }
                        } else if (!l2$1 && !l3$1) {
                            dst[1 + offset] = 0;
                            break a;
                        }
                        dst[1 + offset] = caml_call1(Base_Import[126], cst_List_map3$0);
                    }
                    return block;
                }
            }
        } else if (!l2 && !l3) return 0;
        return caml_call1(Base_Import[126], cst_List_map3);
    }
    function map3(l1, l2, l3, f) {
        return check_length3(l1, l2, l3, function(_aR_) {
            return function(_aS_) {
                return function(_aT_) {
                    return map3_ok(_aR_, _aS_, _aT_, f);
                };
            };
        });
    }
    function map3_exn(l1, l2, l3, f) {
        check_length3_exn(cst_map3_exn, l1, l2, l3);
        return map3_ok(l1, l2, l3, f);
    }
    function rev_map_append(l1, l2, f) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (!l1$0) return l2$0;
            var l1$1 = l1$0[2], h = l1$0[1], l2$1 = [
                0,
                caml_call1(f, h),
                l2$0
            ];
            l1$0 = l1$1;
            l2$0 = l2$1;
        }
    }
    function unzip(list) {
        var list$2 = caml_call1(rev, list), list$0 = list$2, l1 = 0, l2 = 0;
        for(;;){
            if (!list$0) return [
                0,
                l1,
                l2
            ];
            var list$1 = list$0[2], match = list$0[1], y = match[2], x = match[1], l2$0 = [
                0,
                y,
                l2
            ], l1$0 = [
                0,
                x,
                l1
            ];
            list$0 = list$1;
            l1 = l1$0;
            l2 = l2$0;
        }
    }
    function unzip3(list) {
        var list$2 = caml_call1(rev, list), list$0 = list$2, l1 = 0, l2 = 0, l3 = 0;
        for(;;){
            if (!list$0) return [
                0,
                l1,
                l2,
                l3
            ];
            var list$1 = list$0[2], match = list$0[1], z = match[3], y = match[2], x = match[1], l3$0 = [
                0,
                z,
                l3
            ], l2$0 = [
                0,
                y,
                l2
            ], l1$0 = [
                0,
                x,
                l1
            ];
            list$0 = list$1;
            l1 = l1$0;
            l2 = l2$0;
            l3 = l3$0;
        }
    }
    function zip_exn(l1, l2) {
        try {
            var _aP_ = map2_ok(l1, l2, function(a, b) {
                return [
                    0,
                    a,
                    b
                ];
            });
            return _aP_;
        } catch (_aQ_) {
            var _aO_ = caml_call1(length, l2);
            return caml_call4(invalid_argf, _g_, caml_call1(length, l1), _aO_, 0);
        }
    }
    function zip(l1, l2) {
        return map2(l1, l2, function(a, b) {
            return [
                0,
                a,
                b
            ];
        });
    }
    function rev_mapi(l, f) {
        var i = 0, acc = 0, param = l;
        for(;;){
            if (!param) return acc;
            var t = param[2], h = param[1], acc$0 = [
                0,
                caml_call2(f, i, h),
                acc
            ], i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            acc = acc$0;
            param = t;
        }
    }
    function mapi(l, f) {
        var i$2 = 0;
        if (!l) return 0;
        var t = l[2], h = l[1], block = [
            0,
            caml_call2(f, i$2, h),
            24029
        ], i = caml_call2(Base_Import[91], i$2, 1), dst = block, offset = 1, i$0 = i, param = t;
        for(;;){
            if (!param) {
                dst[1 + offset] = 0;
                return block;
            }
            var t$0 = param[2], h$0 = param[1], block0_arg0 = caml_call2(f, i$0, h$0), block$0 = [
                0,
                block0_arg0,
                24029
            ];
            dst[1 + offset] = block$0;
            var i$1 = caml_call2(Base_Import[91], i$0, 1);
            dst = block$0;
            offset = 1;
            i$0 = i$1;
            param = t$0;
        }
    }
    function folding_mapi(t, init, f) {
        var acc = [
            0,
            init
        ];
        return mapi(t, function(i, x) {
            var match = caml_call3(f, i, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
    }
    function fold_mapi(t, init, f) {
        var acc = [
            0,
            init
        ], result = mapi(t, function(i, x) {
            var match = caml_call3(f, i, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
        return [
            0,
            acc[1],
            result
        ];
    }
    function iteri(l, f) {
        caml_call3(fold, l, 0, function(i, x) {
            caml_call2(f, i, x);
            return caml_call2(Base_Import[91], i, 1);
        });
        return 0;
    }
    function foldi(t, init, f) {
        var _aM_ = caml_call3(fold, t, [
            0,
            0,
            init
        ], function(param, v) {
            var acc = param[2], i = param[1], _aN_ = caml_call3(f, i, acc, v);
            return [
                0,
                caml_call2(Base_Import[91], i, 1),
                _aN_
            ];
        });
        return caml_call1(Base_Import[127], _aM_);
    }
    function filteri(l, f) {
        var pos = 0, l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1];
            if (caml_call2(f, pos, hd)) break;
            var pos$1 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$1;
            l$0 = tl;
        }
        var block = [
            0,
            hd,
            24029
        ], pos$0 = caml_call2(Base_Import[91], pos, 1), dst = block, offset = 1, pos$2 = pos$0, l$1 = tl;
        for(;;){
            if (!l$1) {
                dst[1 + offset] = 0;
                return block;
            }
            var tl$0 = l$1[2], hd$0 = l$1[1];
            if (caml_call2(f, pos$2, hd$0)) {
                var block$0 = [
                    0,
                    hd$0,
                    24029
                ];
                dst[1 + offset] = block$0;
                var pos$3 = caml_call2(Base_Import[91], pos$2, 1);
                dst = block$0;
                offset = 1;
                pos$2 = pos$3;
                l$1 = tl$0;
            } else {
                var pos$4 = caml_call2(Base_Import[91], pos$2, 1);
                pos$2 = pos$4;
                l$1 = tl$0;
            }
        }
    }
    function reduce(l, f) {
        if (!l) return 0;
        var tl = l[2], hd = l[1];
        return [
            0,
            caml_call3(fold, tl, hd, f)
        ];
    }
    function reduce_exn(l, f) {
        var match = reduce(l, f);
        if (!match) return caml_call1(Base_Import[126], cst_List_reduce_exn);
        var v = match[1];
        return v;
    }
    function reduce_balanced(l, f) {
        function step_accum(num, acc, x) {
            var num$0 = num, acc$0 = acc, x$0 = x;
            for(;;){
                if (0 === caml_call2(Base_Import[116], num$0, 1)) return [
                    0,
                    x$0,
                    acc$0
                ];
                if (!acc$0) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _h_
                ], 1);
                var acc$1 = acc$0[2], y = acc$0[1], x$1 = caml_call2(f, y, x$0), num$1 = caml_call2(Base_Import[115], num$0, 1);
                num$0 = num$1;
                acc$0 = acc$1;
                x$0 = x$1;
            }
        }
        var match = foldi(l, 0, step_accum);
        if (!match) return 0;
        var xs = match[2], x = match[1];
        return [
            0,
            caml_call3(fold, xs, x, function(x, y) {
                return caml_call2(f, y, x);
            })
        ];
    }
    function reduce_balanced_exn(l, f) {
        var match = reduce_balanced(l, f);
        if (!match) return caml_call1(Base_Import[126], cst_List_reduce_balanced_exn);
        var v = match[1];
        return v;
    }
    function groupi(l, break$0) {
        var pos = [
            0,
            0
        ], l$0 = [
            0,
            l
        ];
        function take_group(param) {
            var group = l$0[1];
            if (group) {
                var tl = group[2];
                if (tl) {
                    var y = tl[1], x = group[1];
                    pos[1] = caml_call2(Base_Import[91], pos[1], 1);
                    l$0[1] = tl;
                    if (caml_call3(break$0, pos[1], x, y)) return [
                        0,
                        x,
                        0
                    ];
                    var block = [
                        0,
                        x,
                        24029
                    ], dst = block, offset = 1;
                    for(;;){
                        var group$0 = l$0[1];
                        a: {
                            if (group$0) {
                                var tl$0 = group$0[2];
                                if (tl$0) {
                                    var y$0 = tl$0[1], x$0 = group$0[1];
                                    pos[1] = caml_call2(Base_Import[91], pos[1], 1);
                                    l$0[1] = tl$0;
                                    if (caml_call3(break$0, pos[1], x$0, y$0)) {
                                        dst[1 + offset] = [
                                            0,
                                            x$0,
                                            0
                                        ];
                                        break a;
                                    }
                                    var dst$0 = [
                                        0,
                                        x$0,
                                        24029
                                    ];
                                    dst[1 + offset] = dst$0;
                                    dst = dst$0;
                                    offset = 1;
                                    continue;
                                }
                            }
                            l$0[1] = 0;
                            dst[1 + offset] = group$0;
                        }
                        return block;
                    }
                }
            }
            l$0[1] = 0;
            return group;
        }
        if (caml_call1(is_empty, l$0[1])) return 0;
        var group = take_group(0), block = [
            0,
            group,
            24029
        ], dst = block, offset = 1;
        for(;;){
            if (caml_call1(is_empty, l$0[1])) {
                dst[1 + offset] = 0;
                return block;
            }
            var group$0 = take_group(0), dst$0 = [
                0,
                group$0,
                24029
            ];
            dst[1 + offset] = dst$0;
            dst = dst$0;
            offset = 1;
        }
    }
    function group(l, break$0) {
        return groupi(l, function(param, x, y) {
            return caml_call2(break$0, x, y);
        });
    }
    function merge(l1, l2, compare) {
        if (!l1) return l2;
        if (!l2) return l1;
        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
        if (0 < caml_call2(compare, h1, h2)) {
            var block = [
                0,
                h2,
                24029
            ];
            merge_dps(block, 1, l1, t2, compare);
            return block;
        }
        var block$0 = [
            0,
            h1,
            24029
        ];
        merge_dps(block$0, 1, t1, l2, compare);
        return block$0;
    }
    function merge_dps(dst, offset, l1, l2, compare) {
        var dst$0 = dst, offset$0 = offset, l1$0 = l1, l2$0 = l2;
        for(;;){
            if (!l1$0) {
                dst$0[1 + offset$0] = l2$0;
                return;
            }
            if (!l2$0) {
                dst$0[1 + offset$0] = l1$0;
                return;
            }
            var t2 = l2$0[2], h2 = l2$0[1], t1 = l1$0[2], h1 = l1$0[1];
            if (0 < caml_call2(compare, h1, h2)) {
                var dst$1 = [
                    0,
                    h2,
                    24029
                ];
                dst$0[1 + offset$0] = dst$1;
                dst$0 = dst$1;
                offset$0 = 1;
                l2$0 = t2;
            } else {
                var dst$2 = [
                    0,
                    h1,
                    24029
                ];
                dst$0[1 + offset$0] = dst$2;
                dst$0 = dst$2;
                offset$0 = 1;
                l1$0 = t1;
            }
        }
    }
    function stable_sort(l, cmp) {
        function sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], s = 0 < caml_call2(cmp, x1, x2) ? [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ] : [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _aL_ = l[2];
                if (_aL_) {
                    var match$2 = _aL_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _aL_[1], x1$0 = l[1], s$0 = 0 < caml_call2(cmp, x1$0, x2$0) ? 0 < caml_call2(cmp, x1$0, x3) ? 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x2$0,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x2$0, x3) ? 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x3,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x1$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x1$0,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ];
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = caml_call2(Base_Import[115], n, 1), n2 = caml_call2(Base_Import[93], n, n1), match$0 = rev_sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = rev_sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
                        if (0 < caml_call2(cmp, h1, h2)) {
                            var accu$0 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            accu = accu$0;
                            continue;
                        }
                        var accu$1 = [
                            0,
                            h2,
                            accu
                        ];
                        l2 = t2;
                        accu = accu$1;
                        continue;
                    }
                    var _aK_ = caml_call2(rev_append, l1, accu);
                } else var _aK_ = caml_call2(rev_append, l2, accu);
                return [
                    0,
                    _aK_,
                    tl$0
                ];
            }
        }
        function rev_sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], s = 0 < caml_call2(cmp, x1, x2) ? [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ] : [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _aJ_ = l[2];
                if (_aJ_) {
                    var match$2 = _aJ_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _aJ_[1], x1$0 = l[1], s$0 = 0 < caml_call2(cmp, x1$0, x2$0) ? 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x1$0,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x1$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x3,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x2$0,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ];
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = caml_call2(Base_Import[115], n, 1), n2 = caml_call2(Base_Import[93], n, n1), match$0 = sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
                        if (0 < caml_call2(cmp, h1, h2)) {
                            var accu$0 = [
                                0,
                                h2,
                                accu
                            ];
                            l2 = t2;
                            accu = accu$0;
                            continue;
                        }
                        var accu$1 = [
                            0,
                            h1,
                            accu
                        ];
                        l1 = t1;
                        accu = accu$1;
                        continue;
                    }
                    var _aI_ = caml_call2(rev_append, l1, accu);
                } else var _aI_ = caml_call2(rev_append, l2, accu);
                return [
                    0,
                    _aI_,
                    tl$0
                ];
            }
        }
        var len = caml_call1(length, l);
        if (2 > len) return l;
        var _aH_ = sort(len, l);
        return caml_call1(Base_Import[125], _aH_);
    }
    function sort_and_group(l, compare) {
        return group(stable_sort(l, compare), function(x, y) {
            return 0 !== caml_call2(compare, x, y) ? 1 : 0;
        });
    }
    function dedup_and_sort(l, cmp) {
        function sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], c$0 = caml_call2(cmp, x1, x2);
                        if (0 <= c$0) var _at_ = 0 < c$0 ? [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ] : [
                            0,
                            x2,
                            0
                        ], s = _at_;
                        else var s = [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _av_ = l[2];
                if (_av_) {
                    var match$2 = _av_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _av_[1], x1$0 = l[1], c$1 = caml_call2(cmp, x1$0, x2$0);
                        if (0 <= c$1) {
                            if (0 < c$1) {
                                var c$2 = caml_call2(cmp, x1$0, x3);
                                if (0 <= c$2) {
                                    if (0 < c$2) {
                                        var c$3 = caml_call2(cmp, x2$0, x3);
                                        if (0 <= c$3) var _aw_ = 0 < c$3 ? [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x2$0,
                                                [
                                                    0,
                                                    x1$0,
                                                    0
                                                ]
                                            ]
                                        ] : [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x1$0,
                                                0
                                            ]
                                        ], _ax_ = _aw_;
                                        else var _ax_ = [
                                            0,
                                            x2$0,
                                            [
                                                0,
                                                x3,
                                                [
                                                    0,
                                                    x1$0,
                                                    0
                                                ]
                                            ]
                                        ];
                                        var _ay_ = _ax_;
                                    } else var _ay_ = [
                                        0,
                                        x2$0,
                                        [
                                            0,
                                            x3,
                                            0
                                        ]
                                    ];
                                    var _az_ = _ay_;
                                } else var _az_ = [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x1$0,
                                        [
                                            0,
                                            x3,
                                            0
                                        ]
                                    ]
                                ];
                                var _aA_ = _az_;
                            } else {
                                var c$4 = caml_call2(cmp, x2$0, x3);
                                if (0 <= c$4) var _aB_ = 0 < c$4 ? [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ] : [
                                    0,
                                    x3,
                                    0
                                ], _aC_ = _aB_;
                                else var _aC_ = [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ];
                                var _aA_ = _aC_;
                            }
                            var s$0 = _aA_;
                        } else {
                            var c$5 = caml_call2(cmp, x2$0, x3);
                            if (0 <= c$5) {
                                if (0 < c$5) {
                                    var c$6 = caml_call2(cmp, x1$0, x3);
                                    if (0 <= c$6) var _aD_ = 0 < c$6 ? [
                                        0,
                                        x3,
                                        [
                                            0,
                                            x1$0,
                                            [
                                                0,
                                                x2$0,
                                                0
                                            ]
                                        ]
                                    ] : [
                                        0,
                                        x3,
                                        [
                                            0,
                                            x2$0,
                                            0
                                        ]
                                    ], _aE_ = _aD_;
                                    else var _aE_ = [
                                        0,
                                        x1$0,
                                        [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x2$0,
                                                0
                                            ]
                                        ]
                                    ];
                                    var _aF_ = _aE_;
                                } else var _aF_ = [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ];
                                var _aG_ = _aF_;
                            } else var _aG_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            var s$0 = _aG_;
                        }
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = caml_call2(Base_Import[115], n, 1), n2 = caml_call2(Base_Import[93], n, n1), match$0 = rev_sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = rev_sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1], c = caml_call2(cmp, h1, h2);
                        if (0 < c) {
                            var accu$0 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            accu = accu$0;
                            continue;
                        }
                        if (0 <= c) {
                            l1 = t1;
                            continue;
                        }
                        var accu$1 = [
                            0,
                            h2,
                            accu
                        ];
                        l2 = t2;
                        accu = accu$1;
                        continue;
                    }
                    var _au_ = caml_call2(rev_append, l1, accu);
                } else var _au_ = caml_call2(rev_append, l2, accu);
                return [
                    0,
                    _au_,
                    tl$0
                ];
            }
        }
        function rev_sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], c$0 = caml_call2(cmp, x1, x2);
                        if (0 < c$0) var s = [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ];
                        else var _af_ = 0 <= c$0 ? [
                            0,
                            x2,
                            0
                        ] : [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ], s = _af_;
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _ah_ = l[2];
                if (_ah_) {
                    var match$2 = _ah_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _ah_[1], x1$0 = l[1], c$1 = caml_call2(cmp, x1$0, x2$0);
                        if (0 < c$1) {
                            var c$2 = caml_call2(cmp, x2$0, x3);
                            if (0 < c$2) var _ai_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            else {
                                if (0 <= c$2) var _aj_ = [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ];
                                else {
                                    var c$3 = caml_call2(cmp, x1$0, x3);
                                    if (0 < c$3) var _ak_ = [
                                        0,
                                        x1$0,
                                        [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x2$0,
                                                0
                                            ]
                                        ]
                                    ];
                                    else var _al_ = 0 <= c$3 ? [
                                        0,
                                        x3,
                                        [
                                            0,
                                            x2$0,
                                            0
                                        ]
                                    ] : [
                                        0,
                                        x3,
                                        [
                                            0,
                                            x1$0,
                                            [
                                                0,
                                                x2$0,
                                                0
                                            ]
                                        ]
                                    ], _ak_ = _al_;
                                    var _aj_ = _ak_;
                                }
                                var _ai_ = _aj_;
                            }
                            var s$0 = _ai_;
                        } else {
                            if (0 <= c$1) {
                                var c$4 = caml_call2(cmp, x2$0, x3);
                                if (0 < c$4) var _am_ = [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ];
                                else var _ao_ = 0 <= c$4 ? [
                                    0,
                                    x3,
                                    0
                                ] : [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ], _am_ = _ao_;
                                var _an_ = _am_;
                            } else {
                                var c$5 = caml_call2(cmp, x1$0, x3);
                                if (0 < c$5) var _ap_ = [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x1$0,
                                        [
                                            0,
                                            x3,
                                            0
                                        ]
                                    ]
                                ];
                                else {
                                    if (0 <= c$5) var _aq_ = [
                                        0,
                                        x2$0,
                                        [
                                            0,
                                            x3,
                                            0
                                        ]
                                    ];
                                    else {
                                        var c$6 = caml_call2(cmp, x2$0, x3);
                                        if (0 < c$6) var _ar_ = [
                                            0,
                                            x2$0,
                                            [
                                                0,
                                                x3,
                                                [
                                                    0,
                                                    x1$0,
                                                    0
                                                ]
                                            ]
                                        ];
                                        else var _as_ = 0 <= c$6 ? [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x1$0,
                                                0
                                            ]
                                        ] : [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x2$0,
                                                [
                                                    0,
                                                    x1$0,
                                                    0
                                                ]
                                            ]
                                        ], _ar_ = _as_;
                                        var _aq_ = _ar_;
                                    }
                                    var _ap_ = _aq_;
                                }
                                var _an_ = _ap_;
                            }
                            var s$0 = _an_;
                        }
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = caml_call2(Base_Import[115], n, 1), n2 = caml_call2(Base_Import[93], n, n1), match$0 = sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1], c = caml_call2(cmp, h1, h2);
                        if (0 > c) {
                            var accu$1 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            accu = accu$1;
                            continue;
                        }
                        if (0 < c) {
                            var accu$0 = [
                                0,
                                h2,
                                accu
                            ];
                            l2 = t2;
                            accu = accu$0;
                            continue;
                        }
                        l1 = t1;
                        continue;
                    }
                    var _ag_ = caml_call2(rev_append, l1, accu);
                } else var _ag_ = caml_call2(rev_append, l2, accu);
                return [
                    0,
                    _ag_,
                    tl$0
                ];
            }
        }
        var len = caml_call1(length, l);
        if (2 > len) return l;
        var _ae_ = sort(len, l);
        return caml_call1(Base_Import[125], _ae_);
    }
    function stable_dedup(list, compare) {
        if (list && list[2]) {
            var dedups = caml_call2(rev_map, list, function(elt) {
                return [
                    0,
                    elt,
                    1
                ];
            }), unique = dedup_and_sort(dedups, function(x, y) {
                return caml_call2(compare, x[1], y[1]);
            });
            caml_call2(iter, unique, function(dedup) {
                dedup[2] = 0;
                return 0;
            });
            return caml_call3(fold, dedups, 0, function(acc, dedup) {
                return dedup[2] ? acc : [
                    0,
                    dedup[1],
                    acc
                ];
            });
        }
        return list;
    }
    function concat_mapi(l, f) {
        function outer_loop_dps$0(counter, dst, offset, pos, param) {
            if (!param) {
                dst[1 + offset] = 0;
                return;
            }
            var tl = param[2], hd = param[1];
            if (!tl) {
                dst[1 + offset] = caml_call2(f, pos, hd);
                return;
            }
            var _ac_ = caml_call2(f, pos, hd), _ad_ = caml_call2(Base_Import[91], pos, 1);
            if (counter >= 50) return caml_trampoline_return(inner_loop_dps$0, [
                0,
                dst,
                offset,
                _ad_,
                _ac_,
                tl
            ]);
            var counter$0 = counter + 1 | 0;
            return inner_loop_dps$0(counter$0, dst, offset, _ad_, _ac_, tl);
        }
        function outer_loop_dps(dst, offset, pos, param) {
            return caml_trampoline(outer_loop_dps$0(0, dst, offset, pos, param));
        }
        function inner_loop_dps$0(counter, dst, offset, pos, l1, l2) {
            var dst$0 = dst, offset$0 = offset, l1$0 = l1;
            for(;;){
                if (!l1$0) {
                    if (counter >= 50) return caml_trampoline_return(outer_loop_dps$0, [
                        0,
                        dst$0,
                        offset$0,
                        pos,
                        l2
                    ]);
                    var counter$4 = counter + 1 | 0;
                    return outer_loop_dps$0(counter$4, dst$0, offset$0, pos, l2);
                }
                var _T_1 = l1$0[2], x1 = l1$0[1];
                if (!_T_1) {
                    var _aa_ = [
                        0,
                        x1,
                        24029
                    ];
                    dst$0[1 + offset$0] = _aa_;
                    var _ab_ = 1;
                    if (counter >= 50) return caml_trampoline_return(outer_loop_dps$0, [
                        0,
                        _aa_,
                        _ab_,
                        pos,
                        l2
                    ]);
                    var counter$3 = counter + 1 | 0;
                    return outer_loop_dps$0(counter$3, _aa_, _ab_, pos, l2);
                }
                var _U_ = _T_1[2], x2 = _T_1[1];
                if (!_U_) {
                    var ___ = [
                        0,
                        x2,
                        24029
                    ];
                    dst$0[1 + offset$0] = [
                        0,
                        x1,
                        ___
                    ];
                    var _$_ = 1;
                    if (counter >= 50) return caml_trampoline_return(outer_loop_dps$0, [
                        0,
                        ___,
                        _$_,
                        pos,
                        l2
                    ]);
                    var counter$2 = counter + 1 | 0;
                    return outer_loop_dps$0(counter$2, ___, _$_, pos, l2);
                }
                var _V_ = _U_[2], x3 = _U_[1];
                if (!_V_) {
                    var _Y_ = [
                        0,
                        x3,
                        24029
                    ];
                    dst$0[1 + offset$0] = [
                        0,
                        x1,
                        [
                            0,
                            x2,
                            _Y_
                        ]
                    ];
                    var _Z_ = 1;
                    if (counter >= 50) return caml_trampoline_return(outer_loop_dps$0, [
                        0,
                        _Y_,
                        _Z_,
                        pos,
                        l2
                    ]);
                    var counter$1 = counter + 1 | 0;
                    return outer_loop_dps$0(counter$1, _Y_, _Z_, pos, l2);
                }
                var match = _V_[2], x4 = _V_[1];
                if (!match) {
                    var _W_ = [
                        0,
                        x4,
                        24029
                    ];
                    dst$0[1 + offset$0] = [
                        0,
                        x1,
                        [
                            0,
                            x2,
                            [
                                0,
                                x3,
                                _W_
                            ]
                        ]
                    ];
                    var _X_ = 1;
                    if (counter >= 50) return caml_trampoline_return(outer_loop_dps$0, [
                        0,
                        _W_,
                        _X_,
                        pos,
                        l2
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return outer_loop_dps$0(counter$0, _W_, _X_, pos, l2);
                }
                var tl = match[2], x5 = match[1], dst$1 = [
                    0,
                    x5,
                    24029
                ];
                dst$0[1 + offset$0] = [
                    0,
                    x1,
                    [
                        0,
                        x2,
                        [
                            0,
                            x3,
                            [
                                0,
                                x4,
                                dst$1
                            ]
                        ]
                    ]
                ];
                dst$0 = dst$1;
                offset$0 = 1;
                l1$0 = tl;
            }
        }
        function inner_loop_dps(dst, offset, pos, l1, l2) {
            return caml_trampoline(inner_loop_dps$0(0, dst, offset, pos, l1, l2));
        }
        var pos = 0, param = l;
        for(;;){
            if (!param) return 0;
            var tl = param[2], hd = param[1];
            if (!tl) return caml_call2(f, pos, hd);
            var l1 = caml_call2(f, pos, hd), pos$0 = caml_call2(Base_Import[91], pos, 1);
            if (l1) break;
            pos = pos$0;
            param = tl;
        }
        var _Q_ = l1[2], x1 = l1[1];
        if (!_Q_) {
            var block$3 = [
                0,
                x1,
                24029
            ];
            outer_loop_dps(block$3, 1, pos$0, tl);
            return block$3;
        }
        var _R_ = _Q_[2], x2 = _Q_[1];
        if (!_R_) {
            var block$2 = [
                0,
                x2,
                24029
            ];
            outer_loop_dps(block$2, 1, pos$0, tl);
            return [
                0,
                x1,
                block$2
            ];
        }
        var _S_ = _R_[2], x3 = _R_[1];
        if (!_S_) {
            var block$1 = [
                0,
                x3,
                24029
            ];
            outer_loop_dps(block$1, 1, pos$0, tl);
            return [
                0,
                x1,
                [
                    0,
                    x2,
                    block$1
                ]
            ];
        }
        var match = _S_[2], x4 = _S_[1];
        if (match) {
            var tl$0 = match[2], x5 = match[1], block = [
                0,
                x5,
                24029
            ];
            inner_loop_dps(block, 1, pos$0, tl$0, tl);
            return [
                0,
                x1,
                [
                    0,
                    x2,
                    [
                        0,
                        x3,
                        [
                            0,
                            x4,
                            block
                        ]
                    ]
                ]
            ];
        }
        var block$0 = [
            0,
            x4,
            24029
        ];
        outer_loop_dps(block$0, 1, pos$0, tl);
        return [
            0,
            x1,
            [
                0,
                x2,
                [
                    0,
                    x3,
                    block$0
                ]
            ]
        ];
    }
    function concat_map(l, f) {
        return concat_mapi(l, function(param, x) {
            return caml_call1(f, x);
        });
    }
    function map2$0(a, b, f) {
        return concat_map(a, function(x) {
            return map(b, function(y) {
                return caml_call2(f, x, y);
            });
        });
    }
    function symbol_bind(t, f) {
        return concat_map(t, f);
    }
    var map$0 = [
        0,
        -198771759,
        map
    ], Applicative = caml_call1(Base_Applicative[13], [
        0,
        singleton,
        map2$0,
        map$0
    ]), map$1 = [
        0,
        -198771759,
        map
    ], Monad = caml_call1(Base_Monad[1], [
        0,
        concat_map,
        singleton,
        map$1
    ]), all = Monad[9], all_unit = Monad[10], ignore_m = Monad[8], join = Monad[7], apply = Applicative[8], both = Applicative[3], map3$0 = Applicative[10], symbol = Applicative[4], symbol$0 = Applicative[6], symbol$1 = Applicative[5], symbol$2 = Applicative[4], symbol$3 = Applicative[6], symbol$4 = Applicative[5], Open_on_rhs = [
        0
    ], Let_syntax = [
        0,
        singleton,
        concat_map,
        map,
        both,
        Open_on_rhs
    ], Let_syntax$0 = [
        0,
        singleton,
        symbol_bind,
        symbol_map,
        Let_syntax
    ], Monad_infix = [
        0,
        symbol_bind,
        symbol_map
    ], cst_List_last = "List.last", _i_ = [
        0,
        [
            11,
            "List.init ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "List.init %d"
    ], _j_ = [
        0,
        cst_src_list_ml,
        1111,
        4
    ], _k_ = [
        1,
        0
    ], _l_ = [
        1,
        0
    ], _m_ = [
        1,
        0
    ], _n_ = [
        0,
        cst_src_list_ml,
        1305,
        12
    ];
    function last_exn(list) {
        var list$0 = list;
        for(;;){
            if (!list$0) return caml_call1(Base_Import[126], cst_List_last);
            var x = list$0[1];
            if (!list$0[2]) return x;
            var list$1 = list$0[2];
            list$0 = list$1;
        }
    }
    function last(list) {
        var list$0 = list;
        for(;;){
            if (!list$0) return 0;
            var x = list$0[1];
            if (!list$0[2]) return [
                0,
                x
            ];
            var list$1 = list$0[2];
            list$0 = list$1;
        }
    }
    function is_prefix(list, prefix, equal) {
        var list$0 = list, prefix$0 = prefix;
        for(;;){
            if (!prefix$0) return 1;
            var prefix$1 = prefix$0[2], hd = prefix$0[1];
            if (!list$0) return 0;
            var list$1 = list$0[2], hd$0 = list$0[1], _P_ = caml_call2(equal, hd, hd$0);
            if (!_P_) return _P_;
            list$0 = list$1;
            prefix$0 = prefix$1;
        }
    }
    function find_consecutive_duplicate(t, equal) {
        if (!t) return 0;
        var t$0 = t[2], a1 = t[1], a1$0 = a1, t$1 = t$0;
        for(;;){
            if (!t$1) return 0;
            var t$2 = t$1[2], a2 = t$1[1];
            if (caml_call2(equal, a1$0, a2)) return [
                0,
                [
                    0,
                    a1$0,
                    a2
                ]
            ];
            a1$0 = a2;
            t$1 = t$2;
        }
    }
    function remove_consecutive_duplicates(opt, list, equal) {
        var which_to_keep = opt ? opt[1] : 847656566;
        if (!list) return 0;
        var tl$0 = list[2], to_keep$2 = list[1], to_keep = to_keep$2, accum = 0, param = tl$0;
        for(;;){
            if (!param) return caml_call1(rev, [
                0,
                to_keep,
                accum
            ]);
            var tl = param[2], to_keep$0 = param[1];
            if (caml_call2(equal, to_keep$0, to_keep)) {
                var to_keep$1 = 847656566 <= which_to_keep ? to_keep$0 : to_keep;
                to_keep = to_keep$1;
                param = tl;
            } else {
                var accum$0 = [
                    0,
                    to_keep,
                    accum
                ];
                to_keep = to_keep$0;
                accum = accum$0;
                param = tl;
            }
        }
    }
    function find_a_dup(l, compare) {
        var sorted = stable_sort(l, compare), l$0 = sorted;
        for(;;){
            if (l$0) {
                var tl = l$0[2];
                if (tl) {
                    var hd2 = tl[1], hd1 = l$0[1];
                    if (0 === caml_call2(compare, hd1, hd2)) return [
                        0,
                        hd1
                    ];
                    l$0 = tl;
                    continue;
                }
            }
            return 0;
        }
    }
    function contains_dup(lst, compare) {
        return find_a_dup(lst, compare) ? 1 : 0;
    }
    function find_all_dups(l, compare) {
        var sorted = stable_sort(l, compare);
        if (!sorted) return 0;
        var sorted$4 = sorted[2], prev$3 = sorted[1], sorted$0 = sorted$4, prev = prev$3, already_recorded = 0;
        for(;;){
            if (!sorted$0) return 0;
            var sorted$1 = sorted$0[2], prev$0 = sorted$0[1];
            if (0 === caml_call2(compare, prev, prev$0)) {
                if (!already_recorded) break;
                sorted$0 = sorted$1;
                prev = prev$0;
                already_recorded = 1;
            } else {
                sorted$0 = sorted$1;
                prev = prev$0;
                already_recorded = 0;
            }
        }
        var block = [
            0,
            prev$0,
            24029
        ], dst = block, offset = 1, sorted$2 = sorted$1, prev$1 = prev$0, already_recorded$0 = 1;
        for(;;){
            if (!sorted$2) {
                dst[1 + offset] = 0;
                return block;
            }
            var sorted$3 = sorted$2[2], prev$2 = sorted$2[1];
            if (0 === caml_call2(compare, prev$1, prev$2)) {
                if (already_recorded$0) {
                    sorted$2 = sorted$3;
                    prev$1 = prev$2;
                    already_recorded$0 = 1;
                } else {
                    var dst$0 = [
                        0,
                        prev$2,
                        24029
                    ];
                    dst[1 + offset] = dst$0;
                    dst = dst$0;
                    offset = 1;
                    sorted$2 = sorted$3;
                    prev$1 = prev$2;
                    already_recorded$0 = 1;
                }
            } else {
                sorted$2 = sorted$3;
                prev$1 = prev$2;
                already_recorded$0 = 0;
            }
        }
    }
    function all_equal(t$0, equal) {
        if (!t$0) return 0;
        var xs$0 = t$0[2], x$0 = t$0[1], t = xs$0;
        for(;;){
            if (t) {
                var xs = t[2], x = t[1], _N_ = caml_call2(equal, x, x$0);
                if (_N_) {
                    t = xs;
                    continue;
                }
                var _O_ = _N_;
            } else var _O_ = 1;
            return _O_ ? [
                0,
                x$0
            ] : 0;
        }
    }
    function count(t, f) {
        return caml_call3(Base_Container[2], fold, t, f);
    }
    function sum(m, t, f) {
        return caml_call4(Base_Container[7], fold, m, t, f);
    }
    function min_elt(t, compare) {
        return caml_call3(Base_Container[3], fold, t, compare);
    }
    function max_elt(t, compare) {
        return caml_call3(Base_Container[4], fold, t, compare);
    }
    function counti(t, f) {
        return foldi(t, 0, function(idx, count, a) {
            return caml_call2(f, idx, a) ? caml_call2(Base_Import[91], count, 1) : count;
        });
    }
    function init(n, f) {
        if (n < 0) caml_call3(invalid_argf, _i_, n, 0);
        var i = n, accum = 0;
        for(;;){
            if (0 > i) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _j_
            ], 1);
            if (0 === i) return accum;
            var accum$0 = [
                0,
                caml_call1(f, caml_call2(Base_Import[93], i, 1)),
                accum
            ], i$0 = caml_call2(Base_Import[93], i, 1);
            i = i$0;
            accum = accum$0;
        }
    }
    function rev_filter_map(l, f) {
        var l$0 = l, accum = 0;
        for(;;){
            if (!l$0) return accum;
            var tl = l$0[2], hd = l$0[1], match = caml_call1(f, hd);
            if (match) {
                var x = match[1], accum$0 = [
                    0,
                    x,
                    accum
                ];
                l$0 = tl;
                accum = accum$0;
            } else l$0 = tl;
        }
    }
    function filter_map(l, f) {
        var l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1], match = caml_call1(f, hd);
            if (match) {
                var x = match[1], block = [
                    0,
                    x,
                    24029
                ], dst = block, offset = 1, l$1 = tl;
                for(;;){
                    if (!l$1) {
                        dst[1 + offset] = 0;
                        return block;
                    }
                    var tl$0 = l$1[2], hd$0 = l$1[1], match$0 = caml_call1(f, hd$0);
                    if (match$0) {
                        var x$0 = match$0[1], dst$0 = [
                            0,
                            x$0,
                            24029
                        ];
                        dst[1 + offset] = dst$0;
                        dst = dst$0;
                        offset = 1;
                        l$1 = tl$0;
                    } else l$1 = tl$0;
                }
            } else l$0 = tl;
        }
    }
    function rev_filter_mapi(l, f) {
        var i = 0, l$0 = l, accum = 0;
        for(;;){
            if (!l$0) return accum;
            var tl = l$0[2], hd = l$0[1], match = caml_call2(f, i, hd);
            if (match) {
                var x = match[1], accum$0 = [
                    0,
                    x,
                    accum
                ], i$0 = caml_call2(Base_Import[91], i, 1);
                i = i$0;
                l$0 = tl;
                accum = accum$0;
            } else {
                var i$1 = caml_call2(Base_Import[91], i, 1);
                i = i$1;
                l$0 = tl;
            }
        }
    }
    function filter_mapi(l, f) {
        var pos = 0, l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1], match = caml_call2(f, pos, hd);
            if (match) break;
            var pos$1 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$1;
            l$0 = tl;
        }
        var x = match[1], block = [
            0,
            x,
            24029
        ], pos$0 = caml_call2(Base_Import[91], pos, 1), dst = block, offset = 1, pos$2 = pos$0, l$1 = tl;
        for(;;){
            if (!l$1) {
                dst[1 + offset] = 0;
                return block;
            }
            var tl$0 = l$1[2], hd$0 = l$1[1], match$0 = caml_call2(f, pos$2, hd$0);
            if (match$0) {
                var x$0 = match$0[1], block$0 = [
                    0,
                    x$0,
                    24029
                ];
                dst[1 + offset] = block$0;
                var pos$3 = caml_call2(Base_Import[91], pos$2, 1);
                dst = block$0;
                offset = 1;
                pos$2 = pos$3;
                l$1 = tl$0;
            } else {
                var pos$4 = caml_call2(Base_Import[91], pos$2, 1);
                pos$2 = pos$4;
                l$1 = tl$0;
            }
        }
    }
    function filter_opt(l) {
        return filter_map(l, function(_M_) {
            return _M_;
        });
    }
    function partition3_map(t, f) {
        var t$0 = t, fst = 0, snd = 0, trd = 0;
        for(;;){
            if (!t$0) {
                var _K_ = caml_call1(rev, trd), _L_ = caml_call1(rev, snd);
                return [
                    0,
                    caml_call1(rev, fst),
                    _L_,
                    _K_
                ];
            }
            var t$1 = t$0[2], x = t$0[1], match = caml_call1(f, x), _J_ = match[1];
            if (4152137 === _J_) {
                var y = match[2], snd$0 = [
                    0,
                    y,
                    snd
                ];
                t$0 = t$1;
                snd = snd$0;
            } else if (4202758 <= _J_) {
                var y$0 = match[2], trd$0 = [
                    0,
                    y$0,
                    trd
                ];
                t$0 = t$1;
                trd = trd$0;
            } else {
                var y$1 = match[2], fst$0 = [
                    0,
                    y$1,
                    fst
                ];
                t$0 = t$1;
                fst = fst$0;
            }
        }
    }
    function partition_tf(t, f) {
        function f$0(x) {
            return caml_call1(f, x) ? [
                0,
                x
            ] : [
                1,
                x
            ];
        }
        return caml_call2(partition_map, t, f$0);
    }
    function partition_result(t) {
        return caml_call2(partition_map, t, Base_Result[38]);
    }
    function t_of_sexp$0(of_a_028, of_b_029, x_037) {
        return caml_call2(Base_Import[173], function(sexp_035) {
            if (1 === sexp_035[0]) {
                var _H_ = sexp_035[1];
                if (_H_) {
                    var _I_ = _H_[2];
                    if (_I_ && !_I_[2]) {
                        var arg1_032 = _I_[1], arg0_031 = _H_[1], res0_033 = caml_call1(of_a_028, arg0_031), res1_034 = caml_call1(of_b_029, arg1_032);
                        return [
                            0,
                            res0_033,
                            res1_034
                        ];
                    }
                }
            }
            return caml_call3(Sexplib0_Sexp_conv_error[4], error_source_036, 2, sexp_035);
        }, x_037);
    }
    function sexp_of_t$1(of_a_038, of_b_039, x_044) {
        return caml_call2(Base_Import[149], function(param) {
            var arg1_041 = param[2], arg0_040 = param[1], res0_042 = caml_call1(of_a_038, arg0_040), res1_043 = caml_call1(of_b_039, arg1_041);
            return [
                1,
                [
                    0,
                    res0_042,
                    [
                        0,
                        res1_043,
                        0
                    ]
                ]
            ];
        }, x_044);
    }
    function t_sexp_grammar$0(a_sexp_grammar, b_sexp_grammar) {
        var _G_ = caml_call1(Base_Import[194], [
            2,
            [
                0,
                [
                    5,
                    [
                        0,
                        Sexplib0_Sexp_grammar[6],
                        _k_,
                        a_sexp_grammar
                    ]
                ],
                [
                    0,
                    [
                        5,
                        [
                            0,
                            Sexplib0_Sexp_grammar[7],
                            _l_,
                            b_sexp_grammar
                        ]
                    ],
                    0
                ]
            ]
        ]);
        return [
            5,
            [
                0,
                Sexplib0_Sexp_grammar[5],
                _m_,
                _G_
            ]
        ];
    }
    function pair_of_group(list) {
        if (!list) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _n_
        ], 1);
        var k = list[1][1];
        return [
            0,
            k,
            map(list, Base_Import[127])
        ];
    }
    function group$0(alist, equal) {
        return map(group(alist, function(_F_, param) {
            var y = param[1], x = _F_[1];
            return 1 - caml_call2(equal, x, y);
        }), pair_of_group);
    }
    function sort_and_group$0(alist, compare) {
        return map(sort_and_group(alist, function(_E_, param) {
            var y = param[1], x = _E_[1];
            return caml_call2(compare, x, y);
        }), pair_of_group);
    }
    function find$0(t, equal, key) {
        var match = find(t, function(param) {
            var key$0 = param[1];
            return caml_call2(equal, key, key$0);
        });
        if (!match) return 0;
        var x = match[1];
        return [
            0,
            caml_call1(Base_Import[127], x)
        ];
    }
    var not_found$3 = [
        0,
        Base_Import[297],
        [
            0,
            "List.Assoc.find_exn: not found"
        ]
    ], cst_List_sub = "List.sub", _o_ = [
        0,
        [
            11,
            "List.chunks_of: Expected length > 0, got ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "List.chunks_of: Expected length > 0, got %d"
    ], cst_List_drop_last_exn_empty_l = "List.drop_last_exn: empty list";
    function find_exn$0(t, equal, key) {
        var t$0 = t;
        for(;;){
            if (!t$0) throw caml_maybe_attach_backtrace(not_found$3, 1);
            var t$1 = t$0[2], match = t$0[1], value = match[2], key$0 = match[1];
            if (caml_call2(equal, key, key$0)) return value;
            t$0 = t$1;
        }
    }
    function mem$0(t, equal, key) {
        return find$0(t, equal, key) ? 1 : 0;
    }
    function remove(t, equal, key) {
        return filter(t, function(param) {
            var key$0 = param[1];
            return 1 - caml_call2(equal, key, key$0);
        });
    }
    function add(t, equal, key, value) {
        return [
            0,
            [
                0,
                key,
                value
            ],
            remove(t, equal, key)
        ];
    }
    function inverse(t) {
        return map(t, function(param) {
            var y = param[2], x = param[1];
            return [
                0,
                y,
                x
            ];
        });
    }
    function map$2(t, f) {
        return map(t, function(param) {
            var value = param[2], key = param[1];
            return [
                0,
                key,
                caml_call1(f, value)
            ];
        });
    }
    function sub(l, pos, len) {
        var _A_ = pos < 0 ? 1 : 0;
        if (_A_) var _B_ = _A_;
        else {
            var _C_ = len < 0 ? 1 : 0;
            if (_C_) var _B_ = _C_;
            else var _D_ = caml_call1(length, l), _B_ = caml_call2(Base_Import[93], _D_, len) < pos ? 1 : 0;
        }
        if (_B_) caml_call1(Base_Import[126], cst_List_sub);
        var stop = caml_call2(Base_Import[91], pos, len), i = 0, l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1];
            if (i >= pos) break;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            l$0 = tl;
        }
        if (i >= stop) return 0;
        var block = [
            0,
            hd,
            24029
        ], i$1 = caml_call2(Base_Import[91], i, 1), dst = block, offset = 1, i$2 = i$1, l$1 = tl;
        for(;;){
            if (l$1) {
                var tl$0 = l$1[2], hd$0 = l$1[1];
                if (i$2 < pos) {
                    var i$3 = caml_call2(Base_Import[91], i$2, 1);
                    i$2 = i$3;
                    l$1 = tl$0;
                    continue;
                }
                if (i$2 < stop) {
                    var block$0 = [
                        0,
                        hd$0,
                        24029
                    ];
                    dst[1 + offset] = block$0;
                    var i$4 = caml_call2(Base_Import[91], i$2, 1);
                    dst = block$0;
                    offset = 1;
                    i$2 = i$4;
                    l$1 = tl$0;
                    continue;
                }
                dst[1 + offset] = 0;
            } else dst[1 + offset] = 0;
            return block;
        }
    }
    function split_n(t_orig, n) {
        if (0 >= n) return [
            0,
            0,
            t_orig
        ];
        var n$0 = n, t = t_orig, accum = 0;
        for(;;){
            if (!t) return [
                0,
                t_orig,
                0
            ];
            var tl = t[2], hd = t[1];
            if (0 === n$0) return [
                0,
                caml_call1(rev, accum),
                t
            ];
            var accum$0 = [
                0,
                hd,
                accum
            ], n$1 = caml_call2(Base_Import[93], n$0, 1);
            n$0 = n$1;
            t = tl;
            accum = accum$0;
        }
    }
    function take(t_orig, n) {
        if (0 >= n) return 0;
        var n$0 = n, t = t_orig, accum = 0;
        for(;;){
            if (!t) return t_orig;
            var tl = t[2], hd = t[1];
            if (0 === n$0) return caml_call1(rev, accum);
            var accum$0 = [
                0,
                hd,
                accum
            ], n$1 = caml_call2(Base_Import[93], n$0, 1);
            n$0 = n$1;
            t = tl;
            accum = accum$0;
        }
    }
    function drop(t, n) {
        var t$0 = t, n$0 = n;
        for(;;){
            if (t$0) {
                var tl = t$0[2];
                if (0 < n$0) {
                    var n$1 = caml_call2(Base_Import[93], n$0, 1);
                    t$0 = tl;
                    n$0 = n$1;
                    continue;
                }
            }
            return t$0;
        }
    }
    function chunks_of(l, length) {
        if (length <= 0) caml_call3(invalid_argf, _o_, length, 0);
        var acc = 0, l$0 = l;
        for(;;){
            if (!l$0) return caml_call1(rev, acc);
            var match = split_n(l$0, length), l$1 = match[2], sublist = match[1], acc$0 = [
                0,
                sublist,
                acc
            ];
            acc = acc$0;
            l$0 = l$1;
        }
    }
    function split_while(xs, f) {
        var acc = 0, t = xs;
        for(;;){
            if (t) {
                var tl = t[2], hd = t[1];
                if (caml_call1(f, hd)) {
                    var acc$0 = [
                        0,
                        hd,
                        acc
                    ];
                    acc = acc$0;
                    t = tl;
                    continue;
                }
            }
            return [
                0,
                caml_call1(rev, acc),
                t
            ];
        }
    }
    function take_while(xs, f) {
        var acc = 0, param = xs;
        for(;;){
            if (param) {
                var tl = param[2], hd = param[1];
                if (caml_call1(f, hd)) {
                    var acc$0 = [
                        0,
                        hd,
                        acc
                    ];
                    acc = acc$0;
                    param = tl;
                    continue;
                }
            }
            return caml_call1(rev, acc);
        }
    }
    function drop_while(t, f) {
        var t$0 = t;
        for(;;){
            if (t$0) {
                var tl = t$0[2], hd = t$0[1];
                if (caml_call1(f, hd)) {
                    t$0 = tl;
                    continue;
                }
            }
            return t$0;
        }
    }
    function drop_last(t) {
        var match = caml_call1(rev, t);
        if (!match) return 0;
        var lst = match[2];
        return [
            0,
            caml_call1(rev, lst)
        ];
    }
    function drop_last_exn(t) {
        var match = drop_last(t);
        if (!match) return caml_call1(Base_Import[124], cst_List_drop_last_exn_empty_l);
        var lst = match[1];
        return lst;
    }
    function cartesian_product(list1, list2) {
        if (caml_call1(is_empty, list2)) return 0;
        var l1 = list1;
        for(;;){
            if (!l1) return 0;
            var l1$0 = l1[2], x1 = l1[1];
            if (list2) break;
            l1 = l1$0;
        }
        var l2 = list2[2], x2 = list2[1], block = [
            0,
            [
                0,
                x1,
                x2
            ],
            24029
        ], dst = block, offset = 1, x1$1 = x1, l1$2 = l1$0, l2$0 = l2;
        for(;;)if (l2$0) {
            var l2$1 = l2$0[2], x2$0 = l2$0[1], dst$0 = [
                0,
                [
                    0,
                    x1$1,
                    x2$0
                ],
                24029
            ];
            dst[1 + offset] = dst$0;
            dst = dst$0;
            offset = 1;
            l2$0 = l2$1;
        } else {
            if (!l1$2) {
                dst[1 + offset] = 0;
                return block;
            }
            var l1$1 = l1$2[2], x1$0 = l1$2[1];
            x1$1 = x1$0;
            l1$2 = l1$1;
            l2$0 = list2;
        }
    }
    function concat(l) {
        return caml_call3(fold_right, l, append, 0);
    }
    function concat_no_order(l) {
        return caml_call3(fold, l, 0, function(acc, l) {
            return caml_call2(rev_append, l, acc);
        });
    }
    function cons(x, l) {
        return [
            0,
            x,
            l
        ];
    }
    function is_sorted(l, compare) {
        var l$0 = l;
        for(;;){
            if (l$0) {
                var rest = l$0[2];
                if (rest) {
                    var x2 = rest[1], x1 = l$0[1], _z_ = caml_call2(compare, x1, x2) <= 0 ? 1 : 0;
                    if (!_z_) return _z_;
                    l$0 = rest;
                    continue;
                }
            }
            return 1;
        }
    }
    function is_sorted_strictly(l, compare) {
        var l$0 = l;
        for(;;){
            if (l$0) {
                var rest = l$0[2];
                if (rest) {
                    var x2 = rest[1], x1 = l$0[1], _y_ = caml_call2(compare, x1, x2) < 0 ? 1 : 0;
                    if (!_y_) return _y_;
                    l$0 = rest;
                    continue;
                }
            }
            return 1;
        }
    }
    var Infix = [
        0,
        append
    ], cst_List_random_element_exn_em = "List.random_element_exn: empty list";
    function permute(opt, list) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        if (list) {
            var _x_ = list[2];
            if (_x_) {
                if (_x_[2]) {
                    var arr = caml_call1(Base_Array0[14], list);
                    caml_call4(Base_Array_permute[25], [
                        0,
                        random_state
                    ], 0, 0, arr);
                    return caml_call1(Base_Array0[16], arr);
                }
                var y = _x_[1], x = list[1];
                return caml_call1(Base_Random[19][17], random_state) ? [
                    0,
                    y,
                    [
                        0,
                        x,
                        0
                    ]
                ] : list;
            }
        }
        return list;
    }
    function random_element_exn(opt, list) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        if (caml_call1(is_empty, list)) return caml_call1(Base_Import[124], cst_List_random_element_exn_em);
        var _w_ = caml_call1(length, list);
        return nth_exn(list, caml_call2(Base_Random[19][7], random_state, _w_));
    }
    function random_element(opt, list) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        try {
            var _u_ = [
                0,
                random_element_exn([
                    0,
                    random_state
                ], list)
            ];
            return _u_;
        } catch (_v_) {
            return 0;
        }
    }
    function compare$0(cmp, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (!a$0) return b$0 ? -1 : 0;
            if (!b$0) return 1;
            var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], n = caml_call2(cmp, x, y);
            if (0 !== n) return n;
            a$0 = xs;
            b$0 = ys;
        }
    }
    function compare_local$0(cmp, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (!a$0) return b$0 ? -1 : 0;
            if (!b$0) return 1;
            var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], n = caml_call2(cmp, x, y);
            if (0 !== n) return n;
            a$0 = xs;
            b$0 = ys;
        }
    }
    var hash_fold_t = Base_Import[212];
    function equal_with_local_closure(equal, t1, t2) {
        var t1$0 = t1, t2$0 = t2;
        for(;;){
            if (t1$0) {
                if (t2$0) {
                    var t2$1 = t2$0[2], x2 = t2$0[1], t1$1 = t1$0[2], x1 = t1$0[1], _t_ = caml_call2(equal, x1, x2);
                    if (!_t_) return _t_;
                    t1$0 = t1$1;
                    t2$0 = t2$1;
                    continue;
                }
            } else if (!t2$0) return 1;
            return 0;
        }
    }
    function equal(f, x, y) {
        return equal_with_local_closure(f, x, y);
    }
    function equal_local(equal_a_local, t1, t2) {
        var t1$0 = t1, t2$0 = t2;
        for(;;){
            if (t1$0) {
                if (t2$0) {
                    var t2$1 = t2$0[2], x2 = t2$0[1], t1$1 = t1$0[2], x1 = t1$0[1], _s_ = caml_call2(equal_a_local, x1, x2);
                    if (!_s_) return _s_;
                    t1$0 = t1$1;
                    t2$0 = t2$1;
                    continue;
                }
            } else if (!t2$0) return 1;
            return 0;
        }
    }
    function transpose(rows$0) {
        var rows = rows$0, columns = 0, do_rev = 1;
        for(;;){
            var t = rows, column_acc = 0, trimmed_rows = 0, found_empty = 0;
            for(;;){
                if (!t) break;
                var match = t[1];
                if (match) {
                    var tl = t[2], xs = match[2], x = match[1], trimmed = [
                        0,
                        xs,
                        trimmed_rows
                    ], column_acc$0 = [
                        0,
                        x,
                        column_acc
                    ];
                    t = tl;
                    column_acc = column_acc$0;
                    trimmed_rows = trimmed;
                } else {
                    var tl$0 = t[2];
                    t = tl$0;
                    found_empty = 1;
                }
            }
            if (!column_acc && !trimmed_rows) return [
                0,
                caml_call1(rev, columns)
            ];
            if (found_empty) return 0;
            var column = do_rev ? caml_call1(rev, column_acc) : column_acc, do_rev$0 = 1 - do_rev, columns$0 = [
                0,
                column,
                columns
            ];
            rows = trimmed_rows;
            columns = columns$0;
            do_rev = do_rev$0;
        }
    }
    var Transpose_got_lists_of_differe = [
        248,
        "Base__List.Transpose_got_lists_of_different_lengths",
        runtime.caml_fresh_oo_id(0)
    ], _p_ = [
        0,
        "list.ml.Transpose_got_lists_of_different_lengths"
    ], _q_ = [
        0,
        cst_src_list_ml,
        1588,
        11
    ];
    caml_call4(Sexplib0_Sexp_conv[72][1], 0, 0, Transpose_got_lists_of_differe, function(param) {
        if (param[1] !== Transpose_got_lists_of_differe) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _q_
        ], 1);
        var arg0_045 = param[2], res0_046 = caml_call2(Base_Import[149], Base_Import[139], arg0_045);
        return [
            1,
            [
                0,
                _p_,
                [
                    0,
                    res0_046,
                    0
                ]
            ]
        ];
    });
    function transpose_exn(l) {
        var match = transpose(l);
        if (!match) throw caml_maybe_attach_backtrace([
            0,
            Transpose_got_lists_of_differe,
            map(l, length)
        ], 1);
        var l$0 = match[1];
        return l$0;
    }
    function intersperse(t, sep) {
        if (!t) return 0;
        var xs = t[2], x = t[1];
        return [
            0,
            x,
            caml_call3(fold_right, xs, function(y, acc) {
                return [
                    0,
                    sep,
                    [
                        0,
                        y,
                        acc
                    ]
                ];
            }, 0)
        ];
    }
    function fold_result(t, init, f) {
        return caml_call4(Base_Container[8], fold, init, f, t);
    }
    function fold_until(t, init, f, finish) {
        return caml_call5(Base_Container[9], fold, init, f, finish, t);
    }
    function is_suffix(list, suffix, equal_elt) {
        var list_len = caml_call1(length, list), suffix_len = caml_call1(length, suffix), _r_ = suffix_len <= list_len ? 1 : 0;
        return _r_ ? equal_with_local_closure(equal_elt, drop(list, caml_call2(Base_Import[93], list_len, suffix_len)), suffix) : _r_;
    }
    var Base_List = [
        0,
        compare$0,
        compare_local$0,
        globalize,
        hash_fold_t,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        of_list,
        of_array,
        append,
        concat,
        filter,
        filter_map,
        concat_map,
        partition_tf,
        partition_map,
        mem,
        is_empty,
        iter,
        fold,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        to_array,
        min_elt,
        max_elt,
        foldi,
        iteri,
        existsi,
        for_alli,
        counti,
        findi,
        find_mapi,
        init,
        mapi,
        filteri,
        filter_mapi,
        concat_mapi,
        length,
        invariant,
        [
            0,
            both,
            symbol,
            symbol$1,
            symbol$0,
            apply,
            map2$0,
            map3$0,
            [
                0,
                symbol$2,
                symbol$4,
                symbol$3,
                symbol_map
            ],
            symbol_bind,
            symbol_map,
            [
                0,
                symbol_bind,
                symbol_map
            ],
            concat_map,
            singleton,
            map,
            join,
            ignore_m,
            all,
            all_unit,
            [
                0,
                singleton,
                symbol_bind,
                symbol_map,
                Let_syntax
            ]
        ],
        symbol_bind,
        symbol_map,
        Monad_infix,
        concat_map,
        singleton,
        map,
        join,
        ignore_m,
        all,
        all_unit,
        Let_syntax$0,
        [
            0,
            compare,
            compare_local,
            sexp_of_t$0
        ],
        singleton,
        nth,
        nth_exn,
        rev,
        rev_append,
        unordered_append,
        rev_map,
        iter2_exn,
        iter2,
        rev_map2_exn,
        rev_map2,
        fold2_exn,
        fold2,
        fold_right2_exn,
        fold_right2,
        for_all2_exn,
        for_all2,
        exists2_exn,
        exists2,
        rev_filter,
        partition3_map,
        partition_result,
        split_n,
        stable_sort,
        stable_sort,
        merge,
        hd,
        tl,
        hd_exn,
        tl_exn,
        findi_exn,
        find_exn,
        find_map_exn,
        find_mapi_exn,
        folding_map,
        folding_mapi,
        fold_map,
        fold_mapi,
        map2_exn,
        map2,
        rev_map3_exn,
        rev_map3,
        map3_exn,
        map3,
        rev_map_append,
        fold_right,
        fold,
        unzip,
        unzip3,
        zip,
        zip_exn,
        rev_mapi,
        reduce_exn,
        reduce,
        reduce_balanced,
        reduce_balanced_exn,
        group,
        groupi,
        sort_and_group,
        chunks_of,
        last,
        last_exn,
        is_prefix,
        is_suffix,
        find_consecutive_duplicate,
        remove_consecutive_duplicates,
        dedup_and_sort,
        stable_dedup,
        find_a_dup,
        contains_dup,
        find_all_dups,
        all_equal,
        range$0,
        range,
        rev_filter_map,
        rev_filter_mapi,
        filter_opt,
        [
            0,
            t_of_sexp$0,
            sexp_of_t$1,
            t_sexp_grammar$0,
            add,
            find$0,
            find_exn$0,
            mem$0,
            remove,
            map$2,
            inverse,
            group$0,
            sort_and_group$0
        ],
        sub,
        take,
        drop,
        take_while,
        drop_while,
        split_while,
        drop_last,
        drop_last_exn,
        concat_no_order,
        cons,
        cartesian_product,
        permute,
        random_element,
        random_element_exn,
        is_sorted,
        is_sorted_strictly,
        equal,
        equal_local,
        Infix,
        transpose,
        transpose_exn,
        intersperse
    ];
    runtime.caml_register_global(62, Base_List, "Base__List");
    return;
})(globalThis);
//# 11358 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_tag = runtime.caml_obj_tag, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, _j_ = [
        0,
        [
            0,
            "cycle while computing message"
        ]
    ], t_sexp_grammar = [
        0,
        "Info.t"
    ], module_name = "Base.Info", Stdlib_Format = global_data.Stdlib__Format, Base_Exn = global_data.Base__Exn, Stdlib_Printexc = global_data.Stdlib__Printexc, Assert_failure = global_data.Assert_failure, CamlinternalLazy = global_data.CamlinternalLazy, Base_Printf = global_data.Base__Printf, Base_Sexp = global_data.Base__Sexp, Base_Hash = global_data.Base__Hash, Base_Import = global_data.Base__Import, Base_List = global_data.Base__List, Base_Source_code_position0 = global_data.Base__Source_code_position0, Base_String0 = global_data.Base__String0, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, Base_Pretty_printer = global_data.Base__Pretty_printer, _a_ = [
        0,
        "Could_not_construct"
    ], _b_ = [
        0,
        "String"
    ], _c_ = [
        0,
        "Exn"
    ], _d_ = [
        0,
        "Sexp"
    ], _e_ = [
        0,
        "Tag_sexp"
    ], _f_ = [
        0,
        "Tag_t"
    ], _g_ = [
        0,
        "Tag_arg"
    ], _h_ = [
        0,
        "Of_list"
    ], _i_ = [
        0,
        "With_backtrace"
    ];
    function sexp_of_t(param) {
        switch(param[0]){
            case 0:
                var arg0_001 = param[1], res0_002 = caml_call1(Base_Sexp[5], arg0_001);
                return [
                    1,
                    [
                        0,
                        _a_,
                        [
                            0,
                            res0_002,
                            0
                        ]
                    ]
                ];
            case 1:
                var arg0_003 = param[1], res0_004 = caml_call1(Base_Import[136], arg0_003);
                return [
                    1,
                    [
                        0,
                        _b_,
                        [
                            0,
                            res0_004,
                            0
                        ]
                    ]
                ];
            case 2:
                var arg0_005 = param[1], res0_006 = caml_call1(Base_Import[198], arg0_005);
                return [
                    1,
                    [
                        0,
                        _c_,
                        [
                            0,
                            res0_006,
                            0
                        ]
                    ]
                ];
            case 3:
                var arg0_007 = param[1], res0_008 = caml_call1(Base_Sexp[5], arg0_007);
                return [
                    1,
                    [
                        0,
                        _d_,
                        [
                            0,
                            res0_008,
                            0
                        ]
                    ]
                ];
            case 4:
                var arg2_011 = param[3], arg1_010 = param[2], arg0_009 = param[1], res0_012 = caml_call1(Base_Import[136], arg0_009), res1_013 = caml_call1(Base_Sexp[5], arg1_010), res2_014 = caml_call2(Base_Import[146], Base_Source_code_position0[9], arg2_011);
                return [
                    1,
                    [
                        0,
                        _e_,
                        [
                            0,
                            res0_012,
                            [
                                0,
                                res1_013,
                                [
                                    0,
                                    res2_014,
                                    0
                                ]
                            ]
                        ]
                    ]
                ];
            case 5:
                var arg1_016 = param[2], arg0_015 = param[1], res0_017 = caml_call1(Base_Import[136], arg0_015), res1_018 = sexp_of_t(arg1_016);
                return [
                    1,
                    [
                        0,
                        _f_,
                        [
                            0,
                            res0_017,
                            [
                                0,
                                res1_018,
                                0
                            ]
                        ]
                    ]
                ];
            case 6:
                var arg2_021 = param[3], arg1_020 = param[2], arg0_019 = param[1], res0_022 = caml_call1(Base_Import[136], arg0_019), res1_023 = caml_call1(Base_Sexp[5], arg1_020), res2_024 = sexp_of_t(arg2_021);
                return [
                    1,
                    [
                        0,
                        _g_,
                        [
                            0,
                            res0_022,
                            [
                                0,
                                res1_023,
                                [
                                    0,
                                    res2_024,
                                    0
                                ]
                            ]
                        ]
                    ]
                ];
            case 7:
                var arg1_026 = param[2], arg0_025 = param[1], res0_027 = caml_call2(Base_Import[146], Base_Import[139], arg0_025), res1_028 = caml_call2(Base_Import[149], sexp_of_t, arg1_026);
                return [
                    1,
                    [
                        0,
                        _h_,
                        [
                            0,
                            res0_027,
                            [
                                0,
                                res1_028,
                                0
                            ]
                        ]
                    ]
                ];
            default:
                var arg1_030 = param[2], arg0_029 = param[1], res0_031 = sexp_of_t(arg0_029), res1_032 = caml_call1(Base_Import[136], arg1_030);
                return [
                    1,
                    [
                        0,
                        _i_,
                        [
                            0,
                            res0_031,
                            [
                                0,
                                res1_032,
                                0
                            ]
                        ]
                    ]
                ];
        }
    }
    function to_sexps_hum(t, ac) {
        switch(t[0]){
            case 0:
                return [
                    0,
                    sexp_of_t(t),
                    ac
                ];
            case 1:
                var string = t[1];
                return [
                    0,
                    [
                        0,
                        string
                    ],
                    ac
                ];
            case 2:
                var exn = t[1];
                return [
                    0,
                    caml_call1(Base_Exn[1], exn),
                    ac
                ];
            case 3:
                var sexp = t[1];
                return [
                    0,
                    sexp,
                    ac
                ];
            case 4:
                var here = t[3], sexp$0 = t[2], tag = t[1];
                if (here) var here$0 = here[1], _R_ = [
                    0,
                    caml_call1(Base_Source_code_position0[9], here$0),
                    0
                ];
                else var _R_ = 0;
                return [
                    0,
                    [
                        1,
                        [
                            0,
                            [
                                0,
                                tag
                            ],
                            [
                                0,
                                sexp$0,
                                _R_
                            ]
                        ]
                    ],
                    ac
                ];
            case 5:
                var t$0 = t[2], tag$0 = t[1];
                return [
                    0,
                    [
                        1,
                        [
                            0,
                            [
                                0,
                                tag$0
                            ],
                            to_sexps_hum(t$0, 0)
                        ]
                    ],
                    ac
                ];
            case 6:
                var t$1 = t[3], sexp$1 = t[2], tag$1 = t[1], body = [
                    0,
                    sexp$1,
                    to_sexps_hum(t$1, 0)
                ];
                return 0 === runtime.caml_ml_string_length(tag$1) ? [
                    0,
                    [
                        1,
                        body
                    ],
                    ac
                ] : [
                    0,
                    [
                        1,
                        [
                            0,
                            [
                                0,
                                tag$1
                            ],
                            body
                        ]
                    ],
                    ac
                ];
            case 7:
                var ts = t[2], _S_ = caml_call1(Base_List[63], ts);
                return caml_call3(Base_List[20], _S_, ac, function(ac, t) {
                    return to_sexps_hum(t, ac);
                });
            default:
                var backtrace = t[2], t$2 = t[1], _T_1 = caml_call1(Base_String0[22], backtrace), _U_ = [
                    0,
                    caml_call2(Base_Import[149], Base_Import[136], _T_1),
                    0
                ];
                return [
                    0,
                    [
                        1,
                        [
                            0,
                            to_sexp_hum(t$2),
                            _U_
                        ]
                    ],
                    ac
                ];
        }
    }
    function to_sexp_hum(t) {
        var sexps = to_sexps_hum(t, 0);
        if (sexps && !sexps[2]) {
            var sexp = sexps[1];
            return sexp;
        }
        return [
            1,
            sexps
        ];
    }
    function globalize_info(param) {
        return param;
    }
    function compute_info$0(counter, info, stack) {
        var info$0 = info, stack$0 = stack;
        for(;;){
            var match = info$0[1];
            if (typeof match === "number") {
                if (counter >= 50) return caml_trampoline_return(compute_message, [
                    0,
                    _j_,
                    stack$0
                ]);
                var counter$0 = counter + 1 | 0;
                return compute_message(counter$0, _j_, stack$0);
            }
            if (0 !== match[0]) {
                var message = match[1];
                if (counter >= 50) return caml_trampoline_return(compute_message, [
                    0,
                    message,
                    stack$0
                ]);
                var counter$1 = counter + 1 | 0;
                return compute_message(counter$1, message, stack$0);
            }
            var cons = match[1];
            info$0[1] = 0;
            var stack$1 = [
                0,
                [
                    0,
                    info$0
                ],
                stack$0
            ];
            switch(cons[0]){
                case 0:
                    var lazy_info = cons[1];
                    try {
                        var _P_ = caml_obj_tag(lazy_info);
                        a: if (250 === _P_) var info$1 = lazy_info[1];
                        else {
                            if (246 !== _P_ && 244 !== _P_) {
                                var info$1 = lazy_info;
                                break a;
                            }
                            var info$1 = caml_call1(CamlinternalLazy[2], lazy_info);
                        }
                    } catch (exn$0) {
                        var exn = caml_wrap_exception(exn$0), _O_ = [
                            0,
                            caml_call1(Base_Exn[1], exn)
                        ];
                        if (counter >= 50) return caml_trampoline_return(compute_message, [
                            0,
                            _O_,
                            stack$1
                        ]);
                        var counter$2 = counter + 1 | 0;
                        return compute_message(counter$2, _O_, stack$1);
                    }
                    info$0 = info$1;
                    stack$0 = stack$1;
                    break;
                case 1:
                    var infos = cons[1], _Q_ = 0;
                    if (counter >= 50) return caml_trampoline_return(compute_info_list, [
                        0,
                        infos,
                        _Q_,
                        stack$1
                    ]);
                    var counter$3 = counter + 1 | 0;
                    return compute_info_list(counter$3, infos, _Q_, stack$1);
                case 2:
                    var info$2 = cons[3], arg = cons[2], tag = cons[1], stack$2 = [
                        0,
                        [
                            1,
                            tag,
                            arg
                        ],
                        stack$1
                    ];
                    info$0 = info$2;
                    stack$0 = stack$2;
                    break;
                default:
                    var info$3 = cons[2], tag$0 = cons[1], stack$3 = [
                        0,
                        [
                            2,
                            tag$0
                        ],
                        stack$1
                    ];
                    info$0 = info$3;
                    stack$0 = stack$3;
            }
        }
    }
    function compute_info(info, stack) {
        return caml_trampoline(compute_info$0(0, info, stack));
    }
    function compute_info_list(counter, fwd_prefix, rev_suffix, stack) {
        if (fwd_prefix) {
            var fwd_prefix$0 = fwd_prefix[2], info = fwd_prefix[1], _M_ = [
                0,
                [
                    3,
                    fwd_prefix$0,
                    rev_suffix
                ],
                stack
            ];
            if (counter >= 50) return caml_trampoline_return(compute_info$0, [
                0,
                info,
                _M_
            ]);
            var counter$1 = counter + 1 | 0;
            return compute_info$0(counter$1, info, _M_);
        }
        var infos = caml_call3(Base_List[20], rev_suffix, 0, function(tail, message) {
            if (7 !== message[0]) return [
                0,
                message,
                tail
            ];
            var messages = message[2];
            return caml_call2(Base_Import[111], messages, tail);
        }), _N_ = [
            7,
            0,
            infos
        ];
        if (counter >= 50) return caml_trampoline_return(compute_message, [
            0,
            _N_,
            stack
        ]);
        var counter$0 = counter + 1 | 0;
        return compute_message(counter$0, _N_, stack);
    }
    function compute_message(counter, message, stack) {
        var message$0 = message, stack$0 = stack;
        for(;;){
            if (!stack$0) return message$0;
            var match = stack$0[1];
            switch(match[0]){
                case 0:
                    var stack$1 = stack$0[2], info = match[1];
                    info[1] = [
                        1,
                        message$0
                    ];
                    stack$0 = stack$1;
                    break;
                case 1:
                    var stack$2 = stack$0[2], arg = match[2], tag = match[1], message$1 = [
                        6,
                        tag,
                        arg,
                        message$0
                    ];
                    message$0 = message$1;
                    stack$0 = stack$2;
                    break;
                case 2:
                    var stack$3 = stack$0[2], tag$0 = match[1], message$2 = [
                        5,
                        tag$0,
                        message$0
                    ];
                    message$0 = message$2;
                    stack$0 = stack$3;
                    break;
                default:
                    var stack$4 = stack$0[2], rev_suffix = match[2], fwd_prefix = match[1], _L_ = [
                        0,
                        message$0,
                        rev_suffix
                    ];
                    if (counter >= 50) return caml_trampoline_return(compute_info_list, [
                        0,
                        fwd_prefix,
                        _L_,
                        stack$4
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return compute_info_list(counter$0, fwd_prefix, _L_, stack$4);
            }
        }
    }
    function to_message(info) {
        return compute_info(info, 0);
    }
    function of_message(message) {
        return [
            0,
            [
                1,
                message
            ]
        ];
    }
    function of_cons(cons) {
        return [
            0,
            [
                0,
                cons
            ]
        ];
    }
    function of_lazy_cons(lazy_cons) {
        return of_cons([
            0,
            [
                246,
                function(_I_) {
                    var _J_ = caml_obj_tag(lazy_cons);
                    a: if (250 === _J_) var _K_ = lazy_cons[1];
                    else {
                        if (246 !== _J_ && 244 !== _J_) {
                            var _K_ = lazy_cons;
                            break a;
                        }
                        var _K_ = caml_call1(CamlinternalLazy[2], lazy_cons);
                    }
                    return of_cons(_K_);
                }
            ]
        ]);
    }
    function of_lazy_message(lazy_message) {
        return of_cons([
            0,
            [
                246,
                function(_F_) {
                    var _G_ = caml_obj_tag(lazy_message);
                    a: if (250 === _G_) var _H_ = lazy_message[1];
                    else {
                        if (246 !== _G_ && 244 !== _G_) {
                            var _H_ = lazy_message;
                            break a;
                        }
                        var _H_ = caml_call1(CamlinternalLazy[2], lazy_message);
                    }
                    return of_message(_H_);
                }
            ]
        ]);
    }
    function invariant(param) {
        return 0;
    }
    function sexp_of_t$0(t) {
        return to_sexp_hum(to_message(t));
    }
    function t_of_sexp(sexp) {
        return of_message([
            3,
            sexp
        ]);
    }
    function compare(t1, t2) {
        var _D_ = sexp_of_t$0(t2), _E_ = sexp_of_t$0(t1);
        return caml_call2(Base_Sexp[7], _E_, _D_);
    }
    function compare_local(t1, t2) {
        return compare(t1, t2);
    }
    function equal(t1, t2) {
        var _B_ = sexp_of_t$0(t2), _C_ = sexp_of_t$0(t1);
        return caml_call2(Base_Sexp[6], _C_, _B_);
    }
    function equal_local(t1, t2) {
        return equal(t1, t2);
    }
    function hash_fold_t(state, t) {
        var _A_ = sexp_of_t$0(t);
        return caml_call2(Base_Sexp[2], state, _A_);
    }
    function hash(t) {
        return caml_call3(Base_Hash[14], 0, hash_fold_t, t);
    }
    function to_string_hum(t) {
        var message = to_message(t);
        if (1 === message[0]) {
            var s = message[1];
            return s;
        }
        var _z_ = to_sexp_hum(message);
        return caml_call2(Base_Sexp[16], 0, _z_);
    }
    function to_string_mach(t) {
        var _y_ = sexp_of_t$0(t);
        return caml_call1(Base_Sexp[17], _y_);
    }
    function of_lazy(l) {
        return of_lazy_message([
            246,
            function(_v_) {
                var _w_ = caml_obj_tag(l);
                a: if (250 === _w_) var _x_ = l[1];
                else {
                    if (246 !== _w_ && 244 !== _w_) {
                        var _x_ = l;
                        break a;
                    }
                    var _x_ = caml_call1(CamlinternalLazy[2], l);
                }
                return [
                    1,
                    _x_
                ];
            }
        ]);
    }
    function of_lazy_sexp(l) {
        return of_lazy_message([
            246,
            function(_s_) {
                var _t_ = caml_obj_tag(l);
                a: if (250 === _t_) var _u_ = l[1];
                else {
                    if (246 !== _t_ && 244 !== _t_) {
                        var _u_ = l;
                        break a;
                    }
                    var _u_ = caml_call1(CamlinternalLazy[2], l);
                }
                return [
                    3,
                    _u_
                ];
            }
        ]);
    }
    function of_lazy_t(lazy_info) {
        return of_cons([
            0,
            lazy_info
        ]);
    }
    function of_string(message) {
        return of_message([
            1,
            message
        ]);
    }
    function createf(format) {
        return caml_call2(Base_Printf[4], of_string, format);
    }
    function of_thunk(f) {
        return of_lazy_message([
            246,
            function(param) {
                return [
                    1,
                    caml_call1(f, 0)
                ];
            }
        ]);
    }
    function create(here, strict, tag, x, sexp_of_x) {
        return strict ? of_message([
            4,
            tag,
            caml_call1(sexp_of_x, x),
            here
        ]) : of_lazy_message([
            246,
            function(param) {
                return [
                    4,
                    tag,
                    caml_call1(sexp_of_x, x),
                    here
                ];
            }
        ]);
    }
    function create_s(sexp) {
        return of_message([
            3,
            sexp
        ]);
    }
    function tag(t, tag) {
        return of_cons([
            3,
            tag,
            t
        ]);
    }
    function tag_s_lazy(t, tag) {
        return of_lazy_cons([
            246,
            function(_p_) {
                var _q_ = caml_obj_tag(tag);
                a: if (250 === _q_) var _r_ = tag[1];
                else {
                    if (246 !== _q_ && 244 !== _q_) {
                        var _r_ = tag;
                        break a;
                    }
                    var _r_ = caml_call1(CamlinternalLazy[2], tag);
                }
                return [
                    2,
                    cst,
                    _r_,
                    t
                ];
            }
        ]);
    }
    function tag_s(t, tag) {
        return of_cons([
            2,
            cst$0,
            tag,
            t
        ]);
    }
    function tag_arg(t, tag, x, sexp_of_x) {
        return of_lazy_cons([
            246,
            function(param) {
                return [
                    2,
                    tag,
                    caml_call1(sexp_of_x, x),
                    t
                ];
            }
        ]);
    }
    function of_list(ts) {
        return of_cons([
            1,
            ts
        ]);
    }
    var Exn = [
        248,
        "Base__Info.Exn",
        runtime.caml_fresh_oo_id(0)
    ], _k_ = [
        0,
        "src/info.ml",
        261,
        6
    ];
    caml_call4(Sexplib0_Sexp_conv[72][1], 0, 0, Exn, function(param) {
        if (param[1] !== Exn) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _k_
        ], 1);
        var t = param[2];
        return sexp_of_t$0(t);
    });
    function to_exn(info) {
        var _n_ = info[1];
        a: {
            if (typeof _n_ !== "number" && 1 === _n_[0]) {
                var _o_ = 1;
                break a;
            }
            var _o_ = 0;
        }
        if (!_o_) return [
            0,
            Exn,
            info
        ];
        var match = to_message(info);
        if (2 !== match[0]) return [
            0,
            Exn,
            info
        ];
        var exn = match[1];
        return exn;
    }
    function of_exn(backtrace, exn) {
        if (backtrace) {
            var match = backtrace[1];
            if (typeof match === "number") var _m_ = [
                0,
                caml_call1(Stdlib_Printexc[6], 0)
            ];
            else var s = match[2], _m_ = [
                0,
                s
            ];
            var backtrace$0 = _m_;
        } else var backtrace$0 = 0;
        if (exn[1] === Exn) {
            var t = exn[2];
            if (!backtrace$0) return t;
            var backtrace$1 = backtrace$0[1];
            return of_lazy_message([
                246,
                function(param) {
                    return [
                        8,
                        to_message(t),
                        backtrace$1
                    ];
                }
            ]);
        }
        if (!backtrace$0) return of_message([
            2,
            exn
        ]);
        var backtrace$2 = backtrace$0[1];
        return of_lazy_message([
            246,
            function(param) {
                return [
                    8,
                    [
                        3,
                        caml_call1(Base_Exn[1], exn)
                    ],
                    backtrace$2
                ];
            }
        ]);
    }
    function pp(ppf, t) {
        var _l_ = to_string_hum(t);
        return caml_call2(Stdlib_Format[13], ppf, _l_);
    }
    var include = caml_call1(Base_Pretty_printer[3], [
        0,
        pp,
        module_name
    ]), pp$0 = include[1], Base_Info = [
        0,
        compare,
        compare_local,
        equal,
        equal_local,
        globalize_info,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$0,
        t_sexp_grammar,
        invariant,
        to_string_hum,
        to_string_mach,
        of_string,
        of_lazy,
        of_lazy_sexp,
        of_thunk,
        of_lazy_t,
        create,
        create_s,
        createf,
        tag,
        tag_s,
        tag_s_lazy,
        tag_arg,
        of_list,
        of_exn,
        to_exn,
        pp$0,
        [
            0,
            sexp_of_t,
            to_message,
            of_message
        ]
    ];
    runtime.caml_register_global(30, Base_Info, "Base__Info");
    return;
})(globalThis);
//# 11914 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), t_sexp_grammar = [
        0,
        "Error.t"
    ], module_name = "Base.Error", Base_Info = global_data.Base__Info, Base_Pretty_printer = global_data.Base__Pretty_printer, compare = Base_Info[1], compare_local = Base_Info[2], equal = Base_Info[3], equal_local = Base_Info[4], globalize = Base_Info[5], hash_fold_t = Base_Info[6], hash = Base_Info[7], t_of_sexp = Base_Info[8], sexp_of_t = Base_Info[9], invariant = Base_Info[11], to_string_hum = Base_Info[12], to_string_mach = Base_Info[13], of_string = Base_Info[14], of_lazy = Base_Info[15], of_lazy_sexp = Base_Info[16], of_thunk = Base_Info[17], of_lazy_t = Base_Info[18], create = Base_Info[19], create_s = Base_Info[20], createf = Base_Info[21], tag = Base_Info[22], tag_s = Base_Info[23], tag_s_lazy = Base_Info[24], tag_arg = Base_Info[25], of_list = Base_Info[26], of_exn = Base_Info[27], to_exn = Base_Info[28], pp = Base_Info[29], Internal_repr = Base_Info[30];
    function raise(t) {
        throw caml_maybe_attach_backtrace(caml_call1(to_exn, t), 1);
    }
    function raise_s(sexp) {
        return raise(caml_call1(create_s, sexp));
    }
    function to_info(t) {
        return t;
    }
    function of_info(t) {
        return t;
    }
    var include = caml_call1(Base_Pretty_printer[3], [
        0,
        pp,
        module_name
    ]), pp$0 = include[1], Base_Error = [
        0,
        compare,
        compare_local,
        equal,
        equal_local,
        globalize,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        invariant,
        to_string_hum,
        to_string_mach,
        of_string,
        of_lazy,
        of_lazy_sexp,
        of_thunk,
        of_lazy_t,
        create,
        create_s,
        createf,
        tag,
        tag_s,
        tag_s_lazy,
        tag_arg,
        of_list,
        of_exn,
        to_exn,
        pp$0,
        Internal_repr,
        raise,
        raise_s,
        to_info,
        of_info
    ];
    runtime.caml_register_global(4, Base_Error, "Base__Error");
    return;
})(globalThis);
//# 12081 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_List = global_data.Base__List, Base_Error = global_data.Base__Error, Base_With_return = global_data.Base__With_return, Assert_failure = global_data.Assert_failure, Base_Result = global_data.Base__Result, Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, Base_Applicative = global_data.Base__Applicative;
    function compare_local(cmp_a, a_007, b_008) {
        return caml_call4(Base_Result[5], cmp_a, Base_Error[2], a_007, b_008);
    }
    function compare(cmp_a, a_001, b_002) {
        return caml_call4(Base_Result[4], cmp_a, Base_Error[1], a_001, b_002);
    }
    function equal_local(cmp_a, a_019, b_020) {
        return caml_call4(Base_Result[7], cmp_a, Base_Error[4], a_019, b_020);
    }
    function equal(cmp_a, a_013, b_014) {
        return caml_call4(Base_Result[6], cmp_a, Base_Error[3], a_013, b_014);
    }
    function globalize(globalize_a_026, x_027) {
        return caml_call3(Base_Result[9], globalize_a_026, Base_Error[5], x_027);
    }
    function hash_fold_t(hash_fold_a, hsv, arg) {
        return caml_call4(Base_Result[8], hash_fold_a, Base_Error[6], hsv, arg);
    }
    function t_of_sexp(of_a_030, x_032) {
        return caml_call3(Base_Result[1], of_a_030, Base_Error[8], x_032);
    }
    function sexp_of_t(of_a_033, x_034) {
        return caml_call3(Base_Result[2], of_a_033, Base_Error[9], x_034);
    }
    function t_sexp_grammar(a_sexp_grammar) {
        return caml_call2(Base_Result[3], a_sexp_grammar, Base_Error[10]);
    }
    var symbol_bind = Base_Result[10], symbol_map = Base_Result[11], bind = Base_Result[14], ignore_m = Base_Result[17], join = Base_Result[16], map = Base_Result[33], return$0 = Base_Result[15];
    function invariant(invariant_a, t) {
        if (0 === t[0]) {
            var a = t[1];
            return caml_call1(invariant_a, a);
        }
        var error = t[1];
        return caml_call1(Base_Error[11], error);
    }
    function map2(a, b, f) {
        if (0 === a[0]) {
            var x = a[1];
            if (0 === b[0]) {
                var y = b[1];
                return [
                    0,
                    caml_call2(f, x, y)
                ];
            }
            var e = b;
        } else {
            var e1 = a[1];
            if (0 !== b[0]) {
                var e2 = b[1];
                return [
                    1,
                    caml_call1(Base_Error[26], [
                        0,
                        e1,
                        [
                            0,
                            e2,
                            0
                        ]
                    ])
                ];
            }
            var e = a;
        }
        return e;
    }
    var map$0 = [
        0,
        -198771759,
        map
    ], For_applicative = caml_call1(Base_Applicative[16], [
        0,
        return$0,
        map2,
        map$0
    ]), symbol = For_applicative[6], symbol$0 = For_applicative[5], symbol$1 = For_applicative[4], apply = For_applicative[8], both = For_applicative[3], map3 = For_applicative[10], include = Base_Result[13], symbol_bind$0 = include[1], symbol_map$0 = include[2], Open_on_rhs = [
        0
    ], ok = Base_Result[26], is_ok = Base_Result[24], is_error = Base_Result[25], _a_ = [
        0,
        3553398
    ];
    function try_with(opt, f) {
        var backtrace = opt ? opt[1] : 0;
        try {
            var _n_ = [
                0,
                caml_call1(f, 0)
            ];
            return _n_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0), _m_ = backtrace ? _a_ : 0;
            return [
                1,
                caml_call2(Base_Error[27], _m_, exn)
            ];
        }
    }
    function try_with_join(backtrace, f) {
        return caml_call1(join, try_with(backtrace, f));
    }
    function ok_exn(param) {
        if (0 === param[0]) {
            var x = param[1];
            return x;
        }
        var err = param[1];
        return caml_call1(Base_Error[31], err);
    }
    function of_exn(backtrace, exn) {
        return [
            1,
            caml_call2(Base_Error[27], backtrace, exn)
        ];
    }
    function of_exn_result(backtrace, z) {
        if (0 === z[0]) return z;
        var exn = z[1];
        return of_exn(backtrace, exn);
    }
    var of_option = Base_Result[30], cst_unimplemented = "unimplemented", _b_ = [
        0,
        "src/or_error.ml",
        192,
        21
    ];
    function error(here, strict, message, a, sexp_of_a) {
        return [
            1,
            caml_call5(Base_Error[19], here, strict, message, a, sexp_of_a)
        ];
    }
    function error_s(sexp) {
        return [
            1,
            caml_call1(Base_Error[20], sexp)
        ];
    }
    function error_string(message) {
        return [
            1,
            caml_call1(Base_Error[14], message)
        ];
    }
    function errorf(format) {
        return caml_call2(Base_Printf[4], error_string, format);
    }
    function tag(t, tag) {
        var _k_ = Base_Error[22];
        return caml_call2(Base_Result[34], t, function(_l_) {
            return caml_call2(_k_, _l_, tag);
        });
    }
    function tag_s(t, tag) {
        var _i_ = Base_Error[23];
        return caml_call2(Base_Result[34], t, function(_j_) {
            return caml_call2(_i_, _j_, tag);
        });
    }
    function tag_s_lazy(t, tag) {
        var _g_ = Base_Error[24];
        return caml_call2(Base_Result[34], t, function(_h_) {
            return caml_call2(_g_, _h_, tag);
        });
    }
    function tag_arg(t, message, a, sexp_of_a) {
        return caml_call2(Base_Result[34], t, function(e) {
            return caml_call4(Base_Error[25], e, message, a, sexp_of_a);
        });
    }
    function unimplemented(s) {
        return error(0, 0, cst_unimplemented, s, Base_Import[136]);
    }
    function combine_internal(list, on_ok, on_error) {
        var match = caml_call1(Base_Result[36], list);
        if (0 === match[0]) {
            var x = match[1];
            return [
                0,
                caml_call1(on_ok, x)
            ];
        }
        var errs = match[1];
        return [
            1,
            caml_call1(on_error, errs)
        ];
    }
    function ignore_unit_list(param) {
        return 0;
    }
    function error_of_list_if_necessary(list) {
        if (list && !list[2]) {
            var e = list[1];
            return e;
        }
        return caml_call1(Base_Error[26], list);
    }
    function all(list) {
        return combine_internal(list, function(_f_) {
            return _f_;
        }, error_of_list_if_necessary);
    }
    function all_unit(list) {
        return combine_internal(list, ignore_unit_list, error_of_list_if_necessary);
    }
    function combine_errors(list) {
        return combine_internal(list, function(_e_) {
            return _e_;
        }, Base_Error[26]);
    }
    function combine_errors_unit(list) {
        return combine_internal(list, ignore_unit_list, Base_Error[26]);
    }
    function filter_ok_at_least_one(l) {
        var match = caml_call2(Base_List[16], l, Base_Result[38]), errs = match[2], ok = match[1];
        return ok ? [
            0,
            ok
        ] : [
            1,
            caml_call1(Base_Error[26], errs)
        ];
    }
    function find_ok(l) {
        var match = caml_call2(Base_List[28], l, Base_Result[26]);
        if (match) {
            var x = match[1];
            return [
                0,
                x
            ];
        }
        var _d_ = caml_call2(Base_List[53], l, function(param) {
            if (0 === param[0]) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _b_
            ], 1);
            var err = param[1];
            return err;
        });
        return [
            1,
            caml_call1(Base_Error[26], _d_)
        ];
    }
    function find_map_ok(l, f) {
        return caml_call1(Base_With_return[1], function(param) {
            var _c_ = caml_call2(Base_List[53], l, function(elt) {
                var x = caml_call1(f, elt);
                if (0 === x[0]) return caml_call1(param, x);
                var err = x[1];
                return err;
            });
            return [
                1,
                caml_call1(Base_Error[26], _c_)
            ];
        });
    }
    var map$1 = Base_Result[33], iter = Base_Result[31], iter_error = Base_Result[32], Base_Or_error = [
        0,
        compare,
        compare_local,
        equal,
        equal_local,
        globalize,
        hash_fold_t,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        both,
        symbol$1,
        symbol$0,
        symbol,
        apply,
        map2,
        map3,
        For_applicative[13],
        invariant,
        symbol_bind,
        symbol_map,
        Base_Result[13],
        bind,
        return$0,
        join,
        ignore_m,
        all,
        all_unit,
        [
            0,
            return$0,
            symbol_bind$0,
            symbol_map$0,
            [
                0,
                return$0,
                bind,
                map,
                both,
                Open_on_rhs
            ]
        ],
        is_ok,
        is_error,
        try_with,
        try_with_join,
        ok,
        ok_exn,
        of_exn,
        of_exn_result,
        of_option,
        error,
        error_s,
        error_string,
        errorf,
        tag,
        tag_s,
        tag_s_lazy,
        tag_arg,
        unimplemented,
        map$1,
        iter,
        iter_error,
        combine_errors,
        combine_errors_unit,
        filter_ok_at_least_one,
        find_ok,
        find_map_ok
    ];
    runtime.caml_register_global(11, Base_Or_error, "Base__Or_error");
    return;
})(globalThis);
//# 12405 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Neg = "Neg", cst_Pos = "Pos", cst_Zero = "Zero", cst_neg = "neg", cst_pos = "pos", cst_zero = "zero", caml_int_compare = runtime.caml_int_compare;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), error_source_003 = "sign0.ml.t", t_sexp_grammar = [
        3,
        [
            0,
            2,
            [
                0,
                [
                    1,
                    [
                        0,
                        cst_Neg,
                        0
                    ]
                ],
                [
                    0,
                    [
                        1,
                        [
                            0,
                            cst_Zero,
                            0
                        ]
                    ],
                    [
                        0,
                        [
                            1,
                            [
                                0,
                                cst_Pos,
                                0
                            ]
                        ],
                        0
                    ]
                ]
            ]
        ]
    ], all = [
        0,
        0,
        [
            0,
            1,
            [
                0,
                2,
                0
            ]
        ]
    ], module_name = "Base.Sign", Base_Import = global_data.Base__Import, Base_Poly0 = global_data.Base__Poly0, Base_Hash = global_data.Base__Hash, Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, _a_ = [
        0,
        cst_Neg
    ], _b_ = [
        0,
        cst_Zero
    ], _c_ = [
        0,
        cst_Pos
    ];
    function t_of_sexp(sexp_004) {
        a: {
            if (0 === sexp_004[0]) {
                var _f_ = sexp_004[1];
                b: if (_f_ !== cst_Neg) {
                    c: if (_f_ !== cst_Pos) {
                        if (_f_ !== cst_Zero) {
                            if (_f_ === cst_neg) break b;
                            if (_f_ === cst_pos) break c;
                            if (_f_ !== cst_zero) break a;
                        }
                        return 1;
                    }
                    return 2;
                }
                return 0;
            }
            var _g_ = sexp_004[1];
            if (!_g_) return caml_call2(Sexplib0_Sexp_conv_error[11], error_source_003, sexp_004);
            var _h_ = _g_[1];
            if (0 !== _h_[0]) return caml_call2(Sexplib0_Sexp_conv_error[10], error_source_003, sexp_004);
            var _i_ = _h_[1];
            b: if (_i_ !== cst_Neg) {
                c: if (_i_ !== cst_Pos) {
                    if (_i_ !== cst_Zero) {
                        if (_i_ === cst_neg) break b;
                        if (_i_ === cst_pos) break c;
                        if (_i_ !== cst_zero) break a;
                    }
                    return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_003, sexp_004);
                }
                return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_003, sexp_004);
            }
            return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_003, sexp_004);
        }
        return caml_call2(Sexplib0_Sexp_conv_error[12], error_source_003, sexp_004);
    }
    function sexp_of_t(param) {
        switch(param){
            case 0:
                return _a_;
            case 1:
                return _b_;
            default:
                return _c_;
        }
    }
    var compare_local = caml_int_compare;
    function compare(a, b) {
        return caml_int_compare(a, b);
    }
    function hash_fold_t(hsv, arg) {
        switch(arg){
            case 0:
                var _e_ = 0;
                break;
            case 1:
                var _e_ = 1;
                break;
            default:
                var _e_ = 2;
        }
        return caml_call2(Base_Hash[3], hsv, _e_);
    }
    function symbol(x, y) {
        return x < y ? 1 : 0;
    }
    function symbol$0(x, y) {
        return x <= y ? 1 : 0;
    }
    function symbol$1(x, y) {
        return x !== y ? 1 : 0;
    }
    function symbol$2(x, y) {
        return x === y ? 1 : 0;
    }
    function symbol$3(x, y) {
        return y < x ? 1 : 0;
    }
    function symbol$4(x, y) {
        return y <= x ? 1 : 0;
    }
    function ascending(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$0 = caml_int_compare;
    function equal(x, y) {
        return x === y ? 1 : 0;
    }
    function equal_local(x, y) {
        return x === y ? 1 : 0;
    }
    function max(x, y) {
        return y <= x ? x : y;
    }
    function min(x, y) {
        return x <= y ? x : y;
    }
    var Replace_polymorphic_compare = [
        0,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        ascending,
        descending,
        compare$0,
        equal,
        equal_local,
        max,
        min
    ];
    function of_string(s) {
        return t_of_sexp(caml_call1(Base_Import[136], s));
    }
    function to_string(t) {
        var _d_ = sexp_of_t(t);
        return caml_call1(Base_Import[160], _d_);
    }
    function to_int(param) {
        switch(param){
            case 0:
                return -1;
            case 1:
                return 0;
            default:
                return 1;
        }
    }
    function of_int(n) {
        return 0 <= n ? 0 === n ? 1 : 2 : 0;
    }
    var Base_Sign0 = [
        0,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        compare_local,
        compare,
        hash_fold_t,
        all,
        Replace_polymorphic_compare,
        of_string,
        to_string,
        to_int,
        to_int,
        module_name,
        of_int
    ];
    runtime.caml_register_global(23, Base_Sign0, "Base__Sign0");
    return;
})(globalThis);
//# 12574 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Comparable_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Comparable_intf, "Base__Comparable_intf");
    return;
})(globalThis);
//# 12585 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_clamp_requires_min_max$1 = "clamp requires [min <= max]", cst_max$1 = "max", cst_min$1 = "min", cst_src_comparable_ml = "src/comparable.ml", caml_compare = runtime.caml_compare, caml_equal = runtime.caml_equal, caml_greaterthan = runtime.caml_greaterthan, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Comparator = global_data.Base__Comparator, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Poly0 = global_data.Base__Poly0, Base_Sign0 = global_data.Base__Sign0, _a_ = [
        0,
        cst_src_comparable_ml,
        47,
        4
    ], cst_max = cst_max$1, cst_min = cst_min$1, cst_clamp_requires_min_max = cst_clamp_requires_min_max$1, _b_ = [
        0,
        cst_src_comparable_ml,
        135,
        4
    ], cst_max$0 = cst_max$1, cst_min$0 = cst_min$1, cst_clamp_requires_min_max$0 = cst_clamp_requires_min_max$1;
    function geq(cmp, a, b) {
        return 0 <= caml_call2(cmp, a, b) ? 1 : 0;
    }
    function leq(cmp, a, b) {
        return caml_call2(cmp, a, b) <= 0 ? 1 : 0;
    }
    function equal(cmp, a, b) {
        return 0 === caml_call2(cmp, a, b) ? 1 : 0;
    }
    function min(cmp, t$0, t) {
        return leq(cmp, t$0, t) ? t$0 : t;
    }
    function max(cmp, t$0, t) {
        return geq(cmp, t$0, t) ? t$0 : t;
    }
    function Infix(T) {
        function symbol(a, b) {
            var cmp = T[1];
            return 0 < caml_call2(cmp, a, b) ? 1 : 0;
        }
        function symbol$0(a, b) {
            var cmp = T[1];
            return caml_call2(cmp, a, b) < 0 ? 1 : 0;
        }
        function symbol$1(a, b) {
            return geq(T[1], a, b);
        }
        function symbol$2(a, b) {
            return leq(T[1], a, b);
        }
        function symbol$3(a, b) {
            return equal(T[1], a, b);
        }
        function symbol$4(a, b) {
            var cmp = T[1];
            return 0 !== caml_call2(cmp, a, b) ? 1 : 0;
        }
        return [
            0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol,
            symbol$0,
            symbol$4
        ];
    }
    function Comparisons(T) {
        var include = Infix(T), symbol = include[1], symbol$0 = include[2], symbol$1 = include[3], symbol$2 = include[4], symbol$3 = include[5], symbol$4 = include[6], compare = T[1];
        function min$0(t$0, t) {
            return min(compare, t$0, t);
        }
        function max$0(t$0, t) {
            return max(compare, t$0, t);
        }
        return [
            0,
            symbol,
            symbol$0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            symbol$1,
            compare,
            min$0,
            max$0
        ];
    }
    function Make_using_comparator(T) {
        var sexp_of_t = T[1], comparator = T[2], compare = comparator[1], Replace_polymorphic_compare = Comparisons([
            0,
            compare
        ]), symbol = Replace_polymorphic_compare[1], symbol$0 = Replace_polymorphic_compare[2], symbol$1 = Replace_polymorphic_compare[3], symbol$2 = Replace_polymorphic_compare[4], symbol$3 = Replace_polymorphic_compare[5], symbol$4 = Replace_polymorphic_compare[6], equal = Replace_polymorphic_compare[7], compare$0 = Replace_polymorphic_compare[8], min = Replace_polymorphic_compare[9], max = Replace_polymorphic_compare[10];
        function descending(t$0, t) {
            return caml_call2(compare$0, t, t$0);
        }
        function between(t, low, high) {
            var _r_ = caml_call2(symbol$0, low, t);
            return _r_ ? caml_call2(symbol$0, t, high) : _r_;
        }
        function clamp_unchecked(t, min, max) {
            return caml_call2(symbol$3, t, min) ? min : caml_call2(symbol$0, t, max) ? t : max;
        }
        function clamp_exn(t, min, max) {
            if (caml_call2(symbol$0, min, max)) return clamp_unchecked(t, min, max);
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _b_
            ], 1);
        }
        function clamp(t, min, max) {
            if (!caml_call2(symbol$2, min, max)) return [
                0,
                clamp_unchecked(t, min, max)
            ];
            var _o_ = [
                0,
                [
                    0,
                    cst_max$0,
                    caml_call1(sexp_of_t, max)
                ],
                0
            ], _p_ = [
                0,
                [
                    0,
                    cst_min$0,
                    caml_call1(sexp_of_t, min)
                ],
                _o_
            ], _q_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max$0, _p_);
            return caml_call1(Base_Or_error[39], _q_);
        }
        return [
            0,
            symbol,
            symbol$0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            equal,
            compare$0,
            min,
            max,
            compare$0,
            descending,
            between,
            clamp_exn,
            clamp,
            comparator
        ];
    }
    function Make(T) {
        var sexp_of_t = T[2], include = caml_call1(Base_Comparator[7], T), comparator = include[1];
        return Make_using_comparator([
            0,
            sexp_of_t,
            comparator
        ]);
    }
    function Inherit(C, T) {
        var sexp_of_t = T[1];
        function compare(t$0, t) {
            var _m_ = caml_call1(T[2], t), _n_ = caml_call1(T[2], t$0);
            return caml_call2(C[1], _n_, _m_);
        }
        return Make([
            0,
            compare,
            sexp_of_t
        ]);
    }
    function lexicographic(cmps, x, y) {
        var param = cmps;
        for(;;){
            if (!param) return 0;
            var cmps$0 = param[2], cmp = param[1], res = caml_call2(cmp, x, y);
            if (0 !== res) return res;
            param = cmps$0;
        }
    }
    function lift(cmp, f, x, y) {
        var _l_ = caml_call1(f, y);
        return caml_call2(cmp, caml_call1(f, x), _l_);
    }
    function reverse(cmp, x, y) {
        return caml_call2(cmp, y, x);
    }
    function compare_reversed(cmp, x, y) {
        return caml_call2(cmp, y, x);
    }
    var Base_Comparable = [
        0,
        lexicographic,
        lift,
        reverse,
        compare_reversed,
        equal,
        max,
        min,
        Infix,
        Comparisons,
        Inherit,
        Make,
        Make_using_comparator,
        function(T) {
            var sexp_of_t = T[1], ascending = Base_Poly0[1], descending = Base_Poly0[2], min = Base_Poly0[3], max = Base_Poly0[4];
            function between(t, low, high) {
                var _j_ = caml_lessequal(low, t), _k_ = _j_ ? caml_lessequal(t, high) : _j_;
                return _k_;
            }
            function clamp_unchecked(t, min, max) {
                return caml_lessthan(t, min) ? min : caml_lessequal(t, max) ? t : max;
            }
            function clamp_exn(t, min, max) {
                if (caml_lessequal(min, max)) return clamp_unchecked(t, min, max);
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _a_
                ], 1);
            }
            function clamp(t, min, max) {
                if (!caml_greaterthan(min, max)) return [
                    0,
                    clamp_unchecked(t, min, max)
                ];
                var _g_ = [
                    0,
                    [
                        0,
                        cst_max,
                        caml_call1(T[1], max)
                    ],
                    0
                ], _h_ = [
                    0,
                    [
                        0,
                        cst_min,
                        caml_call1(T[1], min)
                    ],
                    _g_
                ], _i_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _h_);
                return caml_call1(Base_Or_error[39], _i_);
            }
            var include = caml_call1(Base_Comparator[7], [
                0,
                caml_compare,
                sexp_of_t
            ]), comparator = include[1];
            return [
                0,
                runtime.caml_greaterequal,
                caml_lessequal,
                caml_equal,
                caml_greaterthan,
                caml_lessthan,
                runtime.caml_notequal,
                caml_equal,
                caml_compare,
                min,
                max,
                ascending,
                descending,
                between,
                clamp_exn,
                clamp,
                comparator
            ];
        },
        function(_c_) {
            var _d_ = _c_[3], _e_ = _c_[1];
            function is_positive(t) {
                return 0 < caml_call2(_e_, t, _d_) ? 1 : 0;
            }
            function is_non_negative(t) {
                return 0 <= caml_call2(_e_, t, _d_) ? 1 : 0;
            }
            function is_negative(t) {
                return caml_call2(_e_, t, _d_) < 0 ? 1 : 0;
            }
            function is_non_positive(t) {
                return caml_call2(_e_, t, _d_) <= 0 ? 1 : 0;
            }
            function sign(t) {
                var _f_ = caml_call2(_e_, t, _d_);
                return caml_call1(Base_Sign0[14], _f_);
            }
            return [
                0,
                is_positive,
                is_non_negative,
                is_negative,
                is_non_positive,
                sign
            ];
        }
    ];
    runtime.caml_register_global(14, Base_Comparable, "Base__Comparable");
    return;
})(globalThis);
//# 12854 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import;
    function equal(a, b) {
        var _b_ = a === b ? 1 : 0;
        if (_b_) var _c_ = _b_;
        else {
            var _d_ = a[1] === b[1] ? 1 : 0;
            if (_d_) var _e_ = a[2] === b[2] ? 1 : 0, _c_ = _e_ ? a[3] === b[3] ? 1 : 0 : _e_;
            else var _c_ = _d_;
        }
        return _c_;
    }
    var hash_param = Base_Import[85][105][30], hash = Base_Import[85][105][28], _a_ = [
        0,
        "_"
    ], poly = [
        0,
        hash,
        runtime.caml_compare,
        function(param) {
            return _a_;
        }
    ];
    function of_key(Key) {
        return [
            0,
            Key[3],
            Key[1],
            Key[2]
        ];
    }
    function to_key(param) {
        var sexp_of_t = param[3], compare = param[2], hash = param[1];
        return [
            0,
            compare,
            sexp_of_t,
            hash
        ];
    }
    var Hashable = [
        0,
        equal,
        hash_param,
        hash,
        poly,
        of_key,
        to_key
    ], equal$0 = Hashable[1], hash_param$0 = Hashable[2], hash$0 = Hashable[3], poly$0 = Hashable[4], of_key$0 = Hashable[5], to_key$0 = Hashable[6], Base_Hashable_intf = [
        0,
        Hashable,
        equal$0,
        hash_param$0,
        hash$0,
        poly$0,
        of_key$0,
        to_key$0
    ];
    runtime.caml_register_global(2, Base_Hashable_intf, "Base__Hashable_intf");
    return;
})(globalThis);
//# 12903 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Base_Hashable_intf = global_data.Base__Hashable_intf, equal = Base_Hashable_intf[2], hash_param = Base_Hashable_intf[3], hash = Base_Hashable_intf[4], poly = Base_Hashable_intf[5], of_key = Base_Hashable_intf[6], to_key = Base_Hashable_intf[7], Base_Hashable = [
        0,
        equal,
        poly,
        of_key,
        to_key,
        hash_param,
        hash
    ];
    runtime.caml_register_global(1, Base_Hashable, "Base__Hashable");
    return;
})(globalThis);
//# 12932 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Identifiable_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Identifiable_intf, "Base__Identifiable_intf");
    return;
})(globalThis);
//# 12943 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Comparable = global_data.Base__Comparable, Base_Pretty_printer = global_data.Base__Pretty_printer, Base_Identifiable = [
        0,
        function(T) {
            var hash_fold_t = T[2], hash = T[3], t_of_sexp = T[4], sexp_of_t = T[5], of_string = T[6], to_string = T[7], _b_ = caml_call1(Base_Comparable[11], [
                0,
                T[1],
                T[5]
            ]), symbol = _b_[1], symbol$0 = _b_[2], symbol$1 = _b_[3], symbol$2 = _b_[4], symbol$3 = _b_[5], symbol$4 = _b_[6], equal = _b_[7], compare = _b_[8], min = _b_[9], max = _b_[10], ascending = _b_[11], descending = _b_[12], between = _b_[13], clamp_exn = _b_[14], clamp = _b_[15], comparator = _b_[16], include = caml_call1(Base_Pretty_printer[2], [
                0,
                T[8],
                T[7]
            ]), pp = include[1], hashable = [
                0,
                hash,
                compare,
                sexp_of_t
            ];
            return [
                0,
                hash_fold_t,
                hash,
                t_of_sexp,
                sexp_of_t,
                of_string,
                to_string,
                symbol,
                symbol$0,
                symbol$1,
                symbol$2,
                symbol$3,
                symbol$4,
                equal,
                compare,
                min,
                max,
                ascending,
                descending,
                between,
                clamp_exn,
                clamp,
                comparator,
                pp,
                hashable
            ];
        },
        function(T) {
            var hash_fold_t = T[2], hash = T[3], t_of_sexp = T[4], sexp_of_t = T[5], of_string = T[6], to_string = T[7], _a_ = caml_call1(Base_Comparable[12], [
                0,
                T[5],
                T[9]
            ]), symbol = _a_[1], symbol$0 = _a_[2], symbol$1 = _a_[3], symbol$2 = _a_[4], symbol$3 = _a_[5], symbol$4 = _a_[6], equal = _a_[7], compare = _a_[8], min = _a_[9], max = _a_[10], ascending = _a_[11], descending = _a_[12], between = _a_[13], clamp_exn = _a_[14], clamp = _a_[15], comparator = _a_[16], include = caml_call1(Base_Pretty_printer[2], [
                0,
                T[8],
                T[7]
            ]), pp = include[1], hashable = [
                0,
                hash,
                compare,
                sexp_of_t
            ];
            return [
                0,
                hash_fold_t,
                hash,
                t_of_sexp,
                sexp_of_t,
                of_string,
                to_string,
                symbol,
                symbol$0,
                symbol$1,
                symbol$2,
                symbol$3,
                symbol$4,
                equal,
                compare,
                min,
                max,
                ascending,
                descending,
                between,
                clamp_exn,
                clamp,
                comparator,
                pp,
                hashable
            ];
        }
    ];
    runtime.caml_register_global(2, Base_Identifiable, "Base__Identifiable");
    return;
})(globalThis);
//# 13073 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$0 = "()";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = cst$0, all = [
        0,
        0,
        0
    ], module_name = "Base.Unit", Base_Import = global_data.Base__Import, Base_Identifiable = global_data.Base__Identifiable, globalize = Base_Import[290], hash_fold_t = Base_Import[210], func = Base_Import[224];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[158], sexp_of_t = Base_Import[134], t_sexp_grammar = Base_Import[180], cst_Base_Unit_of_string_expect = "Base.Unit.of_string: () expected";
    function compare(_c_, param) {
        return 0;
    }
    function compare_local(_b_, param) {
        return 0;
    }
    function equal_local(_a_, param) {
        return 1;
    }
    function of_string(param) {
        return param !== cst$0 ? caml_call1(Base_Import[124], cst_Base_Unit_of_string_expect) : 0;
    }
    function to_string(param) {
        return cst;
    }
    var include = caml_call1(Base_Identifiable[1], [
        0,
        compare,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        of_string,
        to_string,
        module_name
    ]), hash_fold_t$0 = include[1], hash$0 = include[2], t_of_sexp$0 = include[3], sexp_of_t$0 = include[4], of_string$0 = include[5], to_string$0 = include[6], symbol = include[7], symbol$0 = include[8], symbol$1 = include[9], symbol$2 = include[10], symbol$3 = include[11], symbol$4 = include[12], equal = include[13], compare$0 = include[14], min = include[15], max = include[16], ascending = include[17], descending = include[18], between = include[19], clamp_exn = include[20], clamp = include[21], comparator = include[22], pp = include[23], hashable = include[24];
    function invariant(param) {
        return 0;
    }
    var Base_Unit = [
        0,
        all,
        globalize,
        t_sexp_grammar,
        hash_fold_t$0,
        hash$0,
        t_of_sexp$0,
        sexp_of_t$0,
        of_string$0,
        to_string$0,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        equal,
        compare$0,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        equal_local,
        compare_local,
        invariant
    ];
    runtime.caml_register_global(7, Base_Unit, "Base__Unit");
    return;
})(globalThis);
//# 13185 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Base_Error = global_data.Base__Error, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common0, get_pos_len_exn = Base_Ordered_collection_common[1], check_pos_len_exn = Base_Ordered_collection_common[2], Private = Base_Ordered_collection_common[3];
    function get_pos_len(pos, len, param, total_length) {
        try {
            var _a_ = [
                0,
                caml_call4(get_pos_len_exn, pos, len, 0, total_length)
            ];
            return _a_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Stdlib[6]) throw caml_maybe_attach_backtrace(exn, 0);
            var s = exn[2];
            return [
                1,
                caml_call1(Base_Error[14], s)
            ];
        }
    }
    var Base_Ordered_collection_common$0 = [
        0,
        get_pos_len_exn,
        check_pos_len_exn,
        Private,
        get_pos_len
    ];
    runtime.caml_register_global(3, Base_Ordered_collection_common$0, "Base__Ordered_collection_common");
    return;
})(globalThis);
//# 13234 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common;
    function find_first_satisfying(pos, len, t, get, length, pred) {
        var _e_ = caml_call1(length, t), match = caml_call4(Base_Ordered_collection_common[1], pos, len, 0, _e_), len$0 = match[2], pos$0 = match[1], _f_ = caml_call2(Base_Import[91], pos$0, len$0), hi$0 = caml_call2(Base_Import[93], _f_, 1), lo$1 = pos$0, hi = hi$0;
        for(;;){
            if (8 >= caml_call2(Base_Import[93], hi, lo$1)) break;
            var _c_ = caml_call2(Base_Import[93], hi, lo$1), _d_ = caml_call2(Base_Import[95], _c_, 2), mid = caml_call2(Base_Import[91], lo$1, _d_);
            if (caml_call1(pred, caml_call2(get, t, mid))) hi = mid;
            else {
                var lo$2 = caml_call2(Base_Import[91], mid, 1);
                lo$1 = lo$2;
            }
        }
        var lo = lo$1;
        for(;;){
            if (hi < lo) return 0;
            if (caml_call1(pred, caml_call2(get, t, lo))) return [
                0,
                lo
            ];
            var lo$0 = caml_call2(Base_Import[91], lo, 1);
            lo = lo$0;
        }
    }
    function find_last_satisfying(pos, len, t, pred, get, length) {
        var _a_ = caml_call1(length, t), match = caml_call4(Base_Ordered_collection_common[1], pos, len, 0, _a_), len$0 = match[2], pos$0 = match[1];
        if (0 === len$0) return 0;
        var match$0 = find_first_satisfying([
            0,
            pos$0
        ], [
            0,
            len$0
        ], t, get, length, function(x) {
            return 1 - caml_call1(pred, x);
        });
        if (match$0) {
            var i = match$0[1];
            return i === pos$0 ? 0 : [
                0,
                caml_call2(Base_Import[93], i, 1)
            ];
        }
        var _b_ = caml_call2(Base_Import[91], pos$0, len$0);
        return [
            0,
            caml_call2(Base_Import[93], _b_, 1)
        ];
    }
    function binary_search(pos, len, t, length, get, compare, how, v) {
        if (-839473056 <= how) return 200870407 <= how ? 926943384 <= how ? find_first_satisfying(pos, len, t, get, length, function(x) {
            return 0 <= caml_call2(compare, x, v) ? 1 : 0;
        }) : find_last_satisfying(pos, len, t, function(x) {
            return caml_call2(compare, x, v) < 0 ? 1 : 0;
        }, get, length) : -253007807 <= how ? find_last_satisfying(pos, len, t, function(x) {
            return caml_call2(compare, x, v) <= 0 ? 1 : 0;
        }, get, length) : find_first_satisfying(pos, len, t, get, length, function(x) {
            return 0 < caml_call2(compare, x, v) ? 1 : 0;
        });
        if (-1055410545 <= how) {
            var match = find_last_satisfying(pos, len, t, function(x) {
                return caml_call2(compare, x, v) <= 0 ? 1 : 0;
            }, get, length);
            if (match) {
                var x = match[1];
                if (0 === caml_call2(compare, caml_call2(get, t, x), v)) return [
                    0,
                    x
                ];
            }
            return 0;
        }
        var match$0 = find_first_satisfying(pos, len, t, get, length, function(x) {
            return 0 <= caml_call2(compare, x, v) ? 1 : 0;
        });
        if (match$0) {
            var x$0 = match$0[1];
            if (0 === caml_call2(compare, caml_call2(get, t, x$0), v)) return [
                0,
                x$0
            ];
        }
        return 0;
    }
    function binary_search_segmented(pos, len, t, length, get, segment_of, how) {
        function is_left(x) {
            return 847852583 <= caml_call1(segment_of, x) ? 1 : 0;
        }
        function is_right(x) {
            return 1 - is_left(x);
        }
        return 125585502 <= how ? find_last_satisfying(pos, len, t, is_left, get, length) : find_first_satisfying(pos, len, t, get, length, is_right);
    }
    var Base_Binary_search = [
        0,
        binary_search,
        binary_search_segmented
    ];
    runtime.caml_register_global(2, Base_Binary_search, "Base__Binary_search");
    return;
})(globalThis);
//# 13392 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, all = [
        0,
        200870407,
        [
            0,
            -253007807,
            [
                0,
                -1055410545,
                [
                    0,
                    -1056898635,
                    [
                        0,
                        926943384,
                        [
                            0,
                            -839473056,
                            0
                        ]
                    ]
                ]
            ]
        ]
    ], all$0 = [
        0,
        125585502,
        [
            0,
            -63348021,
            0
        ]
    ], Which_target_by_key = [
        0,
        all
    ], Which_target_by_segment = [
        0,
        all$0
    ], Base_Binary_searchable_intf = [
        0,
        Which_target_by_key,
        Which_target_by_segment
    ];
    runtime.caml_register_global(2, Base_Binary_searchable_intf, "Base__Binary_searchable_intf");
    return;
})(globalThis);
//# 13415 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    function caml_call8(f, a0, a1, a2, a3, a4, a5, a6, a7) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 8 ? f(a0, a1, a2, a3, a4, a5, a6, a7) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Base_Binary_search = global_data.Base__Binary_search;
    function Make_gen(T) {
        var get = T[1], length = T[2];
        function binary_search(pos, len, t, compare, how, v) {
            return caml_call8(Base_Binary_search[1], pos, len, t, length, get, compare, how, v);
        }
        function binary_search_segmented(pos, len, t, segment_of, how) {
            return caml_call7(Base_Binary_search[2], pos, len, t, length, get, segment_of, how);
        }
        return [
            0,
            ,
            ,
            binary_search,
            binary_search_segmented
        ];
    }
    var Base_Binary_searchable = [
        0,
        function(T) {
            var get = T[1], length = T[2], _b_ = Make_gen([
                0,
                get,
                length
            ]);
            return [
                0,
                _b_[3],
                _b_[4]
            ];
        },
        function(T) {
            var get = T[1], length = T[2], _a_ = Make_gen([
                0,
                get,
                length
            ]);
            return [
                0,
                _a_[3],
                _a_[4]
            ];
        }
    ];
    runtime.caml_register_global(1, Base_Binary_searchable, "Base__Binary_searchable");
    return;
})(globalThis);
//# 13478 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Blit_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Blit_intf, "Base__Blit_intf");
    return;
})(globalThis);
//# 13488 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bytes_unsafe_get = runtime.caml_bytes_unsafe_get, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_ml_bytes_length = runtime.caml_ml_bytes_length;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Base_Sys0 = global_data.Base__Sys0, Base_Uchar0 = global_data.Base__Uchar0, Base_Int_conversions = global_data.Base__Int_conversions, Stdlib_BytesLabels = global_data.Stdlib__BytesLabels, Primitives = [
        0
    ], max_length = Base_Sys0[10], blit = Stdlib_BytesLabels[11], blit_string = Stdlib_BytesLabels[12], compare = Stdlib_BytesLabels[40], copy = Stdlib_BytesLabels[4], create = caml_create_bytes, set_uchar_utf_8 = Stdlib_BytesLabels[51], set_uchar_utf_16le = Stdlib_BytesLabels[57], set_uchar_utf_16be = Stdlib_BytesLabels[54];
    function set_utf_32_uchar(set_int32, bytes, idx, uchar) {
        var _o_ = caml_call1(Base_Uchar0[8], uchar), _p_ = caml_call1(Base_Int_conversions[3], _o_);
        caml_call1(caml_call2(set_int32, bytes, idx), _p_);
        return 4;
    }
    var _a_ = Stdlib_BytesLabels[83];
    function set_uchar_utf_32le(_l_, _m_, _n_) {
        return set_utf_32_uchar(_a_, _l_, _m_, _n_);
    }
    var _b_ = Stdlib_BytesLabels[82], cst_Bytes_create_local = "Bytes.create_local";
    function set_uchar_utf_32be(_i_, _j_, _k_) {
        return set_utf_32_uchar(_b_, _i_, _j_, _k_);
    }
    function create_local(len) {
        if (Base_Sys0[10] < len) caml_call1(Base_Import0[126], cst_Bytes_create_local);
        return runtime.Base_unsafe_create_local_bytes(len);
    }
    var fill = Stdlib_BytesLabels[10], make = Stdlib_BytesLabels[1];
    function map(t, f) {
        var l = caml_ml_bytes_length(t);
        if (0 === l) return t;
        var r = caml_create_bytes(l), _g_ = caml_call2(Base_Import0[93], l, 1), _f_ = 0;
        if (_g_ >= 0) {
            var i = _f_;
            for(;;){
                caml_bytes_unsafe_set(r, i, caml_call1(f, caml_bytes_unsafe_get(t, i)));
                var _h_ = i + 1 | 0;
                if (_g_ === i) break;
                i = _h_;
            }
        }
        return r;
    }
    function mapi(t, f) {
        var l = caml_ml_bytes_length(t);
        if (0 === l) return t;
        var r = caml_create_bytes(l), _d_ = caml_call2(Base_Import0[93], l, 1), _c_ = 0;
        if (_d_ >= 0) {
            var i = _c_;
            for(;;){
                caml_bytes_unsafe_set(r, i, caml_call2(f, i, caml_bytes_unsafe_get(t, i)));
                var _e_ = i + 1 | 0;
                if (_d_ === i) break;
                i = _e_;
            }
        }
        return r;
    }
    var sub = Stdlib_BytesLabels[7], to_string = Stdlib_BytesLabels[6], of_string = Stdlib_BytesLabels[5], Base_Bytes0 = [
        0,
        Primitives,
        max_length,
        blit,
        blit_string,
        compare,
        copy,
        create,
        set_uchar_utf_8,
        set_uchar_utf_16le,
        set_uchar_utf_16be,
        set_utf_32_uchar,
        set_uchar_utf_32le,
        set_uchar_utf_32be,
        create_local,
        fill,
        make,
        map,
        mapi,
        sub,
        to_string,
        of_string
    ];
    runtime.caml_register_global(6, Base_Bytes0, "Base__Bytes0");
    return;
})(globalThis);
//# 13618 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_string_of_bytes = runtime.caml_string_of_bytes;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common;
    function Make_gen(Src, Dst) {
        var unsafe_blit = Dst[3];
        function blit(src, src_pos, dst, dst_pos, len) {
            var _l_ = caml_call1(Src[1], src);
            caml_call3(Base_Ordered_collection_common[2], src_pos, len, _l_);
            var _m_ = caml_call1(Dst[1], dst);
            caml_call3(Base_Ordered_collection_common[2], dst_pos, len, _m_);
            var _n_ = 0 < len ? 1 : 0;
            return _n_ ? caml_call5(unsafe_blit, src, src_pos, dst, dst_pos, len) : _n_;
        }
        function blito(src, _j_, _i_, dst, opt, param) {
            var src_pos = _j_ ? _j_[1] : 0;
            if (_i_) var src_len = _i_[1];
            else var _k_ = caml_call1(Src[1], src), src_len = caml_call2(Base_Import[93], _k_, src_pos);
            var dst_pos = opt ? opt[1] : 0;
            return blit(src, src_pos, dst, dst_pos, src_len);
        }
        function sub(src, pos, len) {
            var _h_ = caml_call1(Src[1], src);
            caml_call3(Base_Ordered_collection_common[2], pos, len, _h_);
            var dst = caml_call2(Dst[2], len, src);
            if (0 < len) caml_call5(unsafe_blit, src, pos, dst, 0, len);
            return dst;
        }
        function subo(opt, len, src) {
            var pos = opt ? opt[1] : 0;
            if (len) var i = len[1], i$0 = i;
            else var _g_ = caml_call1(Src[1], src), i$0 = caml_call2(Base_Import[93], _g_, pos);
            return sub(src, pos, i$0);
        }
        return [
            0,
            unsafe_blit,
            blit,
            blito,
            sub,
            subo
        ];
    }
    function Make_to_string(T, To_bytes) {
        function sub(src, pos, len) {
            return caml_string_of_bytes(caml_call3(To_bytes[4], src, pos, len));
        }
        function subo(pos, len, src) {
            return caml_string_of_bytes(caml_call3(To_bytes[5], pos, len, src));
        }
        return [
            0,
            sub,
            subo
        ];
    }
    var Base_Blit = [
        0,
        function(Sequence) {
            function create_like(len, param) {
                return caml_call1(Sequence[2], len);
            }
            var length = Sequence[1], unsafe_blit = Sequence[3], include = Make_gen([
                0,
                length
            ], [
                0,
                length,
                create_like,
                unsafe_blit
            ]), unsafe_blit$0 = include[1], blit = include[2], blito = include[3], sub = include[4], subo = include[5];
            return [
                0,
                blit,
                blito,
                unsafe_blit$0,
                sub,
                subo
            ];
        },
        function(Src, Dst) {
            var length = Dst[1];
            function create_like(len, param) {
                return caml_call1(Dst[2], len);
            }
            var unsafe_blit = Dst[3], length$0 = Src[1], _f_ = Make_gen([
                0,
                length$0
            ], [
                0,
                length,
                create_like,
                unsafe_blit
            ]);
            return [
                0,
                _f_[2],
                _f_[3],
                _f_[1],
                _f_[4],
                _f_[5]
            ];
        },
        Make_to_string,
        function(_c_) {
            var _d_ = [
                0,
                _c_[2],
                _c_[1],
                _c_[3]
            ], _e_ = Make_gen([
                0,
                _d_[1]
            ], _d_);
            return [
                0,
                _e_[2],
                _e_[3],
                _e_[1],
                _e_[4],
                _e_[5]
            ];
        },
        function(_a_) {
            var _b_ = Make_gen([
                0,
                _a_[2]
            ], [
                0,
                _a_[2],
                _a_[1],
                _a_[3]
            ]);
            return [
                0,
                _b_[2],
                _b_[3],
                _b_[1],
                _b_[4],
                _b_[5]
            ];
        }
    ];
    runtime.caml_register_global(2, Base_Blit, "Base__Blit");
    return;
})(globalThis);
//# 13744 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_bool_ml = "src/bool.ml", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), all = [
        0,
        0,
        [
            0,
            1,
            0
        ]
    ], module_name = "Base.Bool", Base_Import = global_data.Base__Import, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Printf = global_data.Base__Printf, Base_Comparator = global_data.Base__Comparator, Base_Pretty_printer = global_data.Base__Pretty_printer, invalid_argf = Base_Printf[7], compare = Base_Import[225], globalize = Base_Import[281], hash_fold_t = Base_Import[207], func = Base_Import[221];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[159], sexp_of_t = Base_Import[135], t_sexp_grammar = Base_Import[181], hashable = [
        0,
        hash,
        compare,
        sexp_of_t
    ], _a_ = [
        0,
        [
            11,
            "Bool.of_string: expected true or false but got ",
            [
                2,
                0,
                0
            ]
        ],
        "Bool.of_string: expected true or false but got %s"
    ];
    function of_string(s) {
        return s !== "false" ? s !== "true" ? caml_call3(invalid_argf, _a_, s, 0) : 1 : 0;
    }
    var to_string = Base_Import[85][30], include = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ]), comparator = include[1], include$0 = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name,
        to_string
    ]), pp = include$0[1], _b_ = [
        0,
        cst_src_bool_ml,
        59,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function invariant(param) {
        return 0;
    }
    function between(t, low, high) {
        var _k_ = caml_call2(Base_Import[105][2], low, t);
        return _k_ ? caml_call2(Base_Import[105][2], t, high) : _k_;
    }
    function clamp_unchecked(t, min, max) {
        return caml_call2(Base_Import[105][1], t, min) ? min : caml_call2(Base_Import[105][2], t, max) ? t : max;
    }
    function clamp_exn(t, min, max) {
        if (caml_call2(Base_Import[105][2], min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_call2(Base_Import[105][5], min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _h_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _i_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _h_
        ], _j_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _i_);
        return caml_call1(Base_Or_error[39], _j_);
    }
    function to_int(x) {
        return caml_call1(Base_Import[86], x);
    }
    function symbol(a, b) {
        var _f_ = to_int(b), _g_ = to_int(a), x = caml_call2(Base_Import[118], _g_, _f_);
        return x;
    }
    function symbol$0(a, b) {
        var _d_ = to_int(b), _e_ = to_int(a), x = caml_call2(Base_Import[116], _e_, _d_);
        return x;
    }
    var _c_ = [
        0,
        cst_src_bool_ml,
        86,
        9
    ];
    if (1 === to_int(1) && 0 === to_int(0)) {
        var include$1 = Base_Import[105], symbol$1 = include$1[1], symbol$2 = include$1[2], symbol$3 = include$1[3], symbol$4 = include$1[4], symbol$5 = include$1[5], symbol$6 = include$1[6], ascending = include$1[7], descending = include$1[8], compare$0 = include$1[9], compare_local = include$1[10], equal = include$1[11], equal_local = include$1[12], max = include$1[13], min = include$1[14], Base_Bool = [
            0,
            all,
            globalize,
            t_sexp_grammar,
            hash_fold_t,
            hash,
            t_of_sexp,
            sexp_of_t,
            of_string,
            to_string,
            symbol$6,
            symbol$2,
            symbol$4,
            symbol$5,
            symbol$1,
            symbol$3,
            equal,
            compare$0,
            min,
            max,
            ascending,
            descending,
            between,
            clamp_exn,
            clamp,
            comparator,
            pp,
            hashable,
            compare_local,
            equal_local,
            invariant,
            to_int,
            [
                0,
                symbol$0,
                symbol
            ]
        ];
        runtime.caml_register_global(17, Base_Bool, "Base__Bool");
        return;
    }
    throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _c_
    ], 1);
})(globalThis);
//# 14272 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = "", Base_Source_code_position0 = global_data.Base__Source_code_position0, Base_Error = global_data.Base__Error, Base_Import = global_data.Base__Import, Base_Monad = global_data.Base__Monad, Base_Applicative = global_data.Base__Applicative, compare_local = Base_Import[265], compare = Base_Import[237], globalize = Base_Import[294], hash_fold_t = Base_Import[211], t_of_sexp = Base_Import[170], sexp_of_t = Base_Import[146], cst_Option_value_exn = "Option.value_exn", cst_Option_value_exn_None = "Option.value_exn None";
    function t_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Import[193], a_sexp_grammar);
    }
    function is_none(param) {
        return param ? 0 : 1;
    }
    function is_some(param) {
        return param ? 1 : 0;
    }
    function value_map(o, default$0, f) {
        if (!o) return default$0;
        var x = o[1];
        return caml_call1(f, x);
    }
    function iter(o, f) {
        if (!o) return 0;
        var a = o[1];
        return caml_call1(f, a);
    }
    function invariant(f, t) {
        return iter(t, f);
    }
    function call(x, f) {
        if (!f) return 0;
        var f$0 = f[1];
        return caml_call1(f$0, x);
    }
    function value(t, default$0) {
        if (!t) return default$0;
        var x = t[1];
        return x;
    }
    function value_exn(here, error, message, t) {
        if (t) {
            var x = t[1];
            return x;
        }
        if (here) {
            var p = here[1];
            if (error) var e = error[1], _c_ = caml_call2(Base_Import[147], Base_Error[9], Base_Source_code_position0[9]), _d_ = value(message, cst), _e_ = caml_call5(Base_Error[19], 0, 0, _d_, [
                0,
                e,
                p
            ], _c_);
            else if (message) var m = message[1], _e_ = caml_call5(Base_Error[19], 0, 0, m, p, Base_Source_code_position0[9]);
            else var _e_ = caml_call5(Base_Error[19], 0, 0, cst_Option_value_exn, p, Base_Source_code_position0[9]);
            var error$0 = _e_;
        } else if (error) {
            var e$0 = error[1];
            if (message) var m$0 = message[1], _f_ = caml_call2(Base_Error[22], e$0, m$0);
            else var _f_ = e$0;
            var error$0 = _f_;
        } else if (message) var m$1 = message[1], error$0 = caml_call1(Base_Error[14], m$1);
        else var error$0 = caml_call1(Base_Error[14], cst_Option_value_exn_None);
        return caml_call1(Base_Error[31], error$0);
    }
    function value_or_thunk(o, default$0) {
        if (!o) return caml_call1(default$0, 0);
        var x = o[1];
        return x;
    }
    function to_array(t) {
        if (!t) return [
            0
        ];
        var x = t[1];
        return [
            0,
            x
        ];
    }
    function to_list(t) {
        if (!t) return 0;
        var x = t[1];
        return [
            0,
            x,
            0
        ];
    }
    function for_all(t, f) {
        if (!t) return 1;
        var x = t[1];
        return caml_call1(f, x);
    }
    function exists(t, f) {
        if (!t) return 0;
        var x = t[1];
        return caml_call1(f, x);
    }
    function mem(t, a, equal) {
        if (!t) return 0;
        var a$0 = t[1];
        return caml_call2(equal, a, a$0);
    }
    function length(t) {
        return t ? 1 : 0;
    }
    function fold(t, init, f) {
        if (!t) return init;
        var x = t[1];
        return caml_call2(f, init, x);
    }
    function find(t, f) {
        if (!t) return 0;
        var x = t[1];
        return caml_call1(f, x) ? t : 0;
    }
    function find_map(t, f) {
        if (!t) return 0;
        var a = t[1];
        return caml_call1(f, a);
    }
    function equal(f, t$0, t) {
        if (t$0) {
            if (t) {
                var x = t[1], x$0 = t$0[1];
                return caml_call2(f, x$0, x);
            }
        } else if (!t) return 1;
        return 0;
    }
    function equal_local(f, t$0, t) {
        if (t$0) {
            if (t) {
                var x = t[1], x$0 = t$0[1];
                return caml_call2(f, x$0, x);
            }
        } else if (!t) return 1;
        return 0;
    }
    function some(x) {
        return [
            0,
            x
        ];
    }
    function first_some(x, y) {
        return x ? x : y;
    }
    function some_if(cond, x) {
        return cond ? [
            0,
            x
        ] : 0;
    }
    function merge(a, b, f) {
        if (a) {
            if (b) {
                var b$0 = b[1], a$0 = a[1];
                return [
                    0,
                    caml_call2(f, a$0, b$0)
                ];
            }
            var x = a;
        } else var x = b;
        return x;
    }
    function filter(t, f) {
        if (t) {
            var v = t[1];
            if (caml_call1(f, v)) return t;
        }
        return 0;
    }
    function try_with(f) {
        try {
            var x = caml_call1(f, 0);
        } catch (_b_) {
            return 0;
        }
        return [
            0,
            x
        ];
    }
    function try_with_join(f) {
        try {
            var x = caml_call1(f, 0);
            return x;
        } catch (_a_) {
            return 0;
        }
    }
    function return$0(x) {
        return [
            0,
            x
        ];
    }
    var map = [
        0,
        -198771759,
        function(t, f) {
            if (!t) return 0;
            var a = t[1];
            return [
                0,
                caml_call1(f, a)
            ];
        }
    ];
    function bind(o, f) {
        if (!o) return 0;
        var x = o[1];
        return caml_call1(f, x);
    }
    var include = caml_call1(Base_Monad[5], [
        0,
        bind,
        return$0,
        map
    ]), symbol_bind = include[1], Monad_infix = include[3], bind$0 = include[4], join = include[7], ignore_m = include[8], Let_syntax = include[11];
    function return$1(x) {
        return [
            0,
            x
        ];
    }
    var map$0 = [
        0,
        -198771759,
        include[6]
    ];
    function map2(x, y, f) {
        if (x && y) {
            var y$0 = y[1], x$0 = x[1];
            return [
                0,
                caml_call2(f, x$0, y$0)
            ];
        }
        return 0;
    }
    var include$0 = caml_call1(Base_Applicative[16], [
        0,
        return$1,
        map2,
        map$0
    ]), return$2 = include$0[1], map$1 = include$0[2], both = include$0[3], symbol = include$0[4], symbol$0 = include$0[5], symbol$1 = include$0[6], symbol_map = include$0[7], apply = include$0[8], map2$0 = include$0[9], map3 = include$0[10], all = include$0[11], all_unit = include$0[12], Applicative_infix = include$0[13], Base_Option = [
        0,
        compare,
        compare_local,
        globalize,
        hash_fold_t,
        t_sexp_grammar,
        equal,
        equal_local,
        invariant,
        t_of_sexp,
        sexp_of_t,
        both,
        symbol,
        symbol$0,
        symbol$1,
        apply,
        map2$0,
        map3,
        Applicative_infix,
        symbol_bind,
        symbol_map,
        Monad_infix,
        bind$0,
        return$2,
        map$1,
        join,
        ignore_m,
        all,
        all_unit,
        Let_syntax,
        value,
        value_exn,
        value_map,
        value_or_thunk,
        fold,
        mem,
        length,
        iter,
        exists,
        for_all,
        find,
        find_map,
        to_list,
        to_array,
        call,
        merge,
        filter,
        try_with,
        try_with_join,
        some,
        first_some,
        some_if,
        is_none,
        is_some
    ];
    runtime.caml_register_global(8, Base_Option, "Base__Option");
    return;
})(globalThis);
//# 14573 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Both$0 = "Both", cst_Left$0 = "Left", cst_Right$0 = "Right", cst_Sequence_nth$1 = "Sequence.nth", cst_both = "both", cst_left = "left", cst_right = "right", cst_state = "state", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_tag = runtime.caml_obj_tag;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), error_source_057 = "sequence.ml.Merge_with_duplicates_element.t", Base_List1 = global_data.Base__List1, Base_Import = global_data.Base__Import, CamlinternalLazy = global_data.CamlinternalLazy, Base_Result = global_data.Base__Result, Base_Container = global_data.Base__Container, Base_Bool = global_data.Base__Bool, Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, Base_Hash = global_data.Base__Hash, Assert_failure = global_data.Assert_failure, Base_Array0 = global_data.Base__Array0, Base_Monad = global_data.Base__Monad, _a_ = [
        0,
        "Done"
    ], _b_ = [
        0,
        cst_state
    ], _c_ = [
        0,
        "Skip"
    ], _d_ = [
        0,
        cst_state
    ], _e_ = [
        0,
        "value"
    ], _f_ = [
        0,
        "Yield"
    ];
    function sexp_of_t(of_a_001, of_s_002, param) {
        if (typeof param === "number") return _a_;
        if (0 === param[0]) {
            var state_004 = param[1], arg_005 = caml_call1(of_s_002, state_004), bnds_003 = [
                0,
                [
                    1,
                    [
                        0,
                        _b_,
                        [
                            0,
                            arg_005,
                            0
                        ]
                    ]
                ],
                0
            ];
            return [
                1,
                [
                    0,
                    _c_,
                    bnds_003
                ]
            ];
        }
        var state_009 = param[2], value_007 = param[1], arg_010 = caml_call1(of_s_002, state_009), bnds_006 = [
            0,
            [
                1,
                [
                    0,
                    _d_,
                    [
                        0,
                        arg_010,
                        0
                    ]
                ]
            ],
            0
        ], arg_008 = caml_call1(of_a_001, value_007), bnds_006$0 = [
            0,
            [
                1,
                [
                    0,
                    _e_,
                    [
                        0,
                        arg_008,
                        0
                    ]
                ]
            ],
            bnds_006
        ];
        return [
            1,
            [
                0,
                _f_,
                bnds_006$0
            ]
        ];
    }
    var Step = [
        0,
        sexp_of_t
    ], T = [
        0
    ], _h_ = [
        0,
        0,
        0
    ], _i_ = [
        0,
        "src/sequence.ml",
        304,
        14
    ];
    function globalize(_T_1, param) {
        var next = param[2], state = param[1];
        return [
            0,
            state,
            next
        ];
    }
    function view(t) {
        return t;
    }
    function next_step(param) {
        var f = param[2], s = param[1], match = caml_call1(f, s);
        if (typeof match === "number") return 0;
        if (0 === match[0]) {
            var s$0 = match[1];
            return [
                0,
                [
                    0,
                    s$0,
                    f
                ]
            ];
        }
        var s$1 = match[2], a = match[1];
        return [
            1,
            a,
            [
                0,
                s$1,
                f
            ]
        ];
    }
    function delayed_fold_step(s, init, f, finish) {
        function loop(s, next, finish, f, acc) {
            var match = caml_call1(next, s);
            if (typeof match === "number") return caml_call1(finish, acc);
            if (0 === match[0]) {
                var s$0 = match[1];
                return caml_call3(f, acc, 0, function(_S_) {
                    return loop(s$0, next, finish, f, _S_);
                });
            }
            var s$1 = match[2], a = match[1];
            return caml_call3(f, acc, [
                0,
                a
            ], function(_R_) {
                return loop(s$1, next, finish, f, _R_);
            });
        }
        var next = s[2], s$0 = s[1];
        return loop(s$0, next, finish, f, init);
    }
    function unfold_step(init, f) {
        return [
            0,
            init,
            f
        ];
    }
    function unfold(init, f) {
        function f$0(s) {
            var match = caml_call1(f, s);
            if (!match) return 0;
            var match$0 = match[1], s$0 = match$0[2], a = match$0[1];
            return [
                1,
                a,
                s$0
            ];
        }
        return [
            0,
            init,
            f$0
        ];
    }
    function unfold_with(s, init, f) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                init,
                s$0
            ],
            function(param) {
                var s = param[2], seed = param[1], match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            seed,
                            s$0
                        ]
                    ];
                }
                var s$1 = match[2], a = match[1], match$0 = caml_call2(f, seed, a);
                if (typeof match$0 === "number") return 0;
                if (0 === match$0[0]) {
                    var seed$0 = match$0[1];
                    return [
                        0,
                        [
                            0,
                            seed$0,
                            s$1
                        ]
                    ];
                }
                var seed$1 = match$0[2], a$0 = match$0[1];
                return [
                    1,
                    a$0,
                    [
                        0,
                        seed$1,
                        s$1
                    ]
                ];
            }
        ];
    }
    function unfold_with_and_finish(s, init, running_step, inner_finished, finishing_step) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                -172306698,
                [
                    0,
                    init,
                    s$0
                ]
            ],
            function(state) {
                if (301075099 <= state[1]) {
                    var state$0 = state[2], match = caml_call1(finishing_step, state$0);
                    if (typeof match === "number") return 0;
                    if (0 === match[0]) {
                        var state$1 = match[1];
                        return [
                            0,
                            [
                                0,
                                301075099,
                                state$1
                            ]
                        ];
                    }
                    var state$2 = match[2], y = match[1];
                    return [
                        1,
                        y,
                        [
                            0,
                            301075099,
                            state$2
                        ]
                    ];
                }
                var match$0 = state[2], inner_state = match$0[2], state$3 = match$0[1], match$1 = caml_call1(next, inner_state);
                if (typeof match$1 === "number") return [
                    0,
                    [
                        0,
                        301075099,
                        caml_call1(inner_finished, state$3)
                    ]
                ];
                if (0 === match$1[0]) {
                    var inner_state$0 = match$1[1];
                    return [
                        0,
                        [
                            0,
                            -172306698,
                            [
                                0,
                                state$3,
                                inner_state$0
                            ]
                        ]
                    ];
                }
                var inner_state$1 = match$1[2], x = match$1[1], match$2 = caml_call2(running_step, state$3, x);
                if (typeof match$2 === "number") return 0;
                if (0 === match$2[0]) {
                    var state$4 = match$2[1];
                    return [
                        0,
                        [
                            0,
                            -172306698,
                            [
                                0,
                                state$4,
                                inner_state$1
                            ]
                        ]
                    ];
                }
                var state$5 = match$2[2], y$0 = match$2[1];
                return [
                    1,
                    y$0,
                    [
                        0,
                        -172306698,
                        [
                            0,
                            state$5,
                            inner_state$1
                        ]
                    ]
                ];
            }
        ];
    }
    function of_list(init) {
        function f(param) {
            if (!param) return 0;
            var l = param[2], x = param[1];
            return [
                1,
                x,
                l
            ];
        }
        return [
            0,
            init,
            f
        ];
    }
    function fold(t, init, f) {
        var next = t[2], seed$2 = t[1], seed = seed$2, v = init;
        for(;;){
            var match = caml_call1(next, seed);
            if (typeof match === "number") return v;
            if (0 === match[0]) {
                var seed$0 = match[1];
                seed = seed$0;
            } else {
                var seed$1 = match[2], a = match[1], v$0 = caml_call2(f, v, a);
                seed = seed$1;
                v = v$0;
            }
        }
    }
    function to_list_rev(t) {
        return fold(t, 0, function(l, x) {
            return [
                0,
                x,
                l
            ];
        });
    }
    function to_list(param) {
        var next = param[2], s = param[1], s$0 = s;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 !== match[0]) break;
            var s$1 = match[1];
            s$0 = s$1;
        }
        var s$2 = match[2], a = match[1], block = [
            0,
            a,
            24029
        ], dst = block, offset = 1, s$3 = s$2;
        for(;;){
            var match$0 = caml_call1(next, s$3);
            if (typeof match$0 === "number") {
                dst[1 + offset] = 0;
                return block;
            }
            if (0 === match$0[0]) {
                var s$4 = match$0[1];
                s$3 = s$4;
            } else {
                var s$5 = match$0[2], a$0 = match$0[1], dst$0 = [
                    0,
                    a$0,
                    24029
                ];
                dst[1 + offset] = dst$0;
                dst = dst$0;
                offset = 1;
                s$3 = s$5;
            }
        }
    }
    function sexp_of_t$0(sexp_of_a, t) {
        var _Q_ = to_list(t);
        return caml_call2(Base_Import[149], sexp_of_a, _Q_);
    }
    function range(_P_, _O_, opt, start_v, stop_v) {
        var stride = _P_ ? _P_[1] : 1, start = _O_ ? _O_[1] : 104758188, stop = opt ? opt[1] : -160346914, step = 104758188 <= stop ? 0 <= stride ? function(i) {
            return stop_v < i ? 0 : [
                1,
                i,
                caml_call2(Base_Import[91], i, stride)
            ];
        } : function(i) {
            return i < stop_v ? 0 : [
                1,
                i,
                caml_call2(Base_Import[91], i, stride)
            ];
        } : 0 <= stride ? function(i) {
            return stop_v <= i ? 0 : [
                1,
                i,
                caml_call2(Base_Import[91], i, stride)
            ];
        } : function(i) {
            return i <= stop_v ? 0 : [
                1,
                i,
                caml_call2(Base_Import[91], i, stride)
            ];
        }, init = 104758188 <= start ? start_v : caml_call2(Base_Import[91], start_v, stride);
        return [
            0,
            init,
            step
        ];
    }
    function of_lazy(t_lazy) {
        function f(t_lazy) {
            var _N_ = caml_obj_tag(t_lazy);
            a: if (250 === _N_) var match = t_lazy[1];
            else {
                if (246 !== _N_ && 244 !== _N_) {
                    var match = t_lazy;
                    break a;
                }
                var match = caml_call1(CamlinternalLazy[2], t_lazy);
            }
            var next = match[2], s = match[1], match$0 = caml_call1(next, s);
            if (typeof match$0 === "number") return 0;
            if (0 === match$0[0]) {
                var s$0 = match$0[1], v = [
                    0,
                    s$0,
                    next
                ];
                return [
                    0,
                    v
                ];
            }
            var s$1 = match$0[2], x = match$0[1], v$0 = [
                0,
                s$1,
                next
            ];
            return [
                1,
                x,
                v$0
            ];
        }
        return [
            0,
            t_lazy,
            f
        ];
    }
    function _g_(t, f) {
        var next = t[2], seed = t[1];
        return [
            0,
            seed,
            function(seed) {
                var match = caml_call1(next, seed);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s = match[1];
                    return [
                        0,
                        s
                    ];
                }
                var s$0 = match[2], a = match[1];
                return [
                    1,
                    caml_call1(f, a),
                    s$0
                ];
            }
        ];
    }
    function mapi(t, f) {
        var next = t[2], s = t[1];
        return [
            0,
            [
                0,
                0,
                s
            ],
            function(param) {
                var s = param[2], i = param[1], match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            i,
                            s$0
                        ]
                    ];
                }
                var s$1 = match[2], a = match[1], _M_ = [
                    0,
                    caml_call2(Base_Import[91], i, 1),
                    s$1
                ];
                return [
                    1,
                    caml_call2(f, i, a),
                    _M_
                ];
            }
        ];
    }
    function folding_map(t, init, f) {
        return unfold_with(t, init, function(acc, x) {
            var match = caml_call2(f, acc, x), x$0 = match[2], acc$0 = match[1];
            return [
                1,
                x$0,
                acc$0
            ];
        });
    }
    function folding_mapi(t, init, f) {
        return unfold_with(t, [
            0,
            0,
            init
        ], function(param, x) {
            var acc = param[2], i = param[1], match = caml_call3(f, i, acc, x), x$0 = match[2], acc$0 = match[1];
            return [
                1,
                x$0,
                [
                    0,
                    caml_call2(Base_Import[91], i, 1),
                    acc$0
                ]
            ];
        });
    }
    function filter(t, f) {
        var next = t[2], seed = t[1];
        return [
            0,
            seed,
            function(seed) {
                var match = caml_call1(next, seed);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s = match[1];
                    return [
                        0,
                        s
                    ];
                }
                var a = match[1], s$0 = match[2];
                if (caml_call1(f, a)) return [
                    1,
                    a,
                    s$0
                ];
                var s$1 = match[2];
                return [
                    0,
                    s$1
                ];
            }
        ];
    }
    function filteri(t, f) {
        var _L_ = Base_Import[127];
        return _g_(filter(mapi(t, function(i, s) {
            return [
                0,
                i,
                s
            ];
        }), function(param) {
            var s = param[2], i = param[1];
            return caml_call2(f, i, s);
        }), _L_);
    }
    function length(t) {
        var next = t[2], seed = t[1], i = 0, s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return i;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var s$1 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                i = i$0;
                s = s$1;
            }
        }
    }
    function to_array(t) {
        var match = fold(t, _h_, function(param, x) {
            var i = param[2], l = param[1];
            return [
                0,
                [
                    0,
                    x,
                    l
                ],
                caml_call2(Base_Import[91], i, 1)
            ];
        }), len = match[2], l = match[1];
        if (!l) return [
            0
        ];
        var l$0 = l[2], x = l[1], a = caml_call2(Base_Array0[4], len, x), i$1 = caml_call2(Base_Import[93], len, 2), i = i$1, l$1 = l$0;
        for(;;){
            if (!l$1) {
                if (-1 === i) return a;
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _i_
                ], 1);
            }
            var l$2 = l$1[2], x$0 = l$1[1];
            runtime.caml_check_bound(a, i)[1 + i] = x$0;
            var i$0 = caml_call2(Base_Import[93], i, 1);
            i = i$0;
            l$1 = l$2;
        }
    }
    function find(t, f) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) var s$0 = match[1];
            else {
                var a = match[1];
                if (caml_call1(f, a)) return [
                    0,
                    a
                ];
                var s$0 = match[2];
            }
            s = s$0;
        }
    }
    function find_map(t, f) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var s$1 = match[2], a = match[1], some_b = caml_call1(f, a);
                if (some_b) return some_b;
                s = s$1;
            }
        }
    }
    function find_mapi(t, f) {
        var next = t[2], seed = t[1], s = seed, i = 0;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var s$1 = match[2], a = match[1], some_b = caml_call2(f, i, a);
                if (some_b) return some_b;
                var i$0 = caml_call2(Base_Import[91], i, 1);
                s = s$1;
                i = i$0;
            }
        }
    }
    function for_all(t, f) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 1;
            if (0 === match[0]) var s$0 = match[1];
            else {
                var a = match[1];
                if (!caml_call1(f, a)) return 0;
                var s$0 = match[2];
            }
            s = s$0;
        }
    }
    function for_alli(t, f) {
        var next = t[2], seed = t[1], s = seed, i = 0;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 1;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var a = match[1];
                if (!caml_call2(f, i, a)) return 0;
                var s$1 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                s = s$1;
                i = i$0;
            }
        }
    }
    function exists(t, f) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) var s$0 = match[1];
            else {
                var a = match[1];
                if (caml_call1(f, a)) return 1;
                var s$0 = match[2];
            }
            s = s$0;
        }
    }
    function existsi(t, f) {
        var next = t[2], seed = t[1], s = seed, i = 0;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var a = match[1];
                if (caml_call2(f, i, a)) return 1;
                var s$1 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                s = s$1;
                i = i$0;
            }
        }
    }
    function iter(t, f) {
        var next = t[2], seed$2 = t[1], seed = seed$2;
        for(;;){
            var match = caml_call1(next, seed);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var seed$0 = match[1];
                seed = seed$0;
            } else {
                var seed$1 = match[2], a = match[1];
                caml_call1(f, a);
                seed = seed$1;
            }
        }
    }
    function is_empty(t) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 1;
            if (0 !== match[0]) return 0;
            var s$0 = match[1];
            s = s$0;
        }
    }
    function mem(t, a, equal) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) var s$0 = match[1];
            else {
                var b = match[1];
                if (caml_call2(equal, a, b)) return 1;
                var s$0 = match[2];
            }
            s = s$0;
        }
    }
    var empty = [
        0,
        0,
        function(param) {
            return 0;
        }
    ];
    function bind(t, f) {
        function f$0(param) {
            var rest = param[2], match = param[1], next = match[2], seed = match[1], match$0 = caml_call1(next, seed);
            if (typeof match$0 === "number") {
                var next$0 = rest[2], seed$0 = rest[1], match$1 = caml_call1(next$0, seed$0);
                if (typeof match$1 === "number") return 0;
                if (0 === match$1[0]) {
                    var s = match$1[1];
                    return [
                        0,
                        [
                            0,
                            empty,
                            [
                                0,
                                s,
                                next$0
                            ]
                        ]
                    ];
                }
                var s$0 = match$1[2], a = match$1[1];
                return [
                    0,
                    [
                        0,
                        caml_call1(f, a),
                        [
                            0,
                            s$0,
                            next$0
                        ]
                    ]
                ];
            }
            if (0 === match$0[0]) {
                var s$1 = match$0[1];
                return [
                    0,
                    [
                        0,
                        [
                            0,
                            s$1,
                            next
                        ],
                        rest
                    ]
                ];
            }
            var s$2 = match$0[2], a$0 = match$0[1];
            return [
                1,
                a$0,
                [
                    0,
                    [
                        0,
                        s$2,
                        next
                    ],
                    rest
                ]
            ];
        }
        var init = [
            0,
            empty,
            t
        ];
        return [
            0,
            init,
            f$0
        ];
    }
    function return$0(x) {
        function f(param) {
            if (!param) return 0;
            var x = param[1];
            return [
                1,
                x,
                0
            ];
        }
        var init = [
            0,
            x
        ];
        return [
            0,
            init,
            f
        ];
    }
    var map = [
        0,
        -198771759,
        _g_
    ], include = caml_call1(Base_Monad[1], [
        0,
        bind,
        return$0,
        map
    ]), symbol_bind = include[1], symbol_map = include[2], Monad_infix = include[3], bind$0 = include[4], return$1 = include[5], map$0 = include[6], join = include[7], ignore_m = include[8], all = include[9], all_unit = include[10], Let_syntax = include[11], cst_Sequence_nth = cst_Sequence_nth$1, cst_Sequence_nth$0 = cst_Sequence_nth$1, _j_ = [
        0,
        cst_Left$0
    ], _k_ = [
        0,
        cst_Right$0
    ], _l_ = [
        0,
        cst_Both$0
    ], cst_Both = cst_Both$0, cst_Right = cst_Right$0, cst_Left = cst_Left$0, cst_hd_exn = "hd_exn", cst_Sequence_tl_exn = "Sequence.tl_exn", cst_Sequence_chunks_exn = "Sequence.chunks_exn", cst_Sequence_find_exn = "Sequence.find_exn", cst_Sequence_reduce_exn = "Sequence.reduce_exn", cst_Sequence_sub = "Sequence.sub", cst_Sequence_take = "Sequence.take", cst_Sequence_drop = "Sequence.drop";
    function nth(s, n) {
        if (0 > n) return 0;
        var next = s[2], s$3 = s[1], i = n, s$0 = s$3;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], a = match[1];
                if (0 === i) return [
                    0,
                    a
                ];
                var i$0 = caml_call2(Base_Import[93], i, 1);
                i = i$0;
                s$0 = s$2;
            }
        }
    }
    function nth_exn(s, n) {
        if (0 > n) return caml_call1(Base_Import[126], cst_Sequence_nth$0);
        var match = nth(s, n);
        if (!match) return caml_call1(Base_Import[124], cst_Sequence_nth);
        var x = match[1];
        return x;
    }
    function compare_local(cmp_a, cmp_b, a_023, b_024) {
        if (a_023 === b_024) return 0;
        switch(a_023[0]){
            case 0:
                var a_025 = a_023[1];
                if (0 !== b_024[0]) return -1;
                var b_026 = b_024[1];
                return caml_call2(cmp_a, a_025, b_026);
            case 1:
                var a_027 = a_023[1];
                switch(b_024[0]){
                    case 0:
                        break;
                    case 1:
                        var b_028 = b_024[1];
                        return caml_call2(cmp_b, a_027, b_028);
                    default:
                        return -1;
                }
                break;
            default:
                var a_031 = a_023[2], a_029 = a_023[1];
                switch(b_024[0]){
                    case 0:
                        break;
                    case 1:
                        return 1;
                    default:
                        var b_032 = b_024[2], b_030 = b_024[1], n = caml_call2(cmp_a, a_029, b_030);
                        return 0 === n ? caml_call2(cmp_b, a_031, b_032) : n;
                }
        }
        return 1;
    }
    function compare(cmp_a, cmp_b, a_013, b_014) {
        if (a_013 === b_014) return 0;
        switch(a_013[0]){
            case 0:
                var a_015 = a_013[1];
                if (0 !== b_014[0]) return -1;
                var b_016 = b_014[1];
                return caml_call2(cmp_a, a_015, b_016);
            case 1:
                var a_017 = a_013[1];
                switch(b_014[0]){
                    case 0:
                        break;
                    case 1:
                        var b_018 = b_014[1];
                        return caml_call2(cmp_b, a_017, b_018);
                    default:
                        return -1;
                }
                break;
            default:
                var a_021 = a_013[2], a_019 = a_013[1];
                switch(b_014[0]){
                    case 0:
                        break;
                    case 1:
                        return 1;
                    default:
                        var b_022 = b_014[2], b_020 = b_014[1], n = caml_call2(cmp_a, a_019, b_020);
                        return 0 === n ? caml_call2(cmp_b, a_021, b_022) : n;
                }
        }
        return 1;
    }
    function equal_local(cmp_a, cmp_b, a_043, b_044) {
        if (a_043 === b_044) return 1;
        switch(a_043[0]){
            case 0:
                var a_045 = a_043[1];
                if (0 !== b_044[0]) return 0;
                var b_046 = b_044[1];
                return caml_call2(cmp_a, a_045, b_046);
            case 1:
                var a_047 = a_043[1];
                switch(b_044[0]){
                    case 0:
                        break;
                    case 1:
                        var b_048 = b_044[1];
                        return caml_call2(cmp_b, a_047, b_048);
                    default:
                        return 0;
                }
                break;
            default:
                var a_051 = a_043[2], a_049 = a_043[1];
                switch(b_044[0]){
                    case 0:
                        break;
                    case 1:
                        return 0;
                    default:
                        var b_052 = b_044[2], b_050 = b_044[1], _K_ = caml_call2(cmp_a, a_049, b_050);
                        return _K_ ? caml_call2(cmp_b, a_051, b_052) : _K_;
                }
        }
        return 0;
    }
    function equal(cmp_a, cmp_b, a_033, b_034) {
        if (a_033 === b_034) return 1;
        switch(a_033[0]){
            case 0:
                var a_035 = a_033[1];
                if (0 !== b_034[0]) return 0;
                var b_036 = b_034[1];
                return caml_call2(cmp_a, a_035, b_036);
            case 1:
                var a_037 = a_033[1];
                switch(b_034[0]){
                    case 0:
                        break;
                    case 1:
                        var b_038 = b_034[1];
                        return caml_call2(cmp_b, a_037, b_038);
                    default:
                        return 0;
                }
                break;
            default:
                var a_041 = a_033[2], a_039 = a_033[1];
                switch(b_034[0]){
                    case 0:
                        break;
                    case 1:
                        return 0;
                    default:
                        var b_042 = b_034[2], b_040 = b_034[1], _J_ = caml_call2(cmp_a, a_039, b_040);
                        return _J_ ? caml_call2(cmp_b, a_041, b_042) : _J_;
                }
        }
        return 0;
    }
    function hash_fold_t(hash_fold_a, hash_fold_b, hsv, arg) {
        switch(arg[0]){
            case 0:
                var a0 = arg[1], hsv$0 = caml_call2(Base_Hash[3], hsv, 0);
                return caml_call2(hash_fold_a, hsv$0, a0);
            case 1:
                var a0$0 = arg[1], hsv$1 = caml_call2(Base_Hash[3], hsv, 1);
                return caml_call2(hash_fold_b, hsv$1, a0$0);
            default:
                var a1 = arg[2], a0$1 = arg[1], hsv$2 = caml_call2(Base_Hash[3], hsv, 2), hsv$3 = caml_call2(hash_fold_a, hsv$2, a0$1);
                return caml_call2(hash_fold_b, hsv$3, a1);
        }
    }
    function t_of_sexp(of_a_053, of_b_054, sexp_059) {
        a: {
            if (0 === sexp_059[0]) {
                var _F_ = sexp_059[1];
                b: if (_F_ !== cst_Both$0) {
                    c: if (_F_ !== cst_Left$0) {
                        if (_F_ !== cst_Right$0) {
                            if (_F_ === cst_both) break b;
                            if (_F_ === cst_left) break c;
                            if (_F_ !== cst_right) break a;
                        }
                        return caml_call2(Sexplib0_Sexp_conv_error[9], error_source_057, sexp_059);
                    }
                    return caml_call2(Sexplib0_Sexp_conv_error[9], error_source_057, sexp_059);
                }
                return caml_call2(Sexplib0_Sexp_conv_error[9], error_source_057, sexp_059);
            }
            var _G_ = sexp_059[1];
            if (!_G_) return caml_call2(Sexplib0_Sexp_conv_error[11], error_source_057, sexp_059);
            var _H_ = _G_[1];
            if (0 !== _H_[0]) return caml_call2(Sexplib0_Sexp_conv_error[10], error_source_057, sexp_059);
            var tag_060 = _H_[1];
            b: if (tag_060 !== cst_Both$0) {
                c: if (tag_060 !== cst_Left$0) {
                    if (tag_060 !== cst_Right$0) {
                        if (tag_060 === cst_both) break b;
                        if (tag_060 === cst_left) break c;
                        if (tag_060 !== cst_right) break a;
                    }
                    var sexp_args_066 = _G_[2];
                    if (sexp_args_066 && !sexp_args_066[2]) {
                        var arg0_067 = sexp_args_066[1], res0_068 = caml_call1(of_b_054, arg0_067);
                        return [
                            1,
                            res0_068
                        ];
                    }
                    return caml_call3(Sexplib0_Sexp_conv_error[8], error_source_057, tag_060, sexp_059);
                }
                var sexp_args_061 = _G_[2];
                if (sexp_args_061 && !sexp_args_061[2]) {
                    var arg0_062 = sexp_args_061[1], res0_063 = caml_call1(of_a_053, arg0_062);
                    return [
                        0,
                        res0_063
                    ];
                }
                return caml_call3(Sexplib0_Sexp_conv_error[8], error_source_057, tag_060, sexp_059);
            }
            var sexp_args_071 = _G_[2];
            if (sexp_args_071) {
                var _I_ = sexp_args_071[2];
                if (_I_ && !_I_[2]) {
                    var arg1_073 = _I_[1], arg0_072 = sexp_args_071[1], res0_074 = caml_call1(of_a_053, arg0_072), res1_075 = caml_call1(of_b_054, arg1_073);
                    return [
                        2,
                        res0_074,
                        res1_075
                    ];
                }
            }
            return caml_call3(Sexplib0_Sexp_conv_error[8], error_source_057, tag_060, sexp_059);
        }
        return caml_call2(Sexplib0_Sexp_conv_error[12], error_source_057, sexp_059);
    }
    function sexp_of_t$1(of_a_078, of_b_079, param) {
        switch(param[0]){
            case 0:
                var arg0_080 = param[1], res0_081 = caml_call1(of_a_078, arg0_080);
                return [
                    1,
                    [
                        0,
                        _j_,
                        [
                            0,
                            res0_081,
                            0
                        ]
                    ]
                ];
            case 1:
                var arg0_082 = param[1], res0_083 = caml_call1(of_b_079, arg0_082);
                return [
                    1,
                    [
                        0,
                        _k_,
                        [
                            0,
                            res0_083,
                            0
                        ]
                    ]
                ];
            default:
                var arg1_085 = param[2], arg0_084 = param[1], res0_086 = caml_call1(of_a_078, arg0_084), res1_087 = caml_call1(of_b_079, arg1_085);
                return [
                    1,
                    [
                        0,
                        _l_,
                        [
                            0,
                            res0_086,
                            [
                                0,
                                res1_087,
                                0
                            ]
                        ]
                    ]
                ];
        }
    }
    function t_sexp_grammar(a_sexp_grammar, b_sexp_grammar) {
        return [
            3,
            [
                0,
                2,
                [
                    0,
                    [
                        1,
                        [
                            0,
                            cst_Left,
                            [
                                0,
                                [
                                    0,
                                    a_sexp_grammar,
                                    0
                                ]
                            ]
                        ]
                    ],
                    [
                        0,
                        [
                            1,
                            [
                                0,
                                cst_Right,
                                [
                                    0,
                                    [
                                        0,
                                        b_sexp_grammar,
                                        0
                                    ]
                                ]
                            ]
                        ],
                        [
                            0,
                            [
                                1,
                                [
                                    0,
                                    cst_Both,
                                    [
                                        0,
                                        [
                                            0,
                                            a_sexp_grammar,
                                            [
                                                0,
                                                b_sexp_grammar,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ],
                            0
                        ]
                    ]
                ]
            ]
        ];
    }
    function merge_with_duplicates(_E_, param, compare) {
        var next2 = param[2], s2 = param[1], next1 = _E_[2], s1 = _E_[1];
        function next(param) {
            var s1 = param[1];
            if (typeof s1 === "number") {
                var match = param[2];
                if (typeof match === "number") return 0;
                if (0 !== match[0]) {
                    var s2$0 = match[2], b = match[1];
                    return [
                        1,
                        [
                            1,
                            b
                        ],
                        [
                            0,
                            0,
                            [
                                0,
                                s2$0
                            ]
                        ]
                    ];
                }
            } else {
                if (0 === s1[0]) {
                    var s2$1 = param[2], s1$0 = s1[1];
                    return [
                        0,
                        [
                            0,
                            caml_call1(next1, s1$0),
                            s2$1
                        ]
                    ];
                }
                var s2$2 = param[2], s1$1 = s1[2], a = s1[1];
                if (typeof s2$2 === "number") return [
                    1,
                    [
                        0,
                        a
                    ],
                    [
                        0,
                        [
                            0,
                            s1$1
                        ],
                        0
                    ]
                ];
                if (0 !== s2$2[0]) {
                    var s2$3 = s2$2[2], b$0 = s2$2[1], comparison = caml_call2(compare, a, b$0);
                    return 0 <= comparison ? 0 === comparison ? [
                        1,
                        [
                            2,
                            a,
                            b$0
                        ],
                        [
                            0,
                            [
                                0,
                                s1$1
                            ],
                            [
                                0,
                                s2$3
                            ]
                        ]
                    ] : [
                        1,
                        [
                            1,
                            b$0
                        ],
                        [
                            0,
                            s1,
                            [
                                0,
                                s2$3
                            ]
                        ]
                    ] : [
                        1,
                        [
                            0,
                            a
                        ],
                        [
                            0,
                            [
                                0,
                                s1$1
                            ],
                            s2$2
                        ]
                    ];
                }
            }
            var s2 = param[2][1];
            return [
                0,
                [
                    0,
                    s1,
                    caml_call1(next2, s2)
                ]
            ];
        }
        return [
            0,
            [
                0,
                [
                    0,
                    s1
                ],
                [
                    0,
                    s2
                ]
            ],
            next
        ];
    }
    function merge_deduped_and_sorted(s1, s2, compare) {
        return caml_call2(map$0, merge_with_duplicates(s1, s2, compare), function(param) {
            var x = param[1];
            return x;
        });
    }
    function merge_sorted(_D_, param, compare) {
        var next2 = param[2], s2 = param[1], next1 = _D_[2], s1 = _D_[1];
        function next(param) {
            var s1 = param[1];
            if (typeof s1 === "number") {
                var match = param[2];
                if (typeof match === "number") return 0;
                if (0 !== match[0]) {
                    var s2$0 = match[2], b = match[1];
                    return [
                        1,
                        b,
                        [
                            0,
                            0,
                            [
                                0,
                                s2$0
                            ]
                        ]
                    ];
                }
            } else {
                if (0 === s1[0]) {
                    var s2$1 = param[2], s1$0 = s1[1];
                    return [
                        0,
                        [
                            0,
                            caml_call1(next1, s1$0),
                            s2$1
                        ]
                    ];
                }
                var s2$2 = param[2], s1$1 = s1[2], a = s1[1];
                if (typeof s2$2 === "number") return [
                    1,
                    a,
                    [
                        0,
                        [
                            0,
                            s1$1
                        ],
                        0
                    ]
                ];
                if (0 !== s2$2[0]) {
                    var s2$3 = s2$2[2], b$0 = s2$2[1], comparison = caml_call2(compare, a, b$0);
                    return 0 < comparison ? [
                        1,
                        b$0,
                        [
                            0,
                            s1,
                            [
                                0,
                                s2$3
                            ]
                        ]
                    ] : [
                        1,
                        a,
                        [
                            0,
                            [
                                0,
                                s1$1
                            ],
                            s2$2
                        ]
                    ];
                }
            }
            var s2 = param[2][1];
            return [
                0,
                [
                    0,
                    s1,
                    caml_call1(next2, s2)
                ]
            ];
        }
        return [
            0,
            [
                0,
                [
                    0,
                    s1
                ],
                [
                    0,
                    s2
                ]
            ],
            next
        ];
    }
    function hd(s) {
        var next = s[2], s$2 = s[1], s$0 = s$2;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 !== match[0]) {
                var a = match[1];
                return [
                    0,
                    a
                ];
            }
            var s$1 = match[1];
            s$0 = s$1;
        }
    }
    function hd_exn(s) {
        var match = hd(s);
        if (!match) return caml_call1(Base_Import[124], cst_hd_exn);
        var a = match[1];
        return a;
    }
    function tl(s) {
        var next = s[2], s$2 = s[1], s$0 = s$2;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") var match$0 = 0;
            else {
                if (0 === match[0]) {
                    var s$1 = match[1];
                    s$0 = s$1;
                    continue;
                }
                var a = match[2], match$0 = [
                    0,
                    a
                ];
            }
            if (!match$0) return 0;
            var s$3 = match$0[1];
            return [
                0,
                [
                    0,
                    s$3,
                    next
                ]
            ];
        }
    }
    function tl_eagerly_exn(s) {
        var match = tl(s);
        if (!match) return caml_call1(Base_Import[124], cst_Sequence_tl_exn);
        var s$0 = match[1];
        return s$0;
    }
    function lift_identity(next, s) {
        var match = caml_call1(next, s);
        if (typeof match === "number") return 0;
        if (0 === match[0]) {
            var s$0 = match[1];
            return [
                0,
                [
                    0,
                    316735838,
                    s$0
                ]
            ];
        }
        var s$1 = match[2], a = match[1];
        return [
            1,
            a,
            [
                0,
                316735838,
                s$1
            ]
        ];
    }
    function next(s) {
        var next = s[2], s$3 = s[1], s$0 = s$3;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 !== match[0]) {
                var s$2 = match[2], a = match[1];
                return [
                    0,
                    [
                        0,
                        a,
                        [
                            0,
                            s$2,
                            next
                        ]
                    ]
                ];
            }
            var s$1 = match[1];
            s$0 = s$1;
        }
    }
    function filter_opt(s) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            s$0,
            function(s) {
                var match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        s$0
                    ];
                }
                var match$0 = match[1];
                if (match$0) {
                    var s$1 = match[2], a = match$0[1];
                    return [
                        1,
                        a,
                        s$1
                    ];
                }
                var s$2 = match[2];
                return [
                    0,
                    s$2
                ];
            }
        ];
    }
    function filter_map(s, f) {
        return filter_opt(caml_call2(map$0, s, f));
    }
    function filter_mapi(s, f) {
        return filter_map(mapi(s, function(i, s) {
            return [
                0,
                i,
                s
            ];
        }), function(param) {
            var s = param[2], i = param[1];
            return caml_call2(f, i, s);
        });
    }
    function split_n(s, n) {
        var next = s[2], s$3 = s[1], s$0 = s$3, i = n, accum = 0;
        for(;;){
            if (0 >= i) return [
                0,
                caml_call1(Base_List1[19], accum),
                [
                    0,
                    s$0,
                    next
                ]
            ];
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return [
                0,
                caml_call1(Base_List1[19], accum),
                empty
            ];
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], a = match[1], accum$0 = [
                    0,
                    a,
                    accum
                ], i$0 = caml_call2(Base_Import[93], i, 1);
                s$0 = s$2;
                i = i$0;
                accum = accum$0;
            }
        }
    }
    function chunks_exn(init, n) {
        if (0 >= n) return caml_call1(Base_Import[126], cst_Sequence_chunks_exn);
        function f(t) {
            var match = split_n(t, n), xs = match[1];
            if (!xs) return 0;
            var t$0 = match[2];
            return [
                1,
                xs,
                t$0
            ];
        }
        return [
            0,
            init,
            f
        ];
    }
    function findi(t, f) {
        var next = t[2], seed = t[1], s = seed, i = 0;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var a = match[1];
                if (caml_call2(f, i, a)) return [
                    0,
                    [
                        0,
                        i,
                        a
                    ]
                ];
                var s$1 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                s = s$1;
                i = i$0;
            }
        }
    }
    function find_exn(s, f) {
        var match = find(s, f);
        if (!match) return caml_call1(Base_Import[124], cst_Sequence_find_exn);
        var x = match[1];
        return x;
    }
    function append(s1, s2) {
        var next2 = s2[2], s2$0 = s2[1], next1 = s1[2], s1$0 = s1[1];
        return [
            0,
            [
                0,
                472258093,
                s1$0
            ],
            function(param) {
                if (472258093 <= param[1]) {
                    var s1 = param[2], match = caml_call1(next1, s1);
                    if (typeof match === "number") return [
                        0,
                        [
                            0,
                            -630817751,
                            s2$0
                        ]
                    ];
                    if (0 === match[0]) {
                        var s1$0 = match[1];
                        return [
                            0,
                            [
                                0,
                                472258093,
                                s1$0
                            ]
                        ];
                    }
                    var s1$1 = match[2], a = match[1];
                    return [
                        1,
                        a,
                        [
                            0,
                            472258093,
                            s1$1
                        ]
                    ];
                }
                var s2 = param[2], match$0 = caml_call1(next2, s2);
                if (typeof match$0 === "number") return 0;
                if (0 === match$0[0]) {
                    var s2$1 = match$0[1];
                    return [
                        0,
                        [
                            0,
                            -630817751,
                            s2$1
                        ]
                    ];
                }
                var s2$2 = match$0[2], a$0 = match$0[1];
                return [
                    1,
                    a$0,
                    [
                        0,
                        -630817751,
                        s2$2
                    ]
                ];
            }
        ];
    }
    function concat_map(s, f) {
        return caml_call2(bind$0, s, f);
    }
    function concat(s) {
        function f(_C_) {
            return _C_;
        }
        return caml_call2(bind$0, s, f);
    }
    function concat_mapi(s, f) {
        function f$0(param) {
            var s = param[2], i = param[1];
            return caml_call2(f, i, s);
        }
        var s$0 = mapi(s, function(i, s) {
            return [
                0,
                i,
                s
            ];
        });
        return caml_call2(bind$0, s$0, f$0);
    }
    function zip(_A_, param) {
        var next2 = param[2], s2 = param[1], next1 = _A_[2], s1 = _A_[1];
        function next(param) {
            var _B_ = param[1];
            if (typeof _B_ !== "number") {
                if (1 === _B_[0]) {
                    var match = param[2], s1$0 = _B_[2], a = _B_[1];
                    if (typeof match !== "number") {
                        if (0 === match[0]) {
                            var s2$0 = param[2][1];
                            return [
                                0,
                                [
                                    0,
                                    _B_,
                                    caml_call1(next2, s2$0)
                                ]
                            ];
                        }
                        var s2$1 = match[2], b = match[1];
                        return [
                            1,
                            [
                                0,
                                a,
                                b
                            ],
                            [
                                0,
                                [
                                    0,
                                    s1$0
                                ],
                                [
                                    0,
                                    s2$1
                                ]
                            ]
                        ];
                    }
                }
                if (typeof param[2] !== "number") {
                    var s2 = param[2], s1 = _B_[1];
                    return [
                        0,
                        [
                            0,
                            caml_call1(next1, s1),
                            s2
                        ]
                    ];
                }
            }
            return 0;
        }
        return [
            0,
            [
                0,
                [
                    0,
                    s1
                ],
                [
                    0,
                    s2
                ]
            ],
            next
        ];
    }
    function zip_full(_z_, param) {
        var next2 = param[2], s2 = param[1], next1 = _z_[2], s1 = _z_[1];
        function next(param) {
            var s1 = param[1];
            if (typeof s1 === "number") {
                var match = param[2];
                if (typeof match === "number") return 0;
                if (0 !== match[0]) {
                    var s2$0 = match[2], b = match[1];
                    return [
                        1,
                        [
                            0,
                            -57574468,
                            b
                        ],
                        [
                            0,
                            0,
                            caml_call1(next2, s2$0)
                        ]
                    ];
                }
            } else {
                if (0 === s1[0]) {
                    var s2$1 = param[2], s1$0 = s1[1];
                    return [
                        0,
                        [
                            0,
                            caml_call1(next1, s1$0),
                            s2$1
                        ]
                    ];
                }
                var match$0 = param[2], s1$1 = s1[2], a = s1[1];
                if (typeof match$0 === "number") return [
                    1,
                    [
                        0,
                        847852583,
                        a
                    ],
                    [
                        0,
                        caml_call1(next1, s1$1),
                        0
                    ]
                ];
                if (0 !== match$0[0]) {
                    var s2$2 = match$0[2], b$0 = match$0[1];
                    return [
                        1,
                        [
                            0,
                            737457313,
                            [
                                0,
                                a,
                                b$0
                            ]
                        ],
                        [
                            0,
                            [
                                0,
                                s1$1
                            ],
                            [
                                0,
                                s2$2
                            ]
                        ]
                    ];
                }
            }
            var s2 = param[2][1];
            return [
                0,
                [
                    0,
                    s1,
                    caml_call1(next2, s2)
                ]
            ];
        }
        return [
            0,
            [
                0,
                [
                    0,
                    s1
                ],
                [
                    0,
                    s2
                ]
            ],
            next
        ];
    }
    function bounded_length(param, at_most) {
        var next = param[2], seed = param[1], i = 0, seed$0 = seed;
        for(;;){
            if (at_most < i) return 85047514;
            var match = caml_call1(next, seed$0);
            if (typeof match === "number") return [
                0,
                16394,
                i
            ];
            if (0 === match[0]) {
                var seed$1 = match[1];
                seed$0 = seed$1;
            } else {
                var seed$2 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                i = i$0;
                seed$0 = seed$2;
            }
        }
    }
    function length_is_bounded_by(opt, max, t) {
        var min = opt ? opt[1] : -1;
        if (max) {
            var max$0 = max[1], match$0 = bounded_length(t, max$0);
            if (typeof match$0 !== "number" && 16394 === match$0[1]) {
                var len = match$0[2];
                if (min <= len) return 1;
            }
            return 0;
        }
        var next = t[2], s = t[1], s$0 = s, acc = 0;
        for(;;){
            if (min <= acc) return 1;
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], acc$0 = caml_call2(Base_Import[91], acc, 1);
                s$0 = s$2;
                acc = acc$0;
            }
        }
    }
    function iteri(s, f) {
        return iter(mapi(s, function(i, s) {
            return [
                0,
                i,
                s
            ];
        }), function(param) {
            var s = param[2], i = param[1];
            return caml_call2(f, i, s);
        });
    }
    function foldi(s, init, f) {
        return fold(mapi(s, function(i, s) {
            return [
                0,
                i,
                s
            ];
        }), init, function(acc, param) {
            var s = param[2], i = param[1];
            return caml_call3(f, i, acc, s);
        });
    }
    function reduce(s, f) {
        var match = next(s);
        if (!match) return 0;
        var match$0 = match[1], s$0 = match$0[2], a = match$0[1];
        return [
            0,
            fold(s$0, a, f)
        ];
    }
    function reduce_exn(s, f) {
        var match = reduce(s, f);
        if (!match) return caml_call1(Base_Import[124], cst_Sequence_reduce_exn);
        var res = match[1];
        return res;
    }
    function group(param, break$0) {
        var next = param[2], s = param[1];
        function f(param) {
            if (!param) return 0;
            var match = param[1], s = match[2], acc = match[1], match$0 = caml_call1(next, s);
            if (typeof match$0 !== "number" && 0 === match$0[0]) {
                var s$2 = match$0[1];
                return [
                    0,
                    [
                        0,
                        [
                            0,
                            acc,
                            s$2
                        ]
                    ]
                ];
            }
            if (acc) {
                if (typeof match$0 === "number") return [
                    1,
                    caml_call1(Base_List1[19], acc),
                    0
                ];
                var s$0 = match$0[2], cur = match$0[1], prev = acc[1];
                return caml_call2(break$0, prev, cur) ? [
                    1,
                    caml_call1(Base_List1[19], acc),
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                cur,
                                0
                            ],
                            s$0
                        ]
                    ]
                ] : [
                    0,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                cur,
                                acc
                            ],
                            s$0
                        ]
                    ]
                ];
            }
            if (typeof match$0 === "number") return 0;
            var s$1 = match$0[2], cur$0 = match$0[1];
            return [
                0,
                [
                    0,
                    [
                        0,
                        [
                            0,
                            cur$0,
                            0
                        ],
                        s$1
                    ]
                ]
            ];
        }
        var init = [
            0,
            [
                0,
                0,
                s
            ]
        ];
        return [
            0,
            init,
            f
        ];
    }
    function find_consecutive_duplicate(param, equal) {
        var next = param[2], s = param[1], last_elt = 0, s$0 = s;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], a = match[1];
                if (last_elt) {
                    var b = last_elt[1];
                    if (caml_call2(equal, a, b)) return [
                        0,
                        [
                            0,
                            b,
                            a
                        ]
                    ];
                }
                var last_elt$0 = [
                    0,
                    a
                ];
                last_elt = last_elt$0;
                s$0 = s$2;
            }
        }
    }
    function remove_consecutive_duplicates(s, equal) {
        return unfold_with(s, 0, function(prev, a) {
            if (prev) {
                var b = prev[1];
                if (caml_call2(equal, a, b)) return [
                    0,
                    [
                        0,
                        a
                    ]
                ];
            }
            return [
                1,
                a,
                [
                    0,
                    a
                ]
            ];
        });
    }
    function count(s, f) {
        return fold(s, 0, function(acc, elt) {
            var _x_ = caml_call1(f, elt), _y_ = caml_call1(Base_Bool[31], _x_);
            return caml_call2(Base_Import[91], acc, _y_);
        });
    }
    function counti(t, f) {
        return foldi(t, 0, function(i, acc, elt) {
            var _v_ = caml_call2(f, i, elt), _w_ = caml_call1(Base_Bool[31], _v_);
            return caml_call2(Base_Import[91], acc, _w_);
        });
    }
    function sum(m, t, f) {
        return caml_call4(Base_Container[7], fold, m, t, f);
    }
    function min_elt(t, compare) {
        return caml_call3(Base_Container[3], fold, t, compare);
    }
    function max_elt(t, compare) {
        return caml_call3(Base_Container[4], fold, t, compare);
    }
    function init(n, f) {
        function f$0(i) {
            if (n <= i) return 0;
            var _u_ = caml_call2(Base_Import[91], i, 1);
            return [
                1,
                caml_call1(f, i),
                _u_
            ];
        }
        return [
            0,
            0,
            f$0
        ];
    }
    function sub(s, pos, len) {
        var _s_ = pos < 0 ? 1 : 0, _t_ = _s_ || (len < 0 ? 1 : 0);
        if (_t_) caml_call1(Base_Import[124], cst_Sequence_sub);
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                0,
                s$0
            ],
            function(param) {
                var s = param[2], i = param[1];
                if (len <= caml_call2(Base_Import[93], i, pos)) return 0;
                var match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            i,
                            s$0
                        ]
                    ];
                }
                var a = match[1], s$1 = match[2];
                if (pos <= i) return [
                    1,
                    a,
                    [
                        0,
                        caml_call2(Base_Import[91], i, 1),
                        s$1
                    ]
                ];
                var s$2 = match[2];
                return [
                    0,
                    [
                        0,
                        caml_call2(Base_Import[91], i, 1),
                        s$2
                    ]
                ];
            }
        ];
    }
    function take(s, len) {
        if (len < 0) caml_call1(Base_Import[124], cst_Sequence_take);
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                0,
                s$0
            ],
            function(param) {
                var s = param[2], i = param[1];
                if (len <= i) return 0;
                var match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            i,
                            s$0
                        ]
                    ];
                }
                var s$1 = match[2], a = match[1];
                return [
                    1,
                    a,
                    [
                        0,
                        caml_call2(Base_Import[91], i, 1),
                        s$1
                    ]
                ];
            }
        ];
    }
    function drop(s, len) {
        if (len < 0) caml_call1(Base_Import[124], cst_Sequence_drop);
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                0,
                s$0
            ],
            function(param) {
                var s = param[2], i = param[1], match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            i,
                            s$0
                        ]
                    ];
                }
                var a = match[1], s$1 = match[2];
                if (len <= i) return [
                    1,
                    a,
                    [
                        0,
                        caml_call2(Base_Import[91], i, 1),
                        s$1
                    ]
                ];
                var s$2 = match[2];
                return [
                    0,
                    [
                        0,
                        caml_call2(Base_Import[91], i, 1),
                        s$2
                    ]
                ];
            }
        ];
    }
    function take_while(s, f) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            s$0,
            function(s) {
                var match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        s$0
                    ];
                }
                var a = match[1], s$1 = match[2];
                return caml_call1(f, a) ? [
                    1,
                    a,
                    s$1
                ] : 0;
            }
        ];
    }
    function drop_while(s, f) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                -557110719,
                s$0
            ],
            function(param) {
                if (316735838 <= param[1]) {
                    var s = param[2];
                    return lift_identity(next, s);
                }
                var s$0 = param[2], match = caml_call1(next, s$0);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$1 = match[1];
                    return [
                        0,
                        [
                            0,
                            -557110719,
                            s$1
                        ]
                    ];
                }
                var a = match[1], s$2 = match[2];
                if (caml_call1(f, a)) return [
                    0,
                    [
                        0,
                        -557110719,
                        s$2
                    ]
                ];
                var s$3 = match[2];
                return [
                    1,
                    a,
                    [
                        0,
                        316735838,
                        s$3
                    ]
                ];
            }
        ];
    }
    function shift_right(s, x) {
        var next = s[2], seed = s[1];
        return [
            0,
            [
                0,
                -433944719,
                [
                    0,
                    seed,
                    x
                ]
            ],
            function(param) {
                if (316735838 <= param[1]) {
                    var s = param[2];
                    return lift_identity(next, s);
                }
                var match = param[2], x = match[2], seed = match[1];
                return [
                    1,
                    x,
                    [
                        0,
                        316735838,
                        seed
                    ]
                ];
            }
        ];
    }
    function shift_right_with_list(s, l) {
        return append(of_list(l), s);
    }
    var Infix = [
        0,
        append
    ], cst_Sequence_cycle_list_exn = "Sequence.cycle_list_exn", cst_Bug_This_branch_should_be_ = "Bug: This branch should be unreachable";
    function intersperse(s, sep) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                815032112,
                s$0
            ],
            function(param) {
                var _r_ = param[1];
                if (815032112 === _r_) {
                    var s = param[2], match = caml_call1(next, s);
                    if (typeof match === "number") return 0;
                    if (0 === match[0]) {
                        var s$0 = match[1];
                        return [
                            0,
                            [
                                0,
                                815032112,
                                s$0
                            ]
                        ];
                    }
                    var s$1 = match[2], a = match[1];
                    return [
                        1,
                        a,
                        [
                            0,
                            951752159,
                            s$1
                        ]
                    ];
                }
                if (951752159 > _r_) {
                    var match$1 = param[2], s$5 = match$1[2], a$1 = match$1[1];
                    return [
                        1,
                        a$1,
                        [
                            0,
                            951752159,
                            s$5
                        ]
                    ];
                }
                var s$2 = param[2], match$0 = caml_call1(next, s$2);
                if (typeof match$0 === "number") return 0;
                if (0 === match$0[0]) {
                    var s$3 = match$0[1];
                    return [
                        0,
                        [
                            0,
                            951752159,
                            s$3
                        ]
                    ];
                }
                var s$4 = match$0[2], a$0 = match$0[1];
                return [
                    1,
                    sep,
                    [
                        0,
                        -571577571,
                        [
                            0,
                            a$0,
                            s$4
                        ]
                    ]
                ];
            }
        ];
    }
    function repeat(init) {
        function f(x) {
            return [
                1,
                x,
                x
            ];
        }
        return [
            0,
            init,
            f
        ];
    }
    function cycle_list_exn(xs) {
        if (caml_call1(Base_List1[22], xs)) caml_call1(Base_Import[126], cst_Sequence_cycle_list_exn);
        var s = of_list(xs);
        function f(param) {
            return s;
        }
        var s$0 = repeat(0);
        return caml_call2(bind$0, s$0, f);
    }
    function cartesian_product(sa, sb) {
        function f(a) {
            return zip(repeat(a), sb);
        }
        return caml_call2(bind$0, sa, f);
    }
    function singleton(x) {
        return caml_call1(return$1, x);
    }
    function delayed_fold(s, init, f, finish) {
        return delayed_fold_step(s, init, function(acc, option, k) {
            if (!option) return caml_call1(k, acc);
            var a = option[1];
            return caml_call3(f, acc, a, k);
        }, finish);
    }
    function fold_m(bind, return$0, t, init, f) {
        return delayed_fold_step(t, init, function(acc, option, k) {
            if (!option) return caml_call2(bind, caml_call1(return$0, acc), k);
            var a = option[1];
            return caml_call2(bind, caml_call2(f, acc, a), k);
        }, return$0);
    }
    function iter_m(bind, return$0, t, f) {
        return delayed_fold_step(t, 0, function(param, option, k) {
            if (!option) return caml_call2(bind, caml_call1(return$0, 0), k);
            var a = option[1];
            return caml_call2(bind, caml_call1(f, a), k);
        }, return$0);
    }
    function fold_until(s, init, f, finish) {
        var next = s[2], s$3 = s[1], s$0 = s$3, acc = init;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return caml_call1(finish, acc);
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], a = match[1], match$0 = caml_call2(f, acc, a);
                if (0 !== match$0[0]) {
                    var x = match$0[1];
                    return x;
                }
                var acc$0 = match$0[1];
                s$0 = s$2;
                acc = acc$0;
            }
        }
    }
    function fold_result(s, init, f) {
        var next = s[2], s$3 = s[1], s$0 = s$3, acc = init;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return caml_call1(Base_Result[15], acc);
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], a = match[1], e = caml_call2(f, acc, a);
                if (0 !== e[0]) return e;
                var acc$0 = e[1];
                s$0 = s$2;
                acc = acc$0;
            }
        }
    }
    function force_eagerly(t) {
        return of_list(to_list(t));
    }
    function memoize(param) {
        var next = param[2], s = param[1];
        function memoize(s) {
            return [
                0,
                [
                    246,
                    function(_q_) {
                        var s$0 = s;
                        for(;;){
                            var match = caml_call1(next, s$0);
                            if (typeof match === "number") return 0;
                            if (0 !== match[0]) {
                                var s$2 = match[2], a = match[1];
                                return [
                                    1,
                                    a,
                                    memoize(s$2)
                                ];
                            }
                            var s$1 = match[1];
                            s$0 = s$1;
                        }
                    }
                ]
            ];
        }
        return [
            0,
            memoize(s),
            function(param) {
                var l = param[1], _p_ = caml_obj_tag(l);
                if (250 === _p_) return l[1];
                if (246 !== _p_ && 244 !== _p_) return l;
                return caml_call1(CamlinternalLazy[2], l);
            }
        ];
    }
    function drop_eagerly(s, len) {
        var next = s[2], s$3 = s[1], i = 0, s$0 = s$3;
        for(;;){
            if (len <= i) return [
                0,
                s$0,
                next
            ];
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return empty;
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                i = i$0;
                s$0 = s$2;
            }
        }
    }
    function drop_while_option(param, f) {
        var next = param[2], s = param[1], s$0 = s;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], x = match[1];
                if (!caml_call1(f, x)) return [
                    0,
                    [
                        0,
                        x,
                        [
                            0,
                            s$2,
                            next
                        ]
                    ]
                ];
                s$0 = s$2;
            }
        }
    }
    function skip_loop(s, next) {
        var s$0 = s;
        for(;;){
            var next$0 = caml_call1(next, s$0);
            if (typeof next$0 !== "number" && 0 === next$0[0]) {
                var state = next$0[1];
                s$0 = state;
                continue;
            }
            return next$0;
        }
    }
    function compare$0(compare_a, l, param) {
        var next_r = param[2], s_r$1 = param[1], next_l = l[2], s_l$1 = l[1], s_l = s_l$1, s_r = s_r$1;
        for(;;){
            var l$0 = skip_loop(s_l, next_l), r = skip_loop(s_r, next_r);
            if (typeof l$0 === "number") {
                if (typeof r === "number") return 0;
                if (1 === r[0]) return -1;
            } else if (1 === l$0[0]) {
                if (typeof r === "number") return 1;
                if (1 === r[0]) {
                    var c = caml_call2(compare_a, l$0[1], r[1]);
                    if (0 !== c) return c;
                    var s_r$0 = r[2], s_l$0 = l$0[2];
                    s_l = s_l$0;
                    s_r = s_r$0;
                    continue;
                }
            }
            return caml_call1(Base_Import[124], cst_Bug_This_branch_should_be_);
        }
    }
    function compare_local$0(compare_a_local, t1, t2) {
        var _o_ = globalize(0, t2);
        return compare$0(function(x, y) {
            return caml_call2(compare_a_local, x, y);
        }, globalize(0, t1), _o_);
    }
    function equal$0(equal_a, t1, t2) {
        return for_all(zip_full(t1, t2), function(param) {
            if (737457313 !== param[1]) return 0;
            var match = param[2], a2 = match[2], a1 = match[1];
            return caml_call2(equal_a, a1, a2);
        });
    }
    function equal_local$0(equal_a_local, t1, t2) {
        var _n_ = globalize(0, t2);
        return equal$0(function(x, y) {
            return caml_call2(equal_a_local, x, y);
        }, globalize(0, t1), _n_);
    }
    function round_robin(list) {
        function next(param) {
            var done_stack = param[2], todo_stack = param[1];
            if (!todo_stack) return caml_call1(Base_List1[22], done_stack) ? 0 : [
                0,
                [
                    0,
                    caml_call1(Base_List1[19], done_stack),
                    0
                ]
            ];
            var todo_stack$0 = todo_stack[2], match = todo_stack[1], f = match[2], s = match[1], match$0 = caml_call1(f, s);
            if (typeof match$0 === "number") return [
                0,
                [
                    0,
                    todo_stack$0,
                    done_stack
                ]
            ];
            if (0 === match$0[0]) {
                var s$0 = match$0[1];
                return [
                    0,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                s$0,
                                f
                            ],
                            todo_stack$0
                        ],
                        done_stack
                    ]
                ];
            }
            var s$1 = match$0[2], x = match$0[1];
            return [
                1,
                x,
                [
                    0,
                    todo_stack$0,
                    [
                        0,
                        [
                            0,
                            s$1,
                            f
                        ],
                        done_stack
                    ]
                ]
            ];
        }
        var state = [
            0,
            list,
            0
        ];
        return [
            0,
            state,
            next
        ];
    }
    function interleave(param) {
        var f1 = param[2], s1 = param[1];
        function next(param) {
            var s1 = param[3], done_stack = param[2], todo_stack = param[1];
            if (todo_stack) {
                var todo_stack$0 = todo_stack[2], match = todo_stack[1], f2 = match[2], s2 = match[1], match$0 = caml_call1(f2, s2);
                if (typeof match$0 === "number") return [
                    0,
                    [
                        0,
                        todo_stack$0,
                        done_stack,
                        s1
                    ]
                ];
                if (0 === match$0[0]) {
                    var s2$0 = match$0[1];
                    return [
                        0,
                        [
                            0,
                            todo_stack$0,
                            [
                                0,
                                [
                                    0,
                                    s2$0,
                                    f2
                                ],
                                done_stack
                            ],
                            s1
                        ]
                    ];
                }
                var s2$1 = match$0[2], x = match$0[1];
                return [
                    1,
                    x,
                    [
                        0,
                        todo_stack$0,
                        [
                            0,
                            [
                                0,
                                s2$1,
                                f2
                            ],
                            done_stack
                        ],
                        s1
                    ]
                ];
            }
            var match$1 = caml_call1(f1, s1);
            if (typeof match$1 === "number") return done_stack ? [
                0,
                [
                    0,
                    caml_call1(Base_List1[19], done_stack),
                    0,
                    s1
                ]
            ] : 0;
            if (0 === match$1[0]) {
                var s1$0 = match$1[1];
                return [
                    0,
                    [
                        0,
                        caml_call1(Base_List1[19], done_stack),
                        0,
                        s1$0
                    ]
                ];
            }
            var s1$1 = match$1[2], t = match$1[1];
            return [
                0,
                [
                    0,
                    caml_call1(Base_List1[19], [
                        0,
                        t,
                        done_stack
                    ]),
                    0,
                    s1$1
                ]
            ];
        }
        var state = [
            0,
            0,
            0,
            s1
        ];
        return [
            0,
            state,
            next
        ];
    }
    function interleaved_cartesian_product(s1, s2) {
        return interleave(caml_call2(map$0, s1, function(x1) {
            return caml_call2(map$0, s2, function(x2) {
                return [
                    0,
                    x1,
                    x2
                ];
            });
        }));
    }
    function of_seq(init) {
        function f(seq) {
            var match = caml_call1(seq, 0);
            if (!match) return 0;
            var tl = match[2], hd = match[1];
            return [
                1,
                hd,
                tl
            ];
        }
        return [
            0,
            init,
            f
        ];
    }
    function to_seq(param) {
        var next = param[2], state = param[1];
        function loop(state) {
            var state$0 = state;
            for(;;){
                var match = caml_call1(next, state$0);
                if (typeof match === "number") return 0;
                if (0 !== match[0]) {
                    var state$2 = match[2], hd = match[1];
                    return [
                        0,
                        hd,
                        function(param) {
                            return loop(state$2);
                        }
                    ];
                }
                var state$1 = match[1];
                state$0 = state$1;
            }
        }
        return function(param) {
            return loop(state);
        };
    }
    function return$2(x, k) {
        return caml_call1(k, x);
    }
    function bind$1(m, f, k) {
        return caml_call1(m, function(a) {
            var m = caml_call1(f, a);
            return caml_call1(m, k);
        });
    }
    var map$1 = [
        0,
        -198771759,
        function(m, f, k) {
            return caml_call1(m, function(a) {
                return caml_call1(k, caml_call1(f, a));
            });
        }
    ], include$0 = caml_call1(Base_Monad[2], [
        0,
        bind$1,
        map$1,
        return$2
    ]), symbol_bind$0 = include$0[1], symbol_map$0 = include$0[2], Let_syntax$0 = include$0[3], Monad_infix$0 = include$0[4], bind$2 = include$0[5], return$3 = include$0[6], map$2 = include$0[7], join$0 = include$0[8], ignore_m$0 = include$0[9], all$0 = include$0[10], all_unit$0 = include$0[11], _m_ = [
        0,
        0
    ];
    function yield$0(e, k) {
        return [
            0,
            [
                1,
                e,
                k
            ]
        ];
    }
    function of_sequence(sequence) {
        return delayed_fold(sequence, 0, function(param, x, k, f) {
            return [
                0,
                [
                    1,
                    x,
                    function(param) {
                        return caml_call2(k, 0, f);
                    }
                ]
            ];
        }, return$3);
    }
    function run(t) {
        function init(param) {
            return caml_call1(t, function(param) {
                return _m_;
            });
        }
        function f(thunk) {
            var step = caml_call1(thunk, 0)[1];
            return step;
        }
        return [
            0,
            init,
            f
        ];
    }
    var Base_Sequence = [
        0,
        globalize,
        sexp_of_t$0,
        equal$0,
        equal_local$0,
        compare$0,
        compare_local$0,
        mem,
        length,
        is_empty,
        iter,
        fold,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        to_array,
        min_elt,
        max_elt,
        foldi,
        iteri,
        existsi,
        counti,
        findi,
        find_mapi,
        symbol_bind,
        symbol_map,
        Monad_infix,
        bind$0,
        return$1,
        map$0,
        join,
        ignore_m,
        all,
        all_unit,
        Let_syntax,
        empty,
        next,
        Step,
        unfold_step,
        unfold,
        unfold_with,
        unfold_with_and_finish,
        nth,
        nth_exn,
        folding_map,
        folding_mapi,
        mapi,
        filteri,
        filter,
        merge_deduped_and_sorted,
        merge_sorted,
        [
            0,
            compare,
            compare_local,
            equal,
            equal_local,
            hash_fold_t,
            t_of_sexp,
            sexp_of_t$1,
            t_sexp_grammar
        ],
        merge_with_duplicates,
        hd,
        hd_exn,
        tl,
        tl_eagerly_exn,
        find_exn,
        for_alli,
        append,
        concat,
        concat_map,
        concat_mapi,
        interleave,
        round_robin,
        zip,
        zip_full,
        reduce_exn,
        reduce,
        group,
        find_consecutive_duplicate,
        remove_consecutive_duplicates,
        range,
        init,
        filter_map,
        filter_mapi,
        filter_opt,
        sub,
        take,
        drop,
        drop_eagerly,
        take_while,
        drop_while,
        drop_while_option,
        split_n,
        chunks_exn,
        shift_right,
        shift_right_with_list,
        drop,
        Infix,
        cartesian_product,
        interleaved_cartesian_product,
        intersperse,
        cycle_list_exn,
        repeat,
        singleton,
        delayed_fold,
        fold_m,
        iter_m,
        to_list_rev,
        of_list,
        of_lazy,
        memoize,
        force_eagerly,
        bounded_length,
        length_is_bounded_by,
        of_seq,
        to_seq,
        [
            0,
            symbol_bind$0,
            symbol_map$0,
            Let_syntax$0,
            Monad_infix$0,
            bind$2,
            return$3,
            map$2,
            join$0,
            ignore_m$0,
            all$0,
            all_unit$0,
            yield$0,
            of_sequence,
            run
        ],
        [
            0,
            next_step,
            delayed_fold_step,
            T,
            view
        ]
    ];
    runtime.caml_register_global(51, Base_Sequence, "Base__Sequence");
    return;
})(globalThis);
//# 16635 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, cst_Sexpable_Of_stringable_t_o = "Sexpable.Of_stringable.t_of_sexp expected an atom, but got a list";
    function Of_sexpable(Sexpable, M) {
        function t_of_sexp(sexp) {
            var s = caml_call1(Sexpable[1], sexp);
            try {
                var _i_ = caml_call1(M[2], s);
                return _i_;
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                return caml_call2(Base_Import[157], exn, sexp);
            }
        }
        function sexp_of_t(t) {
            var _h_ = caml_call1(M[1], t);
            return caml_call1(Sexpable[2], _h_);
        }
        return [
            0,
            t_of_sexp,
            sexp_of_t
        ];
    }
    function Of_sexpable1(Sexpable, M) {
        function t_of_sexp(a_of_sexp, sexp) {
            var s = caml_call2(Sexpable[1], a_of_sexp, sexp);
            try {
                var _g_ = caml_call1(M[2], s);
                return _g_;
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                return caml_call2(Base_Import[157], exn, sexp);
            }
        }
        function sexp_of_t(sexp_of_a, t) {
            var _f_ = caml_call1(M[1], t);
            return caml_call2(Sexpable[2], sexp_of_a, _f_);
        }
        return [
            0,
            t_of_sexp,
            sexp_of_t
        ];
    }
    function Of_sexpable2(Sexpable, M) {
        function t_of_sexp(a_of_sexp, b_of_sexp, sexp) {
            var s = caml_call3(Sexpable[1], a_of_sexp, b_of_sexp, sexp);
            try {
                var _e_ = caml_call1(M[2], s);
                return _e_;
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                return caml_call2(Base_Import[157], exn, sexp);
            }
        }
        function sexp_of_t(sexp_of_a, sexp_of_b, t) {
            var _d_ = caml_call1(M[1], t);
            return caml_call3(Sexpable[2], sexp_of_a, sexp_of_b, _d_);
        }
        return [
            0,
            t_of_sexp,
            sexp_of_t
        ];
    }
    function Of_sexpable3(Sexpable, M) {
        function t_of_sexp(a_of_sexp, b_of_sexp, c_of_sexp, sexp) {
            var s = caml_call4(Sexpable[1], a_of_sexp, b_of_sexp, c_of_sexp, sexp);
            try {
                var _c_ = caml_call1(M[2], s);
                return _c_;
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                return caml_call2(Base_Import[157], exn, sexp);
            }
        }
        function sexp_of_t(sexp_of_a, sexp_of_b, sexp_of_c, t) {
            var _b_ = caml_call1(M[1], t);
            return caml_call4(Sexpable[2], sexp_of_a, sexp_of_b, sexp_of_c, _b_);
        }
        return [
            0,
            t_of_sexp,
            sexp_of_t
        ];
    }
    function Of_stringable(M) {
        function t_of_sexp(sexp) {
            if (0 !== sexp[0]) return caml_call2(Base_Import[156], cst_Sexpable_Of_stringable_t_o, sexp);
            var s = sexp[1];
            try {
                var _a_ = caml_call1(M[1], s);
                return _a_;
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                return caml_call2(Base_Import[157], exn, sexp);
            }
        }
        function sexp_of_t(t) {
            return [
                0,
                caml_call1(M[2], t)
            ];
        }
        var t_sexp_grammar = caml_call1(Sexplib0_Sexp_grammar[1], Base_Import[182]);
        return [
            0,
            t_sexp_grammar,
            t_of_sexp,
            sexp_of_t
        ];
    }
    var Base_Sexpable = [
        0,
        Of_sexpable,
        Of_sexpable1,
        Of_sexpable2,
        Of_sexpable3,
        Of_stringable
    ];
    runtime.caml_register_global(3, Base_Sexpable, "Base__Sexpable");
    return;
})(globalThis);
//# 16759 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_array_ml = "src/array.ml", caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Assert_failure = global_data.Assert_failure, Base_Import = global_data.Base__Import, Base_Sequence = global_data.Base__Sequence, Base_Random = global_data.Base__Random, Base_Option = global_data.Base__Option, Base_List = global_data.Base__List, Base_Bool = global_data.Base__Bool, Base_Container = global_data.Base__Container, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common, Base_Array0 = global_data.Base__Array0, Base_Array_permute = global_data.Base__Array_permute, Base_Binary_searchable = global_data.Base__Binary_searchable, Base_Blit = global_data.Base__Blit, invalid_argf = Base_Array0[1], max_length = Base_Array0[3], create = Base_Array0[4], create_local = Base_Array0[5], create_float_uninitialized = Base_Array0[6], append = Base_Array0[7], concat = Base_Array0[9], copy = Base_Array0[10], fill = Base_Array0[11], init = Base_Array0[12], make_matrix = Base_Array0[13], of_list = Base_Array0[14], sub = Base_Array0[15], to_list = Base_Array0[16], fold = Base_Array0[17], fold_right = Base_Array0[18], iter = Base_Array0[19], iteri = Base_Array0[20], map = Base_Array0[21], mapi = Base_Array0[22], stable_sort = Base_Array0[23], swap = Base_Array0[24], compare_local = Base_Import[263], compare = Base_Import[235], globalize = Base_Import[291], t_of_sexp = Base_Import[174], sexp_of_t = Base_Import[150];
    function t_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Import[195], a_sexp_grammar);
    }
    function Sorter(S) {
        var get = S[1], set = S[2], length = S[3];
        function swap(arr, i, j) {
            var tmp = caml_call2(get, arr, i);
            caml_call3(set, arr, i, caml_call2(get, arr, j));
            return caml_call3(set, arr, j, tmp);
        }
        function sort(arr, compare, left, right) {
            var _aR_ = caml_call2(Base_Import[91], left, 1);
            if (right >= _aR_) {
                var pos = _aR_;
                for(;;){
                    var v = caml_call2(get, arr, pos), final_pos = pos;
                    for(;;){
                        var i_next = caml_call2(Base_Import[93], final_pos, 1);
                        if (left > i_next) break;
                        if (0 >= caml_call2(compare, caml_call2(get, arr, i_next), v)) break;
                        caml_call3(set, arr, final_pos, caml_call2(get, arr, i_next));
                        final_pos = i_next;
                    }
                    caml_call3(set, arr, final_pos, v);
                    var _aS_ = pos + 1 | 0;
                    if (right === pos) break;
                    pos = _aS_;
                }
            }
            return 0;
        }
        var Insertion_sort = [
            0,
            sort
        ];
        function heapify(arr, compare, root, left, right) {
            var root$0 = root;
            for(;;){
                var relative_root = caml_call2(Base_Import[93], root$0, left), _aK_ = caml_call2(Base_Import[88], 2, relative_root), _aL_ = caml_call2(Base_Import[91], _aK_, left), left_child = caml_call2(Base_Import[91], _aL_, 1), _aM_ = caml_call2(Base_Import[88], 2, relative_root), _aN_ = caml_call2(Base_Import[91], _aM_, left), right_child = caml_call2(Base_Import[91], _aN_, 2);
                a: {
                    if (left_child <= right) {
                        var _aO_ = caml_call2(get, arr, root$0);
                        if (0 < caml_call2(compare, caml_call2(get, arr, left_child), _aO_)) {
                            var largest = left_child;
                            break a;
                        }
                    }
                    var largest = root$0;
                }
                a: {
                    if (right_child <= right) {
                        var _aP_ = caml_call2(get, arr, largest);
                        if (0 < caml_call2(compare, caml_call2(get, arr, right_child), _aP_)) {
                            var largest$0 = right_child;
                            break a;
                        }
                    }
                    var largest$0 = largest;
                }
                var _aQ_ = largest$0 !== root$0 ? 1 : 0;
                if (!_aQ_) return _aQ_;
                swap(arr, root$0, largest$0);
                root$0 = largest$0;
            }
        }
        function sort$0(arr, compare, left, right) {
            var _aF_ = caml_call2(Base_Import[91], left, right), _aG_ = caml_call2(Base_Import[95], _aF_, 2);
            if (_aG_ >= left) {
                var i = _aG_;
                for(;;){
                    heapify(arr, compare, i, left, right);
                    var _aH_ = i - 1 | 0;
                    if (left === i) break;
                    i = _aH_;
                }
            }
            var _aI_ = caml_call2(Base_Import[91], left, 1);
            if (right >= _aI_) {
                var i$0 = right;
                for(;;){
                    swap(arr, left, i$0);
                    heapify(arr, compare, left, left, caml_call2(Base_Import[93], i$0, 1));
                    var _aJ_ = i$0 - 1 | 0;
                    if (_aI_ === i$0) break;
                    i$0 = _aJ_;
                }
            }
            return 0;
        }
        var Heap_sort = [
            0,
            sort$0
        ];
        function five_element_sort(arr, compare, m1, m2, m3, m4, m5) {
            function compare_and_swap(i, j) {
                var _aD_ = caml_call2(get, arr, j), _aE_ = 0 < caml_call2(compare, caml_call2(get, arr, i), _aD_) ? 1 : 0;
                return _aE_ ? swap(arr, i, j) : _aE_;
            }
            compare_and_swap(m1, m2);
            compare_and_swap(m4, m5);
            compare_and_swap(m1, m3);
            compare_and_swap(m2, m3);
            compare_and_swap(m1, m4);
            compare_and_swap(m3, m4);
            compare_and_swap(m2, m5);
            compare_and_swap(m2, m3);
            return compare_and_swap(m4, m5);
        }
        function intro_sort(arr, max_depth, compare, left, right) {
            var max_depth$0 = max_depth, left$0 = left;
            for(;;){
                var _aC_ = caml_call2(Base_Import[93], right, left$0), len = caml_call2(Base_Import[91], _aC_, 1);
                if (32 >= len) return caml_call4(Insertion_sort[1], arr, compare, left$0, right);
                if (0 > max_depth$0) return caml_call4(Heap_sort[1], arr, compare, left$0, right);
                var max_depth$1 = caml_call2(Base_Import[93], max_depth$0, 1), _aB_ = caml_call2(Base_Import[93], right, left$0), sixth = caml_call2(Base_Import[95], _aB_, 6), m1 = caml_call2(Base_Import[91], left$0, sixth), m2 = caml_call2(Base_Import[91], m1, sixth), m3 = caml_call2(Base_Import[91], m2, sixth), m4 = caml_call2(Base_Import[91], m3, sixth), m5 = caml_call2(Base_Import[91], m4, sixth);
                five_element_sort(arr, compare, m1, m2, m3, m4, m5);
                var m2_val = caml_call2(get, arr, m2), m3_val = caml_call2(get, arr, m3), m4_val = caml_call2(get, arr, m4), match = 0 === caml_call2(compare, m2_val, m3_val) ? [
                    0,
                    m2_val,
                    m3_val,
                    1
                ] : 0 === caml_call2(compare, m3_val, m4_val) ? [
                    0,
                    m3_val,
                    m4_val,
                    1
                ] : [
                    0,
                    m2_val,
                    m4_val,
                    0
                ], middle_sorted = match[3], pivot2 = match[2], pivot1 = match[1], l$0 = left$0, p$1 = left$0, r$2 = right;
                for(;;){
                    if (r$2 < p$1) break;
                    var pv = caml_call2(get, arr, p$1);
                    if (0 <= caml_call2(compare, pv, pivot1)) {
                        if (0 < caml_call2(compare, pv, pivot2)) {
                            var r = r$2;
                            for(;;){
                                if (p$1 >= r) break;
                                if (0 >= caml_call2(compare, caml_call2(get, arr, r), pivot2)) break;
                                var r$0 = caml_call2(Base_Import[93], r, 1);
                                r = r$0;
                            }
                            swap(arr, r, p$1);
                            var r$1 = caml_call2(Base_Import[93], r, 1);
                            r$2 = r$1;
                        } else {
                            var p = caml_call2(Base_Import[91], p$1, 1);
                            p$1 = p;
                        }
                    } else {
                        swap(arr, p$1, l$0);
                        var p$0 = caml_call2(Base_Import[91], p$1, 1), l = caml_call2(Base_Import[91], l$0, 1);
                        l$0 = l;
                        p$1 = p$0;
                    }
                }
                intro_sort(arr, max_depth$1, compare, left$0, caml_call2(Base_Import[93], l$0, 1));
                if (1 - middle_sorted) intro_sort(arr, max_depth$1, compare, l$0, r$2);
                var left$1 = caml_call2(Base_Import[91], r$2, 1);
                max_depth$0 = max_depth$1;
                left$0 = left$1;
            }
        }
        function sort$1(arr, compare, left, right) {
            return intro_sort(arr, 32, compare, left, right);
        }
        var Intro_sort = [
            0,
            sort$1,
            five_element_sort
        ];
        function sort$2(pos, len, arr, compare) {
            var _ay_ = caml_call1(length, arr), match = caml_call4(Base_Ordered_collection_common[1], pos, len, 0, _ay_), len$0 = match[2], pos$0 = match[1], _az_ = caml_call2(Base_Import[91], pos$0, len$0), _aA_ = caml_call2(Base_Import[93], _az_, 1);
            return caml_call4(Intro_sort[1], arr, compare, pos$0, _aA_);
        }
        return [
            0,
            ,
            ,
            ,
            ,
            Insertion_sort,
            Heap_sort,
            Intro_sort,
            sort$2
        ];
    }
    function get(_ax_, _aw_) {
        return _ax_[1 + _aw_];
    }
    function set(_av_, _au_, _at_) {
        _av_[1 + _au_] = _at_;
        return 0;
    }
    function length(_as_) {
        return _as_.length - 1;
    }
    var Sort = Sorter([
        0,
        get,
        set,
        length
    ]), sort = Sort[8], _a_ = [
        0,
        cst_src_array_ml,
        486,
        14
    ], _b_ = [
        0,
        [
            11,
            "length mismatch in ",
            [
                2,
                0,
                [
                    11,
                    ": ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " <> ",
                            [
                                4,
                                0,
                                0,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "length mismatch in %s: %d <> %d"
    ], cst_Array_iter2_exn = "Array.iter2_exn", cst_Array_map2_exn = "Array.map2_exn", cst_Array_fold2_exn = "Array.fold2_exn", cst_Array_exists2_exn = "Array.exists2_exn", cst_Array_for_all2_exn = "Array.for_all2_exn", _c_ = [
        0,
        "Array.findi_exn: not found"
    ], _d_ = [
        0,
        "Array.find_exn: not found"
    ];
    function of_array(t) {
        return t;
    }
    function to_array(t) {
        return t;
    }
    function is_empty(t) {
        return 0 === t.length - 1 ? 1 : 0;
    }
    function is_sorted(t, compare) {
        var i = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 < i[1] && result[1]) {
                var elt_i = t[1 + i[1]], elt_i_minus_1 = t[1 + caml_call2(Base_Import[93], i[1], 1)];
                if (0 < caml_call2(compare, elt_i_minus_1, elt_i)) result[1] = 0;
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function is_sorted_strictly(t, compare) {
        var i = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 < i[1] && result[1]) {
                var elt_i = t[1 + i[1]], elt_i_minus_1 = t[1 + caml_call2(Base_Import[93], i[1], 1)];
                if (0 <= caml_call2(compare, elt_i_minus_1, elt_i)) result[1] = 0;
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function merge(a1, a2, compare) {
        var l1 = a1.length - 1, l2 = a2.length - 1;
        if (0 === l1) return caml_call1(copy, a2);
        if (0 === l2) return caml_call1(copy, a1);
        var _an_ = a1[1 + caml_call2(Base_Import[93], l1, 1)];
        if (0 <= caml_call2(compare, a2[1], _an_)) return caml_call2(append, a1, a2);
        var _ao_ = a2[1 + caml_call2(Base_Import[93], l2, 1)];
        if (0 < caml_call2(compare, a1[1], _ao_)) return caml_call2(append, a2, a1);
        var len = caml_call2(Base_Import[91], l1, l2), merged = caml_call2(create, len, a1[1]), a1_index = [
            0,
            0
        ], a2_index = [
            0,
            0
        ], _aq_ = caml_call2(Base_Import[93], len, 1), _ap_ = 0;
        if (_aq_ >= 0) {
            var i = _ap_;
            for(;;){
                var use_a1 = l1 === a1_index[1] ? 0 : l2 === a2_index[1] ? 1 : caml_call2(compare, a1[1 + a1_index[1]], a2[1 + a2_index[1]]) <= 0 ? 1 : 0;
                if (use_a1) {
                    merged[1 + i] = a1[1 + a1_index[1]];
                    a1_index[1] = caml_call2(Base_Import[91], a1_index[1], 1);
                } else {
                    merged[1 + i] = a2[1 + a2_index[1]];
                    a2_index[1] = caml_call2(Base_Import[91], a2_index[1], 1);
                }
                var _ar_ = i + 1 | 0;
                if (_aq_ === i) break;
                i = _ar_;
            }
        }
        return merged;
    }
    function copy_matrix(_am_) {
        return caml_call2(map, _am_, copy);
    }
    function folding_map(t, init, f) {
        var acc = [
            0,
            init
        ];
        return caml_call2(map, t, function(x) {
            var match = caml_call2(f, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
    }
    function fold_map(t, init, f) {
        var acc = [
            0,
            init
        ], result = caml_call2(map, t, function(x) {
            var match = caml_call2(f, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
        return [
            0,
            acc[1],
            result
        ];
    }
    function fold_result(t, init, f) {
        return caml_call4(Base_Container[8], fold, init, f, t);
    }
    function fold_until(t, init, f, finish) {
        return caml_call5(Base_Container[9], fold, init, f, finish, t);
    }
    function sum(m, t, f) {
        return caml_call4(Base_Container[7], fold, m, t, f);
    }
    function extremal_element(t, compare, keep_left_if) {
        if (is_empty(t)) return 0;
        var result = [
            0,
            t[1]
        ], _aj_ = caml_call2(Base_Import[93], t.length - 1, 1), _ai_ = 1;
        if (_aj_ >= 1) {
            var i = _ai_;
            for(;;){
                var x = t[1 + i], _ak_ = result[1];
                result[1] = runtime.caml_csel_value(caml_call1(keep_left_if, caml_call2(compare, x, result[1])), x, _ak_);
                var _al_ = i + 1 | 0;
                if (_aj_ === i) break;
                i = _al_;
            }
        }
        return [
            0,
            result[1]
        ];
    }
    function min_elt(t, compare) {
        return extremal_element(t, compare, function(compare_result) {
            return compare_result < 0 ? 1 : 0;
        });
    }
    function max_elt(t, compare) {
        return extremal_element(t, compare, function(compare_result) {
            return 0 < compare_result ? 1 : 0;
        });
    }
    function foldi(t, init, f) {
        var acc = [
            0,
            init
        ], _ag_ = caml_call2(Base_Import[93], t.length - 1, 1), _af_ = 0;
        if (_ag_ >= 0) {
            var i = _af_;
            for(;;){
                acc[1] = caml_call3(f, i, acc[1], t[1 + i]);
                var _ah_ = i + 1 | 0;
                if (_ag_ === i) break;
                i = _ah_;
            }
        }
        return acc[1];
    }
    function folding_mapi(t, init, f) {
        var acc = [
            0,
            init
        ];
        return caml_call2(mapi, t, function(i, x) {
            var match = caml_call3(f, i, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
    }
    function fold_mapi(t, init, f) {
        var acc = [
            0,
            init
        ], result = caml_call2(mapi, t, function(i, x) {
            var match = caml_call3(f, i, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
        return [
            0,
            acc[1],
            result
        ];
    }
    function count(t, f) {
        var result = [
            0,
            0
        ], _ab_ = caml_call2(Base_Import[93], t.length - 1, 1), _aa_ = 0;
        if (_ab_ >= 0) {
            var i = _aa_;
            for(;;){
                var _ac_ = caml_call1(f, t[1 + i]), _ad_ = caml_call1(Base_Bool[31], _ac_);
                result[1] = caml_call2(Base_Import[91], result[1], _ad_);
                var _ae_ = i + 1 | 0;
                if (_ab_ === i) break;
                i = _ae_;
            }
        }
        return result[1];
    }
    function counti(t, f) {
        var result = [
            0,
            0
        ], _Y_ = caml_call2(Base_Import[93], t.length - 1, 1), _X_ = 0;
        if (_Y_ >= 0) {
            var i = _X_;
            for(;;){
                var _Z_ = caml_call2(f, i, t[1 + i]), ___ = caml_call1(Base_Bool[31], _Z_);
                result[1] = caml_call2(Base_Import[91], result[1], ___);
                var _$_ = i + 1 | 0;
                if (_Y_ === i) break;
                i = _$_;
            }
        }
        return result[1];
    }
    function concat_map(t, f) {
        return caml_call1(concat, caml_call1(to_list, caml_call2(map, t, f)));
    }
    function concat_mapi(t, f) {
        return caml_call1(concat, caml_call1(to_list, caml_call2(mapi, t, f)));
    }
    function rev_inplace(t) {
        var i = [
            0,
            0
        ], j = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ];
        for(;;){
            if (i[1] >= j[1]) return 0;
            caml_call3(swap, t, i[1], j[1]);
            i[1]++;
            j[1]--;
        }
    }
    function rev(t) {
        var t$0 = caml_call1(copy, t);
        rev_inplace(t$0);
        return t$0;
    }
    function of_list_rev(l) {
        if (!l) return [
            0
        ];
        var l$0 = l[2], a = l[1], _U_ = caml_call1(Base_List[45], l$0), len = caml_call2(Base_Import[91], 1, _U_), t = caml_call2(create, len, a), r = [
            0,
            l$0
        ], _V_ = caml_call2(Base_Import[93], len, 2);
        if (_V_ >= 0) {
            var i = _V_;
            for(;;){
                var match = r[1];
                if (!match) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _a_
                ], 1);
                var l$1 = match[2], a$0 = match[1];
                caml_check_bound(t, i)[1 + i] = a$0;
                r[1] = l$1;
                var _W_ = i - 1 | 0;
                if (0 === i) break;
                i = _W_;
            }
        }
        return t;
    }
    function of_list_map(xs, f) {
        if (!xs) return [
            0
        ];
        var tl = xs[2], hd = xs[1], _S_ = caml_call1(f, hd), _T_1 = caml_call1(Base_List[45], tl), a = caml_call2(create, caml_call2(Base_Import[91], 1, _T_1), _S_), i = 1, param = tl;
        for(;;){
            if (!param) return a;
            var tl$0 = param[2], hd$0 = param[1];
            a[1 + i] = caml_call1(f, hd$0);
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            param = tl$0;
        }
    }
    function of_list_mapi(xs, f) {
        if (!xs) return [
            0
        ];
        var tl = xs[2], hd = xs[1], _Q_ = caml_call2(f, 0, hd), _R_ = caml_call1(Base_List[45], tl), a = caml_call2(create, caml_call2(Base_Import[91], 1, _R_), _Q_), i = 1, param = tl;
        for(;;){
            if (!param) return a;
            var tl$0 = param[2], hd$0 = param[1];
            a[1 + i] = caml_call2(f, i, hd$0);
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            param = tl$0;
        }
    }
    function of_list_rev_map(xs, f) {
        var t = of_list_map(xs, f);
        rev_inplace(t);
        return t;
    }
    function of_list_rev_mapi(xs, f) {
        var t = of_list_mapi(xs, f);
        rev_inplace(t);
        return t;
    }
    function filter_mapi(t, f) {
        var r = [
            0,
            [
                0
            ]
        ], k = [
            0,
            0
        ], _O_ = caml_call2(Base_Import[93], t.length - 1, 1), _N_ = 0;
        if (_O_ >= 0) {
            var i = _N_;
            for(;;){
                var match = caml_call2(f, i, t[1 + i]);
                if (match) {
                    var a = match[1];
                    if (0 === k[1]) r[1] = caml_call2(create, t.length - 1, a);
                    r[1][1 + k[1]] = a;
                    k[1]++;
                }
                var _P_ = i + 1 | 0;
                if (_O_ === i) break;
                i = _P_;
            }
        }
        return k[1] === t.length - 1 ? r[1] : 0 < k[1] ? caml_call3(sub, r[1], 0, k[1]) : [
            0
        ];
    }
    function filter_map(t, f) {
        return filter_mapi(t, function(i, a) {
            return caml_call1(f, a);
        });
    }
    function filter_opt(t) {
        return filter_map(t, function(_M_) {
            return _M_;
        });
    }
    function check_length2_exn(name, t1, t2) {
        var n1 = t1.length - 1, n2 = t2.length - 1, _L_ = n1 !== n2 ? 1 : 0;
        return _L_ ? caml_call5(invalid_argf, _b_, name, n1, n2, 0) : _L_;
    }
    function iter2_exn(t1, t2, f) {
        check_length2_exn(cst_Array_iter2_exn, t1, t2);
        return caml_call2(iteri, t1, function(i, x1) {
            return caml_call2(f, x1, t2[1 + i]);
        });
    }
    function map2_exn(t1, t2, f) {
        check_length2_exn(cst_Array_map2_exn, t1, t2);
        return caml_call2(init, t1.length - 1, function(i) {
            return caml_call2(f, t1[1 + i], t2[1 + i]);
        });
    }
    function fold2_exn(t1, t2, init, f) {
        check_length2_exn(cst_Array_fold2_exn, t1, t2);
        return foldi(t1, init, function(i, ac, x) {
            return caml_call3(f, ac, x, t2[1 + i]);
        });
    }
    function filter(t, f) {
        return filter_map(t, function(x) {
            return caml_call1(f, x) ? [
                0,
                x
            ] : 0;
        });
    }
    function filteri(t, f) {
        return filter_mapi(t, function(i, x) {
            return caml_call2(f, i, x) ? [
                0,
                x
            ] : 0;
        });
    }
    function exists(t, f) {
        var i = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ], result = [
            0,
            0
        ];
        for(;;){
            if (0 <= i[1] && !result[1]) {
                if (caml_call1(f, t[1 + i[1]])) {
                    result[1] = 1;
                    continue;
                }
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function existsi(t, f) {
        var i = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ], result = [
            0,
            0
        ];
        for(;;){
            if (0 <= i[1] && !result[1]) {
                if (caml_call2(f, i[1], t[1 + i[1]])) {
                    result[1] = 1;
                    continue;
                }
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function mem(t, a, equal) {
        return exists(t, caml_call1(equal, a));
    }
    function for_all(t, f) {
        var i = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 <= i[1] && result[1]) {
                if (caml_call1(f, t[1 + i[1]])) {
                    i[1]--;
                    continue;
                }
                result[1] = 0;
                continue;
            }
            return result[1];
        }
    }
    function for_alli(t, f) {
        var length = t.length - 1, i = [
            0,
            caml_call2(Base_Import[93], length, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 <= i[1] && result[1]) {
                if (caml_call2(f, i[1], t[1 + i[1]])) {
                    i[1]--;
                    continue;
                }
                result[1] = 0;
                continue;
            }
            return result[1];
        }
    }
    function exists2_exn(t1, t2, f) {
        check_length2_exn(cst_Array_exists2_exn, t1, t2);
        var i = [
            0,
            caml_call2(Base_Import[93], t1.length - 1, 1)
        ], result = [
            0,
            0
        ];
        for(;;){
            if (0 <= i[1] && !result[1]) {
                if (caml_call2(f, t1[1 + i[1]], t2[1 + i[1]])) {
                    result[1] = 1;
                    continue;
                }
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function for_all2_local_exn(t1, t2, f) {
        check_length2_exn(cst_Array_for_all2_exn, t1, t2);
        var i = [
            0,
            caml_call2(Base_Import[93], t1.length - 1, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 <= i[1] && result[1]) {
                if (caml_call2(f, t1[1 + i[1]], t2[1 + i[1]])) {
                    i[1]--;
                    continue;
                }
                result[1] = 0;
                continue;
            }
            return result[1];
        }
    }
    function for_all2_exn(t1, t2, f) {
        return for_all2_local_exn(t1, t2, f);
    }
    function equal_local(equal, t1, t2) {
        var _K_ = t1.length - 1 === t2.length - 1 ? 1 : 0;
        return _K_ ? for_all2_local_exn(t1, t2, equal) : _K_;
    }
    function equal(equal, t1, t2) {
        return equal_local(equal, t1, t2);
    }
    function map_inplace(t, f) {
        var _I_ = caml_call2(Base_Import[93], t.length - 1, 1), _H_ = 0;
        if (_I_ >= 0) {
            var i = _H_;
            for(;;){
                t[1 + i] = caml_call1(f, t[1 + i]);
                var _J_ = i + 1 | 0;
                if (_I_ === i) break;
                i = _J_;
            }
        }
        return 0;
    }
    function findi_internal(t, f, if_found, if_not_found) {
        var length = t.length - 1;
        if (0 === length) return caml_call1(if_not_found, 0);
        var i = [
            0,
            0
        ], found = [
            0,
            0
        ], value_found = [
            0,
            t[1]
        ];
        for(;;){
            if (!found[1] && i[1] < length) {
                var value = t[1 + i[1]];
                if (caml_call2(f, i[1], value)) {
                    value_found[1] = value;
                    found[1] = 1;
                } else i[1]++;
                continue;
            }
            return found[1] ? caml_call2(if_found, i[1], value_found[1]) : caml_call1(if_not_found, 0);
        }
    }
    function findi(t, f) {
        return findi_internal(t, f, function(i, value) {
            return [
                0,
                [
                    0,
                    i,
                    value
                ]
            ];
        }, function(param) {
            return 0;
        });
    }
    function findi_exn(t, f) {
        return findi_internal(t, f, function(i, value) {
            return [
                0,
                i,
                value
            ];
        }, function(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Base_Import[297],
                _c_
            ], 1);
        });
    }
    function find_exn(t, f) {
        return findi_internal(t, function(i, x) {
            return caml_call1(f, x);
        }, function(param, value) {
            return value;
        }, function(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Base_Import[297],
                _d_
            ], 1);
        });
    }
    function find(t, f) {
        var _G_ = findi(t, function(i, x) {
            return caml_call1(f, x);
        });
        return caml_call2(Base_Option[24], _G_, function(param) {
            var x = param[2];
            return x;
        });
    }
    function find_map(t, f) {
        var length = t.length - 1;
        if (0 === length) return 0;
        var i = [
            0,
            0
        ], value_found = [
            0,
            0
        ];
        for(;;){
            if (caml_call1(Base_Option[52], value_found[1]) && i[1] < length) {
                var value = t[1 + i[1]];
                value_found[1] = caml_call1(f, value);
                i[1]++;
                continue;
            }
            return value_found[1];
        }
    }
    var not_found = [
        0,
        Base_Import[297],
        [
            0,
            "Array.find_map_exn: not found"
        ]
    ];
    function find_map_exn(t, f) {
        var match = find_map(t, f);
        if (!match) throw caml_maybe_attach_backtrace(not_found, 1);
        var x = match[1];
        return x;
    }
    function find_mapi(t, f) {
        var length = t.length - 1;
        if (0 === length) return 0;
        var i = [
            0,
            0
        ], value_found = [
            0,
            0
        ];
        for(;;){
            if (caml_call1(Base_Option[52], value_found[1]) && i[1] < length) {
                var value = t[1 + i[1]];
                value_found[1] = caml_call2(f, i[1], value);
                i[1]++;
                continue;
            }
            return value_found[1];
        }
    }
    var not_found$0 = [
        0,
        Base_Import[297],
        [
            0,
            "Array.find_mapi_exn: not found"
        ]
    ], cst_Array_reduce_exn = "Array.reduce_exn";
    function find_mapi_exn(t, f) {
        var match = find_mapi(t, f);
        if (!match) throw caml_maybe_attach_backtrace(not_found$0, 1);
        var x = match[1];
        return x;
    }
    function find_consecutive_duplicate(t, equal) {
        var n = t.length - 1;
        if (1 >= n) return 0;
        var result = [
            0,
            0
        ], i = [
            0,
            1
        ], prev = [
            0,
            t[1]
        ];
        for(;;){
            if (i[1] >= n) return result[1];
            var cur = t[1 + i[1]];
            if (caml_call2(equal, cur, prev[1])) {
                result[1] = [
                    0,
                    [
                        0,
                        prev[1],
                        cur
                    ]
                ];
                i[1] = n;
            } else {
                prev[1] = cur;
                i[1]++;
            }
        }
    }
    function reduce(t, f) {
        if (0 === t.length - 1) return 0;
        var r = [
            0,
            t[1]
        ], _E_ = caml_call2(Base_Import[93], t.length - 1, 1), _D_ = 1;
        if (_E_ >= 1) {
            var i = _D_;
            for(;;){
                r[1] = caml_call2(f, r[1], t[1 + i]);
                var _F_ = i + 1 | 0;
                if (_E_ === i) break;
                i = _F_;
            }
        }
        return [
            0,
            r[1]
        ];
    }
    function reduce_exn(t, f) {
        var match = reduce(t, f);
        if (!match) return caml_call1(Base_Import[126], cst_Array_reduce_exn);
        var v = match[1];
        return v;
    }
    var permute = Base_Array_permute[25], cst_Array_random_element_exn_e = "Array.random_element_exn: empty array", cst_Array_zip_exn = "Array.zip_exn", cst_Array_transpose_exn = "Array.transpose_exn";
    function random_element_exn(opt, t) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        if (is_empty(t)) return caml_call1(Base_Import[124], cst_Array_random_element_exn_e);
        var _C_ = caml_call2(Base_Random[19][7], random_state, t.length - 1);
        return caml_check_bound(t, _C_)[1 + _C_];
    }
    function random_element(opt, t) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        try {
            var _A_ = [
                0,
                random_element_exn([
                    0,
                    random_state
                ], t)
            ];
            return _A_;
        } catch (_B_) {
            return 0;
        }
    }
    function zip(t1, t2) {
        return t1.length - 1 !== t2.length - 1 ? 0 : [
            0,
            map2_exn(t1, t2, function(x1, x2) {
                return [
                    0,
                    x1,
                    x2
                ];
            })
        ];
    }
    function zip_exn(t1, t2) {
        return t1.length - 1 !== t2.length - 1 ? caml_call1(Base_Import[124], cst_Array_zip_exn) : map2_exn(t1, t2, function(x1, x2) {
            return [
                0,
                x1,
                x2
            ];
        });
    }
    function unzip(t) {
        var n = t.length - 1;
        if (0 === n) return [
            0,
            [
                0
            ],
            [
                0
            ]
        ];
        var match = caml_check_bound(t, 0)[1], y = match[2], x = match[1], res1 = caml_call2(create, n, x), res2 = caml_call2(create, n, y), _y_ = caml_call2(Base_Import[93], n, 1), _x_ = 1;
        if (_y_ >= 1) {
            var i = _x_;
            for(;;){
                var match$0 = caml_check_bound(t, i)[1 + i], y$0 = match$0[2], x$0 = match$0[1];
                caml_check_bound(res1, i)[1 + i] = x$0;
                caml_check_bound(res2, i)[1 + i] = y$0;
                var _z_ = i + 1 | 0;
                if (_y_ === i) break;
                i = _z_;
            }
        }
        return [
            0,
            res1,
            res2
        ];
    }
    function sorted_copy(t, compare) {
        var t1 = caml_call1(copy, t);
        sort(0, 0, t1, compare);
        return t1;
    }
    function partition_mapi(t, f) {
        var both = caml_call2(mapi, t, f), firsts = filter_map(both, function(param) {
            if (0 !== param[0]) return 0;
            var x = param[1];
            return [
                0,
                x
            ];
        }), seconds = filter_map(both, function(param) {
            if (0 === param[0]) return 0;
            var x = param[1];
            return [
                0,
                x
            ];
        });
        return [
            0,
            firsts,
            seconds
        ];
    }
    function partitioni_tf(t, f) {
        return partition_mapi(t, function(i, x) {
            return caml_call2(f, i, x) ? [
                0,
                x
            ] : [
                1,
                x
            ];
        });
    }
    function partition_map(t, f) {
        return partition_mapi(t, function(param, x) {
            return caml_call1(f, x);
        });
    }
    function partition_tf(t, f) {
        return partitioni_tf(t, function(param, x) {
            return caml_call1(f, x);
        });
    }
    function last(t) {
        var _w_ = caml_call2(Base_Import[93], t.length - 1, 1);
        return caml_check_bound(t, _w_)[1 + _w_];
    }
    function to_sequence_mutable(t) {
        return caml_call2(Base_Sequence[44], 0, function(i) {
            if (t.length - 1 <= i) return 0;
            var _v_ = caml_call2(Base_Import[91], i, 1);
            return [
                1,
                caml_check_bound(t, i)[1 + i],
                _v_
            ];
        });
    }
    function to_sequence(t) {
        return to_sequence_mutable(caml_call1(copy, t));
    }
    function cartesian_product(t1, t2) {
        if (!is_empty(t1) && !is_empty(t2)) {
            var n1 = t1.length - 1, n2 = t2.length - 1, _k_ = caml_check_bound(t2, 0)[1], _l_ = [
                0,
                caml_check_bound(t1, 0)[1],
                _k_
            ], t = caml_call2(create, caml_call2(Base_Import[88], n1, n2), _l_), r = [
                0,
                0
            ], _n_ = caml_call2(Base_Import[93], n1, 1), _m_ = 0;
            if (_n_ >= 0) {
                var i1 = _m_;
                for(;;){
                    var _p_ = caml_call2(Base_Import[93], n2, 1), _o_ = 0;
                    if (_p_ >= 0) {
                        var i2 = _o_;
                        for(;;){
                            var _r_ = caml_check_bound(t2, i2)[1 + i2], _s_ = [
                                0,
                                caml_check_bound(t1, i1)[1 + i1],
                                _r_
                            ], _t_ = r[1];
                            caml_check_bound(t, _t_)[1 + _t_] = _s_;
                            r[1]++;
                            var _u_ = i2 + 1 | 0;
                            if (_p_ === i2) break;
                            i2 = _u_;
                        }
                    }
                    var _q_ = i1 + 1 | 0;
                    if (_n_ === i1) break;
                    i1 = _q_;
                }
            }
            return t;
        }
        return [
            0
        ];
    }
    function transpose(tt) {
        if (0 === tt.length - 1) return [
            0,
            [
                0
            ]
        ];
        var width = tt.length - 1, depth = caml_check_bound(tt, 0)[1].length - 1;
        return exists(tt, function(t) {
            return t.length - 1 !== depth ? 1 : 0;
        }) ? 0 : [
            0,
            caml_call2(init, depth, function(d) {
                return caml_call2(init, width, function(w) {
                    return caml_check_bound(caml_check_bound(tt, w)[1 + w], d)[1 + d];
                });
            })
        ];
    }
    function transpose_exn(tt) {
        var match = transpose(tt);
        if (!match) return caml_call1(Base_Import[126], cst_Array_transpose_exn);
        var tt$0 = match[1];
        return tt$0;
    }
    function get$0(_j_, _i_) {
        return caml_check_bound(_j_, _i_)[1 + _i_];
    }
    function length$0(_h_) {
        return _h_.length - 1;
    }
    var include = caml_call1(Base_Binary_searchable[2], [
        0,
        get$0,
        length$0
    ]), binary_search = include[1], binary_search_segmented = include[2], _e_ = [
        0,
        cst_src_array_ml,
        917,
        6
    ];
    function length$1(_g_) {
        return _g_.length - 1;
    }
    function create_like(len, t) {
        if (0 === len) return [
            0
        ];
        if (0 < t.length - 1) return caml_call2(create, len, caml_check_bound(t, 0)[1]);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
    }
    var unsafe_blit = runtime.caml_array_blit, include$0 = caml_call1(Base_Blit[4], [
        0,
        create_like,
        length$1,
        unsafe_blit
    ]), blit = include$0[1], blito = include$0[2], unsafe_blit$0 = include$0[3], sub$0 = include$0[4], subo = include$0[5];
    function invariant(invariant_a, t) {
        return caml_call2(iter, t, invariant_a);
    }
    var Base_Array = [
        0,
        compare,
        compare_local,
        globalize,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        binary_search,
        binary_search_segmented,
        of_list,
        of_array,
        append,
        map,
        filter,
        filter_map,
        concat_map,
        partition_tf,
        partition_map,
        mem,
        is_empty,
        iter,
        fold,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        to_array,
        min_elt,
        max_elt,
        foldi,
        iteri,
        existsi,
        for_alli,
        counti,
        findi,
        find_mapi,
        init,
        mapi,
        filteri,
        filter_mapi,
        concat_mapi,
        invariant,
        max_length,
        create,
        create_local,
        create_float_uninitialized,
        make_matrix,
        copy_matrix,
        concat,
        copy,
        fill,
        blit,
        blito,
        unsafe_blit$0,
        sub$0,
        subo,
        folding_map,
        folding_mapi,
        fold_map,
        fold_mapi,
        fold_right,
        sort,
        stable_sort,
        is_sorted,
        is_sorted_strictly,
        merge,
        partitioni_tf,
        cartesian_product,
        transpose,
        transpose_exn,
        filter_opt,
        iter2_exn,
        map2_exn,
        fold2_exn,
        for_all2_exn,
        exists2_exn,
        swap,
        rev_inplace,
        rev,
        of_list_rev,
        of_list_map,
        of_list_mapi,
        of_list_rev_map,
        of_list_rev_mapi,
        map_inplace,
        find_exn,
        find_map_exn,
        findi_exn,
        find_mapi_exn,
        find_consecutive_duplicate,
        reduce,
        reduce_exn,
        permute,
        random_element,
        random_element_exn,
        zip,
        zip_exn,
        unzip,
        sorted_copy,
        last,
        equal,
        equal_local,
        to_sequence,
        to_sequence_mutable,
        [
            0,
            [
                0,
                Sort[5],
                Sort[6],
                Sort[7]
            ],
            function(_f_) {
                return [
                    0,
                    Sorter(_f_)[8]
                ];
            }
        ]
    ];
    runtime.caml_register_global(29, Base_Array, "Base__Array");
    return;
})(globalThis);
//# 18006 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_float0_ml = "src/float0.ml", caml_int64_bits_of_float = runtime.caml_int64_bits_of_float, caml_int64_float_of_bits = runtime.caml_int64_float_of_bits, caml_int64_neg = runtime.caml_int64_neg, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Assert_failure = global_data.Assert_failure, Base_Option = global_data.Base__Option, Base_Printf = global_data.Base__Printf, Stdlib_Float = global_data.Stdlib__Float;
    function ceil(_p_) {
        return Math.ceil(_p_);
    }
    function floor(_o_) {
        return Math.floor(_o_);
    }
    function mod_float(_n_, _m_) {
        return _n_ % _m_;
    }
    var modf = runtime.caml_modf_float, float_of_string = runtime.caml_float_of_string, float_of_string_opt = Base_Import[85][36], nan = Base_Import[85][24], infinity = Base_Import[85][22], neg_infinity = Base_Import[85][23], max_finite_value = Base_Import[85][25], epsilon_float = Base_Import[85][27], classify_float = runtime.caml_classify_float;
    function abs_float(_l_) {
        return Math.abs(_l_);
    }
    var is_integer = Stdlib_Float[18], _a_ = [
        0,
        [
            8,
            [
                0,
                0,
                0
            ],
            0,
            0,
            [
                12,
                32,
                [
                    12,
                    37,
                    [
                        12,
                        32,
                        [
                            8,
                            [
                                0,
                                0,
                                0
                            ],
                            0,
                            0,
                            [
                                11,
                                " in float0.ml: modulus should be positive",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%f %% %f in float0.ml: modulus should be positive"
    ];
    function symbol(_k_, _j_) {
        return Math.pow(_k_, _j_);
    }
    function symbol$0(a, b) {
        if (b < 0.) caml_call4(Base_Printf[7], _a_, a, b, 0);
        var m = a % b;
        return m < 0. ? caml_call2(Base_Import[92], m, b) : m;
    }
    var frexp = runtime.caml_frexp_float, ldexp = runtime.caml_ldexp_float, _b_ = [
        0,
        runtime.caml_int64_create_lo_mi_hi(0, 0, 0)
    ], _c_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _d_ = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 65535), _e_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _f_ = [
        0,
        cst_src_float0_ml,
        190,
        4
    ], _g_ = [
        0,
        cst_src_float0_ml,
        186,
        4
    ];
    function is_nan(x) {
        return x != x ? 1 : 0;
    }
    function to_int64_preserve_order(t) {
        return t != t ? 0 : t == 0. ? _b_ : 0. < t ? [
            0,
            caml_int64_bits_of_float(t)
        ] : [
            0,
            caml_int64_neg(caml_int64_bits_of_float(caml_call1(Base_Import[114], t)))
        ];
    }
    function to_int64_preserve_order_exn(x) {
        var _i_ = to_int64_preserve_order(x);
        return caml_call4(Base_Option[31], 0, 0, 0, _i_);
    }
    function of_int64_preserve_order(x) {
        return runtime.caml_greaterequal(x, _c_) ? caml_int64_float_of_bits(x) : caml_call1(Base_Import[114], caml_int64_float_of_bits(caml_int64_neg(x)));
    }
    function one_ulp(dir, t) {
        var match = to_int64_preserve_order(t);
        if (!match) return Base_Import[85][24];
        var x = match[1], _h_ = 759637122 <= dir ? _d_ : _e_;
        return of_int64_preserve_order(runtime.caml_int64_add(x, _h_));
    }
    function upper_bound_for_int(num_bits) {
        var exp = caml_call2(Base_Import[93], num_bits, 1);
        return one_ulp(759637122, Math.pow(2., exp));
    }
    function is_x_minus_one_exact(x) {
        return 1 - runtime.caml_equal(caml_int64_bits_of_float(x), caml_int64_bits_of_float(caml_call2(Base_Import[94], x, 1.)));
    }
    function lower_bound_for_int(num_bits) {
        var exp = caml_call2(Base_Import[93], num_bits, 1), min_int_as_float = caml_call1(Base_Import[114], Math.pow(2., exp));
        if (53 <= caml_call2(Base_Import[93], num_bits, 1)) {
            if (is_x_minus_one_exact(min_int_as_float)) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _f_
            ], 1);
            return min_int_as_float;
        }
        if (is_x_minus_one_exact(min_int_as_float)) return one_ulp(19067, caml_call2(Base_Import[94], min_int_as_float, 1.));
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _g_
        ], 1);
    }
    function min(a, b) {
        return runtime.caml_sse2_float64_min_bytecode(a, b);
    }
    function max(a, b) {
        return runtime.caml_sse2_float64_max_bytecode(a, b);
    }
    var Intrinsics_with_weird_nan_beha = [
        0,
        min,
        max
    ];
    function clamp_unchecked(to_clamp_maybe_nan, min_which_is_not_nan, max_which_is_not_nan) {
        var t_maybe_nan = caml_call2(Intrinsics_with_weird_nan_beha[2], min_which_is_not_nan, to_clamp_maybe_nan);
        return caml_call2(Intrinsics_with_weird_nan_beha[1], max_which_is_not_nan, t_maybe_nan);
    }
    var x = 0.;
    function box(f) {
        return caml_call2(Base_Import[92], f, x);
    }
    var include = Base_Import[108], ascending = include[1], descending = include[2], compare_local = include[3], equal_local = include[4], max$0 = include[5], min$0 = include[6], Base_Float0 = [
        0,
        ceil,
        floor,
        mod_float,
        modf,
        float_of_string,
        float_of_string_opt,
        nan,
        infinity,
        neg_infinity,
        max_finite_value,
        epsilon_float,
        classify_float,
        abs_float,
        is_integer,
        symbol,
        symbol$0,
        frexp,
        ldexp,
        is_nan,
        to_int64_preserve_order,
        to_int64_preserve_order_exn,
        of_int64_preserve_order,
        one_ulp,
        upper_bound_for_int,
        is_x_minus_one_exact,
        lower_bound_for_int,
        Intrinsics_with_weird_nan_beha,
        clamp_unchecked,
        box,
        ascending,
        descending,
        compare_local,
        equal_local,
        max$0,
        min$0
    ];
    runtime.caml_register_global(21, Base_Float0, "Base__Float0");
    return;
})(globalThis);
//# 18219 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Int_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Int_intf, "Base__Int_intf");
    return;
})(globalThis);
//# 18229 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), overflow_bound_max_int63_on_in = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 16383), overflow_bound_max_int64_value = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 32767), Base_Import = global_data.Base__Import, Base_Int_conversions = global_data.Base__Int_conversions, Assert_failure = global_data.Assert_failure, Base_Array0 = global_data.Base__Array0, int32_positive_overflow_bounds = [
        0,
        2147483647,
        2147483647,
        46340,
        1290,
        215,
        73,
        35,
        21,
        14,
        10,
        8,
        7,
        5,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ].slice(), overflow_bound_max_int_value = caml_call2(Base_Import[120], -1, 1), switcher = Base_Int_conversions[30] - 31 | 0, _g_ = [
        0,
        "src/pow_overflow_bounds.ml",
        216,
        9
    ], _a_ = runtime.caml_int64_create_lo_mi_hi(16777215, 127, 0), _b_ = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 16383), _c_ = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 16383), _h_ = [
        0,
        1073741823,
        1073741823,
        32767,
        1023,
        181,
        63,
        31,
        19,
        13,
        10,
        7,
        6,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ], _d_ = [
        0,
        runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 16383),
        runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 16383),
        runtime.caml_int64_create_lo_mi_hi(16777215, 127, 0),
        runtime.caml_int64_create_lo_mi_hi(1664510, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(46340, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5404, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(1290, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(463, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(215, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(118, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(73, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(49, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(35, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(27, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(21, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(17, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(14, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(12, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(10, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(9, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(8, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(7, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(7, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(6, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(1, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(1, 0, 0)
    ], _e_ = [
        0,
        runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 32767),
        runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 32767),
        runtime.caml_int64_create_lo_mi_hi(324403, 181, 0),
        runtime.caml_int64_create_lo_mi_hi(2097151, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(55108, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(6208, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(1448, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(511, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(234, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(127, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(78, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(52, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(38, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(28, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(22, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(18, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(15, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(13, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(11, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(9, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(8, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(7, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(7, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(6, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(6, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(1, 0, 0)
    ], _f_ = [
        0,
        runtime.caml_int64_create_lo_mi_hi(1, 0, 32768),
        runtime.caml_int64_create_lo_mi_hi(1, 0, 32768),
        runtime.caml_int64_create_lo_mi_hi(16452813, 16777034, 65535),
        runtime.caml_int64_create_lo_mi_hi(14680065, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16722108, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16771008, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16775768, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16776705, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16776982, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777089, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777138, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777164, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777178, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777188, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777194, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777198, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777201, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777203, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777205, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777207, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777208, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777209, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777209, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777210, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777210, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777211, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777211, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777211, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777212, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777212, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777212, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777212, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 65535)
    ], overflow_bound_max_int32_value = 2147483647;
    if (1 < switcher >>> 0) {
        if (32 !== switcher) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _g_
        ], 1);
        var int_positive_overflow_bounds = [
            0,
            caml_int64_to_int32(_c_),
            caml_int64_to_int32(_b_),
            caml_int64_to_int32(_a_),
            1664510,
            46340,
            5404,
            1290,
            463,
            215,
            118,
            73,
            49,
            35,
            27,
            21,
            17,
            14,
            12,
            10,
            9,
            8,
            7,
            7,
            6,
            5,
            5,
            5,
            4,
            4,
            4,
            4,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            1,
            1
        ];
    } else var int_positive_overflow_bounds = switcher ? caml_call2(Base_Array0[21], int32_positive_overflow_bounds, function(_i_) {
        return _i_;
    }) : _h_.slice();
    var int63_on_int64_positive_overfl = _d_.slice(), int64_positive_overflow_bounds = _e_.slice(), int64_negative_overflow_bounds = _f_.slice(), Base_Pow_overflow_bounds = [
        0,
        overflow_bound_max_int32_value,
        int32_positive_overflow_bounds,
        overflow_bound_max_int_value,
        int_positive_overflow_bounds,
        overflow_bound_max_int63_on_in,
        int63_on_int64_positive_overfl,
        overflow_bound_max_int64_value,
        int64_positive_overflow_bounds,
        int64_negative_overflow_bounds
    ];
    runtime.caml_register_global(16, Base_Pow_overflow_bounds, "Base__Pow_overflow_bounds");
    return;
})(globalThis);
//# 18692 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_exponent_can_not_be_negati = "exponent can not be negative", cst_integer_overflow_in_pow = "integer overflow in pow", caml_check_bound = runtime.caml_check_bound, caml_greaterthan = runtime.caml_greaterthan, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_lessthan = runtime.caml_lessthan;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Pow_overflow_bounds = global_data.Base__Pow_overflow_bounds, Base_Printf = global_data.Base__Printf, Stdlib_Int64 = global_data.Stdlib__Int64, invalid_argf = Base_Printf[7], _a_ = [
        0,
        [
            11,
            cst_exponent_can_not_be_negati,
            0
        ],
        cst_exponent_can_not_be_negati
    ], _b_ = [
        0,
        [
            11,
            cst_integer_overflow_in_pow,
            0
        ],
        cst_integer_overflow_in_pow
    ];
    function negative_exponent(param) {
        return caml_call2(Base_Printf[7], _a_, 0);
    }
    function overflow(param) {
        return caml_call2(Base_Printf[7], _b_, 0);
    }
    function int_pow(base, exponent) {
        if (exponent < 0) negative_exponent(0);
        var _J_ = 1 < caml_call1(Base_Import[123], base) ? 1 : 0;
        if (_J_) {
            var _K_ = 63 < exponent ? 1 : 0;
            if (_K_) var _L_ = _K_;
            else var _M_ = caml_check_bound(Base_Pow_overflow_bounds[4], exponent)[1 + exponent], _L_ = _M_ < caml_call1(Base_Import[123], base) ? 1 : 0;
        } else var _L_ = _J_;
        if (_L_) overflow(0);
        return runtime.Base_int_math_int_pow_stub(base, exponent);
    }
    var abs = Stdlib_Int64[8], _c_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _d_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _e_ = runtime.caml_int64_create_lo_mi_hi(63, 0, 0), _f_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _g_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _h_ = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 65535), _i_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _j_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _k_ = runtime.caml_int64_create_lo_mi_hi(63, 0, 0);
    function int64_pow(base, exponent) {
        if (caml_lessthan(exponent, _c_)) negative_exponent(0);
        var _A_ = caml_greaterthan(base, _d_), _B_ = _A_ || caml_lessthan(base, _h_);
        if (_B_) {
            var _C_ = caml_greaterthan(exponent, _e_);
            if (_C_) var _D_ = _C_;
            else {
                var _E_ = runtime.caml_greaterequal(base, _f_);
                if (_E_) var _F_ = caml_int64_to_int32(exponent), _G_ = caml_greaterthan(base, caml_check_bound(Base_Pow_overflow_bounds[8], _F_)[1 + _F_]);
                else var _G_ = _E_;
                if (_G_) var _D_ = _G_;
                else {
                    var _H_ = caml_lessthan(base, _g_);
                    if (_H_) var _I_ = caml_int64_to_int32(exponent), _D_ = caml_lessthan(base, caml_check_bound(Base_Pow_overflow_bounds[9], _I_)[1 + _I_]);
                    else var _D_ = _H_;
                }
            }
        } else var _D_ = _B_;
        if (_D_) overflow(0);
        return runtime.Base_int_math_int64_pow_stub(base, exponent);
    }
    function int63_pow_on_int64(base, exponent) {
        if (caml_lessthan(exponent, _i_)) negative_exponent(0);
        var _v_ = caml_greaterthan(caml_call1(abs, base), _j_);
        if (_v_) {
            var _w_ = caml_greaterthan(exponent, _k_);
            if (_w_) var _x_ = _w_;
            else var _y_ = caml_int64_to_int32(exponent), _z_ = caml_check_bound(Base_Pow_overflow_bounds[6], _y_)[1 + _y_], _x_ = caml_greaterthan(caml_call1(abs, base), _z_);
        } else var _x_ = _v_;
        if (_x_) overflow(0);
        return runtime.Base_int_math_int64_pow_stub(base, exponent);
    }
    var Private = [
        0,
        int_pow,
        int64_pow,
        int63_pow_on_int64
    ], _l_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    12,
                    37,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " in core_int.ml: modulus should be positive",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s %% %s in core_int.ml: modulus should be positive"
    ], _m_ = [
        0,
        [
            2,
            0,
            [
                11,
                " /",
                [
                    12,
                    37,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " in core_int.ml: divisor should be positive",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s /%% %s in core_int.ml: divisor should be positive"
    ], Base_Int_math = [
        0,
        function(X) {
            function symbol(x, y) {
                if (caml_call2(X[11], y, X[18])) {
                    var _u_ = caml_call1(X[4], y);
                    caml_call4(invalid_argf, _l_, caml_call1(X[4], x), _u_, 0);
                }
                var rval = caml_call2(X[20], x, y);
                return caml_call2(X[14], rval, X[18]) ? caml_call2(X[5], rval, y) : rval;
            }
            var one = caml_call1(X[19], 1);
            function symbol$0(x, y) {
                if (caml_call2(X[11], y, X[18])) {
                    var _r_ = caml_call1(X[4], y);
                    caml_call4(invalid_argf, _m_, caml_call1(X[4], x), _r_, 0);
                }
                if (!caml_call2(X[14], x, X[18])) return caml_call2(X[8], x, y);
                var _s_ = caml_call2(X[5], x, one), _t_ = caml_call2(X[8], _s_, y);
                return caml_call2(X[6], _t_, one);
            }
            function symbol$1(x, y) {
                var _p_ = caml_call1(X[2], y), _q_ = caml_call1(X[2], x);
                return caml_call2(Base_Import[96], _q_, _p_);
            }
            function round_down(i, modulus) {
                var _o_ = symbol(i, modulus);
                return caml_call2(X[6], i, _o_);
            }
            function round_up(i, modulus) {
                var remainder = symbol(i, modulus);
                if (caml_call2(X[12], remainder, X[18])) return i;
                var _n_ = caml_call2(X[5], i, modulus);
                return caml_call2(X[6], _n_, remainder);
            }
            function round_towards_zero(i, to_multiple_of) {
                return caml_call2(X[12], i, X[18]) ? X[18] : caml_call2(X[13], i, X[18]) ? round_down(i, to_multiple_of) : round_up(i, to_multiple_of);
            }
            function round_nearest(i, modulus) {
                var remainder = symbol(i, modulus), modulus_minus_remainder = caml_call2(X[6], modulus, remainder);
                return caml_call2(X[11], modulus_minus_remainder, remainder) ? caml_call2(X[5], i, modulus_minus_remainder) : caml_call2(X[6], i, remainder);
            }
            function round(opt, i, to_multiple_of) {
                var dir = opt ? opt[1] : 857423934;
                return 857423934 <= dir ? 1003109192 <= dir ? round_towards_zero(i, to_multiple_of) : round_nearest(i, to_multiple_of) : 759637122 <= dir ? round_down(i, to_multiple_of) : round_up(i, to_multiple_of);
            }
            return [
                0,
                symbol,
                symbol$0,
                symbol$1,
                round,
                round_towards_zero,
                round_down,
                round_up,
                round_nearest
            ];
        },
        Private
    ];
    runtime.caml_register_global(17, Base_Int_math, "Base__Int_math");
    return;
})(globalThis);
//# 18930 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function stage(_b_) {
        return _b_;
    }
    function unstage(_a_) {
        return _a_;
    }
    var Base_Staged = [
        0,
        stage,
        unstage
    ];
    runtime.caml_register_global(0, Base_Staged, "Base__Staged");
    return;
})(globalThis);
//# 18942 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Bytes_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Bytes_intf, "Base__Bytes_intf");
    return;
})(globalThis);
//# 18952 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), module_name = "Base.Char", Base_Import = global_data.Base__Import, Base_Hash = global_data.Base__Hash, Base_Sexp = global_data.Base__Sexp, Base_Error = global_data.Base__Error, Stdlib_Format = global_data.Stdlib__Format, Base_String0 = global_data.Base__String0, Base_Char0 = global_data.Base__Char0, Base_Identifiable = global_data.Base__Identifiable, Base_Array0 = global_data.Base__Array0, Base_Comparable = global_data.Base__Comparable, failwithf = Base_Char0[1], escaped = Base_Char0[2], lowercase = Base_Char0[3], to_int = Base_Char0[4], unsafe_of_int = Base_Char0[5], uppercase = Base_Char0[6], min_value = Base_Char0[8], max_value = Base_Char0[9], of_int = Base_Char0[10], of_int_exn = Base_Char0[11], compare = Base_Import[226], hash_fold_t = Base_Import[205], func = Base_Import[219];
    function hash(x) {
        return caml_call1(func, x);
    }
    var globalize = Base_Import[282], t_of_sexp = Base_Import[162], sexp_of_t = Base_Import[138], t_sexp_grammar = Base_Import[184], _a_ = [
        0,
        [
            11,
            "Char.of_string: ",
            [
                3,
                0,
                0
            ]
        ],
        "Char.of_string: %S"
    ];
    function to_string(t) {
        return caml_call2(Base_String0[8], 1, t);
    }
    function of_string(s) {
        return 1 === runtime.caml_ml_string_length(s) ? runtime.caml_string_get(s, 0) : caml_call3(failwithf, _a_, s, 0);
    }
    var include = caml_call1(Base_Identifiable[1], [
        0,
        compare,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        of_string,
        to_string,
        module_name
    ]), hash_fold_t$0 = include[1], hash$0 = include[2], t_of_sexp$0 = include[3], sexp_of_t$0 = include[4], of_string$0 = include[5], to_string$0 = include[6], between = include[19], clamp_exn = include[20], clamp = include[21], comparator = include[22], hashable = include[24], _b_ = [
        0,
        [
            1,
            0
        ],
        "%C"
    ];
    function pp(fmt, c) {
        return caml_call3(Stdlib_Format[139], fmt, _b_, c);
    }
    function invariant(param) {
        return 0;
    }
    var _c_ = caml_call2(Base_Array0[12], 256, unsafe_of_int), all = caml_call1(Base_Array0[16], _c_), _d_ = [
        0,
        [
            11,
            "Char.get_digit_exn ",
            [
                1,
                [
                    11,
                    ": not a digit",
                    0
                ]
            ]
        ],
        "Char.get_digit_exn %C: not a digit"
    ], cst_char = "char", cst_Char_get_hex_digit_exn_not = "Char.get_hex_digit_exn: not a hexadecimal digit";
    function is_lowercase(param) {
        return 25 < param - 97 >>> 0 ? 0 : 1;
    }
    function is_uppercase(param) {
        return 25 < param - 65 >>> 0 ? 0 : 1;
    }
    function is_print(param) {
        return 94 < param - 32 >>> 0 ? 0 : 1;
    }
    function is_whitespace(param) {
        a: {
            if (14 <= param) {
                if (32 === param) break a;
            } else if (9 <= param) break a;
            return 0;
        }
        return 1;
    }
    function is_digit(param) {
        return 9 < param - 48 >>> 0 ? 0 : 1;
    }
    function is_alpha(param) {
        a: {
            if (91 <= param) {
                if (25 < param - 97 >>> 0) break a;
            } else if (65 > param) break a;
            return 1;
        }
        return 0;
    }
    function is_alphanum(param) {
        var _v_ = param - 48 | 0;
        a: {
            if (42 < _v_ >>> 0) {
                if (25 < _v_ - 49 >>> 0) break a;
            } else if (6 >= _v_ - 10 >>> 0) break a;
            return 1;
        }
        return 0;
    }
    function get_digit_unsafe(t) {
        var _t_ = caml_call1(to_int, 48), _u_ = caml_call1(to_int, t);
        return caml_call2(Base_Import[93], _u_, _t_);
    }
    function get_digit_exn(t) {
        return is_digit(t) ? get_digit_unsafe(t) : caml_call3(failwithf, _d_, t, 0);
    }
    function get_digit(t) {
        return is_digit(t) ? [
            0,
            get_digit_unsafe(t)
        ] : 0;
    }
    function is_hex_digit(param) {
        var _s_ = param - 48 | 0;
        a: {
            if (22 < _s_ >>> 0) {
                if (5 < _s_ - 49 >>> 0) break a;
            } else if (6 >= _s_ - 10 >>> 0) break a;
            return 1;
        }
        return 0;
    }
    function is_hex_digit_lower(param) {
        a: {
            if (58 <= param) {
                if (5 < param - 97 >>> 0) break a;
            } else if (48 > param) break a;
            return 1;
        }
        return 0;
    }
    function is_hex_digit_upper(param) {
        a: {
            if (58 <= param) {
                if (5 < param - 65 >>> 0) break a;
            } else if (48 > param) break a;
            return 1;
        }
        return 0;
    }
    function get_hex_digit_exn(t) {
        if (65 <= t) {
            if (97 <= t) {
                if (103 > t) {
                    var _k_ = caml_call1(to_int, 97), _l_ = caml_call1(to_int, t), _m_ = caml_call2(Base_Import[93], _l_, _k_);
                    return caml_call2(Base_Import[91], _m_, 10);
                }
            } else if (71 > t) {
                var _n_ = caml_call1(to_int, 65), _o_ = caml_call1(to_int, t), _p_ = caml_call2(Base_Import[93], _o_, _n_);
                return caml_call2(Base_Import[91], _p_, 10);
            }
        } else if (9 >= t - 48 >>> 0) {
            var _q_ = caml_call1(to_int, 48), _r_ = caml_call1(to_int, t);
            return caml_call2(Base_Import[93], _r_, _q_);
        }
        var _i_ = [
            0,
            [
                0,
                cst_char,
                caml_call1(sexp_of_t$0, t)
            ],
            0
        ], _j_ = caml_call2(Base_Sexp[10], cst_Char_get_hex_digit_exn_not, _i_);
        return caml_call1(Base_Error[32], _j_);
    }
    function get_hex_digit(t) {
        return is_hex_digit(t) ? [
            0,
            get_hex_digit_exn(t)
        ] : 0;
    }
    var symbol = Base_Import[106][6], symbol$0 = Base_Import[106][2], symbol$1 = Base_Import[106][4], symbol$2 = Base_Import[106][5], symbol$3 = Base_Import[106][1], symbol$4 = Base_Import[106][3], O = [
        0,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4
    ], t_of_sexp$1 = Base_Import[162], sexp_of_t$1 = Base_Import[138], t_sexp_grammar$0 = Base_Import[184];
    function compare$0(c1, c2) {
        var _g_ = caml_call1(lowercase, c2), _h_ = caml_call1(lowercase, c1);
        return caml_call2(Base_Import[106][9], _h_, _g_);
    }
    function compare_local(c1, c2) {
        return compare$0(c1, c2);
    }
    function hash_fold_t$1(state, t) {
        var _f_ = caml_call1(lowercase, t);
        return caml_call2(Base_Import[205], state, _f_);
    }
    function hash$1(t) {
        return caml_call3(Base_Hash[14], 0, hash_fold_t$1, t);
    }
    var include$0 = caml_call1(Base_Comparable[11], [
        0,
        compare$0,
        sexp_of_t$1
    ]), symbol$5 = include$0[1], symbol$6 = include$0[2], symbol$7 = include$0[3], symbol$8 = include$0[4], symbol$9 = include$0[5], symbol$10 = include$0[6], equal = include$0[7], compare$1 = include$0[8], min = include$0[9], max = include$0[10], ascending = include$0[11], descending = include$0[12], between$0 = include$0[13], clamp_exn$0 = include$0[14], clamp$0 = include$0[15], comparator$0 = include$0[16];
    function equal_local(t1, t2) {
        var _e_ = compare$0(t1, t2);
        return caml_call2(Base_Import[242], _e_, 0);
    }
    var include$1 = Base_Import[106], symbol$11 = include$1[1], symbol$12 = include$1[2], symbol$13 = include$1[3], symbol$14 = include$1[4], symbol$15 = include$1[5], symbol$16 = include$1[6], ascending$0 = include$1[7], descending$0 = include$1[8], compare$2 = include$1[9], compare_local$0 = include$1[10], equal$0 = include$1[11], equal_local$0 = include$1[12], max$0 = include$1[13], min$0 = include$1[14], Base_Char = [
        0,
        all,
        globalize,
        t_sexp_grammar,
        hash_fold_t$0,
        hash$0,
        t_of_sexp$0,
        sexp_of_t$0,
        of_string$0,
        to_string$0,
        symbol$16,
        symbol$12,
        symbol$14,
        symbol$15,
        symbol$11,
        symbol$13,
        equal$0,
        compare$2,
        min$0,
        max$0,
        ascending$0,
        descending$0,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        equal_local$0,
        compare_local$0,
        invariant,
        O,
        to_int,
        of_int,
        of_int_exn,
        unsafe_of_int,
        escaped,
        lowercase,
        uppercase,
        is_digit,
        is_lowercase,
        is_uppercase,
        is_alpha,
        is_alphanum,
        is_print,
        is_whitespace,
        get_digit,
        get_digit_exn,
        is_hex_digit,
        is_hex_digit_lower,
        is_hex_digit_upper,
        get_hex_digit,
        get_hex_digit_exn,
        min_value,
        max_value,
        [
            0,
            hash_fold_t$1,
            hash$1,
            t_of_sexp$1,
            sexp_of_t$1,
            t_sexp_grammar$0,
            symbol$5,
            symbol$6,
            symbol$7,
            symbol$8,
            symbol$9,
            symbol$10,
            equal,
            compare$1,
            min,
            max,
            ascending,
            descending,
            between$0,
            clamp_exn$0,
            clamp$0,
            comparator$0,
            equal_local,
            compare_local
        ]
    ];
    runtime.caml_register_global(16, Base_Char, "Base__Char");
    return;
})(globalThis);
//# 19303 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bytes_unsafe_get = runtime.caml_bytes_unsafe_get, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_unsafe_get = runtime.caml_string_unsafe_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Char = global_data.Base__Char, Base_Bytes0 = global_data.Base__Bytes0, Base_Import0 = global_data.Base__Import0;
    function tr_create_map(target, replacement) {
        var tr_map = caml_call1(Base_Bytes0[7], 256), i$3 = 0;
        for(;;){
            caml_bytes_unsafe_set(tr_map, i$3, caml_call1(Base_Char[34], i$3));
            var _j_ = i$3 + 1 | 0;
            if (255 === i$3) break;
            i$3 = _j_;
        }
        var _b_ = caml_call2(Base_Import0[97][4], caml_ml_string_length(target), caml_ml_string_length(replacement)) - 1 | 0, _a_ = 0;
        if (_b_ >= 0) {
            var i$2 = _a_;
            for(;;){
                var index$0 = caml_call1(Base_Char[32], caml_string_unsafe_get(target, i$2));
                caml_bytes_unsafe_set(tr_map, index$0, caml_string_unsafe_get(replacement, i$2));
                var _i_ = i$2 + 1 | 0;
                if (_b_ === i$2) break;
                i$2 = _i_;
            }
        }
        var last_replacement = caml_string_unsafe_get(replacement, caml_ml_string_length(replacement) - 1 | 0), _c_ = caml_call2(Base_Import0[97][4], caml_ml_string_length(target), caml_ml_string_length(replacement)), _d_ = caml_ml_string_length(target) - 1 | 0;
        if (_d_ >= _c_) {
            var i$1 = _c_;
            for(;;){
                var index = caml_call1(Base_Char[32], caml_string_unsafe_get(target, i$1));
                caml_bytes_unsafe_set(tr_map, index, last_replacement);
                var _h_ = i$1 + 1 | 0;
                if (_d_ === i$1) break;
                i$1 = _h_;
            }
        }
        var first_target = runtime.caml_string_get(target, 0), _f_ = caml_bytes_unsafe_get(tr_map, caml_call1(Base_Char[32], first_target));
        if (!caml_call2(Base_Char[15], _f_, first_target)) {
            var i = 0;
            for(;;){
                if (256 === i) var _g_ = 0;
                else {
                    var _e_ = caml_call1(Base_Char[34], i);
                    if (!caml_call2(Base_Char[15], caml_bytes_unsafe_get(tr_map, i), _e_)) {
                        var i$0 = i + 1 | 0;
                        i = i$0;
                        continue;
                    }
                    var _g_ = 1;
                }
                if (_g_) break;
                return 0;
            }
        }
        return [
            0,
            runtime.caml_string_of_bytes(tr_map)
        ];
    }
    var Base_Bytes_tr = [
        0,
        tr_create_map
    ];
    runtime.caml_register_global(3, Base_Bytes_tr, "Base__Bytes_tr");
    return;
})(globalThis);
//# 19405 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_String_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_String_intf, "Base__String_intf");
    return;
})(globalThis);
//# 19415 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$15 = "", cst_case_sensitive = "case_sensitive", cst_char$1 = "char", cst_escape_char$1 = "escape_char", cst_pattern = "pattern", cst_pos$2 = "pos", cst_src_string_ml = "src/string.ml", cst_str$1 = "str", caml_blit_string = runtime.caml_blit_string, caml_bytes_set = runtime.caml_bytes_set, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_string_of_bytes = runtime.caml_string_of_bytes, caml_string_unsafe_get = runtime.caml_string_unsafe_get, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), cst$14 = cst$15, cst$13 = cst$15, cst$12 = cst$15, cst$11 = cst$15, cst$10 = cst$15, cst$8 = cst$15, cst$9 = cst$15, cst$6 = cst$15, cst$7 = cst$15, cst$5 = cst$15, cst$4 = cst$15, cst$3 = cst$15, cst$2 = cst$15, cst$1 = cst$15, cst$0 = cst$15, cst = cst$15, codec_name = "UTF-8", module_name = "Base.String.Utf8", codec_name$0 = "UTF-16LE", module_name$0 = "Base.String.Utf16le", codec_name$1 = "UTF-16BE", module_name$1 = "Base.String.Utf16be", codec_name$2 = "UTF-32LE", module_name$2 = "Base.String.Utf32le", codec_name$3 = "UTF-32BE", module_name$3 = "Base.String.Utf32be", Base_Char = global_data.Base__Char, Base_Import = global_data.Base__Import, Base_Uchar0 = global_data.Base__Uchar0, Base_Bytes0 = global_data.Base__Bytes0, Assert_failure = global_data.Assert_failure, Base_List = global_data.Base__List, Base_Sequence = global_data.Base__Sequence, Base_Sexp = global_data.Base__Sexp, CamlinternalLazy = global_data.CamlinternalLazy, Base_Printf = global_data.Base__Printf, Base_Sexpable = global_data.Base__Sexpable, Base_Identifiable = global_data.Base__Identifiable, Base_Indexed_container = global_data.Base__Indexed_container, Base_Or_error = global_data.Base__Or_error, Base_Option = global_data.Base__Option, Base_Array0 = global_data.Base__Array0, Base_Int0 = global_data.Base__Int0, Stdlib_Format = global_data.Stdlib__Format, Base_Bytes_tr = global_data.Base__Bytes_tr, Base_Container = global_data.Base__Container, Base_Hash = global_data.Base__Hash, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common, Base_String0 = global_data.Base__String0, Base_Error = global_data.Base__Error, Base_Staged = global_data.Base__Staged, Base_Comparator = global_data.Base__Comparator, Base_Comparable = global_data.Base__Comparable, max_length = Base_String0[2], symbol_concat = Base_String0[3], capitalize = Base_String0[4], compare = Base_String0[5], escaped = Base_String0[6], lowercase = Base_String0[7], make = Base_String0[8], uncapitalize = Base_String0[10], uppercase = Base_String0[11], is_valid_utf_8 = Base_String0[12], is_valid_utf_16le = Base_String0[13], is_valid_utf_16be = Base_String0[14], get_utf_8_uchar = Base_String0[15], get_utf_16le_uchar = Base_String0[16], get_utf_16be_uchar = Base_String0[17], get_utf_32le_uchar = Base_String0[18], get_utf_32be_uchar = Base_String0[19], concat = Base_String0[20], iter = Base_String0[21], split_lines = Base_String0[22], invalid_argf = Base_Printf[7], raise_s = Base_Error[32], stage = Base_Staged[1], globalize = Base_Import[289], hash_fold_t = Base_Import[208], func = Base_Import[222];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[160], sexp_of_t = Base_Import[136], t_sexp_grammar = Base_Import[182], hashable = [
        0,
        hash,
        compare,
        sexp_of_t
    ], include = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ]), comparator = include[1], _a_ = [
        0,
        "String.index_exn: not found"
    ], _b_ = [
        0,
        "String.index_from_exn: not found"
    ], cst_String_index_from_exn = "String.index_from_exn", _c_ = [
        0,
        "String.rindex_exn: not found"
    ], _d_ = [
        0,
        "String.rindex_from_exn: not found"
    ], cst_String_rindex_from_exn = "String.rindex_from_exn", _e_ = [
        0,
        cst_case_sensitive
    ], _f_ = [
        0,
        cst_pattern
    ], cst_substring = "substring", cst_Substring_not_found = "Substring not found", _g_ = [
        0,
        "kmp_array"
    ], _h_ = [
        0,
        cst_case_sensitive
    ], _i_ = [
        0,
        cst_pattern
    ];
    function invariant(param) {
        return 0;
    }
    function unsafe_sub(src, pos, len) {
        if (0 === len) return cst;
        var dst = caml_call1(Base_Bytes0[7], len);
        caml_blit_string(src, pos, dst, 0, len);
        return caml_string_of_bytes(dst);
    }
    function sub(src, pos, len) {
        if (0 === pos && len === caml_ml_string_length(src)) return src;
        caml_call3(Base_Ordered_collection_common[2], pos, len, caml_ml_string_length(src));
        return unsafe_sub(src, pos, len);
    }
    function subo(opt, len, src) {
        var pos = opt ? opt[1] : 0;
        if (len) var i = len[1], i$0 = i;
        else var i$0 = caml_call2(Base_Import[93], caml_ml_string_length(src), pos);
        return sub(src, pos, i$0);
    }
    function contains(opt, len, t, char$0) {
        var pos$1 = opt ? opt[1] : 0, total_length = caml_ml_string_length(t), _ej_ = caml_call2(Base_Import[93], total_length, pos$1), len$0 = caml_call2(Base_Option[30], len, _ej_);
        caml_call3(Base_Ordered_collection_common[2], pos$1, len$0, total_length);
        var end = caml_call2(Base_Import[91], pos$1, len$0), pos = pos$1;
        for(;;){
            var _eg_ = pos < end ? 1 : 0;
            if (_eg_) {
                var _eh_ = caml_call2(Base_Char[16], caml_string_unsafe_get(t, pos), char$0);
                if (!_eh_) {
                    var pos$0 = caml_call2(Base_Import[91], pos, 1);
                    pos = pos$0;
                    continue;
                }
                var _ei_ = _eh_;
            } else var _ei_ = _eg_;
            return _ei_;
        }
    }
    function is_empty(t) {
        return 0 === caml_ml_string_length(t) ? 1 : 0;
    }
    function index_from_internal(string, len, not_found, found, char$0, pos) {
        var pos$0 = pos;
        for(;;){
            if (len <= pos$0) return caml_call1(not_found, 0);
            if (caml_call2(Base_Char[16], caml_string_unsafe_get(string, pos$0), char$0)) return caml_call1(found, pos$0);
            var pos$1 = caml_call2(Base_Import[91], pos$0, 1);
            pos$0 = pos$1;
        }
    }
    function index(t, char$0) {
        return index_from_internal(t, caml_ml_string_length(t), function(param) {
            return 0;
        }, Base_Option[49], char$0, 0);
    }
    function index_exn(t, char$0) {
        return index_from_internal(t, caml_ml_string_length(t), function(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Base_Import[297],
                _a_
            ], 1);
        }, function(_ef_) {
            return _ef_;
        }, char$0, 0);
    }
    function index_from(t, pos, char$0) {
        return index_from_internal(t, caml_ml_string_length(t), function(param) {
            return 0;
        }, Base_Option[49], char$0, pos);
    }
    function not_found(param) {
        throw caml_maybe_attach_backtrace([
            0,
            Base_Import[297],
            _b_
        ], 1);
    }
    function index_from_exn(t, pos, char$0) {
        var len = caml_ml_string_length(t);
        if (0 <= pos && len >= pos) return index_from_internal(t, len, not_found, function(_ee_) {
            return _ee_;
        }, char$0, pos);
        return caml_call1(Base_Import[126], cst_String_index_from_exn);
    }
    function rindex_from_internal(string, char$0, found, not_found, pos) {
        var pos$0 = pos;
        for(;;){
            if (0 > pos$0) return caml_call1(not_found, 0);
            if (caml_call2(Base_Char[16], caml_string_unsafe_get(string, pos$0), char$0)) return caml_call1(found, pos$0);
            var pos$1 = caml_call2(Base_Import[93], pos$0, 1);
            pos$0 = pos$1;
        }
    }
    function rindex(t, char$0) {
        var _ed_ = caml_call2(Base_Import[93], caml_ml_string_length(t), 1);
        return rindex_from_internal(t, char$0, Base_Option[49], function(param) {
            return 0;
        }, _ed_);
    }
    function rindex_exn(t, char$0) {
        return rindex_from_internal(t, char$0, function(_ec_) {
            return _ec_;
        }, function(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Base_Import[297],
                _c_
            ], 1);
        }, caml_call2(Base_Import[93], caml_ml_string_length(t), 1));
    }
    function rindex_from(t, pos, char$0) {
        return rindex_from_internal(t, char$0, Base_Option[49], function(param) {
            return 0;
        }, pos);
    }
    function not_found$0(param) {
        throw caml_maybe_attach_backtrace([
            0,
            Base_Import[297],
            _d_
        ], 1);
    }
    function rindex_from_exn(t, pos, char$0) {
        if (-1 <= pos && caml_ml_string_length(t) > pos) return rindex_from_internal(t, char$0, function(_eb_) {
            return _eb_;
        }, not_found$0, pos);
        return caml_call1(Base_Import[126], cst_String_rindex_from_exn);
    }
    function sexp_of_t$0(param) {
        var case_sensitive = param[2], pattern = param[1], _ea_ = [
            0,
            [
                1,
                [
                    0,
                    _e_,
                    [
                        0,
                        caml_call1(Base_Import[135], case_sensitive),
                        0
                    ]
                ]
            ],
            0
        ];
        return [
            1,
            [
                0,
                [
                    1,
                    [
                        0,
                        _f_,
                        [
                            0,
                            caml_call1(Base_Import[136], pattern),
                            0
                        ]
                    ]
                ],
                _ea_
            ]
        ];
    }
    function pattern(t) {
        return t[1];
    }
    function case_sensitive(t) {
        return t[2];
    }
    function kmp_internal_loop(matched_chars, next_text_char, pattern, kmp_array, char_equal) {
        var matched_chars$0 = [
            0,
            matched_chars
        ];
        for(;;){
            if (0 < matched_chars$0[1] && !caml_call2(char_equal, next_text_char, caml_string_unsafe_get(pattern, matched_chars$0[1]))) {
                matched_chars$0[1] = kmp_array[1 + caml_call2(Base_Import[93], matched_chars$0[1], 1)];
                continue;
            }
            if (caml_call2(char_equal, next_text_char, caml_string_unsafe_get(pattern, matched_chars$0[1]))) matched_chars$0[1] = caml_call2(Base_Import[91], matched_chars$0[1], 1);
            return matched_chars$0[1];
        }
    }
    function get_char_equal(case_sensitive) {
        return case_sensitive ? Base_Char[16] : Base_Char[55][12];
    }
    function create(pattern, case_sensitive) {
        var n = caml_ml_string_length(pattern), kmp_array = caml_call2(Base_Array0[4], n, -1);
        if (0 < n) {
            var char_equal = get_char_equal(case_sensitive);
            kmp_array[1] = 0;
            var matched_chars = [
                0,
                0
            ], _d__ = caml_call2(Base_Import[93], n, 1), _d9_ = 1;
            if (_d__ >= 1) {
                var i = _d9_;
                for(;;){
                    matched_chars[1] = kmp_internal_loop(matched_chars[1], caml_string_unsafe_get(pattern, i), pattern, kmp_array, char_equal);
                    kmp_array[1 + i] = matched_chars[1];
                    var _d$_ = i + 1 | 0;
                    if (_d__ === i) break;
                    i = _d$_;
                }
            }
        }
        return [
            0,
            pattern,
            case_sensitive,
            kmp_array
        ];
    }
    function index_internal(opt, param, text) {
        var pos = opt ? opt[1] : 0, kmp_array = param[3], case_sensitive = param[2], pattern = param[1];
        if (0 <= pos && caml_call2(Base_Import[93], caml_ml_string_length(text), caml_ml_string_length(pattern)) >= pos) {
            var char_equal = get_char_equal(case_sensitive), j = [
                0,
                pos
            ], matched_chars = [
                0,
                0
            ], k = caml_ml_string_length(pattern), n = caml_ml_string_length(text);
            for(;;){
                if (j[1] < n && matched_chars[1] < k) {
                    var next_text_char = caml_string_unsafe_get(text, j[1]);
                    matched_chars[1] = kmp_internal_loop(matched_chars[1], next_text_char, pattern, kmp_array, char_equal);
                    j[1] = caml_call2(Base_Import[91], j[1], 1);
                    continue;
                }
                return matched_chars[1] === k ? caml_call2(Base_Import[93], j[1], k) : -1;
            }
        }
        return -1;
    }
    function matches(t, str) {
        return 0 <= index_internal(0, t, str) ? 1 : 0;
    }
    function index$0(pos, t, in$0) {
        var p = index_internal(pos, t, in$0);
        return 0 <= p ? [
            0,
            p
        ] : 0;
    }
    function index_exn$0(pos, t, in$0) {
        var p = index_internal(pos, t, in$0);
        if (0 <= p) return p;
        var _d8_ = [
            0,
            [
                0,
                cst_substring,
                caml_call1(Base_Import[136], t[1])
            ],
            0
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Substring_not_found, _d8_));
    }
    function index_all(param, may_overlap, text) {
        var kmp_array = param[3], case_sensitive = param[2], pattern = param[1];
        if (0 === caml_ml_string_length(pattern)) {
            var _d3_ = caml_call2(Base_Import[91], 1, caml_ml_string_length(text));
            return caml_call2(Base_List[40], _d3_, function(_d7_) {
                return _d7_;
            });
        }
        var char_equal = get_char_equal(case_sensitive), matched_chars = [
            0,
            0
        ], k = caml_ml_string_length(pattern), n = caml_ml_string_length(text), found = [
            0,
            0
        ], _d4_ = 0;
        if (n >= 0) {
            var j = _d4_;
            for(;;){
                if (matched_chars[1] === k) {
                    var _d5_ = found[1];
                    found[1] = [
                        0,
                        caml_call2(Base_Import[93], j, k),
                        _d5_
                    ];
                    matched_chars[1] = may_overlap ? kmp_array[1 + caml_call2(Base_Import[93], k, 1)] : 0;
                }
                if (j < n) {
                    var next_text_char = caml_string_unsafe_get(text, j);
                    matched_chars[1] = kmp_internal_loop(matched_chars[1], next_text_char, pattern, kmp_array, char_equal);
                }
                var _d6_ = j + 1 | 0;
                if (n === j) break;
                j = _d6_;
            }
        }
        return caml_call1(Base_List[63], found[1]);
    }
    function replace_first(pos, t, s, with$0) {
        var match = index$0(pos, t, s);
        if (!match) return s;
        var i = match[1], len_s = caml_ml_string_length(s), len_t = caml_ml_string_length(t[1]), len_with = caml_ml_string_length(with$0), _dX_ = caml_call2(Base_Import[91], len_s, len_with), _dY_ = caml_call2(Base_Import[93], _dX_, len_t), dst = caml_call1(Base_Bytes0[7], _dY_);
        caml_call5(Base_Bytes0[4], s, 0, dst, 0, i);
        caml_call5(Base_Bytes0[4], with$0, 0, dst, i, len_with);
        var _dZ_ = caml_call2(Base_Import[93], len_s, i), _d0_ = caml_call2(Base_Import[93], _dZ_, len_t), _d1_ = caml_call2(Base_Import[91], i, len_with), _d2_ = caml_call2(Base_Import[91], i, len_t);
        caml_call5(Base_Bytes0[4], s, _d2_, dst, _d1_, _d0_);
        return caml_string_of_bytes(dst);
    }
    function replace_all(t, s, with$0) {
        var matches = index_all(t, 0, s);
        if (!matches) return s;
        var len_s = caml_ml_string_length(s), len_t = caml_ml_string_length(t[1]), len_with = caml_ml_string_length(with$0), num_matches = caml_call1(Base_List[45], matches), _dQ_ = caml_call2(Base_Import[93], len_with, len_t), _dR_ = caml_call2(Base_Import[88], _dQ_, num_matches), _dS_ = caml_call2(Base_Import[91], len_s, _dR_), dst = caml_call1(Base_Bytes0[7], _dS_), next_dst_pos = [
            0,
            0
        ], next_src_pos = [
            0,
            0
        ];
        caml_call2(Base_List[19], matches, function(i) {
            var len = caml_call2(Base_Import[93], i, next_src_pos[1]);
            caml_call5(Base_Bytes0[4], s, next_src_pos[1], dst, next_dst_pos[1], len);
            var _dU_ = caml_call2(Base_Import[91], next_dst_pos[1], len);
            caml_call5(Base_Bytes0[4], with$0, 0, dst, _dU_, len_with);
            var _dV_ = caml_call2(Base_Import[91], next_dst_pos[1], len);
            next_dst_pos[1] = caml_call2(Base_Import[91], _dV_, len_with);
            var _dW_ = caml_call2(Base_Import[91], next_src_pos[1], len);
            next_src_pos[1] = caml_call2(Base_Import[91], _dW_, len_t);
            return 0;
        });
        var _dT_ = caml_call2(Base_Import[93], len_s, next_src_pos[1]);
        caml_call5(Base_Bytes0[4], s, next_src_pos[1], dst, next_dst_pos[1], _dT_);
        return caml_string_of_bytes(dst);
    }
    function split_on(t, s) {
        var pattern_len = caml_ml_string_length(t[1]), matches = index_all(t, 0, s), _dM_ = caml_call2(Base_Import[111], matches, [
            0,
            caml_ml_string_length(s),
            0
        ]), _dN_ = [
            0,
            caml_call1(Base_Import[113], pattern_len),
            matches
        ];
        return caml_call3(Base_List[98], _dN_, _dM_, function(i, j) {
            var _dO_ = caml_call2(Base_Import[93], j, i), _dP_ = caml_call2(Base_Import[93], _dO_, pattern_len);
            return sub(s, caml_call2(Base_Import[91], i, pattern_len), _dP_);
        });
    }
    function equal_local(a_003, b_004) {
        if (a_003 === b_004) return 1;
        var _dJ_ = caml_call2(Base_Import[274], a_003[1], b_004[1]);
        if (_dJ_) {
            var _dK_ = caml_call2(Base_Import[267], a_003[2], b_004[2]);
            if (_dK_) return caml_call3(Base_Import[277], Base_Import[270], a_003[3], b_004[3]);
            var _dL_ = _dK_;
        } else var _dL_ = _dJ_;
        return _dL_;
    }
    function equal(a, b) {
        return equal_local(a, b);
    }
    function sexp_of_t$1(param) {
        var kmp_array_012 = param[3], case_sensitive_010 = param[2], pattern_008 = param[1], arg_013 = caml_call2(Base_Import[150], Base_Import[139], kmp_array_012), bnds_007 = [
            0,
            [
                1,
                [
                    0,
                    _g_,
                    [
                        0,
                        arg_013,
                        0
                    ]
                ]
            ],
            0
        ], arg_011 = caml_call1(Base_Import[135], case_sensitive_010), bnds_007$0 = [
            0,
            [
                1,
                [
                    0,
                    _h_,
                    [
                        0,
                        arg_011,
                        0
                    ]
                ]
            ],
            bnds_007
        ], arg_009 = caml_call1(Base_Import[136], pattern_008), bnds_007$1 = [
            0,
            [
                1,
                [
                    0,
                    _i_,
                    [
                        0,
                        arg_009,
                        0
                    ]
                ]
            ],
            bnds_007$0
        ];
        return [
            1,
            bnds_007$1
        ];
    }
    function representation(_dI_) {
        return _dI_;
    }
    function substr_index_gen(case_sensitive, pos, t, pattern) {
        return index$0(pos, create(pattern, case_sensitive), t);
    }
    function substr_index_exn_gen(case_sensitive, pos, t, pattern) {
        return index_exn$0(pos, create(pattern, case_sensitive), t);
    }
    function substr_index_all_gen(case_sensitive, t, may_overlap, pattern) {
        return index_all(create(pattern, case_sensitive), may_overlap, t);
    }
    function substr_replace_first_gen(case_sensitive, pos, t, pattern) {
        var _dG_ = create(pattern, case_sensitive);
        return function(_dH_) {
            return replace_first(pos, _dG_, t, _dH_);
        };
    }
    function substr_replace_all_gen(case_sensitive, t, pattern) {
        var _dE_ = create(pattern, case_sensitive);
        return function(_dF_) {
            return replace_all(_dE_, t, _dF_);
        };
    }
    function is_substring_gen(case_sensitive, t, substring) {
        var _dD_ = substr_index_gen(case_sensitive, 0, t, substring);
        return caml_call1(Base_Option[53], _dD_);
    }
    var _j_ = 1;
    function substr_index(_dA_, _dB_, _dC_) {
        return substr_index_gen(_j_, _dA_, _dB_, _dC_);
    }
    var _k_ = 1;
    function substr_index_exn(_dx_, _dy_, _dz_) {
        return substr_index_exn_gen(_k_, _dx_, _dy_, _dz_);
    }
    var _l_ = 1;
    function substr_index_all(_du_, _dv_, _dw_) {
        return substr_index_all_gen(_l_, _du_, _dv_, _dw_);
    }
    var _m_ = 1;
    function substr_replace_first(_dr_, _ds_, _dt_) {
        return substr_replace_first_gen(_m_, _dr_, _ds_, _dt_);
    }
    var _n_ = 1;
    function substr_replace_all(_dp_, _dq_) {
        return substr_replace_all_gen(_n_, _dp_, _dq_);
    }
    var _o_ = 1, _p_ = [
        0,
        [
            11,
            "String.is_substring_at: invalid index ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " for string of length ",
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "String.is_substring_at: invalid index %d for string of length %d"
    ];
    function is_substring(_dn_, _do_) {
        return is_substring_gen(_o_, _dn_, _do_);
    }
    function is_substring_at_gen(str, str_pos$1, sub, char_equal) {
        var str_len = caml_ml_string_length(str), sub_len = caml_ml_string_length(sub), _dk_ = str_pos$1 < 0 ? 1 : 0, _dl_ = _dk_ || (str_len < str_pos$1 ? 1 : 0);
        if (_dl_) caml_call4(invalid_argf, _p_, str_pos$1, str_len, 0);
        var _dm_ = caml_call2(Base_Import[91], str_pos$1, sub_len) <= str_len ? 1 : 0;
        if (!_dm_) return _dm_;
        var str_pos = str_pos$1, sub_pos = 0;
        for(;;){
            if (sub_pos === sub_len) return 1;
            if (!caml_call2(char_equal, caml_string_unsafe_get(str, str_pos), caml_string_unsafe_get(sub, sub_pos))) return 0;
            var sub_pos$0 = caml_call2(Base_Import[91], sub_pos, 1), str_pos$0 = caml_call2(Base_Import[91], str_pos, 1);
            str_pos = str_pos$0;
            sub_pos = sub_pos$0;
        }
    }
    function is_suffix_gen(string, suffix, char_equal) {
        var string_len = caml_ml_string_length(string), suffix_len = caml_ml_string_length(suffix), _dj_ = suffix_len <= string_len ? 1 : 0;
        return _dj_ ? is_substring_at_gen(string, caml_call2(Base_Import[93], string_len, suffix_len), suffix, char_equal) : _dj_;
    }
    function is_prefix_gen(string, prefix, char_equal) {
        var string_len = caml_ml_string_length(string), prefix_len = caml_ml_string_length(prefix), _di_ = prefix_len <= string_len ? 1 : 0;
        return _di_ ? is_substring_at_gen(string, 0, prefix, char_equal) : _di_;
    }
    var t_of_sexp$0 = Base_Import[160], sexp_of_t$2 = Base_Import[136], t_sexp_grammar$0 = Base_Import[182];
    function compare_local(string1, string2) {
        if (string1 === string2) return 0;
        var len2 = caml_ml_string_length(string2), len1 = caml_ml_string_length(string1), pos = 0;
        for(;;){
            if (pos === len1) return pos === len2 ? 0 : -1;
            if (pos === len2) return 1;
            var c2 = caml_string_unsafe_get(string2, pos), c1 = caml_string_unsafe_get(string1, pos), _dg_ = caml_call1(Base_Char[37], c2), _dh_ = caml_call1(Base_Char[37], c1), c = caml_call2(Base_Char[17], _dh_, _dg_);
            if (0 !== c) return c;
            var pos$0 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$0;
        }
    }
    function compare$0(a, b) {
        return compare_local(a, b);
    }
    function hash_fold_t$0(state, t) {
        var len = caml_ml_string_length(t), state$0 = [
            0,
            caml_call2(Base_Import[206], state, len)
        ], _dd_ = caml_call2(Base_Import[93], len, 1), _dc_ = 0;
        if (_dd_ >= 0) {
            var pos = _dc_;
            for(;;){
                var _de_ = caml_call1(Base_Char[37], caml_string_unsafe_get(t, pos));
                state$0[1] = caml_call2(Base_Import[205], state$0[1], _de_);
                var _df_ = pos + 1 | 0;
                if (_dd_ === pos) break;
                pos = _df_;
            }
        }
        return state$0[1];
    }
    function hash$0(t) {
        return caml_call3(Base_Hash[14], 0, hash_fold_t$0, t);
    }
    function is_suffix(s, suffix) {
        return is_suffix_gen(s, suffix, Base_Char[55][12]);
    }
    function is_prefix(s, prefix) {
        return is_prefix_gen(s, prefix, Base_Char[55][12]);
    }
    var _q_ = 0;
    function substr_index$0(_c$_, _da_, _db_) {
        return substr_index_gen(_q_, _c$_, _da_, _db_);
    }
    var _r_ = 0;
    function substr_index_exn$0(_c8_, _c9_, _c__) {
        return substr_index_exn_gen(_r_, _c8_, _c9_, _c__);
    }
    var _s_ = 0;
    function substr_index_all$0(_c5_, _c6_, _c7_) {
        return substr_index_all_gen(_s_, _c5_, _c6_, _c7_);
    }
    var _t_ = 0;
    function substr_replace_first$0(_c2_, _c3_, _c4_) {
        return substr_replace_first_gen(_t_, _c2_, _c3_, _c4_);
    }
    var _u_ = 0;
    function substr_replace_all$0(_c0_, _c1_) {
        return substr_replace_all_gen(_u_, _c0_, _c1_);
    }
    var _v_ = 0;
    function is_substring$0(_cY_, _cZ_) {
        return is_substring_gen(_v_, _cY_, _cZ_);
    }
    var _w_ = Base_Char[55][12];
    function is_substring_at(_cV_) {
        return function(_cW_) {
            return function(_cX_) {
                return is_substring_at_gen(_cV_, _cW_, _cX_, _w_);
            };
        };
    }
    var include$0 = caml_call1(Base_Comparable[11], [
        0,
        compare$0,
        sexp_of_t$2
    ]), symbol = include$0[1], symbol$0 = include$0[2], symbol$1 = include$0[3], symbol$2 = include$0[4], symbol$3 = include$0[5], symbol$4 = include$0[6], equal$0 = include$0[7], compare$1 = include$0[8], min = include$0[9], max = include$0[10], ascending = include$0[11], descending = include$0[12], between = include$0[13], clamp_exn = include$0[14], clamp = include$0[15], comparator$0 = include$0[16], _x_ = [
        0,
        [
            11,
            "String.init ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "String.init %d"
    ], _y_ = [
        0,
        "String.lsplit2_exn: not found"
    ], _z_ = [
        0,
        "String.rsplit2_exn: not found"
    ], cst_expecting_nonnegative_argu = " expecting nonnegative argument", cst_drop_prefix = "drop_prefix", cst_drop_suffix = "drop_suffix", cst_prefix = "prefix", cst_suffix = "suffix", _A_ = [
        0,
        cst_src_string_ml,
        761,
        17
    ], cst_tr_multi_replacement_is_em = "tr_multi replacement is empty string", _B_ = [
        0,
        cst_src_string_ml,
        925,
        4
    ], _C_ = [
        0,
        [
            11,
            "String.chop_prefix_exn ",
            [
                3,
                0,
                [
                    12,
                    32,
                    [
                        3,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "String.chop_prefix_exn %S %S"
    ], _D_ = [
        0,
        [
            11,
            "String.chop_suffix_exn ",
            [
                3,
                0,
                [
                    12,
                    32,
                    [
                        3,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "String.chop_suffix_exn %S %S"
    ], _E_ = [
        0,
        [
            3,
            0,
            0
        ],
        "%S"
    ], _F_ = [
        0,
        cst$15,
        cst$15
    ], cst_escapeworthy_map = "escapeworthy_map", cst_c_to = "c_to", cst_c_from = "c_from", cst_escapeworthy_map_not_one_t = "escapeworthy_map not one-to-one", _G_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": out of bounds",
                0
            ]
        ],
        "%s: out of bounds"
    ], cst_is_char_escaping = "is_char_escaping", cst_is_char_escaped = "is_char_escaped", cst_is_char_literal = "is_char_literal", cst_index_from = "index_from", cst_char = cst_char$1, cst_pos = cst_pos$2, cst_escape_char = cst_escape_char$1, cst_str = cst_str$1, cst_index_from_exn_not_found = "index_from_exn: not found", cst_rindex_from = "rindex_from", cst_char$0 = cst_char$1, cst_pos$0 = cst_pos$2, cst_escape_char$0 = cst_escape_char$1, cst_str$0 = cst_str$1, cst_rindex_from_exn_not_found = "rindex_from_exn: not found", _H_ = [
        0,
        cst_src_string_ml,
        1858,
        19
    ], _I_ = [
        0,
        cst_src_string_ml,
        1872,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]", _J_ = [
        0,
        [
            2,
            0,
            [
                11,
                ".get: invalid ",
                [
                    2,
                    0,
                    [
                        11,
                        " encoding at given position",
                        0
                    ]
                ]
            ]
        ],
        "%s.get: invalid %s encoding at given position"
    ], cst_pos$1 = cst_pos$2, cst_of_string_invalid = ".of_string: invalid ", _K_ = [
        0,
        cst_src_string_ml,
        1996,
        4
    ], _L_ = [
        0,
        cst_src_string_ml,
        2006,
        4
    ], _M_ = [
        0,
        cst_src_string_ml,
        2020,
        4
    ], _N_ = [
        0,
        cst$15
    ];
    function of_string(_cU_) {
        return _cU_;
    }
    function to_string(_cT_) {
        return _cT_;
    }
    function init(n, f) {
        if (n < 0) caml_call3(invalid_argf, _x_, n, 0);
        var t = caml_call1(Base_Bytes0[7], n), _cR_ = caml_call2(Base_Import[93], n, 1), _cQ_ = 0;
        if (_cR_ >= 0) {
            var i = _cQ_;
            for(;;){
                caml_bytes_set(t, i, caml_call1(f, i));
                var _cS_ = i + 1 | 0;
                if (_cR_ === i) break;
                i = _cS_;
            }
        }
        return caml_string_of_bytes(t);
    }
    function to_list(s) {
        var i$1 = caml_call2(Base_Import[93], caml_ml_string_length(s), 1), acc = 0, i = i$1;
        for(;;){
            if (0 > i) return acc;
            var i$0 = caml_call2(Base_Import[93], i, 1), acc$0 = [
                0,
                caml_string_get(s, i),
                acc
            ];
            acc = acc$0;
            i = i$0;
        }
    }
    function to_list_rev(s) {
        var len = caml_ml_string_length(s), acc = 0, i = 0;
        for(;;){
            if (i === len) return acc;
            var i$0 = caml_call2(Base_Import[91], i, 1), acc$0 = [
                0,
                caml_string_get(s, i),
                acc
            ];
            acc = acc$0;
            i = i$0;
        }
    }
    function rev(t) {
        var len = caml_ml_string_length(t), res = caml_call1(Base_Bytes0[7], len), _cN_ = caml_call2(Base_Import[93], len, 1), _cM_ = 0;
        if (_cN_ >= 0) {
            var i = _cM_;
            for(;;){
                var _cO_ = caml_call2(Base_Import[93], len, 1);
                caml_bytes_unsafe_set(res, i, caml_string_unsafe_get(t, caml_call2(Base_Import[93], _cO_, i)));
                var _cP_ = i + 1 | 0;
                if (_cN_ === i) break;
                i = _cP_;
            }
        }
        return caml_string_of_bytes(res);
    }
    function not_found$1(param) {
        throw caml_maybe_attach_backtrace([
            0,
            Base_Import[297],
            _y_
        ], 1);
    }
    function lsplit2_exn(line, delim) {
        var len = caml_ml_string_length(line), pos = index_from_internal(line, len, not_found$1, function(_cL_) {
            return _cL_;
        }, delim, 0), _cI_ = caml_call2(Base_Import[93], len, pos), _cJ_ = caml_call2(Base_Import[93], _cI_, 1), _cK_ = sub(line, caml_call2(Base_Import[91], pos, 1), _cJ_);
        return [
            0,
            sub(line, 0, pos),
            _cK_
        ];
    }
    function not_found$2(param) {
        throw caml_maybe_attach_backtrace([
            0,
            Base_Import[297],
            _z_
        ], 1);
    }
    function rsplit2_exn(line, delim) {
        var len = caml_ml_string_length(line), pos = rindex_from_internal(line, delim, function(_cH_) {
            return _cH_;
        }, not_found$2, caml_call2(Base_Import[93], len, 1)), _cE_ = caml_call2(Base_Import[93], len, pos), _cF_ = caml_call2(Base_Import[93], _cE_, 1), _cG_ = sub(line, caml_call2(Base_Import[91], pos, 1), _cF_);
        return [
            0,
            sub(line, 0, pos),
            _cG_
        ];
    }
    function lsplit2(line, on) {
        try {
            var _cC_ = [
                0,
                lsplit2_exn(line, on)
            ];
            return _cC_;
        } catch (_cD_) {
            var _cB_ = caml_wrap_exception(_cD_);
            if (_cB_[1] !== Base_Import[297] && _cB_ !== Base_Import[85][8]) throw caml_maybe_attach_backtrace(_cB_, 0);
            return 0;
        }
    }
    function rsplit2(line, on) {
        try {
            var _cz_ = [
                0,
                rsplit2_exn(line, on)
            ];
            return _cz_;
        } catch (_cA_) {
            var _cy_ = caml_wrap_exception(_cA_);
            if (_cy_[1] !== Base_Import[297] && _cy_ !== Base_Import[85][8]) throw caml_maybe_attach_backtrace(_cy_, 0);
            return 0;
        }
    }
    function char_list_mem(l, c) {
        var l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1], _cx_ = caml_call2(Base_Char[16], hd, c);
            if (_cx_) return _cx_;
            l$0 = tl;
        }
    }
    function split_gen(str, on) {
        if (552554919 <= on[1]) var l = on[2], is_delim = function(c) {
            return char_list_mem(l, c);
        };
        else var c = on[2], is_delim = function(c$0) {
            return caml_call2(Base_Char[16], c$0, c);
        };
        var last_pos = caml_ml_string_length(str), pos$1 = caml_call2(Base_Import[93], last_pos, 1), acc = 0, last_pos$1 = last_pos, last_pos$0 = pos$1;
        for(;;){
            if (-1 === last_pos$0) return [
                0,
                sub(str, 0, last_pos$1),
                acc
            ];
            if (is_delim(caml_string_get(str, last_pos$0))) {
                var pos1 = caml_call2(Base_Import[91], last_pos$0, 1), sub_str = sub(str, pos1, caml_call2(Base_Import[93], last_pos$1, pos1)), pos = caml_call2(Base_Import[93], last_pos$0, 1), acc$0 = [
                    0,
                    sub_str,
                    acc
                ];
                acc = acc$0;
                last_pos$1 = last_pos$0;
                last_pos$0 = pos;
            } else {
                var pos$0 = caml_call2(Base_Import[93], last_pos$0, 1);
                last_pos$0 = pos$0;
            }
        }
    }
    function split(str, on) {
        return split_gen(str, [
            0,
            -1044422954,
            on
        ]);
    }
    function split_on_chars(str, chars) {
        return split_gen(str, [
            0,
            552554919,
            chars
        ]);
    }
    function is_suffix$0(s, suffix) {
        return is_suffix_gen(s, suffix, Base_Char[16]);
    }
    function is_prefix$0(s, prefix) {
        return is_prefix_gen(s, prefix, Base_Char[16]);
    }
    function is_substring_at$0(s, pos, substring) {
        return is_substring_at_gen(s, pos, substring, Base_Char[16]);
    }
    function wrap_sub_n(t, n, name, pos, len, on_error) {
        if (0 <= n) try {
            var _cu_ = sub(t, pos, len);
            return _cu_;
        } catch (_cw_) {
            return on_error;
        }
        var _cv_ = caml_call2(symbol_concat, name, cst_expecting_nonnegative_argu);
        return caml_call1(Base_Import[126], _cv_);
    }
    function drop_prefix(t, n) {
        return wrap_sub_n(t, n, cst_drop_prefix, n, caml_call2(Base_Import[93], caml_ml_string_length(t), n), cst$0);
    }
    function drop_suffix(t, n) {
        return wrap_sub_n(t, n, cst_drop_suffix, 0, caml_call2(Base_Import[93], caml_ml_string_length(t), n), cst$1);
    }
    function prefix(t, n) {
        return wrap_sub_n(t, n, cst_prefix, 0, n, t);
    }
    function suffix(t, n) {
        return wrap_sub_n(t, n, cst_suffix, caml_call2(Base_Import[93], caml_ml_string_length(t), n), n, t);
    }
    function lfindi(opt, t, f) {
        var pos = opt ? opt[1] : 0, n = caml_ml_string_length(t), i = pos;
        for(;;){
            if (i === n) return 0;
            if (caml_call2(f, i, caml_string_get(t, i))) return [
                0,
                i
            ];
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
        }
    }
    function find(t, f) {
        var match = lfindi(0, t, function(param, c) {
            return caml_call1(f, c);
        });
        if (!match) return 0;
        var i = match[1];
        return [
            0,
            caml_string_get(t, i)
        ];
    }
    function find_map(t, f) {
        var n = caml_ml_string_length(t), i = 0;
        for(;;){
            if (i === n) return 0;
            var res = caml_call1(f, caml_string_get(t, i));
            if (res) return res;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
        }
    }
    function rfindi(pos, t, f) {
        if (pos) var pos$0 = pos[1], pos$1 = pos$0;
        else var pos$1 = caml_call2(Base_Import[93], caml_ml_string_length(t), 1);
        var i = pos$1;
        for(;;){
            if (0 > i) return 0;
            if (caml_call2(f, i, caml_string_get(t, i))) return [
                0,
                i
            ];
            var i$0 = caml_call2(Base_Import[93], i, 1);
            i = i$0;
        }
    }
    function last_non_drop(drop, t) {
        return rfindi(0, t, function(param, c) {
            return 1 - caml_call1(drop, c);
        });
    }
    function rstrip(opt, t) {
        var drop = opt ? opt[1] : Base_Char[45], match = last_non_drop(drop, t);
        if (!match) return cst$2;
        var i = match[1];
        return i === caml_call2(Base_Import[93], caml_ml_string_length(t), 1) ? t : prefix(t, caml_call2(Base_Import[91], i, 1));
    }
    function first_non_drop(drop, t) {
        return lfindi(0, t, function(param, c) {
            return 1 - caml_call1(drop, c);
        });
    }
    function lstrip(opt, t) {
        var drop = opt ? opt[1] : Base_Char[45], match = first_non_drop(drop, t);
        if (!match) return cst$3;
        var n = match[1];
        return 0 === n ? t : drop_prefix(t, n);
    }
    function strip(opt, t) {
        var drop = opt ? opt[1] : Base_Char[45], length = caml_ml_string_length(t);
        a: if (0 !== length) {
            if (!caml_call1(drop, caml_string_get(t, 0)) && !caml_call1(drop, caml_string_get(t, caml_call2(Base_Import[93], length, 1)))) break a;
            var match = first_non_drop(drop, t);
            if (!match) return cst$4;
            var first = match[1], match$0 = last_non_drop(drop, t);
            if (!match$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _A_
            ], 1);
            var last = match$0[1], _ct_ = caml_call2(Base_Import[93], last, first);
            return sub(t, first, caml_call2(Base_Import[91], _ct_, 1));
        }
        return t;
    }
    function mapi(t, f) {
        var l = caml_ml_string_length(t), t$0 = caml_call1(Base_Bytes0[7], l), _cr_ = caml_call2(Base_Import[93], l, 1), _cq_ = 0;
        if (_cr_ >= 0) {
            var i = _cq_;
            for(;;){
                caml_bytes_unsafe_set(t$0, i, caml_call2(f, i, caml_string_get(t, i)));
                var _cs_ = i + 1 | 0;
                if (_cr_ === i) break;
                i = _cs_;
            }
        }
        return caml_string_of_bytes(t$0);
    }
    function map(t, f) {
        var l = caml_ml_string_length(t), t$0 = caml_call1(Base_Bytes0[7], l), _co_ = caml_call2(Base_Import[93], l, 1), _cn_ = 0;
        if (_co_ >= 0) {
            var i = _cn_;
            for(;;){
                caml_bytes_unsafe_set(t$0, i, caml_call1(f, caml_string_get(t, i)));
                var _cp_ = i + 1 | 0;
                if (_co_ === i) break;
                i = _cp_;
            }
        }
        return caml_string_of_bytes(t$0);
    }
    function to_array(s) {
        return caml_call2(Base_Array0[12], caml_ml_string_length(s), function(i) {
            return caml_string_get(s, i);
        });
    }
    function exists(s, f) {
        var len = caml_ml_string_length(s), i = 0;
        for(;;){
            var _ck_ = i < len ? 1 : 0;
            if (_ck_) {
                var _cl_ = caml_call1(f, caml_string_get(s, i));
                if (!_cl_) {
                    var i$0 = caml_call2(Base_Import[91], i, 1);
                    i = i$0;
                    continue;
                }
                var _cm_ = _cl_;
            } else var _cm_ = _ck_;
            return _cm_;
        }
    }
    function for_all(s, f) {
        var len = caml_ml_string_length(s), i = 0;
        for(;;){
            var _ch_ = i === len ? 1 : 0;
            if (_ch_) var _ci_ = _ch_;
            else {
                var _cj_ = caml_call1(f, caml_string_get(s, i));
                if (_cj_) {
                    var i$0 = caml_call2(Base_Import[91], i, 1);
                    i = i$0;
                    continue;
                }
                var _ci_ = _cj_;
            }
            return _ci_;
        }
    }
    function fold(t, init, f) {
        var len = caml_ml_string_length(t), i = 0, ac = init;
        for(;;){
            if (i === len) return ac;
            var ac$0 = caml_call2(f, ac, caml_string_get(t, i)), i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            ac = ac$0;
        }
    }
    function foldi(t, init, f) {
        var len = caml_ml_string_length(t), i = 0, ac = init;
        for(;;){
            if (i === len) return ac;
            var ac$0 = caml_call3(f, i, ac, caml_string_get(t, i)), i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            ac = ac$0;
        }
    }
    function iteri(t, f) {
        var _cf_ = caml_call2(Base_Import[93], caml_ml_string_length(t), 1), _ce_ = 0;
        if (_cf_ >= 0) {
            var i = _ce_;
            for(;;){
                caml_call2(f, i, caml_string_unsafe_get(t, i));
                var _cg_ = i + 1 | 0;
                if (_cf_ === i) break;
                i = _cg_;
            }
        }
        return 0;
    }
    function count(t, f) {
        return caml_call3(Base_Container[2], fold, t, f);
    }
    function sum(m, t, f) {
        return caml_call4(Base_Container[7], fold, m, t, f);
    }
    function min_elt(t) {
        return caml_call2(Base_Container[3], fold, t);
    }
    function max_elt(t) {
        return caml_call2(Base_Container[4], fold, t);
    }
    function fold_result(t, init, f) {
        return caml_call4(Base_Container[8], fold, init, f, t);
    }
    function fold_until(t, init, f, finish) {
        return caml_call5(Base_Container[9], fold, init, f, finish, t);
    }
    function find_mapi(t, f) {
        return caml_call3(Base_Indexed_container[7], iteri, t, f);
    }
    function findi(t, f) {
        return caml_call3(Base_Indexed_container[6], iteri, t, f);
    }
    function counti(t, f) {
        return caml_call3(Base_Indexed_container[3], foldi, t, f);
    }
    function for_alli(t, f) {
        return caml_call3(Base_Indexed_container[5], iteri, t, f);
    }
    function existsi(t, f) {
        return caml_call3(Base_Indexed_container[4], iteri, t, f);
    }
    function mem(t, c) {
        var len = caml_ml_string_length(t), i = 0;
        for(;;){
            var _cb_ = i < len ? 1 : 0;
            if (_cb_) {
                var _cc_ = caml_call2(Base_Char[16], c, caml_string_unsafe_get(t, i));
                if (!_cc_) {
                    var i$0 = caml_call2(Base_Import[91], i, 1);
                    i = i$0;
                    continue;
                }
                var _cd_ = _cc_;
            } else var _cd_ = _cb_;
            return _cd_;
        }
    }
    function tr(target, replacement, s) {
        return caml_call2(Base_Char[16], target, replacement) ? s : mem(s, target) ? map(s, function(c) {
            return caml_call2(Base_Char[16], c, target) ? replacement : c;
        }) : s;
    }
    function tr_multi(target, replacement) {
        if (is_empty(target)) return caml_call1(stage, function(_ca_) {
            return _ca_;
        });
        if (is_empty(replacement)) return caml_call1(Base_Import[126], cst_tr_multi_replacement_is_em);
        var match = caml_call2(Base_Bytes_tr[1], target, replacement);
        if (!match) return caml_call1(stage, function(_b$_) {
            return _b$_;
        });
        var tr_map = match[1];
        return caml_call1(stage, function(s) {
            return exists(s, function(c) {
                var _b__ = caml_string_unsafe_get(tr_map, caml_call1(Base_Char[32], c));
                return caml_call2(Base_Char[15], c, _b__);
            }) ? map(s, function(c) {
                return caml_string_unsafe_get(tr_map, caml_call1(Base_Char[32], c));
            }) : s;
        });
    }
    function concat_array(sep, ar) {
        return caml_call2(concat, sep, caml_call1(Base_Array0[16], ar));
    }
    function concat_map(sep, s, f) {
        var _b9_ = to_array(s);
        return concat_array(sep, caml_call2(Base_Array0[21], _b9_, f));
    }
    function concat_mapi(sep, t, f) {
        var _b8_ = to_array(t);
        return concat_array(sep, caml_call2(Base_Array0[22], _b8_, f));
    }
    function concat_lines(opt, lines$3) {
        var crlf = opt ? opt[1] : 0, newline_len = crlf ? 2 : 1, lines = lines$3, sum = 0;
        for(;;){
            if (!lines) break;
            var lines$0 = lines[2], line = lines[1], _b7_ = caml_call2(Base_Import[91], sum, caml_ml_string_length(line)), sum$0 = caml_call2(Base_Import[91], _b7_, newline_len);
            lines = lines$0;
            sum = sum$0;
        }
        var buf = caml_call1(Base_Bytes0[7], sum), lines$1 = lines$3, written = 0;
        for(;;){
            if (!lines$1) {
                if (written === sum) return caml_string_of_bytes(buf);
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _B_
                ], 1);
            }
            var lines$2 = lines$1[2], line$0 = lines$1[1];
            caml_blit_string(line$0, 0, buf, written, caml_ml_string_length(line$0));
            var pos = caml_call2(Base_Import[91], written, caml_ml_string_length(line$0)), pos$0 = crlf ? (caml_bytes_unsafe_set(buf, pos, 13), caml_call2(Base_Import[91], pos, 1)) : pos;
            caml_bytes_unsafe_set(buf, pos$0, 10);
            var pos$1 = caml_call2(Base_Import[91], pos$0, 1);
            lines$1 = lines$2;
            written = pos$1;
        }
    }
    function filter(t, f) {
        var n = caml_ml_string_length(t), i = [
            0,
            0
        ];
        for(;;){
            if (i[1] >= n) break;
            if (!caml_call1(f, caml_string_get(t, i[1]))) break;
            i[1]++;
        }
        if (i[1] === n) return t;
        var _b5_ = caml_call2(Base_Import[93], n, 1), out = caml_call1(Base_Bytes0[7], _b5_);
        caml_call5(Base_Bytes0[4], t, 0, out, 0, i[1]);
        var out_pos = [
            0,
            i[1]
        ];
        i[1]++;
        for(;;){
            if (i[1] >= n) {
                var out$0 = caml_string_of_bytes(out), _b6_ = caml_call2(Base_Import[93], n, 1);
                return out_pos[1] === _b6_ ? out$0 : sub(out$0, 0, out_pos[1]);
            }
            var c = caml_string_get(t, i[1]);
            if (caml_call1(f, c)) {
                caml_bytes_set(out, out_pos[1], c);
                out_pos[1]++;
            }
            i[1]++;
        }
    }
    function filteri(t, f) {
        var n = caml_ml_string_length(t), i = [
            0,
            0
        ];
        for(;;){
            if (i[1] >= n) break;
            var _b2_ = caml_string_get(t, i[1]);
            if (!caml_call2(f, i[1], _b2_)) break;
            i[1]++;
        }
        if (i[1] === n) return t;
        var _b3_ = caml_call2(Base_Import[93], n, 1), out = caml_call1(Base_Bytes0[7], _b3_);
        caml_call5(Base_Bytes0[4], t, 0, out, 0, i[1]);
        var out_pos = [
            0,
            i[1]
        ];
        i[1]++;
        for(;;){
            if (i[1] >= n) {
                var out$0 = caml_string_of_bytes(out), _b4_ = caml_call2(Base_Import[93], n, 1);
                return out_pos[1] === _b4_ ? out$0 : sub(out$0, 0, out_pos[1]);
            }
            var c = caml_string_get(t, i[1]);
            if (caml_call2(f, i[1], c)) {
                caml_bytes_set(out, out_pos[1], c);
                out_pos[1]++;
            }
            i[1]++;
        }
    }
    function chop_prefix(s, prefix) {
        return is_prefix$0(s, prefix) ? [
            0,
            drop_prefix(s, caml_ml_string_length(prefix))
        ] : 0;
    }
    function chop_prefix_if_exists(s, prefix) {
        return is_prefix$0(s, prefix) ? drop_prefix(s, caml_ml_string_length(prefix)) : s;
    }
    function chop_prefix_exn(s, prefix) {
        var match = chop_prefix(s, prefix);
        if (!match) return caml_call4(invalid_argf, _C_, s, prefix, 0);
        var str = match[1];
        return str;
    }
    function chop_suffix(s, suffix) {
        return is_suffix$0(s, suffix) ? [
            0,
            drop_suffix(s, caml_ml_string_length(suffix))
        ] : 0;
    }
    function chop_suffix_if_exists(s, suffix) {
        return is_suffix$0(s, suffix) ? drop_suffix(s, caml_ml_string_length(suffix)) : s;
    }
    function chop_suffix_exn(s, suffix) {
        var match = chop_suffix(s, suffix);
        if (!match) return caml_call4(invalid_argf, _D_, s, suffix, 0);
        var str = match[1];
        return str;
    }
    function shorter(a, b) {
        return caml_ml_string_length(a) <= caml_ml_string_length(b) ? a : b;
    }
    function shortest(list) {
        if (!list) return cst$5;
        var rest = list[2], first = list[1];
        return caml_call3(Base_List[20], rest, first, shorter);
    }
    function pos_from_left(param, i) {
        return i;
    }
    function pos_from_right(t, i) {
        var _b1_ = caml_call2(Base_Import[93], caml_ml_string_length(t), i);
        return caml_call2(Base_Import[93], _b1_, 1);
    }
    function common_generic2_length_loop(a, b, get_pos, max_len, len_so_far) {
        var len_so_far$0 = len_so_far;
        for(;;){
            if (max_len <= len_so_far$0) return max_len;
            var _bZ_ = caml_string_unsafe_get(b, caml_call2(get_pos, b, len_so_far$0)), _b0_ = caml_string_unsafe_get(a, caml_call2(get_pos, a, len_so_far$0));
            if (!caml_call2(Base_Char[16], _b0_, _bZ_)) return len_so_far$0;
            var len_so_far$1 = caml_call2(Base_Import[91], len_so_far$0, 1);
            len_so_far$0 = len_so_far$1;
        }
    }
    function common_generic2_length(a, b, get_pos) {
        var max_len = caml_call2(Base_Import[101], caml_ml_string_length(a), caml_ml_string_length(b));
        return common_generic2_length_loop(a, b, get_pos, max_len, 0);
    }
    function common_generic_length_loop(first, list, get_pos, max_len) {
        var first$0 = first, list$0 = list, max_len$0 = max_len;
        for(;;){
            if (!list$0) return max_len$0;
            var rest = list$0[2], second = list$0[1], max_len$1 = common_generic2_length_loop(first$0, second, get_pos, max_len$0, 0);
            first$0 = second;
            list$0 = rest;
            max_len$0 = max_len$1;
        }
    }
    function common_generic_length(list, get_pos) {
        if (!list) return 0;
        var rest = list[2], first = list[1], max_len = caml_ml_string_length(shortest(list));
        return common_generic_length_loop(first, rest, get_pos, max_len);
    }
    function common_generic2(a, b, get_pos, take) {
        var len = common_generic2_length(a, b, get_pos);
        return caml_call2(take, shorter(a, b), len);
    }
    function common_generic(list, get_pos, take) {
        if (!list) return cst$7;
        var rest = list[2], first = list[1], s = shortest(list), max_len = caml_ml_string_length(s);
        if (0 === max_len) return cst$6;
        var len = common_generic_length_loop(first, rest, get_pos, max_len);
        return caml_call2(take, s, len);
    }
    function common_prefix(list) {
        return common_generic(list, pos_from_left, prefix);
    }
    function common_suffix(list) {
        return common_generic(list, pos_from_right, suffix);
    }
    function common_prefix2(a, b) {
        return common_generic2(a, b, pos_from_left, prefix);
    }
    function common_suffix2(a, b) {
        return common_generic2(a, b, pos_from_right, suffix);
    }
    function common_prefix_length(list) {
        return common_generic_length(list, pos_from_left);
    }
    function common_suffix_length(list) {
        return common_generic_length(list, pos_from_right);
    }
    function common_prefix2_length(a, b) {
        return common_generic2_length(a, b, pos_from_left);
    }
    function common_suffix2_length(a, b) {
        return common_generic2_length(a, b, pos_from_right);
    }
    function pp(ppf, string) {
        return caml_call3(Stdlib_Format[139], ppf, _E_, string);
    }
    function of_char(c) {
        return caml_call2(make, 1, c);
    }
    function of_char_list(l) {
        var _bY_ = caml_call1(Base_List[45], l), t = caml_call1(Base_Bytes0[7], _bY_);
        caml_call2(Base_List[34], l, function(i, c) {
            return caml_bytes_set(t, i, c);
        });
        return caml_string_of_bytes(t);
    }
    function of_array(a) {
        return init(a.length - 1, function(_bX_) {
            return caml_check_bound(a, _bX_)[1 + _bX_];
        });
    }
    function to_sequence(t) {
        var len = caml_ml_string_length(t);
        return caml_call2(Base_Sequence[44], 0, function(pos) {
            return len <= pos ? 0 : [
                1,
                caml_string_unsafe_get(t, pos),
                caml_call2(Base_Import[91], pos, 1)
            ];
        });
    }
    function of_sequence(s) {
        return of_char_list(caml_call1(Base_Sequence[20], s));
    }
    function pad_right(opt, s, len) {
        var char$0 = opt ? opt[1] : 32, src_len = caml_ml_string_length(s);
        if (len <= src_len) return s;
        var res = caml_call1(Base_Bytes0[7], len);
        caml_call5(Base_Bytes0[4], s, 0, res, 0, src_len);
        var _bW_ = caml_call2(Base_Import[93], len, src_len);
        caml_call4(Base_Bytes0[15], res, src_len, _bW_, char$0);
        return caml_string_of_bytes(res);
    }
    function pad_left(opt, s, len) {
        var char$0 = opt ? opt[1] : 32, src_len = caml_ml_string_length(s);
        if (len <= src_len) return s;
        var res = caml_call1(Base_Bytes0[7], len), _bU_ = caml_call2(Base_Import[93], len, src_len);
        caml_call5(Base_Bytes0[4], s, 0, res, _bU_, src_len);
        var _bV_ = caml_call2(Base_Import[93], len, src_len);
        caml_call4(Base_Bytes0[15], res, 0, _bV_, char$0);
        return caml_string_of_bytes(res);
    }
    function local_copy_prefix(src, prefix_len, buffer_len) {
        var dst = caml_call1(Base_Bytes0[14], buffer_len);
        caml_blit_string(src, 0, dst, 0, prefix_len);
        return dst;
    }
    function local_copy_to_string(buf, pos) {
        var str = caml_string_of_bytes(buf);
        return unsafe_sub(str, 0, pos);
    }
    function filter_mapi(src, f) {
        var src_len = caml_ml_string_length(src);
        a: {
            var pos = 0;
            for(;;){
                if (pos === src_len) return src;
                var c1 = caml_string_unsafe_get(src, pos), src_pos$0 = caml_call1(Base_Int0[8], pos), option = caml_call2(f, pos, c1);
                if (!option) break a;
                var c2 = option[1];
                if (!caml_call2(Base_Char[16], c1, c2)) break;
                pos = src_pos$0;
            }
        }
        var copy = local_copy_prefix(src, pos, src_len);
        if (option) {
            var c$0 = option[1];
            caml_bytes_unsafe_set(copy, pos, c$0);
            var dst_pos$0 = src_pos$0;
        } else var dst_pos$0 = pos;
        var dst_pos = [
            0,
            dst_pos$0
        ], _bS_ = caml_call2(Base_Import[93], src_len, 1);
        if (_bS_ >= src_pos$0) {
            var src_pos = src_pos$0;
            for(;;){
                var match = caml_call2(f, src_pos, caml_string_unsafe_get(src, src_pos));
                if (match) {
                    var c = match[1];
                    caml_bytes_unsafe_set(copy, dst_pos[1], c);
                    dst_pos[1]++;
                }
                var _bT_ = src_pos + 1 | 0;
                if (_bS_ === src_pos) break;
                src_pos = _bT_;
            }
        }
        return local_copy_to_string(copy, dst_pos[1]);
    }
    function filter_map(t, f) {
        return filter_mapi(t, function(param, c) {
            return caml_call1(f, c);
        });
    }
    function partition_map_difference(src, f, len, src_pos$0, fst_pos$0, snd_pos$0, either) {
        var fsts = local_copy_prefix(src, fst_pos$0, len), snds = local_copy_prefix(src, snd_pos$0, len);
        if (0 === either[0]) {
            var c$1 = either[1];
            caml_bytes_unsafe_set(fsts, fst_pos$0, c$1);
            var snd_pos$1 = snd_pos$0, fst_pos$1 = caml_call2(Base_Import[91], fst_pos$0, 1);
        } else {
            var c$2 = either[1];
            caml_bytes_unsafe_set(snds, snd_pos$0, c$2);
            var snd_pos$2 = caml_call2(Base_Import[91], snd_pos$0, 1), snd_pos$1 = snd_pos$2, fst_pos$1 = fst_pos$0;
        }
        var src_pos$1 = caml_call2(Base_Import[91], src_pos$0, 1), fst_pos = [
            0,
            fst_pos$1
        ], snd_pos = [
            0,
            snd_pos$1
        ], _bP_ = caml_call2(Base_Import[93], len, 1);
        if (_bP_ >= src_pos$1) {
            var src_pos = src_pos$1;
            for(;;){
                var match = caml_call1(f, caml_string_unsafe_get(src, src_pos));
                if (0 === match[0]) {
                    var c = match[1];
                    caml_bytes_unsafe_set(fsts, fst_pos[1], c);
                    fst_pos[1]++;
                } else {
                    var c$0 = match[1];
                    caml_bytes_unsafe_set(snds, snd_pos[1], c$0);
                    snd_pos[1]++;
                }
                var _bR_ = src_pos + 1 | 0;
                if (_bP_ === src_pos) break;
                src_pos = _bR_;
            }
        }
        var _bQ_ = local_copy_to_string(snds, snd_pos[1]);
        return [
            0,
            local_copy_to_string(fsts, fst_pos[1]),
            _bQ_
        ];
    }
    function partition_map(src, f) {
        var len = caml_ml_string_length(src);
        if (0 === len) return _F_;
        var c1$1 = caml_string_unsafe_get(src, 0), either$1 = caml_call1(f, c1$1);
        if (0 === either$1[0]) {
            var c2$1 = either$1[1];
            if (caml_call2(Base_Char[16], c1$1, c2$1)) {
                var pos = 1;
                for(;;){
                    if (pos === len) return [
                        0,
                        src,
                        cst$8
                    ];
                    var c1 = caml_string_unsafe_get(src, pos), either = caml_call1(f, c1);
                    if (0 === either[0]) {
                        var c2 = either[1];
                        if (caml_call2(Base_Char[16], c1, c2)) {
                            var pos$0 = caml_call2(Base_Import[91], pos, 1);
                            pos = pos$0;
                            continue;
                        }
                    }
                    return partition_map_difference(src, f, len, pos, pos, 0, either);
                }
            }
        } else {
            var c2$2 = either$1[1];
            if (caml_call2(Base_Char[16], c1$1, c2$2)) {
                var pos$1 = 1;
                for(;;){
                    if (pos$1 === len) return [
                        0,
                        cst$9,
                        src
                    ];
                    var c1$0 = caml_string_unsafe_get(src, pos$1), either$0 = caml_call1(f, c1$0);
                    if (1 === either$0[0]) {
                        var c2$0 = either$0[1];
                        if (caml_call2(Base_Char[16], c1$0, c2$0)) {
                            var pos$2 = caml_call2(Base_Import[91], pos$1, 1);
                            pos$1 = pos$2;
                            continue;
                        }
                    }
                    return partition_map_difference(src, f, len, pos$1, 0, pos$1, either$0);
                }
            }
        }
        return partition_map_difference(src, f, len, 0, 0, 0, either$1);
    }
    function partition_tf(t, f) {
        return partition_map(t, function(c) {
            return caml_call1(f, c) ? [
                0,
                c
            ] : [
                1,
                c
            ];
        });
    }
    function edit_distance(s1, s2) {
        if (caml_ml_string_length(s1) <= caml_ml_string_length(s2)) var s2$0 = s2, s1$0 = s1;
        else var s2$0 = s1, s1$0 = s2;
        var _bl_ = caml_call2(Base_Import[91], 1, caml_ml_string_length(s1$0)), _bm_ = caml_call2(Base_Import[88], 2, _bl_), table = caml_call2(Base_Array0[5], _bm_, 0);
        function at(i, j) {
            var _bN_ = caml_call2(Base_Import[122], j, 2), _bO_ = caml_call2(Base_Import[88], i, 2);
            return caml_call2(Base_Import[91], _bO_, _bN_);
        }
        var _bo_ = caml_ml_string_length(s1$0), _bn_ = 1;
        if (_bo_ >= 1) {
            var i$0 = _bn_;
            for(;;){
                var _bL_ = at(i$0, 0);
                caml_check_bound(table, _bL_)[1 + _bL_] = i$0;
                var _bM_ = i$0 + 1 | 0;
                if (_bo_ === i$0) break;
                i$0 = _bM_;
            }
        }
        var _bq_ = caml_ml_string_length(s2$0), _bp_ = 1;
        if (_bq_ >= 1) {
            var j = _bp_;
            for(;;){
                var _bs_ = at(0, j);
                caml_check_bound(table, _bs_)[1 + _bs_] = j;
                var _bu_ = caml_ml_string_length(s1$0), _bt_ = 1;
                if (_bu_ >= 1) {
                    var i = _bt_;
                    for(;;){
                        var _bw_ = caml_string_get(s2$0, caml_call2(Base_Import[93], j, 1)), _bx_ = caml_string_get(s1$0, caml_call2(Base_Import[93], i, 1));
                        if (caml_call2(Base_Char[16], _bx_, _bw_)) {
                            var _by_ = caml_call2(Base_Import[93], j, 1), _bz_ = at(caml_call2(Base_Import[93], i, 1), _by_), _bA_ = caml_check_bound(table, _bz_)[1 + _bz_], _bB_ = at(i, j);
                            caml_check_bound(table, _bB_)[1 + _bB_] = _bA_;
                        } else {
                            var _bD_ = caml_call2(Base_Import[93], j, 1), _bE_ = at(caml_call2(Base_Import[93], i, 1), _bD_), sub = caml_check_bound(table, _bE_)[1 + _bE_], _bF_ = at(caml_call2(Base_Import[93], i, 1), j), add = caml_check_bound(table, _bF_)[1 + _bF_], _bG_ = at(i, caml_call2(Base_Import[93], j, 1)), del = caml_check_bound(table, _bG_)[1 + _bG_], _bH_ = caml_call2(Base_Import[101], add, del), _bI_ = caml_call2(Base_Import[101], sub, _bH_), _bJ_ = caml_call2(Base_Import[91], 1, _bI_), _bK_ = at(i, j);
                            caml_check_bound(table, _bK_)[1 + _bK_] = _bJ_;
                        }
                        var _bC_ = i + 1 | 0;
                        if (_bu_ === i) break;
                        i = _bC_;
                    }
                }
                var _bv_ = j + 1 | 0;
                if (_bq_ === j) break;
                j = _bv_;
            }
        }
        var _br_ = at(caml_ml_string_length(s1$0), caml_ml_string_length(s2$0));
        return caml_check_bound(table, _br_)[1 + _br_];
    }
    function build_and_validate_escapeworth(escapeworthy_map, escape_char, func) {
        var escapeworthy_map$0 = caml_call3(Base_List[137][7], escapeworthy_map, Base_Char[16], escape_char) ? escapeworthy_map : [
            0,
            [
                0,
                escape_char,
                escape_char
            ],
            escapeworthy_map
        ], arr = caml_call2(Base_Array0[4], 256, -1), vals = caml_call2(Base_Array0[4], 256, 0), param = escapeworthy_map$0;
        for(;;){
            if (!param) return [
                0,
                arr
            ];
            var l = param[2], match = param[1], c_to = match[2], c_from = match[1];
            if (919809722 <= func) var v = c_from, k = caml_call1(Base_Char[32], c_to);
            else var k$0 = caml_call1(Base_Char[32], c_from), v = c_to, k = k$0;
            if (-1 !== caml_check_bound(arr, k)[1 + k]) break;
            var _bd_ = caml_call1(Base_Char[32], v);
            if (caml_check_bound(vals, _bd_)[1 + _bd_]) break;
            var _bj_ = caml_call1(Base_Char[32], v);
            caml_check_bound(arr, k)[1 + k] = _bj_;
            var _bk_ = caml_call1(Base_Char[32], v);
            caml_check_bound(vals, _bk_)[1 + _bk_] = 1;
            param = l;
        }
        var _be_ = caml_call2(Base_Import[147], Base_Import[138], Base_Import[138]), _bf_ = [
            0,
            [
                0,
                cst_escapeworthy_map,
                caml_call2(Base_Import[149], _be_, escapeworthy_map$0)
            ],
            0
        ], _bg_ = [
            0,
            [
                0,
                cst_c_to,
                caml_call1(Base_Import[138], c_to)
            ],
            _bf_
        ], _bh_ = [
            0,
            [
                0,
                cst_c_from,
                caml_call1(Base_Import[138], c_from)
            ],
            _bg_
        ], _bi_ = caml_call2(Base_Sexp[10], cst_escapeworthy_map_not_one_t, _bh_);
        return caml_call1(Base_Or_error[39], _bi_);
    }
    function escape_gen(escapeworthy_map, escape_char) {
        var x = build_and_validate_escapeworth(escapeworthy_map, escape_char, 258914209);
        if (0 !== x[0]) return x;
        var escapeworthy = x[1];
        return [
            0,
            function(src) {
                var to_escape_len = [
                    0,
                    0
                ], to_escape = foldi(src, 0, function(i, acc, c) {
                    var _bc_ = caml_call1(Base_Char[32], c), n = caml_check_bound(escapeworthy, _bc_)[1 + _bc_];
                    return -1 === n ? acc : (to_escape_len[1]++, [
                        0,
                        [
                            0,
                            i,
                            caml_call1(Base_Char[35], n)
                        ],
                        acc
                    ]);
                });
                if (!to_escape) return src;
                var last_idx = caml_ml_string_length(src), last_dst_pos = caml_call2(Base_Import[91], last_idx, to_escape_len[1]), dst = caml_call1(Base_Bytes0[7], last_dst_pos), last_idx$0 = last_idx, last_dst_pos$0 = last_dst_pos, param = to_escape;
                for(;;){
                    if (!param) {
                        caml_call5(Base_Bytes0[4], src, 0, dst, 0, last_idx$0);
                        return caml_string_of_bytes(dst);
                    }
                    var to_escape$0 = param[2], match = param[1], escaped_char = match[2], last_idx$1 = match[1], _ba_ = caml_call2(Base_Import[93], last_idx$0, last_idx$1), len = caml_call2(Base_Import[93], _ba_, 1), dst_pos = caml_call2(Base_Import[93], last_dst_pos$0, len), _bb_ = caml_call2(Base_Import[91], last_idx$1, 1);
                    caml_call5(Base_Bytes0[4], src, _bb_, dst, dst_pos, len);
                    var last_dst_pos$1 = caml_call2(Base_Import[93], dst_pos, 2);
                    caml_bytes_set(dst, last_dst_pos$1, escape_char);
                    caml_bytes_set(dst, caml_call2(Base_Import[91], last_dst_pos$1, 1), escaped_char);
                    last_idx$0 = last_idx$1;
                    last_dst_pos$0 = last_dst_pos$1;
                    param = to_escape$0;
                }
            }
        ];
    }
    function escape_gen_exn(escapeworthy_map, escape_char) {
        var _a$_ = escape_gen(escapeworthy_map, escape_char);
        return caml_call1(stage, caml_call1(Base_Or_error[34], _a$_));
    }
    function escape(escapeworthy, escape_char) {
        var _a__ = caml_call2(Base_List[126], escapeworthy, Base_Char[17]), escapeworthy_map = caml_call2(Base_List[53], _a__, function(c) {
            return [
                0,
                c,
                c
            ];
        });
        return escape_gen_exn(escapeworthy_map, escape_char);
    }
    function unescape_gen(escapeworthy_map, escape_char) {
        var x = build_and_validate_escapeworth(escapeworthy_map, escape_char, 919809722);
        if (0 !== x[0]) return x;
        var escapeworthy = x[1];
        return [
            0,
            function(src) {
                var i = 0, status = -512962225, to_unescape = 0;
                for(;;){
                    if (caml_ml_string_length(src) <= i) break;
                    if (-512962225 <= status) var _a2_ = caml_string_get(src, i), status$0 = caml_call2(Base_Char[16], _a2_, escape_char) ? -767030498 : -512962225;
                    else var status$0 = -244189789;
                    var acc = -512962225 <= status$0 ? to_unescape : [
                        0,
                        i,
                        to_unescape
                    ], i$0 = caml_call2(Base_Import[91], i, 1);
                    i = i$0;
                    status = status$0;
                    to_unescape = acc;
                }
                if (!to_unescape) return src;
                var to_unescape$0 = to_unescape[2], idx = to_unescape[1], _a3_ = caml_call1(Base_List[45], to_unescape), _a4_ = caml_call2(Base_Import[93], caml_ml_string_length(src), _a3_), dst = caml_call1(Base_Bytes0[7], _a4_);
                function loop(last_idx, last_dst_pos, param) {
                    var last_idx$0 = last_idx, last_dst_pos$0 = last_dst_pos, param$0 = param;
                    for(;;){
                        if (!param$0) return caml_call5(Base_Bytes0[4], src, 0, dst, 0, last_idx$0);
                        var to_unescape = param$0[2], last_idx$1 = param$0[1], _a5_ = caml_call2(Base_Import[93], last_idx$0, last_idx$1), len = caml_call2(Base_Import[93], _a5_, 2), dst_pos = caml_call2(Base_Import[93], last_dst_pos$0, len), _a6_ = caml_call2(Base_Import[91], last_idx$1, 2);
                        caml_call5(Base_Bytes0[4], src, _a6_, dst, dst_pos, len);
                        var last_dst_pos$1 = caml_call2(Base_Import[93], dst_pos, 1), _a7_ = caml_string_get(src, caml_call2(Base_Import[91], last_idx$1, 1)), _a8_ = caml_call1(Base_Char[32], _a7_), n = caml_check_bound(escapeworthy, _a8_)[1 + _a8_], _a9_ = -1 === n ? caml_string_get(src, caml_call2(Base_Import[91], last_idx$1, 1)) : caml_call1(Base_Char[35], n);
                        caml_bytes_set(dst, last_dst_pos$1, _a9_);
                        last_idx$0 = last_idx$1;
                        last_dst_pos$0 = last_dst_pos$1;
                        param$0 = to_unescape;
                    }
                }
                if (idx < caml_call2(Base_Import[93], caml_ml_string_length(src), 1)) loop(caml_ml_string_length(src), caml_ml_bytes_length(dst), to_unescape);
                else loop(caml_call2(Base_Import[93], caml_ml_string_length(src), 1), caml_ml_bytes_length(dst), to_unescape$0);
                return caml_string_of_bytes(dst);
            }
        ];
    }
    function unescape_gen_exn(escapeworthy_map, escape_char) {
        var _a1_ = unescape_gen(escapeworthy_map, escape_char);
        return caml_call1(stage, caml_call1(Base_Or_error[34], _a1_));
    }
    function unescape(escape_char) {
        return unescape_gen_exn(0, escape_char);
    }
    function preceding_escape_chars(str, escape_char, pos) {
        var p$1 = caml_call2(Base_Import[93], pos, 1), p = p$1, cnt = 0;
        for(;;){
            if (0 <= p) {
                var _a0_ = caml_string_get(str, p);
                if (!caml_call2(Base_Char[15], _a0_, escape_char)) {
                    var cnt$0 = caml_call2(Base_Import[91], cnt, 1), p$0 = caml_call2(Base_Import[93], p, 1);
                    p = p$0;
                    cnt = cnt$0;
                    continue;
                }
            }
            return cnt;
        }
    }
    function update_escape_status(str, escape_char, i, param) {
        if (-512962225 > param) return -244189789;
        var _aZ_ = caml_string_get(str, i);
        return caml_call2(Base_Char[16], _aZ_, escape_char) ? -767030498 : -512962225;
    }
    function escape_status(str, escape_char, pos) {
        var _aX_ = preceding_escape_chars(str, escape_char, pos), odd = 1 === caml_call2(Base_Import[122], _aX_, 2) ? 1 : 0, _aY_ = caml_string_get(str, pos), match = caml_call2(Base_Char[16], _aY_, escape_char);
        return odd ? -244189789 : match ? -767030498 : -512962225;
    }
    function check_bound(str, pos, function_name) {
        var _aV_ = caml_ml_string_length(str) <= pos ? 1 : 0, _aW_ = _aV_ || (pos < 0 ? 1 : 0);
        return _aW_ ? caml_call3(invalid_argf, _G_, function_name, 0) : _aW_;
    }
    function is_char_escaping(str, escape_char, pos) {
        check_bound(str, pos, cst_is_char_escaping);
        return -512962225 <= escape_status(str, escape_char, pos) ? 0 : 1;
    }
    function is_char_escaped(str, escape_char, pos) {
        check_bound(str, pos, cst_is_char_escaped);
        return -244189789 <= escape_status(str, escape_char, pos) ? 1 : 0;
    }
    function is_char_literal(str, escape_char, pos) {
        check_bound(str, pos, cst_is_char_literal);
        return -512962225 === escape_status(str, escape_char, pos) ? 1 : 0;
    }
    function index_from$0(str, escape_char, pos, char$0) {
        check_bound(str, pos, cst_index_from);
        var status$1 = escape_status(str, escape_char, pos), i = pos, status = status$1;
        for(;;){
            if (pos <= i) {
                var _aT_ = -512962225 === status ? 1 : 0;
                if (_aT_) {
                    var _aU_ = caml_string_get(str, i);
                    if (caml_call2(Base_Char[16], _aU_, char$0)) return [
                        0,
                        i
                    ];
                }
            }
            var i$0 = caml_call2(Base_Import[91], i, 1);
            if (caml_ml_string_length(str) <= i$0) return 0;
            var status$0 = update_escape_status(str, escape_char, i$0, status);
            i = i$0;
            status = status$0;
        }
    }
    function index_from_exn$0(str, escape_char, pos, char$0) {
        var match = index_from$0(str, escape_char, pos, char$0);
        if (match) {
            var pos$0 = match[1];
            return pos$0;
        }
        var _aP_ = [
            0,
            [
                0,
                cst_char,
                caml_call1(Base_Import[138], char$0)
            ],
            0
        ], _aQ_ = [
            0,
            [
                0,
                cst_pos,
                caml_call1(Base_Import[139], pos)
            ],
            _aP_
        ], _aR_ = [
            0,
            [
                0,
                cst_escape_char,
                caml_call1(Base_Import[138], escape_char)
            ],
            _aQ_
        ], _aS_ = [
            0,
            [
                0,
                cst_str,
                caml_call1(sexp_of_t, str)
            ],
            _aR_
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_index_from_exn_not_found, _aS_));
    }
    function index$1(str, escape_char, char$0) {
        return index_from$0(str, escape_char, 0, char$0);
    }
    function index_exn$1(str, escape_char, char$0) {
        return index_from_exn$0(str, escape_char, 0, char$0);
    }
    function rindex_from$0(str, escape_char, pos, char$0) {
        check_bound(str, pos, cst_rindex_from);
        if (caml_call2(Base_Char[16], char$0, escape_char)) return 0;
        var pos$0 = pos;
        for(;;){
            if (0 > pos$0) return 0;
            var escape_chars = preceding_escape_chars(str, escape_char, pos$0);
            if (0 === caml_call2(Base_Import[122], escape_chars, 2)) {
                var _aN_ = caml_string_get(str, pos$0);
                if (caml_call2(Base_Char[16], _aN_, char$0)) return [
                    0,
                    pos$0
                ];
            }
            var _aO_ = caml_call2(Base_Import[93], pos$0, escape_chars), pos$1 = caml_call2(Base_Import[93], _aO_, 1);
            pos$0 = pos$1;
        }
    }
    function rindex_from_exn$0(str, escape_char, pos, char$0) {
        var match = rindex_from$0(str, escape_char, pos, char$0);
        if (match) {
            var pos$0 = match[1];
            return pos$0;
        }
        var _aJ_ = [
            0,
            [
                0,
                cst_char$0,
                caml_call1(Base_Import[138], char$0)
            ],
            0
        ], _aK_ = [
            0,
            [
                0,
                cst_pos$0,
                caml_call1(Base_Import[139], pos)
            ],
            _aJ_
        ], _aL_ = [
            0,
            [
                0,
                cst_escape_char$0,
                caml_call1(Base_Import[138], escape_char)
            ],
            _aK_
        ], _aM_ = [
            0,
            [
                0,
                cst_str$0,
                caml_call1(sexp_of_t, str)
            ],
            _aL_
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_rindex_from_exn_not_found, _aM_));
    }
    function rindex$0(str, escape_char, char$0) {
        return is_empty(str) ? 0 : rindex_from$0(str, escape_char, caml_call2(Base_Import[93], caml_ml_string_length(str), 1), char$0);
    }
    function rindex_exn$0(str, escape_char, char$0) {
        return rindex_from_exn$0(str, escape_char, caml_call2(Base_Import[93], caml_ml_string_length(str), 1), char$0);
    }
    function split_gen$0(str, escape_char, on) {
        if (552554919 <= on[1]) var l = on[2], is_delim = function(c) {
            return char_list_mem(l, c);
        };
        else var c = on[2], is_delim = function(c$0) {
            return caml_call2(Base_Char[16], c$0, c);
        };
        var len = caml_ml_string_length(str), acc = 0, status = -512962225, last_pos = 0, pos = 0;
        for(;;){
            if (pos === len) {
                var _aH_ = [
                    0,
                    sub(str, last_pos, caml_call2(Base_Import[93], len, last_pos)),
                    acc
                ];
                return caml_call1(Base_List[63], _aH_);
            }
            var status$0 = update_escape_status(str, escape_char, pos, status), _aI_ = -512962225 === status$0 ? 1 : 0;
            if (_aI_ && is_delim(caml_string_get(str, pos))) {
                var sub_str = sub(str, last_pos, caml_call2(Base_Import[93], pos, last_pos)), pos$0 = caml_call2(Base_Import[91], pos, 1), last_pos$0 = caml_call2(Base_Import[91], pos, 1), acc$0 = [
                    0,
                    sub_str,
                    acc
                ];
                acc = acc$0;
                status = status$0;
                last_pos = last_pos$0;
                pos = pos$0;
                continue;
            }
            var pos$1 = caml_call2(Base_Import[91], pos, 1);
            status = status$0;
            pos = pos$1;
        }
    }
    function split$0(str, on) {
        var _aF_ = [
            0,
            -1044422954,
            on
        ];
        return function(_aG_) {
            return split_gen$0(str, _aG_, _aF_);
        };
    }
    function split_on_chars$0(str, chars) {
        var _aD_ = [
            0,
            552554919,
            chars
        ];
        return function(_aE_) {
            return split_gen$0(str, _aE_, _aD_);
        };
    }
    function split_at(str, pos) {
        var _aA_ = caml_call2(Base_Import[93], caml_ml_string_length(str), pos), _aB_ = caml_call2(Base_Import[93], _aA_, 1), _aC_ = sub(str, caml_call2(Base_Import[91], pos, 1), _aB_);
        return [
            0,
            sub(str, 0, pos),
            _aC_
        ];
    }
    function lsplit2$0(str, on, escape_char) {
        var _az_ = index$1(str, escape_char, on);
        return caml_call2(Base_Option[24], _az_, function(x) {
            return split_at(str, x);
        });
    }
    function rsplit2$0(str, on, escape_char) {
        var _ay_ = rindex$0(str, escape_char, on);
        return caml_call2(Base_Option[24], _ay_, function(x) {
            return split_at(str, x);
        });
    }
    function lsplit2_exn$0(str, on, escape_char) {
        return split_at(str, index_exn$1(str, escape_char, on));
    }
    function rsplit2_exn$0(str, on, escape_char) {
        return split_at(str, rindex_exn$0(str, escape_char, on));
    }
    function last_non_drop_literal(drop, escape_char, t) {
        return rfindi(0, t, function(i, c) {
            var _av_ = 1 - caml_call1(drop, c);
            if (_av_) var _aw_ = _av_;
            else {
                var _ax_ = is_char_escaping(t, escape_char, i);
                if (!_ax_) return is_char_escaped(t, escape_char, i);
                var _aw_ = _ax_;
            }
            return _aw_;
        });
    }
    function first_non_drop_literal(drop, escape_char, t) {
        return lfindi(0, t, function(i, c) {
            var _as_ = 1 - caml_call1(drop, c);
            if (_as_) var _at_ = _as_;
            else {
                var _au_ = is_char_escaping(t, escape_char, i);
                if (!_au_) return is_char_escaped(t, escape_char, i);
                var _at_ = _au_;
            }
            return _at_;
        });
    }
    function rstrip_literal(opt, t, escape_char) {
        var drop = opt ? opt[1] : Base_Char[45], match = last_non_drop_literal(drop, escape_char, t);
        if (!match) return cst$10;
        var i = match[1];
        return i === caml_call2(Base_Import[93], caml_ml_string_length(t), 1) ? t : prefix(t, caml_call2(Base_Import[91], i, 1));
    }
    function lstrip_literal(opt, t, escape_char) {
        var drop = opt ? opt[1] : Base_Char[45], match = first_non_drop_literal(drop, escape_char, t);
        if (!match) return cst$11;
        var n = match[1];
        return 0 === n ? t : drop_prefix(t, n);
    }
    function strip_literal(opt, t, escape_char) {
        var drop = opt ? opt[1] : Base_Char[45], length = caml_ml_string_length(t);
        a: if (0 !== length) {
            if (!caml_call1(drop, caml_string_get(t, 0)) && !caml_call1(drop, caml_string_get(t, caml_call2(Base_Import[93], length, 1)))) break a;
            var match = first_non_drop_literal(drop, escape_char, t);
            if (!match) return cst$12;
            var first = match[1], match$0 = last_non_drop_literal(drop, escape_char, t);
            if (!match$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _H_
            ], 1);
            var last = match$0[1], _ar_ = caml_call2(Base_Import[93], last, first);
            return sub(t, first, caml_call2(Base_Import[91], _ar_, 1));
        }
        return t;
    }
    function between$0(t, low, high) {
        var _aq_ = caml_call2(Base_Import[109][2], low, t);
        return _aq_ ? caml_call2(Base_Import[109][2], t, high) : _aq_;
    }
    function clamp_unchecked(t, min, max) {
        return caml_call2(Base_Import[109][1], t, min) ? min : caml_call2(Base_Import[109][2], t, max) ? t : max;
    }
    function clamp_exn$0(t, min, max) {
        if (caml_call2(Base_Import[109][2], min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _I_
        ], 1);
    }
    function clamp$0(t, min, max) {
        if (!caml_call2(Base_Import[109][5], min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _an_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _ao_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _an_
        ], _ap_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _ao_);
        return caml_call1(Base_Or_error[39], _ap_);
    }
    function create$0(opt, pattern) {
        var case_sensitive = opt ? opt[1] : 1;
        return create(pattern, case_sensitive);
    }
    function Make_utf(Format) {
        var codec_name = Format[1], is_valid = Format[3], raise_get_message = [
            246,
            function(_am_) {
                return caml_call3(Base_Printf[2], _J_, Format[2], Format[1]);
            }
        ];
        function raise_get(t, pos) {
            var _aj_ = [
                0,
                [
                    0,
                    cst$13,
                    [
                        0,
                        t
                    ]
                ],
                [
                    0,
                    [
                        0,
                        cst_pos$1,
                        caml_call1(Base_Import[139], pos)
                    ],
                    0
                ]
            ], _ak_ = runtime.caml_obj_tag(raise_get_message);
            a: if (250 === _ak_) var _al_ = raise_get_message[1];
            else {
                if (246 !== _ak_ && 244 !== _ak_) {
                    var _al_ = raise_get_message;
                    break a;
                }
                var _al_ = caml_call1(CamlinternalLazy[2], raise_get_message);
            }
            return caml_call1(raise_s, caml_call2(Base_Sexp[10], _al_, _aj_));
        }
        function get(t, byte_pos) {
            var decode = caml_call2(Format[5], t, byte_pos);
            return caml_call1(Base_Uchar0[18], decode) ? caml_call1(Base_Uchar0[19], decode) : raise_get(t, byte_pos);
        }
        function to_string(_ai_) {
            return _ai_;
        }
        function of_string_unchecked(_ah_) {
            return _ah_;
        }
        var raise_of_string_message = caml_call2(concat, 0, [
            0,
            Format[2],
            [
                0,
                cst_of_string_invalid,
                [
                    0,
                    codec_name,
                    0
                ]
            ]
        ]);
        function raise_of_string(string) {
            return caml_call1(raise_s, caml_call2(Base_Sexp[10], raise_of_string_message, [
                0,
                [
                    0,
                    cst$14,
                    [
                        0,
                        string
                    ]
                ],
                0
            ]));
        }
        function of_string(string) {
            return caml_call1(is_valid, string) ? string : raise_of_string(string);
        }
        var include = caml_call1(Base_Sexpable[5], [
            0,
            of_string,
            to_string
        ]), t_sexp_grammar = include[1], t_of_sexp = include[2], sexp_of_t = include[3], compare = Base_Import[109][9];
        function hash(_ag_) {
            return runtime.Base_hash_string(_ag_);
        }
        var module_name = Format[2], include$0 = caml_call1(Base_Identifiable[1], [
            0,
            compare,
            hash_fold_t,
            hash,
            t_of_sexp,
            sexp_of_t,
            of_string,
            to_string,
            module_name
        ]), hash_fold_t$0 = include$0[1], hash$0 = include$0[2], t_of_sexp$0 = include$0[3], sexp_of_t$0 = include$0[4], of_string$0 = include$0[5], to_string$0 = include$0[6], symbol = include$0[7], symbol$0 = include$0[8], symbol$1 = include$0[9], symbol$2 = include$0[10], symbol$3 = include$0[11], symbol$4 = include$0[12], equal = include$0[13], compare$0 = include$0[14], min = include$0[15], max = include$0[16], ascending = include$0[17], descending = include$0[18], between = include$0[19], clamp_exn = include$0[20], clamp = include$0[21], comparator = include$0[22], pp = include$0[23], hashable = include$0[24];
        function to_sequence(t) {
            var len = caml_ml_string_length(t);
            return caml_call2(Base_Sequence[45], 0, function(byte_pos) {
                if (len <= byte_pos) return 0;
                var decode = caml_call2(Format[5], t, byte_pos), _ae_ = caml_call1(Base_Uchar0[20], decode), _af_ = caml_call2(Base_Import[91], byte_pos, _ae_);
                return [
                    0,
                    [
                        0,
                        caml_call1(Base_Uchar0[19], decode),
                        _af_
                    ]
                ];
            });
        }
        function fold(t, acc, f) {
            var len = caml_ml_string_length(t), byte_pos = 0, acc$0 = acc;
            for(;;){
                if (byte_pos === len) return acc$0;
                var decode = caml_call2(Format[5], t, byte_pos), acc$1 = caml_call2(f, acc$0, caml_call1(Base_Uchar0[19], decode)), _ad_ = caml_call1(Base_Uchar0[20], decode), byte_pos$0 = caml_call2(Base_Import[91], byte_pos, _ad_);
                byte_pos = byte_pos$0;
                acc$0 = acc$1;
            }
        }
        function sanitize(t) {
            var len = fold(t, 0, function(pos, uchar) {
                var _ac_ = caml_call1(Format[4], uchar);
                return caml_call2(Base_Import[91], pos, _ac_);
            }), bytes = caml_call1(Base_Bytes0[7], len), pos = fold(t, 0, function(pos, uchar) {
                var _ab_ = caml_call3(Format[6], bytes, pos, uchar);
                return caml_call2(Base_Import[91], pos, _ab_);
            });
            if (pos === len) return caml_string_of_bytes(bytes);
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _K_
            ], 1);
        }
        function of_list(uchars) {
            var len = caml_call3(Base_List[20], uchars, 0, function(n, u) {
                var _aa_ = caml_call1(Format[4], u);
                return caml_call2(Base_Import[91], n, _aa_);
            }), bytes = caml_call1(Base_Bytes0[7], len), pos = caml_call3(Base_List[20], uchars, 0, function(pos, uchar) {
                var _$_ = caml_call3(Format[6], bytes, pos, uchar);
                return caml_call2(Base_Import[91], pos, _$_);
            });
            if (pos === len) return caml_string_of_bytes(bytes);
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _L_
            ], 1);
        }
        function of_array(uchars) {
            var len = [
                0,
                0
            ], _S_ = caml_call2(Base_Import[93], uchars.length - 1, 1), _R_ = 0;
            if (_S_ >= 0) {
                var i$0 = _R_;
                for(;;){
                    var _Y_ = caml_check_bound(uchars, i$0)[1 + i$0], _Z_ = caml_call1(Format[4], _Y_);
                    len[1] = caml_call2(Base_Import[91], len[1], _Z_);
                    var ___ = i$0 + 1 | 0;
                    if (_S_ === i$0) break;
                    i$0 = ___;
                }
            }
            var bytes = caml_call1(Base_Bytes0[7], len[1]), pos = [
                0,
                0
            ], _U_ = caml_call2(Base_Import[93], uchars.length - 1, 1), _T_1 = 0;
            if (_U_ >= 0) {
                var i = _T_1;
                for(;;){
                    var _V_ = caml_check_bound(uchars, i)[1 + i], _W_ = caml_call3(Format[6], bytes, pos[1], _V_);
                    pos[1] = caml_call2(Base_Import[91], pos[1], _W_);
                    var _X_ = i + 1 | 0;
                    if (_U_ === i) break;
                    i = _X_;
                }
            }
            if (pos[1] === len[1]) return caml_string_of_bytes(bytes);
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _M_
            ], 1);
        }
        function concat$0(list) {
            return caml_call2(concat, _N_, list);
        }
        function split(t, on) {
            var len = caml_ml_string_length(t), start$1 = 0, until = 0;
            for(;;){
                if (until === len) return [
                    0,
                    sub(t, start$1, caml_call2(Base_Import[93], until, start$1)),
                    0
                ];
                var uchar = get(t, until), _P_ = caml_call1(Format[4], uchar), until$0 = caml_call2(Base_Import[91], until, _P_);
                if (caml_call2(Base_Uchar0[11], uchar, on)) break;
                until = until$0;
            }
            var block = [
                0,
                sub(t, start$1, caml_call2(Base_Import[93], until, start$1)),
                24029
            ], dst = block, offset = 1, start = until$0, until$1 = until$0;
            for(;;){
                if (until$1 === len) {
                    dst[1 + offset] = [
                        0,
                        sub(t, start, caml_call2(Base_Import[93], until$1, start)),
                        0
                    ];
                    return block;
                }
                var uchar$0 = get(t, until$1), _Q_ = caml_call1(Format[4], uchar$0), start$0 = caml_call2(Base_Import[91], until$1, _Q_);
                if (caml_call2(Base_Uchar0[11], uchar$0, on)) {
                    var dst$0 = [
                        0,
                        sub(t, start, caml_call2(Base_Import[93], until$1, start)),
                        24029
                    ];
                    dst[1 + offset] = dst$0;
                    dst = dst$0;
                    offset = 1;
                    start = start$0;
                    until$1 = start$0;
                } else until$1 = start$0;
            }
        }
        var C = caml_call1(Base_Indexed_container[12], [
            0,
            [
                0,
                Base_Uchar0[11]
            ],
            of_list,
            of_array,
            concat$0,
            fold,
            -304398144,
            -304398144,
            -304398144,
            -304398144,
            348729712,
            -637740141
        ]), append = C[3], concat_map = C[8], concat_mapi = C[39], count = C[20], counti = C[32], exists = C[18], existsi = C[30], filter = C[6], filter_map = C[7], filter_mapi = C[38], filteri = C[37], find = C[22], find_map = C[23], find_mapi = C[34], findi = C[33], fold_result = C[16], fold_until = C[17], foldi = C[28], for_all = C[19], for_alli = C[31], init = C[35], is_empty = C[13], iter = C[14], iteri = C[29], length = C[12], map = C[5], mapi = C[36], max_elt = C[27], mem = C[11], min_elt = C[26], partition_map = C[10], partition_tf = C[9], sum = C[21], to_array = C[25], to_list = C[24];
        return [
            0,
            codec_name,
            is_valid,
            ,
            ,
            get,
            of_string_unchecked,
            ,
            ,
            t_sexp_grammar,
            hash_fold_t$0,
            hash$0,
            t_of_sexp$0,
            sexp_of_t$0,
            of_string$0,
            to_string$0,
            symbol,
            symbol$0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            equal,
            compare$0,
            min,
            max,
            ascending,
            descending,
            between,
            clamp_exn,
            clamp,
            comparator,
            pp,
            hashable,
            to_sequence,
            fold,
            sanitize,
            of_list,
            of_array,
            concat$0,
            split,
            ,
            append,
            concat_map,
            concat_mapi,
            count,
            counti,
            exists,
            existsi,
            filter,
            filter_map,
            filter_mapi,
            filteri,
            find,
            find_map,
            find_mapi,
            findi,
            fold_result,
            fold_until,
            foldi,
            for_all,
            for_alli,
            init,
            is_empty,
            iter,
            iteri,
            length,
            map,
            mapi,
            max_elt,
            mem,
            min_elt,
            partition_map,
            partition_tf,
            sum,
            to_array,
            to_list,
            length
        ];
    }
    var byte_length = Base_Uchar0[16], set = Base_Bytes0[8], Utf8 = Make_utf([
        0,
        codec_name,
        module_name,
        is_valid_utf_8,
        byte_length,
        get_utf_8_uchar,
        set
    ]), byte_length$0 = Base_Uchar0[17], set$0 = Base_Bytes0[9], Utf16le = Make_utf([
        0,
        codec_name$0,
        module_name$0,
        is_valid_utf_16le,
        byte_length$0,
        get_utf_16le_uchar,
        set$0
    ]), byte_length$1 = Base_Uchar0[17], set$1 = Base_Bytes0[10], Utf16be = Make_utf([
        0,
        codec_name$1,
        module_name$1,
        is_valid_utf_16be,
        byte_length$1,
        get_utf_16be_uchar,
        set$1
    ]);
    function Make_utf32(Format) {
        function byte_length(param) {
            return 4;
        }
        var codec_name = Format[1], module_name = Format[2], set = Format[4], get_decode_result = Format[3];
        function is_valid(t) {
            var len = caml_ml_string_length(t);
            if (0 !== caml_call2(Base_Import[122], len, 4)) return 0;
            var byte_pos = 0;
            for(;;){
                if (byte_pos >= len) return 1;
                var result = caml_call2(Format[3], t, byte_pos), _O_ = caml_call1(Base_Uchar0[18], result);
                if (!_O_) return _O_;
                var byte_pos$0 = caml_call2(Base_Import[91], byte_pos, 4);
                byte_pos = byte_pos$0;
            }
        }
        return Make_utf([
            0,
            codec_name,
            module_name,
            is_valid,
            byte_length,
            get_decode_result,
            set
        ]);
    }
    var set$2 = Base_Bytes0[12], Utf32le = Make_utf32([
        0,
        codec_name$2,
        module_name$2,
        get_utf_32le_uchar,
        set$2
    ]), set$3 = Base_Bytes0[13], Utf32be = Make_utf32([
        0,
        codec_name$3,
        module_name$3,
        get_utf_32be_uchar,
        set$3
    ]), include$1 = Base_Import[109], symbol$5 = include$1[1], symbol$6 = include$1[2], symbol$7 = include$1[3], symbol$8 = include$1[4], symbol$9 = include$1[5], symbol$10 = include$1[6], ascending$0 = include$1[7], descending$0 = include$1[8], compare$2 = include$1[9], compare_local$0 = include$1[10], equal$1 = include$1[11], equal_local$0 = include$1[12], max$0 = include$1[13], min$0 = include$1[14], Base_String = [
        0,
        globalize,
        t_sexp_grammar,
        sub,
        unsafe_sub,
        subo,
        of_char_list,
        of_array,
        symbol_concat,
        map,
        filter,
        filter_map,
        partition_tf,
        partition_map,
        is_empty,
        iter,
        fold,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        to_array,
        min_elt,
        max_elt,
        foldi,
        iteri,
        existsi,
        for_alli,
        counti,
        findi,
        find_mapi,
        init,
        mapi,
        filteri,
        filter_mapi,
        hash_fold_t,
        t_of_sexp,
        sexp_of_t,
        of_string,
        to_string,
        symbol$10,
        symbol$6,
        symbol$8,
        symbol$9,
        symbol$5,
        symbol$7,
        compare$2,
        min$0,
        max$0,
        ascending$0,
        descending$0,
        between$0,
        clamp_exn$0,
        clamp$0,
        comparator,
        pp,
        hashable,
        compare_local$0,
        invariant,
        max_length,
        mem,
        make,
        symbol_concat,
        concat,
        escaped,
        contains,
        uppercase,
        lowercase,
        capitalize,
        uncapitalize,
        [
            0,
            hash_fold_t$0,
            hash$0,
            t_of_sexp$0,
            sexp_of_t$2,
            t_sexp_grammar$0,
            symbol,
            symbol$0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            equal$0,
            compare$1,
            min,
            max,
            ascending,
            descending,
            between,
            clamp_exn,
            clamp,
            comparator$0,
            compare_local,
            is_suffix,
            is_prefix,
            is_substring$0,
            is_substring_at,
            substr_index$0,
            substr_index_exn$0,
            substr_index_all$0,
            substr_replace_first$0,
            substr_replace_all$0
        ],
        index,
        index_exn,
        index_from,
        index_from_exn,
        rindex,
        rindex_exn,
        rindex_from,
        rindex_from_exn,
        to_sequence,
        of_sequence,
        [
            0,
            sexp_of_t$0,
            create$0,
            pattern,
            case_sensitive,
            matches,
            index$0,
            index_exn$0,
            index_all,
            replace_first,
            replace_all,
            split_on,
            [
                0,
                equal,
                equal_local,
                sexp_of_t$1,
                representation
            ]
        ],
        substr_index,
        substr_index_exn,
        substr_index_all,
        substr_replace_first,
        substr_replace_all,
        is_substring,
        is_substring_at$0,
        to_list_rev,
        rev,
        is_suffix$0,
        is_prefix$0,
        lsplit2_exn,
        rsplit2_exn,
        lsplit2,
        rsplit2,
        split,
        split_on_chars,
        split_lines,
        lfindi,
        rfindi,
        lstrip,
        rstrip,
        strip,
        concat_map,
        concat_mapi,
        tr,
        tr_multi,
        chop_suffix_exn,
        chop_prefix_exn,
        chop_suffix,
        chop_prefix,
        chop_suffix_if_exists,
        chop_prefix_if_exists,
        suffix,
        prefix,
        drop_suffix,
        drop_prefix,
        common_suffix,
        common_prefix,
        common_suffix_length,
        common_prefix_length,
        common_suffix2,
        common_prefix2,
        common_suffix2_length,
        common_prefix2_length,
        concat_array,
        concat_lines,
        equal$1,
        equal_local$0,
        of_char,
        of_char_list,
        pad_left,
        pad_right,
        edit_distance,
        [
            0,
            escape_gen_exn,
            escape_gen,
            escape,
            unescape_gen_exn,
            unescape_gen,
            unescape,
            is_char_escaping,
            is_char_escaped,
            is_char_literal,
            index$1,
            index_exn$1,
            rindex$0,
            rindex_exn$0,
            index_from$0,
            index_from_exn$0,
            rindex_from$0,
            rindex_from_exn$0,
            split$0,
            split_on_chars$0,
            lsplit2$0,
            lsplit2_exn$0,
            rsplit2$0,
            rsplit2_exn$0,
            lstrip_literal,
            rstrip_literal,
            strip_literal
        ],
        [
            0,
            Utf8[9],
            Utf8[10],
            Utf8[11],
            Utf8[12],
            Utf8[13],
            Utf8[14],
            Utf8[15],
            Utf8[16],
            Utf8[17],
            Utf8[18],
            Utf8[19],
            Utf8[20],
            Utf8[21],
            Utf8[22],
            Utf8[23],
            Utf8[24],
            Utf8[25],
            Utf8[26],
            Utf8[27],
            Utf8[28],
            Utf8[29],
            Utf8[30],
            Utf8[31],
            Utf8[32],
            Utf8[33],
            Utf8[37],
            Utf8[38],
            Utf8[42],
            Utf8[39],
            Utf8[67],
            Utf8[49],
            Utf8[50],
            Utf8[43],
            Utf8[73],
            Utf8[72],
            Utf8[70],
            Utf8[63],
            Utf8[64],
            Utf8[35],
            Utf8[57],
            Utf8[58],
            Utf8[47],
            Utf8[60],
            Utf8[45],
            Utf8[74],
            Utf8[53],
            Utf8[54],
            Utf8[76],
            Utf8[75],
            Utf8[71],
            Utf8[69],
            Utf8[59],
            Utf8[65],
            Utf8[48],
            Utf8[61],
            Utf8[46],
            Utf8[56],
            Utf8[55],
            Utf8[62],
            Utf8[68],
            Utf8[52],
            Utf8[51],
            Utf8[44],
            Utf8[34],
            Utf8[2],
            Utf8[36],
            Utf8[5],
            Utf8[6],
            Utf8[40],
            Utf8[1],
            Utf8[77],
            Utf8[66]
        ],
        [
            0,
            Utf16le[9],
            Utf16le[10],
            Utf16le[11],
            Utf16le[12],
            Utf16le[13],
            Utf16le[14],
            Utf16le[15],
            Utf16le[16],
            Utf16le[17],
            Utf16le[18],
            Utf16le[19],
            Utf16le[20],
            Utf16le[21],
            Utf16le[22],
            Utf16le[23],
            Utf16le[24],
            Utf16le[25],
            Utf16le[26],
            Utf16le[27],
            Utf16le[28],
            Utf16le[29],
            Utf16le[30],
            Utf16le[31],
            Utf16le[32],
            Utf16le[33],
            Utf16le[37],
            Utf16le[38],
            Utf16le[42],
            Utf16le[39],
            Utf16le[67],
            Utf16le[49],
            Utf16le[50],
            Utf16le[43],
            Utf16le[73],
            Utf16le[72],
            Utf16le[70],
            Utf16le[63],
            Utf16le[64],
            Utf16le[35],
            Utf16le[57],
            Utf16le[58],
            Utf16le[47],
            Utf16le[60],
            Utf16le[45],
            Utf16le[74],
            Utf16le[53],
            Utf16le[54],
            Utf16le[76],
            Utf16le[75],
            Utf16le[71],
            Utf16le[69],
            Utf16le[59],
            Utf16le[65],
            Utf16le[48],
            Utf16le[61],
            Utf16le[46],
            Utf16le[56],
            Utf16le[55],
            Utf16le[62],
            Utf16le[68],
            Utf16le[52],
            Utf16le[51],
            Utf16le[44],
            Utf16le[34],
            Utf16le[2],
            Utf16le[36],
            Utf16le[5],
            Utf16le[6],
            Utf16le[40],
            Utf16le[1],
            Utf16le[77],
            Utf16le[66]
        ],
        [
            0,
            Utf16be[9],
            Utf16be[10],
            Utf16be[11],
            Utf16be[12],
            Utf16be[13],
            Utf16be[14],
            Utf16be[15],
            Utf16be[16],
            Utf16be[17],
            Utf16be[18],
            Utf16be[19],
            Utf16be[20],
            Utf16be[21],
            Utf16be[22],
            Utf16be[23],
            Utf16be[24],
            Utf16be[25],
            Utf16be[26],
            Utf16be[27],
            Utf16be[28],
            Utf16be[29],
            Utf16be[30],
            Utf16be[31],
            Utf16be[32],
            Utf16be[33],
            Utf16be[37],
            Utf16be[38],
            Utf16be[42],
            Utf16be[39],
            Utf16be[67],
            Utf16be[49],
            Utf16be[50],
            Utf16be[43],
            Utf16be[73],
            Utf16be[72],
            Utf16be[70],
            Utf16be[63],
            Utf16be[64],
            Utf16be[35],
            Utf16be[57],
            Utf16be[58],
            Utf16be[47],
            Utf16be[60],
            Utf16be[45],
            Utf16be[74],
            Utf16be[53],
            Utf16be[54],
            Utf16be[76],
            Utf16be[75],
            Utf16be[71],
            Utf16be[69],
            Utf16be[59],
            Utf16be[65],
            Utf16be[48],
            Utf16be[61],
            Utf16be[46],
            Utf16be[56],
            Utf16be[55],
            Utf16be[62],
            Utf16be[68],
            Utf16be[52],
            Utf16be[51],
            Utf16be[44],
            Utf16be[34],
            Utf16be[2],
            Utf16be[36],
            Utf16be[5],
            Utf16be[6],
            Utf16be[40],
            Utf16be[1],
            Utf16be[77],
            Utf16be[66]
        ],
        [
            0,
            Utf32le[9],
            Utf32le[10],
            Utf32le[11],
            Utf32le[12],
            Utf32le[13],
            Utf32le[14],
            Utf32le[15],
            Utf32le[16],
            Utf32le[17],
            Utf32le[18],
            Utf32le[19],
            Utf32le[20],
            Utf32le[21],
            Utf32le[22],
            Utf32le[23],
            Utf32le[24],
            Utf32le[25],
            Utf32le[26],
            Utf32le[27],
            Utf32le[28],
            Utf32le[29],
            Utf32le[30],
            Utf32le[31],
            Utf32le[32],
            Utf32le[33],
            Utf32le[37],
            Utf32le[38],
            Utf32le[42],
            Utf32le[39],
            Utf32le[67],
            Utf32le[49],
            Utf32le[50],
            Utf32le[43],
            Utf32le[73],
            Utf32le[72],
            Utf32le[70],
            Utf32le[63],
            Utf32le[64],
            Utf32le[35],
            Utf32le[57],
            Utf32le[58],
            Utf32le[47],
            Utf32le[60],
            Utf32le[45],
            Utf32le[74],
            Utf32le[53],
            Utf32le[54],
            Utf32le[76],
            Utf32le[75],
            Utf32le[71],
            Utf32le[69],
            Utf32le[59],
            Utf32le[65],
            Utf32le[48],
            Utf32le[61],
            Utf32le[46],
            Utf32le[56],
            Utf32le[55],
            Utf32le[62],
            Utf32le[68],
            Utf32le[52],
            Utf32le[51],
            Utf32le[44],
            Utf32le[34],
            Utf32le[2],
            Utf32le[36],
            Utf32le[5],
            Utf32le[6],
            Utf32le[40],
            Utf32le[1],
            Utf32le[77],
            Utf32le[66]
        ],
        [
            0,
            Utf32be[9],
            Utf32be[10],
            Utf32be[11],
            Utf32be[12],
            Utf32be[13],
            Utf32be[14],
            Utf32be[15],
            Utf32be[16],
            Utf32be[17],
            Utf32be[18],
            Utf32be[19],
            Utf32be[20],
            Utf32be[21],
            Utf32be[22],
            Utf32be[23],
            Utf32be[24],
            Utf32be[25],
            Utf32be[26],
            Utf32be[27],
            Utf32be[28],
            Utf32be[29],
            Utf32be[30],
            Utf32be[31],
            Utf32be[32],
            Utf32be[33],
            Utf32be[37],
            Utf32be[38],
            Utf32be[42],
            Utf32be[39],
            Utf32be[67],
            Utf32be[49],
            Utf32be[50],
            Utf32be[43],
            Utf32be[73],
            Utf32be[72],
            Utf32be[70],
            Utf32be[63],
            Utf32be[64],
            Utf32be[35],
            Utf32be[57],
            Utf32be[58],
            Utf32be[47],
            Utf32be[60],
            Utf32be[45],
            Utf32be[74],
            Utf32be[53],
            Utf32be[54],
            Utf32be[76],
            Utf32be[75],
            Utf32be[71],
            Utf32be[69],
            Utf32be[59],
            Utf32be[65],
            Utf32be[48],
            Utf32be[61],
            Utf32be[46],
            Utf32be[56],
            Utf32be[55],
            Utf32be[62],
            Utf32be[68],
            Utf32be[52],
            Utf32be[51],
            Utf32be[44],
            Utf32be[34],
            Utf32be[2],
            Utf32be[36],
            Utf32be[5],
            Utf32be[6],
            Utf32be[40],
            Utf32be[1],
            Utf32be[77],
            Utf32be[66]
        ]
    ];
    runtime.caml_register_global(114, Base_String, "Base__String");
    return;
})(globalThis);
//# 22789 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bytes_get = runtime.caml_bytes_get, caml_bytes_unsafe_get = runtime.caml_bytes_unsafe_get, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_string_length = runtime.caml_ml_string_length;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), module_name = "Base.Bytes", Base_Char = global_data.Base__Char, Base_Import = global_data.Base__Import, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Bytes_tr = global_data.Base__Bytes_tr, Base_Array0 = global_data.Base__Array0, Base_List = global_data.Base__List, Base_Printf = global_data.Base__Printf, Stdlib_Format = global_data.Stdlib__Format, Base_Staged = global_data.Base__Staged, Base_Bytes0 = global_data.Base__Bytes0, Base_Blit = global_data.Base__Blit, Base_Comparator = global_data.Base__Comparator, Base_Pretty_printer = global_data.Base__Pretty_printer, stage = Base_Staged[1], globalize = Base_Import[288], t_of_sexp = Base_Import[161], sexp_of_t = Base_Import[137], t_sexp_grammar = Base_Import[183], max_length = Base_Bytes0[2], compare = Base_Bytes0[5], copy = Base_Bytes0[6], create = Base_Bytes0[7], set_uchar_utf_8 = Base_Bytes0[8], set_uchar_utf_16le = Base_Bytes0[9], set_uchar_utf_16be = Base_Bytes0[10], set_uchar_utf_32le = Base_Bytes0[12], set_uchar_utf_32be = Base_Bytes0[13], create_local = Base_Bytes0[14], fill = Base_Bytes0[15], make = Base_Bytes0[16], map = Base_Bytes0[17], mapi = Base_Bytes0[18], to_string = Base_Bytes0[20], of_string = Base_Bytes0[21], _a_ = [
        0,
        [
            3,
            0,
            0
        ],
        "%S"
    ];
    function pp(fmt, t) {
        var _w_ = caml_call1(to_string, t);
        return caml_call3(Stdlib_Format[139], fmt, _a_, _w_);
    }
    function create$0(len) {
        return caml_call1(create, len);
    }
    var To_bytes = caml_call1(Base_Blit[1], [
        0,
        caml_ml_bytes_length,
        create$0,
        runtime.caml_blit_bytes
    ]), blit = To_bytes[1], blito = To_bytes[2], unsafe_blit = To_bytes[3], sub = To_bytes[4], subo = To_bytes[5], comparator = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ])[1], include = caml_call1(Base_Pretty_printer[3], [
        0,
        pp,
        module_name
    ]), pp$0 = include[1], To_string = caml_call1(caml_call1(Base_Blit[3], [
        0
    ]), To_bytes);
    function create$1(len) {
        return caml_call1(create, len);
    }
    var length = caml_ml_bytes_length, unsafe_blit$0 = runtime.caml_blit_string, length$0 = caml_ml_string_length, From_string = caml_call1(caml_call1(Base_Blit[2], [
        0,
        length$0
    ]), [
        0,
        length,
        create$1,
        unsafe_blit$0
    ]), _b_ = [
        0,
        [
            11,
            "Bytes.init ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "Bytes.init %d"
    ], cst_tr_multi_replacement_is_th = "tr_multi: replacement is the empty string", _c_ = [
        0,
        "src/bytes.ml",
        130,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function invariant(param) {
        return 0;
    }
    function init(n, f) {
        if (n < 0) caml_call3(Base_Printf[7], _b_, n, 0);
        var t = caml_call1(create, n), _u_ = caml_call2(Base_Import[93], n, 1), _t_ = 0;
        if (_u_ >= 0) {
            var i = _t_;
            for(;;){
                caml_bytes_unsafe_set(t, i, caml_call1(f, i));
                var _v_ = i + 1 | 0;
                if (_u_ === i) break;
                i = _v_;
            }
        }
        return t;
    }
    function of_char_list(l) {
        var t = caml_call1(create, caml_call1(Base_List[45], l));
        caml_call2(Base_List[34], l, function(i, c) {
            return runtime.caml_bytes_set(t, i, c);
        });
        return t;
    }
    function to_list(t) {
        var i$1 = caml_call2(Base_Import[93], caml_ml_bytes_length(t), 1), i = i$1, acc = 0;
        for(;;){
            if (0 > i) return acc;
            var acc$0 = [
                0,
                caml_bytes_unsafe_get(t, i),
                acc
            ], i$0 = caml_call2(Base_Import[93], i, 1);
            i = i$0;
            acc = acc$0;
        }
    }
    function to_array(t) {
        return caml_call2(Base_Array0[12], caml_ml_bytes_length(t), function(i) {
            return caml_bytes_unsafe_get(t, i);
        });
    }
    function map$0(t, f) {
        return caml_call2(map, t, f);
    }
    function mapi$0(t, f) {
        return caml_call2(mapi, t, f);
    }
    function fold(t, init, f) {
        var len = caml_ml_bytes_length(t), pos = 0, acc = init;
        for(;;){
            if (pos === len) return acc;
            var acc$0 = caml_call2(f, acc, caml_bytes_unsafe_get(t, pos)), pos$0 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$0;
            acc = acc$0;
        }
    }
    function foldi(t, init, f) {
        var len = caml_ml_bytes_length(t), pos = 0, acc = init;
        for(;;){
            if (pos === len) return acc;
            var acc$0 = caml_call3(f, pos, acc, caml_bytes_unsafe_get(t, pos)), pos$0 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$0;
            acc = acc$0;
        }
    }
    function tr(target, replacement, s) {
        var _r_ = caml_call2(Base_Import[93], caml_ml_bytes_length(s), 1), _q_ = 0;
        if (_r_ >= 0) {
            var i = _q_;
            for(;;){
                if (caml_call2(Base_Char[16], caml_bytes_unsafe_get(s, i), target)) caml_bytes_unsafe_set(s, i, replacement);
                var _s_ = i + 1 | 0;
                if (_r_ === i) break;
                i = _s_;
            }
        }
        return 0;
    }
    function tr_multi(target, replacement) {
        if (0 === caml_ml_string_length(target)) return caml_call1(stage, function(_p_) {
            return 0;
        });
        if (0 === caml_ml_string_length(replacement)) return caml_call1(Base_Import[126], cst_tr_multi_replacement_is_th);
        var match = caml_call2(Base_Bytes_tr[1], target, replacement);
        if (!match) return caml_call1(stage, function(_o_) {
            return 0;
        });
        var tr_map = match[1];
        return caml_call1(stage, function(s) {
            var _m_ = caml_call2(Base_Import[93], caml_ml_bytes_length(s), 1), _l_ = 0;
            if (_m_ >= 0) {
                var i = _l_;
                for(;;){
                    caml_bytes_unsafe_set(s, i, runtime.caml_string_unsafe_get(tr_map, caml_call1(Base_Char[32], caml_bytes_unsafe_get(s, i))));
                    var _n_ = i + 1 | 0;
                    if (_m_ === i) break;
                    i = _n_;
                }
            }
            return 0;
        });
    }
    function between(t, low, high) {
        var _k_ = caml_call2(Base_Import[110][2], low, t);
        return _k_ ? caml_call2(Base_Import[110][2], t, high) : _k_;
    }
    function clamp_unchecked(t, min, max) {
        return caml_call2(Base_Import[110][1], t, min) ? min : caml_call2(Base_Import[110][2], t, max) ? t : max;
    }
    function clamp_exn(t, min, max) {
        if (caml_call2(Base_Import[110][2], min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _c_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_call2(Base_Import[110][5], min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _h_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _i_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _h_
        ], _j_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _i_);
        return caml_call1(Base_Or_error[39], _j_);
    }
    function contains(pos, len, t, char$0) {
        var match = caml_call4(Base_Ordered_collection_common[1], pos, len, 0, caml_ml_bytes_length(t)), len$0 = match[2], pos$0 = match[1], last = caml_call2(Base_Import[91], pos$0, len$0), i = pos$0;
        for(;;){
            var _d_ = i < last ? 1 : 0;
            if (_d_) {
                var _e_ = caml_bytes_get(t, i), _f_ = caml_call2(Base_Char[16], _e_, char$0);
                if (!_f_) {
                    var i$0 = caml_call2(Base_Import[91], i, 1);
                    i = i$0;
                    continue;
                }
                var _g_ = _f_;
            } else var _g_ = _d_;
            return _g_;
        }
    }
    var Utf8 = [
        0,
        set_uchar_utf_8
    ], Utf16le = [
        0,
        set_uchar_utf_16le
    ], Utf16be = [
        0,
        set_uchar_utf_16be
    ], Utf32le = [
        0,
        set_uchar_utf_32le
    ], Utf32be = [
        0,
        set_uchar_utf_32be
    ], include$0 = Base_Import[110], symbol = include$0[1], symbol$0 = include$0[2], symbol$1 = include$0[3], symbol$2 = include$0[4], symbol$3 = include$0[5], symbol$4 = include$0[6], ascending = include$0[7], descending = include$0[8], compare$0 = include$0[9], compare_local = include$0[10], equal = include$0[11], equal_local = include$0[12], max = include$0[13], min = include$0[14], Base_Bytes = [
        0,
        globalize,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        blit,
        blito,
        unsafe_blit,
        sub,
        subo,
        symbol$4,
        symbol$0,
        symbol$2,
        symbol$3,
        symbol,
        symbol$1,
        equal,
        compare$0,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        compare_local,
        equal_local,
        of_string,
        to_string,
        pp$0,
        invariant,
        To_string,
        From_string,
        create,
        create_local,
        make,
        map$0,
        mapi$0,
        copy,
        init,
        of_char_list,
        caml_bytes_get,
        fill,
        tr,
        tr_multi,
        to_list,
        to_array,
        fold,
        foldi,
        contains,
        max_length,
        Utf8,
        Utf16le,
        Utf16be,
        Utf32le,
        Utf32be
    ];
    runtime.caml_register_global(24, Base_Bytes, "Base__Bytes");
    return;
})(globalThis);
//# 23154 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), ocaml_lex_tables = [
        0,
        "\0\0\0\0\x01\0\x01\0\x02\0\x1b\0R\0i\0",
        "\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\x01\0",
        "\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff",
        "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x02\0\0\0\0\0\x01\0\x03\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\x06\0\x04\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x06\0\x04\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\0\0\0\0\0\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x07\0\0\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0",
        "\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\0\0\x02\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\xff\xff\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\xff\xff\xff\xff\x01\0\x03\0\xff\xff\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\x03\0\x05\0\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\xff\xff\xff\xff\xff\xff\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\xff\xff\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff",
        cst,
        cst,
        cst,
        cst,
        cst,
        cst
    ], Stdlib_Lexing = global_data.Stdlib__Lexing;
    function parse_hex(lexbuf) {
        var ocaml_lex_state = 0;
        for(;;){
            var ocaml_lex_state$0 = caml_call3(Stdlib_Lexing[20], ocaml_lex_tables, ocaml_lex_state, lexbuf);
            if (0 === ocaml_lex_state$0) {
                var body = caml_call3(Stdlib_Lexing[16], lexbuf, lexbuf[5] + 3 | 0, lexbuf[6]);
                return [
                    0,
                    body
                ];
            }
            if (1 === ocaml_lex_state$0) {
                var body$0 = caml_call3(Stdlib_Lexing[16], lexbuf, lexbuf[5] + 2 | 0, lexbuf[6]);
                return [
                    1,
                    body$0
                ];
            }
            caml_call1(lexbuf[1], lexbuf);
            ocaml_lex_state = ocaml_lex_state$0;
        }
    }
    var Base_Hex_lexer = [
        0,
        parse_hex
    ];
    runtime.caml_register_global(2, Base_Hex_lexer, "Base__Hex_lexer");
    return;
})(globalThis);
//# 23215 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_0b$1 = "0b", caml_bytes_set = runtime.caml_bytes_set, caml_string_get = runtime.caml_string_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Char = global_data.Base__Char, Base_String = global_data.Base__String, Base_Hex_lexer = global_data.Base__Hex_lexer, Stdlib_Lexing = global_data.Stdlib__Lexing, Base_Option = global_data.Base__Option, Base_Printf = global_data.Base__Printf, Base_Sexpable = global_data.Base__Sexpable, Base_Bytes = global_data.Base__Bytes, Base_Sexp = global_data.Base__Sexp;
    function insert_delimiter_every(input, delimiter, chars_per_delimiter) {
        var input_length = runtime.caml_ml_string_length(input);
        if (input_length <= chars_per_delimiter) return input;
        var match = caml_string_get(input, 0);
        a: {
            if (43 !== match && 45 !== match) {
                var has_sign = 0;
                break a;
            }
            var has_sign = 1;
        }
        var num_digits = has_sign ? caml_call2(Base_Import[93], input_length, 1) : input_length, _v_ = caml_call2(Base_Import[93], num_digits, 1), num_delimiters = caml_call2(Base_Import[95], _v_, chars_per_delimiter), output_length = caml_call2(Base_Import[91], input_length, num_delimiters), output = caml_call1(Base_Bytes[34], output_length), input_pos = [
            0,
            caml_call2(Base_Import[93], input_length, 1)
        ], output_pos = [
            0,
            caml_call2(Base_Import[93], output_length, 1)
        ], num_chars_until_delimiter = [
            0,
            chars_per_delimiter
        ], first_digit_pos = has_sign ? 1 : 0;
        for(;;){
            if (first_digit_pos > input_pos[1]) {
                if (has_sign) caml_bytes_set(output, 0, caml_string_get(input, 0));
                return runtime.caml_string_of_bytes(output);
            }
            if (0 === num_chars_until_delimiter[1]) {
                caml_bytes_set(output, output_pos[1], delimiter);
                output_pos[1]--;
                num_chars_until_delimiter[1] = chars_per_delimiter;
            }
            var _w_ = caml_string_get(input, input_pos[1]);
            caml_bytes_set(output, output_pos[1], _w_);
            input_pos[1]--;
            output_pos[1]--;
            num_chars_until_delimiter[1]--;
        }
    }
    function insert_delimiter(input, delimiter) {
        return insert_delimiter_every(input, delimiter, 3);
    }
    function insert_underscores(input) {
        return insert_delimiter(input, 95);
    }
    var sexp_of_int_style = Base_Sexp[20], cst_0x = "-0x", cst_0x$0 = "0x", _a_ = [
        0,
        [
            2,
            0,
            [
                11,
                ".of_string: invalid input ",
                [
                    3,
                    0,
                    0
                ]
            ]
        ],
        "%s.of_string: invalid input %S"
    ], cst_0 = "0", cst_0b = cst_0b$1, cst_0b$0 = cst_0b$1, Base_Int_string_conversions = [
        0,
        function(I) {
            var chars_per_delimiter = 3;
            function to_string_hum(opt, t) {
                var delimiter = opt ? opt[1] : 95;
                return insert_delimiter_every(caml_call1(I[1], t), delimiter, chars_per_delimiter);
            }
            function sexp_of_t(t) {
                var s = caml_call1(I[1], t), s$0 = 1009018843 <= sexp_of_int_style[1] ? s : insert_delimiter_every(s, 95, chars_per_delimiter);
                return [
                    0,
                    s$0
                ];
            }
            return [
                0,
                to_string_hum,
                sexp_of_t
            ];
        },
        function(I) {
            var compare_local = I[2];
            function compare(a, b) {
                return caml_call2(compare_local, a, b);
            }
            var hash_fold_t = I[3], func = I[4];
            function hash(x) {
                return caml_call1(func, x);
            }
            var chars_per_delimiter = 4;
            function to_string(delimiter, t) {
                if (delimiter) var delimiter$0 = delimiter[1], make_suffix = function(t) {
                    return insert_delimiter_every(caml_call1(I[5], t), delimiter$0, chars_per_delimiter);
                };
                else var make_suffix = I[5];
                if (caml_call2(I[8], t, I[7])) {
                    var _t_ = caml_call1(make_suffix, caml_call1(I[9], t));
                    return caml_call2(Base_Import[112], cst_0x, _t_);
                }
                var _u_ = caml_call1(make_suffix, t);
                return caml_call2(Base_Import[112], cst_0x$0, _u_);
            }
            function to_string$0(t) {
                return to_string(0, t);
            }
            function to_string_hum(opt, t) {
                var delimiter = opt ? opt[1] : 95;
                return to_string([
                    0,
                    delimiter
                ], t);
            }
            function invalid(str) {
                return caml_call4(Base_Printf[6], _a_, I[10], str, 0);
            }
            function of_string_with_delimiter(str) {
                var _s_ = caml_call2(Base_String[10], str, function(c) {
                    return caml_call2(Base_Char[15], c, 95);
                });
                return caml_call1(I[6], _s_);
            }
            function of_string(str) {
                var lex = caml_call2(Stdlib_Lexing[3], 0, str), result = caml_call1(Base_Option[47], function(param) {
                    return caml_call1(Base_Hex_lexer[1], lex);
                });
                if (lex[6] !== lex[3]) return invalid(str);
                if (!result) return invalid(str);
                var match = result[1];
                if (0 === match[0]) {
                    var body = match[1], _r_ = of_string_with_delimiter(body);
                    return caml_call1(I[9], _r_);
                }
                var body$0 = match[1];
                return of_string_with_delimiter(body$0);
            }
            var include = caml_call1(Base_Sexpable[5], [
                0,
                of_string,
                to_string$0
            ]), t_sexp_grammar = include[1], t_of_sexp = include[2], sexp_of_t = include[3];
            return [
                0,
                [
                    0,
                    t_of_sexp,
                    sexp_of_t,
                    t_sexp_grammar,
                    compare,
                    compare_local,
                    hash_fold_t,
                    hash,
                    of_string,
                    to_string$0,
                    to_string_hum
                ]
            ];
        },
        function(_b_) {
            var func = _b_[6], hash_fold_t = _b_[5], compare_local = _b_[2], _c_ = _b_[12], _d_ = _b_[13], _e_ = _b_[11], _f_ = _b_[10], _g_ = _b_[9], _h_ = _b_[8], _i_ = _b_[7], _j_ = _b_[4];
            function compare(a, b) {
                return caml_call2(compare_local, a, b);
            }
            function hash(x) {
                return caml_call1(func, x);
            }
            function to_string_suffix(t) {
                if (caml_call2(_j_, t, _d_)) var bits = 0;
                else var _m_ = caml_call1(_i_, t), bits = caml_call2(Base_Import[93], _e_, _m_);
                return 0 === bits ? cst_0 : caml_call2(Base_String[36], bits, function(char_index) {
                    var _n_ = caml_call2(Base_Import[93], bits, char_index), bit_index = caml_call2(Base_Import[93], _n_, 1), bit = caml_call2(_g_, caml_call2(_h_, t, bit_index), _c_), _o_ = caml_call1(_f_, bit), _p_ = caml_call1(Base_Char[32], 48), _q_ = caml_call2(Base_Import[91], _p_, _o_);
                    return caml_call1(Base_Char[35], _q_);
                });
            }
            function to_string(t) {
                var _l_ = to_string_suffix(t);
                return caml_call2(Base_Import[112], cst_0b, _l_);
            }
            function to_string_hum(opt, t) {
                var delimiter = opt ? opt[1] : 95, _k_ = insert_delimiter_every(to_string_suffix(t), delimiter, 4);
                return caml_call2(Base_Import[112], cst_0b$0, _k_);
            }
            function sexp_of_t(t) {
                return [
                    0,
                    to_string_hum(0, t)
                ];
            }
            return [
                0,
                [
                    0,
                    sexp_of_t,
                    compare,
                    compare_local,
                    hash_fold_t,
                    hash,
                    to_string,
                    to_string_hum
                ]
            ];
        },
        sexp_of_int_style,
        insert_delimiter_every,
        insert_delimiter,
        insert_underscores
    ];
    runtime.caml_register_global(16, Base_Int_string_conversions, "Base__Int_string_conversions");
    return;
})(globalThis);
//# 23469 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_int64_add = runtime.caml_int64_add, caml_int64_and = runtime.caml_int64_and, caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_shift_right_unsigne = runtime.caml_int64_shift_right_unsigned, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, global_data = runtime.caml_get_global_data(), m1 = runtime.caml_int64_create_lo_mi_hi(5592405, 5592405, 21845), m2 = runtime.caml_int64_create_lo_mi_hi(3355443, 3355443, 13107), m4 = runtime.caml_int64_create_lo_mi_hi(986895, 986895, 3855), h01 = runtime.caml_int64_create_lo_mi_hi(65793, 65793, 257), mask = runtime.caml_int64_create_lo_mi_hi(16777215, 255, 0), Stdlib_Nativeint = global_data.Stdlib__Nativeint, Assert_failure = global_data.Assert_failure;
    function int64_popcount(x$1) {
        var x$0 = runtime.caml_int64_sub(x$1, caml_int64_and(caml_int64_shift_right_unsigne(x$1, 1), m1)), x = caml_int64_add(caml_int64_and(x$0, m2), caml_int64_and(caml_int64_shift_right_unsigne(x$0, 2), m2)), x$2 = caml_int64_and(caml_int64_add(x, caml_int64_shift_right_unsigne(x, 4)), m4);
        return runtime.caml_int64_to_int32(caml_int64_shift_right_unsigne(runtime.caml_int64_mul(x$2, h01), 56));
    }
    function int32_popcount(x) {
        return int64_popcount(caml_int64_and(caml_int64_of_int32(x), mask));
    }
    var _a_ = Stdlib_Nativeint[9], _b_ = [
        0,
        "src/popcount.ml",
        45,
        9
    ];
    if (32 === _a_) var nativeint_popcount = function(x) {
        return int32_popcount(x);
    };
    else {
        if (64 !== _a_) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        var nativeint_popcount = function(x) {
            return int64_popcount(caml_int64_of_int32(x));
        };
    }
    var Base_Popcount = [
        0,
        function(_c_) {
            return runtime.Base_int_math_int_popcount(_c_);
        },
        int32_popcount,
        int64_popcount,
        nativeint_popcount
    ];
    runtime.caml_register_global(8, Base_Popcount, "Base__Popcount");
    return;
})(globalThis);
//# 23530 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Sign0 = global_data.Base__Sign0, Base_Identifiable = global_data.Base__Identifiable, t_sexp_grammar = Base_Sign0[3], compare_local = Base_Sign0[4], all = Base_Sign0[7], Replace_polymorphic_compare = Base_Sign0[8], to_int = Base_Sign0[11], of_int = Base_Sign0[14], _a_ = caml_call1(Base_Identifiable[1], [
        0,
        Base_Sign0[5],
        Base_Sign0[6],
        Base_Sign0[12],
        Base_Sign0[1],
        Base_Sign0[2],
        Base_Sign0[9],
        Base_Sign0[10],
        Base_Sign0[13]
    ]), hash_fold_t = _a_[1], hash = _a_[2], t_of_sexp = _a_[3], sexp_of_t = _a_[4], of_string = _a_[5], to_string = _a_[6], between = _a_[19], clamp_exn = _a_[20], clamp = _a_[21], comparator = _a_[22], pp = _a_[23], hashable = _a_[24], cst_negative = "negative", cst_zero = "zero", cst_positive = "positive";
    function to_string_hum(param) {
        switch(param){
            case 0:
                return cst_negative;
            case 1:
                return cst_zero;
            default:
                return cst_positive;
        }
    }
    function to_float(param) {
        switch(param){
            case 0:
                return -1;
            case 1:
                return 0.;
            default:
                return 1.;
        }
    }
    function flip(param) {
        switch(param){
            case 0:
                return 2;
            case 1:
                return 1;
            default:
                return 0;
        }
    }
    function symbol(t$0, t) {
        var _b_ = caml_call1(to_int, t), _c_ = caml_call1(to_int, t$0);
        return caml_call1(of_int, caml_call2(Base_Import[88], _c_, _b_));
    }
    var symbol$0 = Replace_polymorphic_compare[1], symbol$1 = Replace_polymorphic_compare[2], symbol$2 = Replace_polymorphic_compare[3], symbol$3 = Replace_polymorphic_compare[4], symbol$4 = Replace_polymorphic_compare[5], symbol$5 = Replace_polymorphic_compare[6], ascending = Replace_polymorphic_compare[7], descending = Replace_polymorphic_compare[8], compare = Replace_polymorphic_compare[9], equal = Replace_polymorphic_compare[10], equal_local = Replace_polymorphic_compare[11], max = Replace_polymorphic_compare[12], min = Replace_polymorphic_compare[13], Base_Sign = [
        0,
        all,
        t_sexp_grammar,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        of_string,
        to_string,
        symbol$5,
        symbol$1,
        symbol$3,
        symbol$4,
        symbol$0,
        symbol$2,
        equal,
        compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        compare_local,
        equal_local,
        to_string_hum,
        of_int,
        to_int,
        to_float,
        flip,
        symbol
    ];
    runtime.caml_register_global(9, Base_Sign, "Base__Sign");
    return;
})(globalThis);
//# 23660 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", cst_x = "%x", cst_argument_must_be_strictly_ = "argument must be strictly positive", caml_div = runtime.caml_div, caml_int_compare = runtime.caml_int_compare, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, module_name = "Base.Int.Hex", module_name$0 = "Base.Int", Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Stdlib_Scanf = global_data.Stdlib__Scanf, Base_Float0 = global_data.Base__Float0, Base_Int0 = global_data.Base__Int0, Base_Int_conversions = global_data.Base__Int_conversions, Base_Comparator = global_data.Base__Comparator, Base_Comparable = global_data.Base__Comparable, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Pretty_printer = global_data.Base__Pretty_printer, Base_Int_math = global_data.Base__Int_math, Base_Error = global_data.Base__Error, Base_Sign = global_data.Base__Sign, Base_Popcount = global_data.Base__Popcount, to_string = Base_Int0[1], of_string = Base_Int0[2], of_string_opt = Base_Int0[3], globalize = Base_Import[284], hash_fold_t = Base_Import[206], func = Base_Import[220];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[163], sexp_of_t = Base_Import[139], t_sexp_grammar = Base_Import[185], hashable = [
        0,
        hash,
        caml_int_compare,
        sexp_of_t
    ], compare = caml_int_compare, _a_ = [
        0,
        [
            11,
            "Int.of_string: ",
            [
                3,
                0,
                0
            ]
        ],
        "Int.of_string: %S"
    ];
    function of_string$0(s) {
        try {
            var _ar_ = caml_call1(of_string, s);
            return _ar_;
        } catch (_as_) {
            return caml_call3(Base_Printf[6], _a_, s, 0);
        }
    }
    var num_bits = Base_Int_conversions[30], float_lower_bound = caml_call1(Base_Float0[26], num_bits), float_upper_bound = caml_call1(Base_Float0[24], num_bits), _b_ = [
        0,
        [
            11,
            "Int.of_float: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Int.of_float: argument (%f) is out of range or NaN"
    ];
    function to_float(_aq_) {
        return _aq_;
    }
    function of_float_unchecked(_ap_) {
        return _ap_ | 0;
    }
    function of_float(f) {
        if (float_lower_bound <= f && f <= float_upper_bound) return f | 0;
        var _ao_ = caml_call1(Base_Float0[29], f);
        return caml_call3(Base_Printf[7], _b_, _ao_, 0);
    }
    var zero = 0, one = 1, comparator = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ])[1], _c_ = caml_call1(Base_Comparable[14], [
        0,
        compare,
        sexp_of_t,
        zero
    ]), is_positive = _c_[1], is_non_negative = _c_[2], is_negative = _c_[3], is_non_positive = _c_[4], include = caml_call1(Base_Int_string_conversions[1], [
        0,
        to_string
    ]), to_string_hum = include[1], sexp_of_t$0 = include[2], compare_local = Base_Import[256];
    function compare$0(a, b) {
        return caml_call2(compare_local, a, b);
    }
    var hash_fold_t$0 = Base_Import[206], func$0 = Base_Import[220];
    function hash$0(x) {
        return caml_call1(func$0, x);
    }
    var neg = Base_Import[113], _d_ = [
        0,
        [
            4,
            6,
            0,
            0,
            0
        ],
        cst_x
    ], _e_ = [
        0,
        [
            4,
            6,
            0,
            0,
            0
        ],
        cst_x
    ];
    function symbol(_an_, _am_) {
        return _an_ < _am_ ? 1 : 0;
    }
    function to_string$0(i) {
        return caml_call2(Base_Printf[2], _d_, i);
    }
    function of_string$1(s) {
        return caml_call3(Stdlib_Scanf[5], s, _e_, function(_al_) {
            return _al_;
        });
    }
    var include$0 = caml_call1(Base_Int_string_conversions[2], [
        0,
        compare$0,
        compare_local,
        hash_fold_t$0,
        hash$0,
        to_string$0,
        of_string$1,
        zero,
        symbol,
        neg,
        module_name
    ]), Hex = include$0[1], include$1 = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name$0,
        to_string
    ]), pp = include$1[1], _f_ = [
        0,
        "src/int.ml",
        111,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function invariant(param) {
        return 0;
    }
    function between(t, low, high) {
        var _aj_ = low <= t ? 1 : 0, _ak_ = _aj_ ? t <= high ? 1 : 0 : _aj_;
        return _ak_;
    }
    function clamp_unchecked(t, min, max) {
        var _ai_ = caml_call2(Base_Import[97][4], t, max);
        return caml_call1(caml_call1(Base_Import[97][3], min), _ai_);
    }
    function clamp_exn(t, min, max) {
        if (min <= max) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _f_
        ], 1);
    }
    function clamp(t, min, max) {
        if (max >= min) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _af_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _ag_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _af_
        ], _ah_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _ag_);
        return caml_call1(Base_Or_error[39], _ah_);
    }
    function pred(i) {
        return caml_call2(Base_Import[93], i, 1);
    }
    function succ(i) {
        return caml_call2(Base_Import[91], i, 1);
    }
    function to_int(i) {
        return i;
    }
    function of_int_exn(i) {
        return i;
    }
    var max_value = Base_Import[85][19], min_value = Base_Import[85][20], of_int32 = Base_Int_conversions[6], of_int32_exn = Base_Int_conversions[7], to_int32 = Base_Int_conversions[1], to_int32_exn = Base_Int_conversions[2], of_int64 = Base_Int_conversions[12], of_int64_exn = Base_Int_conversions[13], to_int64 = Base_Int_conversions[4], of_nativeint = Base_Int_conversions[23], of_nativeint_exn = Base_Int_conversions[24], to_nativeint = Base_Int_conversions[5];
    function abs(x) {
        return caml_call1(Base_Import[123], x);
    }
    function rem(a, b) {
        return caml_call2(Base_Import[122], a, b);
    }
    function incr(_ae_) {
        _ae_[1]++;
        return 0;
    }
    function decr(_ad_) {
        _ad_[1]--;
        return 0;
    }
    function shift_right(a, b) {
        return caml_call2(Base_Import[115], a, b);
    }
    function shift_right_logical(a, b) {
        return caml_call2(Base_Import[120], a, b);
    }
    function shift_left(a, b) {
        return caml_call2(Base_Import[119], a, b);
    }
    function bit_not(a) {
        return caml_call1(Base_Import[117], a);
    }
    function bit_or(a, b) {
        return caml_call2(Base_Import[118], a, b);
    }
    function bit_and(a, b) {
        return caml_call2(Base_Import[116], a, b);
    }
    function bit_xor(a, b) {
        return caml_call2(Base_Import[121], a, b);
    }
    var pow = Base_Int_math[2][1];
    function symbol$0(b, e) {
        return caml_call2(pow, b, e);
    }
    var raise_s = Base_Error[32], _g_ = [
        0,
        [
            11,
            cst_argument_must_be_strictly_,
            0
        ],
        cst_argument_must_be_strictly_
    ], cst_Int_floor_log2_got_invalid = "[Int.floor_log2] got invalid input", cst_Int_ceil_log2_got_invalid_ = "[Int.ceil_log2] got invalid input";
    function non_positive_argument(param) {
        return caml_call2(Base_Printf[7], _g_, 0);
    }
    function ceil_pow2(x) {
        if (x <= 0) non_positive_argument(0);
        var x$0 = caml_call2(Base_Import[93], x, 1), _Z_ = caml_call2(Base_Import[120], x$0, 1), x$1 = caml_call2(Base_Import[118], x$0, _Z_), ___ = caml_call2(Base_Import[120], x$1, 2), x$2 = caml_call2(Base_Import[118], x$1, ___), _$_ = caml_call2(Base_Import[120], x$2, 4), x$3 = caml_call2(Base_Import[118], x$2, _$_), _aa_ = caml_call2(Base_Import[120], x$3, 8), x$4 = caml_call2(Base_Import[118], x$3, _aa_), _ab_ = caml_call2(Base_Import[120], x$4, 16), x$5 = caml_call2(Base_Import[118], x$4, _ab_), _ac_ = caml_call2(Base_Import[120], x$5, 32), x$6 = caml_call2(Base_Import[118], x$5, _ac_);
        return caml_call2(Base_Import[91], x$6, 1);
    }
    function floor_pow2(x) {
        if (x <= 0) non_positive_argument(0);
        var _S_ = caml_call2(Base_Import[120], x, 1), x$0 = caml_call2(Base_Import[118], x, _S_), _T_1 = caml_call2(Base_Import[120], x$0, 2), x$1 = caml_call2(Base_Import[118], x$0, _T_1), _U_ = caml_call2(Base_Import[120], x$1, 4), x$2 = caml_call2(Base_Import[118], x$1, _U_), _V_ = caml_call2(Base_Import[120], x$2, 8), x$3 = caml_call2(Base_Import[118], x$2, _V_), _W_ = caml_call2(Base_Import[120], x$3, 16), x$4 = caml_call2(Base_Import[118], x$3, _W_), _X_ = caml_call2(Base_Import[120], x$4, 32), x$5 = caml_call2(Base_Import[118], x$4, _X_), _Y_ = caml_call2(Base_Import[120], x$5, 1);
        return caml_call2(Base_Import[93], x$5, _Y_);
    }
    function is_pow2(x) {
        if (x <= 0) non_positive_argument(0);
        var _R_ = caml_call2(Base_Import[93], x, 1);
        return 0 === caml_call2(Base_Import[116], x, _R_) ? 1 : 0;
    }
    function floor_log2(i) {
        if (i <= 0) {
            var _O_ = [
                0,
                [
                    0,
                    cst,
                    caml_call1(Base_Import[139], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int_floor_log2_got_invalid, _O_));
        }
        var _P_ = runtime.Base_int_math_int_clz(i), _Q_ = caml_call2(Base_Import[93], num_bits, 1);
        return caml_call2(Base_Import[93], _Q_, _P_);
    }
    function ceil_log2(i) {
        if (i <= 0) {
            var _M_ = [
                0,
                [
                    0,
                    cst$0,
                    caml_call1(Base_Import[139], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int_ceil_log2_got_invalid_, _M_));
        }
        if (1 === i) return 0;
        var _N_ = runtime.Base_int_math_int_clz(caml_call2(Base_Import[93], i, 1));
        return caml_call2(Base_Import[93], num_bits, _N_);
    }
    var sign = Base_Sign[30], popcount = Base_Popcount[1], compare_local$0 = Base_Import[256];
    function compare$1(a, b) {
        return caml_call2(compare_local$0, a, b);
    }
    var equal_local = Base_Import[270];
    function equal(a, b) {
        return caml_call2(equal_local, a, b);
    }
    var hash_fold_t$1 = Base_Import[206], func$1 = Base_Import[220];
    function hash$1(x) {
        return caml_call1(func$1, x);
    }
    var land = Base_Import[116], lsr = Base_Import[120];
    function clz(_L_) {
        return runtime.Base_int_math_int_clz(_L_);
    }
    var Binary = caml_call1(Base_Int_string_conversions[3], [
        0,
        compare$1,
        compare_local$0,
        equal,
        equal_local,
        hash_fold_t$1,
        hash$1,
        clz,
        lsr,
        land,
        to_int,
        num_bits,
        one,
        zero
    ])[1], F = caml_call1(Base_Int_math[1], [
        0,
        of_float,
        to_float,
        of_string$0,
        to_string,
        function(_K_, _J_) {
            return _K_ + _J_ | 0;
        },
        function(_I_, _H_) {
            return _I_ - _H_ | 0;
        },
        runtime.caml_mul,
        caml_div,
        function(_G_) {
            return -_G_ | 0;
        },
        function(_F_, _E_) {
            return _E_ <= _F_ ? 1 : 0;
        },
        function(_D_, _C_) {
            return _D_ <= _C_ ? 1 : 0;
        },
        function(_B_, _A_) {
            return _B_ === _A_ ? 1 : 0;
        },
        function(_z_, _y_) {
            return _y_ < _z_ ? 1 : 0;
        },
        function(_x_, _w_) {
            return _x_ < _w_ ? 1 : 0;
        },
        function(_v_, _u_) {
            return _v_ !== _u_ ? 1 : 0;
        },
        abs,
        function(_t_) {
            return -_t_ | 0;
        },
        zero,
        of_int_exn,
        rem
    ]), round = F[4], round_towards_zero = F[5], round_down = F[6], round_up = F[7], round_nearest = F[8], _h_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    12,
                    37,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " in core_int.ml: modulus should be positive",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s %% %s in core_int.ml: modulus should be positive"
    ], _i_ = [
        0,
        [
            2,
            0,
            [
                11,
                " /",
                [
                    12,
                    37,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " in core_int.ml: divisor should be positive",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s /%% %s in core_int.ml: divisor should be positive"
    ];
    function symbol$1(x, y) {
        if (y <= 0) {
            var _r_ = caml_call1(to_string, y), _s_ = caml_call1(to_string, x);
            caml_call4(Base_Printf[7], _h_, _s_, _r_, 0);
        }
        var rval = rem(x, y);
        return rval < 0 ? rval + y | 0 : rval;
    }
    function symbol$2(x, y) {
        if (y <= 0) {
            var _p_ = caml_call1(to_string, y), _q_ = caml_call1(to_string, x);
            caml_call4(Base_Printf[7], _i_, _q_, _p_, 0);
        }
        return x < 0 ? caml_div(x + 1 | 0, y) - 1 | 0 : caml_div(x, y);
    }
    function symbol$3(x, y) {
        return caml_call2(Base_Import[96], x, y);
    }
    var lnot = Base_Import[117], include$2 = Base_Import[97], ascending = include$2[1], descending = include$2[2], max = include$2[3], min = include$2[4], Base_Int = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$0,
        of_string$0,
        to_string,
        function(_o_, _n_) {
            return _o_ === _n_ ? 1 : 0;
        },
        caml_int_compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        caml_int_compare,
        function(_m_, _l_) {
            return _m_ === _l_ ? 1 : 0;
        },
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        one,
        -1,
        rem,
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        succ,
        pred,
        pow,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32_exn,
        to_int32_exn,
        of_int64_exn,
        to_int64,
        of_nativeint_exn,
        to_nativeint,
        of_float_unchecked,
        num_bits,
        max_value,
        min_value,
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        floor_log2,
        is_pow2,
        function(_k_) {
            return runtime.Base_int_math_int_clz(_k_);
        },
        function(_j_) {
            return runtime.Base_int_math_int_ctz(_j_);
        },
        [
            0,
            symbol$0,
            lnot,
            abs,
            zero,
            symbol$1,
            symbol$2,
            symbol$3
        ],
        symbol$0,
        lnot,
        abs,
        zero,
        symbol$1,
        symbol$2,
        symbol$3,
        1073741823,
        of_int_exn,
        to_int,
        of_int32,
        to_int32,
        of_int64,
        of_nativeint,
        to_nativeint,
        [
            0,
            [
                0,
                F[1],
                F[2],
                F[3]
            ]
        ]
    ];
    runtime.caml_register_global(34, Base_Int, "Base__Int");
    return;
})(globalThis);
//# 24132 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Base_Sys0 = global_data.Base__Sys0, backend_type = Base_Sys0[1], interactive = Base_Sys0[2], os_type = Base_Sys0[3], unix = Base_Sys0[4], win32 = Base_Sys0[5], cygwin = Base_Sys0[6], word_size_in_bits = Base_Sys0[7], int_size_in_bits = Base_Sys0[8], big_endian = Base_Sys0[9], max_string_length = Base_Sys0[10], max_array_length = Base_Sys0[11], runtime_variant = Base_Sys0[12], runtime_parameters = Base_Sys0[13], argv = Base_Sys0[14], get_argv = Base_Sys0[15], ocaml_version = Base_Sys0[16], enable_runtime_warnings = Base_Sys0[17], runtime_warnings_enabled = Base_Sys0[18], getenv_exn = Base_Sys0[20], getenv = Base_Sys0[21], Base_Sys = [
        0,
        get_argv,
        argv,
        interactive,
        os_type,
        unix,
        win32,
        cygwin,
        backend_type,
        word_size_in_bits,
        int_size_in_bits,
        big_endian,
        max_string_length,
        max_array_length,
        runtime_variant,
        runtime_parameters,
        ocaml_version,
        enable_runtime_warnings,
        runtime_warnings_enabled,
        getenv,
        getenv_exn
    ];
    runtime.caml_register_global(1, Base_Sys, "Base__Sys");
    return;
})(globalThis);
//# 24290 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_tag = runtime.caml_obj_tag;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Stdlib_Obj = global_data.Stdlib__Obj, Base_Array0 = global_data.Base__Array0, Base_Int0 = global_data.Base__Int0, Base_String0 = global_data.Base__String0, Assert_failure = global_data.Assert_failure, Base_Blit = global_data.Base__Blit, _a_ = [
        0,
        "src/obj_array.ml",
        12,
        2
    ], _b_ = [
        0,
        ">",
        0
    ], cst_Obj_array_t_of_length = "<Obj_array.t of length ", _c_ = [
        0,
        ""
    ];
    function invariant(t) {
        var _t_ = Stdlib_Obj[17];
        if (caml_obj_tag(t) !== _t_) return 0;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
    }
    function length(_s_) {
        return _s_.length - 1;
    }
    function sexp_of_t(t) {
        var _r_ = [
            0,
            cst_Obj_array_t_of_length,
            [
                0,
                caml_call1(Base_Int0[1], t.length - 1),
                _b_
            ]
        ];
        return [
            0,
            caml_call2(Base_String0[20], _c_, _r_)
        ];
    }
    var zero_obj = 0;
    function create_zero(len) {
        return caml_call2(Base_Array0[4], len, zero_obj);
    }
    var empty = [
        0
    ];
    function get(t, i) {
        return caml_check_bound(t, i)[1 + i];
    }
    function unsafe_get(t, i) {
        return t[1 + i];
    }
    function unsafe_set_with_caml_modify(t, i, obj) {
        t[1 + i] = obj;
        return 0;
    }
    function set_with_caml_modify(t, i, obj) {
        caml_check_bound(t, i)[1 + i] = obj;
        return 0;
    }
    function unsafe_set_int_assuming_curren(t, i, int$0) {
        t[1 + i] = int$0;
        return 0;
    }
    function set(t, i, obj) {
        var old_obj = get(t, i);
        if (typeof old_obj === "number" && typeof obj === "number") return unsafe_set_int_assuming_curren(t, i, obj);
        var _q_ = 1 - (old_obj === obj ? 1 : 0);
        return _q_ ? unsafe_set_with_caml_modify(t, i, obj) : _q_;
    }
    function unsafe_set(t, i, obj) {
        var old_obj = t[1 + i];
        if (typeof old_obj === "number" && typeof obj === "number") return unsafe_set_int_assuming_curren(t, i, obj);
        var _p_ = 1 - (old_obj === obj ? 1 : 0);
        return _p_ ? unsafe_set_with_caml_modify(t, i, obj) : _p_;
    }
    function unsafe_set_omit_phys_equal_che(t, i, obj) {
        var old_obj = t[1 + i];
        if (typeof old_obj === "number" && typeof obj === "number") return unsafe_set_int_assuming_curren(t, i, obj);
        return unsafe_set_with_caml_modify(t, i, obj);
    }
    function swap(t, i, j) {
        var a = get(t, i), b = get(t, j);
        unsafe_set(t, i, b);
        return unsafe_set(t, j, a);
    }
    function create(len, x) {
        if (typeof x !== "number") {
            var _l_ = Stdlib_Obj[16];
            if (caml_obj_tag(x) === _l_) {
                var t = create_zero(len), _n_ = caml_call2(Base_Import[93], len, 1), _m_ = 0;
                if (_n_ >= 0) {
                    var i = _m_;
                    for(;;){
                        unsafe_set_with_caml_modify(t, i, x);
                        var _o_ = i + 1 | 0;
                        if (_n_ === i) break;
                        i = _o_;
                    }
                }
                return t;
            }
        }
        return caml_call2(Base_Array0[4], len, x);
    }
    function singleton(obj) {
        return create(1, obj);
    }
    function unsafe_set_assuming_currently_(t, i, obj) {
        return typeof obj === "number" ? unsafe_set_int_assuming_curren(t, i, obj) : unsafe_set_with_caml_modify(t, i, obj);
    }
    function unsafe_set_int(t, i, int$0) {
        var old_obj = t[1 + i];
        return typeof old_obj === "number" ? unsafe_set_int_assuming_curren(t, i, int$0) : unsafe_set_with_caml_modify(t, i, int$0);
    }
    function unsafe_clear_if_pointer(t, i) {
        var old_obj = t[1 + i], _k_ = 1 - (typeof old_obj === "number" ? 1 : 0);
        return _k_ ? unsafe_set_with_caml_modify(t, i, 0) : _k_;
    }
    function unsafe_blit(src, src_pos, dst, dst_pos, len) {
        if (dst_pos < src_pos) {
            var _e_ = caml_call2(Base_Import[93], len, 1), _d_ = 0;
            if (_e_ >= 0) {
                var i = _d_;
                for(;;){
                    var i$0 = caml_call2(Base_Import[91], src_pos, i), _i_ = src[1 + i$0];
                    unsafe_set(dst, caml_call2(Base_Import[91], dst_pos, i), _i_);
                    var _f_ = i + 1 | 0;
                    if (_e_ === i) break;
                    i = _f_;
                }
            }
            return 0;
        }
        var _g_ = caml_call2(Base_Import[93], len, 1);
        if (_g_ >= 0) {
            var i$1 = _g_;
            for(;;){
                var i$2 = caml_call2(Base_Import[91], src_pos, i$1), _j_ = src[1 + i$2];
                unsafe_set(dst, caml_call2(Base_Import[91], dst_pos, i$1), _j_);
                var _h_ = i$1 - 1 | 0;
                if (0 === i$1) break;
                i$1 = _h_;
            }
        }
        return 0;
    }
    var include = caml_call1(Base_Blit[1], [
        0,
        length,
        create_zero,
        unsafe_blit
    ]), blit = include[1], blito = include[2], unsafe_blit$0 = include[3], subo = include[5];
    function copy(src) {
        var dst = create_zero(src.length - 1);
        caml_call6(blito, src, 0, 0, dst, 0, 0);
        return dst;
    }
    var sub = Base_Array0[15], Base_Obj_array = [
        0,
        sexp_of_t,
        blit,
        blito,
        unsafe_blit$0,
        subo,
        invariant,
        create,
        create_zero,
        copy,
        singleton,
        empty,
        length,
        get,
        unsafe_get,
        set,
        unsafe_set,
        swap,
        set_with_caml_modify,
        unsafe_set_assuming_currently_,
        unsafe_set_int_assuming_curren,
        unsafe_set_int,
        unsafe_set_omit_phys_equal_che,
        unsafe_set_with_caml_modify,
        unsafe_clear_if_pointer,
        sub
    ];
    runtime.caml_register_global(12, Base_Obj_array, "Base__Obj_array");
    return;
})(globalThis);
//# 24492 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_uniform_array_ml = "src/uniform_array.ml", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Container = global_data.Base__Container, Assert_failure = global_data.Assert_failure, Base_Array = global_data.Base__Array, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Base_Option = global_data.Base__Option, Base_List = global_data.Base__List, Base_Int = global_data.Base__Int, Stdlib_Obj = global_data.Stdlib__Obj, Base_Obj_array = global_data.Base__Obj_array, Base_Sexpable = global_data.Base__Sexpable, Base_Blit = global_data.Base__Blit, Base_Binary_searchable = global_data.Base__Binary_searchable, empty = Base_Obj_array[11];
    function unsafe_create_uninitialized(len) {
        return caml_call1(Base_Obj_array[8], len);
    }
    function create_obj_array(len) {
        return caml_call1(Base_Obj_array[8], len);
    }
    function create(len, x) {
        return caml_call2(Base_Obj_array[7], len, x);
    }
    function singleton(x) {
        return caml_call1(Base_Obj_array[10], x);
    }
    function swap(t, i, j) {
        return caml_call3(Base_Obj_array[17], t, i, j);
    }
    function get(arr, i) {
        return caml_call2(Base_Obj_array[13], arr, i);
    }
    function set(arr, i, x) {
        return caml_call3(Base_Obj_array[15], arr, i, x);
    }
    function unsafe_get_local(arr, i) {
        return caml_call2(Base_Obj_array[14], arr, i);
    }
    function unsafe_get(arr, i) {
        return unsafe_get_local(arr, i);
    }
    function unsafe_set(arr, i, x) {
        return caml_call3(Base_Obj_array[16], arr, i, x);
    }
    function unsafe_set_int(arr, i, x) {
        return caml_call3(Base_Obj_array[21], arr, i, x);
    }
    function unsafe_set_int_assuming_curren(arr, i, x) {
        return caml_call3(Base_Obj_array[20], arr, i, x);
    }
    function unsafe_set_assuming_currently_(arr, i, x) {
        return caml_call3(Base_Obj_array[19], arr, i, x);
    }
    function unsafe_to_array_inplace_promis(arr) {
        return arr;
    }
    var length = Base_Obj_array[12], unsafe_blit = Base_Obj_array[4], copy = Base_Obj_array[9];
    function unsafe_set_omit_phys_equal_che(t, i, x) {
        return caml_call3(Base_Obj_array[22], t, i, x);
    }
    function unsafe_set_with_caml_modify(t, i, x) {
        return caml_call3(Base_Obj_array[23], t, i, x);
    }
    function set_with_caml_modify(t, i, x) {
        return caml_call3(Base_Obj_array[18], t, i, x);
    }
    var unsafe_clear_if_pointer = Base_Obj_array[24], sub = Base_Obj_array[25], _a_ = [
        0,
        cst_src_uniform_array_ml,
        80,
        2
    ], cst_Uniform_array_init = "Uniform_array.init", cst_Array_fold2_exn = "Array.fold2_exn", cst_Array_map2_exn = "Array.map2_exn";
    function invariant(t) {
        var _ah_ = Stdlib_Obj[17];
        if (runtime.caml_obj_tag(t) !== _ah_) return 0;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
    }
    function init(l, f) {
        if (0 > l) return caml_call1(Base_Import[126], cst_Uniform_array_init);
        var res = unsafe_create_uninitialized(l), _af_ = caml_call2(Base_Import[93], l, 1), _ae_ = 0;
        if (_af_ >= 0) {
            var i = _ae_;
            for(;;){
                unsafe_set(res, i, caml_call1(f, i));
                var _ag_ = i + 1 | 0;
                if (_af_ === i) break;
                i = _ag_;
            }
        }
        return res;
    }
    function of_array(arr) {
        return init(arr.length - 1, function(_ad_) {
            return arr[1 + _ad_];
        });
    }
    function map(arr, f) {
        return init(caml_call1(length, arr), function(i) {
            return caml_call1(f, unsafe_get_local(arr, i));
        });
    }
    function mapi(arr, f) {
        return init(caml_call1(length, arr), function(i) {
            return caml_call2(f, i, unsafe_get_local(arr, i));
        });
    }
    function iter(arr, f) {
        var _aa_ = caml_call1(length, arr), _ab_ = caml_call2(Base_Import[93], _aa_, 1), _$_ = 0;
        if (_ab_ >= 0) {
            var i = _$_;
            for(;;){
                caml_call1(f, unsafe_get_local(arr, i));
                var _ac_ = i + 1 | 0;
                if (_ab_ === i) break;
                i = _ac_;
            }
        }
        return 0;
    }
    function iteri(arr, f) {
        var _Y_ = caml_call1(length, arr), _Z_ = caml_call2(Base_Import[93], _Y_, 1), _X_ = 0;
        if (_Z_ >= 0) {
            var i = _X_;
            for(;;){
                caml_call2(f, i, unsafe_get_local(arr, i));
                var ___ = i + 1 | 0;
                if (_Z_ === i) break;
                i = ___;
            }
        }
        return 0;
    }
    function foldi(arr, init, f) {
        var acc = [
            0,
            init
        ], _T_1 = caml_call1(length, arr), _U_ = caml_call2(Base_Import[93], _T_1, 1), _S_ = 0;
        if (_U_ >= 0) {
            var i = _S_;
            for(;;){
                var _W_ = unsafe_get_local(arr, i);
                acc[1] = caml_call3(f, i, acc[1], _W_);
                var _V_ = i + 1 | 0;
                if (_U_ === i) break;
                i = _V_;
            }
        }
        return acc[1];
    }
    function fold(arr, init, f) {
        var r = [
            0,
            init
        ], _O_ = caml_call1(length, arr), _P_ = caml_call2(Base_Import[93], _O_, 1), _N_ = 0;
        if (_P_ >= 0) {
            var i = _N_;
            for(;;){
                var _R_ = unsafe_get_local(arr, i);
                r[1] = caml_call2(f, r[1], _R_);
                var _Q_ = i + 1 | 0;
                if (_P_ === i) break;
                i = _Q_;
            }
        }
        return r[1];
    }
    function to_list(t) {
        var _L_ = caml_call1(length, t);
        return caml_call2(Base_List[40], _L_, function(_M_) {
            return get(t, _M_);
        });
    }
    function of_list(l) {
        var len = caml_call1(Base_List[45], l), res = unsafe_create_uninitialized(len);
        caml_call2(Base_List[34], l, function(i, x) {
            return set(res, i, x);
        });
        return res;
    }
    function of_list_rev(l) {
        var len = caml_call1(Base_List[45], l), res = unsafe_create_uninitialized(len);
        caml_call2(Base_List[34], l, function(i, x) {
            var _K_ = caml_call2(Base_Import[93], len, i);
            return set(res, caml_call2(Base_Import[93], _K_, 1), x);
        });
        return res;
    }
    function to_array(arr) {
        var _J_ = caml_call1(length, arr);
        return caml_call2(Base_Array[41], _J_, function(i) {
            return unsafe_get_local(arr, i);
        });
    }
    function exists(arr, f) {
        var _I_ = caml_call1(length, arr), i = [
            0,
            caml_call2(Base_Import[93], _I_, 1)
        ], result = [
            0,
            0
        ];
        for(;;){
            if (0 <= i[1] && !result[1]) {
                var i$0 = i[1];
                if (caml_call1(f, unsafe_get_local(arr, i$0))) {
                    result[1] = 1;
                    continue;
                }
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function existsi(arr, f) {
        var _G_ = caml_call1(length, arr), i = [
            0,
            caml_call2(Base_Import[93], _G_, 1)
        ], result = [
            0,
            0
        ];
        for(;;){
            if (0 <= i[1] && !result[1]) {
                var i$0 = i[1], _H_ = unsafe_get_local(arr, i$0);
                if (caml_call2(f, i[1], _H_)) {
                    result[1] = 1;
                    continue;
                }
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function for_all(arr, f) {
        var _F_ = caml_call1(length, arr), i = [
            0,
            caml_call2(Base_Import[93], _F_, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 <= i[1] && result[1]) {
                var i$0 = i[1];
                if (caml_call1(f, unsafe_get_local(arr, i$0))) {
                    i[1]--;
                    continue;
                }
                result[1] = 0;
                continue;
            }
            return result[1];
        }
    }
    function for_alli(arr, f) {
        var length$0 = caml_call1(length, arr), i = [
            0,
            caml_call2(Base_Import[93], length$0, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 <= i[1] && result[1]) {
                var i$0 = i[1], _E_ = unsafe_get_local(arr, i$0);
                if (caml_call2(f, i[1], _E_)) {
                    i[1]--;
                    continue;
                }
                result[1] = 0;
                continue;
            }
            return result[1];
        }
    }
    function filter_mapi(arr, f) {
        var r = [
            0,
            empty
        ], k = [
            0,
            0
        ], _A_ = caml_call1(length, arr), _B_ = caml_call2(Base_Import[93], _A_, 1), _z_ = 0;
        if (_B_ >= 0) {
            var i = _z_;
            for(;;){
                var match = caml_call2(f, i, unsafe_get_local(arr, i));
                if (match) {
                    var a = match[1];
                    if (0 === k[1]) r[1] = create(caml_call1(length, arr), a);
                    unsafe_set(r[1], k[1], a);
                    k[1]++;
                }
                var _D_ = i + 1 | 0;
                if (_B_ === i) break;
                i = _D_;
            }
        }
        var _C_ = caml_call1(length, arr);
        return k[1] === _C_ ? r[1] : 0 < k[1] ? caml_call3(sub, r[1], 0, k[1]) : empty;
    }
    function filteri(t, f) {
        return filter_mapi(t, function(i, x) {
            return caml_call2(f, i, x) ? [
                0,
                x
            ] : 0;
        });
    }
    function filter_map(t, f) {
        return filter_mapi(t, function(i, a) {
            return caml_call1(f, a);
        });
    }
    function filter(t, f) {
        return filter_map(t, function(x) {
            return caml_call1(f, x) ? [
                0,
                x
            ] : 0;
        });
    }
    function fold2_exn(arr$0, arr, init, f) {
        var len = caml_call1(length, arr$0);
        if (caml_call1(length, arr) !== len) caml_call1(Base_Import[126], cst_Array_fold2_exn);
        var acc = [
            0,
            init
        ], _v_ = caml_call2(Base_Import[93], len, 1), _u_ = 0;
        if (_v_ >= 0) {
            var i = _u_;
            for(;;){
                var _y_ = unsafe_get_local(arr, i), _x_ = unsafe_get_local(arr$0, i);
                acc[1] = caml_call3(f, acc[1], _x_, _y_);
                var _w_ = i + 1 | 0;
                if (_v_ === i) break;
                i = _w_;
            }
        }
        return acc[1];
    }
    function map2_exn(arr$0, arr, f) {
        var len = caml_call1(length, arr$0);
        if (caml_call1(length, arr) !== len) caml_call1(Base_Import[126], cst_Array_map2_exn);
        return init(len, function(i) {
            var _t_ = unsafe_get_local(arr, i);
            return caml_call2(f, unsafe_get_local(arr$0, i), _t_);
        });
    }
    function concat(ts) {
        var total_len = caml_call3(Base_List[26], [
            0,
            Base_Int[79],
            function(_s_, _r_) {
                return _s_ + _r_ | 0;
            }
        ], ts, function(t) {
            return caml_call1(length, t);
        }), res = unsafe_create_uninitialized(total_len);
        caml_call3(Base_List[20], ts, 0, function(so_far, t) {
            var len = caml_call1(length, t), _o_ = caml_call2(Base_Import[93], len, 1), _n_ = 0;
            if (_o_ >= 0) {
                var i = _n_;
                for(;;){
                    var _p_ = get(t, i);
                    set(res, caml_call2(Base_Import[91], so_far, i), _p_);
                    var _q_ = i + 1 | 0;
                    if (_o_ === i) break;
                    i = _q_;
                }
            }
            return caml_call2(Base_Import[91], so_far, len);
        });
        return res;
    }
    function concat_mapi(t, f) {
        var _m_ = to_list(t);
        return concat(caml_call2(Base_List[41], _m_, f));
    }
    function concat_map(t, f) {
        var _l_ = to_list(t);
        return concat(caml_call2(Base_List[53], _l_, f));
    }
    function partition_map(arr, f) {
        var right = [
            0,
            empty
        ], left = [
            0,
            empty
        ], right_idx = [
            0,
            0
        ], left_idx = [
            0,
            0
        ];
        function append(data, idx, value) {
            if (0 === idx[1]) data[1] = create(caml_call1(length, arr), value);
            unsafe_set(data[1], idx[1], value);
            idx[1]++;
            return;
        }
        var _g_ = caml_call1(length, arr), _h_ = caml_call2(Base_Import[93], _g_, 1), _f_ = 0;
        if (_h_ >= 0) {
            var i = _f_;
            for(;;){
                var match = caml_call1(f, unsafe_get_local(arr, i));
                if (0 === match[0]) {
                    var a = match[1];
                    append(left, left_idx, a);
                } else {
                    var a$0 = match[1];
                    append(right, right_idx, a$0);
                }
                var _j_ = i + 1 | 0;
                if (_h_ === i) break;
                i = _j_;
            }
        }
        function trim(data, idx) {
            var _k_ = caml_call1(length, arr);
            return idx[1] === _k_ ? data[1] : 0 < idx[1] ? caml_call3(sub, data[1], 0, idx[1]) : empty;
        }
        var _i_ = trim(right, right_idx);
        return [
            0,
            trim(left, left_idx),
            _i_
        ];
    }
    function find_map(arr, f) {
        var length$0 = caml_call1(length, arr);
        if (0 === length$0) return 0;
        var i = [
            0,
            0
        ], value_found = [
            0,
            0
        ];
        for(;;){
            if (caml_call1(Base_Option[52], value_found[1]) && i[1] < length$0) {
                var i$0 = i[1], value = unsafe_get_local(arr, i$0);
                value_found[1] = caml_call1(f, value);
                i[1]++;
                continue;
            }
            return value_found[1];
        }
    }
    function find_mapi(arr, f) {
        var length$0 = caml_call1(length, arr);
        if (0 === length$0) return 0;
        var i = [
            0,
            0
        ], value_found = [
            0,
            0
        ];
        for(;;){
            if (caml_call1(Base_Option[52], value_found[1]) && i[1] < length$0) {
                var i$0 = i[1], value = unsafe_get_local(arr, i$0);
                value_found[1] = caml_call2(f, i[1], value);
                i[1]++;
                continue;
            }
            return value_found[1];
        }
    }
    function find(arr, f) {
        var length$0 = caml_call1(length, arr);
        function _d_(param) {
            var x = param[2];
            return x;
        }
        if (0 === length$0) var _e_ = 0;
        else {
            var i = [
                0,
                0
            ], found = [
                0,
                0
            ], value_found = [
                0,
                unsafe_get_local(arr, 0)
            ];
            for(;;){
                if (!found[1] && i[1] < length$0) {
                    var i$0 = i[1], value = unsafe_get_local(arr, i$0);
                    if (caml_call1(f, value)) {
                        value_found[1] = value;
                        found[1] = 1;
                    } else i[1]++;
                    continue;
                }
                if (found[1]) {
                    var _e_ = [
                        0,
                        [
                            0,
                            i[1],
                            value_found[1]
                        ]
                    ];
                    break;
                }
                var _e_ = 0;
                break;
            }
        }
        return caml_call2(Base_Option[24], _e_, _d_);
    }
    function findi(arr, f) {
        var len = caml_call1(length, arr), i = 0;
        for(;;){
            if (len <= i) return 0;
            var x = unsafe_get_local(arr, i);
            if (caml_call2(f, i, x)) return [
                0,
                [
                    0,
                    i,
                    x
                ]
            ];
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
        }
    }
    function t_sexp_grammar(grammar) {
        var _c_ = caml_call1(Base_Array[6], grammar);
        return caml_call1(Sexplib0_Sexp_grammar[1], _c_);
    }
    var include = caml_call1(caml_call1(Base_Sexpable[2], [
        0,
        Base_Array[4],
        Base_Array[5]
    ]), [
        0,
        to_array,
        of_array
    ]), t_of_sexp = include[1], sexp_of_t = include[2], _b_ = [
        0,
        cst_src_uniform_array_ml,
        347,
        6
    ];
    function create_like(len, t) {
        if (0 === len) return empty;
        if (0 < caml_call1(length, t)) return create(len, get(t, 0));
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
    }
    var include$0 = caml_call1(Base_Blit[4], [
        0,
        create_like,
        length,
        unsafe_blit
    ]), blit = include$0[1], blito = include$0[2], unsafe_blit$0 = include$0[3], sub$0 = include$0[4], subo = include$0[5];
    function min_elt(t, compare) {
        return caml_call3(Base_Container[3], fold, t, compare);
    }
    function max_elt(t, compare) {
        return caml_call3(Base_Container[4], fold, t, compare);
    }
    function compare_local(compare_elt, a, b) {
        if (a === b) return 0;
        var len_a = caml_call1(length, a), len_b = caml_call1(length, b), ret = runtime.caml_int_compare(len_a, len_b);
        if (0 !== ret) return ret;
        var i = 0;
        for(;;){
            if (i === len_a) return 0;
            var l = unsafe_get_local(a, i), r = unsafe_get_local(b, i), res = caml_call2(compare_elt, l, r);
            if (0 !== res) return res;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
        }
    }
    function compare(compare_elt, a, b) {
        return compare_local(compare_elt, a, b);
    }
    var Sort = caml_call1(Base_Array[109][2], [
        0,
        unsafe_get,
        unsafe_set,
        length
    ]), sort = Sort[1], include$1 = caml_call1(Base_Binary_searchable[2], [
        0,
        unsafe_get,
        length
    ]), binary_search = include$1[1], binary_search_segmented = include$1[2], Base_Uniform_array = [
        0,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        compare,
        compare_local,
        invariant,
        empty,
        create,
        singleton,
        init,
        length,
        get,
        unsafe_get,
        unsafe_get_local,
        set,
        unsafe_set,
        swap,
        unsafe_set_omit_phys_equal_che,
        unsafe_set_with_caml_modify,
        set_with_caml_modify,
        map,
        mapi,
        iter,
        iteri,
        fold,
        foldi,
        unsafe_to_array_inplace_promis,
        of_array,
        to_array,
        of_list,
        of_list_rev,
        to_list,
        blit,
        blito,
        unsafe_blit$0,
        sub$0,
        subo,
        copy,
        exists,
        existsi,
        for_all,
        for_alli,
        concat,
        concat_map,
        concat_mapi,
        partition_map,
        filter,
        filteri,
        filter_map,
        filter_mapi,
        find,
        findi,
        find_map,
        find_mapi,
        map2_exn,
        fold2_exn,
        min_elt,
        max_elt,
        sort,
        binary_search,
        binary_search_segmented,
        unsafe_create_uninitialized,
        create_obj_array,
        unsafe_set_assuming_currently_,
        unsafe_set_int_assuming_curren,
        unsafe_set_int,
        unsafe_clear_if_pointer
    ];
    runtime.caml_register_global(18, Base_Uniform_array, "Base__Uniform_array");
    return;
})(globalThis);
//# 25813 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Array = global_data.Base__Array, Base_Import = global_data.Base__Import, Base_Uniform_array = global_data.Base__Uniform_array, Base_Option = global_data.Base__Option, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Stdlib_Obj = global_data.Stdlib__Obj, Base_Sexpable = global_data.Base__Sexpable, Base_Indexed_container = global_data.Base__Indexed_container, Base_Blit = global_data.Base__Blit, none_substitute = runtime.caml_obj_block(Stdlib_Obj[14], 1), none = 24791911, cst_Option_array_get_some_exn_ = "Option_array.get_some_exn: the element is [None]";
    function is_none(x) {
        return x === 24791911 ? 1 : 0;
    }
    function is_some(x) {
        return 1 - (x === 24791911 ? 1 : 0);
    }
    function some(x) {
        return x === 24791911 ? none_substitute : x;
    }
    function value_unsafe(x) {
        return x === none_substitute ? none : x;
    }
    function value_exn(x) {
        return is_some(x) ? value_unsafe(x) : caml_call1(Base_Import[124], cst_Option_array_get_some_exn_);
    }
    function of_sexpable(param) {
        if (!param) return none;
        var x = param[1];
        return some(x);
    }
    function to_sexpable(x) {
        return is_some(x) ? [
            0,
            value_unsafe(x)
        ] : 0;
    }
    var include = caml_call1(caml_call1(Base_Sexpable[2], [
        0,
        Base_Option[9],
        Base_Option[10]
    ]), [
        0,
        to_sexpable,
        of_sexpable
    ]), t_of_sexp = include[1], sexp_of_t = include[2];
    function t_of_sexp$0(of_a_001, x_003) {
        var _w_ = caml_call1(t_of_sexp, of_a_001);
        return caml_call2(Base_Uniform_array[1], _w_, x_003);
    }
    function sexp_of_t$0(of_a_004, x_005) {
        var _v_ = caml_call1(sexp_of_t, of_a_004);
        return caml_call2(Base_Uniform_array[2], _v_, x_005);
    }
    function t_sexp_grammar(a_sexp_grammar) {
        var _t_ = caml_call1(Base_Option[5], a_sexp_grammar), _u_ = caml_call1(Sexplib0_Sexp_grammar[1], _t_);
        return caml_call1(Base_Uniform_array[3], _u_);
    }
    var empty = Base_Uniform_array[7];
    function create(len) {
        return caml_call2(Base_Uniform_array[8], len, none);
    }
    function init(n, f) {
        return caml_call2(Base_Uniform_array[10], n, function(i) {
            return of_sexpable(caml_call1(f, i));
        });
    }
    function init_some(n, f) {
        return caml_call2(Base_Uniform_array[10], n, function(i) {
            return some(caml_call1(f, i));
        });
    }
    var _a_ = Base_Uniform_array[11];
    function get(t, i) {
        return to_sexpable(caml_call2(Base_Uniform_array[12], t, i));
    }
    function get_local(t, i) {
        var x = caml_call2(Base_Uniform_array[12], t, i);
        return is_some(x) ? [
            0,
            value_unsafe(x)
        ] : 0;
    }
    function get_some_exn(t, i) {
        return value_exn(caml_call2(Base_Uniform_array[12], t, i));
    }
    function is_none$0(t, i) {
        var x = caml_call2(Base_Uniform_array[12], t, i);
        return x === 24791911 ? 1 : 0;
    }
    function is_some$0(t, i) {
        return is_some(caml_call2(Base_Uniform_array[12], t, i));
    }
    function set(t, i, x) {
        var _s_ = of_sexpable(x);
        return caml_call3(Base_Uniform_array[15], t, i, _s_);
    }
    function set_some(t, i, x) {
        var _r_ = some(x);
        return caml_call3(Base_Uniform_array[15], t, i, _r_);
    }
    function set_none(t, i) {
        return caml_call3(Base_Uniform_array[15], t, i, none);
    }
    function swap(t, i, j) {
        return caml_call3(Base_Uniform_array[17], t, i, j);
    }
    function unsafe_get(t, i) {
        return to_sexpable(caml_call2(Base_Uniform_array[13], t, i));
    }
    function unsafe_get_some_exn(t, i) {
        return value_exn(caml_call2(Base_Uniform_array[13], t, i));
    }
    function unsafe_get_some_assuming_some(t, i) {
        return value_unsafe(caml_call2(Base_Uniform_array[13], t, i));
    }
    function unsafe_is_some(t, i) {
        return is_some(caml_call2(Base_Uniform_array[13], t, i));
    }
    function unsafe_set(t, i, x) {
        var _q_ = of_sexpable(x);
        return caml_call3(Base_Uniform_array[16], t, i, _q_);
    }
    function unsafe_set_some(t, i, x) {
        var _p_ = some(x);
        return caml_call3(Base_Uniform_array[16], t, i, _p_);
    }
    function unsafe_set_none(t, i) {
        return caml_call3(Base_Uniform_array[16], t, i, none);
    }
    function clear(t) {
        var _m_ = caml_call1(_a_, t), _n_ = caml_call2(Base_Import[93], _m_, 1), _l_ = 0;
        if (_n_ >= 0) {
            var i = _l_;
            for(;;){
                unsafe_set_none(t, i);
                var _o_ = i + 1 | 0;
                if (_n_ === i) break;
                i = _o_;
            }
        }
        return 0;
    }
    function _b_(input, f) {
        var _i_ = caml_call1(_a_, input), _j_ = caml_call2(Base_Import[93], _i_, 1), _h_ = 0;
        if (_j_ >= 0) {
            var i = _h_;
            for(;;){
                caml_call2(f, i, unsafe_get(input, i));
                var _k_ = i + 1 | 0;
                if (_j_ === i) break;
                i = _k_;
            }
        }
        return 0;
    }
    function _c_(input, init, f) {
        var acc = [
            0,
            init
        ];
        _b_(input, function(i, elem) {
            acc[1] = caml_call3(f, i, acc[1], elem);
            return 0;
        });
        return acc[1];
    }
    function fold(input, init, f) {
        return _c_(input, init, function(param, acc, x) {
            return caml_call2(f, acc, x);
        });
    }
    var foldi = [
        0,
        -198771759,
        _c_
    ], iter = [
        0,
        -198771759,
        function(input, f) {
            return _b_(input, function(param, x) {
                return caml_call1(f, x);
            });
        }
    ], iteri = [
        0,
        -198771759,
        _b_
    ], length = [
        0,
        -198771759,
        _a_
    ], include$0 = caml_call1(Base_Indexed_container[10], [
        0,
        fold,
        iter,
        length,
        iteri,
        foldi
    ]), is_empty = include$0[2], mem = include$0[3], iter$0 = include$0[4], fold$0 = include$0[5], fold_result = include$0[6], fold_until = include$0[7], exists = include$0[8], for_all = include$0[9], count = include$0[10], sum = include$0[11], find = include$0[12], find_map = include$0[13], to_list = include$0[14], min_elt = include$0[16], max_elt = include$0[17], foldi$0 = include$0[18], iteri$0 = include$0[19], existsi = include$0[20], for_alli = include$0[21], counti = include$0[22], findi = include$0[23], find_mapi = include$0[24], length$0 = Base_Uniform_array[11];
    function map(input, f) {
        var output = create(caml_call1(length$0, input));
        caml_call2(iteri$0, input, function(i, elem) {
            return unsafe_set(output, i, caml_call1(f, elem));
        });
        return output;
    }
    function map_some(input, f) {
        var len = caml_call1(length$0, input), output = create(len), _f_ = caml_call2(Base_Import[93], len, 1), _e_ = 0;
        if (_f_ >= 0) {
            var i = _e_;
            for(;;){
                var opt = caml_call2(Base_Uniform_array[13], input, i);
                if (is_some(opt)) {
                    var x = value_unsafe(opt);
                    unsafe_set_some(output, i, caml_call1(f, x));
                }
                var _g_ = i + 1 | 0;
                if (_f_ === i) break;
                i = _g_;
            }
        }
        return output;
    }
    function of_array(array) {
        return init(array.length - 1, function(i) {
            return array[1 + i];
        });
    }
    function of_array_some(array) {
        return init_some(array.length - 1, function(i) {
            return array[1 + i];
        });
    }
    function to_array(t) {
        var _d_ = caml_call1(length$0, t);
        return caml_call2(Base_Array[41], _d_, function(i) {
            return unsafe_get(t, i);
        });
    }
    function create_like(len, param) {
        return create(len);
    }
    var unsafe_blit = Base_Uniform_array[35], include$1 = caml_call1(Base_Blit[5], [
        0,
        create_like,
        length$0,
        unsafe_blit
    ]), blit = include$1[1], blito = include$1[2], unsafe_blit$0 = include$1[3], sub = include$1[4], subo = include$1[5], copy = Base_Uniform_array[38], Base_Option_array = [
        0,
        t_of_sexp$0,
        sexp_of_t$0,
        t_sexp_grammar,
        empty,
        create,
        is_empty,
        mem,
        iter$0,
        fold$0,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        min_elt,
        max_elt,
        foldi$0,
        iteri$0,
        existsi,
        for_alli,
        counti,
        findi,
        find_mapi,
        length$0,
        init_some,
        init,
        of_array,
        of_array_some,
        to_array,
        get,
        get_local,
        get_some_exn,
        is_none$0,
        is_some$0,
        unsafe_get,
        unsafe_get_some_exn,
        unsafe_get_some_assuming_some,
        unsafe_is_some,
        set,
        set_some,
        set_none,
        swap,
        clear,
        map,
        map_some,
        unsafe_set,
        unsafe_set_some,
        unsafe_set_none,
        blit,
        blito,
        unsafe_blit$0,
        sub,
        subo,
        copy,
        [
            0,
            [
                0,
                t_of_sexp,
                sexp_of_t,
                none,
                some,
                is_none,
                is_some,
                value_exn,
                value_unsafe,
                to_sexpable,
                of_sexpable
            ]
        ]
    ];
    runtime.caml_register_global(10, Base_Option_array, "Base__Option_array");
    return;
})(globalThis);
//# 26543 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Int = global_data.Base__Int, Base_Source_code_position0 = global_data.Base__Source_code_position0, Base_Comparable = global_data.Base__Comparable;
    function hash_override(param) {
        var pos_cnum = param[4], pos_bol = param[3], pos_lnum = param[2], pos_fname = param[1], _b_ = caml_call1(Base_Int[8], pos_cnum), _c_ = caml_call1(Base_Int[8], pos_bol), _d_ = caml_call1(Base_Int[8], pos_lnum), _e_ = runtime.Base_hash_string(pos_fname), _f_ = caml_call2(Base_Import[121], _e_, _d_), _g_ = caml_call2(Base_Import[121], _f_, _c_);
        return caml_call2(Base_Import[121], _g_, _b_);
    }
    var compare_local = Base_Source_code_position0[2], hash_fold_t = Base_Source_code_position0[4], comparator = Base_Source_code_position0[6], to_string = Base_Source_code_position0[8], sexp_of_t = Base_Source_code_position0[9], include = caml_call1(Base_Comparable[12], [
        0,
        sexp_of_t,
        comparator
    ]), symbol = include[1], symbol$0 = include[2], symbol$1 = include[3], symbol$2 = include[4], symbol$3 = include[5], symbol$4 = include[6], equal = include[7], compare = include[8], min = include[9], max = include[10], ascending = include[11], descending = include[12], between = include[13], clamp_exn = include[14], clamp = include[15], comparator$0 = include[16];
    function equal_local(a, b) {
        var _a_ = caml_call2(compare_local, a, b);
        return caml_call2(Base_Import[242], _a_, 0);
    }
    function of_pos(param) {
        var pos_cnum = param[3], pos_lnum = param[2], pos_fname = param[1];
        return [
            0,
            pos_fname,
            pos_lnum,
            0,
            pos_cnum
        ];
    }
    var Base_Source_code_position = [
        0,
        hash_fold_t,
        hash_override,
        sexp_of_t,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        equal,
        compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator$0,
        equal_local,
        compare_local,
        to_string,
        of_pos
    ];
    runtime.caml_register_global(4, Base_Source_code_position, "Base__Source_code_position");
    return;
})(globalThis);
//# 26922 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Sexp = global_data.Base__Sexp, Base_Comparable = global_data.Base__Comparable, _a_ = caml_call1(Base_Comparable[11], [
        0,
        Base_Sexp[7],
        Base_Sexp[5]
    ]), symbol = _a_[1], symbol$0 = _a_[2], symbol$1 = _a_[3], symbol$2 = _a_[4], symbol$3 = _a_[5], symbol$4 = _a_[6], min = _a_[9], max = _a_[10], ascending = _a_[11], descending = _a_[12], between = _a_[13], clamp_exn = _a_[14], clamp = _a_[15], comparator = _a_[16], globalize = Base_Sexp[1], hash_fold_t = Base_Sexp[2], hash = Base_Sexp[3], t_of_sexp = Base_Sexp[4], sexp_of_t = Base_Sexp[5], equal = Base_Sexp[6], compare = Base_Sexp[7], Not_found_s = Base_Sexp[8], Of_sexp_error = Base_Sexp[9], message = Base_Sexp[10], default_indent = Base_Sexp[11], pp_hum = Base_Sexp[12], pp_hum_indent = Base_Sexp[13], pp_mach = Base_Sexp[14], pp = Base_Sexp[15], to_string_hum = Base_Sexp[16], to_string_mach = Base_Sexp[17], to_string = Base_Sexp[18], of_float_style = Base_Sexp[19], of_int_style = Base_Sexp[20], equal_local = Base_Sexp[22], compare_local = Base_Sexp[23], t_sexp_grammar = Base_Sexp[24], invariant = Base_Sexp[25], of_string = Base_Sexp[26], Base_Sexp_with_comparable = [
        0,
        globalize,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        Not_found_s,
        Of_sexp_error,
        message,
        default_indent,
        pp_hum,
        pp_hum_indent,
        pp_mach,
        pp,
        to_string_hum,
        to_string_mach,
        to_string,
        of_float_style,
        of_int_style,
        t_sexp_grammar,
        invariant,
        of_string,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        equal,
        compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        compare_local,
        equal_local
    ];
    runtime.caml_register_global(2, Base_Sexp_with_comparable, "Base__Sexp_with_comparable");
    return;
})(globalThis);
//# 30102 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Exn = global_data.Base__Exn, Base_List = global_data.Base__List, Base_Import = global_data.Base__Import, compare_local = Base_Import[266], compare = Base_Import[238], equal_local = Base_Import[280], equal = Base_Import[252], globalize = Base_Import[296], t_of_sexp = Base_Import[168], sexp_of_t = Base_Import[144];
    function t_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Import[191], a_sexp_grammar);
    }
    function swap(t1, t2) {
        var tmp = t1[1];
        t1[1] = t2[1];
        t2[1] = tmp;
        return 0;
    }
    function replace(t, f) {
        t[1] = caml_call1(f, t[1]);
        return 0;
    }
    function set_temporarily(t, a, f) {
        var restore_to = t[1];
        t[1] = a;
        return caml_call2(Base_Exn[13], f, function(param) {
            t[1] = restore_to;
            return 0;
        });
    }
    function set(param) {
        var a = param[2], r = param[1];
        r[1] = a;
        return 0;
    }
    function sets(ts) {
        return caml_call2(Base_List[19], ts, set);
    }
    function snapshot(param) {
        var r = param[1];
        return [
            0,
            r,
            r[1]
        ];
    }
    function sets_temporarily(and_values, f) {
        var restore_to = caml_call2(Base_List[53], and_values, snapshot);
        sets(and_values);
        return caml_call2(Base_Exn[13], f, function(param) {
            return sets(restore_to);
        });
    }
    var Base_Ref = [
        0,
        compare,
        compare_local,
        equal,
        equal_local,
        globalize,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        swap,
        replace,
        set_temporarily,
        [
            0,
            set,
            sets,
            snapshot
        ],
        sets_temporarily
    ];
    runtime.caml_register_global(3, Base_Ref, "Base__Ref");
    return;
})(globalThis);
//# 30185 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_length$2 = "length", cst_src_queue_ml = "src/queue.ml", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), cst = "", Base_List = global_data.Base__List, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Base_Import = global_data.Base__Import, Base_Option_array = global_data.Base__Option_array, Base_Array = global_data.Base__Array, Base_Int = global_data.Base__Int, Base_Sexp = global_data.Base__Sexp, Base_Error = global_data.Base__Error, Assert_failure = global_data.Assert_failure, Stdlib_Queue = global_data.Stdlib__Queue, Base_Indexed_container = global_data.Base__Indexed_container, _a_ = [
        0,
        "elts"
    ], _b_ = [
        0,
        cst_length$2
    ], _c_ = [
        0,
        "mask"
    ], _d_ = [
        0,
        "front"
    ], _e_ = [
        0,
        "num_mutations"
    ], cst_length = cst_length$2, cst_index = "index", cst_Queue_index_out_of_bounds = "Queue index out of bounds", _f_ = [
        0,
        "_"
    ], cst_mutation_of_queue_during_i = "mutation of queue during iteration", _g_ = [
        0,
        cst_src_queue_ml,
        184,
        9
    ], _h_ = [
        0,
        cst_src_queue_ml,
        178,
        2
    ], _i_ = [
        0,
        cst_src_queue_ml,
        177,
        2
    ], _j_ = [
        0,
        cst_src_queue_ml,
        176,
        2
    ], _k_ = [
        0,
        cst_src_queue_ml,
        175,
        2
    ], _l_ = [
        0,
        cst_src_queue_ml,
        174,
        2
    ], _m_ = [
        0,
        cst_src_queue_ml,
        172,
        2
    ], _n_ = [
        0,
        cst_src_queue_ml,
        171,
        2
    ], cst_capacity = "capacity", cst_cannot_have_queue_with_neg = "cannot have queue with negative capacity", _o_ = [
        0,
        cst_src_queue_ml,
        212,
        2
    ], cst_length$0 = cst_length$2, cst_Queue_blit_transfer_negati = "Queue.blit_transfer: negative length";
    function globalize(param, t) {
        var _a3_ = caml_call1(Base_Option_array[58], t[5]);
        return [
            0,
            t[1],
            t[2],
            t[3],
            t[4],
            _a3_
        ];
    }
    function inc_num_mutations(t) {
        t[1] = caml_call2(Base_Import[91], t[1], 1);
        return;
    }
    function capacity(t) {
        return caml_call2(Base_Import[91], t[3], 1);
    }
    function elts_index(t, i) {
        var _a1_ = t[3], _a2_ = caml_call2(Base_Import[91], t[2], i);
        return caml_call2(Base_Import[116], _a2_, _a1_);
    }
    function unsafe_get(t, i) {
        var _a0_ = elts_index(t, i);
        return caml_call2(Base_Option_array[40], t[5], _a0_);
    }
    function unsafe_set(t, i, a) {
        var _aZ_ = elts_index(t, i);
        return caml_call3(Base_Option_array[51], t[5], _aZ_, a);
    }
    function check_index_exn(t, i) {
        var _aU_ = i < 0 ? 1 : 0, _aV_ = _aU_ || (t[4] <= i ? 1 : 0);
        if (!_aV_) return _aV_;
        var _aW_ = [
            0,
            [
                0,
                cst_length,
                caml_call1(Base_Int[10], t[4])
            ],
            0
        ], _aX_ = [
            0,
            [
                0,
                cst_index,
                caml_call1(Base_Int[10], i)
            ],
            _aW_
        ], _aY_ = caml_call2(Base_Sexp[10], cst_Queue_index_out_of_bounds, _aX_);
        return caml_call1(Base_Error[32], _aY_);
    }
    function get(t, i) {
        check_index_exn(t, i);
        return unsafe_get(t, i);
    }
    function set(t, i, a) {
        check_index_exn(t, i);
        inc_num_mutations(t);
        return unsafe_set(t, i, a);
    }
    function is_empty(t) {
        return 0 === t[4] ? 1 : 0;
    }
    function length(param) {
        var length = param[4];
        return length;
    }
    function ensure_no_mutation(t, num_mutations) {
        var _aT_ = t[1] !== num_mutations ? 1 : 0;
        if (!_aT_) return _aT_;
        var param = globalize(0, t);
        function of_a_001(param) {
            return _f_;
        }
        var num_mutations_003 = param[1], front_005 = param[2], mask_007 = param[3], length_009 = param[4], elts_011 = param[5], arg_012 = caml_call2(Base_Option_array[2], of_a_001, elts_011), bnds_002 = [
            0,
            [
                1,
                [
                    0,
                    _a_,
                    [
                        0,
                        arg_012,
                        0
                    ]
                ]
            ],
            0
        ], arg_010 = caml_call1(Base_Import[139], length_009), bnds_002$0 = [
            0,
            [
                1,
                [
                    0,
                    _b_,
                    [
                        0,
                        arg_010,
                        0
                    ]
                ]
            ],
            bnds_002
        ], arg_008 = caml_call1(Base_Import[139], mask_007), bnds_002$1 = [
            0,
            [
                1,
                [
                    0,
                    _c_,
                    [
                        0,
                        arg_008,
                        0
                    ]
                ]
            ],
            bnds_002$0
        ], arg_006 = caml_call1(Base_Import[139], front_005), bnds_002$2 = [
            0,
            [
                1,
                [
                    0,
                    _d_,
                    [
                        0,
                        arg_006,
                        0
                    ]
                ]
            ],
            bnds_002$1
        ], arg_004 = caml_call1(Base_Import[139], num_mutations_003), bnds_002$3 = [
            0,
            [
                1,
                [
                    0,
                    _e_,
                    [
                        0,
                        arg_004,
                        0
                    ]
                ]
            ],
            bnds_002$2
        ], _aS_ = caml_call2(Base_Sexp[10], cst_mutation_of_queue_during_i, [
            0,
            [
                0,
                cst,
                [
                    1,
                    bnds_002$3
                ]
            ],
            0
        ]);
        return caml_call1(Base_Error[32], _aS_);
    }
    function compare_local(compare_elt, t1, t2) {
        if (t1 === t2) return 0;
        var mut2 = t2[1], mut1 = t1[1], len2 = t2[4], len1 = t1[4], pos = 0;
        for(;;){
            var match = pos === len2 ? 1 : 0;
            if (pos === len1) return match ? 0 : -1;
            if (match) return 1;
            var _aR_ = unsafe_get(t2, pos), x = caml_call2(compare_elt, unsafe_get(t1, pos), _aR_);
            ensure_no_mutation(t1, mut1);
            ensure_no_mutation(t2, mut2);
            if (0 !== x) return x;
            var pos$0 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$0;
        }
    }
    function compare(compare_elt, t1, t2) {
        return compare_local(compare_elt, t1, t2);
    }
    function equal_local(equal_elt, t1, t2) {
        var _aO_ = t1 === t2 ? 1 : 0;
        if (_aO_) var _aP_ = _aO_;
        else {
            var len1 = t1[4], len2 = t2[4], _aQ_ = len1 === len2 ? 1 : 0;
            if (_aQ_) {
                var mut2 = t2[1], mut1 = t1[1], pos = 0;
                for(;;){
                    var _aL_ = pos === len1 ? 1 : 0;
                    if (_aL_) var _aM_ = _aL_;
                    else {
                        var _aN_ = unsafe_get(t2, pos), b = caml_call2(equal_elt, unsafe_get(t1, pos), _aN_);
                        ensure_no_mutation(t1, mut1);
                        ensure_no_mutation(t2, mut2);
                        if (b) {
                            var pos$0 = caml_call2(Base_Import[91], pos, 1);
                            pos = pos$0;
                            continue;
                        }
                        var _aM_ = b;
                    }
                    return _aM_;
                }
            }
            var _aP_ = _aQ_;
        }
        return _aP_;
    }
    function equal(equal_elt, t1, t2) {
        return equal_local(equal_elt, t1, t2);
    }
    function invariant(invariant_a, t) {
        var num_mutations = t[1], front = t[2], length = t[4], elts = t[5];
        if (0 > front) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _n_
        ], 1);
        if (front >= capacity(t)) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _m_
        ], 1);
        var capacity$0 = capacity(t);
        if (capacity$0 !== caml_call1(Base_Option_array[28], elts)) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _l_
        ], 1);
        if (1 > capacity$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _k_
        ], 1);
        if (!caml_call1(Base_Int[72], capacity$0)) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _j_
        ], 1);
        if (0 > length) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _i_
        ], 1);
        if (length > capacity$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _h_
        ], 1);
        var _aJ_ = caml_call2(Base_Import[93], capacity$0, 1), _aI_ = 0;
        if (_aJ_ >= 0) {
            var i = _aI_;
            for(;;){
                if (i < t[4]) {
                    caml_call1(invariant_a, unsafe_get(t, i));
                    ensure_no_mutation(t, num_mutations);
                } else {
                    var _aH_ = elts_index(t, i);
                    if (caml_call2(Base_Option_array[42], t[5], _aH_)) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _g_
                    ], 1);
                }
                var _aK_ = i + 1 | 0;
                if (_aJ_ === i) break;
                i = _aK_;
            }
        }
        return 0;
    }
    function create(capacity, param) {
        if (capacity) {
            var capacity$0 = capacity[1];
            if (0 <= capacity$0) var _aD_ = 0 === capacity$0 ? 1 : caml_call1(Base_Int[68], capacity$0);
            else var _aF_ = [
                0,
                [
                    0,
                    cst_capacity,
                    caml_call1(Base_Int[10], capacity$0)
                ],
                0
            ], _aG_ = caml_call2(Base_Sexp[10], cst_cannot_have_queue_with_neg, _aF_), _aD_ = caml_call1(Base_Error[32], _aG_);
            var capacity$1 = _aD_;
        } else var capacity$1 = 2;
        var _aE_ = caml_call1(Base_Option_array[5], capacity$1);
        return [
            0,
            0,
            0,
            caml_call2(Base_Import[93], capacity$1, 1),
            0,
            _aE_
        ];
    }
    function blit_to_array(src, dst) {
        var _az_ = caml_call1(Base_Option_array[28], dst);
        if (src[4] > _az_) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _o_
        ], 1);
        var _aA_ = src[2], _aB_ = capacity(src), _aC_ = caml_call2(Base_Import[93], _aB_, _aA_), front_len = caml_call2(Base_Int[15], src[4], _aC_), rest_len = caml_call2(Base_Import[93], src[4], front_len);
        caml_call5(Base_Option_array[53], src[5], src[2], dst, 0, front_len);
        return caml_call5(Base_Option_array[53], src[5], 0, dst, front_len, rest_len);
    }
    function set_capacity_internal(t, new_capacity) {
        var dst = caml_call1(Base_Option_array[5], new_capacity);
        blit_to_array(t, dst);
        t[2] = 0;
        t[3] = caml_call2(Base_Import[93], new_capacity, 1);
        t[5] = dst;
        return 0;
    }
    function set_capacity(t, desired_capacity) {
        inc_num_mutations(t);
        var _aw_ = caml_call2(Base_Import[100], desired_capacity, t[4]), _ax_ = caml_call2(Base_Import[100], 1, _aw_), new_capacity = caml_call1(Base_Int[68], _ax_), _ay_ = new_capacity !== capacity(t) ? 1 : 0;
        return _ay_ ? set_capacity_internal(t, new_capacity) : _ay_;
    }
    function enqueue(t, a) {
        inc_num_mutations(t);
        var _av_ = capacity(t);
        if (t[4] === _av_) set_capacity_internal(t, caml_call2(Base_Import[88], 2, t[4]));
        unsafe_set(t, t[4], a);
        t[4] = caml_call2(Base_Import[91], t[4], 1);
        return 0;
    }
    function enqueue_front(t, a) {
        inc_num_mutations(t);
        var _as_ = capacity(t);
        if (t[4] === _as_) set_capacity_internal(t, caml_call2(Base_Import[88], 2, t[4]));
        var _at_ = t[3], _au_ = caml_call2(Base_Import[93], t[2], 1), front = caml_call2(Base_Import[116], _au_, _at_);
        t[2] = front;
        t[4] = caml_call2(Base_Import[91], t[4], 1);
        return unsafe_set(t, 0, a);
    }
    function dequeue_nonempty(t) {
        inc_num_mutations(t);
        var elts = t[5], front = t[2], res = caml_call2(Base_Option_array[36], elts, front);
        caml_call2(Base_Option_array[45], elts, front);
        t[2] = elts_index(t, 1);
        t[4] = caml_call2(Base_Import[93], t[4], 1);
        return res;
    }
    function back_index(t) {
        return elts_index(t, caml_call2(Base_Import[93], t[4], 1));
    }
    function dequeue_back_nonempty(t) {
        inc_num_mutations(t);
        var elts = t[5], back = back_index(t), res = caml_call2(Base_Option_array[36], elts, back);
        caml_call2(Base_Option_array[45], elts, back);
        t[4] = caml_call2(Base_Import[93], t[4], 1);
        return res;
    }
    function dequeue_exn(t) {
        if (is_empty(t)) throw caml_maybe_attach_backtrace(Stdlib_Queue[1], 1);
        return dequeue_nonempty(t);
    }
    function dequeue(t) {
        return is_empty(t) ? 0 : [
            0,
            dequeue_nonempty(t)
        ];
    }
    function dequeue_and_ignore_exn(t) {
        dequeue_exn(t);
        return 0;
    }
    function dequeue_back_exn(t) {
        if (is_empty(t)) throw caml_maybe_attach_backtrace(Stdlib_Queue[1], 1);
        return dequeue_back_nonempty(t);
    }
    function dequeue_back(t) {
        return is_empty(t) ? 0 : [
            0,
            dequeue_back_nonempty(t)
        ];
    }
    function front_nonempty(t) {
        return caml_call2(Base_Option_array[40], t[5], t[2]);
    }
    function back_nonempty(t) {
        var _ar_ = back_index(t);
        return caml_call2(Base_Option_array[40], t[5], _ar_);
    }
    function last_nonempty(t) {
        return unsafe_get(t, caml_call2(Base_Import[93], t[4], 1));
    }
    function peek(t) {
        return is_empty(t) ? 0 : [
            0,
            front_nonempty(t)
        ];
    }
    function peek_exn(t) {
        if (is_empty(t)) throw caml_maybe_attach_backtrace(Stdlib_Queue[1], 1);
        return front_nonempty(t);
    }
    function peek_back(t) {
        return is_empty(t) ? 0 : [
            0,
            back_nonempty(t)
        ];
    }
    function peek_back_exn(t) {
        if (is_empty(t)) throw caml_maybe_attach_backtrace(Stdlib_Queue[1], 1);
        return back_nonempty(t);
    }
    function last(t) {
        return is_empty(t) ? 0 : [
            0,
            last_nonempty(t)
        ];
    }
    function last_exn(t) {
        if (is_empty(t)) throw caml_maybe_attach_backtrace(Stdlib_Queue[1], 1);
        return last_nonempty(t);
    }
    function drain(t, f, while$0) {
        for(;;){
            if (!is_empty(t) && caml_call1(while$0, front_nonempty(t))) {
                caml_call1(f, dequeue_nonempty(t));
                continue;
            }
            return 0;
        }
    }
    function clear(t) {
        inc_num_mutations(t);
        var _am_ = 0 < t[4] ? 1 : 0;
        if (_am_) {
            var _ao_ = caml_call2(Base_Import[93], t[4], 1), _an_ = 0;
            if (_ao_ >= 0) {
                var i = _an_;
                for(;;){
                    var _al_ = elts_index(t, i);
                    caml_call2(Base_Option_array[52], t[5], _al_);
                    var _aq_ = i + 1 | 0;
                    if (_ao_ === i) break;
                    i = _aq_;
                }
            }
            t[4] = 0;
            t[2] = 0;
            var _ap_ = 0;
        } else var _ap_ = _am_;
        return _ap_;
    }
    function blit_transfer(src, dst, len, param) {
        inc_num_mutations(src);
        inc_num_mutations(dst);
        if (len) {
            var len$0 = len[1];
            if (len$0 < 0) {
                var _X_ = [
                    0,
                    [
                        0,
                        cst_length$0,
                        caml_call1(Base_Int[10], len$0)
                    ],
                    0
                ], _Y_ = caml_call2(Base_Sexp[10], cst_Queue_blit_transfer_negati, _X_);
                caml_call1(Base_Error[32], _Y_);
            }
            var len$1 = caml_call2(Base_Import[101], len$0, src[4]);
        } else var len$1 = src[4];
        var _Z_ = 0 < len$1 ? 1 : 0;
        if (_Z_) {
            var ___ = caml_call2(Base_Import[91], dst[4], len$1), _$_ = capacity(dst);
            set_capacity(dst, caml_call2(Base_Import[100], _$_, ___));
            var dst_start = caml_call2(Base_Import[91], dst[2], dst[4]), _ab_ = caml_call2(Base_Import[93], len$1, 1), _aa_ = 0;
            if (_ab_ >= 0) {
                var i = _aa_;
                for(;;){
                    var _af_ = src[3], _ag_ = caml_call2(Base_Import[91], src[2], i), src_i = caml_call2(Base_Import[116], _ag_, _af_), _ah_ = dst[3], _ai_ = caml_call2(Base_Import[91], dst_start, i), dst_i = caml_call2(Base_Import[116], _ai_, _ah_), _aj_ = caml_call2(Base_Option_array[40], src[5], src_i);
                    caml_call3(Base_Option_array[51], dst[5], dst_i, _aj_);
                    caml_call2(Base_Option_array[52], src[5], src_i);
                    var _ak_ = i + 1 | 0;
                    if (_ab_ === i) break;
                    i = _ak_;
                }
            }
            dst[4] = caml_call2(Base_Import[91], dst[4], len$1);
            var _ac_ = src[3], _ad_ = caml_call2(Base_Import[91], src[2], len$1);
            src[2] = caml_call2(Base_Import[116], _ad_, _ac_);
            src[4] = caml_call2(Base_Import[93], src[4], len$1);
            var _ae_ = 0;
        } else var _ae_ = _Z_;
        return _ae_;
    }
    function enqueue_all(t, l) {
        var _U_ = caml_call1(Base_List[45], l), _V_ = caml_call2(Base_Import[91], t[4], _U_), _W_ = capacity(t);
        set_capacity(t, caml_call2(Base_Int[16], _W_, _V_));
        return caml_call2(Base_List[19], l, function(x) {
            return enqueue(t, x);
        });
    }
    function fold(t, init, f) {
        if (0 === t[4]) return init;
        var num_mutations = t[1], r = [
            0,
            init
        ], _R_ = caml_call2(Base_Import[93], t[4], 1), _Q_ = 0;
        if (_R_ >= 0) {
            var i = _Q_;
            for(;;){
                var _S_ = unsafe_get(t, i);
                r[1] = caml_call2(f, r[1], _S_);
                ensure_no_mutation(t, num_mutations);
                var _T_1 = i + 1 | 0;
                if (_R_ === i) break;
                i = _T_1;
            }
        }
        return r[1];
    }
    function foldi(t, init, f) {
        var i = [
            0,
            0
        ];
        return fold(t, init, function(acc, a) {
            var acc$0 = caml_call3(f, i[1], acc, a);
            i[1] = caml_call2(Base_Import[91], i[1], 1);
            return acc$0;
        });
    }
    function iter(t, f) {
        var num_mutations = t[1], _O_ = caml_call2(Base_Import[93], t[4], 1), _N_ = 0;
        if (_O_ >= 0) {
            var i = _N_;
            for(;;){
                caml_call1(f, unsafe_get(t, i));
                ensure_no_mutation(t, num_mutations);
                var _P_ = i + 1 | 0;
                if (_O_ === i) break;
                i = _P_;
            }
        }
        return 0;
    }
    function iteri(t, f) {
        var num_mutations = t[1], _L_ = caml_call2(Base_Import[93], t[4], 1), _K_ = 0;
        if (_L_ >= 0) {
            var i = _K_;
            for(;;){
                caml_call2(f, i, unsafe_get(t, i));
                ensure_no_mutation(t, num_mutations);
                var _M_ = i + 1 | 0;
                if (_L_ === i) break;
                i = _M_;
            }
        }
        return 0;
    }
    function to_list(t) {
        var result = [
            0,
            0
        ], _H_ = caml_call2(Base_Import[93], t[4], 1);
        if (_H_ >= 0) {
            var i = _H_;
            for(;;){
                var _I_ = result[1];
                result[1] = [
                    0,
                    unsafe_get(t, i),
                    _I_
                ];
                var _J_ = i - 1 | 0;
                if (0 === i) break;
                i = _J_;
            }
        }
        return result[1];
    }
    var iter$0 = [
        0,
        -198771759,
        iter
    ], length$0 = [
        0,
        -198771759,
        length
    ], foldi$0 = [
        0,
        -198771759,
        foldi
    ], iteri$0 = [
        0,
        -198771759,
        iteri
    ], C = caml_call1(Base_Indexed_container[8], [
        0,
        fold,
        iter$0,
        length$0,
        iteri$0,
        foldi$0
    ]), count = C[10], exists = C[8], find = C[12], find_map = C[13], fold_result = C[6], fold_until = C[7], for_all = C[9], max_elt = C[17], mem = C[1], min_elt = C[16], sum = C[11], counti = C[22], existsi = C[20], find_mapi = C[24], findi = C[23], for_alli = C[21], cst_length$1 = cst_length$2, cst_Queue_init_negative_length = "Queue.init: negative length", _p_ = [
        0,
        cst_src_queue_ml,
        507,
        2
    ], _q_ = [
        0,
        1
    ];
    function concat_map(t, f) {
        var t_result = create(0, 0);
        iter(t, function(a) {
            var _G_ = caml_call1(f, a);
            return caml_call2(Base_List[19], _G_, function(b) {
                return enqueue(t_result, b);
            });
        });
        return t_result;
    }
    function concat_mapi(t, f) {
        var t_result = create(0, 0);
        iteri(t, function(i, a) {
            var _F_ = caml_call2(f, i, a);
            return caml_call2(Base_List[19], _F_, function(b) {
                return enqueue(t_result, b);
            });
        });
        return t_result;
    }
    function filter_map(t, f) {
        var t_result = create(0, 0);
        iter(t, function(a) {
            var match = caml_call1(f, a);
            if (!match) return 0;
            var b = match[1];
            return enqueue(t_result, b);
        });
        return t_result;
    }
    function filter_mapi(t, f) {
        var t_result = create(0, 0);
        iteri(t, function(i, a) {
            var match = caml_call2(f, i, a);
            if (!match) return 0;
            var b = match[1];
            return enqueue(t_result, b);
        });
        return t_result;
    }
    function filter(t, f) {
        var t_result = create(0, 0);
        iter(t, function(a) {
            var _E_ = caml_call1(f, a);
            return _E_ ? enqueue(t_result, a) : _E_;
        });
        return t_result;
    }
    function filteri(t, f) {
        var t_result = create(0, 0);
        iteri(t, function(i, a) {
            var _D_ = caml_call2(f, i, a);
            return _D_ ? enqueue(t_result, a) : _D_;
        });
        return t_result;
    }
    function filter_inplace(t, f) {
        var t2 = filter(t, f);
        clear(t);
        return blit_transfer(t2, t, 0, 0);
    }
    function filteri_inplace(t, f) {
        var t2 = filteri(t, f);
        clear(t);
        return blit_transfer(t2, t, 0, 0);
    }
    function copy(src) {
        var dst = create([
            0,
            src[4]
        ], 0);
        blit_to_array(src, dst[5]);
        dst[4] = src[4];
        return dst;
    }
    function of_list(l) {
        var t = create([
            0,
            caml_call1(Base_List[45], l)
        ], 0);
        caml_call2(Base_List[19], l, function(x) {
            return enqueue(t, x);
        });
        return t;
    }
    function init(len, f) {
        if (len < 0) {
            var _x_ = [
                0,
                [
                    0,
                    cst_length$1,
                    caml_call1(Base_Int[10], len)
                ],
                0
            ], _y_ = caml_call2(Base_Sexp[10], cst_Queue_init_negative_length, _x_);
            caml_call1(Base_Error[32], _y_);
        }
        var t = create([
            0,
            len
        ], 0);
        if (len > caml_call1(Base_Option_array[28], t[5])) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _p_
        ], 1);
        var _A_ = caml_call2(Base_Import[93], len, 1), _z_ = 0;
        if (_A_ >= 0) {
            var i = _z_;
            for(;;){
                var _B_ = caml_call1(f, i);
                caml_call3(Base_Option_array[51], t[5], i, _B_);
                var _C_ = i + 1 | 0;
                if (_A_ === i) break;
                i = _C_;
            }
        }
        t[4] = len;
        return t;
    }
    function of_array(a) {
        return init(a.length - 1, function(_w_) {
            return a[1 + _w_];
        });
    }
    function to_array(t) {
        return caml_call2(Base_Array[41], t[4], function(i) {
            return unsafe_get(t, i);
        });
    }
    function map(ta, f) {
        var num_mutations = ta[1], tb = create([
            0,
            ta[4]
        ], 0);
        tb[4] = ta[4];
        var _u_ = caml_call2(Base_Import[93], ta[4], 1), _t_ = 0;
        if (_u_ >= 0) {
            var i = _t_;
            for(;;){
                var b = caml_call1(f, unsafe_get(ta, i));
                ensure_no_mutation(ta, num_mutations);
                caml_call3(Base_Option_array[51], tb[5], i, b);
                var _v_ = i + 1 | 0;
                if (_u_ === i) break;
                i = _v_;
            }
        }
        return tb;
    }
    function mapi(t, f) {
        var i = [
            0,
            0
        ];
        return map(t, function(a) {
            var result = caml_call2(f, i[1], a);
            i[1] = caml_call2(Base_Import[91], i[1], 1);
            return result;
        });
    }
    function singleton(x) {
        var t = create(_q_, 0);
        enqueue(t, x);
        return t;
    }
    function sexp_of_t(sexp_of_a, t) {
        var _s_ = to_list(t);
        return caml_call1(caml_call1(Base_List[6], sexp_of_a), _s_);
    }
    function t_of_sexp(a_of_sexp, sexp) {
        return of_list(caml_call2(Base_List[5], a_of_sexp, sexp));
    }
    function t_sexp_grammar(grammar) {
        var _r_ = caml_call1(Base_List[7], grammar);
        return caml_call1(Sexplib0_Sexp_grammar[1], _r_);
    }
    function start(q) {
        return q[1];
    }
    function assert_no_mutation_since_start(t, q) {
        return ensure_no_mutation(q, t);
    }
    var Iteration = [
        0,
        start,
        assert_no_mutation_since_start
    ], Base_Queue = [
        0,
        compare,
        compare_local,
        globalize,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        mem,
        length,
        is_empty,
        iter,
        fold,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        to_array,
        min_elt,
        max_elt,
        foldi,
        iteri,
        existsi,
        for_alli,
        counti,
        findi,
        find_mapi,
        singleton,
        of_list,
        of_array,
        init,
        enqueue,
        enqueue_all,
        dequeue,
        dequeue_exn,
        dequeue_and_ignore_exn,
        drain,
        peek,
        peek_exn,
        clear,
        copy,
        map,
        mapi,
        concat_map,
        concat_mapi,
        filter_map,
        filter_mapi,
        filter,
        filteri,
        filter_inplace,
        filteri_inplace,
        equal,
        equal_local,
        invariant,
        create,
        last,
        last_exn,
        enqueue_front,
        dequeue_back,
        dequeue_back_exn,
        peek_back,
        peek_back_exn,
        blit_transfer,
        get,
        set,
        capacity,
        set_capacity,
        Iteration
    ];
    runtime.caml_register_global(39, Base_Queue, "Base__Queue");
    return;
})(globalThis);
//# 31112 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", cst_nx = "%nx", cst_argument_must_be_strictly_ = "argument must be strictly positive", caml_lessequal = runtime.caml_lessequal, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, module_name = "Base.Nativeint.Hex", module_name$0 = "Base.Nativeint", Base_Int_math = global_data.Base__Int_math, Base_Import = global_data.Base__Import, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Stdlib_Nativeint = global_data.Stdlib__Nativeint, Base_Printf = global_data.Base__Printf, Base_Float0 = global_data.Base__Float0, Stdlib_Scanf = global_data.Stdlib__Scanf, Base_Comparator = global_data.Base__Comparator, Base_Comparable = global_data.Base__Comparable, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Pretty_printer = global_data.Base__Pretty_printer, Base_Word_size = global_data.Base__Word_size, Base_Error = global_data.Base__Error, Base_Popcount = global_data.Base__Popcount, Base_Int_conversions = global_data.Base__Int_conversions, include = Base_Import[104], compare = include[9], globalize = Base_Import[287], hash_fold_t = Base_Import[202], func = Base_Import[216];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[167], sexp_of_t = Base_Import[143], t_sexp_grammar = Base_Import[189], hashable = [
        0,
        hash,
        compare,
        sexp_of_t
    ], compare$0 = Base_Import[104][9], to_string = Stdlib_Nativeint[15], of_string = runtime.caml_int_of_string, of_string_opt = Stdlib_Nativeint[14], comparator = caml_call1(Base_Comparator[7], [
        0,
        compare$0,
        sexp_of_t
    ])[1], zero = Stdlib_Nativeint[1], _a_ = caml_call1(Base_Comparable[14], [
        0,
        compare$0,
        sexp_of_t,
        zero
    ]), is_positive = _a_[1], is_non_negative = _a_[2], is_negative = _a_[3], is_non_positive = _a_[4], sign = _a_[5], include$0 = caml_call1(Base_Int_string_conversions[1], [
        0,
        to_string
    ]), to_string_hum = include$0[1], sexp_of_t$0 = include$0[2], compare_local = Base_Import[259];
    function compare$1(a, b) {
        return caml_call2(compare_local, a, b);
    }
    var hash_fold_t$0 = Base_Import[202], func$0 = Base_Import[216];
    function hash$0(x) {
        return caml_call1(func$0, x);
    }
    var zero$0 = Stdlib_Nativeint[1];
    function neg(_W_) {
        return -_W_ | 0;
    }
    var symbol = Base_Import[104][1], _b_ = [
        0,
        [
            6,
            6,
            0,
            0,
            0
        ],
        cst_nx
    ], _c_ = [
        0,
        [
            6,
            6,
            0,
            0,
            0
        ],
        cst_nx
    ];
    function to_string$0(i) {
        return caml_call2(Base_Printf[2], _b_, i);
    }
    function of_string$0(s) {
        return caml_call3(Stdlib_Scanf[5], s, _c_, function(_V_) {
            return _V_;
        });
    }
    var include$1 = caml_call1(Base_Int_string_conversions[2], [
        0,
        compare$1,
        compare_local,
        hash_fold_t$0,
        hash$0,
        to_string$0,
        of_string$0,
        zero$0,
        symbol,
        neg,
        module_name
    ]), Hex = include$1[1], include$2 = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name$0,
        to_string
    ]), pp = include$2[1];
    function invariant(param) {
        return 0;
    }
    var num_bits = caml_call1(Base_Word_size[2], Base_Word_size[3]), float_lower_bound = caml_call1(Base_Float0[26], num_bits), float_upper_bound = caml_call1(Base_Float0[24], num_bits);
    function shift_right_logical(_U_, _T_1) {
        return _U_ >>> _T_1 | 0;
    }
    function shift_right(_S_, _R_) {
        return _S_ >> _R_;
    }
    function shift_left(_Q_, _P_) {
        return _Q_ << _P_;
    }
    var bit_not = Stdlib_Nativeint[12];
    function bit_xor(_O_, _N_) {
        return _O_ ^ _N_;
    }
    function bit_or(_M_, _L_) {
        return _M_ | _L_;
    }
    function bit_and(_K_, _J_) {
        return _K_ & _J_;
    }
    var min_value = Stdlib_Nativeint[11], max_value = Stdlib_Nativeint[10], abs = Stdlib_Nativeint[8], pred = Stdlib_Nativeint[7], succ = Stdlib_Nativeint[6], rem = runtime.caml_mod;
    function symbol$0(_I_) {
        return -_I_ | 0;
    }
    var minus_one = Stdlib_Nativeint[3], one = Stdlib_Nativeint[2], zero$1 = Stdlib_Nativeint[1], _d_ = [
        0,
        [
            11,
            "Nativeint.of_float: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Nativeint.of_float: argument (%f) is out of range or NaN"
    ];
    function to_float(_H_) {
        return _H_;
    }
    function of_float_unchecked(_G_) {
        return _G_ | 0;
    }
    function of_float(f) {
        if (float_lower_bound <= f && f <= float_upper_bound) return f | 0;
        var _F_ = caml_call1(Base_Float0[29], f);
        return caml_call3(Base_Printf[7], _d_, _F_, 0);
    }
    var raise_s = Base_Error[32], _e_ = [
        0,
        [
            11,
            cst_argument_must_be_strictly_,
            0
        ],
        cst_argument_must_be_strictly_
    ], cst_Nativeint_floor_log2_got_i = "[Nativeint.floor_log2] got invalid input", cst_Nativeint_ceil_log2_got_in = "[Nativeint.ceil_log2] got invalid input", _f_ = [
        0,
        "src/nativeint.ml",
        206,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function non_positive_argument(param) {
        return caml_call2(Base_Printf[7], _e_, 0);
    }
    function lsr(_E_, _D_) {
        return _E_ >>> _D_ | 0;
    }
    function land(_C_, _B_) {
        return _C_ & _B_;
    }
    function ceil_pow2(x) {
        if (caml_call2(Base_Import[104][2], x, 0)) non_positive_argument(0);
        var x$0 = caml_call1(Stdlib_Nativeint[7], x), x$6 = x$0 | x$0 >>> 1 | 0, x$5 = x$6 | x$6 >>> 2 | 0, x$4 = x$5 | x$5 >>> 4 | 0, x$3 = x$4 | x$4 >>> 8 | 0, x$2 = x$3 | x$3 >>> 16 | 0, x$1 = x$2 | x$2 >>> 32 | 0;
        return caml_call1(Stdlib_Nativeint[6], x$1);
    }
    function floor_pow2(x$0) {
        if (caml_call2(Base_Import[104][2], x$0, 0)) non_positive_argument(0);
        var x = x$0 | x$0 >>> 1 | 0, x$5 = x | x >>> 2 | 0, x$4 = x$5 | x$5 >>> 4 | 0, x$3 = x$4 | x$4 >>> 8 | 0, x$2 = x$3 | x$3 >>> 16 | 0, x$1 = x$2 | x$2 >>> 32 | 0;
        return x$1 - (x$1 >>> 1 | 0) | 0;
    }
    function is_pow2(x) {
        if (caml_call2(Base_Import[104][2], x, 0)) non_positive_argument(0);
        var _A_ = x & caml_call1(Stdlib_Nativeint[7], x);
        return caml_call2(Base_Import[104][4], _A_, 0);
    }
    function floor_log2(i) {
        if (caml_lessequal(i, Stdlib_Nativeint[1])) {
            var _x_ = [
                0,
                [
                    0,
                    cst,
                    caml_call1(Base_Import[143], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Nativeint_floor_log2_got_i, _x_));
        }
        var _y_ = runtime.Base_int_math_nativeint_clz(i), _z_ = caml_call2(Base_Import[93], num_bits, 1);
        return caml_call2(Base_Import[93], _z_, _y_);
    }
    function ceil_log2(i) {
        if (caml_lessequal(i, Stdlib_Nativeint[1])) {
            var _v_ = [
                0,
                [
                    0,
                    cst$0,
                    caml_call1(Base_Import[143], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Nativeint_ceil_log2_got_in, _v_));
        }
        if (caml_call2(Stdlib_Nativeint[18], i, Stdlib_Nativeint[2])) return 0;
        var _w_ = runtime.Base_int_math_nativeint_clz(caml_call1(Stdlib_Nativeint[7], i));
        return caml_call2(Base_Import[93], num_bits, _w_);
    }
    function between(t, low, high) {
        var _u_ = caml_call2(Base_Import[104][2], low, t);
        return _u_ ? caml_call2(Base_Import[104][2], t, high) : _u_;
    }
    function clamp_unchecked(t, min, max) {
        var _t_ = caml_call2(Base_Import[104][14], t, max);
        return caml_call1(caml_call1(Base_Import[104][13], min), _t_);
    }
    function clamp_exn(t, min, max) {
        if (caml_call2(Base_Import[104][2], min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _f_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_call2(Base_Import[104][5], min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _q_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _r_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _q_
        ], _s_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _r_);
        return caml_call1(Base_Or_error[39], _s_);
    }
    var symbol$1 = runtime.caml_div, symbol$2 = runtime.caml_mul;
    function symbol$3(_p_, _o_) {
        return _p_ - _o_ | 0;
    }
    function symbol$4(_n_, _m_) {
        return _n_ + _m_ | 0;
    }
    function incr(r) {
        r[1] = r[1] + one | 0;
        return 0;
    }
    function decr(r) {
        r[1] = r[1] - one | 0;
        return 0;
    }
    function of_nativeint(t) {
        return t;
    }
    function to_nativeint(t) {
        return t;
    }
    var popcount = Base_Popcount[4], of_int_exn = Base_Int_conversions[5], to_int = Base_Int_conversions[23], to_int_exn = Base_Int_conversions[24], to_int_trunc = Base_Int_conversions[25], of_int32 = Base_Int_conversions[10], to_int32 = Base_Int_conversions[26], to_int32_exn = Base_Int_conversions[27], of_int64 = Base_Int_conversions[18], of_int64_exn = Base_Int_conversions[19], of_int64_trunc = Base_Int_conversions[20], to_int64 = Base_Int_conversions[29];
    function pow(b, e) {
        var _k_ = caml_call1(to_int_exn, e), _l_ = caml_call1(to_int_exn, b);
        return caml_call1(of_int_exn, caml_call2(Base_Int_math[2][1], _l_, _k_));
    }
    function symbol$5(b, e) {
        return pow(b, e);
    }
    var compare_local$0 = Base_Import[259];
    function compare$2(a, b) {
        return caml_call2(compare_local$0, a, b);
    }
    var equal_local = Base_Import[273];
    function equal(a, b) {
        return caml_call2(equal_local, a, b);
    }
    var hash_fold_t$1 = Base_Import[202], func$1 = Base_Import[216];
    function hash$1(x) {
        return caml_call1(func$1, x);
    }
    function clz(_j_) {
        return runtime.Base_int_math_nativeint_clz(_j_);
    }
    var Binary = caml_call1(Base_Int_string_conversions[3], [
        0,
        compare$2,
        compare_local$0,
        equal,
        equal_local,
        hash_fold_t$1,
        hash$1,
        clz,
        lsr,
        land,
        to_int_exn,
        num_bits,
        one,
        zero$1
    ])[1], _g_ = Base_Import[104], symbol$6 = _g_[3], symbol$7 = _g_[1], symbol$8 = _g_[5], symbol$9 = _g_[4], symbol$10 = _g_[2], symbol$11 = _g_[6], include$3 = caml_call1(Base_Int_math[1], [
        0,
        of_float,
        to_float,
        of_string,
        to_string,
        symbol$4,
        symbol$3,
        symbol$2,
        symbol$1,
        symbol$0,
        symbol$11,
        symbol$10,
        symbol$9,
        symbol$8,
        symbol$7,
        symbol$6,
        abs,
        symbol$0,
        zero$1,
        of_int_exn,
        rem
    ]), symbol$12 = include$3[1], symbol$13 = include$3[2], symbol$14 = include$3[3], round = include$3[4], round_towards_zero = include$3[5], round_down = include$3[6], round_up = include$3[7], round_nearest = include$3[8], include$4 = Base_Import[104], symbol$15 = include$4[1], symbol$16 = include$4[2], symbol$17 = include$4[3], symbol$18 = include$4[4], symbol$19 = include$4[5], symbol$20 = include$4[6], ascending = include$4[7], descending = include$4[8], compare$3 = include$4[9], compare_local$1 = include$4[10], equal$0 = include$4[11], equal_local$0 = include$4[12], max = include$4[13], min = include$4[14], Base_Nativeint = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int_exn,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$0,
        of_string,
        to_string,
        symbol$20,
        symbol$16,
        symbol$18,
        symbol$19,
        symbol$15,
        symbol$17,
        equal$0,
        compare$3,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        compare_local$1,
        equal_local$0,
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        zero$1,
        one,
        minus_one,
        symbol$4,
        symbol$3,
        symbol$2,
        symbol$5,
        symbol$0,
        symbol$0,
        symbol$13,
        symbol$12,
        symbol$1,
        rem,
        symbol$14,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        shift_left,
        shift_right,
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        abs,
        succ,
        pred,
        pow,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32,
        to_int32_exn,
        of_int64_exn,
        to_int64,
        of_nativeint,
        to_nativeint,
        of_float_unchecked,
        num_bits,
        max_value,
        min_value,
        shift_right_logical,
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        floor_log2,
        is_pow2,
        function(_i_) {
            return runtime.Base_int_math_nativeint_clz(_i_);
        },
        function(_h_) {
            return runtime.Base_int_math_nativeint_ctz(_h_);
        },
        [
            0,
            symbol$4,
            symbol$3,
            symbol$2,
            symbol$1,
            symbol$0,
            symbol$5,
            symbol$11,
            symbol$10,
            symbol$9,
            symbol$8,
            symbol$7,
            symbol$6,
            abs,
            symbol$0,
            zero$1,
            symbol$12,
            symbol$13,
            symbol$14,
            bit_and,
            bit_or,
            bit_xor,
            bit_not,
            shift_left,
            shift_right,
            shift_right_logical
        ],
        of_int_exn,
        to_int,
        of_int32,
        to_int32,
        of_nativeint,
        to_nativeint,
        of_int64,
        to_int_trunc,
        of_int64_trunc,
        runtime.caml_int32_bswap
    ];
    runtime.caml_register_global(35, Base_Nativeint, "Base__Nativeint");
    return;
})(globalThis);
//# 36328 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", cst_Lx = "%Lx", cst_argument_must_be_strictly_ = "argument must be strictly positive", caml_equal = runtime.caml_equal, caml_greaterthan = runtime.caml_greaterthan, caml_int64_add = runtime.caml_int64_add, caml_int64_and = runtime.caml_int64_and, caml_int64_bswap = runtime.caml_int64_bswap, caml_int64_compare = runtime.caml_int64_compare, caml_int64_neg = runtime.caml_int64_neg, caml_int64_of_float = runtime.caml_int64_of_float, caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_or = runtime.caml_int64_or, caml_int64_shift_right_unsigne = runtime.caml_int64_shift_right_unsigned, caml_int64_sub = runtime.caml_int64_sub, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, module_name = "Base.Int64.Hex", module_name$0 = "Base.Int64", Stdlib_Scanf = global_data.Stdlib__Scanf, Base_Printf = global_data.Base__Printf, Stdlib_Int64 = global_data.Stdlib__Int64, Base_Import = global_data.Base__Import, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Float0 = global_data.Base__Float0, Base_Comparator = global_data.Base__Comparator, Base_Int_math = global_data.Base__Int_math, Base_Comparable = global_data.Base__Comparable, Base_Popcount = global_data.Base__Popcount, Base_Int_conversions = global_data.Base__Int_conversions, Base_Error = global_data.Base__Error, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Pretty_printer = global_data.Base__Pretty_printer, globalize = Base_Import[286], hash_fold_t = Base_Import[203], func = Base_Import[217];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[166], sexp_of_t = Base_Import[142], t_sexp_grammar = Base_Import[188], hashable = [
        0,
        hash,
        Stdlib_Int64[15],
        sexp_of_t
    ];
    function compare(_C_, _B_) {
        return caml_int64_compare(_C_, _B_);
    }
    var to_string = Stdlib_Int64[14], of_string = runtime.caml_int64_of_string, of_string_opt = Stdlib_Int64[13], include = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ]), comparator = include[1], num_bits = 64, float_lower_bound = caml_call1(Base_Float0[26], num_bits), float_upper_bound = caml_call1(Base_Float0[24], num_bits), shift_right_logical = caml_int64_shift_right_unsigne, shift_right = runtime.caml_int64_shift_right, shift_left = runtime.caml_int64_shift_left, bit_not = Stdlib_Int64[11], bit_xor = runtime.caml_int64_xor, bit_or = caml_int64_or, bit_and = caml_int64_and, min_value = Stdlib_Int64[10], max_value = Stdlib_Int64[9], abs = Stdlib_Int64[8], pred = Stdlib_Int64[7], succ = Stdlib_Int64[6], symbol = Base_Int_math[2][2], rem = runtime.caml_int64_mod, neg = caml_int64_neg, minus_one = Stdlib_Int64[3], one = Stdlib_Int64[2], zero = Stdlib_Int64[1], to_float = runtime.caml_int64_to_float, of_float_unchecked = caml_int64_of_float, _a_ = [
        0,
        [
            11,
            "Int64.of_float: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Int64.of_float: argument (%f) is out of range or NaN"
    ];
    function of_float(f) {
        if (float_lower_bound <= f && f <= float_upper_bound) return caml_int64_of_float(f);
        var _A_ = caml_call1(Base_Float0[29], f);
        return caml_call3(Base_Printf[7], _a_, _A_, 0);
    }
    function bswap16(x) {
        return caml_int64_shift_right_unsigne(caml_int64_bswap(x), 48);
    }
    function bswap32(x) {
        return caml_int64_shift_right_unsigne(caml_int64_bswap(x), 32);
    }
    function bswap48(x) {
        return caml_int64_shift_right_unsigne(caml_int64_bswap(x), 16);
    }
    var include$0 = caml_call1(Base_Comparable[14], [
        0,
        compare,
        sexp_of_t,
        zero
    ]), is_positive = include$0[1], is_non_negative = include$0[2], is_negative = include$0[3], is_non_positive = include$0[4], sign = include$0[5], _b_ = [
        0,
        "src/int64.ml",
        115,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function invariant(param) {
        return 0;
    }
    function between(t, low, high) {
        var _y_ = caml_lessequal(low, t), _z_ = _y_ ? caml_lessequal(t, high) : _y_;
        return _z_;
    }
    function clamp_unchecked(t, min, max) {
        var _x_ = caml_call2(Base_Import[103][4], t, max);
        return caml_call1(caml_call1(Base_Import[103][3], min), _x_);
    }
    function clamp_exn(t, min, max) {
        if (caml_lessequal(min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_greaterthan(min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _u_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _v_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _u_
        ], _w_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _v_);
        return caml_call1(Base_Or_error[39], _w_);
    }
    function incr(r) {
        r[1] = caml_int64_add(r[1], one);
        return 0;
    }
    function decr(r) {
        r[1] = caml_int64_sub(r[1], one);
        return 0;
    }
    function of_int64_exn(_t_) {
        return _t_;
    }
    function to_int64(t) {
        return t;
    }
    var popcount = Base_Popcount[3], of_int_exn = caml_int64_of_int32, to_int = Base_Int_conversions[12], to_int_exn = Base_Int_conversions[13], of_int32_exn = caml_int64_of_int32, to_int32 = Base_Int_conversions[15], to_int32_exn = Base_Int_conversions[16], of_nativeint_exn = caml_int64_of_int32, to_nativeint = Base_Int_conversions[18], to_nativeint_exn = Base_Int_conversions[19], raise_s = Base_Error[32], _c_ = [
        0,
        [
            11,
            cst_argument_must_be_strictly_,
            0
        ],
        cst_argument_must_be_strictly_
    ];
    function non_positive_argument(param) {
        return caml_call2(Base_Printf[7], _c_, 0);
    }
    var lsr = caml_int64_shift_right_unsigne, land = caml_int64_and, cst_Int64_floor_log2_got_inval = "[Int64.floor_log2] got invalid input", cst_Int64_ceil_log2_got_invali = "[Int64.ceil_log2] got invalid input";
    function ceil_pow2(x) {
        if (caml_lessequal(x, Stdlib_Int64[1])) non_positive_argument(0);
        var x$0 = caml_call1(Stdlib_Int64[7], x), x$6 = caml_int64_or(x$0, caml_int64_shift_right_unsigne(x$0, 1)), x$5 = caml_int64_or(x$6, caml_int64_shift_right_unsigne(x$6, 2)), x$4 = caml_int64_or(x$5, caml_int64_shift_right_unsigne(x$5, 4)), x$3 = caml_int64_or(x$4, caml_int64_shift_right_unsigne(x$4, 8)), x$2 = caml_int64_or(x$3, caml_int64_shift_right_unsigne(x$3, 16)), x$1 = caml_int64_or(x$2, caml_int64_shift_right_unsigne(x$2, 32));
        return caml_call1(Stdlib_Int64[6], x$1);
    }
    function floor_pow2(x$0) {
        if (caml_lessequal(x$0, Stdlib_Int64[1])) non_positive_argument(0);
        var x = caml_int64_or(x$0, caml_int64_shift_right_unsigne(x$0, 1)), x$5 = caml_int64_or(x, caml_int64_shift_right_unsigne(x, 2)), x$4 = caml_int64_or(x$5, caml_int64_shift_right_unsigne(x$5, 4)), x$3 = caml_int64_or(x$4, caml_int64_shift_right_unsigne(x$4, 8)), x$2 = caml_int64_or(x$3, caml_int64_shift_right_unsigne(x$3, 16)), x$1 = caml_int64_or(x$2, caml_int64_shift_right_unsigne(x$2, 32));
        return caml_int64_sub(x$1, caml_int64_shift_right_unsigne(x$1, 1));
    }
    function is_pow2(x) {
        if (caml_lessequal(x, Stdlib_Int64[1])) non_positive_argument(0);
        var _s_ = Stdlib_Int64[1];
        return caml_equal(caml_int64_and(x, caml_call1(Stdlib_Int64[7], x)), _s_);
    }
    function floor_log2(i) {
        if (caml_lessequal(i, Stdlib_Int64[1])) {
            var _p_ = [
                0,
                [
                    0,
                    cst,
                    caml_call1(Base_Import[142], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int64_floor_log2_got_inval, _p_));
        }
        var _q_ = runtime.Base_int_math_int64_clz(i), _r_ = caml_call2(Base_Import[93], num_bits, 1);
        return caml_call2(Base_Import[93], _r_, _q_);
    }
    function ceil_log2(i) {
        if (caml_lessequal(i, Stdlib_Int64[1])) {
            var _n_ = [
                0,
                [
                    0,
                    cst$0,
                    caml_call1(Base_Import[142], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int64_ceil_log2_got_invali, _n_));
        }
        if (caml_call2(Stdlib_Int64[17], i, Stdlib_Int64[2])) return 0;
        var _o_ = runtime.Base_int_math_int64_clz(caml_call1(Stdlib_Int64[7], i));
        return caml_call2(Base_Import[93], num_bits, _o_);
    }
    var include$1 = caml_call1(Base_Int_string_conversions[1], [
        0,
        to_string
    ]), to_string_hum = include$1[1], sexp_of_t$0 = include$1[2], compare_local = Base_Import[258];
    function compare$0(a, b) {
        return caml_call2(compare_local, a, b);
    }
    var hash_fold_t$0 = Base_Import[203], func$0 = Base_Import[217];
    function hash$0(x) {
        return caml_call1(func$0, x);
    }
    var symbol$0 = caml_lessthan, _d_ = [
        0,
        [
            7,
            6,
            0,
            0,
            0
        ],
        cst_Lx
    ], _e_ = [
        0,
        [
            7,
            6,
            0,
            0,
            0
        ],
        cst_Lx
    ];
    function to_string$0(i) {
        return caml_call2(Base_Printf[2], _d_, i);
    }
    function of_string$0(s) {
        return caml_call3(Stdlib_Scanf[5], s, _e_, function(_m_) {
            return _m_;
        });
    }
    var include$2 = caml_call1(Base_Int_string_conversions[2], [
        0,
        compare$0,
        compare_local,
        hash_fold_t$0,
        hash$0,
        to_string$0,
        of_string$0,
        zero,
        symbol$0,
        neg,
        module_name
    ]), Hex = include$2[1], compare_local$0 = Base_Import[258];
    function compare$1(a, b) {
        return caml_call2(compare_local$0, a, b);
    }
    var equal_local = Base_Import[272];
    function equal(a, b) {
        return caml_call2(equal_local, a, b);
    }
    var hash_fold_t$1 = Base_Import[203], func$1 = Base_Import[217];
    function hash$1(x) {
        return caml_call1(func$1, x);
    }
    function clz(_l_) {
        return runtime.Base_int_math_int64_clz(_l_);
    }
    var include$3 = caml_call1(Base_Int_string_conversions[3], [
        0,
        compare$1,
        compare_local$0,
        equal,
        equal_local,
        hash_fold_t$1,
        hash$1,
        clz,
        lsr,
        land,
        to_int_exn,
        num_bits,
        one,
        zero
    ]), Binary = include$3[1], pp = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name$0,
        to_string
    ])[1], include$4 = caml_call1(Base_Int_math[1], [
        0,
        of_float,
        to_float,
        of_string,
        to_string,
        caml_int64_add,
        caml_int64_sub,
        runtime.caml_int64_mul,
        runtime.caml_int64_div,
        caml_int64_neg,
        runtime.caml_greaterequal,
        caml_lessequal,
        caml_equal,
        caml_greaterthan,
        caml_lessthan,
        runtime.caml_notequal,
        abs,
        caml_int64_neg,
        zero,
        of_int_exn,
        rem
    ]), symbol$1 = include$4[1], symbol$2 = include$4[2], symbol$3 = include$4[3], round = include$4[4], round_towards_zero = include$4[5], round_down = include$4[6], round_up = include$4[7], round_nearest = include$4[8], include$5 = Base_Import[103], ascending = include$5[1], descending = include$5[2], max = include$5[3], min = include$5[4], Base_Int64 = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int_exn,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$0,
        of_string,
        to_string,
        caml_equal,
        function(_k_, _j_) {
            return caml_int64_compare(_k_, _j_);
        },
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        function(_i_, _h_) {
            return caml_int64_compare(_i_, _h_);
        },
        caml_equal,
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        one,
        minus_one,
        rem,
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        succ,
        pred,
        symbol,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32_exn,
        to_int32_exn,
        of_int64_exn,
        to_int64,
        of_nativeint_exn,
        to_nativeint_exn,
        of_float_unchecked,
        num_bits,
        max_value,
        min_value,
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        floor_log2,
        is_pow2,
        function(_g_) {
            return runtime.Base_int_math_int64_clz(_g_);
        },
        function(_f_) {
            return runtime.Base_int_math_int64_ctz(_f_);
        },
        [
            0,
            symbol,
            bit_not,
            abs,
            zero,
            symbol$1,
            symbol$2,
            symbol$3
        ],
        symbol,
        bit_not,
        abs,
        zero,
        symbol$1,
        symbol$2,
        symbol$3,
        to_int,
        to_int32,
        to_nativeint,
        bswap16,
        bswap32,
        bswap48
    ];
    runtime.caml_register_global(30, Base_Int64, "Base__Int64");
    return;
})(globalThis);
//# 36754 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_int63_emul_ml = "src/int63_emul.ml", caml_equal = runtime.caml_equal, caml_greaterequal = runtime.caml_greaterequal, caml_greaterthan = runtime.caml_greaterthan, caml_int64_add = runtime.caml_int64_add, caml_int64_and = runtime.caml_int64_and, caml_int64_compare = runtime.caml_int64_compare, caml_int64_mul = runtime.caml_int64_mul, caml_int64_neg = runtime.caml_int64_neg, caml_int64_of_float = runtime.caml_int64_of_float, caml_int64_of_string = runtime.caml_int64_of_string, caml_int64_shift_right = runtime.caml_int64_shift_right, caml_int64_shift_right_unsigne = runtime.caml_int64_shift_right_unsigned, caml_int64_sub = runtime.caml_int64_sub, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_notequal = runtime.caml_notequal, caml_string_get = runtime.caml_string_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), _c_ = runtime.caml_int64_create_lo_mi_hi(2, 0, 0), mask = runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535), module_name = "Base.Int63.Hex", module_name$0 = "Base.Int63", Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, Base_Int_conversions = global_data.Base__Int_conversions, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Float0 = global_data.Base__Float0, Base_Int64 = global_data.Base__Int64, Base_String = global_data.Base__String, Stdlib_Int64 = global_data.Stdlib__Int64, Base_Popcount = global_data.Base__Popcount, Base_Comparator = global_data.Base__Comparator, Base_Int_math = global_data.Base__Int_math, Base_Comparable = global_data.Base__Comparable, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Pretty_printer = global_data.Base__Pretty_printer, include = Base_Import[103], max = include[3], min = include[4], compare_local = Base_Import[258];
    function compare(a, b) {
        return caml_call2(compare_local, a, b);
    }
    var globalize = Base_Import[286], hash_fold_t = Base_Import[203], sexp_of_t = Base_Import[142], t_sexp_grammar = Base_Import[188], include$0 = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ]), comparator = include$0[1], _a_ = runtime.caml_int64_create_lo_mi_hi(2, 0, 0), _e_ = [
        0,
        cst_src_int63_emul_ml,
        117,
        20
    ];
    function wrap_exn(x) {
        caml_call1(Base_Int_conversions[21], x);
        return caml_int64_mul(x, _a_);
    }
    function unwrap(x) {
        return caml_int64_shift_right(x, 1);
    }
    function invariant(t) {
        if (caml_equal(caml_int64_and(t, mask), t)) return 0;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
    }
    var symbol = caml_int64_add, symbol$0 = caml_int64_sub, symbol$1 = caml_int64_neg;
    function abs(x) {
        return caml_call1(Stdlib_Int64[8], x);
    }
    var one = wrap_exn(runtime.caml_int64_create_lo_mi_hi(1, 0, 0));
    function succ(a) {
        return caml_int64_add(a, one);
    }
    function pred(a) {
        return caml_int64_sub(a, one);
    }
    var x = Stdlib_Int64[10], min_value = caml_int64_and(x, mask), x$0 = Stdlib_Int64[9], max_value = caml_int64_and(x$0, mask);
    function bit_not(x) {
        var x$0 = caml_call1(Stdlib_Int64[11], x);
        return caml_int64_and(x$0, mask);
    }
    var bit_and = caml_int64_and, bit_xor = runtime.caml_int64_xor, bit_or = runtime.caml_int64_or, shift_left = runtime.caml_int64_shift_left;
    function shift_right(x, i) {
        var x$0 = caml_int64_shift_right(x, i);
        return caml_int64_and(x$0, mask);
    }
    function shift_right_logical(x, i) {
        var x$0 = caml_int64_shift_right_unsigne(x, i);
        return caml_int64_and(x$0, mask);
    }
    var f = Base_Int_math[2][3], _d_ = runtime.caml_int64_create_lo_mi_hi(2, 0, 0);
    function pow(a, b) {
        return caml_int64_mul(caml_call2(f, caml_int64_shift_right(a, 1), caml_int64_shift_right(b, 1)), _d_);
    }
    function symbol$2(a, b) {
        return caml_int64_mul(a, caml_int64_shift_right(b, 1));
    }
    function symbol$3(a, b) {
        var x = runtime.caml_int64_div(a, b);
        return caml_int64_mul(x, _c_);
    }
    var rem = runtime.caml_int64_mod, _b_ = runtime.caml_int64_create_lo_mi_hi(2, 0, 0);
    function popcount(x) {
        return caml_call1(Base_Popcount[3], x);
    }
    function to_int64(t) {
        return caml_int64_shift_right(t, 1);
    }
    function of_int64(t) {
        return caml_call1(Base_Int_conversions[22], t) ? [
            0,
            caml_int64_mul(t, _b_)
        ] : 0;
    }
    function of_int64_exn(t) {
        return wrap_exn(t);
    }
    function of_int64_trunc(t) {
        return caml_int64_mul(t, _c_);
    }
    function t_of_sexp(x) {
        return wrap_exn(caml_call1(Base_Import[166], x));
    }
    function sexp_of_t$0(x) {
        return caml_call1(Base_Import[142], caml_int64_shift_right(x, 1));
    }
    function compare$0(x, y) {
        return caml_call2(compare_local, x, y);
    }
    function compare_local$0(x, y) {
        return caml_call2(compare_local, x, y);
    }
    var equal_local = caml_equal;
    function is_pow2(x) {
        return caml_call1(Base_Int64[72], caml_int64_shift_right(x, 1));
    }
    function clz(x) {
        return caml_call1(Base_Int64[73], x);
    }
    function ctz(x) {
        return caml_call1(Base_Int64[74], caml_int64_shift_right(x, 1));
    }
    function floor_pow2(x) {
        return wrap_exn(caml_call1(Base_Int64[69], caml_int64_shift_right(x, 1)));
    }
    function ceil_pow2(x) {
        return wrap_exn(caml_call1(Base_Int64[69], caml_int64_shift_right(x, 1)));
    }
    function floor_log2(x) {
        return caml_call1(Base_Int64[71], caml_int64_shift_right(x, 1));
    }
    function ceil_log2(x) {
        return caml_call1(Base_Int64[70], caml_int64_shift_right(x, 1));
    }
    function hash(x) {
        return caml_call1(Base_Import[85][105][28], x);
    }
    var hashable = [
        0,
        hash,
        compare$0,
        sexp_of_t$0
    ], _f_ = [
        0,
        [
            11,
            "Int63.of_string: invalid input ",
            [
                3,
                0,
                0
            ]
        ],
        "Int63.of_string: invalid input %S"
    ], _g_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0);
    function invalid_str(x) {
        return caml_call3(Base_Printf[6], _f_, x, 0);
    }
    function to_string(x) {
        return caml_call1(Stdlib_Int64[14], caml_int64_shift_right(x, 1));
    }
    function of_string_raw(str) {
        var len = caml_ml_string_length(str);
        a: if (0 < len) {
            var switcher = caml_string_get(str, 0) - 43 | 0;
            if (2 >= switcher >>> 0) switch(switcher){
                case 0:
                    var sign = 4003188, pos = 1;
                    break a;
                case 1:
                    break;
                default:
                    var sign = 3901488, pos = 1;
                    break a;
            }
            var sign = 4003188, pos = 0;
        } else var sign = 4003188, pos = 0;
        if (caml_call2(Base_Import[91], pos, 2) < len) var c1 = caml_string_get(str, pos), c2 = caml_string_get(str, caml_call2(Base_Import[91], pos, 1)), match = 48 === c1 ? 9 < c2 - 48 >>> 0 ? [
            0,
            ,
            0
        ] : [
            0,
            ,
            1
        ] : [
            0,
            ,
            1
        ];
        else var match = [
            0,
            ,
            1
        ];
        var signedness = match[2];
        if (signedness) {
            var t = caml_int64_of_string(str);
            return wrap_exn(t);
        }
        if (4003188 <= sign) var pos_str = str;
        else var _z_ = caml_call2(Base_Import[93], caml_ml_string_length(str), 1), pos_str = caml_call3(Base_String[3], str, 1, _z_);
        var int64 = caml_int64_of_string(pos_str);
        if (caml_lessthan(int64, _g_)) invalid_str(str);
        var int63 = caml_int64_mul(int64, _c_);
        return 4003188 <= sign ? int63 : caml_int64_neg(int63);
    }
    function of_string(str) {
        try {
            var _x_ = of_string_raw(str);
            return _x_;
        } catch (_y_) {
            return invalid_str(str);
        }
    }
    function of_string_opt(str) {
        try {
            var t = of_string_raw(str);
        } catch (_w_) {
            return 0;
        }
        return [
            0,
            t
        ];
    }
    function bswap16(t) {
        var x = caml_call1(Base_Int64[86], caml_int64_shift_right(t, 1));
        return caml_int64_mul(x, _c_);
    }
    function bswap32(t) {
        var x = caml_call1(Base_Int64[87], caml_int64_shift_right(t, 1));
        return caml_int64_mul(x, _c_);
    }
    function bswap48(t) {
        var x = caml_call1(Base_Int64[88], caml_int64_shift_right(t, 1));
        return caml_int64_mul(x, _c_);
    }
    var num_bits = 63, float_lower_bound = caml_call1(Base_Float0[26], num_bits), float_upper_bound = caml_call1(Base_Float0[24], num_bits), minus_one = wrap_exn(Stdlib_Int64[3]), one$0 = wrap_exn(Stdlib_Int64[2]), zero = wrap_exn(Stdlib_Int64[1]), _h_ = [
        0,
        [
            11,
            "Int63.of_float: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Int63.of_float: argument (%f) is out of range or NaN"
    ];
    function to_float(x) {
        return runtime.caml_int64_to_float(caml_int64_shift_right(x, 1));
    }
    function of_float_unchecked(x) {
        var x$0 = caml_int64_of_float(x);
        return caml_int64_mul(x$0, _c_);
    }
    function of_float(t) {
        if (float_lower_bound <= t && t <= float_upper_bound) {
            var x = caml_int64_of_float(t);
            return caml_int64_mul(x, _c_);
        }
        var _v_ = caml_call1(Base_Float0[29], t);
        return caml_call3(Base_Printf[7], _h_, _v_, 0);
    }
    var _i_ = caml_call1(Base_Comparable[14], [
        0,
        compare$0,
        sexp_of_t$0,
        zero
    ]), is_positive = _i_[1], is_non_negative = _i_[2], is_negative = _i_[3], is_non_positive = _i_[4], sign = _i_[5], _j_ = [
        0,
        cst_src_int63_emul_ml,
        334,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function between(t, low, high) {
        var _t_ = caml_lessequal(low, t), _u_ = _t_ ? caml_lessequal(t, high) : _t_;
        return _u_;
    }
    function clamp_unchecked(t, min$0, max$0) {
        var _s_ = caml_call2(min, t, max$0);
        return caml_call1(caml_call1(max, min$0), _s_);
    }
    function clamp_exn(t, min, max) {
        if (caml_lessequal(min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _j_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_greaterthan(min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _p_ = [
            0,
            [
                0,
                cst_max,
                sexp_of_t$0(max)
            ],
            0
        ], _q_ = [
            0,
            [
                0,
                cst_min,
                sexp_of_t$0(min)
            ],
            _p_
        ], _r_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _q_);
        return caml_call1(Base_Or_error[39], _r_);
    }
    function symbol$4(b, e) {
        return pow(b, e);
    }
    function incr(r) {
        var x = r[1];
        r[1] = caml_int64_add(x, one$0);
        return 0;
    }
    function decr(r) {
        var x = r[1];
        r[1] = caml_int64_sub(x, one$0);
        return 0;
    }
    function of_int(x) {
        return wrap_exn(caml_call1(Base_Int_conversions[4], x));
    }
    function of_int_exn(x) {
        return of_int(x);
    }
    function to_int(x) {
        return caml_call1(Base_Int_conversions[12], caml_int64_shift_right(x, 1));
    }
    function to_int_exn(x) {
        return caml_call1(Base_Int_conversions[13], caml_int64_shift_right(x, 1));
    }
    function to_int_trunc(x) {
        return caml_call1(Base_Int_conversions[14], caml_int64_shift_right(x, 1));
    }
    function of_int32(x) {
        return wrap_exn(caml_call1(Base_Int_conversions[9], x));
    }
    function of_int32_exn(x) {
        return of_int32(x);
    }
    function to_int32(x) {
        return caml_call1(Base_Int_conversions[15], caml_int64_shift_right(x, 1));
    }
    function to_int32_exn(x) {
        return caml_call1(Base_Int_conversions[16], caml_int64_shift_right(x, 1));
    }
    function to_int32_trunc(x) {
        return caml_call1(Base_Int_conversions[17], caml_int64_shift_right(x, 1));
    }
    function of_nativeint(x) {
        return of_int64(caml_call1(Base_Int_conversions[29], x));
    }
    function of_nativeint_exn(x) {
        return wrap_exn(caml_call1(Base_Int_conversions[29], x));
    }
    function of_nativeint_trunc(x) {
        var t = caml_call1(Base_Int_conversions[29], x);
        return caml_int64_mul(t, _c_);
    }
    function to_nativeint(x) {
        return caml_call1(Base_Int_conversions[18], caml_int64_shift_right(x, 1));
    }
    function to_nativeint_exn(x) {
        return caml_call1(Base_Int_conversions[19], caml_int64_shift_right(x, 1));
    }
    function to_nativeint_trunc(x) {
        return caml_call1(Base_Int_conversions[20], caml_int64_shift_right(x, 1));
    }
    var include$1 = caml_call1(Base_Int_string_conversions[1], [
        0,
        to_string
    ]), to_string_hum = include$1[1], sexp_of_t$1 = include$1[2];
    function compare$1(a, b) {
        return caml_call2(compare_local, a, b);
    }
    function hash$0(x) {
        return hash(x);
    }
    var symbol$5 = caml_lessthan, _k_ = [
        0,
        [
            7,
            6,
            0,
            0,
            0
        ],
        "%Lx"
    ], cst_0x = "0x";
    function to_string$0(i) {
        return caml_call2(Base_Printf[2], _k_, caml_int64_shift_right_unsigne(i, 1));
    }
    function of_string$0(s) {
        return of_string(caml_call2(Base_Import[112], cst_0x, s));
    }
    var include$2 = caml_call1(Base_Int_string_conversions[2], [
        0,
        compare$1,
        compare_local$0,
        hash_fold_t,
        hash$0,
        to_string$0,
        of_string$0,
        zero,
        symbol$5,
        symbol$1,
        module_name
    ]), Hex = include$2[1];
    function to_string$1(x) {
        return to_string(x);
    }
    var pp = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name$0,
        to_string$1
    ])[1], symbol$6 = caml_notequal, symbol$7 = caml_lessthan, symbol$8 = caml_greaterthan, symbol$9 = caml_equal, symbol$10 = caml_lessequal, symbol$11 = caml_greaterequal, include$3 = caml_call1(Base_Int_math[1], [
        0,
        of_float,
        to_float,
        of_string,
        to_string,
        symbol,
        symbol$0,
        symbol$2,
        symbol$3,
        symbol$1,
        symbol$11,
        symbol$10,
        symbol$9,
        symbol$8,
        symbol$7,
        symbol$6,
        abs,
        symbol$1,
        zero,
        of_int_exn,
        rem
    ]), symbol$12 = include$3[1], symbol$13 = include$3[2], symbol$14 = include$3[3], round = include$3[4], round_towards_zero = include$3[5], round_down = include$3[6], round_up = include$3[7], round_nearest = include$3[8];
    function compare$2(a, b) {
        return caml_call2(compare_local, a, b);
    }
    function equal(a, b) {
        return caml_equal(a, b);
    }
    function hash$1(x) {
        return hash(x);
    }
    var include$4 = caml_call1(Base_Int_string_conversions[3], [
        0,
        compare$2,
        compare_local$0,
        equal,
        equal_local,
        hash_fold_t,
        hash$1,
        clz,
        shift_right_logical,
        bit_and,
        to_int_exn,
        num_bits,
        one$0,
        zero
    ]), Binary = include$4[1], Repr = [
        0
    ], include$5 = Base_Import[103], ascending = include$5[1], descending = include$5[2], max$0 = include$5[3], min$0 = include$5[4], Base_Int63_emul = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int_exn,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$1,
        of_string,
        to_string,
        caml_greaterequal,
        caml_lessequal,
        caml_equal,
        caml_greaterthan,
        caml_lessthan,
        caml_notequal,
        caml_equal,
        function(_o_, _n_) {
            return caml_int64_compare(_o_, _n_);
        },
        min$0,
        max$0,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        function(_m_, _l_) {
            return caml_int64_compare(_m_, _l_);
        },
        caml_equal,
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        zero,
        one$0,
        minus_one,
        symbol,
        symbol$0,
        symbol$2,
        symbol$4,
        symbol$1,
        symbol$1,
        symbol$13,
        symbol$12,
        symbol$3,
        rem,
        symbol$14,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        shift_left,
        shift_right,
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        abs,
        succ,
        pred,
        pow,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32_exn,
        to_int32_exn,
        of_int64_exn,
        to_int64,
        of_nativeint_exn,
        to_nativeint_exn,
        of_float_unchecked,
        num_bits,
        max_value,
        min_value,
        shift_right_logical,
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        floor_log2,
        is_pow2,
        clz,
        ctz,
        [
            0,
            symbol,
            symbol$0,
            symbol$2,
            symbol$3,
            symbol$1,
            symbol$4,
            symbol$11,
            symbol$10,
            symbol$9,
            symbol$8,
            symbol$7,
            symbol$6,
            abs,
            symbol$1,
            zero,
            symbol$12,
            symbol$13,
            symbol$14,
            bit_and,
            bit_or,
            bit_xor,
            bit_not,
            shift_left,
            shift_right,
            shift_right_logical
        ],
        of_int,
        to_int,
        to_int_trunc,
        of_int32,
        to_int32,
        to_int32_trunc,
        of_int64,
        of_int64_trunc,
        of_nativeint,
        to_nativeint,
        of_nativeint_trunc,
        to_nativeint_trunc,
        bswap16,
        bswap32,
        bswap48,
        [
            0,
            wrap_exn,
            unwrap
        ],
        Repr,
        1
    ];
    runtime.caml_register_global(34, Base_Int63_emul, "Base__Int63_emul");
    return;
})(globalThis);
//# 37356 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", cst_lx = "%lx", cst_argument_must_be_strictly_ = "argument must be strictly positive", caml_equal = runtime.caml_equal, caml_greaterequal = runtime.caml_greaterequal, caml_greaterthan = runtime.caml_greaterthan, caml_int32_bswap = runtime.caml_int32_bswap, caml_lessequal = runtime.caml_lessequal, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, module_name = "Base.Int32.Hex", module_name$0 = "Base.Int32", Stdlib_Scanf = global_data.Stdlib__Scanf, Base_Printf = global_data.Base__Printf, Stdlib_Int32 = global_data.Stdlib__Int32, Base_Import = global_data.Base__Import, Base_Sexp = global_data.Base__Sexp, Base_Int_math = global_data.Base__Int_math, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Float0 = global_data.Base__Float0, Base_Comparator = global_data.Base__Comparator, Base_Comparable = global_data.Base__Comparable, Base_Popcount = global_data.Base__Popcount, Base_Int_conversions = global_data.Base__Int_conversions, Base_Error = global_data.Base__Error, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Pretty_printer = global_data.Base__Pretty_printer, globalize = Base_Import[285], hash_fold_t = Base_Import[204], func = Base_Import[218];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[165], sexp_of_t = Base_Import[141], t_sexp_grammar = Base_Import[187], hashable = [
        0,
        hash,
        Stdlib_Int32[15],
        sexp_of_t
    ];
    function ascending(x, y) {
        return caml_call2(Stdlib_Int32[15], x, y);
    }
    var to_string = Stdlib_Int32[14], of_string = runtime.caml_int_of_string, of_string_opt = Stdlib_Int32[13], include = caml_call1(Base_Comparator[7], [
        0,
        ascending,
        sexp_of_t
    ]), comparator = include[1], num_bits = 32, float_lower_bound = caml_call1(Base_Float0[26], num_bits), float_upper_bound = caml_call1(Base_Float0[24], num_bits), float_of_bits = runtime.caml_int32_float_of_bits, bits_of_float = runtime.caml_int32_bits_of_float;
    function shift_right_logical(_T_1, _S_) {
        return _T_1 >>> _S_ | 0;
    }
    function shift_right(_R_, _Q_) {
        return _R_ >> _Q_;
    }
    function shift_left(_P_, _O_) {
        return _P_ << _O_;
    }
    var bit_not = Stdlib_Int32[11];
    function bit_xor(_N_, _M_) {
        return _N_ ^ _M_;
    }
    function bit_or(_L_, _K_) {
        return _L_ | _K_;
    }
    function bit_and(_J_, _I_) {
        return _J_ & _I_;
    }
    var min_value = Stdlib_Int32[10], max_value = Stdlib_Int32[9], abs = Stdlib_Int32[8], pred = Stdlib_Int32[7], succ = Stdlib_Int32[6], rem = runtime.caml_mod;
    function symbol(_H_) {
        return -_H_ | 0;
    }
    var minus_one = Stdlib_Int32[3], one = Stdlib_Int32[2], zero = Stdlib_Int32[1], compare_local = runtime.caml_compare, _a_ = [
        0,
        [
            11,
            "Int32.of_float: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Int32.of_float: argument (%f) is out of range or NaN"
    ];
    function to_float(_G_) {
        return _G_;
    }
    function of_float_unchecked(_F_) {
        return _F_ | 0;
    }
    function of_float(f) {
        if (float_lower_bound <= f && f <= float_upper_bound) return f | 0;
        var _E_ = caml_call1(Base_Float0[29], f);
        return caml_call3(Base_Printf[7], _a_, _E_, 0);
    }
    var include$0 = caml_call1(Base_Comparable[14], [
        0,
        ascending,
        sexp_of_t,
        zero
    ]), is_positive = include$0[1], is_non_negative = include$0[2], is_negative = include$0[3], is_non_positive = include$0[4], sign = include$0[5], symbol$0 = caml_greaterequal, symbol$1 = caml_lessequal, symbol$2 = caml_equal, symbol$3 = caml_greaterthan, symbol$4 = runtime.caml_lessthan, symbol$5 = runtime.caml_notequal;
    function descending(x, y) {
        return ascending(y, x);
    }
    function min(x, y) {
        return runtime.caml_csel_value(caml_lessequal(x, y), x, y);
    }
    function max(x, y) {
        return runtime.caml_csel_value(caml_greaterequal(x, y), x, y);
    }
    function equal(x, y) {
        return caml_equal(x, y);
    }
    var equal_local = caml_equal, _b_ = [
        0,
        "src/int32.ml",
        103,
        4
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function between(t, low, high) {
        var _D_ = caml_lessequal(low, t);
        return _D_ ? caml_lessequal(t, high) : _D_;
    }
    function clamp_unchecked(t, min$0, max$0) {
        return max(min$0, min(t, max$0));
    }
    function clamp_exn(t, min, max) {
        if (caml_lessequal(min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_greaterthan(min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _A_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _B_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _A_
        ], _C_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _B_);
        return caml_call1(Base_Or_error[39], _C_);
    }
    function invariant(param) {
        return 0;
    }
    var symbol$6 = runtime.caml_div, symbol$7 = runtime.caml_mul;
    function symbol$8(_z_, _y_) {
        return _z_ - _y_ | 0;
    }
    function symbol$9(_x_, _w_) {
        return _x_ + _w_ | 0;
    }
    function incr(r) {
        r[1] = r[1] + one | 0;
        return 0;
    }
    function decr(r) {
        r[1] = r[1] - one | 0;
        return 0;
    }
    function of_int32(t) {
        return t;
    }
    function to_int32(t) {
        return t;
    }
    var popcount = Base_Popcount[2], of_int = Base_Int_conversions[1], of_int_exn = Base_Int_conversions[2], of_int_trunc = Base_Int_conversions[3], to_int = Base_Int_conversions[6], to_int_exn = Base_Int_conversions[7], to_int_trunc = Base_Int_conversions[8], of_int64 = Base_Int_conversions[15], of_int64_exn = Base_Int_conversions[16], of_int64_trunc = Base_Int_conversions[17], to_int64 = Base_Int_conversions[9], of_nativeint = Base_Int_conversions[26], of_nativeint_exn = Base_Int_conversions[27], of_nativeint_trunc = Base_Int_conversions[28], to_nativeint = Base_Int_conversions[10];
    function pow(b, e) {
        var _u_ = caml_call1(to_int_exn, e), _v_ = caml_call1(to_int_exn, b);
        return caml_call1(of_int_exn, caml_call2(Base_Int_math[2][1], _v_, _u_));
    }
    function symbol$10(b, e) {
        return pow(b, e);
    }
    function bswap16(x) {
        return caml_int32_bswap(x) >>> 16 | 0;
    }
    var raise_s = Base_Error[32], _c_ = [
        0,
        [
            11,
            cst_argument_must_be_strictly_,
            0
        ],
        cst_argument_must_be_strictly_
    ], cst_Int32_floor_log2_got_inval = "[Int32.floor_log2] got invalid input", cst_Int32_ceil_log2_got_invali = "[Int32.ceil_log2] got invalid input";
    function non_positive_argument(param) {
        return caml_call2(Base_Printf[7], _c_, 0);
    }
    function lsr(_t_, _s_) {
        return _t_ >>> _s_ | 0;
    }
    function land(_r_, _q_) {
        return _r_ & _q_;
    }
    function ceil_pow2(x) {
        if (caml_call2(Base_Import[102][2], x, Stdlib_Int32[1])) non_positive_argument(0);
        var x$0 = caml_call1(Stdlib_Int32[7], x), x$5 = x$0 | x$0 >>> 1 | 0, x$4 = x$5 | x$5 >>> 2 | 0, x$3 = x$4 | x$4 >>> 4 | 0, x$2 = x$3 | x$3 >>> 8 | 0, x$1 = x$2 | x$2 >>> 16 | 0;
        return caml_call1(Stdlib_Int32[6], x$1);
    }
    function floor_pow2(x$0) {
        if (caml_call2(Base_Import[102][2], x$0, Stdlib_Int32[1])) non_positive_argument(0);
        var x = x$0 | x$0 >>> 1 | 0, x$4 = x | x >>> 2 | 0, x$3 = x$4 | x$4 >>> 4 | 0, x$2 = x$3 | x$3 >>> 8 | 0, x$1 = x$2 | x$2 >>> 16 | 0;
        return x$1 - (x$1 >>> 1 | 0) | 0;
    }
    function is_pow2(x) {
        if (caml_call2(Base_Import[102][2], x, Stdlib_Int32[1])) non_positive_argument(0);
        var _o_ = Stdlib_Int32[1], _p_ = x & caml_call1(Stdlib_Int32[7], x);
        return caml_call2(Base_Import[102][4], _p_, _o_);
    }
    function floor_log2(i) {
        if (caml_call2(Base_Import[102][2], i, Stdlib_Int32[1])) {
            var _l_ = [
                0,
                [
                    0,
                    cst,
                    caml_call1(Base_Import[141], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int32_floor_log2_got_inval, _l_));
        }
        var _m_ = runtime.Base_int_math_int32_clz(i), _n_ = caml_call2(Base_Import[93], num_bits, 1);
        return caml_call2(Base_Import[93], _n_, _m_);
    }
    function ceil_log2(i) {
        if (caml_call2(Base_Import[102][2], i, Stdlib_Int32[1])) {
            var _j_ = [
                0,
                [
                    0,
                    cst$0,
                    caml_call1(Base_Import[141], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int32_ceil_log2_got_invali, _j_));
        }
        if (caml_call2(Stdlib_Int32[17], i, Stdlib_Int32[2])) return 0;
        var _k_ = runtime.Base_int_math_int32_clz(caml_call1(Stdlib_Int32[7], i));
        return caml_call2(Base_Import[93], num_bits, _k_);
    }
    var include$1 = caml_call1(Base_Int_string_conversions[1], [
        0,
        to_string
    ]), to_string_hum = include$1[1], sexp_of_t$0 = include$1[2], compare_local$0 = Base_Import[257];
    function compare(a, b) {
        return caml_call2(compare_local$0, a, b);
    }
    var hash_fold_t$0 = Base_Import[204], func$0 = Base_Import[218], _d_ = [
        0,
        [
            5,
            6,
            0,
            0,
            0
        ],
        cst_lx
    ], _e_ = [
        0,
        [
            5,
            6,
            0,
            0,
            0
        ],
        cst_lx
    ];
    function hash$0(x) {
        return caml_call1(func$0, x);
    }
    function to_string$0(i) {
        return caml_call2(Base_Printf[2], _d_, i);
    }
    function of_string$0(s) {
        return caml_call3(Stdlib_Scanf[5], s, _e_, function(_i_) {
            return _i_;
        });
    }
    var include$2 = caml_call1(Base_Int_string_conversions[2], [
        0,
        compare,
        compare_local$0,
        hash_fold_t$0,
        hash$0,
        to_string$0,
        of_string$0,
        zero,
        symbol$4,
        symbol,
        module_name
    ]), Hex = include$2[1], compare_local$1 = Base_Import[257];
    function compare$0(a, b) {
        return caml_call2(compare_local$1, a, b);
    }
    var equal_local$0 = Base_Import[271];
    function equal$0(a, b) {
        return caml_call2(equal_local$0, a, b);
    }
    var hash_fold_t$1 = Base_Import[204], func$1 = Base_Import[218];
    function hash$1(x) {
        return caml_call1(func$1, x);
    }
    function clz(_h_) {
        return runtime.Base_int_math_int32_clz(_h_);
    }
    var include$3 = caml_call1(Base_Int_string_conversions[3], [
        0,
        compare$0,
        compare_local$1,
        equal$0,
        equal_local$0,
        hash_fold_t$1,
        hash$1,
        clz,
        lsr,
        land,
        to_int_exn,
        num_bits,
        one,
        zero
    ]), Binary = include$3[1], pp = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name$0,
        to_string
    ])[1], include$4 = caml_call1(Base_Int_math[1], [
        0,
        of_float,
        to_float,
        of_string,
        to_string,
        symbol$9,
        symbol$8,
        symbol$7,
        symbol$6,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        symbol$5,
        abs,
        symbol,
        zero,
        of_int_exn,
        rem
    ]), symbol$11 = include$4[1], symbol$12 = include$4[2], symbol$13 = include$4[3], round = include$4[4], round_towards_zero = include$4[5], round_down = include$4[6], round_up = include$4[7], round_nearest = include$4[8], Base_Int32 = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int_exn,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$0,
        of_string,
        to_string,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        symbol$5,
        equal,
        ascending,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        compare_local,
        equal_local,
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        zero,
        one,
        minus_one,
        symbol$9,
        symbol$8,
        symbol$7,
        symbol$10,
        symbol,
        symbol,
        symbol$12,
        symbol$11,
        symbol$6,
        rem,
        symbol$13,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        shift_left,
        shift_right,
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        abs,
        succ,
        pred,
        pow,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32,
        to_int32,
        of_int64_exn,
        to_int64,
        of_nativeint_exn,
        to_nativeint,
        of_float_unchecked,
        num_bits,
        max_value,
        min_value,
        shift_right_logical,
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        floor_log2,
        is_pow2,
        function(_g_) {
            return runtime.Base_int_math_int32_clz(_g_);
        },
        function(_f_) {
            return runtime.Base_int_math_int32_ctz(_f_);
        },
        [
            0,
            symbol$9,
            symbol$8,
            symbol$7,
            symbol$6,
            symbol,
            symbol$10,
            symbol$0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            symbol$5,
            abs,
            symbol,
            zero,
            symbol$11,
            symbol$12,
            symbol$13,
            bit_and,
            bit_or,
            bit_xor,
            bit_not,
            shift_left,
            shift_right,
            shift_right_logical
        ],
        of_int,
        to_int,
        of_int32,
        to_int32,
        of_nativeint,
        to_nativeint,
        of_int64,
        of_int_trunc,
        to_int_trunc,
        of_nativeint_trunc,
        of_int64_trunc,
        bits_of_float,
        float_of_bits,
        bswap16,
        caml_int32_bswap
    ];
    runtime.caml_register_global(30, Base_Int32, "Base__Int32");
    return;
})(globalThis);
//# 37842 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_product$1 = "product", cst_t$3 = "t", cst_u$3 = "u", caml_div = runtime.caml_div, caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_mul = runtime.caml_mul;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), cst = "", Base_Word_size = global_data.Base__Word_size, Base_Int = global_data.Base__Int, Base_Sexp = global_data.Base__Sexp, Base_Random = global_data.Base__Random, Base_Import = global_data.Base__Import, Base_Bool = global_data.Base__Bool, Base_Int64 = global_data.Base__Int64, Base_Error = global_data.Base__Error, Base_Int63_emul = global_data.Base__Int63_emul, Base_Sys0 = global_data.Base__Sys0, Assert_failure = global_data.Assert_failure, raise_s = Base_Error[32], include = caml_call1(caml_call1(Base_Sys0[19], [
        0
    ]), [
        0
    ]), t_sexp_grammar = Base_Int[2], of_float = Base_Int[3], to_float = Base_Int[4], of_int_exn = Base_Int[5], to_int_exn = Base_Int[6], hash_fold_t = Base_Int[7], hash = Base_Int[8], t_of_sexp = Base_Int[9], sexp_of_t = Base_Int[10], of_string = Base_Int[11], to_string = Base_Int[12], equal = Base_Int[13], compare = Base_Int[14], min = Base_Int[15], max = Base_Int[16], ascending = Base_Int[17], descending = Base_Int[18], between = Base_Int[19], clamp_exn = Base_Int[20], clamp = Base_Int[21], comparator = Base_Int[22], pp = Base_Int[23], hashable = Base_Int[24], is_positive = Base_Int[25], is_non_negative = Base_Int[26], is_negative = Base_Int[27], is_non_positive = Base_Int[28], sign = Base_Int[29], compare_local = Base_Int[30], equal_local = Base_Int[31], invariant = Base_Int[32], Hex = Base_Int[33], Binary = Base_Int[34], of_string_opt = Base_Int[35], to_string_hum = Base_Int[36], one = Base_Int[37], minus_one = Base_Int[38], rem = Base_Int[39], round = Base_Int[40], round_towards_zero = Base_Int[41], round_down = Base_Int[42], round_up = Base_Int[43], round_nearest = Base_Int[44], succ = Base_Int[45], pred = Base_Int[46], pow = Base_Int[47], bit_and = Base_Int[48], bit_or = Base_Int[49], bit_xor = Base_Int[50], bit_not = Base_Int[51], popcount = Base_Int[52], shift_left = Base_Int[53], shift_right = Base_Int[54], decr = Base_Int[55], incr = Base_Int[56], of_int32_exn = Base_Int[57], to_int32_exn = Base_Int[58], of_int64_exn = Base_Int[59], to_int64 = Base_Int[60], of_nativeint_exn = Base_Int[61], to_nativeint_exn = Base_Int[62], of_float_unchecked = Base_Int[63], num_bits = Base_Int[64], max_value = Base_Int[65], min_value = Base_Int[66], shift_right_logical = Base_Int[67], ceil_pow2 = Base_Int[68], floor_pow2 = Base_Int[69], ceil_log2 = Base_Int[70], is_pow2 = Base_Int[72], clz = Base_Int[73], ctz = Base_Int[74], O = Base_Int[75], symbol = Base_Int[76], lnot = Base_Int[77], abs = Base_Int[78], zero = Base_Int[79], symbol$0 = Base_Int[80], symbol$1 = Base_Int[81], symbol$2 = Base_Int[82], of_int = Base_Int[84], to_int32 = Base_Int[87], of_int64 = Base_Int[88], of_nativeint = Base_Int[89], _a_ = Base_Int[90];
    function to_int(x) {
        return [
            0,
            x
        ];
    }
    function to_int_trunc(x) {
        return x;
    }
    function to_nativeint_trunc(x) {
        return caml_call1(_a_, x);
    }
    function to_nativeint(x) {
        return [
            0,
            caml_call1(_a_, x)
        ];
    }
    function bswap32(t) {
        return caml_int64_to_int32(caml_call1(Base_Int64[87], caml_int64_of_int32(t)));
    }
    function bswap48(t) {
        return caml_int64_to_int32(caml_call1(Base_Int64[88], caml_int64_of_int32(t)));
    }
    var cst_Int_floor_log2_got_invalid = "[Int.floor_log2] got invalid input", cst_neg_overflow = "neg overflow", cst_abs_overflow = "abs overflow", cst_product$0 = cst_product$1, cst_u$2 = cst_u$3, cst_t$2 = cst_t$3, cst_overflow$2 = "( / ) overflow", cst_product = cst_product$1, cst_u$1 = cst_u$3, cst_t$1 = cst_t$3, cst_overflow$1 = "( * ) overflow", cst_diff = "diff", cst_u$0 = cst_u$3, cst_t$0 = cst_t$3, cst_overflow$0 = "( - ) overflow", cst_sum = "sum", cst_u = cst_u$3, cst_t = cst_t$3, cst_overflow = "( + ) overflow", _b_ = [
        0,
        "src/int63.ml",
        110,
        9
    ], repr = 0, include$0 = include[1] ? [
        0,
        Base_Int63_emul[2],
        Base_Int63_emul[3],
        Base_Int63_emul[4],
        Base_Int63_emul[5],
        Base_Int63_emul[6],
        Base_Int63_emul[7],
        Base_Int63_emul[8],
        Base_Int63_emul[9],
        Base_Int63_emul[10],
        Base_Int63_emul[11],
        Base_Int63_emul[12],
        Base_Int63_emul[13],
        Base_Int63_emul[14],
        Base_Int63_emul[15],
        Base_Int63_emul[16],
        Base_Int63_emul[17],
        Base_Int63_emul[18],
        Base_Int63_emul[19],
        Base_Int63_emul[20],
        Base_Int63_emul[21],
        Base_Int63_emul[22],
        Base_Int63_emul[23],
        Base_Int63_emul[24],
        Base_Int63_emul[25],
        Base_Int63_emul[26],
        Base_Int63_emul[27],
        Base_Int63_emul[28],
        Base_Int63_emul[29],
        Base_Int63_emul[30],
        Base_Int63_emul[31],
        Base_Int63_emul[32],
        Base_Int63_emul[33],
        Base_Int63_emul[34],
        Base_Int63_emul[35],
        Base_Int63_emul[36],
        Base_Int63_emul[37],
        Base_Int63_emul[38],
        Base_Int63_emul[39],
        Base_Int63_emul[40],
        Base_Int63_emul[41],
        Base_Int63_emul[42],
        Base_Int63_emul[43],
        Base_Int63_emul[44],
        Base_Int63_emul[45],
        Base_Int63_emul[46],
        Base_Int63_emul[47],
        Base_Int63_emul[48],
        Base_Int63_emul[49],
        Base_Int63_emul[50],
        Base_Int63_emul[51],
        Base_Int63_emul[52],
        Base_Int63_emul[53],
        Base_Int63_emul[54],
        Base_Int63_emul[55],
        Base_Int63_emul[56],
        Base_Int63_emul[57],
        Base_Int63_emul[58],
        Base_Int63_emul[59],
        Base_Int63_emul[60],
        Base_Int63_emul[61],
        Base_Int63_emul[62],
        Base_Int63_emul[63],
        Base_Int63_emul[64],
        Base_Int63_emul[65],
        Base_Int63_emul[66],
        Base_Int63_emul[67],
        Base_Int63_emul[68],
        Base_Int63_emul[69],
        Base_Int63_emul[70],
        Base_Int63_emul[71],
        Base_Int63_emul[72],
        Base_Int63_emul[73],
        Base_Int63_emul[74],
        Base_Int63_emul[75],
        Base_Int63_emul[76],
        Base_Int63_emul[77],
        Base_Int63_emul[78],
        Base_Int63_emul[79],
        Base_Int63_emul[80],
        Base_Int63_emul[81],
        Base_Int63_emul[82],
        Base_Int63_emul[83],
        Base_Int63_emul[84],
        Base_Int63_emul[85],
        Base_Int63_emul[86],
        Base_Int63_emul[88],
        Base_Int63_emul[89],
        Base_Int63_emul[90],
        Base_Int63_emul[91],
        Base_Int63_emul[92],
        Base_Int63_emul[93],
        Base_Int63_emul[94],
        Base_Int63_emul[95],
        ,
        Base_Int63_emul[97],
        Base_Int63_emul[98],
        Base_Int63_emul[99],
        Base_Int63_emul[100],
        Base_Int63_emul[101],
        Base_Int63_emul[102],
        Base_Int63_emul[103],
        Base_Int63_emul[104],
        Base_Int63_emul[105],
        Base_Int63_emul[106],
        Base_Int63_emul[107],
        Base_Int63_emul[108],
        Base_Int63_emul[109],
        Base_Int63_emul[110],
        Base_Int63_emul[111],
        Base_Int63_emul[112],
        Base_Int63_emul[87],
        Base_Int63_emul[118],
        Base_Int63_emul[113],
        Base_Int63_emul[114],
        Base_Int63_emul[115]
    ] : [
        0,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int_exn,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        of_string,
        to_string,
        function(_aG_, _aF_) {
            return _aF_ <= _aG_ ? 1 : 0;
        },
        function(_aE_, _aD_) {
            return _aE_ <= _aD_ ? 1 : 0;
        },
        function(_aC_, _aB_) {
            return _aC_ === _aB_ ? 1 : 0;
        },
        function(_aA_, _az_) {
            return _az_ < _aA_ ? 1 : 0;
        },
        function(_ay_, _ax_) {
            return _ay_ < _ax_ ? 1 : 0;
        },
        function(_aw_, _av_) {
            return _aw_ !== _av_ ? 1 : 0;
        },
        equal,
        compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        compare_local,
        equal_local,
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        zero,
        one,
        minus_one,
        function(_au_, _at_) {
            return _au_ + _at_ | 0;
        },
        function(_as_, _ar_) {
            return _as_ - _ar_ | 0;
        },
        caml_mul,
        symbol,
        function(_aq_) {
            return -_aq_ | 0;
        },
        function(_ap_) {
            return -_ap_ | 0;
        },
        symbol$1,
        symbol$0,
        caml_div,
        rem,
        symbol$2,
        function(_ao_, _an_) {
            return _ao_ & _an_;
        },
        function(_am_, _al_) {
            return _am_ | _al_;
        },
        function(_ak_, _aj_) {
            return _ak_ ^ _aj_;
        },
        lnot,
        function(_ai_, _ah_) {
            return _ai_ << _ah_;
        },
        function(_ag_, _af_) {
            return _ag_ >> _af_;
        },
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        abs,
        succ,
        pred,
        pow,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32_exn,
        to_int32_exn,
        of_int64_exn,
        to_int64,
        of_nativeint_exn,
        to_nativeint_exn,
        num_bits,
        max_value,
        min_value,
        function(_ae_, _ad_) {
            return _ae_ >>> _ad_ | 0;
        },
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        ,
        is_pow2,
        clz,
        ctz,
        [
            0,
            function(_ac_, _ab_) {
                return _ac_ + _ab_ | 0;
            },
            function(_aa_, _$_) {
                return _aa_ - _$_ | 0;
            },
            caml_mul,
            caml_div,
            function(___) {
                return -___ | 0;
            },
            O[1],
            function(_Z_, _Y_) {
                return _Y_ <= _Z_ ? 1 : 0;
            },
            function(_X_, _W_) {
                return _X_ <= _W_ ? 1 : 0;
            },
            function(_V_, _U_) {
                return _V_ === _U_ ? 1 : 0;
            },
            function(_T_1, _S_) {
                return _S_ < _T_1 ? 1 : 0;
            },
            function(_R_, _Q_) {
                return _R_ < _Q_ ? 1 : 0;
            },
            function(_P_, _O_) {
                return _P_ !== _O_ ? 1 : 0;
            },
            O[3],
            function(_N_) {
                return -_N_ | 0;
            },
            O[4],
            O[5],
            O[6],
            O[7],
            function(_M_, _L_) {
                return _M_ & _L_;
            },
            function(_K_, _J_) {
                return _K_ | _J_;
            },
            function(_I_, _H_) {
                return _I_ ^ _H_;
            },
            O[2],
            function(_G_, _F_) {
                return _G_ << _F_;
            },
            function(_E_, _D_) {
                return _E_ >> _D_;
            },
            function(_C_, _B_) {
                return _C_ >>> _B_ | 0;
            }
        ],
        of_int,
        to_int,
        to_int_trunc,
        of_int32_exn,
        to_int32,
        function(_A_) {
            return _A_;
        },
        of_int64,
        caml_int64_to_int32,
        of_nativeint,
        to_nativeint,
        function(_z_) {
            return _z_;
        },
        to_nativeint_trunc,
        of_float_unchecked,
        repr,
        runtime.caml_bswap16,
        bswap32,
        bswap48
    ], t_sexp_grammar$0 = include$0[1], of_float$0 = include$0[2], to_float$0 = include$0[3], of_int_exn$0 = include$0[4], to_int_exn$0 = include$0[5], hash_fold_t$0 = include$0[6], hash$0 = include$0[7], t_of_sexp$0 = include$0[8], sexp_of_t$0 = include$0[9], of_string$0 = include$0[10], to_string$0 = include$0[11], symbol$3 = include$0[12], symbol$4 = include$0[13], symbol$5 = include$0[14], symbol$6 = include$0[15], symbol$7 = include$0[16], symbol$8 = include$0[17], equal$0 = include$0[18], compare$0 = include$0[19], min$0 = include$0[20], max$0 = include$0[21], ascending$0 = include$0[22], descending$0 = include$0[23], between$0 = include$0[24], clamp_exn$0 = include$0[25], clamp$0 = include$0[26], comparator$0 = include$0[27], pp$0 = include$0[28], hashable$0 = include$0[29], is_positive$0 = include$0[30], is_non_negative$0 = include$0[31], is_negative$0 = include$0[32], is_non_positive$0 = include$0[33], sign$0 = include$0[34], compare_local$0 = include$0[35], equal_local$0 = include$0[36], invariant$0 = include$0[37], Hex$0 = include$0[38], Binary$0 = include$0[39], of_string_opt$0 = include$0[40], to_string_hum$0 = include$0[41], zero$0 = include$0[42], one$0 = include$0[43], minus_one$0 = include$0[44], symbol$9 = include$0[45], symbol$10 = include$0[46], symbol$11 = include$0[47], symbol$12 = include$0[48], neg = include$0[49], symbol$13 = include$0[50], symbol$14 = include$0[51], symbol$15 = include$0[52], symbol$16 = include$0[53], rem$0 = include$0[54], symbol$17 = include$0[55], land = include$0[56], lor = include$0[57], lxor = include$0[58], lnot$0 = include$0[59], lsl = include$0[60], asr = include$0[61], round$0 = include$0[62], round_towards_zero$0 = include$0[63], round_down$0 = include$0[64], round_up$0 = include$0[65], round_nearest$0 = include$0[66], abs$0 = include$0[67], succ$0 = include$0[68], pred$0 = include$0[69], pow$0 = include$0[70], bit_and$0 = include$0[71], bit_or$0 = include$0[72], bit_xor$0 = include$0[73], bit_not$0 = include$0[74], popcount$0 = include$0[75], shift_left$0 = include$0[76], shift_right$0 = include$0[77], decr$0 = include$0[78], incr$0 = include$0[79], of_int32_exn$0 = include$0[80], to_int32_exn$0 = include$0[81], of_int64_exn$0 = include$0[82], to_int64$0 = include$0[83], of_nativeint_exn$0 = include$0[84], to_nativeint_exn$0 = include$0[85], num_bits$0 = include$0[86], max_value$0 = include$0[87], min_value$0 = include$0[88], lsr = include$0[89], shift_right_logical$0 = include$0[90], ceil_pow2$0 = include$0[91], floor_pow2$0 = include$0[92], ceil_log2$0 = include$0[93], is_pow2$0 = include$0[95], clz$0 = include$0[96], ctz$0 = include$0[97], O$0 = include$0[98], of_int$0 = include$0[99], to_int$0 = include$0[100], to_int_trunc$0 = include$0[101], of_int32 = include$0[102], to_int32$0 = include$0[103], to_int32_trunc = include$0[104], of_int64$0 = include$0[105], of_int64_trunc = include$0[106], of_nativeint$0 = include$0[107], to_nativeint$0 = include$0[108], of_nativeint_trunc = include$0[109], to_nativeint_trunc$0 = include$0[110], of_float_unchecked$0 = include$0[111], repr$0 = include$0[112], bswap16 = include$0[113], bswap32$0 = include$0[114], bswap48$0 = include$0[115];
    function symbol$18(t, u) {
        var sum = caml_call2(symbol$9, t, u), _v_ = caml_call2(bit_xor$0, t, caml_call1(bit_not$0, sum));
        if (caml_call2(symbol$7, caml_call2(bit_or$0, caml_call2(bit_xor$0, t, u), _v_), zero$0)) return sum;
        var _w_ = [
            0,
            [
                0,
                cst_sum,
                caml_call1(sexp_of_t$0, sum)
            ],
            0
        ], _x_ = [
            0,
            [
                0,
                cst_u,
                caml_call1(sexp_of_t$0, u)
            ],
            _w_
        ], _y_ = [
            0,
            [
                0,
                cst_t,
                caml_call1(sexp_of_t$0, t)
            ],
            _x_
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_overflow, _y_));
    }
    function symbol$19(t, u) {
        var diff = caml_call2(symbol$10, t, u), pos_diff = caml_call2(symbol$6, t, u);
        if (caml_call2(symbol$8, t, u)) {
            var _r_ = caml_call1(is_positive$0, diff);
            if (caml_call2(Base_Bool[15], pos_diff, _r_)) {
                var _s_ = [
                    0,
                    [
                        0,
                        cst_diff,
                        caml_call1(sexp_of_t$0, diff)
                    ],
                    0
                ], _t_ = [
                    0,
                    [
                        0,
                        cst_u$0,
                        caml_call1(sexp_of_t$0, u)
                    ],
                    _s_
                ], _u_ = [
                    0,
                    [
                        0,
                        cst_t$0,
                        caml_call1(sexp_of_t$0, t)
                    ],
                    _t_
                ];
                return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_overflow$0, _u_));
            }
        }
        return diff;
    }
    var negative_one = caml_call1(of_int$0, -1);
    function div_would_overflow(t, u) {
        var _q_ = caml_call2(symbol$5, t, min_value$0);
        return _q_ ? caml_call2(symbol$5, u, negative_one) : _q_;
    }
    function symbol$20(t, u) {
        var product = caml_call2(symbol$11, t, u);
        a: if (caml_call2(symbol$8, u, zero$0)) {
            if (!div_would_overflow(product, u) && !caml_call2(symbol$8, caml_call2(symbol$16, product, u), t)) break a;
            var _n_ = [
                0,
                [
                    0,
                    cst_product,
                    caml_call1(sexp_of_t$0, product)
                ],
                0
            ], _o_ = [
                0,
                [
                    0,
                    cst_u$1,
                    caml_call1(sexp_of_t$0, u)
                ],
                _n_
            ], _p_ = [
                0,
                [
                    0,
                    cst_t$1,
                    caml_call1(sexp_of_t$0, t)
                ],
                _o_
            ];
            return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_overflow$1, _p_));
        }
        return product;
    }
    function symbol$21(t, u) {
        if (!div_would_overflow(t, u)) return caml_call2(symbol$16, t, u);
        var _k_ = [
            0,
            [
                0,
                cst_product$0,
                caml_call1(sexp_of_t$0, caml_call2(symbol$16, t, u))
            ],
            0
        ], _l_ = [
            0,
            [
                0,
                cst_u$2,
                caml_call1(sexp_of_t$0, u)
            ],
            _k_
        ], _m_ = [
            0,
            [
                0,
                cst_t$2,
                caml_call1(sexp_of_t$0, t)
            ],
            _l_
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_overflow$2, _m_));
    }
    function abs$1(t) {
        return caml_call2(symbol$5, t, min_value$0) ? caml_call1(Base_Import[124], cst_abs_overflow) : caml_call1(abs$0, t);
    }
    function neg$0(t) {
        return caml_call2(symbol$5, t, min_value$0) ? caml_call1(Base_Import[124], cst_neg_overflow) : caml_call1(neg, t);
    }
    if (63 !== num_bits$0) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _b_
    ], 1);
    function random_of_int(opt, bound) {
        var state = opt ? opt[1] : Base_Random[19][1], _j_ = caml_call1(to_int_exn$0, bound);
        return caml_call1(of_int$0, caml_call2(Base_Random[19][7], state, _j_));
    }
    function random_of_int64(opt, bound) {
        var state = opt ? opt[1] : Base_Random[19][1], _i_ = caml_call1(to_int64$0, bound);
        return caml_call1(of_int64_exn$0, caml_call2(Base_Random[19][10], state, _i_));
    }
    var random_of_int$0 = Base_Word_size[3] ? random_of_int : random_of_int64;
    function random_incl_of_int(opt, lo, hi) {
        var state = opt ? opt[1] : Base_Random[19][1], _g_ = caml_call1(to_int_exn$0, hi), _h_ = caml_call1(to_int_exn$0, lo);
        return caml_call1(of_int$0, caml_call3(Base_Random[19][12], state, _h_, _g_));
    }
    function random_incl_of_int64(opt, lo, hi) {
        var state = opt ? opt[1] : Base_Random[19][1], _e_ = caml_call1(to_int64$0, hi), _f_ = caml_call1(to_int64$0, lo);
        return caml_call1(of_int64_exn$0, caml_call3(Base_Random[19][15], state, _f_, _e_));
    }
    var random_incl = Base_Word_size[3] ? random_incl_of_int : random_incl_of_int64;
    function floor_log2(t) {
        if (Base_Word_size[3]) {
            var _c_ = caml_call1(to_int_exn$0, t);
            return caml_call1(Base_Int[71], _c_);
        }
        if (caml_call2(symbol$4, t, zero$0)) {
            var _d_ = [
                0,
                [
                    0,
                    cst,
                    caml_call1(sexp_of_t$0, t)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int_floor_log2_got_invalid, _d_));
        }
        var floor_log2 = [
            0,
            num_bits$0 - 2 | 0
        ];
        for(;;){
            if (!caml_call2(equal$0, zero$0, caml_call2(bit_and$0, t, caml_call2(shift_left$0, one$0, floor_log2[1])))) return floor_log2[1];
            floor_log2[1] = floor_log2[1] - 1 | 0;
        }
    }
    var Base_Int63 = [
        0,
        t_sexp_grammar$0,
        of_float$0,
        to_float$0,
        of_int_exn$0,
        to_int_exn$0,
        hash_fold_t$0,
        hash$0,
        t_of_sexp$0,
        sexp_of_t$0,
        of_string$0,
        to_string$0,
        symbol$3,
        symbol$4,
        symbol$5,
        symbol$6,
        symbol$7,
        symbol$8,
        equal$0,
        compare$0,
        min$0,
        max$0,
        ascending$0,
        descending$0,
        between$0,
        clamp_exn$0,
        clamp$0,
        comparator$0,
        pp$0,
        hashable$0,
        is_positive$0,
        is_non_negative$0,
        is_negative$0,
        is_non_positive$0,
        sign$0,
        compare_local$0,
        equal_local$0,
        invariant$0,
        Hex$0,
        Binary$0,
        of_string_opt$0,
        to_string_hum$0,
        zero$0,
        one$0,
        minus_one$0,
        symbol$9,
        symbol$10,
        symbol$11,
        symbol$12,
        neg,
        symbol$13,
        symbol$14,
        symbol$15,
        symbol$16,
        rem$0,
        symbol$17,
        land,
        lor,
        lxor,
        lnot$0,
        lsl,
        asr,
        round$0,
        round_towards_zero$0,
        round_down$0,
        round_up$0,
        round_nearest$0,
        abs$0,
        succ$0,
        pred$0,
        pow$0,
        bit_and$0,
        bit_or$0,
        bit_xor$0,
        bit_not$0,
        popcount$0,
        shift_left$0,
        shift_right$0,
        decr$0,
        incr$0,
        of_int32_exn$0,
        to_int32_exn$0,
        of_int64_exn$0,
        to_int64$0,
        of_nativeint_exn$0,
        to_nativeint_exn$0,
        of_float_unchecked$0,
        num_bits$0,
        max_value$0,
        min_value$0,
        lsr,
        shift_right_logical$0,
        ceil_pow2$0,
        floor_pow2$0,
        ceil_log2$0,
        is_pow2$0,
        clz$0,
        ctz$0,
        O$0,
        [
            0,
            symbol$18,
            symbol$19,
            symbol$20,
            symbol$21,
            abs$1,
            neg$0
        ],
        of_int$0,
        to_int$0,
        of_int32,
        to_int32$0,
        of_int64$0,
        of_nativeint$0,
        to_nativeint$0,
        to_int_trunc$0,
        to_int32_trunc,
        of_int64_trunc,
        of_nativeint_trunc,
        to_nativeint_trunc$0,
        bswap16,
        bswap32$0,
        bswap48$0,
        random_of_int$0,
        random_incl,
        floor_log2,
        [
            0,
            Base_Int63_emul[117],
            repr$0
        ]
    ];
    runtime.caml_register_global(32, Base_Int63, "Base__Int63");
    return;
})(globalThis);
//# 38670 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Key = [
        0
    ], Base_Hashtbl_intf = [
        0,
        Key
    ];
    runtime.caml_register_global(0, Base_Hashtbl_intf, "Base__Hashtbl_intf");
    return;
})(globalThis);
//# 38683 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_avltree_ml = "src/avltree.ml", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Base_Sexp = global_data.Base__Sexp, Assert_failure = global_data.Assert_failure, Base_Import = global_data.Base__Import, Base_Error = global_data.Base__Error, raise_s = Base_Error[32];
    function max(x, y) {
        return y < x ? x : y;
    }
    var _a_ = [
        0,
        cst_src_avltree_ml,
        50,
        6
    ], _b_ = [
        0,
        cst_src_avltree_ml,
        56,
        6
    ], _c_ = [
        0,
        cst_src_avltree_ml,
        67,
        6
    ], _d_ = [
        0,
        cst_src_avltree_ml,
        66,
        6
    ], _e_ = [
        0,
        cst_src_avltree_ml,
        87,
        22
    ], _f_ = [
        0,
        cst_src_avltree_ml,
        110,
        26
    ], _g_ = [
        0,
        cst_src_avltree_ml,
        129,
        30
    ], _h_ = [
        0,
        cst_src_avltree_ml,
        145,
        26
    ], _i_ = [
        0,
        cst_src_avltree_ml,
        163,
        30
    ];
    function is_empty(param) {
        return typeof param === "number" ? 1 : 0;
    }
    function height(param) {
        if (typeof param === "number") return 0;
        if (0 !== param[0]) return 1;
        var height = param[4];
        return height;
    }
    function invariant(t, compare) {
        function inv(param) {
            if (typeof param !== "number" && 0 === param[0]) {
                var left = param[1], key = param[2], h = param[4], right = param[5], hr = height(right), hl = height(left);
                inv(left);
                inv(right);
                if (typeof left !== "number") {
                    var left_key = 0 === left[0] ? left[2] : left[1];
                    if (0 <= caml_call2(compare, left_key, key)) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _a_
                    ], 1);
                }
                if (typeof right !== "number") {
                    var right_key = 0 === right[0] ? right[2] : right[1];
                    if (0 >= caml_call2(compare, right_key, key)) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _b_
                    ], 1);
                }
                var _z_ = max(hl, hr);
                if (h !== caml_call2(Base_Import[91], _z_, 1)) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _d_
                ], 1);
                var _A_ = caml_call2(Base_Import[93], hl, hr);
                if (2 < caml_call1(Base_Import[123], _A_)) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _c_
                ], 1);
                return 0;
            }
            return 0;
        }
        return inv(t);
    }
    function update_height(x) {
        if (typeof x !== "number" && 0 === x[0]) {
            var left = x[1], old_height = x[4], right = x[5], _x_ = height(right), _y_ = max(height(left), _x_), new_height = caml_call2(Base_Import[91], _y_, 1);
            if (new_height !== old_height) x[4] = new_height;
            return;
        }
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
    }
    function balance(root_node) {
        if (typeof root_node !== "number" && 0 === root_node[0]) {
            var left_node = root_node[1], right_node = root_node[5], hl = height(left_node), hr = height(right_node);
            if (caml_call2(Base_Import[91], hr, 2) < hl) {
                if (typeof left_node !== "number" && 0 === left_node[0]) {
                    var left_node_left = left_node[1], left_node_right = left_node[5], _v_ = height(left_node_right);
                    if (_v_ <= height(left_node_left)) {
                        root_node[1] = left_node_right;
                        left_node[5] = root_node;
                        update_height(root_node);
                        update_height(left_node);
                        return left_node;
                    }
                    if (typeof left_node_right !== "number" && 0 === left_node_right[0]) {
                        var lr_left = left_node_right[1], lr_right = left_node_right[5];
                        left_node[5] = lr_left;
                        root_node[1] = lr_right;
                        left_node_right[5] = root_node;
                        left_node_right[1] = left_node;
                        update_height(left_node);
                        update_height(root_node);
                        update_height(left_node_right);
                        return left_node_right;
                    }
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _g_
                    ], 1);
                }
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _f_
                ], 1);
            }
            if (caml_call2(Base_Import[91], hl, 2) >= hr) {
                update_height(root_node);
                return root_node;
            }
            if (typeof right_node !== "number" && 0 === right_node[0]) {
                var right_node_left = right_node[1], right_node_right = right_node[5], _w_ = height(right_node_left);
                if (_w_ <= height(right_node_right)) {
                    root_node[5] = right_node_left;
                    right_node[1] = root_node;
                    update_height(root_node);
                    update_height(right_node);
                    return right_node;
                }
                if (typeof right_node_left !== "number" && 0 === right_node_left[0]) {
                    var rl_left = right_node_left[1], rl_right = right_node_left[5];
                    right_node[1] = rl_right;
                    root_node[5] = rl_left;
                    right_node_left[1] = root_node;
                    right_node_left[5] = right_node;
                    update_height(right_node);
                    update_height(root_node);
                    update_height(right_node_left);
                    return right_node_left;
                }
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _i_
                ], 1);
            }
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _h_
            ], 1);
        }
        return root_node;
    }
    function add(t, replace, compare, added, k, v) {
        if (typeof t === "number") {
            added[1] = 1;
            return [
                1,
                k,
                v
            ];
        }
        if (0 !== t[0]) {
            var k$1 = t[1], c$0 = caml_call2(compare, k$1, k);
            if (0 !== c$0) {
                added[1] = 1;
                return 0 <= c$0 ? [
                    0,
                    0,
                    k,
                    v,
                    2,
                    t
                ] : [
                    0,
                    t,
                    k,
                    v,
                    2,
                    0
                ];
            }
            added[1] = 0;
            if (replace) t[2] = v;
            return t;
        }
        var left = t[1], k$0 = t[2], right = t[5], c = caml_call2(compare, k, k$0);
        if (0 === c) {
            added[1] = 0;
            if (replace) t[3] = v;
            return t;
        }
        if (0 <= c) {
            var right$0 = add(right, replace, compare, added, k, v);
            if (1 - (right$0 === right ? 1 : 0)) t[5] = right$0;
        } else {
            var left$0 = add(left, replace, compare, added, k, v);
            if (1 - (left$0 === left ? 1 : 0)) t[1] = left$0;
        }
        return added[1] ? balance(t) : t;
    }
    function first(t) {
        var t$0 = t;
        for(;;){
            if (typeof t$0 === "number") return 0;
            if (0 === t$0[0]) {
                var l = t$0[1];
                if (typeof l !== "number") {
                    t$0 = l;
                    continue;
                }
                var v = t$0[3], k = t$0[2];
            } else var k$0 = t$0[1], v$0 = t$0[2], v = v$0, k = k$0;
            return [
                0,
                [
                    0,
                    k,
                    v
                ]
            ];
        }
    }
    function last(t) {
        var t$0 = t;
        for(;;){
            if (typeof t$0 === "number") return 0;
            if (0 === t$0[0]) {
                var _t_ = t$0[2], _u_ = t$0[3];
                if (typeof t$0[5] !== "number") {
                    var r = t$0[5];
                    t$0 = r;
                    continue;
                }
                var v = _u_, k = _t_;
            } else var k$0 = t$0[1], v$0 = t$0[2], v = v$0, k = k$0;
            return [
                0,
                [
                    0,
                    k,
                    v
                ]
            ];
        }
    }
    function findi_and_call_impl(t, compare, k, arg1, arg2, call_if_found, call_if_not_found, if_found, if_not_found) {
        var t$0 = t;
        for(;;){
            if (typeof t$0 === "number") return caml_call4(call_if_not_found, if_not_found, k, arg1, arg2);
            if (0 !== t$0[0]) {
                var k$1 = t$0[1], v$0 = t$0[2];
                return 0 === caml_call2(compare, k, k$1) ? caml_call5(call_if_found, if_found, k$1, v$0, arg1, arg2) : caml_call4(call_if_not_found, if_not_found, k, arg1, arg2);
            }
            var left = t$0[1], k$0 = t$0[2], v = t$0[3], right = t$0[5], c = caml_call2(compare, k, k$0);
            if (0 === c) return caml_call5(call_if_found, if_found, k$0, v, arg1, arg2);
            var right$0 = 0 <= c ? right : left;
            t$0 = right$0;
        }
    }
    function call_if_found(if_found, _s_, data, _r_, param) {
        return caml_call1(if_found, data);
    }
    function call_if_not_found(if_not_found, key, _q_, param) {
        return caml_call1(if_not_found, key);
    }
    function find_and_call(t, compare, k, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, 0, 0, call_if_found, call_if_not_found, if_found, if_not_found);
    }
    function call_if_found$0(if_found, key, data, _p_, param) {
        return caml_call2(if_found, key, data);
    }
    function call_if_not_found$0(if_not_found, key, _o_, param) {
        return caml_call1(if_not_found, key);
    }
    function findi_and_call(t, compare, k, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, 0, 0, call_if_found$0, call_if_not_found$0, if_found, if_not_found);
    }
    function call_if_found$1(if_found, _n_, data, arg, param) {
        return caml_call2(if_found, data, arg);
    }
    function call_if_not_found$1(if_not_found, key, arg, param) {
        return caml_call2(if_not_found, key, arg);
    }
    function find_and_call1(t, compare, k, a, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, a, 0, call_if_found$1, call_if_not_found$1, if_found, if_not_found);
    }
    function call_if_found$2(if_found, key, data, arg, param) {
        return caml_call3(if_found, key, data, arg);
    }
    function call_if_not_found$2(if_not_found, key, arg, param) {
        return caml_call2(if_not_found, key, arg);
    }
    function findi_and_call1(t, compare, k, a, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, a, 0, call_if_found$2, call_if_not_found$2, if_found, if_not_found);
    }
    function call_if_found$3(if_found, param, data, arg1, arg2) {
        return caml_call3(if_found, data, arg1, arg2);
    }
    function call_if_not_found$3(if_not_found, key, arg1, arg2) {
        return caml_call3(if_not_found, key, arg1, arg2);
    }
    function find_and_call2(t, compare, k, a, b, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, a, b, call_if_found$3, call_if_not_found$3, if_found, if_not_found);
    }
    function call_if_found$4(if_found, key, data, arg1, arg2) {
        return caml_call4(if_found, key, data, arg1, arg2);
    }
    function call_if_not_found$4(if_not_found, key, arg1, arg2) {
        return caml_call3(if_not_found, key, arg1, arg2);
    }
    function findi_and_call2(t, compare, k, a, b, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, a, b, call_if_found$4, call_if_not_found$4, if_found, if_not_found);
    }
    function if_found(v) {
        return [
            0,
            v
        ];
    }
    function if_not_found(param) {
        return 0;
    }
    function find(t, compare, k) {
        return find_and_call(t, compare, k, if_found, if_not_found);
    }
    function if_found$0(param) {
        return 1;
    }
    function if_not_found$0(param) {
        return 0;
    }
    function mem(t, compare, k) {
        return find_and_call(t, compare, k, if_found$0, if_not_found$0);
    }
    var letrec_function_context = [], _j_ = [
        0,
        cst_src_avltree_ml,
        389,
        15
    ], _k_ = [
        0,
        cst_src_avltree_ml,
        406,
        20
    ];
    function remove(t, removed, compare, k) {
        if (typeof t === "number") {
            removed[1] = 0;
            return 0;
        }
        if (0 !== t[0]) {
            var k$1 = t[1];
            return 0 === caml_call2(compare, k, k$1) ? (removed[1] = 1, 0) : (removed[1] = 0, t);
        }
        var left = t[1], k$0 = t[2], right = t[5], c = caml_call2(compare, k, k$0);
        if (0 === c) {
            removed[1] = 1;
            return caml_call2(letrec_function_context[1], left, right);
        }
        if (0 <= c) {
            var right$0 = remove(right, removed, compare, k);
            if (1 - (right$0 === right ? 1 : 0)) t[5] = right$0;
        } else {
            var left$0 = remove(left, removed, compare, k);
            if (1 - (left$0 === left ? 1 : 0)) t[1] = left$0;
        }
        return removed[1] ? balance(t) : t;
    }
    function remove_min_elt(tree) {
        if (typeof tree === "number") throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _j_
        ], 1);
        if (0 !== tree[0]) return 0;
        var left = tree[1];
        if (typeof left === "number") {
            var right = tree[5];
            return right;
        }
        if (1 === left[0]) {
            var k = tree[2], v = tree[3];
            if (typeof tree[5] === "number") return [
                1,
                k,
                v
            ];
        }
        tree[1] = remove_min_elt(left);
        return balance(tree);
    }
    function merge(t1, tree$0) {
        if (typeof t1 === "number") return tree$0;
        if (typeof tree$0 === "number") return t1;
        var tree = tree$0;
        for(;;){
            if (typeof tree === "number") var tree$1 = 0;
            else if (0 === tree[0]) {
                var left = tree[1];
                if (typeof left !== "number") {
                    tree = left;
                    continue;
                }
                var tree$1 = tree;
            } else var tree$1 = tree;
            if (typeof tree$1 === "number") throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _k_
            ], 1);
            if (0 === tree$1[0]) {
                tree$1[5] = remove_min_elt(tree$0);
                tree$1[1] = t1;
                var tree$2 = tree$1;
            } else var k = tree$1[1], v = tree$1[2], t2 = remove_min_elt(tree$0), _l_ = height(t2), _m_ = max(height(t1), _l_), tree$2 = [
                0,
                t1,
                k,
                v,
                caml_call2(Base_Import[91], _m_, 1),
                t2
            ];
            return balance(tree$2);
        }
    }
    runtime.caml_update_dummy(letrec_function_context, [
        0,
        merge
    ]);
    var cst_Avltree_choose_exn_of_empt = "[Avltree.choose_exn] of empty hashtbl";
    function fold(t, init, f) {
        var t$0 = t, init$0 = init;
        for(;;){
            if (typeof t$0 === "number") return init$0;
            if (0 !== t$0[0]) {
                var key$4 = t$0[1], data$4 = t$0[2];
                return caml_call3(f, key$4, data$4, init$0);
            }
            var left = t$0[1];
            if (typeof left === "number") {
                var key = t$0[2], data = t$0[3], match = t$0[5];
                if (typeof match !== "number" && 0 !== match[0]) {
                    var rkey = match[1], rdata = match[2];
                    return caml_call3(f, rkey, rdata, caml_call3(f, key, data, init$0));
                }
            } else {
                if (0 === left[0]) {
                    var key$1 = t$0[2], data$1 = t$0[3], match$0 = t$0[5];
                    if (typeof match$0 !== "number" && 0 !== match$0[0]) {
                        var rkey$0 = match$0[1], rdata$0 = match$0[2];
                        return caml_call3(f, rkey$0, rdata$0, caml_call3(f, key$1, data$1, fold(left, init$0, f)));
                    }
                } else {
                    var lkey$0 = left[1], ldata$0 = left[2], key$3 = t$0[2], data$3 = t$0[3], match$1 = t$0[5];
                    if (typeof match$1 === "number") return caml_call3(f, key$3, data$3, caml_call3(f, lkey$0, ldata$0, init$0));
                    if (0 !== match$1[0]) {
                        var rkey$1 = match$1[1], rdata$1 = match$1[2];
                        return caml_call3(f, rkey$1, rdata$1, caml_call3(f, key$3, data$3, caml_call3(f, lkey$0, ldata$0, init$0)));
                    }
                }
                if (typeof left !== "number" && 1 === left[0]) {
                    var lkey = left[1], ldata = left[2], key$2 = t$0[2], data$2 = t$0[3], right$0 = t$0[5], init$2 = caml_call3(f, key$2, data$2, caml_call3(f, lkey, ldata, init$0));
                    t$0 = right$0;
                    init$0 = init$2;
                    continue;
                }
            }
            var key$0 = t$0[2], data$0 = t$0[3], right = t$0[5], init$1 = caml_call3(f, key$0, data$0, fold(left, init$0, f));
            t$0 = right;
            init$0 = init$1;
        }
    }
    function iter(t, f) {
        var t$0 = t;
        for(;;){
            if (typeof t$0 === "number") return 0;
            if (0 !== t$0[0]) {
                var key$0 = t$0[1], data$0 = t$0[2];
                return caml_call2(f, key$0, data$0);
            }
            var left = t$0[1], key = t$0[2], data = t$0[3], right = t$0[5];
            iter(left, f);
            caml_call2(f, key, data);
            t$0 = right;
        }
    }
    function mapi_inplace(t, f) {
        var t$0 = t;
        for(;;){
            if (typeof t$0 === "number") return 0;
            if (0 !== t$0[0]) {
                var key$0 = t$0[1], value$0 = t$0[2];
                t$0[2] = caml_call2(f, key$0, value$0);
                return 0;
            }
            var left = t$0[1], key = t$0[2], value = t$0[3], right = t$0[5];
            mapi_inplace(left, f);
            t$0[3] = caml_call2(f, key, value);
            t$0 = right;
        }
    }
    function choose_exn(param) {
        if (typeof param === "number") return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Avltree_choose_exn_of_empt, 0));
        if (0 === param[0]) var value = param[3], key = param[2];
        else var key$0 = param[1], value$0 = param[2], value = value$0, key = key$0;
        return [
            0,
            key,
            value
        ];
    }
    var Base_Avltree = [
        0,
        0,
        is_empty,
        invariant,
        add,
        first,
        last,
        find,
        find_and_call,
        find_and_call1,
        find_and_call2,
        findi_and_call,
        findi_and_call1,
        findi_and_call2,
        mem,
        remove,
        fold,
        iter,
        mapi_inplace,
        choose_exn
    ];
    runtime.caml_register_global(16, Base_Avltree, "Base__Avltree");
    return;
})(globalThis);
//# 39268 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_hashtbl_ml = "src/hashtbl.ml", caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Avltree = global_data.Base__Avltree, Base_Import = global_data.Base__Import, Base_Hashable = global_data.Base__Hashable, Base_Array = global_data.Base__Array, Base_List = global_data.Base__List, Base_Or_error = global_data.Base__Or_error, Base_Sexp = global_data.Base__Sexp, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Assert_failure = global_data.Assert_failure, Base_Error = global_data.Base__Error, Base_Option = global_data.Base__Option, Base_Random = global_data.Base__Random, Base_Int = global_data.Base__Int, Base_With_return = global_data.Base__With_return, with_return = Base_With_return[1], hash_param = Base_Hashable[5], hash = Base_Hashable[6], raise_s = Base_Error[32], cst_Hashtbl_mutation_not_allow = "Hashtbl: mutation not allowed during iteration";
    function sexp_of_key(t) {
        return t[4][3];
    }
    function compare_key(t) {
        return t[4][2];
    }
    function ensure_mutation_allowed(t) {
        var _aA_ = 1 - t[5];
        return _aA_ ? caml_call1(Base_Import[124], cst_Hashtbl_mutation_not_allow) : _aA_;
    }
    function without_mutating(t, f) {
        if (!t[5]) return caml_call1(f, 0);
        t[5] = 0;
        try {
            var x = caml_call1(f, 0);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            t[5] = 1;
            throw caml_maybe_attach_backtrace(exn, 0);
        }
        t[5] = 1;
        return x;
    }
    var max_table_length = caml_call1(Base_Int[69], Base_Array[47]), cst_Hashtbl_add_exn_got_key_al = "Hashtbl.add_exn got key already present", cst_Hashtbl_choose_exn_of_empt = "[Hashtbl.choose_exn] of empty hashtbl", cst_Hashtbl_choose_randomly_ex = "[Hashtbl.choose_randomly_exn] of empty hashtbl", _a_ = [
        0,
        cst_src_hashtbl_ml,
        333,
        2
    ], _b_ = [
        0,
        "Hashtbl.find_exn: not found"
    ], cst_Hashtbl_of_alist_exn_dupli = "Hashtbl.of_alist_exn: duplicate key", cst_Hashtbl_t_of_sexp_duplicat = "Hashtbl.t_of_sexp: duplicate key", _c_ = [
        0,
        cst_src_hashtbl_ml,
        582,
        4
    ], cst_keys = "keys", cst_Hashtbl_create_with_key_du = "Hashtbl.create_with_key: duplicate keys", cst_Hashtbl_merge_different_ha = "Hashtbl.merge: different 'hashable' values";
    function create(_ay_, opt, hashable, param) {
        var growth_allowed = _ay_ ? _ay_[1] : 1, size = opt ? opt[1] : 0, _az_ = caml_call2(Base_Int[16], 1, size), size$0 = caml_call2(Base_Int[15], _az_, max_table_length), size$1 = caml_call1(Base_Int[68], size$0);
        return [
            0,
            caml_call2(Base_Array[48], size$1, Base_Avltree[1]),
            0,
            growth_allowed,
            hashable,
            1
        ];
    }
    function slot(t, key) {
        var hash = caml_call1(t[4][1], key), _ax_ = caml_call2(Base_Import[93], t[1].length - 1, 1);
        return caml_call2(Base_Import[116], hash, _ax_);
    }
    function add_worker(t, replace, key, data) {
        var i = slot(t, key), root = caml_check_bound(t[1], i)[1 + i], added = [
            0,
            0
        ], _aw_ = compare_key(t), new_root = caml_call6(Base_Avltree[4], root, replace, _aw_, added, key, data);
        if (added[1]) t[2] = caml_call2(Base_Import[91], t[2], 1);
        if (1 - (new_root === root ? 1 : 0)) caml_check_bound(t[1], i)[1 + i] = new_root;
        return added[1];
    }
    function maybe_resize_table(t) {
        var len = t[1].length - 1, should_grow = len < t[2] ? 1 : 0, _an_ = should_grow ? t[3] : should_grow;
        if (_an_) {
            var _ao_ = caml_call2(Base_Import[88], len, 2), new_array_length = caml_call2(Base_Int[15], _ao_, max_table_length), _ap_ = len < new_array_length ? 1 : 0;
            if (_ap_) {
                var new_table = caml_call2(Base_Array[48], new_array_length, Base_Avltree[1]), old_table = t[1];
                t[1] = new_table;
                t[2] = 0;
                var f = function(key, data) {
                    add_worker(t, 1, key, data);
                    return 0;
                }, _ar_ = caml_call2(Base_Import[93], old_table.length - 1, 1), _aq_ = 0;
                if (_ar_ >= 0) {
                    var i = _aq_;
                    for(;;){
                        var _au_ = caml_check_bound(old_table, i)[1 + i];
                        caml_call2(Base_Avltree[17], _au_, f);
                        var _av_ = i + 1 | 0;
                        if (_ar_ === i) break;
                        i = _av_;
                    }
                }
                var _as_ = 0;
            } else var _as_ = _ap_;
            var _at_ = _as_;
        } else var _at_ = _an_;
        return _at_;
    }
    function capacity(t) {
        return t[1].length - 1;
    }
    function set(t, key, data) {
        ensure_mutation_allowed(t);
        add_worker(t, 1, key, data);
        return maybe_resize_table(t);
    }
    function add(t, key, data) {
        ensure_mutation_allowed(t);
        var added = add_worker(t, 0, key, data);
        return added ? (maybe_resize_table(t), 17724) : -1024851605;
    }
    function add_exn(t, key, data) {
        if (17724 <= add(t, key, data)) return 0;
        var sexp_of_key$0 = sexp_of_key(t), error = caml_call5(Base_Error[19], 0, 0, cst_Hashtbl_add_exn_got_key_al, key, sexp_of_key$0);
        return caml_call1(Base_Error[31], error);
    }
    function clear(t) {
        ensure_mutation_allowed(t);
        var _ak_ = caml_call2(Base_Import[93], t[1].length - 1, 1), _aj_ = 0;
        if (_ak_ >= 0) {
            var i = _aj_;
            for(;;){
                var _al_ = Base_Avltree[1];
                caml_check_bound(t[1], i)[1 + i] = _al_;
                var _am_ = i + 1 | 0;
                if (_ak_ === i) break;
                i = _am_;
            }
        }
        t[2] = 0;
        return 0;
    }
    function find_and_call(t, key, if_found, if_not_found) {
        var _ah_ = slot(t, key), tree = caml_check_bound(t[1], _ah_)[1 + _ah_];
        if (typeof tree === "number") return caml_call1(if_not_found, key);
        if (0 === tree[0]) {
            var _ai_ = compare_key(t);
            return caml_call5(Base_Avltree[8], tree, _ai_, key, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call1(if_found, v) : caml_call1(if_not_found, key);
    }
    function find_and_call1(t, key, a, if_found, if_not_found) {
        var _af_ = slot(t, key), tree = caml_check_bound(t[1], _af_)[1 + _af_];
        if (typeof tree === "number") return caml_call2(if_not_found, key, a);
        if (0 === tree[0]) {
            var _ag_ = compare_key(t);
            return caml_call6(Base_Avltree[9], tree, _ag_, key, a, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call2(if_found, v, a) : caml_call2(if_not_found, key, a);
    }
    function find_and_call2(t, key, a, b, if_found, if_not_found) {
        var _ad_ = slot(t, key), tree = caml_check_bound(t[1], _ad_)[1 + _ad_];
        if (typeof tree === "number") return caml_call3(if_not_found, key, a, b);
        if (0 === tree[0]) {
            var _ae_ = compare_key(t);
            return caml_call7(Base_Avltree[10], tree, _ae_, key, a, b, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call3(if_found, v, a, b) : caml_call3(if_not_found, key, a, b);
    }
    function findi_and_call(t, key, if_found, if_not_found) {
        var _ab_ = slot(t, key), tree = caml_check_bound(t[1], _ab_)[1 + _ab_];
        if (typeof tree === "number") return caml_call1(if_not_found, key);
        if (0 === tree[0]) {
            var _ac_ = compare_key(t);
            return caml_call5(Base_Avltree[11], tree, _ac_, key, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call2(if_found, k, v) : caml_call1(if_not_found, key);
    }
    function findi_and_call1(t, key, a, if_found, if_not_found) {
        var _$_ = slot(t, key), tree = caml_check_bound(t[1], _$_)[1 + _$_];
        if (typeof tree === "number") return caml_call2(if_not_found, key, a);
        if (0 === tree[0]) {
            var _aa_ = compare_key(t);
            return caml_call6(Base_Avltree[12], tree, _aa_, key, a, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call3(if_found, k, v, a) : caml_call2(if_not_found, key, a);
    }
    function findi_and_call2(t, key, a, b, if_found, if_not_found) {
        var _Z_ = slot(t, key), tree = caml_check_bound(t[1], _Z_)[1 + _Z_];
        if (typeof tree === "number") return caml_call3(if_not_found, key, a, b);
        if (0 === tree[0]) {
            var ___ = compare_key(t);
            return caml_call7(Base_Avltree[13], tree, ___, key, a, b, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call4(if_found, k, v, a, b) : caml_call3(if_not_found, key, a, b);
    }
    function if_found(v) {
        return [
            0,
            v
        ];
    }
    function if_not_found(param) {
        return 0;
    }
    function find(t, key) {
        return find_and_call(t, key, if_found, if_not_found);
    }
    function mem(t, key) {
        var _X_ = slot(t, key), tree = caml_check_bound(t[1], _X_)[1 + _X_];
        if (typeof tree === "number") return 0;
        if (0 === tree[0]) {
            var _Y_ = compare_key(t);
            return caml_call3(Base_Avltree[14], tree, _Y_, key);
        }
        var k = tree[1];
        return 0 === caml_call2(compare_key(t), k, key) ? 1 : 0;
    }
    function remove(t, key) {
        ensure_mutation_allowed(t);
        var i = slot(t, key), root = caml_check_bound(t[1], i)[1 + i], removed = [
            0,
            0
        ], _U_ = compare_key(t), new_root = caml_call4(Base_Avltree[15], root, removed, _U_, key);
        if (1 - (root === new_root ? 1 : 0)) caml_check_bound(t[1], i)[1 + i] = new_root;
        var _V_ = removed[1], _W_ = _V_ ? (t[2] = caml_call2(Base_Import[93], t[2], 1), 0) : _V_;
        return _W_;
    }
    function length(t) {
        return t[2];
    }
    function is_empty(t) {
        return 0 === t[2] ? 1 : 0;
    }
    function fold(t, init, f) {
        if (0 === t[2]) return init;
        var n = t[1].length - 1, acc = [
            0,
            init
        ], m = t[5];
        try {
            t[5] = 0;
            var _S_ = caml_call2(Base_Import[93], n, 1), _R_ = 0;
            if (_S_ >= 0) {
                var i = _R_;
                for(;;){
                    var bucket = t[1][1 + i];
                    if (typeof bucket !== "number") {
                        if (0 === bucket[0]) acc[1] = caml_call3(Base_Avltree[16], bucket, acc[1], f);
                        else {
                            var key = bucket[1], data = bucket[2];
                            acc[1] = caml_call3(f, key, data, acc[1]);
                        }
                    }
                    var _T_1 = i + 1 | 0;
                    if (_S_ === i) break;
                    i = _T_1;
                }
            }
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            t[5] = m;
            throw caml_maybe_attach_backtrace(exn, 0);
        }
        t[5] = m;
        return acc[1];
    }
    function iteri(t, f) {
        if (0 === t[2]) return 0;
        var n = t[1].length - 1, m = t[5];
        try {
            t[5] = 0;
            var _P_ = caml_call2(Base_Import[93], n, 1), _O_ = 0;
            if (_P_ >= 0) {
                var i = _O_;
                for(;;){
                    var bucket = t[1][1 + i];
                    if (typeof bucket !== "number") {
                        if (0 === bucket[0]) caml_call2(Base_Avltree[17], bucket, f);
                        else {
                            var key = bucket[1], data = bucket[2];
                            caml_call2(f, key, data);
                        }
                    }
                    var _Q_ = i + 1 | 0;
                    if (_P_ === i) break;
                    i = _Q_;
                }
            }
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            t[5] = m;
            throw caml_maybe_attach_backtrace(exn, 0);
        }
        t[5] = m;
        return 0;
    }
    function iter(t, f) {
        return iteri(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function iter_keys(t, f) {
        return iteri(t, function(key, param) {
            return caml_call1(f, key);
        });
    }
    function choose_nonempty(table, i) {
        var i$0 = i;
        for(;;){
            var avltree = table[1 + i$0];
            if (!caml_call1(Base_Avltree[2], avltree)) return caml_call1(Base_Avltree[19], avltree);
            var _M_ = caml_call2(Base_Import[93], table.length - 1, 1), _N_ = caml_call2(Base_Import[91], i$0, 1), i$1 = caml_call2(Base_Import[116], _N_, _M_);
            i$0 = i$1;
        }
    }
    function choose_exn(t) {
        if (0 === t[2]) caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Hashtbl_choose_exn_of_empt, 0));
        return choose_nonempty(t[1], 0);
    }
    function choose(t) {
        return is_empty(t) ? 0 : [
            0,
            choose_nonempty(t[1], 0)
        ];
    }
    function choose_randomly_nonempty(random_state, t) {
        var start_idx = caml_call2(Base_Random[19][7], random_state, t[1].length - 1);
        return choose_nonempty(t[1], start_idx);
    }
    function choose_randomly(opt, t) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        return is_empty(t) ? 0 : [
            0,
            choose_randomly_nonempty(random_state, t)
        ];
    }
    function choose_randomly_exn(opt, t) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        if (0 === t[2]) caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Hashtbl_choose_randomly_ex, 0));
        return choose_randomly_nonempty(random_state, t);
    }
    function invariant(invariant_key, invariant_data, t) {
        var _I_ = caml_call2(Base_Import[93], t[1].length - 1, 1), _H_ = 0;
        if (_I_ >= 0) {
            var i = _H_;
            for(;;){
                var _J_ = compare_key(t), _K_ = caml_check_bound(t[1], i)[1 + i];
                caml_call2(Base_Avltree[3], _K_, _J_);
                var _L_ = i + 1 | 0;
                if (_I_ === i) break;
                i = _L_;
            }
        }
        var real_len = fold(t, 0, function(key, data, i) {
            caml_call1(invariant_key, key);
            caml_call1(invariant_data, data);
            return caml_call2(Base_Import[91], i, 1);
        });
        if (real_len === t[2]) return 0;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
    }
    function if_found$0(v, param) {
        return v;
    }
    function if_not_found$0(k, t) {
        var _G_ = [
            1,
            [
                0,
                _b_,
                [
                    0,
                    caml_call1(t[4][3], k),
                    0
                ]
            ]
        ];
        throw caml_maybe_attach_backtrace([
            0,
            Base_Import[297],
            _G_
        ], 1);
    }
    function find_exn(t, key) {
        return find_and_call1(t, key, t, if_found$0, if_not_found$0);
    }
    function existsi(t, f) {
        return caml_call1(with_return, function(r) {
            iteri(t, function(key, data) {
                var _F_ = caml_call2(f, key, data);
                return _F_ ? caml_call1(r, 1) : _F_;
            });
            return 0;
        });
    }
    function exists(t, f) {
        return existsi(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function for_alli(t, f) {
        return 1 - existsi(t, function(key, data) {
            return 1 - caml_call2(f, key, data);
        });
    }
    function for_all(t, f) {
        return 1 - existsi(t, function(param, data) {
            return 1 - caml_call1(f, data);
        });
    }
    function counti(t, f) {
        return fold(t, 0, function(key, data, acc) {
            return caml_call2(f, key, data) ? caml_call2(Base_Import[91], acc, 1) : acc;
        });
    }
    function count(t, f) {
        return fold(t, 0, function(param, data, acc) {
            return caml_call1(f, data) ? caml_call2(Base_Import[91], acc, 1) : acc;
        });
    }
    function mapi(t, f) {
        var new_t = create([
            0,
            t[3]
        ], [
            0,
            t[2]
        ], t[4], 0);
        iteri(t, function(key, data) {
            return set(new_t, key, caml_call2(f, key, data));
        });
        return new_t;
    }
    function map(t, f) {
        return mapi(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function copy(t) {
        return map(t, function(_E_) {
            return _E_;
        });
    }
    function filter_mapi(t, f) {
        var new_t = create([
            0,
            t[3]
        ], [
            0,
            t[2]
        ], t[4], 0);
        iteri(t, function(key, data) {
            var match = caml_call2(f, key, data);
            if (!match) return 0;
            var new_data = match[1];
            return set(new_t, key, new_data);
        });
        return new_t;
    }
    function filter_map(t, f) {
        return filter_mapi(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function filteri(t, f) {
        return filter_mapi(t, function(key, data) {
            return caml_call2(f, key, data) ? [
                0,
                data
            ] : 0;
        });
    }
    function filter(t, f) {
        return filteri(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function filter_keys(t, f) {
        return filteri(t, function(key, param) {
            return caml_call1(f, key);
        });
    }
    function partition_mapi(t, f) {
        var t0 = create([
            0,
            t[3]
        ], [
            0,
            t[2]
        ], t[4], 0), t1 = create([
            0,
            t[3]
        ], [
            0,
            t[2]
        ], t[4], 0);
        iteri(t, function(key, data) {
            var match = caml_call2(f, key, data);
            if (0 === match[0]) {
                var new_data = match[1];
                return set(t0, key, new_data);
            }
            var new_data$0 = match[1];
            return set(t1, key, new_data$0);
        });
        return [
            0,
            t0,
            t1
        ];
    }
    function partition_map(t, f) {
        return partition_mapi(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function partitioni_tf(t, f) {
        return partition_mapi(t, function(key, data) {
            return caml_call2(f, key, data) ? [
                0,
                data
            ] : [
                1,
                data
            ];
        });
    }
    function partition_tf(t, f) {
        return partitioni_tf(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function find_or_add(t, id, default$0) {
        return find_and_call(t, id, function(data) {
            return data;
        }, function(key) {
            var default$1 = caml_call1(default$0, 0);
            set(t, key, default$1);
            return default$1;
        });
    }
    function findi_or_add(t, id, default$0) {
        return find_and_call(t, id, function(data) {
            return data;
        }, function(key) {
            var default$1 = caml_call1(default$0, key);
            set(t, key, default$1);
            return default$1;
        });
    }
    function find_and_remove(t, key) {
        var result = find_and_call(t, key, if_found, if_not_found);
        if (caml_call1(Base_Option[53], result)) remove(t, key);
        return result;
    }
    function change(t, key, f) {
        var match = caml_call1(f, find_and_call(t, key, if_found, if_not_found));
        if (!match) return remove(t, key);
        var data = match[1];
        return set(t, key, data);
    }
    function update_and_return(t, key, f) {
        var data = caml_call1(f, find_and_call(t, key, if_found, if_not_found));
        set(t, key, data);
        return data;
    }
    function update(t, id, f) {
        update_and_return(t, id, f);
        return 0;
    }
    function incr_by(remove_if_zero, t, key, by) {
        return remove_if_zero ? change(t, key, function(opt) {
            var _D_ = caml_call2(Base_Option[30], opt, 0), n = caml_call2(Base_Import[91], by, _D_);
            return 0 === n ? 0 : [
                0,
                n
            ];
        }) : update(t, key, function(param) {
            if (!param) return by;
            var i = param[1];
            return caml_call2(Base_Import[91], by, i);
        });
    }
    function incr(_C_, opt, t, key) {
        var by = _C_ ? _C_[1] : 1, remove_if_zero = opt ? opt[1] : 0;
        return incr_by(remove_if_zero, t, key, by);
    }
    function decr(_B_, opt, t, key) {
        var by = _B_ ? _B_[1] : 1, remove_if_zero = opt ? opt[1] : 0;
        return incr_by(remove_if_zero, t, key, caml_call1(Base_Import[113], by));
    }
    function add_multi(t, key, data) {
        return update(t, key, function(param) {
            if (!param) return [
                0,
                data,
                0
            ];
            var l = param[1];
            return [
                0,
                data,
                l
            ];
        });
    }
    function remove_multi(t, key) {
        var match = find_and_call(t, key, if_found, if_not_found);
        if (!match) return 0;
        var _A_ = match[1];
        if (_A_ && _A_[2]) {
            var tl = _A_[2];
            return set(t, key, tl);
        }
        return remove(t, key);
    }
    function find_multi(t, key) {
        var match = find_and_call(t, key, if_found, if_not_found);
        if (!match) return 0;
        var l = match[1];
        return l;
    }
    function create_mapped(growth_allowed, size, hashable, get_key, get_data, rows) {
        if (size) var s = size[1], size$0 = s;
        else var size$0 = caml_call1(Base_List[45], rows);
        var res = create(growth_allowed, [
            0,
            size$0
        ], hashable, 0), dupes = [
            0,
            0
        ];
        caml_call2(Base_List[19], rows, function(r) {
            var key = caml_call1(get_key, r), data = caml_call1(get_data, r);
            return mem(res, key) ? (dupes[1] = [
                0,
                key,
                dupes[1]
            ], 0) : set(res, key, data);
        });
        var keys = dupes[1];
        return keys ? [
            0,
            175765640,
            caml_call2(Base_List[126], keys, hashable[2])
        ] : [
            0,
            17724,
            res
        ];
    }
    function of_alist(growth_allowed, size, hashable, lst) {
        var match = create_mapped(growth_allowed, size, hashable, Base_Import[125], Base_Import[127], lst);
        if (175765640 <= match[1]) {
            var k = match[2];
            return [
                0,
                -1048878709,
                caml_call1(Base_List[88], k)
            ];
        }
        var t = match[2];
        return [
            0,
            17724,
            t
        ];
    }
    function of_alist_report_all_dups(growth_allowed, size, hashable, lst) {
        return create_mapped(growth_allowed, size, hashable, Base_Import[125], Base_Import[127], lst);
    }
    function of_alist_or_error(growth_allowed, size, hashable, lst) {
        var match = of_alist(growth_allowed, size, hashable, lst);
        if (17724 <= match[1]) {
            var v = match[2];
            return [
                0,
                v
            ];
        }
        var key = match[2], sexp_of_key = hashable[3];
        return caml_call5(Base_Or_error[38], 0, 0, cst_Hashtbl_of_alist_exn_dupli, key, sexp_of_key);
    }
    function of_alist_exn(growth_allowed, size, hashable, lst) {
        var match = of_alist_or_error(growth_allowed, size, hashable, lst);
        if (0 === match[0]) {
            var v = match[1];
            return v;
        }
        var e = match[1];
        return caml_call1(Base_Error[31], e);
    }
    function of_alist_multi(growth_allowed, size$0, hashable, rows) {
        var get_data = Base_Import[127], get_key = Base_Import[125];
        if (size$0) var s = size$0[1], size = s;
        else var size = caml_call1(Base_List[45], rows);
        var res = create(growth_allowed, [
            0,
            size
        ], hashable, 0);
        caml_call2(Base_List[19], rows, function(r) {
            var key = caml_call1(get_key, r), data = caml_call1(get_data, r);
            return add_multi(res, key, data);
        });
        return res;
    }
    function to_alist(t) {
        return fold(t, 0, function(key, data, list) {
            return [
                0,
                [
                    0,
                    key,
                    data
                ],
                list
            ];
        });
    }
    function sexp_of_t(sexp_of_key, sexp_of_data, t) {
        var _w_ = to_alist(t), _x_ = caml_call2(Base_List[83], _w_, function(_z_, param) {
            var k2 = param[1], k1 = _z_[1];
            return caml_call2(t[4][2], k1, k2);
        }), _y_ = caml_call2(Base_Import[147], sexp_of_key, sexp_of_data);
        return caml_call1(caml_call1(Base_Import[149], _y_), _x_);
    }
    function t_of_sexp(hashable, k_of_sexp, d_of_sexp, sexp) {
        var _p_ = caml_call2(Base_Import[171], k_of_sexp, d_of_sexp), alist = caml_call2(Base_Import[173], _p_, sexp), match = of_alist(0, [
            0,
            caml_call1(Base_List[45], alist)
        ], hashable, alist);
        if (17724 <= match[1]) {
            var v = match[2];
            return v;
        }
        var k = match[2], _q_ = caml_call2(Base_Import[171], function(_v_) {
            return _v_;
        }, function(_u_) {
            return _u_;
        }), alist_sexps = caml_call2(Base_Import[173], _q_, sexp), found_first_k = [
            0,
            0
        ];
        caml_call3(Base_List[67], alist, alist_sexps, function(_r_, param) {
            var k2_sexp = param[1], k2 = _r_[1], _s_ = 0 === caml_call2(hashable[2], k, k2) ? 1 : 0;
            if (_s_) {
                if (found_first_k[1]) return caml_call2(Base_Import[156], cst_Hashtbl_t_of_sexp_duplicat, k2_sexp);
                found_first_k[1] = 1;
                var _t_ = 0;
            } else var _t_ = _s_;
            return _t_;
        });
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _c_
        ], 1);
    }
    function t_sexp_grammar(k_grammar, v_grammar) {
        var _o_ = caml_call2(Base_List[137][3], k_grammar, v_grammar);
        return caml_call1(Sexplib0_Sexp_grammar[1], _o_);
    }
    function keys(t) {
        return fold(t, 0, function(key, param, acc) {
            return [
                0,
                key,
                acc
            ];
        });
    }
    function data(t) {
        return fold(t, 0, function(param, data, list) {
            return [
                0,
                data,
                list
            ];
        });
    }
    function group(growth_allowed, size, hashable, get_key, get_data, combine, rows) {
        var groups = create(growth_allowed, size, hashable, 0);
        caml_call2(Base_List[19], rows, function(row) {
            var key = caml_call1(get_key, row), data = caml_call1(get_data, row), match = find_and_call(groups, key, if_found, if_not_found);
            if (match) var old = match[1], data$0 = caml_call2(combine, old, data);
            else var data$0 = data;
            return set(groups, key, data$0);
        });
        return groups;
    }
    function create_with_key(growth_allowed, size, hashable, get_key, rows) {
        return create_mapped(growth_allowed, size, hashable, get_key, function(_n_) {
            return _n_;
        }, rows);
    }
    function create_with_key_or_error(growth_allowed, size, hashable, get_key, rows) {
        var match = create_with_key(growth_allowed, size, hashable, get_key, rows);
        if (175765640 <= match[1]) {
            var keys = match[2], sexp_of_key = hashable[3], _l_ = [
                0,
                [
                    0,
                    cst_keys,
                    caml_call2(Base_Import[149], sexp_of_key, keys)
                ],
                0
            ], _m_ = caml_call2(Base_Sexp[10], cst_Hashtbl_create_with_key_du, _l_);
            return caml_call1(Base_Or_error[39], _m_);
        }
        var t = match[2];
        return [
            0,
            t
        ];
    }
    function create_with_key_exn(growth_allowed, size, hashable, get_key, rows) {
        var _k_ = create_with_key_or_error(growth_allowed, size, hashable, get_key, rows);
        return caml_call1(Base_Or_error[34], _k_);
    }
    function maybe_set(t, key, f, d) {
        var match = caml_call2(f, key, d);
        if (!match) return 0;
        var v = match[1];
        return set(t, key, v);
    }
    function merge(t_left, t_right, f) {
        if (1 - caml_call2(Base_Hashable[1], t_left[4], t_right[4])) caml_call1(Base_Import[126], cst_Hashtbl_merge_different_ha);
        var new_t = create([
            0,
            t_left[3]
        ], [
            0,
            t_left[2]
        ], t_left[4], 0);
        without_mutating(t_left, function(param) {
            return without_mutating(t_right, function(param) {
                iteri(t_left, function(key, left) {
                    var match = find_and_call(t_right, key, if_found, if_not_found);
                    if (!match) return maybe_set(new_t, key, f, [
                        0,
                        847852583,
                        left
                    ]);
                    var right = match[1];
                    return maybe_set(new_t, key, f, [
                        0,
                        737457313,
                        [
                            0,
                            left,
                            right
                        ]
                    ]);
                });
                return iteri(t_right, function(key, right) {
                    return find_and_call(t_left, key, if_found, if_not_found) ? 0 : maybe_set(new_t, key, f, [
                        0,
                        -57574468,
                        right
                    ]);
                });
            });
        });
        return new_t;
    }
    function merge_into(src, dst, f) {
        return iteri(src, function(key, data) {
            var dst_data$0 = find_and_call(dst, key, if_found, if_not_found), action = without_mutating(dst, function(param) {
                return caml_call3(f, key, data, dst_data$0);
            });
            if (!action) return remove(dst, key);
            var data$0 = action[1];
            if (!dst_data$0) return set(dst, key, data$0);
            var dst_data = dst_data$0[1], _j_ = 1 - (dst_data === data$0 ? 1 : 0);
            return _j_ ? set(dst, key, data$0) : _j_;
        });
    }
    function filteri_inplace(t, f) {
        var to_remove = fold(t, 0, function(key, data, ac) {
            return caml_call2(f, key, data) ? ac : [
                0,
                key,
                ac
            ];
        });
        return caml_call2(Base_List[19], to_remove, function(key) {
            return remove(t, key);
        });
    }
    function filter_inplace(t, f) {
        return filteri_inplace(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function filter_keys_inplace(t, f) {
        return filteri_inplace(t, function(key, param) {
            return caml_call1(f, key);
        });
    }
    function filter_mapi_inplace(t, f) {
        var map_results = fold(t, 0, function(key, data, ac) {
            return [
                0,
                [
                    0,
                    key,
                    caml_call2(f, key, data)
                ],
                ac
            ];
        });
        return caml_call2(Base_List[19], map_results, function(param) {
            var result = param[2], key = param[1];
            if (!result) return remove(t, key);
            var data = result[1];
            return set(t, key, data);
        });
    }
    function filter_map_inplace(t, f) {
        return filter_mapi_inplace(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function mapi_inplace(t, f) {
        ensure_mutation_allowed(t);
        return without_mutating(t, function(param) {
            var _h_ = Base_Avltree[18];
            return caml_call2(Base_Array[20], t[1], function(_i_) {
                return caml_call2(_h_, _i_, f);
            });
        });
    }
    function map_inplace(t, f) {
        return mapi_inplace(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function similar(equal, t$0, t) {
        var _f_ = t$0[2] === t[2] ? 1 : 0;
        return _f_ ? caml_call1(with_return, function(r) {
            without_mutating(t, function(param) {
                return iteri(t$0, function(key, data) {
                    var match = find_and_call(t, key, if_found, if_not_found);
                    if (!match) return caml_call1(r, 0);
                    var data$0 = match[1], _g_ = 1 - caml_call2(equal, data, data$0);
                    return _g_ ? caml_call1(r, 0) : _g_;
                });
            });
            return 1;
        }) : _f_;
    }
    function Creators(Key) {
        var hashable = Key[1];
        function create$0(growth_allowed, size, param) {
            return create(growth_allowed, size, hashable, 0);
        }
        function of_alist$0(growth_allowed, size, l) {
            return of_alist(growth_allowed, size, hashable, l);
        }
        function of_alist_report_all_dups$0(growth_allowed, size, l) {
            return of_alist_report_all_dups(growth_allowed, size, hashable, l);
        }
        function of_alist_or_error$0(growth_allowed, size, l) {
            return of_alist_or_error(growth_allowed, size, hashable, l);
        }
        function of_alist_exn$0(growth_allowed, size, l) {
            return of_alist_exn(growth_allowed, size, hashable, l);
        }
        function t_of_sexp$0(k_of_sexp, d_of_sexp, sexp) {
            return t_of_sexp(hashable, k_of_sexp, d_of_sexp, sexp);
        }
        function of_alist_multi$0(growth_allowed, size, l) {
            return of_alist_multi(growth_allowed, size, hashable, l);
        }
        function create_mapped$0(growth_allowed, size, get_key, get_data, l) {
            return create_mapped(growth_allowed, size, hashable, get_key, get_data, l);
        }
        function create_with_key$0(growth_allowed, size, get_key, l) {
            return create_with_key(growth_allowed, size, hashable, get_key, l);
        }
        function create_with_key_or_error$0(growth_allowed, size, get_key, l) {
            return create_with_key_or_error(growth_allowed, size, hashable, get_key, l);
        }
        function create_with_key_exn$0(growth_allowed, size, get_key, l) {
            return create_with_key_exn(growth_allowed, size, hashable, get_key, l);
        }
        function group$0(growth_allowed, size, get_key, get_data, combine, l) {
            return group(growth_allowed, size, hashable, get_key, get_data, combine, l);
        }
        return [
            0,
            t_of_sexp$0,
            create$0,
            of_alist$0,
            of_alist_report_all_dups$0,
            of_alist_or_error$0,
            of_alist_exn$0,
            of_alist_multi$0,
            create_mapped$0,
            create_with_key$0,
            create_with_key_or_error$0,
            create_with_key_exn$0,
            group$0
        ];
    }
    var hashable = Base_Hashable[2], _d_ = Creators([
        0,
        hashable
    ]), t_of_sexp$0 = _d_[1], create$0 = _d_[2], of_alist$0 = _d_[3], of_alist_report_all_dups$0 = _d_[4], of_alist_or_error$0 = _d_[5], of_alist_exn$0 = _d_[6], of_alist_multi$0 = _d_[7], create_mapped$0 = _d_[8], create_with_key$0 = _d_[9], create_with_key_or_error$0 = _d_[10], create_with_key_exn$0 = _d_[11], group$0 = _d_[12];
    function hashable$0(t) {
        return t[4];
    }
    var Private = [
        0,
        hashable$0
    ];
    function create$1(growth_allowed, size, m) {
        return create(growth_allowed, size, caml_call1(Base_Hashable[3], m), 0);
    }
    function of_alist$1(growth_allowed, size, m, l) {
        return of_alist(growth_allowed, size, caml_call1(Base_Hashable[3], m), l);
    }
    function of_alist_report_all_dups$1(growth_allowed, size, m, l) {
        return of_alist_report_all_dups(growth_allowed, size, caml_call1(Base_Hashable[3], m), l);
    }
    function of_alist_or_error$1(growth_allowed, size, m, l) {
        return of_alist_or_error(growth_allowed, size, caml_call1(Base_Hashable[3], m), l);
    }
    function of_alist_exn$1(growth_allowed, size, m, l) {
        return of_alist_exn(growth_allowed, size, caml_call1(Base_Hashable[3], m), l);
    }
    function of_alist_multi$1(growth_allowed, size, m, l) {
        return of_alist_multi(growth_allowed, size, caml_call1(Base_Hashable[3], m), l);
    }
    function create_mapped$1(growth_allowed, size, m, get_key, get_data, l) {
        return create_mapped(growth_allowed, size, caml_call1(Base_Hashable[3], m), get_key, get_data, l);
    }
    function create_with_key$1(growth_allowed, size, m, get_key, l) {
        return create_with_key(growth_allowed, size, caml_call1(Base_Hashable[3], m), get_key, l);
    }
    function create_with_key_or_error$1(growth_allowed, size, m, get_key, l) {
        return create_with_key_or_error(growth_allowed, size, caml_call1(Base_Hashable[3], m), get_key, l);
    }
    function create_with_key_exn$1(growth_allowed, size, m, get_key, l) {
        return create_with_key_exn(growth_allowed, size, caml_call1(Base_Hashable[3], m), get_key, l);
    }
    function group$1(growth_allowed, size, m, get_key, get_data, combine, l) {
        return group(growth_allowed, size, caml_call1(Base_Hashable[3], m), get_key, get_data, combine, l);
    }
    function hashable_s(t) {
        return caml_call1(Base_Hashable[4], t[4]);
    }
    function M(K) {
        return [
            0
        ];
    }
    function sexp_of_m_t(K, sexp_of_v, t) {
        return sexp_of_t(K[1], sexp_of_v, t);
    }
    function m_t_of_sexp(K, v_of_sexp, sexp) {
        var _e_ = K[1];
        return t_of_sexp(caml_call1(Base_Hashable[3], [
            0,
            K[2],
            K[3],
            K[4]
        ]), _e_, v_of_sexp, sexp);
    }
    function m_t_sexp_grammar(K, v_grammar) {
        return t_sexp_grammar(K[1], v_grammar);
    }
    function equal_m_t(param, equal_v, t1, t2) {
        return similar(equal_v, t1, t2);
    }
    var Base_Hashtbl = [
        0,
        hash,
        hash_param,
        sexp_of_t,
        create$1,
        of_alist$1,
        of_alist_report_all_dups$1,
        of_alist_or_error$1,
        of_alist_exn$1,
        of_alist_multi$1,
        create_mapped$1,
        create_with_key$1,
        create_with_key_or_error$1,
        create_with_key_exn$1,
        group$1,
        sexp_of_key,
        clear,
        copy,
        fold,
        iter_keys,
        iter,
        iteri,
        existsi,
        exists,
        for_alli,
        for_all,
        counti,
        count,
        length,
        capacity,
        is_empty,
        mem,
        remove,
        choose,
        choose_exn,
        choose_randomly,
        choose_randomly_exn,
        set,
        add,
        add_exn,
        change,
        update,
        update_and_return,
        map,
        mapi,
        filter_map,
        filter_mapi,
        filter_keys,
        filter,
        filteri,
        partition_map,
        partition_mapi,
        partition_tf,
        partitioni_tf,
        find_or_add,
        findi_or_add,
        find,
        find_exn,
        find_and_call,
        find_and_call1,
        find_and_call2,
        findi_and_call,
        findi_and_call1,
        findi_and_call2,
        find_and_remove,
        merge,
        merge_into,
        keys,
        data,
        filter_keys_inplace,
        filter_inplace,
        filteri_inplace,
        map_inplace,
        mapi_inplace,
        filter_map_inplace,
        filter_mapi_inplace,
        similar,
        similar,
        to_alist,
        incr,
        decr,
        add_multi,
        remove_multi,
        find_multi,
        hashable_s,
        invariant,
        Creators,
        [
            0,
            t_of_sexp$0,
            sexp_of_t,
            t_sexp_grammar,
            hashable,
            invariant,
            create$0,
            of_alist$0,
            of_alist_report_all_dups$0,
            of_alist_or_error$0,
            of_alist_exn$0,
            of_alist_multi$0,
            create_mapped$0,
            create_with_key$0,
            create_with_key_or_error$0,
            create_with_key_exn$0,
            group$0,
            sexp_of_key,
            clear,
            copy,
            fold,
            iter_keys,
            iter,
            iteri,
            existsi,
            exists,
            for_alli,
            for_all,
            counti,
            count,
            length,
            capacity,
            is_empty,
            mem,
            remove,
            choose,
            choose_exn,
            choose_randomly,
            choose_randomly_exn,
            set,
            add,
            add_exn,
            change,
            update,
            update_and_return,
            map,
            mapi,
            filter_map,
            filter_mapi,
            filter_keys,
            filter,
            filteri,
            partition_map,
            partition_mapi,
            partition_tf,
            partitioni_tf,
            find_or_add,
            findi_or_add,
            find,
            find_exn,
            find_and_call,
            find_and_call1,
            find_and_call2,
            findi_and_call,
            findi_and_call1,
            findi_and_call2,
            find_and_remove,
            merge,
            merge_into,
            keys,
            data,
            filter_keys_inplace,
            filter_inplace,
            filteri_inplace,
            map_inplace,
            mapi_inplace,
            filter_map_inplace,
            filter_mapi_inplace,
            similar,
            similar,
            to_alist,
            incr,
            decr,
            add_multi,
            remove_multi,
            find_multi
        ],
        M,
        sexp_of_m_t,
        m_t_of_sexp,
        m_t_sexp_grammar,
        equal_m_t,
        Private
    ];
    runtime.caml_register_global(26, Base_Hashtbl, "Base__Hashtbl");
    return;
})(globalThis);
//# 40993 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$4 = "", cst_out_of_range_0 = " out of range [0, ", cst_s_1e = "%s%.1e", cst_is_too_large = ") is too large", cst_is_too_small_or_NaN = ") is too small or NaN", cst$5 = ".", cst_Float_int63_round_down_exn = "Float.int63_round_down_exn: argument (", cst_Float_int63_round_nearest_ = "Float.int63_round_nearest_portable_alloc_exn: argument (", cst_Float_int63_round_up_exn_a = "Float.int63_round_up_exn: argument (", cst_Float_iround_down_exn_argu = "Float.iround_down_exn: argument (", cst_Float_iround_nearest_exn_a = "Float.iround_nearest_exn: argument (", cst_Float_iround_nearest_exn_a$0 = "Float.iround_nearest_exn: argument (%f) is too large", cst_Float_iround_up_exn_argume = "Float.iround_up_exn: argument (", cst_Infinite = "Infinite", cst_Nan = "Nan", cst_Normal = "Normal", cst_Subnormal = "Subnormal", cst_Zero = "Zero", cst_infinite = "infinite", cst_nan$1 = "nan", cst_normal = "normal", cst_src_float_ml = "src/float.ml", cst_subnormal = "subnormal", cst_zero = "zero", caml_bytes_set = runtime.caml_bytes_set, caml_float_compare = runtime.caml_float_compare, caml_format_float = runtime.caml_format_float, caml_int64_bits_of_float = runtime.caml_int64_bits_of_float, caml_int64_or = runtime.caml_int64_or, caml_int_compare = runtime.caml_int_compare, caml_log10_float = runtime.caml_log10_float, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_string_compare = runtime.caml_string_compare;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$3 = cst$4, cst$2 = cst$4, cst$1 = "-", cst$0 = cst$5, cst = cst$5, all = [
        0,
        0,
        [
            0,
            1,
            [
                0,
                2,
                [
                    0,
                    3,
                    [
                        0,
                        4,
                        0
                    ]
                ]
            ]
        ]
    ], error_source_007 = "float.ml.Class.t", t_sexp_grammar$0 = [
        3,
        [
            0,
            2,
            [
                0,
                [
                    1,
                    [
                        0,
                        cst_Infinite,
                        0
                    ]
                ],
                [
                    0,
                    [
                        1,
                        [
                            0,
                            cst_Nan,
                            0
                        ]
                    ],
                    [
                        0,
                        [
                            1,
                            [
                                0,
                                cst_Normal,
                                0
                            ]
                        ],
                        [
                            0,
                            [
                                1,
                                [
                                    0,
                                    cst_Subnormal,
                                    0
                                ]
                            ],
                            [
                                0,
                                [
                                    1,
                                    [
                                        0,
                                        cst_Zero,
                                        0
                                    ]
                                ],
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ], module_name = "Base.Float", Base_Printf = global_data.Base__Printf, Base_Or_error = global_data.Base__Or_error, Base_Int = global_data.Base__Int, Base_Int63 = global_data.Base__Int63, Stdlib_Int64 = global_data.Stdlib__Int64, Base_Int64 = global_data.Base__Int64, Base_Sexp = global_data.Base__Sexp, Base_Error = global_data.Base__Error, Assert_failure = global_data.Assert_failure, Base_Import = global_data.Base__Import, Base_String = global_data.Base__String, Base_Bytes0 = global_data.Base__Bytes0, Base_Char = global_data.Base__Char, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, Base_Float0 = global_data.Base__Float0, Base_Comparator = global_data.Base__Comparator, Base_Word_size = global_data.Base__Word_size, Base_Comparable = global_data.Base__Comparable, Base_Pretty_printer = global_data.Base__Pretty_printer, round_up = Base_Float0[1], round_down = Base_Float0[2], mod_float = Base_Float0[3], modf = Base_Float0[4], float_of_string = Base_Float0[5], float_of_string_opt = Base_Float0[6], nan = Base_Float0[7], max_value = Base_Float0[8], neg_infinity = Base_Float0[9], max_finite_value = Base_Float0[10], epsilon_float = Base_Float0[11], classify_float = Base_Float0[12], abs_float = Base_Float0[13], is_integer = Base_Float0[14], symbol = Base_Float0[15], symbol$0 = Base_Float0[16], frexp = Base_Float0[17], ldexp = Base_Float0[18], is_nan = Base_Float0[19], to_int64_preserve_order = Base_Float0[20], to_int64_preserve_order_exn = Base_Float0[21], of_int64_preserve_order = Base_Float0[22], one_ulp = Base_Float0[23], upper_bound_for_int = Base_Float0[24], lower_bound_for_int = Base_Float0[26], clamp_unchecked = Base_Float0[28], box = Base_Float0[29], raise_s = Base_Error[32], hash_fold_t = Base_Import[209], func = Base_Import[223];
    function hash(x) {
        return caml_call1(func, x);
    }
    var globalize = Base_Import[283], t_of_sexp = Base_Import[164], sexp_of_t = Base_Import[140], t_sexp_grammar = Base_Import[186], hashable = [
        0,
        hash,
        caml_float_compare,
        sexp_of_t
    ], compare = caml_float_compare, include = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ]), comparator = include[1], _a_ = [
        0,
        [
            11,
            "Float.of_string ",
            [
                2,
                0,
                0
            ]
        ],
        "Float.of_string %s"
    ];
    function invariant(param) {
        return 0;
    }
    function to_float(x) {
        return x;
    }
    function of_float(x) {
        return x;
    }
    function of_string(s) {
        try {
            var _a1_ = caml_call1(float_of_string, s);
            return _a1_;
        } catch (_a2_) {
            return caml_call3(Base_Printf[7], _a_, s, 0);
        }
    }
    function to_string(x) {
        var y = caml_format_float("%.15g", x), y$0 = caml_call1(float_of_string, y) == x ? y : caml_format_float("%.17g", x), l = runtime.caml_ml_string_length(y$0), i = 0;
        for(;;){
            if (l <= i) return caml_call2(Base_Import[112], y$0, cst);
            var match = runtime.caml_string_get(y$0, i);
            a: {
                if (48 <= match) {
                    if (58 > match) break a;
                } else if (45 === match) break a;
                return y$0;
            }
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
        }
    }
    var min_positive_subnormal_value = caml_call2(symbol, 2., -1074), min_positive_normal_value = caml_call2(symbol, 2., -1022), zero = 0., of_int = Base_Int[4], to_int = Base_Int[3];
    function of_int63(i) {
        return caml_call1(Base_Int63[3], i);
    }
    var of_int64 = runtime.caml_int64_to_float, to_int64 = runtime.caml_int64_of_float, iround_lbound = caml_call1(lower_bound_for_int, Base_Int[64]), iround_ubound = caml_call1(upper_bound_for_int, Base_Int[64]), _b_ = [
        0,
        [
            11,
            cst_Float_iround_up_exn_argume,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        "Float.iround_up_exn: argument (%f) is too large"
    ], _c_ = [
        0,
        [
            11,
            cst_Float_iround_up_exn_argume,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.iround_up_exn: argument (%f) is too small or NaN"
    ], _d_ = [
        0,
        [
            11,
            cst_Float_iround_down_exn_argu,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        "Float.iround_down_exn: argument (%f) is too large"
    ], _e_ = [
        0,
        [
            11,
            cst_Float_iround_down_exn_argu,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.iround_down_exn: argument (%f) is too small or NaN"
    ], _f_ = [
        0,
        [
            11,
            "Float.iround_towards_zero_exn: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Float.iround_towards_zero_exn: argument (%f) is out of range or NaN"
    ];
    function iround_up(t) {
        if (!(0. < t)) return iround_lbound <= t ? [
            0,
            caml_call1(Base_Int[63], t)
        ] : 0;
        var t$0 = caml_call1(round_up, t);
        return t$0 <= iround_ubound ? [
            0,
            caml_call1(Base_Int[63], t$0)
        ] : 0;
    }
    function iround_up_exn(t) {
        if (0. < t) {
            var t$0 = caml_call1(round_up, t);
            if (t$0 <= iround_ubound) return caml_call1(Base_Int[63], t$0);
            var _aZ_ = caml_call1(box, t);
            return caml_call3(Base_Printf[7], _b_, _aZ_, 0);
        }
        if (iround_lbound <= t) return caml_call1(Base_Int[63], t);
        var _a0_ = caml_call1(box, t);
        return caml_call3(Base_Printf[7], _c_, _a0_, 0);
    }
    function iround_down(t) {
        if (0. <= t) return t <= iround_ubound ? [
            0,
            caml_call1(Base_Int[63], t)
        ] : 0;
        var t$0 = caml_call1(round_down, t);
        return iround_lbound <= t$0 ? [
            0,
            caml_call1(Base_Int[63], t$0)
        ] : 0;
    }
    function iround_down_exn(t) {
        if (0. <= t) {
            if (t <= iround_ubound) return caml_call1(Base_Int[63], t);
            var _aX_ = caml_call1(box, t);
            return caml_call3(Base_Printf[7], _d_, _aX_, 0);
        }
        var t$0 = caml_call1(round_down, t);
        if (iround_lbound <= t$0) return caml_call1(Base_Int[63], t$0);
        var _aY_ = caml_call1(box, t);
        return caml_call3(Base_Printf[7], _e_, _aY_, 0);
    }
    function iround_towards_zero(t) {
        if (iround_lbound <= t && t <= iround_ubound) return [
            0,
            caml_call1(Base_Int[63], t)
        ];
        return 0;
    }
    function iround_towards_zero_exn(t) {
        if (iround_lbound <= t && t <= iround_ubound) return caml_call1(Base_Int[63], t);
        var _aW_ = caml_call1(box, t);
        return caml_call3(Base_Printf[7], _f_, _aW_, 0);
    }
    var _g_ = caml_call2(symbol, 2., 52.), round_nearest_lb = caml_call1(Base_Import[114], _g_), round_nearest_ub = caml_call2(symbol, 2., 52.), one_ulp_less_than_half = caml_call2(one_ulp, 759637122, 0.5);
    function add_half_for_round_nearest(t) {
        var _aV_ = t == one_ulp_less_than_half ? one_ulp_less_than_half : 0.5;
        return caml_call2(Base_Import[92], t, _aV_);
    }
    function iround_nearest_32(t) {
        if (0. <= t) {
            var t$0 = add_half_for_round_nearest(t);
            return t$0 <= iround_ubound ? [
                0,
                caml_call1(Base_Int[63], t$0)
            ] : 0;
        }
        var t$1 = caml_call1(round_down, caml_call2(Base_Import[92], t, 0.5));
        return iround_lbound <= t$1 ? [
            0,
            caml_call1(Base_Int[63], t$1)
        ] : 0;
    }
    function iround_nearest_64(t) {
        if (0. <= t) {
            if (!(t < round_nearest_ub)) return t <= iround_ubound ? [
                0,
                caml_call1(Base_Int[63], t)
            ] : 0;
            var _aT_ = add_half_for_round_nearest(t);
            return [
                0,
                caml_call1(Base_Int[63], _aT_)
            ];
        }
        if (!(round_nearest_lb < t)) return iround_lbound <= t ? [
            0,
            caml_call1(Base_Int[63], t)
        ] : 0;
        var _aU_ = caml_call1(round_down, caml_call2(Base_Import[92], t, 0.5));
        return [
            0,
            caml_call1(Base_Int[63], _aU_)
        ];
    }
    var _R_ = [
        0,
        [
            8,
            [
                0,
                0,
                4
            ],
            0,
            [
                0,
                8
            ],
            0
        ],
        "%.8G"
    ], _P_ = [
        0,
        [
            11,
            "exponent ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    cst_out_of_range_0,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "exponent %d out of range [0, %d]"
    ], _Q_ = [
        0,
        [
            11,
            "mantissa ",
            [
                2,
                0,
                [
                    11,
                    cst_out_of_range_0,
                    [
                        2,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "mantissa %s out of range [0, %s]"
    ], cst_Float_sign_exn_of_NAN = "Float.sign_exn of NAN", cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]", _L_ = [
        0,
        cst_src_float_ml,
        865,
        2
    ], _K_ = [
        0,
        [
            11,
            "Float.round_significant: invalid argument significant_digits:",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "Float.round_significant: invalid argument significant_digits:%d"
    ], _J_ = [
        0,
        [
            8,
            [
                0,
                0,
                3
            ],
            0,
            1,
            0
        ],
        "%.*g"
    ], _I_ = [
        0,
        "p"
    ], cst_t = "t", cst_g = "g", cst_m = "m", cst_k = "k", _F_ = [
        0,
        cst_src_float_ml,
        703,
        8
    ], _E_ = [
        0,
        cst_src_float_ml,
        706,
        8
    ], _A_ = [
        0,
        cst_src_float_ml,
        713,
        8
    ], _B_ = [
        0,
        cst_src_float_ml,
        714,
        8
    ], _C_ = [
        0,
        [
            2,
            0,
            [
                4,
                0,
                0,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        32,
                        0
                    ]
                ]
            ]
        ],
        "%s%d%s "
    ], _D_ = [
        0,
        [
            2,
            0,
            [
                4,
                0,
                0,
                0,
                [
                    2,
                    0,
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "%s%d%s%d"
    ], _z_ = [
        0,
        cst_src_float_ml,
        690,
        8
    ], cst_0 = ".0", _G_ = [
        0,
        [
            2,
            0,
            [
                8,
                [
                    0,
                    0,
                    1
                ],
                0,
                [
                    0,
                    1
                ],
                0
            ]
        ],
        cst_s_1e
    ], _H_ = [
        0,
        [
            2,
            0,
            [
                8,
                [
                    0,
                    0,
                    1
                ],
                0,
                [
                    0,
                    1
                ],
                0
            ]
        ],
        cst_s_1e
    ], cst_inf$1 = "-inf  ", cst_inf$2 = "inf  ", cst_nan$0 = "nan  ", cst_sexp = "sexp", cst_sexp_of_float_produced_str = "[sexp_of_float] produced strange sexp", _w_ = [
        0,
        [
            11,
            "to_string_hum: invalid argument ~decimals=",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "to_string_hum: invalid argument ~decimals=%d"
    ], _x_ = [
        0,
        [
            8,
            [
                0,
                1,
                0
            ],
            0,
            1,
            0
        ],
        "%+.*f"
    ], _y_ = [
        0,
        [
            8,
            [
                0,
                0,
                0
            ],
            0,
            1,
            0
        ],
        "%.*f"
    ], cst_inf = "inf", cst_inf$0 = "-inf", cst_nan = cst_nan$1, _r_ = [
        0,
        cst_Infinite
    ], _s_ = [
        0,
        cst_Nan
    ], _t_ = [
        0,
        cst_Normal
    ], _u_ = [
        0,
        cst_Subnormal
    ], _v_ = [
        0,
        cst_Zero
    ], _p_ = [
        0,
        [
            11,
            cst_Float_int63_round_nearest_,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        "Float.int63_round_nearest_portable_alloc_exn: argument (%f) is too large"
    ], _q_ = [
        0,
        [
            11,
            cst_Float_int63_round_nearest_,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.int63_round_nearest_portable_alloc_exn: argument (%f) is too small or NaN"
    ], _n_ = [
        0,
        [
            11,
            cst_Float_int63_round_down_exn,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        "Float.int63_round_down_exn: argument (%f) is too large"
    ], _o_ = [
        0,
        [
            11,
            cst_Float_int63_round_down_exn,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.int63_round_down_exn: argument (%f) is too small or NaN"
    ], _l_ = [
        0,
        [
            11,
            cst_Float_int63_round_up_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        "Float.int63_round_up_exn: argument (%f) is too large"
    ], _m_ = [
        0,
        [
            11,
            cst_Float_int63_round_up_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.int63_round_up_exn: argument (%f) is too small or NaN"
    ], _j_ = [
        0,
        [
            11,
            cst_Float_iround_nearest_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        cst_Float_iround_nearest_exn_a$0
    ], _k_ = [
        0,
        [
            11,
            cst_Float_iround_nearest_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.iround_nearest_exn: argument (%f) is too small or NaN"
    ], _h_ = [
        0,
        [
            11,
            cst_Float_iround_nearest_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        cst_Float_iround_nearest_exn_a$0
    ], _i_ = [
        0,
        [
            11,
            cst_Float_iround_nearest_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is too small",
                    0
                ]
            ]
        ],
        "Float.iround_nearest_exn: argument (%f) is too small"
    ], one = 1., minus_one = -1, pi = 3.141592653589793, sqrt_pi = 1.772453850905516, sqrt_2pi = 2.5066282746310007, euler = 0.5772156649015329, iround_nearest_64$0 = Base_Word_size[3] ? iround_nearest_64 : iround_nearest_32;
    function iround_nearest_exn_32(t) {
        if (0. <= t) {
            var t$0 = add_half_for_round_nearest(t);
            if (t$0 <= iround_ubound) return caml_call1(Base_Int[63], t$0);
            var _aR_ = caml_call1(box, t);
            return caml_call3(Base_Printf[7], _h_, _aR_, 0);
        }
        var t$1 = caml_call1(round_down, caml_call2(Base_Import[92], t, 0.5));
        if (iround_lbound <= t$1) return caml_call1(Base_Int[63], t$1);
        var _aS_ = caml_call1(box, t);
        return caml_call3(Base_Printf[7], _i_, _aS_, 0);
    }
    function iround_nearest_exn_64(t) {
        if (0. <= t) {
            if (t < round_nearest_ub) {
                var _aN_ = add_half_for_round_nearest(t);
                return caml_call1(Base_Int[63], _aN_);
            }
            if (t <= iround_ubound) return caml_call1(Base_Int[63], t);
            var _aO_ = caml_call1(box, t);
            return caml_call3(Base_Printf[7], _j_, _aO_, 0);
        }
        if (round_nearest_lb < t) {
            var _aP_ = caml_call1(round_down, caml_call2(Base_Import[92], t, 0.5));
            return caml_call1(Base_Int[63], _aP_);
        }
        if (iround_lbound <= t) return caml_call1(Base_Int[63], t);
        var _aQ_ = caml_call1(box, t);
        return caml_call3(Base_Printf[7], _k_, _aQ_, 0);
    }
    var iround_nearest_exn = Base_Word_size[3] ? iround_nearest_exn_64 : iround_nearest_exn_32;
    function iround_exn(opt, t) {
        var dir = opt ? opt[1] : 857423934;
        return 857423934 <= dir ? 1003109192 <= dir ? iround_towards_zero_exn(t) : iround_nearest_exn(t) : 759637122 <= dir ? iround_down_exn(t) : iround_up_exn(t);
    }
    function iround(opt, t) {
        var dir = opt ? opt[1] : 857423934;
        try {
            var _aL_ = [
                0,
                iround_exn([
                    0,
                    dir
                ], t)
            ];
            return _aL_;
        } catch (_aM_) {
            return 0;
        }
    }
    function is_inf(t) {
        return caml_call2(Base_Import[96], 1., t) == 0. ? 1 : 0;
    }
    function is_finite(t) {
        return caml_call2(Base_Import[94], t, t) == 0. ? 1 : 0;
    }
    function min_inan(x, y) {
        return caml_call1(is_nan, y) ? x : caml_call1(is_nan, x) ? y : x < y ? x : y;
    }
    function max_inan(x, y) {
        return caml_call1(is_nan, y) ? x : caml_call1(is_nan, x) ? y : y < x ? x : y;
    }
    var add = Base_Import[92], sub = Base_Import[94], neg = Base_Import[114], scale = Base_Import[90];
    function square(x) {
        return caml_call2(Base_Import[90], x, x);
    }
    function fractional(t) {
        return caml_call1(Base_Import[125], t);
    }
    function integral(t) {
        return caml_call1(Base_Import[127], t);
    }
    function round_towards_zero(t) {
        return 0. <= t ? caml_call1(round_down, t) : caml_call1(round_up, t);
    }
    function round_nearest_inline(t) {
        if (round_nearest_lb < t && t < round_nearest_ub) return caml_call1(round_down, add_half_for_round_nearest(t));
        return caml_call2(Base_Import[92], t, 0.);
    }
    function round_nearest(t) {
        return round_nearest_inline(t);
    }
    function round_nearest_half_to_even(t) {
        if (!(t <= round_nearest_lb) && !(round_nearest_ub <= t)) {
            var floor = caml_call1(round_down, t), ceil_or_succ = caml_call2(Base_Import[92], floor, 1.), diff_floor = caml_call2(Base_Import[94], t, floor), diff_ceil = caml_call2(Base_Import[94], ceil_or_succ, t);
            return diff_floor < diff_ceil ? floor : diff_ceil < diff_floor ? ceil_or_succ : caml_call2(mod_float, floor, 2.) == 0. ? floor : ceil_or_succ;
        }
        return caml_call2(Base_Import[92], t, 0.);
    }
    var int63_round_lbound = caml_call1(lower_bound_for_int, Base_Int63[87]), int63_round_ubound = caml_call1(upper_bound_for_int, Base_Int63[87]);
    function int63_round_up_exn(t) {
        if (0. < t) {
            var t$0 = caml_call1(round_up, t);
            if (t$0 <= int63_round_ubound) return caml_call1(Base_Int63[86], t$0);
            var _aJ_ = caml_call1(Base_Float0[29], t);
            return caml_call3(Base_Printf[7], _l_, _aJ_, 0);
        }
        if (int63_round_lbound <= t) return caml_call1(Base_Int63[86], t);
        var _aK_ = caml_call1(Base_Float0[29], t);
        return caml_call3(Base_Printf[7], _m_, _aK_, 0);
    }
    function int63_round_down_exn(t) {
        if (0. <= t) {
            if (t <= int63_round_ubound) return caml_call1(Base_Int63[86], t);
            var _aH_ = caml_call1(Base_Float0[29], t);
            return caml_call3(Base_Printf[7], _n_, _aH_, 0);
        }
        var t$0 = caml_call1(round_down, t);
        if (int63_round_lbound <= t$0) return caml_call1(Base_Int63[86], t$0);
        var _aI_ = caml_call1(Base_Float0[29], t);
        return caml_call3(Base_Printf[7], _o_, _aI_, 0);
    }
    function int63_round_nearest_portable_a(t0) {
        var t = round_nearest_inline(t0);
        if (0. < t) {
            if (t <= int63_round_ubound) return caml_call1(Base_Int63[86], t);
            var _aF_ = caml_call1(box, t0);
            return caml_call3(Base_Printf[7], _p_, _aF_, 0);
        }
        if (int63_round_lbound <= t) return caml_call1(Base_Int63[86], t);
        var _aG_ = caml_call1(box, t0);
        return caml_call3(Base_Printf[7], _q_, _aG_, 0);
    }
    function int63_round_nearest_arch64_noa(f) {
        var _aE_ = iround_nearest_exn(f);
        return caml_call1(Base_Int63[100], _aE_);
    }
    var int63_round_nearest_exn = Base_Word_size[3] ? int63_round_nearest_arch64_noa : int63_round_nearest_portable_a;
    function round(opt, t) {
        var dir = opt ? opt[1] : 857423934;
        return 857423934 <= dir ? 1003109192 <= dir ? round_towards_zero(t) : round_nearest_inline(t) : 759637122 <= dir ? caml_call1(round_down, t) : caml_call1(round_up, t);
    }
    var compare_local = caml_int_compare;
    function compare$0(a, b) {
        return caml_int_compare(a, b);
    }
    function t_of_sexp$0(sexp_008) {
        a: {
            if (0 === sexp_008[0]) {
                var _ay_ = sexp_008[1], _az_ = caml_string_compare(_ay_, cst_infinite);
                b: {
                    c: {
                        d: {
                            e: {
                                if (0 <= _az_) {
                                    if (0 < _az_) {
                                        if (_ay_ === cst_nan$1) break e;
                                        if (_ay_ === cst_normal) break d;
                                        if (_ay_ === cst_subnormal) break c;
                                        if (_ay_ !== cst_zero) break a;
                                        break b;
                                    }
                                } else if (_ay_ !== cst_Infinite) {
                                    if (_ay_ === cst_Nan) break e;
                                    if (_ay_ === cst_Normal) break d;
                                    if (_ay_ === cst_Subnormal) break c;
                                    if (_ay_ !== cst_Zero) break a;
                                    break b;
                                }
                                return 0;
                            }
                            return 1;
                        }
                        return 2;
                    }
                    return 3;
                }
                return 4;
            }
            var _aA_ = sexp_008[1];
            if (!_aA_) return caml_call2(Sexplib0_Sexp_conv_error[11], error_source_007, sexp_008);
            var _aB_ = _aA_[1];
            if (0 !== _aB_[0]) return caml_call2(Sexplib0_Sexp_conv_error[10], error_source_007, sexp_008);
            var _aC_ = _aB_[1], _aD_ = caml_string_compare(_aC_, cst_infinite);
            b: {
                c: {
                    d: {
                        e: {
                            if (0 <= _aD_) {
                                if (0 < _aD_) {
                                    if (_aC_ === cst_nan$1) break e;
                                    if (_aC_ === cst_normal) break d;
                                    if (_aC_ === cst_subnormal) break c;
                                    if (_aC_ !== cst_zero) break a;
                                    break b;
                                }
                            } else if (_aC_ !== cst_Infinite) {
                                if (_aC_ === cst_Nan) break e;
                                if (_aC_ === cst_Normal) break d;
                                if (_aC_ === cst_Subnormal) break c;
                                if (_aC_ !== cst_Zero) break a;
                                break b;
                            }
                            return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_007, sexp_008);
                        }
                        return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_007, sexp_008);
                    }
                    return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_007, sexp_008);
                }
                return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_007, sexp_008);
            }
            return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_007, sexp_008);
        }
        return caml_call2(Sexplib0_Sexp_conv_error[12], error_source_007, sexp_008);
    }
    function sexp_of_t$0(param) {
        switch(param){
            case 0:
                return _r_;
            case 1:
                return _s_;
            case 2:
                return _t_;
            case 3:
                return _u_;
            default:
                return _v_;
        }
    }
    function to_string$0(t) {
        var _ax_ = sexp_of_t$0(t);
        return caml_call1(Base_Import[160], _ax_);
    }
    function of_string$0(s) {
        return t_of_sexp$0(caml_call1(Base_Import[136], s));
    }
    function classify(t) {
        switch(caml_call1(classify_float, t)){
            case 0:
                return 2;
            case 1:
                return 3;
            case 2:
                return 4;
            case 3:
                return 0;
            default:
                return 1;
        }
    }
    function insert_underscores(_av_, opt, string) {
        var delimiter = _av_ ? _av_[1] : 95, strip_zero = opt ? opt[1] : 0, match = caml_call2(Base_String[100], string, 46);
        if (!match) return caml_call2(Base_Int_string_conversions[6], string, delimiter);
        var match$0 = match[1], right = match$0[2], left = match$0[1], left$0 = caml_call2(Base_Int_string_conversions[6], left, delimiter), right$0 = strip_zero ? caml_call2(Base_String[108], [
            0,
            function(c) {
                return caml_call2(Base_Char[12], c, 48);
            }
        ], right) : right;
        if (right$0 === cst$4) return left$0;
        var _aw_ = caml_call2(Base_Import[112], cst$0, right$0);
        return caml_call2(Base_Import[112], left$0, _aw_);
    }
    function to_string_hum(delimiter, _au_, strip_zero, opt, f) {
        var decimals = _au_ ? _au_[1] : 3, explicit_plus = opt ? opt[1] : 0;
        if (decimals < 0) caml_call3(Base_Printf[7], _w_, decimals, 0);
        var match = classify(f);
        if (1 === match) return cst_nan;
        if (!match) return 0. < f ? cst_inf : cst_inf$0;
        var s = explicit_plus ? caml_call3(Base_Printf[2], _x_, decimals, f) : caml_call3(Base_Printf[2], _y_, decimals, f);
        return insert_underscores(delimiter, strip_zero, s);
    }
    function sexp_of_t$1(t) {
        var sexp = caml_call1(sexp_of_t, t);
        if (1009018843 <= Base_Sexp[19][1]) return sexp;
        if (0 === sexp[0]) {
            var string = sexp[1];
            return caml_call4(Base_String[70], 0, 0, string, 69) ? sexp : [
                0,
                insert_underscores(0, 0, string)
            ];
        }
        var _at_ = [
            0,
            [
                0,
                cst_sexp,
                caml_call1(Base_Sexp[5], sexp)
            ],
            0
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_sexp_of_float_produced_str, _at_));
    }
    function to_padded_compact_string_custo(t, opt, kilo, mega, giga, tera, peta, param) {
        var prefix = opt ? opt[1] : cst$2, match = classify(t);
        if (1 === match) return cst_nan$0;
        if (!match) return t < 0. ? cst_inf$1 : cst_inf$2;
        function go(t) {
            function conv(mag, numerator, denominator) {
                a: {
                    if (denominator == 100. && 999.95 <= numerator) break a;
                    if (100000. <= denominator) {
                        var t$0 = caml_call2(Base_Import[90], denominator, 9.9995);
                        if (round_nearest_inline(t$0) <= numerator) break a;
                    }
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _F_
                    ], 1);
                }
                var t = caml_call2(Base_Import[90], denominator, 9999.5);
                if (!(numerator < round_nearest_inline(t))) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _E_
                ], 1);
                var k = caml_call1(round_down, caml_call2(Base_Import[96], numerator, denominator)), lower = caml_call2(Base_Import[90], denominator, k), _as_ = caml_call2(Base_Import[92], k, 1.), higher = caml_call2(Base_Import[90], denominator, _as_), diff_right = caml_call2(Base_Import[94], higher, numerator), diff_left = caml_call2(Base_Import[94], numerator, lower), k$0 = iround_nearest_exn(k), k$1 = diff_right < diff_left ? caml_call2(Base_Import[91], k$0, 1) : diff_left < diff_right ? k$0 : 0 === caml_call2(Base_Import[122], k$0, 2) ? k$0 : caml_call2(Base_Import[91], k$0, 1), d = caml_call2(Base_Import[122], k$1, 10), i = caml_call2(Base_Import[95], k$1, 10);
                if (0 <= i && 1000 > i) {
                    if (0 <= d && 10 > d) return 0 === d ? caml_call4(Base_Printf[2], _C_, prefix, i, mag) : caml_call5(Base_Printf[2], _D_, prefix, i, mag, d);
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _B_
                    ], 1);
                }
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _A_
                ], 1);
            }
            if (!(t < 999.95)) {
                if (t < 999950.) return conv(kilo, t, 100.);
                if (t < 999950000.) return conv(mega, t, 100000.);
                if (t < 999950000000.) return conv(giga, t, 100000000.);
                if (t < 999950000000000.) return conv(tera, t, 100000000000.);
                if (!peta) return caml_call3(Base_Printf[2], _H_, prefix, t);
                var peta$0 = peta[1];
                return t < 999950000000000000. ? conv(peta$0, t, 100000000000000.) : caml_call3(Base_Printf[2], _G_, prefix, t);
            }
            if (0. <= t && t < 999.95) {
                var x = caml_call2(Base_Import[112], prefix, caml_format_float("%.1f", t));
                if (!caml_call2(Base_String[96], x, cst_0)) return x;
                var x$0 = caml_call1(Base_Bytes0[21], x), n = runtime.caml_ml_bytes_length(x$0);
                caml_bytes_set(x$0, caml_call2(Base_Import[93], n, 1), 32);
                caml_bytes_set(x$0, caml_call2(Base_Import[93], n, 2), 32);
                return runtime.caml_string_of_bytes(x$0);
            }
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _z_
            ], 1);
        }
        if (0. <= t) return go(t);
        var _ar_ = go(caml_call1(Base_Import[114], t));
        return caml_call2(Base_Import[112], cst$1, _ar_);
    }
    function to_padded_compact_string(t) {
        return to_padded_compact_string_custo(t, 0, cst_k, cst_m, cst_g, cst_t, _I_, 0);
    }
    function int_pow(x, n) {
        if (0 === n) return 1.;
        var x$0 = [
            0,
            caml_call2(Base_Import[92], x, -0)
        ], n$0 = [
            0,
            n
        ], accum = [
            0,
            1.
        ];
        if (n$0[1] < 0) {
            x$0[1] = caml_call2(Base_Import[96], 1., x$0[1]);
            n$0[1] = caml_call1(Base_Import[113], n$0[1]);
            if (n$0[1] < 0) {
                accum[1] = x$0[1];
                n$0[1]--;
            }
        }
        for(;;){
            if (1 >= n$0[1]) return caml_call2(Base_Import[90], x$0[1], accum[1]);
            if (0 !== caml_call2(Base_Import[116], n$0[1], 1)) accum[1] = caml_call2(Base_Import[90], x$0[1], accum[1]);
            x$0[1] = caml_call2(Base_Import[90], x$0[1], x$0[1]);
            n$0[1] = caml_call2(Base_Import[120], n$0[1], 1);
        }
    }
    function round_gen(x, how) {
        if (x == 0.) return 0.;
        if (!is_finite(x)) return x;
        if (555917426 <= how[1]) var sd = how[2], _an_ = caml_call1(to_int, caml_call1(round_up, caml_log10_float(caml_call1(abs_float, x)))), dd = caml_call2(Base_Import[93], sd, _an_), dd$0 = dd, sd$0 = sd;
        else var dd$1 = how[2], _aq_ = caml_call1(to_int, caml_call1(round_up, caml_log10_float(caml_call1(abs_float, x)))), sd$1 = caml_call2(Base_Import[91], dd$1, _aq_), dd$0 = dd$1, sd$0 = sd$1;
        if (0 > sd$0) return 0.;
        if (17 <= sd$0) return x;
        var abs_dd = caml_call1(Base_Int[78], dd$0);
        if (22 >= abs_dd && 16 > sd$0) {
            var order = int_pow(10., abs_dd);
            if (0 <= dd$0) {
                var _ao_ = round_nearest_half_to_even(caml_call2(Base_Import[90], x, order));
                return caml_call2(Base_Import[96], _ao_, order);
            }
            var _ap_ = round_nearest_half_to_even(caml_call2(Base_Import[96], x, order));
            return caml_call2(Base_Import[90], _ap_, order);
        }
        return of_string(caml_call3(Base_Printf[2], _J_, sd$0, x));
    }
    function round_significant(x, significant_digits) {
        return 0 < significant_digits ? round_gen(x, [
            0,
            555917426,
            significant_digits
        ]) : caml_call3(Base_Printf[7], _K_, significant_digits, 0);
    }
    function round_decimal(x, decimal_digits) {
        return round_gen(x, [
            0,
            -352548012,
            decimal_digits
        ]);
    }
    function between(t, low, high) {
        var _al_ = low <= t ? 1 : 0, _am_ = _al_ ? t <= high ? 1 : 0 : _al_;
        return _am_;
    }
    function clamp_exn(t, min, max) {
        if (min <= max) return caml_call3(clamp_unchecked, t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _L_
        ], 1);
    }
    function clamp(t, min, max) {
        if (min <= max) return [
            0,
            caml_call3(clamp_unchecked, t, min, max)
        ];
        var _ai_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _aj_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _ai_
        ], _ak_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _aj_);
        return caml_call1(Base_Or_error[39], _ak_);
    }
    var symbol$1 = Base_Import[92], symbol$2 = Base_Import[94], symbol$3 = Base_Import[90], symbol$4 = Base_Import[96], symbol$5 = Base_Import[114];
    function sign_exn(t) {
        if (0. < t) return 2;
        if (t < 0.) return 0;
        if (t == 0.) return 1;
        var _ag_ = [
            0,
            [
                0,
                cst$3,
                sexp_of_t$1(t)
            ],
            0
        ], _ah_ = caml_call2(Base_Sexp[10], cst_Float_sign_exn_of_NAN, _ag_);
        return caml_call1(Base_Error[32], _ah_);
    }
    function sign_or_nan(t) {
        return 0. < t ? 2 : t < 0. ? 0 : t == 0. ? 1 : 3;
    }
    function ieee_negative(t) {
        var bits = caml_int64_bits_of_float(t);
        return runtime.caml_lessthan(bits, Stdlib_Int64[1]);
    }
    var mantissa_bits = 52, _M_ = Base_Int64[37], exponent_mask64 = runtime.caml_int64_sub(caml_call2(Base_Int64[53], Base_Int64[37], 11), _M_), exponent_mask = caml_call1(Base_Int64[6], exponent_mask64), _N_ = Base_Int63[43], _O_ = caml_call2(Base_Int63[76], Base_Int63[43], mantissa_bits), mantissa_mask = caml_call2(Base_Int63[46], _O_, _N_), mantissa_mask64 = caml_call1(Base_Int63[83], mantissa_mask);
    function ieee_exponent(t) {
        var bits = caml_int64_bits_of_float(t), _af_ = caml_call2(Base_Int64[67], bits, mantissa_bits);
        return runtime.caml_int64_to_int32(caml_call2(Base_Int64[48], _af_, exponent_mask64));
    }
    function ieee_mantissa(t) {
        var bits = caml_int64_bits_of_float(t);
        return caml_call1(Base_Int63[109], runtime.caml_int64_and(bits, mantissa_mask64));
    }
    function create_ieee_exn(negative, exponent, mantissa) {
        if (caml_call2(Base_Int[48], exponent, exponent_mask) !== exponent) return caml_call4(Base_Printf[6], _P_, exponent, exponent_mask, 0);
        var _ac_ = caml_call2(Base_Int63[71], mantissa, mantissa_mask);
        if (caml_call2(Base_Int63[17], _ac_, mantissa)) {
            var _ad_ = caml_call1(Base_Int63[11], mantissa_mask), _ae_ = caml_call1(Base_Int63[11], mantissa);
            return caml_call4(Base_Printf[6], _Q_, _ae_, _ad_, 0);
        }
        var sign_bits = negative ? Stdlib_Int64[10] : Stdlib_Int64[1], expt_bits = runtime.caml_int64_shift_left(runtime.caml_int64_of_int32(exponent), 52), mant_bits = caml_call1(Base_Int63[83], mantissa), bits = caml_int64_or(sign_bits, caml_int64_or(expt_bits, mant_bits));
        return runtime.caml_int64_float_of_bits(bits);
    }
    function create_ieee(negative, exponent, mantissa) {
        return caml_call2(Base_Or_error[31], 0, function(param) {
            return create_ieee_exn(negative, exponent, mantissa);
        });
    }
    function to_string$1(x) {
        return caml_call2(Base_Printf[2], _R_, x);
    }
    function sexp_of_t$2(x) {
        return [
            0,
            to_string$1(x)
        ];
    }
    function of_string$1(x) {
        return of_string(x);
    }
    var include$0 = caml_call1(Base_Comparable[14], [
        0,
        compare,
        sexp_of_t,
        zero
    ]), sign = include$0[5];
    function is_positive(t) {
        return 0. < t ? 1 : 0;
    }
    function is_non_negative(t) {
        return 0. <= t ? 1 : 0;
    }
    function is_negative(t) {
        return t < 0. ? 1 : 0;
    }
    function is_non_positive(t) {
        return t <= 0. ? 1 : 0;
    }
    var include$1 = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name,
        to_string
    ]), pp = include$1[1];
    function symbol$6(_ab_, _aa_) {
        return _ab_ != _aa_ ? 1 : 0;
    }
    function symbol$7(_$_, ___) {
        return _$_ < ___ ? 1 : 0;
    }
    function symbol$8(_Z_, _Y_) {
        return _Y_ < _Z_ ? 1 : 0;
    }
    function symbol$9(_X_, _W_) {
        return _X_ == _W_ ? 1 : 0;
    }
    function symbol$10(_V_, _U_) {
        return _V_ <= _U_ ? 1 : 0;
    }
    function symbol$11(_T_1, _S_) {
        return _S_ <= _T_1 ? 1 : 0;
    }
    function of_float$0(x) {
        return x;
    }
    var specialized_hash = Base_Import[223], Private = [
        0,
        box,
        clamp_unchecked,
        lower_bound_for_int,
        upper_bound_for_int,
        specialized_hash,
        one_ulp_less_than_half,
        int63_round_nearest_portable_a,
        int63_round_nearest_arch64_noa,
        iround_nearest_exn_64
    ], include$2 = Base_Import[108], ascending = include$2[1], descending = include$2[2], compare_local$0 = include$2[3], equal_local = include$2[4];
    function min(x, y) {
        if (!(x < y) && !caml_call1(is_nan, x)) return y;
        return x;
    }
    function max(x, y) {
        if (!(y < x) && !caml_call1(is_nan, x)) return y;
        return x;
    }
    var Base_Float = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$1,
        of_string,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        float_of_string_opt,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        equal_local,
        compare_local$0,
        invariant,
        min,
        max,
        nan,
        max_value,
        neg_infinity,
        max_value,
        neg_infinity,
        zero,
        one,
        minus_one,
        pi,
        sqrt_pi,
        sqrt_2pi,
        euler,
        epsilon_float,
        max_finite_value,
        min_positive_subnormal_value,
        min_positive_normal_value,
        to_int64_preserve_order,
        to_int64_preserve_order_exn,
        of_int64_preserve_order,
        one_ulp,
        of_int,
        to_int,
        of_int63,
        of_int64,
        to_int64,
        round,
        iround,
        iround_exn,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        round_nearest_half_to_even,
        iround_towards_zero,
        iround_down,
        iround_up,
        iround_nearest_64$0,
        iround_towards_zero_exn,
        iround_down_exn,
        iround_up_exn,
        iround_nearest_exn,
        int63_round_down_exn,
        int63_round_up_exn,
        int63_round_nearest_exn,
        iround_lbound,
        iround_ubound,
        int63_round_lbound,
        int63_round_ubound,
        round_significant,
        round_decimal,
        is_nan,
        is_inf,
        is_finite,
        is_integer,
        min_inan,
        max_inan,
        symbol$1,
        symbol$2,
        symbol$4,
        symbol$0,
        symbol$3,
        symbol,
        symbol$5,
        [
            0,
            fractional,
            integral
        ],
        modf,
        mod_float,
        add,
        sub,
        neg,
        scale,
        abs_float,
        [
            0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            symbol$0,
            symbol,
            symbol$5,
            symbol$11,
            symbol$10,
            symbol$9,
            symbol$8,
            symbol$7,
            symbol$6,
            abs_float,
            neg,
            zero,
            of_int,
            of_float$0
        ],
        [
            0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            symbol$0,
            symbol,
            symbol$5
        ],
        to_string,
        to_string_hum,
        to_padded_compact_string,
        to_padded_compact_string_custo,
        int_pow,
        square,
        ldexp,
        frexp,
        [
            0,
            compare$0,
            compare_local,
            all,
            t_of_sexp$0,
            sexp_of_t$0,
            t_sexp_grammar$0,
            of_string$0,
            to_string$0
        ],
        classify,
        sign,
        sign_exn,
        sign_or_nan,
        create_ieee,
        create_ieee_exn,
        ieee_negative,
        ieee_exponent,
        ieee_mantissa,
        [
            0,
            t_of_sexp,
            sexp_of_t$2,
            t_sexp_grammar,
            of_string$1,
            to_string$1
        ],
        Private
    ];
    runtime.caml_register_global(191, Base_Float, "Base__Float");
    return;
})(globalThis);
//# 42184 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Buffer_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Buffer_intf, "Base__Buffer_intf");
    return;
})(globalThis);
//# 42194 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Bytes = global_data.Base__Bytes, Base_Import = global_data.Base__Import, Stdlib_Buffer = global_data.Stdlib__Buffer, Base_Blit = global_data.Base__Blit, create = Stdlib_Buffer[1], contents = Stdlib_Buffer[2], to_bytes = Stdlib_Buffer[3], nth = Stdlib_Buffer[6], length = Stdlib_Buffer[7], clear = Stdlib_Buffer[8], reset = Stdlib_Buffer[9], add_char = Stdlib_Buffer[12], add_string = Stdlib_Buffer[16], add_bytes = Stdlib_Buffer[17], add_buffer = Stdlib_Buffer[21], _a_ = Stdlib_Buffer[18], _b_ = Stdlib_Buffer[19];
    function add_substring(t, s, pos, len) {
        return caml_call4(_a_, t, s, pos, len);
    }
    function add_subbytes(t, s, pos, len) {
        return caml_call4(_b_, t, s, pos, len);
    }
    function sexp_of_t(t) {
        var _c_ = caml_call1(contents, t);
        return caml_call1(Base_Import[136], _c_);
    }
    var caml_buffer_length = Stdlib_Buffer[7], caml_buffer_blit = Stdlib_Buffer[5];
    function create$0(len) {
        return caml_call1(Base_Bytes[34], len);
    }
    var length$0 = runtime.caml_ml_bytes_length;
    function unsafe_blit(src, src_pos, dst, dst_pos, len) {
        return caml_call5(caml_buffer_blit, src, src_pos, dst, dst_pos, len);
    }
    var To_bytes = caml_call1(caml_call1(Base_Blit[2], [
        0,
        caml_buffer_length
    ]), [
        0,
        length$0,
        create$0,
        unsafe_blit
    ]), blit = To_bytes[1], blito = To_bytes[2], unsafe_blit$0 = To_bytes[3], sub = To_bytes[4], subo = To_bytes[5], To_string = caml_call1(caml_call1(Base_Blit[3], [
        0
    ]), To_bytes), Base_Buffer = [
        0,
        sexp_of_t,
        create,
        contents,
        to_bytes,
        blit,
        blito,
        unsafe_blit$0,
        sub,
        subo,
        To_string,
        nth,
        length,
        clear,
        reset,
        add_char,
        add_string,
        add_substring,
        add_bytes,
        add_subbytes,
        add_buffer
    ];
    runtime.caml_register_global(4, Base_Buffer, "Base__Buffer");
    return;
})(globalThis);
//# 42290 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), elided_message = "<backtrace elided in test>", Base_Exn = global_data.Base__Exn, Base_Sys0 = global_data.Base__Sys0, Base_String = global_data.Base__String, Base_List = global_data.Base__List, Stdlib_Printexc = global_data.Stdlib__Printexc, Base_Int = global_data.Base__Int, elide = [
        0,
        0
    ];
    function get(opt, param) {
        var at_most_num_frames = opt ? opt[1] : Base_Int[65];
        return runtime.caml_get_current_callstack(at_most_num_frames);
    }
    function to_string(t) {
        return elide[1] ? elided_message : caml_call1(Stdlib_Printexc[14], t);
    }
    function to_string_list(t) {
        var _f_ = to_string(t);
        return caml_call1(Base_String[104], _f_);
    }
    function sexp_of_t(t) {
        var _e_ = to_string_list(t);
        return [
            1,
            caml_call2(Base_List[53], _e_, function(x) {
                return [
                    0,
                    x
                ];
            })
        ];
    }
    var set_recording = Stdlib_Printexc[7], am_recording = Stdlib_Printexc[8], cst_OCAMLRUNPARAM = "OCAMLRUNPARAM", cst_b = "b";
    function most_recent(param) {
        return caml_call1(Stdlib_Printexc[12], 0);
    }
    function most_recent_for_exn(exn) {
        return caml_call1(Base_Exn[18], exn) ? [
            0,
            most_recent(0)
        ] : 0;
    }
    function with_recording(b, f) {
        var saved = caml_call1(am_recording, 0);
        caml_call1(set_recording, b);
        return caml_call2(Base_Exn[13], f, function(param) {
            return caml_call1(set_recording, saved);
        });
    }
    function initialize_module(param) {
        var match = caml_call1(Base_Sys0[21], cst_OCAMLRUNPARAM);
        if (match) var x = match[1], _a_ = Base_String[97], _b_ = caml_call2(Base_String[102], x, 44), ocamlrunparam_mentions_backtra = caml_call2(Base_List[23], _b_, function(_d_) {
            return caml_call2(_a_, _d_, cst_b);
        });
        else var ocamlrunparam_mentions_backtra = 0;
        var _c_ = 1 - ocamlrunparam_mentions_backtra;
        return _c_ ? caml_call1(set_recording, 1) : _c_;
    }
    var Base_Backtrace = [
        0,
        sexp_of_t,
        get,
        to_string,
        to_string_list,
        elide,
        [
            0,
            am_recording,
            set_recording,
            with_recording,
            most_recent,
            most_recent_for_exn
        ],
        initialize_module
    ];
    runtime.caml_register_global(9, Base_Backtrace, "Base__Backtrace");
    return;
})(globalThis);
//# 42385 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Ref = global_data.Base__Ref, Base_Option = global_data.Base__Option, Base_List = global_data.Base__List, Base_Array = global_data.Base__Array, Shadow_stdlib = global_data.Shadow_stdlib, Base_Sexp_with_comparable = global_data.Base__Sexp_with_comparable, Base_Int_conversions = global_data.Base__Int_conversions, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Import = global_data.Base__Import, Base_Bool = global_data.Base__Bool, Base_Char = global_data.Base__Char, Base_Exn = global_data.Base__Exn, Base_Float = global_data.Base__Float, Base_Int = global_data.Base__Int, Base_Int32 = global_data.Base__Int32, Base_Int64 = global_data.Base__Int64, Base_Nativeint = global_data.Base__Nativeint, Base_String = global_data.Base__String, Base_Bytes = global_data.Base__Bytes, Base_Unit = global_data.Base__Unit, Base_Error = global_data.Base__Error, Base_Container_intf = global_data.Base__Container_intf, Base_Backtrace = global_data.Base__Backtrace, Exit = Shadow_stdlib[3], Not_found = Shadow_stdlib[4], max_int = Shadow_stdlib[8], min_int = Shadow_stdlib[9], infinity = Shadow_stdlib[11], neg_infinity = Shadow_stdlib[12], nan = Shadow_stdlib[13], max_float = Shadow_stdlib[14], min_float = Shadow_stdlib[15], epsilon_float = Shadow_stdlib[16], char_of_int = Shadow_stdlib[18], string_of_bool = Shadow_stdlib[19], bool_of_string_opt = Shadow_stdlib[20], bool_of_string = Shadow_stdlib[21], string_of_int = Shadow_stdlib[22], int_of_string_opt = Shadow_stdlib[23], string_of_float = Shadow_stdlib[24], float_of_string_opt = Shadow_stdlib[25], stdin = Shadow_stdlib[27], stdout = Shadow_stdlib[28], stderr = Shadow_stdlib[29], print_char = Shadow_stdlib[30], print_string = Shadow_stdlib[31], print_bytes = Shadow_stdlib[32], print_int = Shadow_stdlib[33], print_float = Shadow_stdlib[34], print_endline = Shadow_stdlib[35], print_newline = Shadow_stdlib[36], prerr_char = Shadow_stdlib[37], prerr_string = Shadow_stdlib[38], prerr_bytes = Shadow_stdlib[39], prerr_int = Shadow_stdlib[40], prerr_float = Shadow_stdlib[41], prerr_endline = Shadow_stdlib[42], prerr_newline = Shadow_stdlib[43], read_line = Shadow_stdlib[44], read_int_opt = Shadow_stdlib[45], read_int = Shadow_stdlib[46], read_float_opt = Shadow_stdlib[47], read_float = Shadow_stdlib[48], open_out = Shadow_stdlib[49], open_out_bin = Shadow_stdlib[50], open_out_gen = Shadow_stdlib[51], flush = Shadow_stdlib[52], flush_all = Shadow_stdlib[53], output_char = Shadow_stdlib[54], output_string = Shadow_stdlib[55], output_bytes = Shadow_stdlib[56], output = Shadow_stdlib[57], output_substring = Shadow_stdlib[58], output_byte = Shadow_stdlib[59], output_binary_int = Shadow_stdlib[60], output_value = Shadow_stdlib[61], seek_out = Shadow_stdlib[62], pos_out = Shadow_stdlib[63], out_channel_length = Shadow_stdlib[64], close_out = Shadow_stdlib[65], close_out_noerr = Shadow_stdlib[66], set_binary_mode_out = Shadow_stdlib[67], open_in = Shadow_stdlib[68], open_in_bin = Shadow_stdlib[69], open_in_gen = Shadow_stdlib[70], input_char = Shadow_stdlib[71], input_line = Shadow_stdlib[72], input = Shadow_stdlib[73], really_input = Shadow_stdlib[74], really_input_string = Shadow_stdlib[75], input_byte = Shadow_stdlib[76], input_binary_int = Shadow_stdlib[77], input_value = Shadow_stdlib[78], seek_in = Shadow_stdlib[79], pos_in = Shadow_stdlib[80], in_channel_length = Shadow_stdlib[81], close_in = Shadow_stdlib[82], close_in_noerr = Shadow_stdlib[83], set_binary_mode_in = Shadow_stdlib[84], string_of_format = Shadow_stdlib[85], symbol = Shadow_stdlib[86], exit = Shadow_stdlib[87], at_exit = Shadow_stdlib[88], valid_float_lexem = Shadow_stdlib[89], unsafe_really_input = Shadow_stdlib[90], do_at_exit = Shadow_stdlib[91], do_domain_local_at_exit = Shadow_stdlib[92], globalize = Base_Sexp_with_comparable[1], hash_fold_t = Base_Sexp_with_comparable[2], hash = Base_Sexp_with_comparable[3], t_of_sexp = Base_Sexp_with_comparable[4], sexp_of_t = Base_Sexp_with_comparable[5], Not_found_s = Base_Sexp_with_comparable[6], Of_sexp_error = Base_Sexp_with_comparable[7], message = Base_Sexp_with_comparable[8], default_indent = Base_Sexp_with_comparable[9], pp_hum = Base_Sexp_with_comparable[10], pp_hum_indent = Base_Sexp_with_comparable[11], pp_mach = Base_Sexp_with_comparable[12], pp = Base_Sexp_with_comparable[13], to_string_hum = Base_Sexp_with_comparable[14], to_string_mach = Base_Sexp_with_comparable[15], to_string = Base_Sexp_with_comparable[16], of_float_style = Base_Sexp_with_comparable[17], of_int_style = Base_Sexp_with_comparable[18], t_sexp_grammar = Base_Sexp_with_comparable[19], invariant = Base_Sexp_with_comparable[20], of_string = Base_Sexp_with_comparable[21], symbol$0 = Base_Sexp_with_comparable[22], symbol$1 = Base_Sexp_with_comparable[23], symbol$2 = Base_Sexp_with_comparable[24], symbol$3 = Base_Sexp_with_comparable[25], symbol$4 = Base_Sexp_with_comparable[26], symbol$5 = Base_Sexp_with_comparable[27], equal = Base_Sexp_with_comparable[28], compare = Base_Sexp_with_comparable[29], min = Base_Sexp_with_comparable[30], max = Base_Sexp_with_comparable[31], ascending = Base_Sexp_with_comparable[32], descending = Base_Sexp_with_comparable[33], between = Base_Sexp_with_comparable[34], clamp_exn = Base_Sexp_with_comparable[35], clamp = Base_Sexp_with_comparable[36], comparator = Base_Sexp_with_comparable[37], compare_local = Base_Sexp_with_comparable[38], equal_local = Base_Sexp_with_comparable[39], Sexp = [
        0,
        globalize,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        Not_found_s,
        Of_sexp_error,
        message,
        default_indent,
        pp_hum,
        pp_hum_indent,
        pp_mach,
        pp,
        to_string_hum,
        to_string_mach,
        to_string,
        of_float_style,
        of_int_style,
        t_sexp_grammar,
        invariant,
        of_string,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        symbol$5,
        equal,
        compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        compare_local,
        equal_local
    ], int_to_int32 = Base_Int_conversions[1], int_to_int32_exn = Base_Int_conversions[2], int_to_int32_trunc = Base_Int_conversions[3], int_to_int64 = Base_Int_conversions[4], int_to_nativeint = Base_Int_conversions[5], int32_to_int = Base_Int_conversions[6], int32_to_int_exn = Base_Int_conversions[7], int32_to_int_trunc = Base_Int_conversions[8], int32_to_int64 = Base_Int_conversions[9], int32_to_nativeint = Base_Int_conversions[10], int32_is_representable_as_int = Base_Int_conversions[11], int64_to_int = Base_Int_conversions[12], int64_to_int_exn = Base_Int_conversions[13], int64_to_int_trunc = Base_Int_conversions[14], int64_to_int32 = Base_Int_conversions[15], int64_to_int32_exn = Base_Int_conversions[16], int64_to_int32_trunc = Base_Int_conversions[17], int64_to_nativeint = Base_Int_conversions[18], int64_to_nativeint_exn = Base_Int_conversions[19], int64_to_nativeint_trunc = Base_Int_conversions[20], int64_fit_on_int63_exn = Base_Int_conversions[21], int64_is_representable_as_int6 = Base_Int_conversions[22], nativeint_to_int = Base_Int_conversions[23], nativeint_to_int_exn = Base_Int_conversions[24], nativeint_to_int_trunc = Base_Int_conversions[25], nativeint_to_int32 = Base_Int_conversions[26], nativeint_to_int32_exn = Base_Int_conversions[27], nativeint_to_int32_trunc = Base_Int_conversions[28], nativeint_to_int64 = Base_Int_conversions[29], num_bits_int = Base_Int_conversions[30], num_bits_int32 = Base_Int_conversions[31], num_bits_int64 = Base_Int_conversions[32], num_bits_nativeint = Base_Int_conversions[33], Make = Base_Int_string_conversions[1], Make_hex = Base_Int_string_conversions[2], Make_binary = Base_Int_string_conversions[3], sexp_of_int_style = Base_Int_string_conversions[4], insert_delimiter_every = Base_Int_string_conversions[5], insert_delimiter = Base_Int_string_conversions[6], insert_underscores = Base_Int_string_conversions[7], Int_conversions = [
        0,
        int_to_int32,
        int_to_int32_exn,
        int_to_int32_trunc,
        int_to_int64,
        int_to_nativeint,
        int32_to_int,
        int32_to_int_exn,
        int32_to_int_trunc,
        int32_to_int64,
        int32_to_nativeint,
        int32_is_representable_as_int,
        int64_to_int,
        int64_to_int_exn,
        int64_to_int_trunc,
        int64_to_int32,
        int64_to_int32_exn,
        int64_to_int32_trunc,
        int64_to_nativeint,
        int64_to_nativeint_exn,
        int64_to_nativeint_trunc,
        int64_fit_on_int63_exn,
        int64_is_representable_as_int6,
        nativeint_to_int,
        nativeint_to_int_exn,
        nativeint_to_int_trunc,
        nativeint_to_int32,
        nativeint_to_int32_exn,
        nativeint_to_int32_trunc,
        nativeint_to_int64,
        num_bits_int,
        num_bits_int32,
        num_bits_int64,
        num_bits_nativeint,
        Make,
        Make_hex,
        Make_binary,
        sexp_of_int_style,
        insert_delimiter_every,
        insert_delimiter,
        insert_underscores
    ], am_testing = Base_Import[129], Exported_for_specific_uses = [
        0,
        am_testing
    ], compare_array_local = Base_Array[2], compare_array = Base_Array[1], equal_array_local = Base_Array[106], equal_array = Base_Array[105], globalize_array = Base_Array[3], array_of_sexp = Base_Array[4], sexp_of_array = Base_Array[5];
    function array_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Array[6], a_sexp_grammar);
    }
    var compare_bool_local = Base_Bool[28];
    function compare_bool(a, b) {
        return caml_call2(compare_bool_local, a, b);
    }
    var equal_bool_local = Base_Bool[29];
    function equal_bool(a, b) {
        return caml_call2(equal_bool_local, a, b);
    }
    var globalize_bool = Base_Bool[2], hash_fold_bool = Base_Bool[4], func = Base_Bool[5];
    function hash_bool(x) {
        return caml_call1(func, x);
    }
    var bool_of_sexp = Base_Bool[6], sexp_of_bool = Base_Bool[7], bool_sexp_grammar = Base_Bool[3], compare_char_local = Base_Char[29];
    function compare_char(a, b) {
        return caml_call2(compare_char_local, a, b);
    }
    var equal_char_local = Base_Char[28];
    function equal_char(a, b) {
        return caml_call2(equal_char_local, a, b);
    }
    var globalize_char = Base_Char[2], hash_fold_char = Base_Char[4], func$0 = Base_Char[5];
    function hash_char(x) {
        return caml_call1(func$0, x);
    }
    var char_of_sexp = Base_Char[6], sexp_of_char = Base_Char[7], char_sexp_grammar = Base_Char[3], sexp_of_exn = Base_Exn[1], compare_float_local = Base_Float[24];
    function compare_float(a, b) {
        return caml_call2(compare_float_local, a, b);
    }
    var equal_float_local = Base_Float[23];
    function equal_float(a, b) {
        return caml_call2(equal_float_local, a, b);
    }
    var globalize_float = Base_Float[1], hash_fold_float = Base_Float[5], func$1 = Base_Float[6];
    function hash_float(x) {
        return caml_call1(func$1, x);
    }
    var float_of_sexp = Base_Float[7], sexp_of_float = Base_Float[8], float_sexp_grammar = Base_Float[2], compare_int_local = Base_Int[30];
    function compare_int(a, b) {
        return caml_call2(compare_int_local, a, b);
    }
    var equal_int_local = Base_Int[31];
    function equal_int(a, b) {
        return caml_call2(equal_int_local, a, b);
    }
    var globalize_int = Base_Int[1], hash_fold_int = Base_Int[7], func$2 = Base_Int[8];
    function hash_int(x) {
        return caml_call1(func$2, x);
    }
    var int_of_sexp = Base_Int[9], sexp_of_int = Base_Int[10], int_sexp_grammar = Base_Int[2], compare_int32_local = Base_Int32[36];
    function compare_int32(a, b) {
        return caml_call2(compare_int32_local, a, b);
    }
    var equal_int32_local = Base_Int32[37];
    function equal_int32(a, b) {
        return caml_call2(equal_int32_local, a, b);
    }
    var globalize_int32 = Base_Int32[1], hash_fold_int32 = Base_Int32[7], func$3 = Base_Int32[8];
    function hash_int32(x) {
        return caml_call1(func$3, x);
    }
    var int32_of_sexp = Base_Int32[9], sexp_of_int32 = Base_Int32[10], int32_sexp_grammar = Base_Int32[2], compare_int64_local = Base_Int64[30];
    function compare_int64(a, b) {
        return caml_call2(compare_int64_local, a, b);
    }
    var equal_int64_local = Base_Int64[31];
    function equal_int64(a, b) {
        return caml_call2(equal_int64_local, a, b);
    }
    var globalize_int64 = Base_Int64[1], hash_fold_int64 = Base_Int64[7], func$4 = Base_Int64[8];
    function hash_int64(x) {
        return caml_call1(func$4, x);
    }
    var int64_of_sexp = Base_Int64[9], sexp_of_int64 = Base_Int64[10], int64_sexp_grammar = Base_Int64[2], compare_list_local = Base_List[2], compare_list = Base_List[1], equal_list_local = Base_List[155], equal_list = Base_List[154], globalize_list = Base_List[3], hash_fold_list = Base_List[4], list_of_sexp = Base_List[5], sexp_of_list = Base_List[6];
    function list_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_List[7], a_sexp_grammar);
    }
    var compare_nativeint_local = Base_Nativeint[36];
    function compare_nativeint(a, b) {
        return caml_call2(compare_nativeint_local, a, b);
    }
    var equal_nativeint_local = Base_Nativeint[37];
    function equal_nativeint(a, b) {
        return caml_call2(equal_nativeint_local, a, b);
    }
    var globalize_nativeint = Base_Nativeint[1], hash_fold_nativeint = Base_Nativeint[7], func$5 = Base_Nativeint[8];
    function hash_nativeint(x) {
        return caml_call1(func$5, x);
    }
    var nativeint_of_sexp = Base_Nativeint[9], sexp_of_nativeint = Base_Nativeint[10], nativeint_sexp_grammar = Base_Nativeint[2], compare_option_local = Base_Option[2], compare_option = Base_Option[1], equal_option_local = Base_Option[7], equal_option = Base_Option[6], globalize_option = Base_Option[3], hash_fold_option = Base_Option[4], option_of_sexp = Base_Option[9], sexp_of_option = Base_Option[10];
    function option_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Option[5], a_sexp_grammar);
    }
    var compare_ref_local = Base_Ref[2], compare_ref = Base_Ref[1], equal_ref_local = Base_Ref[4], equal_ref = Base_Ref[3], globalize_ref = Base_Ref[5], ref_of_sexp = Base_Ref[6], sexp_of_ref = Base_Ref[7];
    function ref_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Ref[8], a_sexp_grammar);
    }
    var compare_string_local = Base_String[62];
    function compare_string(a, b) {
        return caml_call2(compare_string_local, a, b);
    }
    var equal_string_local = Base_String[135];
    function equal_string(a, b) {
        return caml_call2(equal_string_local, a, b);
    }
    var globalize_string = Base_String[1], hash_fold_string = Base_String[40];
    function hash_string(x) {
        return runtime.Base_hash_string(x);
    }
    var string_of_sexp = Base_String[41], sexp_of_string = Base_String[42], string_sexp_grammar = Base_String[2], compare_bytes_local = Base_Bytes[26];
    function compare_bytes(a, b) {
        return caml_call2(compare_bytes_local, a, b);
    }
    var equal_bytes_local = Base_Bytes[27];
    function equal_bytes(a, b) {
        return caml_call2(equal_bytes_local, a, b);
    }
    var globalize_bytes = Base_Bytes[1], bytes_of_sexp = Base_Bytes[2], sexp_of_bytes = Base_Bytes[3], bytes_sexp_grammar = Base_Bytes[4], compare_unit_local = Base_Unit[29];
    function compare_unit(a, b) {
        return caml_call2(compare_unit_local, a, b);
    }
    var equal_unit_local = Base_Unit[28];
    function equal_unit(a, b) {
        return caml_call2(equal_unit_local, a, b);
    }
    var globalize_unit = Base_Unit[2], hash_fold_unit = Base_Unit[4], func$6 = Base_Unit[5];
    function hash_unit(x) {
        return caml_call1(func$6, x);
    }
    var unit_of_sexp = Base_Unit[6], sexp_of_unit = Base_Unit[7], unit_sexp_grammar = Base_Unit[3], symbol$6 = Base_List[156][1], _a_ = Base_Int[75], symbol$7 = _a_[1], lnot = _a_[2], abs = _a_[3], zero = _a_[4], symbol$8 = _a_[5], symbol$9 = _a_[6], symbol$10 = _a_[7], _b_ = Base_Import[97], ascending$0 = _b_[1], descending$0 = _b_[2], max$0 = _b_[3], min$0 = _b_[4], include = Base_Float[100], symbol$11 = include[1], symbol$12 = include[2], symbol$13 = include[3], symbol$14 = include[4], symbol$15 = include[5], symbol$16 = include[6], symbol$17 = include[7], symbol_concat = Base_String[67], fst = Base_Import[125], snd = Base_Import[127], failwith = Base_Import[124], invalid_arg = Base_Import[126], raise_s = Base_Error[32], Export = [
        0,
        compare_array_local,
        compare_array,
        equal_array_local,
        equal_array,
        globalize_array,
        array_of_sexp,
        sexp_of_array,
        array_sexp_grammar,
        compare_bool_local,
        compare_bool,
        equal_bool_local,
        equal_bool,
        globalize_bool,
        hash_fold_bool,
        hash_bool,
        bool_of_sexp,
        sexp_of_bool,
        bool_sexp_grammar,
        compare_char_local,
        compare_char,
        equal_char_local,
        equal_char,
        globalize_char,
        hash_fold_char,
        hash_char,
        char_of_sexp,
        sexp_of_char,
        char_sexp_grammar,
        sexp_of_exn,
        compare_float_local,
        compare_float,
        equal_float_local,
        equal_float,
        globalize_float,
        hash_fold_float,
        hash_float,
        float_of_sexp,
        sexp_of_float,
        float_sexp_grammar,
        compare_int_local,
        compare_int,
        equal_int_local,
        equal_int,
        globalize_int,
        hash_fold_int,
        hash_int,
        int_of_sexp,
        sexp_of_int,
        int_sexp_grammar,
        compare_int32_local,
        compare_int32,
        equal_int32_local,
        equal_int32,
        globalize_int32,
        hash_fold_int32,
        hash_int32,
        int32_of_sexp,
        sexp_of_int32,
        int32_sexp_grammar,
        compare_int64_local,
        compare_int64,
        equal_int64_local,
        equal_int64,
        globalize_int64,
        hash_fold_int64,
        hash_int64,
        int64_of_sexp,
        sexp_of_int64,
        int64_sexp_grammar,
        compare_list_local,
        compare_list,
        equal_list_local,
        equal_list,
        globalize_list,
        hash_fold_list,
        list_of_sexp,
        sexp_of_list,
        list_sexp_grammar,
        compare_nativeint_local,
        compare_nativeint,
        equal_nativeint_local,
        equal_nativeint,
        globalize_nativeint,
        hash_fold_nativeint,
        hash_nativeint,
        nativeint_of_sexp,
        sexp_of_nativeint,
        nativeint_sexp_grammar,
        compare_option_local,
        compare_option,
        equal_option_local,
        equal_option,
        globalize_option,
        hash_fold_option,
        option_of_sexp,
        sexp_of_option,
        option_sexp_grammar,
        compare_ref_local,
        compare_ref,
        equal_ref_local,
        equal_ref,
        globalize_ref,
        ref_of_sexp,
        sexp_of_ref,
        ref_sexp_grammar,
        compare_string_local,
        compare_string,
        equal_string_local,
        equal_string,
        globalize_string,
        hash_fold_string,
        hash_string,
        string_of_sexp,
        sexp_of_string,
        string_sexp_grammar,
        compare_bytes_local,
        compare_bytes,
        equal_bytes_local,
        equal_bytes,
        globalize_bytes,
        bytes_of_sexp,
        sexp_of_bytes,
        bytes_sexp_grammar,
        compare_unit_local,
        compare_unit,
        equal_unit_local,
        equal_unit,
        globalize_unit,
        hash_fold_unit,
        hash_unit,
        unit_of_sexp,
        sexp_of_unit,
        unit_sexp_grammar,
        symbol$6,
        symbol$7,
        lnot,
        abs,
        zero,
        symbol$8,
        symbol$9,
        symbol$10,
        ascending$0,
        descending$0,
        max$0,
        min$0,
        symbol$11,
        symbol$12,
        symbol$13,
        symbol$14,
        symbol$15,
        symbol$16,
        symbol$17,
        symbol_concat,
        fst,
        snd,
        failwith,
        invalid_arg,
        raise_s
    ], compare_array_local$0 = Export[1], compare_array$0 = Export[2], equal_array_local$0 = Export[3], equal_array$0 = Export[4], globalize_array$0 = Export[5], array_of_sexp$0 = Export[6], sexp_of_array$0 = Export[7], array_sexp_grammar$0 = Export[8], compare_bool_local$0 = Export[9], compare_bool$0 = Export[10], equal_bool_local$0 = Export[11], equal_bool$0 = Export[12], globalize_bool$0 = Export[13], hash_fold_bool$0 = Export[14], hash_bool$0 = Export[15], bool_of_sexp$0 = Export[16], sexp_of_bool$0 = Export[17], bool_sexp_grammar$0 = Export[18], compare_char_local$0 = Export[19], compare_char$0 = Export[20], equal_char_local$0 = Export[21], equal_char$0 = Export[22], globalize_char$0 = Export[23], hash_fold_char$0 = Export[24], hash_char$0 = Export[25], char_of_sexp$0 = Export[26], sexp_of_char$0 = Export[27], char_sexp_grammar$0 = Export[28], sexp_of_exn$0 = Export[29], compare_float_local$0 = Export[30], compare_float$0 = Export[31], equal_float_local$0 = Export[32], equal_float$0 = Export[33], globalize_float$0 = Export[34], hash_fold_float$0 = Export[35], hash_float$0 = Export[36], float_of_sexp$0 = Export[37], sexp_of_float$0 = Export[38], float_sexp_grammar$0 = Export[39], compare_int_local$0 = Export[40], compare_int$0 = Export[41], equal_int_local$0 = Export[42], equal_int$0 = Export[43], globalize_int$0 = Export[44], hash_fold_int$0 = Export[45], hash_int$0 = Export[46], int_of_sexp$0 = Export[47], sexp_of_int$0 = Export[48], int_sexp_grammar$0 = Export[49], compare_int32_local$0 = Export[50], compare_int32$0 = Export[51], equal_int32_local$0 = Export[52], equal_int32$0 = Export[53], globalize_int32$0 = Export[54], hash_fold_int32$0 = Export[55], hash_int32$0 = Export[56], int32_of_sexp$0 = Export[57], sexp_of_int32$0 = Export[58], int32_sexp_grammar$0 = Export[59], compare_int64_local$0 = Export[60], compare_int64$0 = Export[61], equal_int64_local$0 = Export[62], equal_int64$0 = Export[63], globalize_int64$0 = Export[64], hash_fold_int64$0 = Export[65], hash_int64$0 = Export[66], int64_of_sexp$0 = Export[67], sexp_of_int64$0 = Export[68], int64_sexp_grammar$0 = Export[69], compare_list_local$0 = Export[70], compare_list$0 = Export[71], equal_list_local$0 = Export[72], equal_list$0 = Export[73], globalize_list$0 = Export[74], hash_fold_list$0 = Export[75], list_of_sexp$0 = Export[76], sexp_of_list$0 = Export[77], list_sexp_grammar$0 = Export[78], compare_nativeint_local$0 = Export[79], compare_nativeint$0 = Export[80], equal_nativeint_local$0 = Export[81], equal_nativeint$0 = Export[82], globalize_nativeint$0 = Export[83], hash_fold_nativeint$0 = Export[84], hash_nativeint$0 = Export[85], nativeint_of_sexp$0 = Export[86], sexp_of_nativeint$0 = Export[87], nativeint_sexp_grammar$0 = Export[88], compare_option_local$0 = Export[89], compare_option$0 = Export[90], equal_option_local$0 = Export[91], equal_option$0 = Export[92], globalize_option$0 = Export[93], hash_fold_option$0 = Export[94], option_of_sexp$0 = Export[95], sexp_of_option$0 = Export[96], option_sexp_grammar$0 = Export[97], compare_ref_local$0 = Export[98], compare_ref$0 = Export[99], equal_ref_local$0 = Export[100], equal_ref$0 = Export[101], globalize_ref$0 = Export[102], ref_of_sexp$0 = Export[103], sexp_of_ref$0 = Export[104], ref_sexp_grammar$0 = Export[105], compare_string_local$0 = Export[106], compare_string$0 = Export[107], equal_string_local$0 = Export[108], equal_string$0 = Export[109], globalize_string$0 = Export[110], hash_fold_string$0 = Export[111], hash_string$0 = Export[112], string_of_sexp$0 = Export[113], sexp_of_string$0 = Export[114], string_sexp_grammar$0 = Export[115], compare_bytes_local$0 = Export[116], compare_bytes$0 = Export[117], equal_bytes_local$0 = Export[118], equal_bytes$0 = Export[119], globalize_bytes$0 = Export[120], bytes_of_sexp$0 = Export[121], sexp_of_bytes$0 = Export[122], bytes_sexp_grammar$0 = Export[123], compare_unit_local$0 = Export[124], compare_unit$0 = Export[125], equal_unit_local$0 = Export[126], equal_unit$0 = Export[127], globalize_unit$0 = Export[128], hash_fold_unit$0 = Export[129], hash_unit$0 = Export[130], unit_of_sexp$0 = Export[131], sexp_of_unit$0 = Export[132], unit_sexp_grammar$0 = Export[133], symbol$18 = Export[134], symbol$19 = Export[135], lnot$0 = Export[136], abs$0 = Export[137], zero$0 = Export[138], symbol$20 = Export[139], symbol$21 = Export[140], symbol$22 = Export[141], ascending$1 = Export[142], descending$1 = Export[143], max$1 = Export[144], min$1 = Export[145], symbol$23 = Export[146], symbol$24 = Export[147], symbol$25 = Export[148], symbol$26 = Export[149], symbol$27 = Export[150], symbol$28 = Export[151], symbol$29 = Export[152], symbol_concat$0 = Export[153], fst$0 = Export[154], snd$0 = Export[155], failwith$0 = Export[156], invalid_arg$0 = Export[157], raise_s$0 = Export[158], include$0 = Base_Container_intf[1], Continue_or_stop = include$0[1], Not_found_s$0 = Base_Import[297];
    caml_call1(Base_Backtrace[7], 0);
    var Caml = [
        0
    ], Base = [
        0,
        Exit,
        Not_found,
        max_int,
        min_int,
        infinity,
        neg_infinity,
        nan,
        max_float,
        min_float,
        epsilon_float,
        char_of_int,
        string_of_bool,
        bool_of_string_opt,
        bool_of_string,
        string_of_int,
        int_of_string_opt,
        string_of_float,
        float_of_string_opt,
        stdin,
        stdout,
        stderr,
        print_char,
        print_string,
        print_bytes,
        print_int,
        print_float,
        print_endline,
        print_newline,
        prerr_char,
        prerr_string,
        prerr_bytes,
        prerr_int,
        prerr_float,
        prerr_endline,
        prerr_newline,
        read_line,
        read_int_opt,
        read_int,
        read_float_opt,
        read_float,
        open_out,
        open_out_bin,
        open_out_gen,
        flush,
        flush_all,
        output_char,
        output_string,
        output_bytes,
        output,
        output_substring,
        output_byte,
        output_binary_int,
        output_value,
        seek_out,
        pos_out,
        out_channel_length,
        close_out,
        close_out_noerr,
        set_binary_mode_out,
        open_in,
        open_in_bin,
        open_in_gen,
        input_char,
        input_line,
        input,
        really_input,
        really_input_string,
        input_byte,
        input_binary_int,
        input_value,
        seek_in,
        pos_in,
        in_channel_length,
        close_in,
        close_in_noerr,
        set_binary_mode_in,
        string_of_format,
        symbol,
        exit,
        at_exit,
        valid_float_lexem,
        unsafe_really_input,
        do_at_exit,
        do_domain_local_at_exit,
        Sexp,
        Int_conversions,
        Exported_for_specific_uses,
        Export,
        compare_array_local$0,
        compare_array$0,
        equal_array_local$0,
        equal_array$0,
        globalize_array$0,
        array_of_sexp$0,
        sexp_of_array$0,
        array_sexp_grammar$0,
        compare_bool_local$0,
        compare_bool$0,
        equal_bool_local$0,
        equal_bool$0,
        globalize_bool$0,
        hash_fold_bool$0,
        hash_bool$0,
        bool_of_sexp$0,
        sexp_of_bool$0,
        bool_sexp_grammar$0,
        compare_char_local$0,
        compare_char$0,
        equal_char_local$0,
        equal_char$0,
        globalize_char$0,
        hash_fold_char$0,
        hash_char$0,
        char_of_sexp$0,
        sexp_of_char$0,
        char_sexp_grammar$0,
        sexp_of_exn$0,
        compare_float_local$0,
        compare_float$0,
        equal_float_local$0,
        equal_float$0,
        globalize_float$0,
        hash_fold_float$0,
        hash_float$0,
        float_of_sexp$0,
        sexp_of_float$0,
        float_sexp_grammar$0,
        compare_int_local$0,
        compare_int$0,
        equal_int_local$0,
        equal_int$0,
        globalize_int$0,
        hash_fold_int$0,
        hash_int$0,
        int_of_sexp$0,
        sexp_of_int$0,
        int_sexp_grammar$0,
        compare_int32_local$0,
        compare_int32$0,
        equal_int32_local$0,
        equal_int32$0,
        globalize_int32$0,
        hash_fold_int32$0,
        hash_int32$0,
        int32_of_sexp$0,
        sexp_of_int32$0,
        int32_sexp_grammar$0,
        compare_int64_local$0,
        compare_int64$0,
        equal_int64_local$0,
        equal_int64$0,
        globalize_int64$0,
        hash_fold_int64$0,
        hash_int64$0,
        int64_of_sexp$0,
        sexp_of_int64$0,
        int64_sexp_grammar$0,
        compare_list_local$0,
        compare_list$0,
        equal_list_local$0,
        equal_list$0,
        globalize_list$0,
        hash_fold_list$0,
        list_of_sexp$0,
        sexp_of_list$0,
        list_sexp_grammar$0,
        compare_nativeint_local$0,
        compare_nativeint$0,
        equal_nativeint_local$0,
        equal_nativeint$0,
        globalize_nativeint$0,
        hash_fold_nativeint$0,
        hash_nativeint$0,
        nativeint_of_sexp$0,
        sexp_of_nativeint$0,
        nativeint_sexp_grammar$0,
        compare_option_local$0,
        compare_option$0,
        equal_option_local$0,
        equal_option$0,
        globalize_option$0,
        hash_fold_option$0,
        option_of_sexp$0,
        sexp_of_option$0,
        option_sexp_grammar$0,
        compare_ref_local$0,
        compare_ref$0,
        equal_ref_local$0,
        equal_ref$0,
        globalize_ref$0,
        ref_of_sexp$0,
        sexp_of_ref$0,
        ref_sexp_grammar$0,
        compare_string_local$0,
        compare_string$0,
        equal_string_local$0,
        equal_string$0,
        globalize_string$0,
        hash_fold_string$0,
        hash_string$0,
        string_of_sexp$0,
        sexp_of_string$0,
        string_sexp_grammar$0,
        compare_bytes_local$0,
        compare_bytes$0,
        equal_bytes_local$0,
        equal_bytes$0,
        globalize_bytes$0,
        bytes_of_sexp$0,
        sexp_of_bytes$0,
        bytes_sexp_grammar$0,
        compare_unit_local$0,
        compare_unit$0,
        equal_unit_local$0,
        equal_unit$0,
        globalize_unit$0,
        hash_fold_unit$0,
        hash_unit$0,
        unit_of_sexp$0,
        sexp_of_unit$0,
        unit_sexp_grammar$0,
        symbol$18,
        symbol$19,
        lnot$0,
        abs$0,
        zero$0,
        symbol$20,
        symbol$21,
        symbol$22,
        ascending$1,
        descending$1,
        max$1,
        min$1,
        symbol$23,
        symbol$24,
        symbol$25,
        symbol$26,
        symbol$27,
        symbol$28,
        symbol$29,
        symbol_concat$0,
        fst$0,
        snd$0,
        failwith$0,
        invalid_arg$0,
        raise_s$0,
        Continue_or_stop,
        Not_found_s$0,
        Caml
    ];
    runtime.caml_register_global(23, Base, "Base");
    return;
})(globalThis);
//# 1 "../.js/default/jane-street-headers/jane_street_headers.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/jane-street-headers/jane_street_headers.cma.js"
//# 1 "../.js/default/ppx_sexp_conv.runtime-lib/ppx_sexp_conv_lib.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_sexp_conv.runtime-lib/ppx_sexp_conv_lib.cma.js"
//# 1 "../.js/default/ppx_compare.runtime-lib/ppx_compare_lib.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_compare.runtime-lib/ppx_compare_lib.cma.js"
//# 1 "../.js/default/ppx_enumerate.runtime-lib/ppx_enumerate_lib.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_enumerate.runtime-lib/ppx_enumerate_lib.cma.js"
//# 1 "../.js/default/ppx_hash.runtime-lib/ppx_hash_lib.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_hash.runtime-lib/ppx_hash_lib.cma.js"
//# 1 "../.js/default/time_now/time_now.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/time_now/time_now.cma.js"
//# 6 "../.js/default/time_now/time_now.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Int63 = global_data.Base__Int63, Base = global_data.Base, cst_clock_gettime_CLOCK_REALTI = "clock_gettime(CLOCK_REALTIME) failed";
    function nanoseconds_since_unix_epoch(param) {
        var t = runtime.time_now_nanoseconds_since_unix_epoch_or_zero(0);
        return caml_call2(Base_Int63[17], t, Base_Int63[42]) ? t : caml_call1(Base[244], cst_clock_gettime_CLOCK_REALTI);
    }
    var Time_now = [
        0,
        nanoseconds_since_unix_epoch,
        function(_a_) {
            return runtime.time_now_nanosecond_counter_for_timing(_a_);
        }
    ];
    runtime.caml_register_global(3, Time_now, "Time_now");
    return;
})(globalThis);
//# 1 "../.js/default/ppx_inline_test.runtime-lib/ppx_inline_test_lib.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_inline_test.runtime-lib/ppx_inline_test_lib.cma.js"
//# 6 "../.js/default/ppx_inline_test.runtime-lib/ppx_inline_test_lib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$13 = "", cst$14 = "\n", cst$15 = " ", cst_line = " , line ", cst_File = " File ", cst_threw = " threw", cst_s$0 = "%s", cst_s = "%s%!", cst$12 = ".\n", cst_Ppx_inline_test_lib$0 = "Ppx_inline_test_lib", cst_TES = "TES", cst_TESTING_FRAMEWORK = "TESTING_FRAMEWORK", cst_T_MODULE_at$0 = "T_MODULE at ", cst_T_MODULES = "T_MODULES", cst_inline_test_runner$0 = "inline-test-runner", cst_inline_tests_log$0 = "inline_tests.log", cst_ppx_inline_test_error_the_ = "ppx_inline_test error: the following -only-test flags matched nothing:", caml_equal = runtime.caml_equal, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_obj_tag = runtime.caml_obj_tag, caml_sys_argv = runtime.caml_sys_argv, caml_sys_getenv = runtime.caml_sys_getenv, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), cst$11 = cst$13, cst$9 = cst$14, cst$10 = cst$15, cst$7 = cst$14, cst$8 = cst$15, cst$5 = cst$14, cst$6 = "  ", cst$3 = cst$14, cst$4 = cst$13, cst$2 = ".", cst$0 = cst$13, cst$1 = ": ", initial = [
        0,
        0,
        [
            0,
            "disabled",
            0
        ]
    ], cst = cst$13, am_running_env_var = cst_TESTING_FRAMEWORK, Stdlib_List = global_data.Stdlib__List, Stdlib = global_data.Stdlib, Stdlib_Printf = global_data.Stdlib__Printf, Base_Exn = global_data.Base__Exn, Stdlib_Filename = global_data.Stdlib__Filename, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, Stdlib_String = global_data.Stdlib__String, CamlinternalLazy = global_data.CamlinternalLazy, Stdlib_Result = global_data.Stdlib__Result, Base = global_data.Base, Base_String = global_data.Base__String, Base_List = global_data.Base__List, Stdlib_Random = global_data.Stdlib__Random, Base_Random = global_data.Base__Random, Stdlib_Printexc = global_data.Stdlib__Printexc, Base_Int63 = global_data.Base__Int63, Time_now = global_data.Time_now, Stdlib_Arg = global_data.Stdlib__Arg, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Scanf = global_data.Stdlib__Scanf, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, cst_success = "success", cst_failure = "failure", cst_error = "error";
    function to_string(param) {
        switch(param){
            case 0:
                return cst_success;
            case 1:
                return cst_failure;
            default:
                return cst_error;
        }
    }
    function combine(t1, t2) {
        a: {
            switch(t1){
                case 0:
                    if (!t2) return 0;
                    break;
                case 1:
                    break;
                default:
                    break a;
            }
            if (2 !== t2) return 1;
        }
        return 2;
    }
    function combine_all(ts) {
        return caml_call3(Stdlib_List[26], combine, 0, ts);
    }
    var already_initialized = [
        0,
        0
    ], test_modules_ran = [
        0,
        0
    ], test_modules_failed = [
        0,
        0
    ], tests_ran = [
        0,
        0
    ], tests_failed = [
        0,
        0
    ], dynamic_lib = [
        0,
        0
    ], action = [
        0,
        -950194894
    ], cst_source_tree_root$0 = "source_tree_root", cst_diff_path_prefix$0 = "diff_path_prefix", cst_diff_command = "diff_command", cst_in_place$0 = "in_place", cst_use_color = "use_color", _O_ = [
        0,
        [
            11,
            "ppx_inline_test error: attempted to access the [",
            [
                2,
                0,
                [
                    11,
                    "] config before [init] was called",
                    0
                ]
            ]
        ],
        "ppx_inline_test error: attempted to access the [%s] config before [init] was called"
    ], _N_ = [
        0,
        [
            2,
            0,
            [
                12,
                10,
                0
            ]
        ],
        "%s\n"
    ], _M_ = [
        0,
        1,
        [
            0,
            7,
            0
        ]
    ], _F_ = [
        0,
        [
            12,
            32,
            [
                2,
                0,
                [
                    12,
                    58,
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        " %s:%d"
    ], _G_ = [
        0,
        [
            12,
            32,
            [
                2,
                0,
                0
            ]
        ],
        " %s"
    ], _B_ = [
        0,
        [
            11,
            "inline_tests_runner.exe is not supposed to be run by hand, you \nshould run the inline_tests_runner script instead.\n",
            [
                10,
                0
            ]
        ],
        "inline_tests_runner.exe is not supposed to be run by hand, you \nshould run the inline_tests_runner script instead.\n%!"
    ], _C_ = [
        0,
        [
            11,
            "You are doing something unexpected with the tests. No tests have \nbeen run. You should use the inline_tests_runner script to run \ntests.\n",
            [
                10,
                0
            ]
        ],
        "You are doing something unexpected with the tests. No tests have \nbeen run. You should use the inline_tests_runner script to run \ntests.\n%!"
    ], _D_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                11,
                " tests ran, ",
                [
                    4,
                    0,
                    0,
                    0,
                    [
                        11,
                        " test_modules ran\n",
                        [
                            10,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "%d tests ran, %d test_modules ran\n%!"
    ], _E_ = [
        0,
        [
            11,
            cst_ppx_inline_test_error_the_,
            0
        ],
        cst_ppx_inline_test_error_the_
    ], _H_ = [
        0,
        [
            11,
            cst$12,
            [
                10,
                0
            ]
        ],
        ".\n%!"
    ], _I_ = [
        0,
        [
            11,
            "ppx_inline_test error: no tests have been run.\n",
            [
                10,
                0
            ]
        ],
        "ppx_inline_test error: no tests have been run.\n%!"
    ], _K_ = [
        0,
        [
            11,
            cst_T_MODULES,
            0
        ],
        cst_T_MODULES
    ], _L_ = [
        0,
        [
            11,
            ", ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " TES",
                    0
                ]
            ]
        ],
        ", %d TES"
    ], _J_ = [
        0,
        [
            11,
            "FAILED ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " / ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " tests",
                            [
                                2,
                                0,
                                [
                                    12,
                                    10,
                                    [
                                        10,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "FAILED %d / %d tests%s\n%!"
    ], _z_ = [
        0,
        [
            11,
            cst_T_MODULE_at$0,
            [
                2,
                0,
                [
                    11,
                    cst_threw,
                    [
                        2,
                        0,
                        [
                            2,
                            0,
                            [
                                11,
                                cst$12,
                                [
                                    2,
                                    0,
                                    [
                                        2,
                                        0,
                                        [
                                            12,
                                            10,
                                            [
                                                10,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "T_MODULE at %s threw%s%s.\n%s%s\n%!"
    ], _A_ = [
        0,
        [
            11,
            cst_TES,
            0
        ],
        cst_TES
    ], cst_ppx_inline_test_cannot_use = "ppx_inline_test: cannot use -list-partition or -partition without specifying a partition at preprocessing time", _t_ = [
        0,
        [
            2,
            0,
            [
                12,
                10,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s\n%s"
    ], _u_ = [
        0,
        [
            2,
            0,
            [
                10,
                0
            ]
        ],
        cst_s
    ], _v_ = [
        0,
        1
    ], _w_ = [
        0,
        [
            11,
            " (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                [
                    0,
                    3
                ],
                [
                    11,
                    " sec)\n",
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        " (%.3f sec)\n%!"
    ], _x_ = [
        0,
        [
            2,
            0,
            [
                11,
                " is false.\n",
                [
                    2,
                    0,
                    [
                        12,
                        10,
                        [
                            10,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "%s is false.\n%s\n%!"
    ], _y_ = [
        0,
        [
            2,
            0,
            [
                11,
                cst_threw,
                [
                    2,
                    0,
                    [
                        2,
                        0,
                        [
                            11,
                            cst$12,
                            [
                                2,
                                0,
                                [
                                    2,
                                    0,
                                    [
                                        12,
                                        10,
                                        [
                                            10,
                                            0
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s threw%s%s.\n%s%s\n%!"
    ], _s_ = [
        0,
        [
            2,
            0,
            [
                10,
                0
            ]
        ],
        cst_s
    ], _r_ = [
        0,
        [
            2,
            0,
            [
                10,
                0
            ]
        ],
        cst_s
    ], _q_ = [
        0,
        [
            12,
            10,
            [
                2,
                0,
                [
                    12,
                    10,
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        "\n%s\n%!"
    ], cst_T_MODULE_at = cst_T_MODULE_at$0, cst_in_TES = "  in TES", cst_time_without_resetting_ran = "time_without_resetting_random_seeds", cst_Ppx_inline_test_lib = cst_Ppx_inline_test_lib$0, _l_ = [
        0,
        0
    ], _j_ = [
        0,
        0
    ], cst_inline_tests_log = cst_inline_tests_log$0, _i_ = [
        0,
        [
            11,
            "Argument ",
            [
                2,
                0,
                [
                    11,
                    " doesn't fit the format filename[:line_number]\n",
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        "Argument %s doesn't fit the format filename[:line_number]\n%!"
    ], _h_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": unexpected anonymous argument ",
                [
                    2,
                    0,
                    [
                        12,
                        10,
                        [
                            10,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "%s: unexpected anonymous argument %s\n%!"
    ], cst_The_inline_test_runner_can = "The inline test runner can only be initialized once, and has already been initialized.", cst_inline_test_runner = cst_inline_test_runner$0, _g_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    2,
                    0,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " [args]",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s %s %s [args]"
    ], cst_Prefix_to_prepend_to_filep = " Prefix to prepend to filepaths in test output", cst_diff_path_prefix = "-diff-path-prefix", cst_Path_to_the_root_of_the_so = " Path to the root of the source tree", cst_source_tree_root = "-source-tree-root", cst_Diff_command_for_tests_tha = " Diff command for tests that require diffing (use - to disable diffing)", cst_diff_cmd = "-diff-cmd", cst_Update_expect_tests_in_pla = " Update expect tests in place", cst_in_place = "-in-place", cst_Summarize_tests_without_us = " Summarize tests without using color", cst_no_color = "-no-color", cst_location_Run_only_the_test = 'location Run only the tests specified by all the -only-test options.\n                      Locations can be one of these forms:\n                      - file.ml\n                      - file.ml:line_number\n                      - File "file.ml"\n                      - File "file.ml", line 23\n                      - File "file.ml", line 23, characters 2-3', cst_only_test = "-only-test", cst_substring_Only_run_tests_w = "substring Only run tests whose names contain the given substring", cst_matching = "-matching", cst_tag_Only_run_tests_tagged_ = "tag Only run tests tagged with [tag] (overrides previous -drop-tag)", cst_require_tag = "-require-tag", cst_tag_Only_run_tests_not_tag = "tag Only run tests not tagged with [tag] (overrides previous -require-tag)", cst_drop_tag = "-drop-tag", cst_Log_the_tests_run_in_inlin = " Log the tests run in inline_tests.log", cst_log = "-log", cst_Show_the_number_of_tests_r = " Show the number of tests ran", cst_show_counts = "-show-counts", cst_End_with_an_error_if_no_te = " End with an error if no tests were run", cst_strict = "-strict", cst_Run_tests_only_up_to_the_f = " Run tests only up to the first error (doesn't work for expect tests)", cst_stop_on_error = "-stop-on-error", cst_Show_the_tests_as_they_run = " Show the tests as they run", cst_verbose = "-verbose", cst_Only_run_the_tests_in_the_ = " Only run the tests in the given partition", cst_partition = "-partition", cst_Lists_all_the_partitions_t = " Lists all the partitions that contain at least one test or test_module into FILE", cst_list_partitions_into_file = "-list-partitions-into-file", cst_Lists_all_the_partitions_t$0 = " Lists all the partitions that contain at least one test or test_module", cst_list_partitions = "-list-partitions", cst_Do_not_run_tests_but_show_ = " Do not run tests but show what would have been run", cst_list_test_names = "-list-test-names", _f_ = [
        0,
        [
            11,
            cst_File,
            [
                3,
                0,
                [
                    11,
                    cst_line,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " , characters ",
                            [
                                4,
                                0,
                                0,
                                0,
                                [
                                    11,
                                    " - ",
                                    [
                                        4,
                                        0,
                                        0,
                                        0,
                                        [
                                            12,
                                            32,
                                            [
                                                10,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        " File %S , line %d , characters %d - %d %!"
    ], _e_ = [
        0,
        [
            11,
            cst_File,
            [
                3,
                0,
                [
                    11,
                    cst_line,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            12,
                            32,
                            [
                                10,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        " File %S , line %d %!"
    ], _d_ = [
        0,
        [
            11,
            cst_File,
            [
                3,
                0,
                [
                    12,
                    32,
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        " File %S %!"
    ], _c_ = [
        0,
        [
            11,
            "File ",
            [
                3,
                0,
                [
                    11,
                    ", line ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ", characters ",
                            [
                                4,
                                0,
                                0,
                                0,
                                [
                                    12,
                                    45,
                                    [
                                        4,
                                        0,
                                        0,
                                        0,
                                        [
                                            2,
                                            0,
                                            0
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "File %S, line %d, characters %d-%d%s"
    ], _k_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s$0
    ], _R_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s$0
    ], _p_ = [
        0,
        187165616,
        545942154
    ], _P_ = [
        0,
        187165616,
        -863538453
    ];
    try {
        caml_sys_getenv("FORCE_DROP_INLINE_TEST");
        var _T_1 = 1, force_drop = _T_1;
    } catch (_bx_) {
        var _a_ = caml_wrap_exception(_bx_);
        if (_a_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_a_, 0);
        var force_drop = 0;
    }
    function get(param) {
        return force_drop ? -950194894 : action[1];
    }
    var _b_ = caml_call2(Stdlib_Hashtbl[1], 0, 23), current = [
        0,
        cst
    ];
    function found_test(param) {
        var _bv_ = current[1] !== cst$13 ? 1 : 0, _bw_ = _bv_ ? 1 - caml_call2(Stdlib_Hashtbl[9], _b_, current[1]) : _bv_;
        return _bw_ ? caml_call3(Stdlib_Hashtbl[5], _b_, current[1], 0) : _bw_;
    }
    function is_current(param) {
        if (!param) return 1;
        var p = param[1];
        return p == current[1] ? 1 : 0;
    }
    var current$0 = [
        0,
        0
    ];
    function current_tags(param) {
        var t = current$0[1], _bu_ = caml_call2(Stdlib_List[20], function(m) {
            return m[2];
        }, t);
        return caml_call1(Stdlib_List[14], _bu_);
    }
    var verbose = [
        0,
        0
    ], strict = [
        0,
        0
    ], show_counts = [
        0,
        0
    ], list_test_names = [
        0,
        0
    ], delayed_errors = [
        0,
        0
    ], stop_on_error = [
        0,
        0
    ], log = [
        0,
        0
    ], time_sec = [
        0,
        0.
    ], use_color = [
        0,
        1
    ], in_place = [
        0,
        0
    ], diff_command = [
        0,
        0
    ], source_tree_root = [
        0,
        0
    ], diff_path_prefix = [
        0,
        0
    ];
    function displayed_descr(descr, filename, line, start_pos, end_pos) {
        var _bs_ = caml_obj_tag(descr);
        a: if (250 === _bs_) var descr$0 = descr[1];
        else {
            if (246 !== _bs_ && 244 !== _bs_) {
                var descr$0 = descr;
                break a;
            }
            var descr$0 = caml_call1(CamlinternalLazy[2], descr);
        }
        var _bt_ = descr$0 == cst$13 ? cst$0 : caml_call2(Stdlib[28], cst$1, descr$0);
        return caml_call6(Stdlib_Printf[4], _c_, filename, line, start_pos, end_pos, _bt_);
    }
    function parse_argv(current, args) {
        if (args) {
            var _a__ = args[2];
            if (_a__) {
                var name = args[1];
                if (_a__[1] === cst_inline_test_runner$0) {
                    var match = _a__[2];
                    if (match) {
                        var rest = match[2], lib = match[1];
                        if (already_initialized[1]) throw caml_maybe_attach_backtrace([
                            0,
                            Stdlib_Arg[8],
                            cst_The_inline_test_runner_can
                        ], 1);
                        already_initialized[1] = 1;
                        var tests = [
                            0,
                            0
                        ], list_partitions = [
                            0,
                            0
                        ], partition = [
                            0,
                            0
                        ], tag_predicate = [
                            0,
                            initial
                        ], name_filter = [
                            0,
                            0
                        ], _a$_ = caml_call4(Stdlib_Printf[4], _g_, name, cst_inline_test_runner, lib), _ba_ = caml_call2(Stdlib_Arg[11], 0, [
                            0,
                            [
                                0,
                                cst_list_test_names,
                                [
                                    0,
                                    function(param) {
                                        list_test_names[1] = 1;
                                        verbose[1] = 1;
                                        return 0;
                                    }
                                ],
                                cst_Do_not_run_tests_but_show_
                            ],
                            [
                                0,
                                [
                                    0,
                                    cst_list_partitions,
                                    [
                                        0,
                                        function(param) {
                                            list_partitions[1] = _j_;
                                            return 0;
                                        }
                                    ],
                                    cst_Lists_all_the_partitions_t$0
                                ],
                                [
                                    0,
                                    [
                                        0,
                                        cst_list_partitions_into_file,
                                        [
                                            4,
                                            function(file) {
                                                list_partitions[1] = [
                                                    0,
                                                    [
                                                        0,
                                                        file
                                                    ]
                                                ];
                                                return 0;
                                            }
                                        ],
                                        cst_Lists_all_the_partitions_t
                                    ],
                                    [
                                        0,
                                        [
                                            0,
                                            cst_partition,
                                            [
                                                4,
                                                function(i) {
                                                    partition[1] = [
                                                        0,
                                                        i
                                                    ];
                                                    return 0;
                                                }
                                            ],
                                            cst_Only_run_the_tests_in_the_
                                        ],
                                        [
                                            0,
                                            [
                                                0,
                                                cst_verbose,
                                                [
                                                    2,
                                                    verbose
                                                ],
                                                cst_Show_the_tests_as_they_run
                                            ],
                                            [
                                                0,
                                                [
                                                    0,
                                                    cst_stop_on_error,
                                                    [
                                                        2,
                                                        stop_on_error
                                                    ],
                                                    cst_Run_tests_only_up_to_the_f
                                                ],
                                                [
                                                    0,
                                                    [
                                                        0,
                                                        cst_strict,
                                                        [
                                                            2,
                                                            strict
                                                        ],
                                                        cst_End_with_an_error_if_no_te
                                                    ],
                                                    [
                                                        0,
                                                        [
                                                            0,
                                                            cst_show_counts,
                                                            [
                                                                2,
                                                                show_counts
                                                            ],
                                                            cst_Show_the_number_of_tests_r
                                                        ],
                                                        [
                                                            0,
                                                            [
                                                                0,
                                                                cst_log,
                                                                [
                                                                    0,
                                                                    function(param) {
                                                                        try {
                                                                            runtime.caml_sys_remove(cst_inline_tests_log$0);
                                                                        } catch (_br_) {}
                                                                        log[1] = [
                                                                            0,
                                                                            caml_call1(Stdlib[60], cst_inline_tests_log)
                                                                        ];
                                                                        return 0;
                                                                    }
                                                                ],
                                                                cst_Log_the_tests_run_in_inlin
                                                            ],
                                                            [
                                                                0,
                                                                [
                                                                    0,
                                                                    cst_drop_tag,
                                                                    [
                                                                        4,
                                                                        function(tag) {
                                                                            var t = tag_predicate[1], _bp_ = [
                                                                                0,
                                                                                tag,
                                                                                t[2]
                                                                            ];
                                                                            tag_predicate[1] = [
                                                                                0,
                                                                                caml_call2(Stdlib_List[44], function(_bq_) {
                                                                                    return tag !== _bq_ ? 1 : 0;
                                                                                }, t[1]),
                                                                                _bp_
                                                                            ];
                                                                            return 0;
                                                                        }
                                                                    ],
                                                                    cst_tag_Only_run_tests_not_tag
                                                                ],
                                                                [
                                                                    0,
                                                                    [
                                                                        0,
                                                                        cst_require_tag,
                                                                        [
                                                                            4,
                                                                            function(tag) {
                                                                                var t = tag_predicate[1], _bn_ = caml_call2(Stdlib_List[44], function(_bo_) {
                                                                                    return tag !== _bo_ ? 1 : 0;
                                                                                }, t[2]);
                                                                                tag_predicate[1] = [
                                                                                    0,
                                                                                    [
                                                                                        0,
                                                                                        tag,
                                                                                        t[1]
                                                                                    ],
                                                                                    _bn_
                                                                                ];
                                                                                return 0;
                                                                            }
                                                                        ],
                                                                        cst_tag_Only_run_tests_tagged_
                                                                    ],
                                                                    [
                                                                        0,
                                                                        [
                                                                            0,
                                                                            cst_matching,
                                                                            [
                                                                                4,
                                                                                function(s) {
                                                                                    name_filter[1] = [
                                                                                        0,
                                                                                        s,
                                                                                        name_filter[1]
                                                                                    ];
                                                                                    return 0;
                                                                                }
                                                                            ],
                                                                            cst_substring_Only_run_tests_w
                                                                        ],
                                                                        [
                                                                            0,
                                                                            [
                                                                                0,
                                                                                cst_only_test,
                                                                                [
                                                                                    4,
                                                                                    function(str) {
                                                                                        try {
                                                                                            var _bg_ = [
                                                                                                0,
                                                                                                caml_call3(Stdlib_Scanf[5], str, _f_, function(file, line, start_pos, end_pos) {
                                                                                                    return [
                                                                                                        0,
                                                                                                        file,
                                                                                                        [
                                                                                                            0,
                                                                                                            line
                                                                                                        ]
                                                                                                    ];
                                                                                                })
                                                                                            ], match = _bg_;
                                                                                        } catch (_bk_) {
                                                                                            try {
                                                                                                var _bf_ = [
                                                                                                    0,
                                                                                                    caml_call3(Stdlib_Scanf[5], str, _e_, function(file, line) {
                                                                                                        return [
                                                                                                            0,
                                                                                                            file,
                                                                                                            [
                                                                                                                0,
                                                                                                                line
                                                                                                            ]
                                                                                                        ];
                                                                                                    })
                                                                                                ], match = _bf_;
                                                                                            } catch (_bl_) {
                                                                                                try {
                                                                                                    var _be_ = [
                                                                                                        0,
                                                                                                        caml_call3(Stdlib_Scanf[5], str, _d_, function(file) {
                                                                                                            return [
                                                                                                                0,
                                                                                                                file,
                                                                                                                0
                                                                                                            ];
                                                                                                        })
                                                                                                    ], match = _be_;
                                                                                                } catch (_bm_) {
                                                                                                    var match = 0;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        if (match) var match$0 = match[1], index = match$0[2], file = match$0[1], index$0 = index, filename = file;
                                                                                        else if (caml_call2(Stdlib_String[15], str, 58)) {
                                                                                            var i = caml_call2(Stdlib_String[36], str, 58), filename$0 = caml_call3(Stdlib_String[16], str, 0, i), index_string = caml_call3(Stdlib_String[16], str, i + 1 | 0, (caml_ml_string_length(str) - i | 0) - 1 | 0);
                                                                                            try {
                                                                                                var index$1 = runtime.caml_int_of_string(index_string);
                                                                                            } catch (_bj_) {
                                                                                                var _bh_ = caml_wrap_exception(_bj_);
                                                                                                if (_bh_[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(_bh_, 0);
                                                                                                var _bi_ = caml_call2(Stdlib_Printf[4], _i_, str);
                                                                                                throw caml_maybe_attach_backtrace([
                                                                                                    0,
                                                                                                    Stdlib_Arg[8],
                                                                                                    _bi_
                                                                                                ], 1);
                                                                                            }
                                                                                            var index$0 = [
                                                                                                0,
                                                                                                index$1
                                                                                            ], filename = filename$0;
                                                                                        } else var index$0 = 0, filename = str;
                                                                                        tests[1] = [
                                                                                            0,
                                                                                            [
                                                                                                0,
                                                                                                filename,
                                                                                                index$0,
                                                                                                [
                                                                                                    0,
                                                                                                    0
                                                                                                ]
                                                                                            ],
                                                                                            tests[1]
                                                                                        ];
                                                                                        return 0;
                                                                                    }
                                                                                ],
                                                                                cst_location_Run_only_the_test
                                                                            ],
                                                                            [
                                                                                0,
                                                                                [
                                                                                    0,
                                                                                    cst_no_color,
                                                                                    [
                                                                                        3,
                                                                                        use_color
                                                                                    ],
                                                                                    cst_Summarize_tests_without_us
                                                                                ],
                                                                                [
                                                                                    0,
                                                                                    [
                                                                                        0,
                                                                                        cst_in_place,
                                                                                        [
                                                                                            2,
                                                                                            in_place
                                                                                        ],
                                                                                        cst_Update_expect_tests_in_pla
                                                                                    ],
                                                                                    [
                                                                                        0,
                                                                                        [
                                                                                            0,
                                                                                            cst_diff_cmd,
                                                                                            [
                                                                                                4,
                                                                                                function(s) {
                                                                                                    diff_command[1] = [
                                                                                                        0,
                                                                                                        s
                                                                                                    ];
                                                                                                    return 0;
                                                                                                }
                                                                                            ],
                                                                                            cst_Diff_command_for_tests_tha
                                                                                        ],
                                                                                        [
                                                                                            0,
                                                                                            [
                                                                                                0,
                                                                                                cst_source_tree_root,
                                                                                                [
                                                                                                    4,
                                                                                                    function(s) {
                                                                                                        source_tree_root[1] = [
                                                                                                            0,
                                                                                                            s
                                                                                                        ];
                                                                                                        return 0;
                                                                                                    }
                                                                                                ],
                                                                                                cst_Path_to_the_root_of_the_so
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                [
                                                                                                    0,
                                                                                                    cst_diff_path_prefix,
                                                                                                    [
                                                                                                        4,
                                                                                                        function(s) {
                                                                                                            diff_path_prefix[1] = [
                                                                                                                0,
                                                                                                                s
                                                                                                            ];
                                                                                                            return 0;
                                                                                                        }
                                                                                                    ],
                                                                                                    cst_Prefix_to_prepend_to_filep
                                                                                                ],
                                                                                                0
                                                                                            ]
                                                                                        ]
                                                                                    ]
                                                                                ]
                                                                            ]
                                                                        ]
                                                                    ]
                                                                ]
                                                            ]
                                                        ]
                                                    ]
                                                ]
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]), _bb_ = caml_call1(Stdlib_Array[11], [
                            0,
                            name,
                            rest
                        ]);
                        caml_call5(Stdlib_Arg[3], current, _bb_, _ba_, function(anon) {
                            var _bd_ = caml_call3(Stdlib_Printf[4], _h_, name, anon);
                            throw caml_maybe_attach_backtrace([
                                0,
                                Stdlib_Arg[8],
                                _bd_
                            ], 1);
                        }, _a$_);
                        var match$0 = list_partitions[1];
                        if (match$0) var where_to_list = match$0[1], _bc_ = [
                            0,
                            -260537174,
                            where_to_list
                        ];
                        else var _bc_ = [
                            0,
                            1025081494,
                            partition[1]
                        ];
                        var v = [
                            0,
                            -753295984,
                            [
                                0,
                                [
                                    0,
                                    lib,
                                    tests[1],
                                    name_filter[1],
                                    tag_predicate[1]
                                ],
                                _bc_
                            ]
                        ];
                        action[1] = v;
                        return;
                    }
                }
            }
        }
        return;
    }
    if (Base[87][1]) try {
        var _S_ = caml_sys_argv(0);
        parse_argv(0, caml_call1(Stdlib_Array[10], _S_));
    } catch (exn$0) {
        var exn = caml_wrap_exception(exn$0);
        if (exn[1] === Stdlib_Arg[8]) {
            var msg = exn[2];
            caml_call2(Stdlib_Printf[3], _k_, msg);
            caml_call1(Stdlib[99], 1);
        } else {
            if (exn[1] !== Stdlib_Arg[7]) throw caml_maybe_attach_backtrace(exn, 0);
            var msg$0 = exn[2];
            caml_call2(Stdlib_Printf[2], _R_, msg$0);
            caml_call1(Stdlib[99], 0);
        }
    }
    function init(args) {
        var current = [
            0,
            0
        ];
        try {
            parse_argv([
                0,
                current
            ], args);
            return _l_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] === Stdlib_Arg[8]) {
                var msg = exn[2];
                return [
                    1,
                    msg
                ];
            }
            if (exn[1] !== Stdlib_Arg[7]) throw caml_maybe_attach_backtrace(exn, 0);
            var msg$0 = exn[2];
            return [
                0,
                [
                    0,
                    msg$0
                ]
            ];
        }
    }
    var am_test_runner = typeof get(0) === "number" ? 0 : 1;
    a: {
        try {
            caml_sys_getenv("PPX_INLINE_TEST_LIB_AM_RUNNING_INLINE_TEST");
        } catch (_a8_) {
            var _m_ = caml_wrap_exception(_a8_);
            if (_m_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_m_, 0);
            b: {
                try {
                    var val = caml_sys_getenv(cst_TESTING_FRAMEWORK);
                } catch (_a9_) {
                    var _n_ = caml_wrap_exception(_a9_);
                    if (_n_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_n_, 0);
                    var _o_ = 0;
                    break b;
                }
                var _Q_ = val !== "inline-test" ? 0 : 1, _o_ = _Q_;
            }
            var am_running = _o_;
            break a;
        }
        var am_running = 1;
    }
    var testing = am_test_runner ? _p_ : am_running ? _P_ : 822171972;
    function timestamp_ns(param) {
        return caml_call1(Time_now[2], 0);
    }
    var where_to_cut_backtrace = [
        246,
        function(param) {
            var _a6_ = caml_call2(Stdlib[28], cst$2, cst_time_without_resetting_ran), _a7_ = caml_call2(Stdlib[28], cst_Ppx_inline_test_lib, _a6_);
            return caml_call2(Base_String[86][2], 0, _a7_);
        }
    ];
    function time_without_resetting_random_(f) {
        var before_ns = timestamp_ns(0);
        try {
            var _a5_ = [
                0,
                caml_call1(f, 0)
            ], res = _a5_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0), res = [
                1,
                [
                    0,
                    exn,
                    caml_call1(Stdlib_Printexc[6], 0)
                ]
            ];
        }
        var _a3_ = timestamp_ns(0), _a4_ = caml_call2(Base_Int63[46], _a3_, before_ns);
        time_sec[1] = caml_call1(Base_Int63[3], _a4_) / 1000000000.;
        return res;
    }
    var saved_caml_random_state = [
        246,
        function(_a2_) {
            return caml_call1(Stdlib_Random[19][1], [
                0,
                100,
                200,
                300
            ]);
        }
    ], saved_base_random_state = [
        246,
        function(_a1_) {
            return caml_call1(Base_Random[19][2], [
                0,
                111,
                222,
                333
            ]);
        }
    ];
    function string_of_module_descr(param) {
        var t = current$0[1], _aW_ = caml_call2(Stdlib_List[20], function(m) {
            return m[1];
        }, t), _aX_ = caml_call2(Stdlib_List[20], function(s) {
            var _aY_ = caml_call1(Stdlib_String[29], s), _aZ_ = caml_call2(Stdlib[28], _aY_, cst$3), _a0_ = caml_call2(Stdlib[28], cst_T_MODULE_at, _aZ_);
            return caml_call2(Stdlib[28], cst_in_TES, _a0_);
        }, _aW_);
        return caml_call2(Stdlib_String[7], cst$4, _aX_);
    }
    function print_delayed_errors(param) {
        var delayed_errors$0 = caml_call1(Stdlib_List[10], delayed_errors[1]);
        if (!delayed_errors$0) return;
        var _aV_ = caml_call2(Stdlib_String[1], 70, 61);
        caml_call2(Stdlib_Printf[3], _q_, _aV_);
        return caml_call2(Stdlib_List[18], function(message) {
            return caml_call2(Stdlib_Printf[3], _r_, message);
        }, delayed_errors$0);
    }
    function eprintf_or_delay(fmt) {
        return caml_call2(Stdlib_Printf[10], function(s) {
            if (verbose[1]) delayed_errors[1] = [
                0,
                s,
                delayed_errors[1]
            ];
            else caml_call2(Stdlib_Printf[3], _s_, s);
            var _aU_ = stop_on_error[1];
            return _aU_ ? (print_delayed_errors(0), caml_call1(Stdlib[99], 2)) : _aU_;
        }, fmt);
    }
    function add_hooks(C, f, param) {
        caml_call1(C[1], 0);
        return caml_call1(f, 0);
    }
    function hum_backtrace(backtrace) {
        var _aO_ = caml_call1(Base_String[104], backtrace), _aP_ = caml_call2(Base_List[141], _aO_, function(str) {
            var _aS_ = caml_obj_tag(where_to_cut_backtrace);
            a: if (250 === _aS_) var _aT_ = where_to_cut_backtrace[1];
            else {
                if (246 !== _aS_ && 244 !== _aS_) {
                    var _aT_ = where_to_cut_backtrace;
                    break a;
                }
                var _aT_ = caml_call1(CamlinternalLazy[2], where_to_cut_backtrace);
            }
            return 1 - caml_call2(Base_String[86][5], _aT_, str);
        }), _aQ_ = caml_call2(Base_List[53], _aP_, function(str) {
            var _aR_ = caml_call2(Base[241], str, cst$5);
            return caml_call2(Base[241], cst$6, _aR_);
        });
        return caml_call2(Base_String[68], 0, _aQ_);
    }
    function test_inner(config, descr, tags, def_filename, def_line_number, start_pos, end_pos, f, bool_of_f) {
        var match = get(0);
        if (typeof match === "number") return 0;
        var _au_ = match[2], what_to_do = _au_[2], match$0 = _au_[1], which_tags = match$0[4], name_filter = match$0[3], only_test_location = match$0[2], libname = match$0[1];
        function f$0(_aN_) {
            return add_hooks(config, f, _aN_);
        }
        var descr$0 = [
            246,
            function(_aM_) {
                return displayed_descr(descr, def_filename, def_line_number, start_pos, end_pos);
            }
        ], _av_ = current_tags(0), complete_tags = caml_call2(Stdlib[37], tags, _av_), _aw_ = caml_equal([
            0,
            libname
        ], dynamic_lib[1]);
        if (_aw_) {
            var _ax_ = only_test_location ? caml_call2(Stdlib_List[34], function(param) {
                var used = param[3], line_number_opt = param[2], filename = param[1], position_start = caml_ml_string_length(def_filename) - caml_ml_string_length(filename) | 0, _aH_ = 0 <= position_start ? 1 : 0;
                if (_aH_) {
                    var end_of_def_filename = caml_call3(Stdlib_String[16], def_filename, position_start, caml_ml_string_length(filename)), _aI_ = end_of_def_filename == filename ? 1 : 0;
                    if (_aI_) {
                        var _aJ_ = 0 === position_start ? 1 : 0, _aK_ = _aJ_ || (47 === runtime.caml_string_get(def_filename, position_start - 1 | 0) ? 1 : 0);
                        if (_aK_) {
                            if (line_number_opt) var line_number = line_number_opt[1], _aL_ = caml_equal(def_line_number, line_number);
                            else var _aL_ = 1;
                        } else var _aL_ = _aK_;
                    } else var _aL_ = _aI_;
                    var found = _aL_;
                } else var found = _aH_;
                if (found) used[1] = 1;
                return found;
            }, only_test_location) : 1;
            if (_ax_) {
                var _ap_ = caml_call2(Stdlib_List[34], function(req) {
                    return 1 - caml_call2(Stdlib_List[37], req, complete_tags);
                }, which_tags[1]), _ay_ = _ap_ || caml_call2(Stdlib_List[34], function(dropped) {
                    return caml_call2(Stdlib_List[37], dropped, complete_tags);
                }, which_tags[2]), _az_ = 1 - _ay_;
                if (_az_) {
                    var _aA_ = caml_obj_tag(descr$0);
                    a: if (250 === _aA_) var descr$1 = descr$0[1];
                    else {
                        if (246 !== _aA_ && 244 !== _aA_) {
                            var descr$1 = descr$0;
                            break a;
                        }
                        var descr$1 = caml_call1(CamlinternalLazy[2], descr$0);
                    }
                    var _aB_ = name_filter ? caml_call2(Stdlib_List[34], function(substring) {
                        return caml_call2(Base_String[92], descr$1, substring);
                    }, name_filter) : 1, should_run = _aB_;
                } else var should_run = _az_;
            } else var should_run = _ax_;
        } else var should_run = _aw_;
        if (!should_run) return should_run;
        if (1025081494 > what_to_do[1]) return found_test(0);
        var partition = what_to_do[2], _aC_ = is_current(partition);
        if (!_aC_) return _aC_;
        var _aD_ = caml_obj_tag(descr$0);
        a: if (250 === _aD_) var descr$2 = descr$0[1];
        else {
            if (246 !== _aD_ && 244 !== _aD_) {
                var descr$2 = descr$0;
                break a;
            }
            var descr$2 = caml_call1(CamlinternalLazy[2], descr$0);
        }
        tests_ran[1]++;
        var match$1 = log[1];
        if (match$1) {
            var ch = match$1[1], _aE_ = string_of_module_descr(0);
            caml_call4(Stdlib_Printf[1], ch, _t_, descr$2, _aE_);
        }
        if (verbose[1]) caml_call2(Stdlib_Printf[2], _u_, descr$2);
        if (list_test_names[1]) var result$0 = _v_;
        else {
            var caml_random_state = caml_call1(Stdlib_Random[20], 0), base_random_state = caml_call1(Base_Random[19][4], Base_Random[19][1]), _aq_ = caml_obj_tag(saved_caml_random_state);
            a: if (250 === _aq_) var _ar_ = saved_caml_random_state[1];
            else {
                if (246 !== _aq_ && 244 !== _aq_) {
                    var _ar_ = saved_caml_random_state;
                    break a;
                }
                var _ar_ = caml_call1(CamlinternalLazy[2], saved_caml_random_state);
            }
            caml_call1(Stdlib_Random[21], _ar_);
            var _as_ = caml_obj_tag(saved_base_random_state);
            a: if (250 === _as_) var _at_ = saved_base_random_state[1];
            else {
                if (246 !== _as_ && 244 !== _as_) {
                    var _at_ = saved_base_random_state;
                    break a;
                }
                var _at_ = caml_call1(CamlinternalLazy[2], saved_base_random_state);
            }
            caml_call1(Base_Random[20], _at_);
            var result = time_without_resetting_random_(f$0);
            caml_call1(Stdlib_Random[21], caml_random_state);
            caml_call1(Base_Random[20], base_random_state);
            var result$0 = caml_call2(Stdlib_Result[8], bool_of_f, result);
        }
        if (verbose[1]) caml_call2(Stdlib_Printf[2], _w_, time_sec[1]);
        if (0 !== result$0[0]) {
            var match$2 = result$0[1], backtrace = match$2[2], exn = match$2[1];
            tests_failed[1]++;
            var backtrace$0 = hum_backtrace(backtrace), exn_str = caml_call1(Sexplib0_Sexp_conv[70], exn), sep = caml_call2(Stdlib_String[15], exn_str, 10) ? cst$7 : cst$8, _aG_ = string_of_module_descr(0);
            return caml_call5(eprintf_or_delay(_y_), descr$2, sep, exn_str, backtrace$0, _aG_);
        }
        if (result$0[1]) return 0;
        tests_failed[1]++;
        var _aF_ = string_of_module_descr(0);
        return caml_call2(eprintf_or_delay(_x_), descr$2, _aF_);
    }
    function set_lib_and_partition(static_lib, partition) {
        if (dynamic_lib[1]) return 0;
        dynamic_lib[1] = [
            0,
            static_lib
        ];
        var match = get(0);
        if (typeof match === "number") return 0;
        var match$0 = match[2], what_to_do = match$0[2], which_tests = match$0[1], _ao_ = which_tests[1] == static_lib ? 1 : 0;
        if (!_ao_) return _ao_;
        a: {
            if (1025081494 <= what_to_do[1] && !what_to_do[2]) {
                var requires_partition = 0;
                break a;
            }
            var requires_partition = 1;
        }
        if (partition == cst$13 && requires_partition) return caml_call1(Stdlib[2], cst_ppx_inline_test_cannot_use);
        current[1] = partition;
        return 0;
    }
    function unset_lib(static_lib) {
        var match = dynamic_lib[1];
        if (!match) return 0;
        var lib = match[1], _am_ = lib == static_lib ? 1 : 0, _an_ = _am_ ? (dynamic_lib[1] = 0, 0) : _am_;
        return _an_;
    }
    function test(config, descr, tags, filename, line_number, start_pos, end_pos, f) {
        return test_inner(config, descr, tags, filename, line_number, start_pos, end_pos, f, function(b) {
            return b;
        });
    }
    function test_unit(config, descr, tags, filename, line_number, start_pos, end_pos, f) {
        return test_inner(config, descr, tags, filename, line_number, start_pos, end_pos, f, function(param) {
            return 1;
        });
    }
    function test_module(config, descr, tags, def_filename, def_line_number, start_pos, end_pos, f) {
        var match = get(0);
        if (typeof match === "number") return 0;
        var _af_ = match[2], what_to_do = _af_[2], match$0 = _af_[1], which_tags = match$0[4], libname = match$0[1];
        function f$0(_al_) {
            return add_hooks(config, f, _al_);
        }
        var _ag_ = current_tags(0), partial_tags = caml_call2(Stdlib[37], tags, _ag_), _ah_ = caml_equal([
            0,
            libname
        ], dynamic_lib[1]), should_run = _ah_ ? 1 - caml_call2(Stdlib_List[34], function(dropped) {
            return caml_call2(Stdlib_List[37], dropped, partial_tags);
        }, which_tags[2]) : _ah_;
        if (!should_run) return should_run;
        if (1025081494 > what_to_do[1]) return found_test(0);
        var partition = what_to_do[2], _ai_ = is_current(partition);
        if (!_ai_) return _ai_;
        test_modules_ran[1]++;
        var descr$0 = displayed_descr(descr, def_filename, def_line_number, start_pos, end_pos), prev = current$0[1];
        current$0[1] = [
            0,
            [
                0,
                descr$0,
                tags
            ],
            prev
        ];
        try {
            var x = time_without_resetting_random_(f$0);
            current$0[1] = prev;
        } catch (e$0) {
            var e = caml_wrap_exception(e$0);
            current$0[1] = prev;
            throw caml_maybe_attach_backtrace(e, 0);
        }
        if (0 === x[0]) return 0;
        var match$1 = x[1], backtrace = match$1[2], exn = match$1[1];
        test_modules_failed[1]++;
        var backtrace$0 = hum_backtrace(backtrace), exn_str = caml_call1(Sexplib0_Sexp_conv[70], exn), sep = caml_call2(Stdlib_String[15], exn_str, 10) ? cst$9 : cst$10, _aj_ = string_of_module_descr(0), _ak_ = caml_call1(Stdlib_String[29], descr$0);
        return caml_call5(eprintf_or_delay(caml_call2(Stdlib[98], _A_, _z_)), _ak_, sep, exn_str, backtrace$0, _aj_);
    }
    function summarize(param) {
        var match = get(0);
        if (typeof match !== "number") {
            var _Z_ = match[2], match$0 = _Z_[2], which_tests = _Z_[1];
            if (1025081494 > match$0[1]) {
                var where_to_list = match$0[2], f = function(fout) {
                    var _ac_ = caml_call3(Stdlib_Hashtbl[14], function(k, param, acc) {
                        return [
                            0,
                            k,
                            acc
                        ];
                    }, _b_, 0), _ad_ = caml_call2(Stdlib_List[59], Stdlib_String[10], _ac_), _ae_ = caml_call2(Stdlib_Printf[1], fout, _N_);
                    return caml_call2(Stdlib_List[18], _ae_, _ad_);
                };
                if (where_to_list) {
                    var file = where_to_list[1], _aa_ = caml_call3(Stdlib[62], _M_, 0, file), _ab_ = Stdlib[76];
                    caml_call2(caml_call1(Base_Exn[12], f), _aa_, _ab_);
                } else f(Stdlib[39]);
                return 0;
            }
            var match$1 = log[1];
            if (match$1) {
                var ch = match$1[1];
                caml_call1(Stdlib[76], ch);
            }
            print_delayed_errors(0);
            var count = tests_failed[1], count_test_modules = test_modules_failed[1];
            if (0 === count && 0 === count_test_modules) {
                if (show_counts[1]) caml_call3(Stdlib_Printf[3], _D_, tests_ran[1], test_modules_ran[1]);
                var unused_tests = caml_call2(Stdlib_List[44], function(param) {
                    var used = param[3];
                    return 1 - used[1];
                }, which_tests[2]), errors = unused_tests ? [
                    0,
                    unused_tests
                ] : 0;
                if (errors) {
                    var tests = errors[1];
                    caml_call1(Stdlib_Printf[3], _E_);
                    caml_call2(Stdlib_List[18], function(param) {
                        var line_number_opt = param[2], filename = param[1];
                        if (!line_number_opt) return caml_call2(Stdlib_Printf[3], _G_, filename);
                        var line_number = line_number_opt[1];
                        return caml_call3(Stdlib_Printf[3], _F_, filename, line_number);
                    }, tests);
                    caml_call1(Stdlib_Printf[3], _H_);
                    return 2;
                }
                if (0 === tests_ran[1] && strict[1]) {
                    caml_call1(Stdlib_Printf[3], _I_);
                    return 2;
                }
                return 0;
            }
            if (0 === count_test_modules) var ___ = cst$11;
            else var _$_ = caml_call2(Stdlib[98], _L_, _K_), ___ = caml_call2(Stdlib_Printf[4], _$_, count_test_modules);
            caml_call4(Stdlib_Printf[3], _J_, count, tests_ran[1], ___);
            return 1;
        }
        a: {
            if (runtime.caml_notequal(caml_sys_argv(0), [
                0
            ])) {
                var _Y_ = runtime.caml_check_bound(caml_sys_argv(0), 0)[1];
                if (caml_call1(Stdlib_Filename[13], _Y_) == "inline_tests_runner.exe") {
                    caml_call1(Stdlib_Printf[3], _B_);
                    break a;
                }
            }
            caml_call1(Stdlib_Printf[3], _C_);
        }
        return 2;
    }
    function assert_test_configs_initialize(config) {
        var _W_ = 1 - already_initialized[1];
        if (!_W_) return _W_;
        var _X_ = caml_call2(Stdlib_Printf[4], _O_, config);
        return caml_call1(Stdlib[2], _X_);
    }
    function use_color$0(param) {
        assert_test_configs_initialize(cst_use_color);
        return use_color[1];
    }
    function in_place$0(param) {
        assert_test_configs_initialize(cst_in_place$0);
        return in_place[1];
    }
    function diff_command$0(param) {
        assert_test_configs_initialize(cst_diff_command);
        return diff_command[1];
    }
    function diff_path_prefix$0(param) {
        assert_test_configs_initialize(cst_diff_path_prefix$0);
        return diff_path_prefix[1];
    }
    function source_tree_root$0(param) {
        assert_test_configs_initialize(cst_source_tree_root$0);
        return source_tree_root[1];
    }
    var evaluators = [
        0,
        [
            0,
            summarize,
            0
        ]
    ];
    function add_evaluator(f) {
        evaluators[1] = [
            0,
            f,
            evaluators[1]
        ];
        return 0;
    }
    function exit(param) {
        var _U_ = caml_call1(Stdlib_List[10], evaluators[1]);
        switch(combine_all(caml_call2(Stdlib_List[20], function(f) {
            return caml_call1(f, 0);
        }, _U_))){
            case 0:
                var _V_ = 0;
                break;
            case 1:
                var _V_ = 2;
                break;
            default:
                var _V_ = 1;
        }
        return caml_call1(Stdlib[99], _V_);
    }
    var Ppx_inline_test_lib = [
        0,
        am_running,
        am_running_env_var,
        testing,
        init,
        [
            0,
            combine,
            combine_all,
            to_string
        ],
        set_lib_and_partition,
        unset_lib,
        test,
        test_unit,
        test_module,
        use_color$0,
        in_place$0,
        diff_command$0,
        diff_path_prefix$0,
        source_tree_root$0,
        add_evaluator,
        exit
    ];
    runtime.caml_register_global(137, Ppx_inline_test_lib, cst_Ppx_inline_test_lib$0);
    return;
})(globalThis);
//# 1 "../.js/default/ppx_here.runtime-lib/ppx_here_lib.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_here.runtime-lib/ppx_here_lib.cma.js"
//# 1 "../.js/default/stdio/stdio.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/stdio/stdio.cma.js"
//# 16 "../.js/default/stdio/stdio.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), flags = [
        0,
        0,
        0
    ], Base_List = global_data.Base__List, Stdlib = global_data.Stdlib, Base_Char = global_data.Base__Char, Base_String = global_data.Base__String, Stdlib_Buffer = global_data.Stdlib__Buffer, Base_Buffer = global_data.Base__Buffer, Base_Exn = global_data.Base__Exn;
    function equal(t1, t2) {
        return t1 === t2 ? 1 : 0;
    }
    var seek = Stdlib[96][4], pos = Stdlib[96][5], length = Stdlib[96][6], stdin = Stdlib[38];
    function create(opt, file) {
        var binary = opt ? opt[1] : 1, flags$0 = binary ? [
            0,
            6,
            flags
        ] : flags;
        return caml_call3(Stdlib[81], flags$0, 0, file);
    }
    var close = Stdlib[93];
    function with_file(binary, file, f) {
        var _i_ = create(binary, file);
        return caml_call3(Base_Exn[12], f, _i_, close);
    }
    function may_eof(f) {
        try {
            var _g_ = [
                0,
                caml_call1(f, 0)
            ];
            return _g_;
        } catch (_h_) {
            var _f_ = caml_wrap_exception(_h_);
            if (_f_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_f_, 0);
        }
    }
    function input(t, buf, pos, len) {
        return caml_call4(Stdlib[84], t, buf, pos, len);
    }
    function really_input(t, buf, pos, len) {
        return may_eof(function(param) {
            return caml_call4(Stdlib[85], t, buf, pos, len);
        });
    }
    function really_input_exn(t, buf, pos, len) {
        return caml_call4(Stdlib[85], t, buf, pos, len);
    }
    function input_byte(t) {
        return may_eof(function(param) {
            return caml_call1(Stdlib[87], t);
        });
    }
    function input_char(t) {
        return may_eof(function(param) {
            return caml_call1(Stdlib[82], t);
        });
    }
    function input_binary_int(t) {
        return may_eof(function(param) {
            return caml_call1(Stdlib[88], t);
        });
    }
    function unsafe_input_value(t) {
        return may_eof(function(param) {
            return caml_call1(Stdlib[89], t);
        });
    }
    function input_buffer(t, buf, len) {
        return may_eof(function(param) {
            return caml_call3(Stdlib_Buffer[22], buf, t, len);
        });
    }
    var set_binary_mode = Stdlib[95];
    function input_all(t) {
        var chunk_size = 65536, buffer = caml_call1(Base_Buffer[2], chunk_size);
        try {
            for(;;)caml_call3(Stdlib_Buffer[22], buffer, t, chunk_size);
        } catch (_e_) {
            var _d_ = caml_wrap_exception(_e_);
            if (_d_ === Stdlib[12]) return caml_call1(Base_Buffer[3], buffer);
            throw caml_maybe_attach_backtrace(_d_, 0);
        }
    }
    function trim(fix_win_eol, line) {
        if (!fix_win_eol) return line;
        var len = runtime.caml_ml_string_length(line);
        if (0 < len) {
            var _c_ = runtime.caml_string_get(line, len - 1 | 0);
            if (caml_call2(Base_Char[16], _c_, 13)) return caml_call3(Base_String[3], line, 0, len - 1 | 0);
        }
        return line;
    }
    function input_line(opt, t) {
        var fix_win_eol = opt ? opt[1] : 1, match = may_eof(function(param) {
            return caml_call1(Stdlib[83], t);
        });
        if (!match) return 0;
        var line = match[1];
        return [
            0,
            trim(fix_win_eol, line)
        ];
    }
    function input_line_exn(opt, t) {
        var fix_win_eol = opt ? opt[1] : 1, line = caml_call1(Stdlib[83], t);
        return trim(fix_win_eol, line);
    }
    function fold_lines(fix_win_eol, t, init, f) {
        var ac = init;
        for(;;){
            var match = input_line(fix_win_eol, t);
            if (!match) return ac;
            var line = match[1], ac$0 = caml_call2(f, ac, line);
            ac = ac$0;
        }
    }
    function input_lines(fix_win_eol, t) {
        var _b_ = fold_lines(fix_win_eol, t, 0, function(lines, line) {
            return [
                0,
                line,
                lines
            ];
        });
        return caml_call1(Base_List[63], _b_);
    }
    function iter_lines(fix_win_eol, t, f) {
        return fold_lines(fix_win_eol, t, 0, function(param, line) {
            return caml_call1(f, line);
        });
    }
    function read_lines(fix_win_eol, fname) {
        return with_file(0, fname, function(_a_) {
            return input_lines(fix_win_eol, _a_);
        });
    }
    function read_all(fname) {
        return with_file(0, fname, input_all);
    }
    var Stdio_In_channel = [
        0,
        equal,
        stdin,
        create,
        with_file,
        close,
        input,
        really_input,
        really_input_exn,
        input_char,
        input_byte,
        input_binary_int,
        unsafe_input_value,
        input_buffer,
        input_all,
        input_line,
        input_line_exn,
        fold_lines,
        input_lines,
        iter_lines,
        seek,
        pos,
        length,
        set_binary_mode,
        read_lines,
        read_all
    ];
    runtime.caml_register_global(8, Stdio_In_channel, "Stdio__In_channel");
    return;
})(globalThis);
//# 199 "../.js/default/stdio/stdio.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = "\n", flags = [
        0,
        1,
        [
            0,
            3,
            0
        ]
    ], Base_Exn = global_data.Base__Exn, Base = global_data.Base, Base_List = global_data.Base__List, Stdlib = global_data.Stdlib, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_Printf = global_data.Stdlib__Printf;
    function equal(t1, t2) {
        return t1 === t2 ? 1 : 0;
    }
    var seek = Stdlib[96][1], pos = Stdlib[96][2], length = Stdlib[96][3], stdout = Stdlib[39], stderr = Stdlib[40], _a_ = [
        0,
        "<stderr>"
    ], _b_ = [
        0,
        "<stdout>"
    ], _c_ = [
        0,
        "<Out_channel.t>"
    ];
    function sexp_of_t(t) {
        return t === stderr ? _a_ : t === stdout ? _b_ : _c_;
    }
    function create(_g_, _f_, _e_, opt, file) {
        var binary = _g_ ? _g_[1] : 1, append = _f_ ? _f_[1] : 0, fail_if_exists = _e_ ? _e_[1] : 0, perm = opt ? opt[1] : 438, _h_ = binary ? 6 : 7, flags$0 = [
            0,
            _h_,
            flags
        ], _i_ = append ? 2 : 4, flags$1 = [
            0,
            _i_,
            flags$0
        ], flags$2 = fail_if_exists ? [
            0,
            5,
            flags$1
        ] : flags$1;
        return caml_call3(Stdlib[62], flags$2, perm, file);
    }
    var set_binary_mode = Stdlib[78], flush = Stdlib[63], close = Stdlib[76], close_no_err = Stdlib[77];
    function output(t, buf, pos, len) {
        return caml_call4(Stdlib[68], t, buf, pos, len);
    }
    function output_substring(t, buf, pos, len) {
        return caml_call4(Stdlib[69], t, buf, pos, len);
    }
    var output_string = Stdlib[66], output_bytes = Stdlib[67], output_char = Stdlib[65], output_byte = Stdlib[70], output_binary_int = Stdlib[71], output_buffer = Stdlib_Buffer[10], output_value = Stdlib[72];
    function newline(t) {
        return caml_call2(output_string, t, cst);
    }
    function output_line(t, line) {
        caml_call2(output_string, t, line);
        return caml_call2(output_string, t, cst);
    }
    function output_lines(t, lines) {
        return caml_call2(Base_List[19], lines, function(line) {
            return output_line(t, line);
        });
    }
    var printf = Stdlib_Printf[2], eprintf = Stdlib_Printf[3], fprintf = Stdlib_Printf[1], kfprintf = Stdlib_Printf[8], print_string = Stdlib[42], print_endline = Stdlib[46], prerr_endline = Stdlib[53];
    function fprint_s(mach, t, sexp) {
        var string = mach ? caml_call1(Base[85][15], sexp) : caml_call2(Base[85][14], 0, sexp);
        caml_call2(output_string, t, string);
        caml_call2(output_char, t, 10);
        return caml_call1(flush, t);
    }
    function print_s(mach, sexp) {
        return fprint_s(mach, stdout, sexp);
    }
    function eprint_s(mach, sexp) {
        return fprint_s(mach, stderr, sexp);
    }
    function with_file(binary, append, fail_if_exists, perm, file, f) {
        var _d_ = create(binary, append, fail_if_exists, perm, file);
        return caml_call3(Base_Exn[12], f, _d_, close);
    }
    function write_lines(file, lines) {
        return with_file(0, 0, 0, 0, file, function(t) {
            return output_lines(t, lines);
        });
    }
    function write_all(file, data) {
        return with_file(0, 0, 0, 0, file, function(t) {
            return caml_call2(output_string, t, data);
        });
    }
    var Stdio_Out_channel = [
        0,
        sexp_of_t,
        equal,
        stdout,
        stderr,
        create,
        with_file,
        close,
        close_no_err,
        set_binary_mode,
        flush,
        output,
        output_string,
        output_substring,
        output_bytes,
        output_char,
        output_byte,
        output_binary_int,
        output_buffer,
        output_value,
        newline,
        output_lines,
        output_line,
        fprintf,
        printf,
        fprint_s,
        print_s,
        eprint_s,
        eprintf,
        kfprintf,
        print_string,
        print_endline,
        prerr_endline,
        seek,
        pos,
        length,
        write_lines,
        write_all
    ];
    runtime.caml_register_global(11, Stdio_Out_channel, "Stdio__Out_channel");
    return;
})(globalThis);
//# 373 "../.js/default/stdio/stdio.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdio_In_channel = global_data.Stdio__In_channel, Stdio_Out_channel = global_data.Stdio__Out_channel, stdin = Stdio_In_channel[2], stdout = Stdio_Out_channel[3], stderr = Stdio_Out_channel[4], eprintf = Stdio_Out_channel[28], printf = Stdio_Out_channel[24], print_s = Stdio_Out_channel[26], eprint_s = Stdio_Out_channel[27], print_string = Stdio_Out_channel[30], print_endline = Stdio_Out_channel[31], prerr_endline = Stdio_Out_channel[32], Stdio = [
        0,
        stdin,
        stdout,
        stderr,
        printf,
        print_s,
        eprint_s,
        eprintf,
        print_string,
        print_endline,
        prerr_endline
    ];
    runtime.caml_register_global(2, Stdio, "Stdio");
    return;
})(globalThis);
//# 1 "../.js/default/ppxlib.print_diff/ppxlib_print_diff.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppxlib.print_diff/ppxlib_print_diff.cma.js"
//# 6 "../.js/default/ppxlib.print_diff/ppxlib_print_diff.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_line_1_characters_0_0 = '", line 1, characters 0-0:\n', cst_File = 'File "', cst_File_s_line_1_characters_0 = 'File "%s", line 1, characters 0-0:\n%!', cst_diff_u$1 = "diff -u";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = " ", Stdlib_Filename = global_data.Stdlib__Filename, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_ListLabels = global_data.Stdlib__ListLabels, Stdlib_StringLabels = global_data.Stdlib__StringLabels, _a_ = [
        0,
        "-location-style omake",
        0
    ], _b_ = [
        0,
        "-keep-whitespace",
        0
    ], cst_patdiff = "patdiff", _c_ = [
        0,
        "-ascii",
        0
    ], _d_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    2,
                    0,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " 1>&2",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s %s %s 1>&2"
    ], _e_ = [
        0,
        [
            11,
            cst_File,
            [
                2,
                0,
                [
                    11,
                    cst_line_1_characters_0_0,
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        cst_File_s_line_1_characters_0
    ], cst_diff_u = cst_diff_u$1, _f_ = [
        0,
        [
            11,
            "Error:\n> ",
            [
                3,
                0,
                [
                    11,
                    " exited with code ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            "\n> Perhaps patdiff is not installed? Hint, try: opam install patdiff\n> Falling back to diff -u\n\n",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Error:\n> %S exited with code %d\n> Perhaps patdiff is not installed? Hint, try: opam install patdiff\n> Falling back to diff -u\n\n"
    ], _g_ = [
        0,
        [
            11,
            cst_File,
            [
                2,
                0,
                [
                    11,
                    cst_line_1_characters_0_0,
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        cst_File_s_line_1_characters_0
    ], cst_diff_u$0 = cst_diff_u$1;
    function print(diff_command, _j_, opt, file1, file2, param) {
        var extra_patdiff_args = _j_ ? _j_[1] : 0, use_color = opt ? opt[1] : 0;
        function exec(cmd) {
            var _k_ = caml_call1(Stdlib_Filename[21], file2), _l_ = caml_call1(Stdlib_Filename[21], file1), cmd$0 = caml_call4(Stdlib_Printf[4], _d_, cmd, _l_, _k_), n = runtime.caml_sys_system_command(cmd$0);
            return 0 === n ? 925282182 : 1 === n ? -890978471 : [
                0,
                106380200,
                [
                    0,
                    n,
                    cmd$0
                ]
            ];
        }
        if (diff_command) {
            var s = diff_command[1];
            exec(s);
            return 0;
        }
        var _h_ = [
            0,
            extra_patdiff_args,
            0
        ], _i_ = use_color ? 0 : _c_, args = caml_call1(Stdlib_ListLabels[14], [
            0,
            _b_,
            [
                0,
                _a_,
                [
                    0,
                    _i_,
                    _h_
                ]
            ]
        ]), match = exec(caml_call2(Stdlib_StringLabels[7], cst, [
            0,
            cst_patdiff,
            args
        ]));
        if (typeof match === "number") return 925282182 <= match ? (caml_call2(Stdlib_Printf[3], _e_, file1), exec(cst_diff_u), 0) : 0;
        var match$0 = match[2], cmd = match$0[2], err_code = match$0[1];
        caml_call3(Stdlib_Printf[3], _f_, cmd, err_code);
        caml_call2(Stdlib_Printf[3], _g_, file1);
        exec(cst_diff_u$0);
        return 0;
    }
    var Ppxlib_print_diff = [
        0,
        print
    ];
    runtime.caml_register_global(15, Ppxlib_print_diff, "Ppxlib_print_diff");
    return;
})(globalThis);
//# 1 "../.js/default/ppx_expect.make_corrected_file/make_corrected_file.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_expect.make_corrected_file/make_corrected_file.cma.js"
//# 30 "../.js/default/ppx_expect.make_corrected_file/make_corrected_file.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$3 = "", cst$4 = "/";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$2 = cst$3, cst$0 = cst$4, cst$1 = cst$3, cst = cst$4, Stdio_In_channel = global_data.Stdio__In_channel, Base_String = global_data.Base__String, Base = global_data.Base, Base_Option = global_data.Base__Option, Stdio_Out_channel = global_data.Stdio__Out_channel, Base_Sys = global_data.Base__Sys, Base_Char = global_data.Base__Char, Base_List = global_data.Base__List, Ppxlib_print_diff = global_data.Ppxlib_print_diff, Base_Error = global_data.Base__Error, _a_ = [
        0,
        0
    ], cst_corrected = ".corrected", cst_TESTING_FRAMEWORK = "TESTING_FRAMEWORK", cst_alt_old = "-alt-old", cst_alt_new = "-alt-new", cst_Changes_found = "Changes found.", _b_ = [
        0,
        "-default",
        0
    ];
    function chop_if_exists(ancestor, path) {
        var _j_ = caml_call2(Base[241], ancestor, cst);
        return caml_call2(Base_String[119], path, _j_);
    }
    function f(_c_, corrected_path, opt, diff_command, diff_path_prefix, next_contents, path, param) {
        var use_dot_patdiff = _c_ ? _c_[1] : 0, use_color = opt ? opt[1] : 0, prev_contents = runtime.caml_sys_file_exists(path) ? caml_call3(Stdio_In_channel[4], 0, path, Stdio_In_channel[14]) : cst$2;
        if (caml_call2(Base_String[47], prev_contents, next_contents)) return _a_;
        var default_corrected_path = caml_call2(Base[241], path, cst_corrected), corrected_path$0 = caml_call2(Base_Option[30], corrected_path, default_corrected_path);
        caml_call2(Stdio_Out_channel[37], corrected_path$0, next_contents);
        if (use_dot_patdiff) var _d_ = caml_call1(Base_Sys[19], cst_TESTING_FRAMEWORK), _e_ = caml_call1(Base_Option[52], _d_);
        else var _e_ = use_dot_patdiff;
        var default_configs = _e_ ? 0 : _b_, cwd = runtime.caml_sys_getcwd(0);
        if (diff_path_prefix) var prefix = diff_path_prefix[1], _f_ = [
            0,
            caml_call1(Base_Char[16], 47)
        ], _g_ = caml_call2(Base_String[108], _f_, prefix), prefix$0 = caml_call2(Base[241], _g_, cst$0);
        else var prefix$0 = cst$1;
        var _h_ = chop_if_exists(cwd, path), alt_old = [
            0,
            cst_alt_old,
            [
                0,
                caml_call2(Base[241], prefix$0, _h_),
                0
            ]
        ], _i_ = chop_if_exists(cwd, default_corrected_path), alt_new = [
            0,
            cst_alt_new,
            [
                0,
                caml_call2(Base[241], prefix$0, _i_),
                0
            ]
        ], extra_patdiff_args = caml_call1(Base_List[11], [
            0,
            default_configs,
            [
                0,
                alt_old,
                [
                    0,
                    alt_new,
                    0
                ]
            ]
        ]);
        caml_call6(Ppxlib_print_diff[1], diff_command, [
            0,
            extra_patdiff_args
        ], [
            0,
            use_color
        ], path, corrected_path$0, 0);
        return [
            1,
            caml_call1(Base_Error[14], cst_Changes_found)
        ];
    }
    var Make_corrected_file = [
        0,
        f
    ];
    runtime.caml_register_global(21, Make_corrected_file, "Make_corrected_file");
    return;
})(globalThis);
//# 1 "../.js/default/ppx_expect.config_types/expect_test_config_types.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_expect.config_types/expect_test_config_types.cma.js"
//# 1 "../.js/default/ppx_expect.config/expect_test_config.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_expect.config/expect_test_config.cma.js"
//# 5 "../.js/default/ppx_expect.config/expect_test_config.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function return$0(x) {
        return x;
    }
    var IO = [
        0,
        return$0
    ];
    function sanitize(s) {
        return s;
    }
    function run(f) {
        return caml_call1(f, 0);
    }
    var Expect_test_config = [
        0,
        IO,
        run,
        sanitize,
        15023
    ];
    runtime.caml_register_global(0, Expect_test_config, "Expect_test_config");
    return;
})(globalThis);
//# 1 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
//# 20 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), default$0 = [
        0,
        2,
        0,
        "%",
        "@@"
    ], default$1 = [
        0,
        cst
    ], Base = global_data.Base, Base_Comparable = global_data.Base__Comparable, Base_Int = global_data.Base__Int;
    function equal(a, b) {
        var _d_ = a[1] === b[1] ? 1 : 0;
        if (_d_) var _e_ = a[2] === b[2] ? 1 : 0, _f_ = _e_ ? a[3] === b[3] ? 1 : 0 : _e_;
        else var _f_ = _d_;
        return _f_;
    }
    var _a_ = [
        0,
        caml_call2(Base_Comparable[2], Base[129], function(t) {
            return t[3];
        }),
        0
    ], _b_ = [
        0,
        caml_call2(Base_Comparable[2], Base[129], function(t) {
            return t[2];
        }),
        _a_
    ], compare_character_range = caml_call1(Base_Comparable[1], _b_), Compact_loc = [
        0,
        equal,
        compare_character_range
    ], Flexibility = [
        0
    ], Expect_node_formatting = [
        0,
        default$0,
        Flexibility
    ], Virtual_loc = [
        0
    ], of_int_exn = Base_Int[5], to_int_exn = Base_Int[6], hash = Base_Int[8], sexp_of_t = Base_Int[10], compare = Base_Int[14], counter = [
        0,
        0
    ];
    function mint(param) {
        var id = counter[1];
        counter[1] = id + 1 | 0;
        return id;
    }
    var Hand = [
        0
    ], Kind = [
        0
    ], Shape = [
        0
    ], _c_ = [
        0,
        cst
    ];
    function handed(t, hand) {
        return hand ? t ? t : _c_ : t;
    }
    var Ppx_expect_runtime_Types = [
        0,
        Expect_node_formatting,
        Compact_loc,
        Virtual_loc,
        [
            0,
            of_int_exn,
            to_int_exn,
            compare,
            sexp_of_t,
            hash,
            mint
        ],
        [
            0,
            Hand,
            Kind,
            Shape,
            [
                0,
                default$1,
                handed
            ]
        ]
    ];
    runtime.caml_register_global(6, Ppx_expect_runtime_Types, "Ppx_expect_runtime__Types");
    return;
})(globalThis);
//# 92 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call8(f, a0, a1, a2, a3, a4, a5, a6, a7) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 8 ? f(a0, a1, a2, a3, a4, a5, a6, a7) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), Base = global_data.Base, Stdlib = global_data.Stdlib, Base_String = global_data.Base__String, Stdio_Out_channel = global_data.Stdio__Out_channel, Stdlib_Filename = global_data.Stdlib__Filename, Make_corrected_file = global_data.Make_corrected_file, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Base_Comparable = global_data.Base__Comparable, Base_List = global_data.Base__List, Patch_with_file_contents = [
        0
    ], cst_corrected = ".corrected", cst_corrected_tmp = ".corrected.tmp";
    function f(use_color, in_place, diff_command, diff_path_prefix, filename, with$0, corrections$0) {
        var dot_corrected = caml_call2(Base[241], filename, cst_corrected), in_channel = caml_call1(Stdlib[80], filename), _c_ = caml_call1(Stdlib[92], in_channel), original_file_contents = caml_call2(Stdlib[86], in_channel, _c_);
        caml_call1(Stdlib[93], in_channel);
        function remove(file) {
            if (runtime.caml_sys_file_exists(file)) runtime.caml_sys_remove(file);
            return;
        }
        var corrections$1 = caml_call2(with$0, original_file_contents, corrections$0), _a_ = caml_call2(Base_Comparable[2], Ppx_expect_runtime_Types[2][2], Base[242]), corrections = caml_call2(Base_List[83], corrections$1, _a_), match = caml_call3(Base_List[96], corrections, 0, function(l_pos, param) {
            var correction = param[2], match = param[1], end_pos = match[3], start_pos = match[2], code_chunk = caml_call3(Base_String[3], original_file_contents, l_pos, start_pos - l_pos | 0);
            return [
                0,
                end_pos,
                [
                    0,
                    code_chunk,
                    [
                        0,
                        correction,
                        0
                    ]
                ]
            ];
        }), strs = match[2], l_pos = match[1], _b_ = caml_call1(Base_List[11], strs), result = caml_call2(Base_String[68], 0, _b_), rest = caml_call3(Base_String[5], [
            0,
            l_pos
        ], 0, original_file_contents), next_contents = caml_call2(Base[241], result, rest);
        if (in_place) {
            if (1 - caml_call2(Base_String[134], original_file_contents, next_contents)) caml_call2(Stdio_Out_channel[37], filename, next_contents);
            remove(dot_corrected);
            return 0;
        }
        if (diff_command && diff_command[1] === "-") {
            caml_call2(Stdio_Out_channel[37], dot_corrected, next_contents);
            return 0;
        }
        var _d_ = caml_call1(Stdlib_Filename[13], filename), _e_ = [
            0,
            caml_call1(Stdlib_Filename[14], filename)
        ], tmp_corrected = caml_call3(Stdlib_Filename[16], _e_, _d_, cst_corrected_tmp);
        return 0 === caml_call8(Make_corrected_file[1], 0, [
            0,
            tmp_corrected
        ], [
            0,
            use_color
        ], diff_command, diff_path_prefix, next_contents, filename, 0)[0] ? (remove(dot_corrected), remove(tmp_corrected), 0) : (runtime.caml_sys_rename(tmp_corrected, dot_corrected), 1);
    }
    var Ppx_expect_runtime_Write_corre = [
        0,
        Patch_with_file_contents,
        f
    ];
    runtime.caml_register_global(12, Ppx_expect_runtime_Write_corre, "Ppx_expect_runtime__Write_corrected_file");
    return;
})(globalThis);
//# 223 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Base_Printf = global_data.Base__Printf, Base_String = global_data.Base__String, Base = global_data.Base, Base_List = global_data.Base__List, Type = [
        0
    ], compare = Base[195], Formatted = [
        0
    ];
    function create(format) {
        return format;
    }
    function apply(format, str) {
        return caml_call1(format, str);
    }
    var Formatter = [
        0,
        create,
        apply
    ];
    function compare$0(a, b) {
        if (!a) return b ? -1 : 0;
        if (!b) return 1;
        var b$0 = b[1], a$0 = a[1];
        return caml_call2(compare, a$0, b$0);
    }
    var Test_result = [
        0,
        compare$0
    ], _a_ = [
        0,
        "\n"
    ], _b_ = [
        0,
        [
            12,
            123,
            [
                2,
                0,
                [
                    12,
                    124,
                    [
                        2,
                        0,
                        [
                            12,
                            124,
                            [
                                2,
                                0,
                                [
                                    12,
                                    125,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "{%s|%s|%s}"
    ], _c_ = [
        0,
        [
            12,
            34,
            [
                2,
                0,
                [
                    12,
                    34,
                    0
                ]
            ]
        ],
        '"%s"'
    ];
    function default$0(contents) {
        return [
            0,
            contents,
            Ppx_expect_runtime_Types[5][4][1]
        ];
    }
    function to_source_code_string(param) {
        var tag = param[2], test_output = param[1];
        if (tag) {
            var tag$0 = tag[1];
            return caml_call4(Base_Printf[2], _b_, tag$0, test_output, tag$0);
        }
        var _k_ = caml_call2(Base_String[102], test_output, 10), _l_ = caml_call2(Base_List[53], _k_, Base_String[69]), _m_ = caml_call1(caml_call1(Base_String[68], _a_), _l_);
        return caml_call2(Base_Printf[2], _c_, _m_);
    }
    var Payload = [
        0,
        default$0,
        to_source_code_string
    ], _d_ = [
        0,
        [
            12,
            123,
            [
                2,
                0,
                [
                    12,
                    124,
                    0
                ]
            ]
        ],
        "{%s|"
    ], cst_xxx = "xxx", _e_ = [
        0,
        [
            12,
            124,
            [
                2,
                0,
                [
                    12,
                    125,
                    0
                ]
            ]
        ],
        "|%s}"
    ], _f_ = [
        0,
        [
            12,
            123,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                12,
                                124,
                                [
                                    2,
                                    0,
                                    [
                                        12,
                                        124,
                                        [
                                            2,
                                            0,
                                            [
                                                12,
                                                125,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "{%s%s %s|%s|%s}"
    ], _g_ = [
        0,
        [
            12,
            123,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        124,
                        [
                            2,
                            0,
                            [
                                11,
                                "|}",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "{%s%s|%s|}"
    ], _h_ = [
        0,
        [
            12,
            91,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                12,
                                93,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "[%s%s %s]"
    ];
    function reconcile(expected_output, test_output) {
        return caml_call2(Base_String[134], expected_output, test_output) ? 0 : [
            0,
            test_output
        ];
    }
    function fail(error_output) {
        return [
            0,
            error_output
        ];
    }
    function fix_delimiter_conflicts(contents, delimiter) {
        if (!delimiter) return 0;
        var tag$1 = delimiter[1], tag = tag$1;
        for(;;){
            let tag$1 = tag;
            var tag_conflicts_with = function(fstr) {
                var _j_ = caml_call2(Base_Printf[2], fstr, tag$1);
                return caml_call2(Base_String[92], contents, _j_);
            };
            if (!tag_conflicts_with(_d_) && !tag_conflicts_with(_e_)) return [
                0,
                tag
            ];
            var tag$0 = caml_call2(Base[241], tag, cst_xxx);
            tag = tag$0;
        }
    }
    function to_formatted_payload(param, contents) {
        return [
            0,
            contents,
            fix_delimiter_conflicts(contents, param)
        ];
    }
    function to_source_code_string$0(expect_node_formatting, shape, tag, contents) {
        var delimiter = fix_delimiter_conflicts(contents, caml_call2(Ppx_expect_runtime_Types[5][4][2], tag, shape[2])), payload = [
            0,
            contents,
            delimiter
        ];
        if (shape[2]) {
            var prefix = expect_node_formatting[3], tag$0 = delimiter[1];
            return tag$0 !== "" ? caml_call6(Base_Printf[2], _f_, prefix, shape[1], tag$0, contents, tag$0) : caml_call4(Base_Printf[2], _g_, prefix, shape[1], contents);
        }
        var prefix$0 = shape[3] ? expect_node_formatting[3] : expect_node_formatting[4], _i_ = caml_call1(Payload[2], payload);
        return caml_call4(Base_Printf[2], _h_, prefix$0, shape[1], _i_);
    }
    var Ppx_expect_runtime_Output = [
        0,
        Type,
        Formatted,
        [
            0
        ],
        Formatter,
        Test_result,
        Payload,
        reconcile,
        fail,
        to_formatted_payload,
        to_source_code_string$0
    ];
    runtime.caml_register_global(15, Ppx_expect_runtime_Output, "Ppx_expect_runtime__Output");
    return;
})(globalThis);
//# 379 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Insert_loc = [
        0
    ], Behavior_type = [
        0
    ], Expect_reachability = [
        0
    ], On_unreachable = [
        0
    ], Behavior = [
        0
    ], Definitions = [
        0,
        Insert_loc,
        Behavior_type,
        Expect_reachability,
        On_unreachable,
        Behavior
    ], Ppx_expect_runtime_Expectation = [
        0,
        Definitions
    ];
    runtime.caml_register_global(0, Ppx_expect_runtime_Expectation, "Ppx_expect_runtime__Expectation_intf");
    return;
})(globalThis);
//# 407 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$7 = "", cst$6 = " ", cst_expect$0 = "expect", cst_expect_uncaught_exn = "expect.uncaught_exn", cst_test_output$2 = "test output", cst_uncaught_exception$1 = "uncaught exception";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$5 = cst$6, cst$4 = cst$7, cst$0 = cst$7, cst$1 = cst$6, cst$2 = cst$6, cst$3 = cst$7, cst = cst$7, last_line = cst$6, first_line = cst$6, Ppx_expect_runtime_Output = global_data.Ppx_expect_runtime__Output, Base_Staged = global_data.Base__Staged, Base = global_data.Base, Base_String = global_data.Base__String, Base_Int = global_data.Base__Int, Base_Char = global_data.Base__Char, Base_List = global_data.Base__List, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types;
    function loc(param) {
        if (0 === param[0]) {
            var whole_node = param[1];
            return whole_node;
        }
        var loc = param[1][1];
        return loc;
    }
    var Insert_loc = [
        0,
        loc
    ], _a_ = [
        0,
        "\n"
    ], _b_ = [
        0,
        cst$6,
        0
    ], cst_test_output = cst_test_output$2, cst_expect = cst_expect$0, cst_test_output$0 = cst_test_output$2, cst_expect_exact = "expect_exact", cst_test_output$1 = cst_test_output$2, _c_ = [
        0,
        cst_expect$0,
        0,
        1
    ], _d_ = [
        1,
        0
    ], cst_uncaught_exception = cst_uncaught_exception$1, _e_ = [
        0,
        cst_expect_uncaught_exn,
        0,
        0
    ], cst_trailing_output = "trailing output", _f_ = [
        0,
        cst_expect$0,
        0,
        1
    ], cst_uncaught_exception$0 = cst_uncaught_exception$1, _g_ = [
        0,
        cst_expect_uncaught_exn,
        0,
        0
    ], _h_ = [
        1,
        1
    ];
    function with_behavior(param, behavior) {
        var inconsistent_outputs_message = param[5], on_incorrect_output = param[4], payload_type = param[3], position = param[1];
        return [
            0,
            position,
            behavior,
            payload_type,
            on_incorrect_output,
            inconsistent_outputs_message
        ];
    }
    function formatter(expect_node_formatting, param) {
        var on_incorrect_output = param[4], payload_type = param[3], behavior = param[2], position = param[1], _q_ = payload_type ? function(str) {
            var _r_ = caml_call1(Base_String[104], str), _s_ = caml_call1(Base_String[108], [
                0,
                Base_Char[45]
            ]), _t_ = caml_call2(Base_List[53], _r_, _s_), _u_ = caml_call2(Base_List[142], _t_, Base_String[14]), _v_ = caml_call1(Base_List[63], _u_), _w_ = caml_call2(Base_List[142], _v_, Base_String[14]), stripped = caml_call1(Base_List[63], _w_), indent_and_contents = caml_call2(Base_List[53], stripped, function(line) {
                var _G_ = caml_call2(Base_String[109], 0, line), _D_ = caml_call1(Base_String[25], line), _E_ = caml_call1(Base_Char[12], 32), _F_ = caml_call2(Base_List[141], _D_, _E_);
                return [
                    0,
                    caml_call1(Base_List[45], _F_),
                    _G_
                ];
            }), _x_ = caml_call2(Base_List[13], indent_and_contents, function(param) {
                var indent = param[1];
                return param[2] !== cst$7 ? [
                    0,
                    indent
                ] : 0;
            }), match = caml_call2(Base_List[31], _x_, Base_Int[14]);
            if (match) var min_indent = match[1], lines = caml_call2(Base_List[53], indent_and_contents, function(param) {
                var line = param[2], indent = param[1];
                return [
                    0,
                    caml_call2(Base_Int[16], 0, indent - min_indent | 0),
                    line
                ];
            });
            else var lines = 0;
            if (0 === behavior[0]) var tag = behavior[1][2], tag$0 = tag;
            else var tag$0 = Ppx_expect_runtime_Types[5][4][1];
            var _y_ = expect_node_formatting[2];
            if (!lines) return tag$0 ? cst$2 : cst$3;
            if (!lines[2] && !_y_) {
                var line = lines[1][2];
                return tag$0 ? caml_call2(Base_String[68], 0, [
                    0,
                    cst$1,
                    [
                        0,
                        line,
                        _b_
                    ]
                ]) : line;
            }
            if (0 === position[0]) var match$0 = position[1], start_pos = match$0[2], start_bol = match$0[1], _z_ = start_pos - start_bol | 0;
            else var match$1 = position[1][2], start_pos$0 = match$1[2], start_bol$0 = match$1[1], _B_ = on_incorrect_output[3] ? expect_node_formatting[1] : 0, _z_ = (start_pos$0 - start_bol$0 | 0) + _B_ | 0;
            var location_indent = expect_node_formatting[1] + _z_ | 0;
            function spaces(n) {
                return caml_call2(Base_String[66], n, 32);
            }
            if (tag$0) var last_line$0 = spaces(location_indent), indentation = location_indent, first_line$0 = cst;
            else var last_line$0 = last_line, indentation = 1, first_line$0 = first_line;
            var lines$0 = caml_call2(Base_List[53], lines, function(param) {
                var indent = param[1];
                if (param[2] === cst$7) return cst$0;
                var line = param[2], _C_ = spaces(indentation + indent | 0);
                return caml_call2(Base[241], _C_, line);
            }), _A_ = caml_call1(Base_List[11], [
                0,
                [
                    0,
                    first_line$0,
                    0
                ],
                [
                    0,
                    lines$0,
                    [
                        0,
                        [
                            0,
                            last_line$0,
                            0
                        ],
                        0
                    ]
                ]
            ]);
            return caml_call1(caml_call1(Base_String[68], _a_), _A_);
        } : function(_H_) {
            return _H_;
        };
        return caml_call1(Ppx_expect_runtime_Output[4][1], _q_);
    }
    function extension_syntax(extension_name, payload_loc, node_loc) {
        if (payload_loc) {
            var payload_loc$0 = payload_loc[1], _o_ = payload_loc$0[2] <= node_loc[2] ? 1 : 0, _p_ = _o_ ? node_loc[3] <= payload_loc$0[3] ? 1 : 0 : _o_;
            if (_p_) return [
                0,
                extension_name,
                1,
                1
            ];
        }
        return [
            0,
            extension_name,
            0,
            1
        ];
    }
    function possibly_relax_strictness(formatting_flexibility, t) {
        if (!formatting_flexibility) return t;
        var expect_node_formatting = formatting_flexibility[1], fmt = formatter(expect_node_formatting, t), _m_ = t[2], reachability = _m_[3], on_unreachable = _m_[2], match = _m_[1], tag = match[2], contents = match[1], _n_ = caml_call2(Ppx_expect_runtime_Output[4][2], fmt, contents), match$0 = caml_call2(Ppx_expect_runtime_Output[7], contents, _n_);
        if (!match$0) return t;
        var contents$0 = match$0[1], payload = caml_call2(Ppx_expect_runtime_Output[9], tag, contents$0);
        return with_behavior(t, [
            0,
            payload,
            on_unreachable,
            reachability
        ]);
    }
    function expected_string_and_payload_lo(param) {
        if (!param) return [
            0,
            caml_call1(Ppx_expect_runtime_Output[6][1], cst$4),
            0
        ];
        var match = param[1], b = match[2], a = match[1];
        return [
            0,
            a,
            [
                0,
                b
            ]
        ];
    }
    function expect(formatting_flexibility, node_loc, located_payload) {
        var match = expected_string_and_payload_lo(located_payload), payload_loc = match[2], payload = match[1];
        return possibly_relax_strictness(formatting_flexibility, [
            0,
            [
                0,
                node_loc,
                payload_loc
            ],
            [
                0,
                payload,
                2,
                0
            ],
            1,
            extension_syntax(cst_expect, payload_loc, node_loc),
            cst_test_output
        ]);
    }
    function expect_exact(formatting_flexibility, node_loc, located_payload) {
        var match = expected_string_and_payload_lo(located_payload), payload_loc = match[2], payload = match[1];
        return possibly_relax_strictness(formatting_flexibility, [
            0,
            [
                0,
                node_loc,
                payload_loc
            ],
            [
                0,
                payload,
                2,
                0
            ],
            0,
            extension_syntax(cst_expect_exact, payload_loc, node_loc),
            cst_test_output$0
        ]);
    }
    function expect_unreachable(node_loc) {
        return [
            0,
            [
                0,
                node_loc,
                0
            ],
            _d_,
            1,
            _c_,
            cst_test_output$1
        ];
    }
    function expect_uncaught_exn(formatting_flexibility, node_loc, located_payload) {
        var match = expected_string_and_payload_lo(located_payload), payload_loc = match[2], payload = match[1];
        return possibly_relax_strictness(formatting_flexibility, [
            0,
            [
                0,
                node_loc,
                payload_loc
            ],
            [
                0,
                payload,
                1,
                1
            ],
            1,
            _e_,
            cst_uncaught_exception
        ]);
    }
    function expect_trailing(insert_loc) {
        return [
            0,
            [
                1,
                insert_loc
            ],
            [
                0,
                caml_call1(Ppx_expect_runtime_Output[6][1], cst$5),
                0,
                0
            ],
            1,
            _f_,
            cst_trailing_output
        ];
    }
    function expect_no_uncaught_exn(insert_loc) {
        return [
            0,
            [
                1,
                insert_loc
            ],
            _h_,
            1,
            _g_,
            cst_uncaught_exception$0
        ];
    }
    function format_payload(mk_node) {
        return caml_call1(Base_Staged[1], function(expect_node_formatting, payload_loc, node_loc, tag, contents) {
            var node = caml_call3(mk_node, 0, node_loc, [
                0,
                [
                    0,
                    [
                        0,
                        contents,
                        tag
                    ],
                    payload_loc
                ]
            ]), _k_ = formatter(expect_node_formatting, node), formatted_contents = caml_call2(Ppx_expect_runtime_Output[4][2], _k_, contents), match = caml_call2(Ppx_expect_runtime_Output[7], contents, formatted_contents);
            if (!match) return 0;
            var contents$0 = match[1], node_shape = node[4];
            if (node_shape[2]) var source_code_string = caml_call4(Ppx_expect_runtime_Output[10], expect_node_formatting, node_shape, tag, contents$0);
            else var _l_ = caml_call2(Ppx_expect_runtime_Output[9], tag, contents$0), source_code_string = caml_call1(Ppx_expect_runtime_Output[6][2], _l_);
            return [
                0,
                source_code_string
            ];
        });
    }
    var _i_ = format_payload(expect), format_expect_payload = caml_call1(Base_Staged[2], _i_), _j_ = format_payload(expect_uncaught_exn), format_uncaught_exn_payload = caml_call1(Base_Staged[2], _j_), Ppx_expect_runtime_Expectation = [
        0,
        Insert_loc,
        with_behavior,
        formatter,
        expect,
        expect_exact,
        expect_unreachable,
        expect_uncaught_exn,
        expect_trailing,
        expect_no_uncaught_exn,
        [
            0,
            format_expect_payload,
            format_uncaught_exn_payload
        ]
    ];
    runtime.caml_register_global(35, Ppx_expect_runtime_Expectation, "Ppx_expect_runtime__Expectation");
    return;
})(globalThis);
//# 761 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$4 = "";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), tag = [
        0,
        cst$4
    ], cst$3 = cst$4, cst$2 = ";", cst = cst$4, cst$0 = "\n", cst$1 = cst$4, Ppx_expect_runtime_Output = global_data.Ppx_expect_runtime__Output, Base_Char = global_data.Base__Char, Base_String = global_data.Base__String, Ppx_expect_runtime_Expectation = global_data.Ppx_expect_runtime__Expectation, Base_Hashtbl = global_data.Base__Hashtbl, Base = global_data.Base, Base_Comparable = global_data.Base__Comparable, Base_List = global_data.Base__List, Base_Option = global_data.Base__Option, Base_Queue = global_data.Base__Queue, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Base_Printf = global_data.Base__Printf, Base_Error = global_data.Base__Error;
    function record_and_return_result(expect_node_formatting, failure_ref, test_output_raw, t) {
        var results = t[2], expectation = t[1], _J_ = caml_call2(Ppx_expect_runtime_Expectation[3], expect_node_formatting, expectation), test_output = caml_call2(Ppx_expect_runtime_Output[4][2], _J_, test_output_raw), _K_ = expectation[2];
        if (0 === _K_[0]) var match = _K_[1], tag$0 = match[2], contents = match[1], tag$1 = tag$0, result = caml_call2(Ppx_expect_runtime_Output[7], contents, test_output);
        else var result$0 = caml_call1(Ppx_expect_runtime_Output[8], test_output), tag$1 = tag, result = result$0;
        if (result) failure_ref[1] = 1;
        caml_call2(Base_Queue[35], results, [
            0,
            [
                0,
                result,
                test_output_raw
            ]
        ]);
        t[3] = 1;
        return [
            0,
            result,
            tag$1
        ];
    }
    function of_expectation(expectation) {
        return [
            0,
            [
                0,
                expectation,
                caml_call2(Base_Queue[58], 0, 0),
                0
            ]
        ];
    }
    function record_end_of_run(t) {
        var match = t[1], results = match[2], reached_this_run = match[3], _I_ = 1 - reached_this_run;
        return _I_ ? caml_call2(Base_Queue[35], results, 0) : _I_;
    }
    function record_result(expect_node_formatting, failure_ref, test_output_raw, param) {
        var inner = param[1];
        record_and_return_result(expect_node_formatting, failure_ref, test_output_raw, inner);
        return 0;
    }
    var global_results_table = caml_call3(Base_Hashtbl[4], 0, 0, [
        0,
        Base_String[51],
        Base_String[42],
        function(_H_) {
            return runtime.Base_hash_string(_H_);
        }
    ]), _d_ = [
        0,
        [
            11,
            "Internal expect test bug: could not find test\nFile: ",
            [
                2,
                0,
                [
                    11,
                    "\nID:   ",
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "Internal expect test bug: could not find test\nFile: %s\nID:   %d"
    ];
    function find_test(absolute_filename, test_id) {
        var _C_ = caml_call2(Base_Hashtbl[56], global_results_table, absolute_filename), _D_ = caml_call2(Base_Option[22], _C_, function(param) {
            var expectations = param[1];
            return caml_call2(Base_Hashtbl[56], expectations, test_id);
        }), _E_ = caml_call1(Ppx_expect_runtime_Types[4][2], test_id), _F_ = caml_call3(Base_Printf[2], _d_, absolute_filename, _E_), _G_ = [
            0,
            caml_call1(Base_Error[14], _F_)
        ];
        return caml_call2(caml_call2(Base_Option[31], 0, _G_), 0, _D_);
    }
    function initialize_and_register_tests(absolute_filename, tests, postprocess) {
        var tests_as_in_table = caml_call2(Base_Queue[58], 0, 0);
        caml_call3(Base_Hashtbl[41], global_results_table, absolute_filename, function(file) {
            var _z_ = Ppx_expect_runtime_Types[4], _A_ = [
                0,
                caml_call3(Base_Hashtbl[4], 0, 0, [
                    0,
                    _z_[3],
                    _z_[4],
                    _z_[5]
                ]),
                postprocess
            ], file$0 = caml_call2(Base_Option[30], file, _A_), _B_ = Ppx_expect_runtime_Types[4], tests$0 = caml_call4(Base_Hashtbl[8], 0, 0, [
                0,
                _B_[3],
                _B_[4],
                _B_[5]
            ], tests);
            caml_call3(Base_Hashtbl[66], tests$0, file$0[1], function(test_id, new_test, existing_test) {
                var test = caml_call2(Base_Option[30], existing_test, new_test);
                test[1][3] = 0;
                caml_call2(Base_Queue[35], tests_as_in_table, [
                    0,
                    test_id,
                    test
                ]);
                return [
                    0,
                    test
                ];
            });
            return file$0;
        });
        return caml_call1(Base_Queue[20], tests_as_in_table);
    }
    function process_each_file(f) {
        var _w_ = caml_call1(Base_Hashtbl[78], global_results_table), _x_ = caml_call2(Base_Comparable[2], Base_String[51], Base[242]), _y_ = caml_call2(Base_List[83], _w_, _x_);
        return caml_call2(Base_List[53], _y_, function(param) {
            var match = param[2], postprocess = match[2], expectations = match[1], filename = param[1], test_nodes = caml_call1(Base_Hashtbl[68], expectations);
            return caml_call3(f, filename, test_nodes, postprocess);
        });
    }
    function expect(formatting_flexibility, node_loc, located_payload) {
        return of_expectation(caml_call3(Ppx_expect_runtime_Expectation[4], formatting_flexibility, node_loc, located_payload));
    }
    function expect_exact(formatting_flexibility, node_loc, located_payload) {
        return of_expectation(caml_call3(Ppx_expect_runtime_Expectation[5], formatting_flexibility, node_loc, located_payload));
    }
    function expect_unreachable(node_loc) {
        return of_expectation(caml_call1(Ppx_expect_runtime_Expectation[6], node_loc));
    }
    var Create = [
        0,
        expect,
        expect_exact,
        expect_unreachable
    ], _a_ = [
        0,
        [
            12,
            91,
            [
                2,
                0,
                [
                    11,
                    "expect.unreachable]",
                    0
                ]
            ]
        ],
        "[%sexpect.unreachable]"
    ], _b_ = [
        0,
        0
    ], _c_ = [
        0,
        [
            11,
            "<expect test ran without ",
            [
                2,
                0,
                [
                    12,
                    62,
                    0
                ]
            ]
        ],
        "<expect test ran without %s>"
    ];
    function loc(param) {
        var position = param[1][1][1];
        return caml_call1(Ppx_expect_runtime_Expectation[1][1], position);
    }
    function expectation_of_t(param) {
        var expectation = param[1][1], _v_ = expectation[2];
        if (0 !== _v_[0]) return 0;
        var contents = _v_[1][1];
        return [
            0,
            contents
        ];
    }
    function record_and_return_number_of_li(expect_node_formatting, failure_ref, test_output_raw, param) {
        var _s_ = record_and_return_result(expect_node_formatting, failure_ref, test_output_raw, param[1]), match = _s_[1];
        if (!match) return 0;
        var tag = _s_[2], contents = match[1], _t_ = caml_call2(Ppx_expect_runtime_Output[9], tag, contents), correction = caml_call1(Ppx_expect_runtime_Output[6][2], _t_), _u_ = caml_call1(Base_Char[16], 10);
        return [
            0,
            caml_call2(Base_String[21], correction, _u_) + 1 | 0
        ];
    }
    function to_diffs(cr_for_multiple_outputs, expect_node_formatting, original_file_contents, t) {
        var match$4 = t[1], results = match$4[2], expectation = match$4[1], results_list = caml_call1(Base_Queue[20], results), match$5 = caml_call2(Base_List[16], results_list, function(param) {
            if (!param) return _b_;
            var output = param[1];
            return [
                1,
                output
            ];
        }), outputs_list = match$5[2], unreached_list = match$5[1], _o_ = caml_call2(Base_Comparable[2], Ppx_expect_runtime_Output[5][1], function(param) {
            var result = param[1];
            return result;
        }), distinct_outputs = caml_call2(Base_List[126], outputs_list, _o_), was_reached = caml_call1(Base_List[18], unreached_list), match$6 = expectation[2];
        if (0 === match$6[0]) var reachability = match$6[3], reachability_behavior = reachability;
        else var reachability_of_corrected = match$6[1], reachability_behavior = reachability_of_corrected;
        function correction_for_single_result(param) {
            if (!param) return 0;
            var received = param[1];
            return [
                0,
                [
                    0,
                    expectation,
                    received
                ]
            ];
        }
        a: if (distinct_outputs) {
            b: if (!distinct_outputs[2]) {
                var result = distinct_outputs[1][1];
                if (!was_reached && reachability_behavior) break b;
                var match$7 = correction_for_single_result(result);
                break a;
            }
            var outputs = caml_call2(Base_List[53], results_list, function(param) {
                if (!param) return caml_call2(Base_Printf[2], _c_, expectation[5]);
                var raw = param[1][2];
                return raw;
            }), _p_ = caml_call2(cr_for_multiple_outputs, expectation[5], outputs), _q_ = caml_call2(Ppx_expect_runtime_Expectation[3], expect_node_formatting, expectation), _r_ = caml_call1(caml_call1(Ppx_expect_runtime_Output[4][2], _q_), _p_), match$7 = correction_for_single_result(caml_call1(Ppx_expect_runtime_Output[8], _r_));
        } else var behavior$0 = expectation[2], match$7 = 0 === behavior$0[0] ? [
            0,
            [
                1,
                caml_call2(Ppx_expect_runtime_Expectation[2], expectation, behavior$0)
            ]
        ] : 0;
        if (!match$7) return 0;
        var correction$2 = match$7[1];
        function safe_byte_get(string, i) {
            if (0 <= i && i < runtime.caml_ml_string_length(string)) return [
                0,
                runtime.caml_string_get(string, i)
            ];
            return 0;
        }
        if (0 === correction$2[0]) {
            var _e_ = correction$2[1], on_incorrect_output = _e_[4], test_output = correction$2[2], behavior = _e_[2], position = _e_[1];
            if (0 === position[0]) var whitespace = cst;
            else var match = position[1][2], start_pos = match[2], start_bol = match[1], let_offset = start_pos - start_bol | 0, _i_ = on_incorrect_output[3] ? expect_node_formatting[1] : 0, indent = let_offset + _i_ | 0, _j_ = caml_call2(Base_String[66], indent, 32), whitespace$0 = caml_call2(Base[241], cst$0, _j_), whitespace = whitespace$0;
            if (0 === behavior[0]) var tag = behavior[1][2], tag$0 = tag;
            else var tag$0 = Ppx_expect_runtime_Types[5][4][1];
            a: {
                if (0 === position[0]) {
                    var _g_ = position[2], _f_ = position[1];
                    if (_g_ && !on_incorrect_output[2] && on_incorrect_output[3]) {
                        var payload_loc = _g_[1], _h_ = caml_call2(Ppx_expect_runtime_Output[9], tag$0, test_output), correction$1 = caml_call1(Ppx_expect_runtime_Output[6][2], _h_), correction$0 = correction$1, loc$0 = payload_loc;
                        break a;
                    }
                    var loc = _f_;
                } else var loc = position[1][1];
                var correction = caml_call4(Ppx_expect_runtime_Output[10], expect_node_formatting, on_incorrect_output, tag$0, test_output), correction$0 = correction, loc$0 = loc;
            }
            var match$0 = [
                0,
                [
                    0,
                    loc$0,
                    caml_call2(Base[241], whitespace, correction$0)
                ]
            ];
        } else {
            var _k_ = correction$2[1], on_incorrect_output$0 = _k_[4], on_unreachable = _k_[2][2], position$0 = _k_[1], loc$1 = caml_call1(Ppx_expect_runtime_Expectation[1][1], position$0);
            switch(on_unreachable){
                case 0:
                    var match$0 = 0;
                    break;
                case 1:
                    var match$0 = [
                        0,
                        [
                            0,
                            loc$1,
                            cst$1
                        ]
                    ];
                    break;
                default:
                    var prefix = on_incorrect_output$0[3] ? expect_node_formatting[3] : expect_node_formatting[4], match$0 = [
                        0,
                        [
                            0,
                            loc$1,
                            caml_call2(Base_Printf[2], _a_, prefix)
                        ]
                    ];
            }
        }
        if (!match$0) return 0;
        var match$1 = match$0[1], diff = match$1[2], loc$2 = match$1[1], end_pos = loc$2[3], start_pos$0 = loc$2[2], start_bol$0 = loc$2[1], main_correction = [
            0,
            [
                0,
                loc$2,
                diff
            ],
            0
        ];
        a: {
            if (1 === correction$2[0] && !correction$2[1][4][3]) {
                var match$2 = safe_byte_get(original_file_contents, start_pos$0 - 1 | 0), match$3 = safe_byte_get(original_file_contents, end_pos);
                b: {
                    c: if (match$2 && 10 === match$2[1]) {
                        if (match$3 && 10 !== match$3[1]) break c;
                        var _n_ = [
                            0,
                            [
                                0,
                                [
                                    0,
                                    start_bol$0,
                                    start_pos$0 - 1 | 0,
                                    start_pos$0
                                ],
                                cst$3
                            ]
                        ];
                        break b;
                    }
                    var _n_ = 0;
                }
                var remove_empty_line_from_deleted = _n_;
                break a;
            }
            var remove_empty_line_from_deleted = 0;
        }
        a: {
            if (0 === correction$2[0]) {
                var _l_ = correction$2[1], _m_ = _l_[1];
                if (0 !== _m_[0] && _l_[4][3]) {
                    var body_loc = _m_[1][2], add_semicolon_before_trailing_ = [
                        0,
                        [
                            0,
                            [
                                0,
                                body_loc[1],
                                body_loc[3],
                                body_loc[3]
                            ],
                            cst$2
                        ]
                    ];
                    break a;
                }
            }
            var add_semicolon_before_trailing_ = 0;
        }
        var additional_corrections = caml_call2(Base_List[14], [
            0,
            remove_empty_line_from_deleted,
            [
                0,
                add_semicolon_before_trailing_,
                0
            ]
        ], Base_Option[42]);
        return caml_call2(Base[222], additional_corrections, main_correction);
    }
    var Ppx_expect_runtime_Test_node = [
        0,
        Create,
        of_expectation,
        record_end_of_run,
        record_result,
        [
            0,
            initialize_and_register_tests,
            find_test,
            process_each_file
        ],
        [
            0,
            expectation_of_t,
            record_and_return_number_of_li,
            loc,
            to_diffs
        ]
    ];
    runtime.caml_register_global(23, Ppx_expect_runtime_Test_node, "Ppx_expect_runtime__Test_node");
    return;
})(globalThis);
//# 1233 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_String = global_data.Base__String, Base = global_data.Base, Base_Printf = global_data.Base__Printf, Stdlib_Filename = global_data.Stdlib__Filename, CamlinternalLazy = global_data.CamlinternalLazy, Base_Or_error = global_data.Base__Or_error, current = [
        0,
        0
    ], cst_new_file = "new_file", cst_old_file = "old_file", cst_Expect_test_collector_set_ = "Expect_test_collector.set: there is already an active file", cst_Expect_test_collector_unse = "Expect_test_collector.unset: there is no active file", cst_Expect_test_collector_get_ = "Expect_test_collector.get: there is no active file";
    function set(filename_rel_to_project_root) {
        var match = current[1];
        if (match) {
            var current$0 = match[1], _h_ = [
                0,
                [
                    0,
                    cst_new_file,
                    caml_call1(Base[202], filename_rel_to_project_root)
                ],
                0
            ], _i_ = [
                0,
                [
                    0,
                    cst_old_file,
                    caml_call1(Base[202], current$0)
                ],
                _h_
            ], _j_ = caml_call2(Base[85][8], cst_Expect_test_collector_set_, _i_);
            return caml_call1(Base[246], _j_);
        }
        current[1] = [
            0,
            filename_rel_to_project_root
        ];
        return 0;
    }
    function unset(param) {
        if (current[1]) {
            current[1] = 0;
            return 0;
        }
        var _g_ = caml_call2(Base[85][8], cst_Expect_test_collector_unse, 0);
        return caml_call1(Base[246], _g_);
    }
    function get(param) {
        var match = current[1];
        if (match) {
            var fn = match[1];
            return fn;
        }
        var _f_ = caml_call2(Base[85][8], cst_Expect_test_collector_get_, 0);
        return caml_call1(Base[246], _f_);
    }
    var dir_or_error = caml_call2(Base_Or_error[31], [
        0,
        1
    ], function(_e_) {
        return runtime.caml_sys_getcwd(_e_);
    }), initial_dir = [
        246,
        function(_d_) {
            return caml_call1(Base_Or_error[34], dir_or_error);
        }
    ], _a_ = [
        0,
        [
            11,
            "Trying to run an expect test from the wrong file.\n- test declared at ",
            [
                2,
                0,
                [
                    12,
                    58,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            "\n- trying to run it from ",
                            [
                                2,
                                0,
                                [
                                    12,
                                    10,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "Trying to run an expect test from the wrong file.\n- test declared at %s:%d\n- trying to run it from %s\n"
    ];
    function absolute_path(file) {
        if (!caml_call1(Stdlib_Filename[5], file)) return file;
        var _b_ = runtime.caml_obj_tag(initial_dir);
        a: if (250 === _b_) var _c_ = initial_dir[1];
        else {
            if (246 !== _b_ && 244 !== _b_) {
                var _c_ = initial_dir;
                break a;
            }
            var _c_ = caml_call1(CamlinternalLazy[2], initial_dir);
        }
        return caml_call2(Stdlib_Filename[4], _c_, file);
    }
    function verify_that_file_is_current_ex(line_number, filename_rel_to_project_root) {
        var registering_tests_for = get(0);
        return caml_call2(Base_String[134], filename_rel_to_project_root, registering_tests_for) ? 0 : caml_call5(Base_Printf[4], Base[244], _a_, filename_rel_to_project_root, line_number, registering_tests_for);
    }
    var Ppx_expect_runtime_Current_fil = [
        0,
        set,
        unset,
        get,
        initial_dir,
        absolute_path,
        verify_that_file_is_current_ex
    ];
    runtime.caml_register_global(13, Ppx_expect_runtime_Current_fil, "Ppx_expect_runtime__Current_file");
    return;
})(globalThis);
//# 1366 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$4 = "", cst$5 = "\n", cst$6 = "(* ", caml_ml_string_length = runtime.caml_ml_string_length, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    function caml_call8(f, a0, a1, a2, a3, a4, a5, a6, a7) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 8 ? f(a0, a1, a2, a3, a4, a5, a6, a7) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), partial = [
        12,
        10,
        [
            10,
            0
        ]
    ], cst$3 = cst$4, cst$1 = "---------------", cst$2 = cst$4, cst = "\n\n", cst$0 = cst$4, Expect_test_config = global_data.Expect_test_config, Base_Source_code_position = global_data.Base__Source_code_position, Base_Printf = global_data.Base__Printf, Base = global_data.Base, Stdlib = global_data.Stdlib, Stdlib_Printf = global_data.Stdlib__Printf, Base_Option = global_data.Base__Option, Ppx_expect_runtime_Test_node = global_data.Ppx_expect_runtime__Test_node, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Base_List = global_data.Base__List, Ppx_expect_runtime_Current_fil = global_data.Ppx_expect_runtime__Current_file, Ppx_expect_runtime_Expectation = global_data.Ppx_expect_runtime__Expectation, Base_String = global_data.Base__String, Stdlib_Filename = global_data.Stdlib__Filename, Ppx_inline_test_lib = global_data.Ppx_inline_test_lib, Stdlib_Printexc = global_data.Stdlib__Printexc, Base_Exn = global_data.Base__Exn, Stdlib_Obj = global_data.Stdlib__Obj, Stdlib_Format = global_data.Stdlib__Format, cst_CR = "CR ", _b_ = [
        0,
        [
            11,
            cst$6,
            [
                2,
                0,
                [
                    11,
                    "expect_test_collector: This test expectation appears to contain a backtrace.\n   This is strongly discouraged as backtraces are fragile.\n   Please change this test to not include a backtrace. *)",
                    0
                ]
            ]
        ],
        "(* %sexpect_test_collector: This test expectation appears to contain a backtrace.\n   This is strongly discouraged as backtraces are fragile.\n   Please change this test to not include a backtrace. *)"
    ], _c_ = [
        0,
        [
            11,
            "Test ran multiple times with different ",
            [
                2,
                0,
                [
                    12,
                    115,
                    0
                ]
            ]
        ],
        "Test ran multiple times with different %ss"
    ], _d_ = [
        0,
        [
            11,
            cst$6,
            [
                2,
                0,
                [
                    11,
                    "expect_test: ",
                    [
                        2,
                        0,
                        [
                            11,
                            " *)",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "(* %sexpect_test: %s *)"
    ], _e_ = [
        0,
        [
            11,
            "=== Output ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " / ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " ===",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "=== Output %d / %d ==="
    ], _f_ = [
        0,
        [
            2,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s%s%s"
    ], _g_ = [
        0,
        cst$5
    ], _h_ = [
        0,
        "Raised at ",
        [
            0,
            "Called from ",
            [
                0,
                "Raised by primitive operation ",
                0
            ]
        ]
    ], _i_ = [
        0,
        [
            11,
            '("',
            [
                2,
                0,
                [
                    11,
                    '(Cannot print more details, Exn.to_string failed)")',
                    0
                ]
            ]
        ],
        '("%s(Cannot print more details, Exn.to_string failed)")'
    ], _j_ = [
        0,
        cst$5
    ];
    function clean_up_block(param) {
        var test_output_writer = param[5], test_output_reader = param[4], output_file = param[2];
        caml_call1(Stdlib[93], test_output_reader);
        runtime.ppx_expect_runtime_after_test(Stdlib[39], Stdlib[40]);
        caml_call1(Stdlib[76], test_output_writer);
        runtime.caml_sys_remove(output_file);
        return;
    }
    function flush(param) {
        caml_call2(Stdlib_Format[39], Stdlib_Format[112], 0);
        caml_call2(Stdlib_Format[39], Stdlib_Format[114], 0);
        caml_call1(Stdlib[63], Stdlib[39]);
        caml_call1(Stdlib[63], Stdlib[40]);
        runtime.ppx_expect_runtime_flush_stubs_streams(0);
        return;
    }
    function read_test_output_unsanitized(param) {
        var old_offset = param[6], test_output_reader = param[4];
        flush(0);
        var new_offset = runtime.ppx_expect_runtime_out_channel_position(Stdlib[39]), len = new_offset - old_offset[1] | 0;
        old_offset[1] = new_offset;
        return caml_call2(Stdlib[86], test_output_reader, len);
    }
    function Configured(C) {
        var cr_prefix = 15023 <= C[4] ? cst_CR : cst$0, cr_for_backtrace = caml_call2(Base_Printf[2], _b_, cr_prefix);
        function cr_for_multiple_outputs(output_name, outputs) {
            var cr_body = caml_call2(Base_Printf[2], _c_, output_name), cr = caml_call3(Base_Printf[2], _d_, cr_prefix, cr_body), num_outputs = caml_call1(Base_List[45], outputs), outputs_with_headers = caml_call2(Base_List[44], outputs, function(index, output) {
                var header = caml_call3(Base_Printf[2], _e_, index + 1 | 0, num_outputs), pad_length = caml_ml_string_length(cr) - caml_ml_string_length(header) | 0, _N_ = [
                    0,
                    output,
                    0
                ];
                if (0 < pad_length) var lpad = caml_call2(Base_String[66], pad_length / 2 | 0, 61), rpad = caml_call2(Base_String[66], pad_length - (pad_length / 2 | 0) | 0, 61), _O_ = caml_call4(Base_Printf[2], _f_, lpad, header, rpad);
                else var _O_ = header;
                return [
                    0,
                    _O_,
                    _N_
                ];
            });
            return caml_call2(Base_String[68], _g_, [
                0,
                cr,
                outputs_with_headers
            ]);
        }
        var sanitize = C[3];
        function check_for_backtraces(s) {
            if (!caml_call2(Base_List[23], _h_, function(substring) {
                return caml_call2(Base_String[92], s, substring);
            })) return s;
            var _M_ = caml_call2(Base[241], cst, s);
            return caml_call2(Base[241], cr_for_backtrace, _M_);
        }
        function dump_backtrace(possible_exn) {
            try {
                caml_call1(C[2], possible_exn);
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0), bt = caml_call1(Stdlib_Printexc[12], 0);
                try {
                    var _K_ = caml_call1(Base_Exn[10], exn), exn_string = _K_;
                } catch (_L_) {
                    var _I_ = caml_call1(Stdlib_Obj[22][1], exn), name = caml_call1(Stdlib_Obj[22][2], _I_), exn_string = caml_call2(Base_Printf[2], _i_, name);
                }
                var bt$0 = caml_call1(Stdlib_Printexc[14], bt), _J_ = bt$0 !== cst$4 ? caml_call2(Base_String[68], _j_, [
                    0,
                    cr_for_backtrace,
                    [
                        0,
                        exn_string,
                        [
                            0,
                            bt$0,
                            0
                        ]
                    ]
                ]) : exn_string;
                return [
                    0,
                    _J_
                ];
            }
            return 0;
        }
        return [
            0,
            ,
            ,
            cr_for_multiple_outputs,
            sanitize,
            check_for_backtraces,
            dump_backtrace
        ];
    }
    var test_is_running = [
        0,
        0
    ], _n_ = [
        0,
        [
            11,
            "File ",
            [
                3,
                0,
                [
                    11,
                    ", line ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ", characters ",
                            [
                                4,
                                0,
                                0,
                                0,
                                [
                                    12,
                                    45,
                                    [
                                        4,
                                        0,
                                        0,
                                        0,
                                        [
                                            11,
                                            ":\nError: program exited while expect test was running!\nOutput captured so far:\n",
                                            [
                                                2,
                                                0,
                                                partial
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "File %S, line %d, characters %d-%d:\nError: program exited while expect test was running!\nOutput captured so far:\n%s\n%!"
    ], _o_ = [
        0,
        [
            11,
            "Ppx_expect_runtime.read_current_test_output_exn called while there are no tests running at ",
            [
                2,
                0,
                0
            ]
        ],
        "Ppx_expect_runtime.read_current_test_output_exn called while there are no tests running at %s"
    ];
    function am_running_expect_test(param) {
        return caml_call1(Base_Option[53], test_is_running[1]);
    }
    function current_test(param) {
        return caml_call2(Base_Option[24], test_is_running[1], function(param) {
            var test_block = param[4];
            return test_block;
        });
    }
    function current_test_exn(param) {
        var _H_ = current_test(0);
        return caml_call4(Base_Option[31], 0, 0, 0, _H_);
    }
    function iter(f) {
        return caml_call2(Base_Option[37], test_is_running[1], f);
    }
    function at_exit(param) {
        return iter(function(param) {
            var test_block = param[4], match = param[3], end_pos = match[3], start_pos = match[2], start_bol = match[1], basename = param[2], line_number = param[1];
            flush(0);
            var output_file = test_block[2], fin = caml_call1(Stdlib[80], output_file), _G_ = caml_call1(Stdlib[92], fin), all_out = caml_call2(Stdlib[86], fin, _G_);
            clean_up_block(test_block);
            return caml_call6(Stdlib_Printf[3], _n_, basename, line_number, start_pos - start_bol | 0, end_pos - start_bol | 0, all_out);
        });
    }
    function read_current_test_output_exn(here) {
        var match = current_test(0);
        if (match) {
            var test_block = match[1], _D_ = read_test_output_unsanitized(test_block);
            return caml_call1(Expect_test_config[3], _D_);
        }
        var _E_ = caml_call1(Base_Source_code_position[22], here), _F_ = caml_call2(Base_Printf[2], _o_, _E_);
        return caml_call1(Base[244], _F_);
    }
    var default_cr_for_multiple_output = Configured(Expect_test_config)[3], For_external = [
        0,
        read_current_test_output_exn,
        am_running_expect_test,
        default_cr_for_multiple_output
    ], cst_output = "output", cst_expect_test = "expect-test", _a_ = [
        0,
        1,
        [
            0,
            3,
            [
                0,
                6,
                0
            ]
        ]
    ], _k_ = [
        0,
        "line"
    ], _l_ = [
        0,
        "file"
    ], cst_inner_test = "inner_test", cst_outer_test = "outer_test", cst_Expect_test_runtime_reache = "Expect_test_runtime: reached one [let%expect_test] from another. Nesting expect\ntests is prohibited.", cst_Trailing_output = "Trailing output", _m_ = [
        0,
        cst$5
    ], Ppx_expect_runtime_Test_block = [
        0,
        function(C) {
            var Configured$0 = Configured(C);
            function read_test_output_no_backtrace_(param) {
                var _C_ = read_test_output_unsanitized(current_test_exn(0));
                return caml_call1(Configured$0[4], _C_);
            }
            function read_test_output_sanitized_and(param) {
                var _B_ = read_test_output_no_backtrace_(0);
                return Configured$0[5].call(null, _B_);
            }
            function run_test_inner(test_id, test_output_raw, t) {
                var src_filename = t[1], _A_ = caml_call2(Ppx_expect_runtime_Test_node[5][2], src_filename, test_id), fail = t[3];
                return caml_call4(Ppx_expect_runtime_Test_node[4], Ppx_expect_runtime_Types[1][1], fail, test_output_raw, _A_);
            }
            function run_test(test_id) {
                var _z_ = current_test_exn(0);
                return run_test_inner(test_id, read_test_output_sanitized_and(0), _z_);
            }
            function run_suite(filename_rel_to_project_root, line_number, location, trailing_loc, body_loc, formatting_flexibility, expected_exn, test_to_run, exn_test_id, description, tags, inline_test_config, expectations, f) {
                var end_pos = location[3], start_pos = location[2], start_bol = location[1], basename = caml_call1(Stdlib_Filename[13], filename_rel_to_project_root);
                iter(function(param) {
                    var outer_basename = param[2], outer_line_number = param[1];
                    function sexp_here(basename, line_number) {
                        var _y_ = [
                            0,
                            [
                                1,
                                [
                                    0,
                                    _k_,
                                    [
                                        0,
                                        caml_call1(Base[136], line_number),
                                        0
                                    ]
                                ]
                            ],
                            0
                        ];
                        return [
                            1,
                            [
                                0,
                                [
                                    1,
                                    [
                                        0,
                                        _l_,
                                        [
                                            0,
                                            caml_call1(Base[202], basename),
                                            0
                                        ]
                                    ]
                                ],
                                _y_
                            ]
                        ];
                    }
                    var _v_ = [
                        0,
                        [
                            0,
                            cst_inner_test,
                            sexp_here(basename, line_number)
                        ],
                        0
                    ], _w_ = [
                        0,
                        [
                            0,
                            cst_outer_test,
                            sexp_here(outer_basename, outer_line_number)
                        ],
                        _v_
                    ], _x_ = caml_call2(Base[85][8], cst_Expect_test_runtime_reache, _w_);
                    return caml_call1(Base[246], _x_);
                });
                return caml_call8(Ppx_inline_test_lib[8], inline_test_config, [
                    246,
                    function(_u_) {
                        return caml_call2(Base_Option[30], description, cst$3);
                    }
                ], tags, basename, line_number, start_pos - start_bol | 0, end_pos - start_bol | 0, function(param) {
                    caml_call2(Ppx_expect_runtime_Current_fil[6], line_number, filename_rel_to_project_root);
                    var absolute_filename = caml_call1(Ppx_expect_runtime_Current_fil[5], basename), _q_ = caml_call1(Ppx_expect_runtime_Expectation[8], [
                        0,
                        [
                            0,
                            trailing_loc[1],
                            trailing_loc[2],
                            trailing_loc[2]
                        ],
                        body_loc
                    ]), trailing_test = caml_call1(Ppx_expect_runtime_Test_node[2], _q_);
                    if (expected_exn) var _r_ = caml_call3(Ppx_expect_runtime_Expectation[7], formatting_flexibility, trailing_loc, expected_exn), exn_test = caml_call1(Ppx_expect_runtime_Test_node[2], _r_);
                    else var _s_ = caml_call1(Ppx_expect_runtime_Expectation[9], [
                        0,
                        trailing_loc,
                        body_loc
                    ]), exn_test = caml_call1(Ppx_expect_runtime_Test_node[2], _s_);
                    var expectations$0 = [
                        0,
                        [
                            0,
                            exn_test_id,
                            exn_test
                        ],
                        [
                            0,
                            [
                                0,
                                test_to_run,
                                trailing_test
                            ],
                            expectations
                        ]
                    ], expectations$1 = caml_call3(Ppx_expect_runtime_Test_node[5][1], absolute_filename, expectations$0, function(original_file_contents, ts) {
                        var _t_ = caml_call3(Ppx_expect_runtime_Test_node[6][4], Configured$0[3], Ppx_expect_runtime_Types[1][1], original_file_contents);
                        return caml_call2(Base_List[14], ts, _t_);
                    });
                    flush(0);
                    var _p_ = caml_call3(Stdlib_Filename[16], 0, cst_expect_test, cst_output), output_file = caml_call1(Ppx_expect_runtime_Current_fil[5], _p_), test_output_writer = caml_call3(Stdlib[62], _a_, 420, output_file), test_output_reader = caml_call1(Stdlib[80], output_file);
                    runtime.ppx_expect_runtime_before_test(test_output_writer, Stdlib[39], Stdlib[40]);
                    var test_block = [
                        0,
                        absolute_filename,
                        output_file,
                        [
                            0,
                            0
                        ],
                        test_output_reader,
                        test_output_writer,
                        [
                            0,
                            0
                        ]
                    ], t = [
                        0,
                        line_number,
                        basename,
                        location,
                        test_block
                    ];
                    test_is_running[1] = [
                        0,
                        t
                    ];
                    var test_exn = Configured$0[6].call(null, function(param) {
                        read_test_output_unsanitized(test_block);
                        return caml_call1(f, 0);
                    }), trailing_raw = read_test_output_sanitized_and(0), trailing_output = caml_call2(Base_String[109], 0, trailing_raw) !== cst$4 ? [
                        0,
                        trailing_raw
                    ] : 0;
                    if (test_exn) {
                        var test_exn$0 = test_exn[1];
                        if (trailing_output) var trailing_output$0 = trailing_output[1], test_output = caml_call2(Base_String[68], _m_, [
                            0,
                            test_exn$0,
                            [
                                0,
                                cst_Trailing_output,
                                [
                                    0,
                                    cst$1,
                                    [
                                        0,
                                        trailing_output$0,
                                        0
                                    ]
                                ]
                            ]
                        ]);
                        else var test_output = test_exn$0;
                        var test_to_run$0 = exn_test_id, test_output$0 = test_output;
                    } else var test_output$1 = caml_call2(Base_Option[30], trailing_output, cst$2), test_to_run$0 = test_to_run, test_output$0 = test_output$1;
                    run_test_inner(test_to_run$0, test_output$0, test_block);
                    caml_call2(Base_List[19], expectations$1, function(param) {
                        var test_node = param[2];
                        return caml_call1(Ppx_expect_runtime_Test_node[3], test_node);
                    });
                    clean_up_block(test_block);
                    test_is_running[1] = 0;
                    return 1;
                });
            }
            return [
                0,
                read_test_output_no_backtrace_,
                run_test,
                run_suite
            ];
        },
        For_external,
        at_exit
    ];
    runtime.caml_register_global(48, Ppx_expect_runtime_Test_block, "Ppx_expect_runtime__Test_block");
    return;
})(globalThis);
//# 1925 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Ppx_inline_test_lib = global_data.Ppx_inline_test_lib, Ppx_expect_runtime_Write_corre = global_data.Ppx_expect_runtime__Write_corrected_file, Ppx_expect_runtime_Current_fil = global_data.Ppx_expect_runtime__Current_file, CamlinternalLazy = global_data.CamlinternalLazy, Ppx_expect_runtime_Test_node = global_data.Ppx_expect_runtime__Test_node, Ppx_expect_runtime_Test_block = global_data.Ppx_expect_runtime__Test_block, Stdlib = global_data.Stdlib;
    caml_call1(Ppx_inline_test_lib[16], function(param) {
        var _a_ = Ppx_expect_runtime_Current_fil[4], _b_ = runtime.caml_obj_tag(_a_);
        a: if (250 === _b_) var _c_ = _a_[1];
        else {
            if (246 !== _b_ && 244 !== _b_) {
                var _c_ = _a_;
                break a;
            }
            var _c_ = caml_call1(CamlinternalLazy[2], _a_);
        }
        runtime.caml_sys_chdir(_c_);
        var _d_ = caml_call1(Ppx_expect_runtime_Test_node[5][3], function(filename, test_nodes, postprocess) {
            var _e_ = caml_call1(Ppx_inline_test_lib[14], 0), _f_ = caml_call1(Ppx_inline_test_lib[13], 0), _g_ = caml_call1(Ppx_inline_test_lib[12], 0), _h_ = caml_call1(Ppx_inline_test_lib[11], 0);
            return caml_call7(Ppx_expect_runtime_Write_corre[2], _h_, _g_, _f_, _e_, filename, postprocess, test_nodes);
        });
        return caml_call1(Ppx_inline_test_lib[5][2], _d_);
    });
    caml_call1(Stdlib[100], Ppx_expect_runtime_Test_block[3]);
    var Current_file = [
        0,
        Ppx_expect_runtime_Current_fil[1],
        Ppx_expect_runtime_Current_fil[2]
    ], Test_node = [
        0
    ], Ppx_expect_runtime = [
        0,
        Current_file,
        Test_node
    ];
    runtime.caml_register_global(7, Ppx_expect_runtime, "Ppx_expect_runtime");
    return;
})(globalThis);
//# 1 "../lib/.tensor_playground.objs/jsoo/default/tensor_playground.cma.js"
// Generated by js_of_ocaml
//# 3 "../lib/.tensor_playground.objs/jsoo/default/tensor_playground.cma.js"
//# 16 "../lib/.tensor_playground.objs/jsoo/default/tensor_playground.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_a = "a", cst_b = "b", cst_lib_Util_ml$0 = "lib/Util.ml", cst_tensor_playground$0 = "tensor_playground";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call14(f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 14 ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7,
            a8,
            a9,
            a10,
            a11,
            a12,
            a13
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_List = global_data.Stdlib__List, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Ppx_expect_runtime = global_data.Ppx_expect_runtime, Ppx_inline_test_lib = global_data.Ppx_inline_test_lib, Stdlib_String = global_data.Stdlib__String, Stdlib_Set = global_data.Stdlib__Set, Expect_test_config = global_data.Expect_test_config, Ppx_expect_runtime_Test_block = global_data.Ppx_expect_runtime__Test_block, Ppx_expect_runtime_Test_node = global_data.Ppx_expect_runtime__Test_node, Inline_test_config = global_data.Inline_test_config;
    caml_call1(Ppx_expect_runtime[1][1], cst_lib_Util_ml$0);
    caml_call2(Ppx_inline_test_lib[6], cst_tensor_playground$0, "Util.ml");
    var String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]);
    function replicate(n, item) {
        return caml_call2(Stdlib_List[11], n, function(param) {
            return item;
        });
    }
    function pad(n, x, xs) {
        var _p_ = replicate(n - caml_call1(Stdlib_List[1], xs) | 0, x);
        return caml_call2(Stdlib[37], _p_, xs);
    }
    var sum = caml_call2(Stdlib_List[26], function(_o_, _n_) {
        return _o_ + _n_ | 0;
    }, 0);
    function find_repeats(names) {
        var repeats$1 = String_set[1], seen$1 = String_set[1], names$0 = names, seen = seen$1, repeats = repeats$1;
        for(;;){
            if (!names$0) return caml_call1(String_set[10], repeats);
            var names$1 = names$0[2], name = names$0[1];
            if (caml_call2(String_set[31], name, seen)) {
                var repeats$0 = caml_call2(String_set[2], name, repeats);
                names$0 = names$1;
                repeats = repeats$0;
            } else {
                var seen$0 = caml_call2(String_set[2], name, seen);
                names$0 = names$1;
                seen = seen$0;
            }
        }
    }
    var _a_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                "c",
                [
                    0,
                    cst_a,
                    [
                        0,
                        "d",
                        [
                            0,
                            "e",
                            [
                                0,
                                cst_b,
                                [
                                    0,
                                    "f",
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ], _b_ = [
        0,
        [
            0,
            [
                0,
                "\n    a\n    b ",
                [
                    0,
                    ""
                ]
            ],
            [
                0,
                718,
                729,
                746
            ]
        ]
    ], _c_ = [
        0,
        718,
        720,
        747
    ], _f_ = [
        0,
        "find_repeats"
    ], _i_ = [
        0,
        597,
        597,
        747
    ], _j_ = [
        0,
        738,
        747,
        747
    ], _k_ = [
        0,
        597,
        597,
        747
    ], cst_lib_Util_ml = cst_lib_Util_ml$0, cst_tensor_playground = cst_tensor_playground$0;
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _d_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _c_, _b_), _e_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 0),
                _d_
            ],
            0
        ], _g_ = caml_call1(Ppx_expect_runtime_Types[4][1], 2), _h_ = caml_call1(Ppx_expect_runtime_Types[4][1], 1);
        caml_call14(Ppx_expect_test_block[3], cst_lib_Util_ml, 20, _k_, _j_, _i_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _h_, _g_, _f_, 0, Inline_test_config, _e_, function(param) {
            var _l_ = find_repeats(_a_);
            caml_call1(caml_call1(Stdlib_List[18], Stdlib[46]), _l_);
            var _m_ = caml_call1(Ppx_expect_runtime_Types[4][1], 0);
            return caml_call1(Ppx_expect_test_block[2], _m_);
        });
    }
    function delete_from_list(i, xs) {
        if (!xs) return 0;
        var x = xs[1];
        if (0 === i) {
            var xs$0 = xs[2];
            return xs$0;
        }
        var xs$1 = xs[2];
        return [
            0,
            x,
            delete_from_list(i - 1 | 0, xs$1)
        ];
    }
    caml_call1(Ppx_inline_test_lib[7], cst_tensor_playground);
    caml_call1(Ppx_expect_runtime[1][2], 0);
    var Tensor_playground_Util = [
        0,
        String_set,
        replicate,
        pad,
        sum,
        find_repeats,
        delete_from_list
    ];
    runtime.caml_register_global(23, Tensor_playground_Util, "Tensor_playground__Util");
    return;
})(globalThis);
//# 796 "../lib/.tensor_playground.objs/jsoo/default/tensor_playground.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_tensor_playground = "tensor_playground";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Option = global_data.Stdlib__Option, Stdlib_List = global_data.Stdlib__List, Stdlib_Seq = global_data.Stdlib__Seq, Ppx_expect_runtime = global_data.Ppx_expect_runtime, Ppx_inline_test_lib = global_data.Ppx_inline_test_lib, Stdlib_String = global_data.Stdlib__String, Stdlib_Map = global_data.Stdlib__Map, Stdlib_Set = global_data.Stdlib__Set;
    caml_call1(Ppx_expect_runtime[1][1], "lib/Counter.ml");
    caml_call2(Ppx_inline_test_lib[6], cst_tensor_playground, "Counter.ml");
    var String_map = caml_call1(Stdlib_Map[1], [
        0,
        Stdlib_String[10]
    ]), String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]), _a_ = [
        0,
        1
    ];
    function add_to_count(map, x) {
        return caml_call3(String_map[4], x, function(param) {
            if (!param) return _a_;
            var n = param[1];
            return [
                0,
                n + 1 | 0
            ];
        }, map);
    }
    var make = caml_call2(Stdlib_List[26], add_to_count, String_map[1]);
    function key_set(m) {
        var _h_ = caml_call1(String_map[39], m), _i_ = caml_call1(caml_call1(Stdlib_Seq[29], function(_j_) {
            return _j_[1];
        }), _h_);
        return caml_call1(String_set[43], _i_);
    }
    function to_list(m) {
        return caml_call1(String_map[10], m);
    }
    function diff(a, b) {
        var _c_ = key_set(b), _d_ = key_set(a), _e_ = caml_call2(String_set[5], _d_, _c_), keys = caml_call1(String_set[37], _e_);
        return caml_call3(Stdlib_List[26], function(acc, key) {
            var _f_ = caml_call2(String_map[18], key, a), a_val = caml_call2(Stdlib_Option[3], _f_, 0), _g_ = caml_call2(String_map[18], key, b), b_val = caml_call2(Stdlib_Option[3], _g_, 0);
            return a_val === b_val ? acc : caml_call3(String_map[2], key, a_val - b_val | 0, acc);
        }, String_map[1], keys);
    }
    function get(m, k) {
        var _b_ = caml_call2(String_map[18], k, m);
        return caml_call2(Stdlib_Option[3], _b_, 0);
    }
    caml_call1(Ppx_inline_test_lib[7], cst_tensor_playground);
    caml_call1(Ppx_expect_runtime[1][2], 0);
    var Tensor_playground_Counter = [
        0,
        String_map,
        String_set,
        make,
        diff,
        get,
        key_set,
        to_list
    ];
    runtime.caml_register_global(13, Tensor_playground_Counter, "Tensor_playground__Counter");
    return;
})(globalThis);
//# 892 "../lib/.tensor_playground.objs/jsoo/default/tensor_playground.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$2 = "", cst_Loop_over_all_summation_in = "\n      # Loop over all summation indices\n      total = 0\n      for s in range(d_s):\n          for t in range(d_t):\n              total += A[s] * B[s, t] * C[t]\n      return total\n      ", cst$6 = " * ", cst$7 = " -> ", cst_a_b_c = " [a; b; c] ", cst_a_b = " [a; b] ", cst_in_range = " in range(", cst_sfor_a_in_range_a = "%sfor %a in range(%a):@.", cst$4 = "):", cst$5 = "+=", cst_hov_4 = "<hov 4>", cst$3 = "@ ", cst_a$0 = "[@[%a@]]@.", cst_a = "a", cst_b = "b", cst_c = "c", cst_for = "for ", cst_i = "i", cst_j = "j", cst_k = "k", cst_lib_Einops_ml$4 = "lib/Einops.ml", cst_result = "result[", cst_s = "s", cst_t = "t", cst_tensor_playground$0 = "tensor_playground", cst_total = "total";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    function caml_call14(f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 14 ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7,
            a8,
            a9,
            a10,
            a11,
            a12,
            a13
        ]);
    }
    var global_data = runtime.caml_get_global_data(), partial = [
        0,
        0,
        cst$2
    ], partial$0 = [
        17,
        0,
        [
            12,
            93,
            [
                17,
                0,
                [
                    17,
                    4,
                    0
                ]
            ]
        ]
    ], cst$1 = cst$2, cst$0 = ":", partial$1 = [
        0,
        cst$3,
        1,
        0
    ], partial$2 = [
        17,
        4,
        0
    ], cst = cst$2, Fmt = global_data.Fmt, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Stdlib_List = global_data.Stdlib__List, Stdlib_String = global_data.Stdlib__String, Stdlib_Char = global_data.Stdlib__Char, Tensor_playground_Counter = global_data.Tensor_playground__Counter, Stdlib = global_data.Stdlib, Stdlib_Format = global_data.Stdlib__Format, Ppx_expect_runtime = global_data.Ppx_expect_runtime, Ppx_inline_test_lib = global_data.Ppx_inline_test_lib, Stdlib_Set = global_data.Stdlib__Set, Stdlib_Map = global_data.Stdlib__Map, Expect_test_config = global_data.Expect_test_config, Ppx_expect_runtime_Test_block = global_data.Ppx_expect_runtime__Test_block, Ppx_expect_runtime_Test_node = global_data.Ppx_expect_runtime__Test_node, Inline_test_config = global_data.Inline_test_config;
    caml_call1(Ppx_expect_runtime[1][1], cst_lib_Einops_ml$4);
    caml_call2(Ppx_inline_test_lib[6], cst_tensor_playground$0, "Einops.ml");
    var String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]), String_map = caml_call1(Stdlib_Map[1], [
        0,
        Stdlib_String[10]
    ]), Colored = [
        248,
        "Tensor_playground.Einops.Colored",
        runtime.caml_fresh_oo_id(0)
    ], _a_ = [
        0,
        [
            2,
            0,
            0
        ],
        "%s"
    ];
    function pp_var(get_color, ppf, var$0) {
        var color = caml_call1(get_color, var$0);
        caml_call2(Stdlib_Format[82], ppf, [
            0,
            Colored,
            color
        ]);
        caml_call3(Fmt[3], ppf, _a_, var$0);
        return caml_call2(Stdlib_Format[84], ppf, 0);
    }
    var PP_var_impl = [
        0,
        pp_var
    ], pp_var$0 = PP_var_impl[1], _b_ = caml_call2(Fmt[64], [
        0,
        Fmt[23]
    ], Fmt[57]), pp_friendly = caml_call2(Fmt[32], 0, _b_);
    function pp_original(ppf, group) {
        var _cX_ = caml_call2(Stdlib_String[7], cst, group);
        return caml_call2(Fmt[57], ppf, _cX_);
    }
    var Group = [
        0,
        pp_friendly,
        pp_original
    ], _c_ = caml_call2(Fmt[64], [
        0,
        Fmt[25]
    ], Group[1]), pp_friendly$0 = caml_call2(Fmt[32], 0, _c_), _d_ = caml_call2(Fmt[64], [
        0,
        Fmt[25]
    ], Group[2]), pp_original$0 = caml_call2(Fmt[32], 0, _d_), Bindings = [
        0,
        pp_friendly$0,
        pp_original$0
    ];
    function indices(param) {
        var rhs = param[2], lhs = param[1], _cW_ = caml_call1(Stdlib_List[15], lhs), lhs$0 = caml_call1(String_set[38], _cW_), rhs$0 = caml_call1(String_set[38], rhs);
        return [
            0,
            rhs$0,
            caml_call2(String_set[8], lhs$0, rhs$0)
        ];
    }
    function free_indices(t) {
        return indices(t)[1];
    }
    function summation_indices(t) {
        return indices(t)[2];
    }
    var _e_ = Group[1], _f_ = Bindings[1], _g_ = [
        0,
        caml_call1(Fmt[18], [
            0,
            [
                11,
                cst$7,
                0
            ],
            cst$7
        ])
    ], _h_ = caml_call3(Fmt[61], _g_, _f_, _e_), pp_friendly$1 = caml_call2(Fmt[32], 0, _h_), _i_ = Group[2], _j_ = Bindings[2], _k_ = [
        0,
        caml_call1(Fmt[18], [
            0,
            [
                11,
                cst$7,
                0
            ],
            cst$7
        ])
    ], _l_ = caml_call3(Fmt[61], _k_, _j_, _i_), pp_original$1 = caml_call2(Fmt[32], 0, _l_), cst_Ran_out_of_letters = "Ran out of letters", _m_ = [
        0,
        [
            11,
            "Result indices must not be repeated ([",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst$2
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            11,
                            "])",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Result indices must not be repeated ([@[%a@]])"
    ], _n_ = [
        0,
        [
            11,
            "Result indices must be a subset of the input indices ([",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst$2
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            11,
                            "] are not)",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Result indices must be a subset of the input indices ([@[%a@]] are not)"
    ];
    function to_original(param) {
        var rhs = param[2], lhs = param[1], match = indices([
            0,
            lhs,
            rhs
        ]), summation = match[2], free = match[1], _cT_ = caml_call2(String_set[5], free, summation), all_indices = caml_call1(String_set[37], _cT_), used = [
            0,
            0
        ];
        function pick_char(s) {
            var first = runtime.caml_string_get(s, 0);
            if (!caml_call2(Stdlib_List[37], first, used[1])) {
                used[1] = [
                    0,
                    first,
                    used[1]
                ];
                return caml_call2(Stdlib_String[1], 1, first);
            }
            var c$1 = caml_call1(Stdlib_Char[1], 97), c = c$1;
            for(;;){
                if (122 < c) return caml_call1(Stdlib[2], cst_Ran_out_of_letters);
                if (!caml_call2(Stdlib_List[37], c, used[1])) {
                    used[1] = [
                        0,
                        c,
                        used[1]
                    ];
                    return caml_call2(Stdlib_String[1], 1, c);
                }
                var c$0 = caml_call1(Stdlib_Char[1], c + 1 | 0);
                c = c$0;
            }
        }
        var assigned_chars = caml_call2(Stdlib_List[20], pick_char, all_indices), assoc_list = caml_call2(Stdlib_List[58], all_indices, assigned_chars);
        function find_char(x) {
            return caml_call2(Stdlib_List[49], x, assoc_list);
        }
        var _cU_ = caml_call2(Stdlib_List[20], find_char, rhs), _cV_ = caml_call1(Stdlib_List[20], find_char);
        return [
            0,
            caml_call2(Stdlib_List[20], _cV_, lhs),
            _cU_
        ];
    }
    function validate(param) {
        var rhs = param[2], lhs = param[1], _cL_ = caml_call1(Stdlib_List[15], lhs), lhs_set = caml_call1(String_set[38], _cL_), rhs_set = caml_call1(String_set[38], rhs), rhs_extras = caml_call2(String_set[8], rhs_set, lhs_set);
        if (!caml_call1(String_set[30], rhs_extras)) {
            var _cQ_ = caml_call1(String_set[37], rhs_extras), _cR_ = caml_call2(Fmt[64], [
                0,
                Fmt[25]
            ], Fmt[57]);
            return [
                0,
                caml_call3(Fmt[6], _n_, _cR_, _cQ_)
            ];
        }
        var _cM_ = caml_call1(Tensor_playground_Counter[3], rhs), _cN_ = caml_call1(Tensor_playground_Counter[7], _cM_), _cO_ = caml_call1(caml_call1(Stdlib_List[44], function(param) {
            var n = param[2];
            return 1 < n ? 1 : 0;
        }), _cN_), repeated_in_rhs = caml_call1(caml_call1(Stdlib_List[20], function(_cS_) {
            return _cS_[1];
        }), _cO_);
        if (0 === repeated_in_rhs) return 0;
        var _cP_ = caml_call2(Fmt[64], [
            0,
            Fmt[25]
        ], Fmt[57]);
        return [
            0,
            caml_call3(Fmt[6], _m_, _cP_, repeated_in_rhs)
        ];
    }
    var Rewrite = [
        0,
        indices,
        free_indices,
        summation_indices,
        pp_friendly$1,
        pp_original$1,
        to_original,
        validate
    ];
    function indexof(x, lst) {
        var i = 0, param = lst;
        for(;;){
            if (!param) return 0;
            var ys = param[2], y = param[1];
            if (runtime.caml_equal(x, y)) return [
                0,
                i
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
            param = ys;
        }
    }
    var Indexof_impl = [
        0,
        indexof
    ], indexof$0 = Indexof_impl[1], _o_ = [
        0,
        [
            11,
            "d_",
            [
                15,
                0
            ]
        ],
        "d_%a"
    ], _p_ = [
        0,
        [
            11,
            "result = np.zeros((",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst$2
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            11,
                            "))",
                            [
                                17,
                                4,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "result = np.zeros((@[%a@]))@."
    ], _q_ = [
        0,
        [
            11,
            "# Loop over all free indices",
            [
                17,
                4,
                0
            ]
        ],
        "# Loop over all free indices@."
    ], _r_ = [
        0,
        [
            2,
            0,
            [
                11,
                cst_for,
                [
                    15,
                    [
                        11,
                        cst_in_range,
                        [
                            15,
                            [
                                11,
                                cst$4,
                                [
                                    17,
                                    4,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_sfor_a_in_range_a
    ], _s_ = [
        0,
        [
            2,
            0,
            [
                12,
                91,
                [
                    15,
                    [
                        12,
                        93,
                        0
                    ]
                ]
            ]
        ],
        "%s[%a]"
    ], _t_ = [
        0,
        [
            2,
            0,
            [
                18,
                [
                    1,
                    [
                        0,
                        [
                            11,
                            cst_hov_4,
                            0
                        ],
                        cst_hov_4
                    ]
                ],
                [
                    11,
                    cst_result,
                    [
                        18,
                        [
                            1,
                            [
                                0,
                                0,
                                cst$2
                            ]
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                [
                                    12,
                                    93,
                                    [
                                        17,
                                        [
                                            0,
                                            cst$3,
                                            1,
                                            0
                                        ],
                                        [
                                            11,
                                            cst$5,
                                            [
                                                17,
                                                partial$1,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s@[<hov 4>result[@[%a@]]@ +=@ "
    ], _u_ = [
        0,
        [
            11,
            cst$6,
            0
        ],
        cst$6
    ], _v_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$2
                ]
            ],
            [
                11,
                "np.sum(",
                [
                    18,
                    [
                        1,
                        [
                            0,
                            0,
                            cst$2
                        ]
                    ],
                    [
                        15,
                        [
                            17,
                            0,
                            [
                                12,
                                41,
                                [
                                    17,
                                    0,
                                    [
                                        17,
                                        0,
                                        [
                                            17,
                                            4,
                                            0
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[np.sum(@[%a@])@]@]@."
    ], _w_ = [
        0,
        [
            11,
            "return result",
            [
                17,
                4,
                0
            ]
        ],
        "return result@."
    ], _x_ = [
        0,
        [
            11,
            "return total",
            [
                17,
                4,
                0
            ]
        ],
        "return total@."
    ], _y_ = [
        0,
        [
            2,
            0,
            [
                18,
                [
                    1,
                    [
                        0,
                        [
                            11,
                            cst_hov_4,
                            0
                        ],
                        cst_hov_4
                    ]
                ],
                [
                    11,
                    cst_total,
                    [
                        17,
                        [
                            0,
                            cst$3,
                            1,
                            0
                        ],
                        [
                            12,
                            61,
                            [
                                17,
                                [
                                    0,
                                    cst$3,
                                    1,
                                    0
                                ],
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s@[<hov 4>total@ =@ "
    ], _z_ = [
        0,
        [
            2,
            0,
            [
                11,
                "# Loop over all summation indices",
                [
                    17,
                    4,
                    0
                ]
            ]
        ],
        "%s# Loop over all summation indices@."
    ], _A_ = [
        0,
        [
            2,
            0,
            [
                11,
                "total = 0",
                [
                    17,
                    4,
                    0
                ]
            ]
        ],
        "%stotal = 0@."
    ], _B_ = [
        0,
        [
            2,
            0,
            [
                11,
                cst_for,
                [
                    15,
                    [
                        11,
                        cst_in_range,
                        [
                            15,
                            [
                                11,
                                cst$4,
                                [
                                    17,
                                    4,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_sfor_a_in_range_a
    ], _C_ = [
        0,
        [
            11,
            cst$6,
            0
        ],
        cst$6
    ], _D_ = [
        0,
        [
            2,
            0,
            [
                18,
                [
                    1,
                    [
                        0,
                        [
                            11,
                            cst_hov_4,
                            0
                        ],
                        cst_hov_4
                    ]
                ],
                [
                    11,
                    cst_total,
                    [
                        17,
                        [
                            0,
                            cst$3,
                            1,
                            0
                        ],
                        [
                            11,
                            cst$5,
                            [
                                17,
                                [
                                    0,
                                    cst$3,
                                    1,
                                    0
                                ],
                                [
                                    18,
                                    [
                                        1,
                                        [
                                            0,
                                            0,
                                            cst$2
                                        ]
                                    ],
                                    [
                                        15,
                                        [
                                            17,
                                            0,
                                            [
                                                17,
                                                0,
                                                partial$2
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s@[<hov 4>total@ +=@ @[%a@]@]@."
    ], _E_ = [
        0,
        [
            2,
            0,
            [
                11,
                cst_result,
                [
                    18,
                    [
                        1,
                        [
                            0,
                            0,
                            cst$2
                        ]
                    ],
                    [
                        15,
                        [
                            17,
                            0,
                            [
                                11,
                                "] = total",
                                [
                                    17,
                                    4,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%sresult[@[%a@]] = total@."
    ];
    function mk_indent(indent) {
        return caml_call2(Stdlib_String[1], indent * 4 | 0, 32);
    }
    function pp(opt, get_color, ppf, param) {
        var use_frob = opt ? opt[1] : 0, rhs_tensor = param[4], lhs_tensors = param[3], summation_indices_set = param[2], free_indices = param[1], free_indices$0 = caml_call1(String_set[10], free_indices), summation_indices = caml_call1(String_set[10], summation_indices_set), pp_var = caml_call1(pp_var$0, get_color);
        function pp_d_var(ppf, var$0) {
            return caml_call4(Fmt[3], ppf, _o_, pp_var, var$0);
        }
        if (rhs_tensor) {
            var _cs_ = caml_call2(Fmt[64], [
                0,
                Fmt[25]
            ], pp_d_var);
            caml_call4(Fmt[3], ppf, _p_, _cs_, rhs_tensor);
        }
        if (free_indices$0) caml_call2(Fmt[3], ppf, _q_);
        var outer_indent = caml_call3(Stdlib_List[26], function(indent, index) {
            var _cK_ = mk_indent(indent);
            caml_call7(Fmt[3], ppf, _r_, _cK_, pp_var, index, pp_d_var, index);
            return indent + 1 | 0;
        }, 0, free_indices$0);
        function pp_access(ppf, param) {
            var indices = param[2], tensor = param[1], _cJ_ = caml_call2(Fmt[64], [
                0,
                Fmt[25]
            ], pp_var);
            return caml_call5(Fmt[3], ppf, _s_, tensor, _cJ_, indices);
        }
        if (use_frob) {
            if (rhs_tensor) {
                var _ct_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[25]
                ], pp_var), _cu_ = mk_indent(outer_indent);
                caml_call5(Fmt[3], ppf, _t_, _cu_, _ct_, free_indices$0);
            } else {
                var _cx_ = mk_indent(outer_indent);
                caml_call3(Fmt[3], ppf, _y_, _cx_);
            }
            var accesses = caml_call2(Stdlib_List[21], function(i, tensor) {
                var _cF_ = caml_call2(Stdlib_List[20], function(label) {
                    return caml_call2(String_set[31], label, summation_indices_set) ? cst$0 : label;
                }, tensor), _cG_ = caml_call1(Stdlib_Char[1], i + 65 | 0);
                return [
                    0,
                    caml_call2(Stdlib_String[1], 1, _cG_),
                    _cF_
                ];
            }, lhs_tensors), _cv_ = [
                0,
                caml_call1(Fmt[18], _u_)
            ], _cw_ = caml_call2(Fmt[64], _cv_, pp_access);
            caml_call4(Fmt[3], ppf, _v_, _cw_, accesses);
        } else {
            if (summation_indices) {
                var _cy_ = mk_indent(outer_indent);
                caml_call3(Fmt[3], ppf, _z_, _cy_);
            }
            var _cz_ = mk_indent(outer_indent);
            caml_call3(Fmt[3], ppf, _A_, _cz_);
            var inner_indent = caml_call3(Stdlib_List[26], function(indent, index) {
                var _cI_ = mk_indent(indent);
                caml_call7(Fmt[3], ppf, _B_, _cI_, pp_var, index, pp_d_var, index);
                return indent + 1 | 0;
            }, outer_indent, summation_indices), accesses$0 = caml_call2(Stdlib_List[21], function(i, tensor) {
                var _cH_ = caml_call1(Stdlib_Char[1], i + 65 | 0);
                return [
                    0,
                    caml_call2(Stdlib_String[1], 1, _cH_),
                    tensor
                ];
            }, lhs_tensors), _cA_ = [
                0,
                caml_call1(Fmt[18], _C_)
            ], _cB_ = caml_call2(Fmt[64], _cA_, pp_access), _cC_ = mk_indent(inner_indent);
            caml_call5(Fmt[3], ppf, _D_, _cC_, _cB_, accesses$0);
            if (rhs_tensor) {
                var _cD_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[25]
                ], pp_var), _cE_ = mk_indent(outer_indent);
                caml_call5(Fmt[3], ppf, _E_, _cE_, _cD_, free_indices$0);
            }
        }
        return rhs_tensor ? caml_call2(Fmt[3], ppf, _w_) : caml_call2(Fmt[3], ppf, _x_);
    }
    var Pyloops = [
        0,
        pp
    ];
    function show_loops(rewrite) {
        var rhs_tensor = rewrite[2], lhs_tensors = rewrite[1], _cr_ = caml_call1(Rewrite[3], rewrite);
        return [
            0,
            caml_call1(Rewrite[2], rewrite),
            _cr_,
            lhs_tensors,
            rhs_tensor
        ];
    }
    var _F_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$2
                ]
            ],
            [
                11,
                "diagonalized: [",
                [
                    18,
                    [
                        1,
                        [
                            0,
                            0,
                            cst$2
                        ]
                    ],
                    [
                        15,
                        [
                            17,
                            0,
                            [
                                11,
                                "],",
                                [
                                    17,
                                    [
                                        0,
                                        cst$3,
                                        1,
                                        0
                                    ],
                                    [
                                        11,
                                        "broadcast: [",
                                        [
                                            18,
                                            [
                                                1,
                                                partial
                                            ],
                                            [
                                                15,
                                                partial$0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[diagonalized: [@[%a@]],@ broadcast: [@[%a@]]@]@."
    ], _G_ = [
        0,
        cst_a,
        0
    ], _H_ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                0
            ]
        ],
        0
    ], _I_ = [
        0,
        cst_b,
        0
    ], _J_ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                0
            ]
        ],
        0
    ], _Y_ = [
        0,
        [
            12,
            91,
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst$2
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            [
                                17,
                                4,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_a$0
    ], _Z_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_c,
                0
            ]
        ]
    ], ___ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                [
                    0,
                    cst_c,
                    0
                ]
            ]
        ],
        [
            0,
            [
                0,
                cst_a,
                [
                    0,
                    cst_b,
                    [
                        0,
                        cst_a,
                        0
                    ]
                ]
            ],
            0
        ]
    ], _$_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_c,
                0
            ]
        ]
    ], _aa_ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                [
                    0,
                    cst_c,
                    0
                ]
            ]
        ],
        [
            0,
            [
                0,
                cst_a,
                [
                    0,
                    "d",
                    [
                        0,
                        cst_b,
                        0
                    ]
                ]
            ],
            0
        ]
    ], _ab_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            0
        ]
    ], _ac_ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                [
                    0,
                    cst_c,
                    0
                ]
            ]
        ],
        [
            0,
            [
                0,
                cst_a,
                [
                    0,
                    cst_b,
                    [
                        0,
                        cst_a,
                        0
                    ]
                ]
            ],
            0
        ]
    ], _ad_ = [
        0,
        cst_a,
        0
    ], _ae_ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                0
            ]
        ],
        0
    ], _aB_ = [
        0,
        [
            12,
            91,
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst$2
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            [
                                17,
                                4,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_a$0
    ], _aC_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_c,
                0
            ]
        ]
    ], _aD_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_a,
                0
            ]
        ]
    ], _aE_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_c,
                [
                    0,
                    cst_a,
                    0
                ]
            ]
        ]
    ], cst_x = "x", _aX_ = [
        0,
        [
            15,
            0
        ],
        "%a"
    ], _aY_ = [
        0,
        cst_a,
        0
    ], _aZ_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            0
        ]
    ], _a0_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_c,
                0
            ]
        ]
    ], _bl_ = [
        0,
        [
            0,
            [
                0,
                cst_i,
                [
                    0,
                    cst_k,
                    0
                ]
            ],
            [
                0,
                [
                    0,
                    cst_k,
                    [
                        0,
                        cst_j,
                        0
                    ]
                ],
                0
            ]
        ],
        [
            0,
            cst_i,
            [
                0,
                cst_j,
                0
            ]
        ]
    ], _bm_ = [
        0,
        [
            0,
            [
                0,
                cst_s,
                0
            ],
            [
                0,
                [
                    0,
                    cst_s,
                    [
                        0,
                        cst_t,
                        0
                    ]
                ],
                [
                    0,
                    [
                        0,
                        cst_t,
                        0
                    ],
                    0
                ]
            ]
        ],
        0
    ], _bn_ = [
        0,
        [
            0,
            [
                0,
                cst_i,
                [
                    0,
                    cst_i,
                    0
                ]
            ],
            0
        ],
        [
            0,
            cst_i,
            0
        ]
    ], _bo_ = [
        0,
        [
            0,
            [
                0,
                cst_i,
                [
                    0,
                    cst_i,
                    0
                ]
            ],
            0
        ],
        0
    ], _bp_ = [
        0,
        [
            0,
            [
                0,
                cst_s,
                0
            ],
            [
                0,
                [
                    0,
                    cst_s,
                    [
                        0,
                        cst_t,
                        0
                    ]
                ],
                [
                    0,
                    [
                        0,
                        cst_t,
                        0
                    ],
                    0
                ]
            ]
        ],
        0
    ], _bq_ = [
        0,
        [
            0,
            [
                0,
                cst_b,
                [
                    0,
                    cst_i,
                    0
                ]
            ],
            [
                0,
                [
                    0,
                    cst_b,
                    [
                        0,
                        cst_j,
                        0
                    ]
                ],
                0
            ]
        ],
        [
            0,
            cst_b,
            [
                0,
                cst_i,
                [
                    0,
                    cst_j,
                    0
                ]
            ]
        ]
    ], _br_ = [
        0,
        [
            0,
            [
                0,
                "\n      result = np.zeros((d_i, d_j))\n      # Loop over all free indices\n      for i in range(d_i):\n          for j in range(d_j):\n              # Loop over all summation indices\n              total = 0\n              for k in range(d_k):\n                  total += A[i, k] * B[k, j]\n              result[i, j] = total\n      return result\n      ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                8294,
                8300,
                8647
            ]
        ]
    ], _bs_ = [
        0,
        8281,
        8285,
        8648
    ], _bv_ = [
        0,
        [
            0,
            [
                0,
                cst_Loop_over_all_summation_in,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                8713,
                8719,
                8908
            ]
        ]
    ], _bw_ = [
        0,
        8700,
        8704,
        8909
    ], _bz_ = [
        0,
        [
            0,
            [
                0,
                "\n      result = np.zeros((d_i))\n      # Loop over all free indices\n      for i in range(d_i):\n          total = 0\n          total += A[i, i]\n          result[i] = total\n      return result\n      ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                8961,
                8967,
                9166
            ]
        ]
    ], _bA_ = [
        0,
        8948,
        8952,
        9167
    ], _bD_ = [
        0,
        [
            0,
            [
                0,
                "\n      # Loop over all summation indices\n      total = 0\n      for i in range(d_i):\n          total += A[i, i]\n      return total\n      ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                9214,
                9220,
                9360
            ]
        ]
    ], _bE_ = [
        0,
        9201,
        9205,
        9361
    ], _bH_ = [
        0,
        [
            0,
            [
                0,
                cst_Loop_over_all_summation_in,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                9426,
                9432,
                9621
            ]
        ]
    ], _bI_ = [
        0,
        9413,
        9417,
        9622
    ], _bL_ = [
        0,
        [
            0,
            [
                0,
                "\n      result = np.zeros((d_b, d_i, d_j))\n      # Loop over all free indices\n      for b in range(d_b):\n          for i in range(d_i):\n              for j in range(d_j):\n                  total = 0\n                  total += A[b, i] * B[b, j]\n                  result[b, i, j] = total\n      return result\n      ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                9698,
                9704,
                10019
            ]
        ]
    ], _bM_ = [
        0,
        9685,
        9689,
        10020
    ], _bP_ = [
        0,
        "show_loops"
    ], _bS_ = [
        0,
        8086,
        8088,
        10020
    ], _bT_ = [
        0,
        10011,
        10020,
        10020
    ], _bU_ = [
        0,
        8086,
        8088,
        10020
    ], cst_lib_Einops_ml$3 = cst_lib_Einops_ml$4, _a1_ = [
        0,
        [
            0,
            [
                0,
                " [] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                10326,
                10337,
                10345
            ]
        ]
    ], _a2_ = [
        0,
        10326,
        10328,
        10346
    ], _a5_ = [
        0,
        [
            0,
            [
                0,
                " [a] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                10362,
                10373,
                10382
            ]
        ]
    ], _a6_ = [
        0,
        10362,
        10364,
        10383
    ], _a9_ = [
        0,
        [
            0,
            [
                0,
                " [a, x, b] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                10404,
                10415,
                10430
            ]
        ]
    ], _a__ = [
        0,
        10404,
        10406,
        10431
    ], _bb_ = [
        0,
        [
            0,
            [
                0,
                " [a, x, b, x, c] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                10457,
                10468,
                10489
            ]
        ]
    ], _bc_ = [
        0,
        10457,
        10459,
        10490
    ], _bf_ = [
        0,
        "intersperse"
    ], _bi_ = [
        0,
        10152,
        10152,
        10490
    ], _bj_ = [
        0,
        10457,
        10490,
        10490
    ], _bk_ = [
        0,
        10152,
        10152,
        10490
    ], cst_lib_Einops_ml$2 = cst_lib_Einops_ml$4, _aF_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b_c,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                11068,
                11081,
                11096
            ]
        ]
    ], _aG_ = [
        0,
        11068,
        11072,
        11097
    ], _aJ_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                11125,
                11138,
                11150
            ]
        ]
    ], _aK_ = [
        0,
        11125,
        11129,
        11151
    ], _aN_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b_c,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                11184,
                11197,
                11212
            ]
        ]
    ], _aO_ = [
        0,
        11184,
        11188,
        11213
    ], _aR_ = [
        0,
        "extract_diagonals"
    ], _aU_ = [
        0,
        10895,
        10897,
        11213
    ], _aV_ = [
        0,
        11184,
        11213,
        11213
    ], _aW_ = [
        0,
        10895,
        10897,
        11213
    ], cst_lib_Einops_ml$1 = cst_lib_Einops_ml$4, _af_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b_c,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                11812,
                11825,
                11840
            ]
        ]
    ], _ag_ = [
        0,
        11812,
        11816,
        11841
    ], _aj_ = [
        0,
        [
            0,
            [
                0,
                " [a; b; c; d] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                11910,
                11923,
                11941
            ]
        ]
    ], _ak_ = [
        0,
        11910,
        11914,
        11942
    ], _an_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b_c,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                12006,
                12019,
                12034
            ]
        ]
    ], _ao_ = [
        0,
        12006,
        12010,
        12035
    ], _ar_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                12070,
                12083,
                12095
            ]
        ]
    ], _as_ = [
        0,
        12070,
        12074,
        12096
    ], _av_ = [
        0,
        "make_common_shape"
    ], _ay_ = [
        0,
        11582,
        11584,
        12096
    ], _az_ = [
        0,
        12070,
        12096,
        12096
    ], _aA_ = [
        0,
        11582,
        11584,
        12096
    ], cst_lib_Einops_ml$0 = cst_lib_Einops_ml$4, _K_ = [
        0,
        [
            0,
            [
                0,
                " diagonalized: [[a; b]], broadcast: [a; b] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                12622,
                12635,
                12682
            ]
        ]
    ], _L_ = [
        0,
        12622,
        12626,
        12683
    ], _O_ = [
        0,
        [
            0,
            [
                0,
                " diagonalized: [[a; b]], broadcast: [b; a] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                12718,
                12731,
                12778
            ]
        ]
    ], _P_ = [
        0,
        12718,
        12722,
        12779
    ], _S_ = [
        0,
        "make"
    ], _V_ = [
        0,
        12270,
        12272,
        12779
    ], _W_ = [
        0,
        12718,
        12779,
        12779
    ], _X_ = [
        0,
        12270,
        12272,
        12779
    ], cst_lib_Einops_ml = cst_lib_Einops_ml$4, cst_tensor_playground = cst_tensor_playground$0;
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block$3 = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _bt_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bs_, _br_), _bu_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 0),
                _bt_
            ],
            0
        ], _bx_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bw_, _bv_), _by_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 1),
                _bx_
            ],
            _bu_
        ], _bB_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bA_, _bz_), _bC_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 2),
                _bB_
            ],
            _by_
        ], _bF_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bE_, _bD_), _bG_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 3),
                _bF_
            ],
            _bC_
        ], _bJ_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bI_, _bH_), _bK_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 4),
                _bJ_
            ],
            _bG_
        ], _bN_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bM_, _bL_), _bO_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 5),
                _bN_
            ],
            _bK_
        ], _bQ_ = caml_call1(Ppx_expect_runtime_Types[4][1], 7), _bR_ = caml_call1(Ppx_expect_runtime_Types[4][1], 6);
        caml_call14(Ppx_expect_test_block$3[3], cst_lib_Einops_ml$3, 273, _bU_, _bT_, _bS_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _bR_, _bQ_, _bP_, 0, Inline_test_config, _bO_, function(param) {
            function go(rewrite) {
                var _cq_ = show_loops(rewrite);
                return caml_call1(caml_call3(Pyloops[1], 0, function(param) {
                    return cst$1;
                }, Fmt[1]), _cq_);
            }
            go(_bl_);
            var _ck_ = caml_call1(Ppx_expect_runtime_Types[4][1], 0);
            caml_call1(Ppx_expect_test_block$3[2], _ck_);
            go(_bm_);
            var _cl_ = caml_call1(Ppx_expect_runtime_Types[4][1], 1);
            caml_call1(Ppx_expect_test_block$3[2], _cl_);
            go(_bn_);
            var _cm_ = caml_call1(Ppx_expect_runtime_Types[4][1], 2);
            caml_call1(Ppx_expect_test_block$3[2], _cm_);
            go(_bo_);
            var _cn_ = caml_call1(Ppx_expect_runtime_Types[4][1], 3);
            caml_call1(Ppx_expect_test_block$3[2], _cn_);
            go(_bp_);
            var _co_ = caml_call1(Ppx_expect_runtime_Types[4][1], 4);
            caml_call1(Ppx_expect_test_block$3[2], _co_);
            go(_bq_);
            var _cp_ = caml_call1(Ppx_expect_runtime_Types[4][1], 5);
            return caml_call1(Ppx_expect_test_block$3[2], _cp_);
        });
    }
    var Explain = [
        0,
        show_loops
    ];
    function intersperse(mk_sep, param) {
        if (!param) return 0;
        var x = param[1];
        if (!param[2]) return [
            0,
            x,
            0
        ];
        var xs = param[2], _cj_ = intersperse(mk_sep, xs);
        return [
            0,
            x,
            [
                0,
                caml_call1(mk_sep, 0),
                _cj_
            ]
        ];
    }
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block$2 = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _a3_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _a2_, _a1_), _a4_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 8),
                _a3_
            ],
            0
        ], _a7_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _a6_, _a5_), _a8_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 9),
                _a7_
            ],
            _a4_
        ], _a$_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _a__, _a9_), _ba_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 10),
                _a$_
            ],
            _a8_
        ], _bd_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bc_, _bb_), _be_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 11),
                _bd_
            ],
            _ba_
        ], _bg_ = caml_call1(Ppx_expect_runtime_Types[4][1], 13), _bh_ = caml_call1(Ppx_expect_runtime_Types[4][1], 12);
        caml_call14(Ppx_expect_test_block$2[3], cst_lib_Einops_ml$2, 357, _bk_, _bj_, _bi_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _bh_, _bg_, _bf_, 0, Inline_test_config, _be_, function(param) {
            function go(strs) {
                var _cg_ = intersperse(function(param) {
                    return cst_x;
                }, strs), _ch_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[25]
                ], Fmt[57]), _ci_ = caml_call1(Fmt[38], _ch_);
                return caml_call3(Fmt[4], _aX_, _ci_, _cg_);
            }
            go(0);
            var _cc_ = caml_call1(Ppx_expect_runtime_Types[4][1], 8);
            caml_call1(Ppx_expect_test_block$2[2], _cc_);
            go(_aY_);
            var _cd_ = caml_call1(Ppx_expect_runtime_Types[4][1], 9);
            caml_call1(Ppx_expect_test_block$2[2], _cd_);
            go(_aZ_);
            var _ce_ = caml_call1(Ppx_expect_runtime_Types[4][1], 10);
            caml_call1(Ppx_expect_test_block$2[2], _ce_);
            go(_a0_);
            var _cf_ = caml_call1(Ppx_expect_runtime_Types[4][1], 11);
            return caml_call1(Ppx_expect_test_block$2[2], _cf_);
        });
    }
    function extract_diagonals(tensor) {
        var seen = 0, param = tensor;
        for(;;){
            if (!param) return caml_call1(Stdlib_List[10], seen);
            var xs = param[2], x = param[1];
            if (caml_call2(Stdlib_List[37], x, seen)) param = xs;
            else {
                var seen$0 = [
                    0,
                    x,
                    seen
                ];
                seen = seen$0;
                param = xs;
            }
        }
    }
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block$1 = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _aH_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _aG_, _aF_), _aI_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 14),
                _aH_
            ],
            0
        ], _aL_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _aK_, _aJ_), _aM_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 15),
                _aL_
            ],
            _aI_
        ], _aP_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _aO_, _aN_), _aQ_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 16),
                _aP_
            ],
            _aM_
        ], _aS_ = caml_call1(Ppx_expect_runtime_Types[4][1], 18), _aT_ = caml_call1(Ppx_expect_runtime_Types[4][1], 17);
        caml_call14(Ppx_expect_test_block$1[3], cst_lib_Einops_ml$1, 387, _aW_, _aV_, _aU_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _aT_, _aS_, _aR_, 0, Inline_test_config, _aQ_, function(param) {
            function go(tensor) {
                var _ca_ = extract_diagonals(tensor), _cb_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], Fmt[57]);
                return caml_call1(caml_call2(Fmt[4], _aB_, _cb_), _ca_);
            }
            go(_aC_);
            var _b9_ = caml_call1(Ppx_expect_runtime_Types[4][1], 14);
            caml_call1(Ppx_expect_test_block$1[2], _b9_);
            go(_aD_);
            var _b__ = caml_call1(Ppx_expect_runtime_Types[4][1], 15);
            caml_call1(Ppx_expect_test_block$1[2], _b__);
            go(_aE_);
            var _b$_ = caml_call1(Ppx_expect_runtime_Types[4][1], 16);
            return caml_call1(Ppx_expect_test_block$1[2], _b$_);
        });
    }
    function make_common_shape(tensors, rhs) {
        var _b7_ = caml_call1(Stdlib_List[15], tensors), index_set = caml_call1(String_set[38], _b7_);
        function compare(x, y) {
            var match = caml_call2(indexof$0, x, rhs), match$0 = caml_call2(indexof$0, y, rhs);
            if (!match) return match$0 ? 1 : caml_call2(Stdlib_String[10], x, y);
            var a = match[1];
            if (!match$0) return -1;
            var b = match$0[1];
            return runtime.caml_int_compare(a, b);
        }
        var _b8_ = caml_call1(String_set[10], index_set);
        return caml_call2(Stdlib_List[59], compare, _b8_);
    }
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block$0 = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _ah_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _ag_, _af_), _ai_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 19),
                _ah_
            ],
            0
        ], _al_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _ak_, _aj_), _am_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 20),
                _al_
            ],
            _ai_
        ], _ap_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _ao_, _an_), _aq_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 21),
                _ap_
            ],
            _am_
        ], _at_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _as_, _ar_), _au_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 22),
                _at_
            ],
            _aq_
        ], _aw_ = caml_call1(Ppx_expect_runtime_Types[4][1], 24), _ax_ = caml_call1(Ppx_expect_runtime_Types[4][1], 23);
        caml_call14(Ppx_expect_test_block$0[3], cst_lib_Einops_ml$0, 409, _aA_, _az_, _ay_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _ax_, _aw_, _av_, 0, Inline_test_config, _au_, function(param) {
            function go(tensors, rhs) {
                var _b5_ = make_common_shape(tensors, rhs), _b6_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], Fmt[57]);
                return caml_call1(caml_call2(Fmt[4], _Y_, _b6_), _b5_);
            }
            go(___, _Z_);
            var _b1_ = caml_call1(Ppx_expect_runtime_Types[4][1], 19);
            caml_call1(Ppx_expect_test_block$0[2], _b1_);
            go(_aa_, _$_);
            var _b2_ = caml_call1(Ppx_expect_runtime_Types[4][1], 20);
            caml_call1(Ppx_expect_test_block$0[2], _b2_);
            go(_ac_, _ab_);
            var _b3_ = caml_call1(Ppx_expect_runtime_Types[4][1], 21);
            caml_call1(Ppx_expect_test_block$0[2], _b3_);
            go(_ae_, _ad_);
            var _b4_ = caml_call1(Ppx_expect_runtime_Types[4][1], 22);
            return caml_call1(Ppx_expect_test_block$0[2], _b4_);
        });
    }
    function make(param) {
        var rhs = param[2], lhs = param[1], diagonalized = caml_call2(Stdlib_List[20], extract_diagonals, lhs), broadcast = make_common_shape(diagonalized, rhs);
        return [
            0,
            diagonalized,
            broadcast
        ];
    }
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _M_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _L_, _K_), _N_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 25),
                _M_
            ],
            0
        ], _Q_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _P_, _O_), _R_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 26),
                _Q_
            ],
            _N_
        ], _T_1 = caml_call1(Ppx_expect_runtime_Types[4][1], 28), _U_ = caml_call1(Ppx_expect_runtime_Types[4][1], 27);
        caml_call14(Ppx_expect_test_block[3], cst_lib_Einops_ml, 428, _X_, _W_, _V_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _U_, _T_1, _S_, 0, Inline_test_config, _R_, function(param) {
            function go(lhs, rhs) {
                var match = make([
                    0,
                    lhs,
                    rhs
                ]), broadcast = match[2], diagonalized = match[1], _bX_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], Fmt[57]), _bY_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], Fmt[57]), _bZ_ = caml_call1(Fmt[38], _bY_), _b0_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], _bZ_);
                return caml_call5(Fmt[4], _F_, _b0_, diagonalized, _bX_, broadcast);
            }
            go(_H_, _G_);
            var _bV_ = caml_call1(Ppx_expect_runtime_Types[4][1], 25);
            caml_call1(Ppx_expect_test_block[2], _bV_);
            go(_J_, _I_);
            var _bW_ = caml_call1(Ppx_expect_runtime_Types[4][1], 26);
            return caml_call1(Ppx_expect_test_block[2], _bW_);
        });
    }
    var Steps = [
        0,
        make
    ];
    caml_call1(Ppx_inline_test_lib[7], cst_tensor_playground);
    caml_call1(Ppx_expect_runtime[1][2], 0);
    var Tensor_playground_Einops = [
        0,
        String_set,
        String_map,
        Colored,
        PP_var_impl,
        pp_var$0,
        Group,
        Bindings,
        Rewrite,
        Indexof_impl,
        indexof$0,
        Pyloops,
        Explain,
        intersperse,
        Steps
    ];
    runtime.caml_register_global(139, Tensor_playground_Einops, "Tensor_playground__Einops");
    return;
})(globalThis);
//# 1973 "../lib/.tensor_playground.objs/jsoo/default/tensor_playground.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "", cst_Arrow = "Arrow", cst_Comma = "Comma", cst_Eof = "Eof", cst_Expected_a_group_got = "Expected a group, got [", cst_Expected_a_group_got_a = "Expected a group, got [@[%a@]]", cst_tensor_playground = "tensor_playground", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Tensor_playground_Einops = global_data.Tensor_playground__Einops, Fmt = global_data.Fmt, Stdlib_List = global_data.Stdlib__List, Stdlib_String = global_data.Stdlib__String, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib = global_data.Stdlib, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Format = global_data.Stdlib__Format, Ppx_expect_runtime = global_data.Ppx_expect_runtime, Ppx_inline_test_lib = global_data.Ppx_inline_test_lib;
    caml_call1(Ppx_expect_runtime[1][1], "lib/Einsum_parser.ml");
    caml_call2(Ppx_inline_test_lib[6], cst_tensor_playground, "Einsum_parser.ml");
    var Error1 = [
        248,
        "Tensor_playground.Einsum_parser.Error",
        runtime.caml_fresh_oo_id(0)
    ], _a_ = [
        0,
        [
            11,
            cst_Arrow,
            0
        ],
        cst_Arrow
    ], _b_ = [
        0,
        [
            11,
            cst_Comma,
            0
        ],
        cst_Comma
    ], _c_ = [
        0,
        [
            11,
            cst_Eof,
            0
        ],
        cst_Eof
    ], _d_ = [
        0,
        [
            11,
            "Str ",
            [
                2,
                0,
                0
            ]
        ],
        "Str %s"
    ], _e_ = [
        0,
        [
            11,
            "At offset ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    ": unexpected character '",
                    [
                        0,
                        [
                            11,
                            "'.\n",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "At offset %d: unexpected character '%c'.\n"
    ], _f_ = [
        0,
        [
            11,
            "Expected an arrow, got [",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Expected an arrow, got [@[%a@]]"
    ], _g_ = [
        0,
        [
            11,
            cst_Expected_a_group_got,
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        cst_Expected_a_group_got_a
    ], _h_ = [
        0,
        [
            11,
            cst_Expected_a_group_got,
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        cst_Expected_a_group_got_a
    ], _i_ = [
        0,
        [
            11,
            "Expected a comma or arrow, got [",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Expected a comma or arrow, got [@[%a@]]"
    ], cst_Expected_more_tokens = "Expected more tokens", _j_ = [
        0,
        [
            11,
            "Expected a group or EOF, got [",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Expected a group or EOF, got [@[%a@]]"
    ], _k_ = [
        0,
        [
            11,
            "Expected an arrow or EOF, got [",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Expected an arrow or EOF, got [@[%a@]]"
    ];
    function pp(ppf, param) {
        if (typeof param === "number") switch(param){
            case 0:
                return caml_call2(Stdlib_Format[139], ppf, _a_);
            case 1:
                return caml_call2(Stdlib_Format[139], ppf, _b_);
            default:
                return caml_call2(Stdlib_Format[139], ppf, _c_);
        }
        var s = param[1];
        return caml_call3(Stdlib_Format[139], ppf, _d_, s);
    }
    function lex_unsafe(input) {
        var i = 0, acc = 0;
        for(;;){
            if (caml_ml_string_length(input) <= i) return caml_call1(Stdlib_List[10], [
                0,
                2,
                acc
            ]);
            var c = caml_string_get(input, i);
            a: {
                if (33 > c) {
                    if (9 !== c && 32 > c) break a;
                    var i$3 = i + 1 | 0;
                    i = i$3;
                    continue;
                }
                if (44 === c) {
                    var acc$0 = [
                        0,
                        1,
                        acc
                    ], i$0 = i + 1 | 0;
                    i = i$0;
                    acc = acc$0;
                    continue;
                }
                if (45 === c && (i + 1 | 0) < caml_ml_string_length(input) && 62 === caml_string_get(input, i + 1 | 0)) {
                    var acc$1 = [
                        0,
                        0,
                        acc
                    ], i$1 = i + 2 | 0;
                    i = i$1;
                    acc = acc$1;
                    continue;
                }
            }
            a: {
                if (97 <= c && 122 >= c) break a;
                if (65 <= c && 90 >= c) break a;
                if (48 <= c && 57 >= c) break a;
                if (95 !== c) {
                    var _C_ = caml_string_get(input, i);
                    throw caml_maybe_attach_backtrace([
                        0,
                        Error1,
                        caml_call3(Stdlib_Printf[4], _e_, i, _C_)
                    ], 1);
                }
            }
            a: b: {
                c: {
                    var end = i;
                    for(;;){
                        if (caml_ml_string_length(input) <= end) break b;
                        var match = caml_string_get(input, end);
                        if (91 <= match) {
                            if (97 <= match) {
                                if (123 <= match) break c;
                            } else if (95 !== match) break c;
                        } else if (58 <= match) {
                            if (65 > match) break;
                        } else if (48 > match) break c;
                        var i$2 = end + 1 | 0;
                        end = i$2;
                    }
                }
                break a;
            }
            var acc$2 = [
                0,
                [
                    0,
                    caml_call3(Stdlib_String[16], input, i, end - i | 0)
                ],
                acc
            ];
            i = end;
            acc = acc$2;
        }
    }
    function group_unsafe(toks) {
        if (toks) {
            var match = toks[1];
            if (typeof match !== "number") {
                var t = toks[2], s = match[1], match$0 = group_unsafe(t), t$0 = match$0[2], strs = match$0[1];
                return [
                    0,
                    [
                        0,
                        s,
                        strs
                    ],
                    t$0
                ];
            }
        }
        return [
            0,
            0,
            toks
        ];
    }
    function parse(str) {
        a: try {
            var tokens = lex_unsafe(str);
            b: {
                c: {
                    var current_group = 0, acc = 0, param = tokens;
                    for(;;){
                        if (!param) break;
                        var tok = param[1];
                        if (typeof tok === "number") {
                            if (1 !== tok) break c;
                            var ts = param[2], acc$0 = caml_call2(Stdlib[37], acc, [
                                0,
                                current_group,
                                0
                            ]);
                            current_group = 0;
                            acc = acc$0;
                            param = ts;
                        } else {
                            var ts$1 = param[2], s = tok[1], current_group$0 = caml_call2(Stdlib[37], current_group, [
                                0,
                                s,
                                0
                            ]);
                            current_group = current_group$0;
                            param = ts$1;
                        }
                    }
                    var match = [
                        0,
                        caml_call2(Stdlib[37], acc, [
                            0,
                            current_group,
                            0
                        ]),
                        0
                    ];
                    break b;
                }
                var ts$0 = param[2], match = [
                    0,
                    caml_call2(Stdlib[37], acc, [
                        0,
                        current_group,
                        0
                    ]),
                    [
                        0,
                        tok,
                        ts$0
                    ]
                ];
            }
            var rest = match[2], lhs = match[1];
            if (rest) {
                var _x_ = rest[1];
                if (typeof _x_ === "number" && !_x_) {
                    var t = rest[2], match$0 = group_unsafe(t), g = match$0[1], _z_ = match$0[2];
                    b: if (_z_) {
                        var _A_ = _z_[1];
                        if (typeof _A_ === "number" && 2 <= _A_ && !_z_[2]) break b;
                        var toks = match$0[2], _B_ = caml_call2(Fmt[64], [
                            0,
                            Fmt[25]
                        ], pp);
                        throw caml_maybe_attach_backtrace([
                            0,
                            Error1,
                            caml_call3(Fmt[6], _g_, _B_, toks)
                        ], 1);
                    }
                    var candidate = [
                        0,
                        lhs,
                        g
                    ], match$1 = caml_call1(Tensor_playground_Einops[8][7], candidate);
                    if (!match$1) break a;
                    var e = match$1[1];
                    throw caml_maybe_attach_backtrace([
                        0,
                        Error1,
                        e
                    ], 1);
                }
            }
            var _y_ = caml_call2(Fmt[64], [
                0,
                Fmt[25]
            ], pp);
            throw caml_maybe_attach_backtrace([
                0,
                Error1,
                caml_call3(Fmt[6], _f_, _y_, rest)
            ], 1);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Error1) throw caml_maybe_attach_backtrace(exn, 0);
            var e$0 = exn[2];
            return [
                1,
                e$0
            ];
        }
        return [
            0,
            candidate
        ];
    }
    function chars_to_strings(str) {
        var _u_ = caml_call1(Stdlib_String[40], str), _v_ = caml_call1(Stdlib_String[1], 1), _w_ = caml_call1(caml_call1(Stdlib_Seq[29], _v_), _u_);
        return caml_call1(Stdlib_List[65], _w_);
    }
    function parse$0(str) {
        a: try {
            var tokens = lex_unsafe(str);
            b: {
                c: {
                    var acc = 0, toks = tokens;
                    for(;;){
                        if (!toks) break;
                        var match = toks[1];
                        if (typeof match === "number") {
                            var _m_ = caml_call2(Fmt[64], 0, pp);
                            throw caml_maybe_attach_backtrace([
                                0,
                                Error1,
                                caml_call3(Fmt[6], _h_, _m_, toks)
                            ], 1);
                        }
                        var ts = toks[2], s = match[1], group = chars_to_strings(s);
                        if (!ts) throw caml_maybe_attach_backtrace([
                            0,
                            Error1,
                            cst_Expected_more_tokens
                        ], 1);
                        var tok = ts[1];
                        if (typeof tok !== "number") {
                            var _n_ = caml_call2(Fmt[64], 0, pp);
                            throw caml_maybe_attach_backtrace([
                                0,
                                Error1,
                                caml_call3(Fmt[6], _i_, _n_, ts)
                            ], 1);
                        }
                        if (1 !== tok) break c;
                        var toks$0 = ts[2], acc$0 = [
                            0,
                            group,
                            acc
                        ];
                        acc = acc$0;
                        toks = toks$0;
                    }
                    var match$0 = [
                        0,
                        caml_call1(Stdlib_List[10], acc),
                        0
                    ];
                    break b;
                }
                var ts$0 = ts[2], match$0 = [
                    0,
                    caml_call1(Stdlib_List[10], [
                        0,
                        group,
                        acc
                    ]),
                    [
                        0,
                        tok,
                        ts$0
                    ]
                ];
            }
            var rest = match$0[2], lhs = match$0[1];
            b: if (rest) {
                var _o_ = rest[1];
                if (typeof _o_ === "number") {
                    switch(_o_){
                        case 0:
                            var ts$1 = rest[2];
                            if (ts$1) {
                                var _p_ = ts$1[1];
                                if (typeof _p_ === "number") {
                                    if (2 <= _p_ && !ts$1[2]) {
                                        var candidate = [
                                            0,
                                            lhs,
                                            0
                                        ];
                                        break;
                                    }
                                } else {
                                    var _r_ = ts$1[2];
                                    if (_r_) {
                                        var _s_ = _r_[1];
                                        if (typeof _s_ === "number" && 2 <= _s_ && !_r_[2]) {
                                            var s$0 = _p_[1], candidate = [
                                                0,
                                                lhs,
                                                chars_to_strings(s$0)
                                            ];
                                            break;
                                        }
                                    }
                                }
                            }
                            var _q_ = caml_call2(Fmt[64], [
                                0,
                                Fmt[25]
                            ], pp);
                            throw caml_maybe_attach_backtrace([
                                0,
                                Error1,
                                caml_call3(Fmt[6], _j_, _q_, ts$1)
                            ], 1);
                        case 1:
                            break b;
                        default:
                            if (rest[2]) break b;
                            var candidate = [
                                0,
                                lhs,
                                0
                            ];
                    }
                    var match$1 = caml_call1(Tensor_playground_Einops[8][7], candidate);
                    if (!match$1) break a;
                    var e = match$1[1];
                    throw caml_maybe_attach_backtrace([
                        0,
                        Error1,
                        e
                    ], 1);
                }
            }
            var _t_ = caml_call2(Fmt[64], [
                0,
                Fmt[25]
            ], pp);
            throw caml_maybe_attach_backtrace([
                0,
                Error1,
                caml_call3(Fmt[6], _k_, _t_, rest)
            ], 1);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Error1) throw caml_maybe_attach_backtrace(exn, 0);
            var e$0 = exn[2];
            return [
                1,
                e$0
            ];
        }
        return [
            0,
            candidate
        ];
    }
    function parse$1(str) {
        var _l_ = parse$0(str);
        return [
            0,
            parse(str),
            _l_
        ];
    }
    caml_call1(Ppx_inline_test_lib[7], cst_tensor_playground);
    caml_call1(Ppx_expect_runtime[1][2], 0);
    var Tensor_playground_Einsum_parse = [
        0,
        [
            0,
            parse
        ],
        [
            0,
            parse$0
        ],
        parse$1
    ];
    runtime.caml_register_global(27, Tensor_playground_Einsum_parse, "Tensor_playground__Einsum_parser");
    return;
})(globalThis);
//# 1 ".tensor_playground_web.eobjs/jsoo/dune__exe.cmo.js"
// Generated by js_of_ocaml
//# 3 ".tensor_playground_web.eobjs/jsoo/dune__exe.cmo.js"
//# 5 ".tensor_playground_web.eobjs/jsoo/dune__exe.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Dune_exe = [
        0
    ];
    runtime.caml_register_global(0, Dune_exe, "Dune__exe");
    return;
})(globalThis);
//# 1 ".tensor_playground_web.eobjs/jsoo/dune__exe__Colors.cmo.js"
// Generated by js_of_ocaml
//# 3 ".tensor_playground_web.eobjs/jsoo/dune__exe__Colors.cmo.js"
//# 6 ".tensor_playground_web.eobjs/jsoo/dune__exe__Colors.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Stdlib_List = global_data.Stdlib__List, edge_attributes = [
        0,
        [
            0,
            "fill-indigo-800 dark:fill-rose-200",
            "text-indigo-800 dark:text-rose-200",
            "bg-indigo-800 dark:bg-rose-200",
            5.
        ],
        [
            0,
            "fill-pink-800 dark:fill-yellow-100",
            "text-pink-800 dark:text-yellow-100",
            "bg-pink-800 dark:bg-yellow-100",
            3.
        ],
        [
            0,
            "fill-fuchsia-800 dark:fill-emerald-200",
            "text-fuchsia-800 dark:text-emerald-200",
            "bg-fuchsia-800 dark:bg-emerald-200",
            7.
        ],
        [
            0,
            "fill-purple-900 dark:fill-cyan-200",
            "text-purple-900 dark:text-cyan-200",
            "bg-purple-900 dark:bg-cyan-200",
            9.
        ],
        [
            0,
            "fill-orange-800 dark:fill-stone-100",
            "text-orange-800 dark:text-stone-100",
            "bg-orange-800 dark:bg-stone-100",
            11.
        ],
        [
            0,
            "fill-red-700 dark:fill-pink-100",
            "text-red-700 dark:text-pink-100",
            "bg-red-700 dark:bg-pink-100",
            2.
        ],
        [
            0,
            "fill-teal-800 dark:fill-orange-200",
            "text-teal-800 dark:text-orange-200",
            "bg-teal-800 dark:bg-orange-200",
            2.
        ],
        [
            0,
            "fill-blue-900 dark:fill-blue-100",
            "text-blue-900 dark:text-blue-100",
            "bg-blue-900 dark:bg-blue-100",
            2.
        ],
        [
            0,
            "fill-cyan-800 dark:fill-slate-300",
            "text-cyan-800 dark:text-slate-300",
            "bg-cyan-800 dark:bg-slate-300",
            2.
        ],
        [
            0,
            "fill-emerald-800 dark:fill-lime-100",
            "text-emerald-800 dark:text-lime-100",
            "bg-emerald-800 dark:bg-lime-100",
            2.
        ]
    ].slice(), _a_ = [
        0,
        "fill-[#000] dark:fill-[#fff]",
        "text-[#000] dark:text-[#fff]",
        "bg-[#000] dark:bg-[#fff]",
        4.
    ];
    function get_edge_attributes(i) {
        return i < edge_attributes.length - 1 ? runtime.caml_check_bound(edge_attributes, i)[1 + i] : _a_;
    }
    function assign_edge_attributes(tensors) {
        var edge_attributes = caml_call2(Stdlib_Hashtbl[1], 0, 10), i = [
            0,
            0
        ];
        caml_call2(Stdlib_List[18], function(tensor) {
            return caml_call2(Stdlib_List[18], function(edge) {
                var _b_ = 1 - caml_call2(Stdlib_Hashtbl[9], edge_attributes, edge);
                if (!_b_) return _b_;
                var attrs = get_edge_attributes(i[1]);
                i[1] = i[1] + 1 | 0;
                return caml_call3(Stdlib_Hashtbl[5], edge_attributes, edge, attrs);
            }, tensor);
        }, tensors);
        return edge_attributes;
    }
    var Dune_exe_Colors = [
        0,
        edge_attributes,
        get_edge_attributes,
        assign_edge_attributes
    ];
    runtime.caml_register_global(4, Dune_exe_Colors, "Dune__exe__Colors");
    return;
})(globalThis);
//# 1 ".tensor_playground_web.eobjs/jsoo/dune__exe__Frontend_util.cmo.js"
// Generated by js_of_ocaml
//# 3 ".tensor_playground_web.eobjs/jsoo/dune__exe__Frontend_util.cmo.js"
//# 6 ".tensor_playground_web.eobjs/jsoo/dune__exe__Frontend_util.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_0_0_20_20$0 = "0 0 20 20", cst_aria_hidden$1 = "aria-hidden", cst_aria_labelledby$1 = "aria-labelledby", cst_block_truncate$1 = "block truncate", cst_button$1 = "button", cst_clip_rule$0 = "clip-rule", cst_currentColor$1 = "currentColor", cst_evenodd$1 = "evenodd", cst_fill_rule$0 = "fill-rule", cst_listbox$1 = "listbox", cst_listbox_label$1 = "listbox-label", cst_role$1 = "role", cst_true$2 = "true", caml_jsstring_of_string = runtime.caml_jsstring_of_string, caml_string_of_jsstring = runtime.caml_string_of_jsstring;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$1 = ", ", cst = "[", cst$0 = "]", Stdlib = global_data.Stdlib, Stdlib_List = global_data.Stdlib__List, Tensor_playground_Einops = global_data.Tensor_playground__Einops, Brr = global_data.Brr, Note = global_data.Note, Note_brr = global_data.Note_brr, Stdlib_String = global_data.Stdlib__String, Brr_svg = global_data.Brr_svg, Stdlib_Option = global_data.Stdlib__Option, Stdlib_Int = global_data.Stdlib__Int, Fmt = global_data.Fmt, Stdlib_Set = global_data.Stdlib__Set, Stdlib_Map = global_data.Stdlib__Map, String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]), String_map = caml_call1(Stdlib_Map[1], [
        0,
        Stdlib_String[10]
    ]), nav = Brr[9][125], h4 = Brr[9][101], h3 = Brr[9][100], h2 = Brr[9][99], h1 = Brr[9][98], li = Brr[9][118], ul = Brr[9][165], ol = Brr[9][128], p = Brr[9][132], tr = Brr[9][162], td = Brr[9][155], tbody = Brr[9][154], table = Brr[9][153], txt = Brr[9][3], span = Brr[9][147], div = Brr[9][88];
    function as_target(_aN_) {
        return _aN_;
    }
    var prop = Brr[9][28], input = Brr[9][112], set_children = Brr[9][18], code = Brr[9][79];
    function embed_svg(_aM_) {
        return _aM_;
    }
    function svg_at(name, value) {
        return caml_call3(Brr_svg[2][1], 0, caml_jsstring_of_string(name), caml_jsstring_of_string(value));
    }
    function at(name, value) {
        return caml_call2(Brr[8][1], caml_jsstring_of_string(name), caml_jsstring_of_string(value));
    }
    function txt_td(str) {
        return caml_call3(td, 0, 0, [
            0,
            caml_call2(txt, 0, str),
            0
        ]);
    }
    function class$0(str) {
        return caml_call1(Brr[8][19], caml_jsstring_of_string(str));
    }
    function classes(str) {
        var _aL_ = caml_call1(caml_call1(Stdlib_String[17], 32), str);
        return caml_call1(caml_call1(Stdlib_List[20], class$0), _aL_);
    }
    function svg_class(str) {
        return caml_call1(Brr_svg[2][23], caml_jsstring_of_string(str));
    }
    function svg_classes(str) {
        var _aK_ = caml_call1(caml_call1(Stdlib_String[17], 32), str);
        return caml_call1(caml_call1(Stdlib_List[20], svg_class), _aK_);
    }
    function type(str) {
        return caml_call1(Brr[8][48], caml_jsstring_of_string(str));
    }
    function d(str) {
        return caml_call1(Brr_svg[2][38], caml_jsstring_of_string(str));
    }
    function viewbox(str) {
        return caml_call1(Brr_svg[2][221], caml_jsstring_of_string(str));
    }
    function fill(str) {
        return caml_call1(Brr_svg[2][54], caml_jsstring_of_string(str));
    }
    function fmt_txt(fmt) {
        return caml_call2(Fmt[8], function(s) {
            return caml_call2(Brr[9][3], 0, s);
        }, fmt);
    }
    function bracketed_input(bracketed_s, elem) {
        var lbracket = caml_call3(Brr[9][147], 0, 0, 0), rbracket = caml_call3(Brr[9][147], 0, 0, 0);
        function f(str, param) {
            return param ? [
                0,
                caml_call2(Brr[9][3], 0, str),
                0
            ] : 0;
        }
        var _aG_ = caml_call3(Note[4][14], 0, function(_aJ_) {
            return f(cst, _aJ_);
        }, bracketed_s);
        caml_call2(Note_brr[4][2], lbracket, _aG_);
        var _aH_ = caml_call3(Note[4][14], 0, function(_aI_) {
            return f(cst$0, _aI_);
        }, bracketed_s);
        caml_call2(Note_brr[4][2], rbracket, _aH_);
        return caml_call3(Brr[9][147], 0, 0, [
            0,
            lbracket,
            [
                0,
                elem,
                [
                    0,
                    rbracket,
                    0
                ]
            ]
        ]);
    }
    function render_vec(direction, items) {
        if (direction) return caml_call3(tbody, 0, 0, caml_call1(caml_call1(Stdlib_List[20], function(i) {
            return caml_call3(tr, 0, 0, [
                0,
                txt_td(caml_call1(Stdlib_Int[12], i)),
                0
            ]);
        }), items));
        var _aF_ = caml_call1(caml_call1(Stdlib_List[20], Stdlib_Int[12]), items);
        return caml_call3(tbody, 0, 0, [
            0,
            caml_call3(tr, 0, 0, caml_call1(caml_call1(Stdlib_List[20], txt_td), _aF_)),
            0
        ]);
    }
    function render_mat(items) {
        var _aD_ = caml_call1(caml_call1(Stdlib_List[20], function(items) {
            var _aE_ = caml_call1(caml_call1(Stdlib_List[20], Stdlib_Int[12]), items);
            return caml_call1(caml_call1(Stdlib_List[20], txt_td), _aE_);
        }), items);
        return caml_call3(tbody, 0, 0, caml_call1(caml_call1(Stdlib_List[20], function(eta) {
            return caml_call3(tr, 0, 0, eta);
        }), _aD_));
    }
    function input$0(opt, start_value, external_update_input) {
        var at = opt ? opt[1] : 0, at$0 = [
            0,
            caml_call1(Brr[8][49], caml_jsstring_of_string(start_value)),
            at
        ], input_elem = caml_call3(input, 0, [
            0,
            at$0
        ], 0), match = caml_call2(Note[4][3], 0, start_value), set_input = match[2], input_signal = match[1];
        caml_call6(Note_brr[3][9], 0, 0, 0, input_elem, Brr[7][44], function(evt) {
            return caml_call2(set_input, 0, caml_string_of_jsstring(caml_call2(prop, Brr[9][27][10], input_elem)));
        });
        var _aC_ = caml_call2(Note[3][9], caml_jsstring_of_string, external_update_input);
        caml_call3(Note_brr[4][5], Brr[9][27][10], _aC_, input_elem);
        return [
            0,
            caml_call3(Note[3][2], 0, external_update_input, function(eta) {
                return caml_call2(set_input, 0, eta);
            }),
            input_elem,
            input_signal
        ];
    }
    var input_classes = classes("rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"), cst_text_red_600 = "text-red-600", _a_ = [
        0,
        0
    ];
    function parsed_input(parse, start_value) {
        var _aA_ = [
            0,
            caml_call1(Brr[8][49], caml_jsstring_of_string(start_value)),
            0
        ], input_elem = caml_call3(input, 0, [
            0,
            caml_call2(Stdlib[37], _aA_, input_classes)
        ], 0), parse_error_elem = caml_call3(div, 0, [
            0,
            classes(cst_text_red_600)
        ], 0), match = caml_call2(Note[4][3], 0, start_value), set_input = match[2], input_signal = match[1], match$0 = caml_call2(Note[4][3], 0, 0), set_parse_error = match$0[2], parse_error_signal = match$0[1], match$1 = caml_call2(Note[4][3], 0, 0), set_parsed = match$1[2], parsed_signal = match$1[1];
        caml_call6(Note_brr[3][9], 0, 0, 0, input_elem, Brr[7][44], function(evt) {
            return caml_call2(set_input, 0, caml_string_of_jsstring(caml_call2(prop, Brr[9][27][10], input_elem)));
        });
        var output_logger = caml_call3(Note[4][2], 0, input_signal, function(str) {
            var match = caml_call1(parse, str);
            if (0 === match[0]) {
                var t = match[1];
                caml_call2(set_parsed, 0, [
                    0,
                    t
                ]);
                return caml_call2(set_parse_error, 0, 0);
            }
            var match$0 = match[1], msg2 = match$0[2], msg1 = match$0[1];
            caml_call2(set_parsed, 0, 0);
            var _aB_ = [
                0,
                caml_call2(txt, 0, msg2),
                0
            ];
            return caml_call2(set_parse_error, 0, [
                0,
                caml_call2(txt, 0, msg1),
                _aB_
            ]);
        });
        caml_call1(Note[2][7], output_logger);
        caml_call2(Note_brr[4][2], parse_error_elem, parse_error_signal);
        return [
            0,
            parsed_signal,
            input_elem,
            parse_error_elem
        ];
    }
    function bracketed_parsed_input(parse, start_value) {
        var match = caml_call2(Note[4][3], 0, 1), set_bracket = match[2], bracket_signal = match[1], match$0 = parsed_input(parse, start_value), err_elem = match$0[3], input_elem = match$0[2], out_signal = match$0[1], _az_ = caml_call1(Stdlib_Option[7], function(param) {
            var bracketed = param[2], t = param[1];
            caml_call2(set_bracket, 0, bracketed);
            return t;
        }), out_signal$0 = caml_call3(Note[4][14], 0, _az_, out_signal), bracketed_input_elem = bracketed_input(bracket_signal, input_elem);
        return [
            0,
            out_signal$0,
            bracketed_input_elem,
            err_elem
        ];
    }
    function result_list(results) {
        function loop(results) {
            if (!results) return _a_;
            var match = results[1];
            if (0 !== match[0]) {
                var e$0 = match[1];
                return [
                    1,
                    e$0
                ];
            }
            var results$0 = results[2], x = match[1], match$0 = loop(results$0);
            if (0 === match$0[0]) {
                var xs = match$0[1];
                return [
                    0,
                    [
                        0,
                        x,
                        xs
                    ]
                ];
            }
            var e = match$0[1];
            return [
                1,
                e
            ];
        }
        return loop(results);
    }
    var _b_ = [
        0,
        svg_at(cst_clip_rule$0, cst_evenodd$1),
        0
    ], _c_ = [
        0,
        svg_at(cst_fill_rule$0, cst_evenodd$1),
        _b_
    ], _d_ = [
        0,
        d("M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"),
        0
    ], _e_ = [
        0,
        caml_call2(Stdlib[37], _d_, _c_)
    ], _f_ = [
        0,
        caml_call3(Brr_svg[3][64], 0, _e_, 0),
        0
    ], _g_ = [
        0,
        fill(cst_currentColor$1),
        0
    ], _h_ = [
        0,
        viewbox(cst_0_0_20_20$0),
        _g_
    ], _i_ = [
        0,
        svg_at(cst_aria_hidden$1, cst_true$2),
        0
    ], _j_ = caml_call2(Stdlib[37], _i_, _h_), _k_ = svg_classes("h-5 w-5 text-gray-400"), _l_ = [
        0,
        caml_call2(Stdlib[37], _k_, _j_)
    ], chevrons_svg = caml_call3(Brr_svg[3][74], 0, _l_, _f_), cst_evenodd = cst_evenodd$1, cst_clip_rule = cst_clip_rule$0, cst_evenodd$0 = cst_evenodd$1, cst_fill_rule = cst_fill_rule$0, cst_M16_704_4_153a_75_75_0_01_ = "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z", cst_currentColor = cst_currentColor$1, cst_0_0_20_20 = cst_0_0_20_20$0, cst_true = cst_true$2, cst_aria_hidden = cst_aria_hidden$1, cst_h_5_w_5 = "h-5 w-5", cst_M_12_2_C_6_4889971_2_2_6_4 = "M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z", cst_currentColor$0 = cst_currentColor$1, cst_0_0_24_24 = "0 0 24 24", cst_true$0 = cst_true$2, cst_aria_hidden$0 = cst_aria_hidden$1, cst_h_4_w_4 = "h-4 w-4", cst_inline_flex = "inline-flex", cst_button = cst_button$1, cst_inline_align_middle_relati = "inline align-middle relative not-prose", cst_w_screen_max_w_md_flex_aut = "w-screen max-w-md flex-auto overflow-hidden rounded-md bg-white dark:bg-slate-800 text-sm/6 shadow-lg ring-1 ring-gray-900/5 p-3", cst_absolute_z_10_flex_w_scree = "absolute z-10 flex w-screen max-w-max px-4", cst_block_truncate = cst_block_truncate$1, cst_pointer_events_none_absolu = "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2", cst_relative_w_full_cursor_def = "relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 inline-flex", cst_listbox_label = cst_listbox_label$1, cst_aria_labelledby = cst_aria_labelledby$1, cst_true$1 = cst_true$2, cst_aria_expanded = "aria-expanded", cst_listbox = cst_listbox$1, cst_aria_haspopup = "aria-haspopup", cst_button$0 = cst_button$1, cst_text_indigo_600_absolute_i = "text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4", cst_option = "option", cst_role = cst_role$1, cst_text_gray_900_relative_cur = "text-gray-900 relative cursor-default select-none py-2 pl-3 pr-9", cst_block_truncate$0 = cst_block_truncate$1, cst_listbox_label$0 = cst_listbox_label$1, cst_aria_labelledby$0 = cst_aria_labelledby$1, cst_listbox$0 = cst_listbox$1, cst_role$0 = cst_role$1, cst_absolute_z_10_mt_1_max_h_6 = "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", cst_not_prose = "not-prose";
    function info(child) {
        var match = caml_call2(Note[4][3], 0, 0), set_dropdown_open = match[2], dropdown_open_signal = match[1], _ap_ = caml_call1(Brr[10][5], Brr[16][2]), click_outside_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(param) {
            return 0;
        }, _ap_), click_child_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(evt) {
            return caml_call1(Brr[7][10], evt);
        }, child), _ah_ = [
            0,
            [
                0,
                d(cst_M_12_2_C_6_4889971_2_2_6_4),
                0
            ]
        ], _ai_ = [
            0,
            caml_call3(Brr_svg[3][64], 0, _ah_, 0),
            0
        ], _aj_ = [
            0,
            fill(cst_currentColor$0),
            0
        ], _ak_ = [
            0,
            viewbox(cst_0_0_24_24),
            _aj_
        ], _al_ = [
            0,
            svg_at(cst_aria_hidden$0, cst_true$0),
            0
        ], _am_ = caml_call2(Stdlib[37], _al_, _ak_), _an_ = svg_classes(cst_h_4_w_4), _ao_ = [
            0,
            caml_call2(Stdlib[37], _an_, _am_)
        ], _aq_ = [
            0,
            caml_call3(Brr_svg[3][74], 0, _ao_, _ai_),
            0
        ], _ar_ = [
            0,
            caml_call3(span, 0, [
                0,
                classes(cst_inline_flex)
            ], _aq_),
            0
        ], _as_ = [
            0,
            [
                0,
                type(cst_button),
                0
            ]
        ], button = caml_call3(Brr[9][75], 0, _as_, _ar_), click_button_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(evt) {
            caml_call1(Brr[7][10], evt);
            return 0;
        }, button), _at_ = caml_call3(Note[3][2], 0, click_button_event, function(param) {
            return caml_call2(set_dropdown_open, 0, 1 - caml_call1(Note[4][6], dropdown_open_signal));
        });
        caml_call1(Note[2][8], _at_);
        var _au_ = caml_call3(Note[3][2], 0, click_outside_event, function(param) {
            return caml_call2(set_dropdown_open, 0, 0);
        });
        caml_call1(Note[2][8], _au_);
        var _av_ = caml_call3(Note[3][2], 0, click_child_event, function(param) {
            return 0;
        });
        caml_call1(Note[2][8], _av_);
        var _aw_ = [
            0,
            classes(cst_inline_align_middle_relati)
        ], result_elem = caml_call3(Brr[9][88], 0, _aw_, 0), _ax_ = caml_call1(caml_call2(Note[4][14], 0, function(open) {
            if (!open) return [
                0,
                button,
                0
            ];
            var _ay_ = [
                0,
                caml_call3(div, 0, [
                    0,
                    classes(cst_w_screen_max_w_md_flex_aut)
                ], [
                    0,
                    child,
                    0
                ]),
                0
            ];
            return [
                0,
                button,
                [
                    0,
                    caml_call3(div, 0, [
                        0,
                        classes(cst_absolute_z_10_flex_w_scree)
                    ], _ay_),
                    0
                ]
            ];
        }), dropdown_open_signal);
        caml_call2(Note_brr[4][2], result_elem, _ax_);
        return result_elem;
    }
    function select(clicked_op_e, items) {
        var match = caml_call2(Note[4][3], 0, 0), set_selected = match[2], selected_signal = match[1], logr = caml_call3(Note[3][2], 0, clicked_op_e, function(clicked_op) {
            var stripped_list = caml_call2(Stdlib_List[20], function(s) {
                var match = caml_call2(Stdlib_String[17], 58, s);
                if (match) {
                    var _ag_ = match[2];
                    if (_ag_ && !_ag_[2]) {
                        var einsum = _ag_[1];
                        return caml_call1(Stdlib_String[24], einsum);
                    }
                }
                return s;
            }, items), match = caml_call2(Stdlib_List[41], function(s) {
                return s == clicked_op ? 1 : 0;
            }, stripped_list);
            if (match) var i = match[1], i$0 = i;
            else var i$0 = 0;
            return caml_call2(set_selected, 0, i$0);
        });
        caml_call1(Note[2][8], logr);
        var selected_item = caml_call1(caml_call2(Note[4][14], 0, function(i) {
            return caml_call2(Stdlib_List[8], items, i);
        }), selected_signal), match$0 = caml_call2(Note[4][3], 0, 0), set_dropdown_open = match$0[2], dropdown_open_signal = match$0[1], selected_span = caml_call3(span, 0, [
            0,
            classes(cst_block_truncate)
        ], 0), _I_ = caml_call1(caml_call2(Note[4][14], 0, function(i) {
            return [
                0,
                caml_call2(txt, 0, i),
                0
            ];
        }), selected_item);
        caml_call2(Note_brr[4][2], selected_span, _I_);
        var _J_ = [
            0,
            classes(cst_pointer_events_none_absolu)
        ], _K_ = [
            0,
            caml_call3(Brr[9][147], 0, _J_, [
                0,
                chevrons_svg,
                0
            ]),
            [
                0,
                selected_span,
                0
            ]
        ], _L_ = classes(cst_relative_w_full_cursor_def), _M_ = [
            0,
            at(cst_aria_labelledby, cst_listbox_label),
            0
        ], _N_ = [
            0,
            at(cst_aria_expanded, cst_true$1),
            _M_
        ], _O_ = [
            0,
            at(cst_aria_haspopup, cst_listbox),
            _N_
        ], _P_ = [
            0,
            type(cst_button$0),
            _O_
        ], _Q_ = [
            0,
            caml_call2(Stdlib[37], _P_, _L_)
        ], button = caml_call3(Brr[9][75], 0, _Q_, _K_), click_button_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(evt) {
            caml_call1(Brr[7][10], evt);
            return 0;
        }, button), _x_ = [
            0,
            svg_at(cst_clip_rule, cst_evenodd),
            0
        ], _y_ = [
            0,
            svg_at(cst_fill_rule, cst_evenodd$0),
            _x_
        ], _z_ = [
            0,
            d(cst_M16_704_4_153a_75_75_0_01_),
            0
        ], _A_ = [
            0,
            caml_call2(Stdlib[37], _z_, _y_)
        ], _B_ = [
            0,
            caml_call3(Brr_svg[3][64], 0, _A_, 0),
            0
        ], _C_ = [
            0,
            fill(cst_currentColor),
            0
        ], _D_ = [
            0,
            viewbox(cst_0_0_20_20),
            _C_
        ], _E_ = [
            0,
            svg_at(cst_aria_hidden, cst_true),
            0
        ], _F_ = caml_call2(Stdlib[37], _E_, _D_), _G_ = svg_classes(cst_h_5_w_5), _H_ = [
            0,
            caml_call2(Stdlib[37], _G_, _F_)
        ], _R_ = [
            0,
            caml_call3(Brr_svg[3][74], 0, _H_, _B_),
            0
        ], checkmark = caml_call3(span, 0, [
            0,
            classes(cst_text_indigo_600_absolute_i)
        ], _R_);
        function item(i, name) {
            var _ac_ = [
                0,
                at(cst_role, cst_option),
                0
            ], _ad_ = classes(cst_text_gray_900_relative_cur), elem = caml_call3(li, 0, [
                0,
                caml_call2(Stdlib[37], _ad_, _ac_)
            ], 0), _ae_ = [
                0,
                caml_call2(txt, 0, name),
                0
            ], text_child = caml_call3(span, 0, [
                0,
                classes(cst_block_truncate$0)
            ], _ae_), is_selected_s = caml_call1(caml_call2(Note[4][14], 0, function(i$0) {
                return i === i$0 ? 1 : 0;
            }), selected_signal), evt = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(param) {
                return i;
            }, elem);
            caml_call3(Note_brr[4][8], "font-normal", is_selected_s, elem);
            caml_call3(Note_brr[4][8], "font-semibold", is_selected_s, elem);
            var _af_ = caml_call1(caml_call2(Note[4][14], 0, function(is_selected) {
                return is_selected ? [
                    0,
                    text_child,
                    [
                        0,
                        checkmark,
                        0
                    ]
                ] : [
                    0,
                    text_child,
                    0
                ];
            }), is_selected_s);
            caml_call2(Note_brr[4][2], elem, _af_);
            return [
                0,
                evt,
                elem
            ];
        }
        var _S_ = caml_call2(Stdlib_List[21], item, items), match$1 = caml_call1(Stdlib_List[57], _S_), list_elems = match$1[2], list_evts = match$1[1], _T_1 = caml_call1(Brr[10][5], Brr[16][2]), click_outside_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(param) {
            return 0;
        }, _T_1), _U_ = caml_call3(Note[3][2], 0, click_button_event, function(param) {
            return caml_call2(set_dropdown_open, 0, 1 - caml_call1(Note[4][6], dropdown_open_signal));
        });
        caml_call1(Note[2][8], _U_);
        var _V_ = caml_call3(Note[3][2], 0, click_outside_event, function(param) {
            return caml_call2(set_dropdown_open, 0, 0);
        });
        caml_call1(Note[2][8], _V_);
        var _W_ = caml_call1(Note[3][13], list_evts), _X_ = caml_call3(Note[3][2], 0, _W_, function(eta) {
            return caml_call2(set_selected, 0, eta);
        });
        caml_call1(Note[2][8], _X_);
        var _Y_ = [
            0,
            at(cst_aria_labelledby$0, cst_listbox_label$0),
            0
        ], _Z_ = [
            0,
            at(cst_role$0, cst_listbox$0),
            _Y_
        ], ___ = [
            0,
            caml_call1(Brr[8][46], -1),
            _Z_
        ], _$_ = classes(cst_absolute_z_10_mt_1_max_h_6), list = caml_call3(ul, 0, [
            0,
            caml_call2(Stdlib[37], _$_, ___)
        ], list_elems), _aa_ = [
            0,
            classes(cst_not_prose)
        ], result_elem = caml_call3(Brr[9][88], 0, _aa_, 0), _ab_ = caml_call1(caml_call2(Note[4][14], 0, function(open) {
            return open ? [
                0,
                button,
                [
                    0,
                    list,
                    0
                ]
            ] : [
                0,
                button,
                0
            ];
        }), dropdown_open_signal);
        caml_call2(Note_brr[4][2], result_elem, _ab_);
        return [
            0,
            result_elem,
            selected_item
        ];
    }
    var Select_and_info = [
        0,
        select,
        info
    ], cst_underline = "underline", cst_unsnoc_empty_list = "unsnoc empty list", cst_and = ", and ", cst_and$0 = " and ", cst_in_his_case_there_are_none = "in his case there are none";
    function select$0(clicked_op_e, items) {
        return caml_call2(Select_and_info[1], clicked_op_e, items);
    }
    function info$0(child) {
        return caml_call1(Select_and_info[2], child);
    }
    function a(link, text) {
        var _u_ = [
            0,
            caml_call2(txt, 0, text),
            0
        ], _v_ = [
            0,
            class$0(cst_underline),
            0
        ], _w_ = [
            0,
            [
                0,
                caml_call1(Brr[8][31], caml_jsstring_of_string(link)),
                _v_
            ]
        ];
        return caml_call3(Brr[9][61], 0, _w_, _u_);
    }
    function unsnoc(param) {
        if (!param) return caml_call1(Stdlib[2], cst_unsnoc_empty_list);
        var x = param[1];
        if (!param[2]) return [
            0,
            0,
            x
        ];
        var xs = param[2], match = unsnoc(xs), last = match[2], init = match[1];
        return [
            0,
            [
                0,
                x,
                init
            ],
            last
        ];
    }
    function list_variables(get_classes, vars) {
        function mk_code(x) {
            var _t_ = [
                0,
                caml_call2(txt, 0, x),
                0
            ];
            return caml_call3(code, 0, [
                0,
                classes(caml_call1(get_classes, x))
            ], _t_);
        }
        if (!vars) return [
            0,
            caml_call2(txt, 0, cst_in_his_case_there_are_none),
            0
        ];
        var _m_ = vars[2], x = vars[1];
        if (!_m_) return [
            0,
            mk_code(x),
            0
        ];
        if (_m_[2]) {
            var match = unsnoc(vars), last = match[2], init = match[1], _n_ = [
                0,
                mk_code(last),
                0
            ], _o_ = [
                0,
                caml_call2(txt, 0, cst_and),
                _n_
            ], _p_ = caml_call2(Stdlib_List[20], mk_code, init), _q_ = caml_call2(Tensor_playground_Einops[13], function(param) {
                return caml_call2(txt, 0, cst$1);
            }, _p_);
            return caml_call2(Stdlib[37], _q_, _o_);
        }
        var y = _m_[1], _r_ = [
            0,
            mk_code(y),
            0
        ], _s_ = [
            0,
            caml_call2(txt, 0, cst_and$0),
            _r_
        ];
        return [
            0,
            mk_code(x),
            _s_
        ];
    }
    var Dune_exe_Frontend_util = [
        0,
        String_set,
        String_map,
        code,
        set_children,
        input,
        prop,
        as_target,
        div,
        span,
        txt,
        table,
        tbody,
        td,
        tr,
        p,
        ol,
        ul,
        li,
        h1,
        h2,
        h3,
        h4,
        nav,
        embed_svg,
        svg_at,
        at,
        txt_td,
        class$0,
        classes,
        svg_class,
        svg_classes,
        type,
        d,
        viewbox,
        fill,
        fmt_txt,
        bracketed_input,
        render_vec,
        render_mat,
        input$0,
        input_classes,
        parsed_input,
        bracketed_parsed_input,
        result_list,
        Select_and_info,
        select$0,
        info$0,
        a,
        unsnoc,
        list_variables
    ];
    runtime.caml_register_global(78, Dune_exe_Frontend_util, "Dune__exe__Frontend_util");
    return;
})(globalThis);
//# 1 ".tensor_playground_web.eobjs/jsoo/dune__exe__Isometric.cmo.js"
// Generated by js_of_ocaml
//# 3 ".tensor_playground_web.eobjs/jsoo/dune__exe__Isometric.cmo.js"
//# 6 ".tensor_playground_web.eobjs/jsoo/dune__exe__Isometric.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "", cst_L = " L", cst$0 = ", [", cst_M_f_f_f_L_f_f_f = "M%f %f %f L%f %f %f", cst_className$1 = "className", cst_fill_slate_500$0 = "fill-slate-500", cst_flex_flex_row$4 = "flex flex-row", cst_height$1 = "height", cst_left$2 = "left", cst_planeView$1 = "planeView", cst_right$2 = "right", cst_top$2 = "top", cst_width$1 = "width", caml_jsstring_of_string = runtime.caml_jsstring_of_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    var undef = undefined, global_data = runtime.caml_get_global_data(), background_color = [
        0,
        "rgba(0, 0, 0, 0)"
    ], partial = [
        17,
        0,
        [
            17,
            4,
            0
        ]
    ], partial$0 = [
        12,
        32,
        [
            8,
            [
                0,
                0,
                0
            ],
            0,
            0,
            0
        ]
    ], partial$1 = [
        0,
        0,
        0
    ], partial$2 = [
        12,
        32,
        [
            8,
            [
                0,
                0,
                0
            ],
            0,
            0,
            0
        ]
    ], partial$3 = [
        0,
        0,
        0
    ], side_name = cst_top$2, fill_class_name = cst_fill_slate_500$0, zero = [
        254,
        0.,
        0.,
        0.
    ], Fmt = global_data.Fmt, Stdlib_List = global_data.Stdlib__List, Tensor_playground_Einops = global_data.Tensor_playground__Einops, Stdlib_String = global_data.Stdlib__String, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Stdlib_Queue = global_data.Stdlib__Queue, Brr = global_data.Brr, Assert_failure = global_data.Assert_failure, Dune_exe_Frontend_util = global_data.Dune__exe__Frontend_util, Stdlib = global_data.Stdlib, Stdlib_Array = global_data.Stdlib__Array, Jv = global_data.Jv, Stdlib_Option = global_data.Stdlib__Option, Stdlib_Set = global_data.Stdlib__Set, String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]), default_height = 160, default_width = 200;
    function isometric(param) {
        return Jv[12]["isometric"];
    }
    var classes = Dune_exe_Frontend_util[29];
    function array_max(arr) {
        return caml_call3(Stdlib_Array[18], Stdlib[17], Stdlib[26], arr);
    }
    function get_class_name(edge_attributes, label) {
        var fill_classes = caml_call2(Stdlib_Hashtbl[6], edge_attributes, label)[1];
        return fill_classes;
    }
    var EdgeAnimation = [
        0
    ], top = "TOP", front = "FRONT", side = "SIDE", _a_ = [
        0,
        caml_call5(Fmt[42], 0, 0, cst_right$2, function(t) {
            return t[5];
        }, Fmt[53]),
        0
    ], _b_ = [
        0,
        caml_call5(Fmt[42], 0, 0, cst_left$2, function(t) {
            return t[4];
        }, Fmt[53]),
        _a_
    ], _c_ = [
        0,
        caml_call5(Fmt[42], 0, 0, cst_top$2, function(t) {
            return t[3];
        }, Fmt[53]),
        _b_
    ], _d_ = [
        0,
        caml_call5(Fmt[42], 0, 0, cst_height$1, function(t) {
            return t[2];
        }, Fmt[53]),
        _c_
    ], _e_ = [
        0,
        caml_call5(Fmt[42], 0, 0, cst_width$1, function(t) {
            return t[1];
        }, Fmt[53]),
        _d_
    ], _f_ = caml_call2(Fmt[43], [
        0,
        Fmt[26]
    ], _e_), pp = caml_call1(Fmt[39], _f_), cst_top = cst_top$2, cst_left = cst_left$2, cst_right = cst_right$2, cst_planeView = cst_planeView$1, cst_className = cst_className$1, cst_width = cst_width$1, cst_height = cst_height$1, _g_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst
                ]
            ],
            [
                11,
                "animate_dimensions: [",
                [
                    18,
                    [
                        1,
                        [
                            0,
                            0,
                            cst
                        ]
                    ],
                    [
                        15,
                        [
                            17,
                            0,
                            [
                                12,
                                93,
                                [
                                    17,
                                    0,
                                    [
                                        17,
                                        4,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[animate_dimensions: [@[%a@]]@]@."
    ], _h_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst
                ]
            ],
            [
                11,
                "Rectangle.create [",
                [
                    15,
                    [
                        12,
                        93,
                        [
                            17,
                            0,
                            [
                                17,
                                4,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[Rectangle.create [%a]@]@."
    ], _i_ = [
        0,
        [
            12,
            77,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    12,
                    32,
                    [
                        8,
                        [
                            0,
                            0,
                            0
                        ],
                        0,
                        0,
                        [
                            12,
                            32,
                            [
                                8,
                                [
                                    0,
                                    0,
                                    0
                                ],
                                0,
                                0,
                                [
                                    11,
                                    cst_L,
                                    [
                                        8,
                                        [
                                            0,
                                            0,
                                            0
                                        ],
                                        0,
                                        0,
                                        [
                                            12,
                                            32,
                                            [
                                                8,
                                                partial$1,
                                                0,
                                                0,
                                                partial$0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_M_f_f_f_L_f_f_f
    ], _j_ = [
        0,
        [
            12,
            77,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    12,
                    32,
                    [
                        8,
                        [
                            0,
                            0,
                            0
                        ],
                        0,
                        0,
                        [
                            12,
                            32,
                            [
                                8,
                                [
                                    0,
                                    0,
                                    0
                                ],
                                0,
                                0,
                                [
                                    11,
                                    cst_L,
                                    [
                                        8,
                                        [
                                            0,
                                            0,
                                            0
                                        ],
                                        0,
                                        0,
                                        [
                                            12,
                                            32,
                                            [
                                                8,
                                                partial$3,
                                                0,
                                                0,
                                                partial$2
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_M_f_f_f_L_f_f_f
    ], cst_path = "path", cst_red = "red", cst_fontSize = "fontSize", cst_fontWeight = "fontWeight", cst_className$0 = cst_className$1, cst_strokeWidth = "strokeWidth", cst_top$0 = cst_top$2, cst_left$0 = cst_left$2, cst_right$0 = cst_right$2, cst_planeView$0 = cst_planeView$1, cst_text = "text", cst_fill_slate_500 = cst_fill_slate_500$0, cst_top$1 = cst_top$2, cst_left$1 = cst_left$2, cst_right$1 = cst_right$2, cst_container = "container", cst_backgroundColor = "backgroundColor", cst_scale = "scale", cst_height$0 = cst_height$1, cst_width$0 = cst_width$1, _k_ = [
        0,
        0.
    ], _l_ = [
        0,
        0.
    ], _m_ = [
        0,
        0.
    ], _n_ = [
        0,
        [
            11,
            "Invalid tensor: [",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            [
                                17,
                                4,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "Invalid tensor: [@[%a@]]@."
    ], _o_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst
                ]
            ],
            [
                11,
                "Tensor.create rectangle (",
                [
                    2,
                    0,
                    [
                        11,
                        cst$0,
                        [
                            15,
                            [
                                11,
                                "]) (",
                                [
                                    2,
                                    0,
                                    [
                                        11,
                                        cst$0,
                                        [
                                            15,
                                            [
                                                11,
                                                "])",
                                                partial
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[Tensor.create rectangle (%s, [%a]) (%s, [%a])@]@."
    ], _p_ = [
        0,
        -1.4
    ], cst_scalar = "(scalar)", cst_Start = "Start", cst_flex_flex_row = cst_flex_flex_row$4, cst_Diagonalize = "Diagonalize", cst_flex_flex_row$0 = cst_flex_flex_row$4, _q_ = [
        0,
        0,
        0
    ], cst_Reorder_and_Broadcast = "Reorder and Broadcast", cst_flex_flex_row$1 = cst_flex_flex_row$4, cst_Pointwise_Multiply = "Pointwise Multiply", cst_Contract = "Contract ", cst_flex_flex_col = "flex flex-col", cst_Reorder = "Reorder", cst_Broadcast = "Broadcast", _r_ = [
        0,
        "frontend/Isometric.ml",
        657,
        28
    ], cst_flex_flex_row$2 = cst_flex_flex_row$4, cst_flex_flex_row$3 = cst_flex_flex_row$4, _s_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst
                ]
            ],
            [
                11,
                "render: ",
                [
                    15,
                    [
                        17,
                        0,
                        [
                            17,
                            4,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "@[render: %a@]@."
    ];
    function to_jv(param) {
        var right = param[5], left = param[4], top = param[3], height = param[2], width = param[1];
        return {
            width: width,
            height: height,
            top: top,
            left: left,
            right: right
        };
    }
    function opts(top, left, right, plane_view, class_name, width, height, param) {
        var o = {};
        caml_call3(Jv[21][4], o, cst_top, top);
        caml_call3(Jv[21][4], o, cst_left, left);
        caml_call3(Jv[21][4], o, cst_right, right);
        caml_call3(Jv[23][4], o, cst_planeView, plane_view);
        var _aJ_ = caml_call2(Stdlib_Option[7], Jv[24], class_name);
        caml_call3(Jv[16], o, cst_className, _aJ_);
        caml_call3(Jv[21][3], o, cst_width, width);
        caml_call3(Jv[21][3], o, cst_height, height);
        return o;
    }
    function create(opts, values, param) {
        var _aH_ = caml_call2(Fmt[65], [
            0,
            Fmt[26]
        ], pp);
        caml_call3(Fmt[4], _h_, _aH_, values);
        var face$0 = new (isometric(0))["IsometricRectangle"](opts), values$0 = caml_call2(Stdlib_Array[14], function(x) {
            return x[3];
        }, values), _aG_ = caml_call2(Jv[28], function(_aI_) {
            return _aI_;
        }, values$0), anim_opts = {
            property: caml_call1(Jv[24], side_name),
            duration: 2.,
            values: _aG_
        }, face = face$0.addAnimation(anim_opts);
        if (1 === values.length - 1) return face;
        var _aE_ = caml_call1(Stdlib_Array[10], values), _aF_ = caml_call2(Fmt[64], [
            0,
            Fmt[26]
        ], pp);
        caml_call3(Fmt[4], _g_, _aF_, _aE_);
        return face.animateDimensions(caml_call2(Jv[28], to_jv, values), 2.);
    }
    function create$0(opt, path_start, path_end) {
        var stroke_color = opt ? opt[1] : cst_red, opts = {
            strokeColor: caml_call1(Jv[24], stroke_color)
        }, piece = new (isometric(0))["IsometricPath"](opts), start = caml_call7(Fmt[6], _i_, path_start[1], path_start[2], path_start[3], path_start[1], path_start[2], path_start[3]), finish = caml_call7(Fmt[6], _j_, path_start[1], path_start[2], path_start[3], path_end[1], path_end[2], path_end[3]), _aD_ = caml_call2(Jv[28], Jv[24], [
            0,
            start,
            finish
        ]), anim_opts = {
            property: caml_call1(Jv[24], cst_path),
            duration: 2.,
            values: _aD_
        };
        piece.addAnimation(anim_opts);
        return piece;
    }
    function opts$0(_aC_, _aB_, opt, top, left, right, plane_view, text) {
        var font_size = _aC_ ? _aC_[1] : 18., class_name = _aB_ ? _aB_[1] : cst_fill_slate_500, stroke_width = opt ? opt[1] : 0., o = {};
        caml_call3(Jv[21][3], o, cst_fontSize, font_size);
        caml_call3(Jv[23][3], o, cst_fontWeight, "500");
        caml_call3(Jv[23][3], o, cst_className$0, caml_jsstring_of_string(class_name));
        caml_call3(Jv[21][3], o, cst_strokeWidth, stroke_width);
        caml_call3(Jv[21][4], o, cst_top$0, top);
        caml_call3(Jv[21][4], o, cst_left$0, left);
        caml_call3(Jv[21][4], o, cst_right$0, right);
        caml_call3(Jv[23][4], o, cst_planeView$0, plane_view);
        caml_call3(Jv[23][3], o, cst_text, caml_jsstring_of_string(text));
        return o;
    }
    function create$1(opt, param) {
        var opts = opt ? opt[1] : Jv[5];
        return new (isometric(0))["IsometricText"](opts);
    }
    function create$2(_aA_, _az_, opt, children) {
        var top = _aA_ ? _aA_[1] : 0., left = _az_ ? _az_[1] : 0., right = opt ? opt[1] : 0., opts = {};
        caml_call3(Jv[21][3], opts, cst_top$1, top);
        caml_call3(Jv[21][3], opts, cst_left$1, left);
        caml_call3(Jv[21][3], opts, cst_right$1, right);
        var group = new (isometric(0))["IsometricGroup"](opts);
        runtime.caml_js_meth_call(group, "addChildren", caml_call1(Stdlib_Array[11], children));
        return group;
    }
    function add_child(o, child) {
        o.addChild(child);
        return;
    }
    function create$3(draw_diag, edge_attributes) {
        return function(invalid) {
            if (!invalid) return create$1([
                0,
                opts$0(0, 0, 0, 0, 0, 0, 0, cst_scalar)
            ], 0);
            var _ab_ = invalid[2], _ac_ = invalid[1], height$0 = _ac_[2], dim1 = _ac_[1];
            if (!_ab_) {
                var _aw_ = [
                    0,
                    array_max(height$0) * 0.5
                ], _ax_ = [
                    0,
                    create$1([
                        0,
                        opts$0(0, [
                            0,
                            get_class_name(edge_attributes, dim1)
                        ], 0, 0, _aw_, _p_, 0, dim1)
                    ], 0),
                    0
                ], _ay_ = caml_call2(Stdlib_Array[14], function(height) {
                    return [
                        254,
                        0.,
                        height,
                        0.,
                        0.,
                        0.
                    ];
                }, height$0), children$0 = [
                    0,
                    create(opts(0, 0, 0, [
                        0,
                        top
                    ], [
                        0,
                        fill_class_name
                    ], 0., array_max(height$0), 0), _ay_, 0),
                    _ax_
                ];
                return create$2(0, 0, 0, children$0);
            }
            var _ad_ = _ab_[2], _ae_ = _ab_[1], width$0 = _ae_[2], dim2 = _ae_[1];
            if (!_ad_) {
                var _al_ = caml_call2(Fmt[65], [
                    0,
                    Fmt[26]
                ], Fmt[53]), _am_ = caml_call2(Fmt[65], [
                    0,
                    Fmt[26]
                ], Fmt[53]);
                caml_call7(Fmt[4], _o_, dim1, _am_, height$0, dim2, _al_, width$0);
                var _an_ = [
                    0,
                    array_max(width$0) * 0.5
                ], _ao_ = [
                    0,
                    array_max(height$0) * -0.5
                ], _ap_ = [
                    0,
                    create$1([
                        0,
                        opts$0(0, [
                            0,
                            get_class_name(edge_attributes, dim2)
                        ], 0, 0, _ao_, _an_, 0, dim2)
                    ], 0),
                    0
                ], _aq_ = [
                    0,
                    array_max(width$0) * -0.5
                ], _ar_ = [
                    0,
                    array_max(height$0) * 0.5
                ], _as_ = [
                    0,
                    create$1([
                        0,
                        opts$0(0, [
                            0,
                            get_class_name(edge_attributes, dim1)
                        ], 0, 0, _ar_, _aq_, 0, dim1)
                    ], 0),
                    _ap_
                ], _at_ = caml_call3(Stdlib_Array[22], function(height, width) {
                    return [
                        254,
                        width,
                        height,
                        0.,
                        0.,
                        0.
                    ];
                }, height$0, width$0), _au_ = array_max(height$0), children = [
                    0,
                    create(opts(0, 0, 0, [
                        0,
                        top
                    ], [
                        0,
                        fill_class_name
                    ], array_max(width$0), _au_, 0), _at_, 0),
                    _as_
                ];
                a: {
                    if (draw_diag && dim1 == dim2) {
                        var _av_ = array_max(width$0), paths$0 = [
                            0,
                            create$0(0, zero, [
                                254,
                                array_max(height$0),
                                _av_,
                                0.
                            ]),
                            0
                        ];
                        break a;
                    }
                    var paths$0 = 0;
                }
                return create$2(0, 0, 0, caml_call2(Stdlib[37], children, paths$0));
            }
            if (_ad_[2]) {
                var _af_ = caml_call2(Fmt[65], [
                    0,
                    Fmt[26]
                ], Fmt[53]), _ag_ = caml_call1(Fmt[38], _af_), _ah_ = caml_call3(Fmt[61], [
                    0,
                    Fmt[25]
                ], Fmt[57], _ag_), _ai_ = caml_call1(Fmt[37], _ah_), _aj_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], _ai_), _ak_ = caml_call3(Fmt[6], _n_, _aj_, invalid);
                return caml_call1(Stdlib[2], _ak_);
            }
            var depth$0 = _ad_[1], depth = depth$0[2], depth_label = depth$0[1], width = _ae_[2], width_label = _ae_[1], height = _ac_[2], height_label = _ac_[1], max_height = array_max(height), max_width = array_max(width), max_depth = array_max(depth), _V_ = caml_call3(Stdlib_Array[22], function(height, d_as_w) {
                return [
                    254,
                    d_as_w,
                    height,
                    0.,
                    0.,
                    0.
                ];
            }, height, depth), _W_ = [
                0,
                create(opts(0, [
                    0,
                    max_width
                ], 0, [
                    0,
                    side
                ], [
                    0,
                    fill_class_name
                ], max_depth, max_height, 0), _V_, 0),
                0
            ], _X_ = caml_call3(Stdlib_Array[22], function(height, width) {
                return [
                    254,
                    width,
                    height,
                    0.,
                    0.,
                    0.
                ];
            }, height, width), _Y_ = [
                0,
                create(opts(0, 0, [
                    0,
                    max_depth
                ], [
                    0,
                    front
                ], [
                    0,
                    fill_class_name
                ], max_width, max_height, 0), _X_, 0),
                _W_
            ], _Z_ = caml_call3(Stdlib_Array[22], function(w_as_h, d_as_w) {
                return [
                    254,
                    d_as_w,
                    w_as_h,
                    0.,
                    0.,
                    0.
                ];
            }, width, depth), faces = [
                0,
                create(opts([
                    0,
                    max_height
                ], 0, 0, [
                    0,
                    top
                ], [
                    0,
                    fill_class_name
                ], max_depth, max_width, 0), _Z_, 0),
                _Y_
            ], ___ = [
                0,
                create$1([
                    0,
                    opts$0(0, [
                        0,
                        get_class_name(edge_attributes, width_label)
                    ], 0, [
                        0,
                        max_height * 0.5
                    ], [
                        0,
                        max_width * 1.2
                    ], _k_, 0, width_label)
                ], 0),
                0
            ], _$_ = [
                0,
                create$1([
                    0,
                    opts$0(0, [
                        0,
                        get_class_name(edge_attributes, depth_label)
                    ], 0, [
                        0,
                        max_height * 1.25
                    ], _l_, [
                        0,
                        max_depth * 0.5
                    ], 0, depth_label)
                ], 0),
                ___
            ], labels = [
                0,
                create$1([
                    0,
                    opts$0(0, [
                        0,
                        get_class_name(edge_attributes, height_label)
                    ], 0, [
                        0,
                        max_height * 1.25
                    ], [
                        0,
                        max_width * 0.65
                    ], _m_, 0, height_label)
                ], 0),
                _$_
            ];
            a: if (draw_diag) {
                if (height_label == width_label && width_label == depth_label) {
                    var paths = [
                        0,
                        create$0(0, [
                            254,
                            0.,
                            max_width,
                            max_height
                        ], [
                            254,
                            max_depth,
                            0.,
                            0.
                        ]),
                        0
                    ];
                    break a;
                }
                var paths = height_label == width_label ? [
                    0,
                    create$0(0, [
                        254,
                        0.,
                        max_width,
                        max_height
                    ], [
                        254,
                        max_depth,
                        0.,
                        max_height
                    ]),
                    0
                ] : height_label == depth_label ? [
                    0,
                    create$0(0, [
                        254,
                        max_depth,
                        max_width,
                        0.
                    ], [
                        254,
                        max_depth,
                        0.,
                        max_height
                    ]),
                    0
                ] : width_label == depth_label ? [
                    0,
                    create$0(0, [
                        254,
                        0.,
                        max_width,
                        0.
                    ], [
                        254,
                        max_depth,
                        max_width,
                        max_height
                    ]),
                    0
                ] : 0;
            } else var paths = 0;
            var _aa_ = caml_call2(Stdlib[37], labels, paths);
            return create$2(0, 0, 0, caml_call2(Stdlib[37], faces, _aa_));
        };
    }
    function render_unsafe(_x_, _w_, opt, edge_attributes, lhs, rhs) {
        var scale = _x_ ? _x_[1] : 10., height = _w_ ? _w_[1] : default_height, width = opt ? opt[1] : default_width;
        function get_length(label) {
            return caml_call2(Stdlib_Hashtbl[6], edge_attributes, label)[4];
        }
        function get_classes(edge_name) {
            return get_class_name(edge_attributes, edge_name);
        }
        var rows = caml_call1(Stdlib_Queue[2], 0), txt = Brr[9][3], span = Brr[9][147], div = Brr[9][88], match = caml_call1(Tensor_playground_Einops[14][1], [
            0,
            lhs,
            rhs
        ]), broadcast = match[2], diagonalized = match[1];
        function mk_canvas(param) {
            var container = caml_call3(div, 0, 0, 0), width$0 = [
                0,
                width
            ], height$0 = [
                0,
                height
            ], scale$0 = [
                0,
                scale
            ], container$0 = [
                0,
                container
            ], opts = {}, _S_ = caml_call2(Stdlib_Option[7], function(_U_) {
                return _U_;
            }, container$0);
            caml_call3(Jv[16], opts, cst_container, _S_);
            var _T_1 = caml_call2(Stdlib_Option[7], Jv[24], background_color);
            caml_call3(Jv[16], opts, cst_backgroundColor, _T_1);
            caml_call3(Jv[21][4], opts, cst_scale, scale$0);
            caml_call3(Jv[20][4], opts, cst_height$0, height$0);
            caml_call3(Jv[20][4], opts, cst_width$0, width$0);
            var canvas = new (isometric(0))["IsometricCanvas"](opts);
            return [
                0,
                canvas,
                container
            ];
        }
        var _y_ = caml_call3(div, 0, 0, [
            0,
            caml_call2(txt, 0, cst_Start),
            0
        ]);
        caml_call2(Stdlib_Queue[3], _y_, rows);
        var row = caml_call2(Stdlib_List[20], function(tensor) {
            var match = mk_canvas(0), container = match[2], canvas = match[1], _Q_ = caml_call2(Stdlib_List[20], function(label) {
                var _R_ = get_length(label);
                return [
                    0,
                    label,
                    [
                        254,
                        get_length(label),
                        _R_
                    ]
                ];
            }, tensor), tensor$0 = create$3(0, edge_attributes)(_Q_);
            add_child(canvas, tensor$0);
            return container;
        }, lhs), _z_ = caml_call3(div, 0, [
            0,
            caml_call1(classes, cst_flex_flex_row)
        ], row);
        caml_call2(Stdlib_Queue[3], _z_, rows);
        var diagonals_exist = caml_call3(Stdlib_List[36], function(tensor, diagonalized) {
            return 1 - caml_call3(Stdlib_List[16], Stdlib_String[9], tensor, diagonalized);
        }, lhs, diagonalized);
        if (diagonals_exist) {
            var _A_ = caml_call3(div, 0, 0, [
                0,
                caml_call2(txt, 0, cst_Diagonalize),
                0
            ]);
            caml_call2(Stdlib_Queue[3], _A_, rows);
            var row$0 = caml_call2(Stdlib_List[20], function(tensor) {
                var match = mk_canvas(0), container = match[2], canvas = match[1], _O_ = caml_call2(Stdlib_List[20], function(label) {
                    var _P_ = get_length(label);
                    return [
                        0,
                        label,
                        [
                            254,
                            get_length(label),
                            _P_
                        ]
                    ];
                }, tensor), tensor$0 = create$3(1, edge_attributes)(_O_);
                add_child(canvas, tensor$0);
                return container;
            }, lhs), elem = caml_call3(div, 0, [
                0,
                caml_call1(classes, cst_flex_flex_row$0)
            ], row$0);
        } else var elem = caml_call3(div, 0, [
            0,
            caml_call1(classes, cst_flex_flex_row$3)
        ], 0);
        caml_call2(Stdlib_Queue[3], elem, rows);
        var match$0 = caml_call3(Stdlib_List[27], function(tensor, param) {
            var acc = param[2], reorder_necessary = param[1], reordered_tensor = caml_call2(Stdlib_List[59], function(a, b) {
                var match = caml_call2(Tensor_playground_Einops[10], b, rhs), _N_ = caml_call2(Tensor_playground_Einops[10], a, rhs);
                if (!_N_) return match ? 1 : 0;
                var i = _N_[1];
                if (!match) return -1;
                var j = match[1];
                return runtime.caml_int_compare(i, j);
            }, tensor);
            return runtime.caml_equal(reordered_tensor, tensor) ? [
                0,
                reorder_necessary,
                [
                    0,
                    reordered_tensor,
                    acc
                ]
            ] : [
                0,
                1,
                [
                    0,
                    reordered_tensor,
                    acc
                ]
            ];
        }, diagonalized, _q_), reordered = match$0[2], reorder_necessary = match$0[1], _B_ = caml_call2(Stdlib_List[16], Stdlib_String[9], broadcast), tensors_match_shape = caml_call2(Stdlib_List[33], _B_, reordered), broadcast_necessary = 1 - tensors_match_shape;
        a: {
            if (!reorder_necessary && !broadcast_necessary) {
                var elem$0 = caml_call3(div, 0, [
                    0,
                    caml_call1(classes, cst_flex_flex_row$2)
                ], 0);
                break a;
            }
            if (reorder_necessary) var msg = broadcast_necessary ? cst_Reorder_and_Broadcast : cst_Reorder;
            else {
                if (!broadcast_necessary) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _r_
                ], 1);
                var msg = cst_Broadcast;
            }
            var _C_ = caml_call3(div, 0, 0, [
                0,
                caml_call2(txt, 0, msg),
                0
            ]);
            caml_call2(Stdlib_Queue[3], _C_, rows);
            var row$1 = caml_call2(Stdlib_List[20], function(diag_tensor) {
                var match = mk_canvas(0), container = match[2], canvas = match[1], animate_edges = caml_call2(Stdlib_List[44], function(x) {
                    return 1 - caml_call2(Stdlib_List[37], x, diag_tensor);
                }, broadcast), axis_spec = caml_call2(Stdlib_List[20], function(label) {
                    var base_length = get_length(label), lengths = caml_call2(Stdlib_List[37], label, animate_edges) ? [
                        254,
                        0.,
                        base_length
                    ] : [
                        254,
                        base_length,
                        base_length
                    ];
                    return [
                        0,
                        label,
                        lengths
                    ];
                }, broadcast), tensor = create$3(0, edge_attributes)(axis_spec);
                add_child(canvas, tensor);
                return container;
            }, reordered), elem$0 = caml_call3(div, 0, [
                0,
                caml_call1(classes, cst_flex_flex_row$1)
            ], row$1);
        }
        caml_call2(Stdlib_Queue[3], elem$0, rows);
        a: {
            if (reordered && !reordered[2]) {
                var elem$1 = caml_call3(div, 0, 0, 0);
                break a;
            }
            var _D_ = caml_call3(div, 0, 0, [
                0,
                caml_call2(txt, 0, cst_Pointwise_Multiply),
                0
            ]);
            caml_call2(Stdlib_Queue[3], _D_, rows);
            var match$1 = mk_canvas(0), container = match$1[2], canvas = match$1[1], _E_ = caml_call2(Stdlib_List[20], function(label) {
                var _M_ = get_length(label);
                return [
                    0,
                    label,
                    [
                        254,
                        get_length(label),
                        _M_
                    ]
                ];
            }, broadcast), tensor = create$3(0, edge_attributes)(_E_);
            add_child(canvas, tensor);
            var elem$1 = caml_call3(div, 0, 0, [
                0,
                container,
                0
            ]);
        }
        caml_call2(Stdlib_Queue[3], elem$1, rows);
        var need_contraction = 1 - caml_call3(Stdlib_List[16], Stdlib_String[9], broadcast, rhs);
        if (need_contraction) {
            var _F_ = caml_call1(String_set[38], rhs), _G_ = caml_call1(String_set[38], broadcast), _H_ = caml_call2(String_set[8], _G_, _F_), axes_to_contract = caml_call1(String_set[37], _H_), _I_ = [
                0,
                caml_call3(span, 0, 0, caml_call2(Dune_exe_Frontend_util[50], get_classes, axes_to_contract)),
                0
            ], _J_ = caml_call3(div, 0, 0, [
                0,
                caml_call2(txt, 0, cst_Contract),
                _I_
            ]);
            caml_call2(Stdlib_Queue[3], _J_, rows);
            var match$2 = mk_canvas(0), container$0 = match$2[2], canvas$0 = match$2[1], axis_spec = caml_call2(Stdlib_List[20], function(label) {
                var base_length = get_length(label), lengths = caml_call2(Stdlib_List[37], label, axes_to_contract) ? [
                    254,
                    base_length,
                    0.
                ] : [
                    254,
                    base_length,
                    base_length
                ];
                return [
                    0,
                    label,
                    lengths
                ];
            }, broadcast), tensor$0 = create$3(0, edge_attributes)(axis_spec);
            add_child(canvas$0, tensor$0);
            var elem$2 = caml_call3(div, 0, 0, [
                0,
                container$0,
                0
            ]);
        } else var elem$2 = caml_call3(div, 0, 0, 0);
        caml_call2(Stdlib_Queue[3], elem$2, rows);
        var _K_ = caml_call1(Stdlib_Queue[18], rows), _L_ = caml_call1(Stdlib_List[65], _K_);
        return caml_call3(div, 0, [
            0,
            caml_call1(classes, cst_flex_flex_col)
        ], _L_);
    }
    function render(_u_, _t_, opt, edge_attributes, lhs, rhs) {
        var scale = _u_ ? _u_[1] : 10., height = _t_ ? _t_[1] : default_height, width = opt ? opt[1] : default_width;
        try {
            var _v_ = [
                0,
                render_unsafe([
                    0,
                    scale
                ], [
                    0,
                    height
                ], [
                    0,
                    width
                ], edge_attributes, lhs, rhs)
            ];
            return _v_;
        } catch (e$0) {
            var e = caml_wrap_exception(e$0);
            caml_call4(Fmt[3], Fmt[2], _s_, Fmt[59], e);
            return 0;
        }
    }
    var Scene = [
        0,
        render
    ], Dune_exe_Isometric = [
        0,
        EdgeAnimation,
        Scene
    ];
    runtime.caml_register_global(152, Dune_exe_Isometric, "Dune__exe__Isometric");
    return;
})(globalThis);
//# 1 ".tensor_playground_web.eobjs/jsoo/dune__exe__Tensor_diagram.cmo.js"
// Generated by js_of_ocaml
//# 3 ".tensor_playground_web.eobjs/jsoo/dune__exe__Tensor_diagram.cmo.js"
//# 6 ".tensor_playground_web.eobjs/jsoo/dune__exe__Tensor_diagram.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$5 = "", cst_edge$1 = "edge", cst_group = "group-", cst_group_s = "group-%s", cst_tensor$0 = "tensor-", cst_tensor_d = "tensor-%d", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$4 = cst$5, label = cst$5, cst$3 = cst$5, partial = [
        17,
        0,
        [
            17,
            4,
            0
        ]
    ], cst$1 = cst$5, cst$2 = cst$5, cst = cst$5, cst$0 = cst$5, Stdlib_List = global_data.Stdlib__List, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Fmt = global_data.Fmt, Brr = global_data.Brr, Stdlib_Queue = global_data.Stdlib__Queue, Stdlib_Option = global_data.Stdlib__Option, Stdlib = global_data.Stdlib, Tensor_playground_Einops = global_data.Tensor_playground__Einops, Stdlib_Array = global_data.Stdlib__Array, Jv = global_data.Jv, Stdlib_String = global_data.Stdlib__String, Stdlib_Set = global_data.Stdlib__Set, Dune_exe_Frontend_util = global_data.Dune__exe__Frontend_util, String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]), classes = Dune_exe_Frontend_util[29], cst_tensor = "tensor", cst_edge = cst_edge$1, _a_ = [
        0,
        [
            11,
            cst_tensor$0,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        cst_tensor_d
    ], _b_ = [
        0,
        [
            11,
            cst_group,
            [
                2,
                0,
                0
            ]
        ],
        cst_group_s
    ], _c_ = [
        0,
        [
            11,
            cst_tensor$0,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        cst_tensor_d
    ], _d_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$5
                ]
            ],
            [
                11,
                "find_partner ",
                [
                    4,
                    0,
                    0,
                    0,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " lhs=([",
                                [
                                    18,
                                    [
                                        1,
                                        [
                                            0,
                                            0,
                                            cst$5
                                        ]
                                    ],
                                    [
                                        15,
                                        [
                                            17,
                                            0,
                                            [
                                                11,
                                                "]) -> Not_found",
                                                partial
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[find_partner %d %s lhs=([@[%a@]]) -> Not_found@]@."
    ], _e_ = [
        0,
        [
            11,
            cst_tensor$0,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        cst_tensor_d
    ], _f_ = [
        0,
        [
            15,
            0
        ],
        "%a"
    ], cst_edge$0 = cst_edge$1, _g_ = [
        0,
        [
            11,
            cst_tensor$0,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        cst_tensor_d
    ], _h_ = [
        0,
        [
            11,
            cst_group,
            [
                2,
                0,
                0
            ]
        ],
        cst_group_s
    ], cst_mx_auto = "mx-auto";
    function to_jv(param) {
        var class_name = param[4], node_type = param[3], label = param[2], id = param[1], _I_ = node_type ? cst_tensor : cst_edge, _J_ = caml_call1(Jv[24], _I_), _K_ = caml_call1(Jv[24], class_name), _L_ = caml_call1(Jv[24], label);
        return {
            id: caml_call1(Jv[24], id),
            label: _L_,
            class_name: _K_,
            type: _J_
        };
    }
    function to_jv$0(param) {
        var target = param[4], source = param[3], label = param[2], class_name = param[1], _F_ = caml_call1(Jv[24], target), _G_ = caml_call1(Jv[24], source), _H_ = caml_call1(Jv[24], label);
        return {
            class_name: caml_call1(Jv[24], class_name),
            label: _H_,
            source: _G_,
            target: _F_
        };
    }
    function nested_list_count(target, param) {
        if (!param) return 0;
        var lsts = param[2], lst = param[1], _D_ = nested_list_count(target, lsts), _E_ = caml_call2(Stdlib_List[37], target, lst) ? 1 : 0;
        return _E_ + _D_ | 0;
    }
    function draw_einsum(edge_attributes, lhs, rhs) {
        function get_color(name) {
            return caml_call2(Stdlib_Hashtbl[6], edge_attributes, name);
        }
        var match = caml_call1(Tensor_playground_Einops[8][1], [
            0,
            lhs,
            rhs
        ]), summation = match[2], free = match[1], _i_ = caml_call1(String_set[37], summation), match$0 = caml_call3(Stdlib_List[26], function(param, edge) {
            var groups = param[3], pairs = param[2], selves = param[1], count = nested_list_count(edge, lhs);
            return 1 === count ? [
                0,
                caml_call2(String_set[2], edge, selves),
                pairs,
                groups
            ] : 2 === count ? [
                0,
                selves,
                caml_call2(String_set[2], edge, pairs),
                groups
            ] : [
                0,
                selves,
                pairs,
                caml_call2(String_set[2], edge, groups)
            ];
        }, [
            0,
            String_set[1],
            String_set[1],
            String_set[1]
        ], _i_), contracted_in_group = match$0[3], contracted_in_pair = match$0[2], self_contracted = match$0[1], _j_ = caml_call1(caml_call1(Stdlib_List[21], function(i, x) {
            var id = caml_call2(Fmt[6], _a_, i);
            return [
                0,
                id,
                cst$0,
                1,
                cst
            ];
        }), lhs), tensor_nodes = caml_call1(Stdlib_Array[11], _j_), _k_ = caml_call1(caml_call1(Stdlib_List[20], function(x) {
            var fill_classes = get_color(x)[1];
            return [
                0,
                x,
                x,
                0,
                fill_classes
            ];
        }), rhs), uncontracted_nodes = caml_call1(Stdlib_Array[11], _k_), _l_ = caml_call1(String_set[37], contracted_in_group), _m_ = caml_call1(caml_call1(Stdlib_List[20], function(x) {
            var id = caml_call2(Fmt[6], _b_, x);
            return [
                0,
                id,
                cst$2,
                0,
                cst$1
            ];
        }), _l_), contraction_group_nodes = caml_call1(Stdlib_Array[11], _m_), nodes = caml_call1(Stdlib_Array[5], [
            0,
            tensor_nodes,
            [
                0,
                uncontracted_nodes,
                [
                    0,
                    contraction_group_nodes,
                    0
                ]
            ]
        ]), edges = caml_call1(Stdlib_Queue[2], 0), pair_edges_seen = caml_call2(Stdlib_Hashtbl[1], 0, 10);
        caml_call2(Stdlib_List[19], function(source_n, edge_names) {
            var _r_ = caml_call2(Stdlib_List[44], function(x) {
                return caml_call2(String_set[31], x, self_contracted);
            }, edge_names), _s_ = caml_call1(String_set[38], _r_), self_contracted$0 = caml_call1(String_set[37], _s_);
            if (self_contracted$0) {
                a: {
                    if (self_contracted$0 && !self_contracted$0[2]) {
                        var x = self_contracted$0[1], fill_classes = get_color(x)[1], class_name = fill_classes;
                        break a;
                    }
                    var class_name = cst$3;
                }
                var node_id = caml_call2(Fmt[6], _e_, source_n), _t_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[25]
                ], Fmt[57]), edge = [
                    0,
                    class_name,
                    caml_call3(Fmt[6], _f_, _t_, self_contracted$0),
                    node_id,
                    node_id
                ];
                caml_call2(Stdlib_Queue[3], edge, edges);
            }
            return caml_call2(Stdlib_List[18], function(edge_name) {
                var contracted_in_pair$0 = caml_call2(String_set[31], edge_name, contracted_in_pair);
                a: {
                    if (contracted_in_pair$0 && caml_call2(Stdlib_Hashtbl[9], pair_edges_seen, edge_name)) break a;
                    if (!caml_call2(String_set[31], edge_name, self_contracted)) {
                        if (caml_call2(String_set[31], edge_name, free)) var label$0 = cst$4, target = edge_name;
                        else if (contracted_in_pair$0) {
                            var _u_ = caml_call2(Stdlib_List[21], function(i, x) {
                                return [
                                    0,
                                    i,
                                    x
                                ];
                            }, lhs), found_ix = caml_call3(Stdlib_List[26], function(acc, param) {
                                var edge_names = param[2], j = param[1];
                                if (source_n !== j && !caml_call1(Stdlib_Option[11], acc)) return caml_call2(Stdlib_List[37], edge_name, edge_names) ? [
                                    0,
                                    caml_call2(Fmt[6], _c_, j)
                                ] : acc;
                                return acc;
                            }, 0, _u_);
                            if (!found_ix) {
                                var _v_ = caml_call2(Stdlib_List[21], function(i, x) {
                                    return [
                                        0,
                                        i,
                                        x
                                    ];
                                }, lhs), _w_ = caml_call2(Fmt[64], [
                                    0,
                                    Fmt[23]
                                ], Fmt[57]), _x_ = caml_call1(Fmt[38], _w_), _y_ = caml_call3(Fmt[61], [
                                    0,
                                    Fmt[25]
                                ], Fmt[45], _x_), _z_ = caml_call1(Fmt[37], _y_), _A_ = caml_call2(Fmt[64], [
                                    0,
                                    Fmt[26]
                                ], _z_);
                                caml_call6(Fmt[3], Fmt[2], _d_, source_n, edge_name, _A_, _v_);
                                throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                            }
                            var j = found_ix[1], label$0 = edge_name, target = j;
                        } else var target$0 = caml_call2(Fmt[6], _h_, edge_name), label$0 = label, target = target$0;
                        if (contracted_in_pair$0) caml_call3(Stdlib_Hashtbl[5], pair_edges_seen, edge_name, 0);
                        var _B_ = [
                            0,
                            cst_edge$0,
                            [
                                0,
                                edge_name,
                                [
                                    0,
                                    get_color(edge_name),
                                    0
                                ]
                            ]
                        ];
                        caml_call1(Brr[12][9], _B_);
                        var _C_ = caml_call2(Fmt[6], _g_, source_n), fill_classes = get_color(edge_name)[1], edge = [
                            0,
                            fill_classes,
                            label$0,
                            _C_,
                            target
                        ];
                        return caml_call2(Stdlib_Queue[3], edge, edges);
                    }
                }
                return 0;
            }, edge_names);
        }, lhs);
        var _n_ = caml_call1(Stdlib_Queue[18], edges), edges$0 = caml_call1(Stdlib_Array[41], _n_), _o_ = [
            0,
            caml_call1(classes, cst_mx_auto)
        ], el = caml_call3(Brr[9][88], 0, _o_, 0), _p_ = caml_call2(Jv[28], to_jv$0, edges$0), _q_ = caml_call2(Jv[28], to_jv, nodes);
        Jv[12].renderTensorDiagram(el, _q_, _p_);
        return el;
    }
    var Dune_exe_Tensor_diagram = [
        0,
        draw_einsum
    ];
    runtime.caml_register_global(41, Dune_exe_Tensor_diagram, "Dune__exe__Tensor_diagram");
    return;
})(globalThis);
//# 1 ".tensor_playground_web.eobjs/jsoo/dune__exe__Einsum_explanation.cmo.js"
// Generated by js_of_ocaml
//# 3 ".tensor_playground_web.eobjs/jsoo/dune__exe__Einsum_explanation.cmo.js"
//# 6 ".tensor_playground_web.eobjs/jsoo/dune__exe__Einsum_explanation.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$11 = "", cst_and$2 = " and ", cst_for_more$1 = " for more.", cst_a$0 = "%a@?", cst$12 = ")", cst$13 = ").", cst_0_0_24_24$0 = "0 0 24 24", cst_1_5$0 = "1.5", cst_RangeFormatter_unknown_sta = "RangeFormatter unknown stag\n", cst_Tabs = "Tabs", cst_blank = "_blank", cst_a_b$2 = "a b", cst_a_b_b_c_a_c$2 = "a b, b c -> a c", cst_aria_label = "aria-label", cst_before_content_after_conte$1 = "before:content-[''] after:content-['']", cst_currentColor$0 = "currentColor", cst_evenodd = "evenodd", cst_flex_flex_row_my_4$1 = "flex flex-row my-4", cst_https_rockt_ai_2018_04_30_$1 = "https://rockt.ai/2018/04/30/einsum", cst_i$5 = "i", cst_i_j_i$1 = "i j -> i", cst_i_j_j$2 = "i j -> j", cst_i_j_i_j_i_j$1 = "i j, i j -> i j", cst_j$3 = "j", cst_none$0 = "none", cst_numpy_einsum$2 = "numpy.einsum", cst_round$1 = "round", cst_size_5_inline_fill_slate_9 = "size-5 inline fill-slate-900 dark:fill-white", cst_stroke$0 = "stroke", cst_stroke_linecap$0 = "stroke-linecap", cst_stroke_linejoin$0 = "stroke-linejoin", cst_stroke_width$0 = "stroke-width", cst_target = "target", cst_text_xl_mt_3_mb_1$2 = "text-xl mt-3 mb-1", cst_true$1 = "true", caml_jsstring_of_string = runtime.caml_jsstring_of_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$4 = cst$11, cst$3 = cst$12, cst$5 = cst$12, cst$6 = cst$12, cst$7 = " ", cst$8 = cst$13, cst$9 = ".", cst$10 = cst$13, base_classes = "flex items-center justify-center rounded-md bg-white px-3 py-3 text-sm font-semibold uppercase text-gray-900 ring-1 ring-gray-300 hover:bg-gray-50 data-[checked]:bg-indigo-600 data-[checked]:text-white data-[checked]:ring-0 data-[focus]:data-[checked]:ring-2 data-[focus]:ring-2 data-[focus]:ring-indigo-600 data-[focus]:ring-offset-2 data-[checked]:hover:bg-indigo-500 sm:flex-1 [&:not([data-focus],[data-checked])]:ring-inset cursor-pointer focus:outline-none", cst$1 = cst$11, cst$2 = cst$11, cst = cst$11, cst$0 = cst$11, Dune_exe_Frontend_util = global_data.Dune__exe__Frontend_util, Brr = global_data.Brr, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Dune_exe_Colors = global_data.Dune__exe__Colors, Tensor_playground_Einops = global_data.Tensor_playground__Einops, Fmt = global_data.Fmt, Dune_exe_Tensor_diagram = global_data.Dune__exe__Tensor_diagram, Dune_exe_Isometric = global_data.Dune__exe__Isometric, Tensor_playground_Einsum_parse = global_data.Tensor_playground__Einsum_parser, Note = global_data.Note, Note_brr = global_data.Note_brr, Stdlib = global_data.Stdlib, Stdlib_List = global_data.Stdlib__List, Brr_svg = global_data.Brr_svg, Stdlib_Queue = global_data.Stdlib__Queue, Stdlib_Stack = global_data.Stdlib__Stack, Stdio = global_data.Stdio, Stdlib_String = global_data.Stdlib__String, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Format = global_data.Stdlib__Format, Tensor_playground_Util = global_data.Tensor_playground__Util;
    function code(text) {
        var _gn_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, text),
            0
        ];
        return caml_call3(Dune_exe_Frontend_util[3], 0, 0, _gn_);
    }
    var text_button_classes = caml_call1(Dune_exe_Frontend_util[29], "not-prose text-indigo-500 dark:text-indigo-200 hover:text-gray-700"), _a_ = [
        0,
        [
            11,
            "Path must have length (",
            [
                4,
                0,
                0,
                0,
                [
                    12,
                    41,
                    0
                ]
            ]
        ],
        "Path must have length (%d)"
    ], _b_ = [
        0,
        [
            11,
            "Path components must be between 0 and ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " (the number of un-contracted tensors remaining at this point) (got ",
                    [
                        15,
                        [
                            12,
                            41,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Path components must be between 0 and %d (the number of un-contracted tensors remaining at this point) (got %a)"
    ], cst_All_path_components_must_b = "All path components must be non-negative", _c_ = [
        0,
        0
    ], cst_Indices_in_the_result_must = "Indices in the result must be a subset of the indices in the inputs", _d_ = [
        0,
        [
            11,
            "Indices in the result must be unique. Invalid: ",
            [
                15,
                [
                    12,
                    46,
                    0
                ]
            ]
        ],
        "Indices in the result must be unique. Invalid: %a."
    ], _e_ = [
        0,
        [
            11,
            "add_spaces negative value (!): ",
            [
                4,
                0,
                0,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        "add_spaces negative value (!): %d\n"
    ], _f_ = [
        0,
        [
            11,
            cst_RangeFormatter_unknown_sta,
            0
        ],
        cst_RangeFormatter_unknown_sta
    ];
    function validate_path(n_tensors, path) {
        if (0 === caml_call1(Stdlib_List[1], path)) return 0;
        if (caml_call1(Stdlib_List[1], path) !== (n_tensors - 1 | 0)) return [
            0,
            [
                0,
                caml_call2(Dune_exe_Frontend_util[36], _a_, n_tensors - 1 | 0),
                0
            ]
        ];
        var path$0 = path;
        for(;;){
            if (!path$0) return 0;
            var path$1 = path$0[2], match = path$0[1], y = match[2], x = match[1];
            if (0 <= x && 0 <= y) {
                if (n_tensors > x && n_tensors > y) {
                    path$0 = path$1;
                    continue;
                }
                var _gl_ = caml_call3(Fmt[61], [
                    0,
                    Fmt[25]
                ], Fmt[45], Fmt[45]), _gm_ = caml_call1(Fmt[37], _gl_);
                return [
                    0,
                    [
                        0,
                        caml_call4(Dune_exe_Frontend_util[36], _b_, n_tensors - 1 | 0, _gm_, [
                            0,
                            x,
                            y
                        ]),
                        0
                    ]
                ];
            }
            return [
                0,
                [
                    0,
                    caml_call2(Dune_exe_Frontend_util[10], 0, cst_All_path_components_must_b),
                    0
                ]
            ];
        }
    }
    function validate_inputs(rewrite, path) {
        var rhs = rewrite[2], bindings = rewrite[1], match = validate_path(caml_call1(Stdlib_List[1], bindings), path);
        if (match) {
            var errors = match[1];
            return [
                1,
                errors
            ];
        }
        var repeats = caml_call1(Tensor_playground_Util[5], rhs);
        if (0 === repeats) {
            var _gi_ = caml_call1(Stdlib_List[14], bindings), lhs_names = caml_call1(Dune_exe_Frontend_util[1][38], _gi_), rhs_names_set = caml_call1(Dune_exe_Frontend_util[1][38], rhs);
            return caml_call2(Dune_exe_Frontend_util[1][34], rhs_names_set, lhs_names) ? _c_ : [
                1,
                [
                    0,
                    caml_call2(Dune_exe_Frontend_util[10], 0, cst_Indices_in_the_result_must),
                    0
                ]
            ];
        }
        var _gj_ = caml_call2(Fmt[64], [
            0,
            Fmt[25]
        ], Fmt[57]), _gk_ = caml_call1(Fmt[38], _gj_);
        return [
            1,
            [
                0,
                caml_call3(Dune_exe_Frontend_util[36], _d_, _gk_, repeats),
                0
            ]
        ];
    }
    function trim_before_colon(s) {
        try {
            var colon_index = caml_call2(Stdlib_String[36], s, 58), _gg_ = caml_call3(Stdlib_String[16], s, colon_index + 1 | 0, (runtime.caml_ml_string_length(s) - colon_index | 0) - 1 | 0);
            return _gg_;
        } catch (_gh_) {
            var _gf_ = caml_wrap_exception(_gh_);
            if (_gf_ === Stdlib[8]) return s;
            throw caml_maybe_attach_backtrace(_gf_, 0);
        }
    }
    function make_formatter(param) {
        var match = caml_call1(Note[3][3], 0), trigger_add_elem = match[2], add_elem_e = match[1], do_add_elem = caml_call1(caml_call1(Note[3][9], function(elem, elems) {
            return caml_call2(Stdlib[37], elems, [
                0,
                elem,
                0
            ]);
        }), add_elem_e), top_level_elems = caml_call3(Note[4][19], 0, 0, do_add_elem), stack = caml_call1(Stdlib_Stack[2], 0);
        function add_at_current_level(elem) {
            try {
                var val = caml_call1(Stdlib_Stack[7], stack);
            } catch (_ge_) {
                var _gd_ = caml_wrap_exception(_ge_);
                if (_gd_ === Stdlib_Stack[1]) return caml_call2(trigger_add_elem, 0, elem);
                throw caml_maybe_attach_backtrace(_gd_, 0);
            }
            var q = val[2];
            return caml_call2(Stdlib_Queue[3], elem, q);
        }
        function add_text(str) {
            var _gc_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, str),
                0
            ];
            return add_at_current_level(caml_call3(Dune_exe_Frontend_util[9], 0, 0, _gc_));
        }
        function add_spaces(n) {
            return 0 < n ? add_text(caml_call2(Stdlib_String[1], n, 32)) : 0 <= n ? 0 : caml_call2(Stdlib_Printf[2], _e_, n);
        }
        var out_fns = [
            0,
            function(str, start, char_count) {
                return add_text(str);
            },
            function(x) {
                return x;
            },
            function(param) {
                return add_at_current_level(caml_call3(Brr[9][74], 0, 0, 0));
            },
            add_spaces,
            add_spaces
        ], stag_fns = [
            0,
            function(param) {
                if (param[1] === Tensor_playground_Einops[3]) {
                    var color = param[2], _gb_ = [
                        0,
                        color,
                        caml_call1(Stdlib_Queue[2], 0)
                    ];
                    caml_call2(Stdlib_Stack[3], _gb_, stack);
                    return cst$1;
                }
                caml_call1(Stdio[4], _f_);
                return cst$2;
            },
            function(param) {
                try {
                    var val = caml_call1(Stdlib_Stack[4], stack);
                } catch (_ga_) {
                    var _f8_ = caml_wrap_exception(_ga_);
                    if (_f8_ === Stdlib_Stack[1]) return cst;
                    throw caml_maybe_attach_backtrace(_f8_, 0);
                }
                var q = val[2], class_name = val[1], _f9_ = caml_call1(Stdlib_Queue[18], q), _f__ = caml_call1(Stdlib_List[65], _f9_), _f$_ = [
                    0,
                    caml_call1(Dune_exe_Frontend_util[29], class_name)
                ];
                add_at_current_level(caml_call1(caml_call2(Dune_exe_Frontend_util[9], 0, _f$_), _f__));
                return cst$0;
            },
            function(param) {
                return 0;
            },
            function(param) {
                return 0;
            }
        ], fmt = caml_call1(Stdlib_Format[124], out_fns);
        caml_call2(Stdlib_Format[86], fmt, 1);
        caml_call2(Stdlib_Format[106], fmt, stag_fns);
        var cons = Brr[9][79], result = caml_call3(cons, 0, 0, 0);
        caml_call2(Note_brr[4][2], result, top_level_elems);
        return [
            0,
            result,
            fmt
        ];
    }
    var Make_formatter = [
        0,
        make_formatter
    ], cst_true = cst_true$1, cst_false = "false", cst_round = cst_round$1, cst_stroke_linejoin = cst_stroke_linejoin$0, cst_round$0 = cst_round$1, cst_stroke_linecap = cst_stroke_linecap$0, cst_m19_5_8_25_7_5_7_5_7_5_7_5 = "m19.5 8.25-7.5 7.5-7.5-7.5", cst_none = cst_none$0, cst_0_0_24_24 = cst_0_0_24_24$0, cst_1_5 = cst_1_5$0, cst_stroke_width = cst_stroke_width$0, cst_currentColor = cst_currentColor$0, cst_stroke = cst_stroke$0, cst_true$0 = cst_true$1, cst_aria_hidden = "aria-hidden", cst_pointer_events_none_col_st = "pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500", cst_col_start_1_row_start_1_w_ = "col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600", cst_border_indigo_500_text_ind = "border-indigo-500 text-indigo-600", cst_whitespace_nowrap_border_b = "whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium", cst_border_transparent_text_gr = "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700", cst_mb_px_flex_space_x_8 = "-mb-px flex space-x-8", cst_border_b_border_gray_200 = "border-b border-gray-200", cst_hidden_sm_block = "hidden sm:block", cst_grid_grid_cols_1_sm_hidden = "grid grid-cols-1 sm:hidden";
    function radio(desc, selected, value, f) {
        var attrs = [
            0,
            caml_call2(Brr[8][1], "role", "radio"),
            0
        ], _f0_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, desc),
            0
        ], _f1_ = caml_call1(Dune_exe_Frontend_util[29], base_classes), _f2_ = [
            0,
            caml_call2(Stdlib[37], attrs, _f1_)
        ], input_elem = caml_call3(Dune_exe_Frontend_util[9], 0, _f2_, _f0_), _f3_ = caml_call1(caml_call2(Note[4][14], 0, function(selected) {
            return selected ? [
                0,
                cst_true$1
            ] : 0;
        }), selected);
        caml_call3(Note_brr[4][4], "data-checked", _f3_, input_elem);
        var _f4_ = caml_call1(caml_call2(Note[4][14], 0, function(selected) {
            var _f7_ = selected ? cst_true : cst_false;
            return [
                0,
                caml_jsstring_of_string(_f7_)
            ];
        }), selected);
        caml_call3(Note_brr[4][4], "aria-checked", _f4_, input_elem);
        var _f5_ = Brr[7][45], _f6_ = caml_call1(Dune_exe_Frontend_util[7], input_elem);
        caml_call6(Note_brr[3][9], 0, 0, 0, _f6_, _f5_, function(param) {
            return caml_call1(f, value);
        });
        return input_elem;
    }
    function make_tabs(opt, tabs) {
        var default$0 = opt ? opt[1] : 0, match = caml_call2(Note[4][3], 0, default$0), set_current_tab = match[2], current_tab_s = match[1], _fq_ = caml_call2(Stdlib_List[20], function(tab) {
            var _fZ_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, tab[1]),
                0
            ];
            return caml_call3(Brr[9][130], 0, 0, _fZ_);
        }, tabs), _fr_ = caml_call1(Dune_exe_Frontend_util[29], cst_col_start_1_row_start_1_w_), _fs_ = [
            0,
            caml_call2(Brr[8][1], cst_aria_label, "Select a tab"),
            _fr_
        ], _ft_ = caml_jsstring_of_string(caml_call1(Stdlib_List[6], tabs)[1]), _fu_ = [
            0,
            [
                0,
                caml_call2(Brr[8][1], "default-value", _ft_),
                _fs_
            ]
        ], select = caml_call3(Brr[9][144], 0, _fu_, _fq_);
        caml_call4(Brr[7][20], 0, Brr[7][44], function(evt) {
            var tab_name = runtime.caml_string_of_jsstring(caml_call2(Brr[9][28], Brr[9][27][10], select)), match = caml_call2(Stdlib_List[41], function(tab) {
                return tab[1] == tab_name ? 1 : 0;
            }, tabs);
            if (!match) return 0;
            var i = match[1];
            return caml_call2(set_current_tab, 0, i);
        }, select);
        var elem = caml_call1(caml_call2(Note[4][25], 0, function(current_tab_num) {
            var _fJ_ = caml_call1(caml_call1(Stdlib_List[21], function(i, tab) {
                if (i === current_tab_num) var _fV_ = caml_call1(Dune_exe_Frontend_util[29], cst_border_indigo_500_text_ind), attrs = [
                    0,
                    caml_call2(Brr[8][1], "aria-current", "page"),
                    _fV_
                ];
                else var attrs = caml_call1(Dune_exe_Frontend_util[29], cst_border_transparent_text_gr);
                var _fW_ = caml_call1(Dune_exe_Frontend_util[29], cst_whitespace_nowrap_border_b), attrs$0 = caml_call2(Stdlib[37], attrs, _fW_), _fX_ = [
                    0,
                    caml_call2(Dune_exe_Frontend_util[10], 0, tab[1]),
                    0
                ], btn = caml_call3(Brr[9][75], 0, [
                    0,
                    attrs$0
                ], _fX_), evt = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(param) {
                    return 0;
                }, btn), _fY_ = caml_call3(Note[3][2], 0, evt, function(param) {
                    return caml_call2(set_current_tab, 0, i);
                });
                caml_call1(Note[2][8], _fY_);
                return btn;
            }), tabs), _fK_ = caml_call1(Dune_exe_Frontend_util[29], cst_mb_px_flex_space_x_8), _fL_ = [
                0,
                [
                    0,
                    caml_call2(Brr[8][1], cst_aria_label, cst_Tabs),
                    _fK_
                ]
            ], _fM_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[23], 0, _fL_, _fJ_),
                0
            ], _fN_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_border_b_border_gray_200)
            ], _fO_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[8], 0, _fN_, _fM_),
                0
            ], _fP_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_hidden_sm_block)
            ], _fQ_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[8], 0, _fP_, _fO_),
                0
            ], _fv_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[25], cst_stroke_linejoin, cst_round),
                0
            ], _fw_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[25], cst_stroke_linecap, cst_round$0),
                _fv_
            ], _fx_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[33], cst_m19_5_8_25_7_5_7_5_7_5_7_5),
                0
            ], _fy_ = [
                0,
                caml_call2(Stdlib[37], _fx_, _fw_)
            ], _fz_ = [
                0,
                caml_call3(Brr_svg[3][64], 0, _fy_, 0),
                0
            ], _fA_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[35], cst_none),
                0
            ], _fB_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[34], cst_0_0_24_24),
                _fA_
            ], _fC_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[25], cst_stroke_width, cst_1_5),
                0
            ], _fD_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[25], cst_stroke, cst_currentColor),
                _fC_
            ], _fE_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[25], cst_aria_hidden, cst_true$0),
                _fD_
            ], _fF_ = caml_call2(Stdlib[37], _fE_, _fB_), _fG_ = caml_call1(Dune_exe_Frontend_util[31], cst_pointer_events_none_col_st), _fH_ = [
                0,
                caml_call2(Stdlib[37], _fG_, _fF_)
            ], _fI_ = caml_call3(Brr_svg[3][74], 0, _fH_, _fz_), _fR_ = [
                0,
                select,
                [
                    0,
                    caml_call1(Dune_exe_Frontend_util[24], _fI_),
                    0
                ]
            ], _fS_ = caml_call1(Dune_exe_Frontend_util[29], cst_grid_grid_cols_1_sm_hidden), _fT_ = [
                0,
                [
                    0,
                    caml_call2(Brr[8][1], cst_aria_label, cst_Tabs),
                    _fS_
                ]
            ], _fU_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[8], 0, _fT_, _fR_),
                _fQ_
            ];
            return caml_call3(Dune_exe_Frontend_util[8], 0, 0, _fU_);
        }), current_tab_s);
        return [
            0,
            elem,
            current_tab_s
        ];
    }
    var Tabs = [
        0,
        make_tabs
    ], cst_for_more = cst_for_more$1, cst_tensors_net = "tensors.net", cst_https_www_tensors_net_intr = "https://www.tensors.net/intro", cst_or = " or ", cst_tensornetwork_org = "tensornetwork.org", cst_https_tensornetwork_org_di = "https://tensornetwork.org/diagrams/", cst_See = "See ", cst_Each_node_in_a_tensor_diag = "Each node in a tensor diagram represents a tensor (e.g a matrix or vector). Each line emanating from a tensor represents one of that tensor's dimensions. When two tensors are connected by a single line that represents a contraction (summation over the connected indices). Look through the examples to see how common operations correspond to tensor diagrams.", cst_Interpreting_a_Tensor_Diag = "Interpreting a Tensor Diagram", cst_text_lg = "text-lg";
    function mk_tensor_diagram_info(param) {
        var _fe_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_for_more),
            0
        ], _ff_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[48], cst_https_www_tensors_net_intr, cst_tensors_net),
            _fe_
        ], _fg_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_or),
            _ff_
        ], _fh_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[48], cst_https_tensornetwork_org_di, cst_tensornetwork_org),
            _fg_
        ], _fi_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_See),
            _fh_
        ], _fj_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _fi_),
            0
        ], _fk_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Each_node_in_a_tensor_diag),
            0
        ], _fl_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _fk_),
            _fj_
        ], _fm_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Interpreting_a_Tensor_Diag),
            0
        ], _fn_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_text_lg)
        ], _fo_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[20], 0, _fn_, _fm_),
            _fl_
        ], _fp_ = caml_call3(Dune_exe_Frontend_util[8], 0, 0, _fo_);
        return caml_call1(Dune_exe_Frontend_util[47], _fp_);
    }
    var _g_ = [
        0,
        caml_call1(Dune_exe_Frontend_util[33], "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"),
        0
    ], _h_ = [
        0,
        caml_call2(Dune_exe_Frontend_util[25], cst_stroke_linejoin$0, cst_round$1),
        _g_
    ], _i_ = [
        0,
        [
            0,
            caml_call2(Dune_exe_Frontend_util[25], cst_stroke_linecap$0, cst_round$1),
            _h_
        ]
    ], _j_ = [
        0,
        caml_call3(Brr_svg[3][64], 0, _i_, 0),
        0
    ], _k_ = caml_call1(Dune_exe_Frontend_util[31], "size-5 inline"), _l_ = [
        0,
        caml_call2(Dune_exe_Frontend_util[25], "fill", cst_none$0),
        0
    ], _m_ = [
        0,
        caml_call2(Dune_exe_Frontend_util[25], cst_stroke$0, cst_currentColor$0),
        _l_
    ], _n_ = [
        0,
        caml_call2(Dune_exe_Frontend_util[25], cst_stroke_width$0, cst_1_5$0),
        _m_
    ], _o_ = [
        0,
        caml_call1(Dune_exe_Frontend_util[34], cst_0_0_24_24$0),
        _n_
    ], _p_ = [
        0,
        caml_call2(Stdlib[37], _o_, _k_)
    ], website = caml_call3(Brr_svg[3][74], 0, _p_, _j_), _q_ = [
        0,
        [
            0,
            caml_call1(Dune_exe_Frontend_util[33], "m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z"),
            0
        ]
    ], _r_ = [
        0,
        caml_call3(Brr_svg[3][64], 0, _q_, 0),
        0
    ], _s_ = caml_call1(Dune_exe_Frontend_util[31], cst_size_5_inline_fill_slate_9), _t_ = [
        0,
        [
            0,
            caml_call1(Dune_exe_Frontend_util[34], "0 0 300 271"),
            _s_
        ]
    ], x = caml_call3(Brr_svg[3][74], 0, _t_, _r_), _u_ = [
        0,
        caml_call1(Dune_exe_Frontend_util[33], "M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z"),
        0
    ], _v_ = [
        0,
        caml_call2(Dune_exe_Frontend_util[25], "clip-rule", cst_evenodd),
        _u_
    ], _w_ = [
        0,
        [
            0,
            caml_call2(Dune_exe_Frontend_util[25], "fill-rule", cst_evenodd),
            _v_
        ]
    ], _x_ = [
        0,
        caml_call3(Brr_svg[3][64], 0, _w_, 0),
        0
    ], _y_ = caml_call1(Dune_exe_Frontend_util[31], cst_size_5_inline_fill_slate_9), _z_ = [
        0,
        [
            0,
            caml_call1(Dune_exe_Frontend_util[34], "0 0 98 96"),
            _y_
        ]
    ], github = caml_call3(Brr_svg[3][74], 0, _z_, _x_), Icons = [
        0,
        website,
        x,
        github
    ], cst_Close = "Close", cst_md_hidden_text_blue_500_fo = "md:hidden text-blue-500 font-semibold", cst_a_b_b_c_a_c = cst_a_b_b_c_a_c$2, cst_torch_einsum = "torch.einsum", cst_notation_which_is_the_same = " notation (which is the same as ", cst_numpy_einsum = cst_numpy_einsum$2, cst_or_as = " or as ", cst_Einops_notation = "Einops notation", cst_https_einops_rocks_why_use = "https://einops.rocks/#why-use-einops-notation", cst_This_input_is_valid_as_eit = "This input is valid as either ", cst_We_accept_either = "We accept either ", cst_numpy_einsum$0 = cst_numpy_einsum$2, cst_Switch_to = "Switch to ", _A_ = [
        0,
        1
    ], cst_We_ve_interpreted_it_as_Ei = "We've interpreted it as Einops notation.", cst_Switch_to_Einops = "Switch to Einops", _B_ = [
        0,
        0
    ], cst_notation = " notation.", cst_numpy_einsum$1 = cst_numpy_einsum$2, cst_We_ve_interpreted_it_as = "We've interpreted it as ", _C_ = [
        0,
        0
    ], _D_ = [
        0,
        [
            15,
            [
                17,
                2,
                0
            ]
        ],
        cst_a$0
    ], _E_ = [
        0,
        1
    ], _F_ = [
        0,
        [
            15,
            [
                17,
                2,
                0
            ]
        ],
        cst_a$0
    ], cst_High_level_tensor_diagram = "High-level: tensor diagram", cst_text_xl_mt_3_mb_1 = cst_text_xl_mt_3_mb_1$2, cst_Medium_level = "Medium-level", cst_text_xl_mt_3_mb_1$0 = cst_text_xl_mt_3_mb_1$2, cst_before_content_after_conte = cst_before_content_after_conte$1, cst_flex_flex_row_my_4 = cst_flex_flex_row_my_4$1, cst_instead_of_iterating_over_ = ") instead of iterating over each summation index individually.", cst_np_sum_inputs = "np.sum(inputs)", cst_In_this_next_version_of_th = "In this next version of the code, we use the Frobenius product (", cst_before_content_after_conte$0 = cst_before_content_after_conte$1, cst_flex_flex_row_my_4$0 = cst_flex_flex_row_my_4$1, cst_array_and_then_iterate_ove = " array and then iterate over every position in every axis, building up the result.", cst_result = "result", cst_to_sum_over_each_product_t = ") to sum over each product term. First, here's equivalent, simplified (but slow, because it's not vectorized) Python code. We initialize an empty ", cst_while_in_inner_loops_we_it = "), while in inner loops we iterate over all summation indices (", cst_In_outer_loops_we_iterate_ = "In outer loops, we iterate over all free indices to generate each output element (", cst_Low_level_Python_Code = "Low-level: Python Code", cst_text_xl_mt_3_mb_1$1 = cst_text_xl_mt_3_mb_1$2, cst_Isometric_diagrams_are_onl = "Isometric diagrams are only available if all tensors (and all intermediate tensors, which may be bigger than all inputs and the output!) are of dimension 3 or less.", cst_text_red_600 = "text-red-600", cst_Broadcasting_is_a_techniqu = "Broadcasting is a technique used in numpy and other libraries to allow operations on arrays of different shapes. For example, if you have a 3x3 matrix and a 3x1 vector, numpy will automatically expand the vector to a 3x3 matrix by repeating the vector along the second axis. ", cst_https_github_com_joelburge = "https://github.com/joelburget/einsum-tutorial", cst_https_x_com_joel_burget = "https://x.com/joel_burget", cst_https_joelburget_com = "https://joelburget.com", cst_Built_by_Joel_Burget = "Built by Joel Burget ", cst_flex_flex_row_gap_4_mt_4 = "flex flex-row gap-4 mt-4", cst_Einsum_is_All_you_Need_Ein = "Einsum is All you Need - Einstein Summation in Deep Learning", cst_https_rockt_ai_2018_04_30_ = cst_https_rockt_ai_2018_04_30_$1, cst_Stack_Overflow_How_is_nump = "Stack Overflow: How is numpy.einsum implemented?", cst_https_stackoverflow_com_qu = "https://stackoverflow.com/questions/72952005/how-is-numpy-einsum-implemented", cst_ajcr_s_A_basic_introductio = "ajcr's A basic introduction to NumPy's einsum", cst_https_ajcr_net_Basic_guide = "https://ajcr.net/Basic-guide-to-einsum/", cst_Olexa_Bilaniuk_s_Einstein_ = "Olexa Bilaniuk's Einstein Summation in Numpy", cst_https_obilaniu6266h16_word = "https://obilaniu6266h16.wordpress.com/2016/02/04/einstein-summation-in-numpy/", cst_Other_Resources = "Other Resources", cst_source_code = "source code", cst_https_github_com_Transform = "https://github.com/TransformerLensOrg/TransformerLens/blob/3267a43ebcd7e42121fc1c568568165b073f4a9f/transformer_lens/utilities/attention.py", cst_see = " (see ", cst_batch_pos_head_index_d_mod = "batch pos head_index d_model, head_index d_model d_head -> batch pos head_index d_head", cst_batch_head_index_q_pos_d_m = "batch head_index q_pos d_model, batch head_index k_pos d_model -> batch head_index q_pos k_pos", cst_Attention = "Attention:", cst_Batch_matrix_multiplicatio = " (Batch matrix multiplication)", cst_batch_i_j_batch_j_k_batch_ = "batch i j, batch j k -> batch i k", cst_Machine_Learning = "Machine Learning", cst_Tim_Rockt_schel_s_post = "Tim Rockt\xc3\xa4schel's post", cst_https_rockt_ai_2018_04_30_$0 = cst_https_rockt_ai_2018_04_30_$1, cst_bilinear_transformation_se = " (bilinear transformation, see ", cst_i_k_j_k_l_i_l_i_j = "i k, j k l, i l -> i j", cst_outer_product = " (outer product)", cst_i_j_i_j = "i, j -> i j", cst_Hadamard_product = " (Hadamard product)", cst_i_j_i_j_i_j = cst_i_j_i_j_i_j$1, cst_inner_product = " (inner product)", cst_i_i = "i, i ->", cst_row_sum = " (row sum)", cst_i_j_i = cst_i_j_i$1, cst_column_sum = " (column sum)", cst_i_j_j = cst_i_j_j$2, cst_trace = " (trace)", cst_i_i$0 = "i i ->", cst_matrix_vector_product = " (matrix-vector product)", cst_a_b_b_a = "a b, b -> a", cst_matrix_multiplication = " (matrix multiplication)", cst_a_b_b_c_a_c$0 = cst_a_b_b_c_a_c$2, cst_Linear_Algebra = "Linear Algebra", cst_Now_that_we_ve_defined_wha = "Now that we've defined what einsums are doing and given basic examples, here are some examples you might come across in practice.", cst_Examples = "Examples", cst_for_more$0 = cst_for_more$1, cst_opt_einsum_docs = "opt_einsum docs", cst_https_dgasmith_github_io_o = "https://dgasmith.github.io/opt_einsum/paths/introduction/", cst_See_the = ". See the ", cst_quickly = "quickly", cst_https_en_wikipedia_org_wik = "https://en.wikipedia.org/wiki/Matrix_chain_multiplication", cst_grows = "grows", cst_https_en_wikipedia_org_wik$0 = "https://en.wikipedia.org/wiki/Catalan_number", cst_The_general_problem_of_fin = "The general problem of finding the optimal path is NP-hard (the number of possible ways of reducing n tensors ", cst_shows_an_example_where_the = " shows an example where the same reduction takes 3000x longer without optimization.", cst_opt_einsum = "opt_einsum", cst_https_github_com_dgasmith_ = "https://github.com/dgasmith/opt_einsum", cst_A_group_of_tensors_is_redu = "A group of tensors is reduced one pair at a time. The result will be the same no matter which order tensors were reduced in, but different orders can have vastly different performance characteristics. ", cst_Bonus_How_Contractions_Are = "Bonus: How Contractions Are Actually Computed", cst_I_suspect_that_in_practice = 'I suspect that in practice, people often approach tensor contractions with an "if it compiles, it works" attitude. You dump all of the tensors you need in, and tell einsum the shape you want out, and it tends to do the right thing.', cst_Above_I_classified_dimensi = "Above I classified dimensions in three ways: input, output, or different pieces of data. Using the co / contravariant lens, we can see that it's equally valid to think of just two categories, where inputs are contravariant, and both outputs and different pieces of data are covariant.", cst_In_physics_there_s_no_ambi = "In physics there's no ambiguity because physicists use special notation to distinguish outputs and inputs (or what they call co / contravariant). In physics, a contraction happens by pairing a covariant and a contravariant index. This ensures that you're connecting an output (or data) (covariant) to an input (contravariant).", cst_and_multiplied_on_the_righ = " and multiplied on the right.", cst_a_b = "a -> b", cst_to_be_interpreted_as_a_fun = " to be interpreted as a function ", cst_a_b$0 = cst_a_b$2, cst_and_you_multiply_it_on_the = ", and you multiply it on the left, but it sometimes happens that it's more convenient for ", cst_b_a = "b -> a", cst_is_an_output_or_vice_versa = " is an output or vice-versa. The convention in math is for that shape of matrix to be interpreted as a function ", cst_b = "b", cst_is_an_input_and = " is an input and ", cst_a = "a", cst_that_s_not_enough_informat = ", that's not enough information to say whether ", cst_a_b$1 = cst_a_b$2, cst_Unfortunately_when_you_see = "Unfortunately, when you see a matrix with type ", cst_a_b_b_c_a_c$1 = cst_a_b_b_c_a_c$2, cst_and_matrix_multiplication_ = ") and matrix multiplication (composing two functions: ", cst_a_b_a_b = "a b, a -> b", cst_When_you_see_two_tensors_c = "When you see two tensors contracted along some dimension, the typical interpretation is data flow, and the prototypical examples are the matrix-vector product (applying some transformation to data: ", cst_we_can_make_a_pretty_good_ = " we can make a pretty good guess. In fact, those three dimensions correspond to the three roles I just mentioned (batch is a typical name for different pieces of data processed in parallel).", cst_batch_d_in_d_out = "batch d_in d_out", cst_and_say_what_each_dimensio = " and say what each dimension represents. But given a tensor labeled ", cst_a_b_c = "a b c", cst_Because_tensors_are_just_n = "Because tensors are just n-dimensional grids of numbers, we can't look at a tensor labeled ", cst_Different_pieces_of_data_b = "Different pieces of data being operated on in parallel", cst_Output_from_a_computation = "Output from a computation", cst_Input_to_a_computation = "Input to a computation", cst_Finally_on_the_highest_lev = "Finally, on the highest level, I think of dimensions as fulfilling three different roles:", cst_Concisely_diagonalize_make = "Concisely: diagonalize, make the same shape (broadcast / reorder), align, and contract.", cst_Contract_all_summation_ind = "Contract all summation indices (those which don't appear in the output) by summing across them.", cst_Pointwise_multiply_each_te = "Pointwise multiply each tensor, giving a single tensor with maximal dimension (it has one axis for each unique input dimension).", cst_and_reorder_as_necessary_t = " and reorder as necessary to make each input tensor the same shape.", cst_Broadcast = "Broadcast", cst_For_each_input_tensor_with = "For each input tensor with repeated indices, extract the values on the diagonal, producing a new tensor of smaller dimension. Now each input tensor has uniquely named dimensions.", cst_to_confirm_that_it_is_cons = " to confirm that it is consistent with the other two.", cst_script = "script", cst_https_github_com_joelburge$0 = "https://github.com/joelburget/einsum-tutorial/blob/main/verify_consistency.py", cst_I_hadn_t_previously_seen_t = "I hadn't previously seen this interpretation, so I wrote a ", cst_Second_on_the_middle_level = "Second, on the middle level (see isometric diagrams):", cst_For_each_cell_in_the_outpu = "For each cell in the output, loop over each summation index. This gives a unique location in each input tensor. You multiply the values in each tensor and add this product to the current cell.", cst_The_free_indices_define_th = "The free indices define the shape of the output (this gives rise to a loop over each free index in the code).", cst_Classify_each_index_as_fre = "Classify each index as free (if it occurs in the output) or summation (if not).", cst_First_at_the_lowest_level_ = "First, at the lowest level, which is useful for defining the operational semantics of einsum but inefficient to compute (see Python code) and not very insightful:", cst_There_are_at_least_three_w = "There are at least three ways of thinking about what an einsum is doing, at increasing levels of abstraction.", cst_Three_ways_to_think_about_ = "Three ways to think about contractions", cst_Hadamard_product$0 = "Hadamard product", cst_https_en_wikipedia_org_wik$1 = "https://en.wikipedia.org/wiki/Hadamard_product_(matrices)", cst_is_the_element_wise_produc = " is the element-wise product of two matrices. In general, we can always combine two tensors of the same shape in this way. This is called the ", cst_i_j_i_j_i_j$0 = cst_i_j_i_j_i_j$1, cst_is_the_element_wise_produc$0 = " is the element-wise product of two vectors. Likewise, ", cst_i_i_i = "i, i -> i", cst_There_s_one_more_basic_ope = "There's one more basic operation. So far, we've been operating on a single tensor, but an einsum can act on any number of tensors. ", cst_5_element_wise_product = "5. element-wise product", cst_is_invalid = ") is invalid.", cst_i_i_i$0 = "i -> i i", cst_Repeating_a_dimension_in_a = "Repeating a dimension in an output (", cst_i_i_i_i = "i i i -> i", cst_It_s_also_possible_to_repe = "). It's also possible to repeat an index three or more times (", cst_arr_i_i_for_i_in_d_i = "[arr[i, i] for i in d_i]", cst_You_can_think_of_this_as_u = "). You can think of this as using the same variable to iterate over both dimensions (", cst_i_i_i$1 = "i i -> i", cst_If_a_dimension_is_repeated = "If a dimension is repeated in an input tensor, we take a diagonal (", cst_4_diagonal = "4. diagonal", cst_On_a_higher_level_you_can_ = "On a higher level, you can think of the distinction being about which dimensions are preserved vs contracted.", cst_On_a_low_level_free_indice = "On a low level, free indices are associated with outer loops, one loop for each dimension of the output. While summation indices are associated with inner loops, which are run for each value in the output.", cst_is_an_example_of_a_summed_ = " is an example of a summed index. Free indices appear in the output specification, while summation indices don't.", cst_i = cst_i$5, cst_is_an_example_of_a_free_in = " is an example of a free index, while ", cst_j = cst_j$3, cst_indices_act_differently = " indices act differently. ", cst_j$0 = cst_j$3, cst_and = cst_and$2, cst_i$0 = cst_i$5, cst_you_may_notice_that_the = ", you may notice that the ", cst_i_j_j$0 = cst_i_j_j$2, cst_In_an_example_like = "In an example like ", cst_Terminology_free_and_summa = "Terminology: free and summation indices", cst_do = " do?", cst_i_j_i$0 = cst_i_j_i$1, cst_and$0 = cst_and$2, cst_i_j_j$1 = cst_i_j_j$2, cst_sums_a_matrix_Can_you_expl = " sums a matrix. Can you explain what ", cst_i_j = "i j ->", cst_sums_a_vector = " sums a vector. ", cst_i$1 = "i ->", cst_So_far_we_ve_just_rearrang = "So far we've just rearranged tensors. You can also sum across a dimension by omitting it from the result. So ", cst_3_sum = "3. sum", cst_But_einsums_can_t_do_this = ". But einsums can't do this.", cst_3_2_1 = "<3 2 1>", cst_to = " to ", cst_1_2_3 = "<1 2 3>", cst_As_an_aside_you_may_wonder = "As an aside, you may wonder whether there's a way to reverse the direction of a dimension. For example, reverse ", cst_So_this_operation_is_the_t = ". So this operation is the transpose.", cst_j$1 = cst_j$3, cst_changes_from_the_row_dimen = " changes from the row dimension to the column dimension, and likewise with ", cst_i$2 = cst_i$5, cst_dimensions = " dimensions. ", cst_j$2 = cst_j$3, cst_and$1 = cst_and$2, cst_i$3 = cst_i$5, cst_swaps_the_positions_of_the = " swaps the positions of the ", cst_i_j_j_i = "i j -> j i", cst_The_ordering_of_labels_mat = "The ordering of labels matters. ", cst_2_transpose = "2. transpose", cst_is_the_identity_operation_ = " is the identity operation on 3-dimensional tensors.", cst_i_j_k_i_j_k = "i j k -> i j k", cst_is_the_identity_operation_$0 = " is the identity operation on matrices, and ", cst_i_j_i_j$0 = "i j -> i j", cst_and_returns_the_same_vecto = ") and returns the same vector. Likewise ", cst_i$4 = cst_i$5, cst_takes_a_vector_the_fact_th = " takes a vector (the fact that a vector is one-dimensional corresponds to the single index, ", cst_i_i$1 = "i -> i", cst_An_einsum_expression_names = "An einsum expression names the axes involved in an operation. ", cst_1_identity = "1. identity", cst_We_ll_start_with_five_simp = "We'll start with five simple examples which illustrate all of the principles you need to understand einsums.", cst_Basic_Operations = "Basic Operations", cst_Though_Einsums_are_easy_to = "Though Einsums are easy to read and to understand on the level of the shapes of the input and output tensors, I initially found it hard to understand what an einsum expression was actually doing. That's why I built this page, where we start from the basics and build up to understanding what complex expressions actually mean.", cst_is_a_compact_and_intuitive = " is a compact and intuitive way to write many linear algebra operations: matrix multiplication, dot / Frobenius product, transpose, trace, as well as many more complex operations which don't have a name.", cst_Einsum_Einstein_summation_ = "Einsum (Einstein summation) notation", cst_https_en_wikipedia_org_wik$2 = "https://en.wikipedia.org/wiki/Einstein_notation", cst_Einsum_in_Depth = "Einsum in Depth", cst_flex_1_md_w_1_2_w_full_ove = "flex-1 md:w-1/2 w-full overflow-y-auto border-r p-4 prose dark:prose-invert prose-p:my-2 prose-pre:bg-gray-100 prose-pre:dark:bg-[#00000080] prose-pre:text-gray-900 prose-pre:dark:text-[#d1d5db]", cst_Click_on_an_example_to_see = "Click on an example to see its explanation here.", cst_Explanation = "Explanation", cst_text_2xl = "text-2xl", cst_flex_items_center_justify_ = "flex items-center justify-between border-b pb-2 mb-4", cst_flex_1_md_w_1_2_w_full_ove$0 = "flex-1 md:w-1/2 w-full overflow-y-auto p-4 bg-gray-50 dark:bg-gray-800 md:static md:translate-y-0 md:relative fixed bottom-0 left-0 right-0 top-0 transform transition-transform duration-300 ease-in-out md:border-none border-t border-gray-300 z-50", cst_Or_enter_your_own_contract = "Or enter your own contraction: ", cst_relative_flex_flex_col_md_ = "relative flex flex-col md:flex-row h-screen";
    function tutorial(container) {
        var match = caml_call2(Note[4][3], 0, 1), set_overlay_hidden = match[2], overlay_hidden_s = match[1], match$0 = caml_call2(Note[4][3], 0, 0), set_syntax_preference = match$0[2], syntax_preference_s = match$0[1], _G_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Close),
            0
        ], _H_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_md_hidden_text_blue_500_fo)
        ], close_button = caml_call3(Brr[9][75], 0, _H_, _G_), match$1 = caml_call1(Note[3][3], 0), send_clicked_op_in_text = match$1[2], clicked_op_in_text_e = match$1[1];
        function example(friendly_spec) {
            function f(param) {
                if (param && param[1]) {
                    var match = caml_call1(Tensor_playground_Einsum_parse[2][1], friendly_spec);
                    if (0 !== match[0]) return friendly_spec;
                    var parsed = match[1], _fd_ = caml_call1(Tensor_playground_Einops[8][6], parsed);
                    return caml_call1(caml_call1(Fmt[96], Tensor_playground_Einops[8][5]), _fd_);
                }
                return friendly_spec;
            }
            var contents_s = caml_call1(caml_call2(Note[4][14], 0, function(preference) {
                return [
                    0,
                    code(f(preference)),
                    0
                ];
            }), syntax_preference_s), button = caml_call3(Brr[9][75], 0, [
                0,
                text_button_classes
            ], 0);
            caml_call2(Note_brr[4][2], button, contents_s);
            var evt = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(param) {
                return 0;
            }, button), _fc_ = caml_call3(Note[3][2], 0, evt, function(param) {
                caml_call2(send_clicked_op_in_text, 0, f(caml_call1(Note[4][6], syntax_preference_s)));
                return caml_call2(set_overlay_hidden, 0, 0);
            });
            caml_call1(Note[2][8], _fc_);
            return button;
        }
        var match$2 = caml_call3(Dune_exe_Frontend_util[40], [
            0,
            Dune_exe_Frontend_util[41]
        ], cst_a_b_b_c_a_c, clicked_op_in_text_e), current_input = match$2[3], c_input = match$2[2], logger = match$2[1];
        caml_call1(Note[2][8], logger);
        var parsed_input_signal = caml_call3(Note[4][14], 0, function(str) {
            var _fb_ = trim_before_colon(str);
            return caml_call1(Tensor_playground_Einsum_parse[3], _fb_);
        }, current_input);
        function interpretation_info(valid_as_both) {
            var _e1_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst$3),
                0
            ], _e2_ = [
                0,
                code(cst_torch_einsum),
                0
            ], _e3_ = [
                0,
                [
                    0,
                    caml_call1(Brr[8][31], "https://pytorch.org/docs/stable/generated/torch.einsum.html"),
                    0
                ]
            ], _e4_ = [
                0,
                caml_call3(Brr[9][61], 0, _e3_, _e2_),
                _e1_
            ], _e5_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_notation_which_is_the_same),
                _e4_
            ], _e6_ = [
                0,
                code(cst_numpy_einsum),
                0
            ], _e7_ = [
                0,
                [
                    0,
                    caml_call1(Brr[8][31], "https://numpy.org/doc/stable/reference/generated/numpy.einsum.html"),
                    0
                ]
            ], _e8_ = [
                0,
                caml_call3(Brr[9][61], 0, _e7_, _e6_),
                _e5_
            ], _e9_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_or_as),
                _e8_
            ], _e__ = [
                0,
                caml_call2(Dune_exe_Frontend_util[48], cst_https_einops_rocks_why_use, cst_Einops_notation),
                _e9_
            ], _e$_ = valid_as_both ? cst_This_input_is_valid_as_eit : cst_We_accept_either, _fa_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, _e$_),
                _e__
            ];
            return caml_call3(Dune_exe_Frontend_util[15], 0, 0, _fa_);
        }
        var _I_ = [
            0,
            code(cst_numpy_einsum$0),
            0
        ], _J_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Switch_to),
            _I_
        ], button = caml_call3(Brr[9][75], 0, [
            0,
            text_button_classes
        ], _J_), click_button_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(evt) {
            caml_call1(Brr[7][10], evt);
            return 0;
        }, button), _K_ = caml_call3(Note[3][2], 0, click_button_event, function(param) {
            return caml_call2(set_syntax_preference, 0, _A_);
        });
        caml_call1(Note[2][8], _K_);
        var _L_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_We_ve_interpreted_it_as_Ei),
            0
        ], _M_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _L_),
            [
                0,
                button,
                0
            ]
        ], _N_ = [
            0,
            interpretation_info(1),
            _M_
        ], interpreted_as_friendly_messag = caml_call3(Dune_exe_Frontend_util[8], 0, 0, _N_), _O_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Switch_to_Einops),
            0
        ], button$0 = caml_call3(Brr[9][75], 0, [
            0,
            text_button_classes
        ], _O_), click_button_event$0 = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(evt) {
            caml_call1(Brr[7][10], evt);
            return 0;
        }, button$0), _P_ = caml_call3(Note[3][2], 0, click_button_event$0, function(param) {
            return caml_call2(set_syntax_preference, 0, _B_);
        });
        caml_call1(Note[2][8], _P_);
        var _Q_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_notation),
            0
        ], _R_ = [
            0,
            code(cst_numpy_einsum$1),
            _Q_
        ], _S_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_We_ve_interpreted_it_as),
            _R_
        ], _T_1 = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _S_),
            [
                0,
                button$0,
                0
            ]
        ], _U_ = [
            0,
            interpretation_info(1),
            _T_1
        ], interpreted_as_original_messag = caml_call3(Dune_exe_Frontend_util[8], 0, 0, _U_);
        function render_explanation(rewrite, syntax_preference) {
            var edge_attributes = caml_call1(Dune_exe_Colors[3], rewrite[1]);
            function text_color(edge_name) {
                var match = caml_call2(Stdlib_Hashtbl[7], edge_attributes, edge_name);
                if (!match) return cst$4;
                var text_classes = match[1][2];
                return text_classes;
            }
            var pyloops = caml_call1(Tensor_playground_Einops[12][1], rewrite), match = caml_call1(Make_formatter[1], 0), code_ppf = match[2], python_code = match[1], _eo_ = caml_call2(Tensor_playground_Einops[11][1], _C_, text_color);
            caml_call4(Fmt[3], code_ppf, _D_, _eo_, pyloops);
            var match$0 = caml_call1(Make_formatter[1], 0), frob_code_ppf = match$0[2], frob_python_code = match$0[1], _ep_ = caml_call2(Tensor_playground_Einops[11][1], _E_, text_color);
            caml_call4(Fmt[3], frob_code_ppf, _F_, _ep_, pyloops);
            var free_indices = caml_call1(Dune_exe_Frontend_util[1][37], pyloops[1]), summation_indices = caml_call1(Dune_exe_Frontend_util[1][37], pyloops[2]), rhs = rewrite[2], lhs = rewrite[1], _eq_ = [
                0,
                caml_call3(Dune_exe_Tensor_diagram[1], edge_attributes, lhs, rhs),
                0
            ], _er_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[8], 0, 0, _eq_),
                0
            ], _es_ = [
                0,
                mk_tensor_diagram_info(0),
                0
            ], _et_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_High_level_tensor_diagram),
                _es_
            ], _eu_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_text_xl_mt_3_mb_1)
            ], _ev_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[20], 0, _eu_, _et_),
                _er_
            ], match$1 = caml_call6(Dune_exe_Isometric[2][1], 0, 0, 0, edge_attributes, lhs, rhs);
            if (match$1) var render = match$1[1], _ew_ = [
                0,
                render,
                0
            ];
            else var _ew_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_Isometric_diagrams_are_onl),
                0
            ];
            var _ex_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[8], 0, 0, _ew_),
                _ev_
            ], _ey_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_Medium_level),
                0
            ], _ez_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_text_xl_mt_3_mb_1$0)
            ], _eA_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[20], 0, _ez_, _ey_),
                _ex_
            ], _eB_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_before_content_after_conte)
            ], _eC_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[3], 0, _eB_, [
                    0,
                    frob_python_code,
                    0
                ]),
                0
            ], _eD_ = [
                0,
                caml_call3(Brr[9][134], 0, 0, _eC_),
                0
            ], _eE_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_flex_flex_row_my_4)
            ], _eF_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[8], 0, _eE_, _eD_),
                _eA_
            ], _eG_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_instead_of_iterating_over_),
                0
            ], _eH_ = [
                0,
                code(cst_np_sum_inputs),
                _eG_
            ], _eI_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_In_this_next_version_of_th),
                _eH_
            ], _eJ_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[15], 0, 0, _eI_),
                _eF_
            ], _eK_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_before_content_after_conte$0)
            ], _eL_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[3], 0, _eK_, [
                    0,
                    python_code,
                    0
                ]),
                0
            ], _eM_ = [
                0,
                caml_call3(Brr[9][134], 0, 0, _eL_),
                0
            ], _eN_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_flex_flex_row_my_4$0)
            ], _eO_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[8], 0, _eN_, _eM_),
                _eJ_
            ], _eP_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_array_and_then_iterate_ove),
                0
            ], _eQ_ = [
                0,
                code(cst_result),
                _eP_
            ], _eR_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_to_sum_over_each_product_t),
                _eQ_
            ], _eS_ = caml_call2(Dune_exe_Frontend_util[50], text_color, summation_indices), _eT_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[9], 0, 0, _eS_),
                _eR_
            ], _eU_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_while_in_inner_loops_we_it),
                _eT_
            ], _eV_ = caml_call2(Dune_exe_Frontend_util[50], text_color, free_indices), _eW_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[9], 0, 0, _eV_),
                _eU_
            ], _eX_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_In_outer_loops_we_iterate_),
                _eW_
            ], _eY_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[15], 0, 0, _eX_),
                _eO_
            ], _eZ_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_Low_level_Python_Code),
                0
            ], _e0_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_text_xl_mt_3_mb_1$1)
            ];
            return [
                0,
                caml_call3(Dune_exe_Frontend_util[20], 0, _e0_, _eZ_),
                _eY_
            ];
        }
        var explanation_message_s = caml_call4(Note[4][26], 0, function(rewrites, syntax_preference) {
            var _el_ = rewrites[1];
            a: if (0 === _el_[0]) {
                var match = rewrites[2], friendly_rewrite = _el_[1];
                if (0 === match[0]) {
                    var original_rewrite = match[1];
                    if (syntax_preference && syntax_preference[1]) {
                        var opt_syntax_preference_message = [
                            0,
                            interpreted_as_original_messag
                        ], opt_syntax_preference_message$0 = opt_syntax_preference_message, explanation = render_explanation(original_rewrite, syntax_preference);
                        break a;
                    }
                    var opt_syntax_preference_message$1 = [
                        0,
                        interpreted_as_friendly_messag
                    ], opt_syntax_preference_message$0 = opt_syntax_preference_message$1, explanation = render_explanation(friendly_rewrite, syntax_preference);
                } else var opt_syntax_preference_message$0 = 0, explanation = render_explanation(friendly_rewrite, syntax_preference);
            } else {
                var msg$0 = _el_[1], match$0 = rewrites[2];
                if (0 === match$0[0]) var rewrite = match$0[1], opt_syntax_preference_message$0 = 0, explanation = render_explanation(rewrite, syntax_preference);
                else var _em_ = [
                    0,
                    caml_call2(Dune_exe_Frontend_util[10], 0, msg$0),
                    0
                ], _en_ = [
                    0,
                    caml_call1(Dune_exe_Frontend_util[29], cst_text_red_600)
                ], explanation$0 = [
                    0,
                    caml_call3(Dune_exe_Frontend_util[8], 0, _en_, _em_),
                    0
                ], opt_syntax_preference_message$0 = 0, explanation = explanation$0;
            }
            if (opt_syntax_preference_message$0) var msg = opt_syntax_preference_message$0[1], syntax_preference_message = msg;
            else var syntax_preference_message = interpretation_info(0);
            return [
                0,
                explanation,
                syntax_preference_message
            ];
        }, parsed_input_signal, syntax_preference_s);
        function a(href, text) {
            var _eh_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, text),
                0
            ], _ei_ = [
                0,
                caml_call1(Brr[8][19], "underline"),
                0
            ], _ej_ = [
                0,
                caml_call2(Brr[8][1], cst_target, cst_blank),
                _ei_
            ], _ek_ = [
                0,
                [
                    0,
                    caml_call2(Brr[8][1], "href", caml_jsstring_of_string(href)),
                    _ej_
                ]
            ];
            return caml_call3(Brr[9][61], 0, _ek_, _eh_);
        }
        var _V_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Broadcasting_is_a_techniqu),
            0
        ], broadcast_info = caml_call3(Dune_exe_Frontend_util[8], 0, 0, _V_);
        function icon_link(link_location, icon) {
            var _ee_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[24], icon),
                0
            ], _ef_ = [
                0,
                caml_call2(Brr[8][1], cst_target, cst_blank),
                0
            ], _eg_ = [
                0,
                [
                    0,
                    caml_call1(Brr[8][31], caml_jsstring_of_string(link_location)),
                    _ef_
                ]
            ];
            return caml_call3(Brr[9][61], 0, _eg_, _ee_);
        }
        var _W_ = [
            0,
            icon_link(cst_https_github_com_joelburge, Icons[3]),
            0
        ], _X_ = [
            0,
            icon_link(cst_https_x_com_joel_burget, Icons[2]),
            _W_
        ], _Y_ = [
            0,
            icon_link(cst_https_joelburget_com, Icons[1]),
            _X_
        ], _Z_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Built_by_Joel_Burget),
            _Y_
        ], ___ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_flex_flex_row_gap_4_mt_4)
        ], _$_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, ___, _Z_),
            0
        ], _aa_ = [
            0,
            a(cst_https_rockt_ai_2018_04_30_, cst_Einsum_is_All_you_Need_Ein),
            0
        ], _ab_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aa_),
            0
        ], _ac_ = [
            0,
            a(cst_https_stackoverflow_com_qu, cst_Stack_Overflow_How_is_nump),
            0
        ], _ad_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ac_),
            _ab_
        ], _ae_ = [
            0,
            a(cst_https_ajcr_net_Basic_guide, cst_ajcr_s_A_basic_introductio),
            0
        ], _af_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ae_),
            _ad_
        ], _ag_ = [
            0,
            a(cst_https_obilaniu6266h16_word, cst_Olexa_Bilaniuk_s_Einstein_),
            0
        ], _ah_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ag_),
            _af_
        ], _ai_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _ah_),
            _$_
        ], _aj_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Other_Resources),
            0
        ], _ak_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[20], 0, 0, _aj_),
            _ai_
        ], _al_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$5),
            0
        ], _am_ = [
            0,
            a(cst_https_github_com_Transform, cst_source_code),
            _al_
        ], _an_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_see),
            _am_
        ], _ao_ = [
            0,
            example(cst_batch_pos_head_index_d_mod),
            _an_
        ], _ap_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ao_),
            0
        ], _aq_ = [
            0,
            example(cst_batch_head_index_q_pos_d_m),
            0
        ], _ar_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aq_),
            _ap_
        ], _as_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _ar_),
            0
        ], _at_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Attention),
            _as_
        ], _au_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _at_),
            0
        ], _av_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Batch_matrix_multiplicatio),
            0
        ], _aw_ = [
            0,
            example(cst_batch_i_j_batch_j_k_batch_),
            _av_
        ], _ax_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aw_),
            _au_
        ], _ay_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _ax_),
            _ak_
        ], _az_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Machine_Learning),
            0
        ], _aA_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[20], 0, 0, _az_),
            _ay_
        ], _aB_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$6),
            0
        ], _aC_ = [
            0,
            a(cst_https_rockt_ai_2018_04_30_$0, cst_Tim_Rockt_schel_s_post),
            _aB_
        ], _aD_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_bilinear_transformation_se),
            _aC_
        ], _aE_ = [
            0,
            example(cst_i_k_j_k_l_i_l_i_j),
            _aD_
        ], _aF_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aE_),
            0
        ], _aG_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_outer_product),
            0
        ], _aH_ = [
            0,
            example(cst_i_j_i_j),
            _aG_
        ], _aI_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aH_),
            _aF_
        ], _aJ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Hadamard_product),
            0
        ], _aK_ = [
            0,
            example(cst_i_j_i_j_i_j),
            _aJ_
        ], _aL_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aK_),
            _aI_
        ], _aM_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_inner_product),
            0
        ], _aN_ = [
            0,
            example(cst_i_i),
            _aM_
        ], _aO_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aN_),
            _aL_
        ], _aP_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_row_sum),
            0
        ], _aQ_ = [
            0,
            example(cst_i_j_i),
            _aP_
        ], _aR_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aQ_),
            _aO_
        ], _aS_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_column_sum),
            0
        ], _aT_ = [
            0,
            example(cst_i_j_j),
            _aS_
        ], _aU_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aT_),
            _aR_
        ], _aV_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_trace),
            0
        ], _aW_ = [
            0,
            example(cst_i_i$0),
            _aV_
        ], _aX_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aW_),
            _aU_
        ], _aY_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_matrix_vector_product),
            0
        ], _aZ_ = [
            0,
            example(cst_a_b_b_a),
            _aY_
        ], _a0_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aZ_),
            _aX_
        ], _a1_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_matrix_multiplication),
            0
        ], _a2_ = [
            0,
            example(cst_a_b_b_c_a_c$0),
            _a1_
        ], _a3_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _a2_),
            _a0_
        ], _a4_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _a3_),
            _aA_
        ], _a5_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Linear_Algebra),
            0
        ], _a6_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[20], 0, 0, _a5_),
            _a4_
        ], _a7_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Now_that_we_ve_defined_wha),
            0
        ], _a8_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _a7_),
            _a6_
        ], _a9_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Examples),
            0
        ], _a__ = [
            0,
            caml_call3(Dune_exe_Frontend_util[19], 0, 0, _a9_),
            _a8_
        ], _a$_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_for_more$0),
            0
        ], _ba_ = [
            0,
            a(cst_https_dgasmith_github_io_o, cst_opt_einsum_docs),
            _a$_
        ], _bb_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_See_the),
            _ba_
        ], _bc_ = [
            0,
            a(cst_https_en_wikipedia_org_wik, cst_quickly),
            _bb_
        ], _bd_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$7),
            _bc_
        ], _be_ = [
            0,
            a(cst_https_en_wikipedia_org_wik$0, cst_grows),
            _bd_
        ], _bf_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_The_general_problem_of_fin),
            _be_
        ], _bg_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bf_),
            _a__
        ], _bh_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_shows_an_example_where_the),
            0
        ], _bi_ = [
            0,
            a(cst_https_github_com_dgasmith_, cst_opt_einsum),
            _bh_
        ], _bj_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_A_group_of_tensors_is_redu),
            _bi_
        ], _bk_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bj_),
            _bg_
        ], _bl_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Bonus_How_Contractions_Are),
            0
        ], _bm_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _bl_),
            _bk_
        ], _bn_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_I_suspect_that_in_practice),
            0
        ], _bo_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bn_),
            _bm_
        ], _bp_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Above_I_classified_dimensi),
            0
        ], _bq_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bp_),
            _bo_
        ], _br_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_In_physics_there_s_no_ambi),
            0
        ], _bs_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _br_),
            _bq_
        ], _bt_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_multiplied_on_the_righ),
            0
        ], _bu_ = [
            0,
            code(cst_a_b),
            _bt_
        ], _bv_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_to_be_interpreted_as_a_fun),
            _bu_
        ], _bw_ = [
            0,
            code(cst_a_b$0),
            _bv_
        ], _bx_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_you_multiply_it_on_the),
            _bw_
        ], _by_ = [
            0,
            code(cst_b_a),
            _bx_
        ], _bz_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_an_output_or_vice_versa),
            _by_
        ], _bA_ = [
            0,
            code(cst_b),
            _bz_
        ], _bB_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_an_input_and),
            _bA_
        ], _bC_ = [
            0,
            code(cst_a),
            _bB_
        ], _bD_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_that_s_not_enough_informat),
            _bC_
        ], _bE_ = [
            0,
            code(cst_a_b$1),
            _bD_
        ], _bF_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Unfortunately_when_you_see),
            _bE_
        ], _bG_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bF_),
            _bs_
        ], _bH_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$8),
            0
        ], _bI_ = [
            0,
            example(cst_a_b_b_c_a_c$1),
            _bH_
        ], _bJ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_matrix_multiplication_),
            _bI_
        ], _bK_ = [
            0,
            example(cst_a_b_a_b),
            _bJ_
        ], _bL_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_When_you_see_two_tensors_c),
            _bK_
        ], _bM_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bL_),
            _bG_
        ], _bN_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_we_can_make_a_pretty_good_),
            0
        ], _bO_ = [
            0,
            code(cst_batch_d_in_d_out),
            _bN_
        ], _bP_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_say_what_each_dimensio),
            _bO_
        ], _bQ_ = [
            0,
            code(cst_a_b_c),
            _bP_
        ], _bR_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Because_tensors_are_just_n),
            _bQ_
        ], _bS_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bR_),
            _bM_
        ], _bT_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Different_pieces_of_data_b),
            0
        ], _bU_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _bT_),
            0
        ], _bV_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Output_from_a_computation),
            0
        ], _bW_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _bV_),
            _bU_
        ], _bX_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Input_to_a_computation),
            0
        ], _bY_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _bX_),
            _bW_
        ], _bZ_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _bY_),
            _bS_
        ], _b0_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Finally_on_the_highest_lev),
            0
        ], _b1_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _b0_),
            _bZ_
        ], _b2_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Concisely_diagonalize_make),
            0
        ], _b3_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _b2_),
            _b1_
        ], _b4_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Contract_all_summation_ind),
            0
        ], _b5_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _b4_),
            0
        ], _b6_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Pointwise_multiply_each_te),
            0
        ], _b7_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _b6_),
            _b5_
        ], _b8_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_reorder_as_necessary_t),
            0
        ], _b9_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[47], broadcast_info),
            _b8_
        ], _b__ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Broadcast),
            _b9_
        ], _b$_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _b__),
            _b7_
        ], _ca_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_For_each_input_tensor_with),
            0
        ], _cb_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ca_),
            _b$_
        ], _cc_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _cb_),
            _b3_
        ], _cd_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_to_confirm_that_it_is_cons),
            0
        ], _ce_ = [
            0,
            a(cst_https_github_com_joelburge$0, cst_script),
            _cd_
        ], _cf_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_I_hadn_t_previously_seen_t),
            _ce_
        ], _cg_ = caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cf_), _ch_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[47], _cg_),
            0
        ], _ci_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Second_on_the_middle_level),
            _ch_
        ], _cj_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _ci_),
            _cc_
        ], _ck_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_For_each_cell_in_the_outpu),
            0
        ], _cl_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ck_),
            0
        ], _cm_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_The_free_indices_define_th),
            0
        ], _cn_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _cm_),
            _cl_
        ], _co_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Classify_each_index_as_fre),
            0
        ], _cp_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _co_),
            _cn_
        ], _cq_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _cp_),
            _cj_
        ], _cr_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_First_at_the_lowest_level_),
            0
        ], _cs_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cr_),
            _cq_
        ], _ct_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_There_are_at_least_three_w),
            0
        ], _cu_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _ct_),
            _cs_
        ], _cv_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Three_ways_to_think_about_),
            0
        ], _cw_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[19], 0, 0, _cv_),
            _cu_
        ], _cx_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$9),
            0
        ], _cy_ = [
            0,
            a(cst_https_en_wikipedia_org_wik$1, cst_Hadamard_product$0),
            _cx_
        ], _cz_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_the_element_wise_produc),
            _cy_
        ], _cA_ = [
            0,
            example(cst_i_j_i_j_i_j$0),
            _cz_
        ], _cB_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_the_element_wise_produc$0),
            _cA_
        ], _cC_ = [
            0,
            example(cst_i_i_i),
            _cB_
        ], _cD_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_There_s_one_more_basic_ope),
            _cC_
        ], _cE_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cD_),
            _cw_
        ], _cF_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_5_element_wise_product),
            0
        ], _cG_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _cF_),
            _cE_
        ], _cH_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_invalid),
            0
        ], _cI_ = [
            0,
            example(cst_i_i_i$0),
            _cH_
        ], _cJ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Repeating_a_dimension_in_a),
            _cI_
        ], _cK_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cJ_),
            _cG_
        ], _cL_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$10),
            0
        ], _cM_ = [
            0,
            example(cst_i_i_i_i),
            _cL_
        ], _cN_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_It_s_also_possible_to_repe),
            _cM_
        ], _cO_ = [
            0,
            code(cst_arr_i_i_for_i_in_d_i),
            _cN_
        ], _cP_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_You_can_think_of_this_as_u),
            _cO_
        ], _cQ_ = [
            0,
            example(cst_i_i_i$1),
            _cP_
        ], _cR_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_If_a_dimension_is_repeated),
            _cQ_
        ], _cS_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cR_),
            _cK_
        ], _cT_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_4_diagonal),
            0
        ], _cU_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _cT_),
            _cS_
        ], _cV_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_On_a_higher_level_you_can_),
            0
        ], _cW_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cV_),
            _cU_
        ], _cX_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_On_a_low_level_free_indice),
            0
        ], _cY_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cX_),
            _cW_
        ], _cZ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_an_example_of_a_summed_),
            0
        ], _c0_ = [
            0,
            code(cst_i),
            _cZ_
        ], _c1_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_an_example_of_a_free_in),
            _c0_
        ], _c2_ = [
            0,
            code(cst_j),
            _c1_
        ], _c3_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_indices_act_differently),
            _c2_
        ], _c4_ = [
            0,
            code(cst_j$0),
            _c3_
        ], _c5_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and),
            _c4_
        ], _c6_ = [
            0,
            code(cst_i$0),
            _c5_
        ], _c7_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_you_may_notice_that_the),
            _c6_
        ], _c8_ = [
            0,
            example(cst_i_j_j$0),
            _c7_
        ], _c9_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_In_an_example_like),
            _c8_
        ], _c__ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _c9_),
            _cY_
        ], _c$_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Terminology_free_and_summa),
            0
        ], _da_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[22], 0, 0, _c$_),
            _c__
        ], _db_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_do),
            0
        ], _dc_ = [
            0,
            example(cst_i_j_i$0),
            _db_
        ], _dd_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and$0),
            _dc_
        ], _de_ = [
            0,
            example(cst_i_j_j$1),
            _dd_
        ], _df_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_sums_a_matrix_Can_you_expl),
            _de_
        ], _dg_ = [
            0,
            example(cst_i_j),
            _df_
        ], _dh_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_sums_a_vector),
            _dg_
        ], _di_ = [
            0,
            example(cst_i$1),
            _dh_
        ], _dj_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_So_far_we_ve_just_rearrang),
            _di_
        ], _dk_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dj_),
            _da_
        ], _dl_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_3_sum),
            0
        ], _dm_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _dl_),
            _dk_
        ], _dn_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_But_einsums_can_t_do_this),
            0
        ], _do_ = [
            0,
            code(cst_3_2_1),
            _dn_
        ], _dp_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_to),
            _do_
        ], _dq_ = [
            0,
            code(cst_1_2_3),
            _dp_
        ], _dr_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_As_an_aside_you_may_wonder),
            _dq_
        ], _ds_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dr_),
            _dm_
        ], _dt_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_So_this_operation_is_the_t),
            0
        ], _du_ = [
            0,
            code(cst_j$1),
            _dt_
        ], _dv_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_changes_from_the_row_dimen),
            _du_
        ], _dw_ = [
            0,
            code(cst_i$2),
            _dv_
        ], _dx_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_dimensions),
            _dw_
        ], _dy_ = [
            0,
            code(cst_j$2),
            _dx_
        ], _dz_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and$1),
            _dy_
        ], _dA_ = [
            0,
            code(cst_i$3),
            _dz_
        ], _dB_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_swaps_the_positions_of_the),
            _dA_
        ], _dC_ = [
            0,
            example(cst_i_j_j_i),
            _dB_
        ], _dD_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_The_ordering_of_labels_mat),
            _dC_
        ], _dE_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dD_),
            _ds_
        ], _dF_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_2_transpose),
            0
        ], _dG_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _dF_),
            _dE_
        ], _dH_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_the_identity_operation_),
            0
        ], _dI_ = [
            0,
            example(cst_i_j_k_i_j_k),
            _dH_
        ], _dJ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_the_identity_operation_$0),
            _dI_
        ], _dK_ = [
            0,
            example(cst_i_j_i_j$0),
            _dJ_
        ], _dL_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_returns_the_same_vecto),
            _dK_
        ], _dM_ = [
            0,
            code(cst_i$4),
            _dL_
        ], _dN_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_takes_a_vector_the_fact_th),
            _dM_
        ], _dO_ = [
            0,
            example(cst_i_i$1),
            _dN_
        ], _dP_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_An_einsum_expression_names),
            _dO_
        ], _dQ_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dP_),
            _dG_
        ], _dR_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_1_identity),
            0
        ], _dS_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _dR_),
            _dQ_
        ], _dT_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_We_ll_start_with_five_simp),
            0
        ], _dU_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dT_),
            _dS_
        ], _dV_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Basic_Operations),
            0
        ], _dW_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[20], 0, 0, _dV_),
            _dU_
        ], _dX_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Though_Einsums_are_easy_to),
            0
        ], _dY_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dX_),
            _dW_
        ], _dZ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_a_compact_and_intuitive),
            0
        ], _d0_ = [
            0,
            a(cst_https_en_wikipedia_org_wik$2, cst_Einsum_Einstein_summation_),
            _dZ_
        ], _d1_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _d0_),
            _dY_
        ], _d2_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Einsum_in_Depth),
            0
        ], _d3_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[19], 0, 0, _d2_),
            _d1_
        ], content = caml_call3(Brr[9][88], 0, 0, _d3_), _d4_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_flex_1_md_w_1_2_w_full_ove)
        ], left_pane = caml_call3(Brr[9][88], 0, _d4_, [
            0,
            content,
            0
        ]), syntax_message_container = caml_call3(Dune_exe_Frontend_util[8], 0, 0, 0), result_container = caml_call3(Dune_exe_Frontend_util[8], 0, 0, 0), _d5_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Click_on_an_example_to_see),
            0
        ], _d6_ = [
            0,
            caml_call3(Brr[9][132], 0, 0, _d5_),
            [
                0,
                syntax_message_container,
                [
                    0,
                    result_container,
                    0
                ]
            ]
        ], _d7_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Explanation),
            0
        ], _d8_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_text_2xl)
        ], _d9_ = [
            0,
            caml_call3(Brr[9][99], 0, _d8_, _d7_),
            [
                0,
                close_button,
                0
            ]
        ], _d__ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_flex_items_center_justify_)
        ], _d$_ = [
            0,
            caml_call3(Brr[9][88], 0, _d__, _d9_),
            _d6_
        ], _ea_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_flex_1_md_w_1_2_w_full_ove$0)
        ], right_pane = caml_call3(Brr[9][88], 0, _ea_, _d$_), explanation_signal = caml_call2(Note[4][30][1], 0, explanation_message_s), syntax_preference_message_s = caml_call2(Note[4][30][2], 0, explanation_message_s);
        caml_call2(Note_brr[4][2], result_container, explanation_signal);
        var _eb_ = caml_call3(Note[4][14], 0, function(msg) {
            var _ed_ = [
                0,
                c_input,
                [
                    0,
                    caml_call1(Dune_exe_Frontend_util[47], msg),
                    0
                ]
            ];
            return [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_Or_enter_your_own_contract),
                _ed_
            ];
        }, syntax_preference_message_s);
        caml_call2(Note_brr[4][2], syntax_message_container, _eb_);
        caml_call3(Note_brr[4][8], "translate-y-full", overlay_hidden_s, right_pane);
        caml_call4(Brr[7][20], 0, Brr[7][45], function(param) {
            return caml_call2(set_overlay_hidden, 0, 1);
        }, close_button);
        var _ec_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_relative_flex_flex_col_md_)
        ], wrapper = caml_call3(Brr[9][88], 0, _ec_, [
            0,
            left_pane,
            [
                0,
                right_pane,
                0
            ]
        ]);
        return caml_call2(Dune_exe_Frontend_util[4], container, [
            0,
            wrapper,
            0
        ]);
    }
    var Dune_exe_Einsum_explanation = [
        0,
        code,
        text_button_classes,
        validate_path,
        validate_inputs,
        trim_before_colon,
        Make_formatter,
        radio,
        Tabs,
        mk_tensor_diagram_info,
        Icons,
        tutorial
    ];
    runtime.caml_register_global(358, Dune_exe_Einsum_explanation, "Dune__exe__Einsum_explanation");
    return;
})(globalThis);
//# 1 ".tensor_playground_web.eobjs/jsoo/dune__exe__Tensor_playground_web.cmo.js"
// Generated by js_of_ocaml
//# 3 ".tensor_playground_web.eobjs/jsoo/dune__exe__Tensor_playground_web.cmo.js"
//# 6 ".tensor_playground_web.eobjs/jsoo/dune__exe__Tensor_playground_web.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Brr = global_data.Brr, Stdlib_Option = global_data.Stdlib__Option, Dune_exe_Einsum_explanation = global_data.Dune__exe__Einsum_explanation, Jv = global_data.Jv;
    function main(param) {
        var _a_ = caml_call2(Brr[10][2], Brr[16][2], "render"), container = caml_call1(Stdlib_Option[4], _a_);
        return caml_call1(Dune_exe_Einsum_explanation[11], container);
    }
    Jv[12]["tensor_playground_main"] = runtime.caml_js_wrap_callback_strict(1, main);
    var Dune_exe_Tensor_playground_web = [
        0,
        main
    ];
    runtime.caml_register_global(6, Dune_exe_Tensor_playground_web, "Dune__exe__Tensor_playground_web");
    return;
})(globalThis);
//# 1 "../.js/default/stdlib/std_exit.cmo.js"
// Generated by js_of_ocaml
//# 3 "../.js/default/stdlib/std_exit.cmo.js"
//# 6 "../.js/default/stdlib/std_exit.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) == 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib;
    caml_call1(Stdlib[103], 0);
    var Std_exit = [
        0
    ];
    runtime.caml_register_global(1, Std_exit, "Std_exit");
    return;
})(globalThis);

});
parcelRegister("48K42", function(module, exports) {
"use strict";

});

parcelRegister("77U2W", function(module, exports) {
module.exports = JSON.parse("{\"O_RDONLY\":0,\"O_WRONLY\":1,\"O_RDWR\":2,\"S_IFMT\":61440,\"S_IFREG\":32768,\"S_IFDIR\":16384,\"S_IFCHR\":8192,\"S_IFBLK\":24576,\"S_IFIFO\":4096,\"S_IFLNK\":40960,\"S_IFSOCK\":49152,\"O_CREAT\":512,\"O_EXCL\":2048,\"O_NOCTTY\":131072,\"O_TRUNC\":1024,\"O_APPEND\":8,\"O_DIRECTORY\":1048576,\"O_NOFOLLOW\":256,\"O_SYNC\":128,\"O_SYMLINK\":2097152,\"O_NONBLOCK\":4,\"S_IRWXU\":448,\"S_IRUSR\":256,\"S_IWUSR\":128,\"S_IXUSR\":64,\"S_IRWXG\":56,\"S_IRGRP\":32,\"S_IWGRP\":16,\"S_IXGRP\":8,\"S_IRWXO\":7,\"S_IROTH\":4,\"S_IWOTH\":2,\"S_IXOTH\":1,\"E2BIG\":7,\"EACCES\":13,\"EADDRINUSE\":48,\"EADDRNOTAVAIL\":49,\"EAFNOSUPPORT\":47,\"EAGAIN\":35,\"EALREADY\":37,\"EBADF\":9,\"EBADMSG\":94,\"EBUSY\":16,\"ECANCELED\":89,\"ECHILD\":10,\"ECONNABORTED\":53,\"ECONNREFUSED\":61,\"ECONNRESET\":54,\"EDEADLK\":11,\"EDESTADDRREQ\":39,\"EDOM\":33,\"EDQUOT\":69,\"EEXIST\":17,\"EFAULT\":14,\"EFBIG\":27,\"EHOSTUNREACH\":65,\"EIDRM\":90,\"EILSEQ\":92,\"EINPROGRESS\":36,\"EINTR\":4,\"EINVAL\":22,\"EIO\":5,\"EISCONN\":56,\"EISDIR\":21,\"ELOOP\":62,\"EMFILE\":24,\"EMLINK\":31,\"EMSGSIZE\":40,\"EMULTIHOP\":95,\"ENAMETOOLONG\":63,\"ENETDOWN\":50,\"ENETRESET\":52,\"ENETUNREACH\":51,\"ENFILE\":23,\"ENOBUFS\":55,\"ENODATA\":96,\"ENODEV\":19,\"ENOENT\":2,\"ENOEXEC\":8,\"ENOLCK\":77,\"ENOLINK\":97,\"ENOMEM\":12,\"ENOMSG\":91,\"ENOPROTOOPT\":42,\"ENOSPC\":28,\"ENOSR\":98,\"ENOSTR\":99,\"ENOSYS\":78,\"ENOTCONN\":57,\"ENOTDIR\":20,\"ENOTEMPTY\":66,\"ENOTSOCK\":38,\"ENOTSUP\":45,\"ENOTTY\":25,\"ENXIO\":6,\"EOPNOTSUPP\":102,\"EOVERFLOW\":84,\"EPERM\":1,\"EPIPE\":32,\"EPROTO\":100,\"EPROTONOSUPPORT\":43,\"EPROTOTYPE\":41,\"ERANGE\":34,\"EROFS\":30,\"ESPIPE\":29,\"ESRCH\":3,\"ESTALE\":70,\"ETIME\":101,\"ETIMEDOUT\":60,\"ETXTBSY\":26,\"EWOULDBLOCK\":35,\"EXDEV\":18,\"SIGHUP\":1,\"SIGINT\":2,\"SIGQUIT\":3,\"SIGILL\":4,\"SIGTRAP\":5,\"SIGABRT\":6,\"SIGIOT\":6,\"SIGBUS\":10,\"SIGFPE\":8,\"SIGKILL\":9,\"SIGUSR1\":30,\"SIGSEGV\":11,\"SIGUSR2\":31,\"SIGPIPE\":13,\"SIGALRM\":14,\"SIGTERM\":15,\"SIGCHLD\":20,\"SIGCONT\":19,\"SIGSTOP\":17,\"SIGTSTP\":18,\"SIGTTIN\":21,\"SIGTTOU\":22,\"SIGURG\":16,\"SIGXCPU\":24,\"SIGXFSZ\":25,\"SIGVTALRM\":26,\"SIGPROF\":27,\"SIGWINCH\":28,\"SIGIO\":23,\"SIGSYS\":12,\"SSL_OP_ALL\":2147486719,\"SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION\":262144,\"SSL_OP_CIPHER_SERVER_PREFERENCE\":4194304,\"SSL_OP_CISCO_ANYCONNECT\":32768,\"SSL_OP_COOKIE_EXCHANGE\":8192,\"SSL_OP_CRYPTOPRO_TLSEXT_BUG\":2147483648,\"SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS\":2048,\"SSL_OP_EPHEMERAL_RSA\":0,\"SSL_OP_LEGACY_SERVER_CONNECT\":4,\"SSL_OP_MICROSOFT_BIG_SSLV3_BUFFER\":32,\"SSL_OP_MICROSOFT_SESS_ID_BUG\":1,\"SSL_OP_MSIE_SSLV2_RSA_PADDING\":0,\"SSL_OP_NETSCAPE_CA_DN_BUG\":536870912,\"SSL_OP_NETSCAPE_CHALLENGE_BUG\":2,\"SSL_OP_NETSCAPE_DEMO_CIPHER_CHANGE_BUG\":1073741824,\"SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG\":8,\"SSL_OP_NO_COMPRESSION\":131072,\"SSL_OP_NO_QUERY_MTU\":4096,\"SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION\":65536,\"SSL_OP_NO_SSLv2\":16777216,\"SSL_OP_NO_SSLv3\":33554432,\"SSL_OP_NO_TICKET\":16384,\"SSL_OP_NO_TLSv1\":67108864,\"SSL_OP_NO_TLSv1_1\":268435456,\"SSL_OP_NO_TLSv1_2\":134217728,\"SSL_OP_PKCS1_CHECK_1\":0,\"SSL_OP_PKCS1_CHECK_2\":0,\"SSL_OP_SINGLE_DH_USE\":1048576,\"SSL_OP_SINGLE_ECDH_USE\":524288,\"SSL_OP_SSLEAY_080_CLIENT_DH_BUG\":128,\"SSL_OP_SSLREF2_REUSE_CERT_TYPE_BUG\":0,\"SSL_OP_TLS_BLOCK_PADDING_BUG\":512,\"SSL_OP_TLS_D5_BUG\":256,\"SSL_OP_TLS_ROLLBACK_BUG\":8388608,\"ENGINE_METHOD_DSA\":2,\"ENGINE_METHOD_DH\":4,\"ENGINE_METHOD_RAND\":8,\"ENGINE_METHOD_ECDH\":16,\"ENGINE_METHOD_ECDSA\":32,\"ENGINE_METHOD_CIPHERS\":64,\"ENGINE_METHOD_DIGESTS\":128,\"ENGINE_METHOD_STORE\":256,\"ENGINE_METHOD_PKEY_METHS\":512,\"ENGINE_METHOD_PKEY_ASN1_METHS\":1024,\"ENGINE_METHOD_ALL\":65535,\"ENGINE_METHOD_NONE\":0,\"DH_CHECK_P_NOT_SAFE_PRIME\":2,\"DH_CHECK_P_NOT_PRIME\":1,\"DH_UNABLE_TO_CHECK_GENERATOR\":4,\"DH_NOT_SUITABLE_GENERATOR\":8,\"NPN_ENABLED\":1,\"RSA_PKCS1_PADDING\":1,\"RSA_SSLV23_PADDING\":2,\"RSA_NO_PADDING\":3,\"RSA_PKCS1_OAEP_PADDING\":4,\"RSA_X931_PADDING\":5,\"RSA_PKCS1_PSS_PADDING\":6,\"POINT_CONVERSION_COMPRESSED\":2,\"POINT_CONVERSION_UNCOMPRESSED\":4,\"POINT_CONVERSION_HYBRID\":6,\"F_OK\":0,\"R_OK\":4,\"W_OK\":2,\"X_OK\":1,\"UV_UDP_REUSEADDR\":4}");

});

parcelRegister("85dKZ", function(module, exports) {

$parcel$export(module.exports, "isatty", () => $5e297631d1214357$export$9b473d35051e2626, (v) => $5e297631d1214357$export$9b473d35051e2626 = v);
$parcel$export(module.exports, "ReadStream", () => $5e297631d1214357$export$de64a30e4ee40519, (v) => $5e297631d1214357$export$de64a30e4ee40519 = v);
$parcel$export(module.exports, "WriteStream", () => $5e297631d1214357$export$b6b358f069d459a3, (v) => $5e297631d1214357$export$b6b358f069d459a3 = v);
var $5e297631d1214357$export$9b473d35051e2626;
var $5e297631d1214357$export$de64a30e4ee40519;
var $5e297631d1214357$export$b6b358f069d459a3;
$5e297631d1214357$export$9b473d35051e2626 = function() {
    return false;
};
function $5e297631d1214357$var$ReadStream() {
    throw new Error('tty.ReadStream is not implemented');
}
$5e297631d1214357$export$de64a30e4ee40519 = $5e297631d1214357$var$ReadStream;
function $5e297631d1214357$var$WriteStream() {
    throw new Error('tty.WriteStream is not implemented');
}
$5e297631d1214357$export$b6b358f069d459a3 = $5e297631d1214357$var$WriteStream;

});


parcelRegister("9eF39", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $jKHze = parcelRequire("jKHze");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $jKHze.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $jKHze.default)(Rgb, rgb, (0, $jKHze.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $jKHze.default)(Hsl, hsl, (0, $jKHze.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("jKHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6141bbfd30ac9e4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $e6141bbfd30ac9e4$export$8b58be045bf06082);
function $e6141bbfd30ac9e4$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $e6141bbfd30ac9e4$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


var $b225529de5fe4d82$exports = {};

$parcel$export($b225529de5fe4d82$exports, "LineCap", () => $b225529de5fe4d82$export$71ff7619005e0377);
$parcel$export($b225529de5fe4d82$exports, "LineJoin", () => $b225529de5fe4d82$export$93dad4aa23335ca1);
$parcel$export($b225529de5fe4d82$exports, "PlaneView", () => $b225529de5fe4d82$export$34151b55b8cbc6dd);
$parcel$export($b225529de5fe4d82$exports, "Axis", () => $b225529de5fe4d82$export$d06866a9fb0606da);
$parcel$export($b225529de5fe4d82$exports, "IsometricCanvas", () => $b225529de5fe4d82$export$e3e1252f38307002);
$parcel$export($b225529de5fe4d82$exports, "IsometricGroup", () => $b225529de5fe4d82$export$d223442bf82eaf54);
$parcel$export($b225529de5fe4d82$exports, "IsometricRectangle", () => $b225529de5fe4d82$export$f54a3aa3bdb4a9c8);
$parcel$export($b225529de5fe4d82$exports, "IsometricCircle", () => $b225529de5fe4d82$export$77cf72652ee46fc7);
$parcel$export($b225529de5fe4d82$exports, "IsometricPentagram", () => $b225529de5fe4d82$export$893c7f23d4115570);
$parcel$export($b225529de5fe4d82$exports, "IsometricStarPolygon", () => $b225529de5fe4d82$export$d3c4444c1d97c361);
$parcel$export($b225529de5fe4d82$exports, "IsometricPath", () => $b225529de5fe4d82$export$271c527cab8eab68);
$parcel$export($b225529de5fe4d82$exports, "IsometricText", () => $b225529de5fe4d82$export$b5ee75f3884097c5);
/// <reference types="./index.d.ts" />
var $b225529de5fe4d82$var$t, $b225529de5fe4d82$var$e, $b225529de5fe4d82$var$n = "http://www.w3.org/2000/svg";
!function(t) {
    t.svg = "svg", t.group = "g", t.path = "path", t.rect = "rect", t.text = "text", t.tspan = "tspan", t.pattern = "pattern", t.image = "image", t.animate = "animate", t.animateTransform = "animateTransform";
}($b225529de5fe4d82$var$t || ($b225529de5fe4d82$var$t = {})), function(t) {
    t.viewBox = "viewBox";
}($b225529de5fe4d82$var$e || ($b225529de5fe4d82$var$e = {}));
Math.sqrt(3).toFixed(6);
var $b225529de5fe4d82$var$i, $b225529de5fe4d82$export$71ff7619005e0377, $b225529de5fe4d82$export$93dad4aa23335ca1, $b225529de5fe4d82$var$a, $b225529de5fe4d82$export$34151b55b8cbc6dd, $b225529de5fe4d82$export$d06866a9fb0606da, $b225529de5fe4d82$var$u, $b225529de5fe4d82$var$h, $b225529de5fe4d82$var$p, $b225529de5fe4d82$var$l = +(Math.sqrt(3) / 2).toFixed(6), $b225529de5fe4d82$var$d = "(-?\\d+(?:\\.\\d+)?|-?\\.\\d+)", $b225529de5fe4d82$var$f = "\\s*", $b225529de5fe4d82$var$m = "\\s+", $b225529de5fe4d82$var$g = "".concat($b225529de5fe4d82$var$d).concat($b225529de5fe4d82$var$m).concat($b225529de5fe4d82$var$d).concat($b225529de5fe4d82$var$m).concat($b225529de5fe4d82$var$d), $b225529de5fe4d82$var$y = "".concat($b225529de5fe4d82$var$g).concat($b225529de5fe4d82$var$m).concat($b225529de5fe4d82$var$g), $b225529de5fe4d82$var$v = new RegExp("(?:(M|L)".concat($b225529de5fe4d82$var$f).concat($b225529de5fe4d82$var$g).concat($b225529de5fe4d82$var$f, "|(C)").concat($b225529de5fe4d82$var$f).concat($b225529de5fe4d82$var$y, ")").concat($b225529de5fe4d82$var$f), "g"), $b225529de5fe4d82$var$b = Math.sqrt(1.5), $b225529de5fe4d82$var$_ = Math.PI / 3, $b225529de5fe4d82$var$x = Math.PI / 4, $b225529de5fe4d82$var$E = Math.atan(Math.SQRT2);
!function(t) {
    t.white = "white", t.black = "black";
}($b225529de5fe4d82$var$i || ($b225529de5fe4d82$var$i = {})), function(t) {
    t.butt = "butt", t.square = "square", t.round = "round";
}($b225529de5fe4d82$export$71ff7619005e0377 || ($b225529de5fe4d82$export$71ff7619005e0377 = {})), function(t) {
    t.miter = "miter", t.round = "round", t.bevel = "bevel";
}($b225529de5fe4d82$export$93dad4aa23335ca1 || ($b225529de5fe4d82$export$93dad4aa23335ca1 = {})), function(t) {
    t.move = "move", t.line = "line", t.curve = "curve";
}($b225529de5fe4d82$var$a || ($b225529de5fe4d82$var$a = {})), function(t) {
    t.FRONT = "FRONT", t.SIDE = "SIDE", t.TOP = "TOP";
}($b225529de5fe4d82$export$34151b55b8cbc6dd || ($b225529de5fe4d82$export$34151b55b8cbc6dd = {})), function(t) {
    t.RIGHT = "RIGHT", t.LEFT = "LEFT", t.TOP = "TOP";
}($b225529de5fe4d82$export$d06866a9fb0606da || ($b225529de5fe4d82$export$d06866a9fb0606da = {})), function(t) {
    t.UNDEFINED = "undefined", t.NUMBER = "number";
}($b225529de5fe4d82$var$u || ($b225529de5fe4d82$var$u = {})), function(t) {
    t.MOUSE_MOVE = "mousemove", t.MOUSE_DOWN = "mousedown", t.MOUSE_UP = "mouseup", t.TOUCH_START = "touchstart", t.TOUCH_MOVE = "touchmove", t.TOUCH_END = "touchend";
}($b225529de5fe4d82$var$h || ($b225529de5fe4d82$var$h = {})), function(t) {
    t.CENTER = "center", t.LEFT = "left", t.RIGHT = "right", t.TOP = "top", t.BOTTOM = "bottom";
}($b225529de5fe4d82$var$p || ($b225529de5fe4d82$var$p = {}));
var $b225529de5fe4d82$var$O = function(t, e) {
    return $b225529de5fe4d82$var$O = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }, $b225529de5fe4d82$var$O(t, e);
};
function $b225529de5fe4d82$var$P(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function n() {
        this.constructor = t;
    }
    $b225529de5fe4d82$var$O(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
}
var $b225529de5fe4d82$var$C = function() {
    return $b225529de5fe4d82$var$C = Object.assign || function(t) {
        for(var e, n = 1, i = arguments.length; n < i; n++)for(var r in e = arguments[n])Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        return t;
    }, $b225529de5fe4d82$var$C.apply(this, arguments);
};
function $b225529de5fe4d82$var$w(t, e) {
    var n = {};
    for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for(i = Object.getOwnPropertySymbols(t); r < i.length; r++)e.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[r]) && (n[i[r]] = t[i[r]]);
    }
    return n;
}
function $b225529de5fe4d82$var$A(t, e, n) {
    if (n || 2 === arguments.length) for(var i, r = 0, o = e.length; r < o; r++)!i && r in e || (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
    return t.concat(i || Array.prototype.slice.call(e));
}
"function" == typeof SuppressedError && SuppressedError;
var $b225529de5fe4d82$var$T = function(t, e) {
    var n = Math.pow(10, e);
    return Math.round(t * n) / n;
}, $b225529de5fe4d82$var$S = function(t) {
    return {
        sin: $b225529de5fe4d82$var$T(Math.sin(t), 6),
        cos: $b225529de5fe4d82$var$T(Math.cos(t), 6)
    };
}, $b225529de5fe4d82$var$j = function(t, e) {
    return {
        x: t.x - e.x,
        y: t.y - e.y
    };
}, $b225529de5fe4d82$var$k = function(t, e) {
    var n = $b225529de5fe4d82$var$j(t, e);
    return Math.sqrt(Math.pow(n.x, 2) + Math.pow(n.y, 2));
}, $b225529de5fe4d82$var$N = function(t, e, n) {
    return {
        x: t.x + Math.cos(e) * n,
        y: t.y + Math.sin(e) * n
    };
}, $b225529de5fe4d82$var$M = function(t, e) {
    var n = $b225529de5fe4d82$var$j(e, t);
    return Math.atan2(n.y, n.x);
}, $b225529de5fe4d82$var$I = function(t, e, n, i) {
    return {
        x: $b225529de5fe4d82$var$T(t + (n.r - n.l) * i * $b225529de5fe4d82$var$l, 6),
        y: $b225529de5fe4d82$var$T(e + ((n.r + n.l) / 2 - n.t) * i, 6)
    };
}, $b225529de5fe4d82$var$D = function(t, e, n) {
    var i = $b225529de5fe4d82$var$j(e, t), r = {
        x: t.x + i.x / 2,
        y: t.y + i.y / 2
    }, o = function(t, e, n) {
        var i = $b225529de5fe4d82$var$j(t, e), r = i.x * Math.cos(n) - i.y * Math.sin(n), o = i.x * Math.sin(n) + i.y * Math.cos(n);
        return {
            x: e.x + r,
            y: e.y + o
        };
    }(e, r, Math.PI / 2), a = {
        x: o.x + (n.x - o.x) / 2,
        y: o.y + (n.y - o.y) / 2
    }, s = $b225529de5fe4d82$var$k(a, r), c = $b225529de5fe4d82$var$N(a, $b225529de5fe4d82$var$M(a, o), s), u = $b225529de5fe4d82$var$N(a, $b225529de5fe4d82$var$M(a, n), s);
    return [
        $b225529de5fe4d82$var$T($b225529de5fe4d82$var$k(n, c), 6),
        $b225529de5fe4d82$var$T($b225529de5fe4d82$var$k(n, u), 6),
        $b225529de5fe4d82$var$T(180 * $b225529de5fe4d82$var$M(r, u) / Math.PI, 6)
    ];
}, $b225529de5fe4d82$var$R = function() {
    return Array.from(Array(3)).map(function() {
        return Math.random().toString(16).slice(2);
    }).join("-");
}, $b225529de5fe4d82$var$F = function(t, e) {
    return t.map(function(n, i) {
        return e[0].map(function(r, o) {
            return n.reduce(function(n, r, a) {
                return n + t[i][a] * e[a][o];
            }, 0);
        });
    });
}, $b225529de5fe4d82$var$B = function() {
    for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
    for(var n = t[0], i = 1; i < t.length; i++)n = $b225529de5fe4d82$var$F(n, t[i]);
    return n;
}, $b225529de5fe4d82$var$L = function(t) {
    var e = $b225529de5fe4d82$var$S(t);
    return [
        [
            1,
            0,
            0
        ],
        [
            0,
            e.cos,
            -e.sin
        ],
        [
            0,
            e.sin,
            e.cos
        ]
    ];
}, $b225529de5fe4d82$var$U = function(t) {
    var e = $b225529de5fe4d82$var$S(t);
    return [
        [
            e.cos,
            0,
            e.sin
        ],
        [
            0,
            1,
            0
        ],
        [
            -e.sin,
            0,
            e.cos
        ]
    ];
}, $b225529de5fe4d82$var$V = function(t) {
    var e = $b225529de5fe4d82$var$S(t);
    return [
        [
            e.cos,
            -e.sin,
            0
        ],
        [
            e.sin,
            e.cos,
            0
        ],
        [
            0,
            0,
            1
        ]
    ];
}, $b225529de5fe4d82$var$G = $b225529de5fe4d82$var$B($b225529de5fe4d82$var$L($b225529de5fe4d82$var$E), $b225529de5fe4d82$var$V(-$b225529de5fe4d82$var$x)), $b225529de5fe4d82$var$z = $b225529de5fe4d82$var$B($b225529de5fe4d82$var$V(-$b225529de5fe4d82$var$_), $b225529de5fe4d82$var$L($b225529de5fe4d82$var$E), $b225529de5fe4d82$var$V($b225529de5fe4d82$var$x)), $b225529de5fe4d82$var$X = $b225529de5fe4d82$var$B($b225529de5fe4d82$var$V($b225529de5fe4d82$var$_), $b225529de5fe4d82$var$L($b225529de5fe4d82$var$E), $b225529de5fe4d82$var$V(-$b225529de5fe4d82$var$x)), $b225529de5fe4d82$var$H = function(t, e) {
    var n = e.value * Math.PI / 180;
    switch(t){
        case $b225529de5fe4d82$export$34151b55b8cbc6dd.TOP:
            switch(e.axis){
                case $b225529de5fe4d82$export$d06866a9fb0606da.TOP:
                    return $b225529de5fe4d82$var$V(n);
                case $b225529de5fe4d82$export$d06866a9fb0606da.LEFT:
                    return $b225529de5fe4d82$var$L(-n);
                case $b225529de5fe4d82$export$d06866a9fb0606da.RIGHT:
                    return $b225529de5fe4d82$var$U(n);
                default:
                    return null;
            }
        case $b225529de5fe4d82$export$34151b55b8cbc6dd.FRONT:
            switch(e.axis){
                case $b225529de5fe4d82$export$d06866a9fb0606da.TOP:
                    return $b225529de5fe4d82$var$U(n);
                case $b225529de5fe4d82$export$d06866a9fb0606da.LEFT:
                    return $b225529de5fe4d82$var$L(n);
                case $b225529de5fe4d82$export$d06866a9fb0606da.RIGHT:
                    return $b225529de5fe4d82$var$V(n);
                default:
                    return null;
            }
        case $b225529de5fe4d82$export$34151b55b8cbc6dd.SIDE:
            switch(e.axis){
                case $b225529de5fe4d82$export$d06866a9fb0606da.TOP:
                    return $b225529de5fe4d82$var$U(n);
                case $b225529de5fe4d82$export$d06866a9fb0606da.LEFT:
                    return $b225529de5fe4d82$var$V(n);
                case $b225529de5fe4d82$export$d06866a9fb0606da.RIGHT:
                    return $b225529de5fe4d82$var$L(-n);
                default:
                    return null;
            }
        default:
            return null;
    }
}, $b225529de5fe4d82$var$Y = function(t, e) {
    Object.keys(e).forEach(function(n) {
        t.setAttributeNS(null, n, e[n]);
    });
}, $b225529de5fe4d82$var$W = function(t) {
    return 0 === t.length || t[0].command === $b225529de5fe4d82$var$a.move ? $b225529de5fe4d82$var$A([], t, !0) : $b225529de5fe4d82$var$A([
        {
            command: $b225529de5fe4d82$var$a.move,
            point: {
                r: 0,
                l: 0,
                t: 0
            }
        }
    ], t, !0);
}, $b225529de5fe4d82$var$q = function(t, e, n, i, r) {
    var o = $b225529de5fe4d82$var$W(t).map(function(r, o) {
        var s, c, u, h = $b225529de5fe4d82$var$I(e, n, r.point, i);
        switch(r.command){
            case $b225529de5fe4d82$var$a.move:
                return "M".concat(h.x, " ").concat(h.y);
            case $b225529de5fe4d82$var$a.line:
                return "L".concat(h.x, " ").concat(h.y);
            case $b225529de5fe4d82$var$a.curve:
                var p = $b225529de5fe4d82$var$I(e, n, t[o - 1].point, i), l = $b225529de5fe4d82$var$I(e, n, r.control, i), d = $b225529de5fe4d82$var$D(p, h, l), f = (s = p, u = h, ((c = l).y - s.y) * (u.x - c.x) - (c.x - s.x) * (u.y - c.y) >= 0 ? 0 : 1);
                return "A ".concat(d[0], " ").concat(d[1], " ").concat(d[2], " 0 ").concat(f, " ").concat(h.x, " ").concat(h.y);
        }
    });
    if (o.length) {
        var s = r ? "z" : "";
        return "".concat(o.join(" ").trim()).concat(s);
    }
    return "";
}, $b225529de5fe4d82$var$Q = function(t) {
    for(var e, n = []; null !== (e = $b225529de5fe4d82$var$v.exec(t));)switch(e[5] || e[1]){
        case "M":
            n.push({
                command: $b225529de5fe4d82$var$a.move,
                point: {
                    r: +e[2],
                    l: +e[3],
                    t: +e[4]
                }
            });
            break;
        case "L":
            n.push({
                command: $b225529de5fe4d82$var$a.line,
                point: {
                    r: +e[2],
                    l: +e[3],
                    t: +e[4]
                }
            });
            break;
        case "C":
            n.push({
                command: $b225529de5fe4d82$var$a.curve,
                control: {
                    r: +e[6],
                    l: +e[7],
                    t: +e[8]
                },
                point: {
                    r: +e[9],
                    l: +e[10],
                    t: +e[11]
                }
            });
    }
    return n;
}, $b225529de5fe4d82$var$J = function(t, e, n, i) {
    t.forEach(function(t) {
        t.point.r += e, t.point.l += n, t.point.t += i, t.control && (t.control.r += e, t.control.l += n, t.control.t += i);
    });
}, $b225529de5fe4d82$var$K = function(t) {
    return [
        "fillColor",
        "fillOpacity",
        "strokeColor",
        "strokeOpacity",
        "strokeWidth",
        "className"
    ].includes(t);
};
function $b225529de5fe4d82$var$Z(t, e, n, i, r) {
    var o = {
        fn: i,
        fnBind: i.bind(this)
    };
    e.push(o), t.addEventListener(n, o.fnBind, r);
}
var $b225529de5fe4d82$var$$, $b225529de5fe4d82$var$tt = function(t, e, n, i) {
    var r = function(t, e) {
        var n = [], i = e ? $b225529de5fe4d82$var$H(t, e) : null;
        switch(i && n.push(i), t){
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.TOP:
                return $b225529de5fe4d82$var$B.apply(void 0, $b225529de5fe4d82$var$A([
                    $b225529de5fe4d82$var$G
                ], n, !1));
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.FRONT:
                return $b225529de5fe4d82$var$B.apply(void 0, $b225529de5fe4d82$var$A([
                    $b225529de5fe4d82$var$z
                ], n, !1));
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.SIDE:
                return $b225529de5fe4d82$var$B.apply(void 0, $b225529de5fe4d82$var$A([
                    $b225529de5fe4d82$var$X
                ], n, !1));
        }
        return null;
    }(e, i), o = "translate(".concat(t.x, " ").concat(t.y, ")");
    if (r) {
        var a = $b225529de5fe4d82$var$T(r[0][0], 6), c = $b225529de5fe4d82$var$T(r[1][0], 6), u = $b225529de5fe4d82$var$T(r[0][1], 6), h = $b225529de5fe4d82$var$T(r[1][1], 6);
        o += " matrix(".concat(a, ",").concat(c, ",").concat(u, ",").concat(h, ",0,0)"), o += " scale(".concat($b225529de5fe4d82$var$T($b225529de5fe4d82$var$b * (n || 1), 6), ")");
    } else n && (o += " scale(".concat($b225529de5fe4d82$var$T(n, 6), ")"));
    return o;
}, $b225529de5fe4d82$var$et = function(t) {
    return !!t.parentNode && ("SVGSVGElement" === t.parentNode.constructor.name || $b225529de5fe4d82$var$et(t.parentNode));
}, $b225529de5fe4d82$var$nt = function() {
    function t(t, e, n) {
        this.sizes = {
            centerX: t / 2,
            centerY: e / 2,
            height: e,
            width: t,
            scale: n
        };
    }
    return Object.defineProperty(t.prototype, "width", {
        get: function() {
            return this.sizes.width;
        },
        set: function(t) {
            this.sizes.width = t, this.sizes.centerX = t / 2;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "height", {
        get: function() {
            return this.sizes.height;
        },
        set: function(t) {
            this.sizes.height = t, this.sizes.centerY = t / 2;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "scale", {
        get: function() {
            return this.sizes.scale;
        },
        set: function(t) {
            this.sizes.scale = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "centerX", {
        get: function() {
            return this.sizes.centerX;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "centerY", {
        get: function() {
            return this.sizes.centerY;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $b225529de5fe4d82$var$it = function(t) {
    function e(e, i) {
        var r = t.call(this) || this;
        return r._id = e, r.listeners = [], r.element = document.createElementNS($b225529de5fe4d82$var$n, i), $b225529de5fe4d82$var$Y(r.element, {
            id: r._id
        }), r;
    }
    return $b225529de5fe4d82$var$P(e, t), e.prototype.setId = function(t) {
        this._id = t, $b225529de5fe4d82$var$Y(this.element, {
            id: this._id
        });
    }, e.prototype.getElement = function() {
        return this.element;
    }, e.prototype.addEventListener = function(t, e, n) {
        return void 0 === n && (n = !1), $b225529de5fe4d82$var$Z.call(this, this.element, this.listeners, t, e, n), this;
    }, e.prototype.removeEventListener = function(t, e, n) {
        return void 0 === n && (n = !1), function(t, e, n, i, r) {
            var o;
            e.find(function(t, n) {
                if (t.fn === i) return o = e.splice(n, 1)[0], !0;
            }), o && t.removeEventListener(n, o.fnBind, r);
        }(this.element, this.listeners, t, e, n), this;
    }, e;
}(function() {
    function t() {}
    return Object.defineProperty(t.prototype, "data", {
        get: function() {
            return this.dataStore;
        },
        set: function(t) {
            this.dataStore = t;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}()), $b225529de5fe4d82$var$rt = {
    fillColor: $b225529de5fe4d82$var$i.white,
    fillOpacity: 1,
    strokeColor: $b225529de5fe4d82$var$i.black,
    strokeDashArray: [],
    strokeLinecap: $b225529de5fe4d82$export$71ff7619005e0377.butt,
    strokeLinejoin: $b225529de5fe4d82$export$93dad4aa23335ca1.round,
    strokeOpacity: 1,
    strokeWidth: 1
}, $b225529de5fe4d82$var$ot = function(e) {
    function i(t, n) {
        var i = e.call(this, t.id || $b225529de5fe4d82$var$R(), n) || this;
        i.props = $b225529de5fe4d82$var$C($b225529de5fe4d82$var$C({}, $b225529de5fe4d82$var$rt), t), i.animations = [], i.props.texture && i.createTexture(i.props.texture);
        var r = {
            fill: i.props.texture ? "url(#".concat(i.patternId, ") ").concat(i.fillColor) : i.fillColor,
            "fill-opacity": "".concat(i.fillOpacity),
            stroke: i.strokeColor,
            "stroke-dasharray": i.strokeDashArray.join(" "),
            "stroke-linecap": i.strokeLinecap,
            "stroke-linejoin": i.strokeLinejoin,
            "stroke-opacity": "".concat(i.strokeOpacity),
            "stroke-width": "".concat(i.strokeWidth)
        };
        return i.props.className && (r.class = i.props.className), $b225529de5fe4d82$var$Y(i.element, r), i;
    }
    return $b225529de5fe4d82$var$P(i, e), i.prototype.createTexture = function(e) {
        this.patternId = "".concat(this.id, "__texture"), this.pattern = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.pattern), $b225529de5fe4d82$var$Y(this.pattern, {
            id: this.patternId,
            preserveAspectRatio: "none",
            patternUnits: "userSpaceOnUse"
        });
        var i = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.image);
        $b225529de5fe4d82$var$Y(i, {
            href: e.url,
            x: "0",
            y: "0",
            preserveAspectRatio: "none"
        }), e.pixelated && $b225529de5fe4d82$var$Y(i, {
            style: "image-rendering: pixelated"
        }), this.pattern.appendChild(i);
    }, i.prototype._updateTexture = function() {
        var t = this.pattern.firstChild;
        this.props.texture.url && t.getAttribute("href") !== this.props.texture.url && $b225529de5fe4d82$var$Y(t, {
            href: this.props.texture.url
        }), this.props.texture.pixelated ? $b225529de5fe4d82$var$Y(t, {
            style: "image-rendering: pixelated"
        }) : t.removeAttribute("style"), this.update();
    }, i.prototype.addAnimationBasicProperties = function(t, e) {
        $b225529de5fe4d82$var$Y(e.element, {
            repeatCount: "".concat(e.repeat || "indefinite"),
            attributeName: t,
            dur: "".concat(e.duration || 1, "s")
        });
    }, i.prototype.updateAnimations = function() {
        var e = this;
        this.animations.forEach(function(i) {
            if ($b225529de5fe4d82$var$K(i.property)) {
                var r = function(t) {
                    return ({
                        fillColor: "fill",
                        fillOpacity: "fill-opacity",
                        strokeColor: "stroke",
                        strokeOpacity: "stroke-opacity",
                        strokeWidth: "stroke-width",
                        className: "class"
                    })[t];
                }(i.property);
                i.element || (i.element = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.animate)), i.element.parentNode || e.element.appendChild(i.element), e.addAnimationBasicProperties(r, i), i.values ? $b225529de5fe4d82$var$Y(i.element, {
                    values: Array.isArray(i.values) ? i.values.map(function(t) {
                        return "".concat(t);
                    }).join(";") : "".concat(i.values)
                }) : $b225529de5fe4d82$var$Y(i.element, {
                    from: "".concat(i.from),
                    to: "".concat(i.to)
                });
            }
        }), this.updateSubClassAnimations(), this.updateAnimations2 && this.updateAnimations2();
    }, i.prototype.updatePatternTransform = function(t, e) {
        var n, i, r;
        if (this.props.texture) {
            var o = this.props.texture.height ? "".concat(this.props.texture.height * this.data.scale) : "100%", a = this.props.texture.width ? "".concat(this.props.texture.width * this.data.scale) : "100%", s = $b225529de5fe4d82$var$I(0, 0, {
                r: (null === (n = this.props.texture.shift) || void 0 === n ? void 0 : n.right) || 0,
                l: (null === (i = this.props.texture.shift) || void 0 === i ? void 0 : i.left) || 0,
                t: (null === (r = this.props.texture.shift) || void 0 === r ? void 0 : r.top) || 0
            }, this.data.scale), c = $b225529de5fe4d82$var$tt({
                x: $b225529de5fe4d82$var$T(t.x + s.x, 6),
                y: $b225529de5fe4d82$var$T(t.y + s.y, 6)
            }, this.props.texture.planeView || e, this.props.texture.scale, this.props.texture.rotation);
            $b225529de5fe4d82$var$Y(this.pattern, {
                patternTransform: c,
                height: o,
                width: a
            }), $b225529de5fe4d82$var$Y(this.pattern.firstChild, {
                height: o,
                width: a
            });
        }
    }, Object.defineProperty(i.prototype, "id", {
        get: function() {
            return this._id;
        },
        set: function(t) {
            this.setId(t), this.pattern && (this.patternId = "".concat(this.id, "__texture"), $b225529de5fe4d82$var$Y(this.pattern, {
                id: this.patternId
            }));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fillColor", {
        get: function() {
            return this.props.fillColor;
        },
        set: function(t) {
            this.props.fillColor = t, $b225529de5fe4d82$var$Y(this.element, {
                fill: this.props.texture ? "url(#".concat(this.patternId, ") ").concat(this.fillColor) : this.fillColor
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fillOpacity", {
        get: function() {
            return this.props.fillOpacity;
        },
        set: function(t) {
            this.props.fillOpacity = t, $b225529de5fe4d82$var$Y(this.element, {
                "fill-opacity": "".concat(this.fillOpacity)
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "texture", {
        get: function() {
            return this.props.texture;
        },
        set: function(t) {
            var e = !!this.props.texture;
            this.props.texture = t, e ? this._updateTexture() : (this.createTexture(this.props.texture), this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeColor", {
        get: function() {
            return this.props.strokeColor;
        },
        set: function(t) {
            this.props.strokeColor = t, $b225529de5fe4d82$var$Y(this.element, {
                stroke: this.strokeColor
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeDashArray", {
        get: function() {
            return this.props.strokeDashArray;
        },
        set: function(t) {
            this.props.strokeDashArray = t, $b225529de5fe4d82$var$Y(this.element, {
                "stroke-dasharray": this.strokeDashArray.join(" ")
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeLinecap", {
        get: function() {
            return this.props.strokeLinecap;
        },
        set: function(t) {
            this.props.strokeLinecap = $b225529de5fe4d82$export$71ff7619005e0377[t], $b225529de5fe4d82$var$Y(this.element, {
                "stroke-linecap": this.strokeLinecap
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeLinejoin", {
        get: function() {
            return this.props.strokeLinejoin;
        },
        set: function(t) {
            this.props.strokeLinejoin = $b225529de5fe4d82$export$93dad4aa23335ca1[t], $b225529de5fe4d82$var$Y(this.element, {
                "stroke-linejoin": this.strokeLinejoin
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeOpacity", {
        get: function() {
            return this.props.strokeOpacity;
        },
        set: function(t) {
            this.props.strokeOpacity = t, $b225529de5fe4d82$var$Y(this.element, {
                "stroke-opacity": "".concat(this.strokeOpacity)
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeWidth", {
        get: function() {
            return this.props.strokeWidth;
        },
        set: function(t) {
            this.props.strokeWidth = t, $b225529de5fe4d82$var$Y(this.element, {
                "stroke-width": "".concat(this.strokeWidth)
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "className", {
        get: function() {
            return this.props.className;
        },
        set: function(t) {
            this.props.className = t, $b225529de5fe4d82$var$Y(this.element, {
                class: this.props.className
            });
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.getPattern = function() {
        return this.pattern;
    }, i.prototype.updateTexture = function(t) {
        var e = !!this.props.texture;
        if (e || t.url) {
            var n = t.shift, i = t.rotation, r = $b225529de5fe4d82$var$w(t, [
                "shift",
                "rotation"
            ]);
            this.props.texture = $b225529de5fe4d82$var$C(e ? $b225529de5fe4d82$var$C({}, this.props.texture) : {}, r), n && (this.props.texture.shift = $b225529de5fe4d82$var$C($b225529de5fe4d82$var$C({}, this.props.texture.shift || {}), n)), i && (this.props.texture.rotation = i), e ? this._updateTexture() : (this.createTexture(this.props.texture), this.update());
        }
        return this;
    }, i.prototype.addAnimation = function(t) {
        return this.animations.push($b225529de5fe4d82$var$C({}, t)), this.update(), this;
    }, i.prototype.removeAnimationByIndex = function(t) {
        if (t >= 0 && t < this.animations.length) {
            var e = this.animations.splice(t, 1)[0];
            e.element && e.element.parentNode && e.element.parentNode.removeChild(e.element);
        }
        return this;
    }, i.prototype.removeAnimations = function() {
        return this.animations.splice(0).forEach(function(t) {
            t.element && t.element.parentNode && t.element.parentNode.removeChild(t.element);
        }), this;
    }, i;
}($b225529de5fe4d82$var$it), $b225529de5fe4d82$var$at = function(t) {
    function e(e, n) {
        var i = t.call(this, e, n) || this;
        return i._children = [], i;
    }
    return $b225529de5fe4d82$var$P(e, t), e.prototype.getChildIndex = function(t) {
        return this._children.indexOf(t);
    }, e.prototype.throwChildError = function() {
        throw new Error("You cannot provide a child that is not a children of the container");
    }, e.prototype.removeSVGChild = function(t) {
        var e = t.getElement();
        if (t instanceof $b225529de5fe4d82$var$ot) {
            var n = t.getPattern();
            n && n.parentNode && this.element.removeChild(n);
        }
        e.parentNode && this.element.removeChild(e);
    }, e.prototype.insertPattern = function(t) {
        t && this.element.insertBefore(t, this.element.firstChild);
    }, Object.defineProperty(e.prototype, "id", {
        get: function() {
            return this._id;
        },
        set: function(t) {
            this.setId(t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "children", {
        get: function() {
            return this._children;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.update = function() {
        var t = this;
        return $b225529de5fe4d82$var$et(this.element) && this._children.forEach(function(e) {
            e.data = t.data, e.update();
        }), this;
    }, e.prototype.clear = function() {
        var t = this;
        return this._children.splice(0).forEach(function(e) {
            t.removeSVGChild(e);
        }), this;
    }, e.prototype.addChild = function(t) {
        return t.data = this.data, this._children.push(t), t instanceof $b225529de5fe4d82$var$ot && this.insertPattern(t.getPattern()), this.element.appendChild(t.getElement()), t.update(), this;
    }, e.prototype.addChildren = function() {
        for(var t = this, e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        return e.forEach(function(e) {
            return t.addChild(e);
        }), this;
    }, e.prototype.getChildByIndex = function(t) {
        return this._children[t] || null;
    }, e.prototype.getChildById = function(t) {
        return this._children.find(function(e) {
            return e.id === t;
        }) || null;
    }, e.prototype.removeChild = function(t) {
        var e = this.getChildIndex(t);
        if (e > -1) return this._children.splice(e, 1), this.removeSVGChild(t), this;
        this.throwChildError();
    }, e.prototype.removeChildren = function() {
        for(var t = this, e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        return e.forEach(function(e) {
            -1 === t.getChildIndex(e) && t.throwChildError(), t.removeChild(e);
        }), this;
    }, e.prototype.removeChildByIndex = function(t) {
        if (t >= 0 && t < this._children.length) {
            var e = this._children.splice(t, 1)[0];
            this.removeSVGChild(e);
        }
        return this;
    }, e.prototype.removeChildById = function(t) {
        var e = this.getChildById(t);
        if (e) return this.removeChild(e);
    }, e.prototype.setChildIndex = function(t, e) {
        var n = this.getChildIndex(t);
        if (n > -1) {
            e = Math.min(Math.max(0, e), this._children.length - 1);
            var i = t.getElement(), r = this._children[e].getElement();
            return this._children[e] !== t && (this._children.splice(n, 1), this._children.splice(e, 0, t), n > e ? this.element.insertBefore(i, r) : r.nextSibling ? this.element.insertBefore(i, r.nextSibling) : this.element.appendChild(i)), this;
        }
        this.throwChildError();
    }, e.prototype.bringChildToFront = function(t) {
        if (this.getChildIndex(t) > -1) return this.setChildIndex(t, this._children.length - 1), this;
        this.throwChildError();
    }, e.prototype.bringChildForward = function(t) {
        var e = this.getChildIndex(t);
        if (e > -1) return e < this._children.length - 1 && this.setChildIndex(t, e + 1), this;
        this.throwChildError();
    }, e.prototype.sendChildToBack = function(t) {
        if (this.getChildIndex(t) > -1) return this.setChildIndex(t, 0), this;
        this.throwChildError();
    }, e.prototype.sendChildBackward = function(t) {
        var e = this.getChildIndex(t);
        if (e > -1) return e > 0 && this.setChildIndex(t, e - 1), this;
        this.throwChildError();
    }, e;
}($b225529de5fe4d82$var$it), $b225529de5fe4d82$var$st = {
    container: "body",
    backgroundColor: $b225529de5fe4d82$var$i.white,
    scale: 1,
    height: 480,
    width: 640
}, $b225529de5fe4d82$export$e3e1252f38307002 = function(i) {
    function r(r) {
        var o;
        void 0 === r && (r = {});
        var a = i.call(this, r.id || $b225529de5fe4d82$var$R(), $b225529de5fe4d82$var$t.svg) || this;
        return a.props = $b225529de5fe4d82$var$C($b225529de5fe4d82$var$C({}, $b225529de5fe4d82$var$st), r), a.isAnimated = !0, a.data = new $b225529de5fe4d82$var$nt(a.props.width, a.props.height, a.props.scale), $b225529de5fe4d82$var$Y(a.element, ((o = {})[$b225529de5fe4d82$var$e.viewBox] = "0 0 ".concat(a.data.width, " ").concat(a.data.height), o.width = "".concat(a.data.width, "px"), o.height = "".concat(a.data.height, "px"), o)), a.background = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.rect), $b225529de5fe4d82$var$Y(a.background, {
            fill: a.backgroundColor,
            x: "0",
            y: "0",
            width: "".concat(a.data.width, "px"),
            height: "".concat(a.data.height, "px")
        }), a.element.appendChild(a.background), ("string" == typeof a.props.container ? document.querySelector(a.props.container) : a.props.container).appendChild(a.element), a;
    }
    return $b225529de5fe4d82$var$P(r, i), Object.defineProperty(r.prototype, "backgroundColor", {
        get: function() {
            return this.props.backgroundColor;
        },
        set: function(t) {
            this.props.backgroundColor = t, $b225529de5fe4d82$var$Y(this.background, {
                fill: this.backgroundColor
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(r.prototype, "scale", {
        get: function() {
            return this.data.scale;
        },
        set: function(t) {
            this.data.scale = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(r.prototype, "height", {
        get: function() {
            return this.data.height;
        },
        set: function(t) {
            var n;
            this.data.height = t, $b225529de5fe4d82$var$Y(this.element, ((n = {})[$b225529de5fe4d82$var$e.viewBox] = "0 0 ".concat(this.data.width, " ").concat(this.data.height), n.height = "".concat(this.data.height, "px"), n)), $b225529de5fe4d82$var$Y(this.background, {
                height: "".concat(this.data.height, "px")
            }), this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(r.prototype, "width", {
        get: function() {
            return this.data.width;
        },
        set: function(t) {
            var n;
            this.data.width = t, $b225529de5fe4d82$var$Y(this.element, ((n = {})[$b225529de5fe4d82$var$e.viewBox] = "0 0 ".concat(this.data.width, " ").concat(this.data.height), n.width = "".concat(this.data.width, "px"), n)), $b225529de5fe4d82$var$Y(this.background, {
                width: "".concat(this.data.width, "px")
            }), this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(r.prototype, "animated", {
        get: function() {
            return this.isAnimated;
        },
        enumerable: !1,
        configurable: !0
    }), r.prototype.getSVGCode = function() {
        return this.element.outerHTML;
    }, r.prototype.pauseAnimations = function() {
        var t = this.element;
        return "function" == typeof t.pauseAnimations && t.pauseAnimations(), this.isAnimated = !1, this;
    }, r.prototype.resumeAnimations = function() {
        var t = this.element;
        return "function" == typeof t.unpauseAnimations && t.unpauseAnimations(), this.isAnimated = !0, this;
    }, r;
}($b225529de5fe4d82$var$at), $b225529de5fe4d82$var$ut = function(t, e) {
    Object.getOwnPropertyNames(e.prototype).forEach(function(n) {
        Object.defineProperty(t.prototype, n, Object.getOwnPropertyDescriptor(e.prototype, n));
    });
}, $b225529de5fe4d82$var$ht = [
    Number.MIN_SAFE_INTEGER,
    Number.MAX_SAFE_INTEGER
];
!function(t) {
    t.DRAG_START = "dragstart", t.DRAG = "drag", t.DRAG_END = "dragend";
}($b225529de5fe4d82$var$$ || ($b225529de5fe4d82$var$$ = {}));
var $b225529de5fe4d82$var$pt = typeof window !== $b225529de5fe4d82$var$u.UNDEFINED, $b225529de5fe4d82$var$lt = $b225529de5fe4d82$var$pt ? window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame : null, $b225529de5fe4d82$var$dt = {
    right: 0,
    left: 0,
    top: 0,
    x: 0,
    y: 0
}, $b225529de5fe4d82$var$ft = function(t) {
    return t instanceof Event ? function(t) {
        return "clientX" in t;
    }(t) ? {
        clientX: t.clientX,
        clientY: t.clientY
    } : {
        clientX: t.touches[0].clientX,
        clientY: t.touches[0].clientY
    } : t;
}, $b225529de5fe4d82$var$mt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $b225529de5fe4d82$var$P(e, t), e.prototype.setup = function() {
        this.startDrag = this.startDrag.bind(this), this.stopDrag = this.stopDrag.bind(this), this.moveElement = this.moveElement.bind(this), this.dropElement = this.dropElement.bind(this), this.animate = this.animate.bind(this), typeof this._bounds === $b225529de5fe4d82$var$u.UNDEFINED && (this._bounds = !1), typeof this._dragStore === $b225529de5fe4d82$var$u.UNDEFINED && (this._dragStore = $b225529de5fe4d82$var$dt), typeof this._coords === $b225529de5fe4d82$var$u.UNDEFINED && (this._coords = {});
    }, e.prototype.betweenBounds = function(t, e) {
        var n = $b225529de5fe4d82$var$A([], e, !0).sort();
        return $b225529de5fe4d82$var$T(Math.min(Math.max(t, n[0]), n[1]), 6);
    }, e.prototype.getBoundOrMaximum = function(t) {
        var e;
        return this.bounds && null !== (e = this.bounds[t]) && void 0 !== e ? e : $b225529de5fe4d82$var$A([], $b225529de5fe4d82$var$ht, !0);
    }, e.prototype.getRight = function(t) {
        var e = this.getBoundOrMaximum("right");
        return this.betweenBounds(this._dragStore.right + t / this.data.scale, e);
    }, e.prototype.getLeft = function(t) {
        var e = this.getBoundOrMaximum("left");
        return this.betweenBounds(this._dragStore.left + t / this.data.scale, e);
    }, e.prototype.getTop = function(t) {
        var e = this.getBoundOrMaximum("top");
        return this.betweenBounds(this._dragStore.top + t / this.data.scale, e);
    }, e.prototype.getFixedCoordinates = function(t) {
        var e = this;
        return Object.entries(t).reduce(function(t, n) {
            var i = $b225529de5fe4d82$var$C({}, t);
            switch(n[0]){
                case "right":
                    i.right = e.getRight(n[1]);
                    break;
                case "left":
                    i.left = e.getLeft(n[1]);
                    break;
                default:
                    i.top = e.getTop(n[1]);
            }
            return i;
        }, {});
    }, e.prototype.dispatchEvent = function(t) {
        var e, n, i, r = new CustomEvent(t, {
            cancelable: t === $b225529de5fe4d82$var$$.DRAG,
            detail: {
                right: null !== (e = this._coords.right) && void 0 !== e ? e : this.right,
                left: null !== (n = this._coords.left) && void 0 !== n ? n : this.left,
                top: null !== (i = this._coords.top) && void 0 !== i ? i : this.top
            }
        });
        return this.element.dispatchEvent(r), r;
    }, e.prototype.animate = function() {
        this._update && (this._prevented || (typeof this._coords.right === $b225529de5fe4d82$var$u.NUMBER && (this.right = this._coords.right), typeof this._coords.left === $b225529de5fe4d82$var$u.NUMBER && (this.left = this._coords.left), typeof this._coords.top === $b225529de5fe4d82$var$u.NUMBER && (this.top = this._coords.top)), $b225529de5fe4d82$var$lt(this.animate));
    }, e.prototype.startDrag = function(t) {
        t.preventDefault();
        var e = $b225529de5fe4d82$var$ft(t), n = e.clientX, i = e.clientY;
        this._dragStore.x = n, this._dragStore.y = i, this._dragStore.right = this.right, this._dragStore.left = this.left, this._dragStore.top = this.top, this._update = !0, this.moveElement({
            clientX: n,
            clientY: i
        }), this.element.addEventListener($b225529de5fe4d82$var$h.TOUCH_MOVE, this.moveElement, !0), this.element.addEventListener($b225529de5fe4d82$var$h.TOUCH_END, this.dropElement, !0), document.addEventListener($b225529de5fe4d82$var$h.MOUSE_MOVE, this.moveElement, !0), document.addEventListener($b225529de5fe4d82$var$h.MOUSE_UP, this.dropElement, !0), $b225529de5fe4d82$var$lt(this.animate);
    }, e.prototype.moveElement = function(t) {
        var e, n, i, r = $b225529de5fe4d82$var$ft(t), o = r.clientX, a = r.clientY, c = o - this._dragStore.x, u = a - this._dragStore.y;
        this._drag === $b225529de5fe4d82$export$34151b55b8cbc6dd.TOP ? this._coords = this.getFixedCoordinates({
            right: n = (2 * u + (e = c / $b225529de5fe4d82$var$l)) / 2,
            left: n - e
        }) : this._drag === $b225529de5fe4d82$export$34151b55b8cbc6dd.FRONT ? this._coords = this.getFixedCoordinates(function(t, e) {
            var n = -t / $b225529de5fe4d82$var$l;
            return {
                left: n,
                top: n / 2 - e
            };
        }(c, u)) : this._coords = this.getFixedCoordinates(function(t, e) {
            var n = t / $b225529de5fe4d82$var$l;
            return {
                right: n,
                top: n / 2 - e
            };
        }(c, u)), t instanceof Event && (t.preventDefault(), this._dragging || this.dispatchEvent($b225529de5fe4d82$var$$.DRAG_START), this._dragging = !0, i = this.dispatchEvent($b225529de5fe4d82$var$$.DRAG)), this._prevented = !(!i || !i.defaultPrevented);
    }, e.prototype.dropElement = function() {
        this._update = !1, this._dragging = !1, this.element.removeEventListener($b225529de5fe4d82$var$h.TOUCH_MOVE, this.moveElement, !0), this.element.removeEventListener($b225529de5fe4d82$var$h.TOUCH_END, this.dropElement, !0), document.removeEventListener($b225529de5fe4d82$var$h.MOUSE_MOVE, this.moveElement, !0), document.removeEventListener($b225529de5fe4d82$var$h.MOUSE_UP, this.dropElement, !0), this.dispatchEvent($b225529de5fe4d82$var$$.DRAG_END);
    }, e.prototype.beginDrag = function() {
        this.element.addEventListener($b225529de5fe4d82$var$h.TOUCH_START, this.startDrag, !0), this.element.addEventListener($b225529de5fe4d82$var$h.MOUSE_DOWN, this.startDrag, !0);
    }, e.prototype.stopDrag = function() {
        this.element.removeEventListener($b225529de5fe4d82$var$h.TOUCH_START, this.startDrag, !0), this.element.removeEventListener($b225529de5fe4d82$var$h.TOUCH_MOVE, this.moveElement, !0), this.element.removeEventListener($b225529de5fe4d82$var$h.TOUCH_END, this.dropElement, !0), this.element.removeEventListener($b225529de5fe4d82$var$h.MOUSE_DOWN, this.startDrag, !0), document.removeEventListener($b225529de5fe4d82$var$h.MOUSE_MOVE, this.moveElement, !0), document.removeEventListener($b225529de5fe4d82$var$h.MOUSE_UP, this.dropElement, !0);
    }, Object.defineProperty(e.prototype, "right", {
        get: function() {
            return this.props.right;
        },
        set: function(t) {
            this.props.right !== t && (this.props.right = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "left", {
        get: function() {
            return this.props.left;
        },
        set: function(t) {
            this.props.left !== t && (this.props.left = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "top", {
        get: function() {
            return this.props.top;
        },
        set: function(t) {
            this.props.top !== t && (this.props.top = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "drag", {
        get: function() {
            return this._drag || !1;
        },
        set: function(t) {
            typeof this._drag === $b225529de5fe4d82$var$u.UNDEFINED && this.setup(), this._drag = t, $b225529de5fe4d82$var$pt && (this.stopDrag(), this.beginDrag());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "bounds", {
        get: function() {
            return this._bounds || !1;
        },
        set: function(t) {
            this._bounds = t;
            var e = this.getBoundOrMaximum("right"), n = this.getBoundOrMaximum("left"), i = this.getBoundOrMaximum("top");
            this.right = this.betweenBounds(this.right, e), this.left = this.betweenBounds(this.left, n), this.top = this.betweenBounds(this.top, i);
        },
        enumerable: !1,
        configurable: !0
    }), e;
}($b225529de5fe4d82$var$it), $b225529de5fe4d82$var$gt = {
    right: 0,
    left: 0,
    top: 0
}, $b225529de5fe4d82$export$d223442bf82eaf54 = function(e) {
    function n(n) {
        void 0 === n && (n = {});
        var i = e.call(this, n.id || $b225529de5fe4d82$var$R(), $b225529de5fe4d82$var$t.group) || this;
        return i.props = $b225529de5fe4d82$var$C($b225529de5fe4d82$var$C({}, $b225529de5fe4d82$var$gt), n), i;
    }
    return $b225529de5fe4d82$var$P(n, e), n.prototype.update = function() {
        if ($b225529de5fe4d82$var$et(this.element)) {
            var t = $b225529de5fe4d82$var$I(0, 0, {
                r: this.props.right,
                l: this.props.left,
                t: this.props.top
            }, this.data.scale);
            $b225529de5fe4d82$var$Y(this.element, {
                transform: "translate(".concat(t.x, ", ").concat(t.y, ")")
            });
        }
        return e.prototype.update.call(this);
    }, n;
}($b225529de5fe4d82$var$at);
$b225529de5fe4d82$var$ut($b225529de5fe4d82$export$d223442bf82eaf54, $b225529de5fe4d82$var$mt);
var $b225529de5fe4d82$var$vt = function(t) {
    function e(e, n) {
        return t.call(this, e, n) || this;
    }
    return $b225529de5fe4d82$var$P(e, t), e.prototype.updateGraphic = function(t, e) {
        if (void 0 === e && (e = !0), $b225529de5fe4d82$var$et(this.element)) {
            var n = this.getCommands(), i = function(t, e, n, i) {
                var r = {
                    x: Number.MAX_SAFE_INTEGER,
                    y: Number.MAX_SAFE_INTEGER
                };
                return $b225529de5fe4d82$var$W(t).forEach(function(t) {
                    var o = $b225529de5fe4d82$var$I(e, n, t.point, i);
                    (o.x < r.x || o.x === r.x && o.y < r.y) && (r.x = o.x, r.y = o.y);
                }), r;
            }(n, this.data.centerX, this.data.centerY, this.data.scale);
            $b225529de5fe4d82$var$Y(this.element, {
                d: $b225529de5fe4d82$var$q(n, this.data.centerX, this.data.centerY, this.data.scale, e)
            }), this.updatePatternTransform(i, t), this.updateAnimations();
        }
    }, e;
}($b225529de5fe4d82$var$ot), $b225529de5fe4d82$var$bt = {
    right: 0,
    left: 0,
    top: 0
}, $b225529de5fe4d82$var$_t = function(e) {
    function n(n) {
        return e.call(this, $b225529de5fe4d82$var$C($b225529de5fe4d82$var$C({}, $b225529de5fe4d82$var$bt), n), $b225529de5fe4d82$var$t.path) || this;
    }
    return $b225529de5fe4d82$var$P(n, e), n.prototype.update = function() {
        return this.updateGraphic(this.planeView), this;
    }, n.prototype.clear = function() {
        return $b225529de5fe4d82$var$Y(this.element, {
            d: ""
        }), this;
    }, Object.defineProperty(n.prototype, "planeView", {
        get: function() {
            return this.props.planeView;
        },
        set: function(t) {
            this.props.planeView = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), n;
}($b225529de5fe4d82$var$vt);
$b225529de5fe4d82$var$ut($b225529de5fe4d82$var$_t, $b225529de5fe4d82$var$mt);
var $b225529de5fe4d82$export$f54a3aa3bdb4a9c8 = function(e) {
    function i(t) {
        var n = this, i = t.height, r = t.width, o = $b225529de5fe4d82$var$w(t, [
            "height",
            "width"
        ]);
        return (n = e.call(this, o) || this)._width = r, n._height = i, n;
    }
    return $b225529de5fe4d82$var$P(i, e), i.prototype.getCommands = function(t) {
        var e, n, i, r, o, c = null !== (e = null == t ? void 0 : t.right) && void 0 !== e ? e : this.right, u = null !== (n = null == t ? void 0 : t.left) && void 0 !== n ? n : this.left, h = null !== (i = null == t ? void 0 : t.top) && void 0 !== i ? i : this.top, p = null !== (r = null == t ? void 0 : t.width) && void 0 !== r ? r : this.width, l = null !== (o = null == t ? void 0 : t.height) && void 0 !== o ? o : this.height, d = [
            {
                command: $b225529de5fe4d82$var$a.move,
                point: {
                    r: 0,
                    l: 0,
                    t: 0
                }
            }
        ];
        switch(this.planeView){
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.FRONT:
                d.push({
                    command: $b225529de5fe4d82$var$a.line,
                    point: {
                        r: 0,
                        l: p,
                        t: 0
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.line,
                    point: {
                        r: 0,
                        l: p,
                        t: l
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.line,
                    point: {
                        r: 0,
                        l: 0,
                        t: l
                    }
                });
                break;
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.SIDE:
                d.push({
                    command: $b225529de5fe4d82$var$a.line,
                    point: {
                        r: p,
                        l: 0,
                        t: 0
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.line,
                    point: {
                        r: p,
                        l: 0,
                        t: l
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.line,
                    point: {
                        r: 0,
                        l: 0,
                        t: l
                    }
                });
                break;
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.TOP:
                d.push({
                    command: $b225529de5fe4d82$var$a.line,
                    point: {
                        r: p,
                        l: 0,
                        t: 0
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.line,
                    point: {
                        r: p,
                        l: l,
                        t: 0
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.line,
                    point: {
                        r: 0,
                        l: l,
                        t: 0
                    }
                });
        }
        return $b225529de5fe4d82$var$J(d, c, u, h), d;
    }, i.prototype.getRectanglePath = function(t) {
        var e = this.getCommands(t);
        return $b225529de5fe4d82$var$q(e, this.data.centerX, this.data.centerY, this.data.scale, !0);
    }, i.prototype.updateSubClassAnimations = function() {
        var e = this;
        this.animations.forEach(function(i) {
            if (!$b225529de5fe4d82$var$K(i.property)) {
                var r = {
                    right: e.right,
                    left: e.left,
                    top: e.top,
                    width: e.width,
                    height: e.height
                };
                if (Object.prototype.hasOwnProperty.call(r, i.property)) {
                    var o = i.property, a = void 0;
                    if (i.values) {
                        if (Array.isArray(i.values)) a = {
                            values: i.values.map(function(t) {
                                var n = $b225529de5fe4d82$var$C({}, r);
                                return n[o] = +t, e.getRectanglePath(n);
                            }).join(";")
                        };
                        else {
                            var s = $b225529de5fe4d82$var$C({}, r);
                            s[o] = +i.values, a = {
                                values: e.getRectanglePath(s)
                            };
                        }
                    } else {
                        var c = $b225529de5fe4d82$var$C({}, r), u = $b225529de5fe4d82$var$C({}, r);
                        c[o] = +i.from, u[o] = +i.to, a = {
                            from: e.getRectanglePath(c),
                            to: e.getRectanglePath(u)
                        };
                    }
                    i.element || (i.element = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.animate)), i.element.parentNode || e.element.appendChild(i.element), e.addAnimationBasicProperties("d", i), $b225529de5fe4d82$var$Y(i.element, a);
                }
            }
        });
    }, Object.defineProperty(i.prototype, "width", {
        get: function() {
            return this._width;
        },
        set: function(t) {
            this._width = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "height", {
        get: function() {
            return this._height;
        },
        set: function(t) {
            this._height = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.addAnimation = function(t) {
        return e.prototype.addAnimation.call(this, t);
    }, i.prototype.animateDimensions = function(t, e) {
        return void 0 === e && (e = 1), this._animInfo = {
            dims: t,
            duration: e
        }, this;
    }, i.prototype.updateAnimations2 = function() {
        var e = this, i = this._animInfo, r = i.dims, o = i.duration, a = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.animate);
        this.element.appendChild(a);
        var s = {
            repeatCount: "indefinite",
            attributeName: "d",
            dur: "".concat(o, "s"),
            values: r.map(function(t) {
                return e.getRectanglePath(t);
            }).join(";")
        };
        console.log("updateAnimations2", s), $b225529de5fe4d82$var$Y(a, s);
    }, i;
}($b225529de5fe4d82$var$_t), $b225529de5fe4d82$export$77cf72652ee46fc7 = function(e) {
    function i(t) {
        var n = this, i = t.radius, r = $b225529de5fe4d82$var$w(t, [
            "radius"
        ]);
        return (n = e.call(this, r) || this)._radius = i, n;
    }
    return $b225529de5fe4d82$var$P(i, e), i.prototype.getCommands = function(t) {
        var e, n, i, r, o = null !== (e = null == t ? void 0 : t.right) && void 0 !== e ? e : this.right, c = null !== (n = null == t ? void 0 : t.left) && void 0 !== n ? n : this.left, u = null !== (i = null == t ? void 0 : t.top) && void 0 !== i ? i : this.top, h = null !== (r = null == t ? void 0 : t.radius) && void 0 !== r ? r : this.radius, p = [];
        switch(this.planeView){
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.FRONT:
                p.push({
                    command: $b225529de5fe4d82$var$a.move,
                    point: {
                        r: 0,
                        l: h,
                        t: 0
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.curve,
                    point: {
                        r: 0,
                        l: -h,
                        t: 0
                    },
                    control: {
                        r: 0,
                        l: 0,
                        t: -h
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.curve,
                    point: {
                        r: 0,
                        l: h,
                        t: 0
                    },
                    control: {
                        r: 0,
                        l: 0,
                        t: h
                    }
                });
                break;
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.SIDE:
                p.push({
                    command: $b225529de5fe4d82$var$a.move,
                    point: {
                        r: -h,
                        l: 0,
                        t: 0
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.curve,
                    point: {
                        r: h,
                        l: 0,
                        t: 0
                    },
                    control: {
                        r: 0,
                        l: 0,
                        t: -h
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.curve,
                    point: {
                        r: -h,
                        l: 0,
                        t: 0
                    },
                    control: {
                        r: 0,
                        l: 0,
                        t: h
                    }
                });
                break;
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.TOP:
                p.push({
                    command: $b225529de5fe4d82$var$a.move,
                    point: {
                        r: 0,
                        l: h,
                        t: 0
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.curve,
                    point: {
                        r: 0,
                        l: -h,
                        t: 0
                    },
                    control: {
                        r: h,
                        l: 0,
                        t: 0
                    }
                }, {
                    command: $b225529de5fe4d82$var$a.curve,
                    point: {
                        r: 0,
                        l: h,
                        t: 0
                    },
                    control: {
                        r: -h,
                        l: 0,
                        t: 0
                    }
                });
        }
        return $b225529de5fe4d82$var$J(p, o, c, u), p;
    }, i.prototype.getCirclePath = function(t) {
        var e = this.getCommands(t);
        return $b225529de5fe4d82$var$q(e, this.data.centerX, this.data.centerY, this.data.scale, !0);
    }, i.prototype.updateSubClassAnimations = function() {
        var e = this;
        this.animations.forEach(function(i) {
            if (!$b225529de5fe4d82$var$K(i.property)) {
                var r = {
                    right: e.right,
                    left: e.left,
                    top: e.top,
                    radius: e.radius
                };
                if (Object.prototype.hasOwnProperty.call(r, i.property)) {
                    var o = i.property, a = void 0;
                    if (i.values) {
                        if (Array.isArray(i.values)) a = {
                            values: i.values.map(function(t) {
                                var n = $b225529de5fe4d82$var$C({}, r);
                                return n[o] = +t, e.getCirclePath(n);
                            }).join(";")
                        };
                        else {
                            var s = $b225529de5fe4d82$var$C({}, r);
                            s[o] = +i.values, a = {
                                values: e.getCirclePath(s)
                            };
                        }
                    } else {
                        var c = $b225529de5fe4d82$var$C({}, r), u = $b225529de5fe4d82$var$C({}, r);
                        c[o] = +i.from, u[o] = +i.to, a = {
                            from: e.getCirclePath(c),
                            to: e.getCirclePath(u)
                        };
                    }
                    i.element || (i.element = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.animate)), i.element.parentNode || e.element.appendChild(i.element), e.addAnimationBasicProperties("d", i), $b225529de5fe4d82$var$Y(i.element, a);
                }
            }
        });
    }, Object.defineProperty(i.prototype, "radius", {
        get: function() {
            return this._radius;
        },
        set: function(t) {
            this._radius = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.addAnimation = function(t) {
        return e.prototype.addAnimation.call(this, t);
    }, i.prototype.updateAnimations2 = function() {}, i;
}($b225529de5fe4d82$var$_t), $b225529de5fe4d82$var$Ot = function(e) {
    function i(t) {
        var n = this, i = t.radius, r = t.points, o = t.density, a = t.rotation, s = void 0 === a ? 0 : a, c = $b225529de5fe4d82$var$w(t, [
            "radius",
            "points",
            "density",
            "rotation"
        ]);
        return (n = e.call(this, c) || this)._radius = i, n._points = r, n._density = o, n._rotation = s, n._sector = 2 * Math.PI / n._points, n._halfSector = n._sector / 2, n;
    }
    return $b225529de5fe4d82$var$P(i, e), i.prototype.getCommands = function(t) {
        var e, n, i, r, o, c, u, h = null !== (e = null == t ? void 0 : t.right) && void 0 !== e ? e : this.right, p = null !== (n = null == t ? void 0 : t.left) && void 0 !== n ? n : this.left, l = null !== (i = null == t ? void 0 : t.top) && void 0 !== i ? i : this.top, d = null !== (r = null == t ? void 0 : t.radius) && void 0 !== r ? r : this.radius, f = null !== (o = null == t ? void 0 : t.points) && void 0 !== o ? o : this._points, m = null !== (c = null == t ? void 0 : t.density) && void 0 !== c ? c : this._density, g = null !== (u = null == t ? void 0 : t.rotation) && void 0 !== u ? u : this.rotation, y = this.get2DCoordinates(d, f, m, g), v = [];
        switch(this.planeView){
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.FRONT:
                y.forEach(function(t, e) {
                    v.push({
                        command: 0 === e ? $b225529de5fe4d82$var$a.move : $b225529de5fe4d82$var$a.line,
                        point: {
                            r: 0,
                            l: t.x,
                            t: t.y
                        }
                    });
                });
                break;
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.SIDE:
                y.forEach(function(t, e) {
                    v.push({
                        command: 0 === e ? $b225529de5fe4d82$var$a.move : $b225529de5fe4d82$var$a.line,
                        point: {
                            r: t.x,
                            l: 0,
                            t: t.y
                        }
                    });
                });
                break;
            case $b225529de5fe4d82$export$34151b55b8cbc6dd.TOP:
                y.forEach(function(t, e) {
                    v.push({
                        command: 0 === e ? $b225529de5fe4d82$var$a.move : $b225529de5fe4d82$var$a.line,
                        point: {
                            r: -t.x,
                            l: -t.y,
                            t: 0
                        }
                    });
                });
        }
        return $b225529de5fe4d82$var$J(v, h, p, l), v;
    }, i.prototype._getRadianAngle = function(t) {
        return t * Math.PI / 180;
    }, i.prototype._getInnerRadius = function(t, e, n) {
        return t * Math.cos(Math.PI * n / e) / Math.cos(Math.PI * (n - 1) / e);
    }, i.prototype.get2DCoordinates = function(t, e, n, i) {
        var r = this, o = this._getInnerRadius(t, e, n);
        return $b225529de5fe4d82$var$A([], Array(this._points), !0).reduce(function(e, n, a) {
            var s = a * r._sector + 2 * Math.PI - r._getRadianAngle(i), c = s + r._halfSector, u = Math.sin(s) * t, h = Math.cos(s) * t, p = Math.sin(c) * o, l = Math.cos(c) * o;
            return $b225529de5fe4d82$var$A($b225529de5fe4d82$var$A([], e, !0), [
                {
                    x: u,
                    y: h
                },
                {
                    x: p,
                    y: l
                }
            ], !1);
        }, []);
    }, i.prototype.getPentagramPath = function(t) {
        var e = this.getCommands(t);
        return $b225529de5fe4d82$var$q(e, this.data.centerX, this.data.centerY, this.data.scale, !0);
    }, i.prototype.updateSubClassAnimations = function() {
        var e = this;
        this.animations.forEach(function(i) {
            if (!$b225529de5fe4d82$var$K(i.property)) {
                var r = {
                    right: e.right,
                    left: e.left,
                    top: e.top,
                    radius: e.radius,
                    points: e._points,
                    density: e._density,
                    rotation: e.rotation
                };
                if (Object.prototype.hasOwnProperty.call(r, i.property)) {
                    var o = i.property, a = void 0;
                    if (i.values) {
                        if (Array.isArray(i.values)) a = {
                            values: i.values.map(function(t) {
                                var n = $b225529de5fe4d82$var$C({}, r);
                                return n[o] = +t, e.getPentagramPath(n);
                            }).join(";")
                        };
                        else {
                            var s = $b225529de5fe4d82$var$C({}, r);
                            s[o] = +i.values, a = {
                                values: e.getPentagramPath(s)
                            };
                        }
                    } else {
                        var c = $b225529de5fe4d82$var$C({}, r), u = $b225529de5fe4d82$var$C({}, r);
                        c[o] = +i.from, u[o] = +i.to, a = {
                            from: e.getPentagramPath(c),
                            to: e.getPentagramPath(u)
                        };
                    }
                    i.element || (i.element = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.animate)), i.element.parentNode || e.element.appendChild(i.element), e.addAnimationBasicProperties("d", i), $b225529de5fe4d82$var$Y(i.element, a);
                }
            }
        });
    }, Object.defineProperty(i.prototype, "radius", {
        get: function() {
            return this._radius;
        },
        set: function(t) {
            this._radius = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "rotation", {
        get: function() {
            return this._rotation;
        },
        set: function(t) {
            this._rotation = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.addAnimation = function(t) {
        return e.prototype.addAnimation.call(this, t);
    }, i;
}($b225529de5fe4d82$var$_t), $b225529de5fe4d82$export$893c7f23d4115570 = function(t) {
    function e(e) {
        return t.call(this, $b225529de5fe4d82$var$C($b225529de5fe4d82$var$C({}, e), {
            points: 5,
            density: 2
        })) || this;
    }
    return $b225529de5fe4d82$var$P(e, t), e.prototype.updateAnimations2 = function() {}, e;
}($b225529de5fe4d82$var$Ot), $b225529de5fe4d82$export$d3c4444c1d97c361 = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $b225529de5fe4d82$var$P(e, t), Object.defineProperty(e.prototype, "points", {
        get: function() {
            return this._points;
        },
        set: function(t) {
            this._points = t, this._sector = 2 * Math.PI / this._points, this._halfSector = this._sector / 2, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "density", {
        get: function() {
            return this._density;
        },
        set: function(t) {
            this._density = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.updateAnimations2 = function() {}, e;
}($b225529de5fe4d82$var$Ot), $b225529de5fe4d82$export$271c527cab8eab68 = function(e) {
    function i(n) {
        void 0 === n && (n = {});
        var i = e.call(this, n, $b225529de5fe4d82$var$t.path) || this;
        return i.getPathFromCommands = function(t) {
            return $b225529de5fe4d82$var$q($b225529de5fe4d82$var$Q(t), i.data.centerX, i.data.centerY, i.data.scale, i._autoclose);
        }, i.commands = [], i._autoclose = !("autoclose" in n) || n.autoclose, i;
    }
    return $b225529de5fe4d82$var$P(i, e), i.prototype.updateSubClassAnimations = function() {
        var e = this;
        this.animations.forEach(function(i) {
            if ("path" === i.property) {
                var r = void 0;
                r = i.values ? {
                    values: Array.isArray(i.values) ? i.values.map(function(t) {
                        return e.getPathFromCommands("".concat(t));
                    }).join(";") : e.getPathFromCommands("".concat(i.values))
                } : {
                    from: e.getPathFromCommands("".concat(i.from)),
                    to: e.getPathFromCommands("".concat(i.to))
                }, i.element || (i.element = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.animate)), i.element.parentNode || e.element.appendChild(i.element), e.addAnimationBasicProperties("d", i), $b225529de5fe4d82$var$Y(i.element, r);
            }
        });
    }, i.prototype.getCommands = function() {
        return this.commands;
    }, Object.defineProperty(i.prototype, "autoclose", {
        get: function() {
            return this._autoclose;
        },
        set: function(t) {
            this._autoclose = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.update = function() {
        return this.updateGraphic(void 0, this.autoclose), this;
    }, i.prototype.clear = function() {
        return this.commands.splice(0), $b225529de5fe4d82$var$Y(this.element, {
            d: ""
        }), this;
    }, i.prototype.moveTo = function(t, e, n) {
        return this.commands.push({
            command: $b225529de5fe4d82$var$a.move,
            point: {
                r: t,
                l: e,
                t: n
            }
        }), this.update(), this;
    }, i.prototype.lineTo = function(t, e, n) {
        return this.commands.push({
            command: $b225529de5fe4d82$var$a.line,
            point: {
                r: t,
                l: e,
                t: n
            }
        }), this.update(), this;
    }, i.prototype.curveTo = function(t, e, n, i, r, o) {
        return this.commands.push({
            command: $b225529de5fe4d82$var$a.curve,
            control: {
                r: t,
                l: e,
                t: n
            },
            point: {
                r: i,
                l: r,
                t: o
            }
        }), this.update(), this;
    }, i.prototype.mt = function(t, e, n) {
        return this.moveTo(t, e, n);
    }, i.prototype.lt = function(t, e, n) {
        return this.lineTo(t, e, n);
    }, i.prototype.ct = function(t, e, n, i, r, o) {
        return this.curveTo(t, e, n, i, r, o);
    }, i.prototype.draw = function(t) {
        return this.commands = $b225529de5fe4d82$var$Q(t), this.update(), this;
    }, i.prototype.addAnimation = function(t) {
        return e.prototype.addAnimation.call(this, t);
    }, i.prototype.updateAnimations2 = function() {}, i;
}($b225529de5fe4d82$var$vt), $b225529de5fe4d82$export$b5ee75f3884097c5 = function(e) {
    function i(i) {
        var r, o = this, a = i.planeView, s = i.text, c = void 0 === s ? "" : s, u = i.fontFamily, h = void 0 === u ? "Arial" : u, l = i.fontSize, d = void 0 === l ? 12 : l, f = i.fontStyle, m = void 0 === f ? "normal" : f, g = i.fontWeight, y = void 0 === g ? "normal" : g, v = i.origin, b = void 0 === v ? [
            "center",
            "center"
        ] : v, _ = i.right, x = void 0 === _ ? 0 : _, E = i.left, O = void 0 === E ? 0 : E, P = i.top, C = void 0 === P ? 0 : P, A = i.rotation, T = void 0 === A ? 0 : A, S = i.selectable, j = void 0 === S || S, k = $b225529de5fe4d82$var$w(i, [
            "planeView",
            "text",
            "fontFamily",
            "fontSize",
            "fontStyle",
            "fontWeight",
            "origin",
            "right",
            "left",
            "top",
            "rotation",
            "selectable"
        ]);
        return (o = e.call(this, k, $b225529de5fe4d82$var$t.group) || this)._originHash = ((r = {})[$b225529de5fe4d82$var$p.CENTER] = "middle", r[$b225529de5fe4d82$var$p.LEFT] = "start", r[$b225529de5fe4d82$var$p.RIGHT] = "end", r[$b225529de5fe4d82$var$p.TOP] = "hanging", r[$b225529de5fe4d82$var$p.BOTTOM] = "baseline", r), o.commonAnimationAttributes = {
            attributeName: "transform",
            attributeType: "XML",
            additive: "sum",
            fill: "freeze"
        }, o.getMatrixTransform = function(t) {
            var e = $b225529de5fe4d82$var$tt(o.getPositionTransform(t), o.planeView, 1);
            return "".concat(e, " rotate(").concat(o.rotation, ")");
        }, o._textElement = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.text), o._tspan = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.tspan), o._textElement.appendChild(o._tspan), o.element.appendChild(o._textElement), o.planeView = a, o.fontFamily = h, o.fontSize = d, o.fontStyle = m, o.fontWeight = y, o.selectable = j, o.origin = b, o.right = x, o.left = O, o.top = C, o.rotation = T, o.text = c, o;
    }
    return $b225529de5fe4d82$var$P(i, e), i.prototype.getPositionTransform = function(t, e) {
        return void 0 === e && (e = !0), $b225529de5fe4d82$var$I(e ? this.data.centerX : 0, e ? this.data.centerY : 0, {
            r: t.right,
            l: t.left,
            t: t.top
        }, this.data.scale);
    }, i.prototype.updateSubClassAnimations = function() {
        var e = this, i = {
            right: 0,
            left: 0,
            top: 0,
            rotation: 0
        };
        this.animations.forEach(function(r) {
            if (!$b225529de5fe4d82$var$K(r.property) && Object.prototype.hasOwnProperty.call(i, r.property)) {
                var o = r.property, a = "rotation" === o, s = $b225529de5fe4d82$var$C($b225529de5fe4d82$var$C({}, e.commonAnimationAttributes), {
                    type: a ? "rotate" : "translate",
                    begin: "indefinite"
                }), c = void 0;
                if (r.values) {
                    if (Array.isArray(r.values)) c = $b225529de5fe4d82$var$C({
                        values: r.values.map(function(t) {
                            if (a) return "".concat(t);
                            var n = $b225529de5fe4d82$var$C({}, i);
                            n[o] = +t - e[o];
                            var r = e.getPositionTransform(n, !1);
                            return "".concat(r.x, ",").concat(r.y);
                        }).join(";")
                    }, s);
                    else if (a) c = $b225529de5fe4d82$var$C({
                        values: "".concat(r.values)
                    }, s);
                    else {
                        var u = $b225529de5fe4d82$var$C({}, i);
                        u[o] = +r.values - e[o];
                        var h = e.getPositionTransform(u, !1);
                        c = $b225529de5fe4d82$var$C({
                            values: "".concat(h.x, ",").concat(h.y)
                        }, s);
                    }
                } else if (a) c = $b225529de5fe4d82$var$C({
                    from: "".concat(r.from),
                    to: "".concat(r.to)
                }, s);
                else {
                    var p = $b225529de5fe4d82$var$C({}, i), l = $b225529de5fe4d82$var$C({}, i);
                    p[o] = +r.from - e[o], l[o] = +r.to - e[o];
                    var d = e.getPositionTransform(p, !1), f = e.getPositionTransform(l, !1);
                    c = $b225529de5fe4d82$var$C({
                        from: "".concat(d.x, ",").concat(d.y),
                        to: "".concat(f.x, ",").concat(f.y)
                    }, s);
                }
                r.element || (r.element = document.createElementNS($b225529de5fe4d82$var$n, $b225529de5fe4d82$var$t.animateTransform)), e.addAnimationBasicProperties("transform", r), $b225529de5fe4d82$var$Y(r.element, c), r.element.parentNode || (a ? e._textElement.appendChild(r.element) : e.element.appendChild(r.element)), window.requestAnimationFrame(function() {
                    r.element.beginElement();
                });
            }
        });
    }, i.prototype.update = function() {
        if ($b225529de5fe4d82$var$et(this.element)) {
            var t = this.getMatrixTransform({
                right: this.right,
                left: this.left,
                top: this.top
            });
            $b225529de5fe4d82$var$Y(this._textElement, {
                transform: t
            }), this._tspan.textContent = this._text, this.updatePatternTransform({
                x: 0,
                y: 0
            }, this.planeView), this.updateAnimations();
        }
        return this;
    }, i.prototype.clear = function() {
        return this.text = "", this.update(), this;
    }, Object.defineProperty(i.prototype, "text", {
        get: function() {
            return this._text;
        },
        set: function(t) {
            this._text = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "planeView", {
        get: function() {
            return this._planeView;
        },
        set: function(t) {
            this._planeView = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fontFamily", {
        get: function() {
            return this._fontFamily;
        },
        set: function(t) {
            this._fontFamily = t, $b225529de5fe4d82$var$Y(this._tspan, {
                "font-family": this._fontFamily
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fontSize", {
        get: function() {
            return this._fontSize;
        },
        set: function(t) {
            this._fontSize = t, $b225529de5fe4d82$var$Y(this._tspan, {
                "font-size": "".concat(this._fontSize, "px")
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fontStyle", {
        get: function() {
            return this._fontStyle;
        },
        set: function(t) {
            this._fontStyle = t, $b225529de5fe4d82$var$Y(this._tspan, {
                "font-style": "".concat(this._fontStyle)
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fontWeight", {
        get: function() {
            return this._fontWeight;
        },
        set: function(t) {
            this._fontWeight = t, $b225529de5fe4d82$var$Y(this._tspan, {
                "font-weight": "".concat(this._fontWeight)
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "selectable", {
        get: function() {
            return this._selectable;
        },
        set: function(t) {
            this._selectable = t, this._selectable ? this._textElement.removeAttribute("style") : $b225529de5fe4d82$var$Y(this._textElement, {
                style: [
                    "-webkit-user-select",
                    "-moz-user-select",
                    "-ms-user-select",
                    "user-select",
                    "pointer-events"
                ].map(function(t) {
                    return "".concat(t, ": none");
                }).join(";")
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "origin", {
        get: function() {
            return this._origin;
        },
        set: function(t) {
            this._origin = t;
            var e = this._origin, n = e[0], i = e[1];
            $b225529de5fe4d82$var$Y(this._tspan, {
                "text-anchor": this._originHash[n],
                "alignment-baseline": this._originHash[i]
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "right", {
        get: function() {
            return this._right;
        },
        set: function(t) {
            this._right !== t && (this._right = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "left", {
        get: function() {
            return this._left;
        },
        set: function(t) {
            this._left !== t && (this._left = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "top", {
        get: function() {
            return this._top;
        },
        set: function(t) {
            this._top !== t && (this._top = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "rotation", {
        get: function() {
            return this._rotation;
        },
        set: function(t) {
            this._rotation !== t && (this._rotation = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.updateAnimations2 = function() {}, i;
}($b225529de5fe4d82$var$ot);


parcelRequire("5oaC6");


var $f22df01f36f3bbc5$var$noop = {
    value: ()=>{}
};
function $f22df01f36f3bbc5$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $f22df01f36f3bbc5$var$Dispatch(_);
}
function $f22df01f36f3bbc5$var$Dispatch(_) {
    this._ = _;
}
function $f22df01f36f3bbc5$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$f22df01f36f3bbc5$var$Dispatch.prototype = $f22df01f36f3bbc5$var$dispatch.prototype = {
    constructor: $f22df01f36f3bbc5$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $f22df01f36f3bbc5$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $f22df01f36f3bbc5$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $f22df01f36f3bbc5$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $f22df01f36f3bbc5$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $f22df01f36f3bbc5$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $f22df01f36f3bbc5$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $f22df01f36f3bbc5$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $f22df01f36f3bbc5$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $f22df01f36f3bbc5$export$2e2bcd8739ae039 = $f22df01f36f3bbc5$var$dispatch;



function $a696f7efe74d657f$var$none() {}
function $a696f7efe74d657f$export$2e2bcd8739ae039(selector) {
    return selector == null ? $a696f7efe74d657f$var$none : function() {
        return this.querySelector(selector);
    };
}


function $fe3e8a5771c356f3$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $a696f7efe74d657f$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $6100a2c8d9353abb$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $a251e86126c3c196$var$empty() {
    return [];
}
function $a251e86126c3c196$export$2e2bcd8739ae039(selector) {
    return selector == null ? $a251e86126c3c196$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $c3afa9f57c3c6584$var$arrayAll(select) {
    return function() {
        return (0, $6100a2c8d9353abb$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $c3afa9f57c3c6584$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $c3afa9f57c3c6584$var$arrayAll(select);
    else select = (0, $a251e86126c3c196$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(subgroups, parents);
}


function $9217c1f6bb2d2b85$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $9217c1f6bb2d2b85$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $b34141b01ced0a61$var$find = Array.prototype.find;
function $b34141b01ced0a61$var$childFind(match) {
    return function() {
        return $b34141b01ced0a61$var$find.call(this.children, match);
    };
}
function $b34141b01ced0a61$var$childFirst() {
    return this.firstElementChild;
}
function $b34141b01ced0a61$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $b34141b01ced0a61$var$childFirst : $b34141b01ced0a61$var$childFind(typeof match === "function" ? match : (0, $9217c1f6bb2d2b85$export$90c2759c036528)(match)));
}



var $437727374f9902ec$var$filter = Array.prototype.filter;
function $437727374f9902ec$var$children() {
    return Array.from(this.children);
}
function $437727374f9902ec$var$childrenFilter(match) {
    return function() {
        return $437727374f9902ec$var$filter.call(this.children, match);
    };
}
function $437727374f9902ec$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $437727374f9902ec$var$children : $437727374f9902ec$var$childrenFilter(typeof match === "function" ? match : (0, $9217c1f6bb2d2b85$export$90c2759c036528)(match)));
}




function $417eb06912872de0$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $9217c1f6bb2d2b85$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(subgroups, this._parents);
}



function $16e10e18a783a307$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $b2f4aac14f806d3c$export$2e2bcd8739ae039() {
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(this._enter || this._groups.map((0, $16e10e18a783a307$export$2e2bcd8739ae039)), this._parents);
}
function $b2f4aac14f806d3c$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$b2f4aac14f806d3c$export$67b01759a14cf6a4.prototype = {
    constructor: $b2f4aac14f806d3c$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $75c268d1af54dd4d$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $052a9a1821040aa9$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $b2f4aac14f806d3c$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $052a9a1821040aa9$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $b2f4aac14f806d3c$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $052a9a1821040aa9$var$datum(node) {
    return node.__data__;
}
function $052a9a1821040aa9$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $052a9a1821040aa9$var$datum);
    var bind = key ? $052a9a1821040aa9$var$bindKey : $052a9a1821040aa9$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $75c268d1af54dd4d$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $052a9a1821040aa9$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $052a9a1821040aa9$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $0e815177caeed21b$export$2e2bcd8739ae039() {
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(this._exit || this._groups.map((0, $16e10e18a783a307$export$2e2bcd8739ae039)), this._parents);
}


function $63f586900c2b4b42$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $7a412a9de8021db3$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(merges, this._parents);
}


function $e17552b51cfac160$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $6d597722efeda79a$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $6d597722efeda79a$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $6d597722efeda79a$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $ae070bcd7d1235fe$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $c6e4ab7976218275$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $055d135910c13cd5$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $f897b6f378fcb9fc$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $889880c4b5f21a22$export$2e2bcd8739ae039() {
    return !this.node();
}


function $b879b1474342de48$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $a95bc3014beac1d3$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $a95bc3014beac1d3$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $a95bc3014beac1d3$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $58b58edfe5dae49c$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $a95bc3014beac1d3$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $a95bc3014beac1d3$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $d206eec3d2c8e9d1$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $d206eec3d2c8e9d1$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $d206eec3d2c8e9d1$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $d206eec3d2c8e9d1$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $d206eec3d2c8e9d1$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $d206eec3d2c8e9d1$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $d206eec3d2c8e9d1$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $d206eec3d2c8e9d1$var$attrRemoveNS : $d206eec3d2c8e9d1$var$attrRemove : typeof value === "function" ? fullname.local ? $d206eec3d2c8e9d1$var$attrFunctionNS : $d206eec3d2c8e9d1$var$attrFunction : fullname.local ? $d206eec3d2c8e9d1$var$attrConstantNS : $d206eec3d2c8e9d1$var$attrConstant)(fullname, value));
}


function $a802501d7f7ae391$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $df9d8f43b4be6d4b$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $df9d8f43b4be6d4b$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $df9d8f43b4be6d4b$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $df9d8f43b4be6d4b$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $df9d8f43b4be6d4b$var$styleRemove : typeof value === "function" ? $df9d8f43b4be6d4b$var$styleFunction : $df9d8f43b4be6d4b$var$styleConstant)(name, value, priority == null ? "" : priority)) : $df9d8f43b4be6d4b$export$5e3cec964f0b5efd(this.node(), name);
}
function $df9d8f43b4be6d4b$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $a802501d7f7ae391$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $f99b3adab0522f33$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $f99b3adab0522f33$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $f99b3adab0522f33$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $f99b3adab0522f33$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $f99b3adab0522f33$var$propertyRemove : typeof value === "function" ? $f99b3adab0522f33$var$propertyFunction : $f99b3adab0522f33$var$propertyConstant)(name, value)) : this.node()[name];
}


function $d06e661034a45406$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $d06e661034a45406$var$classList(node) {
    return node.classList || new $d06e661034a45406$var$ClassList(node);
}
function $d06e661034a45406$var$ClassList(node) {
    this._node = node;
    this._names = $d06e661034a45406$var$classArray(node.getAttribute("class") || "");
}
$d06e661034a45406$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $d06e661034a45406$var$classedAdd(node, names) {
    var list = $d06e661034a45406$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $d06e661034a45406$var$classedRemove(node, names) {
    var list = $d06e661034a45406$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $d06e661034a45406$var$classedTrue(names) {
    return function() {
        $d06e661034a45406$var$classedAdd(this, names);
    };
}
function $d06e661034a45406$var$classedFalse(names) {
    return function() {
        $d06e661034a45406$var$classedRemove(this, names);
    };
}
function $d06e661034a45406$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $d06e661034a45406$var$classedAdd : $d06e661034a45406$var$classedRemove)(this, names);
    };
}
function $d06e661034a45406$export$2e2bcd8739ae039(name, value) {
    var names = $d06e661034a45406$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $d06e661034a45406$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $d06e661034a45406$var$classedFunction : value ? $d06e661034a45406$var$classedTrue : $d06e661034a45406$var$classedFalse)(names, value));
}


function $039cad3e6b62ef93$var$textRemove() {
    this.textContent = "";
}
function $039cad3e6b62ef93$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $039cad3e6b62ef93$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $039cad3e6b62ef93$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $039cad3e6b62ef93$var$textRemove : (typeof value === "function" ? $039cad3e6b62ef93$var$textFunction : $039cad3e6b62ef93$var$textConstant)(value)) : this.node().textContent;
}


function $c8e884507bcbc0d6$var$htmlRemove() {
    this.innerHTML = "";
}
function $c8e884507bcbc0d6$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $c8e884507bcbc0d6$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $c8e884507bcbc0d6$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $c8e884507bcbc0d6$var$htmlRemove : (typeof value === "function" ? $c8e884507bcbc0d6$var$htmlFunction : $c8e884507bcbc0d6$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $d32582798f21257c$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $d32582798f21257c$export$2e2bcd8739ae039() {
    return this.each($d32582798f21257c$var$raise);
}


function $81fa89a3cf707281$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $81fa89a3cf707281$export$2e2bcd8739ae039() {
    return this.each($81fa89a3cf707281$var$lower);
}




function $9eff7b5d7c009c96$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $a95bc3014beac1d3$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $a95bc3014beac1d3$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $9eff7b5d7c009c96$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $9eff7b5d7c009c96$export$2e2bcd8739ae039(name) {
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $9eff7b5d7c009c96$var$creatorFixed : $9eff7b5d7c009c96$var$creatorInherit)(fullname);
}


function $e7e5728b38923688$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $9eff7b5d7c009c96$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $92828970e51f2858$var$constantNull() {
    return null;
}
function $92828970e51f2858$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $9eff7b5d7c009c96$export$2e2bcd8739ae039)(name), select = before == null ? $92828970e51f2858$var$constantNull : typeof before === "function" ? before : (0, $a696f7efe74d657f$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $3fba60665c09da9b$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $3fba60665c09da9b$export$2e2bcd8739ae039() {
    return this.each($3fba60665c09da9b$var$remove);
}


function $f8ba4680beaf3292$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $f8ba4680beaf3292$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $f8ba4680beaf3292$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $f8ba4680beaf3292$var$selection_cloneDeep : $f8ba4680beaf3292$var$selection_cloneShallow);
}


function $d5e7be624eaf3e5d$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $f620cfb2b91d85e5$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $f620cfb2b91d85e5$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $f620cfb2b91d85e5$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $f620cfb2b91d85e5$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $f620cfb2b91d85e5$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $f620cfb2b91d85e5$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $f620cfb2b91d85e5$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $f620cfb2b91d85e5$var$onAdd : $f620cfb2b91d85e5$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $049280ac271fdabe$var$dispatchEvent(node, type, params) {
    var window = (0, $a802501d7f7ae391$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $049280ac271fdabe$var$dispatchConstant(type, params) {
    return function() {
        return $049280ac271fdabe$var$dispatchEvent(this, type, params);
    };
}
function $049280ac271fdabe$var$dispatchFunction(type, params) {
    return function() {
        return $049280ac271fdabe$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $049280ac271fdabe$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $049280ac271fdabe$var$dispatchFunction : $049280ac271fdabe$var$dispatchConstant)(type, params));
}


function* $c0c33d07b05cd299$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $3fa3bddc94b4f8a8$export$e8e78c978b129247 = [
    null
];
function $3fa3bddc94b4f8a8$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $3fa3bddc94b4f8a8$var$selection() {
    return new $3fa3bddc94b4f8a8$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $3fa3bddc94b4f8a8$export$e8e78c978b129247);
}
function $3fa3bddc94b4f8a8$var$selection_selection() {
    return this;
}
$3fa3bddc94b4f8a8$export$52baac22726c72bf.prototype = $3fa3bddc94b4f8a8$var$selection.prototype = {
    constructor: $3fa3bddc94b4f8a8$export$52baac22726c72bf,
    select: (0, $fe3e8a5771c356f3$export$2e2bcd8739ae039),
    selectAll: (0, $c3afa9f57c3c6584$export$2e2bcd8739ae039),
    selectChild: (0, $b34141b01ced0a61$export$2e2bcd8739ae039),
    selectChildren: (0, $437727374f9902ec$export$2e2bcd8739ae039),
    filter: (0, $417eb06912872de0$export$2e2bcd8739ae039),
    data: (0, $052a9a1821040aa9$export$2e2bcd8739ae039),
    enter: (0, $b2f4aac14f806d3c$export$2e2bcd8739ae039),
    exit: (0, $0e815177caeed21b$export$2e2bcd8739ae039),
    join: (0, $63f586900c2b4b42$export$2e2bcd8739ae039),
    merge: (0, $7a412a9de8021db3$export$2e2bcd8739ae039),
    selection: $3fa3bddc94b4f8a8$var$selection_selection,
    order: (0, $e17552b51cfac160$export$2e2bcd8739ae039),
    sort: (0, $6d597722efeda79a$export$2e2bcd8739ae039),
    call: (0, $ae070bcd7d1235fe$export$2e2bcd8739ae039),
    nodes: (0, $c6e4ab7976218275$export$2e2bcd8739ae039),
    node: (0, $055d135910c13cd5$export$2e2bcd8739ae039),
    size: (0, $f897b6f378fcb9fc$export$2e2bcd8739ae039),
    empty: (0, $889880c4b5f21a22$export$2e2bcd8739ae039),
    each: (0, $b879b1474342de48$export$2e2bcd8739ae039),
    attr: (0, $d206eec3d2c8e9d1$export$2e2bcd8739ae039),
    style: (0, $df9d8f43b4be6d4b$export$2e2bcd8739ae039),
    property: (0, $f99b3adab0522f33$export$2e2bcd8739ae039),
    classed: (0, $d06e661034a45406$export$2e2bcd8739ae039),
    text: (0, $039cad3e6b62ef93$export$2e2bcd8739ae039),
    html: (0, $c8e884507bcbc0d6$export$2e2bcd8739ae039),
    raise: (0, $d32582798f21257c$export$2e2bcd8739ae039),
    lower: (0, $81fa89a3cf707281$export$2e2bcd8739ae039),
    append: (0, $e7e5728b38923688$export$2e2bcd8739ae039),
    insert: (0, $92828970e51f2858$export$2e2bcd8739ae039),
    remove: (0, $3fba60665c09da9b$export$2e2bcd8739ae039),
    clone: (0, $f8ba4680beaf3292$export$2e2bcd8739ae039),
    datum: (0, $d5e7be624eaf3e5d$export$2e2bcd8739ae039),
    on: (0, $f620cfb2b91d85e5$export$2e2bcd8739ae039),
    dispatch: (0, $049280ac271fdabe$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $c0c33d07b05cd299$export$2e2bcd8739ae039)
};
var $3fa3bddc94b4f8a8$export$2e2bcd8739ae039 = $3fa3bddc94b4f8a8$var$selection;


function $4506c173c1ba6b79$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $3fa3bddc94b4f8a8$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $19c289642832a009$export$524615cd03e458cc = {
    passive: false
};
const $19c289642832a009$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $19c289642832a009$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $19c289642832a009$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $ae3cd07c3e922ae3$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $19c289642832a009$export$2e2bcd8739ae039), (0, $19c289642832a009$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $19c289642832a009$export$2e2bcd8739ae039), (0, $19c289642832a009$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $ae3cd07c3e922ae3$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $19c289642832a009$export$2e2bcd8739ae039), (0, $19c289642832a009$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $9eF39 = parcelRequire("9eF39");

var $9eF39 = parcelRequire("9eF39");
function $881d0702247da37d$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $881d0702247da37d$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $881d0702247da37d$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $d875b83ab5863578$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $881d0702247da37d$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $32a1f36c13df06e0$export$2e2bcd8739ae039 = (x)=>()=>x;


function $8dfce0561889250e$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $8dfce0561889250e$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $8dfce0561889250e$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $8dfce0561889250e$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $8dfce0561889250e$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $8dfce0561889250e$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $8dfce0561889250e$var$exponential(a, b, y) : (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $8dfce0561889250e$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $8dfce0561889250e$var$linear(a, d) : (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $c99ed0dd240dae7d$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $8dfce0561889250e$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $9eF39.rgb)(start)).r, (end = (0, $9eF39.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $c99ed0dd240dae7d$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $9eF39.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $c99ed0dd240dae7d$export$2c0e28f2e2852d3f = $c99ed0dd240dae7d$var$rgbSpline((0, $881d0702247da37d$export$2e2bcd8739ae039));
var $c99ed0dd240dae7d$export$53d5214f625ccd4c = $c99ed0dd240dae7d$var$rgbSpline((0, $d875b83ab5863578$export$2e2bcd8739ae039));



function $910b5323d0705334$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $910b5323d0705334$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $66ad23a6bb88ccc7$export$2e2bcd8739ae039(a, b) {
    return ((0, $910b5323d0705334$export$5cd576d1827d40c8)(b) ? (0, $910b5323d0705334$export$2e2bcd8739ae039) : $66ad23a6bb88ccc7$export$15d09067c6a5ee49)(a, b);
}
function $66ad23a6bb88ccc7$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $0a6b21d627aa3b76$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $3133c9670a94856a$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $4a087d8646486986$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $83516c74d826a95f$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $0a6b21d627aa3b76$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $256699786eb44963$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $256699786eb44963$var$reB = new RegExp($256699786eb44963$var$reA.source, "g");
function $256699786eb44963$var$zero(b) {
    return function() {
        return b;
    };
}
function $256699786eb44963$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $256699786eb44963$export$2e2bcd8739ae039(a, b) {
    var bi = $256699786eb44963$var$reA.lastIndex = $256699786eb44963$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $256699786eb44963$var$reA.exec(a)) && (bm = $256699786eb44963$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $256699786eb44963$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $256699786eb44963$var$one(q[0].x) : $256699786eb44963$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $0a6b21d627aa3b76$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $4a087d8646486986$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $9eF39.default)(b)) ? (b = c, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : (0, $256699786eb44963$export$2e2bcd8739ae039) : b instanceof (0, $9eF39.default) ? (0, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : b instanceof Date ? (0, $3133c9670a94856a$export$2e2bcd8739ae039) : (0, $910b5323d0705334$export$5cd576d1827d40c8)(b) ? (0, $910b5323d0705334$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $66ad23a6bb88ccc7$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $83516c74d826a95f$export$2e2bcd8739ae039) : (0, $4a087d8646486986$export$2e2bcd8739ae039))(a, b);
}


function $39821514e2bb6c34$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $7edc954089de14ac$export$2e2bcd8739ae039(event, node) {
    event = (0, $39821514e2bb6c34$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $0830f34b180fabe6$var$frame = 0, $0830f34b180fabe6$var$timeout = 0, $0830f34b180fabe6$var$interval = 0, $0830f34b180fabe6$var$pokeDelay = 1000, $0830f34b180fabe6$var$taskHead, $0830f34b180fabe6$var$taskTail, $0830f34b180fabe6$var$clockLast = 0, $0830f34b180fabe6$var$clockNow = 0, $0830f34b180fabe6$var$clockSkew = 0, $0830f34b180fabe6$var$clock = typeof performance === "object" && performance.now ? performance : Date, $0830f34b180fabe6$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $0830f34b180fabe6$export$461939dd4422153() {
    return $0830f34b180fabe6$var$clockNow || ($0830f34b180fabe6$var$setFrame($0830f34b180fabe6$var$clearNow), $0830f34b180fabe6$var$clockNow = $0830f34b180fabe6$var$clock.now() + $0830f34b180fabe6$var$clockSkew);
}
function $0830f34b180fabe6$var$clearNow() {
    $0830f34b180fabe6$var$clockNow = 0;
}
function $0830f34b180fabe6$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$0830f34b180fabe6$export$c57e9b2d8b9e4de.prototype = $0830f34b180fabe6$export$9dc4ecf953986f04.prototype = {
    constructor: $0830f34b180fabe6$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $0830f34b180fabe6$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $0830f34b180fabe6$var$taskTail !== this) {
            if ($0830f34b180fabe6$var$taskTail) $0830f34b180fabe6$var$taskTail._next = this;
            else $0830f34b180fabe6$var$taskHead = this;
            $0830f34b180fabe6$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $0830f34b180fabe6$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $0830f34b180fabe6$var$sleep();
        }
    }
};
function $0830f34b180fabe6$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $0830f34b180fabe6$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $0830f34b180fabe6$export$d60154c1d7f3990e() {
    $0830f34b180fabe6$export$461939dd4422153(); // Get the current time, if not already set.
    ++$0830f34b180fabe6$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $0830f34b180fabe6$var$taskHead, e;
    while(t){
        if ((e = $0830f34b180fabe6$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$0830f34b180fabe6$var$frame;
}
function $0830f34b180fabe6$var$wake() {
    $0830f34b180fabe6$var$clockNow = ($0830f34b180fabe6$var$clockLast = $0830f34b180fabe6$var$clock.now()) + $0830f34b180fabe6$var$clockSkew;
    $0830f34b180fabe6$var$frame = $0830f34b180fabe6$var$timeout = 0;
    try {
        $0830f34b180fabe6$export$d60154c1d7f3990e();
    } finally{
        $0830f34b180fabe6$var$frame = 0;
        $0830f34b180fabe6$var$nap();
        $0830f34b180fabe6$var$clockNow = 0;
    }
}
function $0830f34b180fabe6$var$poke() {
    var now = $0830f34b180fabe6$var$clock.now(), delay = now - $0830f34b180fabe6$var$clockLast;
    if (delay > $0830f34b180fabe6$var$pokeDelay) $0830f34b180fabe6$var$clockSkew -= delay, $0830f34b180fabe6$var$clockLast = now;
}
function $0830f34b180fabe6$var$nap() {
    var t0, t1 = $0830f34b180fabe6$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $0830f34b180fabe6$var$taskHead = t2;
    }
    $0830f34b180fabe6$var$taskTail = t0;
    $0830f34b180fabe6$var$sleep(time);
}
function $0830f34b180fabe6$var$sleep(time) {
    if ($0830f34b180fabe6$var$frame) return; // Soonest alarm already set, or will be.
    if ($0830f34b180fabe6$var$timeout) $0830f34b180fabe6$var$timeout = clearTimeout($0830f34b180fabe6$var$timeout);
    var delay = time - $0830f34b180fabe6$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $0830f34b180fabe6$var$timeout = setTimeout($0830f34b180fabe6$var$wake, time - $0830f34b180fabe6$var$clock.now() - $0830f34b180fabe6$var$clockSkew);
        if ($0830f34b180fabe6$var$interval) $0830f34b180fabe6$var$interval = clearInterval($0830f34b180fabe6$var$interval);
    } else {
        if (!$0830f34b180fabe6$var$interval) $0830f34b180fabe6$var$clockLast = $0830f34b180fabe6$var$clock.now(), $0830f34b180fabe6$var$interval = setInterval($0830f34b180fabe6$var$poke, $0830f34b180fabe6$var$pokeDelay);
        $0830f34b180fabe6$var$frame = 1, $0830f34b180fabe6$var$setFrame($0830f34b180fabe6$var$wake);
    }
}


function $761d5cee6e823ef5$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $0830f34b180fabe6$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $b5673d202c1a718d$var$emptyOn = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $b5673d202c1a718d$var$emptyTween = [];
var $b5673d202c1a718d$export$ff39ebd4bb12b718 = 0;
var $b5673d202c1a718d$export$584530fe98d14a84 = 1;
var $b5673d202c1a718d$export$a5d151aee16efd42 = 2;
var $b5673d202c1a718d$export$fb935ab5849a0db9 = 3;
var $b5673d202c1a718d$export$1573e22b087389af = 4;
var $b5673d202c1a718d$export$a2e792214ded83b2 = 5;
var $b5673d202c1a718d$export$9d38167254403955 = 6;
function $b5673d202c1a718d$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $b5673d202c1a718d$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $b5673d202c1a718d$var$emptyOn,
        tween: $b5673d202c1a718d$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $b5673d202c1a718d$export$ff39ebd4bb12b718
    });
}
function $b5673d202c1a718d$export$2cd8252107eb640b(node, id) {
    var schedule = $b5673d202c1a718d$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $b5673d202c1a718d$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $b5673d202c1a718d$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $b5673d202c1a718d$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $b5673d202c1a718d$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $b5673d202c1a718d$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $b5673d202c1a718d$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $0830f34b180fabe6$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $b5673d202c1a718d$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $b5673d202c1a718d$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $b5673d202c1a718d$export$fb935ab5849a0db9) return (0, $761d5cee6e823ef5$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $b5673d202c1a718d$export$1573e22b087389af) {
                o.state = $b5673d202c1a718d$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $b5673d202c1a718d$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $761d5cee6e823ef5$export$2e2bcd8739ae039)(function() {
            if (self.state === $b5673d202c1a718d$export$fb935ab5849a0db9) {
                self.state = $b5673d202c1a718d$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $b5673d202c1a718d$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $b5673d202c1a718d$export$a5d151aee16efd42) return; // interrupted
        self.state = $b5673d202c1a718d$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $b5673d202c1a718d$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $b5673d202c1a718d$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $b5673d202c1a718d$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $a9f60c0c7972321a$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $b5673d202c1a718d$export$a5d151aee16efd42) && schedule.state < (0, $b5673d202c1a718d$export$a2e792214ded83b2);
        schedule.state = (0, $b5673d202c1a718d$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $1edbe92636db4b14$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this, name);
    });
}




var $5e622cc4ee5dcd58$var$degrees = 180 / Math.PI;
var $5e622cc4ee5dcd58$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $5e622cc4ee5dcd58$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $5e622cc4ee5dcd58$var$degrees,
        skewX: Math.atan(skewX) * $5e622cc4ee5dcd58$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $2336aa7b25388556$var$svgNode;
function $2336aa7b25388556$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $5e622cc4ee5dcd58$export$f0954fd7d5368655) : (0, $5e622cc4ee5dcd58$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $2336aa7b25388556$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $5e622cc4ee5dcd58$export$f0954fd7d5368655;
    if (!$2336aa7b25388556$var$svgNode) $2336aa7b25388556$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $2336aa7b25388556$var$svgNode.setAttribute("transform", value);
    if (!(value = $2336aa7b25388556$var$svgNode.transform.baseVal.consolidate())) return 0, $5e622cc4ee5dcd58$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $5e622cc4ee5dcd58$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $58d4bff51a6cd97b$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $58d4bff51a6cd97b$export$56bec7123bb3589a = $58d4bff51a6cd97b$var$interpolateTransform((0, $2336aa7b25388556$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $58d4bff51a6cd97b$export$da8cba906d64c082 = $58d4bff51a6cd97b$var$interpolateTransform((0, $2336aa7b25388556$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $2b846766134b1951$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $2b846766134b1951$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $2b846766134b1951$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $2b846766134b1951$var$tweenRemove : $2b846766134b1951$var$tweenFunction)(id, name, value));
}
function $2b846766134b1951$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $9eF39 = parcelRequire("9eF39");

function $1d03f40d2ee03a56$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $4a087d8646486986$export$2e2bcd8739ae039) : b instanceof (0, $9eF39.default) ? (0, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : (c = (0, $9eF39.default)(b)) ? (b = c, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : (0, $256699786eb44963$export$2e2bcd8739ae039))(a, b);
}


function $fa11014bc225ccbd$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $fa11014bc225ccbd$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $fa11014bc225ccbd$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $fa11014bc225ccbd$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $fa11014bc225ccbd$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $fa11014bc225ccbd$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $fa11014bc225ccbd$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $58d4bff51a6cd97b$export$da8cba906d64c082) : (0, $1d03f40d2ee03a56$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $fa11014bc225ccbd$var$attrFunctionNS : $fa11014bc225ccbd$var$attrFunction)(fullname, i, (0, $2b846766134b1951$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $fa11014bc225ccbd$var$attrRemoveNS : $fa11014bc225ccbd$var$attrRemove)(fullname) : (fullname.local ? $fa11014bc225ccbd$var$attrConstantNS : $fa11014bc225ccbd$var$attrConstant)(fullname, i, value));
}



function $89c852aaf0ffbd98$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $89c852aaf0ffbd98$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $89c852aaf0ffbd98$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $89c852aaf0ffbd98$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $89c852aaf0ffbd98$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $89c852aaf0ffbd98$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $89c852aaf0ffbd98$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $89c852aaf0ffbd98$var$attrTweenNS : $89c852aaf0ffbd98$var$attrTween)(fullname, value));
}



function $998317f5aa574ea5$var$delayFunction(id, value) {
    return function() {
        (0, $b5673d202c1a718d$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $998317f5aa574ea5$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $b5673d202c1a718d$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $998317f5aa574ea5$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $998317f5aa574ea5$var$delayFunction : $998317f5aa574ea5$var$delayConstant)(id, value)) : (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $fb064aa40c04a3a9$var$durationFunction(id, value) {
    return function() {
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $fb064aa40c04a3a9$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $fb064aa40c04a3a9$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $fb064aa40c04a3a9$var$durationFunction : $fb064aa40c04a3a9$var$durationConstant)(id, value)) : (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $3b84501e3f09c967$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $3b84501e3f09c967$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($3b84501e3f09c967$var$easeConstant(id, value)) : (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $5d52f5c2bc33bebb$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $5d52f5c2bc33bebb$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($5d52f5c2bc33bebb$var$easeVarying(this._id, value));
}




function $be9cef0700338389$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $9217c1f6bb2d2b85$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $612e64afad319e12$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $43adaf0311e82f05$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $43adaf0311e82f05$var$onFunction(id, name, listener) {
    var on0, on1, sit = $43adaf0311e82f05$var$start(name) ? (0, $b5673d202c1a718d$export$2cd8252107eb640b) : (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $43adaf0311e82f05$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($43adaf0311e82f05$var$onFunction(id, name, listener));
}


function $d081c5c9ee67d011$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $d081c5c9ee67d011$export$2e2bcd8739ae039() {
    return this.on("end.remove", $d081c5c9ee67d011$var$removeFunction(this._id));
}





function $33c939ab69fb50d4$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $a696f7efe74d657f$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $5accf6381f758c01$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $a251e86126c3c196$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $7a60ab3f6361005a$var$Selection = (0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype.constructor;
function $7a60ab3f6361005a$export$2e2bcd8739ae039() {
    return new $7a60ab3f6361005a$var$Selection(this._groups, this._parents);
}







function $406987af83016736$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $406987af83016736$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $406987af83016736$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $406987af83016736$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $406987af83016736$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $406987af83016736$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $406987af83016736$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $58d4bff51a6cd97b$export$56bec7123bb3589a) : (0, $1d03f40d2ee03a56$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $406987af83016736$var$styleNull(name, i)).on("end.style." + name, $406987af83016736$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $406987af83016736$var$styleFunction(name, i, (0, $2b846766134b1951$export$f78ce6ab10405d82)(this, "style." + name, value))).each($406987af83016736$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $406987af83016736$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $084d18b0ed660f1f$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $084d18b0ed660f1f$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $084d18b0ed660f1f$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $084d18b0ed660f1f$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $084d18b0ed660f1f$var$styleTween(name, value, priority == null ? "" : priority));
}



function $77d3177f82afb684$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $77d3177f82afb684$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $77d3177f82afb684$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $77d3177f82afb684$var$textFunction((0, $2b846766134b1951$export$f78ce6ab10405d82)(this, "text", value)) : $77d3177f82afb684$var$textConstant(value == null ? "" : value + ""));
}


function $2281728614db71a0$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $2281728614db71a0$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $2281728614db71a0$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $2281728614db71a0$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $2281728614db71a0$var$textTween(value));
}




function $5075f917ce7577c6$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $f4875d2c4bb511a9$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id0);
            (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $3a3e51e88d3fd2e7$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $f4875d2c4bb511a9$var$id = 0;
function $f4875d2c4bb511a9$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $f4875d2c4bb511a9$export$2e2bcd8739ae039(name) {
    return (0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039)().transition(name);
}
function $f4875d2c4bb511a9$export$9ffd10a3fbdc175b() {
    return ++$f4875d2c4bb511a9$var$id;
}
var $f4875d2c4bb511a9$var$selection_prototype = (0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype;
$f4875d2c4bb511a9$export$be58926105124dd4.prototype = $f4875d2c4bb511a9$export$2e2bcd8739ae039.prototype = {
    constructor: $f4875d2c4bb511a9$export$be58926105124dd4,
    select: (0, $33c939ab69fb50d4$export$2e2bcd8739ae039),
    selectAll: (0, $5accf6381f758c01$export$2e2bcd8739ae039),
    selectChild: $f4875d2c4bb511a9$var$selection_prototype.selectChild,
    selectChildren: $f4875d2c4bb511a9$var$selection_prototype.selectChildren,
    filter: (0, $be9cef0700338389$export$2e2bcd8739ae039),
    merge: (0, $612e64afad319e12$export$2e2bcd8739ae039),
    selection: (0, $7a60ab3f6361005a$export$2e2bcd8739ae039),
    transition: (0, $5075f917ce7577c6$export$2e2bcd8739ae039),
    call: $f4875d2c4bb511a9$var$selection_prototype.call,
    nodes: $f4875d2c4bb511a9$var$selection_prototype.nodes,
    node: $f4875d2c4bb511a9$var$selection_prototype.node,
    size: $f4875d2c4bb511a9$var$selection_prototype.size,
    empty: $f4875d2c4bb511a9$var$selection_prototype.empty,
    each: $f4875d2c4bb511a9$var$selection_prototype.each,
    on: (0, $43adaf0311e82f05$export$2e2bcd8739ae039),
    attr: (0, $fa11014bc225ccbd$export$2e2bcd8739ae039),
    attrTween: (0, $89c852aaf0ffbd98$export$2e2bcd8739ae039),
    style: (0, $406987af83016736$export$2e2bcd8739ae039),
    styleTween: (0, $084d18b0ed660f1f$export$2e2bcd8739ae039),
    text: (0, $77d3177f82afb684$export$2e2bcd8739ae039),
    textTween: (0, $2281728614db71a0$export$2e2bcd8739ae039),
    remove: (0, $d081c5c9ee67d011$export$2e2bcd8739ae039),
    tween: (0, $2b846766134b1951$export$2e2bcd8739ae039),
    delay: (0, $998317f5aa574ea5$export$2e2bcd8739ae039),
    duration: (0, $fb064aa40c04a3a9$export$2e2bcd8739ae039),
    ease: (0, $3b84501e3f09c967$export$2e2bcd8739ae039),
    easeVarying: (0, $5d52f5c2bc33bebb$export$2e2bcd8739ae039),
    end: (0, $3a3e51e88d3fd2e7$export$2e2bcd8739ae039),
    [Symbol.iterator]: $f4875d2c4bb511a9$var$selection_prototype[Symbol.iterator]
};



function $9b730ba464200928$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $9b730ba464200928$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $9b730ba464200928$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $091a2eb19c9bc49f$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $9b730ba464200928$export$89238d3bc79d3ada)
};
function $091a2eb19c9bc49f$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $091a2eb19c9bc49f$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $f4875d2c4bb511a9$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $f4875d2c4bb511a9$export$9ffd10a3fbdc175b)(), (timing = $091a2eb19c9bc49f$var$defaultTiming).time = (0, $0830f34b180fabe6$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $091a2eb19c9bc49f$var$inherit(node, id));
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype.interrupt = (0, $1edbe92636db4b14$export$2e2bcd8739ae039);
(0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype.transition = (0, $091a2eb19c9bc49f$export$2e2bcd8739ae039);







var $778de0494e50ca37$export$2e2bcd8739ae039 = (x)=>()=>x;


function $6364eea05eaaf9a1$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $f663d3f9720c3b93$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $f663d3f9720c3b93$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $08836f1eb7bc5d70$var$MODE_DRAG = {
    name: "drag"
}, $08836f1eb7bc5d70$var$MODE_SPACE = {
    name: "space"
}, $08836f1eb7bc5d70$var$MODE_HANDLE = {
    name: "handle"
}, $08836f1eb7bc5d70$var$MODE_CENTER = {
    name: "center"
};
const { abs: $08836f1eb7bc5d70$var$abs, max: $08836f1eb7bc5d70$var$max, min: $08836f1eb7bc5d70$var$min } = Math;
function $08836f1eb7bc5d70$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $08836f1eb7bc5d70$var$number2(e) {
    return [
        $08836f1eb7bc5d70$var$number1(e[0]),
        $08836f1eb7bc5d70$var$number1(e[1])
    ];
}
var $08836f1eb7bc5d70$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($08836f1eb7bc5d70$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $08836f1eb7bc5d70$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($08836f1eb7bc5d70$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $08836f1eb7bc5d70$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($08836f1eb7bc5d70$var$type),
    input: function(xy) {
        return xy == null ? null : $08836f1eb7bc5d70$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $08836f1eb7bc5d70$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $08836f1eb7bc5d70$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $08836f1eb7bc5d70$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $08836f1eb7bc5d70$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $08836f1eb7bc5d70$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $08836f1eb7bc5d70$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $08836f1eb7bc5d70$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $08836f1eb7bc5d70$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $08836f1eb7bc5d70$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $08836f1eb7bc5d70$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $08836f1eb7bc5d70$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $08836f1eb7bc5d70$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $08836f1eb7bc5d70$export$979ace6c88860aa8() {
    return $08836f1eb7bc5d70$var$brush($08836f1eb7bc5d70$var$X);
}
function $08836f1eb7bc5d70$export$468748b530991c54() {
    return $08836f1eb7bc5d70$var$brush($08836f1eb7bc5d70$var$Y);
}
function $08836f1eb7bc5d70$export$2e2bcd8739ae039() {
    return $08836f1eb7bc5d70$var$brush($08836f1eb7bc5d70$var$XY);
}
function $08836f1eb7bc5d70$var$brush(dim) {
    var extent = $08836f1eb7bc5d70$var$defaultExtent, filter = $08836f1eb7bc5d70$var$defaultFilter, touchable = $08836f1eb7bc5d70$var$defaultTouchable, keys = true, listeners = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $08836f1eb7bc5d70$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $08836f1eb7bc5d70$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $08836f1eb7bc5d70$var$local(this).extent;
            (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $08836f1eb7bc5d70$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $08836f1eb7bc5d70$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $08836f1eb7bc5d70$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $0a6b21d627aa3b76$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this), selection = $08836f1eb7bc5d70$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $6364eea05eaaf9a1$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $08836f1eb7bc5d70$var$MODE_DRAG : keys && event.altKey ? $08836f1eb7bc5d70$var$MODE_CENTER : $08836f1eb7bc5d70$var$MODE_HANDLE, signX = dim === $08836f1eb7bc5d70$var$Y ? null : $08836f1eb7bc5d70$var$signsX[type], signY = dim === $08836f1eb7bc5d70$var$X ? null : $08836f1eb7bc5d70$var$signsY[type], state = $08836f1eb7bc5d70$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $08836f1eb7bc5d70$var$Y ? W : $08836f1eb7bc5d70$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $08836f1eb7bc5d70$var$X ? N : $08836f1eb7bc5d70$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $08836f1eb7bc5d70$var$Y ? E : $08836f1eb7bc5d70$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $08836f1eb7bc5d70$var$X ? S : $08836f1eb7bc5d70$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $08836f1eb7bc5d70$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $ae3cd07c3e922ae3$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($08836f1eb7bc5d70$var$abs(point.cur[0] - point[0]) > $08836f1eb7bc5d70$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $f663d3f9720c3b93$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $08836f1eb7bc5d70$var$MODE_SPACE:
                case $08836f1eb7bc5d70$var$MODE_DRAG:
                    if (signX) dx = $08836f1eb7bc5d70$var$max(W - w0, $08836f1eb7bc5d70$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $08836f1eb7bc5d70$var$max(N - n0, $08836f1eb7bc5d70$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $08836f1eb7bc5d70$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, points[0][0])), e1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, points[0][1])), s1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $08836f1eb7bc5d70$var$max(W - w0, $08836f1eb7bc5d70$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $08836f1eb7bc5d70$var$max(W - e0, $08836f1eb7bc5d70$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $08836f1eb7bc5d70$var$max(N - n0, $08836f1eb7bc5d70$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $08836f1eb7bc5d70$var$max(N - s0, $08836f1eb7bc5d70$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $08836f1eb7bc5d70$var$MODE_CENTER:
                    if (signX) w1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, w0 - dx * signX)), e1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, n0 - dy * signY)), s1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $08836f1eb7bc5d70$var$flipX) overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors[type = $08836f1eb7bc5d70$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $08836f1eb7bc5d70$var$flipY) overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors[type = $08836f1eb7bc5d70$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $f663d3f9720c3b93$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $ae3cd07c3e922ae3$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($08836f1eb7bc5d70$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $08836f1eb7bc5d70$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $08836f1eb7bc5d70$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $08836f1eb7bc5d70$var$MODE_HANDLE || mode === $08836f1eb7bc5d70$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $08836f1eb7bc5d70$var$MODE_SPACE;
                        overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $f663d3f9720c3b93$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $08836f1eb7bc5d70$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $08836f1eb7bc5d70$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $08836f1eb7bc5d70$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $08836f1eb7bc5d70$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $08836f1eb7bc5d70$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $f663d3f9720c3b93$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $08836f1eb7bc5d70$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $778de0494e50ca37$export$2e2bcd8739ae039)($08836f1eb7bc5d70$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $778de0494e50ca37$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $778de0494e50ca37$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}
































var $ab1b56f08da5f0f8$var$epsilon2 = 1e-12;
function $ab1b56f08da5f0f8$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $ab1b56f08da5f0f8$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $ab1b56f08da5f0f8$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $ab1b56f08da5f0f8$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $ab1b56f08da5f0f8$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $ab1b56f08da5f0f8$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $ab1b56f08da5f0f8$var$tanh(rho * s + r0) - $ab1b56f08da5f0f8$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $ab1b56f08da5f0f8$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $855f7c13dc5c8800$export$2e2bcd8739ae039 = (x)=>()=>x;


function $f8b8ac12d46296b4$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $2aeeefb9d4aa62cb$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$2aeeefb9d4aa62cb$export$563a914cafbdc389.prototype = {
    constructor: $2aeeefb9d4aa62cb$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $2aeeefb9d4aa62cb$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $2aeeefb9d4aa62cb$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $2aeeefb9d4aa62cb$export$f0954fd7d5368655 = new $2aeeefb9d4aa62cb$export$563a914cafbdc389(1, 0, 0);
$2aeeefb9d4aa62cb$export$2e2bcd8739ae039.prototype = $2aeeefb9d4aa62cb$export$563a914cafbdc389.prototype;
function $2aeeefb9d4aa62cb$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $2aeeefb9d4aa62cb$export$f0954fd7d5368655;
    return node.__zoom;
}


function $4c382e9682a58de3$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $4c382e9682a58de3$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $2e3210259ae866af$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $2e3210259ae866af$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $2e3210259ae866af$var$defaultTransform() {
    return this.__zoom || (0, $2aeeefb9d4aa62cb$export$f0954fd7d5368655);
}
function $2e3210259ae866af$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $2e3210259ae866af$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $2e3210259ae866af$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $2e3210259ae866af$export$2e2bcd8739ae039() {
    var filter = $2e3210259ae866af$var$defaultFilter, extent = $2e3210259ae866af$var$defaultExtent, constrain = $2e3210259ae866af$var$defaultConstrain, wheelDelta = $2e3210259ae866af$var$defaultWheelDelta, touchable = $2e3210259ae866af$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $ab1b56f08da5f0f8$export$2e2bcd8739ae039), listeners = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $2e3210259ae866af$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $2e3210259ae866af$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $2aeeefb9d4aa62cb$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $2aeeefb9d4aa62cb$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $2aeeefb9d4aa62cb$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $2aeeefb9d4aa62cb$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $f8b8ac12d46296b4$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $ae3cd07c3e922ae3$export$2e2bcd8739ae039)(event.view);
        (0, $4c382e9682a58de3$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $ae3cd07c3e922ae3$export$833237748009e1e1)(event.view, g.moved);
            (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $4c382e9682a58de3$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $4c382e9682a58de3$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}







const $dad545c909cfec2d$var$width = 500;
const $dad545c909cfec2d$var$height = 320;
const $dad545c909cfec2d$var$tensorNodeDistance = 75;
const $dad545c909cfec2d$var$edgeNodeDistance = 140;
function $dad545c909cfec2d$var$renderTensorDiagram(container, nodes, edges) {
    const svg = $4506c173c1ba6b79$export$2e2bcd8739ae039(container).append("svg").attr("width", $dad545c909cfec2d$var$width).attr("height", $dad545c909cfec2d$var$height).attr("viewBox", [
        -$dad545c909cfec2d$var$width / 2,
        -$dad545c909cfec2d$var$height / 2,
        $dad545c909cfec2d$var$width,
        $dad545c909cfec2d$var$height
    ]).attr("class", "max-w-full h-auto");
    // Separate tensor and edge nodes
    const tensorNodes = nodes.filter((n)=>n.type === "tensor");
    const edgeNodes = nodes.filter((n)=>n.type === "edge");
    // Position tensor nodes in geometric patterns
    const tensorCount = tensorNodes.length;
    if (tensorCount > 0) tensorNodes.forEach((node, i)=>{
        if (tensorCount === 1) {
            node.x = 0;
            node.y = 0;
        } else {
            const angle = i * 2 * Math.PI / tensorCount;
            node.x = $dad545c909cfec2d$var$tensorNodeDistance * Math.cos(angle);
            node.y = $dad545c909cfec2d$var$tensorNodeDistance * Math.sin(angle);
        }
    });
    // Helper function to find optimal position for edge nodes
    function getEdgeNodePosition(node) {
        const connectedEdges = edges.filter((e)=>e.source === node.id || e.target === node.id);
        const connectedTensors = connectedEdges.flatMap((e)=>{
            const sourceNode = nodes.find((n)=>n.id === e.source);
            const targetNode = nodes.find((n)=>n.id === e.target);
            return [
                sourceNode,
                targetNode
            ].filter((n)=>n.type === "tensor");
        });
        // Calculate average position of connected tensors
        const avgX = connectedTensors.reduce((sum, n)=>sum + (n.x || 0), 0) / connectedTensors.length;
        const avgY = connectedTensors.reduce((sum, n)=>sum + (n.y || 0), 0) / connectedTensors.length;
        // Place node further out in the same direction from center
        const angle = Math.atan2(avgY, avgX);
        return {
            x: $dad545c909cfec2d$var$edgeNodeDistance * Math.cos(angle),
            y: $dad545c909cfec2d$var$edgeNodeDistance * Math.sin(angle)
        };
    }
    // Position edge nodes
    edgeNodes.forEach((node)=>{
        const pos = getEdgeNodePosition(node);
        node.x = pos.x;
        node.y = pos.y;
    });
    function calculateLinkPath(source, target) {
        if (source === target) {
            const x = source.x;
            const y = source.y;
            return `M${x - 5},${y - 5} A30,30 0 1,1 ${x + 5},${y + 5}`;
        }
        return `M${source.x},${source.y} L${target.x},${target.y}`;
    }
    // Draw the edges
    const link = svg.append("g").attr("class", "links").selectAll("path").data(edges).enter();
    link.append("path").attr("d", (d)=>{
        const source = nodes.find((n)=>n.id === d.source);
        const target = nodes.find((n)=>n.id === d.target);
        return calculateLinkPath(source, target);
    }).attr("fill", "none").attr("stroke", "#aaa").attr("stroke-width", 2);
    link.append("text").text((d)=>d.label).attr("class", (d)=>d.class_name).attr("x", (d)=>{
        const source = nodes.find((n)=>n.id === d.source);
        const target = nodes.find((n)=>n.id === d.target);
        return source === target ? source.x + 30 : (source.x + target.x) / 2;
    }).attr("y", (d)=>{
        const source = nodes.find((n)=>n.id === d.source);
        const target = nodes.find((n)=>n.id === d.target);
        return source === target ? source.y - 30 : (source.y + target.y) / 2;
    });
    // Draw the nodes
    const node = svg.append("g").attr("class", "nodes").selectAll("g").data(nodes).enter().append("g").attr("transform", (d)=>`translate(${d.x}, ${d.y})`);
    node.append("circle").attr("r", 10).attr("fill", "#69b3a2").attr("visibility", (d)=>d.type === "edge" ? "hidden" : "visible");
    node.append("text").text((d)=>d.label).attr("class", (d)=>d.class_name);
}
window.renderTensorDiagram = $dad545c909cfec2d$var$renderTensorDiagram;
window.isometric = $b225529de5fe4d82$exports;
window.addEventListener("load", ()=>window.tensor_playground_main());


//# sourceMappingURL=index.88fa300d.js.map
